/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 340);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(347);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(464)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var namespace = exports.namespace = 'grommetux-';

exports.default = {
  ACCORDION: namespace + 'accordion',
  ACCORDION_PANEL: namespace + 'accordion-panel',
  ANCHOR: namespace + 'anchor',
  ANIMATE: namespace + 'animate',
  APP: namespace + 'app',
  ARTICLE: namespace + 'article',
  ATTRIBUTE: namespace + 'attribute',
  BACKGROUND_COLOR_INDEX: namespace + 'background-color-index',
  BOX: namespace + 'box',
  BORDER_COLOR_INDEX: namespace + 'border-color-index',
  BRICK: namespace + 'brick',
  BUTTON: namespace + 'button',
  CALENDAR: namespace + 'calendar',
  CARD: namespace + 'card',
  CAROUSEL: namespace + 'carousel',
  CAROUSEL_CONTROLS: namespace + 'carousel-controls',
  CHART: namespace + 'chart',
  CHART_AXIS: namespace + 'chart-axis',
  CHART_BASE: namespace + 'chart-base',
  CHART_GRAPH: namespace + 'chart-graph',
  CHART_GRID: namespace + 'chart-grid',
  CHART_HOT_SPOTS: namespace + 'chart-hot-spots',
  CHART_LAYERS: namespace + 'chart-layers',
  CHART_MARKER: namespace + 'chart-marker',
  CHART_MARKER_LABEL: namespace + 'chart-marker-label',
  CHART_RANGE: namespace + 'chart-range',
  CHECK_BOX: namespace + 'check-box',
  COLLAPSIBLE: namespace + 'collapsible',
  COLOR_INDEX: namespace + 'color-index',
  COLUMNS: namespace + 'columns',
  CONTROL_ICON: namespace + 'control-icon',
  DATE_TIME: namespace + 'date-time',
  DATE_TIME_DROP: namespace + 'date-time-drop',
  DISTRIBUTION: namespace + 'distribution',
  DROP: namespace + 'drop',
  FOOTER: namespace + 'footer',
  FORM: namespace + 'form',
  FORM_FIELD: namespace + 'form-field',
  FORM_FIELDS: namespace + 'form-fields',
  HEADER: namespace + 'header',
  HEADING: namespace + 'heading',
  HEADLINE: namespace + 'headline',
  HERO: namespace + 'hero',
  IMAGE: namespace + 'image',
  IMAGE_FIELD: namespace + 'image-field',
  INPUT: namespace + 'input',
  LABEL: namespace + 'label',
  LAYER: namespace + 'layer',
  LEGEND: namespace + 'legend',
  LIST: namespace + 'list',
  LIST_ITEM: namespace + 'list-item',
  LOGIN: namespace + 'login',
  LOGIN_FORM: namespace + 'login-form',
  LOGO_ICON: namespace + 'logo-icon',
  MAP: namespace + 'map',
  MENU: namespace + 'menu',
  METER: namespace + 'meter',
  NAMESPACE: '' + namespace,
  NOTIFICATION: namespace + 'notification',
  NUMBER_INPUT: namespace + 'number-input',
  OBJECT: namespace + 'object',
  PARAGRAPH: namespace + 'paragraph',
  PASSWORD_INPUT: namespace + 'password-input',
  PULSE: namespace + 'pulse',
  QUOTE: namespace + 'quote',
  RADIO_BUTTON: namespace + 'radio-button',
  SEARCH: namespace + 'search',
  SEARCH_INPUT: namespace + 'search-input',
  SECTION: namespace + 'section',
  SELECT: namespace + 'select',
  SIDEBAR: namespace + 'sidebar',
  SKIP_LINK_ANCHOR: namespace + 'skip-link-anchor',
  SKIP_LINKS: namespace + 'skip-links',
  SPLIT: namespace + 'split',
  SPINNING: namespace + 'icon-spinning',
  STATUS_ICON: namespace + 'status-icon',
  SUN_BURST: namespace + 'sun-burst',
  TAB: namespace + 'tab',
  TABLE: namespace + 'table',
  TABLE_ROW: namespace + 'table-row',
  TABS: namespace + 'tabs',
  TAG: namespace + 'tag',
  TAGS: namespace + 'tags',
  TBD: namespace + 'tbd',
  TEXT_INPUT: namespace + 'text-input',
  TILE: namespace + 'tile',
  TILES: namespace + 'tiles',
  TIMESTAMP: namespace + 'timestamp',
  TIP: namespace + 'tip',
  TITLE: namespace + 'title',
  TOAST: namespace + 'toast',
  TOPOLOGY: namespace + 'topology',
  VALUE: namespace + 'value',
  VIDEO: namespace + 'video',
  WORLD_MAP: namespace + 'world-map'
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* globals
	Atomics,
	SharedArrayBuffer,
*/

var undefined;

var $TypeError = TypeError;

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () { throw new $TypeError(); };
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(111)();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var generator; // = function * () {};
var generatorFunction = generator ? getProto(generator) : undefined;
var asyncFn; // async function() {};
var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
var asyncGen; // async function * () {};
var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
var asyncGenIterator = asyncGen ? asyncGen() : undefined;

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%ArrayPrototype%': Array.prototype,
	'%ArrayProto_entries%': Array.prototype.entries,
	'%ArrayProto_forEach%': Array.prototype.forEach,
	'%ArrayProto_keys%': Array.prototype.keys,
	'%ArrayProto_values%': Array.prototype.values,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': asyncFunction,
	'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
	'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
	'%AsyncGeneratorFunction%': asyncGenFunction,
	'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
	'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%Boolean%': Boolean,
	'%BooleanPrototype%': Boolean.prototype,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
	'%Date%': Date,
	'%DatePrototype%': Date.prototype,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%ErrorPrototype%': Error.prototype,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%EvalErrorPrototype%': EvalError.prototype,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
	'%Function%': Function,
	'%FunctionPrototype%': Function.prototype,
	'%Generator%': generator ? getProto(generator()) : undefined,
	'%GeneratorFunction%': generatorFunction,
	'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
	'%Math%': Math,
	'%Number%': Number,
	'%NumberPrototype%': Number.prototype,
	'%Object%': Object,
	'%ObjectPrototype%': Object.prototype,
	'%ObjProto_toString%': Object.prototype.toString,
	'%ObjProto_valueOf%': Object.prototype.valueOf,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
	'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
	'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
	'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
	'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%RangeErrorPrototype%': RangeError.prototype,
	'%ReferenceError%': ReferenceError,
	'%ReferenceErrorPrototype%': ReferenceError.prototype,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%RegExpPrototype%': RegExp.prototype,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%StringPrototype%': String.prototype,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
	'%SyntaxError%': SyntaxError,
	'%SyntaxErrorPrototype%': SyntaxError.prototype,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
	'%TypeError%': $TypeError,
	'%TypeErrorPrototype%': $TypeError.prototype,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
	'%URIError%': URIError,
	'%URIErrorPrototype%': URIError.prototype,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
};

var bind = __webpack_require__(112);
var $replace = bind.call(Function.call, String.prototype.replace);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	if (!(name in INTRINSICS)) {
		throw new SyntaxError('intrinsic ' + name + ' does not exist!');
	}

	// istanbul ignore if // hopefully this is impossible to test :-)
	if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
		throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
	}

	return INTRINSICS[name];
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new TypeError('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);

	var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
	for (var i = 1; i < parts.length; i += 1) {
		if (value != null) {
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, parts[i]);
				if (!allowMissing && !(parts[i] in value)) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				value = desc ? (desc.get || desc.value) : value[parts[i]];
			} else {
				value = value[parts[i]];
			}
		}
	}
	return value;
};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014 Hewlett Packard Enterprise Development LP
exports.default = {
  getMessage: function getMessage(intl, key, values, defaultMessage) {
    if (intl) {
      return intl.formatMessage({
        id: key,
        defaultMessage: defaultMessage || key
      }, values);
    } else {
      return key;
    }
  }
};
module.exports = exports["default"];

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.default = {
  pick: function pick(props, fields) {
    var has = function has(p) {
      return props.hasOwnProperty(p);
    };
    var obj = {};
    (fields || []).forEach(function (field) {
      if (has(field)) obj[field] = props[field];
    });
    return obj;
  },
  omit: function omit(props, fields) {
    var obj = {};
    Object.keys(props).forEach(function (p) {
      if ((fields || []).indexOf(p) === -1) {
        obj[p] = props[p];
      }
    });
    return obj;
  }
};
module.exports = exports["default"];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5Type = __webpack_require__(377);

// https://www.ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	return ES5Type(x);
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _DOM = __webpack_require__(59);

var _SkipLinkAnchor = __webpack_require__(264);

var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.BOX;
var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;

var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box(props) {
    _classCallCheck(this, Box);

    var _this = _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).call(this, props));

    _this.state = { mouseActive: false };
    return _this;
  }

  _createClass(Box, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var onClick = this.props.onClick;

      if (onClick) {
        var clickCallback = function clickCallback() {
          if (_this2.boxContainerRef === document.activeElement) {
            onClick();
          }
        };

        _KeyboardAccelerators2.default.startListeningToKeyboard(this, {
          enter: clickCallback,
          space: clickCallback
        });
      }

      this._setDarkBackground();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.colorIndex !== this.props.colorIndex) {
        if (nextProps.colorIndex) {
          this.setState({ updateDarkBackground: true });
        } else {
          this.setState({ darkBackground: undefined });
        }
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.announce) {
        (0, _Announcer.announce)(this.boxContainerRef.textContent);
      }
      if (this.state.updateDarkBackground) {
        this.setState({ updateDarkBackground: false });
        this._setDarkBackground();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.onClick) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
      }
      if (this._checkBackground) {
        this._checkBackground.stop();
      }
    }
  }, {
    key: '_setDarkBackground',
    value: function _setDarkBackground() {
      var _this3 = this;

      var colorIndex = this.props.colorIndex;

      var box = (0, _reactDom.findDOMNode)(this.boxContainerRef);
      if (this._checkBackground) {
        this._checkBackground.stop();
      }
      this._checkBackground = (0, _DOM.checkDarkBackground)(colorIndex, box, function (darkBackground) {
        return _this3.setState({ darkBackground: darkBackground });
      });
    }
  }, {
    key: '_normalize',
    value: function _normalize(string) {
      return string.replace('/', '-');
    }
  }, {
    key: '_addPropertyClass',
    value: function _addPropertyClass(classes, property) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var value = (options.object || this.props)[property];
      var elementName = options.elementName || CLASS_ROOT;
      var prefix = options.prefix || property;
      if (value) {
        if (typeof value === 'string') {
          classes.push(elementName + '--' + prefix + '-' + this._normalize(value));
        } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
          Object.keys(value).forEach(function (key) {
            _this4._addPropertyClass(classes, key, {
              object: value, prefix: prefix + '-' + key });
          });
        } else {
          classes.push(elementName + '--' + this._normalize(prefix));
        }
      }
    }
  }, {
    key: '_backgroundContextClass',
    value: function _backgroundContextClass(darkBackground) {
      var result = void 0;
      if (undefined === darkBackground) {
        result = BACKGROUND_COLOR_INDEX + '--pending';
      } else if (darkBackground) {
        result = BACKGROUND_COLOR_INDEX + '--dark';
      } else {
        result = BACKGROUND_COLOR_INDEX + '--light';
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          appCentered = _props.appCentered,
          backgroundImage = _props.backgroundImage,
          children = _props.children,
          className = _props.className,
          colorIndex = _props.colorIndex,
          containerClassName = _props.containerClassName,
          focusable = _props.focusable,
          full = _props.full,
          id = _props.id,
          onClick = _props.onClick,
          _onBlur = _props.onBlur,
          _onFocus = _props.onFocus,
          _onMouseDown = _props.onMouseDown,
          _onMouseUp = _props.onMouseUp,
          pad = _props.pad,
          primary = _props.primary,
          role = _props.role,
          size = _props.size,
          tabIndex = _props.tabIndex,
          tag = _props.tag,
          texture = _props.texture;
      var _state = this.state,
          darkBackground = _state.darkBackground,
          mouseActive = _state.mouseActive;

      var classes = [CLASS_ROOT];
      var containerClasses = [CLASS_ROOT + '__container'];
      var restProps = _Props2.default.omit(this.props, Object.keys(Box.propTypes));
      this._addPropertyClass(classes, 'full');
      if (full && full.responsive === undefined) {
        // default is true for backwards compatibility sake
        classes.push(CLASS_ROOT + '--full-responsive');
      }
      this._addPropertyClass(classes, 'direction');
      this._addPropertyClass(classes, 'justify');
      this._addPropertyClass(classes, 'align');
      this._addPropertyClass(classes, 'alignContent', { prefix: 'align-content' });
      this._addPropertyClass(classes, 'alignSelf', { prefix: 'align-self' });
      this._addPropertyClass(classes, 'reverse');
      this._addPropertyClass(classes, 'responsive');
      this._addPropertyClass(classes, 'basis');
      this._addPropertyClass(classes, 'flex');
      this._addPropertyClass(classes, 'pad');
      this._addPropertyClass(classes, 'margin');
      this._addPropertyClass(classes, 'separator');
      this._addPropertyClass(classes, 'textAlign', { prefix: 'text-align' });
      this._addPropertyClass(classes, 'wrap');

      if (this.props.hasOwnProperty('flex')) {
        if (!this.props.flex) {
          classes.push(CLASS_ROOT + '--flex-off');
        }
      }
      if (size) {
        if ((typeof size === 'undefined' ? 'undefined' : _typeof(size)) === 'object') {
          Object.keys(size).forEach(function (key) {
            _this5._addPropertyClass(classes, key, { object: size });
          });
        } else {
          this._addPropertyClass(classes, 'size');
        }
        if (size) {
          if (!(size.width && size.width.max)) {
            // don't apply 100% max-width when size using size.width.max option
            classes.push(CLASS_ROOT + '--size');
          }
          if (size.width && size.width.max) {
            // allow widths to shrink, apply 100% width
            classes.push(CLASS_ROOT + '--width-max');
          }
        }
      }

      // needed to properly set flex-basis for 1/3 & 2/3 basis boxes
      if (pad && pad.between && children) {
        if (_react2.default.Children.count(children) % 3 === 0) {
          classes.push(CLASS_ROOT + '--pad-between-thirds');
        }
      }

      if (appCentered) {
        this._addPropertyClass(containerClasses, 'full', { elementName: CLASS_ROOT + '__container' });
        if (colorIndex) {
          containerClasses.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
          containerClasses.push(this._backgroundContextClass(darkBackground));
        }
        if (containerClassName) {
          containerClasses.push(containerClassName);
        }
      } else if (colorIndex) {
        classes.push(BACKGROUND_COLOR_INDEX + '-' + colorIndex);
        classes.push(this._backgroundContextClass(darkBackground));
      }

      var a11yProps = {};
      var clickableProps = {};
      if (onClick) {
        classes.push(CLASS_ROOT + "--clickable");
        clickableProps = {
          onMouseDown: function onMouseDown(event) {
            _this5.setState({ mouseActive: true });
            if (_onMouseDown) {
              _onMouseDown(event);
            }
          },
          onMouseUp: function onMouseUp(event) {
            _this5.setState({ mouseActive: false });
            if (_onMouseUp) {
              _onMouseUp(event);
            }
          },
          onFocus: function onFocus(event) {
            if (mouseActive === false) {
              _this5.setState({ focus: true });
            }
            if (_onFocus) {
              _onFocus(event);
            }
          },
          onBlur: function onBlur(event) {
            _this5.setState({ focus: false });
            if (_onBlur) {
              _onBlur(event);
            }
          }
        };
        if (focusable) {
          if (this.state.focus) {
            classes.push(CLASS_ROOT + '--focus');
          }
          var boxLabel = typeof a11yTitle !== 'undefined' ? a11yTitle : _Intl2.default.getMessage(this.context.intl, 'Box');
          a11yProps.tabIndex = tabIndex || 0;
          a11yProps["aria-label"] = this.props['aria-label'] || boxLabel;
          a11yProps.role = role || 'group';
        }
      }

      var skipLinkAnchor = void 0;
      if (primary) {
        var mainContentLabel = _Intl2.default.getMessage(this.context.intl, 'Main Content');
        skipLinkAnchor = _react2.default.createElement(_SkipLinkAnchor2.default, { label: mainContentLabel });
      }

      if (className) {
        classes.push(className);
      }

      var style = {};
      if (texture && 'string' === typeof texture) {
        if (texture.indexOf('url(') !== -1) {
          style.backgroundImage = texture;
        } else {
          style.backgroundImage = 'url(' + texture + ')';
        }
      } else if (backgroundImage) {
        style.background = backgroundImage + " no-repeat center center";
        style.backgroundSize = "cover";
      }
      style = _extends({}, style, restProps.style);
      var textureMarkup = void 0;
      if ('object' === (typeof texture === 'undefined' ? 'undefined' : _typeof(texture))) {
        textureMarkup = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + "__texture" },
          texture
        );
      }

      var Component = tag;
      if (appCentered) {
        return _react2.default.createElement(
          'div',
          _extends({}, restProps, { ref: function ref(_ref) {
              return _this5.boxContainerRef = _ref;
            },
            className: containerClasses.join(' '),
            style: style, role: role }, a11yProps, clickableProps),
          skipLinkAnchor,
          _react2.default.createElement(
            Component,
            { id: id, className: classes.join(' ') },
            textureMarkup,
            children
          )
        );
      } else {
        return _react2.default.createElement(
          Component,
          _extends({}, restProps, { ref: function ref(_ref2) {
              return _this5.boxContainerRef = _ref2;
            },
            id: id, className: classes.join(' '), style: style,
            role: role, tabIndex: tabIndex,
            onClick: onClick }, a11yProps, clickableProps),
          skipLinkAnchor,
          textureMarkup,
          children
        );
      }
    }
  }]);

  return Box;
}(_react.Component);

Box.displayName = 'Box';
exports.default = Box;


var FIXED_SIZES = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
var RELATIVE_SIZES = ['full', '1/2', '1/3', '2/3', '1/4', '3/4'];
var SIZES = FIXED_SIZES.concat(RELATIVE_SIZES);
var MARGIN_SIZES = ['small', 'medium', 'large', 'none'];
var PAD_SIZES = ['small', 'medium', 'large', 'xlarge', 'none'];

Box.propTypes = {
  a11yTitle: _propTypes2.default.string,
  announce: _propTypes2.default.bool,
  align: _propTypes2.default.oneOf(['start', 'center', 'end', 'baseline', 'stretch']),
  alignContent: _propTypes2.default.oneOf(['start', 'center', 'end', 'between', 'around', 'stretch']),
  alignSelf: _propTypes2.default.oneOf(['start', 'center', 'end', 'stretch']),
  appCentered: _propTypes2.default.bool,
  backgroundImage: _propTypes2.default.string,
  basis: _propTypes2.default.oneOf(SIZES),
  colorIndex: _propTypes2.default.string,
  containerClassName: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['row', 'column']),
  focusable: _propTypes2.default.bool,
  flex: _propTypes2.default.oneOf(['grow', 'shrink', true, false]),
  full: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.shape({
    vertical: _propTypes2.default.bool,
    horizontal: _propTypes2.default.bool,
    responsive: _propTypes2.default.bool
  })]),
  // remove in 1.0?
  onClick: _propTypes2.default.func,
  justify: _propTypes2.default.oneOf(['start', 'center', 'between', 'end', 'around']),
  margin: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(MARGIN_SIZES), _propTypes2.default.shape({
    bottom: _propTypes2.default.oneOf(MARGIN_SIZES),
    horizontal: _propTypes2.default.oneOf(MARGIN_SIZES),
    left: _propTypes2.default.oneOf(MARGIN_SIZES),
    right: _propTypes2.default.oneOf(MARGIN_SIZES),
    top: _propTypes2.default.oneOf(MARGIN_SIZES),
    vertical: _propTypes2.default.oneOf(MARGIN_SIZES)
  })]),
  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(PAD_SIZES), _propTypes2.default.shape({
    between: _propTypes2.default.oneOf(PAD_SIZES),
    horizontal: _propTypes2.default.oneOf(PAD_SIZES),
    vertical: _propTypes2.default.oneOf(PAD_SIZES)
  })]),
  primary: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  responsive: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  separator: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right', 'horizontal', 'vertical', 'all', 'none']),
  size: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['auto', 'xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge', 'full']), // remove in 1.0?, use basis
  _propTypes2.default.shape({
    height: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
      max: _propTypes2.default.oneOf(FIXED_SIZES),
      min: _propTypes2.default.oneOf(FIXED_SIZES)
    })]),
    width: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(SIZES), _propTypes2.default.shape({
      max: _propTypes2.default.oneOf(FIXED_SIZES),
      min: _propTypes2.default.oneOf(FIXED_SIZES)
    })])
  })]),
  tag: _propTypes2.default.string,
  textAlign: _propTypes2.default.oneOf(['left', 'center', 'right']),
  texture: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  wrap: _propTypes2.default.bool
};

Box.contextTypes = {
  intl: _propTypes2.default.object
};

Box.defaultProps = {
  announce: false,
  direction: 'column',
  pad: 'none',
  tag: 'div',
  responsive: true,
  focusable: true
};
module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EPAActvSolnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return saveworkloadopened; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return redirectPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return changeSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return toggleSizeButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return updateSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SaveCurrentSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deleteSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return errorValidataion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return updateCountry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return updateEULA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return refArchSession; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return sapSolPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return sapHanaSolPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return sapTdiSolPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return refArchBOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return fetchCompareSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchMetricsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return fetchCompareMetricsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return downloadMetricsData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return downloadFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return downloadSolutionPreview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return exportCompareSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return exportCompareSolutionData; });
/* unused harmony export fetchWorkloads */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return fetchBOMString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fetchGRinput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return fetchGRBomInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return fetchConfigString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return fetchDefaultData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return getSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return getAdvancedSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return validateWorkload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return saveWorkload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return saveSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return loadSessionList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return loadSessionfromSSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return loadSessionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return deleteSessionItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return shareItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return loadNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return acceptwlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return rejectwlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchSupportedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return saveUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deleteUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return fetchLookupServersList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return comparedata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return compareGlgrowthData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return updateSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchSettings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GetWorkloadWithMainstream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return clearGuidance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return showLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppConfig__ = __webpack_require__(13);
var EPAActvSolnChange=function EPAActvSolnChange(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["q" /* EPA_ACTV_SOLN_CHANGE */],payload:{data:data}};};var saveworkloadopened=function saveworkloadopened(value){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["P" /* OPENED_SAVEWORKLOAD */],payload:{data:value}};};var redirectPage=function redirectPage(isTrue,path){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["S" /* REDIRECT_CONFLICT */],payload:{isTrue:isTrue,path:path}};};var addSession=function addSession(id,name){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["b" /* ADD_SESSION */],payload:{id:id,name:name}};};var changeSession=function changeSession(id){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["g" /* CHANGE_SESSION */],payload:{id:id}};};var toggleSizeButton=function toggleSizeButton(value){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_2" /* TOGGLE_SIZE_BUTTON */],payload:{value:value}};};var updateSession=function updateSession(session){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_5" /* UPDATE_SESSION */],payload:{session:session}};};var SaveCurrentSession=function SaveCurrentSession(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["X" /* SAVE_DATA */]};};var deleteSession=function deleteSession(id){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["o" /* DELETE_SESSION */],payload:{id:id}};};var errorValidataion=function errorValidataion(errorMsg){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["u" /* ERROR_SESSION */],payload:{errorMsg:errorMsg}};};var updateCountry=function updateCountry(country){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["m" /* COUNTRY_CHANGE */],payload:{country:country}};};var updateEULA=function updateEULA(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["j" /* CLOSE_EULA */],payload:{data:data}};};var refArchSession=function refArchSession(UserData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'EPA/LoadReferenceArchitectrureSolution',data:UserData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["L" /* LOAD_SELECTION */]}};};var sapSolPreview=function sapSolPreview(UserData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/SAPSolutionPreview',data:UserData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["W" /* SAP_SOL_PREVIEW */]}};};var sapHanaSolPreview=function sapHanaSolPreview(UserData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetSolutionPreview',data:UserData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["U" /* SAPHANA_SOL_PREVIEW */]}};};var sapTdiSolPreview=function sapTdiSolPreview(UserData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetSolutionPreview',data:UserData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["V" /* SAPTDI_SOL_PREVIEW */]}};};var refArchBOM=function refArchBOM(UserData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'EPA/LoadReferenceArchitectrureSolution',data:UserData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["D" /* FETCH_RA_BOM */]}};};var fetchCompareSolution=function fetchCompareSolution(UserData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/FetchCompareSolution',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["x" /* FETCH_COMPARE_SOLUTION */],data:UserData}};};var fetchMetricsData=function fetchMetricsData(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetMetricsData',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["C" /* FETCH_METRICS_DATA */],data:sessionID}};};var fetchCompareMetricsData=function fetchCompareMetricsData(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetCompareMetricsData',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["w" /* FETCH_COMPARE_METRICS_DATA */],data:sessionID}};};var downloadMetricsData=function downloadMetricsData(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/ExportMetricsData',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["r" /* EPA_DOWNLOAD_METRICS */],data:data}};};var downloadFile=function downloadFile(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["d" /* API_REQUEST_BLOB */],payload:{url:data.url,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["p" /* DOWNLOAD_FILE */],fileName:data.name}};};var downloadSolutionPreview=function downloadSolutionPreview(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["f" /* API_REQUEST_POST_BLOB */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GenerateSolutionPreviewpdf',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["p" /* DOWNLOAD_FILE */],fileName:data.name,data:data}};};var exportCompareSolution=function exportCompareSolution(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/ExportCompareSolutionData',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["s" /* EPA_EXPORT_COMPARESOLUTIONDATA */],data:data}};};var exportCompareSolutionData=function exportCompareSolutionData(data){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'EPAvNext/ExportCompareSolutionData',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["s" /* EPA_EXPORT_COMPARESOLUTIONDATA */],data:data}};};var fetchWorkloads=function fetchWorkloads(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* API_REQUEST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'Dummy/getSizerDefaults',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["I" /* FETCH_WORKLOADS */]}};};var fetchBOMString=function fetchBOMString(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GenerateBillOfMaterial',data:sessionID,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["v" /* FETCH_BOM */]}};};var fetchGRinput=function fetchGRinput(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GenerateGRInput',data:sessionID,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["B" /* FETCH_GR_INPUT */]}};};var fetchGRBomInput=function fetchGRBomInput(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GenerateBOMforGR',data:sessionID,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["A" /* FETCH_GRBOM */]}};};var fetchConfigString=function fetchConfigString(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GenerateConfigurationDetails',data:sessionID,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["y" /* FETCH_CONFIGDETAILS */]}};};var fetchDefaultData=function fetchDefaultData(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* API_REQUEST */],payload:{// url: 'http://16.100.138.154/api/ExchangeSizer',
// url: 'http://128.88.150.172:8090/api/ExchangeSizer', 
url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetSizerDefaults',//url: 'http://16.107.49.148:99/Services/CS750VirtSizer/GetSizerDefaults',
next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["z" /* FETCH_DEFAULT_DATA */]}};};var getSolution=function getSolution(workload){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/SizeSolution',data:workload,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["F" /* FETCH_SOLUTION */]}};};var getAdvancedSolution=function getAdvancedSolution(workload){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'API/ExternalSizing/AdvancedSizing',data:workload,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["G" /* FETCH_SOLUTION_ADVANCED */]}};};var validateWorkload=function validateWorkload(url,workload){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:url,data:workload,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_6" /* VALIDATE_WORKLOAD */]}};};var saveWorkload=function saveWorkload(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/SaveWorkload',data:sessionID,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["Z" /* SAVE_WORKLOAD */]}};};var saveSolution=function saveSolution(sessionID){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/SaveSolution',data:sessionID,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["Y" /* SAVE_SOLUTION */]}};};var loadSessionList=function loadSessionList(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/FetchUserData',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["M" /* LOAD_USER_DATA */]}};};var loadSessionfromSSET=function loadSessionfromSSET(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GetSSETData',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["L" /* LOAD_SELECTION */]}};};var loadSessionItem=function loadSessionItem(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/getSelection',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["L" /* LOAD_SELECTION */]}};};var deleteSessionItem=function deleteSessionItem(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/DeleteSelection',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["n" /* DELETE_SELECTION */]}};};var shareItems=function shareItems(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/CreateNotification',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_0" /* SHARE_SELECTION */]}};};var loadNotifications=function loadNotifications(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/FetchNotifications',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["K" /* LOAD_NOTIFICATIONS */]}};};var acceptwlsl=function acceptwlsl(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/ShareSelection',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["a" /* ACCEPT_WLSL */]}};};var rejectwlsl=function rejectwlsl(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/RejectNotification',data:userData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["T" /* REJECT_WLSL */]}};};var fetchSupportedList=function fetchSupportedList(){return{type:'API_REQUEST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetAllSupportedComponents',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["t" /* EPA_FETCH_SUPPORTEDLIST */]}};};var saveUserData=function saveUserData(UserInfo){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/SaveUserInfo',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["R" /* POST_USER_DATA */],data:UserInfo}};};var deleteUserData=function deleteUserData(UserInfo){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/DeleteUserInfo',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_3" /* UNSUBSCRIBE_USER_DATA */],data:UserInfo}};};var fetchLookupServersList=function fetchLookupServersList(UserInfo){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/SupportedServers',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_4" /* UPDATE_LOOKUPSERVERS */],data:UserInfo}};};var comparedata=function comparedata(compdata){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetComparedata',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["l" /* COMPARE_SOL_DATA */],data:compdata}};};var compareGlgrowthData=function compareGlgrowthData(compdata){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'api/'+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetComparedata'+'?strSessionID='+(''+compdata),next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["k" /* COMPARE_GLGROWTH_DATA */],data:compdata}};};var updateSettings=function updateSettings(settings){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/UserPreferences',next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["E" /* FETCH_SETTINGS */],data:settings}};};var fetchSettings=function fetchSettings(queryString){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* API_REQUEST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/UserPreferences/'+queryString,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["E" /* FETCH_SETTINGS */]}};};var GetWorkloadWithMainstream=function GetWorkloadWithMainstream(UserData){return{type:'API_REQUEST_POST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]+'/GetWorkloadWithMainstream',data:UserData,next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["J" /* GET_WORKLOAD_WITH_MAINSTREAM */]}};};var clearGuidance=function clearGuidance(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["i" /* CLEAR_GUIDANCE_ERROR */]};};var showLoading=function showLoading(msg){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["Q" /* POSTSSET_PENDING */],payload:msg};};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.HEADING;

var Heading = function (_Component) {
  _inherits(Heading, _Component);

  function Heading() {
    _classCallCheck(this, Heading);

    return _possibleConstructorReturn(this, (Heading.__proto__ || Object.getPrototypeOf(Heading)).apply(this, arguments));
  }

  _createClass(Heading, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          align = _props.align,
          children = _props.children,
          className = _props.className,
          margin = _props.margin,
          size = _props.size,
          strong = _props.strong,
          Tag = _props.tag,
          truncate = _props.truncate,
          uppercase = _props.uppercase,
          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'strong', 'tag', 'truncate', 'uppercase']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _classnames), className);

      return _react2.default.createElement(
        Tag,
        _extends({}, props, { className: classes }),
        children
      );
    }
  }]);

  return Heading;
}(_react.Component);

Heading.displayName = 'Heading';
exports.default = Heading;


Heading.propTypes = {
  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  strong: _propTypes2.default.bool,
  tag: _propTypes2.default.string,
  truncate: _propTypes2.default.bool,
  uppercase: _propTypes2.default.bool
};

Heading.defaultProps = {
  tag: 'h1'
};
module.exports = exports['default'];

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLASS_ROOT = _CSSClassnames2.default.BUTTON;

function getHoverModifier(hoverIndicator) {
  if (hoverIndicator) {
    if ((typeof hoverIndicator === 'undefined' ? 'undefined' : _typeof(hoverIndicator)) === 'object') {
      if (hoverIndicator.background) {
        if (typeof hoverIndicator.background === 'string') {
          var prefix = _CSSClassnames.namespace + 'background-hover-color-index-';
          return '' + prefix + hoverIndicator.background;
        }
        return CLASS_ROOT + '--hover-background';
      }
    } else if (typeof hoverIndicator === 'string') {
      return CLASS_ROOT + '--hover-' + hoverIndicator;
    }
  }
}

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

    _this._onClick = _this._onClick.bind(_this);
    _this._onMouseDown = _this._onMouseDown.bind(_this);
    _this._onMouseUp = _this._onMouseUp.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onBlur = _this._onBlur.bind(_this);
    _this.state = {
      mouseActive: false,
      focus: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: '_onClick',
    value: function _onClick(event) {
      var _props = this.props,
          method = _props.method,
          onClick = _props.onClick,
          path = _props.path;
      var router = this.context.router;

      var modifierKey = event.ctrlKey || event.metaKey;

      if (modifierKey && !onClick) {
        return true;
      }

      event.preventDefault();

      if ('push' === method) {
        (router.history || router).push(path);
      } else if ('replace' === method) {
        (router.history || router).replace(path);
      }

      if (onClick) {
        onClick.apply(undefined, arguments);
      }
    }
  }, {
    key: '_onMouseDown',
    value: function _onMouseDown(event) {
      var onMouseDown = this.props.onMouseDown;

      this.setState({ mouseActive: true });
      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: '_onMouseUp',
    value: function _onMouseUp(event) {
      var onMouseUp = this.props.onMouseUp;

      this.setState({ mouseActive: false });
      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: '_onFocus',
    value: function _onFocus(event) {
      var onFocus = this.props.onFocus;
      var mouseActive = this.state.mouseActive;

      if (mouseActive === false) {
        this.setState({ focus: true });
      }
      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: '_onBlur',
    value: function _onBlur(event) {
      var onBlur = this.props.onBlur;

      this.setState({ focus: false });
      if (onBlur) {
        onBlur(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          accent = _props2.accent,
          align = _props2.align,
          box = _props2.box,
          children = _props2.children,
          className = _props2.className,
          critical = _props2.critical,
          fill = _props2.fill,
          hoverIndicator = _props2.hoverIndicator,
          href = _props2.href,
          icon = _props2.icon,
          label = _props2.label,
          onClick = _props2.onClick,
          path = _props2.path,
          plain = _props2.plain,
          primary = _props2.primary,
          reverse = _props2.reverse,
          secondary = _props2.secondary,
          type = _props2.type,
          props = _objectWithoutProperties(_props2, ['a11yTitle', 'accent', 'align', 'box', 'children', 'className', 'critical', 'fill', 'hoverIndicator', 'href', 'icon', 'label', 'onClick', 'path', 'plain', 'primary', 'reverse', 'secondary', 'type']);

      delete props.method;
      var router = this.context.router;


      var buttonIcon = void 0;
      if (icon) {
        buttonIcon = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__icon' },
          icon
        );
      }

      var buttonLabel = void 0;
      if (label) {
        buttonLabel = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__label' },
          label
        );
      }

      var adjustedHref = void 0;
      if (router && router.createPath) {
        adjustedHref = path && router ? router.createPath(path) : href;
      } else {
        adjustedHref = path && router && router.history ? router.history.createHref({ pathname: path }) : href;
      }

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--box', box), _defineProperty(_classnames, CLASS_ROOT + '--critical', critical), _defineProperty(_classnames, CLASS_ROOT + '--focus', this.state.focus), _defineProperty(_classnames, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames, CLASS_ROOT + '--secondary', secondary), _defineProperty(_classnames, CLASS_ROOT + '--accent', accent), _defineProperty(_classnames, CLASS_ROOT + '--disabled', !onClick && !adjustedHref && ['reset', 'submit'].indexOf(type) === -1), _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--plain', plain || box || _react.Children.count(children) > 0 || icon && !label), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, getHoverModifier(hoverIndicator), hoverIndicator), _classnames), className);

      var adjustedOnClick = path && router ? this._onClick : onClick;

      var Tag = adjustedHref ? 'a' : 'button';
      var buttonType = void 0;
      if (!adjustedHref) {
        buttonType = type;
      }

      var boxProps = void 0;
      if (box) {
        // Let the root element of the Button be a Box element with tag prop
        boxProps = {
          tag: Tag
        };
        Tag = _Box2.default;
      }

      var first = reverse ? buttonLabel : buttonIcon;
      var second = reverse ? buttonIcon : buttonLabel;

      return _react2.default.createElement(
        Tag,
        _extends({}, props, boxProps, { href: adjustedHref, type: buttonType,
          className: classes, 'aria-label': a11yTitle,
          onClick: adjustedOnClick,
          disabled: !onClick && !adjustedHref && ['reset', 'submit'].indexOf(type) === -1,
          onMouseDown: this._onMouseDown, onMouseUp: this._onMouseUp,
          onFocus: this._onFocus, onBlur: this._onBlur }),
        first,
        second,
        children
      );
    }
  }]);

  return Button;
}(_react.Component);

Button.displayName = 'Button';
exports.default = Button;


Button.propTypes = {
  a11yTitle: _propTypes2.default.string,
  accent: _propTypes2.default.bool,
  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
  box: _propTypes2.default.bool,
  critical: _propTypes2.default.bool,
  fill: _propTypes2.default.bool,
  hoverIndicator: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['background']), _propTypes2.default.shape({
    background: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string])
  })]),
  href: _propTypes2.default.string,
  icon: _propTypes2.default.element,
  label: _propTypes2.default.node,
  method: _propTypes2.default.oneOf(['push', 'replace']),
  onClick: _propTypes2.default.func,
  path: _propTypes2.default.string,
  plain: _propTypes2.default.bool,
  primary: _propTypes2.default.bool,
  reverse: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['button', 'reset', 'submit'])
};

Button.defaultProps = {
  method: 'push',
  type: 'button'
};

Button.contextTypes = {
  router: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serviceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return said; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return basename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return landingUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logOutAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return redirection_Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__ = __webpack_require__(63);
//import {_serviceUrl,_appUrl,_version,_said,_sizerType,_sizerName,_launcher,_launcherClass} from './SizerUI/SizerConfig/Config'
var supportEmail="ese_aa_solutions@hpe.com";var serviceUrl=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["e" /* _serviceUrl */];var appUrl=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["a" /* _appUrl */];var version=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["g" /* _version */];var said=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["d" /* _said */];var title=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["f" /* _title */];var basename=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["b" /* _basename */];var landingUrl=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_Config__["c" /* _landingUrl */];var logOutAttribute='ssoLoggedOut';//export const redirection_Link = 'hc9w03273.itcs.hpe.com'
//export const redirection_Link = 'solutionsizers.ext.hpe.com'
var redirection_Link=window.location.host;// export const sizerType = _sizerType;             
// export const sizerName = _sizerName ;
// export const launcher = _launcher ;
// export const launcherClass = _launcherClass ;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.PARAGRAPH;

var Paragraph = function (_Component) {
  _inherits(Paragraph, _Component);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          align = _props.align,
          children = _props.children,
          className = _props.className,
          margin = _props.margin,
          size = _props.size,
          width = _props.width,
          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'margin', 'size', 'width']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + margin, margin), _defineProperty(_classnames, CLASS_ROOT + '--width-' + width, width), _classnames), className);

      return _react2.default.createElement(
        'p',
        _extends({}, props, { className: classes }),
        children
      );
    }
  }]);

  return Paragraph;
}(_react.Component);

Paragraph.displayName = 'Paragraph';
exports.default = Paragraph;


Paragraph.propTypes = {
  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge']),
  width: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};
module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _Close = __webpack_require__(27);

var _Close2 = _interopRequireDefault(_Close);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _DOM = __webpack_require__(59);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.LAYER;
var APP = _CSSClassnames2.default.APP;

var LayerContents = function (_Component) {
  _inherits(LayerContents, _Component);

  function LayerContents(props, context) {
    _classCallCheck(this, LayerContents);

    var _this = _possibleConstructorReturn(this, (LayerContents.__proto__ || Object.getPrototypeOf(LayerContents)).call(this, props, context));

    _this._onClickOverlay = _this._onClickOverlay.bind(_this);
    _this._processTab = _this._processTab.bind(_this);

    _this.state = {
      dropActive: false
    };
    return _this;
  }

  _createClass(LayerContents, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        history: this.props.history,
        intl: this.props.intl,
        onDropChange: function onDropChange(active) {
          _this2.setState({ dropActive: active });
        },
        router: this.props.router,
        store: this.props.store
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          hidden = _props.hidden,
          onClose = _props.onClose,
          overlayClose = _props.overlayClose;


      if (!hidden) {
        this.anchorStepRef.focus();
        this.anchorStepRef.scrollIntoView();
      }

      this._keyboardHandlers = {
        tab: this._processTab
      };
      if (onClose) {
        this._keyboardHandlers.esc = onClose;
      }
      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);

      if (onClose && overlayClose) {
        var layerParent = this.containerRef.parentNode;
        layerParent.addEventListener('click', this._onClickOverlay);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var hidden = this.props.hidden;


      if (nextProps.hidden !== hidden) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);

        if (!nextProps.hidden) {
          _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
        }
      };
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props,
          onClose = _props2.onClose,
          overlayClose = _props2.overlayClose;

      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);

      if (onClose && overlayClose) {
        var layerParent = this.containerRef.parentNode;
        layerParent.removeEventListener('click', this._onClickOverlay);
      }
    }
  }, {
    key: '_processTab',
    value: function _processTab(event) {
      var hidden = this.props.hidden;

      if (hidden) {
        return;
      }
      var items = this.containerRef.getElementsByTagName('*');
      items = (0, _DOM.filterByFocusable)(items);

      if (!items || items.length === 0) {
        event.preventDefault();
      } else {
        if (event.shiftKey) {
          if (event.target === items[0]) {
            items[items.length - 1].focus();
            event.preventDefault();
          }
        } else if (event.target === items[items.length - 1]) {
          items[0].focus();
          event.preventDefault();
        }
      }
    }
  }, {
    key: '_onClickOverlay',
    value: function _onClickOverlay(event) {
      var dropActive = this.state.dropActive;

      if (!dropActive) {
        var onClose = this.props.onClose;

        var layerContents = this.containerRef;

        if (layerContents && !layerContents.contains(event.target)) {
          onClose();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          a11yTitle = _props3.a11yTitle,
          children = _props3.children,
          closer = _props3.closer,
          onClose = _props3.onClose;
      var intl = this.context.intl;


      var closerNode = void 0;
      if ((typeof closer === 'undefined' ? 'undefined' : _typeof(closer)) === 'object') {
        closerNode = closer;
      } else if (onClose && closer) {
        var closeLabel = _Intl2.default.getMessage(intl, 'Close');
        var layerLabel = _Intl2.default.getMessage(intl, 'Layer');
        var closeIconTitle = closeLabel + ' ' + (a11yTitle || '') + ' ' + layerLabel;

        closerNode = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + '__closer' },
          _react2.default.createElement(_Button2.default, { plain: true, icon: _react2.default.createElement(_Close2.default, {
              a11yTitle: closeIconTitle }),
            onClick: onClose })
        );
      }

      return _react2.default.createElement(
        'div',
        { ref: function ref(_ref2) {
            return _this3.containerRef = _ref2;
          },
          className: CLASS_ROOT + '__container' },
        _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true', style: { outline: 'none' },
          ref: function ref(_ref) {
            return _this3.anchorStepRef = _ref;
          } }),
        closerNode,
        children
      );
    }
  }]);

  return LayerContents;
}(_react.Component);

LayerContents.displayName = 'LayerContents';


LayerContents.propTypes = {
  a11yTitle: _propTypes2.default.string,
  closer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
  history: _propTypes2.default.object,
  intl: _propTypes2.default.object,
  onClose: _propTypes2.default.func,
  overlayClose: _propTypes2.default.bool,
  router: _propTypes2.default.any,
  store: _propTypes2.default.any
};

// Because Layer creates a new DOM render context, the context
// is not transfered. For now, we hard code these specific ones.
// TODO: Either figure out how to introspect the context and transfer
// whatever we find or have callers explicitly indicate which parts
// of the context to transfer somehow.
LayerContents.childContextTypes = {
  history: _propTypes2.default.object,
  intl: _propTypes2.default.object,
  onDropChange: _propTypes2.default.func,
  router: _propTypes2.default.any,
  store: _propTypes2.default.object
};

var Layer = function (_Component2) {
  _inherits(Layer, _Component2);

  function Layer() {
    _classCallCheck(this, Layer);

    return _possibleConstructorReturn(this, (Layer.__proto__ || Object.getPrototypeOf(Layer)).apply(this, arguments));
  }

  _createClass(Layer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._originalFocusedElement = document.activeElement;
      this._originalScrollPosition = {
        top: window.pageYOffset,
        left: window.pageXOffset
      };
      this._addLayer();
      this._renderLayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._renderLayer();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this5 = this;

      var hidden = this.props.hidden;

      if (this._originalFocusedElement && !hidden) {
        if (this._originalFocusedElement.focus) {
          // wait for the fixed positioning to come back to normal
          // see layer styling for reference
          setTimeout(function () {
            _this5._originalFocusedElement.focus();
            window.scrollTo(_this5._originalScrollPosition.left, _this5._originalScrollPosition.top);
          }, 0);
        } else if (this._originalFocusedElement.parentNode && this._originalFocusedElement.parentNode.focus) {
          // required for IE11 and Edge
          this._originalFocusedElement.parentNode.focus();
          window.scrollTo(this._originalScrollPosition.left, this._originalScrollPosition.top);
        }
      }

      this._removeLayer();
    }
  }, {
    key: '_classesFromProps',
    value: function _classesFromProps() {
      var _classnames;

      var _props4 = this.props,
          align = _props4.align,
          className = _props4.className,
          closer = _props4.closer,
          flush = _props4.flush,
          hidden = _props4.hidden,
          peek = _props4.peek;


      return (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--align-' + this.props.align, align), _defineProperty(_classnames, CLASS_ROOT + '--closeable', closer), _defineProperty(_classnames, CLASS_ROOT + '--flush', flush), _defineProperty(_classnames, CLASS_ROOT + '--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '--peek', peek), _classnames), className);
    }
  }, {
    key: '_addLayer',
    value: function _addLayer() {
      var id = this.props.id;


      var element = document.createElement('div');
      if (id) {
        element.id = id;
      }
      element.className = this._classesFromProps();
      // insert before .app, if possible.
      var appElements = document.querySelectorAll('.' + APP);
      var beforeElement;
      if (appElements.length > 0) {
        beforeElement = appElements[0];
      } else {
        beforeElement = document.body.firstChild;
      }
      if (beforeElement) {
        this._element = beforeElement.parentNode.insertBefore(element, beforeElement);
      }
    }
  }, {
    key: '_handleAriaHidden',
    value: function _handleAriaHidden(hideOverlay) {
      var _this6 = this;

      setTimeout(function () {
        var ariaHidden = hideOverlay || false;
        var grommetApps = document.querySelectorAll('.' + APP);
        var visibleLayers = document.querySelectorAll('.' + CLASS_ROOT + ':not(.' + CLASS_ROOT + '--hidden)');

        if (grommetApps) {
          Array.prototype.slice.call(grommetApps).forEach(function (grommetApp) {
            if (ariaHidden && visibleLayers.length === 0) {
              // make sure to only show grommet apps if there is no other layer
              grommetApp.setAttribute('aria-hidden', false);
              grommetApp.classList.remove(APP + '--hidden');
              // scroll body content to the original position
              grommetApp.style.top = '-' + _this6._originalScrollPosition.top + 'px';
              grommetApp.style.left = '-' + _this6._originalScrollPosition.left + 'px';
            } else {
              grommetApp.setAttribute('aria-hidden', true);
              grommetApp.classList.add(APP + '--hidden');
              // this must be null to work
              grommetApp.style.top = null;
              grommetApp.style.left = null;
            }
          }, _this6);
        }
      }, 0);
    }
  }, {
    key: '_renderLayer',
    value: function _renderLayer() {
      var _this7 = this;

      if (this._element) {
        this._element.className = this._classesFromProps();
        var contents = _react2.default.createElement(LayerContents, _extends({}, this.props, {
          history: this.context.history,
          intl: this.context.intl,
          router: this.context.router,
          store: this.context.store }));
        _reactDom2.default.render(contents, this._element, function () {
          var hidden = _this7.props.hidden;

          if (hidden) {
            _this7._handleAriaHidden(true);
          } else {
            _this7._handleAriaHidden(false);
          }
        });
      }
    }
  }, {
    key: '_removeLayer',
    value: function _removeLayer() {
      if (this._element) {
        this._element.removeEventListener('animationend', this._onAnimationEnd);

        _reactDom2.default.unmountComponentAtNode(this._element);
        this._element.parentNode.removeChild(this._element);
        this._element = undefined;

        // make sure to handle aria attributes after the layer is removed
        this._handleAriaHidden(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('span', { style: { display: 'none' } });
    }
  }]);

  return Layer;
}(_react.Component);

Layer.displayName = 'Layer';
exports.default = Layer;


Layer.propTypes = {
  align: _propTypes2.default.oneOf(['center', 'top', 'bottom', 'left', 'right']),
  closer: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.bool]),
  flush: _propTypes2.default.bool,
  hidden: _propTypes2.default.bool,
  overlayClose: _propTypes2.default.bool,
  peek: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};

Layer.contextTypes = {
  router: _propTypes2.default.any,
  history: _propTypes2.default.object,
  intl: _propTypes2.default.object,
  store: _propTypes2.default.object
};

Layer.defaultProps = {
  align: 'center'
};
module.exports = exports['default'];

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var callBind = __webpack_require__(212);

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.')) {
		return callBind(intrinsic);
	}
	return intrinsic;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SPINNING;

var Spinning = function (_Component) {
  _inherits(Spinning, _Component);

  function Spinning() {
    _classCallCheck(this, Spinning);

    return _possibleConstructorReturn(this, (Spinning.__proto__ || Object.getPrototypeOf(Spinning)).apply(this, arguments));
  }

  _createClass(Spinning, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          small = _props.small,
          size = _props.size,
          responsive = _props.responsive,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className', 'small', 'size', 'responsive']);

      var intl = this.context.intl;


      var sizeOverride = small ? 'small' : size;

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + sizeOverride, sizeOverride), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _classnames), className);

      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 48 48', version: '1.1',
          role: 'img', 'aria-label': a11yTitle || _Intl2.default.getMessage(intl, 'Spinning') }),
        _react2.default.createElement('circle', { cx: '24', cy: '24', r: '21',
          stroke: '#979797', strokeWidth: '6', fill: 'none' })
      );
    }
  }]);

  return Spinning;
}(_react.Component);

Spinning.displayName = 'Spinning';
exports.default = Spinning;


Spinning.contextTypes = {
  intl: _propTypes2.default.object
};

Spinning.defaultProps = {
  responsive: true
};

Spinning.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string,
  small: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(348);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://www.ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BIG_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return BLUE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return HPE_CP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return NONGPU_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return GPU_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_161", function() { return STORAGE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return GATEWAY_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return CONTROLLER_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return MASTER_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return GPU_NODE_STORAGE_DRIVE_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return GPU_NODE_STORAGE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return GPU_TENANT_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return GPU_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return NONGPU_NODE_STORAGE_DRIVE_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return NONGPU_NODE_STORAGE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return NONGPU_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return NONGPU_TENANT_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_162", function() { return STORAGE_HOST_ROLE_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_167", function() { return STORAGE_NODE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_169", function() { return STORAGE_PROCESSOR_FAMILY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_170", function() { return STORAGE_PROCESSOR_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_163", function() { return STORAGE_MEMORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_165", function() { return STORAGE_NODE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_166", function() { return STORAGE_NODE_DRIVE_QTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_168", function() { return STORAGE_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_171", function() { return STORAGE_TENANT_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_172", function() { return STORAGE_TENANT_DRIVE_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_164", function() { return STORAGE_NODE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return GATEWAY_NODE_STORAGE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return GATEWAY_NODE_STORAGE_DRIVE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return GATEWAY_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return CONTROLLER_NODE_STORAGE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return CONTROLLER_NODE_STORAGE_DRIVE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return CONTROLLER_TENANT_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return CONTROLLER_TENANT_DRIVE_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return CONTROLLER_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return MASTER_NODE_STORAGE_DRIVE; });
/* unused harmony export MASTER_NODE_STORAGE_DRIVE_COUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return MASTER_TENANT_DRIVE; });
/* unused harmony export MASTER_TENANT_DRIVE_COUNT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return MASTER_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return MIXED_STORAGE_SERVER_CHANGE_WARNING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_182", function() { return TENANT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return NVME_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return HPECP_SIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return HPE_E_CP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return HPE_E_CPDESC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_145", function() { return RE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_147", function() { return RE_SHORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return E910; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return EL4000; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return HPECP_SUPPORTED_SERVERS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return HPECP_WARNING_MESSAGE; });
/* unused harmony export CONFIGURE_IN_ALL_SERVICES_MESSAGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return HPECP_CONTAINER_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return NAV_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_197", function() { return WARNING_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return HPE_APOLLO_4200_GEN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return HPE_APOLLO_4200_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return HPE_APOLLO_4500_GEN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_175", function() { return SYN_480_GEN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_176", function() { return SYN_480_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return PROLIANT_DL360_GEN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return PROLIANT_DL380_GEN10; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return PROLIANT_DL360_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return PROLIANT_DL365_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return PROLIANT_DL325_GEN10_PLUS_V2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return PROLIANT_DL380_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return PROLIANT_DL385_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return PROLIANT_DL325_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_139", function() { return PROLIANT_XL290N_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return GATEWAY_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return MASTER_NODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return PERSISTENT_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_189", function() { return TRUE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return FALSE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_210", function() { return tRUE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_204", function() { return fALSE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return NONE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return INCHES_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return INCHES_THREE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return NINE_X_FIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return MOONSHOT_510; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return MOONSHOT_750; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_157", function() { return SFF_DESCRIPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return ERROR_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return DRIVE_CANNOTBE_MIXED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return MAXDRIVEQTY_EXCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return HORTONWORK_ENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return HORTONWORK_ENT_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return HORTONWORKS_DATAFLOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return CLOUDERA_ESSENTIALS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return CLOUDERA_ENT_DATAHUB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return CLOUDERA_DATA_ENGINEERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CLOUDERA_OP_DATABASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return CLOUDERA_ANALYTICAL_DB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return HPE_EZMERAL_MLOPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return KUBERNETES_CM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return LFF_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_152", function() { return SATA_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return HDD_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_151", function() { return SAS_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return NVMe_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return M_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_188", function() { return TRAINING_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return INFERENCE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_160", function() { return SPARK_JUPYTER_CONTAINER_GPU_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_159", function() { return SPARK_JUPYTER_CONTAINER_GPU_LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_184", function() { return TENSORFLOW_JUPYPETER_CONTAINER_GPU_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_183", function() { return TENSORFLOW_JUPYPETER_CONTAINER_GPU_LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_MEDIUM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_LARGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return DATA_APPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return DATA_APPS_wMLOPs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return HARDWARELICENSE_PARAGRAPH_CLASSNAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return INFOICON_COLORINDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return INCLUDE_HA_TOOLTIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_153", function() { return SEPARATE_STORAGE_HOSTS_TOOLTIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_138", function() { return PROLIANT_XL225N_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_137", function() { return PROLIANT_XL220N_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return DLC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return NUMERIC_ONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return NUMERIC_TWO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_212", function() { return yES_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_206", function() { return nONE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_207", function() { return nO_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return EPIC_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return KUBERNETES_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_198", function() { return WHITE_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BLACK_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BLOCK_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_180", function() { return TAB_BACKGROUND; });
/* unused harmony export BOTH_ */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_190", function() { return VMWARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_191", function() { return VMWARE_VCENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_195", function() { return VMWARE_VSPHERE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_193", function() { return VMWARE_VREALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_194", function() { return VMWARE_VSAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return MLOPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CAAS_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return GATEWAY_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CONTROLLER_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return MASTER_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return EPA_GROWTH_HEADINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return EZMERAL_GROWTH_HEADINGS; });
/* unused harmony export MLOPS_CAAS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return GENERAL_PURPOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return EZMERAL_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_186", function() { return TOTALS_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return NODE_STORAGE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return NODE_STORAGE_DRIVE_QTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return EPHEMERAL_STORAGE_DTIVE_QUANTITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return EPHEMERAL_STORAGE_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return CONFIGURATION_MARGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_199", function() { return ZERO_PERCENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return HYPHEN_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_158", function() { return SIZE_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return LST_HDFS_DRIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return DDRIVE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_174", function() { return STR_DRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return I_QTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return CONFIGURATION_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_202", function() { return configurationWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_211", function() { return templateWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_201", function() { return clustersWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_208", function() { return nodesPerClusterWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_203", function() { return coresWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_205", function() { return memoryWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return EphemeralStorageWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_209", function() { return persistentStorageWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return GPUsWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_187", function() { return TRAINING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return IMAGE_PROCESSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return MLOPS_TEMPLATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return MLOPS_IMAGE_PROCESSING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return DATA_FABRIC; });
/* unused harmony export PROLIANT_XL170r */
/* unused harmony export HP_MOONSHOT_SYSTEM */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return GPU_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return NONGPU_RESULT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_185", function() { return TEXT_ATTRIBUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ATTRIBUTE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ATTRIBUTE_ISSELECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ATTRIBUTE_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_142", function() { return QTY_ONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_143", function() { return QTY_TWO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return CAAS_MEMORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return MANAGEMENT_HOSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return DISK_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return PROCESSOR_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return MEMORY_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_181", function() { return TB_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return GB_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return EDGELINE_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return POWER_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return DATA_LAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return HDFS_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return HDFS_EC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_144", function() { return RAW_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ATTRIBUTE_OSDRIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ATTRIBUTE_PERSISTENTDRIVEQTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DATALAKE_COMPRESSION_MINVLAUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DATALAKE_COMPRESSION_MAXVLAUE; });
/* unused harmony export HPE_EZMERAL_DATAFABRIC */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return HPE_EZMERAL_DF_XD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return HPE_EZMERAL_DF_FILE_STORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return HPE_EZMERAL_DF_ANALYTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return HPE_EZMERAL_DF_SPARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return HPE_EZMERAL_DF_STREAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return HPE_EZMERAL_DF_DATABASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return HPE_EZMERAL_DF_BUNDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DATAFABRIC_XD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DATAFABRIC_ANALYTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DATAFABRIC_SPARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DATAFABRIC_STREAMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DATAFABRIC_DATABASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DATAFABRIC_BUNDLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DATAFABRIC_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return DATALAKE_REPLICATION_MINVALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return DATALAKE_REPLICATION_MAXVALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_156", function() { return SERVICES_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return HPE_CONTAINER_PLATFORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BLUEDATA_AI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DATALAKE_MIN_NODES; });
/* unused harmony export INFERENCE_SERVERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return EZMERAL_CP_OPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_154", function() { return SERVERCHANGE_WARNINGTEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return IOT_; });
/* unused harmony export MINIFI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return FUNCTIONNAME_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_155", function() { return SERVICENAME_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DATADISKS_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ATTRIBUTE_dISK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ATTRIBUTE_qTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return NONE_RADBTN_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return CUSTOM_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return CUSTOM_WGPUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ATTRIBUTE_VCLUSTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ATTRIBUTE_NODESPERCLUSTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ATTRIBUTE_VCPUPERNODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ATTRIBUTE_VMEMORYPERNODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ATTRIBUTE_VSTORAGEPERNODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return OVERHEAD_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_146", function() { return REPLICATION_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_173", function() { return STORAGE_TO_COMPUTE_RATIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return PERSISTENT_STORAGE_DEFAULTVALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return CUSTOMTEMPLATE_DEFAULTVALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_141", function() { return PROLIANT_XL675D_GEN10_PLUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_140", function() { return PROLIANT_XL645D_GEN10_PLUS; });
/* unused harmony export A100_SXM4_40GB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return PROLIANT_E910T_2U_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return PROLIANT_E910_2U_SERVER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_179", function() { return T4_TESLA_GPU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return HPE_Ezmeral_CP_Option; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return DiskCapacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return Overhead; });
/* unused harmony export Storage_Workload */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return CapacityType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return Compression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_149", function() { return Replication; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_178", function() { return Select_Green_Lake_Flex_Capacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_150", function() { return Replication_to_a_second_site; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_200", function() { return calculated_ARC_level; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Add_servers_to_this_deployment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return BOM_and_SKU_information; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_177", function() { return SelectWorkloadTemp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return EzemeralServicesToolTips; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return DEFAULT_GROWTH_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_192", function() { return VMWARE_VCENTER_3YRS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_196", function() { return VMWARE_VSPHERE_3YRS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_148", function() { return RI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return IMAGE_PER_SEC; });
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var CHANGE="Change";var BLUR="Blur";var BIG_DATA="BigData";var BLUE_DATA="BlueData";var HPE_CP="HPECP";var NONGPU_="NonGPU";var GPU_="GPU";var STORAGE_="Storage";var GATEWAY_="Gateway";var CONTROLLER_="Controller";var MASTER_="Master";var GPU_NODE_STORAGE_DRIVE_QUANTITY="GPUNodeStorageDriveQuantity";var GPU_NODE_STORAGE_DRIVE="GPUStrDrivetype";var GPU_TENANT_DRIVE="GPUTenantStoragedrive";var GPU_OSDRIVE="GPUOSDrive";var NONGPU_NODE_STORAGE_DRIVE_QUANTITY="NonGPUNodeStorageDriveQuantity";var NONGPU_NODE_STORAGE_DRIVE="NonGPUStrDrivetype";var NONGPU_OSDRIVE="NonGPUOSDrive";var NONGPU_TENANT_DRIVE="NonGPUTenantStoragedrive";var STORAGE_HOST_ROLE_NAME="Storage Host";var STORAGE_NODE_TYPE="storageNodeType";var STORAGE_PROCESSOR_FAMILY="storageProcFamilyType";var STORAGE_PROCESSOR_TYPE="storageProcType";var STORAGE_MEMORY="storageMemory";var STORAGE_NODE_DRIVE="storageNodeDrive";var STORAGE_NODE_DRIVE_QTY="storageNodeDriveQty";var STORAGE_OSDRIVE="storageOSDrive";var STORAGE_TENANT_DRIVE="storageTenantStoragedrive";var STORAGE_TENANT_DRIVE_QUANTITY="storageTenantDriveQuantity";var STORAGE_NODE_COUNT="storageNodeCount";var GATEWAY_NODE_STORAGE_DRIVE="GatewayStrDrvtype";var GATEWAY_NODE_STORAGE_DRIVE_COUNT="GatewayStrDrvCount";var GATEWAY_OSDRIVE="GatewayOSDrive";var CONTROLLER_NODE_STORAGE_DRIVE="ControllerStrDrvtype";var CONTROLLER_NODE_STORAGE_DRIVE_COUNT="ControllerStrDrvCount";var CONTROLLER_TENANT_DRIVE="TenantStrDrvtype";var CONTROLLER_TENANT_DRIVE_COUNT="TenantStrDrvCount";var CONTROLLER_OSDRIVE="ControllerOSDrive";var MASTER_NODE_STORAGE_DRIVE="MasterStrDrvtype";var MASTER_NODE_STORAGE_DRIVE_COUNT="MasterStrDrvCount";var MASTER_TENANT_DRIVE="MasterTenantStrDrvtype";var MASTER_TENANT_DRIVE_COUNT="MasterTenantStrDrvCount";var MASTER_OSDRIVE="MasterOSDrive";var MIXED_STORAGE_SERVER_CHANGE_WARNING="All Mixed Storage Configurations have to be deleted to change server selection.";var TENANT="Tenant";var NODE="Node";var NVME_="NVME";var HPECP_SIZER="EzmeralCPSizer";var HPE_E_CP="HPE Ezmeral RE";var HPE_E_CPDESC="HPE Ezmeral Runtime Enterprise";var RE="Runtime Enterprise";var RE_SHORT="RE";var E910="e910";var EL4000='EL4000';var HPECP_SUPPORTED_SERVERS_LIST=["ProLiant XL170r Gen10","ProLiant XL190r Gen10","ProLiant XL270d Gen10","HPE Apollo 4200 Gen10 Server","HPE Apollo 4500 Gen10 System","Synergy 480 Gen10 Server","ProLiant DL360 Gen10","ProLiant DL380 Gen10"];var HPECP_WARNING_MESSAGE='Please click on Calculate Sizer Recommendation button to perform Finish.';var CONFIGURE_IN_ALL_SERVICES_MESSAGE='Please selet the workload and click on Calculate Sizer Recommendation button in all selected services to perform Finish.';var HPECP_CONTAINER_PAGE='HPEEzmeralRuntimeEnterprise';var NAV_MESSAGE='Click here to navigate.';var WARNING_TEXT="Warning";var HPE_APOLLO_4200_GEN10="HPE Apollo 4200 Gen10 Server";var HPE_APOLLO_4200_GEN10_PLUS="HPE Apollo 4200 Gen10 Server Plus";var HPE_APOLLO_4500_GEN10="HPE Apollo 4500 Gen10 System";var SYN_480_GEN10="Synergy 480 Gen10 Server";var SYN_480_GEN10_PLUS="Synergy 480 Gen10 Plus Server";var PROLIANT_DL360_GEN10="ProLiant DL360 Gen10";var PROLIANT_DL380_GEN10="ProLiant DL380 Gen10";var PROLIANT_DL360_GEN10_PLUS="ProLiant DL360 Gen10 Plus";var PROLIANT_DL365_GEN10_PLUS="ProLiant DL365 Gen10 Plus";var PROLIANT_DL325_GEN10_PLUS_V2="ProLiant DL325 Gen10 Plus v2";var PROLIANT_DL380_GEN10_PLUS="ProLiant DL380 Gen10 Plus";var PROLIANT_DL385_GEN10_PLUS="ProLiant DL385 Gen10 Plus";var PROLIANT_DL325_GEN10_PLUS="ProLiant DL325 Gen10 Plus";var PROLIANT_XL290N_GEN10_PLUS="ProLiant XL290n Gen10 Plus";var GATEWAY_NODE="Gateway Node";var MASTER_NODE="Master Node";var PERSISTENT_="Persistent";var TRUE_="True";var FALSE_="False";var tRUE_="true";var fALSE_="false";var NONE_="None";var INCHES_='2.5IN';var INCHES_THREE='3.5IN';var NINE_X_FIVE="9x5 1y";var MOONSHOT_510='m510';var MOONSHOT_750='m750';var SFF_DESCRIPTIONS=['SFF','2.5IN'];var ERROR_TEXT="Error";var DRIVE_CANNOTBE_MIXED="The selected drive type cannot be mixed with existing drives.";var MAXDRIVEQTY_EXCEEDED=["Maximum Drive Quantity (",") is exceeded for the selected drive type."];var HORTONWORK_ENT="HortonWork Enterprise";var HORTONWORK_ENT_PLUS="HortonWork Enterprise Plus";var HORTONWORKS_DATAFLOW="Hortonworks DataFlow";var CLOUDERA_ESSENTIALS="Cloudera Essentials";var CLOUDERA_ENT_DATAHUB="Cloudera Enterprise Data Hub";var CLOUDERA_DATA_ENGINEERING="Cloudera Data Engineering";var CLOUDERA_OP_DATABASE="Cloudera Operational Database";var CLOUDERA_ANALYTICAL_DB="Cloudera Analytical Database";var HPE_EZMERAL_MLOPS="HPE Ezmeral ML Ops";var KUBERNETES_CM="Kubernetes CM";var HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR="HPE Ezmeral RE External Kubernetes Cluster Manager";var LFF_='LFF';var SATA_='SATA';var HDD_='HDD';var SAS_='SAS';var NVMe_='NVMe';var M_2='M.2';var TRAINING_="Training-";var INFERENCE_="Inference";var SPARK_JUPYTER_CONTAINER_GPU_MEDIUM="Spark Jupyter-Container GPU Medium";var SPARK_JUPYTER_CONTAINER_GPU_LARGE="Spark Jupyter-Container GPU Large";var TENSORFLOW_JUPYPETER_CONTAINER_GPU_MEDIUM="Tensorflow Jupyter-Container GPU Medium";var TENSORFLOW_JUPYPETER_CONTAINER_GPU_LARGE="Tensorflow Jupyter-Container GPU Large";var INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_MEDIUM="Inference-Tensorflow ModelServer-Container GPU Medium";var INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_LARGE="Inference-Tensorflow ModelServer-Container GPU Large";var DATA_APPS="Data Apps";var DATA_APPS_wMLOPs="Data Apps w/ML Ops";var HARDWARELICENSE_PARAGRAPH_CLASSNAME="HardwareLicensesParagraph";var INFOICON_COLORINDEX="accent-3";var INCLUDE_HA_TOOLTIP='Checking the High Availability check box will add two additional controller servers. One for a Shadow Controller and one Arbiter. In addition the minimum number of gateway servers will be set to two.';var SEPARATE_STORAGE_HOSTS_TOOLTIP="Data Fabric or Persistent Storage is to be configured on separate storage hosts.";var PROLIANT_XL225N_GEN10_PLUS="ProLiant XL225n Gen10 Plus";var PROLIANT_XL220N_GEN10_PLUS="ProLiant XL220n Gen10 Plus";var DLC="DLC";var AC="AC";var NUMERIC_ONE="1";var NUMERIC_TWO="2";var yES_="yes";var nONE_="none";var nO_="no";var EPIC_="EPIC";var KUBERNETES_="Kubernetes";var WHITE_COLOR="white";var BLACK_COLOR="black";var BLOCK_="block";var TAB_BACKGROUND='#425563 80%';var BOTH_="Both";var VMWARE="VMWare";var VMWARE_VCENTER="VMWare vCenter";var VMWARE_VSPHERE="VMWare vSphere";var VMWARE_VREALIZE="VMWare vRealize";var VMWARE_VSAN="VMWare vSAN";var MLOPS="MLOps";var CAAS_="CaaS";var GATEWAY_HOST="Gateway Host";var CONTROLLER_HOST="Controller Host";var MASTER_HOST="Master Host";var EPA_GROWTH_HEADINGS=['Services','Growth Y/Y','%','Total # of Nodes Yr 1','Total # of Nodes Yr 2','Total # of Nodes Yr 3'];var EZMERAL_GROWTH_HEADINGS=['Services','Growth %','Total # of Host Yr 1','Total # of Host Yr 2','Total # of Host Yr 3','Total # of Host Yr 4'];var MLOPS_CAAS=["MLOps","CaaS"];var GENERAL_PURPOSE="Runtime Enterprise";var EZMERAL_="Ezmeral";var TOTALS_TEXT=" Totals :";var NODE_STORAGE_DRIVE="NodeStorageDrive";var NODE_STORAGE_DRIVE_QTY="NodeStorageDriveQty";var EPHEMERAL_STORAGE_DTIVE_QUANTITY="Ephemeral Storage Drive Quantity";var EPHEMERAL_STORAGE_DRIVE="Ephemeral Storage Drive";var CONFIGURATION_MARGIN='8%';var ZERO_PERCENT='0%';var HYPHEN_="-";var SIZE_ATTRIBUTE="@size";var LST_HDFS_DRIVES='lstHDFSDrives';var DDRIVE_SIZE='DDriveSize';var STR_DRIVE='StrDrive';var I_QTY='IQty';var CONFIGURATION_OPTIONS=["Cost","Density","Performance","Power"];var configurationWidth='13%';var templateWidth='18%';var clustersWidth='10%';var nodesPerClusterWidth='12%';var coresWidth='9%';var memoryWidth='9%';var EphemeralStorageWidth='10%';var persistentStorageWidth='10%';var GPUsWidth='9%';var TRAINING="Training";var IMAGE_PROCESSING="Image Processing";var MLOPS_TEMPLATES="MLOps Templates";var MLOPS_IMAGE_PROCESSING="MLOps Image Processing";var DATA_FABRIC="Data Fabric";var PROLIANT_XL170r="ProLiant XL170r Gen10";var HP_MOONSHOT_SYSTEM="HP Moonshot System";var GPU_RESULT="GPU_Result";var NONGPU_RESULT="NonGPU_Result";var TEXT_ATTRIBUTE="#text";var ATTRIBUTE_TYPE="@Type";var ATTRIBUTE_ISSELECTED="@IsSelected";var ATTRIBUTE_DESCRIPTION="@Description";var QTY_ONE="1";var QTY_TWO="2";var CAAS_MEMORY="384 GB";var MANAGEMENT_HOSTS="ManagementHosts";var DISK_="Disk";var PROCESSOR_="Processor";var MEMORY_="Memory";var TB_='TB';var GB_='GB';var EDGELINE_="Edgeline";var POWER_="Power";var DATA_LAKE="Data Lake";var HDFS_="HDFS";var HDFS_EC="HDFS and HDFS-EC";var RAW_="Raw";var ATTRIBUTE_OSDRIVE="OSDrive";var ATTRIBUTE_PERSISTENTDRIVEQTY="PersistentDriveQty";var DATALAKE_COMPRESSION_MINVLAUE="0.00";var DATALAKE_COMPRESSION_MAXVLAUE="1.00";var HPE_EZMERAL_DATAFABRIC="HPE Ezmeral Data Fabric";var HPE_EZMERAL_DF_XD="HPE Ezmeral Data Fabric XD";var HPE_EZMERAL_DF_FILE_STORE="HPE Ezmeral Data Fabric File Store";var HPE_EZMERAL_DF_ANALYTICS="HPE Ezmeral Data Fabric Analytics";var HPE_EZMERAL_DF_SPARK="HPE Ezmeral Data Fabric Spark";var HPE_EZMERAL_DF_STREAMS="HPE Ezmeral Data Fabric Streams";var HPE_EZMERAL_DF_DATABASE="HPE Ezmeral Data Fabric Database";var HPE_EZMERAL_DF_BUNDLE="HPE Ezmeral Data Fabric Bundle";var DATAFABRIC_XD="DataFabric XD";var DATAFABRIC_ANALYTICS="DataFabric Analytics";var DATAFABRIC_SPARK="DataFabric Spark";var DATAFABRIC_STREAMS="DataFabric Streams";var DATAFABRIC_DATABASE="DataFabric Database";var DATAFABRIC_BUNDLE="DataFabric Bundle";var DATAFABRIC_SERVICES="HPE Ezmeral Data Fabric Services";var DATALAKE_REPLICATION_MINVALUE="1.00";var DATALAKE_REPLICATION_MAXVALUE="5.00";var SERVICES_="Services";var HPE_CONTAINER_PLATFORM="HPE Container Platform";var BLUEDATA_AI="BlueDataAI";var DATALAKE_MIN_NODES="4";var INFERENCE_SERVERS=[PROLIANT_DL360_GEN10,PROLIANT_DL380_GEN10];var EZMERAL_CP_OPTION="EzmeralREOption";var SERVERCHANGE_WARNINGTEXT="The selected server does not support the existing drive configuration, please delete the mixed drive configuration to change the server.";var IOT_="IoT";var MINIFI="MiNifi";var FUNCTIONNAME_="functionName";var SERVICENAME_="serviceName";var DATADISKS_="DataDisks";var ATTRIBUTE_dISK="@disk";var ATTRIBUTE_qTY="@qty";var NONE_RADBTN_ID="choice1-4";var CUSTOM_TEMPLATE="Custom";var CUSTOM_WGPUS="Custom w/GPUs";var ATTRIBUTE_VCLUSTERS="@vClusters";var ATTRIBUTE_NODESPERCLUSTER="@vNodesPerCluster";var ATTRIBUTE_VCPUPERNODE="@vCPUPerNode";var ATTRIBUTE_VMEMORYPERNODE="@vMemoryPerNode";var ATTRIBUTE_VSTORAGEPERNODE="@StoragePervNode";var OVERHEAD_="Overhead";var REPLICATION_="Replication";var STORAGE_TO_COMPUTE_RATIO="Storage to Compute Ratio";var PERSISTENT_STORAGE_DEFAULTVALUE="0";var CUSTOMTEMPLATE_DEFAULTVALUE="1";var PROLIANT_XL675D_GEN10_PLUS="ProLiant XL675d Gen10 Plus";var PROLIANT_XL645D_GEN10_PLUS="ProLiant XL645d Gen10 Plus";var A100_SXM4_40GB="A100-SXM4-40GB";var PROLIANT_E910T_2U_SERVER="HPE ProLiant e910t 2U CTO Blade Server";var PROLIANT_E910_2U_SERVER="HPE ProLiant e910 2U CTO Blade Server";var T4_TESLA_GPU="Tesla-PCIE-16GB";var HPE_Ezmeral_CP_Option="HPE RE Licenses and Services are applicable for HPE servers";var DiskCapacity="Total Storage capacity (TB) required for the cluster.";var Overhead="It is the extra space needed to store the raw data, like temp files, metadata, logs etc";var Storage_Workload="StorageWorkload field allows you to fine tune sizing vs Equivalent 2P nodes.20% is the average value. If you know your workload is more Storage oriented, you can increase this percentage in order to obtain more accurate sizing";var CapacityType="Select “Raw” if you want to input Raw Storage, Select “Usable” if you want to input usable Storage";var Compression="It reduces the space needed to store files, and it speeds up data transfer across the network to or from disk.";var Replication="Number of replicas to store.";var Select_Green_Lake_Flex_Capacity="Add HPE Green Lake Flex capacity";var Replication_to_a_second_site="Replication to multiple sites";var calculated_ARC_level="For Erasure Coding scheme.";var Add_servers_to_this_deployment='Select No if building a configuration for a temporary POC environment or eternally small configuration';var BOM_and_SKU_information="Sizing using selected hardware configuration and server count.";var SelectWorkloadTemp="Select the workload templates that best fits your workload. You can modify the inputs to fit the requirements. Each template configures core/memory/storage requirements for each container. Also number of containers for each cluster is configured.";var EzemeralServicesToolTips={"Runtime Enterprise":"Small/Medium/Large configurations with Container and Physical requirements are available. Also Utility with  Medium/Large configuration are available with this option. Physical configuration with 22 core/150GB mem/1.5TB ephemeral storage can be selected. Medium and Large physical configurations add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.","Data Fabric":"Small/Medium/Large Storage configurations with Container and Physical requirements are available. Also Hadoop/HDF/MapR/Spark containers with HA and Small/Medium/Large configuration are available in this option. Physical configuration with 22 core/150GB mem/1.5TB ephemeral storage can be selected. Medium and Large physical configuration add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.","Unified Analytics":"Small/Medium/Large Analytics configurations with Container and Physical requirements are available. Also Kafka/Elastic Search/MySQL/Spark containers with Medium/Large configuration are available in this option. Physical configuration with 22 core/150GB mem/1.5TB ephemeral storage can be selected. Medium and Large physical configuration add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.","MLOps":"Inference and Training (Small/Medium/Large) configurations with Container and Physical GPU requirements are available in this option. Physical configuration with 22 core/150GB mem/1.5TB storage can be selected. Can be used to build a bare metal server. Medium and Large physical configuration add 20TB and 40TB persistent storage and 3/10/20 nodes are configured with Small/Medium/Large templates. Containers  with 4 core/16GB mem/100GB ephemeral storage configurations. Medium and Large container configurations have larger memory and storage. All parameters are configurable.","CaaS":"Small/Medium/Large configurations with Container and Physical requirements are available. Physical configuration with 22 core/150GB mem/1.5TB storage can be selected and can be used to build a bare metal server with those parameters. Small, Medium and Large physical configuration add 10TB, 20TB and 40TB persistent storage. Physical host with 12 nodes are configured with Small/Medium/Large templates with different memory and storage requirements. Container configuration with 4 core/16GB mem/100GB storage. Medium and Large container configurations have large memory and storage. All parameters are editable and number of containers is prepopulated."};var DEFAULT_GROWTH_OBJECT={Service:[{"@GrowthRate":"0","@GrowthType":"Nodes","@Name":"Storage","@Nodes1Y":"37","@Nodes2Y":"-","@Nodes3Y":"-","@Service":"Data Lake"},_defineProperty({"@Name":"Master Node","@Service":"","@GrowthType":"Nodes","@GrowthRate":"0","@Nodes1Y":"3","@Nodes2Y":"-","@Nodes3Y":"-"},"@Service","")]};var VMWARE_VCENTER_3YRS="VMWare vCenter 3 Years";var VMWARE_VSPHERE_3YRS="VMWare vSphere 3 Years";var RI="RI";var IMAGE_PER_SEC="@ImagesPerSec";

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TABLE_ROW;

var TableRow = function (_Component) {
  _inherits(TableRow, _Component);

  function TableRow() {
    _classCallCheck(this, TableRow);

    return _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).apply(this, arguments));
  }

  _createClass(TableRow, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          props = _objectWithoutProperties(_props, ['children', 'className', 'onClick']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--selectable', onClick), className);

      return _react2.default.createElement(
        'tr',
        _extends({}, props, { className: classes, onClick: onClick }),
        children
      );
    }
  }]);

  return TableRow;
}(_react.Component);

TableRow.displayName = 'TableRow';
exports.default = TableRow;


TableRow.propTypes = {
  onClick: _propTypes2.default.func
};
module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = __webpack_require__(18);

var _DOM = __webpack_require__(59);

// Allow callers to use key labels instead of key code numbers.
// This makes their code easier to read.
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var KEYS = {
  backspace: 8,
  tab: 9,
  enter: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  comma: 188,
  shift: 16
};

var _keyboardAccelerators = {};
var _listeners = [];
var _isKeyboardAcceleratorListening = false;

var _onKeyboardAcceleratorKeyPress = function _onKeyboardAcceleratorKeyPress(e) {
  var key = e.keyCode ? e.keyCode : e.which;
  _listeners.slice().reverse().some(function (listener) {
    if (_keyboardAccelerators[listener]) {
      var handlers = _keyboardAccelerators[listener].handlers;
      if (handlers.hasOwnProperty(key)) {
        if (handlers[key] && handlers[key](e)) {
          return true;
        }
      }
    }
    return false;
  });
};

// KeyboardAccelerators is a utility for handling keyboard events.
// Add listeners using startListeningToKeyboard().
// Remove listeners using stopListeningToKeyboard().
exports.default = {
  _initKeyboardAccelerators: function _initKeyboardAccelerators(element) {
    var id = (0, _DOM.generateId)(element);
    _keyboardAccelerators[id] = {
      handlers: {}
    };
  },
  _getKeyboardAcceleratorHandlers: function _getKeyboardAcceleratorHandlers(element) {
    var id = (0, _DOM.generateId)(element);
    return _keyboardAccelerators[id].handlers;
  },
  _getDowns: function _getDowns(element) {
    var id = (0, _DOM.generateId)(element);
    return _keyboardAccelerators[id].downs;
  },
  _isComponentListening: function _isComponentListening(element) {
    var id = (0, _DOM.generateId)(element);

    return _listeners.some(function (listener) {
      return listener === id;
    });
  },
  _subscribeComponent: function _subscribeComponent(element) {
    var id = (0, _DOM.generateId)(element);
    _listeners.push(id);
  },
  _unsubscribeComponent: function _unsubscribeComponent(element) {
    var id = (0, _DOM.generateId)(element);

    var removeListenerIndex = _listeners.indexOf(id);
    _listeners.splice(removeListenerIndex, 1);

    delete _keyboardAccelerators[id];
  },


  // Add handlers for specific keys.
  // This function can be called multiple times, existing handlers will
  // be replaced, new handlers will be added.
  startListeningToKeyboard: function startListeningToKeyboard(component, handlers) {
    var element = (0, _reactDom.findDOMNode)(component);
    if (element) {
      this._initKeyboardAccelerators(element);
      var keys = 0;
      for (var key in handlers) {
        if (handlers.hasOwnProperty(key)) {
          var keyCode = key;
          if (KEYS.hasOwnProperty(key)) {
            keyCode = KEYS[key];
          }
          keys += 1;
          this._getKeyboardAcceleratorHandlers(element)[keyCode] = handlers[key];
        }
      }

      if (keys > 0) {
        if (!_isKeyboardAcceleratorListening) {
          window.addEventListener("keydown", _onKeyboardAcceleratorKeyPress);
          _isKeyboardAcceleratorListening = true;
        }
        if (!this._isComponentListening(element)) {
          this._subscribeComponent(element);
        }
      }
    }
  },


  // Remove handlers for all keys or specific keys.
  // If no argument is passed in, all handlers are removed.
  // This function can be called multiple times, only the handlers
  // specified will be removed.
  stopListeningToKeyboard: function stopListeningToKeyboard(component, handlers) {
    var element = (0, _reactDom.findDOMNode)(component);
    if (!this._isComponentListening(element)) {
      return;
    }
    if (handlers) {
      for (var key in handlers) {
        if (handlers.hasOwnProperty(key)) {
          var keyCode = key;
          if (KEYS.hasOwnProperty(key)) {
            keyCode = KEYS[key];
          }
          delete this._getKeyboardAcceleratorHandlers(element)[keyCode];
        }
      }
    }

    var keyCount = 0;
    for (var keyHandler in this._getKeyboardAcceleratorHandlers(element)) {
      if (this._getKeyboardAcceleratorHandlers(element).hasOwnProperty(keyHandler)) {
        keyCount += 1;
      }
    }

    if (!handlers || 0 === keyCount) {
      this._initKeyboardAccelerators(element);
      this._unsubscribeComponent(element);
    }

    if (_listeners.length === 0) {
      window.removeEventListener("keydown", _onKeyboardAcceleratorKeyPress);
      _isKeyboardAcceleratorListening = false;
    }
  }
};
module.exports = exports['default'];

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Drop = __webpack_require__(124);

var _Drop2 = _interopRequireDefault(_Drop);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _CheckBox = __webpack_require__(39);

var _CheckBox2 = _interopRequireDefault(_CheckBox);

var _RadioButton = __webpack_require__(96);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _Search = __webpack_require__(547);

var _Search2 = _interopRequireDefault(_Search);

var _CaretDown = __webpack_require__(549);

var _CaretDown2 = _interopRequireDefault(_CaretDown);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SELECT;
var INPUT = _CSSClassnames2.default.INPUT;

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select(props, context) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props, context));

    _this._onAddDrop = _this._onAddDrop.bind(_this);
    _this._onRemoveDrop = _this._onRemoveDrop.bind(_this);
    _this._onForceClose = _this._onForceClose.bind(_this);
    _this._onSearchChange = _this._onSearchChange.bind(_this);
    _this._onNextOption = _this._onNextOption.bind(_this);
    _this._onPreviousOption = _this._onPreviousOption.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);
    _this._stopPropagation = _this._stopPropagation.bind(_this);
    _this._onInputKeyDown = _this._onInputKeyDown.bind(_this);
    _this._announceOptions = _this._announceOptions.bind(_this);

    _this.state = {
      announceChange: false,
      activeOptionIndex: -1,
      dropActive: false,
      searchText: '',
      value: _this._normalizeValue(props, {})
    };
    return _this;
  }

  _createClass(Select, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.hasOwnProperty('value')) {
        this.setState({ value: this._normalizeValue(nextProps, this.state) });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          inline = _props.inline,
          options = _props.options;
      var _state = this.state,
          announceChange = _state.announceChange,
          dropActive = _state.dropActive;
      var intl = this.context.intl;

      // Set up keyboard listeners appropriate to the current state.

      var activeKeyboardHandlers = {
        up: this._onPreviousOption,
        down: this._onNextOption,
        enter: this._onEnter,
        left: this._stopPropagation,
        right: this._stopPropagation
      };

      if (!inline) {
        activeKeyboardHandlers.esc = this._onForceClose;
        activeKeyboardHandlers.tab = this._onForceClose;
      }

      // the order here is important, need to turn off keys before turning on
      if (!dropActive && prevState.dropActive) {
        document.removeEventListener('click', this._onRemoveDrop);
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
        if (this._drop) {
          this._drop.remove();
          this._drop = undefined;
        }
      }

      if (inline && !prevProps.inline || dropActive && !prevState.dropActive) {

        if (!inline) {
          document.addEventListener('click', this._onRemoveDrop);
        }

        _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);

        if (!inline) {
          // If this is inside a FormField, place the drop in reference to it.
          var control = this.valueRef || this.inputRef;
          this._drop = new _Drop2.default(control, this._renderOptions(CLASS_ROOT + '__drop'), {
            align: { top: 'bottom', left: 'left' },
            context: this.context,
            responsive: false // so suggestion changes don't re-align
          });
        }

        if (this._searchRef) {
          this._searchRef.focus();
          this._searchRef._inputRef.select();
        }
      } else if (dropActive && prevState.dropActive) {
        this._drop.render(this._renderOptions(CLASS_ROOT + '__drop'));
      }

      if (announceChange && options) {
        var matchResultsMessage = _Intl2.default.getMessage(intl, 'Match Results', {
          count: options.length
        });
        var navigationHelpMessage = '';
        if (options.length) {
          navigationHelpMessage = '(' + _Intl2.default.getMessage(intl, 'Navigation Help') + ')';
        }
        (0, _Announcer.announce)(matchResultsMessage + ' ' + navigationHelpMessage);
        this.setState({ announceChange: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this._onRemoveDrop);
      if (this._drop) {
        this._drop.remove();
      }
    }
  }, {
    key: '_normalizeValue',
    value: function _normalizeValue(props, state) {
      var multiple = props.multiple,
          value = props.value;

      var normalizedValue = value;
      if (multiple) {
        if (value) {
          if (!Array.isArray(value)) {
            normalizedValue = [value];
          }
        } else {
          normalizedValue = [];
        }
      }
      return normalizedValue;
    }
  }, {
    key: '_announceOptions',
    value: function _announceOptions(index) {
      var intl = this.context.intl;

      var labelMessage = this._renderValue(this.props.options[index]);
      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
      (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
    }
  }, {
    key: '_onInputKeyDown',
    value: function _onInputKeyDown(event) {
      var up = 38;
      var down = 40;
      if (event.keyCode === up || event.keyCode === down) {
        // stop the input to move the cursor when options are present
        event.preventDefault();
      }
    }
  }, {
    key: '_onSearchChange',
    value: function _onSearchChange(event) {
      var inline = this.props.inline;

      this.setState({
        announceChange: true,
        activeOptionIndex: -1,
        dropActive: !inline,
        searchText: event.target.value
      });
      if (this.props.onSearch) {
        this.props.onSearch(event);
      }
    }
  }, {
    key: '_onAddDrop',
    value: function _onAddDrop(event) {
      var _props2 = this.props,
          options = _props2.options,
          value = _props2.value;

      event.preventDefault();
      // Get values of options, so we can highlight selected option
      if (options) {
        var optionValues = options.map(function (option) {
          if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
            return option.value;
          } else {
            return option;
          }
        });
        var activeOptionIndex = optionValues.indexOf(value);
        this.setState({
          dropActive: true,
          activeOptionIndex: activeOptionIndex
        });
      }
    }
  }, {
    key: '_onRemoveDrop',
    value: function _onRemoveDrop(event) {
      if (!this._searchRef || !(0, _reactDom.findDOMNode)(this._searchRef).contains(event.target)) {
        this.setState({ dropActive: false });
      }
    }
  }, {
    key: '_onForceClose',
    value: function _onForceClose() {
      this.setState({ dropActive: false });
    }
  }, {
    key: '_onNextOption',
    value: function _onNextOption(event) {
      event.preventDefault();
      var index = this.state.activeOptionIndex;
      index = Math.min(index + 1, this.props.options.length - 1);
      this.setState({ activeOptionIndex: index }, this._announceOptions.bind(this, index));
    }
  }, {
    key: '_onPreviousOption',
    value: function _onPreviousOption(event) {
      event.preventDefault();
      var index = this.state.activeOptionIndex;
      index = Math.max(index - 1, 0);
      this.setState({ activeOptionIndex: index }, this._announceOptions.bind(this, index));
    }
  }, {
    key: '_valueForSelectedOption',
    value: function _valueForSelectedOption(option) {
      var multiple = this.props.multiple;
      var value = this.state.value;

      var nextValue = void 0;
      if (multiple) {
        nextValue = value.slice(0);
        var index = void 0;
        for (index = 0; index < nextValue.length; index += 1) {
          if (this._valueEqualsOption(nextValue[index], option)) {
            break;
          }
        }
        if (index < nextValue.length) {
          // already existing, remove
          nextValue.splice(index, 1);
        } else {
          // not there, add
          nextValue.push(option);
        }
      } else {
        nextValue = option;
      }
      return nextValue;
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(event) {
      var _this2 = this;

      var _props3 = this.props,
          onChange = _props3.onChange,
          options = _props3.options;
      var activeOptionIndex = this.state.activeOptionIndex;
      var intl = this.context.intl;

      if (activeOptionIndex >= 0) {
        event.preventDefault(); // prevent submitting forms
        var option = options[activeOptionIndex];
        var value = this._valueForSelectedOption(option);
        this.setState({ dropActive: false, value: value }, function () {
          var optionMessage = _this2._renderLabel(option);
          var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
          (0, _Announcer.announce)(optionMessage + ' ' + selectedMessage);
        });
        if (onChange) {
          onChange({ target: this.inputRef, option: option, value: value });
        }
      } else {
        this.setState({ dropActive: false });
      }
    }
  }, {
    key: '_stopPropagation',
    value: function _stopPropagation() {
      if ((0, _reactDom.findDOMNode)(this._searchRef).contains(document.activeElement)) {
        return true;
      }
    }
  }, {
    key: '_onClickOption',
    value: function _onClickOption(option) {
      var onChange = this.props.onChange;

      var value = this._valueForSelectedOption(option);
      this.setState({ dropActive: false, value: value });
      if (onChange) {
        onChange({ target: this.inputRef, option: option, value: value });
      }
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel(option) {
      if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
        // revert for announce as label is often a complex object
        return option.label || option.value || '';
      } else {
        return undefined === option || null === option ? '' : option;
      }
    }
  }, {
    key: '_renderValue',
    value: function _renderValue(option) {
      var intl = this.context.intl;

      if (Array.isArray(option)) {
        // Could be an Array when !inline+multiple
        if (1 === option.length) {
          return this._renderValue(option[0]);
        } else if (option.length > 1) {
          var selectedMultiple = _Intl2.default.getMessage(intl, 'Selected Multiple', {
            count: option.length
          });
          return selectedMultiple;
        }
      } else if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
        return option.label || option.value || '';
      } else {
        return undefined === option || null === option ? '' : option;
      }
    }
  }, {
    key: '_valueEqualsOption',
    value: function _valueEqualsOption(value, option) {
      var result = false;
      if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
          result = value.value === option.value;
        } else {
          result = value.value === option;
        }
      } else {
        if (option && (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
          result = value === option.value;
        } else {
          result = value === option;
        }
      }
      return result;
    }
  }, {
    key: '_optionSelected',
    value: function _optionSelected(option, value) {
      var _this3 = this;

      var result = false;
      if (value && Array.isArray(value)) {
        result = value.some(function (val) {
          return _this3._valueEqualsOption(val, option);
        });
      } else {
        result = this._valueEqualsOption(value, option);
      }
      return result;
    }
  }, {
    key: '_renderOptions',
    value: function _renderOptions(className) {
      var _this4 = this;

      var restProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var intl = this.context.intl;
      var _props4 = this.props,
          id = _props4.id,
          inline = _props4.inline,
          multiple = _props4.multiple,
          options = _props4.options,
          onSearch = _props4.onSearch,
          value = _props4.value,
          _props4$searchPlaceHo = _props4.searchPlaceHolder,
          searchPlaceHolder = _props4$searchPlaceHo === undefined ? _Intl2.default.getMessage(intl, 'Search') : _props4$searchPlaceHo;
      var _state2 = this.state,
          activeOptionIndex = _state2.activeOptionIndex,
          searchText = _state2.searchText;


      var search = void 0;
      if (onSearch) {
        search = _react2.default.createElement(_Search2.default, { className: CLASS_ROOT + '__search',
          ref: function ref(_ref) {
            return _this4._searchRef = _ref;
          },
          inline: true, fill: true, responsive: false, pad: 'medium',
          placeHolder: searchPlaceHolder, value: searchText,
          onDOMChange: this._onSearchChange,
          onKeyDown: this._onInputKeyDown });
      }

      var items = void 0;
      if (options) {
        items = options.map(function (option, index) {
          var _classnames;

          var selected = _this4._optionSelected(option, value);
          var content = _this4._renderLabel(option);
          var classes = (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__option', true), _defineProperty(_classnames, CLASS_ROOT + '__option--element', _react2.default.isValidElement(content)), _defineProperty(_classnames, CLASS_ROOT + '__option--selected', selected), _defineProperty(_classnames, CLASS_ROOT + '__option--active', index === activeOptionIndex), _classnames));

          if (option && option.icon) {
            content = _react2.default.createElement(
              'span',
              null,
              option.icon,
              ' ',
              content
            );
          }

          var itemOnClick = void 0;
          if (inline) {
            var itemId = '' + (option ? option.value || option : index);
            var Type = multiple ? _CheckBox2.default : _RadioButton2.default;
            content = _react2.default.createElement(Type, {
              key: itemId,
              id: id ? id + '-' + itemId : undefined,
              label: content,
              checked: selected,
              onChange: _this4._onClickOption.bind(_this4, option)
            });
          } else {
            itemOnClick = function itemOnClick(e) {
              e.stopPropagation();
              _this4._onClickOption.bind(_this4, option)();
            };
          }

          return _react2.default.createElement(
            'li',
            { key: index, className: classes, onClick: itemOnClick },
            content
          );
        });
      }

      var onClick = void 0;
      if (!inline) {
        onClick = this._onRemoveDrop;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, restProps, { className: className }),
        search,
        _react2.default.createElement(
          'ol',
          { className: CLASS_ROOT + '__options', onClick: onClick },
          items
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2,
          _this5 = this;

      var _props5 = this.props,
          className = _props5.className,
          inline = _props5.inline,
          placeHolder = _props5.placeHolder,
          value = _props5.value;
      var active = this.state.active;
      var intl = this.context.intl;

      var classes = (0, _classnames4.default)(CLASS_ROOT, (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '--active', active), _defineProperty(_classnames2, CLASS_ROOT + '--inline', inline), _classnames2), className);
      var restProps = _Props2.default.omit(this.props, Object.keys(Select.propTypes));

      if (inline) {
        return this._renderOptions(classes, restProps);
      } else {
        var renderedValue = this._renderValue(value);
        var shouldRenderElement = _react2.default.isValidElement(renderedValue);

        return _react2.default.createElement(
          'div',
          { className: classes, onClick: this._onAddDrop },
          shouldRenderElement ? _react2.default.createElement(
            'div',
            { ref: function ref(_ref2) {
                return _this5.valueRef = _ref2;
              },
              className: CLASS_ROOT + '__value' },
            renderedValue
          ) : null,
          _react2.default.createElement('input', _extends({}, restProps, { ref: function ref(_ref3) {
              return _this5.inputRef = _ref3;
            },
            type: shouldRenderElement ? 'hidden' : 'text',
            className: INPUT + ' ' + CLASS_ROOT + '__input',
            placeholder: placeHolder, readOnly: true,
            value: !shouldRenderElement && renderedValue || '' })),
          _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__control',
            a11yTitle: _Intl2.default.getMessage(intl, 'Select Icon'),
            icon: _react2.default.createElement(_CaretDown2.default, null),
            onClick: this._onAddDrop })
        );
      }
    }
  }]);

  return Select;
}(_react.Component);

Select.displayName = 'Select';
exports.default = Select;


var valueType = _propTypes2.default.oneOfType([_propTypes2.default.shape({
  label: _propTypes2.default.node,
  value: _propTypes2.default.any
}), _propTypes2.default.string, _propTypes2.default.number]);

Select.propTypes = {
  inline: _propTypes2.default.bool,
  multiple: _propTypes2.default.bool,
  onSearch: _propTypes2.default.func,
  onChange: _propTypes2.default.func, // (value(s))
  placeHolder: _propTypes2.default.string,
  searchPlaceHolder: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(valueType).isRequired,
  value: _propTypes2.default.oneOfType([valueType, _propTypes2.default.arrayOf(valueType)])
};

Select.contextTypes = {
  intl: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _Spinning = __webpack_require__(17);

var _Spinning2 = _interopRequireDefault(_Spinning);

var _InfiniteScroll = __webpack_require__(171);

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _Selection = __webpack_require__(172);

var _Selection2 = _interopRequireDefault(_Selection);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Responsive = __webpack_require__(78);

var _Responsive2 = _interopRequireDefault(_Responsive);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Announcer = __webpack_require__(34);

var _TableHeader = __webpack_require__(271);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TABLE;
var SELECTED_CLASS = CLASS_ROOT + '-row--selected';
var ACTIVE_CLASS = CLASS_ROOT + '-row--active';
// empirical number describing a minimum cell width for a
// table to be presented in column-mode.
var MIN_CELL_WIDTH = 120;

function getTotalCellCount(cells) {
  var cellCount = 0;
  [].forEach.call(cells, function (cell) {
    var colspan = cell.getAttribute('colspan');
    cellCount += colspan ? parseInt(colspan) : 1;
  });

  return cellCount;
}

// function that filters the items that are not
// an immediate child of its parent
function immediateTableChildOnly(result, tableParent) {
  var immediateChild = [];
  [].forEach.call(result, function (item) {
    var currentParent = item.parentNode;
    while (currentParent) {
      if (currentParent.tagName.toLowerCase() === 'table') {
        if (currentParent === tableParent) {
          immediateChild.push(item);
        }
        break;
      }
      currentParent = currentParent.parentNode;
    }
  });
  return immediateChild;
}

function findHead(children) {
  if (!children) {
    return undefined;
  }

  var childElements = _react.Children.toArray(children);

  var head = void 0;
  childElements.some(function (child) {
    if (child.type && (child.type === 'thead' || child.type === _TableHeader2.default || child.type.displayName === _TableHeader2.default.displayName)) {
      head = child;
      return true;
    } else if (child.props && child.props.children) {
      head = findHead(child.props.children);
      if (head) {
        return true;
      }
    }
    return false;
  });

  return head;
}

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table(props, context) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props, context));

    _this._onClick = _this._onClick.bind(_this);
    _this._onResize = _this._onResize.bind(_this);
    _this._layout = _this._layout.bind(_this);
    _this._onResponsive = _this._onResponsive.bind(_this);
    _this._onPreviousRow = _this._onPreviousRow.bind(_this);
    _this._onNextRow = _this._onNextRow.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);
    _this._fireClick = _this._fireClick.bind(_this);
    _this._announceRow = _this._announceRow.bind(_this);
    _this._onViewPortChange = _this._onViewPortChange.bind(_this);

    _this.state = {
      activeRow: undefined,
      mouseActive: false,
      selected: _Selection2.default.normalizeIndexes(props.selected),
      columnMode: false,
      small: false
    };
    return _this;
  }

  _createClass(Table, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onMore = _props.onMore,
          onMoreAbove = _props.onMoreAbove,
          selectable = _props.selectable,
          scrollable = _props.scrollable;
      var _state = this.state,
          columnMode = _state.columnMode,
          small = _state.small;

      this._setSelection();
      if (scrollable && !columnMode && !small) {
        this._alignMirror();
      }
      if (onMore || onMoreAbove) {
        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore, this.moreAboveRef, onMoreAbove);
      }
      this._adjustBodyCells();
      setTimeout(this._layout, 50);
      window.addEventListener('resize', this._onResize);

      if (selectable) {
        // only listen for navigation keys if the table row can be selected
        this._keyboardHandlers = {
          left: this._onPreviousRow,
          up: this._onPreviousRow,
          right: this._onNextRow,
          down: this._onNextRow,
          enter: this._onEnter,
          space: this._onEnter
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }

      this._responsive = _Responsive2.default.start(this._onViewPortChange);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this._scroll) {
        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
        this._scroll = undefined;
      }
      if (nextProps.selected !== undefined) {
        this.setState({
          selected: _Selection2.default.normalizeIndexes(nextProps.selected)
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          onMore = _props2.onMore,
          onMoreAbove = _props2.onMoreAbove,
          selectable = _props2.selectable,
          scrollable = _props2.scrollable;
      var _state2 = this.state,
          columnMode = _state2.columnMode,
          selected = _state2.selected,
          small = _state2.small;

      if (JSON.stringify(selected) !== JSON.stringify(prevState.selected)) {
        this._setSelection();
      }
      if (scrollable && !columnMode && !small) {
        this._alignMirror();
      }
      if ((onMore || onMoreAbove) && !this._scroll) {
        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore, this.moreAboveRef, onMoreAbove);
      }
      this._adjustBodyCells();
      this._layout();

      if (selectable) {
        // only listen for navigation keys if the table row can be selected
        this._keyboardHandlers = {
          left: this._onPreviousRow,
          up: this._onPreviousRow,
          right: this._onNextRow,
          down: this._onNextRow,
          enter: this._onEnter,
          space: this._onEnter
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var selectable = this.props.selectable;

      if (this._scroll) {
        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
      }
      clearTimeout(this._resizeTimer);
      window.removeEventListener('resize', this._onResize);

      if (selectable) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
      }

      this._responsive.stop();
    }
  }, {
    key: '_onViewPortChange',
    value: function _onViewPortChange(small) {
      this.setState({ small: small });
    }
  }, {
    key: '_announceRow',
    value: function _announceRow(label) {
      var intl = this.context.intl;

      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
      (0, _Announcer.announce)(label + ' ' + enterSelectMessage);
    }
  }, {
    key: '_onResponsive',
    value: function _onResponsive() {
      var columnMode = this.state.columnMode;

      if (this.containerRef && this.tableRef) {
        var availableSize = this.containerRef.offsetWidth;
        var numberOfCells = getTotalCellCount(immediateTableChildOnly(this.tableRef.querySelectorAll('thead th'), this.tableRef));

        if (numberOfCells * MIN_CELL_WIDTH > availableSize) {
          if (columnMode === false) {
            this.setState({ columnMode: true });
          }
        } else {
          if (columnMode === true) {
            this.setState({ columnMode: false });
          }
        }
      }
    }
  }, {
    key: '_container',
    value: function _container() {
      var containerElement = this.tableRef;
      if (containerElement) {
        var tableBodies = containerElement.getElementsByTagName('TBODY');
        if (tableBodies.length > 0) {
          containerElement = tableBodies[0];
        }
      }
      return containerElement;
    }
  }, {
    key: '_setSelection',
    value: function _setSelection() {
      var selected = this.state.selected;

      _Selection2.default.setClassFromIndexes({
        containerElement: this._container(),
        childSelector: 'tr',
        selectedClass: SELECTED_CLASS,
        selectedIndexes: selected
      });
    }
  }, {
    key: '_onPreviousRow',
    value: function _onPreviousRow(event) {
      var _this2 = this;

      if (this.tableRef.contains(document.activeElement)) {
        event.preventDefault();
        var activeRow = this.state.activeRow;

        var rows = immediateTableChildOnly(this.tableRef.querySelectorAll('tbody tr'), this.tableRef);
        if (rows && rows.length > 0) {
          if (activeRow === undefined) {
            rows[0].classList.add(ACTIVE_CLASS);
            this.setState({ activeRow: 0 }, function () {
              _this2._announceRow(rows[_this2.state.activeRow].innerText);
            });
          } else if (activeRow - 1 >= 0) {
            rows[activeRow].classList.remove(ACTIVE_CLASS);
            rows[activeRow - 1].classList.add(ACTIVE_CLASS);
            this.setState({ activeRow: activeRow - 1 }, function () {
              _this2._announceRow(rows[_this2.state.activeRow].innerText);
            });
          }
        }

        //stop event propagation
        return true;
      }
    }
  }, {
    key: '_onNextRow',
    value: function _onNextRow(event) {
      var _this3 = this;

      if (this.tableRef.contains(document.activeElement)) {
        event.preventDefault();
        var activeRow = this.state.activeRow;

        var rows = immediateTableChildOnly(this.tableRef.querySelectorAll('tbody tr'), this.tableRef);
        if (rows && rows.length > 0) {
          if (activeRow === undefined) {
            rows[0].classList.add(ACTIVE_CLASS);
            this.setState({ activeRow: 0 }, function () {
              _this3._announceRow(rows[_this3.state.activeRow].innerText);
            });
          } else if (activeRow + 1 <= rows.length - 1) {
            rows[activeRow].classList.remove(ACTIVE_CLASS);
            rows[activeRow + 1].classList.add(ACTIVE_CLASS);
            this.setState({ activeRow: activeRow + 1 }, function () {
              _this3._announceRow(rows[_this3.state.activeRow].innerText);
            });
          }
        }

        //stop event propagation
        return true;
      }
    }
  }, {
    key: '_fireClick',
    value: function _fireClick(element, shiftKey) {
      var event = void 0;
      try {
        event = new MouseEvent('click', {
          'bubbles': true,
          'cancelable': true,
          'shiftKey': shiftKey
        });
      } catch (e) {
        // IE11 workaround.
        event = document.createEvent('Event');
        event.initEvent('click', true, true);
      }
      // We use dispatchEvent to have the browser fill out the event fully.
      element.dispatchEvent(event);
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(event) {
      var activeRow = this.state.activeRow;
      var intl = this.context.intl;

      if (this.tableRef.contains(document.activeElement) && activeRow !== undefined) {
        var rows = immediateTableChildOnly(this.tableRef.querySelectorAll('tbody tr'), this.tableRef);
        this._fireClick(rows[activeRow], event.shiftKey);
        rows[activeRow].classList.remove(ACTIVE_CLASS);
        var label = rows[activeRow].innerText;
        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
        (0, _Announcer.announce)(label + ' ' + selectedMessage);
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(event) {
      var _props3 = this.props,
          onSelect = _props3.onSelect,
          selectable = _props3.selectable,
          selected = _props3.selected;


      var selection = _Selection2.default.onClick(event, {
        containerElement: this._container(),
        childSelector: 'tr',
        selectedClass: SELECTED_CLASS,
        multiSelect: 'multiple' === selectable,
        priorSelectedIndexes: this.state.selected
      });
      // only set the selected state and classes if the caller isn't managing it.
      if (selected === undefined) {
        this.setState({ selected: selection }, this._setSelection);
      }

      if (onSelect) {
        onSelect(selection.length === 1 ? selection[0] : selection);
      }
    }
  }, {
    key: '_adjustBodyCells',
    value: function _adjustBodyCells() {
      // adjust table body cells to have link to the header
      // so that in responsive mode it displays the text as content in css.
      // IMPORTANT: non-text header cells, such as icon, are rendered as empty
      // headers.
      if (this.tableRef) {
        var headerCells = immediateTableChildOnly(this.tableRef.querySelectorAll('thead th'), this.tableRef);
        var totalHeaderCells = getTotalCellCount(headerCells);
        if (headerCells.length > 0) {
          var increments = [];
          headerCells.forEach(function (cell) {
            var colspan = cell.getAttribute('colspan');
            increments.push(colspan ? parseInt(colspan) : 1);
          });

          var rows = immediateTableChildOnly(this.tableRef.querySelectorAll('tbody tr'), this.tableRef);

          rows.forEach(function (row) {
            var incrementCount = 0;
            var headerIndex = 0;

            if (getTotalCellCount(row.cells) !== totalHeaderCells) {
              console.error('Table row cells do not match length of header cells.');
            }

            [].forEach.call(row.cells, function (cell) {
              var colspan = cell.getAttribute('colspan');
              var cellCount = colspan ? parseInt(colspan) : 1;
              if (cellCount < totalHeaderCells) {
                // only set the header if the cell colspan is smaller
                // than the total header cells
                cell.setAttribute('data-th', headerCells[headerIndex].innerText || headerCells[headerIndex].textContent);
              }

              incrementCount++;
              if (incrementCount === increments[headerIndex]) {
                incrementCount = 0;
                headerIndex++;
              }
            });
          });
        }
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      // debounce
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(this._layout, 50);
    }
  }, {
    key: '_layout',
    value: function _layout() {
      var scrollable = this.props.scrollable;
      var small = this.state.small;

      if (scrollable && !small) {
        this._alignMirror();
      }
      this._onResponsive();
    }
  }, {
    key: '_alignMirror',
    value: function _alignMirror() {
      var mirrorElement = this.mirrorRef;
      if (mirrorElement) {
        var mirrorCells = immediateTableChildOnly(mirrorElement.querySelectorAll('thead tr th'), mirrorElement);
        if (this.mirrorRef && mirrorCells.length > 0) {
          var tableElement = this.tableRef;
          var cells = immediateTableChildOnly(tableElement.querySelectorAll('thead tr th'), tableElement);

          var rect = tableElement.getBoundingClientRect();
          mirrorElement.style.width = '' + Math.floor(rect.right - rect.left) + 'px';

          var height = 0;
          for (var i = 0; i < cells.length; i++) {
            rect = cells[i].getBoundingClientRect();
            mirrorCells[i].style.width = '' + Math.floor(rect.right - rect.left) + 'px';
            mirrorCells[i].style.height = '' + Math.floor(rect.bottom - rect.top) + 'px';
            height = Math.max(height, Math.floor(rect.bottom - rect.top));
          }
          mirrorElement.style.height = '' + height + 'px';
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this4 = this;

      var _props4 = this.props,
          a11yTitle = _props4.a11yTitle,
          children = _props4.children,
          className = _props4.className,
          _onBlur = _props4.onBlur,
          _onFocus = _props4.onFocus,
          onMore = _props4.onMore,
          onMoreAbove = _props4.onMoreAbove,
          _onMouseDown = _props4.onMouseDown,
          _onMouseUp = _props4.onMouseUp,
          responsive = _props4.responsive,
          scrollable = _props4.scrollable,
          selectable = _props4.selectable,
          props = _objectWithoutProperties(_props4, ['a11yTitle', 'children', 'className', 'onBlur', 'onFocus', 'onMore', 'onMoreAbove', 'onMouseDown', 'onMouseUp', 'responsive', 'scrollable', 'selectable']);

      delete props.onSelect;
      delete props.selected;
      var _state3 = this.state,
          activeRow = _state3.activeRow,
          columnMode = _state3.columnMode,
          focus = _state3.focus,
          mouseActive = _state3.mouseActive,
          small = _state3.small;
      var intl = this.context.intl;

      var classes = (0, _classnames4.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--small', responsive && columnMode), _defineProperty(_classnames, CLASS_ROOT + '--selectable', selectable), _defineProperty(_classnames, CLASS_ROOT + '--scrollable', scrollable && !small), _classnames), className);

      var mirror = void 0;
      if (scrollable && !small) {
        var head = findHead(children);
        mirror = _react2.default.createElement(
          'table',
          { ref: function ref(_ref) {
              return _this4.mirrorRef = _ref;
            },
            className: CLASS_ROOT + '__mirror' },
          head
        );
      }

      var more = void 0;
      if (onMore) {
        more = _react2.default.createElement(
          'div',
          { ref: function ref(_ref2) {
              return _this4.moreRef = _ref2;
            }, className: CLASS_ROOT + '__more' },
          _react2.default.createElement(_Spinning2.default, null)
        );
      }

      var moreAbove = void 0;
      if (onMoreAbove) {
        moreAbove = _react2.default.createElement(
          'div',
          { ref: function ref(_ref3) {
              return _this4.moreAboveRef = _ref3;
            },
            className: CLASS_ROOT + '__more' },
          _react2.default.createElement(_Spinning2.default, null)
        );
      }

      var selectableProps = void 0;
      if (selectable) {
        var multiSelectMessage = selectable === 'multiple' ? '(' + _Intl2.default.getMessage(intl, 'Multi Select') + ')' : '';
        var tableMessage = a11yTitle || _Intl2.default.getMessage(intl, 'Table');
        var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
        selectableProps = {
          'aria-label': tableMessage + ' ' + multiSelectMessage + ' ' + navigationHelpMessage,
          tabIndex: '0',
          onClick: this._onClick,
          onMouseDown: function onMouseDown(event) {
            _this4.setState({ mouseActive: true });
            if (_onMouseDown) {
              _onMouseDown(event);
            }
          },
          onMouseUp: function onMouseUp(event) {
            _this4.setState({ mouseActive: false });
            if (_onMouseUp) {
              _onMouseUp(event);
            }
          },
          onFocus: function onFocus(event) {
            if (mouseActive === false) {
              _this4.setState({ focus: true });
            }
            if (_onFocus) {
              _onFocus(event);
            }
          },
          onBlur: function onBlur(event) {
            if (activeRow) {
              var rows = immediateTableChildOnly(_this4.tableRef.querySelectorAll('tbody tr'), _this4.tableRef);
              rows[activeRow].classList.remove(ACTIVE_CLASS);
            }
            _this4.setState({ focus: false, activeRow: undefined });
            if (_onBlur) {
              _onBlur(event);
            }
          }
        };
      }

      var tableClasses = (0, _classnames4.default)(CLASS_ROOT + '__table', _defineProperty({}, CLASS_ROOT + '__table--focus', focus));

      return _react2.default.createElement(
        'div',
        _extends({ ref: function ref(_ref5) {
            return _this4.containerRef = _ref5;
          } }, props, { className: classes }),
        mirror,
        moreAbove,
        _react2.default.createElement(
          'table',
          _extends({ ref: function ref(_ref4) {
              return _this4.tableRef = _ref4;
            } }, selectableProps, {
            className: tableClasses }),
          children
        ),
        more
      );
    }
  }]);

  return Table;
}(_react.Component);

Table.displayName = 'Table';
exports.default = Table;


Table.contextTypes = {
  intl: _propTypes2.default.object
};

Table.propTypes = {
  a11yTitle: _propTypes2.default.string,
  onMore: _propTypes2.default.func,
  onMoreAbove: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  responsive: _propTypes2.default.bool,
  scrollable: _propTypes2.default.bool,
  selectable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['multiple'])]),
  selected: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
};

Table.defaultProps = {
  responsive: true
};
module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');
var $Number = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $parseInteger = GetIntrinsic('%parseInt%');

var callBound = __webpack_require__(16);
var regexTester = __webpack_require__(213);
var isPrimitive = __webpack_require__(214);

var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};

var ToPrimitive = __webpack_require__(87);

// https://www.ecma-international.org/ecma-262/6.0/#sec-tonumber

module.exports = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		} else {
			var trimmed = $trim(value);
			if (trimmed !== value) {
				return ToNumber(trimmed);
			}
		}
	}
	return $Number(value);
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-close', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'close');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,3 L21,21 M3,21 L21,3' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Close';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Drop = __webpack_require__(124);

var _Drop2 = _interopRequireDefault(_Drop);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Announcer = __webpack_require__(34);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TEXT_INPUT;
var INPUT = _CSSClassnames2.default.INPUT;

var TextInput = function (_Component) {
  _inherits(TextInput, _Component);

  function TextInput(props, context) {
    _classCallCheck(this, TextInput);

    var _this = _possibleConstructorReturn(this, (TextInput.__proto__ || Object.getPrototypeOf(TextInput)).call(this, props, context));

    _this.activeKeyboardHandlers = {
      esc: _this._onRemoveDrop,
      tab: _this._onRemoveDrop,
      up: _this._onPreviousSuggestion,
      down: _this._onNextSuggestion,
      enter: _this._onEnter
    };
    _this.focusedKeyboardHandlers = {
      down: _this._onAddDrop
    };


    _this._onInputChange = _this._onInputChange.bind(_this);
    _this._onAddDrop = _this._onAddDrop.bind(_this);
    _this._onRemoveDrop = _this._onRemoveDrop.bind(_this);
    _this._onNextSuggestion = _this._onNextSuggestion.bind(_this);
    _this._onPreviousSuggestion = _this._onPreviousSuggestion.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);
    _this._onClickSuggestion = _this._onClickSuggestion.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onInputKeyDown = _this._onInputKeyDown.bind(_this);
    _this._stopPropagation = _this._stopPropagation.bind(_this);
    _this._announceSuggestion = _this._announceSuggestion.bind(_this);

    _this.state = {
      announceChange: false,
      dropActive: false,
      activeSuggestionIndex: -1
    };
    return _this;
  }

  _createClass(TextInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var suggestions = this.props.suggestions;
      var _state = this.state,
          announceChange = _state.announceChange,
          dropActive = _state.dropActive,
          focused = _state.focused;
      var intl = this.context.intl;
      var activeKeyboardHandlers = this.activeKeyboardHandlers,
          focusedKeyboardHandlers = this.focusedKeyboardHandlers;
      // the order here is important, need to turn off keys before turning on

      if (!focused && prevState.focused) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
      }

      if (!dropActive && prevState.dropActive) {
        document.removeEventListener('click', this._onRemoveDrop);
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
        if (this._drop) {
          this._drop.remove();
          this._drop = undefined;
        }
      }

      if (focused && !prevState.focused) {
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, focusedKeyboardHandlers);
      }

      if (dropActive && !prevState.dropActive) {
        document.addEventListener('click', this._onRemoveDrop);
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);

        // If this is inside a FormField, place the drop in reference to it.
        var control = this.componentRef;
        this._drop = new _Drop2.default(control, this._renderDropContent(), {
          align: { top: 'bottom', left: 'left' },
          responsive: false // so suggestion changes don't re-align
        });
      } else if (dropActive && prevState.dropActive) {
        this._drop.render(this._renderDropContent());
      }

      if (announceChange && suggestions) {
        var matchResultsMessage = _Intl2.default.getMessage(intl, 'Match Results', {
          count: suggestions.length
        });
        var navigationHelpMessage = '';
        if (suggestions.length) {
          navigationHelpMessage = '(' + _Intl2.default.getMessage(intl, 'Navigation Help') + ')';
        }
        (0, _Announcer.announce)(matchResultsMessage + ' ' + navigationHelpMessage);
        this.setState({ announceChange: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var activeKeyboardHandlers = this.activeKeyboardHandlers,
          focusedKeyboardHandlers = this.focusedKeyboardHandlers;


      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);

      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);

      document.removeEventListener('click', this._onRemoveDrop);
      if (this._drop) {
        this._drop.remove();
      }
    }
  }, {
    key: '_stopPropagation',
    value: function _stopPropagation() {
      if (document.activeElement === this.componentRef) {
        return true;
      }
    }
  }, {
    key: '_onInputChange',
    value: function _onInputChange(event) {
      var _props = this.props,
          onDOMChange = _props.onDOMChange,
          suggestions = _props.suggestions;


      if (suggestions && Array.isArray(suggestions)) {
        this.setState({
          activeSuggestionIndex: -1, announceChange: true, dropActive: true
        });
      }

      if (onDOMChange) {
        onDOMChange(event);
      }
    }
  }, {
    key: '_announceSuggestion',
    value: function _announceSuggestion(index) {
      var suggestions = this.props.suggestions;
      var intl = this.context.intl;

      if (suggestions && suggestions.length > 0) {
        var labelMessage = this._renderLabel(suggestions[index]);
        var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
        (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
      }
    }
  }, {
    key: '_onAddDrop',
    value: function _onAddDrop(event) {
      var _props2 = this.props,
          suggestions = _props2.suggestions,
          value = _props2.value;
      // Get values of suggestions, so we can highlight selected suggestion

      if (suggestions) {
        event.preventDefault();
        var suggestionValues = suggestions.map(function (suggestion) {
          if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
            return suggestion.value;
          } else {
            return suggestion;
          }
        });
        var activeSuggestionIndex = suggestionValues.indexOf(value);
        this.setState({
          dropActive: true,
          activeSuggestionIndex: activeSuggestionIndex
        });
      }
    }
  }, {
    key: '_onRemoveDrop',
    value: function _onRemoveDrop() {
      this.setState({ dropActive: false });
    }
  }, {
    key: '_onNextSuggestion',
    value: function _onNextSuggestion() {
      var suggestions = this.props.suggestions;
      var activeSuggestionIndex = this.state.activeSuggestionIndex;

      var index = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
      this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
    }
  }, {
    key: '_onPreviousSuggestion',
    value: function _onPreviousSuggestion() {
      var activeSuggestionIndex = this.state.activeSuggestionIndex;

      var index = Math.max(activeSuggestionIndex - 1, 0);
      this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(event) {
      var _this2 = this;

      var _props3 = this.props,
          onSelect = _props3.onSelect,
          suggestions = _props3.suggestions;
      var activeSuggestionIndex = this.state.activeSuggestionIndex;
      var intl = this.context.intl;

      this.setState({ dropActive: false });
      if (activeSuggestionIndex >= 0) {
        event.preventDefault(); // prevent submitting forms
        var suggestion = suggestions[activeSuggestionIndex];
        this.setState({ value: suggestion }, function () {
          var suggestionMessage = _this2._renderLabel(suggestion);
          var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
          (0, _Announcer.announce)(suggestionMessage + ' ' + selectedMessage);
        });
        if (onSelect) {
          onSelect({
            target: this.componentRef, suggestion: suggestion
          });
        }
      }
    }
  }, {
    key: '_onClickSuggestion',
    value: function _onClickSuggestion(suggestion) {
      var onSelect = this.props.onSelect;

      this.setState({ value: suggestion, dropActive: false });
      if (onSelect) {
        onSelect({
          target: this.componentRef, suggestion: suggestion
        });
      }
    }
  }, {
    key: '_onFocus',
    value: function _onFocus(event) {
      var onFocus = this.props.onFocus;

      this.setState({
        focused: true,
        activeSuggestionIndex: -1
      });

      if (onFocus) {
        onFocus(event);
      }
    }
  }, {
    key: '_onInputKeyDown',
    value: function _onInputKeyDown(event) {
      var _props4 = this.props,
          onKeyDown = _props4.onKeyDown,
          suggestions = _props4.suggestions;
      var dropActive = this.state.dropActive;

      if (suggestions) {
        var up = 38;
        var down = 40;
        var tab = 9;
        if (event.keyCode === up || event.keyCode === down) {
          // stop the input to move the cursor when suggestions are present
          event.preventDefault();

          if (event.keyCode === down && !dropActive) {
            this._onAddDrop(event);
          }
        }

        if (event.keyCode === tab) {
          this.setState({ focused: false });
        }
      }

      if (onKeyDown) {
        onKeyDown(event);
      }
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel(suggestion) {
      if (suggestion && (typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
        return suggestion.label || suggestion.value;
      } else {
        return suggestion;
      }
    }
  }, {
    key: '_renderDropContent',
    value: function _renderDropContent() {
      var _this3 = this;

      var suggestions = this.props.suggestions;
      var activeSuggestionIndex = this.state.activeSuggestionIndex;

      var items = void 0;
      if (suggestions) {
        items = suggestions.map(function (suggestion, index) {
          var _classnames;

          var classes = (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__suggestion', true), _defineProperty(_classnames, CLASS_ROOT + '__suggestion--active', index === activeSuggestionIndex), _classnames));
          return _react2.default.createElement(
            'li',
            { key: index, className: classes,
              onClick: _this3._onClickSuggestion.bind(_this3, suggestion) },
            _this3._renderLabel(suggestion)
          );
        });
      }

      return _react2.default.createElement(
        'ol',
        { className: CLASS_ROOT + '__suggestions', onClick: this._onRemoveDrop },
        items
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props5 = this.props,
          className = _props5.className,
          defaultValue = _props5.defaultValue,
          value = _props5.value,
          placeHolder = _props5.placeHolder,
          props = _objectWithoutProperties(_props5, ['className', 'defaultValue', 'value', 'placeHolder']);

      delete props.suggestions;
      delete props.onDOMChange;
      delete props.onSelect;
      var classes = (0, _classnames4.default)(CLASS_ROOT, INPUT, _defineProperty({}, CLASS_ROOT + '--active', this.state.active), className);

      return _react2.default.createElement('input', _extends({
        ref: function ref(_ref) {
          return _this4.componentRef = _ref;
        },
        type: 'text',
        autoComplete: 'off'
      }, props, {
        className: classes,
        defaultValue: this._renderLabel(defaultValue),
        value: this._renderLabel(value),
        placeholder: placeHolder,
        onChange: this._onInputChange, onFocus: this._onFocus,
        onKeyDown: this._onInputKeyDown }));
    }
  }]);

  return TextInput;
}(_react.Component);

TextInput.displayName = 'TextInput';
exports.default = TextInput;


TextInput.contextTypes = {
  intl: _propTypes2.default.object
};

TextInput.propTypes = {
  defaultValue: _propTypes2.default.string,
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onDOMChange: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  placeHolder: _propTypes2.default.string,
  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
    label: _propTypes2.default.node,
    value: _propTypes2.default.any
  }), _propTypes2.default.string])),
  value: _propTypes2.default.string
};
module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

/* Decorators */


/* Utils */


/* CSS */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _staticMethods = __webpack_require__(537);

var _staticMethods2 = _interopRequireDefault(_staticMethods);

var _windowListener = __webpack_require__(280);

var _windowListener2 = _interopRequireDefault(_windowListener);

var _customEvent = __webpack_require__(281);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isCapture = __webpack_require__(538);

var _isCapture2 = _interopRequireDefault(_isCapture);

var _getEffect = __webpack_require__(539);

var _getEffect2 = _interopRequireDefault(_getEffect);

var _bodyMode = __webpack_require__(540);

var _bodyMode2 = _interopRequireDefault(_bodyMode);

var _trackRemoval = __webpack_require__(541);

var _trackRemoval2 = _interopRequireDefault(_trackRemoval);

var _getPosition = __webpack_require__(542);

var _getPosition2 = _interopRequireDefault(_getPosition);

var _getTipContent = __webpack_require__(543);

var _getTipContent2 = _interopRequireDefault(_getTipContent);

var _aria = __webpack_require__(544);

var _nodeListToArray = __webpack_require__(545);

var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);

var _style = __webpack_require__(546);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _bodyMode2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(ReactTooltip, _React$Component);

  function ReactTooltip(props) {
    _classCallCheck(this, ReactTooltip);

    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));

    _this.state = {
      place: props.place || 'top', // Direction of tooltip
      desiredPlace: props.place || 'top',
      type: 'dark', // Color theme of tooltip
      effect: 'float', // float or fixed
      show: false,
      border: false,
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null, // Current mouse event
      currentTarget: null, // Current target of mouse event
      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
      isEmptyTip: false,
      disable: false,
      possibleCustomEvents: props.possibleCustomEvents || '',
      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
      originTooltip: null,
      isMultiline: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.delayReshow = null;
    _this.intervalUpdateContent = null;
    return _this;
  }

  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: 'bind',
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          insecure = _props.insecure,
          resizeHide = _props.resizeHide;

      if (insecure) {
        this.setStyleHeader(); // Set the style to the <link>
      }

      this.bindListener(); // Bind listener for tooltip
      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mount = false;

      this.clearTimer();

      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }

    /**
     * Return if the mouse is on the tooltip.
     * @returns {boolean} true - mouse is on the tooltip
     */

  }, {
    key: 'mouseOnToolTip',
    value: function mouseOnToolTip() {
      var show = this.state.show;


      if (show && this.tooltipRef) {
        /* old IE or Firefox work around */
        if (!this.tooltipRef.matches) {
          /* old IE work around */
          if (this.tooltipRef.msMatchesSelector) {
            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
          } else {
            /* old Firefox work around */
            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
          }
        }
        return this.tooltipRef.matches(':hover');
      }
      return false;
    }
    /**
     * Pick out corresponded target elements
     */

  }, {
    key: 'getTargetArray',
    value: function getTargetArray(id) {
      var targetArray = void 0;
      if (!id) {
        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
      }
      // targetArray is a NodeList, convert it to a real array
      return (0, _nodeListToArray2.default)(targetArray);
    }

    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: 'bindListener',
    value: function bindListener() {
      var _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          globalEventOff = _props2.globalEventOff,
          isCapture = _props2.isCapture;

      var targetArray = this.getTargetArray(id);

      targetArray.forEach(function (target) {
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }
        _this3.unbindBasicListener(target);
        if (_this3.isCustomEvent(target)) {
          _this3.customUnbindListener(target);
        }
      });

      if (this.isBodyMode()) {
        this.bindBodyListener(targetArray);
      } else {
        targetArray.forEach(function (target) {
          var isCaptureMode = _this3.isCapture(target);
          var effect = _this3.getEffect(target);
          if (_this3.isCustomEvent(target)) {
            _this3.customBindListener(target);
            return;
          }

          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
          if (effect === 'float') {
            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
          }
          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
        });
      }

      // Global event to hide tooltip
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
      }

      // Track removal of targetArray elements from DOM
      this.bindRemovalTracker();
    }

    /**
     * Unbind listeners on target elements
     */

  }, {
    key: 'unbindListener',
    value: function unbindListener() {
      var _this4 = this;

      var _props3 = this.props,
          id = _props3.id,
          globalEventOff = _props3.globalEventOff;

      if (this.isBodyMode()) {
        this.unbindBodyListener();
      } else {
        var targetArray = this.getTargetArray(id);
        targetArray.forEach(function (target) {
          _this4.unbindBasicListener(target);
          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
        });
      }

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }

    /**
     * Invoke this before bind listener and unmount the component
     * it is necessary to invoke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: 'unbindBasicListener',
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'getTooltipContent',
    value: function getTooltipContent() {
      var _props4 = this.props,
          getContent = _props4.getContent,
          children = _props4.children;

      // Generate tooltip content

      var content = void 0;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0](this.state.originTooltip);
        } else {
          content = getContent(this.state.originTooltip);
        }
      }

      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
    }
  }, {
    key: 'isEmptyTip',
    value: function isEmptyTip(placeholder) {
      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
    }

    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: 'showTooltip',
    value: function showTooltip(e, isGlobalCall) {
      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement) return;
      }
      // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected
      var _props5 = this.props,
          multiline = _props5.multiline,
          getContent = _props5.getContent;

      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

      // if it needs to skip adding hide listener to scroll
      var scrollHide = true;
      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }

      // Make sure the correct place is set
      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
      var result = (0, _getPosition2.default)(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
      }

      var place = result.isNewState ? result.newState.place : desiredPlace;

      // To prevent previously created timers from triggering
      this.clearTimer();

      var target = e.currentTarget;

      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;

      var self = this;

      var updateState = function updateState() {
        self.setState({
          originTooltip: originTooltip,
          isMultiline: isMultiline,
          desiredPlace: desiredPlace,
          place: place,
          type: target.getAttribute('data-type') || self.props.type || 'dark',
          effect: effect,
          offset: offset,
          html: target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html || false,
          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
          border: target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border || false,
          extraClass: target.getAttribute('data-class') || self.props.class || self.props.className || '',
          disable: target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable || false,
          currentTarget: target
        }, function () {
          if (scrollHide) self.addScrollListener(self.state.currentTarget);
          self.updateTooltip(e);

          if (getContent && Array.isArray(getContent)) {
            self.intervalUpdateContent = setInterval(function () {
              if (self.mount) {
                var _getContent = self.props.getContent;

                var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
                var isEmptyTip = self.isEmptyTip(placeholder);
                self.setState({
                  isEmptyTip: isEmptyTip
                });
                self.updatePosition();
              }
            }, getContent[1]);
          }
        });
      };

      // If there is no delay call immediately, don't allow events to get in first.
      if (reshowDelay) {
        this.delayReshow = setTimeout(updateState, reshowDelay);
      } else {
        updateState();
      }
    }

    /**
     * When mouse hover, update tool tip
     */

  }, {
    key: 'updateTooltip',
    value: function updateTooltip(e) {
      var _this5 = this;

      var _state = this.state,
          delayShow = _state.delayShow,
          disable = _state.disable;
      var afterShow = this.props.afterShow;

      var placeholder = this.getTooltipContent();
      var delayTime = parseInt(delayShow, 10);
      var eventTarget = e.currentTarget || e.target;

      // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
      if (this.mouseOnToolTip()) {
        return;
      }

      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this5.state.show;
          _this5.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this5.updatePosition();
            if (isInvisible && afterShow) afterShow(e);
          });
        }
      };

      clearTimeout(this.delayShowLoop);
      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }

    /*
    * If we're mousing over the tooltip remove it when we leave.
     */

  }, {
    key: 'listenForTooltipExit',
    value: function listenForTooltipExit() {
      var show = this.state.show;


      if (show && this.tooltipRef) {
        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
      }
    }
  }, {
    key: 'removeListenerForTooltipExit',
    value: function removeListenerForTooltipExit() {
      var show = this.state.show;


      if (show && this.tooltipRef) {
        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
      }
    }

    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: 'hideTooltip',
    value: function hideTooltip(e, hasTarget) {
      var _this6 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { isScroll: false };
      var disable = this.state.disable;
      var isScroll = options.isScroll;

      var delayHide = isScroll ? 0 : this.state.delayHide;
      var afterHide = this.props.afterHide;

      var placeholder = this.getTooltipContent();
      if (!this.mount) return;
      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }

      var resetState = function resetState() {
        var isVisible = _this6.state.show;
        // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
        if (_this6.mouseOnToolTip()) {
          _this6.listenForTooltipExit();
          return;
        }
        _this6.removeListenerForTooltipExit();

        _this6.setState({
          show: false
        }, function () {
          _this6.removeScrollListener();
          if (isVisible && afterHide) afterHide(e);
        });
      };

      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }

    /**
     * When scroll, hide tooltip
     */

  }, {
    key: 'hideTooltipOnScroll',
    value: function hideTooltipOnScroll(event, hasTarget) {
      this.hideTooltip(event, hasTarget, { isScroll: true });
    }

    /**
     * Add scroll event listener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: 'addScrollListener',
    value: function addScrollListener(currentTarget) {
      var isCaptureMode = this.isCapture(currentTarget);
      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.hideTooltipOnScroll);
    }

    // Calculation the position

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _this7 = this;

      var _state2 = this.state,
          currentEvent = _state2.currentEvent,
          currentTarget = _state2.currentTarget,
          place = _state2.place,
          desiredPlace = _state2.desiredPlace,
          effect = _state2.effect,
          offset = _state2.offset;

      var node = this.tooltipRef;
      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      if (result.position && this.props.overridePosition) {
        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
      }

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this7.updatePosition();
        });
      }
      // Set tooltip position
      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }

    /**
     * Set style tag in header
     * in this way we can insert default css
     */

  }, {
    key: 'setStyleHeader',
    value: function setStyleHeader() {
      var head = document.getElementsByTagName('head')[0];
      if (!head.querySelector('style[id="react-tooltip"]')) {
        var tag = document.createElement('style');
        tag.id = 'react-tooltip';
        tag.innerHTML = _style2.default;
        /* eslint-disable */
        if (typeof __webpack_require__.nc !== 'undefined' && __webpack_require__.nc) {
          tag.setAttribute('nonce', __webpack_require__.nc);
        }
        /* eslint-enable */
        head.insertBefore(tag, head.firstChild);
      }
    }

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearTimeout(this.delayReshow);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _state3 = this.state,
          extraClass = _state3.extraClass,
          html = _state3.html,
          ariaProps = _state3.ariaProps,
          disable = _state3.disable;

      var placeholder = this.getTooltipContent();
      var isEmptyTip = this.isEmptyTip(placeholder);
      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' }, { 'allow_hover': this.props.delayUpdate }, { 'allow_click': this.props.clickable });

      var Wrapper = this.props.wrapper;
      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }
      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');

      if (html) {
        return _react2.default.createElement(Wrapper, _extends({ className: wrapperClassName,
          id: this.props.id,
          ref: function ref(_ref) {
            return _this8.tooltipRef = _ref;
          }
        }, ariaProps, {
          'data-id': 'tooltip',
          dangerouslySetInnerHTML: { __html: placeholder } }));
      } else {
        return _react2.default.createElement(
          Wrapper,
          _extends({ className: wrapperClassName,
            id: this.props.id
          }, ariaProps, {
            ref: function ref(_ref2) {
              return _this8.tooltipRef = _ref2;
            },
            'data-id': 'tooltip' }),
          placeholder
        );
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var ariaProps = prevState.ariaProps;

      var newAriaProps = (0, _aria.parseAria)(nextProps);
      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (!isChanged) {
        return null;
      }
      return _extends({}, prevState, {
        ariaProps: newAriaProps
      });
    }
  }]);

  return ReactTooltip;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.any,
  place: _propTypes2.default.string,
  type: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  offset: _propTypes2.default.object,
  multiline: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  insecure: _propTypes2.default.bool,
  class: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  html: _propTypes2.default.bool,
  delayHide: _propTypes2.default.number,
  delayUpdate: _propTypes2.default.number,
  delayShow: _propTypes2.default.number,
  event: _propTypes2.default.string,
  eventOff: _propTypes2.default.string,
  watchWindow: _propTypes2.default.bool,
  isCapture: _propTypes2.default.bool,
  globalEventOff: _propTypes2.default.string,
  getContent: _propTypes2.default.any,
  afterShow: _propTypes2.default.func,
  afterHide: _propTypes2.default.func,
  overridePosition: _propTypes2.default.func,
  disable: _propTypes2.default.bool,
  scrollHide: _propTypes2.default.bool,
  resizeHide: _propTypes2.default.bool,
  wrapper: _propTypes2.default.string,
  bodyMode: _propTypes2.default.bool,
  possibleCustomEvents: _propTypes2.default.string,
  possibleCustomEventsOff: _propTypes2.default.string,
  clickable: _propTypes2.default.bool
}, _class2.defaultProps = {
  insecure: true,
  resizeHide: true,
  wrapper: 'div',
  clickable: false
}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;

/* export default not fit for standalone, it will exports {default:...} */


module.exports = ReactTooltip;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(36);

var assertRecord = __webpack_require__(90);

var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-isdatadescriptor

module.exports = function IsDataDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mod(number, modulo) {
	var remain = number % modulo;
	return Math.floor(remain >= 0 ? remain : remain + modulo);
};


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLUE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EPA_METRICS_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EZMERALCP_METRICS_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SizerIds; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SSETSizingModes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SSETTitles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HPECPWorkloadRequirements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return Workload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HDFS_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DATA_LAKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ROLENAME_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DisplayPrice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GR_RACKCONFIGURATION_NOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SAPHANA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GROWTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GPELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PRIMERA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return STORAGEHEADING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SYNERGYSOLUTIONPREVIEWVARIABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SAPSOLUTIONPREVIEWVARIABLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SSETTITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return imageProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppConfig__ = __webpack_require__(13);
function shouldDisplayPrice(){if(__WEBPACK_IMPORTED_MODULE_0__AppConfig__["f" /* said */]===SizerIds.EPAVNEXT){return true;}else{return false;}}var BLUE_DATA='BlueData';var EPA_METRICS_HEADER='Elastic Config';var EZMERALCP_METRICS_HEADER="HPE Ezmeral Runtime Enterprise Configuration";var SizerIds={EPAVNEXT:'EPAvNext',SAP:'SAP',SAPHANA:'SAPHANA'};var SSETSizingModes={epaMLOps:'MLOps'};var SSETTitles={epaMLOps:'HPE Ezmeral Machine Learning Ops',hpeCP:'HPE Ezmeral Runtime Enterprise'};var HPECPWorkloadRequirements={"CP":"HPE Ezmeral Runtime Enterprise Workload Requirements",'MLOps':"MLOps Workload Requirements","CaaS":"CaaS Workload Requirements"};var Workload="Workload ";var HDFS_='HDFS';var DATA_LAKE="Data Lake";var ROLENAME_="RoleName";var DisplayPrice=shouldDisplayPrice();var GR_RACKCONFIGURATION_NOTE="Click on Rack image to view more details.";var SAPHANA='SAPHANA';var GROWTH='Growth';var GPELEMENT='General Purpose Elements';var PRIMERA="Primera";var STORAGEHEADING="Storage Trays/Drives:";var SYNERGYSOLUTIONPREVIEWVARIABLES={"SERVER":'Server:',"PROCESSOR":'Processor:',"MEMORY":'Memory:',"NUMSERVER":'Number of Servers:',"PROCMODEL":'Processor Model:',"REQRAM":'Required Ram:',"LOCALBOOTDRIVECOUNT":'Local Boot Drive Count:',"LOCALBOOTDRIVETYPE":'Local Boot Drive Type:',"STORAGETYPE":'Storage Type:',"VOLNAME":'Volume Name:',"DISK":'Disk:',"DISKQTY":'Disk Quantity:',"CONTROLLER":'Controller:',"CAPACITIES":'Capacities:',"CACHES":'Caches:',"NETWORKING":'Networking:',"CAPACITY":'Capacity:',"CACHE":'Cache:',"FRAMENAME":'Frame Name:',"DISKTYPE":'Disk Type:',"ARRAYMODEL":'Array Model:',"LUNTYPE":'Lun Type:',"RAIDLEVEL":'Raid Level:',"FONTTYPE_NORMAL":"normal","FONTTYPE_BOLD":"bold","FONTSIZE_11":"11","FONTSIZE_12":"12","FONTSIZE_14":"14","RECOMMENDED":'Recommended',"HOSTCONFIG":'Host Configuration',"STORAGECONFIG":'Storage Configuration',"SITE":'Site',"ROLE_COMPUTE":'Compute Optimized',"ROLE_MEMORY":'Memory Optimized',"ROLE_GENERALPURPOSE":'General Purpose',"BLOCKSTORAGE":'Block Storage',"ROLE_COMPUTENODE":'Compute Node',"ROLE_STORAGENODE":'Storage Node',"ROLE_PRODUCTION":'Production',"ROLE_MGMT":'Management',"ROLE_GATEWAY":'Gateway',"VIRTUAL_MACHINES":'Virtual Machines',"HEAD_NODES":'Head Nodes',"BARE_METAL":'Bare Metal',"CONTAINERS":'Containers',"CONTAINERSONVM":'Containers On VM',"CONTAINERSONBAREMETAL":'Containers On Bare Metal',"GATEWAY":'Gateway',"SHARED":'Shared',"SHAREDSTORAGE":"Shared Storage","MODULE":'Module:',"CONTROL_PLANE":'Control Plane',"HEADNODE":'Head Node',"ODF_STORAGE":'ODF storage',"COREOS_VM":'CoreOS on Virtual Machine',"RHEL_BM":'RHEL on Bare Metal'};var SAPSOLUTIONPREVIEWVARIABLES={"RECOMMENDED":'Recommended',"SERVER":'Server:',"PROCESSOR_QUANTITY":'Processor Quantity:',"PROCESSOR_MODEL":'Processor Model:',"PROCESSOR_FAMILY":'Processor Family:',"MEMORY":'Memory (GB):',"ROLE_PRODUCITON_ENVIRONMENT":'Production Environment',"ROLE_APPLICATION_ENVIRONMENT":'Application Environment',"ROLE_PROD_CENTRAL_SERVER":'ProdCentralServer',"ROLE_TEST_ASSURANCE_SYSTEM":'Test/Quality Assurance System',"ROLE_TRAINING_SYSTEM":'Training System',"ROLE_DEVELOPMENT_SYSTEM":'Development System',"ROLE_SANDBOX_SYSTEM":'Sandbox System',"CPU_MODEL":'CPU Model:',"SAPS":'SAPS:',"DATABASE_SIZE":'Data Base Size:',"CONFIG_TYPE":'Configuration Type:',"DB_SERVER_CPU_CAPACITY":'DB Server CPU Capacity:',"DATABSE_TYPE":'Data Base Type:',"OPERATING_SYSTEM":'Operating System:',"CPU_PERCENTAGE":'CPU Percentage:',"STORAGE_PERCENTAGE":'Storage Percentage:',"FONTTYPE_NORMAL":"normal","FONTTYPE_BOLD":"bold","FONTSIZE_11":"11","FONTSIZE_12":"12","FONTSIZE_14":"14"};var SSETTITLE="HPE SSET";var imageProperties={logoWithName:'data:image/png;base64,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',logoUrl:'data:image/png;base64,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'};

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return removeObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cleanupGrowth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return updateGrowthItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return updateEzemeralGrowthItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateCalculations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return validateApollo4200SFFDrives; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return validateNVMEorSFFDrivesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return nodeStorageDriveQuantityOnBlurValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return validateDriveChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGatewayandControllerHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateControllerHostCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return updateMasterHostCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateFinishButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterDriveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return filterOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return updateMasterandGatewayServices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateServiceLicenses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serverChangeCompatibilityCheck; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Datafiles_ConfigurationMinValues_json__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Datafiles_ConfigurationMinValues_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Datafiles_ConfigurationMinValues_json__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var configurationMinValues=__WEBPACK_IMPORTED_MODULE_1__Datafiles_ConfigurationMinValues_json___default.a;var removeObject=function removeObject(itemToRemove,isService,workload){if(workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){if(workload.UserInputs.Environments.Growth){var rest=void 0;isService?rest=workload.UserInputs.Environments['Growth'].Service.filter(function(item){return item['@Service']!==itemToRemove;}):rest=workload.UserInputs.Environments['Growth'].Service.filter(function(item){return item['@Name']!==itemToRemove;});workload.UserInputs.Environments['Growth'].Service=rest;}}};var cleanupGrowth=function cleanupGrowth(workload){if(workload.UserInputs.Environments.Growth){var getObject=void 0;if(workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){workload.UserInputs.Environments.Functions.Function.forEach(function(x){if(Array.isArray(x.Service)){x.Service.filter(function(elem){return elem["@Selected"]=="false";}).forEach(function(filteredItem){getObject=workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Service']===filteredItem['@Type'];});if(getObject){removeObject(getObject['@Service'],true,workload);}});}else{if(x.Service["@Selected"]=="false"&&x["@Type"]!=="Gateway Node"&&x["@Type"]!=="Master Node"){getObject=workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Service']===x.Service['@Type'];});if(getObject){removeObject(getObject['@Service'],true,workload);}}else if(x.Service["@Selected"]==="false"){getObject=workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Name']===x['@Type'];});if(getObject){removeObject(getObject['@Name'],false,workload);}}else if(x.Service["@Selected"]==="true"&&x["@Type"]==="Gateway Node"&&isNaN(x.Service.Hardware["@NodesCount"])){getObject=workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Name']===x['@Type'];});if(getObject){removeObject(getObject['@Name'],false,workload);}}}});}else{var index=void 0;if(!Array.isArray(workload.UserInputs.Environments.Growth.Host)){var growthObject=workload.UserInputs.Environments.Growth.Host;workload.UserInputs.Environments.Growth.Host=[];workload.UserInputs.Environments.Growth.Host.push(growthObject);}index=workload.UserInputs.Environments.Growth.Host.findIndex(function(service){return service["@SolutionType"]===""&&service["@RoleName"]==="";});if(index>-1){workload.UserInputs.Environments.Growth.Host.splice(index,1);}workload.UserInputs.Environments.Environment.map(function(solution){if(Array.isArray(solution.Templates.ServerDetails.Server)){solution.Templates.ServerDetails.Server.filter(function(role){return role["@NodesCount"]==="0";}).map(function(unconfiguredRole){index=workload.UserInputs.Environments['Growth'].Host.findIndex(function(service){return service["@SolutionType"]===solution["@SolutionType"]&&service["@RoleName"]===unconfiguredRole["@RoleName"];});if(index>-1){workload.UserInputs.Environments.Growth.Host.splice(index,1);}});}else{if(solution.Templates.ServerDetails.Server["@NodesCount"]===0){index=workload.UserInputs.Environments['Growth'].Host.find(function(service){return service["@SolutionType"]===solution["@SolutionType"]&&service["@RoleName"]===solution.Templates.ServerDetails.Server["@RoleName"];});if(index>-1){workload.UserInputs.Environments.Growth.Host.splice(index,1);}}}});workload.UserInputs.Environments.ManagementHosts.Server.filter(function(role){return role["@NodesCount"]==="0";}).map(function(unconfiguredRole){index=workload.UserInputs.Environments['Growth'].Host.find(function(service){return service["@SolutionType"]===unconfiguredRole["@RoleName"];});if(index>-1){workload.UserInputs.Environments.Growth.Host.splice(index,1);}});}}};var updateGrowthItem=function updateGrowthItem(service,value,workload){if(workload.UserInputs.Environments.Growth){cleanupGrowth(workload);var growthItem=workload.UserInputs.Environments.Growth.Service.find(function(item){return item['@Service']===service||item['@Name']===service;});if(growthItem){if(isNaN(value)&&service==='Gateway Node'){var rest=workload.UserInputs.Environments['Growth'].Service.filter(function(item){return item['@Name']!=='Gateway Node';});workload.UserInputs.Environments['Growth'].Service=rest;}else{growthItem['@Nodes1Y']=value;updateCalculations(growthItem,workload);}}}};var updateEzemeralGrowthItems=function updateEzemeralGrowthItems(workload){var item={};var oldGrowthObject=[].concat(_toConsumableArray(workload.UserInputs.Environments.Growth.Host));workload.UserInputs.Environments.Growth.Host=[];workload.UserInputs.Environments.Environment.map(function(x){if(x["@isSelected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_212" /* yES_ */]){x.Templates.ServerDetails.Server.map(function(role){if(role["@NodesCount"]!=="0"){var growthRate="0";var growthObjectIndex=oldGrowthObject.findIndex(function(growthItem){return growthItem["@SolutionType"]===x["@SolutionType"]&&growthItem["@RoleName"]===role["@RoleName"];});if(growthObjectIndex>-1){growthRate=oldGrowthObject[growthObjectIndex]["@GrowthRate"];}item["@GrowthRate"]=growthRate.toString();item["@Nodes1Y"]=role["@NodesCount"].toString();item["@Nodes2Y"]="-";item["@Nodes3Y"]="-";item["@Nodes4Y"]="-";item["@RoleName"]=role["@RoleName"];item["@SolutionType"]=x["@SolutionType"];updateCalculations(item,workload);workload.UserInputs.Environments.Growth.Host.push(Object.assign({},item));}});}});var isGrowthGiven=false;if(workload.UserInputs.Environments.Growth.Host.filter(function(service){return parseInt(service["@GrowthRate"],10)>0;}).length>0){isGrowthGiven=true;}workload.UserInputs.Environments.Growth.Host.map(function(service){if(!isGrowthGiven){service["@Nodes2Y"]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_72" /* HYPHEN_ */];service["@Nodes3Y"]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_72" /* HYPHEN_ */];service["@Nodes4Y"]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_72" /* HYPHEN_ */];}});};var updateCalculations=function updateCalculations(itemToUpdate,workload){var value=parseInt(itemToUpdate["@GrowthRate"],10);var nodes=parseInt(itemToUpdate["@Nodes1Y"],10);if(workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){if(value===0){itemToUpdate["@Nodes2Y"]='-';itemToUpdate["@Nodes3Y"]='-';}else{if(itemToUpdate["@GrowthType"]==="Percentage"){value=value/100;itemToUpdate["@Nodes2Y"]=Math.round(nodes*Math.pow(value+1,1));itemToUpdate["@Nodes3Y"]=Math.round(nodes*Math.pow(value+1,2));}else{itemToUpdate["@Nodes2Y"]=nodes+value;itemToUpdate["@Nodes3Y"]=nodes+value*2;}}}else{if(itemToUpdate["@RoleName"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_162" /* STORAGE_HOST_ROLE_NAME */]){var RepFactor=void 0;var PersistentSize=void 0;var ServerQty=void 0;var UsableSize=void 0;var AdditionalHosts=0;var TotalPersistentSize=void 0;var usablePersistentStorage=0;workload.UserInputs.Environments.Environment.map(function(x){if(x["@SolutionType"]===itemToUpdate["@SolutionType"]){RepFactor=parseInt(x.Templates.ServerDetails.Requirements["@HDFSRepFactor"],10);PersistentSize=parseInt(x.Templates.ServerDetails.Requirements["@HDFSRawSize"],10);x.Templates.ServerDetails.Server.map(function(Server){if(Server["@RoleName"]===itemToUpdate["@RoleName"]){ServerQty=Server["@NodesCount"];if(Array.isArray(Server.PersistentDisks)){Server.PersistentDisks.map(function(qty){if(qty.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_158" /* SIZE_ATTRIBUTE */]]){usablePersistentStorage+=parseInt(qty.Item["@qty"],10)*parseFloat(qty.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_158" /* SIZE_ATTRIBUTE */]]);}});}UsableSize=ServerQty*usablePersistentStorage/RepFactor;for(var i=2;i<5;i++){TotalPersistentSize=Math.round(PersistentSize*Math.pow(1+value/100,i));if(TotalPersistentSize>UsableSize){if((TotalPersistentSize-UsableSize)/60>0){AdditionalHosts=Math.ceil((TotalPersistentSize-UsableSize)/60);}}itemToUpdate['@Nodes'+i+'Y']=(parseInt(itemToUpdate["@Nodes1Y"],10)+AdditionalHosts).toString();;}}});}});}else{value=value/100;itemToUpdate["@Nodes2Y"]=Math.round(nodes*Math.pow(value+1,2)).toString();itemToUpdate["@Nodes3Y"]=Math.round(nodes*Math.pow(value+1,3)).toString();itemToUpdate["@Nodes4Y"]=Math.round(nodes*Math.pow(value+1,4)).toString();}}};var validateApollo4200SFFDrives=function validateApollo4200SFFDrives(referenceDrive1,referenceDrive2,currentDrive){var isNVMEdrive=false;var isValid=true;if(currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){isNVMEdrive=true;}function validationMethod(referenceDrive){if(referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1){if(isNVMEdrive){if(referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])===-1){isValid=false;}}else{if(referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){isValid=false;}}}}if(referenceDrive1){validationMethod(referenceDrive1);}if(isValid&&referenceDrive2){validationMethod(referenceDrive2);}return isValid;};var validateNVMEorSFFDrivesCount=function validateNVMEorSFFDrivesCount(roleObject,maxSFFDriveQuantity){var isValid=true;var existingNVMEorSFFDriveCount=0;var nonNVMEDrivesCount=0;var apollo4200nonNVMEmaxDriveCount=22;if(roleObject["@Name"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(roleObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||roleObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1){existingNVMEorSFFDriveCount+=parseInt(roleObject["@StorageDiskQty"],10);}else{nonNVMEDrivesCount+=parseInt(roleObject["@StorageDiskQty"],10);}if(roleObject["@Type"]!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_29" /* GATEWAY_ */]){if(roleObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||roleObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1){existingNVMEorSFFDriveCount+=parseInt(roleObject["@TStorageDriveQty"],10);}else{nonNVMEDrivesCount+=parseInt(roleObject["@TStorageDriveQty"],10);}}if(roleObject["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||roleObject["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1){existingNVMEorSFFDriveCount+=parseInt(roleObject["@OSDiskQty"],10);}else{nonNVMEDrivesCount+=parseInt(roleObject["@OSDiskQty"],10);}if(roleObject["@OSDisk"].indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_103" /* M_2 */])>-1){apollo4200nonNVMEmaxDriveCount=24;}if(existingNVMEorSFFDriveCount>0&&nonNVMEDrivesCount>apollo4200nonNVMEmaxDriveCount){isValid=false;}}else{if(roleObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){existingNVMEorSFFDriveCount+=parseInt(roleObject["@StorageDiskQty"],10);}if(roleObject["@Type"]!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_29" /* GATEWAY_ */]){if(roleObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){existingNVMEorSFFDriveCount+=parseInt(roleObject["@TStorageDriveQty"],10);}}if(roleObject["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){existingNVMEorSFFDriveCount+=parseInt(roleObject["@OSDiskQty"],10);}}if(existingNVMEorSFFDriveCount>maxSFFDriveQuantity){isValid=false;}return isValid;};var nodeStorageDriveQuantityOnBlurValidation=function nodeStorageDriveQuantityOnBlurValidation(x,value,supportedListDetails){var NoOfNVMEDrives=0;var NoOfNonNVMEDrives=0;var remainingDrives=0;var NonGPUMaxDrives=0;if((x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1)&&x["@Name"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]||x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){NoOfNVMEDrives+=parseInt(x["@OSDiskQty"],10);}else{NoOfNonNVMEDrives+=parseInt(x["@OSDiskQty"],10);}if((x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1)&&x["@Name"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]||x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){NoOfNVMEDrives+=parseInt(x["@TStorageDriveQty"],10);}else{NoOfNonNVMEDrives+=parseInt(x["@TStorageDriveQty"],10);}if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1)||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){NonGPUMaxDrives=supportedListDetails[x["@Name"]].MaxNVMeDrives;remainingDrives=NonGPUMaxDrives-NoOfNVMEDrives;}else{NonGPUMaxDrives=supportedListDetails[x["@Name"]].MaxDrives;if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]&&NoOfNVMEDrives>0){if(x["@OSDisk"].indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_103" /* M_2 */])>-1){NonGPUMaxDrives=26;}else{NonGPUMaxDrives=24;}remainingDrives=NonGPUMaxDrives-NoOfNonNVMEDrives;}else{remainingDrives=NonGPUMaxDrives-NoOfNonNVMEDrives-NoOfNVMEDrives;}}if(parseInt(value,10)<=remainingDrives){x["@StorageDiskQty"]=value;}else{if(remainingDrives<0){x["@StorageDiskQty"]="0";}else{x["@StorageDiskQty"]=remainingDrives.toString();}}};var validateDriveChange=function validateDriveChange(referenceDrive1,referenceDrive2,currentDrive,serverName){var tenantStorageQty=arguments.length>4&&arguments[4]!==undefined?arguments[4]:null;var type=arguments.length>5&&arguments[5]!==undefined?arguments[5]:'';var isValid=true;var validationMethod=function validationMethod(referenceDrive){//In Apollo 4200 LFF and SFF can mix
//In DL380 OS drives(SFF) can mix LFF drives
if(serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_56" /* HPE_APOLLO_4200_GEN10_PLUS */]){if(referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_86" /* LFF_ */])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_76" /* INCHES_THREE */])>-1){if((currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_75" /* INCHES_ */])>-1)&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_132" /* PROLIANT_DL380_GEN10 */]&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_134" /* PROLIANT_DL385_GEN10_PLUS */]){isValid=false;}}else if((referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_75" /* INCHES_ */])>-1)&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_132" /* PROLIANT_DL380_GEN10 */]&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_134" /* PROLIANT_DL385_GEN10_PLUS */]){if(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_86" /* LFF_ */])>-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_76" /* INCHES_THREE */])>-1){isValid=false;}}}if(referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_152" /* SATA_ */])>-1&&referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_45" /* HDD_ */])>-1){//In Apollo 4200 LFF SATA HDD can mix SFF SAS drives or SFF SATA HDD can mix with LFF SAS drives.
if(serverName===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_151" /* SAS_ */])>-1){if((referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_86" /* LFF_ */])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_76" /* INCHES_THREE */])>-1)&&(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_86" /* LFF_ */])>-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_76" /* INCHES_THREE */])>-1)){isValid=false;}if((referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_75" /* INCHES_ */])>-1)&&(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_75" /* INCHES_ */])>-1)){isValid=false;}}}else{if(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_151" /* SAS_ */])>-1||currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_120" /* NVMe_ */])>-1){isValid=false;}}}else if(referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_151" /* SAS_ */])>-1||referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_120" /* NVMe_ */])>-1&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_152" /* SATA_ */])>-1&&currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_45" /* HDD_ */])>-1){if(serverName===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]){if((referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_86" /* LFF_ */])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_76" /* INCHES_THREE */])>-1)&&(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_86" /* LFF_ */])>-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_76" /* INCHES_THREE */])>-1)){isValid=false;}if((referenceDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||referenceDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_75" /* INCHES_ */])>-1)&&(currentDrive.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_75" /* INCHES_ */])>-1)){isValid=false;}}else{isValid=false;}}}};if(serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_175" /* SYN_480_GEN10 */]&&serverName!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_57" /* HPE_APOLLO_4500_GEN10 */]){if(referenceDrive1){if(tenantStorageQty===0&&type==='ephemeral'){}else{validationMethod(referenceDrive1);}}if(isValid){if(referenceDrive2){if(tenantStorageQty===0&&type==='osdrive'){}else{validationMethod(referenceDrive2);}}}}return isValid;};var getGatewayandControllerHost=function getGatewayandControllerHost(workload,hostType){var nonGPUServers=[];var serverName=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_137" /* PROLIANT_XL220N_GEN10_PLUS */];var selectedServices=[];workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_212" /* yES_ */];}).map(function(selectedSolution){if(selectedSolution.NonGPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]||selectedSolution.GPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]||selectedSolution.StorageValue.isCalculated===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){selectedServices.push(selectedSolution["@SolutionType"]);}if(selectedSolution.NonGPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){if(selectedSolution.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_111" /* NONGPU_ */];})){nonGPUServers.push(selectedSolution.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_111" /* NONGPU_ */];})["@Name"]);}}});if(hostType===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_29" /* GATEWAY_ */]&&selectedServices.length===1&&selectedServices[0]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["v" /* CAAS_ */]){serverName=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_175" /* SYN_480_GEN10 */];}else if(selectedServices.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_98" /* MLOPS */])>-1||selectedServices.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["v" /* CAAS_ */])>-1){serverName=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_129" /* PROLIANT_DL360_GEN10 */];}else if(nonGPUServers.length>0){var sameServerInAllRoles=true;for(var i=0;i<nonGPUServers.length;i++){if(nonGPUServers[i]!==nonGPUServers[0]){sameServerInAllRoles=false;}}if(sameServerInAllRoles){serverName=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_137" /* PROLIANT_XL220N_GEN10_PLUS */];}}return serverName;};var updateControllerHostCount=function updateControllerHostCount(workload,isHAIncluded){var kubernetesTemplate="";var EPICTemplate="";var controllerHostCount=0;var controllerObject=workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["F" /* CONTROLLER_ */];});var oldControllerHostCount=parseInt(controllerObject["@NodesCount"],10);if(controllerObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){controllerHostCount=3;}else{workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_212" /* yES_ */];}).map(function(selectedSolution){if(!kubernetesTemplate){kubernetesTemplate=selectedSolution.Templates.Template.find(function(template){return template["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_84" /* KUBERNETES_ */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_109" /* NONE_ */]&&!(selectedSolution['@SolutionType']===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_98" /* MLOPS */]&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_74" /* IMAGE_PROCESSING */]);});}if(!EPICTemplate){EPICTemplate=selectedSolution.Templates.Template.find(function(template){return template["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_20" /* EPIC_ */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_109" /* NONE_ */]&&!(selectedSolution['@SolutionType']===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_98" /* MLOPS */]&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_74" /* IMAGE_PROCESSING */]);});}});if(kubernetesTemplate){controllerHostCount=6;}else{controllerHostCount=3;}}if(!isHAIncluded){controllerHostCount=2;}if(controllerObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){controllerHostCount=2;}else{if(controllerObject["@HAIncluded"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){controllerHostCount=3;}else{controllerHostCount=1;}}if(controllerHostCount>0){controllerObject["@NodesCount"]=controllerHostCount.toString();}};var updateMasterHostCount=function updateMasterHostCount(workload,isHAIncluded){var kubernetesTemplate="";var EPICTemplate="";var masterHostCount=0;var masterObject=workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_89" /* MASTER_ */];});var oldControllerHostCount=parseInt(masterObject["@NodesCount"],10);if(masterObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){masterHostCount=3;}else{workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_212" /* yES_ */];}).map(function(selectedSolution){if(!kubernetesTemplate){kubernetesTemplate=selectedSolution.Templates.Template.find(function(template){return template["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_84" /* KUBERNETES_ */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_109" /* NONE_ */]&&!(selectedSolution['@SolutionType']===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_98" /* MLOPS */]&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_74" /* IMAGE_PROCESSING */]);});}if(!EPICTemplate){EPICTemplate=selectedSolution.Templates.Template.find(function(template){return template["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_20" /* EPIC_ */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_109" /* NONE_ */]&&!(selectedSolution['@SolutionType']===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_98" /* MLOPS */]&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_74" /* IMAGE_PROCESSING */]);});}});if(kubernetesTemplate){masterHostCount=6;}else{masterHostCount=3;}}if(!isHAIncluded){masterHostCount=2;}if(masterObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){masterHostCount=2;}else{if(masterObject["@HAIncluded"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){masterHostCount=3;}else{masterHostCount=1;}}if(masterHostCount>0){masterObject["@NodesCount"]=masterHostCount.toString();}};var updateFinishButton=function updateFinishButton(workload,displayWarning,isSizeEnabled){var result=false;if(workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){if(workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_212" /* yES_ */];})){if(!displayWarning){if(!isSizeEnabled){result=true;}}}}return result;};var filterDriveList=function filterDriveList(rawData,value){var filteredOptions=[];rawData.map(function(drive){if(drive.indexOf(value)===-1){filteredOptions.push(drive);}});return filteredOptions;};var filterOptions=function filterOptions(rawData,configuration,role,field){if(configuration===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_125" /* POWER_ */]){return rawData;}var filteredOptions=[];var baseValue='';if(field===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_126" /* PROCESSOR_ */]){if(role===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_161" /* STORAGE_ */]){rawData.map(function(proc){if(parseInt(proc.split('/')[2].split(' ')[1],10)>=16){filteredOptions.push(proc);}});}else{baseValue=parseInt(configurationMinValues[configuration][role]["@procSpecInt"].split(' ')[0],10);rawData.map(function(proc){if(parseInt(proc.split('/')[3].split(' ')[1],10)>baseValue){filteredOptions.push(proc);}});}}if(field===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_96" /* MEMORY_ */]){baseValue=parseInt(configurationMinValues[configuration][role]["@Memory"].split(' ')[0],10);rawData.map(function(memory){if(parseInt(memory.split(' ')[0],10)>=baseValue){filteredOptions.push(memory);}});}if(field.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_10" /* DISK_ */])>-1){var baseDriveCapacity=parseFloat(configurationMinValues[configuration][role]['@'+field].split(' ')[0].split(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_181" /* TB_ */])[0],10);var baseDriveType=configurationMinValues[configuration][role]['@'+field].split(' ')[1];rawData.map(function(drive){var driveCapacity=drive.split(' ')[1];if(driveCapacity===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_15" /* EDGELINE_ */]){driveCapacity=drive.split(' ')[2];}if(drive.indexOf(baseDriveType)>-1){if(driveCapacity.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_181" /* TB_ */])>-1){if(parseFloat(driveCapacity.split(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_181" /* TB_ */])[0],10)>=baseDriveCapacity){filteredOptions.push(drive);}}else if(driveCapacity.indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_35" /* GB_ */])>-1){if(parseFloat(driveCapacity.split(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_35" /* GB_ */])[0]/1024,10)>=baseDriveCapacity){filteredOptions.push(drive);}}}else{filteredOptions.push(drive);}});}if(filteredOptions.length===0){return rawData;}return filteredOptions;};var updateMasterandGatewayServices=function updateMasterandGatewayServices(workload){var isDataLakeSelected=false;var otherServiceSelected=false;var isDataFabricSelected=false;workload.UserInputs.Environments.Functions.Function.map(function(Function){if(Array.isArray(Function.Service)){Function.Service.map(function(service){if(service["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){if(service["@Selected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){isDataLakeSelected=true;}}else{if(service["@Selected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){otherServiceSelected=true;}}});}else{if(Function["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_82" /* IOT_ */]){if(Function.Service["@Selected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){otherServiceSelected=true;}}}});if(workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric["@IsSelected"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){isDataFabricSelected=true;}if(isDataLakeSelected&&isDataFabricSelected&&!otherServiceSelected){workload.UserInputs.Environments.Functions.Function.map(function(Function){if(!Array.isArray(Function.Service)){if(Function["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_91" /* MASTER_NODE */]||Function["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_31" /* GATEWAY_NODE */]){Function.Service["@Selected"]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}}});}else{workload.UserInputs.Environments.Functions.Function.map(function(Function){if(!Array.isArray(Function.Service)){if(Function["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_91" /* MASTER_NODE */]||Function["@Type"]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_31" /* GATEWAY_NODE */]){Function.Service["@Selected"]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];}}});}};var updateServiceLicenses=function updateServiceLicenses(serviceLicenses,serviceSupportedList){if(serviceLicenses&&serviceSupportedList){var hortonWorkandCloudEraUpdate=function hortonWorkandCloudEraUpdate(HortonWorkorCloudEraObject){if(Array.isArray(HortonWorkorCloudEraObject.License)){HortonWorkorCloudEraObject.License.map(function(license){if(license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_50" /* HORTONWORK_ENT_PLUS */]){license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["c" /* ATTRIBUTE_ISSELECTED */]]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["b" /* ATTRIBUTE_DESCRIPTION */]]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_109" /* NONE_ */];}else{var supportedOptions=[];var service=serviceSupportedList.find(function(supportedLicense){return supportedLicense[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]]===license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]];});if(service){if(!Array.isArray(service.Item)){var option=service.Item;service.Item=[option];}supportedOptions=service.Item;if(supportedOptions.indexOf(license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["b" /* ATTRIBUTE_DESCRIPTION */]])===-1){license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["b" /* ATTRIBUTE_DESCRIPTION */]]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_109" /* NONE_ */];license[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["c" /* ATTRIBUTE_ISSELECTED */]]=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}}}});}};if(serviceLicenses.Hortonworks){hortonWorkandCloudEraUpdate(serviceLicenses.Hortonworks);}if(serviceLicenses.Cloudera){hortonWorkandCloudEraUpdate(serviceLicenses.Cloudera);}}};var serverChangeCompatibilityCheck=function serverChangeCompatibilityCheck(workload,selectedServer,supportedList,type,title){var shouldChangeServer=true;var warningMessage="";var MixedDrives=[];var supportedDrives=[];var driveCount=0;var NVMEDriveCount=0;var isNVMeDrivePresent=false;var isSFFDrivePresent=false;var SFFDriveCount=0;var selectedServerSupportedList=supportedList.find(function(service){return service[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_28" /* FUNCTIONNAME_ */]]===type&&service[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_155" /* SERVICENAME_ */]]===title;}).totalList[selectedServer];var maxDrives=selectedServerSupportedList.iDataDiskQty;var maxNVMEDrives=selectedServerSupportedList.iMaxNVMeDrive;workload.UserInputs.Environments.Functions.Function.map(function(Function){if(Function[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]]===type){if(Array.isArray(Function.Service)){MixedDrives=Function.Service.find(function(service){return service[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]]===title;})[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["R" /* DATADISKS_ */]];}else{MixedDrives=Function.Service[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["R" /* DATADISKS_ */]];}}});selectedServerSupportedList.DataDiskList.map(function(drive){supportedDrives.push(drive.StrDrive);});MixedDrives.map(function(drive){if(shouldChangeServer){if(supportedDrives.indexOf(drive.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["l" /* ATTRIBUTE_dISK */]])===-1){shouldChangeServer=false;warningMessage=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_154" /* SERVERCHANGE_WARNINGTEXT */];}}if(drive.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["l" /* ATTRIBUTE_dISK */]].indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_119" /* NVME_ */])>-1){isNVMeDrivePresent=true;NVMEDriveCount+=parseInt(drive.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["m" /* ATTRIBUTE_qTY */]],10);}if(selectedServer===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]&&drive.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["l" /* ATTRIBUTE_dISK */]].indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_157" /* SFF_DESCRIPTIONS */][0])>-1){isSFFDrivePresent=true;SFFDriveCount+=parseInt(drive.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["m" /* ATTRIBUTE_qTY */]],10);}else{driveCount+=parseInt(drive.Item[__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["m" /* ATTRIBUTE_qTY */]],10);}});if(selectedServer===__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_55" /* HPE_APOLLO_4200_GEN10 */]&&shouldChangeServer&&(isNVMeDrivePresent||isSFFDrivePresent)){maxDrives=22;if(isSFFDrivePresent){if(SFFDriveCount>maxNVMEDrives){shouldChangeServer=false;warningMessage=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_154" /* SERVERCHANGE_WARNINGTEXT */];}}}if(shouldChangeServer&&(driveCount>maxDrives||NVMEDriveCount>maxNVMEDrives)){shouldChangeServer=false;warningMessage=__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_154" /* SERVERCHANGE_WARNINGTEXT */];}return[shouldChangeServer,warningMessage];};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.announcePageLoaded = announcePageLoaded;
exports.announce = announce;

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_ROOT = _CSSClassnames2.default.APP; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

function clearAnnouncer() {
  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
  if (announcer) {
    announcer.innerHTML = '';
  }
};

function announcePageLoaded(title) {
  announce(title + ' page was loaded');
}

function announce(message) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'assertive';

  var announcer = document.querySelector('.' + CLASS_ROOT + '__announcer');
  if (announcer) {
    announcer.setAttribute('aria-live', 'off');
    announcer.innerHTML = message;
    setTimeout(clearAnnouncer, 500);
    announcer.setAttribute('aria-live', mode);
  }
}

exports.default = { announce: announce, announcePageLoaded: announcePageLoaded };

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-circle-information', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'circle-information');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,10 L12,18 M12,6 L12,8' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CircleInformation';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(112);

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.LABEL;

var Label = function (_Component) {
  _inherits(Label, _Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.announce) {
        (0, _Announcer.announce)(this.labelRef.textContent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          align = _props.align,
          children = _props.children,
          className = _props.className,
          labelFor = _props.labelFor,
          margin = _props.margin,
          size = _props.size,
          truncate = _props.truncate,
          uppercase = _props.uppercase,
          props = _objectWithoutProperties(_props, ['align', 'children', 'className', 'labelFor', 'margin', 'size', 'truncate', 'uppercase']);

      delete props.announce;
      var labelMargin = margin ? margin : 'small' === size ? 'none' : 'medium';
      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--truncate', truncate), _defineProperty(_classnames, CLASS_ROOT + '--uppercase', uppercase), _defineProperty(_classnames, CLASS_ROOT + '--margin-' + labelMargin, labelMargin), _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _classnames), className);

      return _react2.default.createElement(
        'label',
        _extends({ ref: function ref(_ref) {
            return _this2.labelRef = _ref;
          } }, props, {
          className: classes, htmlFor: labelFor }),
        children
      );
    }
  }]);

  return Label;
}(_react.Component);

Label.displayName = 'Label';
exports.default = Label;


Label.propTypes = {
  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
  announce: _propTypes2.default.bool,
  labelFor: _propTypes2.default.string,
  margin: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  truncate: _propTypes2.default.bool,
  uppercase: _propTypes2.default.bool
};

Label.defaultProps = {
  size: 'medium'
};
module.exports = exports['default'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-alert', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'alert');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,17 L12,19 M12,10 L12,16 M12,3 L2,22 L22,22 L12,3 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Alert';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CHECK_BOX;

var CheckBox = function (_Component) {
  _inherits(CheckBox, _Component);

  function CheckBox() {
    _classCallCheck(this, CheckBox);

    return _possibleConstructorReturn(this, (CheckBox.__proto__ || Object.getPrototypeOf(CheckBox)).apply(this, arguments));
  }

  _createClass(CheckBox, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          checked = _props.checked,
          className = _props.className,
          disabled = _props.disabled,
          label = _props.label,
          name = _props.name,
          onChange = _props.onChange,
          reverse = _props.reverse,
          toggle = _props.toggle,
          props = _objectWithoutProperties(_props, ['checked', 'className', 'disabled', 'label', 'name', 'onChange', 'reverse', 'toggle']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--toggle', toggle), _defineProperty(_classnames, CLASS_ROOT + '--disabled', disabled), _defineProperty(_classnames, CLASS_ROOT + '--reverse', reverse), _classnames), className);

      var hidden = void 0;
      if (disabled && checked) {
        hidden = _react2.default.createElement('input', { name: name, type: 'hidden', value: 'true' });
      }

      var children = [_react2.default.createElement(
        'span',
        { key: 'checkbox' },
        _react2.default.createElement('input', _extends({}, props, { tabIndex: '0', className: CLASS_ROOT + '__input',
          name: name, type: 'checkbox',
          disabled: disabled,
          checked: checked,
          onChange: onChange })),
        _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__control' },
          _react2.default.createElement(
            'svg',
            { className: CLASS_ROOT + '__control-check', viewBox: '0 0 24 24',
              preserveAspectRatio: 'xMidYMid meet' },
            _react2.default.createElement('path', { fill: 'none', d: 'M6,11.3 L10.3,16 L18,6.2' })
          )
        )
      ), _react2.default.createElement(
        'span',
        { key: 'label', className: CLASS_ROOT + '__label' },
        label
      )];

      return _react2.default.createElement(
        'label',
        { className: classes, htmlFor: props.id },
        reverse ? children.reverse() : children,
        hidden
      );
    }
  }]);

  return CheckBox;
}(_react.Component);

CheckBox.displayName = 'CheckBox';
exports.default = CheckBox;


CheckBox.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  label: _propTypes2.default.node,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  reverse: _propTypes2.default.bool,
  toggle: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return fetchSupportedList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return fetchTemplateList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchActiveList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return fetchFilteredComps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return errorclose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return controllerchnaged; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calbutn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return fetchServerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return defaultfetchServerList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return onepicequirements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return fetchNodeQty; });
/* unused harmony export fetchDefaults */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getARCValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getosdisklist; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getosdisklistBlueData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getTenantStorageDiskList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getextranodesqty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return oncalbluedataconfigtrue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return oncalbluedataconfigfalse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return fetchgatewaydlts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return recallAnalyticsandDatabasenodeQty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GetGatewayRecommendations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GetControllerRecommendations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GetMasterRecommendations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__ = __webpack_require__(63);
var fetchSupportedList=function fetchSupportedList(){return{type:'API_REQUEST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetAllSupportedComponents',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["j" /* EPA_FETCH_SUPPORTEDLIST */]}};};var fetchTemplateList=function fetchTemplateList(){return{type:'API_REQUEST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetTemplates',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["h" /* EPAVNEXT_FETCH_TEMPLATELIST */]}};};var fetchActiveList=function fetchActiveList(){return{type:'API_REQUEST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetActivePartNumbers',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["i" /* EPA_FETCH_ACTIVEPARTNUMBERS */]}};};var fetchFilteredComps=function fetchFilteredComps(data){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["q" /* FILTERED_COMPONENTS */],payload:{data:data}};};var errorclose=function errorclose(){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["l" /* ERROR_CLOSE */]};};var controllerchnaged=function controllerchnaged(data){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["f" /* CONTROLLER_CONFIG */],payload:{data:data}};};var Calbutn=function Calbutn(data){return{type:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["d" /* CALC_DISABLED */],payload:{data:data}};};var fetchServerList=function fetchServerList(data){return{type:'API_REQUEST_POST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetServersAndHardware',data:data,next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["w" /* SERVER_LIST */]}};};var defaultfetchServerList=function defaultfetchServerList(data){return{type:'API_REQUEST_POST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetHardWareDefaults',data:data,next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["w" /* SERVER_LIST */]}};};var onepicequirements=function onepicequirements(data){return{type:'API_REQUEST_POST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetEPICRequirements',data:data,next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["k" /* EPICREQUIREMENTS */]}};};var fetchNodeQty=function fetchNodeQty(data){return{type:'API_REQUEST_POST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/NodeQty',data:data,next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["p" /* FETCH_NODEQTY */]}};};var fetchDefaults=function fetchDefaults(){return{type:'API_REQUEST',payload:{url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["n" /* FETCH_DEFAULT_WRKLD */]}};};var getARCValue=function getARCValue(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetARCValue',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["a" /* ARCVALUE */]}};};var getosdisklist=function getosdisklist(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetOSDiskList',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["u" /* OSLIST */]}};};var getosdisklistBlueData=function getosdisklistBlueData(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetOSDiskList',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["v" /* OSLISTBLUEDATA */]}};};var getTenantStorageDiskList=function getTenantStorageDiskList(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetOSDiskList',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["x" /* TENANTDRIVELIST */]}};};var getextranodesqty=function getextranodesqty(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetExtraNodesQty',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["s" /* GETEXTRANODES_QTY */]}};};var oncalbluedataconfigtrue=function oncalbluedataconfigtrue(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/CalculateBlueDataConfiguration',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["b" /* CALCULATEBLUEDATACONFIG */]}};};var oncalbluedataconfigfalse=function oncalbluedataconfigfalse(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/CalculateBlueDataConfiguration',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["c" /* CALCULATEBLUEDATACONFIGFALSE */]}};};var fetchgatewaydlts=function fetchgatewaydlts(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetGatewayNodeDetails',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["o" /* FETCH_GATEWAYDLTS */]}};};var recallAnalyticsandDatabasenodeQty=function recallAnalyticsandDatabasenodeQty(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GetRecallNodeStorageCalc',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["m" /* FETCH_ANALYTICSDATABASENODEQTY */]}};};var GetGatewayRecommendations=function GetGatewayRecommendations(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GatewayAndControllerRecommendations',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["r" /* GATEWAY_RECOMMENDATIONS */]}};};var GetControllerRecommendations=function GetControllerRecommendations(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GatewayAndControllerRecommendations',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["g" /* CONTROLLER_RECOMMENDATIONS */]}};};var GetMasterRecommendations=function GetMasterRecommendations(data){return{type:'API_REQUEST_POST',payload:{data:data,url:__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["e" /* _serviceUrl */]+__WEBPACK_IMPORTED_MODULE_1__SizerConfig_Config__["d" /* _said */]+'/GatewayAndControllerRecommendations',next:__WEBPACK_IMPORTED_MODULE_0__action_types_epaActionTypes__["t" /* MASTER_RECOMMENDATIONS */]}};};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(67);
var core = __webpack_require__(99);
var hide = __webpack_require__(178);
var redefine = __webpack_require__(558);
var ctx = __webpack_require__(287);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var NS = exports.NAMESPACES = {
    HTML: 'http://www.w3.org/1999/xhtml',
    MATHML: 'http://www.w3.org/1998/Math/MathML',
    SVG: 'http://www.w3.org/2000/svg',
    XLINK: 'http://www.w3.org/1999/xlink',
    XML: 'http://www.w3.org/XML/1998/namespace',
    XMLNS: 'http://www.w3.org/2000/xmlns/'
};

exports.ATTRS = {
    TYPE: 'type',
    ACTION: 'action',
    ENCODING: 'encoding',
    PROMPT: 'prompt',
    NAME: 'name',
    COLOR: 'color',
    FACE: 'face',
    SIZE: 'size'
};

exports.DOCUMENT_MODE = {
    NO_QUIRKS: 'no-quirks',
    QUIRKS: 'quirks',
    LIMITED_QUIRKS: 'limited-quirks'
};

var $ = exports.TAG_NAMES = {
    A: 'a',
    ADDRESS: 'address',
    ANNOTATION_XML: 'annotation-xml',
    APPLET: 'applet',
    AREA: 'area',
    ARTICLE: 'article',
    ASIDE: 'aside',

    B: 'b',
    BASE: 'base',
    BASEFONT: 'basefont',
    BGSOUND: 'bgsound',
    BIG: 'big',
    BLOCKQUOTE: 'blockquote',
    BODY: 'body',
    BR: 'br',
    BUTTON: 'button',

    CAPTION: 'caption',
    CENTER: 'center',
    CODE: 'code',
    COL: 'col',
    COLGROUP: 'colgroup',

    DD: 'dd',
    DESC: 'desc',
    DETAILS: 'details',
    DIALOG: 'dialog',
    DIR: 'dir',
    DIV: 'div',
    DL: 'dl',
    DT: 'dt',

    EM: 'em',
    EMBED: 'embed',

    FIELDSET: 'fieldset',
    FIGCAPTION: 'figcaption',
    FIGURE: 'figure',
    FONT: 'font',
    FOOTER: 'footer',
    FOREIGN_OBJECT: 'foreignObject',
    FORM: 'form',
    FRAME: 'frame',
    FRAMESET: 'frameset',

    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    HEAD: 'head',
    HEADER: 'header',
    HGROUP: 'hgroup',
    HR: 'hr',
    HTML: 'html',

    I: 'i',
    IMG: 'img',
    IMAGE: 'image',
    INPUT: 'input',
    IFRAME: 'iframe',

    KEYGEN: 'keygen',

    LABEL: 'label',
    LI: 'li',
    LINK: 'link',
    LISTING: 'listing',

    MAIN: 'main',
    MALIGNMARK: 'malignmark',
    MARQUEE: 'marquee',
    MATH: 'math',
    MENU: 'menu',
    MENUITEM: 'menuitem',
    META: 'meta',
    MGLYPH: 'mglyph',
    MI: 'mi',
    MO: 'mo',
    MN: 'mn',
    MS: 'ms',
    MTEXT: 'mtext',

    NAV: 'nav',
    NOBR: 'nobr',
    NOFRAMES: 'noframes',
    NOEMBED: 'noembed',
    NOSCRIPT: 'noscript',

    OBJECT: 'object',
    OL: 'ol',
    OPTGROUP: 'optgroup',
    OPTION: 'option',

    P: 'p',
    PARAM: 'param',
    PLAINTEXT: 'plaintext',
    PRE: 'pre',

    RB: 'rb',
    RP: 'rp',
    RT: 'rt',
    RTC: 'rtc',
    RUBY: 'ruby',

    S: 's',
    SCRIPT: 'script',
    SECTION: 'section',
    SELECT: 'select',
    SOURCE: 'source',
    SMALL: 'small',
    SPAN: 'span',
    STRIKE: 'strike',
    STRONG: 'strong',
    STYLE: 'style',
    SUB: 'sub',
    SUMMARY: 'summary',
    SUP: 'sup',

    TABLE: 'table',
    TBODY: 'tbody',
    TEMPLATE: 'template',
    TEXTAREA: 'textarea',
    TFOOT: 'tfoot',
    TD: 'td',
    TH: 'th',
    THEAD: 'thead',
    TITLE: 'title',
    TR: 'tr',
    TRACK: 'track',
    TT: 'tt',

    U: 'u',
    UL: 'ul',

    SVG: 'svg',

    VAR: 'var',

    WBR: 'wbr',

    XMP: 'xmp'
};

var SPECIAL_ELEMENTS = exports.SPECIAL_ELEMENTS = Object.create(null);

SPECIAL_ELEMENTS[NS.HTML] = Object.create(null);
SPECIAL_ELEMENTS[NS.HTML][$.ADDRESS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.APPLET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.AREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ARTICLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.ASIDE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BASEFONT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BGSOUND] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BLOCKQUOTE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.BUTTON] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.CENTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.COLGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DETAILS] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DIV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.DT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.EMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIELDSET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGCAPTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FIGURE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FOOTER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FORM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.FRAMESET] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H1] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H2] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H3] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H4] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H5] = true;
SPECIAL_ELEMENTS[NS.HTML][$.H6] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HEADER] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HGROUP] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.HTML] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IFRAME] = true;
SPECIAL_ELEMENTS[NS.HTML][$.IMG] = true;
SPECIAL_ELEMENTS[NS.HTML][$.INPUT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LI] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LINK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.LISTING] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MAIN] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MARQUEE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.MENU] = true;
SPECIAL_ELEMENTS[NS.HTML][$.META] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NAV] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOEMBED] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOFRAMES] = true;
SPECIAL_ELEMENTS[NS.HTML][$.NOSCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OBJECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.OL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.P] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PARAM] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PLAINTEXT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.PRE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SCRIPT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SECTION] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SELECT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SOURCE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.STYLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.SUMMARY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TABLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TBODY] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEMPLATE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TEXTAREA] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TFOOT] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TH] = true;
SPECIAL_ELEMENTS[NS.HTML][$.THEAD] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.TRACK] = true;
SPECIAL_ELEMENTS[NS.HTML][$.UL] = true;
SPECIAL_ELEMENTS[NS.HTML][$.WBR] = true;
SPECIAL_ELEMENTS[NS.HTML][$.XMP] = true;

SPECIAL_ELEMENTS[NS.MATHML] = Object.create(null);
SPECIAL_ELEMENTS[NS.MATHML][$.MI] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MO] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MN] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MS] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.MTEXT] = true;
SPECIAL_ELEMENTS[NS.MATHML][$.ANNOTATION_XML] = true;

SPECIAL_ELEMENTS[NS.SVG] = Object.create(null);
SPECIAL_ELEMENTS[NS.SVG][$.TITLE] = true;
SPECIAL_ELEMENTS[NS.SVG][$.FOREIGN_OBJECT] = true;
SPECIAL_ELEMENTS[NS.SVG][$.DESC] = true;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var inspect = __webpack_require__(147);

var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

/**
 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
 * 1. Assert: Type(O) is Object.
 * 2. Assert: IsPropertyKey(P) is true.
 * 3. Return O.[[Get]](P, O).
 */

module.exports = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HoursPerDay = 24;
var MinutesPerHour = 60;
var SecondsPerMinute = 60;
var msPerSecond = 1e3;
var msPerMinute = msPerSecond * SecondsPerMinute;
var msPerHour = msPerMinute * MinutesPerHour;
var msPerDay = 86400000;

module.exports = {
	HoursPerDay: HoursPerDay,
	MinutesPerHour: MinutesPerHour,
	SecondsPerMinute: SecondsPerMinute,
	msPerSecond: msPerSecond,
	msPerMinute: msPerMinute,
	msPerHour: msPerHour,
	msPerDay: msPerDay
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.5.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2020-05-04T22:49Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.5.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( _i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.5
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2020-03-14
 */
( function( window ) {
var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ( {} ).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	pushNative = arr.push,
	push = arr.push,
	slice = arr.slice,

	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[ i ] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
		"ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5]
		// or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
		whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
		"*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
			whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
			whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rhtml = /HTML$/i,
	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		return nonHex ?

			// Strip the backslash prefix from a non-hex escape sequence
			nonHex :

			// Replace a hexadecimal escape sequence with the encoded Unicode code point
			// Support: IE <=11+
			// For values outside the Basic Multilingual Plane (BMP), manually construct a
			// surrogate pair
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" +
				ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android<4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;

			// Can't trust NodeList.length
			while ( ( target[ j++ ] = els[ i++ ] ) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

				// Support: IE 8 only
				// Exclude object elements
				( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					if ( newContext !== context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split( "|" ),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[ i ] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( ( cur = cur.nextSibling ) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return ( name === "input" || name === "button" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
					inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	var namespace = elem.namespaceURI,
		docElem = ( elem.ownerDocument || elem ).documentElement;

	// Support: IE <=8
	// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
	// https://bugs.jquery.com/ticket/4833
	return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
	// Safari 4 - 5 only, Opera <=11.6 - 12.x only
	// IE/Edge & older browsers don't support the :scope pseudo-class.
	// Support: Safari 6.0 only
	// Safari 6.0 supports :scope but it's an alias of :root there.
	support.scope = assert( function( el ) {
		docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
		return typeof el.querySelectorAll !== "undefined" &&
			!el.querySelectorAll( ":scope fieldset div" ).length;
	} );

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert( function( el ) {
		el.className = "i";
		return !el.getAttribute( "className" );
	} );

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert( function( el ) {
		el.appendChild( document.createComment( "" ) );
		return !el.getElementsByTagName( "*" ).length;
	} );

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter[ "ID" ] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter[ "ID" ] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find[ "ID" ] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find[ "TAG" ] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( ( elem = results[ i++ ] ) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert( function( el ) {

			var input;

			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll( "[selected]" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push( "~=" );
			}

			// Support: IE 11+, Edge 15 - 18+
			// IE 11/Edge don't find elements on a `[name='']` query in some cases.
			// Adding a temporary attribute to the document before the selection works
			// around the issue.
			// Interestingly, IE 10 & older don't seem to have the issue.
			input = document.createElement( "input" );
			input.setAttribute( "name", "" );
			el.appendChild( input );
			if ( !el.querySelectorAll( "[name='']" ).length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
					whitespace + "*(?:''|\"\")" );
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll( ":checked" ).length ) {
				rbuggyQSA.push( ":checked" );
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push( ".#.+[+~]" );
			}

			// Support: Firefox <=3.6 - 5 only
			// Old Firefox doesn't throw on a badly-escaped identifier.
			el.querySelectorAll( "\\\f" );
			rbuggyQSA.push( "[\\r\\n\\f]" );
		} );

		assert( function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement( "input" );
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll( "[name=d]" ).length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: Opera 10 - 11 only
			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll( "*,:x" );
			rbuggyQSA.push( ",.*:" );
		} );
	}

	if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector ) ) ) ) {

		assert( function( el ) {

			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		} );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			) );
		} :
		function( a, b ) {
			if ( b ) {
				while ( ( b = b.parentNode ) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a == document || a.ownerDocument == preferredDoc &&
				contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b == document || b.ownerDocument == preferredDoc &&
				contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {

		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			return a == document ? -1 :
				b == document ? 1 :
				/* eslint-enable eqeqeq */
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( ( cur = cur.parentNode ) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( ( cur = cur.parentNode ) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[ i ] === bp[ i ] ) {
			i++;
		}

		return i ?

			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[ i ], bp[ i ] ) :

			// Otherwise nodes in our document sort first
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			/* eslint-disable eqeqeq */
			ap[ i ] == preferredDoc ? -1 :
			bp[ i ] == preferredDoc ? 1 :
			/* eslint-enable eqeqeq */
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( support.matchesSelector && documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

				// As well, disconnected nodes are said to be in a document
				// fragment in IE 9
				elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			( val = elem.getAttributeNode( name ) ) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {

		// If no nodeType, this is expected to be an array
		while ( ( node = elem[ i++ ] ) ) {

			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {

			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}

	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
				match[ 5 ] || "" ).replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

				// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				Sizzle.error( match[ 0 ] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace +
					")" + className + "(" + whitespace + "|$)" ) ) && classCache(
						className, function( elem ) {
							return pattern.test(
								typeof elem.className === "string" && elem.className ||
								typeof elem.getAttribute !== "undefined" &&
									elem.getAttribute( "class" ) ||
								""
							);
				} );
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				/* eslint-disable max-len */

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
				/* eslint-enable max-len */

			};
		},

		"CHILD": function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || ( node[ expando ] = {} );

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								( outerCache[ node.uniqueID ] = {} );

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {

								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || ( node[ expando ] = {} );

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												( outerCache[ node.uniqueID ] = {} );

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		"not": markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element (issue #299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		"has": markFunction( function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		} ),

		"contains": markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement &&
				( !document.hasFocus || document.hasFocus() ) &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return ( nodeName === "input" && !!elem.checked ) ||
				( nodeName === "option" && !!elem.selected );
		},

		"selected": function( elem ) {

			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {

			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos[ "empty" ]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		"last": createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		"even": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"odd": createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ?
				argument + length :
				argument > length ?
					length :
					argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rcombinators.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrim, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :

			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] ||
							( outerCache[ elem.uniqueID ] = {} );

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = uniqueCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts(
				selector || "*",
				context.nodeType ? [ context ] : context,
				[]
			),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?

				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

					// If the preceding token was a descendant combinator, insert an implicit any-element `*`
					tokens
						.slice( 0, i - 1 )
						.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache(
			selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers )
		);

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
			context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
				.replace( runescape, funescape ), context ) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
						context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert( function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute( "href" ) === "#";
} ) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	} );
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert( function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
} ) ) {
	addHandle( "value", function( elem, _name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	} );
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert( function( el ) {
	return el.getAttribute( "disabled" ) == null;
} ) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
		}
	} );
}

return Sizzle;

} )( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
function expectSync( elem, type ) {
	return ( elem === safeActiveElement() ) === ( type === "focus" );
}

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
					dataPriv.get( this, "events" ) || Object.create( null )
				)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", returnTrue );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, expectSync ) {

	// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
	if ( !expectSync ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var notAsync, result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				// Saved data should be false in such cases, but might be a leftover capture object
				// from an async native handler (gh-4350)
				if ( !saved.length ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					// Support: IE <=9 - 11+
					// focus() and blur() are asynchronous
					notAsync = expectSync( this, type );
					this[ type ]();
					result = dataPriv.get( this, type );
					if ( saved !== result || notAsync ) {
						dataPriv.set( this, type, false );
					} else {
						result = {};
					}
					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();
						return result.value;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering the
				// native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved.length ) {

				// ...and capture the result
				dataPriv.set( this, type, {
					value: jQuery.event.trigger(

						// Support: IE <=9 - 11+
						// Extend with the prototype to reset the above stopImmediatePropagation()
						jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
						saved.slice( 1 ),
						this
					)
				} );

				// Abort handling of the native event
				event.stopImmediatePropagation();
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, expectSync );

			// Return false to allow normal processing in the caller
			return false;
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		delegateType: delegateType
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px";
				tr.style.height = "1px";
				trChild.style.height = "9px";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"gridArea": true,
		"gridColumn": true,
		"gridColumnEnd": true,
		"gridColumnStart": true,
		"gridRow": true,
		"gridRowEnd": true,
		"gridRowStart": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
					jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = (
					dataPriv.get( cur, "events" ) || Object.create( null )
				)[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {

				// Handle: regular nodes (via `this.ownerDocument`), window
				// (via `this.document`) & document (via `this`).
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this.document || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script
			if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			if ( typeof props.top === "number" ) {
				props.top += "px";
			}
			if ( typeof props.left === "number" ) {
				props.left += "px";
			}
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );

jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Spinning = __webpack_require__(17);

var _Spinning2 = _interopRequireDefault(_Spinning);

var _InfiniteScroll = __webpack_require__(171);

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _Selection = __webpack_require__(172);

var _Selection2 = _interopRequireDefault(_Selection);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.LIST;
var LIST_ITEM = _CSSClassnames2.default.LIST_ITEM;
var SELECTED_CLASS = CLASS_ROOT + '-item--selected';
var ACTIVE_CLASS = CLASS_ROOT + '-item--active';

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props, context) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props, context));

    _this._onClick = _this._onClick.bind(_this);
    _this._fireClick = _this._fireClick.bind(_this);
    _this._announceItem = _this._announceItem.bind(_this);
    _this._onPreviousItem = _this._onPreviousItem.bind(_this);
    _this._onNextItem = _this._onNextItem.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);

    _this.state = {
      activeItem: undefined,
      mouseActive: false,
      selected: _Selection2.default.normalizeIndexes(props.selected)
    };
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          onMore = _props.onMore,
          selectable = _props.selectable;

      this._setSelection();
      if (onMore) {
        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
      }
      if (selectable) {
        // only listen for navigation keys if the list row can be selected
        this._keyboardHandlers = {
          left: this._onPreviousItem,
          up: this._onPreviousItem,
          right: this._onNextItem,
          down: this._onNextItem,
          enter: this._onEnter,
          space: this._onEnter
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this._scroll) {
        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
        this._scroll = undefined;
      }
      if (nextProps.hasOwnProperty('selected')) {
        this.setState({
          selected: _Selection2.default.normalizeIndexes(nextProps.selected)
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          onMore = _props2.onMore,
          selectable = _props2.selectable;
      var selected = this.state.selected;

      if (JSON.stringify(selected) !== JSON.stringify(prevState.selected)) {
        this._setSelection();
      }
      if (onMore && !this._scroll) {
        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
      }
      if (selectable) {
        // only listen for navigation keys if the list row can be selected
        this._keyboardHandlers = {
          left: this._onPreviousItem,
          up: this._onPreviousItem,
          right: this._onNextItem,
          down: this._onNextItem,
          enter: this._onEnter,
          space: this._onEnter
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var selectable = this.props.selectable;

      if (this._scroll) {
        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
      }
      if (selectable) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: '_announceItem',
    value: function _announceItem(label) {
      var intl = this.context.intl;

      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
      (0, _Announcer.announce)(label + ' ' + enterSelectMessage);
    }
  }, {
    key: '_setSelection',
    value: function _setSelection() {
      if (this.listRef) {
        _Selection2.default.setClassFromIndexes({
          containerElement: this.listRef,
          childSelector: '.' + LIST_ITEM,
          selectedClass: SELECTED_CLASS,
          selectedIndexes: this.state.selected
        });
      };
    }
  }, {
    key: '_onPreviousItem',
    value: function _onPreviousItem(event) {
      var _this2 = this;

      if (this.listRef.contains(document.activeElement)) {
        event.preventDefault();
        var activeItem = this.state.activeItem;

        var rows = this.listRef.querySelectorAll('ul li');
        if (rows && rows.length > 0) {
          if (activeItem === undefined) {
            rows[0].classList.add(ACTIVE_CLASS);
            this.setState({ activeItem: 0 }, function () {
              _this2._announceItem(rows[_this2.state.activeItem].innerText);
            });
          } else if (activeItem - 1 >= 0) {
            rows[activeItem].classList.remove(ACTIVE_CLASS);
            rows[activeItem - 1].classList.add(ACTIVE_CLASS);
            this.setState({ activeItem: activeItem - 1 }, function () {
              _this2._announceItem(rows[_this2.state.activeItem].innerText);
            });
          }
        }

        //stop event propagation
        return true;
      }
    }
  }, {
    key: '_onNextItem',
    value: function _onNextItem(event) {
      var _this3 = this;

      if (this.listRef.contains(document.activeElement)) {
        event.preventDefault();
        var activeItem = this.state.activeItem;

        var rows = this.listRef.querySelectorAll('ul li');
        if (rows && rows.length > 0) {
          if (activeItem === undefined) {
            rows[0].classList.add(ACTIVE_CLASS);
            this.setState({ activeItem: 0 }, function () {
              _this3._announceItem(rows[_this3.state.activeItem].innerText);
            });
          } else if (activeItem + 1 <= rows.length - 1) {
            rows[activeItem].classList.remove(ACTIVE_CLASS);
            rows[activeItem + 1].classList.add(ACTIVE_CLASS);
            this.setState({ activeItem: activeItem + 1 }, function () {
              _this3._announceItem(rows[_this3.state.activeItem].innerText);
            });
          }
        }

        //stop event propagation
        return true;
      }
    }
  }, {
    key: '_fireClick',
    value: function _fireClick(element, shiftKey) {
      var event = void 0;
      try {
        event = new MouseEvent('click', {
          'bubbles': true,
          'cancelable': true,
          'shiftKey': shiftKey
        });
      } catch (e) {
        // IE11 workaround.
        event = document.createEvent('Event');
        event.initEvent('click', true, true);
      }
      // We use dispatchEvent to have the browser fill out the event fully.
      element.dispatchEvent(event);
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(event) {
      var activeItem = this.state.activeItem;
      var intl = this.context.intl;

      if (this.listRef.contains(document.activeElement) && activeItem !== undefined) {
        var rows = this.listRef.querySelectorAll('ul li');
        this._fireClick(rows[activeItem], event.shiftKey);
        rows[activeItem].classList.remove(ACTIVE_CLASS);
        var label = rows[activeItem].innerText;
        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
        (0, _Announcer.announce)(label + ' ' + selectedMessage);
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(event) {
      var _props3 = this.props,
          onSelect = _props3.onSelect,
          selectable = _props3.selectable,
          selected = _props3.selected;

      if (!this.props.selectable) {
        return;
      }

      var selection = _Selection2.default.onClick(event, {
        containerElement: this.listRef,
        childSelector: '.' + LIST_ITEM,
        selectedClass: SELECTED_CLASS,
        multiSelect: 'multiple' === selectable,
        priorSelectedIndexes: this.state.selected
      });

      // only set the selected state and classes if the caller isn't managing it.
      if (selected === undefined) {
        this.setState({ selected: selection }, this._setSelection);
      }

      if (onSelect) {
        onSelect(selection.length === 1 ? selection[0] : selection);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this4 = this;

      var _props4 = this.props,
          a11yTitle = _props4.a11yTitle,
          children = _props4.children,
          className = _props4.className,
          emptyIndicator = _props4.emptyIndicator,
          _onBlur = _props4.onBlur,
          _onFocus = _props4.onFocus,
          onMore = _props4.onMore,
          _onMouseDown = _props4.onMouseDown,
          _onMouseUp = _props4.onMouseUp,
          selectable = _props4.selectable,
          props = _objectWithoutProperties(_props4, ['a11yTitle', 'children', 'className', 'emptyIndicator', 'onBlur', 'onFocus', 'onMore', 'onMouseDown', 'onMouseUp', 'selectable']);

      var _state = this.state,
          activeItem = _state.activeItem,
          focus = _state.focus,
          mouseActive = _state.mouseActive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--focus', focus), _defineProperty(_classnames, CLASS_ROOT + '--selectable', selectable), _defineProperty(_classnames, CLASS_ROOT + '--moreable', onMore), _classnames), className);

      var empty = void 0;
      if (emptyIndicator) {
        empty = _react2.default.createElement(
          'li',
          { className: CLASS_ROOT + '__empty' },
          emptyIndicator
        );
      }

      var more = void 0;
      if (onMore) {
        more = _react2.default.createElement(
          'li',
          { ref: function ref(_ref) {
              return _this4.moreRef = _ref;
            }, className: CLASS_ROOT + '__more' },
          _react2.default.createElement(_Spinning2.default, null)
        );
      }

      var selectableProps = void 0;
      if (selectable) {
        var multiSelectMessage = selectable === 'multiple' ? '(' + _Intl2.default.getMessage(intl, 'Multi Select') + ')' : '';
        var listMessage = a11yTitle || _Intl2.default.getMessage(intl, 'List');
        var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
        selectableProps = {
          'aria-label': listMessage + ' ' + multiSelectMessage + ' ' + navigationHelpMessage,
          tabIndex: '0',
          onClick: this._onClick,
          onMouseDown: function onMouseDown(event) {
            _this4.setState({ mouseActive: true });
            if (_onMouseDown) {
              _onMouseDown(event);
            }
          },
          onMouseUp: function onMouseUp(event) {
            _this4.setState({ mouseActive: false });
            if (_onMouseUp) {
              _onMouseUp(event);
            }
          },
          onFocus: function onFocus(event) {
            if (mouseActive === false) {
              _this4.setState({ focus: true });
            }
            if (_onFocus) {
              _onFocus(event);
            }
          },
          onBlur: function onBlur(event) {
            if (activeItem) {
              var rows = _this4.listRef.querySelectorAll('ul li');
              rows[activeItem].classList.remove(ACTIVE_CLASS);
            }
            _this4.setState({ focus: false, activeItem: undefined });
            if (_onBlur) {
              _onBlur(event);
            }
          }
        };
      }

      return _react2.default.createElement(
        'ul',
        _extends({}, props, { ref: function ref(_ref2) {
            return _this4.listRef = _ref2;
          }, className: classes
        }, selectableProps),
        empty,
        children,
        more
      );
    }
  }]);

  return List;
}(_react.Component);

List.displayName = 'List';
exports.default = List;


List.contextTypes = {
  intl: _propTypes2.default.object
};

List.propTypes = {
  emptyIndicator: _propTypes2.default.node,
  onMore: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  selectable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['multiple'])]),
  selected: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
};

List.defaultProps = {
  role: 'list'
};
module.exports = exports['default'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.LIST_ITEM;

var ListItem = function (_Component) {
  _inherits(ListItem, _Component);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick;


      var classes = (0, _classnames3.default)(CLASS_ROOT, className, _defineProperty({}, CLASS_ROOT + '--selectable', onClick));

      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
      var restProps = _Props2.default.omit(this.props, Object.keys(ListItem.propTypes));

      return _react2.default.createElement(
        _Box2.default,
        _extends({}, boxProps, restProps, { tag: 'li', className: classes }),
        children
      );
    }
  }]);

  return ListItem;
}(_react.Component);

ListItem.displayName = 'ListItem';
exports.default = ListItem;
;

ListItem.propTypes = _extends({}, _Box2.default.propTypes);

ListItem.defaultProps = {
  align: 'center',
  direction: 'row',
  pad: { horizontal: 'medium', vertical: 'small' },
  separator: 'bottom',
  role: 'listitem'
};
module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.FORM_FIELD;

var FormField = function (_Component) {
  _inherits(FormField, _Component);

  function FormField(props, context) {
    _classCallCheck(this, FormField);

    var _this = _possibleConstructorReturn(this, (FormField.__proto__ || Object.getPrototypeOf(FormField)).call(this, props, context));

    _this._onFocus = _this._onFocus.bind(_this);
    _this._onBlur = _this._onBlur.bind(_this);
    _this._onClick = _this._onClick.bind(_this);

    _this.state = { focus: false };
    return _this;
  }

  _createClass(FormField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var contentsElement = this.contentsRef;
      if (contentsElement) {
        var inputElements = contentsElement.querySelectorAll('input, textarea, select');
        if (inputElements.length === 1) {
          this._inputElement = inputElements[0];
          this._inputElement.addEventListener('focus', this._onFocus);
          this._inputElement.addEventListener('blur', this._onBlur);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._inputElement) {
        this._inputElement.removeEventListener('focus', this._onFocus);
        this._inputElement.removeEventListener('blur', this._onBlur);
        delete this._inputElement;
      }
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      this.setState({ focus: true });
    }
  }, {
    key: '_onBlur',
    value: function _onBlur() {
      this.setState({ focus: false });
    }
  }, {
    key: '_onClick',
    value: function _onClick() {
      if (this._inputElement) {
        this._inputElement.focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          help = _props.help,
          hidden = _props.hidden,
          htmlFor = _props.htmlFor,
          label = _props.label,
          size = _props.size,
          strong = _props.strong,
          error = _props.error,
          props = _objectWithoutProperties(_props, ['children', 'className', 'help', 'hidden', 'htmlFor', 'label', 'size', 'strong', 'error']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--focus', this.state.focus), _defineProperty(_classnames, CLASS_ROOT + '--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '--text', htmlFor), _defineProperty(_classnames, CLASS_ROOT + '--size-' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--strong', strong), _defineProperty(_classnames, CLASS_ROOT + '--error', error), _classnames), className);

      var fieldError = error ? _react2.default.createElement(
        'span',
        { className: CLASS_ROOT + "__error" },
        error
      ) : undefined;

      var fieldHelp = help !== null && help !== undefined ? _react2.default.createElement(
        'span',
        { className: CLASS_ROOT + "__help" },
        this.props.help
      ) : undefined;

      var labelNode = label ? _react2.default.createElement(
        'label',
        { className: CLASS_ROOT + "__label", htmlFor: htmlFor },
        label
      ) : undefined;

      return _react2.default.createElement(
        'div',
        _extends({ className: classes }, props, { onClick: this._onClick }),
        fieldError,
        labelNode,
        fieldHelp,
        _react2.default.createElement(
          'span',
          { ref: function ref(_ref) {
              return _this2.contentsRef = _ref;
            },
            className: CLASS_ROOT + "__contents" },
          children
        )
      );
    }
  }]);

  return FormField;
}(_react.Component);

FormField.displayName = 'FormField';
exports.default = FormField;


FormField.propTypes = {
  error: _propTypes2.default.node,
  help: _propTypes2.default.node,
  hidden: _propTypes2.default.bool,
  htmlFor: _propTypes2.default.string,
  label: _propTypes2.default.node,
  size: _propTypes2.default.oneOf(['medium', 'large']),
  strong: _propTypes2.default.bool
};

FormField.defaultProps = {
  size: 'medium',
  strong: false
};
module.exports = exports['default'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-close', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-close');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7,7 L17,17 M7,17 L17,7' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormClose';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(179)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"."}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(640);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(641);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && __webpack_require__(16)('Object.prototype.toString');

// https://www.ecma-international.org/ecma-262/6.0/#sec-isarray

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(36);

var assertRecord = __webpack_require__(90);

var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-isaccessordescriptor

module.exports = function IsAccessorDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
		return false;
	}

	return true;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/5.1/#sec-9.11

module.exports = __webpack_require__(215);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': 'access accessibility',
  'access-ad': 'access ad',
  'access-assist-listening': 'access assist listening',
  'access-braille': 'access braille',
  'access-sign': 'access sign',
  'access-tty': 'access tty',
  'access-volume-control': 'access volume control',
  'access-wheelchair-active': 'access wheelchair active',
  'access-wheelchair': 'access wheelchair',
  'achievement': 'achievement',
  'action': 'action',
  'actions': 'actions',
  'add-circle': 'add circle',
  'add': 'add',
  'aggregate': 'aggregate',
  'aid': 'aid',
  'alarm': 'alarm',
  'alert': 'alert',
  'analytics': 'analytics',
  'announce': 'announce',
  'apps': 'apps',
  'archive': 'archive',
  'article': 'article',
  'ascend': 'ascend',
  'attachment': 'attachment',
  'back-ten': 'back ten',
  'bar-chart': 'bar chart',
  'basket': 'basket',
  'blog': 'blog',
  'book': 'book',
  'bookmark': 'bookmark',
  'bottom-corner': 'bottom corner',
  'brand-apple-app-store': 'brand apple app store',
  'brand-codepen-edit': 'brand codepen edit',
  'brand-codepen-try': 'brand codepen try',
  'brand-google-play': 'brand google play',
  'brand-grommet-outline': 'brand grommet outline',
  'brand-grommet-path': 'brand grommet path',
  'brand-hpe-element-outline': 'brand hpe element outline',
  'brand-hpe-element-path': 'brand hpe element path',
  'brand-hpe-labs-insignia-outline': 'brand hpe labs insignia outline',
  'brand-hpe-labs-insignia': 'brand hpe labs insignia',
  'brand-hpe-stack-centered': 'brand hpe stack centered',
  'brand-hpe-stack': 'brand hpe stack',
  'briefcase': 'briefcase',
  'brush': 'brush',
  'bug': 'bug',
  'bundle': 'bundle',
  'business-service': 'business service',
  'calculator': 'calculator',
  'calendar': 'calendar',
  'camera': 'camera',
  'capacity': 'capacity',
  'car': 'car',
  'caret-down': 'caret down',
  'caret-next': 'caret next',
  'caret-previous': 'caret previous',
  'caret-up': 'caret up',
  'cart': 'cart',
  'catalog': 'catalog',
  'chapter-add': 'chapter add',
  'chapter-next': 'chapter next',
  'chapter-previous': 'chapter previous',
  'chat': 'chat',
  'checkbox-selected': 'checkbox selected',
  'checkbox': 'checkbox',
  'checkmark': 'checkmark',
  'circle-information': 'circle information',
  'circle-play': 'circle play',
  'circle-question': 'circle question',
  'clear-option': 'clear option',
  'clear': 'clear',
  'cli': 'cli',
  'clipboard': 'clipboard',
  'clock': 'clock',
  'clone': 'clone',
  'close': 'close',
  'closed-caption': 'closed caption',
  'cloud-computer': 'cloud computer',
  'cloud-download': 'cloud download',
  'cloud-software': 'cloud software',
  'cloud-upload': 'cloud upload',
  'cloud': 'cloud',
  'cluster': 'cluster',
  'code': 'code',
  'columns': 'columns',
  'compare': 'compare',
  'compass': 'compass',
  'compliance': 'compliance',
  'configure': 'configure',
  'connect': 'connect',
  'contact-info': 'contact info',
  'contact': 'contact',
  'contract': 'contract',
  'copy': 'copy',
  'credit-card': 'credit card',
  'cube': 'cube',
  'cubes': 'cubes',
  'currency': 'currency',
  'cursor': 'cursor',
  'cut': 'cut',
  'cycle': 'cycle',
  'dashboard': 'dashboard',
  'database': 'database',
  'deliver': 'deliver',
  'deploy': 'deploy',
  'descend': 'descend',
  'desktop': 'desktop',
  'detach': 'detach',
  'diamond': 'diamond',
  'directions': 'directions',
  'dislike': 'dislike',
  'document-cloud': 'document cloud',
  'document-config': 'document config',
  'document-csv': 'document csv',
  'document-download': 'document download',
  'document-excel': 'document excel',
  'document-exe': 'document exe',
  'document-image': 'document image',
  'document-locked': 'document locked',
  'document-missing': 'document missing',
  'document-notes': 'document notes',
  'document-outlook': 'document outlook',
  'document-pdf': 'document pdf',
  'document-performance': 'document performance',
  'document-ppt': 'document ppt',
  'document-rtf': 'document rtf',
  'document-sound': 'document sound',
  'document-store': 'document store',
  'document-test': 'document test',
  'document-threat': 'document threat',
  'document-time': 'document time',
  'document-transfer': 'document transfer',
  'document-txt': 'document txt',
  'document-update': 'document update',
  'document-upload': 'document upload',
  'document-user': 'document user',
  'document-verified': 'document verified',
  'document-video': 'document video',
  'document-windows': 'document windows',
  'document-word': 'document word',
  'document-zip': 'document zip',
  'document': 'document',
  'domain': 'domain',
  'down': 'down',
  'download': 'download',
  'drag': 'drag',
  'drive-cage': 'drive cage',
  'duplicate': 'duplicate',
  'edit': 'edit',
  'eject': 'eject',
  'empty-circle': 'empty circle',
  'expand': 'expand',
  'fan': 'fan',
  'fast-forward': 'fast forward',
  'favorite': 'favorite',
  'filter': 'filter',
  'finger-print': 'finger print',
  'flag': 'flag',
  'folder-cycle': 'folder cycle',
  'folder-open': 'folder open',
  'folder': 'folder',
  'form-edit': 'form edit',
  'forward-ten': 'forward ten',
  'gallery': 'gallery',
  'gamepad': 'gamepad',
  'gift': 'gift',
  'globe': 'globe',
  'grid': 'grid',
  'group': 'group',
  'grow': 'grow',
  'halt': 'halt',
  'help': 'help',
  'history': 'history',
  'home': 'home',
  'host-maintenance': 'host maintenance',
  'host': 'host',
  'image': 'image',
  'impact': 'impact',
  'in-progress': 'in progress',
  'inbox': 'inbox',
  'indicator': 'indicator',
  'info': 'info',
  'inherit': 'inherit',
  'inspect': 'inspect',
  'install': 'install',
  'integration': 'integration',
  'iteration': 'iteration',
  'java': 'java',
  'language': 'language',
  'launch': 'launch',
  'layer': 'layer',
  'license': 'license',
  'like': 'like',
  'line-chart': 'line chart',
  'link-bottom': 'link bottom',
  'link-down': 'link down',
  'link-next': 'link next',
  'link-previous': 'link previous',
  'link-top': 'link top',
  'link-up': 'link up',
  'link': 'link',
  'local': 'local',
  'location-pin': 'location pin',
  'location': 'location',
  'lock': 'lock',
  'login': 'login',
  'logout': 'logout',
  'magic': 'magic',
  'mail-option': 'mail option',
  'mail': 'mail',
  'manual': 'manual',
  'map-location': 'map location',
  'map': 'map',
  'menu': 'menu',
  'microphone': 'microphone',
  'money': 'money',
  'monitor': 'monitor',
  'more': 'more',
  'multiple': 'multiple',
  'navigate': 'navigate',
  'new-window': 'new window',
  'new': 'new',
  'next': 'next',
  'nodes': 'nodes',
  'note': 'note',
  'notes': 'notes',
  'notification': 'notification',
  'object-group': 'object group',
  'object-ungroup': 'object ungroup',
  'optimize': 'optimize',
  'organization': 'organization',
  'overview': 'overview',
  'pan': 'pan',
  'pause-fill': 'pause fill',
  'pause': 'pause',
  'personal-computer': 'personal computer',
  'pie-chart': 'pie chart',
  'pin': 'pin',
  'plan': 'plan',
  'platform-amazon': 'platform amazon',
  'platform-android': 'platform android',
  'platform-apple': 'platform apple',
  'platform-archlinux': 'platform archlinux',
  'platform-aruba': 'platform aruba',
  'platform-centos': 'platform centos',
  'platform-chrome': 'platform chrome',
  'platform-cloudlinux': 'platform cloudlinux',
  'platform-debian': 'platform debian',
  'platform-docker': 'platform docker',
  'platform-dos': 'platform dos',
  'platform-dropbox': 'platform dropbox',
  'platform-dxc': 'platform dxc',
  'platform-edge': 'platform edge',
  'platform-fedora': 'platform fedora',
  'platform-firefox': 'platform firefox',
  'platform-freebsd': 'platform freebsd',
  'platform-google': 'platform google',
  'platform-hadoop': 'platform hadoop',
  'platform-heroku': 'platform heroku',
  'platform-horton': 'platform horton',
  'platform-hp': 'platform hp',
  'platform-hpi': 'platform hpi',
  'platform-internet-explorer': 'platform internet explorer',
  'platform-java': 'platform java',
  'platform-mandriva': 'platform mandriva',
  'platform-mysql': 'platform mysql',
  'platform-norton': 'platform norton',
  'platform-onedrive': 'platform onedrive',
  'platform-opera': 'platform opera',
  'platform-oracle': 'platform oracle',
  'platform-pied-piper': 'platform pied piper',
  'platform-raspberry': 'platform raspberry',
  'platform-reactjs': 'platform reactjs',
  'platform-redhat': 'platform redhat',
  'platform-safari-option': 'platform safari option',
  'platform-safari': 'platform safari',
  'platform-sco': 'platform sco',
  'platform-solaris': 'platform solaris',
  'platform-suse': 'platform suse',
  'platform-swift': 'platform swift',
  'platform-turbolinux': 'platform turbolinux',
  'platform-ubuntu': 'platform ubuntu',
  'platform-unixware': 'platform unixware',
  'platform-vmware': 'platform vmware',
  'platform-windows-legacy': 'platform windows legacy',
  'platform-windows': 'platform windows',
  'play-fill': 'play fill',
  'play': 'play',
  'power': 'power',
  'previous': 'previous',
  'print': 'print',
  'radial-selected': 'radial selected',
  'radial': 'radial',
  'refresh': 'refresh',
  'resources': 'resources',
  'resume': 'resume',
  'revert': 'revert',
  'rewind': 'rewind',
  'risk': 'risk',
  'robot': 'robot',
  'rss': 'rss',
  'run': 'run',
  'satellite': 'satellite',
  'save': 'save',
  'scan': 'scan',
  'schedule-new': 'schedule new',
  'schedule-play': 'schedule play',
  'schedule': 'schedule',
  'schedules': 'schedules',
  'scorecard': 'scorecard',
  'search-advanced': 'search advanced',
  'search': 'search',
  'secure': 'secure',
  'select': 'select',
  'selection': 'selection',
  'send': 'send',
  'server-cluster': 'server cluster',
  'server': 'server',
  'servers': 'servers',
  'service-play': 'service play',
  'services': 'services',
  'settings-option': 'settings option',
  'share': 'share',
  'shield-security': 'shield security',
  'shield': 'shield',
  'shift': 'shift',
  'sidebar': 'sidebar',
  'social-amazon': 'social amazon',
  'social-amex': 'social amex',
  'social-bitcoin': 'social bitcoin',
  'social-codepen': 'social codepen',
  'social-creative-commons': 'social creative commons',
  'social-dropbox': 'social dropbox',
  'social-facebook-option': 'social facebook option',
  'social-facebook': 'social facebook',
  'social-github': 'social github',
  'social-google-plus': 'social google plus',
  'social-google-wallet': 'social google wallet',
  'social-instagram': 'social instagram',
  'social-linkedin-option': 'social linkedin option',
  'social-linkedin': 'social linkedin',
  'social-mail': 'social mail',
  'social-mastercard': 'social mastercard',
  'social-medium': 'social medium',
  'social-paypal': 'social paypal',
  'social-pinterest': 'social pinterest',
  'social-product-hunt': 'social product hunt',
  'social-reddit': 'social reddit',
  'social-skype': 'social skype',
  'social-slack': 'social slack',
  'social-snapchat': 'social snapchat',
  'social-square': 'social square',
  'social-stack-overflow': 'social stack overflow',
  'social-stripe': 'social stripe',
  'social-tumblr': 'social tumblr',
  'social-twitter': 'social twitter',
  'social-vimeo': 'social vimeo',
  'social-vine': 'social vine',
  'social-visa': 'social visa',
  'social-wordpress': 'social wordpress',
  'social-youtube': 'social youtube',
  'sort': 'sort',
  'split': 'split',
  'splits': 'splits',
  'stakeholder': 'stakeholder',
  'standards-3d-effects': 'standards 3d effects',
  'standards-connectivity': 'standards connectivity',
  'standards-css3': 'standards css3',
  'standards-device': 'standards device',
  'standards-fireball': 'standards fireball',
  'standards-html5': 'standards html5',
  'standards-multimedia': 'standards multimedia',
  'standards-offline-storage': 'standards offline storage',
  'standards-performance': 'standards performance',
  'standards-sematics': 'standards sematics',
  'star-half': 'star half',
  'star': 'star',
  'steps': 'steps',
  'stop-fill': 'stop fill',
  'stop': 'stop',
  'storage': 'storage',
  'street-view': 'street view',
  'subtract-circle': 'subtract circle',
  'subtract': 'subtract',
  'support': 'support',
  'sync': 'sync',
  'system': 'system',
  'table-add': 'table add',
  'table': 'table',
  'tag': 'tag',
  'target': 'target',
  'task': 'task',
  'tasks': 'tasks',
  'technology': 'technology',
  'template': 'template',
  'terminal': 'terminal',
  'test-desktop': 'test desktop',
  'test': 'test',
  'text-wrap': 'text wrap',
  'threats': 'threats',
  'ticket': 'ticket',
  'tools': 'tools',
  'tooltip': 'tooltip',
  'top-corner': 'top corner',
  'transaction': 'transaction',
  'trash': 'trash',
  'tree': 'tree',
  'trigger': 'trigger',
  'trophy': 'trophy',
  'troubleshoot': 'troubleshoot',
  'unlink': 'unlink',
  'unlock': 'unlock',
  'up': 'up',
  'update': 'update',
  'upgrade': 'upgrade',
  'upload': 'upload',
  'user-add': 'user add',
  'user-admin': 'user admin',
  'user-expert': 'user expert',
  'user-female': 'user female',
  'user-manager': 'user manager',
  'user-new': 'user new',
  'user-police': 'user police',
  'user-settings': 'user settings',
  'user-worker': 'user worker',
  'user': 'user',
  'validate': 'validate',
  'video': 'video',
  'view': 'view',
  'virtual-machine': 'virtual machine',
  'vm-maintenance': 'vm maintenance',
  'volume-low': 'volume low',
  'volume-mute': 'volume mute',
  'volume': 'volume',
  'vulnerability': 'vulnerability',
  'waypoint': 'waypoint',
  'workshop': 'workshop',
  'zoom-in': 'zoom in',
  'zoom-out': 'zoom out'
};
module.exports = exports['default'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.findScrollParents = findScrollParents;
exports.isDescendant = isDescendant;
exports.findAncestor = findAncestor;
exports.filterByFocusable = filterByFocusable;
exports.getBestFirstFocusable = getBestFirstFocusable;
exports.isFormElement = isFormElement;
exports.generateId = generateId;
exports.generateUUID = generateUUID;
exports.checkDarkBackground = checkDarkBackground;
exports.findVisibleParent = findVisibleParent;
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var COLOR_RGB_REGEXP = /rgb\((\d+), (\d+), (\d+)\)/;
var COLOR_RGBA_REGEXP = /rgba\((\d+), (\d+), (\d+), ([\d\.]+)\)/;
var LIGHT_HINT_REGEXP = /^light/;

function hash(input) {
  var hash = 0,
      i,
      chr,
      len;
  if (input.length === 0) return hash;
  for (i = 0, len = input.length; i < len; i++) {
    chr = input.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

function findScrollParents(element, horizontal) {
  var result = [];
  var parent = element.parentNode;
  while (parent && parent.getBoundingClientRect) {
    var rect = parent.getBoundingClientRect();
    // 10px is to account for borders and scrollbars in a lazy way
    if (horizontal) {
      if (rect.width && parent.scrollWidth > rect.width + 10) {
        result.push(parent);
      }
    } else {
      if (rect.height && parent.scrollHeight > rect.height + 10) {
        result.push(parent);
      }
    }
    parent = parent.parentNode;
  }
  // last scrollable element will be the document
  // if nothing else is scrollable in the page
  if (result.length === 0) {
    result.push(document);
  }
  return result;
}

function isDescendant(parent, child) {
  var node = child.parentNode;
  while (node != null) {
    if (node == parent) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}

function findAncestor(element, className) {
  var node = element.parentNode;
  while (node != null) {
    if (node.classList && node.classList.contains(className)) {
      break;
    }
    node = node.parentNode;
  }
  return node;
}

function filterByFocusable(elements) {
  return Array.prototype.filter.call(elements || [], function (element) {
    var currentTag = element.tagName.toLowerCase();
    var validTags = /(svg|a|area|input|select|textarea|button|iframe|div)$/;
    var isValidTag = currentTag.match(validTags) && element.focus;

    if (currentTag === 'a') {
      return isValidTag && element.childNodes.length > 0 && element.getAttribute('href');
    } else if (currentTag === 'svg' || currentTag === 'div') {
      return isValidTag && element.hasAttribute('tabindex');
    }

    return isValidTag;
  });
}

function getBestFirstFocusable(elements) {
  var bestFirstFocusable;

  Array.prototype.some.call(elements || [], function (element) {
    var currentTag = element.tagName.toLowerCase();
    var isValidTag = currentTag.match(/(input|select|textarea)$/);
    return isValidTag ? (bestFirstFocusable = element, true) : false;
  });

  if (!bestFirstFocusable) {
    bestFirstFocusable = this.filterByFocusable(elements)[0];
  }

  return bestFirstFocusable;
}

function isFormElement(element) {
  var elementType = element ? element.tagName.toLowerCase() : undefined;
  return elementType && (elementType === 'input' || elementType === 'textarea');
}

function generateId(element) {
  if (element && typeof element.getAttribute === 'function') {
    var id = void 0;
    var elementId = element.getAttribute('id');
    if (!elementId) {
      // IE11 fix: check for parentNode instead of parentElement
      var parentElement = element.parentElement || element.parentNode;
      if (parentElement) {
        id = hash(parentElement.innerHTML);
        element.setAttribute('id', id);
      }
    } else {
      id = elementId;
    }
    return id;
  }
}

function generateUUID() {
  function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  }
  var uuid = '' + S4() + S4() + ('-' + S4() + '-4' + S4().substr(0, 3)) + ('-' + S4() + '-' + S4() + S4() + S4()).toLowerCase();
  return uuid;
}

var CHECK_DARK_BACKGROUND_BACKOFFS = [0, 20, 80, 200];

function hasDarkBackground(element) {
  var result = false;
  var color = window.getComputedStyle(element).backgroundColor;
  var match = color.match(COLOR_RGB_REGEXP) || color.match(COLOR_RGBA_REGEXP);
  if (match) {
    var _match$slice$map = match.slice(1).map(function (n) {
      return parseInt(n, 10);
    }),
        _match$slice$map2 = _slicedToArray(_match$slice$map, 3),
        red = _match$slice$map2[0],
        green = _match$slice$map2[1],
        blue = _match$slice$map2[2];
    // http://www.had2know.com/technology/
    //  color-contrast-calculator-web-design.html


    var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
    if (0 === brightness) {
      // Browsers return 0,0,0 when they don't know yet.
      result = undefined;
      // changed threshold below to accomodate the Aruba theme for now
    } else if (brightness < 137) {
      ///125) {
      result = true;
    }
  }
  return result;
}

function checkDarkBackgroundBackoff(element, handler, backoffDurations) {
  return setTimeout(function () {
    var dark = hasDarkBackground(element);
    if (undefined === dark && backoffDurations.length > 0) {
      checkDarkBackgroundBackoff(element, handler, backoffDurations);
    } else {
      handler(dark);
    }
  }, backoffDurations.shift());
}

function checkDarkBackground(colorIndex, element, handler) {
  var timer = void 0;
  if (colorIndex) {
    if ('dark' === colorIndex) {
      // caller knows
      handler(true);
    } else if (LIGHT_HINT_REGEXP.test(colorIndex)) {
      // skip if this is a 'light-*' color index
      handler(false);
    } else {
      // Measure the actual background color brightness to determine whether
      // to set a dark or light context.
      if (element && window.getComputedStyle) {
        timer = checkDarkBackgroundBackoff(element, handler, CHECK_DARK_BACKGROUND_BACKOFFS);
      }
    }
  }
  return { stop: function stop() {
      return clearTimeout(timer);
    } };
}

function findVisibleParent(element) {
  if (element) {
    return element.offsetParent ? element : findVisibleParent(element.parentElement);
  } else {
    return null;
  }
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TABS;

var Tabs = function (_Component) {
  _inherits(Tabs, _Component);

  function Tabs(props, context) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props, context));

    _this._activateTab = _this._activateTab.bind(_this);

    _this.state = {
      activeIndex: props.activeIndex || 0,
      justify: props.justify
    };
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((nextProps.activeIndex || 0 === nextProps.activeIndex) && this.state.activeIndex !== nextProps.activeIndex) {
        this.setState({ activeIndex: nextProps.activeIndex });
      }
    }
  }, {
    key: '_activateTab',
    value: function _activateTab(index) {
      if (!this.props.hasOwnProperty('activeIndex')) {
        this.setState({ activeIndex: index });
      }
      if (this.props.onActive) {
        this.props.onActive(index);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          justify = _props.justify,
          responsive = _props.responsive,
          props = _objectWithoutProperties(_props, ['children', 'className', 'justify', 'responsive']);

      delete props.activeIndex;
      delete props.onActive;
      var activeIndex = this.state.activeIndex;
      var intl = this.context.intl;

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--justify-' + justify, justify), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _classnames), className);

      var activeContainer = void 0;
      var activeTitle = void 0;
      var tabs = _react2.default.Children.map(children, function (tab, index) {
        if (!tab) return null;

        var tabProps = tab.props || tab._store.props || {};

        var isTabActive = index === activeIndex;

        if (isTabActive) {
          activeContainer = tabProps.children;
          activeTitle = tabProps.title;
        }

        return _react2.default.cloneElement(tab, {
          active: isTabActive,
          id: 'tab-' + index,
          onRequestForActive: function onRequestForActive() {
            _this2._activateTab(index);
          }
        });
      }, this);

      var tabContentTitle = _Intl2.default.getMessage(intl, 'Tab Contents', {
        activeTitle: activeTitle
      });

      return _react2.default.createElement(
        'div',
        { role: 'tablist' },
        _react2.default.createElement(
          'ul',
          _extends({}, props, { className: classes }),
          tabs
        ),
        _react2.default.createElement(
          'div',
          { 'aria-label': tabContentTitle, role: 'tabpanel' },
          activeContainer
        )
      );
    }
  }]);

  return Tabs;
}(_react.Component);

Tabs.displayName = 'Tabs';
exports.default = Tabs;


Tabs.propTypes = {
  activeIndex: _propTypes2.default.number,
  justify: _propTypes2.default.oneOf(['start', 'center', 'end']),
  responsive: _propTypes2.default.bool,
  onActive: _propTypes2.default.func
};

Tabs.contextTypes = {
  intl: _propTypes2.default.object
};

Tabs.defaultProps = {
  justify: 'center',
  responsive: true
};
module.exports = exports['default'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TAB;

var Tab = function (_Component) {
  _inherits(Tab, _Component);

  function Tab() {
    _classCallCheck(this, Tab);

    var _this = _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).call(this));

    _this._onClickTab = _this._onClickTab.bind(_this);
    return _this;
  }

  _createClass(Tab, [{
    key: '_onClickTab',
    value: function _onClickTab(event) {
      var onRequestForActive = this.props.onRequestForActive;

      if (event) {
        event.preventDefault();
      }
      onRequestForActive();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          id = _props.id,
          title = _props.title,
          props = _objectWithoutProperties(_props, ['active', 'className', 'id', 'title']);

      delete props.onRequestForActive;
      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--active', active), className);

      return _react2.default.createElement(
        'li',
        _extends({}, props, { className: classes, id: id }),
        _react2.default.createElement(
          _Button2.default,
          { className: CLASS_ROOT + '__button', plain: true,
            role: 'tab', 'aria-selected': active,
            onClick: this._onClickTab, 'aria-expanded': active },
          _react2.default.createElement(
            'label',
            { className: CLASS_ROOT + '__label', htmlFor: id },
            title
          )
        )
      );
    }
  }]);

  return Tab;
}(_react.Component);

Tab.displayName = 'Tab';
exports.default = Tab;


Tab.propTypes = {
  title: _propTypes2.default.node.isRequired,
  active: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  onRequestForActive: _propTypes2.default.func // from Tabs
};
module.exports = exports['default'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://dev.w3.org/csswg/css-color/

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HEX3 = /^#([a-f0-9]{3})$/i;
var hex3 = function hex3(value) {
    var match = value.match(HEX3);
    if (match) {
        return [parseInt(match[1][0] + match[1][0], 16), parseInt(match[1][1] + match[1][1], 16), parseInt(match[1][2] + match[1][2], 16), null];
    }
    return false;
};

var HEX6 = /^#([a-f0-9]{6})$/i;
var hex6 = function hex6(value) {
    var match = value.match(HEX6);
    if (match) {
        return [parseInt(match[1].substring(0, 2), 16), parseInt(match[1].substring(2, 4), 16), parseInt(match[1].substring(4, 6), 16), null];
    }
    return false;
};

var RGB = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgb = function rgb(value) {
    var match = value.match(RGB);
    if (match) {
        return [Number(match[1]), Number(match[2]), Number(match[3]), null];
    }
    return false;
};

var RGBA = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;
var rgba = function rgba(value) {
    var match = value.match(RGBA);
    if (match && match.length > 4) {
        return [Number(match[1]), Number(match[2]), Number(match[3]), Number(match[4])];
    }
    return false;
};

var fromArray = function fromArray(array) {
    return [Math.min(array[0], 255), Math.min(array[1], 255), Math.min(array[2], 255), array.length > 3 ? array[3] : null];
};

var namedColor = function namedColor(name) {
    var color = NAMED_COLORS[name.toLowerCase()];
    return color ? color : false;
};

var Color = function () {
    function Color(value) {
        _classCallCheck(this, Color);

        var _ref = Array.isArray(value) ? fromArray(value) : hex3(value) || rgb(value) || rgba(value) || namedColor(value) || hex6(value) || [0, 0, 0, null],
            _ref2 = _slicedToArray(_ref, 4),
            r = _ref2[0],
            g = _ref2[1],
            b = _ref2[2],
            a = _ref2[3];

        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }

    _createClass(Color, [{
        key: 'isTransparent',
        value: function isTransparent() {
            return this.a === 0;
        }
    }, {
        key: 'toString',
        value: function toString() {
            return this.a !== null && this.a !== 1 ? 'rgba(' + this.r + ',' + this.g + ',' + this.b + ',' + this.a + ')' : 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
        }
    }]);

    return Color;
}();

exports.default = Color;


var NAMED_COLORS = {
    transparent: [0, 0, 0, 0],
    aliceblue: [240, 248, 255, null],
    antiquewhite: [250, 235, 215, null],
    aqua: [0, 255, 255, null],
    aquamarine: [127, 255, 212, null],
    azure: [240, 255, 255, null],
    beige: [245, 245, 220, null],
    bisque: [255, 228, 196, null],
    black: [0, 0, 0, null],
    blanchedalmond: [255, 235, 205, null],
    blue: [0, 0, 255, null],
    blueviolet: [138, 43, 226, null],
    brown: [165, 42, 42, null],
    burlywood: [222, 184, 135, null],
    cadetblue: [95, 158, 160, null],
    chartreuse: [127, 255, 0, null],
    chocolate: [210, 105, 30, null],
    coral: [255, 127, 80, null],
    cornflowerblue: [100, 149, 237, null],
    cornsilk: [255, 248, 220, null],
    crimson: [220, 20, 60, null],
    cyan: [0, 255, 255, null],
    darkblue: [0, 0, 139, null],
    darkcyan: [0, 139, 139, null],
    darkgoldenrod: [184, 134, 11, null],
    darkgray: [169, 169, 169, null],
    darkgreen: [0, 100, 0, null],
    darkgrey: [169, 169, 169, null],
    darkkhaki: [189, 183, 107, null],
    darkmagenta: [139, 0, 139, null],
    darkolivegreen: [85, 107, 47, null],
    darkorange: [255, 140, 0, null],
    darkorchid: [153, 50, 204, null],
    darkred: [139, 0, 0, null],
    darksalmon: [233, 150, 122, null],
    darkseagreen: [143, 188, 143, null],
    darkslateblue: [72, 61, 139, null],
    darkslategray: [47, 79, 79, null],
    darkslategrey: [47, 79, 79, null],
    darkturquoise: [0, 206, 209, null],
    darkviolet: [148, 0, 211, null],
    deeppink: [255, 20, 147, null],
    deepskyblue: [0, 191, 255, null],
    dimgray: [105, 105, 105, null],
    dimgrey: [105, 105, 105, null],
    dodgerblue: [30, 144, 255, null],
    firebrick: [178, 34, 34, null],
    floralwhite: [255, 250, 240, null],
    forestgreen: [34, 139, 34, null],
    fuchsia: [255, 0, 255, null],
    gainsboro: [220, 220, 220, null],
    ghostwhite: [248, 248, 255, null],
    gold: [255, 215, 0, null],
    goldenrod: [218, 165, 32, null],
    gray: [128, 128, 128, null],
    green: [0, 128, 0, null],
    greenyellow: [173, 255, 47, null],
    grey: [128, 128, 128, null],
    honeydew: [240, 255, 240, null],
    hotpink: [255, 105, 180, null],
    indianred: [205, 92, 92, null],
    indigo: [75, 0, 130, null],
    ivory: [255, 255, 240, null],
    khaki: [240, 230, 140, null],
    lavender: [230, 230, 250, null],
    lavenderblush: [255, 240, 245, null],
    lawngreen: [124, 252, 0, null],
    lemonchiffon: [255, 250, 205, null],
    lightblue: [173, 216, 230, null],
    lightcoral: [240, 128, 128, null],
    lightcyan: [224, 255, 255, null],
    lightgoldenrodyellow: [250, 250, 210, null],
    lightgray: [211, 211, 211, null],
    lightgreen: [144, 238, 144, null],
    lightgrey: [211, 211, 211, null],
    lightpink: [255, 182, 193, null],
    lightsalmon: [255, 160, 122, null],
    lightseagreen: [32, 178, 170, null],
    lightskyblue: [135, 206, 250, null],
    lightslategray: [119, 136, 153, null],
    lightslategrey: [119, 136, 153, null],
    lightsteelblue: [176, 196, 222, null],
    lightyellow: [255, 255, 224, null],
    lime: [0, 255, 0, null],
    limegreen: [50, 205, 50, null],
    linen: [250, 240, 230, null],
    magenta: [255, 0, 255, null],
    maroon: [128, 0, 0, null],
    mediumaquamarine: [102, 205, 170, null],
    mediumblue: [0, 0, 205, null],
    mediumorchid: [186, 85, 211, null],
    mediumpurple: [147, 112, 219, null],
    mediumseagreen: [60, 179, 113, null],
    mediumslateblue: [123, 104, 238, null],
    mediumspringgreen: [0, 250, 154, null],
    mediumturquoise: [72, 209, 204, null],
    mediumvioletred: [199, 21, 133, null],
    midnightblue: [25, 25, 112, null],
    mintcream: [245, 255, 250, null],
    mistyrose: [255, 228, 225, null],
    moccasin: [255, 228, 181, null],
    navajowhite: [255, 222, 173, null],
    navy: [0, 0, 128, null],
    oldlace: [253, 245, 230, null],
    olive: [128, 128, 0, null],
    olivedrab: [107, 142, 35, null],
    orange: [255, 165, 0, null],
    orangered: [255, 69, 0, null],
    orchid: [218, 112, 214, null],
    palegoldenrod: [238, 232, 170, null],
    palegreen: [152, 251, 152, null],
    paleturquoise: [175, 238, 238, null],
    palevioletred: [219, 112, 147, null],
    papayawhip: [255, 239, 213, null],
    peachpuff: [255, 218, 185, null],
    peru: [205, 133, 63, null],
    pink: [255, 192, 203, null],
    plum: [221, 160, 221, null],
    powderblue: [176, 224, 230, null],
    purple: [128, 0, 128, null],
    rebeccapurple: [102, 51, 153, null],
    red: [255, 0, 0, null],
    rosybrown: [188, 143, 143, null],
    royalblue: [65, 105, 225, null],
    saddlebrown: [139, 69, 19, null],
    salmon: [250, 128, 114, null],
    sandybrown: [244, 164, 96, null],
    seagreen: [46, 139, 87, null],
    seashell: [255, 245, 238, null],
    sienna: [160, 82, 45, null],
    silver: [192, 192, 192, null],
    skyblue: [135, 206, 235, null],
    slateblue: [106, 90, 205, null],
    slategray: [112, 128, 144, null],
    slategrey: [112, 128, 144, null],
    snow: [255, 250, 250, null],
    springgreen: [0, 255, 127, null],
    steelblue: [70, 130, 180, null],
    tan: [210, 180, 140, null],
    teal: [0, 128, 128, null],
    thistle: [216, 191, 216, null],
    tomato: [255, 99, 71, null],
    turquoise: [64, 224, 208, null],
    violet: [238, 130, 238, null],
    wheat: [245, 222, 179, null],
    white: [255, 255, 255, null],
    whitesmoke: [245, 245, 245, null],
    yellow: [255, 255, 0, null],
    yellowgreen: [154, 205, 50, null]
};

var TRANSPARENT = exports.TRANSPARENT = new Color([0, 0, 0, 0]);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _serviceUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _appUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _said; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _basename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _landingUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__ = __webpack_require__(20);
//ITG
// export const _serviceUrl = 'https://i2wg552788.it.hpe.com/Services/';
// export const _appUrl = 'https://i2wg552788.it.hpe.com/EPAvNextSizer/';
// export const _basename = '/EPAvNextSizer';
//Production
//export const _serviceUrl = 'https://solutionsizers.ext.hpe.com/Services/';
//export const _appUrl = 'https://solutionsizers.ext.hpe.com/EPASizer/';
//export const _basename = '/EPASizer';
// export const _serviceUrl = 'http://192.168.43.245:89/Services/';
var _baseUrl=window.location.protocol+'//'+window.location.host;var _serviceUrl=_baseUrl+'/Services/';var _appUrl=void 0;var isHPECP=false;if(window.location.href.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_52" /* HPECP_SIZER */].toUpperCase())>-1){isHPECP=true;_appUrl=_baseUrl+'/EzmeralCPSizer/';}else{_appUrl=_baseUrl+'/EPASizer/';}var _version='20.8.0';var _said='EPAvNext';var _title='HPE Sizing Tool for the Elastic Platform for Analytics (EPA)';var _basename='/EPASizer';if(isHPECP){_basename='/EzmeralCPSizer';_title='HPE Sizing Tool for Ezmeral '+__WEBPACK_IMPORTED_MODULE_0__Redux_action_types_EPAConstants__["_145" /* RE */];}var _landingUrl='213190_SIZERS_PRO_HPE';

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-revert', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'revert');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,3 L3,8 L8,13 M12,20 L15,20 C18.3137085,20 21,17.3137085 21,14 C21,10.6862915 18.3137085,8 15,8 L4,8' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Revert';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactDesc = __webpack_require__(514);

var _reactRouter = __webpack_require__(518);

var _LinkNext = __webpack_require__(170);

var _LinkNext2 = _interopRequireDefault(_LinkNext);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.ANCHOR;

var Anchor = function (_Component) {
  _inherits(Anchor, _Component);

  function Anchor(props, context) {
    _classCallCheck(this, Anchor);

    var _this = _possibleConstructorReturn(this, (Anchor.__proto__ || Object.getPrototypeOf(Anchor)).call(this, props, context));

    _this._onClick = _this._onClick.bind(_this);
    _this._onLocationChange = _this._onLocationChange.bind(_this);
    _this._attachUnlisten = _this._attachUnlisten.bind(_this);
    _this._isRouteActive = _this._isRouteActive.bind(_this);
    var path = props.path;
    var router = context.router;


    var active = _this._isRouteActive(path, router);

    _this.state = { active: active };
    return _this;
  }

  _createClass(Anchor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var path = this.props.path;
      var router = this.context.router;


      if (path) {
        this._attachUnlisten(router.history || router);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var path = nextProps.path;
      var router = this.context.router;


      if (path && path !== this.props.path) {
        this._attachUnlisten(router.history || router);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var path = this.props.path;

      if (path) {
        this._unlisten();
      }
      this._unmounted = true;
    }
  }, {
    key: '_isRouteActive',
    value: function _isRouteActive(path, router) {
      if (!path) {
        return false;
      }
      var active = void 0;
      if (router && router.isActive) {
        active = router && router.isActive && path && router.isActive({
          pathname: path.path || path,
          query: { indexLink: path.index }
        });
      } else if (router && _reactRouter.matchPath) {
        active = !!(0, _reactRouter.matchPath)(router.history.location.pathname, { path: path.path || path, exact: !!path.index });
      }

      return active;
    }
  }, {
    key: '_attachUnlisten',
    value: function _attachUnlisten(router) {
      this._unlisten = router.listen(this._onLocationChange);
    }
  }, {
    key: '_onLocationChange',
    value: function _onLocationChange(location) {
      // sometimes react router is still calling the listen callback even
      // if we called unlisten. So we added this check here to prevent
      // calling setState in a unmounted component
      if (!this._unmounted) {
        var path = this.props.path;
        var router = this.context.router;

        var active = _reactRouter.matchPath ? !!(0, _reactRouter.matchPath)(location.pathname, { path: path.path || path, exact: !!path.index }) : router && location.pathname === (path.path || path);
        this.setState({ active: active });
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(event) {
      var _props = this.props,
          method = _props.method,
          onClick = _props.onClick,
          path = _props.path,
          disabled = _props.disabled;
      var router = this.context.router;

      var modifierKey = event.ctrlKey || event.metaKey;

      if (modifierKey && !disabled && !onClick) {
        return true;
      }

      event.preventDefault();

      if (!disabled) {
        if (path) {
          if ('push' === method) {
            (router.history || router).push(path.path || path);
          } else if ('replace' === method) {
            (router.history || router).replace(path.path || path);
          }
        }

        if (onClick) {
          onClick.apply(undefined, arguments);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          align = _props2.align,
          animateIcon = _props2.animateIcon,
          children = _props2.children,
          className = _props2.className,
          disabled = _props2.disabled,
          href = _props2.href,
          icon = _props2.icon,
          label = _props2.label,
          onClick = _props2.onClick,
          path = _props2.path,
          primary = _props2.primary,
          reverse = _props2.reverse,
          tag = _props2.tag,
          props = _objectWithoutProperties(_props2, ['a11yTitle', 'align', 'animateIcon', 'children', 'className', 'disabled', 'href', 'icon', 'label', 'onClick', 'path', 'primary', 'reverse', 'tag']);

      delete props.method;
      var active = this.state.active;
      var router = this.context.router;


      var anchorIcon = void 0;
      if (icon) {
        anchorIcon = icon;
      } else if (primary) {
        anchorIcon = _react2.default.createElement(_LinkNext2.default, { a11yTitle: 'link next' });
      }

      if (anchorIcon && !primary && !label) {
        anchorIcon = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__icon' },
          anchorIcon
        );
      }

      var hasIcon = anchorIcon !== undefined;
      var anchorChildren = _react.Children.map(children, function (child) {
        if (child && child.type && child.type.icon) {
          hasIcon = true;
          child = _react2.default.createElement(
            'span',
            { className: CLASS_ROOT + '__icon' },
            child
          );
        }
        return child;
      });

      var target = path ? path.path || path : undefined;
      var adjustedHref = void 0;
      if (router && router.createPath) {
        adjustedHref = path && router ? router.createPath(target) : href;
      } else {
        adjustedHref = path && router && router.history ? router.history.createHref(typeof target === 'string' ? { pathname: target } : target) : href;
      }

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--animate-icon', hasIcon && animateIcon !== false), _defineProperty(_classnames, CLASS_ROOT + '--disabled', disabled), _defineProperty(_classnames, CLASS_ROOT + '--icon', anchorIcon || hasIcon), _defineProperty(_classnames, CLASS_ROOT + '--icon-label', hasIcon && label), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames, CLASS_ROOT + '--reverse', reverse), _defineProperty(_classnames, CLASS_ROOT + '--active', active), _classnames), className);

      var adjustedOnClick = path && router ? this._onClick : onClick;
      if (!anchorChildren) {
        anchorChildren = label;
      }

      var first = reverse ? anchorChildren : anchorIcon;
      var second = reverse ? anchorIcon : anchorChildren;

      var Component = tag;

      return _react2.default.createElement(
        Component,
        _extends({}, props, { href: adjustedHref, className: classes,
          'aria-label': a11yTitle, onClick: function onClick(event) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              args[_key - 1] = arguments[_key];
            }

            if (disabled) {
              event.preventDefault();
            } else if (adjustedOnClick) {
              adjustedOnClick.apply(undefined, [event].concat(args));
            }
          } }),
        first,
        second
      );
    }
  }]);

  return Anchor;
}(_react.Component);

Anchor.displayName = 'Anchor';
exports.default = Anchor;
;

(0, _reactDesc.schema)(Anchor, {
  description: 'A text link. We have a separate component from the browser\n  base so we can style it. You can either set the icon and/or label properties\n  or just use children.',
  usage: 'import Anchor from \'grommet/components/Anchor\';\n  <Anchor href={location} label="Label" />',
  props: {
    a11yTitle: [_reactDesc.PropTypes.string, 'Accessibility title.'],
    align: [_reactDesc.PropTypes.oneOf(['start', 'center', 'end']), 'Text alignment.'],
    animateIcon: [_reactDesc.PropTypes.bool, 'Whether to animate the icon on hover.', {
      defaultProp: true
    }],
    disabled: [_reactDesc.PropTypes.bool, 'Whether to disable the anchor.'],
    href: [_reactDesc.PropTypes.string, 'Hyperlink reference to place in the anchor. If' + ' `path` prop is provided, `href` prop will be ignored.'],
    icon: [_reactDesc.PropTypes.element, 'Icon element to place in the anchor.'],
    id: [_reactDesc.PropTypes.string, 'Anchor identifier.'],
    label: [_reactDesc.PropTypes.node, 'Label text to place in the anchor.'],
    method: [_reactDesc.PropTypes.oneOf(['push', 'replace']), 'Valid only when used with path. Indicates whether the browser history' + ' should be appended to or replaced.', {
      defaultProp: 'push'
    }],
    onClick: [_reactDesc.PropTypes.func, 'Click handler.'],
    path: [_reactDesc.PropTypes.oneOfType([_reactDesc.PropTypes.object, _reactDesc.PropTypes.string]), 'React-router path to navigate to when clicked.' + ' Use path={{ path: \'/\', index: true }} if you want the Anchor to be' + ' active only when the index route is current.'],
    primary: [_reactDesc.PropTypes.bool, 'Whether this is a primary anchor.'],
    reverse: [_reactDesc.PropTypes.bool, 'Whether an icon and label should be reversed so that the icon is at ' + 'the end of the anchor.'],
    tag: [_reactDesc.PropTypes.string, 'The DOM tag to use for the element. The default is <a>. This should be' + ' used in conjunction with components like Link from React Router. In' + ' this case, Link controls the navigation while Anchor controls the' + ' styling.', {
      defaultProp: 'a'
    }],
    target: [_reactDesc.PropTypes.string, 'Target of the link.']
  }
});

Anchor.contextTypes = {
  router: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _DOM = __webpack_require__(59);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _Scroll = __webpack_require__(277);

var _Scroll2 = _interopRequireDefault(_Scroll);

var _Responsive = __webpack_require__(78);

var _Responsive2 = _interopRequireDefault(_Responsive);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _LinkNext = __webpack_require__(170);

var _LinkNext2 = _interopRequireDefault(_LinkNext);

var _LinkPrevious = __webpack_require__(278);

var _LinkPrevious2 = _interopRequireDefault(_LinkPrevious);

var _Up = __webpack_require__(536);

var _Up2 = _interopRequireDefault(_Up);

var _Down = __webpack_require__(265);

var _Down2 = _interopRequireDefault(_Down);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.ARTICLE;
var DEFAULT_PLAY_INTERVAL = 10000; // 10s

var Article = function (_Component) {
  _inherits(Article, _Component);

  function Article(props, context) {
    _classCallCheck(this, Article);

    var _this = _possibleConstructorReturn(this, (Article.__proto__ || Object.getPrototypeOf(Article)).call(this, props, context));

    _this._onScroll = _this._onScroll.bind(_this);
    _this._onWheel = _this._onWheel.bind(_this);
    _this._onTouchStart = _this._onTouchStart.bind(_this);
    _this._onTouchMove = _this._onTouchMove.bind(_this);
    _this._onResize = _this._onResize.bind(_this);
    _this._onNext = _this._onNext.bind(_this);
    _this._onPrevious = _this._onPrevious.bind(_this);
    _this._onTogglePlay = _this._onTogglePlay.bind(_this);
    _this._onSelect = _this._onSelect.bind(_this);
    _this._checkControls = _this._checkControls.bind(_this);
    _this._checkPreviousNextControls = _this._checkPreviousNextControls.bind(_this);
    _this._onResponsive = _this._onResponsive.bind(_this);
    _this._updateHiddenElements = _this._updateHiddenElements.bind(_this);
    _this._updateProgress = _this._updateProgress.bind(_this);

    // Necessary to detect for Firefox or Edge to implement accessibility
    // tabbing
    var accessibilityTabbingCompatible = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1 && navigator.userAgent.indexOf('Edge') === -1;

    _this.state = {
      selectedIndex: props.selected || 0,
      playing: false,
      accessibilityTabbingCompatible: accessibilityTabbingCompatible
    };
    return _this;
  }

  _createClass(Article, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._propsSetup(this.props);
      if (this.state.selectedIndex) {
        this._onSelect(this.state.selectedIndex);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.scrollStep && this.props.scrollStep) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keys);
        document.removeEventListener('wheel', this._onWheel);
        window.removeEventListener('resize', this._onResize);
      }
      if (!nextProps.onProgress && this.props.onProgress) {
        if (this._responsive) {
          this._responsive.stop();
        }
        if (this.props.onProgress) {
          window.removeEventListener('scroll', this._updateProgress);
        }
      }

      this._propsSetup(nextProps);

      // allow updates to selected props to trigger new chapter select
      if (typeof nextProps.selected !== 'undefined' && nextProps.selected !== null && nextProps.selected !== this.state.selectedIndex) {
        this._onSelect(nextProps.selected);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.scrollStep) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keys);
        document.removeEventListener('wheel', this._onWheel);
        window.removeEventListener('resize', this._onResize);
      }
      if (this._responsive) {
        this._responsive.stop();
      }
      if (this.props.onProgress) {
        window.removeEventListener('scroll', this._updateProgress);
      }
    }
  }, {
    key: '_propsSetup',
    value: function _propsSetup(props) {
      var direction = props.direction,
          full = props.full,
          onProgress = props.onProgress,
          scrollStep = props.scrollStep;

      if (scrollStep) {
        if (full) {
          console.warn('Article cannot use `scrollStep` with `full`.');
        }

        this._keys = { up: this._onPrevious, down: this._onNext };
        if ('row' === direction) {
          this._keys = {
            left: this._onPrevious,
            right: this._onNext
          };

          if (this.state.accessibilityTabbingCompatible) {
            this._updateHiddenElements();
          }
        }
        //keys.space = this._onTogglePlay;
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keys);

        document.addEventListener('wheel', this._onWheel);
        window.addEventListener('resize', this._onResize);

        this._checkControls();

        if ('row' === direction) {
          this._responsive = _Responsive2.default.start(this._onResponsive);
        }
      }

      if (onProgress) {
        window.addEventListener('scroll', this._updateProgress);

        if (direction === 'row') {
          this._responsive = _Responsive2.default.start(this._onResponsive);
        }
      }
    }
  }, {
    key: '_childDOMNode',
    value: function _childDOMNode(index) {
      var componentElement = (0, _reactDom.findDOMNode)(this._componentRef);
      return componentElement.children[index];
    }
  }, {
    key: '_checkPreviousNextControls',
    value: function _checkPreviousNextControls(currentScroll, nextProp, prevProp) {
      var selectedIndex = this.state.selectedIndex;

      if (currentScroll > 0) {
        var nextStepNode = this._childDOMNode(selectedIndex + 1);
        var previousStepNode = this._childDOMNode(selectedIndex - 1);

        if (nextStepNode) {
          var nextStepPosition = nextStepNode.getBoundingClientRect()[nextProp] * (selectedIndex + 1);

          if (currentScroll > nextStepPosition) {
            this.setState({ selectedIndex: selectedIndex + 1 });
          }
        }

        if (previousStepNode) {
          var previousStepPosition = previousStepNode.getBoundingClientRect()[prevProp] * selectedIndex;

          if (currentScroll < previousStepPosition) {
            this.setState({ selectedIndex: selectedIndex - 1 });
          }
        }
      }
    }
  }, {
    key: '_checkControls',
    value: function _checkControls() {
      var direction = this.props.direction;

      if (direction === 'row') {
        var currentScroll = this._componentRef.boxContainerRef.scrollLeft;
        this._checkPreviousNextControls(currentScroll, 'left', 'right');
      } else {
        var _currentScroll = this._componentRef.boxContainerRef.scrollTop;
        this._checkPreviousNextControls(_currentScroll, 'top', 'bottom');
      }
    }
  }, {
    key: '_visibleIndexes',
    value: function _visibleIndexes() {
      var _props = this.props,
          children = _props.children,
          direction = _props.direction;

      var result = [];
      var childCount = _react2.default.Children.count(children);
      var limit = 'row' === direction ? window.innerWidth : window.innerHeight;
      for (var index = 0; index < childCount; index += 1) {
        var childElement = this._childDOMNode(index);
        var rect = childElement.getBoundingClientRect();
        // ignore small drifts of 10 pixels on either end
        if ('row' === direction) {
          if (rect.right > 10 && rect.left < limit - 10) {
            result.push(index);
          } else if (result.length > 0) {
            break;
          }
        } else {
          if (rect.bottom > 10 && rect.top < limit - 10) {
            result.push(index);
          } else if (result.length > 0) {
            break;
          }
        }
      }
      return result;
    }
  }, {
    key: '_shortTimer',
    value: function _shortTimer(name, duration) {
      var _this2 = this;

      if (!this[name]) {
        this[name] = true;
      }
      var timerName = this[name] + 'Timer';
      clearTimeout(this[timerName]);
      this[timerName] = setTimeout(function () {
        _this2[name] = false;
      }, duration);
    }
  }, {
    key: '_onWheel',
    value: function _onWheel(event) {
      var _this3 = this;

      var direction = this.props.direction;

      if ('row' === direction) {
        if (this._scrollingHorizontally) {
          // no-op
        } else if (!this._scrollingVertically) {
          if (Math.abs(event.deltaY * 2) > Math.abs(event.deltaX)) {
            // user is scrolling vertically
            this._shortTimer('_scrollingVertically', 1000);
          }
        }
      } else {
        // Give the user lots of control.
        var delta = event.deltaY;
        if (Math.abs(delta) > 100) {
          // The user is expressing a resolute interest in controlling the
          // scrolling behavior. Stop doing any of our scroll step aligning
          // until he stops expressing such interest.
          clearInterval(this._wheelTimer);
          clearInterval(this._wheelLongTimer);
          this._wheelLongTimer = setTimeout(function () {
            _this3._wheelLongTimer = undefined;
          }, 2000);
        } else if (!this._wheelLongTimer) {
          if (delta > 10) {
            clearInterval(this._wheelTimer);
            this._wheelTimer = setTimeout(this._onNext, 200);
          } else if (delta < -10) {
            clearInterval(this._wheelTimer);
            this._wheelTimer = setTimeout(this._onPrevious, 200);
          } else {
            clearInterval(this._controlTimer);
            this._controlTimer = setTimeout(this._checkControls, 200);
          }
        }
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      var _this4 = this;

      var direction = this.props.direction;

      if ('row' === direction) {
        var selectedIndex = this.state.selectedIndex;

        var componentElement = (0, _reactDom.findDOMNode)(this._componentRef);
        var childElement = this._childDOMNode(selectedIndex);
        var rect = childElement.getBoundingClientRect();
        if (event.target === componentElement) {
          // scrolling Article
          if (this._scrollingVertically) {
            // prevent Article horizontal scrolling while scrolling vertically
            componentElement.scrollLeft += rect.left;
          } else {
            var scrollingRight = this._priorScrollLeft < componentElement.scrollLeft;
            // once we stop scrolling, align with child boundaries
            clearTimeout(this._scrollTimer);
            this._scrollTimer = setTimeout(function () {
              if (!_this4._resizing) {
                var indexes = _this4._visibleIndexes();
                if (indexes.length > 1 && scrollingRight) {
                  _this4._onSelect(indexes[1]);
                } else {
                  _this4._onSelect(indexes[0]);
                }
              }
            }, 100);
            this._priorScrollLeft = componentElement.scrollLeft;
          }
        } else if (event.target.parentNode === componentElement) {
          // scrolling child
          // Has it scrolled near the bottom?
          if (this.state.accessibilityTabbingCompatible) {
            // only use lastGrandChild logic if we're not using Firefox or IE.
            // causes flashing in Firefox, but required for Safari scrolling.
            var grandchildren = event.target.children;
            var lastGrandChild = grandchildren[grandchildren.length - 1];
            rect = lastGrandChild.getBoundingClientRect();
          }
          if (rect.bottom <= window.innerHeight + 24) {
            // at the bottom
            this.setState({ atBottom: true });
          } else {
            // not at the bottom
            this.setState({ atBottom: false });
          }
        }
      }
    }
  }, {
    key: '_onTouchStart',
    value: function _onTouchStart(event) {
      var touched = event.changedTouches[0];
      this._touchStartX = touched.clientX;
      this._touchStartY = touched.clientY;
    }
  }, {
    key: '_onTouchMove',
    value: function _onTouchMove(event) {
      var touched = event.changedTouches[0];
      var deltaX = touched.clientX - this._touchStartX;
      var deltaY = touched.clientY - this._touchStartY;
      // Only step if the user isn't scrolling vertically, bias vertically
      if (Math.abs(deltaY) < Math.abs(deltaX * 2)) {
        if (deltaX < 0) {
          this._onNext();
        } else {
          this._onPrevious();
        }
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var _this5 = this;

      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(function () {
        _this5._onSelect(_this5.state.selectedIndex);
        _this5._shortTimer('_resizing', 1000);
      }, 50);
    }
  }, {
    key: '_onNext',
    value: function _onNext(event, wrap) {
      // only process if the focus is NOT in a form element
      if (!(0, _DOM.isFormElement)(document.activeElement)) {
        var children = this.props.children;
        var selectedIndex = this.state.selectedIndex;

        var childCount = _react2.default.Children.count(children);
        if (event) {
          this._stop();
          event.preventDefault();
        }
        var targetIndex = this._visibleIndexes()[0] + 1;
        if (targetIndex !== selectedIndex) {
          if (targetIndex < childCount) {
            this._onSelect(Math.min(childCount - 1, targetIndex));
          } else if (wrap) {
            this._onSelect(1);
          }
        }
      }
    }
  }, {
    key: '_onPrevious',
    value: function _onPrevious(event) {
      // only process if the focus is NOT in a form element
      if (!(0, _DOM.isFormElement)(document.activeElement)) {
        var selectedIndex = this.state.selectedIndex;

        if (event) {
          this._stop();
          event.preventDefault();
        }
        var targetIndex = this._visibleIndexes()[0] - 1;
        if (targetIndex !== selectedIndex) {
          this._onSelect(Math.max(0, targetIndex));
        }
      }
    }
  }, {
    key: '_start',
    value: function _start() {
      var _this6 = this;

      this._playTimer = setInterval(function () {
        _this6._onNext(null, true);
      }, DEFAULT_PLAY_INTERVAL);
      this.setState({ playing: true });
    }
  }, {
    key: '_stop',
    value: function _stop() {
      clearInterval(this._playTimer);
      this.setState({ playing: false });
    }
  }, {
    key: '_onTogglePlay',
    value: function _onTogglePlay(event) {
      event.preventDefault();
      if (this.state.playing) {
        this._stop();
      } else {
        this._start();
      }
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(selectedIndex) {
      var _this7 = this;

      var _props2 = this.props,
          direction = _props2.direction,
          onSelect = _props2.onSelect;

      var componentElement = (0, _reactDom.findDOMNode)(this._componentRef);
      var childElement = this._childDOMNode(selectedIndex);
      var windowHeight = window.innerHeight + 24;

      if (childElement) {
        if (selectedIndex !== this.state.selectedIndex) {
          var parentElement = childElement.parentNode;
          var atBottom = Math.round(parentElement.scrollTop) >= parentElement.scrollHeight - parentElement.clientHeight;

          // scroll child to top
          childElement.scrollTop = 0;
          // ensures controls are displayed when selecting a new index and
          // scrollbar is at bottom of article
          this.setState({
            selectedIndex: selectedIndex,
            atBottom: atBottom
          }, function () {
            if (onSelect) {
              onSelect(selectedIndex);
            }

            // Necessary to detect for Firefox or Edge to implement accessibility
            // tabbing
            if (direction === 'row' && _this7.state.accessibilityTabbingCompatible) {
              _this7._anchorStepRef.focus();
              _this7._updateHiddenElements();
            }
          });
        } else if (childElement.scrollHeight <= windowHeight) {
          // on initial chapter load, ensure arrows are rendered
          // when there are no scrollbars
          this.setState({ atBottom: true });
        }

        var rect = childElement.getBoundingClientRect();
        if ('row' === direction) {
          if (rect.left !== 0) {
            this._scrollingHorizontally = true;
            _Scroll2.default.scrollBy(componentElement, 'scrollLeft', rect.left, function () {
              _this7._scrollingHorizontally = false;
            });
          }
        } else {
          if (rect.top !== 0) {
            this._scrollingVertically = true;
            _Scroll2.default.scrollBy(componentElement, 'scrollTop', rect.top, function () {
              _this7._scrollingVertically = false;
            });
          }
        }
      }
    }
  }, {
    key: '_onResponsive',
    value: function _onResponsive(small) {
      this.setState({ narrow: small });
    }
  }, {
    key: '_toggleDisableChapter',
    value: function _toggleDisableChapter(chapter, disabled) {
      var elements = (0, _DOM.filterByFocusable)(chapter.getElementsByTagName('*'));

      if (elements) {
        elements.forEach(function (element) {
          if (disabled) {
            element.setAttribute('disabled', 'disabled');
          } else {
            element.removeAttribute('disabled');
          }

          element.setAttribute('tabindex', disabled ? '-1' : '0');
        });
      }
    }
  }, {
    key: '_updateHiddenElements',
    value: function _updateHiddenElements() {
      var component = (0, _reactDom.findDOMNode)(this._componentRef);
      var children = component.children;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (child.getAttribute('aria-hidden')) {
          this._toggleDisableChapter(child, true);
        } else {
          this._toggleDisableChapter(child, false);
        }
      }
    }
  }, {
    key: '_updateProgress',
    value: function _updateProgress(event) {
      var _props3 = this.props,
          direction = _props3.direction,
          responsive = _props3.responsive;
      var narrow = this.state.narrow;

      var article = (0, _reactDom.findDOMNode)(this._componentRef);
      var articleRect = article.getBoundingClientRect();

      var offset = direction === 'column' ? Math.abs(articleRect.top) : Math.abs(articleRect.left);
      var totalDistance = direction === 'column' ? window.innerHeight : this._getChildrenWidth(this._componentRef.boxContainerRef.childNodes);
      var objectDistance = direction === 'column' ? articleRect.height : articleRect.width;

      // Covers row responding to column layout.
      if (direction === 'row' && narrow && responsive !== false) {
        offset = Math.abs(articleRect.top);
        totalDistance = window.innerHeight;
        objectDistance = articleRect.height;
      }

      var progress = Math.abs(offset / (objectDistance - totalDistance));
      var scrollPercentRounded = Math.round(progress * 100);
      this.props.onProgress(scrollPercentRounded);
    }
  }, {
    key: '_renderControls',
    value: function _renderControls() {
      var direction = this.props.direction;
      var _state = this.state,
          atBottom = _state.atBottom,
          narrow = _state.narrow,
          selectedIndex = _state.selectedIndex;

      var CONTROL_CLASS_PREFIX = CLASS_ROOT + '__control ' + CLASS_ROOT + '__control';
      var childCount = _react2.default.Children.count(this.props.children);
      var controls = [];

      var a11yTitle = this.props.a11yTitle || {};
      if ('row' === direction) {
        if (!narrow || atBottom) {
          if (selectedIndex > 0) {
            controls.push(_react2.default.createElement(_Button2.default, { key: 'previous',
              plain: true, a11yTitle: a11yTitle.previous,
              className: CONTROL_CLASS_PREFIX + '-left',
              onClick: this._onPrevious, icon: _react2.default.createElement(_LinkPrevious2.default, {
                a11yTitle: 'article-previous-title', size: 'large' }) }));
          }
          if (selectedIndex < childCount - 1) {
            controls.push(_react2.default.createElement(_Button2.default, { key: 'next',
              plain: true, a11yTitle: a11yTitle.next,
              className: CONTROL_CLASS_PREFIX + '-right',
              onClick: this._onNext, icon: _react2.default.createElement(_LinkNext2.default, {
                size: 'large', a11yTitle: 'article-next-title' }) }));
          }
        }
      } else {
        if (selectedIndex > 0) {
          controls.push(_react2.default.createElement(
            _Button2.default,
            { key: 'previous',
              plain: true, a11yTitle: a11yTitle.previous,
              className: CONTROL_CLASS_PREFIX + '-up',
              onClick: this._onPrevious },
            _react2.default.createElement(_Up2.default, null)
          ));
        }
        if (selectedIndex < childCount - 1) {
          controls.push(_react2.default.createElement(
            _Button2.default,
            { key: 'next', plain: true, a11yTitle: a11yTitle.next,
              className: CONTROL_CLASS_PREFIX + '-down', onClick: this._onNext },
            _react2.default.createElement(_Down2.default, { a11yTitle: 'article-down' })
          ));
        }
      }

      return controls;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props4 = this.props,
          className = _props4.className,
          primary = _props4.primary,
          scrollStep = _props4.scrollStep;
      var selectedIndex = this.state.selectedIndex;

      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--scroll-step', scrollStep), className);

      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
      var restProps = _Props2.default.omit(this.props, Object.keys(Article.propTypes));

      var controls = void 0;
      if (this.props.controls) {
        controls = this._renderControls();
      }

      var anchorStepNode = void 0;
      if (this.state.accessibilityTabbingCompatible) {
        anchorStepNode = _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true',
          ref: function ref(_ref) {
            return _this8._anchorStepRef = _ref;
          } });
      }

      var children = this.props.children;
      if (scrollStep || controls) {
        children = _react.Children.map(this.props.children, function (element, index) {
          if (element) {

            if (controls) {
              var ariaHidden = void 0;
              if (selectedIndex !== index && _this8.state.accessibilityTabbingCompatible) {
                ariaHidden = 'true';
              }

              element = _react2.default.createElement(
                'div',
                { 'aria-hidden': ariaHidden },
                element
              );
            }

            return element;
          }

          return undefined;
        }, this);
      }

      delete boxProps.a11yTitle;

      return _react2.default.createElement(
        _Box2.default,
        _extends({}, restProps, boxProps, { ref: function ref(_ref2) {
            return _this8._componentRef = _ref2;
          },
          tag: 'article', className: classes, primary: primary,
          onScroll: this._onScroll, onTouchStart: this._onTouchStart,
          onTouchMove: this._onTouchMove }),
        children,
        controls,
        anchorStepNode
      );
    }
  }]);

  return Article;
}(_react.Component);

Article.displayName = 'Article';
exports.default = Article;


Article.propTypes = _extends({
  controls: _propTypes2.default.bool
}, _Box2.default.propTypes, {
  a11yTitle: _propTypes2.default.shape({
    next: _propTypes2.default.string,
    previous: _propTypes2.default.string
  }),
  onProgress: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  scrollStep: _propTypes2.default.bool,
  selected: _propTypes2.default.number
});

Article.defaultProps = {
  pad: 'none',
  direction: 'column'
};
module.exports = exports['default'];

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(290);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = Object.create(__webpack_require__(104));
util.inherits = __webpack_require__(83);
/*</replacement>*/

var Readable = __webpack_require__(315);
var Writable = __webpack_require__(197);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calculateLengthFromValueWithUnit = exports.LENGTH_TYPE = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NodeContainer = __webpack_require__(84);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LENGTH_WITH_UNIT = /([\d.]+)(px|r?em|%)/i;

var LENGTH_TYPE = exports.LENGTH_TYPE = {
    PX: 0,
    PERCENTAGE: 1
};

var Length = function () {
    function Length(value) {
        _classCallCheck(this, Length);

        this.type = value.substr(value.length - 1) === '%' ? LENGTH_TYPE.PERCENTAGE : LENGTH_TYPE.PX;
        var parsedValue = parseFloat(value);
        if (false) {
            console.error('Invalid value given for Length: "' + value + '"');
        }
        this.value = isNaN(parsedValue) ? 0 : parsedValue;
    }

    _createClass(Length, [{
        key: 'isPercentage',
        value: function isPercentage() {
            return this.type === LENGTH_TYPE.PERCENTAGE;
        }
    }, {
        key: 'getAbsoluteValue',
        value: function getAbsoluteValue(parentLength) {
            return this.isPercentage() ? parentLength * (this.value / 100) : this.value;
        }
    }], [{
        key: 'create',
        value: function create(v) {
            return new Length(v);
        }
    }]);

    return Length;
}();

exports.default = Length;


var getRootFontSize = function getRootFontSize(container) {
    var parent = container.parent;
    return parent ? getRootFontSize(parent) : parseFloat(container.style.font.fontSize);
};

var calculateLengthFromValueWithUnit = exports.calculateLengthFromValueWithUnit = function calculateLengthFromValueWithUnit(container, value, unit) {
    switch (unit) {
        case 'px':
        case '%':
            return new Length(value + unit);
        case 'em':
        case 'rem':
            var length = new Length(value);
            length.value *= unit === 'em' ? parseFloat(container.style.font.fontSize) : getRootFontSize(container);
            return length;
        default:
            // TODO: handle correctly if unknown unit is used
            return new Length('0');
    }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBoundCurves = exports.calculatePaddingBoxPath = exports.calculateBorderBoxPath = exports.parsePathForBorder = exports.parseDocumentSize = exports.calculateContentBox = exports.calculatePaddingBox = exports.parseBounds = exports.Bounds = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Vector = __webpack_require__(139);

var _Vector2 = _interopRequireDefault(_Vector);

var _BezierCurve = __webpack_require__(669);

var _BezierCurve2 = _interopRequireDefault(_BezierCurve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TOP = 0;
var RIGHT = 1;
var BOTTOM = 2;
var LEFT = 3;

var H = 0;
var V = 1;

var Bounds = exports.Bounds = function () {
    function Bounds(x, y, w, h) {
        _classCallCheck(this, Bounds);

        this.left = x;
        this.top = y;
        this.width = w;
        this.height = h;
    }

    _createClass(Bounds, null, [{
        key: 'fromClientRect',
        value: function fromClientRect(clientRect, scrollX, scrollY) {
            return new Bounds(clientRect.left + scrollX, clientRect.top + scrollY, clientRect.width, clientRect.height);
        }
    }]);

    return Bounds;
}();

var parseBounds = exports.parseBounds = function parseBounds(node, scrollX, scrollY) {
    return Bounds.fromClientRect(node.getBoundingClientRect(), scrollX, scrollY);
};

var calculatePaddingBox = exports.calculatePaddingBox = function calculatePaddingBox(bounds, borders) {
    return new Bounds(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth));
};

var calculateContentBox = exports.calculateContentBox = function calculateContentBox(bounds, padding, borders) {
    // TODO support percentage paddings
    var paddingTop = padding[TOP].value;
    var paddingRight = padding[RIGHT].value;
    var paddingBottom = padding[BOTTOM].value;
    var paddingLeft = padding[LEFT].value;

    return new Bounds(bounds.left + paddingLeft + borders[LEFT].borderWidth, bounds.top + paddingTop + borders[TOP].borderWidth, bounds.width - (borders[RIGHT].borderWidth + borders[LEFT].borderWidth + paddingLeft + paddingRight), bounds.height - (borders[TOP].borderWidth + borders[BOTTOM].borderWidth + paddingTop + paddingBottom));
};

var parseDocumentSize = exports.parseDocumentSize = function parseDocumentSize(document) {
    var body = document.body;
    var documentElement = document.documentElement;

    if (!body || !documentElement) {
        throw new Error( false ? 'Unable to get document size' : '');
    }
    var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));

    var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));

    return new Bounds(0, 0, width, height);
};

var parsePathForBorder = exports.parsePathForBorder = function parsePathForBorder(curves, borderSide) {
    switch (borderSide) {
        case TOP:
            return createPathFromCurves(curves.topLeftOuter, curves.topLeftInner, curves.topRightOuter, curves.topRightInner);
        case RIGHT:
            return createPathFromCurves(curves.topRightOuter, curves.topRightInner, curves.bottomRightOuter, curves.bottomRightInner);
        case BOTTOM:
            return createPathFromCurves(curves.bottomRightOuter, curves.bottomRightInner, curves.bottomLeftOuter, curves.bottomLeftInner);
        case LEFT:
        default:
            return createPathFromCurves(curves.bottomLeftOuter, curves.bottomLeftInner, curves.topLeftOuter, curves.topLeftInner);
    }
};

var createPathFromCurves = function createPathFromCurves(outer1, inner1, outer2, inner2) {
    var path = [];
    if (outer1 instanceof _BezierCurve2.default) {
        path.push(outer1.subdivide(0.5, false));
    } else {
        path.push(outer1);
    }

    if (outer2 instanceof _BezierCurve2.default) {
        path.push(outer2.subdivide(0.5, true));
    } else {
        path.push(outer2);
    }

    if (inner2 instanceof _BezierCurve2.default) {
        path.push(inner2.subdivide(0.5, true).reverse());
    } else {
        path.push(inner2);
    }

    if (inner1 instanceof _BezierCurve2.default) {
        path.push(inner1.subdivide(0.5, false).reverse());
    } else {
        path.push(inner1);
    }

    return path;
};

var calculateBorderBoxPath = exports.calculateBorderBoxPath = function calculateBorderBoxPath(curves) {
    return [curves.topLeftOuter, curves.topRightOuter, curves.bottomRightOuter, curves.bottomLeftOuter];
};

var calculatePaddingBoxPath = exports.calculatePaddingBoxPath = function calculatePaddingBoxPath(curves) {
    return [curves.topLeftInner, curves.topRightInner, curves.bottomRightInner, curves.bottomLeftInner];
};

var parseBoundCurves = exports.parseBoundCurves = function parseBoundCurves(bounds, borders, borderRadius) {
    var tlh = borderRadius[CORNER.TOP_LEFT][H].getAbsoluteValue(bounds.width);
    var tlv = borderRadius[CORNER.TOP_LEFT][V].getAbsoluteValue(bounds.height);
    var trh = borderRadius[CORNER.TOP_RIGHT][H].getAbsoluteValue(bounds.width);
    var trv = borderRadius[CORNER.TOP_RIGHT][V].getAbsoluteValue(bounds.height);
    var brh = borderRadius[CORNER.BOTTOM_RIGHT][H].getAbsoluteValue(bounds.width);
    var brv = borderRadius[CORNER.BOTTOM_RIGHT][V].getAbsoluteValue(bounds.height);
    var blh = borderRadius[CORNER.BOTTOM_LEFT][H].getAbsoluteValue(bounds.width);
    var blv = borderRadius[CORNER.BOTTOM_LEFT][V].getAbsoluteValue(bounds.height);

    var factors = [];
    factors.push((tlh + trh) / bounds.width);
    factors.push((blh + brh) / bounds.width);
    factors.push((tlv + blv) / bounds.height);
    factors.push((trv + brv) / bounds.height);
    var maxFactor = Math.max.apply(Math, factors);

    if (maxFactor > 1) {
        tlh /= maxFactor;
        tlv /= maxFactor;
        trh /= maxFactor;
        trv /= maxFactor;
        brh /= maxFactor;
        brv /= maxFactor;
        blh /= maxFactor;
        blv /= maxFactor;
    }

    var topWidth = bounds.width - trh;
    var rightHeight = bounds.height - brv;
    var bottomWidth = bounds.width - brh;
    var leftHeight = bounds.height - blv;

    return {
        topLeftOuter: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new _Vector2.default(bounds.left, bounds.top),
        topLeftInner: tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth, Math.max(0, tlh - borders[LEFT].borderWidth), Math.max(0, tlv - borders[TOP].borderWidth), CORNER.TOP_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + borders[TOP].borderWidth),
        topRightOuter: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top),
        topRightInner: trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borders[LEFT].borderWidth), bounds.top + borders[TOP].borderWidth, topWidth > bounds.width + borders[LEFT].borderWidth ? 0 : trh - borders[LEFT].borderWidth, trv - borders[TOP].borderWidth, CORNER.TOP_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + borders[TOP].borderWidth),
        bottomRightOuter: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width, bounds.top + bounds.height),
        bottomRightInner: brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borders[LEFT].borderWidth), bounds.top + Math.min(rightHeight, bounds.height + borders[TOP].borderWidth), Math.max(0, brh - borders[RIGHT].borderWidth), brv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_RIGHT) : new _Vector2.default(bounds.left + bounds.width - borders[RIGHT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth),
        bottomLeftOuter: blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left, bounds.top + bounds.height),
        bottomLeftInner: blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borders[LEFT].borderWidth, bounds.top + leftHeight, Math.max(0, blh - borders[LEFT].borderWidth), blv - borders[BOTTOM].borderWidth, CORNER.BOTTOM_LEFT) : new _Vector2.default(bounds.left + borders[LEFT].borderWidth, bounds.top + bounds.height - borders[BOTTOM].borderWidth)
    };
};

var CORNER = {
    TOP_LEFT: 0,
    TOP_RIGHT: 1,
    BOTTOM_RIGHT: 2,
    BOTTOM_LEFT: 3
};

var getCurvePoints = function getCurvePoints(x, y, r1, r2, position) {
    var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
    var ox = r1 * kappa; // control point offset horizontal
    var oy = r2 * kappa; // control point offset vertical
    var xm = x + r1; // x-middle
    var ym = y + r2; // y-middle

    switch (position) {
        case CORNER.TOP_LEFT:
            return new _BezierCurve2.default(new _Vector2.default(x, ym), new _Vector2.default(x, ym - oy), new _Vector2.default(xm - ox, y), new _Vector2.default(xm, y));
        case CORNER.TOP_RIGHT:
            return new _BezierCurve2.default(new _Vector2.default(x, y), new _Vector2.default(x + ox, y), new _Vector2.default(xm, ym - oy), new _Vector2.default(xm, ym));
        case CORNER.BOTTOM_RIGHT:
            return new _BezierCurve2.default(new _Vector2.default(xm, y), new _Vector2.default(xm, y + oy), new _Vector2.default(x + ox, ym), new _Vector2.default(x, ym));
        case CORNER.BOTTOM_LEFT:
        default:
            return new _BezierCurve2.default(new _Vector2.default(xm, ym), new _Vector2.default(xm - ox, ym), new _Vector2.default(x, y + oy), new _Vector2.default(x, y));
    }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(36);

var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(7);
var ToBoolean = __webpack_require__(73);
var IsCallable = __webpack_require__(56);

// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5

module.exports = function ToPropertyDescriptor(Obj) {
	if (Type(Obj) !== 'Object') {
		throw new $TypeError('ToPropertyDescriptor requires an object');
	}

	var desc = {};
	if (has(Obj, 'enumerable')) {
		desc['[[Enumerable]]'] = ToBoolean(Obj.enumerable);
	}
	if (has(Obj, 'configurable')) {
		desc['[[Configurable]]'] = ToBoolean(Obj.configurable);
	}
	if (has(Obj, 'value')) {
		desc['[[Value]]'] = Obj.value;
	}
	if (has(Obj, 'writable')) {
		desc['[[Writable]]'] = ToBoolean(Obj.writable);
	}
	if (has(Obj, 'get')) {
		var getter = Obj.get;
		if (typeof getter !== 'undefined' && !IsCallable(getter)) {
			throw new TypeError('getter must be a function');
		}
		desc['[[Get]]'] = getter;
	}
	if (has(Obj, 'set')) {
		var setter = Obj.set;
		if (typeof setter !== 'undefined' && !IsCallable(setter)) {
			throw new $TypeError('setter must be a function');
		}
		desc['[[Set]]'] = setter;
	}

	if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
		throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
	}
	return desc;
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/5.1/#sec-9.2

module.exports = function ToBoolean(value) { return !!value; };


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43);

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.12

module.exports = function SameValue(x, y) {
	if (x === y) { // 0 === -0, but they are not identical.
		if (x === 0) { return 1 / x === 1 / y; }
		return true;
	}
	return $isNaN(x) && $isNaN(y);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

// https://www.ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var inspect = __webpack_require__(147);

var IsCallable = __webpack_require__(56);

// https://www.ecma-international.org/ecma-262/6.0/#sec-call

module.exports = function Call(F, V) {
	var args = arguments.length > 2 ? arguments[2] : [];
	if (!IsCallable(F)) {
		throw new $TypeError(inspect(F) + ' is not a function');
	}
	return F.apply(V, args);
};


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.smallSize = smallSize;
// (C) Copyright 2014 Hewlett Packard Enterprise Development LP

/*
 * Responsive is a utility for tracking the display size.
 * It aligns with CSS media queries.
 */

var SMALL_WIDTH_EM = 44.9375; // align with _settings.responsive.scss

function smallSize() {
  var fontSize = '16px';
  // unit tests don't have getComputedStyle
  if (window.getComputedStyle) {
    fontSize = window.getComputedStyle(document.documentElement).fontSize;
  }
  return SMALL_WIDTH_EM * parseFloat(fontSize);
}

exports.default = {

  // Track responsive sizing.
  //
  // Example:
  // inside componentDidMount()
  //   this._responsive = Responsive.start(this._onResponsive);
  // inside componentWillUnmount()
  //   this._responsive.stop()

  start: function start(func) {
    var responsive = {
      func: func,
      timer: undefined,
      small: undefined,
      smallSize: this.smallSize()
    };
    responsive.onResize = this._onResize.bind(this, responsive);
    responsive.layout = this._check.bind(this, responsive);
    responsive.stop = this._stop.bind(this, responsive);
    window.addEventListener('resize', responsive.onResize);
    responsive.layout();
    return responsive;
  },
  _stop: function _stop(responsive) {
    clearTimeout(responsive.timer);
    window.removeEventListener('resize', responsive.onResize);
  },
  _onResize: function _onResize(responsive) {
    // Don't debounce so we align more closely with how the stylesheets are
    // processed.
    responsive.layout();
  },
  _check: function _check(responsive) {
    if (window.innerWidth <= responsive.smallSize) {
      if (!responsive.small) {
        responsive.small = true;
        responsive.func(true);
      }
    } else {
      if (false !== responsive.small) {
        responsive.small = false;
        responsive.func(false);
      }
    }
  },


  smallSize: smallSize
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(511);
var objectAssign = __webpack_require__(108);
var decodeComponent = __webpack_require__(512);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

function extract(str) {
	var queryStart = str.indexOf('?');
	if (queryStart === -1) {
		return '';
	}
	return str.slice(queryStart + 1);
}

function parse(str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^[?#&]/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeComponent(val);

		formatter(decodeComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	if (opts.sort === false) {
		opts.sort = function () {};
	}

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};

exports.parseUrl = function (str, opts) {
	return {
		url: str.split('?')[0] || '',
		query: parse(extract(str), opts)
	};
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _reactTransitionGroup = __webpack_require__(302);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _DOM = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.ANIMATE;

var AnimateChild = function (_Component) {
  _inherits(AnimateChild, _Component);

  function AnimateChild(props, context) {
    _classCallCheck(this, AnimateChild);

    var _this = _possibleConstructorReturn(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).call(this, props, context));

    var enter = props.enter,
        leave = props.leave;
    // leave will reuse enter if leave is not defined

    _this.state = {
      enter: enter,
      leave: leave || enter,
      state: 'inactive'
    };
    return _this;
  }

  _createClass(AnimateChild, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var enter = nextProps.enter,
          leave = nextProps.leave;

      this.setState({ enter: enter, leave: leave || enter });
      if (nextProps.visible !== this.props.visible) {
        var _ref = nextProps.visible ? ['enter', 'active'] : ['leave', 'inactive'],
            _ref2 = _slicedToArray(_ref, 2),
            nextState = _ref2[0],
            lastState = _ref2[1];

        this._delay(nextState, this._done.bind(this, lastState));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._timer) {
        clearTimeout(this._timer);
        this._timer = undefined;
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(callback) {
      if (true === this.props.visible) {
        this._delay('enter', callback);
      }
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      if (true === this.props.visible) {
        this._delay('enter', callback);
      }
    }
  }, {
    key: 'componentDidAppear',
    value: function componentDidAppear() {
      this._done('active');
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      this._done('active');
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      this._delay('leave', callback);
    }
  }, {
    key: 'componentDidLeave',
    value: function componentDidLeave(callback) {
      this._done('inactive');
    }
  }, {
    key: '_delay',
    value: function _delay(state, callback) {
      var delay = this.state[state].delay;
      // ensure we start out inactive in case we aren't being kept in the DOM

      if ('enter' === state) {
        this.setState({ state: 'inactive ' });
      }
      clearTimeout(this._timer);
      this._timer = setTimeout(this._start.bind(this, state, callback), delay || 1);
    }
  }, {
    key: '_start',
    value: function _start(state, callback) {
      var duration = this.state[state].duration;

      this.setState({ state: state });
      this._timer = setTimeout(callback, duration);
    }
  }, {
    key: '_done',
    value: function _done(state) {
      this.setState({ state: state });
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          enter = _state.enter,
          leave = _state.leave,
          state = _state.state;

      var animation = (this.state[state] || this.state.enter).animation;
      var className = (0, _classnames2.default)(CLASS_ROOT + '__child', CLASS_ROOT + '__child--' + animation, CLASS_ROOT + '__child--' + state);
      var duration = 'enter' === state || 'inactive' === state ? enter.duration : leave.duration;
      var style = { transitionDuration: (duration || 0) + 'ms' };
      return _react2.default.createElement(
        'div',
        { className: className, style: style },
        children
      );
    }
  }]);

  return AnimateChild;
}(_react.Component);

AnimateChild.displayName = 'AnimateChild';


AnimateChild.propTypes = {
  enter: _propTypes2.default.shape({
    animation: _propTypes2.default.string,
    duration: _propTypes2.default.number,
    delay: _propTypes2.default.number
  }).isRequired,
  leave: _propTypes2.default.shape({
    animation: _propTypes2.default.string,
    duration: _propTypes2.default.number,
    delay: _propTypes2.default.number
  }),
  visible: _propTypes2.default.bool
};

AnimateChild.defaultProps = {
  visible: false
};

var Animate = function (_Component2) {
  _inherits(Animate, _Component2);

  function Animate(props, context) {
    _classCallCheck(this, Animate);

    var _this2 = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props, context));

    _this2._checkScroll = _this2._checkScroll.bind(_this2);
    _this2.state = { visible: true === props.visible };
    return _this2;
  }

  _createClass(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ('scroll' === this.props.visible) {
        this._listenForScroll();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var visible = this.props.visible;

      if (visible !== nextProps.visible) {
        if ('scroll' === visible) {
          this._unlistenForScroll();
        } else if ('scroll' === nextProps.visible) {
          this._listenForScroll();
        }
        this.setState({ visible: true === nextProps.visible });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if ('scroll' === this.props.visible) {
        this._unlistenForScroll();
      }
    }
  }, {
    key: '_listenForScroll',
    value: function _listenForScroll() {
      var _this3 = this;

      // add a timeout so that the findScrollParents function
      // get the right container sizes
      setTimeout(function () {
        var scrollParents = (0, _DOM.findScrollParents)((0, _reactDom.findDOMNode)(_this3.animateRef));
        if (scrollParents.indexOf(document) === -1) {
          document.addEventListener('scroll', _this3._checkScroll);
        }
        scrollParents.forEach(function (scrollParent) {
          scrollParent.addEventListener('scroll', _this3._checkScroll);
        }, _this3);
      }, 0);
    }
  }, {
    key: '_unlistenForScroll',
    value: function _unlistenForScroll() {
      var _this4 = this;

      var scrollParents = (0, _DOM.findScrollParents)((0, _reactDom.findDOMNode)(this.animateRef));
      if (scrollParents.indexOf(document) === -1) {
        document.removeEventListener('scroll', this._checkScroll);
      }
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', _this4._checkScroll);
      }, this);
    }
  }, {
    key: '_checkScroll',
    value: function _checkScroll() {
      var _props = this.props,
          onAppear = _props.onAppear,
          onLeave = _props.onLeave;

      var group = (0, _reactDom.findDOMNode)(this.animateRef);
      var rect = group.getBoundingClientRect();

      if (rect.top < window.innerHeight) {
        this.setState({ visible: true }, function () {
          if (onAppear) {
            onAppear();
          }
        });
      } else {
        this.setState({ visible: false }, function () {
          if (onLeave) {
            onLeave();
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          enter = _props2.enter,
          leave = _props2.leave,
          className = _props2.className,
          children = _props2.children,
          component = _props2.component,
          keep = _props2.keep,
          props = _objectWithoutProperties(_props2, ['enter', 'leave', 'className', 'children', 'component', 'keep']);

      delete props.onAppear;
      delete props.onLeave;
      delete props.visible;
      var visible = this.state.visible;


      var classes = (0, _classnames2.default)(CLASS_ROOT, className);

      var animateChildren = void 0;
      if (keep || visible) {
        animateChildren = _react2.default.Children.map(children, function (child, index) {
          return _react2.default.createElement(
            AnimateChild,
            { key: index, enter: enter, leave: leave,
              visible: visible },
            child
          );
        });
      }

      return _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        _extends({}, props, {
          className: classes,
          component: component,
          ref: function ref(_ref3) {
            return _this5.animateRef = _ref3;
          }
        }),
        animateChildren
      );
    }
  }]);

  return Animate;
}(_react.Component);

Animate.displayName = 'Animate';
exports.default = Animate;


var ANIMATIONS = ['fade', 'slide-up', 'slide-down', 'slide-left', 'slide-right', 'jiggle'];

Animate.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  enter: _propTypes2.default.shape({
    animation: _propTypes2.default.oneOf(ANIMATIONS).isRequired,
    duration: _propTypes2.default.number,
    delay: _propTypes2.default.number
  }).isRequired,
  keep: _propTypes2.default.bool,
  leave: _propTypes2.default.shape({
    animation: _propTypes2.default.oneOf(ANIMATIONS).isRequired,
    duration: _propTypes2.default.number,
    delay: _propTypes2.default.number
  }),
  onAppear: _propTypes2.default.func,
  onLeave: _propTypes2.default.func,
  visible: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['scroll']), _propTypes2.default.bool])
};

Animate.defaultProps = {
  component: 'div',
  enter: { animation: 'fade', duration: 300 },
  visible: true
};
module.exports = exports['default'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Preprocessor = __webpack_require__(635),
    UNICODE = __webpack_require__(102),
    neTree = __webpack_require__(636);

//Aliases
var $ = UNICODE.CODE_POINTS,
    $$ = UNICODE.CODE_POINT_SEQUENCES;

//Replacement code points for numeric entities
var NUMERIC_ENTITY_REPLACEMENTS = {
    0x00: 0xFFFD, 0x0D: 0x000D, 0x80: 0x20AC, 0x81: 0x0081, 0x82: 0x201A, 0x83: 0x0192, 0x84: 0x201E,
    0x85: 0x2026, 0x86: 0x2020, 0x87: 0x2021, 0x88: 0x02C6, 0x89: 0x2030, 0x8A: 0x0160, 0x8B: 0x2039,
    0x8C: 0x0152, 0x8D: 0x008D, 0x8E: 0x017D, 0x8F: 0x008F, 0x90: 0x0090, 0x91: 0x2018, 0x92: 0x2019,
    0x93: 0x201C, 0x94: 0x201D, 0x95: 0x2022, 0x96: 0x2013, 0x97: 0x2014, 0x98: 0x02DC, 0x99: 0x2122,
    0x9A: 0x0161, 0x9B: 0x203A, 0x9C: 0x0153, 0x9D: 0x009D, 0x9E: 0x017E, 0x9F: 0x0178
};

// Named entity tree flags
var HAS_DATA_FLAG = 1 << 0;
var DATA_DUPLET_FLAG = 1 << 1;
var HAS_BRANCHES_FLAG = 1 << 2;
var MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;


//States
var DATA_STATE = 'DATA_STATE',
    CHARACTER_REFERENCE_IN_DATA_STATE = 'CHARACTER_REFERENCE_IN_DATA_STATE',
    RCDATA_STATE = 'RCDATA_STATE',
    CHARACTER_REFERENCE_IN_RCDATA_STATE = 'CHARACTER_REFERENCE_IN_RCDATA_STATE',
    RAWTEXT_STATE = 'RAWTEXT_STATE',
    SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE',
    PLAINTEXT_STATE = 'PLAINTEXT_STATE',
    TAG_OPEN_STATE = 'TAG_OPEN_STATE',
    END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE',
    TAG_NAME_STATE = 'TAG_NAME_STATE',
    RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE',
    RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE',
    RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE',
    RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE',
    RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE',
    RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE',
    SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE',
    SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE',
    SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE',
    SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE',
    SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE',
    SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE',
    SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE',
    SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE',
    SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE',
    BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE',
    ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE',
    AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE',
    BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE',
    ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE',
    ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE',
    CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE = 'CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE',
    AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE',
    SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE',
    BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE',
    BOGUS_COMMENT_STATE_CONTINUATION = 'BOGUS_COMMENT_STATE_CONTINUATION',
    MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE',
    COMMENT_START_STATE = 'COMMENT_START_STATE',
    COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE',
    COMMENT_STATE = 'COMMENT_STATE',
    COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE',
    COMMENT_END_STATE = 'COMMENT_END_STATE',
    COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE',
    DOCTYPE_STATE = 'DOCTYPE_STATE',
    DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE',
    AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE',
    BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE',
    BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE',
    BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE',
    DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE',
    AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE',
    BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE',
    CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
    return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}

function isAsciiDigit(cp) {
    return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}

function isAsciiUpper(cp) {
    return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}

function isAsciiLower(cp) {
    return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}

function isAsciiLetter(cp) {
    return isAsciiLower(cp) || isAsciiUpper(cp);
}

function isAsciiAlphaNumeric(cp) {
    return isAsciiLetter(cp) || isAsciiDigit(cp);
}

function isDigit(cp, isHex) {
    return isAsciiDigit(cp) || isHex && (cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F ||
                                         cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F);
}

function isReservedCodePoint(cp) {
    return cp >= 0xD800 && cp <= 0xDFFF || cp > 0x10FFFF;
}

function toAsciiLowerCodePoint(cp) {
    return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
    if (cp <= 0xFFFF)
        return String.fromCharCode(cp);

    cp -= 0x10000;
    return String.fromCharCode(cp >>> 10 & 0x3FF | 0xD800) + String.fromCharCode(0xDC00 | cp & 0x3FF);
}

function toAsciiLowerChar(cp) {
    return String.fromCharCode(toAsciiLowerCodePoint(cp));
}

function findNamedEntityTreeBranch(nodeIx, cp) {
    var branchCount = neTree[++nodeIx],
        lo = ++nodeIx,
        hi = lo + branchCount - 1;

    while (lo <= hi) {
        var mid = lo + hi >>> 1,
            midCp = neTree[mid];

        if (midCp < cp)
            lo = mid + 1;

        else if (midCp > cp)
            hi = mid - 1;

        else
            return neTree[mid + branchCount];
    }

    return -1;
}


//Tokenizer
var Tokenizer = module.exports = function () {
    this.preprocessor = new Preprocessor();

    this.tokenQueue = [];

    this.allowCDATA = false;

    this.state = DATA_STATE;
    this.returnState = '';

    this.tempBuff = [];
    this.additionalAllowedCp = void 0;
    this.lastStartTagName = '';

    this.consumedAfterSnapshot = -1;
    this.active = false;

    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = null;
};

//Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
    DATA: DATA_STATE,
    RCDATA: RCDATA_STATE,
    RAWTEXT: RAWTEXT_STATE,
    SCRIPT_DATA: SCRIPT_DATA_STATE,
    PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function (token, attrName) {
    for (var i = token.attrs.length - 1; i >= 0; i--) {
        if (token.attrs[i].name === attrName)
            return token.attrs[i].value;
    }

    return null;
};

//API
Tokenizer.prototype.getNextToken = function () {
    while (!this.tokenQueue.length && this.active) {
        this._hibernationSnapshot();

        var cp = this._consume();

        if (!this._ensureHibernation())
            this[this.state](cp);
    }

    return this.tokenQueue.shift();
};

Tokenizer.prototype.write = function (chunk, isLastChunk) {
    this.active = true;
    this.preprocessor.write(chunk, isLastChunk);
};

Tokenizer.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.active = true;
    this.preprocessor.insertHtmlAtCurrentPos(chunk);
};

//Hibernation
Tokenizer.prototype._hibernationSnapshot = function () {
    this.consumedAfterSnapshot = 0;
};

Tokenizer.prototype._ensureHibernation = function () {
    if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--)
            this.preprocessor.retreat();

        this.active = false;
        this.tokenQueue.push({type: Tokenizer.HIBERNATION_TOKEN});

        return true;
    }

    return false;
};


//Consumption
Tokenizer.prototype._consume = function () {
    this.consumedAfterSnapshot++;
    return this.preprocessor.advance();
};

Tokenizer.prototype._unconsume = function () {
    this.consumedAfterSnapshot--;
    this.preprocessor.retreat();
};

Tokenizer.prototype._unconsumeSeveral = function (count) {
    while (count--)
        this._unconsume();
};

Tokenizer.prototype._reconsumeInState = function (state) {
    this.state = state;
    this._unconsume();
};

Tokenizer.prototype._consumeSubsequentIfMatch = function (pattern, startCp, caseSensitive) {
    var consumedCount = 0,
        isMatch = true,
        patternLength = pattern.length,
        patternPos = 0,
        cp = startCp,
        patternCp = void 0;

    for (; patternPos < patternLength; patternPos++) {
        if (patternPos > 0) {
            cp = this._consume();
            consumedCount++;
        }

        if (cp === $.EOF) {
            isMatch = false;
            break;
        }

        patternCp = pattern[patternPos];

        if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
            isMatch = false;
            break;
        }
    }

    if (!isMatch)
        this._unconsumeSeveral(consumedCount);

    return isMatch;
};

//Lookahead
Tokenizer.prototype._lookahead = function () {
    var cp = this._consume();

    this._unconsume();

    return cp;
};

//Temp buffer
Tokenizer.prototype.isTempBufferEqualToScriptString = function () {
    if (this.tempBuff.length !== $$.SCRIPT_STRING.length)
        return false;

    for (var i = 0; i < this.tempBuff.length; i++) {
        if (this.tempBuff[i] !== $$.SCRIPT_STRING[i])
            return false;
    }

    return true;
};

//Token creation
Tokenizer.prototype._createStartTagToken = function () {
    this.currentToken = {
        type: Tokenizer.START_TAG_TOKEN,
        tagName: '',
        selfClosing: false,
        attrs: []
    };
};

Tokenizer.prototype._createEndTagToken = function () {
    this.currentToken = {
        type: Tokenizer.END_TAG_TOKEN,
        tagName: '',
        attrs: []
    };
};

Tokenizer.prototype._createCommentToken = function () {
    this.currentToken = {
        type: Tokenizer.COMMENT_TOKEN,
        data: ''
    };
};

Tokenizer.prototype._createDoctypeToken = function (initialName) {
    this.currentToken = {
        type: Tokenizer.DOCTYPE_TOKEN,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null
    };
};

Tokenizer.prototype._createCharacterToken = function (type, ch) {
    this.currentCharacterToken = {
        type: type,
        chars: ch
    };
};

//Tag attributes
Tokenizer.prototype._createAttr = function (attrNameFirstCh) {
    this.currentAttr = {
        name: attrNameFirstCh,
        value: ''
    };
};

Tokenizer.prototype._isDuplicateAttr = function () {
    return Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) !== null;
};

Tokenizer.prototype._leaveAttrName = function (toState) {
    this.state = toState;

    if (!this._isDuplicateAttr())
        this.currentToken.attrs.push(this.currentAttr);
};

Tokenizer.prototype._leaveAttrValue = function (toState) {
    this.state = toState;
};

//Appropriate end tag token
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#appropriate-end-tag-token)
Tokenizer.prototype._isAppropriateEndTagToken = function () {
    return this.lastStartTagName === this.currentToken.tagName;
};

//Token emission
Tokenizer.prototype._emitCurrentToken = function () {
    this._emitCurrentCharacterToken();

    //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
    if (this.currentToken.type === Tokenizer.START_TAG_TOKEN)
        this.lastStartTagName = this.currentToken.tagName;

    this.tokenQueue.push(this.currentToken);
    this.currentToken = null;
};

Tokenizer.prototype._emitCurrentCharacterToken = function () {
    if (this.currentCharacterToken) {
        this.tokenQueue.push(this.currentCharacterToken);
        this.currentCharacterToken = null;
    }
};

Tokenizer.prototype._emitEOFToken = function () {
    this._emitCurrentCharacterToken();
    this.tokenQueue.push({type: Tokenizer.EOF_TOKEN});
};

//Characters emission

//OPTIMIZATION: specification uses only one type of character tokens (one token per character).
//This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
//If we have a sequence of characters that belong to the same group, parser can process it
//as a single solid character token.
//So, there are 3 types of character tokens in parse5:
//1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
//2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
//3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
Tokenizer.prototype._appendCharToCurrentCharacterToken = function (type, ch) {
    if (this.currentCharacterToken && this.currentCharacterToken.type !== type)
        this._emitCurrentCharacterToken();

    if (this.currentCharacterToken)
        this.currentCharacterToken.chars += ch;

    else
        this._createCharacterToken(type, ch);
};

Tokenizer.prototype._emitCodePoint = function (cp) {
    var type = Tokenizer.CHARACTER_TOKEN;

    if (isWhitespace(cp))
        type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;

    else if (cp === $.NULL)
        type = Tokenizer.NULL_CHARACTER_TOKEN;

    this._appendCharToCurrentCharacterToken(type, toChar(cp));
};

Tokenizer.prototype._emitSeveralCodePoints = function (codePoints) {
    for (var i = 0; i < codePoints.length; i++)
        this._emitCodePoint(codePoints[i]);
};

//NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
//So we can avoid additional checks here.
Tokenizer.prototype._emitChar = function (ch) {
    this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
};

//Character reference tokenization
Tokenizer.prototype._consumeNumericEntity = function (isHex) {
    var digits = '',
        nextCp = void 0;

    do {
        digits += toChar(this._consume());
        nextCp = this._lookahead();
    } while (nextCp !== $.EOF && isDigit(nextCp, isHex));

    if (this._lookahead() === $.SEMICOLON)
        this._consume();

    var referencedCp = parseInt(digits, isHex ? 16 : 10),
        replacement = NUMERIC_ENTITY_REPLACEMENTS[referencedCp];

    if (replacement)
        return replacement;

    if (isReservedCodePoint(referencedCp))
        return $.REPLACEMENT_CHARACTER;

    return referencedCp;
};

// NOTE: for the details on this algorithm see
// https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md
Tokenizer.prototype._consumeNamedEntity = function (inAttr) {
    var referencedCodePoints = null,
        referenceSize = 0,
        cp = null,
        consumedCount = 0,
        semicolonTerminated = false;

    for (var i = 0; i > -1;) {
        var current = neTree[i],
            inNode = current < MAX_BRANCH_MARKER_VALUE,
            nodeWithData = inNode && current & HAS_DATA_FLAG;

        if (nodeWithData) {
            referencedCodePoints = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
            referenceSize = consumedCount;

            if (cp === $.SEMICOLON) {
                semicolonTerminated = true;
                break;
            }
        }

        cp = this._consume();
        consumedCount++;

        if (cp === $.EOF)
            break;

        if (inNode)
            i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;

        else
            i = cp === current ? ++i : -1;
    }


    if (referencedCodePoints) {
        if (!semicolonTerminated) {
            //NOTE: unconsume excess (e.g. 'it' in '&notit')
            this._unconsumeSeveral(consumedCount - referenceSize);

            //NOTE: If the character reference is being consumed as part of an attribute and the next character
            //is either a U+003D EQUALS SIGN character (=) or an alphanumeric ASCII character, then, for historical
            //reasons, all the characters that were matched after the U+0026 AMPERSAND character (&) must be
            //unconsumed, and nothing is returned.
            //However, if this next character is in fact a U+003D EQUALS SIGN character (=), then this is a
            //parse error, because some legacy user agents will misinterpret the markup in those cases.
            //(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tokenization.html#tokenizing-character-references)
            if (inAttr) {
                var nextCp = this._lookahead();

                if (nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp)) {
                    this._unconsumeSeveral(referenceSize);
                    return null;
                }
            }
        }

        return referencedCodePoints;
    }

    this._unconsumeSeveral(consumedCount);

    return null;
};

Tokenizer.prototype._consumeCharacterReference = function (startCp, inAttr) {
    if (isWhitespace(startCp) || startCp === $.GREATER_THAN_SIGN ||
        startCp === $.AMPERSAND || startCp === this.additionalAllowedCp || startCp === $.EOF) {
        //NOTE: not a character reference. No characters are consumed, and nothing is returned.
        this._unconsume();
        return null;
    }

    if (startCp === $.NUMBER_SIGN) {
        //NOTE: we have a numeric entity candidate, now we should determine if it's hex or decimal
        var isHex = false,
            nextCp = this._lookahead();

        if (nextCp === $.LATIN_SMALL_X || nextCp === $.LATIN_CAPITAL_X) {
            this._consume();
            isHex = true;
        }

        nextCp = this._lookahead();

        //NOTE: if we have at least one digit this is a numeric entity for sure, so we consume it
        if (nextCp !== $.EOF && isDigit(nextCp, isHex))
            return [this._consumeNumericEntity(isHex)];

        //NOTE: otherwise this is a bogus number entity and a parse error. Unconsume the number sign
        //and the 'x'-character if appropriate.
        this._unconsumeSeveral(isHex ? 2 : 1);
        return null;
    }

    this._unconsume();

    return this._consumeNamedEntity(inAttr);
};

//State machine
var _ = Tokenizer.prototype;

//12.2.4.1 Data state
//------------------------------------------------------------------
_[DATA_STATE] = function dataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_DATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = TAG_OPEN_STATE;

    else if (cp === $.NULL)
        this._emitCodePoint(cp);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.2 Character reference in data state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_DATA_STATE] = function characterReferenceInDataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = DATA_STATE;
    }
};


//12.2.4.3 RCDATA state
//------------------------------------------------------------------
_[RCDATA_STATE] = function rcdataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.AMPERSAND)
        this.state = CHARACTER_REFERENCE_IN_RCDATA_STATE;

    else if (cp === $.LESS_THAN_SIGN)
        this.state = RCDATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.4 Character reference in RCDATA state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_RCDATA_STATE] = function characterReferenceInRcdataState(cp) {
    this.additionalAllowedCp = void 0;

    var referencedCodePoints = this._consumeCharacterReference(cp, false);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints)
            this._emitSeveralCodePoints(referencedCodePoints);

        else
            this._emitChar('&');

        this.state = RCDATA_STATE;
    }
};


//12.2.4.5 RAWTEXT state
//------------------------------------------------------------------
_[RAWTEXT_STATE] = function rawtextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = RAWTEXT_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.6 Script data state
//------------------------------------------------------------------
_[SCRIPT_DATA_STATE] = function scriptDataState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.7 PLAINTEXT state
//------------------------------------------------------------------
_[PLAINTEXT_STATE] = function plaintextState(cp) {
    this.preprocessor.dropParsedChunk();

    if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._emitEOFToken();

    else
        this._emitCodePoint(cp);
};


//12.2.4.8 Tag open state
//------------------------------------------------------------------
_[TAG_OPEN_STATE] = function tagOpenState(cp) {
    if (cp === $.EXCLAMATION_MARK)
        this.state = MARKUP_DECLARATION_OPEN_STATE;

    else if (cp === $.SOLIDUS)
        this.state = END_TAG_OPEN_STATE;

    else if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.QUESTION_MARK)
        this._reconsumeInState(BOGUS_COMMENT_STATE);

    else {
        this._emitChar('<');
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.9 End tag open state
//------------------------------------------------------------------
_[END_TAG_OPEN_STATE] = function endTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
    }

    else if (cp === $.GREATER_THAN_SIGN)
        this.state = DATA_STATE;

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitChar('<');
        this._emitChar('/');
    }

    else
        this._reconsumeInState(BOGUS_COMMENT_STATE);
};


//12.2.4.10 Tag name state
//------------------------------------------------------------------
_[TAG_NAME_STATE] = function tagNameState(cp) {
    if (isWhitespace(cp))
        this.state = BEFORE_ATTRIBUTE_NAME_STATE;

    else if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (isAsciiUpper(cp))
        this.currentToken.tagName += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.tagName += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentToken.tagName += toChar(cp);
};


//12.2.4.11 RCDATA less-than sign state
//------------------------------------------------------------------
_[RCDATA_LESS_THAN_SIGN_STATE] = function rcdataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RCDATA_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.12 RCDATA end tag open state
//------------------------------------------------------------------
_[RCDATA_END_TAG_OPEN_STATE] = function rcdataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.13 RCDATA end tag name state
//------------------------------------------------------------------
_[RCDATA_END_TAG_NAME_STATE] = function rcdataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this.state = DATA_STATE;
                this._emitCurrentToken();
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RCDATA_STATE);
    }
};


//12.2.4.14 RAWTEXT less-than sign state
//------------------------------------------------------------------
_[RAWTEXT_LESS_THAN_SIGN_STATE] = function rawtextLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RAWTEXT_END_TAG_OPEN_STATE;
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.15 RAWTEXT end tag open state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_OPEN_STATE] = function rawtextEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.16 RAWTEXT end tag name state
//------------------------------------------------------------------
_[RAWTEXT_END_TAG_NAME_STATE] = function rawtextEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RAWTEXT_STATE);
    }
};


//12.2.4.17 Script data less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_LESS_THAN_SIGN_STATE] = function scriptDataLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
    }

    else if (cp === $.EXCLAMATION_MARK) {
        this.state = SCRIPT_DATA_ESCAPE_START_STATE;
        this._emitChar('<');
        this._emitChar('!');
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.18 Script data end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_OPEN_STATE] = function scriptDataEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.19 Script data end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_END_TAG_NAME_STATE] = function scriptDataEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            else if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            else if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_STATE);
    }
};


//12.2.4.20 Script data escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_STATE] = function scriptDataEscapeStartState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.21 Script data escape start dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPE_START_DASH_STATE] = function scriptDataEscapeStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_STATE);
};


//12.2.4.22 Script data escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_STATE] = function scriptDataEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.23 Script data escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_STATE] = function scriptDataEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.24 Script data escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_DASH_DASH_STATE] = function scriptDataEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN)
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.25 Script data escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
    }

    else if (isAsciiLetter(cp)) {
        this.tempBuff = [];
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
    }

    else {
        this._emitChar('<');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.26 Script data escaped end tag open state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE] = function scriptDataEscapedEndTagOpenState(cp) {
    if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
    }

    else {
        this._emitChar('<');
        this._emitChar('/');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.27 Script data escaped end tag name state
//------------------------------------------------------------------
_[SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE] = function scriptDataEscapedEndTagNameState(cp) {
    if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
    }

    else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
    }

    else {
        if (this._isAppropriateEndTagToken()) {
            if (isWhitespace(cp)) {
                this.state = BEFORE_ATTRIBUTE_NAME_STATE;
                return;
            }

            if (cp === $.SOLIDUS) {
                this.state = SELF_CLOSING_START_TAG_STATE;
                return;
            }

            if (cp === $.GREATER_THAN_SIGN) {
                this._emitCurrentToken();
                this.state = DATA_STATE;
                return;
            }
        }

        this._emitChar('<');
        this._emitChar('/');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
    }
};


//12.2.4.28 Script data double escape start state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE] = function scriptDataDoubleEscapeStartState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
};


//12.2.4.29 Script data double escaped state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_STATE] = function scriptDataDoubleEscapedState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL)
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._emitCodePoint(cp);
};


//12.2.4.30 Script data double escaped dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE] = function scriptDataDoubleEscapedDashState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
        this._emitChar('-');
    }

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.31 Script data double escaped dash dash state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE] = function scriptDataDoubleEscapedDashDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this._emitChar('-');

    else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChar('<');
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChar('>');
    }

    else if (cp === $.NULL) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChar(UNICODE.REPLACEMENT_CHARACTER);
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
    }
};


//12.2.4.32 Script data double escaped less-than sign state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE] = function scriptDataDoubleEscapedLessThanSignState(cp) {
    if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
        this._emitChar('/');
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.33 Script data double escape end state
//------------------------------------------------------------------
_[SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE] = function scriptDataDoubleEscapeEndState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this.isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;

        this._emitCodePoint(cp);
    }

    else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
    }

    else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
    }

    else
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
};


//12.2.4.34 Before attribute name state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_NAME_STATE] = function beforeAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);

    else if (cp === $.EQUALS_SIGN) {
        this._createAttr('=');
        this.state = ATTRIBUTE_NAME_STATE;
    }

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.35 Attribute name state
//------------------------------------------------------------------
_[ATTRIBUTE_NAME_STATE] = function attributeNameState(cp) {
    if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
        this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
        this._unconsume();
    }

    else if (cp === $.EQUALS_SIGN)
        this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);

    else if (isAsciiUpper(cp))
        this.currentAttr.name += toAsciiLowerChar(cp);

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN)
        this.currentAttr.name += toChar(cp);

    else if (cp === $.NULL)
        this.currentAttr.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentAttr.name += toChar(cp);
};


//12.2.4.36 After attribute name state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_NAME_STATE] = function afterAttributeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.SOLIDUS)
        this.state = SELF_CLOSING_START_TAG_STATE;

    else if (cp === $.EQUALS_SIGN)
        this.state = BEFORE_ATTRIBUTE_VALUE_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
    }
};


//12.2.4.37 Before attribute value state
//------------------------------------------------------------------
_[BEFORE_ATTRIBUTE_VALUE_STATE] = function beforeAttributeValueState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK)
        this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;

    else if (cp === $.APOSTROPHE)
        this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;

    else
        this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
};


//12.2.4.38 Attribute value (double-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE] = function attributeValueDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.QUOTATION_MARK;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.39 Attribute value (single-quoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE] = function attributeValueSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.APOSTROPHE;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.40 Attribute value (unquoted) state
//------------------------------------------------------------------
_[ATTRIBUTE_VALUE_UNQUOTED_STATE] = function attributeValueUnquotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.AMPERSAND) {
        this.additionalAllowedCp = $.GREATER_THAN_SIGN;
        this.returnState = this.state;
        this.state = CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.NULL)
        this.currentAttr.value += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN ||
             cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT)
        this.currentAttr.value += toChar(cp);

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this.currentAttr.value += toChar(cp);
};


//12.2.4.41 Character reference in attribute value state
//------------------------------------------------------------------
_[CHARACTER_REFERENCE_IN_ATTRIBUTE_VALUE_STATE] = function characterReferenceInAttributeValueState(cp) {
    var referencedCodePoints = this._consumeCharacterReference(cp, true);

    if (!this._ensureHibernation()) {
        if (referencedCodePoints) {
            for (var i = 0; i < referencedCodePoints.length; i++)
                this.currentAttr.value += toChar(referencedCodePoints[i]);
        }
        else
            this.currentAttr.value += '&';

        this.state = this.returnState;
    }
};


//12.2.4.42 After attribute value (quoted) state
//------------------------------------------------------------------
_[AFTER_ATTRIBUTE_VALUE_QUOTED_STATE] = function afterAttributeValueQuotedState(cp) {
    if (isWhitespace(cp))
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);

    else if (cp === $.SOLIDUS)
        this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);

    else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.43 Self-closing start tag state
//------------------------------------------------------------------
_[SELF_CLOSING_START_TAG_STATE] = function selfClosingStartTagState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.selfClosing = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF)
        this._reconsumeInState(DATA_STATE);

    else
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
};


//12.2.4.44 Bogus comment state
//------------------------------------------------------------------
_[BOGUS_COMMENT_STATE] = function bogusCommentState() {
    this._createCommentToken();
    this._reconsumeInState(BOGUS_COMMENT_STATE_CONTINUATION);
};

//HACK: to support streaming and make BOGUS_COMMENT_STATE reentrant we've
//introduced BOGUS_COMMENT_STATE_CONTINUATION state which will not produce
//comment token on each call.
_[BOGUS_COMMENT_STATE_CONTINUATION] = function bogusCommentStateContinuation(cp) {
    while (true) {
        if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            break;
        }

        else if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            this.currentToken.data += cp === $.NULL ? UNICODE.REPLACEMENT_CHARACTER : toChar(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                return;
        }
    }

    this._emitCurrentToken();
};

//12.2.4.45 Markup declaration open state
//------------------------------------------------------------------
_[MARKUP_DECLARATION_OPEN_STATE] = function markupDeclarationOpenState(cp) {
    var dashDashMatch = this._consumeSubsequentIfMatch($$.DASH_DASH_STRING, cp, true),
        doctypeMatch = !dashDashMatch && this._consumeSubsequentIfMatch($$.DOCTYPE_STRING, cp, false),
        cdataMatch = !dashDashMatch && !doctypeMatch &&
                     this.allowCDATA &&
                     this._consumeSubsequentIfMatch($$.CDATA_START_STRING, cp, true);

    if (!this._ensureHibernation()) {
        if (dashDashMatch) {
            this._createCommentToken();
            this.state = COMMENT_START_STATE;
        }

        else if (doctypeMatch)
            this.state = DOCTYPE_STATE;

        else if (cdataMatch)
            this.state = CDATA_SECTION_STATE;

        else
            this._reconsumeInState(BOGUS_COMMENT_STATE);
    }
};


//12.2.4.46 Comment start state
//------------------------------------------------------------------
_[COMMENT_START_STATE] = function commentStartState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_START_DASH_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.47 Comment start dash state
//------------------------------------------------------------------
_[COMMENT_START_DASH_STATE] = function commentStartDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.48 Comment state
//------------------------------------------------------------------
_[COMMENT_STATE] = function commentState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_DASH_STATE;

    else if (cp === $.NULL)
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.data += toChar(cp);
};


//12.2.4.49 Comment end dash state
//------------------------------------------------------------------
_[COMMENT_END_DASH_STATE] = function commentEndDashState(cp) {
    if (cp === $.HYPHEN_MINUS)
        this.state = COMMENT_END_STATE;

    else if (cp === $.NULL) {
        this.currentToken.data += '-';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '-';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.50 Comment end state
//------------------------------------------------------------------
_[COMMENT_END_STATE] = function commentEndState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.EXCLAMATION_MARK)
        this.state = COMMENT_END_BANG_STATE;

    else if (cp === $.HYPHEN_MINUS)
        this.currentToken.data += '-';

    else if (cp === $.NULL) {
        this.currentToken.data += '--';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._reconsumeInState(DATA_STATE);
        this._emitCurrentToken();
    }

    else {
        this.currentToken.data += '--';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.51 Comment end bang state
//------------------------------------------------------------------
_[COMMENT_END_BANG_STATE] = function commentEndBangState(cp) {
    if (cp === $.HYPHEN_MINUS) {
        this.currentToken.data += '--!';
        this.state = COMMENT_END_DASH_STATE;
    }

    else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else if (cp === $.NULL) {
        this.currentToken.data += '--!';
        this.currentToken.data += UNICODE.REPLACEMENT_CHARACTER;
        this.state = COMMENT_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else {
        this.currentToken.data += '--!';
        this.currentToken.data += toChar(cp);
        this.state = COMMENT_STATE;
    }
};


//12.2.4.52 DOCTYPE state
//------------------------------------------------------------------
_[DOCTYPE_STATE] = function doctypeState(cp) {
    if (isWhitespace(cp))
        return;

    else if (cp === $.GREATER_THAN_SIGN) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
    else {
        this._createDoctypeToken('');
        this._reconsumeInState(DOCTYPE_NAME_STATE);
    }
};


//12.2.4.54 DOCTYPE name state
//------------------------------------------------------------------
_[DOCTYPE_NAME_STATE] = function doctypeNameState(cp) {
    if (isWhitespace(cp) || cp === $.GREATER_THAN_SIGN || cp === $.EOF)
        this._reconsumeInState(AFTER_DOCTYPE_NAME_STATE);

    else if (isAsciiUpper(cp))
        this.currentToken.name += toAsciiLowerChar(cp);

    else if (cp === $.NULL)
        this.currentToken.name += UNICODE.REPLACEMENT_CHARACTER;

    else
        this.currentToken.name += toChar(cp);
};


//12.2.4.55 After DOCTYPE name state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_NAME_STATE] = function afterDoctypeNameState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
    }

    else {
        var publicMatch = this._consumeSubsequentIfMatch($$.PUBLIC_STRING, cp, false),
            systemMatch = !publicMatch && this._consumeSubsequentIfMatch($$.SYSTEM_STRING, cp, false);

        if (!this._ensureHibernation()) {
            if (publicMatch)
                this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;

            else if (systemMatch)
                this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

            else {
                this.currentToken.forceQuirks = true;
                this.state = BOGUS_DOCTYPE_STATE;
            }
        }
    }
};


//12.2.4.57 Before DOCTYPE public identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE] = function beforeDoctypePublicIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.58 DOCTYPE public identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypePublicIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.59 DOCTYPE public identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypePublicIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;

    else if (cp === $.NULL)
        this.currentToken.publicId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.publicId += toChar(cp);
};


//12.2.4.61 Between DOCTYPE public and system identifiers state
//------------------------------------------------------------------
_[BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE] = function betweenDoctypePublicAndSystemIdentifiersState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }


    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.63 Before DOCTYPE system identifier state
//------------------------------------------------------------------
_[BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function beforeDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
    }

    else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
    }

    else {
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
    }
};


//12.2.4.64 DOCTYPE system identifier (double-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE] = function doctypeSystemIdentifierDoubleQuotedState(cp) {
    if (cp === $.QUOTATION_MARK)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.65 DOCTYPE system identifier (single-quoted) state
//------------------------------------------------------------------
_[DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE] = function doctypeSystemIdentifierSingleQuotedState(cp) {
    if (cp === $.APOSTROPHE)
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;

    else if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.NULL)
        this.currentToken.systemId += UNICODE.REPLACEMENT_CHARACTER;

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.currentToken.systemId += toChar(cp);
};


//12.2.4.66 After DOCTYPE system identifier state
//------------------------------------------------------------------
_[AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE] = function afterDoctypeSystemIdentifierState(cp) {
    if (isWhitespace(cp))
        return;

    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }

    else
        this.state = BOGUS_DOCTYPE_STATE;
};


//12.2.4.67 Bogus DOCTYPE state
//------------------------------------------------------------------
_[BOGUS_DOCTYPE_STATE] = function bogusDoctypeState(cp) {
    if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
    }

    else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._reconsumeInState(DATA_STATE);
    }
};


//12.2.4.68 CDATA section state
//------------------------------------------------------------------
_[CDATA_SECTION_STATE] = function cdataSectionState(cp) {
    while (true) {
        if (cp === $.EOF) {
            this._reconsumeInState(DATA_STATE);
            break;
        }

        else {
            var cdataEndMatch = this._consumeSubsequentIfMatch($$.CDATA_END_STRING, cp, true);

            if (this._ensureHibernation())
                break;

            if (cdataEndMatch) {
                this.state = DATA_STATE;
                break;
            }

            this._emitCodePoint(cp);

            this._hibernationSnapshot();
            cp = this._consume();

            if (this._ensureHibernation())
                break;
        }
    }
};


/***/ }),
/* 83 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

var _Util = __webpack_require__(85);

var _background = __webpack_require__(106);

var _border = __webpack_require__(199);

var _borderRadius = __webpack_require__(670);

var _display = __webpack_require__(671);

var _float = __webpack_require__(672);

var _font = __webpack_require__(673);

var _letterSpacing = __webpack_require__(674);

var _lineBreak = __webpack_require__(675);

var _listStyle = __webpack_require__(140);

var _margin = __webpack_require__(676);

var _overflow = __webpack_require__(677);

var _overflowWrap = __webpack_require__(324);

var _padding = __webpack_require__(323);

var _position = __webpack_require__(325);

var _textDecoration = __webpack_require__(198);

var _textShadow = __webpack_require__(678);

var _textTransform = __webpack_require__(326);

var _transform = __webpack_require__(679);

var _visibility = __webpack_require__(680);

var _wordBreak = __webpack_require__(681);

var _zIndex = __webpack_require__(682);

var _Bounds = __webpack_require__(71);

var _Input = __webpack_require__(327);

var _ListItem = __webpack_require__(201);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var INPUT_TAGS = ['INPUT', 'TEXTAREA', 'SELECT'];

var NodeContainer = function () {
    function NodeContainer(node, parent, resourceLoader, index) {
        var _this = this;

        _classCallCheck(this, NodeContainer);

        this.parent = parent;
        this.tagName = node.tagName;
        this.index = index;
        this.childNodes = [];
        this.listItems = [];
        if (typeof node.start === 'number') {
            this.listStart = node.start;
        }
        var defaultView = node.ownerDocument.defaultView;
        var scrollX = defaultView.pageXOffset;
        var scrollY = defaultView.pageYOffset;
        var style = defaultView.getComputedStyle(node, null);
        var display = (0, _display.parseDisplay)(style.display);

        var IS_INPUT = node.type === 'radio' || node.type === 'checkbox';

        var position = (0, _position.parsePosition)(style.position);

        this.style = {
            background: IS_INPUT ? _Input.INPUT_BACKGROUND : (0, _background.parseBackground)(style, resourceLoader),
            border: IS_INPUT ? _Input.INPUT_BORDERS : (0, _border.parseBorder)(style),
            borderRadius: (node instanceof defaultView.HTMLInputElement || node instanceof HTMLInputElement) && IS_INPUT ? (0, _Input.getInputBorderRadius)(node) : (0, _borderRadius.parseBorderRadius)(style),
            color: IS_INPUT ? _Input.INPUT_COLOR : new _Color2.default(style.color),
            display: display,
            float: (0, _float.parseCSSFloat)(style.float),
            font: (0, _font.parseFont)(style),
            letterSpacing: (0, _letterSpacing.parseLetterSpacing)(style.letterSpacing),
            listStyle: display === _display.DISPLAY.LIST_ITEM ? (0, _listStyle.parseListStyle)(style) : null,
            lineBreak: (0, _lineBreak.parseLineBreak)(style.lineBreak),
            margin: (0, _margin.parseMargin)(style),
            opacity: parseFloat(style.opacity),
            overflow: INPUT_TAGS.indexOf(node.tagName) === -1 ? (0, _overflow.parseOverflow)(style.overflow) : _overflow.OVERFLOW.HIDDEN,
            overflowWrap: (0, _overflowWrap.parseOverflowWrap)(style.overflowWrap ? style.overflowWrap : style.wordWrap),
            padding: (0, _padding.parsePadding)(style),
            position: position,
            textDecoration: (0, _textDecoration.parseTextDecoration)(style),
            textShadow: (0, _textShadow.parseTextShadow)(style.textShadow),
            textTransform: (0, _textTransform.parseTextTransform)(style.textTransform),
            transform: (0, _transform.parseTransform)(style),
            visibility: (0, _visibility.parseVisibility)(style.visibility),
            wordBreak: (0, _wordBreak.parseWordBreak)(style.wordBreak),
            zIndex: (0, _zIndex.parseZIndex)(position !== _position.POSITION.STATIC ? style.zIndex : 'auto')
        };

        if (this.isTransformed()) {
            // getBoundingClientRect provides values post-transform, we want them without the transformation
            node.style.transform = 'matrix(1,0,0,1,0,0)';
        }

        if (display === _display.DISPLAY.LIST_ITEM) {
            var listOwner = (0, _ListItem.getListOwner)(this);
            if (listOwner) {
                var listIndex = listOwner.listItems.length;
                listOwner.listItems.push(this);
                this.listIndex = node.hasAttribute('value') && typeof node.value === 'number' ? node.value : listIndex === 0 ? typeof listOwner.listStart === 'number' ? listOwner.listStart : 1 : listOwner.listItems[listIndex - 1].listIndex + 1;
            }
        }

        // TODO move bound retrieval for all nodes to a later stage?
        if (node.tagName === 'IMG') {
            node.addEventListener('load', function () {
                _this.bounds = (0, _Bounds.parseBounds)(node, scrollX, scrollY);
                _this.curvedBounds = (0, _Bounds.parseBoundCurves)(_this.bounds, _this.style.border, _this.style.borderRadius);
            });
        }
        this.image = getImage(node, resourceLoader);
        this.bounds = IS_INPUT ? (0, _Input.reformatInputBounds)((0, _Bounds.parseBounds)(node, scrollX, scrollY)) : (0, _Bounds.parseBounds)(node, scrollX, scrollY);
        this.curvedBounds = (0, _Bounds.parseBoundCurves)(this.bounds, this.style.border, this.style.borderRadius);

        if (false) {
            this.name = '' + node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + node.className.toString().split(' ').map(function (s) {
                return s.length ? '.' + s : '';
            }).join('');
        }
    }

    _createClass(NodeContainer, [{
        key: 'getClipPaths',
        value: function getClipPaths() {
            var parentClips = this.parent ? this.parent.getClipPaths() : [];
            var isClipped = this.style.overflow !== _overflow.OVERFLOW.VISIBLE;

            return isClipped ? parentClips.concat([(0, _Bounds.calculatePaddingBoxPath)(this.curvedBounds)]) : parentClips;
        }
    }, {
        key: 'isInFlow',
        value: function isInFlow() {
            return this.isRootElement() && !this.isFloating() && !this.isAbsolutelyPositioned();
        }
    }, {
        key: 'isVisible',
        value: function isVisible() {
            return !(0, _Util.contains)(this.style.display, _display.DISPLAY.NONE) && this.style.opacity > 0 && this.style.visibility === _visibility.VISIBILITY.VISIBLE;
        }
    }, {
        key: 'isAbsolutelyPositioned',
        value: function isAbsolutelyPositioned() {
            return this.style.position !== _position.POSITION.STATIC && this.style.position !== _position.POSITION.RELATIVE;
        }
    }, {
        key: 'isPositioned',
        value: function isPositioned() {
            return this.style.position !== _position.POSITION.STATIC;
        }
    }, {
        key: 'isFloating',
        value: function isFloating() {
            return this.style.float !== _float.FLOAT.NONE;
        }
    }, {
        key: 'isRootElement',
        value: function isRootElement() {
            return this.parent === null;
        }
    }, {
        key: 'isTransformed',
        value: function isTransformed() {
            return this.style.transform !== null;
        }
    }, {
        key: 'isPositionedWithZIndex',
        value: function isPositionedWithZIndex() {
            return this.isPositioned() && !this.style.zIndex.auto;
        }
    }, {
        key: 'isInlineLevel',
        value: function isInlineLevel() {
            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_FLEX) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_GRID) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_LIST_ITEM) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
        }
    }, {
        key: 'isInlineBlockOrInlineTable',
        value: function isInlineBlockOrInlineTable() {
            return (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_BLOCK) || (0, _Util.contains)(this.style.display, _display.DISPLAY.INLINE_TABLE);
        }
    }]);

    return NodeContainer;
}();

exports.default = NodeContainer;


var getImage = function getImage(node, resourceLoader) {
    if (node instanceof node.ownerDocument.defaultView.SVGSVGElement || node instanceof SVGSVGElement) {
        var s = new XMLSerializer();
        return resourceLoader.loadImage('data:image/svg+xml,' + encodeURIComponent(s.serializeToString(node)));
    }
    switch (node.tagName) {
        case 'IMG':
            // $FlowFixMe
            var img = node;
            return resourceLoader.loadImage(img.currentSrc || img.src);
        case 'CANVAS':
            // $FlowFixMe
            var canvas = node;
            return resourceLoader.loadCanvas(canvas);
        case 'IFRAME':
            var iframeKey = node.getAttribute('data-html2canvas-internal-iframe-key');
            if (iframeKey) {
                return iframeKey;
            }
            break;
    }

    return null;
};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var contains = exports.contains = function contains(bit, value) {
    return (bit & value) !== 0;
};

var distance = exports.distance = function distance(a, b) {
    return Math.sqrt(a * a + b * b);
};

var copyCSSStyles = exports.copyCSSStyles = function copyCSSStyles(style, target) {
    // Edge does not provide value for cssText
    for (var i = style.length - 1; i >= 0; i--) {
        var property = style.item(i);
        // Safari shows pseudoelements if content is set
        if (property !== 'content') {
            target.style.setProperty(property, style.getPropertyValue(property));
        }
    }
    return target;
};

var SMALL_IMAGE = exports.SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.polarToCartesian = polarToCartesian;
exports.arcCommands = arcCommands;
exports.translateEndAngle = translateEndAngle;
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var POST_DECIMAL_DIGITS = 10;

var baseUnit = exports.baseUnit = 24;

function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
  var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};

function arcCommands(centerX, centerY, radius, startAngle, endAngle) {
  // handle that we can't draw a complete circle
  if (endAngle - startAngle >= 360) {
    endAngle = startAngle + 359.99;
  }
  var start = polarToCartesian(centerX, centerY, radius, endAngle);
  var end = polarToCartesian(centerX, centerY, radius, startAngle);
  var arcSweep = endAngle - startAngle <= 180 ? "0" : "1";
  var d = ["M", start.x.toFixed(POST_DECIMAL_DIGITS), start.y.toFixed(POST_DECIMAL_DIGITS), "A", radius.toFixed(POST_DECIMAL_DIGITS), radius.toFixed(POST_DECIMAL_DIGITS), 0, arcSweep, 0, end.x.toFixed(POST_DECIMAL_DIGITS), end.y.toFixed(POST_DECIMAL_DIGITS)].join(" ");
  return d;
};

function translateEndAngle(startAngle, anglePer, value) {
  return Math.min(360, Math.max(0, startAngle + anglePer * value));
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toPrimitive = __webpack_require__(373);

// https://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Math = GetIntrinsic('%Math%');

var $floor = $Math.floor;
var $abs = $Math.abs;

var $isNaN = __webpack_require__(43);
var $isFinite = __webpack_require__(44);

// https://www.ecma-international.org/ecma-262/6.0/#sec-isinteger

module.exports = function IsInteger(argument) {
	if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
		return false;
	}
	var abs = $abs(argument);
	return $floor(abs) === abs;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var has = __webpack_require__(36);
var $TypeError = GetIntrinsic('%TypeError%');

module.exports = function IsPropertyDescriptor(ES, Desc) {
	if (ES.Type(Desc) !== 'Object') {
		return false;
	}
	var allowed = {
		'[[Configurable]]': true,
		'[[Enumerable]]': true,
		'[[Get]]': true,
		'[[Set]]': true,
		'[[Value]]': true,
		'[[Writable]]': true
	};

    for (var key in Desc) { // eslint-disable-line
		if (has(Desc, key) && !allowed[key]) {
			return false;
		}
	}

	if (ES.IsDataDescriptor(Desc) && ES.IsAccessorDescriptor(Desc)) {
		throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	}
	return true;
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var has = __webpack_require__(36);

var predicates = {
	// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	'Property Descriptor': function isPropertyDescriptor(Type, Desc) {
		if (Type(Desc) !== 'Object') {
			return false;
		}
		var allowed = {
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Get]]': true,
			'[[Set]]': true,
			'[[Value]]': true,
			'[[Writable]]': true
		};

		for (var key in Desc) { // eslint-disable-line
			if (has(Desc, key) && !allowed[key]) {
				return false;
			}
		}

		var isData = has(Desc, '[[Value]]');
		var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
		if (isData && IsAccessor) {
			throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
		}
		return true;
	}
};

module.exports = function assertRecord(Type, recordType, argumentName, value) {
	var predicate = predicates[recordType];
	if (typeof predicate !== 'function') {
		throw new $SyntaxError('unknown record type: ' + recordType);
	}
	if (!predicate(Type, value)) {
		throw new $TypeError(argumentName + ' must be a ' + recordType);
	}
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Object = GetIntrinsic('%Object%');

var isPrimitive = __webpack_require__(214);

var $preventExtensions = $Object.preventExtensions;
var $isExtensible = $Object.isExtensible;

// https://www.ecma-international.org/ecma-262/6.0/#sec-isextensible-o

module.exports = $preventExtensions
	? function IsExtensible(obj) {
		return !isPrimitive(obj) && $isExtensible(obj);
	}
	: function IsExtensible(obj) { // eslint-disable-line no-unused-vars
		return true;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(90);

var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-frompropertydescriptor

module.exports = function FromPropertyDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return Desc;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	var obj = {};
	if ('[[Value]]' in Desc) {
		obj.value = Desc['[[Value]]'];
	}
	if ('[[Writable]]' in Desc) {
		obj.writable = Desc['[[Writable]]'];
	}
	if ('[[Get]]' in Desc) {
		obj.get = Desc['[[Get]]'];
	}
	if ('[[Set]]' in Desc) {
		obj.set = Desc['[[Set]]'];
	}
	if ('[[Enumerable]]' in Desc) {
		obj.enumerable = Desc['[[Enumerable]]'];
	}
	if ('[[Configurable]]' in Desc) {
		obj.configurable = Desc['[[Configurable]]'];
	}
	return obj;
};


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(121);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.RADIO_BUTTON;

var RadioButton = function (_Component) {
  _inherits(RadioButton, _Component);

  function RadioButton() {
    _classCallCheck(this, RadioButton);

    return _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
  }

  _createClass(RadioButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          props = _objectWithoutProperties(_props, ['className', 'label']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--disabled', props.disabled), className);

      return _react2.default.createElement(
        'label',
        { htmlFor: props.id, className: classes },
        _react2.default.createElement('input', _extends({}, props, { className: CLASS_ROOT + '__input',
          type: 'radio' })),
        _react2.default.createElement('span', { className: CLASS_ROOT + '__control' }),
        _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__label' },
          label
        )
      );
    }
  }]);

  return RadioButton;
}(_react.Component);

RadioButton.displayName = 'RadioButton';
exports.default = RadioButton;


RadioButton.propTypes = {
  checked: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  id: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.node.isRequired,
  name: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.string
};
module.exports = exports['default'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-next-link', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-next-link');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,12.4 L18,12.4 M12.6,7 L18,12.4 L12.6,17.8' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormNextLink';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
var checkPath=function checkPath(text){return window.location.href.toUpperCase().indexOf(text.toUpperCase())!==-1;};var Warning=function Warning(props){var isEnabled=props.isEnabled,message=props.message,history=props.history;var displayStyle=checkPath(__WEBPACK_IMPORTED_MODULE_4__Redux_action_types_EPAConstants_js__["_52" /* HPECP_SIZER */])&&!isEnabled?{display:'block'}:{display:'none'};var optionalMessage=checkPath(__WEBPACK_IMPORTED_MODULE_4__Redux_action_types_EPAConstants_js__["_51" /* HPECP_CONTAINER_PAGE */].toUpperCase());return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'none',margin:'none',style:displayStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',direction:'row',margin:'none',pad:'small',style:{backgroundColor:'yellow'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_icons_base_Alert___default.a,{size:'small',margin:'small',type:'status'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Label___default.a,{style:{marginLeft:'10px'},size:'medium',margin:'none'},message),!optionalMessage?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Label___default.a,{size:'medium',margin:'none',style:{marginLeft:'10px',cursor:'pointer',textDecoration:'underline'},onClick:function onClick(){return history.push('/Build/HPEEzmeralRuntimeEnterprise');}},__WEBPACK_IMPORTED_MODULE_4__Redux_action_types_EPAConstants_js__["_104" /* NAV_MESSAGE */]):''));};/* harmony default export */ __webpack_exports__["a"] = (Warning);

/***/ }),
/* 99 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(560);
var defined = __webpack_require__(290);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.REPLACEMENT_CHARACTER = '\uFFFD';

exports.CODE_POINTS = {
    EOF: -1,
    NULL: 0x00,
    TABULATION: 0x09,
    CARRIAGE_RETURN: 0x0D,
    LINE_FEED: 0x0A,
    FORM_FEED: 0x0C,
    SPACE: 0x20,
    EXCLAMATION_MARK: 0x21,
    QUOTATION_MARK: 0x22,
    NUMBER_SIGN: 0x23,
    AMPERSAND: 0x26,
    APOSTROPHE: 0x27,
    HYPHEN_MINUS: 0x2D,
    SOLIDUS: 0x2F,
    DIGIT_0: 0x30,
    DIGIT_9: 0x39,
    SEMICOLON: 0x3B,
    LESS_THAN_SIGN: 0x3C,
    EQUALS_SIGN: 0x3D,
    GREATER_THAN_SIGN: 0x3E,
    QUESTION_MARK: 0x3F,
    LATIN_CAPITAL_A: 0x41,
    LATIN_CAPITAL_F: 0x46,
    LATIN_CAPITAL_X: 0x58,
    LATIN_CAPITAL_Z: 0x5A,
    GRAVE_ACCENT: 0x60,
    LATIN_SMALL_A: 0x61,
    LATIN_SMALL_F: 0x66,
    LATIN_SMALL_X: 0x78,
    LATIN_SMALL_Z: 0x7A,
    REPLACEMENT_CHARACTER: 0xFFFD
};

exports.CODE_POINT_SEQUENCES = {
    DASH_DASH_STRING: [0x2D, 0x2D], //--
    DOCTYPE_STRING: [0x44, 0x4F, 0x43, 0x54, 0x59, 0x50, 0x45], //DOCTYPE
    CDATA_START_STRING: [0x5B, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5B], //[CDATA[
    CDATA_END_STRING: [0x5D, 0x5D, 0x3E], //]]>
    SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74], //script
    PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4C, 0x49, 0x43], //PUBLIC
    SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4D] //SYSTEM
};


/***/ }),
/* 103 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(196).Buffer))

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _CanvasRenderer = __webpack_require__(321);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _Logger = __webpack_require__(322);

var _Logger2 = _interopRequireDefault(_Logger);

var _Window = __webpack_require__(665);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var html2canvas = function html2canvas(element, conf) {
    var config = conf || {};
    var logger = new _Logger2.default(typeof config.logging === 'boolean' ? config.logging : true);
    logger.log('html2canvas ' + "$npm_package_version");

    if (false) {
        logger.error('onrendered option is deprecated, html2canvas returns a Promise with the canvas as the value');
    }

    var ownerDocument = element.ownerDocument;
    if (!ownerDocument) {
        return Promise.reject('Provided element is not within a Document');
    }
    var defaultView = ownerDocument.defaultView;

    var defaultOptions = {
        async: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        imageTimeout: 15000,
        logging: true,
        proxy: null,
        removeContainer: true,
        foreignObjectRendering: false,
        scale: defaultView.devicePixelRatio || 1,
        target: new _CanvasRenderer2.default(config.canvas),
        useCORS: false,
        windowWidth: defaultView.innerWidth,
        windowHeight: defaultView.innerHeight,
        scrollX: defaultView.pageXOffset,
        scrollY: defaultView.pageYOffset
    };

    var result = (0, _Window.renderElement)(element, _extends({}, defaultOptions, config), logger);

    if (false) {
        return result.catch(function (e) {
            logger.error(e);
            throw e;
        });
    }
    return result;
};

html2canvas.CanvasRenderer = _CanvasRenderer2.default;

module.exports = html2canvas;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBackgroundImage = exports.parseBackground = exports.calculateBackgroundRepeatPath = exports.calculateBackgroundPosition = exports.calculateBackgroungPositioningArea = exports.calculateBackgroungPaintingArea = exports.calculateGradientBackgroundSize = exports.calculateBackgroundSize = exports.BACKGROUND_ORIGIN = exports.BACKGROUND_CLIP = exports.BACKGROUND_SIZE = exports.BACKGROUND_REPEAT = undefined;

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

var _Size = __webpack_require__(668);

var _Size2 = _interopRequireDefault(_Size);

var _Vector = __webpack_require__(139);

var _Vector2 = _interopRequireDefault(_Vector);

var _Bounds = __webpack_require__(71);

var _padding = __webpack_require__(323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BACKGROUND_REPEAT = exports.BACKGROUND_REPEAT = {
    REPEAT: 0,
    NO_REPEAT: 1,
    REPEAT_X: 2,
    REPEAT_Y: 3
};

var BACKGROUND_SIZE = exports.BACKGROUND_SIZE = {
    AUTO: 0,
    CONTAIN: 1,
    COVER: 2,
    LENGTH: 3
};

var BACKGROUND_CLIP = exports.BACKGROUND_CLIP = {
    BORDER_BOX: 0,
    PADDING_BOX: 1,
    CONTENT_BOX: 2
};

var BACKGROUND_ORIGIN = exports.BACKGROUND_ORIGIN = BACKGROUND_CLIP;

var AUTO = 'auto';

var BackgroundSize = function BackgroundSize(size) {
    _classCallCheck(this, BackgroundSize);

    switch (size) {
        case 'contain':
            this.size = BACKGROUND_SIZE.CONTAIN;
            break;
        case 'cover':
            this.size = BACKGROUND_SIZE.COVER;
            break;
        case 'auto':
            this.size = BACKGROUND_SIZE.AUTO;
            break;
        default:
            this.value = new _Length2.default(size);
    }
};

var calculateBackgroundSize = exports.calculateBackgroundSize = function calculateBackgroundSize(backgroundImage, image, bounds) {
    var width = 0;
    var height = 0;
    var size = backgroundImage.size;
    if (size[0].size === BACKGROUND_SIZE.CONTAIN || size[0].size === BACKGROUND_SIZE.COVER) {
        var targetRatio = bounds.width / bounds.height;
        var currentRatio = image.width / image.height;
        return targetRatio < currentRatio !== (size[0].size === BACKGROUND_SIZE.COVER) ? new _Size2.default(bounds.width, bounds.width / currentRatio) : new _Size2.default(bounds.height * currentRatio, bounds.height);
    }

    if (size[0].value) {
        width = size[0].value.getAbsoluteValue(bounds.width);
    }

    if (size[0].size === BACKGROUND_SIZE.AUTO && size[1].size === BACKGROUND_SIZE.AUTO) {
        height = image.height;
    } else if (size[1].size === BACKGROUND_SIZE.AUTO) {
        height = width / image.width * image.height;
    } else if (size[1].value) {
        height = size[1].value.getAbsoluteValue(bounds.height);
    }

    if (size[0].size === BACKGROUND_SIZE.AUTO) {
        width = height / image.height * image.width;
    }

    return new _Size2.default(width, height);
};

var calculateGradientBackgroundSize = exports.calculateGradientBackgroundSize = function calculateGradientBackgroundSize(backgroundImage, bounds) {
    var size = backgroundImage.size;
    var width = size[0].value ? size[0].value.getAbsoluteValue(bounds.width) : bounds.width;
    var height = size[1].value ? size[1].value.getAbsoluteValue(bounds.height) : size[0].value ? width : bounds.height;

    return new _Size2.default(width, height);
};

var AUTO_SIZE = new BackgroundSize(AUTO);

var calculateBackgroungPaintingArea = exports.calculateBackgroungPaintingArea = function calculateBackgroungPaintingArea(curves, clip) {
    switch (clip) {
        case BACKGROUND_CLIP.BORDER_BOX:
            return (0, _Bounds.calculateBorderBoxPath)(curves);
        case BACKGROUND_CLIP.PADDING_BOX:
        default:
            return (0, _Bounds.calculatePaddingBoxPath)(curves);
    }
};

var calculateBackgroungPositioningArea = exports.calculateBackgroungPositioningArea = function calculateBackgroungPositioningArea(backgroundOrigin, bounds, padding, border) {
    var paddingBox = (0, _Bounds.calculatePaddingBox)(bounds, border);

    switch (backgroundOrigin) {
        case BACKGROUND_ORIGIN.BORDER_BOX:
            return bounds;
        case BACKGROUND_ORIGIN.CONTENT_BOX:
            var paddingLeft = padding[_padding.PADDING_SIDES.LEFT].getAbsoluteValue(bounds.width);
            var paddingRight = padding[_padding.PADDING_SIDES.RIGHT].getAbsoluteValue(bounds.width);
            var paddingTop = padding[_padding.PADDING_SIDES.TOP].getAbsoluteValue(bounds.width);
            var paddingBottom = padding[_padding.PADDING_SIDES.BOTTOM].getAbsoluteValue(bounds.width);
            return new _Bounds.Bounds(paddingBox.left + paddingLeft, paddingBox.top + paddingTop, paddingBox.width - paddingLeft - paddingRight, paddingBox.height - paddingTop - paddingBottom);
        case BACKGROUND_ORIGIN.PADDING_BOX:
        default:
            return paddingBox;
    }
};

var calculateBackgroundPosition = exports.calculateBackgroundPosition = function calculateBackgroundPosition(position, size, bounds) {
    return new _Vector2.default(position[0].getAbsoluteValue(bounds.width - size.width), position[1].getAbsoluteValue(bounds.height - size.height));
};

var calculateBackgroundRepeatPath = exports.calculateBackgroundRepeatPath = function calculateBackgroundRepeatPath(background, position, size, backgroundPositioningArea, bounds) {
    var repeat = background.repeat;
    switch (repeat) {
        case BACKGROUND_REPEAT.REPEAT_X:
            return [new _Vector2.default(Math.round(bounds.left), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(size.height + backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(bounds.left), Math.round(size.height + backgroundPositioningArea.top + position.y))];
        case BACKGROUND_REPEAT.REPEAT_Y:
            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(bounds.height + bounds.top))];
        case BACKGROUND_REPEAT.NO_REPEAT:
            return [new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x + size.width), Math.round(backgroundPositioningArea.top + position.y + size.height)), new _Vector2.default(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y + size.height))];
        default:
            return [new _Vector2.default(Math.round(bounds.left), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.top)), new _Vector2.default(Math.round(bounds.left + bounds.width), Math.round(bounds.height + bounds.top)), new _Vector2.default(Math.round(bounds.left), Math.round(bounds.height + bounds.top))];
    }
};

var parseBackground = exports.parseBackground = function parseBackground(style, resourceLoader) {
    return {
        backgroundColor: new _Color2.default(style.backgroundColor),
        backgroundImage: parseBackgroundImages(style, resourceLoader),
        backgroundClip: parseBackgroundClip(style.backgroundClip),
        backgroundOrigin: parseBackgroundOrigin(style.backgroundOrigin)
    };
};

var parseBackgroundClip = function parseBackgroundClip(backgroundClip) {
    switch (backgroundClip) {
        case 'padding-box':
            return BACKGROUND_CLIP.PADDING_BOX;
        case 'content-box':
            return BACKGROUND_CLIP.CONTENT_BOX;
    }
    return BACKGROUND_CLIP.BORDER_BOX;
};

var parseBackgroundOrigin = function parseBackgroundOrigin(backgroundOrigin) {
    switch (backgroundOrigin) {
        case 'padding-box':
            return BACKGROUND_ORIGIN.PADDING_BOX;
        case 'content-box':
            return BACKGROUND_ORIGIN.CONTENT_BOX;
    }
    return BACKGROUND_ORIGIN.BORDER_BOX;
};

var parseBackgroundRepeat = function parseBackgroundRepeat(backgroundRepeat) {
    switch (backgroundRepeat.trim()) {
        case 'no-repeat':
            return BACKGROUND_REPEAT.NO_REPEAT;
        case 'repeat-x':
        case 'repeat no-repeat':
            return BACKGROUND_REPEAT.REPEAT_X;
        case 'repeat-y':
        case 'no-repeat repeat':
            return BACKGROUND_REPEAT.REPEAT_Y;
        case 'repeat':
            return BACKGROUND_REPEAT.REPEAT;
    }

    if (false) {
        console.error('Invalid background-repeat value "' + backgroundRepeat + '"');
    }

    return BACKGROUND_REPEAT.REPEAT;
};

var parseBackgroundImages = function parseBackgroundImages(style, resourceLoader) {
    var sources = parseBackgroundImage(style.backgroundImage).map(function (backgroundImage) {
        if (backgroundImage.method === 'url') {
            var key = resourceLoader.loadImage(backgroundImage.args[0]);
            backgroundImage.args = key ? [key] : [];
        }
        return backgroundImage;
    });
    var positions = style.backgroundPosition.split(',');
    var repeats = style.backgroundRepeat.split(',');
    var sizes = style.backgroundSize.split(',');

    return sources.map(function (source, index) {
        var size = (sizes[index] || AUTO).trim().split(' ').map(parseBackgroundSize);
        var position = (positions[index] || AUTO).trim().split(' ').map(parseBackgoundPosition);

        return {
            source: source,
            repeat: parseBackgroundRepeat(typeof repeats[index] === 'string' ? repeats[index] : repeats[0]),
            size: size.length < 2 ? [size[0], AUTO_SIZE] : [size[0], size[1]],
            position: position.length < 2 ? [position[0], position[0]] : [position[0], position[1]]
        };
    });
};

var parseBackgroundSize = function parseBackgroundSize(size) {
    return size === 'auto' ? AUTO_SIZE : new BackgroundSize(size);
};

var parseBackgoundPosition = function parseBackgoundPosition(position) {
    switch (position) {
        case 'bottom':
        case 'right':
            return new _Length2.default('100%');
        case 'left':
        case 'top':
            return new _Length2.default('0%');
        case 'auto':
            return new _Length2.default('0');
    }
    return new _Length2.default(position);
};

var parseBackgroundImage = exports.parseBackgroundImage = function parseBackgroundImage(image) {
    var whitespace = /^\s$/;
    var results = [];

    var args = [];
    var method = '';
    var quote = null;
    var definition = '';
    var mode = 0;
    var numParen = 0;

    var appendResult = function appendResult() {
        var prefix = '';
        if (method) {
            if (definition.substr(0, 1) === '"') {
                definition = definition.substr(1, definition.length - 2);
            }

            if (definition) {
                args.push(definition.trim());
            }

            var prefix_i = method.indexOf('-', 1) + 1;
            if (method.substr(0, 1) === '-' && prefix_i > 0) {
                prefix = method.substr(0, prefix_i).toLowerCase();
                method = method.substr(prefix_i);
            }
            method = method.toLowerCase();
            if (method !== 'none') {
                results.push({
                    prefix: prefix,
                    method: method,
                    args: args
                });
            }
        }
        args = [];
        method = definition = '';
    };

    image.split('').forEach(function (c) {
        if (mode === 0 && whitespace.test(c)) {
            return;
        }
        switch (c) {
            case '"':
                if (!quote) {
                    quote = c;
                } else if (quote === c) {
                    quote = null;
                }
                break;
            case '(':
                if (quote) {
                    break;
                } else if (mode === 0) {
                    mode = 1;
                    return;
                } else {
                    numParen++;
                }
                break;
            case ')':
                if (quote) {
                    break;
                } else if (mode === 1) {
                    if (numParen === 0) {
                        mode = 0;
                        appendResult();
                        return;
                    } else {
                        numParen--;
                    }
                }
                break;

            case ',':
                if (quote) {
                    break;
                } else if (mode === 0) {
                    appendResult();
                    return;
                } else if (mode === 1) {
                    if (numParen === 0 && !method.match(/^url$/i)) {
                        args.push(definition.trim());
                        definition = '';
                        return;
                    }
                }
                break;
        }

        if (mode === 0) {
            method += c;
        } else {
            definition += c;
        }
    });

    appendResult();
    return results;
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.baseDimension = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.buildPath = buildPath;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Graphics = __webpack_require__(86);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_ROOT = _CSSClassnames2.default.METER;

var baseDimension = exports.baseDimension = _Graphics.baseUnit * 8;

var propTypes = exports.propTypes = {
  activeIndex: _propTypes2.default.number,
  a11yTitle: _propTypes2.default.string,
  max: _propTypes2.default.number.isRequired,
  min: _propTypes2.default.number.isRequired,
  onActivate: _propTypes2.default.func,
  series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.number.isRequired,
    colorIndex: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  })).isRequired,
  total: _propTypes2.default.number
};

function buildPath(itemIndex, commands, classes, onActivate, onClick, a11yTitle, role) {
  if (onActivate) {
    var onOver = onActivate.bind(null, itemIndex);
    var onOut = onActivate.bind(null, undefined);

    var a11yRoles = {};
    if (a11yTitle) {
      a11yRoles['aria-label'] = a11yTitle;
      a11yRoles.role = role;
    }

    return _react2.default.createElement(
      'g',
      _extends({ key: itemIndex }, a11yRoles),
      _react2.default.createElement('path', { className: classes, d: commands,
        'data-index': itemIndex, onFocus: onOver, onBlur: onOut }),
      _react2.default.createElement('path', { className: CLASS_ROOT + '__hot', d: commands, fill: 'none',
        onMouseOver: onOver, onMouseOut: onOut,
        onClick: onClick })
    );
  } else {
    return _react2.default.createElement('path', { key: itemIndex, className: classes, d: commands });
  }
}

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(110);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var arePropertyDescriptorsSupported = function () {
	var obj = {};
	try {
		origDefineProperty(obj, 'x', { enumerable: false, value: obj });
		// eslint-disable-next-line no-unused-vars, no-restricted-syntax
		for (var _ in obj) { // jscs:ignore disallowUnusedVariables
			return false;
		}
		return obj.x === obj;
	} catch (e) { /* this is IE 8. */
		return false;
	}
};
var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value;
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(209);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(369);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var origSymbol = global.Symbol;
var hasSymbolSham = __webpack_require__(211);

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(372);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $defineProperty = GetIntrinsic('%Object.defineProperty%');

var callBound = __webpack_require__(16);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

// eslint-disable-next-line max-params
module.exports = function DefineOwnProperty(IsDataDescriptor, SameValue, FromPropertyDescriptor, O, P, desc) {
	if (!$defineProperty) {
		if (!IsDataDescriptor(desc)) {
			// ES3 does not support getters/setters
			return false;
		}
		if (!desc['[[Configurable]]'] || !desc['[[Writable]]']) {
			return false;
		}

		// fallback for ES3
		if (P in O && $isEnumerable(O, P) !== !!desc['[[Enumerable]]']) {
			// a non-enumerable existing property
			return false;
		}

		// property does not exist at all, or exists but is enumerable
		var V = desc['[[Value]]'];
		// eslint-disable-next-line no-param-reassign
		O[P] = V; // will use [[Define]]
		return SameValue(O[P], V);
	}
	$defineProperty(O, P, FromPropertyDescriptor(desc));
	return true;
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://www.ecma-international.org/ecma-262/6.0/#sec-isconstructor

module.exports = function IsConstructor(argument) {
	return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES5ToInteger = __webpack_require__(396);

var ToNumber = __webpack_require__(26);

// https://www.ecma-international.org/ecma-262/6.0/#sec-tointeger

module.exports = function ToInteger(value) {
	var number = ToNumber(value);
	return ES5ToInteger(number);
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $floor = GetIntrinsic('%Math.floor%');

var msPerDay = __webpack_require__(46).msPerDay;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.2

module.exports = function Day(t) {
	return $floor(t / msPerDay);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Date = GetIntrinsic('%Date%');

var callBound = __webpack_require__(16);

var $getUTCFullYear = callBound('Date.prototype.getUTCFullYear');

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3

module.exports = function YearFromTime(t) {
	// largest y such that this.TimeFromYear(y) <= t
	return $getUTCFullYear(new $Date(t));
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var GetV = __webpack_require__(155);
var IsCallable = __webpack_require__(56);
var IsPropertyKey = __webpack_require__(19);

/**
 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
 * 1. Assert: IsPropertyKey(P) is true.
 * 2. Let func be GetV(O, P).
 * 3. ReturnIfAbrupt(func).
 * 4. If func is either undefined or null, return undefined.
 * 5. If IsCallable(func) is false, throw a TypeError exception.
 * 6. Return func.
 */

module.exports = function GetMethod(O, P) {
	// 7.3.9.1
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	// 7.3.9.2
	var func = GetV(O, P);

	// 7.3.9.4
	if (func == null) {
		return void 0;
	}

	// 7.3.9.5
	if (!IsCallable(func)) {
		throw new $TypeError(P + 'is not a function');
	}

	// 7.3.9.6
	return func;
};


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(467);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': 'accès accessibilité',
  'access-ad': 'accès ad',
  'access-assist-listening': 'accès assistance audio',
  'access-braille': 'accès braille',
  'access-sign': 'accès langage des signes',
  'access-tty': 'accès tty',
  'access-volume-control': 'accès contrôle de volume',
  'access-wheelchair-active': 'accès chaise-roulante active',
  'access-wheelchair': 'accès chaise-roulante',
  'achievement': 'réussite',
  'action': 'action',
  'actions': 'actions',
  'add-circle': 'cercle d\'ajout',
  'add': 'ajout',
  'aggregate': 'aggrégation',
  'aid': 'soin',
  'alarm': 'alarme',
  'alert': 'alerte',
  'analytics': 'analyse',
  'announce': 'annonce',
  'apps': 'applications',
  'archive': 'archive',
  'article': 'article',
  'ascend': 'ascendant',
  'attachment': 'joint',
  'back-ten': 'retour dix',
  'bar-chart': 'diagramme  à bande',
  'basket': 'panier',
  'blog': 'blog',
  'book': 'livre',
  'bookmark': 'signet',
  'bottom-corner': 'coin inférieur',
  'brand-apple-app-store': 'étiquette apple app store',
  'brand-codepen-edit': 'étiquette codepen edit',
  'brand-codepen-try': 'étiquette codepen try',
  'brand-google-play': 'étiquette google play',
  'brand-grommet-outline': 'étiquette grommet outline',
  'brand-grommet-path': 'étiquette grommet path',
  'brand-hpe-element-outline': 'étiquette hpe element outline',
  'brand-hpe-element-path': 'étiquette hpe element path',
  'brand-hpe-labs-insignia-outline': 'étiquette hpe labs insignia outline',
  'brand-hpe-labs-insignia': 'étiquette hpe labs insignia',
  'brand-hpe-stack-centered': 'étiquette hpe stack centered',
  'brand-hpe-stack': 'étiquette hpe stack',
  'briefcase': 'porte document',
  'brush': 'brosse',
  'bug': 'insecte',
  'bundle': 'paquet',
  'business-service': 'service d\'affaire',
  'calculator': 'calculatrice',
  'calendar': 'calendrier',
  'camera': 'camera',
  'capacity': 'capacité',
  'car': 'voiture',
  'caret-down': 'caret bas',
  'caret-next': 'caret suivant',
  'caret-previous': 'caret précédant',
  'caret-up': 'caret haut',
  'cart': 'panier',
  'catalog': 'catalogue',
  'chapter-add': 'ajout de chapitre',
  'chapter-next': 'chapitre suivant',
  'chapter-previous': 'chapitre précédent',
  'chat': 'clavardage',
  'checkbox-selected': 'case sélectionnée',
  'checkbox': 'case de sélection',
  'checkmark': 'crochet',
  'circle-information': 'cercle d\'information',
  'circle-play': 'cercle play',
  'circle-question': 'cercle question',
  'clear-option': 'option nettoyer',
  'clear': 'nettoyer',
  'cli': 'cli',
  'clipboard': 'presse papier',
  'clock': 'horloge',
  'clone': 'clône',
  'close': 'fermer',
  'closed-caption': 'sous-titrage',
  'cloud-computer': 'ordinateur du nuage',
  'cloud-download': 'téléchargement du nuage',
  'cloud-software': 'logiciel du nuage',
  'cloud-upload': 'téléchargement sur le nuage',
  'cloud': 'nuage',
  'cluster': 'cluster',
  'code': 'code',
  'columns': 'colonnes',
  'compare': 'comparaison',
  'compass': 'boussole',
  'compliance': 'conformité',
  'configure': 'configuration',
  'connect': 'connexion',
  'contact-info': 'info du contact',
  'contact': 'contact',
  'contract': 'contrat',
  'copy': 'copie',
  'credit-card': 'carte de crédit',
  'cube': 'cube',
  'cubes': 'cubes',
  'currency': 'monnaie',
  'cursor': 'curseur',
  'cut': 'couper',
  'cycle': 'cycle',
  'dashboard': 'tableau de bord',
  'database': 'base de données',
  'deliver': 'livraison',
  'deploy': 'déployer',
  'descend': 'descendant',
  'desktop': 'ordinateur',
  'detach': 'disjoint',
  'diamond': 'diamand',
  'directions': 'directions',
  'dislike': 'je n\'aime pas',
  'document-cloud': 'fichier du nuage',
  'document-config': 'fichier de config',
  'document-csv': 'fichier csv',
  'document-download': 'téléchargement de fichier',
  'document-excel': 'fichier excel',
  'document-exe': 'fichier exe',
  'document-image': 'fichier d\'image',
  'document-locked': 'fichier vérouillé',
  'document-missing': 'fichier manquant',
  'document-notes': 'fichier de notes',
  'document-outlook': 'fichier outlook',
  'document-pdf': 'fichier pdf',
  'document-performance': 'fichier de performance',
  'document-ppt': 'fichier ppt',
  'document-rtf': 'fichier rtf',
  'document-sound': 'fichier audio',
  'document-store': 'fichier de sauvegarde',
  'document-test': 'fichier de test',
  'document-threat': 'fichier dangereux',
  'document-time': 'historique du fichier',
  'document-transfer': 'transfère de fichier',
  'document-txt': 'fichier txt',
  'document-update': 'mise à jour de fichier',
  'document-upload': 'téléversement de fichier',
  'document-user': 'fichier utilisateur',
  'document-verified': 'fichier vérifié',
  'document-video': 'fichier video',
  'document-windows': 'fichier windows',
  'document-word': 'fichier word',
  'document-zip': 'fichier zip',
  'document': 'fichier',
  'domain': 'domaine',
  'down': 'bas',
  'download': 'télécharger',
  'drag': 'glisser',
  'drive-cage': 'cage de disque',
  'duplicate': 'dupliquer',
  'edit': 'éditer',
  'eject': 'éjecter',
  'empty-circle': 'cercle vide',
  'expand': 'agrandir',
  'fan': 'ventilateur',
  'fast-forward': 'avance rapide',
  'favorite': 'favorie',
  'filter': 'filtre',
  'finger-print': 'empreinte digitale',
  'flag': 'drapeau',
  'folder-cycle': 'dossier cyclique',
  'folder-open': 'dossier ouvert',
  'folder': 'dossier',
  'form-edit': 'éditer le formulaire',
  'forward-ten': 'avance dix',
  'gallery': 'galerie',
  'gamepad': 'mannette',
  'gift': 'cadeau',
  'globe': 'globe',
  'grid': 'grille',
  'group': 'groupe',
  'grow': 'pousser',
  'halt': 'arrêt',
  'help': 'aide',
  'history': 'historique',
  'home': 'maison',
  'host-maintenance': 'maintenance de l\'hôte',
  'host': 'hôte',
  'image': 'image',
  'impact': 'impacte',
  'in-progress': 'en cours',
  'inbox': 'boîte',
  'indicator': 'indicateurr',
  'info': 'info',
  'inherit': 'héritage',
  'inspect': 'inspecter',
  'install': 'installer',
  'integration': 'integration',
  'iteration': 'itération',
  'java': 'java',
  'language': 'langue',
  'launch': 'lancer',
  'layer': 'calque',
  'license': 'license',
  'like': 'j\'aime',
  'line-chart': 'diagramme à ligne',
  'link-bottom': 'lien inférieur',
  'link-down': 'lien vers le bas',
  'link-next': 'lien suivant',
  'link-previous': 'lien précédent',
  'link-top': 'lien vers le haut',
  'link-up': 'lien supérieur',
  'link': 'lien',
  'local': 'locale',
  'location-pin': 'point de localisation',
  'location': 'localisation',
  'lock': 'verrou',
  'login': 'connexion',
  'logout': 'déconnexion',
  'magic': 'magie',
  'mail-option': 'option de courriel',
  'mail': 'courriel',
  'manual': 'manuel',
  'map-location': 'carte localisation',
  'map': 'carte',
  'menu': 'menu',
  'microphone': 'microphone',
  'money': 'argent',
  'monitor': 'moniteurr',
  'more': 'plus',
  'multiple': 'multiple',
  'navigate': 'naviguer',
  'new-window': 'nouvelle fenêtre',
  'new': 'nouveau',
  'next': 'suivant',
  'nodes': 'noeuds',
  'note': 'note',
  'notes': 'notes',
  'notification': 'notification',
  'object-group': 'objet groupé',
  'object-ungroup': 'objet séparé',
  'optimize': 'optimiser',
  'organization': 'organisation',
  'overview': 'aperçu',
  'pan': 'croix directionnelle',
  'pause-fill': 'pause pleine',
  'pause': 'pause',
  'personal-computer': 'ordinateur personnel',
  'pie-chart': 'diagramme en pointe de tarte',
  'pin': 'point',
  'plan': 'plan',
  'platform-amazon': 'platforme amazon',
  'platform-android': 'platforme android',
  'platform-apple': 'platforme apple',
  'platform-archlinux': 'platforme archlinux',
  'platform-aruba': 'platforme aruba',
  'platform-centos': 'platforme centos',
  'platform-chrome': 'platforme chrome',
  'platform-cloudlinux': 'platforme cloudlinux',
  'platform-debian': 'platforme debian',
  'platform-docker': 'platforme docker',
  'platform-dos': 'platforme dos',
  'platform-dropbox': 'platforme dropbox',
  'platform-edge': 'platforme edge',
  'platform-fedora': 'platforme fedora',
  'platform-firefox': 'platforme firefox',
  'platform-freebsd': 'platforme freebsd',
  'platform-google': 'platforme google',
  'platform-hadoop': 'platforme hadoop',
  'platform-heroku': 'platforme heroku',
  'platform-horton': 'platforme horton',
  'platform-hp': 'platforme hp',
  'platform-hpi': 'platforme hpi',
  'platform-internet-explorer': 'platforme internet explorer',
  'platform-java': 'platforme java',
  'platform-mandriva': 'platforme mandriva',
  'platform-mysql': 'platforme mysql',
  'platform-norton': 'platforme norton',
  'platform-onedrive': 'platforme onedrive',
  'platform-opera': 'platforme opera',
  'platform-oracle': 'platforme oracle',
  'platform-pied-piper': 'platforme pied piper',
  'platform-raspberry': 'platforme raspberry',
  'platform-reactjs': 'platforme reactjs',
  'platform-redhat': 'platforme redhat',
  'platform-safari-option': 'platforme safari option',
  'platform-safari': 'platforme safari',
  'platform-sco': 'platforme sco',
  'platform-solaris': 'platforme solaris',
  'platform-suse': 'platforme suse',
  'platform-swift': 'platforme swift',
  'platform-turbolinux': 'platforme turbolinux',
  'platform-ubuntu': 'platforme ubuntu',
  'platform-unixware': 'platforme unixware',
  'platform-vmware': 'platforme vmware',
  'platform-windows-legacy': 'platforme windows legacy',
  'platform-windows': 'platforme windows',
  'play-fill': 'play plein',
  'play': 'play',
  'power': 'démarrer',
  'previous': 'précédent',
  'print': 'imprimer',
  'radial-selected': 'sélecteur radial',
  'radial': 'radial',
  'refresh': 'rafraîchir',
  'resources': 'ressources',
  'resume': 'résumé',
  'revert': 'inverser',
  'rewind': 'rembobinner',
  'risk': 'risque',
  'robot': 'robot',
  'rss': 'rss',
  'run': 'course',
  'satellite': 'satellite',
  'save': 'sauvegarde',
  'scan': 'scan',
  'schedule-new': 'nouvel horaire',
  'schedule-play': 'horaire de jeu',
  'schedule': 'horaire',
  'schedules': 'horaires',
  'scorecard': 'tableau de point',
  'search-advanced': 'recherche avancée',
  'search': 'recherche',
  'secure': 'sécuritaire',
  'select': 'sélecteur',
  'selection': 'sélection',
  'send': 'envoie',
  'server-cluster': 'grappe de serveur',
  'server': 'serveur',
  'servers': 'serveurs',
  'service-play': 'service de jeu',
  'services': 'services',
  'settings-option': 'option de paramètre',
  'share': 'partager',
  'shield-security': 'bouclier de sécurité',
  'shield': 'bouclier',
  'shift': 'interchanger',
  'sidebar': 'barre latérale',
  'social-amazon': 'social amazon',
  'social-amex': 'social amex',
  'social-bitcoin': 'social bitcoin',
  'social-codepen': 'social codepen',
  'social-creative-commons': 'social creative commons',
  'social-dropbox': 'social dropbox',
  'social-facebook-option': 'social facebook option',
  'social-facebook': 'social facebook',
  'social-github': 'social github',
  'social-google-plus': 'social google plus',
  'social-google-wallet': 'social google wallet',
  'social-instagram': 'social instagram',
  'social-linkedin-option': 'social linkedin option',
  'social-linkedin': 'social linkedin',
  'social-mail': 'social mail',
  'social-mastercard': 'social mastercard',
  'social-medium': 'social medium',
  'social-paypal': 'social paypal',
  'social-pinterest': 'social pinterest',
  'social-product-hunt': 'social product hunt',
  'social-reddit': 'social reddit',
  'social-skype': 'social skype',
  'social-slack': 'social slack',
  'social-snapchat': 'social snapchat',
  'social-square': 'social square',
  'social-stack-overflow': 'social stack overflow',
  'social-stripe': 'social stripe',
  'social-tumblr': 'social tumblr',
  'social-twitter': 'social twitter',
  'social-vimeo': 'social vimeo',
  'social-vine': 'social vine',
  'social-visa': 'social visa',
  'social-wordpress': 'social wordpress',
  'social-youtube': 'social youtube',
  'sort': 'classer',
  'split': 'division',
  'splits': 'divisions',
  'stakeholder': 'partenaire',
  'standards-3d-effects': 'effets 3d standards',
  'standards-connectivity': 'standards de connectivité',
  'standards-css3': 'standards de css3',
  'standards-device': 'standards d\'appariels',
  'standards-fireball': 'standards boule de feux',
  'standards-html5': 'standards html5',
  'standards-multimedia': 'standards multimédia',
  'standards-offline-storage': 'standards d\'entreposage hors ligne',
  'standards-performance': 'standards de performances',
  'standards-sematics': 'standards sémantique',
  'star-half': 'demi étoile',
  'star': 'étoile',
  'steps': 'étape',
  'stop-fill': 'stop plein',
  'stop': 'stop',
  'storage': 'entreposage',
  'street-view': 'vue urbaine',
  'subtract-circle': 'cercle de soustraction',
  'subtract': 'soustraction',
  'support': 'support',
  'sync': 'synchroniser',
  'system': 'système',
  'table-add': 'ajout de tableau',
  'table': 'tableau',
  'tag': 'étiquette',
  'target': 'cible',
  'task': 'tâche',
  'tasks': 'tâches',
  'technology': 'technologie',
  'template': 'modèle',
  'terminal': 'terminale',
  'test-desktop': 'test ordinateur',
  'test': 'test',
  'text-wrap': 'encadrer par le texte',
  'threats': 'dangers',
  'ticket': 'billets',
  'tools': 'outils',
  'tooltip': 'indication',
  'top-corner': 'coin supérieur',
  'transaction': 'transaction',
  'trash': 'corbeille',
  'tree': 'arbre',
  'trigger': 'gchette',
  'trophy': 'trophé',
  'troubleshoot': 'dépannage',
  'unlink': 'délier',
  'unlock': 'déverrouiller',
  'up': 'haut',
  'update': 'mise à jours',
  'upgrade': 'améliorer',
  'upload': 'téléverser',
  'user-add': 'ajout utilisateur',
  'user-admin': 'utilisateur administratif',
  'user-expert': 'utilisateur expert',
  'user-female': 'utilisateur femelle',
  'user-manager': 'utilisateur manager',
  'user-new': 'nouvel utilisateur',
  'user-police': 'utilisateur policier',
  'user-settings': 'option d\'utilisateur',
  'user-worker': 'utilisateur travailleur',
  'user': 'utilisateur',
  'validate': 'valider',
  'video': 'vidéo',
  'view': 'vue',
  'virtual-machine': 'machine virtuelle',
  'vm-maintenance': 'vm en maintenance',
  'volume-low': 'volume bas',
  'volume-mute': 'volume en sourdine',
  'volume': 'volume',
  'vulnerability': 'vulnerabilité',
  'waypoint': 'direction',
  'workshop': 'atelier',
  'zoom-in': 'zoom avant',
  'zoom-out': 'zoom arrirère'
};
module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _DOM = __webpack_require__(59);

var _Drop = __webpack_require__(124);

var _Drop2 = _interopRequireDefault(_Drop);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _Responsive = __webpack_require__(78);

var _Responsive2 = _interopRequireDefault(_Responsive);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _Down = __webpack_require__(265);

var _Down2 = _interopRequireDefault(_Down);

var _More = __webpack_require__(504);

var _More2 = _interopRequireDefault(_More);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.MENU;

function isFunction(obj) {
  return obj && obj.constructor && obj.call && obj.apply;
}

// We have a separate module for the drop component
// so we can transfer the router context.

var MenuDrop = function (_Component) {
  _inherits(MenuDrop, _Component);

  function MenuDrop(props, context) {
    _classCallCheck(this, MenuDrop);

    var _this = _possibleConstructorReturn(this, (MenuDrop.__proto__ || Object.getPrototypeOf(MenuDrop)).call(this, props, context));

    _this._onUpKeyPress = _this._onUpKeyPress.bind(_this);
    _this._onDownKeyPress = _this._onDownKeyPress.bind(_this);
    _this._processTab = _this._processTab.bind(_this);
    return _this;
  }

  _createClass(MenuDrop, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        intl: this.props.intl,
        history: this.props.history,
        router: this.props.router,
        store: this.props.store
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._originalFocusedElement = document.activeElement;
      this._keyboardHandlers = {
        tab: this._processTab,
        up: this._onUpKeyPress,
        left: this._onUpKeyPress,
        down: this._onDownKeyPress,
        right: this._onDownKeyPress
      };
      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._originalFocusedElement.focus) {
        this._originalFocusedElement.focus();
      } else if (this._originalFocusedElement.parentNode && this._originalFocusedElement.parentNode.focus) {
        // required for IE11 and Edge
        this._originalFocusedElement.parentNode.focus();
      }
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
    }
  }, {
    key: '_processTab',
    value: function _processTab(event) {
      var container = (0, _reactDom.findDOMNode)(this.menuDropRef);
      var items = container.getElementsByTagName('*');
      items = (0, _DOM.filterByFocusable)(items);

      if (!items || items.length === 0) {
        event.preventDefault();
      } else {
        if (event.shiftKey) {
          if (event.target === items[0]) {
            items[items.length - 1].focus();
            event.preventDefault();
          }
        } else if (event.target === items[items.length - 1]) {
          items[0].focus();
          event.preventDefault();
        }
      }
    }
  }, {
    key: '_onUpKeyPress',
    value: function _onUpKeyPress(event) {
      event.preventDefault();
      var container = (0, _reactDom.findDOMNode)(this.navContainerRef);
      var menuItems = container.childNodes;
      if (!this.activeMenuItem) {
        var lastMenuItem = menuItems[menuItems.length - 1];
        this.activeMenuItem = lastMenuItem;
      } else if (this.activeMenuItem.previousSibling) {
        this.activeMenuItem = this.activeMenuItem.previousSibling;
      }

      var classes = this.activeMenuItem.className.split(/\s+/);
      var tagName = this.activeMenuItem.tagName.toLowerCase();
      // want to skip items of the menu that are not focusable.
      if (tagName !== 'button' && tagName !== 'a' && classes.indexOf('check-box') === -1) {
        if (this.activeMenuItem === menuItems[0]) {
          return true;
        } else {
          // If this item is not focusable, check the next item.
          return this._onUpKeyPress(event);
        }
      }

      this.activeMenuItem.focus();
      // Stops KeyboardAccelerators from calling the other listeners.
      // Works limilar to event.stopPropagation().
      return true;
    }
  }, {
    key: '_onDownKeyPress',
    value: function _onDownKeyPress(event) {
      event.preventDefault();
      var container = (0, _reactDom.findDOMNode)(this.navContainerRef);
      var menuItems = container.childNodes;
      if (!this.activeMenuItem) {
        this.activeMenuItem = menuItems[0];
      } else if (this.activeMenuItem.nextSibling) {
        this.activeMenuItem = this.activeMenuItem.nextSibling;
      }

      var classes = this.activeMenuItem.className.split(/\s+/);
      var tagName = this.activeMenuItem.tagName.toLowerCase();
      // want to skip items of the menu that are not focusable.
      if (tagName !== 'button' && tagName !== 'a' && classes.indexOf('check-box') === -1) {
        if (this.activeMenuItem === menuItems[menuItems.length - 1]) {
          return true;
        } else {
          // If this item is not focusable, check the next item.
          return this._onDownKeyPress(event);
        }
      }

      this.activeMenuItem.focus();
      // Stops KeyboardAccelerators from calling the other listeners.
      // Works limilar to event.stopPropagation().
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this,
          _classnames;

      var _props = this.props,
          dropAlign = _props.dropAlign,
          size = _props.size,
          children = _props.children,
          control = _props.control,
          colorIndex = _props.colorIndex,
          onClick = _props.onClick,
          props = _objectWithoutProperties(_props, ['dropAlign', 'size', 'children', 'control', 'colorIndex', 'onClick']);

      var restProps = _Props2.default.omit(props, [].concat(_toConsumableArray(Object.keys(MenuDrop.childContextTypes)), _toConsumableArray(Object.keys(MenuDrop.propTypes))));

      // Put nested Menus inline
      var menuDropChildren = _react2.default.Children.map(children, function (child) {
        var result = child;
        if (child && isFunction(child.type) && child.type.prototype._renderMenuDrop) {
          result = _react2.default.cloneElement(child, { inline: 'expanded', direction: 'column' });
        }
        return result;
      });

      var contents = [_react2.default.createElement(
        _Box2.default,
        _extends({}, restProps, { key: 'nav', ref: function ref(_ref) {
            return _this2.navContainerRef = _ref;
          },
          tag: 'nav', className: CLASS_ROOT + '__contents',
          primary: false }),
        menuDropChildren
      )];

      // do not show the control if menu doesn't overlap with it when expanded
      var showControl = ('top' === dropAlign.top || 'bottom' === dropAlign.bottom) && ('left' === dropAlign.left || 'right' === dropAlign.right);

      if (showControl) {
        contents.unshift(_react2.default.cloneElement(control, { key: 'control', fill: true }));
      }

      if (dropAlign.bottom) {
        contents.reverse();
      }

      var classes = (0, _classnames4.default)(CLASS_ROOT + '__drop', (_classnames = {}, _defineProperty(_classnames, this.props.className + '__drop', this.props.className), _defineProperty(_classnames, CLASS_ROOT + '__drop--align-right', dropAlign.right), _defineProperty(_classnames, CLASS_ROOT + '__drop--' + size, size), _classnames));

      return _react2.default.createElement(
        _Box2.default,
        { ref: function ref(_ref2) {
            return _this2.menuDropRef = _ref2;
          }, className: classes,
          colorIndex: colorIndex, onClick: onClick, focusable: false },
        contents
      );
    }
  }]);

  return MenuDrop;
}(_react.Component);

MenuDrop.displayName = 'MenuDrop';


MenuDrop.propTypes = _extends({
  control: _propTypes2.default.node,
  dropAlign: _Drop.dropAlignPropType,
  dropColorIndex: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.any,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  store: _propTypes2.default.any
}, _Box2.default.propTypes);

MenuDrop.childContextTypes = {
  history: _propTypes2.default.any,
  intl: _propTypes2.default.any,
  router: _propTypes2.default.any,
  store: _propTypes2.default.any
};

var Menu = function (_Component2) {
  _inherits(Menu, _Component2);

  function Menu(props, context) {
    _classCallCheck(this, Menu);

    var _this3 = _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).call(this, props, context));

    _this3._onOpen = _this3._onOpen.bind(_this3);
    _this3._onClose = _this3._onClose.bind(_this3);
    _this3._checkOnClose = _this3._checkOnClose.bind(_this3);
    _this3._onSink = _this3._onSink.bind(_this3);
    _this3._onResponsive = _this3._onResponsive.bind(_this3);
    _this3._onFocusControl = _this3._onFocusControl.bind(_this3);
    _this3._onBlurControl = _this3._onBlurControl.bind(_this3);

    var inline = void 0;
    if (props.hasOwnProperty('inline')) {
      inline = props.inline;
    } else {
      inline = !props.label && !props.icon;
    }
    var responsive = void 0;
    if (props.hasOwnProperty('responsive')) {
      responsive = props.responsive;
    } else {
      responsive = inline && 'row' === props.direction;
    }
    _this3.state = {
      // state may be 'collapsed', 'focused' or 'expanded' (active).
      state: 'collapsed',
      initialInline: inline,
      inline: inline,
      responsive: responsive
    };
    return _this3;
  }

  _createClass(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.responsive) {
        this._responsive = _Responsive2.default.start(this._onResponsive);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.inline !== nextProps.inline || this.props.icon !== nextProps.icon) {
        this.setState({
          inline: nextProps.hasOwnProperty('inline') ? nextProps.inline : !nextProps.label && !nextProps.icon
        });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this4 = this;

      var dropContainer = this.props.dropContainer;


      if (this.state.state !== prevState.state) {
        var activeKeyboardHandlers = {
          esc: this._onClose
        };
        var focusedKeyboardHandlers = {
          space: this._onOpen,
          down: this._onOpen,
          enter: this._onOpen
        };

        switch (this.state.state) {
          case 'collapsed':
            _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
            _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
            document.removeEventListener('click', this._checkOnClose);
            document.removeEventListener('touchstart', this._checkOnClose);
            if (this._drop) {
              // When Menu is used with Anchor/paths the Drop removes too quickly
              // and react looks for a DOM element which is gone. Adding a
              // slight delay resolves this issue.
              setTimeout(function () {
                _this4._drop.remove();
                _this4._drop = undefined;
              }, 5);
            }
            break;
          case 'focused':
            _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
            _KeyboardAccelerators2.default.startListeningToKeyboard(this, focusedKeyboardHandlers);
            break;
          case 'expanded':
            // only add the drop again if the instance is not defined
            // see https://github.com/grommet/grommet/issues/1431
            if (!this._drop) {
              _KeyboardAccelerators2.default.stopListeningToKeyboard(this, focusedKeyboardHandlers);
              _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);
              document.addEventListener('click', this._checkOnClose);
              document.addEventListener('touchstart', this._checkOnClose);
              this._drop = new _Drop2.default((0, _reactDom.findDOMNode)(this._controlRef), this._renderMenuDrop(), {
                align: this.props.dropAlign,
                colorIndex: this.props.dropColorIndex,
                className: this.props.className && this.props.className + '__drop--container',
                focusControl: true,
                dropContainer: dropContainer
              });
            }
            break;
        }
      } else if (this.state.state === 'expanded') {
        this._drop.render(this._renderMenuDrop());
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this._checkOnClose);
      document.removeEventListener('touchstart', this._checkOnClose);
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
      if (this._drop) {
        this._drop.remove();
      }
      if (this._responsive) {
        this._responsive.stop();
      }
    }
  }, {
    key: '_onOpen',
    value: function _onOpen() {
      if ((0, _reactDom.findDOMNode)(this._controlRef).contains(document.activeElement)) {
        this.setState({ state: 'expanded' });
      }
    }
  }, {
    key: '_onClose',
    value: function _onClose() {
      this.setState({ state: 'collapsed' });
    }
  }, {
    key: '_checkOnClose',
    value: function _checkOnClose(event) {
      var drop = (0, _reactDom.findDOMNode)(this._menuDrop);
      var control = (0, _reactDom.findDOMNode)(this._controlRef);
      if (drop && !drop.contains(event.target) && !control.contains(event.target)) {
        this._onClose();
      }
    }
  }, {
    key: '_onSink',
    value: function _onSink(event) {
      event.stopPropagation();
      // need to go native to prevent closing via document
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: '_onResponsive',
    value: function _onResponsive(small) {
      // deactivate if we change resolutions
      var newState = this.state.state;
      if (this.state.state === 'expanded') {
        newState = 'focused';
      }
      if (small) {
        this.setState({ inline: false, active: newState, controlCollapsed: true });
      } else {
        this.setState({
          inline: this.state.initialInline,
          active: newState,
          state: 'collapsed',
          controlCollapsed: false
        });
      }
    }
  }, {
    key: '_onFocusControl',
    value: function _onFocusControl() {
      if (this.state.state !== 'focused') {
        this.setState({ state: 'focused' });
      }
    }
  }, {
    key: '_onBlurControl',
    value: function _onBlurControl() {
      if (this.state.state === 'focused') {
        this.setState({ state: 'collapsed' });
      }
    }
  }, {
    key: '_renderButtonProps',
    value: function _renderButtonProps() {
      var _props2 = this.props,
          icon = _props2.icon,
          label = _props2.label;
      // Use default icon if no label or icon is provided

      if (!label && !icon) {
        return { icon: _react2.default.createElement(_More2.default, null) };
      }

      // Return provided label(if any) and provided icon, or default
      // to DropCaretIcon
      return {
        label: label,
        icon: icon || _react2.default.createElement(_Down2.default, { a11yTitle: 'menu-down' })
      };
    }
  }, {
    key: '_renderMenuDrop',
    value: function _renderMenuDrop() {
      var _this5 = this;

      var closeLabel = _Intl2.default.getMessage(this.context.intl, 'Close');
      var menuLabel = _Intl2.default.getMessage(this.context.intl, 'Menu');
      var menuTitle = closeLabel + ' ' + (this.props.a11yTitle || this.props.label || '') + ' ' + ('' + menuLabel);

      var control = _react2.default.createElement(_Button2.default, _extends({ className: CLASS_ROOT + '__control', plain: true,
        a11yTitle: menuTitle, reverse: true
      }, this._renderButtonProps(), { onClick: this._onClose }));

      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
      var onClick = this.props.closeOnClick ? this._onClose : this._onSink;

      return _react2.default.createElement(
        MenuDrop,
        _extends({}, boxProps, this.context, {
          className: this.props.className,
          dropAlign: this.props.dropAlign,
          size: this.props.size,
          onClick: onClick,
          control: control, ref: function ref(_ref3) {
            return _this5._menuDrop = _ref3;
          } }),
        this.props.children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2,
          _this6 = this;

      var _props3 = this.props,
          a11yTitle = _props3.a11yTitle,
          children = _props3.children,
          className = _props3.className,
          direction = _props3.direction,
          fill = _props3.fill,
          label = _props3.label,
          primary = _props3.primary,
          size = _props3.size,
          pad = _props3.pad,
          props = _objectWithoutProperties(_props3, ['a11yTitle', 'children', 'className', 'direction', 'fill', 'label', 'primary', 'size', 'pad']);

      delete props.closeOnClick;
      delete props.dropColorIndex;
      delete props.dropAlign;
      delete props.icon;
      delete props.inline;
      var inline = this.state.inline;

      var classes = (0, _classnames4.default)(CLASS_ROOT, (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '--' + direction, direction), _defineProperty(_classnames2, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames2, CLASS_ROOT + '--primary', primary), _defineProperty(_classnames2, CLASS_ROOT + '--inline', inline), _defineProperty(_classnames2, CLASS_ROOT + '--controlled', !inline), _defineProperty(_classnames2, CLASS_ROOT + '__control', !inline), _defineProperty(_classnames2, CLASS_ROOT + '--labelled', !inline && label), _defineProperty(_classnames2, CLASS_ROOT + '--fill', fill), _classnames2), className);

      if (inline) {
        var menuLabel = void 0;
        if ('expanded' === inline) {
          menuLabel = _react2.default.createElement(
            'div',
            { className: CLASS_ROOT + '__label' },
            label
          );
        }

        return _react2.default.createElement(
          _Box2.default,
          _extends({}, props, { pad: pad, direction: direction, tag: 'nav',
            className: classes, primary: false }),
          menuLabel,
          children
        );
      } else {
        var openLabel = _Intl2.default.getMessage(this.context.intl, 'Open');
        var _menuLabel = _Intl2.default.getMessage(this.context.intl, 'Menu');
        var menuTitle = openLabel + ' ' + (a11yTitle || label || '') + ' ' + ('' + _menuLabel);

        return _react2.default.createElement(
          _Box2.default,
          _extends({ ref: function ref(_ref4) {
              return _this6._controlRef = _ref4;
            } }, props, { className: classes }),
          _react2.default.createElement(_Button2.default, _extends({ plain: true, reverse: true,
            a11yTitle: menuTitle }, this._renderButtonProps(), {
            onClick: function onClick() {
              return _this6.setState({
                state: _this6.state.state !== 'expanded' ? 'expanded' : 'collapsed'
              });
            },
            onFocus: this._onFocusControl, onBlur: this._onBlurControl }))
        );
      }
    }
  }]);

  return Menu;
}(_react.Component);

Menu.displayName = 'Menu';
exports.default = Menu;


Menu.propTypes = _extends({
  closeOnClick: _propTypes2.default.bool,
  dropAlign: _Drop.dropAlignPropType,
  dropColorIndex: _propTypes2.default.string,
  dropContainer: _propTypes2.default.object,
  icon: _propTypes2.default.node,
  id: _propTypes2.default.string,
  inline: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['expand'])]),
  fill: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
}, _Box2.default.propTypes);

Menu.contextTypes = {
  history: _propTypes2.default.any,
  intl: _propTypes2.default.any,
  router: _propTypes2.default.any,
  store: _propTypes2.default.any
};

Menu.defaultProps = {
  closeOnClick: true,
  direction: 'column',
  dropAlign: { top: 'top', left: 'left' },
  pad: 'none',
  dropContainer: undefined
};
module.exports = exports['default'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dropAlignPropType = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _DOM = __webpack_require__(59);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.DROP;
var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;

/*
 * Drop is a utility for rendering components like drop down menus layered above
 * their initiating controls.
 */

var VERTICAL_ALIGN_OPTIONS = ['top', 'bottom'];
var HORIZONTAL_ALIGN_OPTIONS = ['right', 'left'];

var DropContents = function (_Component) {
  _inherits(DropContents, _Component);

  function DropContents(props, context) {
    _classCallCheck(this, DropContents);

    var _this = _possibleConstructorReturn(this, (DropContents.__proto__ || Object.getPrototypeOf(DropContents)).call(this, props, context));

    _this._processTab = _this._processTab.bind(_this);
    return _this;
  }

  _createClass(DropContents, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.props.context;

      return _extends({}, context);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var focusControl = this.props.focusControl;

      if (focusControl) {
        this._keyboardHandlers = {
          tab: this._processTab
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var focusControl = this.props.focusControl;

      if (focusControl) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: '_processTab',
    value: function _processTab(event) {
      var items = this._containerRef.getElementsByTagName('*');
      items = (0, _DOM.filterByFocusable)(items);
      if (!items || items.length === 0) {
        event.preventDefault();
      } else {
        if (event.shiftKey) {
          if (event.target === items[0]) {
            items[items.length - 1].focus();
            event.preventDefault();
          }
        } else if (event.target === items[items.length - 1]) {
          items[0].focus();
          event.preventDefault();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          content = _props.content,
          focusControl = _props.focusControl;


      var anchorStep = void 0;
      if (focusControl) {
        anchorStep = _react2.default.createElement('a', { tabIndex: '-1', 'aria-hidden': 'true',
          className: CLASS_ROOT + '__anchor' });
      }
      return _react2.default.createElement(
        'div',
        { ref: function ref(_ref) {
            return _this2._containerRef = _ref;
          } },
        anchorStep,
        content
      );
    }
  }]);

  return DropContents;
}(_react.Component);

DropContents.displayName = 'DropContents';


DropContents.propTypes = {
  content: _propTypes2.default.node.isRequired,
  context: _propTypes2.default.any,
  focusControl: _propTypes2.default.bool
};

DropContents.childContextTypes = {
  history: _propTypes2.default.object,
  intl: _propTypes2.default.object,
  onDropChange: _propTypes2.default.func,
  router: _propTypes2.default.any,
  store: _propTypes2.default.object
};

var _normalizeOptions = function _normalizeOptions(options) {
  var opts = _extends({}, options);
  // normalize for older interface that just had align content
  if (options.top || options.bottom || options.left || options.right) {
    opts = { align: _extends({}, options) };
  }
  // validate align
  if (options && options.align && options.align.top && VERTICAL_ALIGN_OPTIONS.indexOf(options.align.top) === -1) {
    console.warn("Warning: Invalid align.top value '" + options.align.top + "' supplied to Drop," + "expected one of [" + VERTICAL_ALIGN_OPTIONS.join(',') + "]");
  }
  if (options.align && options.align.bottom && VERTICAL_ALIGN_OPTIONS.indexOf(options.align.bottom) === -1) {
    console.warn("Warning: Invalid align.bottom value '" + options.align.bottom + "' supplied to Drop," + "expected one of [" + VERTICAL_ALIGN_OPTIONS.join(',') + "]");
  }
  if (options.align && options.align.left && HORIZONTAL_ALIGN_OPTIONS.indexOf(options.align.left) === -1) {
    console.warn("Warning: Invalid align.left value '" + options.align.left + "' supplied to Drop," + "expected one of [" + HORIZONTAL_ALIGN_OPTIONS.join(',') + "]");
  }
  if (options.align && options.align.right && HORIZONTAL_ALIGN_OPTIONS.indexOf(options.align.right) === -1) {
    console.warn("Warning: Invalid align.right value '" + options.align.right + "' supplied to Drop," + "expected one of [" + HORIZONTAL_ALIGN_OPTIONS.join(',') + "]");
  }
  opts.align = _extends({}, opts.align) || {};
  if (!options.align.top && !options.align.bottom) {
    opts.align.top = "top";
  }
  if (!options.align.left && !options.align.right) {
    opts.align.left = "left";
  }
  opts.responsive = options.responsive !== false ? true : options.responsive;
  return opts;
};

// Drop options:
//
// align: See dropAlignPropType
// className: PropTypes.string
// colorIndex: PropTypes.string
//    Background color
// context: PropTypes.object
//    React context to pass through
// focusControl: PropTypes.bool
//    Whether to focus inside the dropped content when added
// responsive: PropTypes.bool
//    Whether to dynamically re-place when resized
//

var Drop = function () {
  function Drop(control, content, opts) {
    var _classnames,
        _this3 = this;

    _classCallCheck(this, Drop);

    var options = _normalizeOptions(opts);
    var context = options.context,
        focusControl = options.focusControl;

    // bind functions to instance

    this.render = this.render.bind(this);
    this.remove = this.remove.bind(this);
    this.place = this.place.bind(this);
    this._onResize = this._onResize.bind(this);
    this._control = control;

    // setup DOM
    var container = document.createElement('div');
    container.className = (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, options.className, options.className), _defineProperty(_classnames, BACKGROUND_COLOR_INDEX + '-' + options.colorIndex, options.colorIndex), _classnames));

    if (opts.dropContainer) {
      opts.dropContainer.appendChild(container);
      this.parentContainer = opts.dropContainer;
    } else {
      // prepend in body to avoid browser scroll issues
      document.body.insertBefore(container, document.body.firstChild);
      this.parentContainer = document.body;
    }

    var scrollParents = (0, _DOM.findScrollParents)(control);

    // initialize state
    this.state = {
      container: container, control: control, initialFocusNeeded: focusControl, options: options,
      scrollParents: scrollParents
    };

    (0, _reactDom.render)(_react2.default.createElement(DropContents, { content: content, context: context,
      focusControl: focusControl }), container, function () {
      return _this3.place();
    });

    this._listen();
  }

  _createClass(Drop, [{
    key: '_listen',
    value: function _listen() {
      var _this4 = this;

      var scrollParents = this.state.scrollParents;

      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', _this4.place);
      });
      // we intentionally skipped debounce as we believe resizing
      // will not be a common action. Also the UI looks better if the Drop
      // doesn’t lag to align with the control component.
      window.addEventListener('resize', this._onResize);
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var _this5 = this;

      var scrollParents = this.state.scrollParents;
      // we need to update scroll parents as Responsive options may change
      // the parent for the target element

      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', _this5.place);
      });

      var nextScrollParents = (0, _DOM.findScrollParents)(this._control);

      nextScrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', _this5.place);
      });

      this.state.scrollParents = nextScrollParents;

      this.place();
    }
  }, {
    key: 'place',
    value: function place() {
      var _state = this.state,
          control = _state.control,
          container = _state.container,
          initialFocusNeeded = _state.initialFocusNeeded,
          _state$options = _state.options,
          align = _state$options.align,
          responsive = _state$options.responsive;

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // clear prior styling
      container.style.left = '';
      container.style.width = '';
      container.style.top = '';
      container.style.maxHeight = '';

      // get bounds
      var controlRect = (0, _DOM.findVisibleParent)(control).getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();

      // determine width
      var width = Math.min(Math.max(controlRect.width, containerRect.width), windowWidth);

      // set left position
      var left = void 0;
      if (align.left) {
        if ('left' === align.left) {
          left = controlRect.left;
        } else if ('right' === align.left) {
          left = controlRect.left - width;
        }
      } else if (align.right) {
        if ('left' === align.right) {
          left = controlRect.left - width;
        } else if ('right' === align.right) {
          left = controlRect.left + controlRect.width - width;
        }
      }

      if (left + width > windowWidth) {
        left -= left + width - windowWidth;
      } else if (left < 0) {
        left = 0;
      }

      // set top position
      var top = void 0,
          maxHeight = void 0;
      if (align.top) {
        if ('top' === align.top) {
          top = controlRect.top;
          maxHeight = Math.min(windowHeight - controlRect.top, windowHeight);
        } else {
          top = controlRect.bottom;
          maxHeight = Math.min(windowHeight - controlRect.bottom, windowHeight - controlRect.height);
        }
      } else if (align.bottom) {
        if ('bottom' === align.bottom) {
          top = controlRect.bottom - containerRect.height;
          maxHeight = Math.max(controlRect.bottom, 0);
        } else {
          top = controlRect.top - containerRect.height;
          maxHeight = Math.max(controlRect.top, 0);
        }
      }

      // if we can't fit it all, see if there's more room the other direction
      if (containerRect.height > maxHeight) {
        // We need more room than we have.
        if (align.top && top > windowHeight / 2) {
          // We put it below, but there's more room above, put it above
          if (align.top === 'bottom') {
            if (responsive) {
              top = Math.max(controlRect.top - containerRect.height, 0);
            }
            maxHeight = controlRect.top;
          } else {
            if (responsive) {
              top = Math.max(controlRect.bottom - containerRect.height, 0);
            }
            maxHeight = controlRect.bottom;
          }
        } else if (align.bottom && maxHeight < windowHeight / 2) {
          // We put it above but there's more room below, put it below
          if (align.bottom === 'bottom') {
            if (responsive) {
              top = controlRect.top;
            }
            maxHeight = Math.min(windowHeight - top, windowHeight);
          } else {
            if (responsive) {
              top = controlRect.bottom;
            }
            maxHeight = Math.min(windowHeight - top, windowHeight - controlRect.height);
          }
        }
      }

      container.style.left = left + 'px';
      // offset width by 0.1 to avoid a bug in ie11 that
      // unnecessarily wraps the text if width is the same
      container.style.width = width + 0.1 + 'px';
      // the (position:absolute + scrollTop)
      // is presenting issues with desktop scroll flickering
      container.style.top = top + 'px';
      container.style.maxHeight = windowHeight - top + 'px';

      if (initialFocusNeeded) {
        // Now that we've placed it, focus on it
        this._focus();
      }
    }
  }, {
    key: '_focus',
    value: function _focus() {
      var container = this.state.container;

      this.state.originalFocusedElement = document.activeElement;
      if (!container.contains(document.activeElement)) {
        var anchor = container.querySelector(CLASS_ROOT + '__anchor');
        if (anchor) {
          anchor.focus();
          anchor.scrollIntoView();
        }
      }
      delete this.state.initialFocusNeeded;
    }
  }, {
    key: 'render',
    value: function render(content) {
      var _this6 = this;

      var _state2 = this.state,
          container = _state2.container,
          _state2$options = _state2.options,
          context = _state2$options.context,
          focusControl = _state2$options.focusControl;

      var originalScrollPosition = container.scrollTop;
      (0, _reactDom.render)(_react2.default.createElement(DropContents, { content: content, context: context,
        focusControl: focusControl }), container, function () {
        _this6.place();
        // reset container to its original scroll position
        container.scrollTop = originalScrollPosition;
      });
    }
  }, {
    key: 'remove',
    value: function remove() {
      var _this7 = this;

      var _state3 = this.state,
          container = _state3.container,
          originalFocusedElement = _state3.originalFocusedElement,
          scrollParents = _state3.scrollParents;

      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', _this7.place);
      });
      window.removeEventListener('resize', this._onResize);

      (0, _reactDom.unmountComponentAtNode)(container);
      this.parentContainer.removeChild(container);
      // weird bug in Chrome does not remove child if
      // document.body.insertBefore is called in another new drop.
      // the code below will go over remaining drop that was not removed
      [].forEach.call(document.getElementsByClassName(CLASS_ROOT), function (element) {
        if (element.getAttribute('style') === container.getAttribute('style')) {
          document.body.removeChild(element);
        }
      });

      if (originalFocusedElement) {
        originalFocusedElement.focus();
      }

      this.state = undefined;
    }
  }]);

  return Drop;
}();

// How callers can validate a property for drop alignment which will be
// passed to add().


exports.default = Drop;
var dropAlignPropType = exports.dropAlignPropType = _propTypes2.default.shape({
  top: _propTypes2.default.oneOf(VERTICAL_ALIGN_OPTIONS),
  bottom: _propTypes2.default.oneOf(VERTICAL_ALIGN_OPTIONS),
  left: _propTypes2.default.oneOf(HORIZONTAL_ALIGN_OPTIONS),
  right: _propTypes2.default.oneOf(HORIZONTAL_ALIGN_OPTIONS)
});

Drop.add = function (control, content, options) {
  console.warn("Warning: Drop.add() is deprecated, use new Drop().");
  return new Drop(control, content, options);
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.FORM;

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          compact = _props.compact,
          fill = _props.fill,
          pad = _props.pad,
          plain = _props.plain,
          props = _objectWithoutProperties(_props, ['className', 'compact', 'fill', 'pad', 'plain']);

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--compact', compact), _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--pad-' + pad, typeof pad === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--pad-horizontal-' + pad.horizontal, (typeof pad === 'undefined' ? 'undefined' : _typeof(pad)) === 'object' && 'horizontal' in pad), _defineProperty(_classnames, CLASS_ROOT + '--pad-vertical-' + pad.vertical, (typeof pad === 'undefined' ? 'undefined' : _typeof(pad)) === 'object' && 'vertical' in pad), _defineProperty(_classnames, CLASS_ROOT + '--plain', plain), _classnames), className);

      return _react2.default.createElement(
        'form',
        _extends({}, props, { className: classes, onSubmit: this.props.onSubmit }),
        this.props.children
      );
    }
  }]);

  return Form;
}(_react.Component);

Form.displayName = 'Form';
exports.default = Form;


Form.propTypes = {
  compact: _propTypes2.default.bool,
  fill: _propTypes2.default.bool,
  onSubmit: _propTypes2.default.func,
  pad: _propTypes2.default.oneOfType([_propTypes2.default.oneOf(['none', 'small', 'medium', 'large']), _propTypes2.default.shape({
    horizontal: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
    vertical: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large'])
  })]),
  plain: _propTypes2.default.bool
};

Form.defaultProps = {
  compact: false,
  fill: false,
  pad: 'none'
};
module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Header__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Share__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_DocumentConfig__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_DocumentConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_DocumentConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Info__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SizerScreens__ = __webpack_require__(175);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Tile from 'grommet/components/Tile';
//import FormField from 'grommet/components/FormField';
//import Compare from './Compare';
var compare='';var SavedSolutionName='';var DeleteLayer,ShareLayer;var HPECP_SIZER='EzmeralCPSizer'.toUpperCase();var inputText='';var EPAId='EPAvNext';var BLUE_DATA='BlueData';var OldSolutionLayer='';var LoadFiles=function(_Component){_inherits(LoadFiles,_Component);function LoadFiles(){_classCallCheck(this,LoadFiles);var _this=_possibleConstructorReturn(this,(LoadFiles.__proto__||Object.getPrototypeOf(LoadFiles)).call(this));_this.CloseOldSolutionLayer=function(){OldSolutionLayer='';_this.props.updateLoadedOldSolution(false);_this.setState({displayOldSolutionContent:false});};_this.state={LoadItemIndex:'',WorkloadList:[],SolutionList:[],showLoading:false,CompareLayer:false,showShareLayer:false,shareId:'',displayOldSolutionContent:false,SelectedType:'',WorkloadnSolutionData:[]};_this.onLoad=_this.onLoad.bind(_this);//DelSession: '',
_this.onDelete=_this.onDelete.bind(_this);_this.OnShare=_this.OnShare.bind(_this);_this.Submit_Delete_WL=_this.Submit_Delete_WL.bind(_this);_this.shareClicked=_this.shareClicked.bind(_this);_this.onCompare=_this.onCompare.bind(_this);_this.handleClose=_this.handleClose.bind(_this);return _this;}_createClass(LoadFiles,[{key:'componentDidMount',value:function componentDidMount(){var userId=this.props.UserID;var subsaid=null;if(userId===undefined){userId='TestUser@test.com';}if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='EPAvNext'){if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["a" /* appUrl */].toUpperCase().indexOf(HPECP_SIZER)>-1){subsaid="<WorkloadType>BlueData</WorkloadType>";}else{subsaid="<WorkloadType>BigData</WorkloadType>";}}else if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='SAPHANA'&&this.props.SSETid!==undefined){if(this.props.WorkloadType!==undefined&&this.props.WorkloadType.toUpperCase().indexOf('TDI')>-1){subsaid="<WorkloadType>TDI</WorkloadType>";}else{subsaid="<WorkloadType>SAPHANA</WorkloadType>";}}var userData={//"UserId": this.props.userData.email,
"UserId":userId,"SizerId":__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */],"subSAID":subsaid};this.props.onLoadWokload(userData);if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='EPA'){this.props.onUpdateDefaultSession(this.props.DefaultInputs);if(this.props.supportedList===null)this.props.OnFetchSupportedList();}else if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='SAPHANA'){this.props.onUpdateDefaultSession(this.props.DefaultInputs);}}},{key:'CloseDelSession',value:function CloseDelSession(){DeleteLayer='';this.setState({});}},{key:'onLoad',value:function onLoad(index){var selection=0;if(this.props.title==='Workload'){//Devendu Changes 25052020
if(this.props.guiState!=undefined){this.props.guiState.loadWorkload=true;}this.state.WorkloadList.filter(function(value,id){if(index===id){selection=value['id'];}});// this.props.onAddSession(Date.now(),'Load Workload Session');
this.props.onLoadSession({"ID":selection});// this.props.history.push('/Build/ContactInfo');
// this.props.onClose(false);
// this.props.redirectTo('/Build/ContactInfo');
}else if(this.props.title==='Solution'){//Devendu Changes 25052020
if(this.props.guiState!=undefined){this.props.guiState.loadSolution=true;}this.state.SolutionList.filter(function(value,id){if(index===id){selection=value['id'];}});// this.props.onAddSession(Date.now(),'Load Solution Session');
this.props.onLoadSession({"ID":selection});// this.props.onClose(false);
// this.props.redirectTo('/Build/SolnAlternative');
// this.props.history.push('/Build/SolnAlternative');
}else if(this.props.title==='All'){if(this.state.SelectedType==='Workload'){if(this.props.guiState!=undefined){this.props.guiState.loadWorkload=true;}}else{if(this.props.guiState!=undefined){this.props.guiState.loadSolution=true;}}this.state.WorkloadnSolutionData.filter(function(value,id){if(index===id){selection=value['id'];}});this.props.onLoadSession({"ID":selection});}// this.props.onAddSession(Date.now(),'Loaded Workload');
// if(this.props.activeSession !== ''){
//   this.props.activeSession.workload = DataObj.Workloads.Workload[index]["Content"];
//   this.props.onClose(false);
//   this.props.history.push('/Build/ContactInfo');
// }
}},{key:'Submit_Delete_WL',value:function Submit_Delete_WL(index){var selection=0;if(this.props.title==='Workload'){this.state.WorkloadList.filter(function(value,id){if(index===id){selection=value['id'];}});this.props.onDeleteSession({"ID":selection});}else if(this.props.title==='Solution'){this.state.SolutionList.filter(function(value,id){if(index===id){selection=value['id'];}});this.props.onDeleteSession({"ID":selection});}else{}DeleteLayer='';}},{key:'handleClose',value:function handleClose(){compare='';this.props.onClose(false);this.setState({CompareLayer:false});}},{key:'handleCloseError',value:function handleCloseError(){compare='';this.setState({CompareLayer:false});}},{key:'shareClicked',value:function shareClicked(id){this.setState({showLoading:true});var item;if(this.props.title==='Solution')item=this.state.SolutionList[this.state.LoadItemIndex];/*Changes by Vinay replaced else if (this.props.title === 'Workload') condition by else, for CID:'10625'*/else item=this.state.WorkloadList[this.state.LoadItemIndex];var userData={"itemId":item.id,"userIdtoShareWith":this.state.shareId.split(',')};this.props.onShareItems(userData);}},{key:'onCompare',value:function onCompare(index){var selectedselection=0;var activeSessionid=this.props.activeSession.id;this.state.SolutionList.filter(function(value,id){if(index===id){selectedselection=value['id'];}});this.props.Savedname(SavedSolutionName,selectedselection);this.props.onClose(false);var value={"SessionID":activeSessionid,"SessionIDsaved":selectedselection,"EPASolutionType":this.props.solutionIndex};this.props.OnComparedata(value);this.setState({CompareLayer:true});}},{key:'OnShare',value:function OnShare(id){var _this2=this;var shareItem;if(this.props.title==='Solution')shareItem=this.state.SolutionList[id];/* Changes by Vinay, replaced "else if (this.props.title === 'Workload')" with "else", for CID:10626 */else shareItem=this.state.WorkloadList[id];var text='Sharing';var textStyle;var method=this.shareClicked;if(this.state.showLoading){method=undefined;}this.state.shareId.split(',').map(function(emailId,index){if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailId)){method=undefined;}});var responseData=this.props.responseFromShare.response!==''?this.props.responseFromShare.response.map(function(item,index){item.status==='Error'?textStyle={color:'red',paddingTop:'10px'}:textStyle={color:'#01a982',paddingTop:'10px'};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:textStyle},item.message);}):'';text+=' '+shareItem.type+" - "+shareItem.alias;ShareLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Share___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Share')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){if(!_this2.state.showLoading){ShareLayer='';_this2.setState({showShareLayer:false});_this2.props.responseFromShare.response='';_this2.setState({shareId:''});}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:true},text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5'},'Please Enter a valid user email id and click on share'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'}},this.state.showLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput___default.a,{disabled:true,style:{width:'60%',marginRight:'10px'}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput___default.a,{value:this.state.shareId,onDOMChange:function onDOMChange(e){_this2.setState({shareId:e.target.value});},style:{width:'60%',marginRight:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:true,label:'Share',onClick:method})),this.state.showLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{paddingTop:'10px'},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_Spinning___default.a,{size:'small',className:'spinnerStyle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Please wait while we share...')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,responseData))));if(!this.state.showShareLayer){this.setState({showShareLayer:true});}}},{key:'onDelete',value:function onDelete(){var _this3=this;//this.setState({DeletePopup:true})
DeleteLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.CloseDelSession.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},this.props.title==="Solution"?"Are you sure you want to delete the selected Solution?":"Are you sure you want to delete the selected Workload ?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:function onClick(){return _this3.Submit_Delete_WL(_this3.state.LoadItemIndex);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',critical:true,onClick:this.CloseDelSession.bind(this)}))));this.setState({});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this4=this;this.state.WorkloadList=[];this.state.SolutionList=[];if(nextProps.loadedOldSolution){if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]===EPAId){this.state.displayOldSolutionContent=true;}}nextProps.userData.map(function(value,index){if(value['type'].indexOf('Workload')===0){if(_this4.state.WorkloadList.indexOf(value)!==0){_this4.state.WorkloadList.push(value);}}else{if(_this4.state.SolutionList.indexOf(value)!==0){_this4.state.SolutionList.push(value);}}});this.state.WorkloadnSolutionData=[];if(this.props.title==='All'){this.state.WorkloadList.map(function(value,index){_this4.state.WorkloadnSolutionData.push(value);});this.state.SolutionList.map(function(value,index){_this4.state.WorkloadnSolutionData.push(value);});}/*var selsessionID = '';
    if (nextProps.title === 'Workload') {
      this.state.WorkloadList.filter((value, id) => {
        if (this.state.LoadItemIndex === id) {
          selsessionID = value['sessionID'];
        }
      });
    } else if (nextProps.title === 'Solution') {
      this.state.SolutionList.filter((value, id) => {
        if (this.state.LoadItemIndex === id) {
          selsessionID = value['sessionID'];
        }
      });
    }*/if(nextProps.activeSession.id!=""){if(nextProps.activeSession.id!==this.props.activeSession.id){if(nextProps.activeSession.treeView!==''){var obj="";if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='SynergySizer'){obj={"Workload":nextProps.activeSession.workload};}else{obj=nextProps.activeSession.workload;}if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]===EPAId&&nextProps.activeSession.workload.UserInputs.Environments.WorkloadType===BLUE_DATA){if(Array.isArray(nextProps.activeSession.workload.UserInputs.Environments.Environment)){this.props.onNewSession(obj);this.props.redirectTo('/Build/SolnAlternative');}}else{this.props.onNewSession(obj);this.props.redirectTo('/Build/SolnAlternative');}// this.props.history.push('/Build/SolnAlternative');
}else{var _obj="";if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='SynergySizer'){_obj={"Workload":nextProps.activeSession.workload};}else{_obj=nextProps.activeSession.workload;}this.props.onNewSession(_obj);if(__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='EPAvNext'||__WEBPACK_IMPORTED_MODULE_16__AppConfig__["f" /* said */]==='SAPHANA'){var specificPages=__WEBPACK_IMPORTED_MODULE_17__SizerScreens__["a" /* interviewScreens */].filter(function(route,id){if(route.type===nextProps.activeSession.workload.UserInputs.Environments.WorkloadType){return route;}});this.props.redirectTo(specificPages[0].path);}else{this.props.redirectTo(__WEBPACK_IMPORTED_MODULE_17__SizerScreens__["a" /* interviewScreens */][0].path);}// this.props.history.push('/Build/ContactInfo');
}}}if(this.state.showLoading&&this.props.responseFromShare.response!==nextProps.responseFromShare.response){this.setState({showLoading:false});}}},{key:'render',value:function render(){var _this5=this;var TileItems='';if(this.props.userData.length>0){// this.props.userData.map( (value, index) => {
//       if(value['type'].indexOf('Workload') === 0 ){
//           if(this.state.WorkloadList.indexOf(value) !== 0 ){
//             this.state.WorkloadList.push(value);
//           }
//       }else{
//           if(this.state.SolutionList.indexOf(value) !== 0 ){
//             this.state.SolutionList.push(value);
//           }
//       }
// });
// <Header size='small' pad={{"horizontal": "small"}}>
//      <Box direction="row" margin="none" pad={{between: 'small'}} >
//           <Box className='WorkloadItemIcon'>
//             <WorkLoadIcon size='small' />
//           </Box>
//           <Heading tag='h5' strong={true} margin='none'>
//             {value['id']}
//           </Heading>
//     </Box>
// </Header>
// <Header size='medium' pad={{"horizontal": "small"}}>
//      <Box direction="row" margin="small" pad={{between: 'small'}} >
//           <Box justify='center' className='SolutionItemIcon'>
//                <SolutionIcon size='medium' />
//           </Box>
//           <Box margin="none" pad={{between: 'small'}}>
//                <Box direction="row" margin="none" pad={{between: 'small'}} > 
//                     <Heading tag='h5' strong={true} margin='none' style={{color:'#01a982'}} >
//                       ID:
//                     </Heading>
//                     <Heading tag='h5' strong={true} margin='none'>
//                       {value['id']}
//                     </Heading>
//                </Box>
//                <Box direction="row" margin="none" pad={{between: 'small'}} > 
//                     <Heading tag='h5' strong={true} margin='none' style={{color:'#01a982'}} >
//                       sessionID:
//                     </Heading>
//                     <Heading tag='h5' strong={true} margin='none'>
//                       {value['sessionID']}
//                     </Heading>
//                </Box>
//                <Box direction="row" margin="none" pad={{between: 'small'}} > 
//                     <Heading tag='h5' strong={true} margin='none' style={{color:'#01a982'}} >
//                       Created at:
//                     </Heading>
//                     <Heading tag='h5' strong={true} margin='none'>
//                       {value['timestamp']}
//                     </Heading>
//                </Box>
//           </Box>
//     </Box>
// </Header>
if(this.props.title==='Workload'){var selectionstyleing;if(this.state.WorkloadList.length>0){TileItems=this.state.WorkloadList.map(function(value,index){if(_this5.state.LoadItemIndex===index){selectionstyleing='brand';}else{selectionstyleing='accent-2-t';}inputText=_this5.props.flag===true?"Please select an item to Compare:":"Please select an item to Load:";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{key:index,separator:'top',align:'start',className:'LoadBoxInside',onClick:function onClick(){_this5.setState({LoadItemIndex:index});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Header___default.a,{size:'medium',pad:{"horizontal":"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{justify:'center',className:'WorkloadItemIcon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_DocumentConfig___default.a,{size:'medium',colorIndex:selectionstyleing})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:{between:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},value['alias'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:false,margin:'none'},value['timestamp']))))));});}else{inputText=" ";TileItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{alignItems:"center",justifyContent:'center',height:'300px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},'No Workloads are saved'));}}else if(this.props.title==='Solution'){if(this.state.SolutionList.length>0){TileItems=this.state.SolutionList.map(function(value,index){if(_this5.state.LoadItemIndex===index){selectionstyleing='brand';SavedSolutionName=value.alias;}else{selectionstyleing='accent-3-t';}inputText=_this5.props.flag===true?"Please select an item to Compare:":"Please select an item to Load:";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{key:index,separator:'top',align:'start',className:'LoadBoxInside '+_this5.state.SelectedTabActive,onClick:function onClick(){_this5.setState({LoadItemIndex:index});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Header___default.a,{size:'medium',pad:{"horizontal":"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{justify:'center',className:'SolutionItemIcon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Info___default.a,{size:'medium',colorIndex:selectionstyleing})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:{between:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},value['alias'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:false,margin:'none'},value['timestamp']))))));});}else{inputText=" ";TileItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{alignItems:"center",justifyContent:'center',height:'300px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},'No Solutions are saved '));}}else if(this.props.title==='All'){var selectionstyleing;if(this.state.WorkloadnSolutionData.length>0){TileItems=this.state.WorkloadnSolutionData.map(function(value,index){if(_this5.state.LoadItemIndex===index){selectionstyleing='brand';}else{selectionstyleing='accent-2-t';}inputText=_this5.props.flag===true?"Please select an item to Compare:":"Please select an item to Load:";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{key:index,separator:'top',align:'start',className:'LoadBoxInside',onClick:function onClick(){_this5.setState({LoadItemIndex:index,SelectedType:value.type});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Header___default.a,{size:'medium',pad:{"horizontal":"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},value.type==='Workload'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{justify:'center',className:'WorkloadItemIcon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_DocumentConfig___default.a,{size:'medium',colorIndex:selectionstyleing})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{justify:'center',className:'SolutionItemIcon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Info___default.a,{size:'medium',colorIndex:selectionstyleing})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:{between:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},value['alias'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',strong:false,margin:'none'},value['timestamp']))))));});}}else{TileItems='No Data available.';}}if(this.state.displayOldSolutionContent){OldSolutionLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.CloseOldSolutionLayer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Paragraph___default.a,{margin:'small'},'Loaded workload/solution is saved in older version. Tool is updated with newer inputs and functionalities. Please build a new workload/solution.'))));}if(this.state.CompareLayer&&!this.props.isLoading&&this.props.comparedata!==null&&this.props.comparedata.CompareData!=='File Mismatch'){// compare = <Layer margin="none" className="CompareTable" pad="small" style={{ width: '100% !important', zIndex: '500 !important' }}>
//   <Box  margin="none" pad="none" align='start' alignContent="start"  >
//     <Compare CloseLayer={this.handleClose.bind(this)} SavedSolName={SavedSolutionName}/>
//   </Box>
// </Layer>
}else{if(this.props.comparedata!==null&&!this.props.isLoading&&this.state.CompareLayer&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData==='File Mismatch'){compare=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.handleCloseError.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Paragraph___default.a,{margin:'small'},'Current solution is configured with different platform. Kindly select the solution with same platform to compare'))));}}//var emllay = ''
// if (this.state.EmailLayer) {
//   emllay = <Layer margin="none" pad="small" style={{ width: '100% !important', zIndex: '500 !important' }}>
//     <Box direction="row" margin="none" pad="none" align='start' alignContent="start"  >
//       <FormField className="DiskCapacityDetails" label='Enter Email id with whom you want to share' error="(3-10)">
//         <Box direction="row">
//           <TextInput id='StoraegWorkload' value={"Xyz@mphasis.com"} />
//         </Box>
//       </FormField>
//       <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" onClick={this.handleEmailClose.bind(this)} />
//     </Box>
//   </Layer>
// }
// var TileItems = DataObj.Workloads.Workload.map( (value, index) => {
// DataObj.Workloads.Workload.map( (value, index) => {
//          return <Tile key={index} basis='1/2' separator='top' align='start' > 
//                       <Header size='small' pad={{"horizontal": "small"}}>
//                            <Box direction="row" margin="none" pad={{between: 'small'}} >
//                                 <Box className='WorkloadItemIcon'>
//                                   <WorkLoadIcon size='small' />
//                                 </Box>
//                                 <Box className='SolutionItemIcon'>
//                                   <SolutionIcon size='small' />
//                                 </Box>
//                                 <Heading tag='h4' strong={true} margin='none'>
//                                   {value['@ID']}
//                                 </Heading>
//                           </Box>
//                       </Header>
//                       <Box pad='small'>
//                            <Heading tag='h4' strong={true} margin='none'> {value['@Name']} </Heading>
//                       </Box>
//                 </Tile>        
// });
if(this.state.showShareLayer){this.OnShare(this.state.LoadItemIndex);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Your Saved ',this.props.title,'(s)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){return _this5.props.onClose(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',style:{padding:'12px 12px 0px 12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:false,margin:'none'},inputText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{className:'LoadScrTileContainer',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none'},TileItems,compare)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',justify:'end',separator:'none',pad:{between:'small'}},this.state.LoadItemIndex===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:this.props.flag===true?'Compare':'Load'}):this.props.flag===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Compare',onClick:function onClick(){return _this5.onCompare(_this5.state.LoadItemIndex);}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Load',onClick:function onClick(){return _this5.onLoad(_this5.state.LoadItemIndex);}}),this.state.LoadItemIndex===''?this.props.flag===true?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Delete'}):this.props.flag===true?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Delete',onClick:function onClick(){return _this5.onDelete(_this5.state.LoadItemIndex);}}),this.state.LoadItemIndex===''?this.props.flag===true||this.props.SSETid!==undefined?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Share'}):this.props.flag===true||this.props.SSETid!==undefined?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Share',onClick:function onClick(){return _this5.OnShare(_this5.state.LoadItemIndex);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,label:'Cancel',onClick:function onClick(){return _this5.props.onClose(false);},critical:true})),DeleteLayer,ShareLayer,OldSolutionLayer);}}]);return LoadFiles;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var workloadtype="SAPHANA";if(state.sizerWorkload.workload.UserInputs!==undefined&&state.sizerWorkload.workload.UserInputs.Environments)workloadtype=state.sizerWorkload.workload.UserInputs.Environments.WorkloadType;return{allSessions:state.sessions.sessions,activeSession:state.sessions.activeSession,DefaultInputs:state.sessions.sessionDefaults.inputs,userData:state.sessions.userData,supportedList:state.sizerWorkload.supportedList,UserID:state.auth.userData.hpclname,isLoading:state.sessions.isLoading,loadedOldSolution:state.sessions.loadedOldSolution||false,responseFromShare:state.sessions.feedback,comparedata:state.sessions.CompareData,// DefaultInputs: state.sessions.sessionDefaults.inputs,
guiState:state.sizerWorkload.guiState,//Devendu Changes 25052020
SSETid:state.sessions.SSETid,WorkloadType:workloadtype};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAddSession:function onAddSession(id,name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["e" /* addSession */])(id,name));},onLoadWokload:function onLoadWokload(userData){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["H" /* loadSessionList */])(userData));},onShareItems:function onShareItems(userData){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["U" /* shareItems */])(userData));},onLoadSession:function onLoadSession(selectedID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["G" /* loadSessionItem */])(selectedID));},onDeleteSession:function onDeleteSession(selectedID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["k" /* deleteSessionItem */])(selectedID));},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});},onUpdateDefaultSession:function onUpdateDefaultSession(inputs){dispatch({type:'UPDATE_SESSION_DEFAULTS',payload:inputs});},OnFetchSupportedList:function OnFetchSupportedList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["C" /* fetchSupportedList */])());},OnComparedata:function OnComparedata(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["i" /* comparedata */])(value));},updateLoadedOldSolution:function updateLoadedOldSolution(value){dispatch({type:'UPDATE_LOADED_OLD_SOLUTION',payload:value});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(LoadFiles));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-up', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-up');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '18 9 12 15 6 9', transform: 'matrix(1 0 0 -1 0 24)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormUp';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-down');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '18 9 12 15 6 9' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormDown';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(284);
var IE8_DOM_DEFINE = __webpack_require__(285);
var toPrimitive = __webpack_require__(130);
var dP = Object.defineProperty;

exports.f = __webpack_require__(52) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(100);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(183);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(286) || !__webpack_require__(179)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(67)[K];
});


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = module.exports = function (host) {
    var originalMethods = {},
        overriddenMethods = this._getOverriddenMethods(this, originalMethods);

    Object.keys(overriddenMethods).forEach(function (key) {
        if (typeof overriddenMethods[key] === 'function') {
            originalMethods[key] = host[key];
            host[key] = overriddenMethods[key];
        }
    });
};

Mixin.prototype._getOverriddenMethods = function () {
    throw new Error('Not implemented');
};



/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(193).EventEmitter;
var inherits = __webpack_require__(83);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(194);
Stream.Writable = __webpack_require__(654);
Stream.Duplex = __webpack_require__(655);
Stream.Transform = __webpack_require__(656);
Stream.PassThrough = __webpack_require__(657);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)))

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var PATH = exports.PATH = {
    VECTOR: 0,
    BEZIER_CURVE: 1,
    CIRCLE: 2
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Path = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Vector = function Vector(x, y) {
    _classCallCheck(this, Vector);

    this.type = _Path.PATH.VECTOR;
    this.x = x;
    this.y = y;
    if (false) {
        if (isNaN(x)) {
            console.error('Invalid x value given for Vector');
        }
        if (isNaN(y)) {
            console.error('Invalid y value given for Vector');
        }
    }
};

exports.default = Vector;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseListStyle = exports.parseListStyleType = exports.LIST_STYLE_TYPE = exports.LIST_STYLE_POSITION = undefined;

var _background = __webpack_require__(106);

var LIST_STYLE_POSITION = exports.LIST_STYLE_POSITION = {
    INSIDE: 0,
    OUTSIDE: 1
};

var LIST_STYLE_TYPE = exports.LIST_STYLE_TYPE = {
    NONE: -1,
    DISC: 0,
    CIRCLE: 1,
    SQUARE: 2,
    DECIMAL: 3,
    CJK_DECIMAL: 4,
    DECIMAL_LEADING_ZERO: 5,
    LOWER_ROMAN: 6,
    UPPER_ROMAN: 7,
    LOWER_GREEK: 8,
    LOWER_ALPHA: 9,
    UPPER_ALPHA: 10,
    ARABIC_INDIC: 11,
    ARMENIAN: 12,
    BENGALI: 13,
    CAMBODIAN: 14,
    CJK_EARTHLY_BRANCH: 15,
    CJK_HEAVENLY_STEM: 16,
    CJK_IDEOGRAPHIC: 17,
    DEVANAGARI: 18,
    ETHIOPIC_NUMERIC: 19,
    GEORGIAN: 20,
    GUJARATI: 21,
    GURMUKHI: 22,
    HEBREW: 22,
    HIRAGANA: 23,
    HIRAGANA_IROHA: 24,
    JAPANESE_FORMAL: 25,
    JAPANESE_INFORMAL: 26,
    KANNADA: 27,
    KATAKANA: 28,
    KATAKANA_IROHA: 29,
    KHMER: 30,
    KOREAN_HANGUL_FORMAL: 31,
    KOREAN_HANJA_FORMAL: 32,
    KOREAN_HANJA_INFORMAL: 33,
    LAO: 34,
    LOWER_ARMENIAN: 35,
    MALAYALAM: 36,
    MONGOLIAN: 37,
    MYANMAR: 38,
    ORIYA: 39,
    PERSIAN: 40,
    SIMP_CHINESE_FORMAL: 41,
    SIMP_CHINESE_INFORMAL: 42,
    TAMIL: 43,
    TELUGU: 44,
    THAI: 45,
    TIBETAN: 46,
    TRAD_CHINESE_FORMAL: 47,
    TRAD_CHINESE_INFORMAL: 48,
    UPPER_ARMENIAN: 49,
    DISCLOSURE_OPEN: 50,
    DISCLOSURE_CLOSED: 51
};

var parseListStyleType = exports.parseListStyleType = function parseListStyleType(type) {
    switch (type) {
        case 'disc':
            return LIST_STYLE_TYPE.DISC;
        case 'circle':
            return LIST_STYLE_TYPE.CIRCLE;
        case 'square':
            return LIST_STYLE_TYPE.SQUARE;
        case 'decimal':
            return LIST_STYLE_TYPE.DECIMAL;
        case 'cjk-decimal':
            return LIST_STYLE_TYPE.CJK_DECIMAL;
        case 'decimal-leading-zero':
            return LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO;
        case 'lower-roman':
            return LIST_STYLE_TYPE.LOWER_ROMAN;
        case 'upper-roman':
            return LIST_STYLE_TYPE.UPPER_ROMAN;
        case 'lower-greek':
            return LIST_STYLE_TYPE.LOWER_GREEK;
        case 'lower-alpha':
            return LIST_STYLE_TYPE.LOWER_ALPHA;
        case 'upper-alpha':
            return LIST_STYLE_TYPE.UPPER_ALPHA;
        case 'arabic-indic':
            return LIST_STYLE_TYPE.ARABIC_INDIC;
        case 'armenian':
            return LIST_STYLE_TYPE.ARMENIAN;
        case 'bengali':
            return LIST_STYLE_TYPE.BENGALI;
        case 'cambodian':
            return LIST_STYLE_TYPE.CAMBODIAN;
        case 'cjk-earthly-branch':
            return LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH;
        case 'cjk-heavenly-stem':
            return LIST_STYLE_TYPE.CJK_HEAVENLY_STEM;
        case 'cjk-ideographic':
            return LIST_STYLE_TYPE.CJK_IDEOGRAPHIC;
        case 'devanagari':
            return LIST_STYLE_TYPE.DEVANAGARI;
        case 'ethiopic-numeric':
            return LIST_STYLE_TYPE.ETHIOPIC_NUMERIC;
        case 'georgian':
            return LIST_STYLE_TYPE.GEORGIAN;
        case 'gujarati':
            return LIST_STYLE_TYPE.GUJARATI;
        case 'gurmukhi':
            return LIST_STYLE_TYPE.GURMUKHI;
        case 'hebrew':
            return LIST_STYLE_TYPE.HEBREW;
        case 'hiragana':
            return LIST_STYLE_TYPE.HIRAGANA;
        case 'hiragana-iroha':
            return LIST_STYLE_TYPE.HIRAGANA_IROHA;
        case 'japanese-formal':
            return LIST_STYLE_TYPE.JAPANESE_FORMAL;
        case 'japanese-informal':
            return LIST_STYLE_TYPE.JAPANESE_INFORMAL;
        case 'kannada':
            return LIST_STYLE_TYPE.KANNADA;
        case 'katakana':
            return LIST_STYLE_TYPE.KATAKANA;
        case 'katakana-iroha':
            return LIST_STYLE_TYPE.KATAKANA_IROHA;
        case 'khmer':
            return LIST_STYLE_TYPE.KHMER;
        case 'korean-hangul-formal':
            return LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL;
        case 'korean-hanja-formal':
            return LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL;
        case 'korean-hanja-informal':
            return LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL;
        case 'lao':
            return LIST_STYLE_TYPE.LAO;
        case 'lower-armenian':
            return LIST_STYLE_TYPE.LOWER_ARMENIAN;
        case 'malayalam':
            return LIST_STYLE_TYPE.MALAYALAM;
        case 'mongolian':
            return LIST_STYLE_TYPE.MONGOLIAN;
        case 'myanmar':
            return LIST_STYLE_TYPE.MYANMAR;
        case 'oriya':
            return LIST_STYLE_TYPE.ORIYA;
        case 'persian':
            return LIST_STYLE_TYPE.PERSIAN;
        case 'simp-chinese-formal':
            return LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL;
        case 'simp-chinese-informal':
            return LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL;
        case 'tamil':
            return LIST_STYLE_TYPE.TAMIL;
        case 'telugu':
            return LIST_STYLE_TYPE.TELUGU;
        case 'thai':
            return LIST_STYLE_TYPE.THAI;
        case 'tibetan':
            return LIST_STYLE_TYPE.TIBETAN;
        case 'trad-chinese-formal':
            return LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL;
        case 'trad-chinese-informal':
            return LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL;
        case 'upper-armenian':
            return LIST_STYLE_TYPE.UPPER_ARMENIAN;
        case 'disclosure-open':
            return LIST_STYLE_TYPE.DISCLOSURE_OPEN;
        case 'disclosure-closed':
            return LIST_STYLE_TYPE.DISCLOSURE_CLOSED;
        case 'none':
        default:
            return LIST_STYLE_TYPE.NONE;
    }
};

var parseListStyle = exports.parseListStyle = function parseListStyle(style) {
    var listStyleImage = (0, _background.parseBackgroundImage)(style.getPropertyValue('list-style-image'));
    return {
        listStyleType: parseListStyleType(style.getPropertyValue('list-style-type')),
        listStyleImage: listStyleImage.length ? listStyleImage[0] : null,
        listStylePosition: parseListStylePosition(style.getPropertyValue('list-style-position'))
    };
};

var parseListStylePosition = function parseListStylePosition(position) {
    switch (position) {
        case 'inside':
            return LIST_STYLE_POSITION.INSIDE;
        case 'outside':
        default:
            return LIST_STYLE_POSITION.OUTSIDE;
    }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _textTransform = __webpack_require__(326);

var _TextBounds = __webpack_require__(328);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextContainer = function () {
    function TextContainer(text, parent, bounds) {
        _classCallCheck(this, TextContainer);

        this.text = text;
        this.parent = parent;
        this.bounds = bounds;
    }

    _createClass(TextContainer, null, [{
        key: 'fromTextNode',
        value: function fromTextNode(node, parent) {
            var text = transform(node.data, parent.style.textTransform);
            return new TextContainer(text, parent, (0, _TextBounds.parseTextBounds)(text, parent, node));
        }
    }]);

    return TextContainer;
}();

exports.default = TextContainer;


var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;

var transform = function transform(text, _transform) {
    switch (_transform) {
        case _textTransform.TEXT_TRANSFORM.LOWERCASE:
            return text.toLowerCase();
        case _textTransform.TEXT_TRANSFORM.CAPITALIZE:
            return text.replace(CAPITALIZE, capitalize);
        case _textTransform.TEXT_TRANSFORM.UPPERCASE:
            return text.toUpperCase();
        default:
            return text;
    }
};

function capitalize(m, p1, p2) {
    if (m.length > 0) {
        return p1 + p2.toUpperCase();
    }

    return m;
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ForeignObjectRenderer = __webpack_require__(329);

var testRangeBounds = function testRangeBounds(document) {
    var TEST_HEIGHT = 123;

    if (document.createRange) {
        var range = document.createRange();
        if (range.getBoundingClientRect) {
            var testElement = document.createElement('boundtest');
            testElement.style.height = TEST_HEIGHT + 'px';
            testElement.style.display = 'block';
            document.body.appendChild(testElement);

            range.selectNode(testElement);
            var rangeBounds = range.getBoundingClientRect();
            var rangeHeight = Math.round(rangeBounds.height);
            document.body.removeChild(testElement);
            if (rangeHeight === TEST_HEIGHT) {
                return true;
            }
        }
    }

    return false;
};

// iOS 10.3 taints canvas with base64 images unless crossOrigin = 'anonymous'
var testBase64 = function testBase64(document, src) {
    var img = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');

    return new Promise(function (resolve) {
        // Single pixel base64 image renders fine on iOS 10.3???
        img.src = src;

        var onload = function onload() {
            try {
                ctx.drawImage(img, 0, 0);
                canvas.toDataURL();
            } catch (e) {
                return resolve(false);
            }

            return resolve(true);
        };

        img.onload = onload;
        img.onerror = function () {
            return resolve(false);
        };

        if (img.complete === true) {
            setTimeout(function () {
                onload();
            }, 500);
        }
    });
};

var testCORS = function testCORS() {
    return typeof new Image().crossOrigin !== 'undefined';
};

var testResponseType = function testResponseType() {
    return typeof new XMLHttpRequest().responseType === 'string';
};

var testSVG = function testSVG(document) {
    var img = new Image();
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    img.src = 'data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\'></svg>';

    try {
        ctx.drawImage(img, 0, 0);
        canvas.toDataURL();
    } catch (e) {
        return false;
    }
    return true;
};

var isGreenPixel = function isGreenPixel(data) {
    return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
};

var testForeignObject = function testForeignObject(document) {
    var canvas = document.createElement('canvas');
    var size = 100;
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext('2d');
    ctx.fillStyle = 'rgb(0, 255, 0)';
    ctx.fillRect(0, 0, size, size);

    var img = new Image();
    var greenImageSrc = canvas.toDataURL();
    img.src = greenImageSrc;
    var svg = (0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, img);
    ctx.fillStyle = 'red';
    ctx.fillRect(0, 0, size, size);

    return (0, _ForeignObjectRenderer.loadSerializedSVG)(svg).then(function (img) {
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, size, size).data;
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);

        var node = document.createElement('div');
        node.style.backgroundImage = 'url(' + greenImageSrc + ')';
        node.style.height = size + 'px';
        // Firefox 55 does not render inline <img /> tags
        return isGreenPixel(data) ? (0, _ForeignObjectRenderer.loadSerializedSVG)((0, _ForeignObjectRenderer.createForeignObjectSVG)(size, size, 0, 0, node)) : Promise.reject(false);
    }).then(function (img) {
        ctx.drawImage(img, 0, 0);
        // Edge does not render background-images
        return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
    }).catch(function (e) {
        return false;
    });
};

var FEATURES = {
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RANGE_BOUNDS() {
        'use strict';

        var value = testRangeBounds(document);
        Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_SVG_DRAWING() {
        'use strict';

        var value = testSVG(document);
        Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_BASE64_DRAWING() {
        'use strict';

        return function (src) {
            var _value = testBase64(document, src);
            Object.defineProperty(FEATURES, 'SUPPORT_BASE64_DRAWING', { value: function value() {
                    return _value;
                } });
            return _value;
        };
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_FOREIGNOBJECT_DRAWING() {
        'use strict';

        var value = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
        Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_IMAGES() {
        'use strict';

        var value = testCORS();
        Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_RESPONSE_TYPE() {
        'use strict';

        var value = testResponseType();
        Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
        return value;
    },
    // $FlowFixMe - get/set properties not yet supported
    get SUPPORT_CORS_XHR() {
        'use strict';

        var value = 'withCredentials' in new XMLHttpRequest();
        Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
        return value;
    }
};

exports.default = FEATURES;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _utils = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.METER;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Graphic = function (_Component) {
  _inherits(Graphic, _Component);

  function Graphic(props, context) {
    _classCallCheck(this, Graphic);

    var _this = _possibleConstructorReturn(this, (Graphic.__proto__ || Object.getPrototypeOf(Graphic)).call(this, props, context));

    _this.state = _this._stateFromProps(props);

    _this._onNextBand = _this._onNextBand.bind(_this);
    _this._onPreviousBand = _this._onPreviousBand.bind(_this);
    _this._onGraphicFocus = _this._onGraphicFocus.bind(_this);
    _this._onGraphicBlur = _this._onGraphicBlur.bind(_this);
    _this._onBandClick = _this._onBandClick.bind(_this);
    return _this;
  }

  _createClass(Graphic, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var state = this._stateFromProps(newProps);
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._keyboardHandlers) {
        this._onGraphicBlur();
      }
    }
  }, {
    key: '_onGraphicFocus',
    value: function _onGraphicFocus() {
      this._keyboardHandlers = {
        left: this._onPreviousBand,
        up: this._onPreviousBand,
        right: this._onNextBand,
        down: this._onNextBand,
        enter: this._onBandClick
      };
      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
    }
  }, {
    key: '_onGraphicBlur',
    value: function _onGraphicBlur() {
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
      this._keyboardHandlers = undefined;
    }
  }, {
    key: '_onBandClick',
    value: function _onBandClick() {
      if (this.props.activeIndex !== undefined) {
        var activeBand = this.props.series[this.props.activeIndex];
        if (activeBand && activeBand.onClick) {
          activeBand.onClick();
        }
      }
    }

    // override

  }, {
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      return {};
    }

    // override

  }, {
    key: '_sliceCommands',
    value: function _sliceCommands(trackIndex, item, startValue) {
      return "";
    }
  }, {
    key: '_renderSlice',
    value: function _renderSlice(trackIndex, item, itemIndex, startValue, max, track, threshold) {
      var _props = this.props,
          activeIndex = _props.activeIndex,
          onActivate = _props.onActivate;

      var path = void 0;
      if (!item.hidden) {
        var _classnames;

        var classes = (0, _classnames3.default)(CLASS_ROOT + '__slice', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__slice--active', itemIndex === activeIndex), _defineProperty(_classnames, CLASS_ROOT + '__slice--clickable', item.onClick), _defineProperty(_classnames, COLOR_INDEX + '-' + item.colorIndex, item.colorIndex), _classnames));

        var commands = this._sliceCommands(trackIndex, item, startValue, max);

        if (threshold) {
          path = (0, _utils.buildPath)(itemIndex, commands, classes);
        } else if (track) {
          path = (0, _utils.buildPath)(itemIndex, commands, classes, onActivate, item.onClick);
        } else {
          var a11yTitle = '' + item.value;
          var role = this.props.series.length > 1 ? 'img' : undefined;
          path = (0, _utils.buildPath)(itemIndex, commands, classes, onActivate, item.onClick, a11yTitle, role);
        }
      }

      return path;
    }
  }, {
    key: '_renderSlices',
    value: function _renderSlices(series, trackIndex, track, threshold) {
      var _this2 = this;

      var _props2 = this.props,
          min = _props2.min,
          max = _props2.max;

      var startValue = min;

      var paths = series.map(function (item, itemIndex) {
        var path = _this2._renderSlice(trackIndex, item, itemIndex, startValue, max, track, threshold);

        startValue += item.value;

        return path;
      });

      return paths;
    }
  }, {
    key: '_loadingCommands',
    value: function _loadingCommands() {
      return this._sliceCommands(0, { value: this.props.max }, this.props.min);
    }
  }, {
    key: '_onPreviousBand',
    value: function _onPreviousBand(event) {
      event.preventDefault();
      var activeIndex = this.props.activeIndex !== undefined ? this.props.activeIndex : -1;

      if (activeIndex - 1 >= 0) {
        this.props.onActivate(activeIndex - 1);
      }

      //stop event propagation
      return true;
    }
  }, {
    key: '_onNextBand',
    value: function _onNextBand(event) {
      event.preventDefault();
      var activeIndex = this.props.activeIndex !== undefined ? this.props.activeIndex : -1;

      var totalBands = _reactDom2.default.findDOMNode(this.meterValuesRef).childNodes.length;

      if (activeIndex + 1 < totalBands) {
        this.props.onActivate(activeIndex + 1);
      }

      //stop event propagation
      return true;
    }
  }, {
    key: '_renderLoading',
    value: function _renderLoading() {
      var classes = (0, _classnames3.default)(CLASS_ROOT + '__slice', CLASS_ROOT + '__slice--loading', COLOR_INDEX + '-loading');
      var commands = this._loadingCommands();
      return [_react2.default.createElement('path', { key: 'loading', className: classes, d: commands })];
    }
  }, {
    key: '_renderValues',
    value: function _renderValues() {
      var _this3 = this;

      var _props3 = this.props,
          min = _props3.min,
          max = _props3.max;

      var values = void 0;
      if (this.props.stacked) {
        values = this._renderSlices(this.props.series, 0);
      } else {
        values = this.props.series.map(function (item, index) {
          return _this3._renderSlice(index, item, index, min, max);
        });
      }
      if (values.length === 0) {
        values = this._renderLoading();
      }
      return _react2.default.createElement(
        'g',
        { ref: function ref(_ref) {
            return _this3.meterValuesRef = _ref;
          },
          className: CLASS_ROOT + '__values' },
        values
      );
    }
  }, {
    key: '_renderTracks',
    value: function _renderTracks() {
      var _this4 = this;

      var _props4 = this.props,
          min = _props4.min,
          max = _props4.max;

      var trackValue = { value: max };
      var tracks = void 0;
      if (this.props.stacked) {
        tracks = this._renderSlice(0, trackValue, 0, min, max, true, false);
      } else {
        tracks = this.props.series.map(function (item, index) {
          return _this4._renderSlice(index, trackValue, index, min, max, true, false);
        });
      }
      return _react2.default.createElement(
        'g',
        { className: CLASS_ROOT + '__tracks' },
        tracks
      );
    }
  }, {
    key: '_renderThresholds',
    value: function _renderThresholds() {
      var result = void 0;
      var thresholds = this._renderSlices(this.props.thresholds, -0.4, false, true);
      if (thresholds.length > 0) {
        result = _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__thresholds' },
          thresholds
        );
      }
      return result;
    }
  }, {
    key: '_renderTotal',
    value: function _renderTotal() {
      return this.props.series.map(function (s) {
        return s.value;
      }).reduce(function (prev, curr) {
        return prev + curr;
      }, 0);
    }
  }, {
    key: '_renderTopLayer',
    value: function _renderTopLayer() {
      return undefined;
    }
  }, {
    key: '_renderA11YTitle',
    value: function _renderA11YTitle() {
      var a11yTitle = this.props.a11yTitle;
      if (!a11yTitle) {
        var graphicTitle = _Intl2.default.getMessage(this.context.intl, this.displayName);
        var meterTitle = _Intl2.default.getMessage(this.context.intl, 'Meter');

        a11yTitle = graphicTitle + ' ' + meterTitle;
      }

      return a11yTitle + '. ' + this._renderA11YDesc();
    }
  }, {
    key: '_renderA11YDesc',
    value: function _renderA11YDesc() {
      var a11yDesc = this.props.a11yDesc;
      if (!a11yDesc) {
        var valueLabel = _Intl2.default.getMessage(this.context.intl, 'Value');
        a11yDesc = ', ' + valueLabel + ': ' + this._renderTotal();

        if (this.props.min) {
          var minLabel = _Intl2.default.getMessage(this.context.intl, 'Min');
          a11yDesc += ', ' + minLabel + ': ' + this.props.min;
        }

        if (this.props.max) {
          var maxLabel = _Intl2.default.getMessage(this.context.intl, 'Max');
          a11yDesc += ', ' + maxLabel + ': ' + this.props.max;
        }

        if (this.props.thresholds) {
          var thresholdLabel = _Intl2.default.getMessage(this.context.intl, 'Threshold');
          this.props.thresholds.forEach(function (threshold) {
            if (threshold.ariaLabel) {
              a11yDesc += ', ' + thresholdLabel + ': ' + threshold.ariaLabel;
            }
          });
        }
      }

      return a11yDesc;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          series = _props5.series,
          tabIndex = _props5.tabIndex;
      var _state = this.state,
          viewBoxHeight = _state.viewBoxHeight,
          viewBoxWidth = _state.viewBoxWidth;

      var tracks = this._renderTracks();
      var values = this._renderValues();
      var thresholds = this._renderThresholds();
      var topLayer = this._renderTopLayer();

      var a11yTitle = this._renderA11YTitle();

      var role = series.length > 1 ? 'group' : 'img';

      return _react2.default.createElement(
        'svg',
        { className: CLASS_ROOT + '__graphic',
          tabIndex: role === 'img' ? undefined : tabIndex || '0',
          width: viewBoxWidth, role: role,
          height: viewBoxHeight,
          viewBox: '0 0 ' + viewBoxWidth + ' ' + viewBoxHeight,
          preserveAspectRatio: 'xMidYMid meet',
          'aria-label': a11yTitle, onFocus: this._onGraphicFocus,
          onBlur: this._onGraphicBlur },
        tracks,
        thresholds,
        values,
        topLayer
      );
    }
  }]);

  return Graphic;
}(_react.Component);

Graphic.displayName = 'Graphic';
exports.default = Graphic;


Graphic.propTypes = _extends({
  stacked: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.string,
  thresholds: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.number.isRequired,
    colorIndex: _propTypes2.default.string
  })).isRequired,
  vertical: _propTypes2.default.bool
}, _utils.propTypes);

Graphic.contextTypes = {
  intl: _propTypes2.default.object
};

Graphic.defaultProps = {
  tabIndex: '0'
};
module.exports = exports['default'];

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function every(array, predicate) {
	for (var i = 0; i < array.length; i += 1) {
		if (!predicate(array[i], i, array)) {
			return false;
		}
	}
	return true;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assertRecord = __webpack_require__(90);

var IsAccessorDescriptor = __webpack_require__(55);
var IsDataDescriptor = __webpack_require__(30);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-isgenericdescriptor

module.exports = function IsGenericDescriptor(Desc) {
	if (typeof Desc === 'undefined') {
		return false;
	}

	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (!IsAccessorDescriptor(Desc) && !IsDataDescriptor(Desc)) {
		return true;
	}

	return false;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;

var inspectCustom = __webpack_require__(388).custom;
var inspectSymbol = inspectCustom && isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') { // eslint-disable-line valid-typeof
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return '[Object]';
    }

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        return '[Function' + (name ? ': ' + name : '') + ']';
    }
    if (isSymbol(obj)) {
        var symString = Symbol.prototype.toString.call(obj);
        return typeof obj === 'object' ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        return '[ ' + arrObjKeys(obj, inspect).join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object') {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var xs = arrObjKeys(obj, inspect);
        if (xs.length === 0) { return '{}'; }
        return '{ ' + xs.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]'; }
function isDate(obj) { return toStr(obj) === '[object Date]'; }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]'; }
function isError(obj) { return toStr(obj) === '[object Error]'; }
function isSymbol(obj) { return toStr(obj) === '[object Symbol]'; }
function isString(obj) { return toStr(obj) === '[object String]'; }
function isNumber(obj) { return toStr(obj) === '[object Number]'; }
function isBigInt(obj) { return toStr(obj) === '[object BigInt]'; }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]'; }

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(f, /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b', 9: 't', 10: 'n', 12: 'f', 13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16);
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries) {
    return type + ' (' + size + ') {' + entries.join(', ') + '}';
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    return xs;
}


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(393);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Day = __webpack_require__(116);
var DayFromYear = __webpack_require__(151);
var YearFromTime = __webpack_require__(117);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.4

module.exports = function DayWithinYear(t) {
	return Day(t) - DayFromYear(YearFromTime(t));
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $floor = GetIntrinsic('%Math.floor%');

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3

module.exports = function DayFromYear(y) {
	return (365 * (y - 1970)) + $floor((y - 1969) / 4) - $floor((y - 1901) / 100) + $floor((y - 1601) / 400);
};



/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $EvalError = GetIntrinsic('%EvalError%');

var DaysInYear = __webpack_require__(228);
var YearFromTime = __webpack_require__(117);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3

module.exports = function InLeapYear(t) {
	var days = DaysInYear(YearFromTime(t));
	if (days === 365) {
		return 0;
	}
	if (days === 366) {
		return 1;
	}
	throw new $EvalError('Assertion failed: there are not 365 or 366 days in a year, got: ' + days);
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DayWithinYear = __webpack_require__(150);
var InLeapYear = __webpack_require__(152);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.4

module.exports = function MonthFromTime(t) {
	var day = DayWithinYear(t);
	if (0 <= day && day < 31) {
		return 0;
	}
	var leap = InLeapYear(t);
	if (31 <= day && day < (59 + leap)) {
		return 1;
	}
	if ((59 + leap) <= day && day < (90 + leap)) {
		return 2;
	}
	if ((90 + leap) <= day && day < (120 + leap)) {
		return 3;
	}
	if ((120 + leap) <= day && day < (151 + leap)) {
		return 4;
	}
	if ((151 + leap) <= day && day < (181 + leap)) {
		return 5;
	}
	if ((181 + leap) <= day && day < (212 + leap)) {
		return 6;
	}
	if ((212 + leap) <= day && day < (243 + leap)) {
		return 7;
	}
	if ((243 + leap) <= day && day < (273 + leap)) {
		return 8;
	}
	if ((273 + leap) <= day && day < (304 + leap)) {
		return 9;
	}
	if ((304 + leap) <= day && day < (334 + leap)) {
		return 10;
	}
	if ((334 + leap) <= day && day < (365 + leap)) {
		return 11;
	}
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(89);
var DefineOwnProperty = __webpack_require__(113);

var FromPropertyDescriptor = __webpack_require__(92);
var IsAccessorDescriptor = __webpack_require__(55);
var IsDataDescriptor = __webpack_require__(30);
var IsPropertyKey = __webpack_require__(19);
var SameValue = __webpack_require__(74);
var ToPropertyDescriptor = __webpack_require__(72);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow

module.exports = function DefinePropertyOrThrow(O, P, desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var Desc = isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, desc) ? desc : ToPropertyDescriptor(desc);
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc is not a valid Property Descriptor');
	}

	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		Desc
	);
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(19);
var ToObject = __webpack_require__(229);

/**
 * 7.3.2 GetV (V, P)
 * 1. Assert: IsPropertyKey(P) is true.
 * 2. Let O be ToObject(V).
 * 3. ReturnIfAbrupt(O).
 * 4. Return O.[[Get]](P, V).
 */

module.exports = function GetV(V, P) {
	// 7.3.2.1
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	// 7.3.2.2-3
	var O = ToObject(V);

	// 7.3.2.4
	return O[P];
};


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* unused harmony export Link */
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(245);
/* unused harmony reexport MemoryRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* unused harmony reexport Redirect */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* unused harmony reexport Router */
/* unused harmony reexport StaticRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* unused harmony reexport generatePath */
/* unused harmony reexport matchPath */
/* unused harmony reexport useHistory */
/* unused harmony reexport useLocation */
/* unused harmony reexport useParams */
/* unused harmony reexport useRouteMatch */
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(121);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["default"])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["default"])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(481)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = __webpack_require__(58);

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filters}\n  =1 {one filter}\n  ' + 'other {# filters}\n}'
  }
}, _enUS2.default, {
  Active: 'Active',
  Activate: 'Activate',
  Activated: 'Activated',
  Add: 'Add',
  add: 'add',
  Alerts: 'Alerts',
  All: 'All',
  ampm: 'ampm',
  Arc: 'Arc',
  AxisLabel: '{orientation} Axis',
  area: 'area',
  Bar: 'Bar',
  bar: 'bar',
  Blank: 'Blank',
  Box: 'Box',
  Carousel: 'Carousel',
  Category: 'Category',
  Circle: 'Circle',
  Chart: 'Chart',
  Children: 'Children',
  Clear: 'Clear',
  Cleared: 'Cleared',
  Close: 'Close',
  'Close Menu': 'Close Menu',
  Completed: 'Completed',
  'Connects With': 'Connects With',
  created: 'Created',
  Critical: 'Critical',
  'Currently Active': 'Currently Active',
  'Date Selector': 'Date Selector',
  'Date Time Icon': 'Open Date and Time Selector',
  day: 'day',
  Disabled: 'Disabled',
  Distribution: 'Distribution',
  Email: 'Email',
  'Enter Select': 'Press enter to select it',
  Error: 'Error',
  Filter: 'Filter',
  Footer: 'Footer',
  Grommet: 'Grommet',
  HotSpotsLabel: 'HotSpots: press arrow keys to interact with it',
  'GraphValues': 'Graph has {count} items. Highest is {highest}' + ' and smallest is {smallest}',
  hour: 'hour',
  'Grommet Logo': 'Grommet Logo',
  'Layer': 'Layer',
  List: 'List',
  line: 'line',
  'Loading': 'Loading',
  loginInvalidPassword: 'Please provide Username and Password.',
  'Log In': 'Log In',
  Logout: 'Logout',
  'Main Content': 'Main Content',
  Max: 'Max',
  Menu: 'Menu',
  Meter: 'Meter',
  Min: 'Min',
  minute: 'minute',
  model: 'Model',
  modified: 'Modified',
  monitor: 'monitor',
  month: 'month',
  'Multi Select': 'Multi Select',
  Name: 'Name',
  'Navigation Help': 'Use arrow keys to navigate',
  'Next Month': 'Next Month',
  'Next Slide': 'Next Slide',
  'No Relationship': 'No Relationship',
  'Notification': 'Notification',
  OK: 'OK',
  Open: 'Open',
  Parent: 'Parent',
  Parents: 'Parents',
  Parts: 'Parts',
  Part: 'Part',
  Password: 'Password',
  'Previous Month': 'Previous Month',
  'Previous Slide': 'Previous Slide',
  'Previous Tiles': 'Previous Tiles',
  'Remember me': 'Remember me',
  'Range Start': 'Range Start',
  'Range End': 'Range End',
  Resource: 'Resource',
  Running: 'Running',
  Search: 'Search',
  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
  second: 'second',
  'Select Icon': 'Open Select Drop',
  Selected: 'Selected',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
  'Skip to': 'Skip to',
  'Slide Number': 'Slide {slideNumber}',
  Sort: 'Sort',
  Spinning: 'Spinning',
  Spiral: 'Spiral',
  State: 'State',
  Status: 'Status',
  Subtract: 'Subtract',
  SunBurst: 'SunBurst',
  'Tab Contents': '{activeTitle} Tab Contents',
  Table: 'Table',
  Tasks: 'Tasks',
  Tiles: 'Tiles',
  Time: 'Time',
  Title: 'Title',
  Today: 'Today',
  Topology: 'Topology',
  Total: 'Total',
  Threshold: 'Threshold',
  Unknown: 'Unknown',
  Username: 'Username',
  uri: 'URI',
  Value: 'Value',
  Warning: 'Warning',
  year: 'year'
});
module.exports = exports['default'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _frFR = __webpack_require__(122);

var _frFR2 = _interopRequireDefault(_frFR);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filtres}\n  =1 {un filtre}\n  ' + 'other {# filtres}\n}'
  }
}, _frFR2.default, {
  Active: 'Actif',
  Activate: 'Activé',
  Activated: 'Est Actif',
  Add: 'Ajouter',
  add: 'ajouter',
  Alerts: 'Alertes',
  All: 'Tout',
  ampm: 'ampm',
  Arc: 'Arc',
  AxisLabel: '{orientation} Axe',
  area: 'zone',
  Bar: 'Barre',
  bar: 'barre',
  Blank: 'Vide',
  Box: 'Cadre',
  Carousel: 'Carousel',
  Category: 'Catégorie',
  Circle: 'Cercle',
  Chart: 'Diagramme',
  Children: 'Enfant',
  Clear: 'Nettoyer',
  Cleared: 'Nettoyé',
  Close: 'Fermer',
  'Close Menu': 'Fermer le menu',
  Completed: 'Completer',
  'Connects With': 'Se connecte avec',
  created: 'Créer',
  Critical: 'Critique',
  'Currently Active': 'Actuellement Actif',
  'Date Selector': 'Sélecteur de date',
  'Date Time Icon': 'Ouvrir le sélecteur de date et heure',
  day: 'jour',
  Disabled: 'Désactivé',
  Distribution: 'Distribution',
  Email: 'Courriel',
  'Enter Select': 'Appuyer sur entrer pour sélectionner',
  Error: 'Erreur',
  Filter: 'Filtre',
  Footer: 'Pied de page',
  Grommet: 'Grommet',
  HotSpotsLabel: 'HotSpots: press arrow keys to interact with it',
  'GraphValues': 'Le graphique a {count} articles. Le plus grand est {highest}' + ' le plus petit est {smallest}',
  hour: 'heure',
  'Grommet Logo': 'Logo de Grommet',
  'Layer': 'Calque',
  List: 'Liste',
  line: 'ligne',
  'Loading': 'Chargement',
  loginInvalidPassword: 'Veuillez entrer un nom d\'utilisateur et un mot de passe.',
  'Log In': 'Connexion',
  Logout: 'Déconnexion',
  'Main Content': 'Contenu principal',
  Max: 'Max',
  Menu: 'Menu',
  Meter: 'Mètre',
  Min: 'Min',
  minute: 'minute',
  model: 'Modèle',
  modified: 'Modifié',
  monitor: 'moniteur',
  month: 'mois',
  'Multi Select': 'Sélection multiple',
  Name: 'Nom',
  'Navigation Help': 'Utilisez les flèches pour naviguer',
  'Next Month': 'Mois Suivant',
  'Next Slide': 'Fiche Suivante',
  'No Relationship': 'Aucun relation',
  'Notification': 'Notification',
  OK: 'OK',
  Open: 'Ouvrir',
  Parent: 'Parent',
  Parents: 'Parents',
  Parts: 'Parties',
  Part: 'Partie',
  Password: 'Mot de passe',
  'Previous Month': 'Mois Précédent',
  'Previous Slide': 'Fiche Précédente',
  'Previous Tiles': 'Tuiles Précédentes',
  'Remember me': 'Se souvenir de moi',
  'Range Start': 'Début de l\'intervalle',
  'Range End': 'Fin de l\'intervalle',
  Resource: 'Ressource',
  Running: 'En marche',
  Search: 'Recherche',
  'Match Results': 'Il {count, plural,\n      =0 {n\'y a aucun r\xE9sultat}\n      one {y a # r\xE9sultat}\n      other {y a # r\xE9sultats}\n  }',
  second: 'seconde',
  'Select Icon': 'Ouvrir le sélecteur déroulant',
  Selected: 'Sélectionné',
  'Selected Multiple': '{count, plural,\n      =0 {aucune}\n      one {# valeur}\n      other {# valeurs}\n  }',
  'Skip to': 'Aller à',
  'Slide Number': 'Fiche {slideNumber}',
  Sort: 'Classer',
  Spinning: 'Rotation',
  Spiral: 'Spirale',
  State: 'État',
  Status: 'Status',
  Subtract: 'Soustraire',
  SunBurst: 'Graphique en rayons de soleil',
  'Tab Contents': '{activeTitle} Contenu de l\'onglet',
  Table: 'Tableau',
  Tasks: 'Tâches',
  Tiles: 'Tuiles',
  Time: 'Temps',
  Title: 'Titre',
  Today: 'Aujourd\'hui',
  Topology: 'Topologie',
  Total: 'Totale',
  Threshold: 'Seuil',
  Unknown: 'Inconne',
  Username: 'Nom d\'utilisateur',
  uri: 'URI',
  Value: 'Valeur',
  Warning: 'Avertissement',
  year: 'année'
});
module.exports = exports['default'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3D',
  'access-accessibility': 'アクセスアクセシビリティ',
  'access-ad': 'アクセスAD',
  'access-assist-listening': 'アクセス聴覚支援',
  'access-braille': 'アクセス点字',
  'access-sign': 'アクセスサイン',
  'access-tty': 'アクセスtty',
  'access-volume-control': 'アクセスボリューム制御',
  'access-wheelchair-active': 'アクセス車椅子アクティブ',
  'access-wheelchair': 'アクセス車椅子',
  'achievement': '達成',
  'action': 'アクション',
  'actions': 'アクション',
  'add-circle': '追加円',
  'add': '追加',
  'aggregate': '集計',
  'aid': '補助',
  'alarm': 'アラーム',
  'alert': 'アラート',
  'analytics': '分析',
  'announce': 'アナウンス',
  'apps': 'アプリ',
  'archive': 'アーカイブ',
  'article': '記事',
  'ascend': '昇順',
  'attachment': '添付ファイル',
  'back-ten': '10戻る',
  'bar-chart': '棒グラフ',
  'basket': 'バスケット',
  'blog': 'ブログ',
  'book': '書籍',
  'bookmark': 'ブックマーク',
  'bottom-corner': '下部コーナー',
  'brand-apple-app-store': 'ブランドApple App Store',
  'brand-codepen-edit': 'ブランドCodepen編集',
  'brand-codepen-try': 'ブランドCodepen試行',
  'brand-google-play': 'ブランドGoogle Play',
  'brand-grommet-outline': 'ブランドGrommetアウトライン',
  'brand-grommet-path': 'ブランドGrommetパス',
  'brand-hpe-element-outline': 'ブランドHPEエレメントアウトライン',
  'brand-hpe-element-path': 'ブランドHPEエレメントパス',
  'brand-hpe-labs-insignia-outline': 'ブランドHPEラボ記章アウトライン',
  'brand-hpe-labs-insignia': 'ブランドHPEラボ記章',
  'brand-hpe-stack-centered': 'ブランドHPEスタック中央揃え',
  'brand-hpe-stack': 'ブランドHPEスタック',
  'briefcase': 'ブリーフケース',
  'brush': 'ブラシ',
  'bug': 'バグ',
  'bundle': 'バンドル',
  'business-service': 'ビジネスサービス',
  'calculator': '計算機',
  'calendar': 'カレンダー',
  'camera': 'カメラ',
  'capacity': '容量',
  'car': '車',
  'caret-down': 'キャレット下へ',
  'caret-next': 'キャレット次へ',
  'caret-previous': 'キャレット前へ',
  'caret-up': 'キャレット上へ',
  'cart': 'カート',
  'catalog': 'カタログ',
  'chapter-add': 'チャプター追加',
  'chapter-next': 'チャプター次へ',
  'chapter-previous': 'チャプター前へ',
  'chat': 'チャット',
  'checkbox-selected': 'チェックボックスオン',
  'checkbox': 'チェックボックス',
  'checkmark': 'チェックマーク',
  'circle-information': '円情報',
  'circle-play': '円再生',
  'circle-question': '円質問',
  'clear-option': 'クリアオプション',
  'clear': 'クリア',
  'CLI': 'CLI',
  'clipboard': 'クリップボード',
  'clock': 'クロック',
  'clone': '複製',
  'close': '閉じる',
  'closed-caption': 'クローズドキャプション',
  'cloud-computer': 'クラウドコンピューター',
  'cloud-download': 'クラウドダウンロード',
  'cloud-software': 'クラウドソフトウェア',
  'cloud-upload': 'クラウドアップロード',
  'cloud': 'クラウド',
  'cluster': 'クラスター',
  'code': 'コード',
  'columns': 'カラム',
  'compare': '比較',
  'compass': 'コンパス',
  'compliance': 'コンプライアンス',
  'configure': '構成',
  'connect': '接続',
  'contact-info': '連絡先情報',
  'contact': '連絡先',
  'contract': '契約',
  'copy': 'コピー',
  'credit-card': 'クレジットカード',
  'cube': '立方体',
  'cubes': '立方体',
  'currency': '通貨',
  'cursor': 'カーソル',
  'cut': '切り取り',
  'cycle': 'サイクル',
  'dashboard': 'ダッシュボード',
  'database': 'データベース',
  'deliver': '提供',
  'deploy': 'デプロイ',
  'descend': '下降',
  'desktop': 'デスクトップ',
  'detach': 'デタッチ',
  'diamond': 'ダイヤモンド',
  'directions': '方向',
  'dislike': '賛同しない',
  'document-cloud': 'ドキュメントクラウド',
  'document-config': 'ドキュメント設定',
  'document-csv': 'ドキュメントCSV',
  'document-download': 'ドキュメントのダウンロード',
  'document-excel': 'ドキュメントExcel',
  'document-exe': 'ドキュメント実行',
  'document-image': 'ドキュメント画像',
  'document-locked': 'ドキュメントロック済み',
  'document-missing': 'ドキュメント欠落',
  'document-notes': 'ドキュメントメモ',
  'document-outlook': 'ドキュメントOutlook',
  'document-pdf': 'ドキュメントPDF',
  'document-performance': 'ドキュメントパフォーマンス',
  'document-ppt': 'ドキュメントPPT',
  'document-rtf': 'ドキュメントRTF',
  'document-sound': 'ドキュメントサウンド',
  'document-store': 'ドキュメント保存',
  'document-test': 'ドキュメントテスト',
  'document-threat': 'ドキュメント脅威',
  'document-time': 'ドキュメント時刻',
  'document-transfer': 'ドキュメント転送',
  'document-txt': 'ドキュメントtxt',
  'document-update': 'ドキュメント更新',
  'document-upload': 'ドキュメントアップロード',
  'document-user': 'ドキュメントユーザー',
  'document-verified': 'ドキュメント検証済み',
  'document-video': 'ドキュメントビデオ',
  'document-windows': 'ドキュメントWindows',
  'document-word': 'ドキュメントWord',
  'document-zip': 'ドキュメントZIP',
  'document': 'ドキュメント',
  'domain': 'ドメイン',
  'down': '下へ',
  'download': 'ダウンロード',
  'drag': 'ドラッグ',
  'drive-cage': 'ドライブケージ',
  'duplicate': '重複',
  'edit': '編集',
  'eject': '取り出し',
  'empty-circle': '空の円',
  'expand': '拡大',
  'fan': 'ファン',
  'fast-forward': '早送り',
  'favorite': 'お気に入り',
  'filter': 'フィルター',
  'finger-print': '指紋',
  'flag': 'フラグ',
  'folder-cycle': 'フォルダーサイクル',
  'folder-open': 'フォルダー開く',
  'folder': 'フォルダー',
  'forward-ten': '10進む',
  'gallery': 'ギャラリー',
  'gamepad': 'ゲームパッド',
  'gift': 'ギフト',
  'globe': '地球',
  'grid': 'グリッド',
  'group': 'グループ',
  'grow': '拡張',
  'halt': '停止',
  'help': 'ヘルプ',
  'history': '履歴',
  'home': 'ホーム',
  'host-maintenance': 'ホストメンテナンス',
  'host': 'ホスト',
  'image': 'イメージ',
  'impact': '影響',
  'in-progress': '進行中',
  'inbox': '受信トレイ',
  'indicator': 'インジケーター',
  'info': '情報',
  'inherit': '継承',
  'inspect': '検査',
  'install': 'インストール',
  'integration': '統合',
  'iteration': '反復',
  'java': 'Java',
  'language': '言語',
  'launch': '起動',
  'layer': 'レイヤー',
  'license': 'ライセンス',
  'like': '賛同する',
  'line-chart': '線グラフ',
  'link-bottom': 'リンク末尾',
  'link-down': 'リンク下へ',
  'link-next': 'リンク次へ',
  'link-previous': 'リンク前へ',
  'link-top': 'リンクトップへ',
  'link-up': 'リンク上へ',
  'link': 'リンク',
  'local': 'ローカル',
  'location-pin': '場所ピン',
  'location': '場所',
  'lock': 'ロック',
  'login': 'ログイン',
  'logout': 'ログアウト',
  'magic': '魔法',
  'mail-option': 'メールオプション',
  'mail': 'メール',
  'manual': 'マニュアル',
  'map-location': 'マップ位置',
  'map': 'マップ',
  'menu': 'メニュー',
  'microphone': 'マイクロフォン',
  'money': 'お金',
  'monitor': 'モニター',
  'more': 'その他',
  'multiple': '複数',
  'navigate': 'ナビゲート',
  'new-window': '新規ウィンドウ',
  'new': '新規',
  'next': '次へ',
  'nodes': 'ノード',
  'note': 'メモ',
  'notes': 'メモ',
  'notification': '通知',
  'object-group': 'オブジェクトグループ',
  'object-ungroup': 'オブジェクトグループ解除',
  'optimize': '最適化',
  'organization': '組織',
  'overview': '概要',
  'pan': 'パン',
  'pause-fill': '一時停止中塗り',
  'pause': '一時停止',
  'personal-computer': 'パーソナルコンピューター',
  'pie-chart': '円グラフ',
  'pin': 'ピン',
  'plan': '計画',
  'platform-amazon': 'プラットフォームAmazon',
  'platform-android': 'プラットフォームAndroid',
  'platform-apple': 'プラットフォームApple',
  'platform-archlinux': 'プラットフォームArch Linux',
  'platform-aruba': 'プラットフォームAruba',
  'platform-centos': 'プラットフォームCentOS',
  'platform-chrome': 'プラットフォームChrome',
  'platform-cloudlinux': 'プラットフォームCloudLinux',
  'platform-debian': 'プラットフォームDebian',
  'platform-docker': 'プラットフォームDocker',
  'platform-dos': 'プラットフォームDOS',
  'platform-dropbox': 'プラットフォームDropbox',
  'platform-edge': 'プラットフォームEdge',
  'platform-fedora': 'プラットフォームFedora',
  'platform-firefox': 'プラットフォームFirefox',
  'platform-freebsd': 'プラットフォームFreeBSD',
  'platform-google': 'プラットフォームGoogle',
  'platform-hadoop': 'プラットフォームHadoop',
  'platform-heroku': 'プラットフォームHeroku',
  'platform-horton': 'プラットフォームHorton',
  'platform-hp': 'プラットフォームHP',
  'platform-hpi': 'プラットフォームHPI',
  'platform-internet-explorer': 'プラットフォームInternet Explorer',
  'platform-java': 'プラットフォームJava',
  'platform-mandriva': 'プラットフォームMandriva',
  'platform-mysql': 'プラットフォームMySQL',
  'platform-norton': 'プラットフォームNorton',
  'platform-onedrive': 'プラットフォームOneDrive',
  'platform-opera': 'プラットフォームOpera',
  'platform-oracle': 'プラットフォームOracle',
  'platform-pied-piper': 'プラットフォームPied Piper',
  'platform-raspberry': 'プラットフォームRaspberry',
  'platform-reactjs': 'プラットフォームReact.js',
  'platform-redhat': 'プラットフォームRed Hat',
  'platform-safari-option': 'プラットフォームSafariオプション',
  'platform-safari': 'プラットフォームSafari',
  'platform-sco': 'プラットフォームSCO',
  'platform-solaris': 'プラットフォームSolaris',
  'platform-suse': 'プラットフォームSUSE',
  'platform-swift': 'プラットフォームSwift',
  'platform-turbolinux': 'プラットフォームTurbolinux',
  'platform-ubuntu': 'プラットフォームUbuntu',
  'platform-unixware': 'プラットフォームUnixWare',
  'platform-vmware': 'プラットフォームVMware',
  'platform-windows-legacy': 'プラットフォームWindowsレガシー',
  'platform-windows': 'プラットフォームWindows',
  'play-fill': '再生中塗り',
  'play': '再生',
  'power': '電源',
  'previous': '前へ',
  'print': '印刷',
  'radial-selected': 'ラジアル選択',
  'radial': 'ラジアル',
  'refresh': '更新',
  'resources': 'リソース',
  'resume': '再開',
  'revert': '戻す',
  'rewind': '巻き戻し',
  'risk': 'リスク',
  'robot': 'ロボット',
  'rss': 'RSS',
  'run': '走る',
  'satellite': '衛星',
  'save': '保存',
  'scan': 'スキャン',
  'schedule-new': 'スケジュール新規',
  'schedule-play': 'スケジュール再生',
  'schedule': 'スケジュール',
  'schedules': 'スケジュール',
  'scorecard': 'スコアカード',
  'search-advanced': '詳細検索',
  'search': '検索',
  'secure': 'セキュア',
  'select': '選択',
  'selection': '選択',
  'send': '送信',
  'server-cluster': 'サーバークラスター',
  'server': 'サーバー',
  'servers': 'サーバー',
  'service-play': 'サービス再生',
  'services': 'サービス',
  'settings-option': '設定オプション',
  'share': '共有',
  'shield-security': 'シールドセキュリティ',
  'shield': 'シールド',
  'shift': 'シフト',
  'sidebar': 'サイドバー',
  'social-amazon': 'ソーシャルAmazon',
  'social-amex': 'ソーシャルAMEX',
  'social-bitcoin': 'ソーシャルBitcoin',
  'social-codepen': 'ソーシャルCodepen',
  'social-creative-commons': 'ソーシャルCreative Commons',
  'social-dropbox': 'ソーシャルDropbox',
  'social-facebook-option': 'ソーシャルFacebookオプション',
  'social-facebook': 'ソーシャルFacebook',
  'social-github': 'ソーシャルGithub',
  'social-google-plus': 'ソーシャルGoogle+',
  'social-google-wallet': 'ソーシャルGoogle Wallet',
  'social-instagram': 'ソーシャルInstagram',
  'social-linkedin-option': 'ソーシャルLinkedInオプション',
  'social-linkedin': 'ソーシャルLinkedIn',
  'social-mail': 'ソーシャルメール',
  'social-mastercard': 'ソーシャルMastercard',
  'social-medium': 'ソーシャルMedium',
  'social-paypal': 'ソーシャルPayPal',
  'social-pinterest': 'ソーシャルPinterest',
  'social-product-hunt': 'ソーシャルProduct Hunt',
  'social-reddit': 'ソーシャルReddit',
  'social-skype': 'ソーシャルSkype',
  'social-slack': 'ソーシャルSlack',
  'social-snapchat': 'ソーシャルSnapchat',
  'social-square': 'ソーシャルSquare',
  'social-stack-overflow': 'ソーシャルStack Overflow',
  'social-stripe': 'ソーシャルStripe',
  'social-tumblr': 'ソーシャルTumblr',
  'social-twitter': 'ソーシャルTwitter',
  'social-vimeo': 'ソーシャルVimeo',
  'social-vine': 'ソーシャルVine',
  'social-visa': 'ソーシャルVisa',
  'social-wordpress': 'ソーシャルWordPress',
  'social-youtube': 'ソーシャルYouTube',
  'sort': 'ソート',
  'split': '分割',
  'splits': '複数分割',
  'stakeholder': '関係者',
  'standards-3d-effects': '標準3Dエフェクト',
  'standards-connectivity': '標準コネクティビティ',
  'standards-css3': '標準CSS3',
  'standards-device': '標準デバイス',
  'standards-fireball': '標準ファイアボール',
  'standards-html5': '標準HTML5',
  'standards-multimedia': '標準マルチメディア',
  'standards-offline-storage': '標準オフラインストレージ',
  'standards-performance': '標準パフォーマンス',
  'standards-sematics': '標準セマンティクス',
  'star-half': '星半分',
  'star': '星',
  'steps': 'ステップ',
  'stop-fill': '停止中塗り',
  'stop': '停止',
  'storage': 'ストレージ',
  'street-view': 'ストリートビュー',
  'subtract-circle': '減算円',
  'subtract': '減算',
  'support': 'サポート',
  'sync': '同期',
  'system': 'システム',
  'table-add': 'テーブル追加',
  'table': 'テーブル',
  'tag': 'タグ',
  'target': 'ターゲット',
  'task': 'タスク',
  'tasks': 'タスク',
  'technology': 'テクノロジー',
  'template': 'テンプレート',
  'terminal': 'ターミナル',
  'test-desktop': 'テストデスクトップ',
  'test': 'テスト',
  'text-wrap': 'テキスト折り返し',
  'threats': '脅威',
  'ticket': 'チケット',
  'tools': 'ツール',
  'tooltip': 'ツールヒント',
  'top-corner': '上部コーナー',
  'transaction': 'トランザクション',
  'trash': 'ゴミ',
  'tree': '木',
  'trigger': 'トリガー',
  'trophy': 'トロフィー',
  'troubleshoot': 'トラブルシューティング',
  'unlink': 'リンク解除',
  'unlock': 'ロック解除',
  'up': '上へ',
  'update': '更新',
  'upgrade': 'アップグレード',
  'upload': 'アップロード',
  'user-add': 'ユーザー追加',
  'user-admin': 'ユーザー管理者',
  'user-expert': 'ユーザー専門家',
  'user-female': 'ユーザー女性',
  'user-manager': 'ユーザーマネージャー',
  'user-new': 'ユーザー新規',
  'user-police': 'ユーザー警察',
  'user-settings': 'ユーザー設定',
  'user-worker': 'ユーザー作業者',
  'user': 'ユーザー',
  'validate': '検証',
  'video': 'ビデオ',
  'view': '表示',
  'virtual-machine': '仮想マシン',
  'vm-maintenance': 'VMメンテナンス',
  'volume-low': 'ボリューム小',
  'volume-mute': 'ボリュームミュート',
  'volume': 'ボリューム',
  'vulnerability': '脆弱性',
  'waypoint': 'ウェイポイント',
  'workshop': 'ワークショップ',
  'zoom-in': 'ズームイン',
  'zoom-out': 'ズームアウト'
};
module.exports = exports['default'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': 'toegang voor beperkten',
  'access-ad': 'toegang tot AD',
  'access-assist-listening': 'toegang tot begeleid luisteren',
  'access-braille': 'toegang tot braille',
  'access-sign': 'toegang tot gebarentaal',
  'access-tty': 'toegang tot terminal',
  'access-volume-control': 'toegang tot volumecontrole',
  'access-wheelchair-active': 'toegang voor rolstoel is actief',
  'access-wheelchair': 'toegang voor rolstoel',
  'achievement': 'prestatie',
  'action': 'actiie',
  'actions': 'actiies',
  'add-circle': 'voeg toe',
  'add': 'voeg toe',
  'aggregate': 'aggregaat',
  'aid': 'hulp',
  'alarm': 'alarm',
  'alert': 'waarschuwing',
  'analytics': 'analyze',
  'announce': 'aankondiging',
  'apps': 'toepassingen',
  'archive': 'archief',
  'article': 'artikel',
  'ascend': 'stijging',
  'attachment': 'bijlage',
  'back-ten': 'tien terug',
  'bar-chart': 'balkdiagram',
  'basket': 'korf',
  'blog': 'blog',
  'book': 'boek',
  'bookmark': 'bladwijzer',
  'bottom-corner': 'hoek beneden',
  'brand-apple-app-store': 'Apple AppStore',
  'brand-codepen-edit': 'Editeer op CodePen',
  'brand-codepen-try': 'Probeer CodePen',
  'brand-google-play': 'Google Play',
  'brand-grommet-outline': 'Grommet omtrek',
  'brand-grommet-path': 'Grommet pad',
  'brand-hpe-element-outline': 'HPE omtrek',
  'brand-hpe-element-path': 'HPE pad',
  'brand-hpe-labs-insignia-outline': 'HPE Labs Insignia omtrek',
  'brand-hpe-labs-insignia': 'HPE Labs Insignia',
  'brand-hpe-stack-centered': 'HPE stack gecentreerd',
  'brand-hpe-stack': 'HPE stack',
  'briefcase': 'boekentas',
  'brush': 'borstel',
  'bug': 'defect',
  'bundle': 'bundel',
  'business-service': 'zakelijke dienst',
  'calculator': 'rekenmachine',
  'calendar': 'kalender',
  'camera': 'camera',
  'capacity': 'capaciteit',
  'car': 'wagen',
  'caret-down': 'cursor naar beneden',
  'caret-next': 'cursor volgende',
  'caret-previous': 'cursor vorige',
  'caret-up': 'cursor naar boven',
  'cart': 'winkelkar',
  'catalog': 'cataloog',
  'chapter-add': 'nieuw hoofdstuk',
  'chapter-next': 'volgend hoofdstuk',
  'chapter-previous': 'vorig hoofdstuk',
  'chat': 'chat',
  'checkbox-selected': 'geselecteerde checkbox',
  'checkbox': 'checkbox',
  'checkmark': 'vinkje',
  'circle-information': 'informatie in cirkel',
  'circle-play': 'speel af in cirkel',
  'circle-question': 'vraagteken in cirkel',
  'clear-option': 'optie leeg maken',
  'clear': 'leeg maken',
  'cli': 'cli',
  'clipboard': 'plakbord',
  'clock': 'klok',
  'clone': 'kloon',
  'close': 'sluit',
  'closed-caption': 'closed caption',
  'cloud-computer': 'cloud computer',
  'cloud-download': 'cloud download',
  'cloud-software': 'cloud software',
  'cloud-upload': 'cloud upload',
  'cloud': 'cloud',
  'cluster': 'cluster',
  'code': 'code',
  'columns': 'kolommen',
  'compare': 'vergelijk',
  'compass': 'kompas',
  'compliance': 'naleving',
  'configure': 'configureer',
  'connect': 'verbind',
  'contact-info': 'contact info',
  'contact': 'contact',
  'contract': 'contract',
  'copy': 'kopieer',
  'credit-card': 'credit card',
  'cube': 'kubus',
  'cubes': 'kubussen',
  'currency': 'munteenheid',
  'cursor': 'cursor',
  'cut': 'knip',
  'cycle': 'cyclus',
  'dashboard': 'dashboard',
  'database': 'database',
  'deliver': 'leveren',
  'deploy': 'ontplooien',
  'descend': 'daling',
  'desktop': 'desktop',
  'detach': 'verbinding verbreken',
  'diamond': 'diamand',
  'directions': 'richtingen',
  'dislike': 'niet leuk',
  'document-cloud': 'document in de cloud',
  'document-config': 'configuratie-document',
  'document-csv': 'CSV document',
  'document-download': 'download document',
  'document-excel': 'Excel document',
  'document-exe': 'uitvoerbaar bestand',
  'document-image': 'document met afbeelding',
  'document-locked': 'gereserveerd document',
  'document-missing': 'ontbrekend document',
  'document-notes': 'nota\'s',
  'document-outlook': 'Outlook document',
  'document-pdf': 'PDF document',
  'document-performance': 'performantie document',
  'document-ppt': 'Powerpoint document',
  'document-rtf': 'RTF document',
  'document-sound': 'document met geluid',
  'document-store': 'opslagplaats documenten',
  'document-test': 'test-document',
  'document-threat': 'document bedreiging',
  'document-time': 'document tijd',
  'document-transfer': 'transfer-document',
  'document-txt': 'tekst-document',
  'document-update': 'document aanpassen',
  'document-upload': 'document uploaden',
  'document-user': 'document gebruiker',
  'document-verified': 'geverifieerd document',
  'document-video': 'video',
  'document-windows': 'Windows document',
  'document-word': 'Word document',
  'document-zip': 'ZIP document',
  'document': 'document',
  'domain': 'domein',
  'down': 'naar beneden',
  'download': 'downloaden',
  'drag': 'slepen',
  'drive-cage': 'diskdrive-cabinet',
  'duplicate': 'dupliceren',
  'edit': 'editeren',
  'eject': 'uitwerpen',
  'empty-circle': 'lege cirkel',
  'expand': 'expanderen',
  'fan': 'ventilatie',
  'fast-forward': 'snel vooruit',
  'favorite': 'favoriet',
  'filter': 'filter',
  'finger-print': 'vingerafdruk',
  'flag': 'vlag',
  'folder-cycle': 'map met cyclus',
  'folder-open': 'open map',
  'folder': 'map',
  'forward-ten': 'tien vooruit',
  'gallery': 'galerij',
  'gamepad': 'spelcontroller',
  'gift': 'gift',
  'globe': 'wereldbol',
  'grid': 'raster',
  'group': 'groep',
  'grow': 'groei',
  'halt': 'halt',
  'help': 'help',
  'history': 'geschiedenis',
  'home': 'thuis',
  'host-maintenance': 'onderhoud computer',
  'host': 'computer',
  'image': 'afbeelding',
  'impact': 'impact',
  'in-progress': 'bezig',
  'inbox': 'inbox',
  'indicator': 'indicator',
  'info': 'info',
  'inherit': 'erven',
  'inspect': 'inspecteren',
  'install': 'installeren',
  'integration': 'integratie',
  'iteration': 'iteratie',
  'java': 'java',
  'language': 'taal',
  'launch': 'lancering',
  'layer': 'laag',
  'license': 'licentie',
  'like': 'leuk',
  'line-chart': 'lijndiagram',
  'link-bottom': 'link bodem',
  'link-down': 'link naar beneden',
  'link-next': 'link volgende',
  'link-previous': 'link vorige',
  'link-top': 'link top',
  'link-up': 'link naar boven',
  'link': 'link',
  'local': 'lokaal',
  'location-pin': 'locatiepin',
  'location': 'locatie',
  'lock': 'slot',
  'login': 'aanmelden',
  'logout': 'afmelden',
  'magic': 'magie',
  'mail-option': 'optie mail',
  'mail': 'mail',
  'manual': 'manueel',
  'map-location': 'positie op kaart',
  'map': 'kaart',
  'menu': 'menu',
  'microphone': 'microfoon',
  'money': 'geld',
  'monitor': 'monitor',
  'more': 'meer',
  'multiple': 'meerdere',
  'navigate': 'navigeren',
  'new-window': 'nieuw venster',
  'new': 'nieuw',
  'next': 'volgende',
  'nodes': 'nodes',
  'note': 'nota',
  'notes': 'nota\'s',
  'notification': 'notificatie',
  'object-group': 'groepeer objecten',
  'object-ungroup': 'maak object-groepering ongedaan',
  'optimize': 'optimaliseren',
  'organization': 'organisatie',
  'overview': 'overzicht',
  'pan': 'verschuiven',
  'pause-fill': 'pause vol',
  'pause': 'pause',
  'personal-computer': 'personal computer',
  'pie-chart': 'taartdiagram',
  'pin': 'pin',
  'plan': 'plan',
  'platform-amazon': 'Amazon',
  'platform-android': 'Android',
  'platform-apple': 'Apple',
  'platform-archlinux': 'Archlinux',
  'platform-aruba': 'Aruba',
  'platform-centos': 'CentOS',
  'platform-chrome': 'Chrome',
  'platform-cloudlinux': 'CloudLinux',
  'platform-debian': 'Debian',
  'platform-docker': 'Docker',
  'platform-dos': 'DOS',
  'platform-dropbox': 'Dropbox',
  'platform-edge': 'Edge',
  'platform-fedora': 'Fedora',
  'platform-firefox': 'Firefox',
  'platform-freebsd': 'FreeBSD',
  'platform-google': 'Google',
  'platform-hadoop': 'Hadoop',
  'platform-heroku': 'Heroku',
  'platform-horton': 'Horton',
  'platform-hp': 'HP',
  'platform-hpi': 'HPI',
  'platform-internet-explorer': 'Internet Explorer',
  'platform-java': 'Java',
  'platform-mandriva': 'Mandriva',
  'platform-mysql': 'MySQL',
  'platform-norton': 'Norton',
  'platform-onedrive': 'OneDrive',
  'platform-opera': 'Opera',
  'platform-oracle': 'Oracle',
  'platform-pied-piper': 'Pied Piper',
  'platform-raspberry': 'Raspberry',
  'platform-reactjs': 'ReactJS',
  'platform-redhat': 'RedHat',
  'platform-safari-option': 'Safari optie',
  'platform-safari': 'Safari',
  'platform-sco': 'SCO',
  'platform-solaris': 'Solaris',
  'platform-suse': 'SUSE',
  'platform-swift': 'Swift',
  'platform-turbolinux': 'TurboLinux',
  'platform-ubuntu': 'Ubuntu',
  'platform-unixware': 'Unixware',
  'platform-vmware': 'VMware',
  'platform-windows-legacy': 'Windows legacy',
  'platform-windows': 'Windows',
  'play-fill': 'afspelen vol',
  'play': 'afspelen',
  'power': 'aanzetten',
  'previous': 'vorige',
  'print': 'afdrukken',
  'radial-selected': 'geselecteerde radiaal',
  'radial': 'radiaal',
  'refresh': 'verversen',
  'resources': 'middelen',
  'resume': 'verder gaan',
  'revert': 'ongedaan maken',
  'rewind': 'terugspoelen',
  'risk': 'risico',
  'robot': 'robot',
  'rss': 'RSS',
  'run': 'lopen',
  'satellite': 'satelliet',
  'save': 'bewaren',
  'scan': 'scannen',
  'schedule-new': 'nieuw rooster',
  'schedule-play': 'speel rooster af',
  'schedule': 'rooster',
  'schedules': 'roosters',
  'scorecard': 'score kaart',
  'search-advanced': 'geavanceerd zoeken',
  'search': 'zoeken',
  'secure': 'beveiligd',
  'select': 'selecteren',
  'selection': 'selectie',
  'send': 'verzenden',
  'server-cluster': 'server cluster',
  'server': 'server',
  'servers': 'servers',
  'service-play': 'dienst afspelen',
  'services': 'diensten',
  'settings-option': 'instellingen optie',
  'share': 'delen',
  'shield-security': 'veiligheidsschild',
  'shield': 'schild',
  'shift': 'schuif',
  'sidebar': 'zijbalk',
  'social-amazon': 'Amazon sociaal',
  'social-amex': 'Amex sociaal',
  'social-bitcoin': 'Bitcoin sociaal',
  'social-codepen': 'CodePen sociaal',
  'social-creative-commons': 'Creative Commons sociaal',
  'social-dropbox': 'Dropbox sociaal',
  'social-facebook-option': 'Facebook optie sociaal',
  'social-facebook': 'Facebook sociaal',
  'social-github': 'Githu sociaal',
  'social-google-plus': 'Google Plus sociaal',
  'social-google-wallet': 'Google Wallet sociaal',
  'social-instagram': 'Instagram sociaal',
  'social-linkedin-option': 'LinkedIN optie',
  'social-linkedin': 'LinkedIN sociaal',
  'social-mail': 'mail sociaal',
  'social-mastercard': 'Mastercard sociaal',
  'social-medium': 'medium sociaal',
  'social-paypal': 'PayPal sociaal',
  'social-pinterest': 'Pinterest sociaal',
  'social-product-hunt': 'product Hunt sociaal',
  'social-reddit': 'Reddit sociaal',
  'social-skype': 'Skype sociaal',
  'social-slack': 'Slack sociaal',
  'social-snapchat': 'Snapchat sociaal',
  'social-square': 'Square sociaal',
  'social-stack-overflow': 'Stack Overflow sociaal',
  'social-stripe': 'Stripe sociaal',
  'social-tumblr': 'TumblR sociaal',
  'social-twitter': 'Twitter sociaal',
  'social-vimeo': 'Vimeo sociaal',
  'social-vine': 'Vine sociaal',
  'social-visa': 'Visa sociaal',
  'social-wordpress': 'Wordpress sociaal',
  'social-youtube': 'Youtube sociaal',
  'sort': 'sorteren',
  'split': 'splitsen',
  'splits': 'splitsingen',
  'stakeholder': 'belanghebbende',
  'standards-3d-effects': 'standaarden 3d effecten',
  'standards-connectivity': 'standaarden connectiviteit',
  'standards-css3': 'standaarden CSS3',
  'standards-device': 'standaarden toestel',
  'standards-fireball': 'standaarden fireball',
  'standards-html5': 'standaarden HTML5',
  'standards-multimedia': 'standaarden multimedia',
  'standards-offline-storage': 'standaarden offline opslag',
  'standards-performance': 'standaarden performantie',
  'standards-sematics': 'standaarden sematiek',
  'star-half': 'halve ster',
  'star': 'ster',
  'steps': 'stappen',
  'stop-fill': 'stoppen vol',
  'stop': 'stoppen',
  'storage': 'opslag',
  'street-view': 'street view',
  'subtract-circle': 'aftrekken met cirkel',
  'subtract': 'aftrekken',
  'support': 'ondersteuning',
  'sync': 'synchroniseren',
  'system': 'systeem',
  'table-add': 'voeg toe in tabel',
  'table': 'tabel',
  'tag': 'label',
  'target': 'doel',
  'task': 'taak',
  'tasks': 'taken',
  'technology': 'technologie',
  'template': 'sjabloon',
  'terminal': 'terminal',
  'test-desktop': 'test-desktop',
  'test': 'test',
  'text-wrap': 'tekst rondgewikkeld',
  'threats': 'bedreigingen',
  'ticket': 'ticket',
  'tools': 'gereedschap',
  'tooltip': 'tooltip',
  'top-corner': 'hoek boven',
  'transaction': 'transactie',
  'trash': 'vuilbak',
  'tree': 'boom',
  'trigger': 'in gang zetten',
  'trophy': 'trofee',
  'troubleshoot': 'oplossen',
  'unlink': 'verbinding verbreken',
  'unlock': 'ontsluiten',
  'up': 'naar boven',
  'update': 'aanpassen',
  'upgrade': 'upgraden',
  'upload': 'uploaden',
  'user-add': 'gebruiker toevoegen',
  'user-admin': 'administrator',
  'user-expert': 'expert',
  'user-female': 'dame',
  'user-manager': 'manager',
  'user-new': 'nieuwe gebuiker',
  'user-police': 'politieagent',
  'user-settings': 'gebruikersinstellingen',
  'user-worker': 'arbeider',
  'user': 'gebruiker',
  'validate': 'valideren',
  'video': 'video',
  'view': 'bekijken',
  'virtual-machine': 'virtuele machine',
  'vm-maintenance': 'onderhoud VM',
  'volume-low': 'laag volume',
  'volume-mute': 'volume uit',
  'volume': 'volume',
  'vulnerability': 'kwestbaarheid',
  'waypoint': 'richtingsaanduiding',
  'workshop': 'workshop',
  'zoom-in': 'inzoomen',
  'zoom-out': 'uitzoomen'
};
module.exports = exports['default'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': '访问辅助功能',
  'access-ad': '访问 ad',
  'access-assist-listening': '访问辅助听力',
  'access-braille': '访问盲文',
  'access-sign': '访问标志',
  'access-tty': '访问 tty',
  'access-volume-control': '访问音量控制',
  'access-wheelchair-active': '访问轮椅活动',
  'access-wheelchair': '访问轮椅',
  'achievement': '成果',
  'action': '操作',
  'actions': '操作',
  'add-circle': '添加循环',
  'add': '添加',
  'aggregate': '聚合',
  'aid': '辅助',
  'alarm': '警报',
  'alert': '警报',
  'analytics': '分析',
  'announce': '通告',
  'apps': '应用程序',
  'archive': '存档',
  'article': '文章',
  'ascend': '升序',
  'attachment': '附件',
  'back-ten': '后退十步',
  'bar-chart': '条形图',
  'basket': '购物篮',
  'blog': '博客',
  'book': '书',
  'bookmark': '书签',
  'bottom-corner': '底角',
  'brand-apple-app-store': 'apple 品牌应用商店',
  'brand-codepen-edit': 'codepen 品牌编辑',
  'brand-codepen-try': 'codepen 品牌尝试',
  'brand-google-play': 'google play 品牌',
  'brand-grommet-outline': 'grommet 品牌轮廓',
  'brand-grommet-path': 'grommet 品牌路径',
  'brand-hpe-element-outline': 'hpe 品牌元素轮廓',
  'brand-hpe-element-path': 'hpe 品牌元素路径',
  'brand-hpe-labs-insignia-outline': 'hpe 品牌实验室徽章轮廓',
  'brand-hpe-labs-insignia': 'hpe 品牌实验室徽章',
  'brand-hpe-stack-centered': 'hpe 品牌堆栈居中',
  'brand-hpe-stack': 'hpe 品牌堆栈',
  'briefcase': '公文包',
  'brush': '刷子',
  'bug': '缺陷',
  'bundle': '包',
  'business-service': '业务服务',
  'calculator': '计算器',
  'calendar': '日历',
  'camera': '相机',
  'capacity': '容量',
  'car': 'car',
  'caret-down': '脱字号下',
  'caret-next': '脱字号后',
  'caret-previous': '脱字号前',
  'caret-up': '脱字号上',
  'cart': '购物车',
  'catalog': '目录',
  'chapter-add': '添加章',
  'chapter-next': '下一章',
  'chapter-previous': '上一章',
  'chat': '聊天',
  'checkbox-selected': '复选框选中',
  'checkbox': '复选框',
  'checkmark': '复选标记',
  'circle-information': '循环信息',
  'circle-play': '循环播放',
  'circle-question': '循环问题',
  'clear-option': '清除选项',
  'clear': '清除',
  'cli': 'cli',
  'clipboard': '剪贴板',
  'clock': '时钟',
  'clone': '克隆',
  'close': '关闭',
  'closed-caption': '隐藏字幕',
  'cloud-computer': '云计算机',
  'cloud-download': '云下载',
  'cloud-software': '云软件',
  'cloud-upload': '云上载',
  'cloud': '云',
  'cluster': '群集',
  'code': '代码',
  'columns': '列',
  'compare': '比较',
  'compass': '指南针',
  'compliance': '合规性',
  'configure': '配置',
  'connect': '连接',
  'contact-info': '联系人信息',
  'contact': '联系人',
  'contract': '合同',
  'copy': '复制',
  'credit-card': '信用卡',
  'cube': '立方形',
  'cubes': '立方形',
  'currency': '货币',
  'cursor': '光标',
  'cut': '剪切',
  'cycle': '周期',
  'dashboard': '控制面板',
  'database': '数据库',
  'deliver': '提供',
  'deploy': '部署',
  'descend': '降序',
  'desktop': '桌面',
  'detach': '分离',
  'diamond': '钻石',
  'directions': '方向',
  'dislike': '踩',
  'document-cloud': '文档云',
  'document-config': '文档配置',
  'document-csv': 'csv 文档',
  'document-download': '文档下载',
  'document-excel': 'excel 文档',
  'document-exe': 'exe 文档',
  'document-image': '图像文档',
  'document-locked': '文档被锁定',
  'document-missing': '文档丢失',
  'document-notes': '文档注释',
  'document-outlook': 'outlook 文档',
  'document-pdf': 'pdf 文档',
  'document-performance': '文档性能',
  'document-ppt': 'ppt 文档',
  'document-rtf': 'rtf 文档',
  'document-sound': '声音文档',
  'document-store': '文档存储',
  'document-test': '文档测试',
  'document-threat': '文档威胁',
  'document-time': '文档时间',
  'document-transfer': '文档传输',
  'document-txt': 'txt 文档',
  'document-update': '文档更新',
  'document-upload': '文档上载',
  'document-user': '文档用户',
  'document-verified': '已验证文档',
  'document-video': '视频文档',
  'document-windows': 'Windows 文档',
  'document-word': 'word 文档',
  'document-zip': 'zip 文档',
  'document': '文档',
  'domain': '域',
  'down': '下',
  'download': '下载',
  'drag': '拖动',
  'drive-cage': '驱动器固定架',
  'duplicate': '重复',
  'edit': '编辑',
  'eject': '弹出',
  'empty-circle': '空循环',
  'expand': '展开',
  'fan': '风扇',
  'fast-forward': '快进',
  'favorite': '收藏',
  'filter': '筛选',
  'finger-print': '指纹',
  'flag': '标志',
  'folder-cycle': '文件夹刷新',
  'folder-open': '文件夹已打开',
  'folder': '文件夹',
  'forward-ten': '前进十步',
  'gallery': '画廊',
  'gamepad': '游戏板',
  'gift': '礼物',
  'globe': '全球',
  'grid': '网格',
  'group': '组',
  'grow': '增长',
  'halt': '停止',
  'help': '帮助',
  'history': '历史记录',
  'home': '主页',
  'host-maintenance': '主机维护',
  'host': '主机',
  'image': '映像',
  'impact': '影响',
  'in-progress': '正在进行',
  'inbox': '收件箱',
  'indicator': '指标',
  'info': '信息',
  'inherit': '继承',
  'inspect': '检查',
  'install': '安装',
  'integration': '集成',
  'iteration': '迭代',
  'java': 'java',
  'language': '语言',
  'launch': '启动',
  'layer': '层',
  'license': '许可',
  'like': '赞',
  'line-chart': '折线图',
  'link-bottom': '链接底部',
  'link-down': '链接中断',
  'link-next': '下一个链接',
  'link-previous': '上一个链接',
  'link-top': '链接顶部',
  'link-up': '链接连通',
  'link': '链接',
  'local': '本地',
  'location-pin': '定位销',
  'location': '位置',
  'lock': '锁',
  'login': '登录',
  'logout': '注销',
  'magic': '魔力',
  'mail-option': '邮件选项',
  'mail': '邮件',
  'manual': '手动',
  'map-location': '地图位置',
  'map': '地图',
  'menu': '菜单',
  'microphone': '麦克风',
  'money': '资金',
  'monitor': '监控',
  'more': '更多',
  'multiple': '多个',
  'navigate': '导航',
  'new-window': '新窗口',
  'new': '新',
  'next': '下一页',
  'nodes': '节点',
  'note': '注释',
  'notes': '备注',
  'notification': '通知',
  'object-group': '对象分组',
  'object-ungroup': '取消组合对象',
  'optimize': '优化',
  'organization': '组织',
  'overview': '概述',
  'pan': '平移',
  'pause-fill': '暂停填充',
  'pause': '暂停',
  'personal-computer': '个人计算机',
  'pie-chart': '饼图',
  'pin': '大头针',
  'plan': '计划',
  'platform-amazon': 'amazon 平台',
  'platform-android': 'android 平台',
  'platform-apple': 'apple 平台',
  'platform-archlinux': 'archlinux 平台',
  'platform-aruba': 'aruba 平台',
  'platform-centos': 'centos 平台',
  'platform-chrome': 'chrome 平台',
  'platform-cloudlinux': 'cloudlinux 平台',
  'platform-debian': 'debian 平台',
  'platform-docker': 'docker 平台',
  'platform-dos': 'dos 平台',
  'platform-dropbox': 'dropbox 平台',
  'platform-edge': 'edge 平台',
  'platform-fedora': 'fedora 平台',
  'platform-firefox': 'firefox 平台',
  'platform-freebsd': 'freebsd 平台',
  'platform-google': 'google 平台',
  'platform-hadoop': 'hadoop 平台',
  'platform-heroku': 'heroku 平台',
  'platform-horton': 'horton 平台',
  'platform-hp': 'hp 平台',
  'platform-hpi': 'hpi 平台',
  'platform-internet-explorer': 'internet explorer 平台',
  'platform-java': 'java 平台',
  'platform-mandriva': 'mandriva 平台',
  'platform-mysql': 'mysql 平台',
  'platform-norton': 'norton 平台',
  'platform-onedrive': 'onedrive 平台',
  'platform-opera': 'opera 平台',
  'platform-oracle': 'oracle 平台',
  'platform-pied-piper': 'pied piper 平台',
  'platform-raspberry': 'raspberry 平台',
  'platform-reactjs': 'reactjs 平台',
  'platform-redhat': 'redhat 平台',
  'platform-safari-option': 'safari 平台选项',
  'platform-safari': 'safari 平台',
  'platform-sco': 'sco 平台',
  'platform-solaris': 'solaris 平台',
  'platform-suse': 'suse 平台',
  'platform-swift': 'swift 平台',
  'platform-turbolinux': 'turbolinux 平台',
  'platform-ubuntu': 'ubuntu 平台',
  'platform-unixware': 'unixware 平台',
  'platform-vmware': 'vmware 平台',
  'platform-windows-legacy': 'windows 旧版平台',
  'platform-windows': 'windows 平台',
  'play-fill': '播放填充',
  'play': '播放',
  'power': '电源',
  'previous': '上一页',
  'print': '打印',
  'radial-selected': '径向选择',
  'radial': '径向',
  'refresh': '刷新',
  'resources': '资源',
  'resume': '继续',
  'revert': '恢复',
  'rewind': '倒带',
  'risk': '风险',
  'robot': '机器人',
  'rss': 'rss',
  'run': '运行',
  'satellite': '卫星',
  'save': '保存',
  'scan': '扫描',
  'schedule-new': '新建计划',
  'schedule-play': '播放计划',
  'schedule': '计划',
  'schedules': '计划',
  'scorecard': '记分卡',
  'search-advanced': '高级搜索',
  'search': '搜索',
  'secure': '安全',
  'select': '选择',
  'selection': '选择',
  'send': '发送',
  'server-cluster': '服务器群集',
  'server': '服务器',
  'servers': '服务器',
  'service-play': '播放服务',
  'services': '服务',
  'settings-option': '设置选项',
  'share': '共享',
  'shield-security': '安全防护',
  'shield': '防护',
  'shift': '转变',
  'sidebar': '侧栏',
  'social-amazon': 'amazon 社交',
  'social-amex': 'amex 社交',
  'social-bitcoin': 'bitcoin 社交',
  'social-codepen': 'codepen 社交',
  'social-creative-commons': 'creative commons 社交',
  'social-dropbox': 'dropbox 社交',
  'social-facebook-option': 'facebook option 社交',
  'social-facebook': 'facebook 社交',
  'social-github': 'github 社交',
  'social-google-plus': 'google plus 社交',
  'social-google-wallet': 'google wallet 社交',
  'social-instagram': 'instagram 社交',
  'social-linkedin-option': 'linkedin option 社交',
  'social-linkedin': 'linkedin 社交',
  'social-mail': 'mail 社交',
  'social-mastercard': 'mastercard 社交',
  'social-medium': 'medium 社交',
  'social-paypal': 'paypal 社交',
  'social-pinterest': 'pinterest 社交',
  'social-product-hunt': 'product hunt 社交',
  'social-reddit': 'reddit 社交',
  'social-skype': 'skype 社交',
  'social-slack': 'slack 社交',
  'social-snapchat': 'snapchat 社交',
  'social-square': 'square 社交',
  'social-stack-overflow': 'stack overflow 社交',
  'social-stripe': 'stripe 社交',
  'social-tumblr': 'tumblr 社交',
  'social-twitter': 'twitter 社交',
  'social-vimeo': 'vimeo 社交',
  'social-vine': 'vine 社交',
  'social-visa': 'visa 社交',
  'social-wordpress': 'wordpress 社交',
  'social-youtube': 'youtube 社交',
  'sort': '排序',
  'split': '拆分',
  'splits': '拆分',
  'stakeholder': '利益相关者',
  'standards-3d-effects': '3d 效果标准',
  'standards-connectivity': '连接标准',
  'standards-css3': 'css3 标准',
  'standards-device': '设备标准',
  'standards-fireball': 'fireball 标准',
  'standards-html5': 'html5 标准',
  'standards-multimedia': '多媒体标准',
  'standards-offline-storage': '脱机存储标准',
  'standards-performance': '性能标准',
  'standards-sematics': '语义标准',
  'star-half': '半星',
  'star': '星级',
  'steps': '步骤',
  'stop-fill': '停止填充',
  'stop': '停止',
  'storage': '存储',
  'street-view': '街景',
  'subtract-circle': '减去循环',
  'subtract': '减去',
  'support': '支持',
  'sync': '同步',
  'system': '系统',
  'table-add': '添加表',
  'table': '表',
  'tag': '标记',
  'target': '目标',
  'task': '任务',
  'tasks': '任务',
  'technology': '技术',
  'template': '模板',
  'terminal': '终端',
  'test-desktop': '测试桌面',
  'test': '测试',
  'text-wrap': '文字环绕',
  'threats': '威胁',
  'ticket': '记录单',
  'tools': '工具',
  'tooltip': '工具提示',
  'top-corner': '顶角',
  'transaction': '交易',
  'trash': '垃圾',
  'tree': '树',
  'trigger': '触发',
  'trophy': '奖品',
  'troubleshoot': '疑难解答',
  'unlink': '取消链接',
  'unlock': '解锁',
  'up': '上',
  'update': '更新',
  'upgrade': '升级',
  'upload': '上载',
  'user-add': '添加用户',
  'user-admin': '管理员用户',
  'user-expert': '专家用户',
  'user-female': '女性用户',
  'user-manager': '用户管理器',
  'user-new': '新用户',
  'user-police': '警察用户',
  'user-settings': '用户设置',
  'user-worker': '工人用户',
  'user': '用户',
  'validate': '验证',
  'video': '视频',
  'view': '查看',
  'virtual-machine': '虚拟机',
  'vm-maintenance': '虚拟机维护',
  'volume-low': '音量低',
  'volume-mute': '静音',
  'volume': '音量',
  'vulnerability': '漏洞',
  'waypoint': '路径点',
  'workshop': '工作室',
  'zoom-in': '放大',
  'zoom-out': '缩小'
};
module.exports = exports['default'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = __webpack_require__(58);

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {フィルター}\n  =1 {1つのフィルター}\n  ' + 'other {#個のフィルター}\n}'
  }
}, _enUS2.default, {
  Active: 'アクティブ',
  Activate: 'アクティブ化',
  Activated: 'アクティブ化済み',
  Add: '追加',
  add: '追加',
  Alerts: 'アラート',
  All: 'すべて',
  ampm: 'ampm',
  Arc: '円弧',
  AxisLabel: '{orientation}軸',
  area: '領域',
  Bar: 'バー',
  bar: 'バー',
  Blank: '空白',
  Box: 'ボックス',
  Carousel: 'カルーセル',
  Category: 'カテゴリ',
  Circle: '円',
  Chart: 'グラフ',
  Children: '子',
  Clear: 'クリア',
  Cleared: 'クリア済み',
  Close: '閉じる',
  'Close Menu': 'メニューを閉じる',
  Completed: '完了',
  'Connects With': '接続先',
  created: '作成済み',
  Critical: '重大',
  'Currently Active': '現在アクティブ',
  'Date Selector': '日付セレクター',
  'Date Time Icon': '日付時刻セレクターを開く',
  day: '日',
  Disabled: '無効',
  Distribution: '配布',
  Email: '電子メール',
  'Enter Select': 'Enterを押して選択',
  Error: 'エラー',
  Filter: 'フィルター',
  Footer: 'フッター',
  Grommet: 'Grommet',
  HotSpotsLabel: 'ホットスポット: 矢印キーを押して対話操作する',
  'GraphValues': 'グラフには{count}個の項目があります。最高は{highest}、' + ' 最小は{smallest}です',
  hour: '時間',
  'Grommet Logo': 'Grommetロゴ',
  'Layer': 'レイヤー',
  List: 'リスト',
  line: '線',
  'Loading': 'ロード中',
  loginInvalidPassword: 'ユーザー名とパスワードを指定してください。',
  'Log In': 'ログイン',
  Logout: 'ログアウト',
  'Main Content': 'メインコンテンツ',
  Max: '最大',
  Menu: 'メニュー',
  Meter: 'メートル',
  Min: '最小',
  minute: '分',
  model: 'モデル',
  modified: '変更済み',
  monitor: 'モニター',
  month: '月',
  'Multi Select': '複数選択',
  Name: '名前',
  'Navigation Help': 'ナビゲーションには矢印キーを使用します',
  'Next Month': '次の月',
  'Next Slide': '次のスライド',
  'No Relationship': '関係なし',
  'Notification': '通知',
  OK: 'OK',
  Open: '開く',
  Parent: '親',
  Parents: '親',
  Parts: '部品',
  Part: '部品',
  Password: 'パスワード',
  'Previous Month': '前の月',
  'Previous Slide': '前のスライド',
  'Previous Tiles': '前のタイル',
  'Remember me': 'ユーザー名を保存する',
  Resource: 'リソース',
  Running: '実行中',
  Search: '検索',
  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
  second: '秒',
  'Select Icon': '選択ドロップを開く',
  Selected: '選択済み',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
  'Skip to': 'スキップ先',
  'Slide Number': 'スライド{slideNumber}',
  Sort: 'ソート',
  Spinning: '回転',
  Spiral: 'スパイラル',
  State: '状態',
  Status: 'ステータス',
  Subtract: '減算',
  SunBurst: 'サンバースト',
  'Tab Contents': '[{activeTitle}] タブの内容',
  Table: 'テーブル',
  Tasks: 'タスク',
  Tiles: 'タイル',
  Time: '時刻',
  Title: 'タイトル',
  Today: '今日',
  Topology: 'トポロジ',
  Total: '合計',
  Threshold: 'しきい値',
  Unknown: '不明',
  Username: 'ユーザー名',
  uri: 'URI',
  Value: '値',
  Warning: '警告',
  year: '年'
});
module.exports = exports['default'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.default = {
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filtros}\n  =1 {um filtro}\n  ' + 'other {# filtros}\n}'
  },
  Active: 'Ativos',
  Activate: 'Ativar',
  Activated: 'Ativado',
  Add: 'Adicionar',
  add: 'adicionar',
  Alerts: 'Alertas',
  All: 'Todos',
  AxisLabel: 'Coordenada {orientation}',
  area: 'Área',
  Bar: 'Bar',
  bar: 'bar',
  Blank: 'Em branco',
  Box: 'Box',
  Carousel: 'Carrossel',
  camera: 'Câmera',
  Category: 'Categoria',
  Circle: 'Círculo',
  Chart: 'Gráfico',
  Children: 'Filho',
  Clear: 'Limpar',
  Cleared: 'Livre',
  Close: 'Fechar',
  close: 'fechar',
  'Close Menu': 'Fechar Menu',
  'command-line': 'linha de comando',
  Completed: 'Completado',
  'Connects With': 'Conecta-se com',
  created: 'Criado',
  Critical: 'Crítico',
  'Currently Active': 'Ativo Atualmente',
  'Date Selector': 'Seletor de Data',
  'Date Time Icon': 'Abrir Seleção de Data e Hora',
  Disabled: 'Desabilitado',
  Distribution: 'Distribuição',
  down: 'baixo',
  Email: 'Email',
  'Enter Select': 'Pressione enter para selecionar',
  Error: 'Erro',
  Filter: 'Filtro',
  filter: 'filtro',
  Footer: 'Rodapé',
  HotSpotsLabel: 'HotSpots: pressione setas de nevegação para interagir',
  hour: 'hora',
  'GraphValues': 'Gráfico têm {count} itens. O maior é {highest}' + ' e o menor é {smallest}',
  'Grommet Logo': 'Gromment Logomarca',
  'Layer': 'Modal',
  line: 'linha',
  'link-next': 'link-next',
  'link-previous': 'link-previous',
  'Loading': 'Carregando',
  loginInvalidPassword: 'Por favor, informe Usuário e Senha.',
  'Log In': 'Logar',
  Logout: 'Deslogar',
  'Main Content': 'Conteúdo Principal',
  Max: 'Max',
  Menu: 'Menu',
  menu: 'menu',
  Meter: 'Meter',
  Min: 'Min',
  minute: 'minuto',
  model: 'Modelo',
  modified: 'Modificado',
  monitor: 'monitor',
  more: 'mais',
  'Multi Select': 'Seleção Múltipla',
  Name: 'Nome',
  'Navigation Help': 'Use as setas para navegar',
  'Next Month': 'Próximo Mês',
  'Next Slide': 'Próximo Slide',
  'No Relationship': 'Sem Relacionamento',
  'Notification': 'Notificação',
  OK: 'OK',
  Open: 'Abrir',
  Parent: 'Pai',
  Parents: 'Pais',
  Parts: 'Partes',
  Part: 'Parte',
  Password: 'Senha',
  power: 'power',
  'Previous Month': 'Mês Anterior',
  'Previous Slide': 'Slide Anterior',
  'Previous Tiles': 'Tiles Anteriores',
  'Remember me': 'Lembrar Usuário',
  Resource: 'Recurso',
  Running: 'Executando',
  Search: 'Buscar',
  search: 'buscar',
  'Match Results': '{count, plural,\n      =0 {N\xE3o existe sugest\xE3o}\n      one {Existe # sugest\xE3o}\n      other {Existem # sugest\xF5es}\n  }',
  second: 'segundo',
  'Select Icon': 'Abrir menu de seleção',
  Selected: 'Selecionada(o)',
  'Skip to': 'Saltar para',
  'Slide Number': 'Slide {slideNumber}',
  Spinning: 'Carregando',
  State: 'Estado',
  Status: 'Situaçāo',
  SubBurst: 'SubBurst',
  Subtract: 'Subtrair',
  subtract: 'subtrair',
  'Tab Contents': '{activeTitle} Conteúdo da Tab',
  Table: 'Tabela',
  Tasks: 'Tarefas',
  Tiles: 'Tiles',
  Time: 'Data',
  Title: 'Título',
  Today: 'Hoje',
  Topology: 'Topologia',
  Total: 'Total',
  trash: 'lixeira',
  Threshold: 'Limiar',
  Unknown: 'Desconhecido',
  user: 'user',
  Username: 'Usuário',
  uri: 'URI',
  validation: 'validation',
  Value: 'Valor',
  Warning: 'Alerta'
};
module.exports = exports['default'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = __webpack_require__(58);

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: { // Did I understand the interpolation syntax?
    filters: '{quantity, plural,\n      =0 {\u043D\u0435\u0442 \u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432}\n      =1 {\u043E\u0434\u0438\u043D \u0444\u0438\u043B\u044C\u0442\u0440}\n      other {# \u0444\u0438\u043B\u044C\u0442\u0440\u044B}\n    }'
  }
}, _enUS2.default, {
  Active: 'Активный',
  Activate: 'Активировать',
  Activated: 'Активирован',
  Add: 'Добавить',
  add: 'добавить',
  Alerts: 'Уведомления',
  All: 'Все',
  ampm: 'ампм', // context?
  Arc: 'Дуга',
  AxisLabel: '{orientation} Ось',
  area: 'зона',
  Bar: 'Бар', // context?
  bar: 'бар', // context?
  Blank: 'Пустой',
  Box: 'Ящик', // context?
  Carousel: 'Карусель',
  Category: 'Категория',
  Circle: 'Круг',
  Chart: 'Диаграмма',
  Children: 'Дети',
  Clear: 'Очистить',
  Cleared: 'Очищенный',
  Close: 'Закрыть',
  'Close Menu': 'Закрыть меню',
  Completed: 'Завершенный',
  'Connects With': 'Соединяется с',
  created: 'созданный',
  Critical: 'Критический',
  'Currently Active': 'Активный',
  'Date Selector': 'Выбор даты',
  'Date Time Icon': 'Выбор даты и времени',
  day: 'день',
  Disabled: 'Отключен',
  Distribution: 'Распределение',
  Email: 'Эл. адрес',
  'Enter Select': 'Нажмите enter чтобы выбрать его',
  Error: 'Ошибка',
  Filter: 'Фильтр',
  Footer: 'Нижний колонтитул', // Not 100% sure on this one
  Grommet: 'Громмет',
  HotSpotsLabel: 'HotSpots: нажмите клавиши со стрелками, чтобы взаимодействовать с ним.',
  'GraphValues': 'График имеет {count} элементы. Наивысшее - {highest}, а наименьшее - {smallest}',
  hour: 'час',
  'Grommet Logo': 'Громмет Лого',
  Layer: 'Слой',
  List: 'Список',
  line: 'линия',
  Loading: 'Загружается',
  loginInvalidPassword: 'Пожалуйста, укажите имя и пароль пользователя.',
  'Log In': 'Авторизоваться',
  Logout: 'Выйти',
  'Main Content': 'Основное содержание',
  Max: 'Максимум',
  Menu: 'Меню',
  Meter: 'метр',
  Min: 'Минимум', // assming 'minimum'
  minute: 'минута',
  model: 'модель',
  modified: 'модифицирован',
  monitor: 'монитор',
  month: 'месяц',
  'Multi Select': 'Выбор из нескольких вариантов',
  Name: 'Имя',
  'Navigation Help': 'Используйте клавиши со стрелками для навигации',
  'Next Month': 'Следующий месяц',
  'Next Slide': 'Следующий слайд',
  'No Relationship': 'Нет отношений',
  'Notification': 'Уведомление',
  OK: 'ОК',
  Open: 'Открыть',
  Parent: 'Родитель',
  Parents: 'Родители',
  Parts: 'Части',
  Part: 'Часть',
  Password: 'Пароль',
  'Previous Month': 'Предыдущий Месяц',
  'Previous Slide': 'Предыдущая Слайд',
  'Previous Tiles': 'Предыдущие Плитки',
  'Remember me': 'Запомни меня',
  'Range Start': 'Начало Диапазона',
  'Range End': 'Конец Диапазона',
  Resource: 'Ресурс',
  Running: 'Работает', // "working" -- fitting in context?
  Search: 'Поиск',
  'Match Results': '{count, plural,\n      =0 {\u041D\u0435\u0442 \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F}\n      one {\u0415\u0441\u0442\u044C \u043E\u0434\u043D\u043E \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u044F}\n      other {\u0415\u0441\u0442\u044C # \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0439}\n  }',
  second: 'второй', // as in sequence (number #2), not as in time (hour/minute/second) (might need conjugation based on context)
  'Select Icon': 'Открыть селектор', // "open selector"
  Selected: 'Selected',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435}\n      other {# \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F}\n  }',
  'Skip to': 'Перейти к',
  'Slide Number': ' Слайд {slideNumber}',
  Sort: 'Сортировать',
  Spinning: 'Прядильный', // not 100% sure on this
  Spiral: 'Спираль',
  State: 'Состояние',
  Status: 'Статус',
  Subtract: 'Вычитать',
  SunBurst: 'SunBurst', // context?
  'Tab Contents': 'Содержимое вкладки {activeTitle}',
  Table: 'Таблица',
  Tasks: 'Задания',
  Tiles: 'Плитки',
  Time: 'Время',
  Title: 'Заглавие',
  Today: 'Cегодня',
  Topology: 'Топология',
  Total: 'Всего',
  Threshold: 'Порог',
  Unknown: 'Неизвестный',
  Username: 'Имя пользователя',
  uri: 'унифицированный идентификатор ресурса', // no common abbreviation
  Value: 'Стоимость',
  Warning: 'Предупреждение',
  year: 'год'
});
module.exports = exports['default'];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = __webpack_require__(58);

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {筛选}\n  =1 {1 个筛选}\n  ' + 'other {# 筛选}\n}'
  }
}, _enUS2.default, {
  Active: '活动',
  Activate: '激活',
  Activated: '已激活',
  Add: '添加',
  add: '添加',
  Alerts: '警报',
  All: '全部',
  ampm: 'ampm',
  Arc: '存档',
  AxisLabel: '{orientation} 轴',
  area: '区域',
  Bar: '栏',
  bar: '栏',
  Blank: '空白',
  Box: '框',
  Carousel: '传送',
  Category: '类别',
  Circle: '圆',
  Chart: '图表',
  Children: '子项',
  Clear: '清除',
  Cleared: '已清除',
  Close: '关闭',
  'Close Menu': '关闭菜单',
  Completed: '已完成',
  'Connects With': '连接对象',
  created: '已创建',
  Critical: '严重',
  'Currently Active': '当前处于活动状态',
  'Date Selector': '日期选择器',
  'Date Time Icon': '打开日期和时间选择器',
  day: '天',
  Disabled: '已禁用',
  Distribution: '分布',
  Email: '电子邮件',
  'Enter Select': '按 Enter 进行选择',
  Error: '错误',
  Filter: '筛选',
  Footer: '页脚',
  Grommet: 'Grommet',
  HotSpotsLabel: '热点: 按箭头键可与它进行交互',
  'GraphValues': '图有 {count} 项。最大值为 {highest}，' + ' 最小值为 {smallest}',
  hour: '小时',
  'Grommet Logo': 'Grommet 徽标',
  'Layer': '层',
  List: '列表',
  line: '线',
  'Loading': '正在加载',
  loginInvalidPassword: '请提供用户名和密码。',
  'Log In': '登录',
  Logout: '注销',
  'Main Content': '主要内容',
  Max: '最大值',
  Menu: '菜单',
  Meter: '度量',
  Min: '最小值',
  minute: '分钟',
  model: '型号',
  modified: '已修改',
  monitor: '监控',
  month: '月',
  'Multi Select': '多重选择',
  Name: '名称',
  'Navigation Help': '使用箭头键导航',
  'Next Month': '下个月',
  'Next Slide': '下一张幻灯片',
  'No Relationship': '无关系',
  'Notification': '通知',
  OK: '确定',
  Open: '打开',
  Parent: '父项',
  Parents: '父项',
  Parts: '部分',
  Part: '部分',
  Password: '密码',
  'Previous Month': '上个月',
  'Previous Slide': '上一张幻灯片',
  'Previous Tiles': '之前的磁贴',
  'Remember me': '记住我',
  Resource: '资源',
  Running: '正在运行',
  Search: '搜索',
  'Match Results': 'There {count, plural,\n      =0 {is no match}\n      one {is # match}\n      other {are # matches}\n  }',
  second: '秒',
  'Select Icon': '打开选择下拉列表',
  Selected: '已选择',
  'Selected Multiple': '{count, plural,\n      =0 {none}\n      one {# value}\n      other {# values}\n  }',
  'Skip to': '跳转到',
  'Slide Number': '幻灯片 {slideNumber}',
  Sort: '排序',
  Spinning: '旋转',
  Spiral: '螺旋',
  State: '状况',
  Status: '状态',
  Subtract: '减去',
  SunBurst: 'SunBurst',
  'Tab Contents': '{activeTitle} 选项卡内容',
  Table: '表',
  Tasks: '任务',
  Tiles: '磁贴',
  Time: '时间',
  Title: '标题',
  Today: '今天',
  Topology: '拓扑',
  Total: '总计',
  Threshold: '阈值',
  Unknown: '未知',
  Username: '用户名',
  uri: 'URI',
  Value: '值',
  Warning: '警告',
  year: '年'
});
module.exports = exports['default'];

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-next');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'LinkNext';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DOM = __webpack_require__(59);

var SCROLL_MORE_DELAY = 500; // when the user scrolls
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var SCROLL_MORE_INITIAL_DELAY = 50; // when we start out at the bottom already

function _evaluate(scrollState) {
  (scrollState.scrollParents || []).forEach(function (scrollParent) {
    // are we at the bottom?
    var bottom = void 0;
    if (scrollParent === document) {
      bottom = window.innerHeight;
    } else {
      bottom = scrollParent.getBoundingClientRect().bottom;
    }
    if (scrollState.onEnd) {
      var indicatorRect = scrollState.endIndicatorElement.getBoundingClientRect();
      // Only if bottom isn't zero. This can happen when content hasn't
      // arrived yet.
      // 10px offset is to ensure onEnd() gets called
      if (bottom && indicatorRect.bottom <= bottom + 10) {
        scrollState.onEnd();
      }
    }
    if (scrollState.onTop) {
      var _indicatorRect = scrollState.startIndicatorElement.getBoundingClientRect();
      // If the bottom position is 0 we're right at it. Below it its negative
      // and scrolling too far up its positive.
      if (_indicatorRect.bottom > 0) {
        scrollState.onTop();
      }
    }
  });
}

function _onScroll(scrollState) {
  // delay a bit to ride out quick users
  clearTimeout(scrollState.scrollTimer);
  scrollState.scrollTimer = setTimeout(function () {
    return _evaluate(scrollState);
  }, SCROLL_MORE_DELAY);
}

function _onResize(scrollState) {
  clearTimeout(scrollState.scrollTimer);
  scrollState.scrollTimer = setTimeout(function () {
    return _evaluate(scrollState);
  }, SCROLL_MORE_DELAY);
}

exports.default = {
  startListeningForScroll: function startListeningForScroll(endIndicatorElement, onEnd, startIndicatorElement, onTop) {

    var scrollState = {
      onEnd: onEnd,
      endIndicatorElement: endIndicatorElement,
      onTop: onTop,
      startIndicatorElement: startIndicatorElement,
      scrollParents: (0, _DOM.findScrollParents)(endIndicatorElement || startIndicatorElement)
    };

    scrollState._onResize = _onResize.bind(this, scrollState);
    scrollState._onScroll = _onScroll.bind(this, scrollState);

    window.addEventListener("resize", scrollState._onResize);
    // check in case we're already at the extreme and the indicator is visible
    (scrollState.scrollParents || []).forEach(function (scrollParent, idx) {
      scrollParent.addEventListener("scroll", scrollState._onScroll);

      if (startIndicatorElement) {
        var scrollElement = scrollParent === document ? scrollParent.scrollingElement : scrollParent;

        var rect = startIndicatorElement.getBoundingClientRect();

        //If not enough data to scroll we'll need to load more...
        if (scrollElement.getBoundingClientRect().height + rect.bottom >= scrollElement.scrollHeight) {
          scrollState.scrollTimer = setTimeout(onTop, SCROLL_MORE_INITIAL_DELAY);
        } else if (!idx) {
          //If we're scrolling we need to move the scrollbar down slightly so
          // as to not trigger the onTop() until the user needs it.
          //Only do this for the first scrolling parent
          scrollState.scrollTimer = setTimeout(function () {
            var updatedRect = startIndicatorElement.getBoundingClientRect();
            scrollElement.scrollTop = updatedRect.bottom + 10;
          }, SCROLL_MORE_INITIAL_DELAY);
        }
      }

      if (scrollParent === document || scrollParent === document.body) {
        if (endIndicatorElement) {
          var _rect = endIndicatorElement.getBoundingClientRect();
          if (_rect.top < window.innerHeight) {
            scrollState.scrollTimer = setTimeout(onEnd, SCROLL_MORE_INITIAL_DELAY);
          }
        }
      }
    });
    return scrollState;
  },
  stopListeningForScroll: function stopListeningForScroll(scrollState) {
    (scrollState.scrollParents || []).forEach(function (scrollParent) {
      clearTimeout(scrollState.scrollTimer);
      scrollParent.removeEventListener("scroll", scrollState._onScroll);
      window.removeEventListener("resize", scrollState._onResize);
    });
    scrollState.scrollParents = undefined;
  }
};
module.exports = exports["default"];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2015 Hewlett Packard Enterprise Development LP

// Functions to manage selection via both child index and a specific class name.

// Ensures it is an array.
function normalizeIndexes(selectedIndexes) {
  var result = void 0;
  if (undefined === selectedIndexes || null === selectedIndexes) {
    result = [];
  } else if (typeof selectedIndexes === 'number') {
    result = [selectedIndexes];
  } else {
    result = selectedIndexes;
  }
  return result;
}

// Clears any selected items
// options: {containerElement: , selectedClass: }
function clearClass(options) {
  if (options && options.containerElement) {
    var items = options.containerElement.querySelectorAll("." + options.selectedClass);
    for (var i = 0; i < items.length; i++) {
      items[i].classList.remove(options.selectedClass);
    }
  }
}

// Sets the selectedClass on all children whose index is in selectedIndexes.
// options: {containerElement: , childSelector: , selectedClass: ,
//    selectedIndexes: []}
function setClassFromIndexes(options) {
  clearClass(options);
  if (options && options.containerElement && options.selectedIndexes) {
    var items = options.containerElement.querySelectorAll(options.childSelector);
    options.selectedIndexes.forEach(function (index) {
      if (items[index]) {
        items[index].classList.add(options.selectedClass);
      }
    });
  }
}

// Gets the selected selectedClass on all children whose index is in
// selectedIndexes.
// options: {containerElement: , childSelector: , selectedClass: }
function getIndexesFromClass(options) {
  var items = options.containerElement.querySelectorAll(options.childSelector);
  var selectedIndexes = [];
  for (var i = 0; i < items.length; i++) {
    if (items[i].classList.contains(options.selectedClass)) {
      selectedIndexes.push(i);
    }
  }
  return selectedIndexes;
}

// Returns a new selectedIndexes array with the latest selected indexes
// options: {containerElement: , childSelector: , //selectedClass: ,
//   multiSelect: true|false, priorSelectedIndexes: []}
function onClick(event, options) {

  // Go up the DOM tree until we match the childSelector
  var item = event.target;
  var matchFunction = item.matches || item.matchesElement || item.msMatchesSelector;
  while (matchFunction && item && !matchFunction.bind(item, options.childSelector)()) {
    item = item.parentNode;
    matchFunction = item.matches || item.matchesElement || item.msMatchesSelector;
  }

  // determine the index of the clicked element
  var indexInContainer = 0;
  var previousItem = item.previousSibling;
  while (previousItem != null) {
    previousItem = previousItem.previousSibling;
    indexInContainer += 1;
  }

  var selectedIndexes = void 0; // what will be returned

  if (!event.ctrlKey && !event.metaKey && !event.shiftKey) {

    selectedIndexes = [indexInContainer];
  } else {
    // was it selected?
    var indexInPrior = options.priorSelectedIndexes.indexOf(indexInContainer);

    if (!options.multiSelect) {

      if (-1 !== indexInPrior && (event.ctrlKey || event.metaKey)) {
        selectedIndexes = [];
      } else {
        selectedIndexes = options.priorSelectedIndexes;
      }
    } else {
      // multi-select

      // make a copy of the prior list so we can modify it
      selectedIndexes = options.priorSelectedIndexes.slice(0);

      if (event.shiftKey) {

        // select from nearest selected item to the currently selected item
        var closestIndex = -1;
        selectedIndexes.forEach(function (selectIndex, arrayIndex) {
          if (-1 === closestIndex) {
            closestIndex = selectIndex;
          } else if (Math.abs(indexInContainer - selectIndex) < Math.abs(indexInContainer - closestIndex)) {
            closestIndex = selectIndex;
          }
        });

        for (var i = indexInContainer; i !== closestIndex;) {
          selectedIndexes.push(i);
          if (closestIndex < indexInContainer) {
            i -= 1;
          } else {
            i += 1;
          }
        }

        if (indexInPrior > -1) {
          selectedIndexes.splice(indexInPrior, 1);
        }

        // Remove text selection. This often happens when shift multi-selecting
        window.getSelection().removeAllRanges();
      } else {
        // toggle
        if (-1 === indexInPrior) {
          selectedIndexes.push(indexInContainer);
        } else {
          selectedIndexes.splice(indexInPrior, 1);
        }
      }
    }
  }

  return selectedIndexes;
}

exports.default = {
  normalizeIndexes: normalizeIndexes,
  clearClass: clearClass,
  getIndexesFromClass: getIndexesFromClass,
  setClassFromIndexes: setClassFromIndexes,
  onClick: onClick
};
module.exports = exports["default"];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-info', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'info');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,17.0002864 C15,14.0000003 19,12.0005727 19,8.00028636 C19,4.00000002 16,1.00028636 12,1.00028636 C8,1.00028636 5,4.00000002 5,8.00028636 C5,12.0005727 9,14.0000003 9,17.0002864 C9,20.0005725 9,20 9,20 C9,22.0000003 10,22.9999997 12,23 C14,23.0000003 15,22.0000003 15,20 C15,20 15,20.0005725 15,17.0002864 Z M9,18 L15,18' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Info';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-document-config', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'document-config');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L16,23 M18,1 L18,6 L23,6 M9,14 L9,11 M9,20 C10.6568542,20 12,18.6568542 12,17 C12,15.3431458 10.6568542,14 9,14 C7.34314575,14 6,15.3431458 6,17 C6,18.6568542 7.34314575,20 9,20 Z M9,23 L9,20 M12,17 L15,17 M3,17 L6,17 M5,13 L7,15 M11,19 L13,21 M13,13 L11,15 M7,19 L5,21' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'DocumentConfig';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interviewScreens; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_RouteConfig__ = __webpack_require__(534);
var interviewScreens=__WEBPACK_IMPORTED_MODULE_0__SizerUI_SizerConfig_RouteConfig__["a" /* sizerScreens */];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-trash', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'trash');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4,5 L20,5 L20,23 L4,23 L4,5 Z M1,5 L23,5 M9,1 L15,1 L15,5 L9,5 L9,1 Z M9,1 L15,1 L15,5 L9,5 L9,1 Z M15,9 L15,19 M9,9 L9,19' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Trash';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
var DataDrive=function DataDrive(props){var Drives=props.Drives,dataDiskValue=props.dataDiskValue,type=props.type,title=props.title,onDataDiskChange=props.onDataDiskChange,noOfDisksValue=props.noOfDisksValue,onNoOfDisksChange=props.onNoOfDisksChange,dataDriveType=props.dataDriveType,onDatadriveTypeChange=props.onDatadriveTypeChange,renderTable=props.renderTable,onAddingDataDisk=props.onAddingDataDisk,dataDriveConsolidatedOptions=props.dataDriveConsolidatedOptions,isMixedStorage=props.isMixedStorage,enableADDButton=props.enableADDButton,driveChangeMethodParam1=props.driveChangeMethodParam1,driveQtyChangeMethodParam1=props.driveQtyChangeMethodParam1,roleName=props.roleName,workloadType=props.workloadType,isEPIC=props.isEPIC;var driveTypeLabel="Data Drive Type";var driveLabel='Data Disk';var drivesQuantityLabel='No. of Data Disks';var onDriveChange=function onDriveChange(e){if(workloadType===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]){onDataDiskChange(e,type,title);}if(workloadType===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]){onDataDiskChange(e,driveChangeMethodParam1,roleName);}};var onDriveQtyChange=function onDriveQtyChange(e,ChorBlur){if(workloadType===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]){if(ChorBlur===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]){onNoOfDisksChange(e,type,title,__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]);}else if(ChorBlur===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){onNoOfDisksChange(e,type,title,__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["t" /* BLUR */]);}}if(workloadType===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]){if(ChorBlur===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]){onNoOfDisksChange(e,driveQtyChangeMethodParam1,__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]);}else if(ChorBlur===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){onNoOfDisksChange(e,driveQtyChangeMethodParam1,__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["t" /* BLUR */]);}}};if(workloadType===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]){driveTypeLabel="Persistent Drive Type";driveLabel='Persistent Drive';drivesQuantityLabel='No. of Persistent Drives';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{alignItems:"center"}},isMixedStorage==="True"?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Click on Add to go with mixed storage configuration'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:driveTypeLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Select___default.a,{value:dataDriveType,options:dataDriveConsolidatedOptions,onChange:function onChange(e){return onDatadriveTypeChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:driveLabel/*error={this.state.DiskCapacityerror}*/},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Select___default.a,{placeHolder:'None',options:Drives,value:dataDiskValue,onChange:function onChange(e){return onDriveChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:drivesQuantityLabel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{placeHolder:'None',value:noOfDisksValue,onDOMChange:function onDOMChange(e){return onDriveQtyChange(e,__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]);},onBlur:function onBlur(e){return onDriveQtyChange(e,__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["t" /* BLUR */]);}})),enableADDButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{style:{margin:'14px 0px',padding:'8px 13px'},primary:true,onClick:function onClick(e){return onAddingDataDisk();}},'ADD'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{style:{margin:'14px 0px',padding:'8px 13px'},primary:true},'ADD')),isMixedStorage==="True"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Table___default.a,{style:{width:'80%',margin:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Drive')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Drive Quantity')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,renderTable())),workloadType===__WEBPACK_IMPORTED_MODULE_8__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default.a,{style:{color:'red',fontWeight:'600'}},'Note: All Mixed Storage Configurations have to be deleted to change server selection.'):''):'');};/* harmony default export */ __webpack_exports__["a"] = (DataDrive);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(129);
var createDesc = __webpack_require__(180);
module.exports = __webpack_require__(52) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(99);
var global = __webpack_require__(67);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(286) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 183 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(185)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(178)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(182)('wks');
var uid = __webpack_require__(181);
var Symbol = __webpack_require__(67).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(297);
var createDesc = __webpack_require__(180);
var toIObject = __webpack_require__(101);
var toPrimitive = __webpack_require__(130);
var has = __webpack_require__(131);
var IE8_DOM_DEFINE = __webpack_require__(285);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(52) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 187 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-save', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'save');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,2 L3,21 L21,21 L21,3 L12,3 L12,14 M8,11 L12,15 L16,11' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Save';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _Label = __webpack_require__(37);

var _Label2 = _interopRequireDefault(_Label);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.IMAGE;

var Image = function (_Component) {
  _inherits(Image, _Component);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          align = _props.align,
          caption = _props.caption,
          className = _props.className,
          full = _props.full,
          mask = _props.mask,
          size = _props.size,
          fit = _props.fit,
          props = _objectWithoutProperties(_props, ['align', 'caption', 'className', 'full', 'mask', 'size', 'fit']);

      var classes = (0, _classnames4.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--' + fit, fit), _defineProperty(_classnames, CLASS_ROOT + '--full', fit ? true : typeof full === 'boolean' && full), _defineProperty(_classnames, CLASS_ROOT + '--full-' + full, typeof full === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--mask', mask), _defineProperty(_classnames, CLASS_ROOT + '--align-top', align && align.top), _defineProperty(_classnames, CLASS_ROOT + '--align-bottom', align && align.bottom), _defineProperty(_classnames, CLASS_ROOT + '--align-left', align && align.left), _defineProperty(_classnames, CLASS_ROOT + '--align-right', align && align.right), _classnames), className);

      var captionText = typeof caption === 'string' ? caption : props.alt;
      var imgNode = _react2.default.createElement('img', _extends({}, props, { className: classes }));

      var labelRoot = CLASS_ROOT + '__caption';
      var labelClasses = (0, _classnames4.default)(labelRoot, _defineProperty({}, labelRoot + '--' + size, size));
      return caption && captionText ? _react2.default.createElement(
        'span',
        { className: CLASS_ROOT + '__container' },
        imgNode,
        _react2.default.createElement(
          _Label2.default,
          { className: labelClasses },
          captionText
        )
      ) : imgNode;
    }
  }]);

  return Image;
}(_react.Component);

Image.displayName = 'Image';
exports.default = Image;


Image.propTypes = {
  align: _propTypes2.default.shape({
    bottom: _propTypes2.default.boolean,
    left: _propTypes2.default.boolean,
    right: _propTypes2.default.boolean,
    top: _propTypes2.default.boolean
  }),
  alt: _propTypes2.default.string,
  caption: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  fit: _propTypes2.default.oneOf(['contain', 'cover']),
  full: _propTypes2.default.oneOf([true, 'horizontal', 'vertical', false]),
  mask: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'thumb']),
  src: _propTypes2.default.string,
  title: _propTypes2.default.string
};

Image.defaultProps = {
  size: 'medium'
};
module.exports = exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__(42).DOCUMENT_MODE;

//Node construction
exports.createDocument = function () {
    return {
        nodeName: '#document',
        mode: DOCUMENT_MODE.NO_QUIRKS,
        childNodes: []
    };
};

exports.createDocumentFragment = function () {
    return {
        nodeName: '#document-fragment',
        childNodes: []
    };
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    return {
        nodeName: tagName,
        tagName: tagName,
        attrs: attrs,
        namespaceURI: namespaceURI,
        childNodes: [],
        parentNode: null
    };
};

exports.createCommentNode = function (data) {
    return {
        nodeName: '#comment',
        data: data,
        parentNode: null
    };
};

var createTextNode = function (value) {
    return {
        nodeName: '#text',
        value: value,
        parentNode: null
    };
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    parentNode.childNodes.push(newNode);
    newNode.parentNode = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.childNodes.indexOf(referenceNode);

    parentNode.childNodes.splice(insertionIdx, 0, newNode);
    newNode.parentNode = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    templateElement.content = contentElement;
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.content;
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var doctypeNode = null;

    for (var i = 0; i < document.childNodes.length; i++) {
        if (document.childNodes[i].nodeName === '#documentType') {
            doctypeNode = document.childNodes[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.name = name;
        doctypeNode.publicId = publicId;
        doctypeNode.systemId = systemId;
    }

    else {
        appendChild(document, {
            nodeName: '#documentType',
            name: name,
            publicId: publicId,
            systemId: systemId
        });
    }
};

exports.setDocumentMode = function (document, mode) {
    document.mode = mode;
};

exports.getDocumentMode = function (document) {
    return document.mode;
};

exports.detachNode = function (node) {
    if (node.parentNode) {
        var idx = node.parentNode.childNodes.indexOf(node);

        node.parentNode.childNodes.splice(idx, 1);
        node.parentNode = null;
    }
};

exports.insertText = function (parentNode, text) {
    if (parentNode.childNodes.length) {
        var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];

        if (prevNode.nodeName === '#text') {
            prevNode.value += text;
            return;
        }
    }

    appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.nodeName === '#text')
        prevNode.value += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    var recipientAttrsMap = [];

    for (var i = 0; i < recipient.attrs.length; i++)
        recipientAttrsMap.push(recipient.attrs[i].name);

    for (var j = 0; j < attrs.length; j++) {
        if (recipientAttrsMap.indexOf(attrs[j].name) === -1)
            recipient.attrs.push(attrs[j]);
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.childNodes[0];
};

exports.getChildNodes = function (node) {
    return node.childNodes;
};

exports.getParentNode = function (node) {
    return node.parentNode;
};

exports.getAttrList = function (element) {
    return element.attrs;
};

//Node data
exports.getTagName = function (element) {
    return element.tagName;
};

exports.getNamespaceURI = function (element) {
    return element.namespaceURI;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.value;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode.name;
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode.publicId;
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function (node) {
    return node.nodeName === '#text';
};

exports.isCommentNode = function (node) {
    return node.nodeName === '#comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.nodeName === '#documentType';
};

exports.isElementNode = function (node) {
    return !!node.tagName;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function mergeOptions(defaults, options) {
    options = options || Object.create(null);

    return [defaults, options].reduce(function (merged, optObj) {
        Object.keys(optObj).forEach(function (key) {
            merged[key] = optObj[key];
        });

        return merged;
    }, Object.create(null));
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DOCUMENT_MODE = __webpack_require__(42).DOCUMENT_MODE;

//Const
var VALID_DOCTYPE_NAME = 'html',
    QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd',
    QUIRKS_MODE_PUBLIC_ID_PREFIXES = [
        '+//silmaril//dtd html pro v0r11 19970101//en',
        '-//advasoft ltd//dtd html 3.0 aswedit + extensions//en',
        '-//as//dtd html 3.0 aswedit + extensions//en',
        '-//ietf//dtd html 2.0 level 1//en',
        '-//ietf//dtd html 2.0 level 2//en',
        '-//ietf//dtd html 2.0 strict level 1//en',
        '-//ietf//dtd html 2.0 strict level 2//en',
        '-//ietf//dtd html 2.0 strict//en',
        '-//ietf//dtd html 2.0//en',
        '-//ietf//dtd html 2.1e//en',
        '-//ietf//dtd html 3.0//en',
        '-//ietf//dtd html 3.0//en//',
        '-//ietf//dtd html 3.2 final//en',
        '-//ietf//dtd html 3.2//en',
        '-//ietf//dtd html 3//en',
        '-//ietf//dtd html level 0//en',
        '-//ietf//dtd html level 0//en//2.0',
        '-//ietf//dtd html level 1//en',
        '-//ietf//dtd html level 1//en//2.0',
        '-//ietf//dtd html level 2//en',
        '-//ietf//dtd html level 2//en//2.0',
        '-//ietf//dtd html level 3//en',
        '-//ietf//dtd html level 3//en//3.0',
        '-//ietf//dtd html strict level 0//en',
        '-//ietf//dtd html strict level 0//en//2.0',
        '-//ietf//dtd html strict level 1//en',
        '-//ietf//dtd html strict level 1//en//2.0',
        '-//ietf//dtd html strict level 2//en',
        '-//ietf//dtd html strict level 2//en//2.0',
        '-//ietf//dtd html strict level 3//en',
        '-//ietf//dtd html strict level 3//en//3.0',
        '-//ietf//dtd html strict//en',
        '-//ietf//dtd html strict//en//2.0',
        '-//ietf//dtd html strict//en//3.0',
        '-//ietf//dtd html//en',
        '-//ietf//dtd html//en//2.0',
        '-//ietf//dtd html//en//3.0',
        '-//metrius//dtd metrius presentational//en',
        '-//microsoft//dtd internet explorer 2.0 html strict//en',
        '-//microsoft//dtd internet explorer 2.0 html//en',
        '-//microsoft//dtd internet explorer 2.0 tables//en',
        '-//microsoft//dtd internet explorer 3.0 html strict//en',
        '-//microsoft//dtd internet explorer 3.0 html//en',
        '-//microsoft//dtd internet explorer 3.0 tables//en',
        '-//netscape comm. corp.//dtd html//en',
        '-//netscape comm. corp.//dtd strict html//en',
        '-//o\'reilly and associates//dtd html 2.0//en',
        '-//o\'reilly and associates//dtd html extended 1.0//en',
        '-//spyglass//dtd html 2.0 extended//en',
        '-//sq//dtd html 2.0 hotmetal + extensions//en',
        '-//sun microsystems corp.//dtd hotjava html//en',
        '-//sun microsystems corp.//dtd hotjava strict html//en',
        '-//w3c//dtd html 3 1995-03-24//en',
        '-//w3c//dtd html 3.2 draft//en',
        '-//w3c//dtd html 3.2 final//en',
        '-//w3c//dtd html 3.2//en',
        '-//w3c//dtd html 3.2s draft//en',
        '-//w3c//dtd html 4.0 frameset//en',
        '-//w3c//dtd html 4.0 transitional//en',
        '-//w3c//dtd html experimental 19960712//en',
        '-//w3c//dtd html experimental 970421//en',
        '-//w3c//dtd w3 html//en',
        '-//w3o//dtd w3 html 3.0//en',
        '-//w3o//dtd w3 html 3.0//en//',
        '-//webtechs//dtd mozilla html 2.0//en',
        '-//webtechs//dtd mozilla html//en'
    ],
    QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat([
        '-//w3c//dtd html 4.01 frameset//',
        '-//w3c//dtd html 4.01 transitional//'
    ]),
    QUIRKS_MODE_PUBLIC_IDS = [
        '-//w3o//dtd w3 html strict 3.0//en//',
        '-/w3c/dtd html 4.0 transitional/en',
        'html'
    ],
    LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = [
        '-//W3C//DTD XHTML 1.0 Frameset//',
        '-//W3C//DTD XHTML 1.0 Transitional//'
    ],
    LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat([
        '-//W3C//DTD HTML 4.01 Frameset//',
        '-//W3C//DTD HTML 4.01 Transitional//'
    ]);


//Utils
function enquoteDoctypeId(id) {
    var quote = id.indexOf('"') !== -1 ? '\'' : '"';

    return quote + id + quote;
}

function hasPrefix(publicId, prefixes) {
    for (var i = 0; i < prefixes.length; i++) {
        if (publicId.indexOf(prefixes[i]) === 0)
            return true;
    }

    return false;
}


//API
exports.getDocumentMode = function (name, publicId, systemId) {
    if (name !== VALID_DOCTYPE_NAME)
        return DOCUMENT_MODE.QUIRKS;

    if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID)
        return DOCUMENT_MODE.QUIRKS;

    if (publicId !== null) {
        publicId = publicId.toLowerCase();

        if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1)
            return DOCUMENT_MODE.QUIRKS;

        var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.QUIRKS;

        prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;

        if (hasPrefix(publicId, prefixes))
            return DOCUMENT_MODE.LIMITED_QUIRKS;
    }

    return DOCUMENT_MODE.NO_QUIRKS;
};

exports.serializeContent = function (name, publicId, systemId) {
    var str = '!DOCTYPE ';

    if (name)
        str += name;

    if (publicId !== null)
        str += ' PUBLIC ' + enquoteDoctypeId(publicId);

    else if (systemId !== null)
        str += ' SYSTEM';

    if (systemId !== null)
        str += ' ' + enquoteDoctypeId(systemId);

    return str;
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(315);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(197);
exports.Duplex = __webpack_require__(69);
exports.Transform = __webpack_require__(320);
exports.PassThrough = __webpack_require__(653);


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(196)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(644)
var ieee754 = __webpack_require__(645)
var isArray = __webpack_require__(316)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = Object.create(__webpack_require__(104));
util.inherits = __webpack_require__(83);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(651)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(317);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(195).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(318);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(69);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(69);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103), __webpack_require__(649).setImmediate, __webpack_require__(22)))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextDecoration = exports.TEXT_DECORATION_LINE = exports.TEXT_DECORATION = exports.TEXT_DECORATION_STYLE = undefined;

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TEXT_DECORATION_STYLE = exports.TEXT_DECORATION_STYLE = {
    SOLID: 0,
    DOUBLE: 1,
    DOTTED: 2,
    DASHED: 3,
    WAVY: 4
};

var TEXT_DECORATION = exports.TEXT_DECORATION = {
    NONE: null
};

var TEXT_DECORATION_LINE = exports.TEXT_DECORATION_LINE = {
    UNDERLINE: 1,
    OVERLINE: 2,
    LINE_THROUGH: 3,
    BLINK: 4
};

var parseLine = function parseLine(line) {
    switch (line) {
        case 'underline':
            return TEXT_DECORATION_LINE.UNDERLINE;
        case 'overline':
            return TEXT_DECORATION_LINE.OVERLINE;
        case 'line-through':
            return TEXT_DECORATION_LINE.LINE_THROUGH;
    }
    return TEXT_DECORATION_LINE.BLINK;
};

var parseTextDecorationLine = function parseTextDecorationLine(line) {
    if (line === 'none') {
        return null;
    }

    return line.split(' ').map(parseLine);
};

var parseTextDecorationStyle = function parseTextDecorationStyle(style) {
    switch (style) {
        case 'double':
            return TEXT_DECORATION_STYLE.DOUBLE;
        case 'dotted':
            return TEXT_DECORATION_STYLE.DOTTED;
        case 'dashed':
            return TEXT_DECORATION_STYLE.DASHED;
        case 'wavy':
            return TEXT_DECORATION_STYLE.WAVY;
    }
    return TEXT_DECORATION_STYLE.SOLID;
};

var parseTextDecoration = exports.parseTextDecoration = function parseTextDecoration(style) {
    var textDecorationLine = parseTextDecorationLine(style.textDecorationLine ? style.textDecorationLine : style.textDecoration);
    if (textDecorationLine === null) {
        return TEXT_DECORATION.NONE;
    }

    var textDecorationColor = style.textDecorationColor ? new _Color2.default(style.textDecorationColor) : null;
    var textDecorationStyle = parseTextDecorationStyle(style.textDecorationStyle);

    return {
        textDecorationLine: textDecorationLine,
        textDecorationColor: textDecorationColor,
        textDecorationStyle: textDecorationStyle
    };
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBorder = exports.BORDER_SIDES = exports.BORDER_STYLE = undefined;

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BORDER_STYLE = exports.BORDER_STYLE = {
    NONE: 0,
    SOLID: 1
};

var BORDER_SIDES = exports.BORDER_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};

var SIDES = Object.keys(BORDER_SIDES).map(function (s) {
    return s.toLowerCase();
});

var parseBorderStyle = function parseBorderStyle(style) {
    switch (style) {
        case 'none':
            return BORDER_STYLE.NONE;
    }
    return BORDER_STYLE.SOLID;
};

var parseBorder = exports.parseBorder = function parseBorder(style) {
    return SIDES.map(function (side) {
        var borderColor = new _Color2.default(style.getPropertyValue('border-' + side + '-color'));
        var borderStyle = parseBorderStyle(style.getPropertyValue('border-' + side + '-style'));
        var borderWidth = parseFloat(style.getPropertyValue('border-' + side + '-width'));
        return {
            borderColor: borderColor,
            borderStyle: borderStyle,
            borderWidth: isNaN(borderWidth) ? 0 : borderWidth
        };
    });
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var toCodePoints = exports.toCodePoints = function toCodePoints(str) {
    var codePoints = [];
    var i = 0;
    var length = str.length;
    while (i < length) {
        var value = str.charCodeAt(i++);
        if (value >= 0xd800 && value <= 0xdbff && i < length) {
            var extra = str.charCodeAt(i++);
            if ((extra & 0xfc00) === 0xdc00) {
                codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
            } else {
                codePoints.push(value);
                i--;
            }
        } else {
            codePoints.push(value);
        }
    }
    return codePoints;
};

var fromCodePoint = exports.fromCodePoint = function fromCodePoint() {
    if (String.fromCodePoint) {
        return String.fromCodePoint.apply(String, arguments);
    }

    var length = arguments.length;
    if (!length) {
        return '';
    }

    var codeUnits = [];

    var index = -1;
    var result = '';
    while (++index < length) {
        var codePoint = arguments.length <= index ? undefined : arguments[index];
        if (codePoint <= 0xffff) {
            codeUnits.push(codePoint);
        } else {
            codePoint -= 0x10000;
            codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
        }
        if (index + 1 === length || codeUnits.length > 0x4000) {
            result += String.fromCharCode.apply(String, codeUnits);
            codeUnits.length = 0;
        }
    }
    return result;
};

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}

var decode = exports.decode = function decode(base64) {
    var bufferLength = base64.length * 0.75,
        len = base64.length,
        i = void 0,
        p = 0,
        encoded1 = void 0,
        encoded2 = void 0,
        encoded3 = void 0,
        encoded4 = void 0;

    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') {
            bufferLength--;
        }
    }

    var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
    var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);

    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64.charCodeAt(i)];
        encoded2 = lookup[base64.charCodeAt(i + 1)];
        encoded3 = lookup[base64.charCodeAt(i + 2)];
        encoded4 = lookup[base64.charCodeAt(i + 3)];

        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }

    return buffer;
};

var polyUint16Array = exports.polyUint16Array = function polyUint16Array(buffer) {
    var length = buffer.length;
    var bytes = [];
    for (var _i = 0; _i < length; _i += 2) {
        bytes.push(buffer[_i + 1] << 8 | buffer[_i]);
    }
    return bytes;
};

var polyUint32Array = exports.polyUint32Array = function polyUint32Array(buffer) {
    var length = buffer.length;
    var bytes = [];
    for (var _i2 = 0; _i2 < length; _i2 += 4) {
        bytes.push(buffer[_i2 + 3] << 24 | buffer[_i2 + 2] << 16 | buffer[_i2 + 1] << 8 | buffer[_i2]);
    }
    return bytes;
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCounterText = exports.inlineListItemElement = exports.getListOwner = undefined;

var _Util = __webpack_require__(85);

var _NodeContainer = __webpack_require__(84);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _TextContainer = __webpack_require__(141);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _listStyle = __webpack_require__(140);

var _Unicode = __webpack_require__(330);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Margin between the enumeration and the list item content
var MARGIN_RIGHT = 7;

var ancestorTypes = ['OL', 'UL', 'MENU'];

var getListOwner = exports.getListOwner = function getListOwner(container) {
    var parent = container.parent;
    if (!parent) {
        return null;
    }

    do {
        var isAncestor = ancestorTypes.indexOf(parent.tagName) !== -1;
        if (isAncestor) {
            return parent;
        }
        parent = parent.parent;
    } while (parent);

    return container.parent;
};

var inlineListItemElement = exports.inlineListItemElement = function inlineListItemElement(node, container, resourceLoader) {
    var listStyle = container.style.listStyle;

    if (!listStyle) {
        return;
    }

    var style = node.ownerDocument.defaultView.getComputedStyle(node, null);
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    (0, _Util.copyCSSStyles)(style, wrapper);

    wrapper.style.position = 'absolute';
    wrapper.style.bottom = 'auto';
    wrapper.style.display = 'block';
    wrapper.style.letterSpacing = 'normal';

    switch (listStyle.listStylePosition) {
        case _listStyle.LIST_STYLE_POSITION.OUTSIDE:
            wrapper.style.left = 'auto';
            wrapper.style.right = node.ownerDocument.defaultView.innerWidth - container.bounds.left - container.style.margin[1].getAbsoluteValue(container.bounds.width) + MARGIN_RIGHT + 'px';
            wrapper.style.textAlign = 'right';
            break;
        case _listStyle.LIST_STYLE_POSITION.INSIDE:
            wrapper.style.left = container.bounds.left - container.style.margin[3].getAbsoluteValue(container.bounds.width) + 'px';
            wrapper.style.right = 'auto';
            wrapper.style.textAlign = 'left';
            break;
    }

    var text = void 0;
    var MARGIN_TOP = container.style.margin[0].getAbsoluteValue(container.bounds.width);
    var styleImage = listStyle.listStyleImage;
    if (styleImage) {
        if (styleImage.method === 'url') {
            var image = node.ownerDocument.createElement('img');
            image.src = styleImage.args[0];
            wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
            wrapper.style.width = 'auto';
            wrapper.style.height = 'auto';
            wrapper.appendChild(image);
        } else {
            var size = parseFloat(container.style.font.fontSize) * 0.5;
            wrapper.style.top = container.bounds.top - MARGIN_TOP + container.bounds.height - 1.5 * size + 'px';
            wrapper.style.width = size + 'px';
            wrapper.style.height = size + 'px';
            wrapper.style.backgroundImage = style.listStyleImage;
        }
    } else if (typeof container.listIndex === 'number') {
        text = node.ownerDocument.createTextNode(createCounterText(container.listIndex, listStyle.listStyleType, true));
        wrapper.appendChild(text);
        wrapper.style.top = container.bounds.top - MARGIN_TOP + 'px';
    }

    // $FlowFixMe
    var body = node.ownerDocument.body;
    body.appendChild(wrapper);

    if (text) {
        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    } else {
        // $FlowFixMe
        container.childNodes.push(new _NodeContainer2.default(wrapper, container, resourceLoader, 0));
    }
};

var ROMAN_UPPER = {
    integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
    values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
};

var ARMENIAN = {
    integers: [9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
    values: ['Ք', 'Փ', 'Ւ', 'Ց', 'Ր', 'Տ', 'Վ', 'Ս', 'Ռ', 'Ջ', 'Պ', 'Չ', 'Ո', 'Շ', 'Ն', 'Յ', 'Մ', 'Ճ', 'Ղ', 'Ձ', 'Հ', 'Կ', 'Ծ', 'Խ', 'Լ', 'Ի', 'Ժ', 'Թ', 'Ը', 'Է', 'Զ', 'Ե', 'Դ', 'Գ', 'Բ', 'Ա']
};

var HEBREW = {
    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
    values: ['י׳', 'ט׳', 'ח׳', 'ז׳', 'ו׳', 'ה׳', 'ד׳', 'ג׳', 'ב׳', 'א׳', 'ת', 'ש', 'ר', 'ק', 'צ', 'פ', 'ע', 'ס', 'נ', 'מ', 'ל', 'כ', 'יט', 'יח', 'יז', 'טז', 'טו', 'י', 'ט', 'ח', 'ז', 'ו', 'ה', 'ד', 'ג', 'ב', 'א']
};

var GEORGIAN = {
    integers: [10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
    values: ['ჵ', 'ჰ', 'ჯ', 'ჴ', 'ხ', 'ჭ', 'წ', 'ძ', 'ც', 'ჩ', 'შ', 'ყ', 'ღ', 'ქ', 'ფ', 'ჳ', 'ტ', 'ს', 'რ', 'ჟ', 'პ', 'ო', 'ჲ', 'ნ', 'მ', 'ლ', 'კ', 'ი', 'თ', 'ჱ', 'ზ', 'ვ', 'ე', 'დ', 'გ', 'ბ', 'ა']
};

var createAdditiveCounter = function createAdditiveCounter(value, min, max, symbols, fallback, suffix) {
    if (value < min || value > max) {
        return createCounterText(value, fallback, suffix.length > 0);
    }

    return symbols.integers.reduce(function (string, integer, index) {
        while (value >= integer) {
            value -= integer;
            string += symbols.values[index];
        }
        return string;
    }, '') + suffix;
};

var createCounterStyleWithSymbolResolver = function createCounterStyleWithSymbolResolver(value, codePointRangeLength, isNumeric, resolver) {
    var string = '';

    do {
        if (!isNumeric) {
            value--;
        }
        string = resolver(value) + string;
        value /= codePointRangeLength;
    } while (value * codePointRangeLength >= codePointRangeLength);

    return string;
};

var createCounterStyleFromRange = function createCounterStyleFromRange(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
    var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;

    return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
        return (0, _Unicode.fromCodePoint)(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
    }) + suffix);
};

var createCounterStyleFromSymbols = function createCounterStyleFromSymbols(value, symbols) {
    var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '. ';

    var codePointRangeLength = symbols.length;
    return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) {
        return symbols[Math.floor(codePoint % codePointRangeLength)];
    }) + suffix;
};

var CJK_ZEROS = 1 << 0;
var CJK_TEN_COEFFICIENTS = 1 << 1;
var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
var CJK_HUNDRED_COEFFICIENTS = 1 << 3;

var createCJKCounter = function createCJKCounter(value, numbers, multipliers, negativeSign, suffix, flags) {
    if (value < -9999 || value > 9999) {
        return createCounterText(value, _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL, suffix.length > 0);
    }
    var tmp = Math.abs(value);
    var string = suffix;

    if (tmp === 0) {
        return numbers[0] + string;
    }

    for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
        var coefficient = tmp % 10;

        if (coefficient === 0 && (0, _Util.contains)(flags, CJK_ZEROS) && string !== '') {
            string = numbers[coefficient] + string;
        } else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && (0, _Util.contains)(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && (0, _Util.contains)(flags, CJK_HUNDRED_COEFFICIENTS)) {
            string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
        } else if (coefficient === 1 && digit > 0) {
            string = multipliers[digit - 1] + string;
        }
        tmp = Math.floor(tmp / 10);
    }

    return (value < 0 ? negativeSign : '') + string;
};

var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
var JAPANESE_NEGATIVE = 'マイナス';
var KOREAN_NEGATIVE = '마이너스 ';

var createCounterText = exports.createCounterText = function createCounterText(value, type, appendSuffix) {
    var defaultSuffix = appendSuffix ? '. ' : '';
    var cjkSuffix = appendSuffix ? '、' : '';
    var koreanSuffix = appendSuffix ? ', ' : '';
    switch (type) {
        case _listStyle.LIST_STYLE_TYPE.DISC:
            return '•';
        case _listStyle.LIST_STYLE_TYPE.CIRCLE:
            return '◦';
        case _listStyle.LIST_STYLE_TYPE.SQUARE:
            return '◾';
        case _listStyle.LIST_STYLE_TYPE.DECIMAL_LEADING_ZERO:
            var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
            return string.length < 4 ? '0' + string : string;
        case _listStyle.LIST_STYLE_TYPE.CJK_DECIMAL:
            return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_ROMAN:
            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
        case _listStyle.LIST_STYLE_TYPE.UPPER_ROMAN:
            return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_GREEK:
            return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_ALPHA:
            return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.UPPER_ALPHA:
            return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.ARABIC_INDIC:
            return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.ARMENIAN:
        case _listStyle.LIST_STYLE_TYPE.UPPER_ARMENIAN:
            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.LOWER_ARMENIAN:
            return createAdditiveCounter(value, 1, 9999, ARMENIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix).toLowerCase();
        case _listStyle.LIST_STYLE_TYPE.BENGALI:
            return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.CAMBODIAN:
        case _listStyle.LIST_STYLE_TYPE.KHMER:
            return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.CJK_EARTHLY_BRANCH:
            return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.CJK_HEAVENLY_STEM:
            return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.CJK_IDEOGRAPHIC:
        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_INFORMAL:
            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.TRAD_CHINESE_FORMAL:
            return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_INFORMAL:
            return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.SIMP_CHINESE_FORMAL:
            return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.JAPANESE_INFORMAL:
            return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
        case _listStyle.LIST_STYLE_TYPE.JAPANESE_FORMAL:
            return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANGUL_FORMAL:
            return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_INFORMAL:
            return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
        case _listStyle.LIST_STYLE_TYPE.KOREAN_HANJA_FORMAL:
            return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
        case _listStyle.LIST_STYLE_TYPE.DEVANAGARI:
            return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.GEORGIAN:
            return createAdditiveCounter(value, 1, 19999, GEORGIAN, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.GUJARATI:
            return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.GURMUKHI:
            return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.HEBREW:
            return createAdditiveCounter(value, 1, 10999, HEBREW, _listStyle.LIST_STYLE_TYPE.DECIMAL, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.HIRAGANA:
            return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
        case _listStyle.LIST_STYLE_TYPE.HIRAGANA_IROHA:
            return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
        case _listStyle.LIST_STYLE_TYPE.KANNADA:
            return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.KATAKANA:
            return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.KATAKANA_IROHA:
            return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
        case _listStyle.LIST_STYLE_TYPE.LAO:
            return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.MONGOLIAN:
            return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.MYANMAR:
            return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.ORIYA:
            return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.PERSIAN:
            return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.TAMIL:
            return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.TELUGU:
            return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.THAI:
            return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.TIBETAN:
            return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
        case _listStyle.LIST_STYLE_TYPE.DECIMAL:
        default:
            return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
    }
};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_RESULT__;!function(t){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t()}(function(){"use strict";
/** @license
   * jsPDF - PDF Document creation from JavaScript
   * Version 1.5.3 Built on 2018-12-27T14:11:42.696Z
   *                      CommitID d93d28db14
   *
   * Copyright (c) 2010-2016 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
   *               2010 Aaron Spike, https://github.com/acspike
   *               2012 Willow Systems Corporation, willow-systems.com
   *               2012 Pablo Hess, https://github.com/pablohess
   *               2012 Florian Jenett, https://github.com/fjenett
   *               2013 Warren Weckesser, https://github.com/warrenweckesser
   *               2013 Youssef Beddad, https://github.com/lifof
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2013 Stefan Slonevskiy, https://github.com/stefslon
   *               2013 Jeremy Morel, https://github.com/jmorel
   *               2013 Christoph Hartmann, https://github.com/chris-rock
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Makes, https://github.com/dollaruw
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Steven Spungin, https://github.com/Flamenco
   *               2014 Kenneth Glassey, https://github.com/Gavvers
   *
   * Licensed under the MIT License
   *
   * Contributor(s):
   *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
   *    kim3er, mfo, alnorth, Flamenco
   */function se(t){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}!function(t){if("object"!==se(t.console)){t.console={};for(var e,n,r=t.console,i=function(){},o=["memory"],a="assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(",");e=o.pop();)r[e]||(r[e]={});for(;n=a.pop();)r[n]||(r[n]=i)}var s,l,h,u,c="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";void 0===t.btoa&&(t.btoa=function(t){var e,n,r,i,o,a=0,s=0,l="",h=[];if(!t)return t;for(;e=(o=t.charCodeAt(a++)<<16|t.charCodeAt(a++)<<8|t.charCodeAt(a++))>>18&63,n=o>>12&63,r=o>>6&63,i=63&o,h[s++]=c.charAt(e)+c.charAt(n)+c.charAt(r)+c.charAt(i),a<t.length;);l=h.join("");var u=t.length%3;return(u?l.slice(0,u-3):l)+"===".slice(u||3)}),void 0===t.atob&&(t.atob=function(t){var e,n,r,i,o,a,s=0,l=0,h=[];if(!t)return t;for(t+="";e=(a=c.indexOf(t.charAt(s++))<<18|c.indexOf(t.charAt(s++))<<12|(i=c.indexOf(t.charAt(s++)))<<6|(o=c.indexOf(t.charAt(s++))))>>16&255,n=a>>8&255,r=255&a,h[l++]=64==i?String.fromCharCode(e):64==o?String.fromCharCode(e,n):String.fromCharCode(e,n,r),s<t.length;);return h.join("")}),Array.prototype.map||(Array.prototype.map=function(t){if(null==this||"function"!=typeof t)throw new TypeError;for(var e=Object(this),n=e.length>>>0,r=new Array(n),i=1<arguments.length?arguments[1]:void 0,o=0;o<n;o++)o in e&&(r[o]=t.call(i,e[o],o,e));return r}),Array.isArray||(Array.isArray=function(t){return"[object Array]"===Object.prototype.toString.call(t)}),Array.prototype.forEach||(Array.prototype.forEach=function(t,e){if(null==this||"function"!=typeof t)throw new TypeError;for(var n=Object(this),r=n.length>>>0,i=0;i<r;i++)i in n&&t.call(e,n[i],i,n)}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(t){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),n=e.length>>>0;if("function"!=typeof t)throw new TypeError("predicate must be a function");for(var r=arguments[1],i=0;i<n;){var o=e[i];if(t.call(r,o,i,e))return o;i++}},configurable:!0,writable:!0}),Object.keys||(Object.keys=(s=Object.prototype.hasOwnProperty,l=!{toString:null}.propertyIsEnumerable("toString"),u=(h=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"]).length,function(t){if("object"!==se(t)&&("function"!=typeof t||null===t))throw new TypeError;var e,n,r=[];for(e in t)s.call(t,e)&&r.push(e);if(l)for(n=0;n<u;n++)s.call(t,h[n])&&r.push(h[n]);return r})),"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");t=Object(t);for(var e=1;e<arguments.length;e++){var n=arguments[e];if(null!=n)for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}),String.prototype.trim||(String.prototype.trim=function(){return this.replace(/^\s+|\s+$/g,"")}),String.prototype.trimLeft||(String.prototype.trimLeft=function(){return this.replace(/^\s+/g,"")}),String.prototype.trimRight||(String.prototype.trimRight=function(){return this.replace(/\s+$/g,"")}),Number.isInteger=Number.isInteger||function(t){return"number"==typeof t&&isFinite(t)&&Math.floor(t)===t}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var t,e,n,_,l,F,P,p,d,k,a,o,s,h,u,c,r,i,f,g,m,y,v,w,b,x,I,C,B,N,L,A,S,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y,J,X,K,Z,Q,$,tt,et,nt,rt,it,ot,at,st,lt=function(ie){function oe(o){if("object"!==se(o))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var a={};this.subscribe=function(t,e,n){if(n=n||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof n)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");a.hasOwnProperty(t)||(a[t]={});var r=Math.random().toString(35);return a[t][r]=[e,!!n],r},this.unsubscribe=function(t){for(var e in a)if(a[e][t])return delete a[e][t],0===Object.keys(a[e]).length&&delete a[e],!0;return!1},this.publish=function(t){if(a.hasOwnProperty(t)){var e=Array.prototype.slice.call(arguments,1),n=[];for(var r in a[t]){var i=a[t][r];try{i[0].apply(o,e)}catch(t){ie.console&&console.error("jsPDF PubSub Error",t.message,t)}i[1]&&n.push(r)}n.length&&n.forEach(this.unsubscribe)}},this.getTopics=function(){return a}}function ae(t,e,i,n){var r={},o=[],a=1;"object"===se(t)&&(t=(r=t).orientation,e=r.unit||e,i=r.format||i,n=r.compress||r.compressPdf||n,o=r.filters||(!0===n?["FlateEncode"]:o),a="number"==typeof r.userUnit?Math.abs(r.userUnit):1),e=e||"mm",t=(""+(t||"P")).toLowerCase();var s=r.putOnlyUsedFonts||!0,K={},l={internal:{},__private__:{}};l.__private__.PubSub=oe;var h="1.3",u=l.__private__.getPdfVersion=function(){return h},c=(l.__private__.setPdfVersion=function(t){h=t},{a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]}),f=(l.__private__.getPageFormats=function(){return c},l.__private__.getPageFormat=function(t){return c[t]});"string"==typeof i&&(i=f(i)),i=i||f("a4");var p,Z=l.f2=l.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},Q=l.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return t.toFixed(3)},d="00000000000000000000000000000000",g=l.__private__.getFileId=function(){return d},m=l.__private__.setFileId=function(t){return t=t||"12345678901234567890123456789012".split("").map(function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))}).join(""),d=t};l.setFileId=function(t){return m(t),this},l.getFileId=function(){return g()};var y=l.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),n=e<0?"+":"-",r=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),o=[n,P(r),"'",P(i),"'"].join("");return["D:",t.getFullYear(),P(t.getMonth()+1),P(t.getDate()),P(t.getHours()),P(t.getMinutes()),P(t.getSeconds()),o].join("")},v=l.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),n=parseInt(t.substr(6,2),10)-1,r=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),o=parseInt(t.substr(12,2),10),a=parseInt(t.substr(14,2),10);parseInt(t.substr(16,2),10),parseInt(t.substr(20,2),10);return new Date(e,n,r,i,o,a,0)},w=l.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),"object"===se(t)&&"[object Date]"===Object.prototype.toString.call(t))e=y(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|\-0[0-9]|\-1[0-1])\'(0[0-9]|[1-5][0-9])\'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return p=e},b=l.__private__.getCreationDate=function(t){var e=p;return"jsDate"===t&&(e=v(p)),e};l.setCreationDate=function(t){return w(t),this},l.getCreationDate=function(t){return b(t)};var x,N,L,A,S,$,_,F,P=l.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},k=!1,I=[],C=[],B=0,tt=(l.__private__.setCustomOutputDestination=function(t){N=t},l.__private__.resetCustomOutputDestination=function(t){N=void 0},l.__private__.out=function(t){var e;return t="string"==typeof t?t:t.toString(),(e=void 0===N?k?I[x]:C:N).push(t),k||(B+=t.length+1),e}),j=l.__private__.write=function(t){return tt(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},E=l.__private__.getArrayBuffer=function(t){for(var e=t.length,n=new ArrayBuffer(e),r=new Uint8Array(n);e--;)r[e]=t.charCodeAt(e);return n},M=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]],et=(l.__private__.getStandardFonts=function(t){return M},r.fontSize||16),O=(l.__private__.setFontSize=l.setFontSize=function(t){return et=t,this},l.__private__.getFontSize=l.getFontSize=function(){return et}),nt=r.R2L||!1,q=(l.__private__.setR2L=l.setR2L=function(t){return nt=t,this},l.__private__.getR2L=l.getR2L=function(t){return nt},l.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^\d*\.?\d*\%$/.test(t))L=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');L=t}else L=parseInt(t,10)}),T=(l.__private__.getZoomMode=function(){return L},l.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');A=t}),R=(l.__private__.getPageMode=function(){return A},l.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');S=t}),D=(l.__private__.getLayoutMode=function(){return S},l.__private__.setDisplayMode=l.setDisplayMode=function(t,e,n){return q(t),R(e),T(n),this},{title:"",subject:"",author:"",keywords:"",creator:""}),U=(l.__private__.getDocumentProperty=function(t){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return D[t]},l.__private__.getDocumentProperties=function(t){return D},l.__private__.setDocumentProperties=l.setProperties=l.setDocumentProperties=function(t){for(var e in D)D.hasOwnProperty(e)&&t[e]&&(D[e]=t[e]);return this},l.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(D).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return D[t]=e},0),z=[],rt={},H={},W=0,V=[],G=[],it=new oe(l),Y=r.hotfixes||[],J=l.__private__.newObject=function(){var t=X();return ot(t,!0),t},X=l.__private__.newObjectDeferred=function(){return z[++U]=function(){return B},U},ot=function(t,e){return e="boolean"==typeof e&&e,z[t]=B,e&&tt(t+" 0 obj"),t},at=l.__private__.newAdditionalObject=function(){var t={objId:X(),content:""};return G.push(t),t},st=X(),lt=X(),ht=l.__private__.decodeColorString=function(t){var e=t.split(" ");if(2===e.length&&("g"===e[1]||"G"===e[1])){var n=parseFloat(e[0]);e=[n,n,n,"r"]}for(var r="#",i=0;i<3;i++)r+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return r},ut=l.__private__.encodeColorString=function(t){var e;"string"==typeof t&&(t={ch1:t});var n=t.ch1,r=t.ch2,i=t.ch3,o=t.ch4,a=(t.precision,"draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"]);if("string"==typeof n&&"#"!==n.charAt(0)){var s=new RGBColor(n);if(s.ok)n=s.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var l=parseInt(n.substr(1),16);n=l>>16&255,r=l>>8&255,i=255&l}if(void 0===r||void 0===o&&n===r&&r===i)if("string"==typeof n)e=n+" "+a[0];else switch(t.precision){case 2:e=Z(n/255)+" "+a[0];break;case 3:default:e=Q(n/255)+" "+a[0]}else if(void 0===o||"object"===se(o)){if(o&&!isNaN(o.a)&&0===o.a)return e=["1.000","1.000","1.000",a[1]].join(" ");if("string"==typeof n)e=[n,r,i,a[1]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),a[1]].join(" ");break;default:case 3:e=[Q(n/255),Q(r/255),Q(i/255),a[1]].join(" ")}}else if("string"==typeof n)e=[n,r,i,o,a[2]].join(" ");else switch(t.precision){case 2:e=[Z(n/255),Z(r/255),Z(i/255),Z(o/255),a[2]].join(" ");break;case 3:default:e=[Q(n/255),Q(r/255),Q(i/255),Q(o/255),a[2]].join(" ")}return e},ct=l.__private__.getFilters=function(){return o},ft=l.__private__.putStream=function(t){var e=(t=t||{}).data||"",n=t.filters||ct(),r=t.alreadyAppliedFilters||[],i=t.addLength1||!1,o=e.length,a={};!0===n&&(n=["FlateEncode"]);var s=t.additionalKeyValues||[],l=(a=void 0!==ae.API.processDataByFilters?ae.API.processDataByFilters(e,n):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(r)?r.join(" "):r.toString());0!==a.data.length&&(s.push({key:"Length",value:a.data.length}),!0===i&&s.push({key:"Length1",value:o})),0!=l.length&&(l.split("/").length-1==1?s.push({key:"Filter",value:l}):s.push({key:"Filter",value:"["+l+"]"})),tt("<<");for(var h=0;h<s.length;h++)tt("/"+s[h].key+" "+s[h].value);tt(">>"),0!==a.data.length&&(tt("stream"),tt(a.data),tt("endstream"))},pt=l.__private__.putPage=function(t){t.mediaBox;var e=t.number,n=t.data,r=t.objId,i=t.contentsObjId;ot(r,!0);V[x].mediaBox.topRightX,V[x].mediaBox.bottomLeftX,V[x].mediaBox.topRightY,V[x].mediaBox.bottomLeftY;tt("<</Type /Page"),tt("/Parent "+t.rootDictionaryObjId+" 0 R"),tt("/Resources "+t.resourceDictionaryObjId+" 0 R"),tt("/MediaBox ["+parseFloat(Z(t.mediaBox.bottomLeftX))+" "+parseFloat(Z(t.mediaBox.bottomLeftY))+" "+Z(t.mediaBox.topRightX)+" "+Z(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&tt("/CropBox ["+Z(t.cropBox.bottomLeftX)+" "+Z(t.cropBox.bottomLeftY)+" "+Z(t.cropBox.topRightX)+" "+Z(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&tt("/BleedBox ["+Z(t.bleedBox.bottomLeftX)+" "+Z(t.bleedBox.bottomLeftY)+" "+Z(t.bleedBox.topRightX)+" "+Z(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&tt("/TrimBox ["+Z(t.trimBox.bottomLeftX)+" "+Z(t.trimBox.bottomLeftY)+" "+Z(t.trimBox.topRightX)+" "+Z(t.trimBox.topRightY)+"]"),null!==t.artBox&&tt("/ArtBox ["+Z(t.artBox.bottomLeftX)+" "+Z(t.artBox.bottomLeftY)+" "+Z(t.artBox.topRightX)+" "+Z(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&tt("/UserUnit "+t.userUnit),it.publish("putPage",{objId:r,pageContext:V[e],pageNumber:e,page:n}),tt("/Contents "+i+" 0 R"),tt(">>"),tt("endobj");var o=n.join("\n");return ot(i,!0),ft({data:o,filters:ct()}),tt("endobj"),r},dt=l.__private__.putPages=function(){var t,e,n=[];for(t=1;t<=W;t++)V[t].objId=X(),V[t].contentsObjId=X();for(t=1;t<=W;t++)n.push(pt({number:t,data:I[t],objId:V[t].objId,contentsObjId:V[t].contentsObjId,mediaBox:V[t].mediaBox,cropBox:V[t].cropBox,bleedBox:V[t].bleedBox,trimBox:V[t].trimBox,artBox:V[t].artBox,userUnit:V[t].userUnit,rootDictionaryObjId:st,resourceDictionaryObjId:lt}));ot(st,!0),tt("<</Type /Pages");var r="/Kids [";for(e=0;e<W;e++)r+=n[e]+" 0 R ";tt(r+"]"),tt("/Count "+W),tt(">>"),tt("endobj"),it.publish("postPutPages")},gt=function(){!function(){for(var t in rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&(e=rt[t],it.publish("putFont",{font:e,out:tt,newObject:J,putStream:ft}),!0!==e.isAlreadyPutted&&(e.objectNumber=J(),tt("<<"),tt("/Type /Font"),tt("/BaseFont /"+e.postScriptName),tt("/Subtype /Type1"),"string"==typeof e.encoding&&tt("/Encoding /"+e.encoding),tt("/FirstChar 32"),tt("/LastChar 255"),tt(">>"),tt("endobj")));var e}(),it.publish("putResources"),ot(lt,!0),tt("<<"),function(){for(var t in tt("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),tt("/Font <<"),rt)rt.hasOwnProperty(t)&&(!1===s||!0===s&&K.hasOwnProperty(t))&&tt("/"+t+" "+rt[t].objectNumber+" 0 R");tt(">>"),tt("/XObject <<"),it.publish("putXobjectDict"),tt(">>")}(),tt(">>"),tt("endobj"),it.publish("postPutResources")},mt=function(t,e,n){H.hasOwnProperty(e)||(H[e]={}),H[e][n]=t},yt=function(t,e,n,r,i){i=i||!1;var o="F"+(Object.keys(rt).length+1).toString(10),a={id:o,postScriptName:t,fontName:e,fontStyle:n,encoding:r,isStandardFont:i,metadata:{}};return it.publish("addFont",{font:a,instance:this}),void 0!==o&&(rt[o]=a,mt(o,e,n)),o},vt=l.__private__.pdfEscape=l.pdfEscape=function(t,e){return function(t,e){var n,r,i,o,a,s,l,h,u;if(i=(e=e||{}).sourceEncoding||"Unicode",a=e.outputEncoding,(e.autoencode||a)&&rt[$].metadata&&rt[$].metadata[i]&&rt[$].metadata[i].encoding&&(o=rt[$].metadata[i].encoding,!a&&rt[$].encoding&&(a=rt[$].encoding),!a&&o.codePages&&(a=o.codePages[0]),"string"==typeof a&&(a=o[a]),a)){for(l=!1,s=[],n=0,r=t.length;n<r;n++)(h=a[t.charCodeAt(n)])?s.push(String.fromCharCode(h)):s.push(t[n]),s[n].charCodeAt(0)>>8&&(l=!0);t=s.join("")}for(n=t.length;void 0===l&&0!==n;)t.charCodeAt(n-1)>>8&&(l=!0),n--;if(!l)return t;for(s=e.noBOM?[]:[254,255],n=0,r=t.length;n<r;n++){if((u=(h=t.charCodeAt(n))>>8)>>8)throw new Error("Character at position "+n+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(u),s.push(h-(u<<8))}return String.fromCharCode.apply(void 0,s)}(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},wt=l.__private__.beginPage=function(t,e){var n,r="string"==typeof e&&e.toLowerCase();if("string"==typeof t&&(n=f(t.toLowerCase()))&&(t=n[0],e=n[1]),Array.isArray(t)&&(e=t[1],t=t[0]),(isNaN(t)||isNaN(e))&&(t=i[0],e=i[1]),r){switch(r.substr(0,1)){case"l":t<e&&(r="s");break;case"p":e<t&&(r="s")}"s"===r&&(n=t,t=e,e=n)}(14400<t||14400<e)&&(console.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),t=Math.min(14400,t),e=Math.min(14400,e)),i=[t,e],k=!0,I[++W]=[],V[W]={objId:0,contentsObjId:0,userUnit:Number(a),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t),topRightY:Number(e)}},xt(W)},bt=function(){wt.apply(this,arguments),Dt(Rt),tt(Jt),0!==te&&tt(te+" J"),0!==ne&&tt(ne+" j"),it.publish("addPage",{pageNumber:W})},xt=function(t){0<t&&t<=W&&(x=t)},Nt=l.__private__.getNumberOfPages=l.getNumberOfPages=function(){return I.length-1},Lt=function(t,e,n){var r,i=void 0;return n=n||{},t=void 0!==t?t:rt[$].fontName,e=void 0!==e?e:rt[$].fontStyle,r=t.toLowerCase(),void 0!==H[r]&&void 0!==H[r][e]?i=H[r][e]:void 0!==H[t]&&void 0!==H[t][e]?i=H[t][e]:!1===n.disableWarning&&console.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),i||n.noFallback||null==(i=H.times[e])&&(i=H.times.normal),i},At=l.__private__.putInfo=function(){for(var t in J(),tt("<<"),tt("/Producer (jsPDF "+ae.version+")"),D)D.hasOwnProperty(t)&&D[t]&&tt("/"+t.substr(0,1).toUpperCase()+t.substr(1)+" ("+vt(D[t])+")");tt("/CreationDate ("+p+")"),tt(">>"),tt("endobj")},St=l.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||st;switch(J(),tt("<<"),tt("/Type /Catalog"),tt("/Pages "+e+" 0 R"),L||(L="fullwidth"),L){case"fullwidth":tt("/OpenAction [3 0 R /FitH null]");break;case"fullheight":tt("/OpenAction [3 0 R /FitV null]");break;case"fullpage":tt("/OpenAction [3 0 R /Fit]");break;case"original":tt("/OpenAction [3 0 R /XYZ null null 1]");break;default:var n=""+L;"%"===n.substr(n.length-1)&&(L=parseInt(L)/100),"number"==typeof L&&tt("/OpenAction [3 0 R /XYZ null null "+Z(L)+"]")}switch(S||(S="continuous"),S){case"continuous":tt("/PageLayout /OneColumn");break;case"single":tt("/PageLayout /SinglePage");break;case"two":case"twoleft":tt("/PageLayout /TwoColumnLeft");break;case"tworight":tt("/PageLayout /TwoColumnRight")}A&&tt("/PageMode /"+A),it.publish("putCatalog"),tt(">>"),tt("endobj")},_t=l.__private__.putTrailer=function(){tt("trailer"),tt("<<"),tt("/Size "+(U+1)),tt("/Root "+U+" 0 R"),tt("/Info "+(U-1)+" 0 R"),tt("/ID [ <"+d+"> <"+d+"> ]"),tt(">>")},Ft=l.__private__.putHeader=function(){tt("%PDF-"+h),tt("%ºß¬à")},Pt=l.__private__.putXRef=function(){var t=1,e="0000000000";for(tt("xref"),tt("0 "+(U+1)),tt("0000000000 65535 f "),t=1;t<=U;t++){"function"==typeof z[t]?tt((e+z[t]()).slice(-10)+" 00000 n "):void 0!==z[t]?tt((e+z[t]).slice(-10)+" 00000 n "):tt("0000000000 00000 n ")}},kt=l.__private__.buildDocument=function(){k=!1,B=U=0,C=[],z=[],G=[],st=X(),lt=X(),it.publish("buildDocument"),Ft(),dt(),function(){it.publish("putAdditionalObjects");for(var t=0;t<G.length;t++){var e=G[t];ot(e.objId,!0),tt(e.content),tt("endobj")}it.publish("postPutAdditionalObjects")}(),gt(),At(),St();var t=B;return Pt(),_t(),tt("startxref"),tt(""+t),tt("%%EOF"),k=!0,C.join("\n")},It=l.__private__.getBlob=function(t){return new Blob([E(t)],{type:"application/pdf"})},Ct=l.output=l.__private__.output=((F=function(t,e){e=e||{};var n=kt();switch("string"==typeof e?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return n;case"save":l.save(e.filename);break;case"arraybuffer":return E(n);case"blob":return It(n);case"bloburi":case"bloburl":if(void 0!==ie.URL&&"function"==typeof ie.URL.createObjectURL)return ie.URL&&ie.URL.createObjectURL(It(n))||void 0;console.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":return"data:application/pdf;filename="+e.filename+";base64,"+btoa(n);case"dataurlnewwindow":var r='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring")+'"></iframe></body></html>',i=ie.open();if(null!==i&&i.document.write(r),i||"undefined"==typeof safari)return i;case"datauri":case"dataurl":return ie.document.location.href="data:application/pdf;filename="+e.filename+";base64,"+btoa(n);default:return null}}).foo=function(){try{return F.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!ie.console)throw new Error(n);ie.console.error(n,t),ie.alert&&alert(n)}},(F.foo.bar=F).foo),Bt=function(t){return!0===Array.isArray(Y)&&-1<Y.indexOf(t)};switch(e){case"pt":_=1;break;case"mm":_=72/25.4;break;case"cm":_=72/2.54;break;case"in":_=72;break;case"px":_=1==Bt("px_scaling")?.75:96/72;break;case"pc":case"em":_=12;break;case"ex":_=6;break;default:throw new Error("Invalid unit: "+e)}w(),m();var jt=l.__private__.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:V[t].objId,pageNumber:t,pageContext:V[t]}},Et=l.__private__.getPageInfoByObjId=function(t){for(var e in V)if(V[e].objId===t)break;if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");return jt(e)},Mt=l.__private__.getCurrentPageInfo=function(){return{objId:V[x].objId,pageNumber:x,pageContext:V[x]}};l.addPage=function(){return bt.apply(this,arguments),this},l.setPage=function(){return xt.apply(this,arguments),this},l.insertPage=function(t){return this.addPage(),this.movePage(x,t),this},l.movePage=function(t,e){if(e<t){for(var n=I[t],r=V[t],i=t;e<i;i--)I[i]=I[i-1],V[i]=V[i-1];I[e]=n,V[e]=r,this.setPage(e)}else if(t<e){for(n=I[t],r=V[t],i=t;i<e;i++)I[i]=I[i+1],V[i]=V[i+1];I[e]=n,V[e]=r,this.setPage(e)}return this},l.deletePage=function(){return function(t){0<t&&t<=W&&(I.splice(t,1),--W<x&&(x=W),this.setPage(x))}.apply(this,arguments),this};l.__private__.text=l.text=function(t,e,n,i){var r;"number"!=typeof t||"number"!=typeof e||"string"!=typeof n&&!Array.isArray(n)||(r=n,n=e,e=t,t=r);var o=arguments[3],a=arguments[4],s=arguments[5];if("object"===se(o)&&null!==o||("string"==typeof a&&(s=a,a=null),"string"==typeof o&&(s=o,o=null),"number"==typeof o&&(a=o,o=null),i={flags:o,angle:a,align:s}),(o=o||{}).noBOM=o.noBOM||!0,o.autoencode=o.autoencode||!0,isNaN(e)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return c;var l,h="",u="number"==typeof i.lineHeightFactor?i.lineHeightFactor:Tt,c=i.scope||this;function f(t){for(var e,n=t.concat(),r=[],i=n.length;i--;)"string"==typeof(e=n.shift())?r.push(e):Array.isArray(t)&&1===e.length?r.push(e[0]):r.push([e[0],e[1],e[2]]);return r}function p(t,e){var n;if("string"==typeof t)n=e(t)[0];else if(Array.isArray(t)){for(var r,i,o=t.concat(),a=[],s=o.length;s--;)"string"==typeof(r=o.shift())?a.push(e(r)[0]):Array.isArray(r)&&"string"===r[0]&&(i=e(r[0],r[1],r[2]),a.push([i[0],i[1],i[2]]));n=a}return n}var d=!1,g=!0;if("string"==typeof t)d=!0;else if(Array.isArray(t)){for(var m,y=t.concat(),v=[],w=y.length;w--;)("string"!=typeof(m=y.shift())||Array.isArray(m)&&"string"!=typeof m[0])&&(g=!1);d=g}if(!1===d)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');var b=rt[$].encoding;"WinAnsiEncoding"!==b&&"StandardEncoding"!==b||(t=p(t,function(t,e,n){return[(r=t,r=r.split("\t").join(Array(i.TabLen||9).join(" ")),vt(r,o)),e,n];var r})),"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var x=et/c.internal.scaleFactor,N=x*(Tt-1);switch(i.baseline){case"bottom":n-=N;break;case"top":n+=x-N;break;case"hanging":n+=x-2*N;break;case"middle":n+=x/2-N}0<(O=i.maxWidth||0)&&("string"==typeof t?t=c.splitTextToSize(t,O):"[object Array]"===Object.prototype.toString.call(t)&&(t=c.splitTextToSize(t.join(" "),O)));var L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("preProcessText",L),t=L.text;a=(i=L.options).angle;var A=c.internal.scaleFactor,S=[];if(a){a*=Math.PI/180;var _=Math.cos(a),F=Math.sin(a);S=[Z(_),Z(F),Z(-1*F),Z(_)]}void 0!==(M=i.charSpace)&&(h+=Q(M*A)+" Tc\n");i.lang;var P=-1,k=void 0!==i.renderingMode?i.renderingMode:i.stroke,I=c.internal.getCurrentPageInfo().pageContext;switch(k){case 0:case!1:case"fill":P=0;break;case 1:case!0:case"stroke":P=1;break;case 2:case"fillThenStroke":P=2;break;case 3:case"invisible":P=3;break;case 4:case"fillAndAddForClipping":P=4;break;case 5:case"strokeAndAddPathForClipping":P=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":P=6;break;case 7:case"addToPathForClipping":P=7}var C=void 0!==I.usedRenderingMode?I.usedRenderingMode:-1;-1!==P?h+=P+" Tr\n":-1!==C&&(h+="0 Tr\n"),-1!==P&&(I.usedRenderingMode=P);s=i.align||"left";var B=et*u,j=c.internal.pageSize.getWidth(),E=(A=c.internal.scaleFactor,rt[$]),M=i.charSpace||Qt,O=i.maxWidth||0,q=(o={},[]);if("[object Array]"===Object.prototype.toString.call(t)){var T,R;v=f(t);"left"!==s&&(R=v.map(function(t){return c.getStringUnitWidth(t,{font:E,charSpace:M,fontSize:et})*et/A}));var D,U=Math.max.apply(Math,R),z=0;if("right"===s){e-=R[0],t=[];var H=0;for(w=v.length;H<w;H++)U-R[H],T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])*A,-B),t.push([v[H],D,T]),z=R[H]}else if("center"===s){e-=R[0]/2,t=[];for(H=0,w=v.length;H<w;H++)(U-R[H])/2,T=0===H?(D=Wt(e),Vt(n)):(D=(z-R[H])/2*A,-B),t.push([v[H],D,T]),z=R[H]}else if("left"===s){t=[];for(H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,t.push(v[H])}else{if("justify"!==s)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[];for(O=0!==O?O:j,H=0,w=v.length;H<w;H++)T=0===H?Vt(n):-B,D=0===H?Wt(e):0,H<w-1&&q.push(((O-R[H])/(v[H].split(" ").length-1)*A).toFixed(2)),t.push([v[H],D,T])}}!0===("boolean"==typeof i.R2L?i.R2L:nt)&&(t=p(t,function(t,e,n){return[t.split("").reverse().join(""),e,n]}));L={text:t,x:e,y:n,options:i,mutex:{pdfEscape:vt,activeFontKey:$,fonts:rt,activeFontSize:et}};it.publish("postProcessText",L),t=L.text,l=L.mutex.isHex;v=f(t);t=[];var W,V,G,Y=0,J=(w=v.length,"");for(H=0;H<w;H++)J="",Array.isArray(v[H])?(W=parseFloat(v[H][1]),V=parseFloat(v[H][2]),G=(l?"<":"(")+v[H][0]+(l?">":")"),Y=1):(W=Wt(e),V=Vt(n),G=(l?"<":"(")+v[H]+(l?">":")")),void 0!==q&&void 0!==q[H]&&(J=q[H]+" Tw\n"),0!==S.length&&0===H?t.push(J+S.join(" ")+" "+W.toFixed(2)+" "+V.toFixed(2)+" Tm\n"+G):1===Y||0===Y&&0===H?t.push(J+W.toFixed(2)+" "+V.toFixed(2)+" Td\n"+G):t.push(J+G);t=0===Y?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var X="BT\n/"+$+" "+et+" Tf\n"+(et*u).toFixed(2)+" TL\n"+Kt+"\n";return X+=h,X+=t,tt(X+="ET"),K[$]=!0,c},l.__private__.lstext=l.lstext=function(t,e,n,r){return console.warn("jsPDF.lstext is deprecated"),this.text(t,e,n,{charSpace:r})},l.__private__.clip=l.clip=function(t){tt("evenodd"===t?"W*":"W"),tt("n")},l.__private__.clip_fixed=l.clip_fixed=function(t){console.log("clip_fixed is deprecated"),l.clip(t)};var Ot=l.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","F","DF","FD","f","f*","B","B*"].indexOf(t)&&(e=!0),e},qt=l.__private__.getStyle=function(t){var e="S";return"F"===t?e="f":"FD"===t||"DF"===t?e="B":"f"!==t&&"f*"!==t&&"B"!==t&&"B*"!==t||(e=t),e};l.__private__.line=l.line=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw new Error("Invalid arguments passed to jsPDF.line");return this.lines([[n-t,r-e]],t,e)},l.__private__.lines=l.lines=function(t,e,n,r,i,o){var a,s,l,h,u,c,f,p,d,g,m,y;if("number"==typeof t&&(y=n,n=e,e=t,t=y),r=r||[1,1],o=o||!1,isNaN(e)||isNaN(n)||!Array.isArray(t)||!Array.isArray(r)||!Ot(i)||"boolean"!=typeof o)throw new Error("Invalid arguments passed to jsPDF.lines");for(tt(Q(Wt(e))+" "+Q(Vt(n))+" m "),a=r[0],s=r[1],h=t.length,g=e,m=n,l=0;l<h;l++)2===(u=t[l]).length?(g=u[0]*a+g,m=u[1]*s+m,tt(Q(Wt(g))+" "+Q(Vt(m))+" l")):(c=u[0]*a+g,f=u[1]*s+m,p=u[2]*a+g,d=u[3]*s+m,g=u[4]*a+g,m=u[5]*s+m,tt(Q(Wt(c))+" "+Q(Vt(f))+" "+Q(Wt(p))+" "+Q(Vt(d))+" "+Q(Wt(g))+" "+Q(Vt(m))+" c"));return o&&tt(" h"),null!==i&&tt(qt(i)),this},l.__private__.rect=l.rect=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.rect");return tt([Z(Wt(t)),Z(Vt(e)),Z(n*_),Z(-r*_),"re"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.triangle=l.triangle=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[n-t,r-e],[i-n,o-r],[t-i,e-o]],t,e,[1,1],a,!0),this},l.__private__.roundedRect=l.roundedRect=function(t,e,n,r,i,o,a){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o)||!Ot(a))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return this.lines([[n-2*i,0],[i*s,0,i,o-o*s,i,o],[0,r-2*o],[0,o*s,-i*s,o,-i,o],[2*i-n,0],[-i*s,0,-i,-o*s,-i,-o],[0,2*o-r],[0,-o*s,i*s,-o,i,-o]],t+i,e,[1,1],a),this},l.__private__.ellipse=l.ellipse=function(t,e,n,r,i){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||!Ot(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var o=4/3*(Math.SQRT2-1)*n,a=4/3*(Math.SQRT2-1)*r;return tt([Z(Wt(t+n)),Z(Vt(e)),"m",Z(Wt(t+n)),Z(Vt(e-a)),Z(Wt(t+o)),Z(Vt(e-r)),Z(Wt(t)),Z(Vt(e-r)),"c"].join(" ")),tt([Z(Wt(t-o)),Z(Vt(e-r)),Z(Wt(t-n)),Z(Vt(e-a)),Z(Wt(t-n)),Z(Vt(e)),"c"].join(" ")),tt([Z(Wt(t-n)),Z(Vt(e+a)),Z(Wt(t-o)),Z(Vt(e+r)),Z(Wt(t)),Z(Vt(e+r)),"c"].join(" ")),tt([Z(Wt(t+o)),Z(Vt(e+r)),Z(Wt(t+n)),Z(Vt(e+a)),Z(Wt(t+n)),Z(Vt(e)),"c"].join(" ")),null!==i&&tt(qt(i)),this},l.__private__.circle=l.circle=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||!Ot(r))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,n,n,r)};l.setFont=function(t,e){return $=Lt(t,e,{disableWarning:!1}),this},l.setFontStyle=l.setFontType=function(t){return $=Lt(void 0,t),this};l.__private__.getFontList=l.getFontList=function(){var t,e,n,r={};for(t in H)if(H.hasOwnProperty(t))for(e in r[t]=n=[],H[t])H[t].hasOwnProperty(e)&&n.push(e);return r};l.addFont=function(t,e,n,r){yt.call(this,t,e,n,r=r||"Identity-H")};var Tt,Rt=r.lineWidth||.200025,Dt=l.__private__.setLineWidth=l.setLineWidth=function(t){return tt((t*_).toFixed(2)+" w"),this},Ut=(l.__private__.setLineDash=ae.API.setLineDash=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map(function(t){return(t*_).toFixed(3)}).join(" "),e=parseFloat((e*_).toFixed(3)),tt("["+t+"] "+e+" d"),this},l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt}),zt=(Ut=l.__private__.getLineHeight=l.getLineHeight=function(){return et*Tt},l.__private__.setLineHeightFactor=l.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(Tt=t),this}),Ht=l.__private__.getLineHeightFactor=l.getLineHeightFactor=function(){return Tt};zt(r.lineHeight);var Wt=l.__private__.getHorizontalCoordinate=function(t){return t*_},Vt=l.__private__.getVerticalCoordinate=function(t){return V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_},Gt=l.__private__.getHorizontalCoordinateString=function(t){return Z(t*_)},Yt=l.__private__.getVerticalCoordinateString=function(t){return Z(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY-t*_)},Jt=r.strokeColor||"0 G",Xt=(l.__private__.getStrokeColor=l.getDrawColor=function(){return ht(Jt)},l.__private__.setStrokeColor=l.setDrawColor=function(t,e,n,r){return Jt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"draw",precision:2}),tt(Jt),this},r.fillColor||"0 g"),Kt=(l.__private__.getFillColor=l.getFillColor=function(){return ht(Xt)},l.__private__.setFillColor=l.setFillColor=function(t,e,n,r){return Xt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"fill",precision:2}),tt(Xt),this},r.textColor||"0 g"),Zt=l.__private__.getTextColor=l.getTextColor=function(){return ht(Kt)},Qt=(l.__private__.setTextColor=l.setTextColor=function(t,e,n,r){return Kt=ut({ch1:t,ch2:e,ch3:n,ch4:r,pdfColorType:"text",precision:3}),this},r.charSpace||0),$t=l.__private__.getCharSpace=l.getCharSpace=function(){return Qt},te=(l.__private__.setCharSpace=l.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return Qt=t,this},0);l.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2};l.__private__.setLineCap=l.setLineCap=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((te=e)+" J"),this};var ee,ne=0;l.__private__.setLineJoin=l.setLineJoin=function(t){var e=l.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return tt((ne=e)+" j"),this},l.__private__.setMiterLimit=l.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setMiterLimit");return ee=parseFloat(Z(t*_)),tt(ee+" M"),this};for(var re in l.save=function(r,t){if(r=r||"generated.pdf",(t=t||{}).returnPromise=t.returnPromise||!1,!1!==t.returnPromise)return new Promise(function(t,e){try{var n=le(It(kt()),r);"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911),t(n)}catch(t){e(t.message)}});le(It(kt()),r),"function"==typeof le.unload&&ie.setTimeout&&setTimeout(le.unload,911)},ae.API)ae.API.hasOwnProperty(re)&&("events"===re&&ae.API.events.length?function(t,e){var n,r,i;for(i=e.length-1;-1!==i;i--)n=e[i][0],r=e[i][1],t.subscribe.apply(t,[n].concat("function"==typeof r?[r]:r))}(it,ae.API.events):l[re]=ae.API[re]);return l.internal={pdfEscape:vt,getStyle:qt,getFont:function(){return rt[Lt.apply(l,arguments)]},getFontSize:O,getCharSpace:$t,getTextColor:Zt,getLineHeight:Ut,getLineHeightFactor:Ht,write:j,getHorizontalCoordinate:Wt,getVerticalCoordinate:Vt,getCoordinateString:Gt,getVerticalCoordinateString:Yt,collections:{},newObject:J,newAdditionalObject:at,newObjectDeferred:X,newObjectDeferredBegin:ot,getFilters:ct,putStream:ft,events:it,scaleFactor:_,pageSize:{getWidth:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},setWidth:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},getHeight:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},setHeight:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY}},output:Ct,getNumberOfPages:Nt,pages:I,out:tt,f2:Z,f3:Q,getPageInfo:jt,getPageInfoByObjId:Et,getCurrentPageInfo:Mt,getPDFVersion:u,hasHotfix:Bt},Object.defineProperty(l.internal.pageSize,"width",{get:function(){return(V[x].mediaBox.topRightX-V[x].mediaBox.bottomLeftX)/_},set:function(t){V[x].mediaBox.topRightX=t*_+V[x].mediaBox.bottomLeftX},enumerable:!0,configurable:!0}),Object.defineProperty(l.internal.pageSize,"height",{get:function(){return(V[x].mediaBox.topRightY-V[x].mediaBox.bottomLeftY)/_},set:function(t){V[x].mediaBox.topRightY=t*_+V[x].mediaBox.bottomLeftY},enumerable:!0,configurable:!0}),function(t){for(var e=0,n=M.length;e<n;e++){var r=yt(t[e][0],t[e][1],t[e][2],M[e][3],!0);K[r]=!0;var i=t[e][0].split("-");mt(r,i[0],i[1]||"")}it.publish("addFonts",{fonts:rt,dictionary:H})}(M),$="F1",bt(i,t),it.publish("initialized"),l}return ae.API={events:[]},ae.version="1.5.3", true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return ae}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?(module.exports=ae,module.exports.jsPDF=ae):ie.jsPDF=ae,ae}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());
/**
   * @license
   * Copyright (c) 2016 Alexander Weidt,
   * https://github.com/BiggA94
   * 
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
(function(t,e){var A,n=1,S=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},y=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},_=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(2)},s=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return t.toFixed(5)};t.__acroform__={};var r=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},v=function(t){return t*n},w=function(t){return t/n},l=function(t){var e=new j,n=Y.internal.getHeight(t)||0,r=Y.internal.getWidth(t)||0;return e.BBox=[0,0,Number(_(r)),Number(_(n))],e},i=t.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},o=t.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},a=t.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},b=t.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return a(t,e-1)},x=t.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return i(t,e-1)},N=t.__acroform__.clearBitForPdf=function(t,e,n){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return o(t,e-1)},c=t.__acroform__.calculateCoordinates=function(t){var e=this.internal.getHorizontalCoordinate,n=this.internal.getVerticalCoordinate,r=t[0],i=t[1],o=t[2],a=t[3],s={};return s.lowerLeft_X=e(r)||0,s.lowerLeft_Y=n(i+a)||0,s.upperRight_X=e(r+o)||0,s.upperRight_Y=n(i)||0,[Number(_(s.lowerLeft_X)),Number(_(s.lowerLeft_Y)),Number(_(s.upperRight_X)),Number(_(s.upperRight_Y))]},f=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],n=t.V||t.DV,r=h(t,n),i=A.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(A.__private__.encodeColorString(t.color)),e.push("/"+i+" "+_(r.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(r.text),e.push("ET"),e.push("Q"),e.push("EMC");var o=new l(t);return o.stream=e.join("\n"),o}},h=function(i,t){var e=i.maxFontSize||12,n=(i.fontName,{text:"",fontSize:""}),o=(t=")"==(t="("==t.substr(0,1)?t.substr(1):t).substr(t.length-1)?t.substr(0,t.length-1):t).split(" "),r=(A.__private__.encodeColorString(i.color),e),a=Y.internal.getHeight(i)||0;a=a<0?-a:a;var s=Y.internal.getWidth(i)||0;s=s<0?-s:s;var l=function(t,e,n){if(t+1<o.length){var r=e+" "+o[t+1];return F(r,i,n).width<=s-4}return!1};r++;t:for(;;){t="";var h=F("3",i,--r).height,u=i.multiline?a-r:(a-h)/2,c=-2,f=u+=2,p=0,d=0,g=0;if(r<=0){t="(...) Tj\n",t+="% Width of Text: "+F(t,i,r=12).width+", FieldWidth:"+s+"\n";break}g=F(o[0]+" ",i,r).width;var m="",y=0;for(var v in o)if(o.hasOwnProperty(v)){m=" "==(m+=o[v]+" ").substr(m.length-1)?m.substr(0,m.length-1):m;var w=parseInt(v);g=F(m+" ",i,r).width;var b=l(w,m,r),x=v>=o.length-1;if(b&&!x){m+=" ";continue}if(b||x){if(x)d=w;else if(i.multiline&&a<(h+2)*(y+2)+2)continue t}else{if(!i.multiline)continue t;if(a<(h+2)*(y+2)+2)continue t;d=w}for(var N="",L=p;L<=d;L++)N+=o[L]+" ";switch(N=" "==N.substr(N.length-1)?N.substr(0,N.length-1):N,g=F(N,i,r).width,i.textAlign){case"right":c=s-g-2;break;case"center":c=(s-g)/2;break;case"left":default:c=2}t+=_(c)+" "+_(f)+" Td\n",t+="("+S(N)+") Tj\n",t+=-_(c)+" 0 Td\n",f=-(r+2),g=0,p=d+1,y++,m=""}else;break}return n.text=t,n.fontSize=r,n},F=function(t,e,n){var r=A.internal.getFont(e.fontName,e.fontStyle),i=A.getStringUnitWidth(t,{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n);return{height:A.getStringUnitWidth("3",{font:r,fontSize:parseFloat(n),charSpace:0})*parseFloat(n)*1.5,width:i}},u={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},p=function(){A.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var t=A.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var e in t)if(t.hasOwnProperty(e)){var n=t[e];n.objId=void 0,n.hasAnnotation&&d.call(A,n)}},d=function(t){var e={type:"reference",object:t};void 0===A.internal.getPageInfo(t.page).pageContext.annotations.find(function(t){return t.type===e.type&&t.object===e.object})&&A.internal.getPageInfo(t.page).pageContext.annotations.push(e)},g=function(){if(void 0===A.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");A.internal.write("/AcroForm "+A.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")},m=function(){A.internal.events.unsubscribe(A.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete A.internal.acroformPlugin.acroFormDictionaryRoot._eventID,A.internal.acroformPlugin.printedOut=!0},L=function(t){var e=!t;t||(A.internal.newObjectDeferredBegin(A.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),A.internal.acroformPlugin.acroFormDictionaryRoot.putStream());t=t||A.internal.acroformPlugin.acroFormDictionaryRoot.Kids;for(var n in t)if(t.hasOwnProperty(n)){var r=t[n],i=[],o=r.Rect;if(r.Rect&&(r.Rect=c.call(this,r.Rect)),A.internal.newObjectDeferredBegin(r.objId,!0),r.DA=Y.createDefaultAppearanceStream(r),"object"===se(r)&&"function"==typeof r.getKeyValueListForStream&&(i=r.getKeyValueListForStream()),r.Rect=o,r.hasAppearanceStream&&!r.appearanceStreamContent){var a=f.call(this,r);i.push({key:"AP",value:"<</N "+a+">>"}),A.internal.acroformPlugin.xForms.push(a)}if(r.appearanceStreamContent){var s="";for(var l in r.appearanceStreamContent)if(r.appearanceStreamContent.hasOwnProperty(l)){var h=r.appearanceStreamContent[l];if(s+="/"+l+" ",s+="<<",1<=Object.keys(h).length||Array.isArray(h))for(var n in h){var u;if(h.hasOwnProperty(n))"function"==typeof(u=h[n])&&(u=u.call(this,r)),s+="/"+n+" "+u+" ",0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u)}else"function"==typeof(u=h)&&(u=u.call(this,r)),s+="/"+n+" "+u,0<=A.internal.acroformPlugin.xForms.indexOf(u)||A.internal.acroformPlugin.xForms.push(u);s+=">>"}i.push({key:"AP",value:"<<\n"+s+">>"})}A.internal.putStream({additionalKeyValues:i}),A.internal.out("endobj")}e&&P.call(this,A.internal.acroformPlugin.xForms)},P=function(t){for(var e in t)if(t.hasOwnProperty(e)){var n=e,r=t[e];A.internal.newObjectDeferredBegin(r&&r.objId,!0),"object"===se(r)&&"function"==typeof r.putStream&&r.putStream(),delete t[n]}},k=function(){if(void 0!==this.internal&&(void 0===this.internal.acroformPlugin||!1===this.internal.acroformPlugin.isInitialized)){if(A=this,M.FieldNum=0,this.internal.acroformPlugin=JSON.parse(JSON.stringify(u)),this.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");n=A.internal.scaleFactor,A.internal.acroformPlugin.acroFormDictionaryRoot=new E,A.internal.acroformPlugin.acroFormDictionaryRoot._eventID=A.internal.events.subscribe("postPutResources",m),A.internal.events.subscribe("buildDocument",p),A.internal.events.subscribe("putCatalog",g),A.internal.events.subscribe("postPutPages",L),A.internal.acroformPlugin.isInitialized=!0}},I=t.__acroform__.arrayToPdfArray=function(t){if(Array.isArray(t)){for(var e="[",n=0;n<t.length;n++)switch(0!==n&&(e+=" "),se(t[n])){case"boolean":case"number":case"object":e+=t[n].toString();break;case"string":"/"!==t[n].substr(0,1)?e+="("+S(t[n].toString())+")":e+=t[n].toString()}return e+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var C=function(t){return(t=t||"").toString(),t="("+S(t)+")"},B=function(){var e;Object.defineProperty(this,"objId",{configurable:!0,get:function(){if(e||(e=A.internal.newObjectDeferred()),!e)throw new Error("AcroFormPDFObject: Couldn't create Object ID");return e},set:function(t){e=t}})};B.prototype.toString=function(){return this.objId+" 0 R"},B.prototype.putStream=function(){var t=this.getKeyValueListForStream();A.internal.putStream({data:this.stream,additionalKeyValues:t}),A.internal.out("endobj")},B.prototype.getKeyValueListForStream=function(){return function(t){var e=[],n=Object.getOwnPropertyNames(t).filter(function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"_"!=t.substring(0,1)});for(var r in n)if(!1===Object.getOwnPropertyDescriptor(t,n[r]).configurable){var i=n[r],o=t[i];o&&(Array.isArray(o)?e.push({key:i,value:I(o)}):o instanceof B?e.push({key:i,value:o.objId+" 0 R"}):"function"!=typeof o&&e.push({key:i,value:o}))}return e}(this)};var j=function(){B.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writeable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writeable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writeable:!0});var e,n=[];Object.defineProperty(this,"BBox",{configurable:!1,writeable:!0,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writeable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(t){e=t.trim()},get:function(){return e||null}})};r(j,B);var E=function(){B.call(this);var e,t=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return 0<t.length?t:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return t}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(e)return"("+e+")"},set:function(t){e=t}})};r(E,B);var M=function t(){B.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(e,3))},set:function(t){!0===Boolean(t)?this.F=x(e,3):this.F=N(e,3)}});var n=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');n=t}});var r=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==r.length)return r},set:function(t){r=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[0])?0:w(r[0])},set:function(t){r[0]=v(t)}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[1])?0:w(r[1])},set:function(t){r[1]=v(t)}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[2])?0:w(r[2])},set:function(t){r[2]=v(t)}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!r||isNaN(r[3])?0:w(r[3])},set:function(t){r[3]=v(t)}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var o=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!o||o.length<1){if(this instanceof H)return;o="FieldObject"+t.FieldNum++}return"("+S(o)+")"},set:function(t){o=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return o},set:function(t){o=t}});var a="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return a},set:function(t){a=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var l=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return w(l)},set:function(t){l=v(t)}});var h=50;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return w(h)},set:function(t){h=v(t)}});var u="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return u},set:function(t){u=t}});var c="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!c||this instanceof H||this instanceof V))return C(c)},set:function(t){t=t.toString(),c=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof D==!1?C(f):f},set:function(t){t=t.toString(),f=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof D==!0?"/"+t:t}});var p=null;Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(p)return this instanceof D==!1?C(p):p},set:function(t){t=t.toString(),p=this instanceof D==!1?"("===t.substr(0,1)?y(t.substr(1,t.length-2)):y(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof D==!0?y(p.substr(1,p.length-1)):p},set:function(t){t=t.toString(),p=this instanceof D==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var d,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,writeable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,writeable:!0,get:function(){if(d)return d},set:function(t){d=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,1):this.Ff=N(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,2):this.Ff=N(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,3):this.Ff=N(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t="left";switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};r(M,B);var O=function(){M.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var e=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){e=t}});var r=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return I(r)},set:function(t){var e,n;n=[],"string"==typeof(e=t)&&(n=function(t,e,n){n||(n=1);for(var r,i=[];r=e.exec(t);)i.push(r[n]);return i}(e,/\((.*?)\)/g)),r=n}}),this.getOptions=function(){return r},this.setOptions=function(t){r=t,this.sort&&r.sort()},this.addOption=function(t){t=(t=t||"").toString(),r.push(t),this.sort&&r.sort()},this.removeOption=function(t,e){for(e=e||!1,t=(t=t||"").toString();-1!==r.indexOf(t)&&(r.splice(r.indexOf(t),1),!1!==e););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,18):this.Ff=N(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=x(this.Ff,19):this.Ff=N(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=x(this.Ff,20),r.sort()):this.Ff=N(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,22):this.Ff=N(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,27):this.Ff=N(this.Ff,27)}}),this.hasAppearanceStream=!1};r(O,M);var q=function(){O.call(this),this.fontName="helvetica",this.combo=!1};r(q,O);var T=function(){q.call(this),this.combo=!0};r(T,q);var R=function(){T.call(this),this.edit=!0};r(R,T);var D=function(){M.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,15):this.Ff=N(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,16):this.Ff=N(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,17):this.Ff=N(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e,n={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){if(0!==Object.keys(n).length){var t,e=[];for(t in e.push("<<"),n)e.push("/"+t+" ("+n[t]+")");return e.push(">>"),e.join("\n")}},set:function(t){"object"===se(t)&&(n=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return n.CA||""},set:function(t){"string"==typeof t&&(n.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return e.substr(1,e.length-1)},set:function(t){e="/"+t}})};r(D,M);var U=function(){D.call(this),this.pushButton=!0};r(U,D);var z=function(){D.call(this),this.radio=!0,this.pushButton=!1;var e=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=void 0!==t?t:[]}})};r(z,D);var H=function(){var e,n;M.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return n},set:function(t){n=t}});var r,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t,e=[];for(t in e.push("<<"),i)e.push("/"+t+" ("+i[t]+")");return e.push(">>"),e.join("\n")},set:function(t){"object"===se(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){r=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return r.substr(1,r.length-1)},set:function(t){r="/"+t}}),this.optionName=name,this.caption="l",this.appearanceState="Off",this._AppearanceType=Y.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(name)};r(H,M),z.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t&&"getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var n=this.Kids[e];n.appearanceStreamContent=t.createAppearanceStream(n.optionName),n.caption=t.getCA()}},z.prototype.createOption=function(t){this.Kids.length;var e=new H;return e.Parent=this,e.optionName=t,this.Kids.push(e),J.call(this,e),e};var W=function(){D.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Y.CheckBox.createAppearanceStream()};r(W,D);var V=function(){M.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,13):this.Ff=N(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,21):this.Ff=N(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,23):this.Ff=N(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,24):this.Ff=N(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,25):this.Ff=N(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,26):this.Ff=N(this.Ff,26)}});var e=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return e},set:function(t){Number.isInteger(t)&&(e=t)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};r(V,M);var G=function(){V.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(b(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=x(this.Ff,14):this.Ff=N(this.Ff,14)}}),this.password=!0};r(G,V);var Y={CheckBox:{createAppearanceStream:function(){return{N:{On:Y.CheckBox.YesNormal},D:{On:Y.CheckBox.YesPushDown,Off:Y.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=l(t),n=[],r=A.internal.getFont(t.fontName,t.fontStyle).id,i=A.__private__.encodeColorString(t.color),o=h(t,t.caption);return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),n.push("BMC"),n.push("q"),n.push("0 0 1 rg"),n.push("/"+r+" "+_(o.fontSize)+" Tf "+i),n.push("BT"),n.push(o.text),n.push("ET"),n.push("Q"),n.push("EMC"),e.stream=n.join("\n"),e},YesNormal:function(t){var e=l(t),n=A.internal.getFont(t.fontName,t.fontStyle).id,r=A.__private__.encodeColorString(t.color),i=[],o=Y.internal.getHeight(t),a=Y.internal.getWidth(t),s=h(t,t.caption);return i.push("1 g"),i.push("0 0 "+_(a)+" "+_(o)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+_(a-1)+" "+_(o-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+n+" "+_(s.fontSize)+" Tf "+r),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Circle.YesNormal,e.D[t]=Y.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4;r=Number((.9*r).toFixed(5));var i=Y.internal.Bezier_C,o=Number((r*i).toFixed(5));return n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+o+" "+o+" "+r+" 0 "+r+" c"),n.push("-"+o+" "+r+" -"+r+" "+o+" -"+r+" 0 c"),n.push("-"+r+" -"+o+" -"+o+" -"+r+" 0 -"+r+" c"),n.push(o+" -"+r+" "+r+" -"+o+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5)),a=Number((r*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),n.push("0 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(r+" 0 m"),n.push(r+" "+a+" "+a+" "+r+" 0 "+r+" c"),n.push("-"+a+" "+r+" -"+r+" "+a+" -"+r+" 0 c"),n.push("-"+r+" -"+a+" -"+a+" -"+r+" 0 -"+r+" c"),n.push(a+" -"+r+" "+r+" -"+a+" "+r+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[],r=Y.internal.getWidth(t)<=Y.internal.getHeight(t)?Y.internal.getWidth(t)/4:Y.internal.getHeight(t)/4,i=(r=Number((.9*r).toFixed(5)),Number((2*r).toFixed(5))),o=Number((i*Y.internal.Bezier_C).toFixed(5));return n.push("0.749023 g"),n.push("q"),n.push("1 0 0 1 "+s(Y.internal.getWidth(t)/2)+" "+s(Y.internal.getHeight(t)/2)+" cm"),n.push(i+" 0 m"),n.push(i+" "+o+" "+o+" "+i+" 0 "+i+" c"),n.push("-"+o+" "+i+" -"+i+" "+o+" -"+i+" 0 c"),n.push("-"+i+" -"+o+" -"+o+" -"+i+" 0 -"+i+" c"),n.push(o+" -"+i+" "+i+" -"+o+" "+i+" 0 c"),n.push("f"),n.push("Q"),e.stream=n.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Y.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Y.RadioButton.Cross.YesNormal,e.D[t]=Y.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=l(t),n=[],r=Y.internal.calculateCross(t);return n.push("q"),n.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(_(r.x1.x)+" "+_(r.x1.y)+" m"),n.push(_(r.x2.x)+" "+_(r.x2.y)+" l"),n.push(_(r.x4.x)+" "+_(r.x4.y)+" m"),n.push(_(r.x3.x)+" "+_(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},YesPushDown:function(t){var e=l(t),n=Y.internal.calculateCross(t),r=[];return r.push("0.749023 g"),r.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),r.push("f"),r.push("q"),r.push("1 1 "+_(Y.internal.getWidth(t)-2)+" "+_(Y.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(_(n.x1.x)+" "+_(n.x1.y)+" m"),r.push(_(n.x2.x)+" "+_(n.x2.y)+" l"),r.push(_(n.x4.x)+" "+_(n.x4.y)+" m"),r.push(_(n.x3.x)+" "+_(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=l(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+_(Y.internal.getWidth(t))+" "+_(Y.internal.getHeight(t))+" re"),n.push("f"),e.stream=n.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=A.internal.getFont(t.fontName,t.fontStyle).id,n=A.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+n}};Y.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Y.internal.getWidth(t),n=Y.internal.getHeight(t),r=Math.min(e,n);return{x1:{x:(e-r)/2,y:(n-r)/2+r},x2:{x:(e-r)/2+r,y:(n-r)/2},x3:{x:(e-r)/2,y:(n-r)/2},x4:{x:(e-r)/2+r,y:(n-r)/2+r}}}},Y.internal.getWidth=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[2])),e},Y.internal.getHeight=function(t){var e=0;return"object"===se(t)&&(e=v(t.Rect[3])),e};var J=t.addField=function(t){if(k.call(this),!(t instanceof M))throw new Error("Invalid argument passed to jsPDF.addField.");return function(t){A.internal.acroformPlugin.printedOut&&(A.internal.acroformPlugin.printedOut=!1,A.internal.acroformPlugin.acroFormDictionaryRoot=null),A.internal.acroformPlugin.acroFormDictionaryRoot||k.call(A),A.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(t)}.call(this,t),t.page=A.internal.getCurrentPageInfo().pageNumber,this};t.addButton=function(t){if(t instanceof D==!1)throw new Error("Invalid argument passed to jsPDF.addButton.");return J.call(this,t)},t.addTextField=function(t){if(t instanceof V==!1)throw new Error("Invalid argument passed to jsPDF.addTextField.");return J.call(this,t)},t.addChoiceField=function(t){if(t instanceof O==!1)throw new Error("Invalid argument passed to jsPDF.addChoiceField.");return J.call(this,t)};"object"==se(e)&&void 0===e.ChoiceField&&void 0===e.ListBox&&void 0===e.ComboBox&&void 0===e.EditBox&&void 0===e.Button&&void 0===e.PushButton&&void 0===e.RadioButton&&void 0===e.CheckBox&&void 0===e.TextField&&void 0===e.PasswordField?(e.ChoiceField=O,e.ListBox=q,e.ComboBox=T,e.EditBox=R,e.Button=D,e.PushButton=U,e.RadioButton=z,e.CheckBox=W,e.TextField=V,e.PasswordField=G,e.AcroForm={Appearance:Y}):console.warn("AcroForm-Classes are not populated into global-namespace, because the class-Names exist already."),t.AcroFormChoiceField=O,t.AcroFormListBox=q,t.AcroFormComboBox=T,t.AcroFormEditBox=R,t.AcroFormButton=D,t.AcroFormPushButton=U,t.AcroFormRadioButton=z,t.AcroFormCheckBox=W,t.AcroFormTextField=V,t.AcroFormPasswordField=G,t.AcroFormAppearance=Y,t.AcroForm={ChoiceField:O,ListBox:q,ComboBox:T,EditBox:R,Button:D,PushButton:U,RadioButton:z,CheckBox:W,TextField:V,PasswordField:G,Appearance:Y}})((window.tmp=lt).API,"undefined"!=typeof window&&window||"undefined"!=typeof global&&global),
/** @license
   * jsPDF addImage plugin
   * Copyright (c) 2012 Jason Siefken, https://github.com/siefkenj/
   *               2013 Chris Dowling, https://github.com/gingerchris
   *               2013 Trinh Ho, https://github.com/ineedfat
   *               2013 Edwin Alejandro Perez, https://github.com/eaparango
   *               2013 Norah Smith, https://github.com/burnburnrocket
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   */
function(x){var N="addImage_",l={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},h=x.getImageFileTypeByImageData=function(t,e){var n,r;e=e||"UNKNOWN";var i,o,a,s="UNKNOWN";for(a in x.isArrayBufferView(t)&&(t=x.arrayBufferToBinaryString(t)),l)for(i=l[a],n=0;n<i.length;n+=1){for(o=!0,r=0;r<i[n].length;r+=1)if(void 0!==i[n][r]&&i[n][r]!==t.charCodeAt(r)){o=!1;break}if(!0===o){s=a;break}}return"UNKNOWN"===s&&"UNKNOWN"!==e&&(console.warn('FileType of Image not recognized. Processing image as "'+e+'".'),s=e),s},n=function t(e){for(var n=this.internal.newObject(),r=this.internal.write,i=this.internal.putStream,o=(0,this.internal.getFilters)();-1!==o.indexOf("FlateEncode");)o.splice(o.indexOf("FlateEncode"),1);e.n=n;var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.w}),a.push({key:"Height",value:e.h}),e.cs===this.color_spaces.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.pal.length/3-1)+" "+("smask"in e?n+2:n+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.cs}),e.cs===this.color_spaces.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bpc}),"dp"in e&&a.push({key:"DecodeParms",value:"<<"+e.dp+">>"}),"trns"in e&&e.trns.constructor==Array){for(var s="",l=0,h=e.trns.length;l<h;l++)s+=e.trns[l]+" "+e.trns[l]+" ";a.push({key:"Mask",value:"["+s+"]"})}"smask"in e&&a.push({key:"SMask",value:n+1+" 0 R"});var u=void 0!==e.f?["/"+e.f]:void 0;if(i({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u}),r("endobj"),"smask"in e){var c="/Predictor "+e.p+" /Colors 1 /BitsPerComponent "+e.bpc+" /Columns "+e.w,f={w:e.w,h:e.h,cs:"DeviceGray",bpc:e.bpc,dp:c,data:e.smask};"f"in e&&(f.f=e.f),t.call(this,f)}e.cs===this.color_spaces.INDEXED&&(this.internal.newObject(),i({data:this.arrayBufferToBinaryString(new Uint8Array(e.pal))}),r("endobj"))},L=function(){var t=this.internal.collections[N+"images"];for(var e in t)n.call(this,t[e])},A=function(){var t,e=this.internal.collections[N+"images"],n=this.internal.write;for(var r in e)n("/I"+(t=e[r]).i,t.n,"0","R")},S=function(t){return"function"==typeof x["process"+t.toUpperCase()]},_=function(t){return"object"===se(t)&&1===t.nodeType},F=function(t,e){if("IMG"===t.nodeName&&t.hasAttribute("src")){var n=""+t.getAttribute("src");if(0===n.indexOf("data:image/"))return unescape(n);var r=x.loadFile(n);if(void 0!==r)return btoa(r)}if("CANVAS"===t.nodeName){var i=t;return t.toDataURL("image/jpeg",1)}(i=document.createElement("canvas")).width=t.clientWidth||t.width,i.height=t.clientHeight||t.height;var o=i.getContext("2d");if(!o)throw"addImage requires canvas to be supported by browser.";return o.drawImage(t,0,0,i.width,i.height),i.toDataURL("png"==(""+e).toLowerCase()?"image/png":"image/jpeg")},P=function(t,e){var n;if(e)for(var r in e)if(t===e[r].alias){n=e[r];break}return n};x.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"},x.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"},x.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},x.sHashCode=function(t){var e,n=0;if(0===(t=t||"").length)return n;for(e=0;e<t.length;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;return n},x.isString=function(t){return"string"==typeof t},x.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+\/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9\/][A-Za-z0-9+\/]|[A-Za-z0-9+\/]=|==$/.test(t.substr(-2))&&(e=!1),e},x.extractInfoFromBase64DataURI=function(t){return/^data:([\w]+?\/([\w]+?));\S*;*base64,(.+)$/g.exec(t)},x.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),n=null;if(2===e.length){var r=/^data:(\w*\/\w*);*(charset=[\w=-]*)*;*$/.exec(e[0]);Array.isArray(r)&&(n={mimeType:r[1],charset:r[2],data:e[1]})}return n},x.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array},x.isArrayBuffer=function(t){return!!this.supportsArrayBuffer()&&t instanceof ArrayBuffer},x.isArrayBufferView=function(t){return!!this.supportsArrayBuffer()&&("undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array))},x.binaryStringToUint8Array=function(t){for(var e=t.length,n=new Uint8Array(e),r=0;r<e;r++)n[r]=t.charCodeAt(r);return n},x.arrayBufferToBinaryString=function(t){if("function"==typeof atob)return atob(this.arrayBufferToBase64(t))},x.arrayBufferToBase64=function(t){for(var e,n="",r="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",i=new Uint8Array(t),o=i.byteLength,a=o%3,s=o-a,l=0;l<s;l+=3)n+=r[(16515072&(e=i[l]<<16|i[l+1]<<8|i[l+2]))>>18]+r[(258048&e)>>12]+r[(4032&e)>>6]+r[63&e];return 1==a?n+=r[(252&(e=i[s]))>>2]+r[(3&e)<<4]+"==":2==a&&(n+=r[(64512&(e=i[s]<<8|i[s+1]))>>10]+r[(1008&e)>>4]+r[(15&e)<<2]+"="),n},x.createImageInfo=function(t,e,n,r,i,o,a,s,l,h,u,c,f){var p={alias:s,w:e,h:n,cs:r,bpc:i,i:a,data:t};return o&&(p.f=o),l&&(p.dp=l),h&&(p.trns=h),u&&(p.pal=u),c&&(p.smask=c),f&&(p.p=f),p},x.addImage=function(t,e,n,r,i,o,a,s,l){var h="";if("string"!=typeof e){var u=o;o=i,i=r,r=n,n=e,e=u}if("object"===se(t)&&!_(t)&&"imageData"in t){var c=t;t=c.imageData,e=c.format||e||"UNKNOWN",n=c.x||n||0,r=c.y||r||0,i=c.w||i,o=c.h||o,a=c.alias||a,s=c.compression||s,l=c.rotation||c.angle||l}var f=this.internal.getFilters();if(void 0===s&&-1!==f.indexOf("FlateEncode")&&(s="SLOW"),"string"==typeof t&&(t=unescape(t)),isNaN(n)||isNaN(r))throw console.error("jsPDF.addImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addImage");var p,d,g,m,y,v,w,b=function(){var t=this.internal.collections[N+"images"];return t||(this.internal.collections[N+"images"]=t={},this.internal.events.subscribe("putResources",L),this.internal.events.subscribe("putXobjectDict",A)),t}.call(this);if(!((p=P(t,b))||(_(t)&&(t=F(t,e)),(null==(w=a)||0===w.length)&&(a="string"==typeof(v=t)?x.sHashCode(v):x.isArrayBufferView(v)?x.sHashCode(x.arrayBufferToBinaryString(v)):null),p=P(a,b)))){if(this.isString(t)&&(""!==(h=this.convertStringToImageData(t))?t=h:void 0!==(h=x.loadFile(t))&&(t=h)),e=this.getImageFileTypeByImageData(t,e),!S(e))throw new Error("addImage does not support files of type '"+e+"', please ensure that a plugin for '"+e+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(d=t,t=this.binaryStringToUint8Array(t))),!(p=this["process"+e.toUpperCase()](t,(y=0,(m=b)&&(y=Object.keys?Object.keys(m).length:function(t){var e=0;for(var n in t)t.hasOwnProperty(n)&&e++;return e}(m)),y),a,((g=s)&&"string"==typeof g&&(g=g.toUpperCase()),g in x.image_compression?g:x.image_compression.NONE),d)))throw new Error("An unknown error occurred whilst processing the image")}return function(t,e,n,r,i,o,a,s){var l=function(t,e,n){return t||e||(e=t=-96),t<0&&(t=-1*n.w*72/t/this.internal.scaleFactor),e<0&&(e=-1*n.h*72/e/this.internal.scaleFactor),0===t&&(t=e*n.w/n.h),0===e&&(e=t*n.h/n.w),[t,e]}.call(this,n,r,i),h=this.internal.getCoordinateString,u=this.internal.getVerticalCoordinateString;if(n=l[0],r=l[1],a[o]=i,s){s*=Math.PI/180;var c=Math.cos(s),f=Math.sin(s),p=function(t){return t.toFixed(4)},d=[p(c),p(f),p(-1*f),p(c),0,0,"cm"]}this.internal.write("q"),s?(this.internal.write([1,"0","0",1,h(t),u(e+r),"cm"].join(" ")),this.internal.write(d.join(" ")),this.internal.write([h(n),"0","0",h(r),"0","0","cm"].join(" "))):this.internal.write([h(n),"0","0",h(r),h(t),u(e+r),"cm"].join(" ")),this.internal.write("/I"+i.i+" Do"),this.internal.write("Q")}.call(this,n,r,i,o,p,p.i,b,l),this},x.convertStringToImageData=function(t){var e,n="";if(this.isString(t)){var r;e=null!==(r=this.extractImageFromDataUrl(t))?r.data:t;try{n=atob(e)}catch(t){throw x.validateStringAsBase64(e)?new Error("atob-Error in jsPDF.convertStringToImageData "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertStringToImageData ")}}return n};var u=function(t,e){return t.subarray(e,e+5)};x.processJPEG=function(t,e,n,r,i,o){var a,s=this.decode.DCT_DECODE;if(!this.isString(t)&&!this.isArrayBuffer(t)&&!this.isArrayBufferView(t))return null;if(this.isString(t)&&(a=function(t){var e;if("JPEG"!==h(t))throw new Error("getJpegSize requires a binary string jpeg file");for(var n=256*t.charCodeAt(4)+t.charCodeAt(5),r=4,i=t.length;r<i;){if(r+=n,255!==t.charCodeAt(r))throw new Error("getJpegSize could not find the size of the image");if(192===t.charCodeAt(r+1)||193===t.charCodeAt(r+1)||194===t.charCodeAt(r+1)||195===t.charCodeAt(r+1)||196===t.charCodeAt(r+1)||197===t.charCodeAt(r+1)||198===t.charCodeAt(r+1)||199===t.charCodeAt(r+1))return e=256*t.charCodeAt(r+5)+t.charCodeAt(r+6),[256*t.charCodeAt(r+7)+t.charCodeAt(r+8),e,t.charCodeAt(r+9)];r+=2,n=256*t.charCodeAt(r)+t.charCodeAt(r+1)}}(t)),this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)&&(a=function(t){if(65496!=(t[0]<<8|t[1]))throw new Error("Supplied data is not a JPEG");for(var e,n=t.length,r=(t[4]<<8)+t[5],i=4;i<n;){if(r=((e=u(t,i+=r))[2]<<8)+e[3],(192===e[1]||194===e[1])&&255===e[0]&&7<r)return{width:((e=u(t,i+5))[2]<<8)+e[3],height:(e[0]<<8)+e[1],numcomponents:e[4]};i+=2}throw new Error("getJpegSizeFromBytes could not find the size of the image")}(t),t=i||this.arrayBufferToBinaryString(t)),void 0===o)switch(a.numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;default:case 3:o=this.color_spaces.DEVICE_RGB}return this.createImageInfo(t,a.width,a.height,o,8,s,e,n)},x.processJPG=function(){return this.processJPEG.apply(this,arguments)},x.getImageProperties=function(t){var e,n,r="";if(_(t)&&(t=F(t)),this.isString(t)&&(""!==(r=this.convertStringToImageData(t))?t=r:void 0!==(r=x.loadFile(t))&&(t=r)),n=this.getImageFileTypeByImageData(t),!S(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if(this.supportsArrayBuffer()&&(t instanceof Uint8Array||(t=this.binaryStringToUint8Array(t))),!(e=this["process"+n.toUpperCase()](t)))throw new Error("An unknown error occurred whilst processing the image");return{fileType:n,width:e.w,height:e.h,colorSpace:e.cs,compressionMode:e.f,bitsPerComponent:e.bpc}}}(lt.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
t=lt.API,lt.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var e=this.internal.getPageInfoByObjId(t.objId),n=t.pageContext.annotations,r=function(t){if(void 0!==t&&""!=t)return!0},i=!1,o=0;o<n.length&&!i;o++)switch((l=n[o]).type){case"link":if(r(l.options.url)||r(l.options.pageNumber)){i=!0;break}case"reference":case"text":case"freetext":i=!0}if(0!=i){this.internal.write("/Annots ["),this.internal.pageSize.height;var a=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;for(o=0;o<n.length;o++){var l;switch((l=n[o]).type){case"reference":this.internal.write(" "+l.object.objId+" 0 R ");break;case"text":var h=this.internal.newAdditionalObject(),u=this.internal.newAdditionalObject(),c=l.title||"Note";m="<</Type /Annot /Subtype /Text "+(p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y)+"] ")+"/Contents ("+l.contents+")",m+=" /Popup "+u.objId+" 0 R",m+=" /P "+e.objId+" 0 R",m+=" /T ("+c+") >>",h.content=m;var f=h.objId+" 0 R";m="<</Type /Annot /Subtype /Popup "+(p="/Rect ["+a(l.bounds.x+30)+" "+s(l.bounds.y+l.bounds.h)+" "+a(l.bounds.x+l.bounds.w+30)+" "+s(l.bounds.y)+"] ")+" /Parent "+f,l.open&&(m+=" /Open true"),m+=" >>",u.content=m,this.internal.write(h.objId,"0 R",u.objId,"0 R");break;case"freetext":var p="/Rect ["+a(l.bounds.x)+" "+s(l.bounds.y)+" "+a(l.bounds.x+l.bounds.w)+" "+s(l.bounds.y+l.bounds.h)+"] ",d=l.color||"#000000";m="<</Type /Annot /Subtype /FreeText "+p+"/Contents ("+l.contents+")",m+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+d+")",m+=" /Border [0 0 0]",m+=" >>",this.internal.write(m);break;case"link":if(l.options.name){var g=this.annotations._nameMap[l.options.name];l.options.pageNumber=g.page,l.options.top=g.y}else l.options.top||(l.options.top=0);p="/Rect ["+a(l.x)+" "+s(l.y)+" "+a(l.x+l.w)+" "+s(l.y+l.h)+"] ";var m="";if(l.options.url)m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /A <</S /URI /URI ("+l.options.url+") >>";else if(l.options.pageNumber)switch(m="<</Type /Annot /Subtype /Link "+p+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(l.options.pageNumber).objId+" 0 R",l.options.magFactor=l.options.magFactor||"XYZ",l.options.magFactor){case"Fit":m+=" /Fit]";break;case"FitH":m+=" /FitH "+l.options.top+"]";break;case"FitV":l.options.left=l.options.left||0,m+=" /FitV "+l.options.left+"]";break;case"XYZ":default:var y=s(l.options.top);l.options.left=l.options.left||0,void 0===l.options.zoom&&(l.options.zoom=0),m+=" /XYZ "+l.options.left+" "+y+" "+l.options.zoom+"]"}""!=m&&(m+=" >>",this.internal.write(m))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,n,r,i){this.internal.getCurrentPageInfo().pageContext.annotations.push({x:t,y:e,w:n,h:r,options:i,type:"link"})},t.textWithLink=function(t,e,n,r){var i=this.getTextWidth(t),o=this.internal.getLineHeight()/this.internal.scaleFactor;return this.text(t,e,n),n+=.2*o,this.link(e,n-o,i,o,r),i},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor},
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var h={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},a={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},e={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},n=[1570,1571,1573,1575];t.__arabicParser__={};var r=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==h[t.charCodeAt(0)]},u=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},i=t.__arabicParser__.isArabicEndLetter=function(t){return u(t)&&r(t)&&h[t.charCodeAt(0)].length<=2},o=t.__arabicParser__.isArabicAlfLetter=function(t){return u(t)&&0<=n.indexOf(t.charCodeAt(0))},s=(t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return u(t)&&r(t)&&1<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasFinalForm=function(t){return u(t)&&r(t)&&2<=h[t.charCodeAt(0)].length}),l=(t.__arabicParser__.arabicLetterHasInitialForm=function(t){return u(t)&&r(t)&&3<=h[t.charCodeAt(0)].length},t.__arabicParser__.arabicLetterHasMedialForm=function(t){return u(t)&&r(t)&&4==h[t.charCodeAt(0)].length}),c=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=a,r=0,i="",o=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(o++,"number"==typeof(n=n[t.charCodeAt(e)])&&(r=-1!==(r=f(t.charAt(e),t.charAt(e-o),t.charAt(e+1)))?r:0,i+=String.fromCharCode(n),n=a,o=0),e===t.length-1&&(n=a,i+=t.charAt(e-(o-1)),e-=o-1,o=0)):(n=a,i+=t.charAt(e-o),e-=o,o=0);return i},f=(t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==e[t.charCodeAt(0)]},t.__arabicParser__.getCorrectForm=function(t,e,n){return u(t)?!1===r(t)?-1:!s(t)||!u(e)&&!u(n)||!u(n)&&i(e)||i(t)&&!u(e)||i(t)&&o(e)||i(t)&&i(e)?0:l(t)&&u(e)&&!i(e)&&u(n)&&s(n)?3:i(t)||!u(n)?1:2:-1}),p=t.__arabicParser__.processArabic=t.processArabic=function(t){var e=0,n=0,r=0,i="",o="",a="",s=(t=t||"").split("\\s+"),l=[];for(e=0;e<s.length;e+=1){for(l.push(""),n=0;n<s[e].length;n+=1)i=s[e][n],o=s[e][n-1],a=s[e][n+1],u(i)?(r=f(i,o,a),l[e]+=-1!==r?String.fromCharCode(h[i.charCodeAt(0)][r]):i):l[e]+=i;l[e]=c(l[e])}return l.join(" ")};t.events.push(["preProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([p(e[i][0]),e[i][1],e[i][2]]):r.push([p(e[i])]);t.text=r}else t.text=p(e)}])}(lt.API),lt.API.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){this.internal.out("/OpenAction "+e+" 0 R")})}return this},
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
e=lt.API,(n=function(){var e=void 0;Object.defineProperty(this,"pdf",{get:function(){return e},set:function(t){e=t}});var n=150;Object.defineProperty(this,"width",{get:function(){return n},set:function(t){n=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=n+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var i=[];Object.defineProperty(this,"childNodes",{get:function(){return i},set:function(t){i=t}});var o={};Object.defineProperty(this,"style",{get:function(){return o},set:function(t){o=t}}),Object.defineProperty(this,"parentNode",{get:function(){return!1}})}).prototype.getContext=function(t,e){var n;if("2d"!==(t=t||"2d"))return null;for(n in e)this.pdf.context2d.hasOwnProperty(n)&&(this.pdf.context2d[n]=e[n]);return(this.pdf.context2d._canvas=this).pdf.context2d},n.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},e.events.push(["initialized",function(){this.canvas=new n,this.canvas.pdf=this}]),
/** 
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *               2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *               2013 Lee Driscoll, https://github.com/lsdriscoll
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 James Hall, james@parall.ax
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
_=lt.API,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,p=function(t,e,n,r,i){F={x:t,y:e,w:n,h:r,ln:i}},d=function(){return F},k={left:0,top:0,bottom:0},_.setHeaderFunction=function(t){l=t},_.getTextDimensions=function(t,e){var n=this.table_font_size||this.internal.getFontSize(),r=(this.internal.getFont().fontStyle,(e=e||{}).scaleFactor||this.internal.scaleFactor),i=0,o=0,a=0;if("string"==typeof t)0!=(i=this.getStringUnitWidth(t)*n)&&(o=1);else{if("[object Array]"!==Object.prototype.toString.call(t))throw new Error("getTextDimensions expects text-parameter to be of type String or an Array of Strings.");for(var s=0;s<t.length;s++)i<(a=this.getStringUnitWidth(t[s])*n)&&(i=a);0!==i&&(o=t.length)}return{w:i/=r,h:Math.max((o*n*this.getLineHeightFactor()-n*(this.getLineHeightFactor()-1))/r,0)}},_.cellAddPage=function(){var t=this.margins||k;this.addPage(),p(t.left,t.top,void 0,void 0),P+=1},_.cellInitialize=function(){F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1},_.cell=function(t,e,n,r,i,o,a){var s=d(),l=!1;if(void 0!==s.ln)if(s.ln===o)t=s.x+s.w,e=s.y;else{var h=this.margins||k;s.y+s.h+r+13>=this.internal.pageSize.getHeight()-h.bottom&&(this.cellAddPage(),l=!0,this.printHeaders&&this.tableHeaderRow&&this.printHeaderRow(o,!0)),e=d().y+d().h,l&&(e=23)}if(void 0!==i[0])if(this.printingHeaderRow?this.rect(t,e,n,r,"FD"):this.rect(t,e,n,r),"right"===a){i instanceof Array||(i=[i]);for(var u=0;u<i.length;u++){var c=i[u],f=this.getStringUnitWidth(c)*this.internal.getFontSize()/this.internal.scaleFactor;this.text(c,t+n-f-3,e+this.internal.getLineHeight()*(u+1))}}else this.text(i,t+3,e+this.internal.getLineHeight());return p(t,e,n,r,o),this},_.arrayMax=function(t,e){var n,r,i,o=t[0];for(n=0,r=t.length;n<r;n+=1)i=t[n],e?-1===e(o,i)&&(o=i):o<i&&(o=i);return o},_.table=function(t,e,n,r,i){if(!n)throw"No data for PDF table";var o,a,s,l,h,u,c,f,p,d,g=[],m=[],y={},v={},w=[],b=[],x=!1,N=!0,L=12,A=k;if(A.width=this.internal.pageSize.getWidth(),i&&(!0===i.autoSize&&(x=!0),!1===i.printHeaders&&(N=!1),i.fontSize&&(L=i.fontSize),i.css&&void 0!==i.css["font-size"]&&(L=16*i.css["font-size"]),i.margins&&(A=i.margins)),this.lnMod=0,F={x:void 0,y:void 0,w:void 0,h:void 0,ln:void 0},P=1,this.printHeaders=N,this.margins=A,this.setFontSize(L),this.table_font_size=L,null==r)g=Object.keys(n[0]);else if(r[0]&&"string"!=typeof r[0])for(a=0,s=r.length;a<s;a+=1)o=r[a],g.push(o.name),m.push(o.prompt),v[o.name]=o.width*(19.049976/25.4);else g=r;if(x)for(d=function(t){return t[o]},a=0,s=g.length;a<s;a+=1){for(y[o=g[a]]=n.map(d),w.push(this.getTextDimensions(m[a]||o,{scaleFactor:1}).w),c=0,l=(u=y[o]).length;c<l;c+=1)h=u[c],w.push(this.getTextDimensions(h,{scaleFactor:1}).w);v[o]=_.arrayMax(w),w=[]}if(N){var S=this.calculateLineHeight(g,v,m.length?m:g);for(a=0,s=g.length;a<s;a+=1)o=g[a],b.push([t,e,v[o],S,String(m.length?m[a]:o)]);this.setTableHeaderRow(b),this.printHeaderRow(1,!1)}for(a=0,s=n.length;a<s;a+=1)for(f=n[a],S=this.calculateLineHeight(g,v,f),c=0,p=g.length;c<p;c+=1)o=g[c],this.cell(t,e,v[o],S,f[o],a+2,o.align);return this.lastCellPos=F,this.table_x=t,this.table_y=e,this},_.calculateLineHeight=function(t,e,n){for(var r,i=0,o=0;o<t.length;o++){n[r=t[o]]=this.splitTextToSize(String(n[r]),e[r]-3);var a=this.internal.getLineHeight()*n[r].length+3;i<a&&(i=a)}return i},_.setTableHeaderRow=function(t){this.tableHeaderRow=t},_.printHeaderRow=function(t,e){if(!this.tableHeaderRow)throw"Property tableHeaderRow does not exist.";var n,r,i,o;if(this.printingHeaderRow=!0,void 0!==l){var a=l(this,P);p(a[0],a[1],a[2],a[3],-1)}this.setFontStyle("bold");var s=[];for(i=0,o=this.tableHeaderRow.length;i<o;i+=1)this.setFillColor(200,200,200),n=this.tableHeaderRow[i],e&&(this.margins.top=13,n[1]=this.margins&&this.margins.top||0,s.push(n)),r=[].concat(n),this.cell.apply(this,r.concat(t));0<s.length&&this.setTableHeaderRow(s),this.setFontStyle("normal"),this.printingHeaderRow=!1},
/**
   * jsPDF Context2D PlugIn Copyright (c) 2014 Steven Spungin (TwelveTone LLC) steven@twelvetone.tv
   *
   * Licensed under the MIT License. http://opensource.org/licenses/mit-license
   */
function(t,e){var l,i,o,h,u,c=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new M,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new j,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new j,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new n(this),l=this.internal.f2,this.internal.f3,i=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,h=this.internal.getHorizontalCoordinate,u=this.internal.getVerticalCoordinate}]);var n=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}}),Object.defineProperty(this,"pdf",{get:function(){return t}});var e=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return e},set:function(t){e=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var r=0;Object.defineProperty(this,"posX",{get:function(){return r},set:function(t){isNaN(t)||(r=t)}});var i=0;Object.defineProperty(this,"posY",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=Boolean(t)}});var a=0;Object.defineProperty(this,"lastBreak",{get:function(){return a},set:function(t){a=t}});var s=[];Object.defineProperty(this,"pageBreaks",{get:function(){return s},set:function(t){s=t}});var l=new c;Object.defineProperty(this,"ctx",{get:function(){return l},set:function(t){t instanceof c&&(l=t)}}),Object.defineProperty(this,"path",{get:function(){return l.path},set:function(t){l.path=t}});var h=[];Object.defineProperty(this,"ctxStack",{get:function(){return h},set:function(t){h=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=f(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=f(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var n=e[1],r=(e[2],e[3]),i=e[4],o=e[5],a=e[6];i="px"===o?Math.floor(parseFloat(i)):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)),this.pdf.setFontSize(i);var s="";("bold"===r||700<=parseInt(r,10)||"bold"===n)&&(s="bold"),"italic"===n&&(s+="italic"),0===s.length&&(s="normal");for(var l="",h=a.toLowerCase().replace(/"|'/g,"").split(/\s*,\s*/),u={arial:"Helvetica",verdana:"Helvetica",helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",courier:"Courier",times:"Times",cursive:"Times",fantasy:"Times",serif:"Times"},c=0;c<h.length;c++){if(void 0!==this.pdf.internal.getFont(h[c],s,{noFallback:!0,disableWarning:!0})){l=h[c];break}if("bolditalic"===s&&void 0!==this.pdf.internal.getFont(h[c],"bold",{noFallback:!0,disableWarning:!0}))l=h[c],s="bold";else if(void 0!==this.pdf.internal.getFont(h[c],"normal",{noFallback:!0,disableWarning:!0})){l=h[c],s="normal";break}}if(""===l)for(c=0;c<h.length;c++)if(u[h[c]]){l=u[h[c]];break}l=""===l?"Times":l,this.pdf.setFont(l,s)}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};n.prototype.fill=function(){r.call(this,"fill",!1)},n.prototype.stroke=function(){r.call(this,"stroke",!1)},n.prototype.beginPath=function(){this.path=[{type:"begin"}]},n.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"mt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(t,e)},n.prototype.closePath=function(){var t=new j(0,0),e=0;for(e=this.path.length-1;-1!==e;e--)if("begin"===this.path[e].type&&"object"===se(this.path[e+1])&&"number"==typeof this.path[e+1].x){t=new j(this.path[e+1].x,this.path[e+1].y),this.path.push({type:"lt",x:t.x,y:t.y});break}"object"===se(this.path[e+2])&&"number"==typeof this.path[e+2].x&&this.path.push(JSON.parse(JSON.stringify(this.path[e+2]))),this.path.push({type:"close"}),this.ctx.lastPoint=new j(t.x,t.y)},n.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var n=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"lt",x:n.x,y:n.y}),this.ctx.lastPoint=new j(n.x,n.y)},n.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),r.call(this,null,!0)},n.prototype.quadraticCurveTo=function(t,e,n,r){if(isNaN(n)||isNaN(r)||isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var i=this.ctx.transform.applyToPoint(new j(n,r)),o=this.ctx.transform.applyToPoint(new j(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:i.x,y:i.y}),this.ctx.lastPoint=new j(i.x,i.y)},n.prototype.bezierCurveTo=function(t,e,n,r,i,o){if(isNaN(i)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var a=this.ctx.transform.applyToPoint(new j(i,o)),s=this.ctx.transform.applyToPoint(new j(t,e)),l=this.ctx.transform.applyToPoint(new j(n,r));this.path.push({type:"bct",x1:s.x,y1:s.y,x2:l.x,y2:l.y,x:a.x,y:a.y}),this.ctx.lastPoint=new j(a.x,a.y)},n.prototype.arc=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i))throw console.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var a=this.ctx.transform.applyToPoint(new j(t,e));t=a.x,e=a.y;var s=this.ctx.transform.applyToPoint(new j(0,n)),l=this.ctx.transform.applyToPoint(new j(0,0));n=Math.sqrt(Math.pow(s.x-l.x,2)+Math.pow(s.y-l.y,2))}Math.abs(i-r)>=2*Math.PI&&(r=0,i=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:n,startAngle:r,endAngle:i,counterclockwise:o})},n.prototype.arcTo=function(t,e,n,r,i){throw new Error("arcTo not implemented.")},n.prototype.rect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+n,e),this.lineTo(t+n,e+r),this.lineTo(t,e+r),this.lineTo(t,e),this.lineTo(t+n,e),this.lineTo(t,e)},n.prototype.fillRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!N.call(this)){var i={};"butt"!==this.lineCap&&(i.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(i.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,n,r),this.fill(),i.hasOwnProperty("lineCap")&&(this.lineCap=i.lineCap),i.hasOwnProperty("lineJoin")&&(this.lineJoin=i.lineJoin)}},n.prototype.strokeRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");L.call(this)||(this.beginPath(),this.rect(t,e,n,r),this.stroke())},n.prototype.clearRect=function(t,e,n,r){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r))throw console.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,n,r))},n.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var r=new c(this.ctx);this.ctxStack.push(this.ctx),this.ctx=r}},n.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,n=0;n<this.pdf.internal.getNumberOfPages();n++)this.pdf.setPage(n+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin)},n.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var f=function(t){var e,n,r,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))i=r=n=e=0;else{var o=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==o)e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=1;else if(null!==(o=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d\.]+)\s*\)/.exec(t)))e=parseInt(o[1]),n=parseInt(o[2]),r=parseInt(o[3]),i=parseFloat(o[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var a=new RGBColor(t);t=a.ok?a.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,n=t.substring(2,3),n+=n,r=t.substring(3,4),r+=r):(e=t.substring(1,3),n=t.substring(3,5),r=t.substring(5,7)),e=parseInt(e,16),n=parseInt(n,16),r=parseInt(r,16)}}return{r:e,g:n,b:r,a:i,style:t}},N=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},L=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};n.prototype.fillText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(r=isNaN(r)?void 0:r,!N.call(this)){n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.strokeText=function(t,e,n,r){if(isNaN(e)||isNaN(n)||"string"!=typeof t)throw console.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!L.call(this)){r=isNaN(r)?void 0:r,n=a.call(this,n);var i=B(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;s.call(this,{text:t,x:e,y:n,scale:o,renderingMode:"stroke",angle:i,align:this.textAlign,maxWidth:r})}},n.prototype.measureText=function(t){if("string"!=typeof t)throw console.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,n=this.pdf.internal.scaleFactor,r=e.internal.getFontSize(),i=e.getStringUnitWidth(t)*r/e.internal.scaleFactor;return new function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this}({width:i*=Math.round(96*n/72*1e4)/1e4})},n.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var n=new M(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.rotate=function(t){if(isNaN(t))throw console.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new M(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},n.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw console.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var n=new M(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(n)},n.prototype.transform=function(t,e,n,r,i,o){if(isNaN(t)||isNaN(e)||isNaN(n)||isNaN(r)||isNaN(i)||isNaN(o))throw console.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var a=new M(t,e,n,r,i,o);this.ctx.transform=this.ctx.transform.multiply(a)},n.prototype.setTransform=function(t,e,n,r,i,o){t=isNaN(t)?1:t,e=isNaN(e)?0:e,n=isNaN(n)?0:n,r=isNaN(r)?1:r,i=isNaN(i)?0:i,o=isNaN(o)?0:o,this.ctx.transform=new M(t,e,n,r,i,o)},n.prototype.drawImage=function(t,e,n,r,i,o,a,s,l){var h=this.pdf.getImageProperties(t),u=1,c=1,f=1,p=1;void 0!==r&&void 0!==s&&(f=s/r,p=l/i,u=h.width/r*s/r,c=h.height/i*l/i),void 0===o&&(o=e,a=n,n=e=0),void 0!==r&&void 0===s&&(s=r,l=i),void 0===r&&void 0===s&&(s=h.width,l=h.height);var d=this.ctx.transform.decompose(),g=B(d.rotate.shx);d.scale.sx,d.scale.sy;for(var m,y=new M,v=((y=(y=(y=y.multiply(d.translate)).multiply(d.skew)).multiply(d.scale)).applyToPoint(new j(s,l)),y.applyToRectangle(new E(o-e*f,a-n*p,r*u,i*c))),w=F.call(this,v),b=[],x=0;x<w.length;x+=1)-1===b.indexOf(w[x])&&b.push(w[x]);if(b.sort(),this.autoPaging)for(var N=b[0],L=b[b.length-1],A=N;A<L+1;A++){if(this.pdf.setPage(A),0!==this.ctx.clip_path.length){var S=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(m,this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY),k.call(this,"fill",!0),this.path=S}var _=JSON.parse(JSON.stringify(v));_=P([_],this.posX,-1*this.pdf.internal.pageSize.height*(A-1)+this.posY)[0],this.pdf.addImage(t,"jpg",_.x,_.y,_.w,_.h,null,null,g)}else this.pdf.addImage(t,"jpg",v.x,v.y,v.w,v.h,null,null,g)};var F=function(t,e,n){var r=[];switch(e=e||this.pdf.internal.pageSize.width,n=n||this.pdf.internal.pageSize.height,t.type){default:case"mt":case"lt":r.push(Math.floor((t.y+this.posY)/n)+1);break;case"arc":r.push(Math.floor((t.y+this.posY-t.radius)/n)+1),r.push(Math.floor((t.y+this.posY+t.radius)/n)+1);break;case"qct":var i=w(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);r.push(Math.floor(i.y/n)+1),r.push(Math.floor((i.y+i.h)/n)+1);break;case"bct":var o=b(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);r.push(Math.floor(o.y/n)+1),r.push(Math.floor((o.y+o.h)/n)+1);break;case"rect":r.push(Math.floor((t.y+this.posY)/n)+1),r.push(Math.floor((t.y+t.h+this.posY)/n)+1)}for(var a=0;a<r.length;a+=1)for(;this.pdf.internal.getNumberOfPages()<r[a];)v.call(this);return r},v=function(){var t=this.fillStyle,e=this.strokeStyle,n=this.font,r=this.lineCap,i=this.lineWidth,o=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=n,this.lineCap=r,this.lineWidth=i,this.lineJoin=o},P=function(t,e,n){for(var r=0;r<t.length;r++)switch(t[r].type){case"bct":t[r].x2+=e,t[r].y2+=n;case"qct":t[r].x1+=e,t[r].y1+=n;case"mt":case"lt":case"arc":default:t[r].x+=e,t[r].y+=n}return t},r=function(t,e){for(var n,r,i=this.fillStyle,o=this.strokeStyle,a=(this.font,this.lineCap),s=this.lineWidth,l=this.lineJoin,h=JSON.parse(JSON.stringify(this.path)),u=JSON.parse(JSON.stringify(this.path)),c=[],f=0;f<u.length;f++)if(void 0!==u[f].x)for(var p=F.call(this,u[f]),d=0;d<p.length;d+=1)-1===c.indexOf(p[d])&&c.push(p[d]);for(f=0;f<c.length;f++)for(;this.pdf.internal.getNumberOfPages()<c[f];)v.call(this);if(c.sort(),this.autoPaging){var g=c[0],m=c[c.length-1];for(f=g;f<m+1;f++){if(this.pdf.setPage(f),this.fillStyle=i,this.strokeStyle=o,this.lineCap=a,this.lineWidth=s,this.lineJoin=l,0!==this.ctx.clip_path.length){var y=this.path;n=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(n,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),k.call(this,t,!0),this.path=y}r=JSON.parse(JSON.stringify(h)),this.path=P(r,this.posX,-1*this.pdf.internal.pageSize.height*(f-1)+this.posY),!1!==e&&0!==f||k.call(this,t,e)}}else k.call(this,t,e);this.path=h},k=function(t,e){if(("stroke"!==t||e||!L.call(this))&&("stroke"===t||e||!N.call(this))){var n=[];this.ctx.globalAlpha;this.ctx.fillOpacity<1&&this.ctx.fillOpacity;for(var r,i=this.path,o=0;o<i.length;o++){var a=i[o];switch(a.type){case"begin":n.push({begin:!0});break;case"close":n.push({close:!0});break;case"mt":n.push({start:a,deltas:[],abs:[]});break;case"lt":var s=n.length;if(!isNaN(i[o-1].x)){var l=[a.x-i[o-1].x,a.y-i[o-1].y];if(0<s)for(;0<=s;s--)if(!0!==n[s-1].close&&!0!==n[s-1].begin){n[s-1].deltas.push(l),n[s-1].abs.push(a);break}}break;case"bct":l=[a.x1-i[o-1].x,a.y1-i[o-1].y,a.x2-i[o-1].x,a.y2-i[o-1].y,a.x-i[o-1].x,a.y-i[o-1].y];n[n.length-1].deltas.push(l);break;case"qct":var h=i[o-1].x+2/3*(a.x1-i[o-1].x),u=i[o-1].y+2/3*(a.y1-i[o-1].y),c=a.x+2/3*(a.x1-a.x),f=a.y+2/3*(a.y1-a.y),p=a.x,d=a.y;l=[h-i[o-1].x,u-i[o-1].y,c-i[o-1].x,f-i[o-1].y,p-i[o-1].x,d-i[o-1].y];n[n.length-1].deltas.push(l);break;case"arc":n.push({deltas:[],abs:[],arc:!0}),Array.isArray(n[n.length-1].abs)&&n[n.length-1].abs.push(a)}}r=e?null:"stroke"===t?"stroke":"fill";for(o=0;o<n.length;o++){if(n[o].arc)for(var g=n[o].abs,m=0;m<g.length;m++){var y=g[m];if(void 0!==y.startAngle){var v=B(y.startAngle),w=B(y.endAngle),b=y.x,x=y.y;A.call(this,b,x,y.radius,v,w,y.counterclockwise,r,e)}else I.call(this,y.x,y.y)}if(!n[o].arc&&!0!==n[o].close&&!0!==n[o].begin){b=n[o].start.x,x=n[o].start.y;C.call(this,n[o].deltas,b,x,null,null)}}r&&S.call(this,r),e&&_.call(this)}},a=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,n=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-n;case"top":return t+e-n;case"hanging":return t+e-2*n;case"middle":return t+e/2-n;case"ideographic":return t;case"alphabetic":default:return t}};n.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},n.prototype.createPattern=function(){return this.createLinearGradient()},n.prototype.createRadialGradient=function(){return this.createLinearGradient()};var A=function(t,e,n,r,i,o,a,s){this.pdf.internal.scaleFactor;for(var l=y(r),h=y(i),u=g.call(this,n,l,h,o),c=0;c<u.length;c++){var f=u[c];0===c&&p.call(this,f.x1+t,f.y1+e),d.call(this,t,e,f.x2,f.y2,f.x3,f.y3,f.x4,f.y4)}s?_.call(this):S.call(this,a)},S=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},_=function(){this.pdf.clip()},p=function(t,e){this.pdf.internal.out(i(t)+" "+o(e)+" m")},s=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var n=this.ctx.transform.applyToPoint(new j(t.x,t.y)),r=this.ctx.transform.decompose(),i=new M;i=(i=(i=i.multiply(r.translate)).multiply(r.skew)).multiply(r.scale);for(var o,a=this.pdf.getTextDimensions(t.text),s=this.ctx.transform.applyToRectangle(new E(t.x,t.y,a.w,a.h)),l=i.applyToRectangle(new E(t.x,t.y-a.h,a.w,a.h)),h=F.call(this,l),u=[],c=0;c<h.length;c+=1)-1===u.indexOf(h[c])&&u.push(h[c]);if(u.sort(),!0===this.autoPaging)for(var f=u[0],p=u[u.length-1],d=f;d<p+1;d++){if(this.pdf.setPage(d),0!==this.ctx.clip_path.length){var g=this.path;o=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=P(o,this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY),k.call(this,"fill",!0),this.path=g}var m=JSON.parse(JSON.stringify(s));if(m=P([m],this.posX,-1*this.pdf.internal.pageSize.height*(d-1)+this.posY)[0],.01<=t.scale){var y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,m.x,m.y,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}else{if(.01<=t.scale){y=this.pdf.internal.getFontSize();this.pdf.setFontSize(y*t.scale)}this.pdf.text(t.text,n.x+this.posX,n.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),.01<=t.scale&&this.pdf.setFontSize(y)}},I=function(t,e,n,r){n=n||0,r=r||0,this.pdf.internal.out(i(t+n)+" "+o(e+r)+" l")},C=function(t,e,n){return this.pdf.lines(t,e,n,null,null)},d=function(t,e,n,r,i,o,a,s){this.pdf.internal.out([l(h(n+t)),l(u(r+e)),l(h(i+t)),l(u(o+e)),l(h(a+t)),l(u(s+e)),"c"].join(" "))},g=function(t,e,n,r){var i=2*Math.PI,o=e;(o<i||i<o)&&(o%=i);var a=n;(a<i||i<a)&&(a%=i);for(var s=[],l=Math.PI/2,h=r?-1:1,u=e,c=Math.min(i,Math.abs(a-o));1e-5<c;){var f=u+h*Math.min(c,l);s.push(m.call(this,t,u,f)),c-=Math.abs(f-u),u=f}return s},m=function(t,e,n){var r=(n-e)/2,i=t*Math.cos(r),o=t*Math.sin(r),a=i,s=-o,l=a*a+s*s,h=l+a*i+s*o,u=4/3*(Math.sqrt(2*l*h)-h)/(a*o-s*i),c=a-u*s,f=s+u*a,p=c,d=-f,g=r+e,m=Math.cos(g),y=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:c*m-f*y,y2:c*y+f*m,x3:p*m-d*y,y3:p*y+d*m,x4:t*Math.cos(n),y4:t*Math.sin(n)}},B=function(t){return 180*t/Math.PI},y=function(t){return t*Math.PI/180},w=function(t,e,n,r,i,o){var a=t+.5*(n-t),s=e+.5*(r-e),l=i+.5*(n-i),h=o+.5*(r-o),u=Math.min(t,i,a,l),c=Math.max(t,i,a,l),f=Math.min(e,o,s,h),p=Math.max(e,o,s,h);return new E(u,f,c-u,p-f)},b=function(t,e,n,r,i,o,a,s){for(var l,h,u,c,f,p,d,g,m,y,v,w,b,x=n-t,N=r-e,L=i-n,A=o-r,S=a-i,_=s-o,F=0;F<41;F++)g=(p=(h=t+(l=F/40)*x)+l*((c=n+l*L)-h))+l*(c+l*(i+l*S-c)-p),m=(d=(u=e+l*N)+l*((f=r+l*A)-u))+l*(f+l*(o+l*_-f)-d),b=0==F?(w=y=g,v=m):(y=Math.min(y,g),v=Math.min(v,m),w=Math.max(w,g),Math.max(b,m));return new E(Math.round(y),Math.round(v),Math.round(w-y),Math.round(b-v))},j=function(t,e){var n=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var r=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},E=function(t,e,n,r){j.call(this,t,e),this.type="rect";var i=n||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var o=r||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return o},set:function(t){isNaN(t)||(o=parseFloat(t))}}),this},M=function(t,e,n,r,i,o){var a=[];return Object.defineProperty(this,"sx",{get:function(){return a[0]},set:function(t){a[0]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shy",{get:function(){return a[1]},set:function(t){a[1]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"shx",{get:function(){return a[2]},set:function(t){a[2]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"sy",{get:function(){return a[3]},set:function(t){a[3]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"tx",{get:function(){return a[4]},set:function(t){a[4]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"ty",{get:function(){return a[5]},set:function(t){a[5]=Math.round(1e5*t)/1e5}}),Object.defineProperty(this,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(this,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(this,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(this,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),this.sx=isNaN(t)?1:t,this.shy=isNaN(e)?0:e,this.shx=isNaN(n)?0:n,this.sy=isNaN(r)?1:r,this.tx=isNaN(i)?0:i,this.ty=isNaN(o)?0:o,this};M.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,n=t.sx*this.shy+t.shy*this.sy,r=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,o=t.tx*this.sx+t.ty*this.shx+this.tx,a=t.tx*this.shy+t.ty*this.sy+this.ty;return new M(e,n,r,i,o,a)},M.prototype.decompose=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty,a=Math.sqrt(t*t+e*e),s=(t/=a)*n+(e/=a)*r;n-=t*s,r-=e*s;var l=Math.sqrt(n*n+r*r);return s/=l,t*(r/=l)<e*(n/=l)&&(t=-t,e=-e,s=-s,a=-a),{scale:new M(a,0,0,l,0,0),translate:new M(1,0,0,1,i,o),rotate:new M(t,e,-e,t,0,0),skew:new M(1,0,s,1,0,0)}},M.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,n=t.x*this.shy+t.y*this.sy+this.ty;return new j(e,n)},M.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),n=this.applyToPoint(new j(t.x+t.w,t.y+t.h));return new E(e.x,e.y,n.x-e.x,n.y-e.y)},M.prototype.clone=function(){var t=this.sx,e=this.shy,n=this.shx,r=this.sy,i=this.tx,o=this.ty;return new M(t,e,n,r,i,o)}}(lt.API,"undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),
/**
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
a=lt.API,o=function(t){var r,e,n,i,o,a,s,l,h,u;for(/[^\x00-\xFF]/.test(t),e=[],n=0,i=(t+=r="\0\0\0\0".slice(t.length%4||4)).length;n<i;n+=4)0!==(o=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(a=(o=((o=((o=((o=(o-(u=o%85))/85)-(h=o%85))/85)-(l=o%85))/85)-(s=o%85))/85)%85,e.push(a+33,s+33,l+33,h+33,u+33)):e.push(122);return function(t,e){for(var n=r.length;0<n;n--)t.pop()}(e),String.fromCharCode.apply(String,e)+"~>"},s=function(t){var r,e,n,i,o,a=String,s="length",l="charCodeAt",h="slice",u="replace";for(t[h](-2),t=t[h](0,-2)[u](/\s/g,"")[u]("z","!!!!!"),n=[],i=0,o=(t+=r="uuuuu"[h](t[s]%5||5))[s];i<o;i+=5)e=52200625*(t[l](i)-33)+614125*(t[l](i+1)-33)+7225*(t[l](i+2)-33)+85*(t[l](i+3)-33)+(t[l](i+4)-33),n.push(255&e>>24,255&e>>16,255&e>>8,255&e);return function(t,e){for(var n=r[s];0<n;n--)t.pop()}(n),a.fromCharCode.apply(a,n)},h=function(t){for(var e="",n=0;n<t.length;n+=1)e+=("0"+t.charCodeAt(n).toString(16)).slice(-2);return e+=">"},u=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var n="",r=0;r<t.length;r+=2)n+=String.fromCharCode("0x"+(t[r]+t[r+1]));return n},c=function(t,e){e=Object.assign({predictor:1,colors:1,bitsPerComponent:8,columns:1},e);for(var n,r,i=[],o=t.length;o--;)i[o]=t.charCodeAt(o);return n=a.adler32cs.from(t),(r=new Deflater(6)).append(new Uint8Array(i)),t=r.flush(),(i=new Uint8Array(t.length+6)).set(new Uint8Array([120,156])),i.set(t,2),i.set(new Uint8Array([255&n,n>>8&255,n>>16&255,n>>24&255]),t.length+2),t=String.fromCharCode.apply(null,i)},a.processDataByFilters=function(t,e){var n=0,r=t||"",i=[];for("string"==typeof(e=e||[])&&(e=[e]),n=0;n<e.length;n+=1)switch(e[n]){case"ASCII85Decode":case"/ASCII85Decode":r=s(r),i.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":r=o(r),i.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":r=u(r),i.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":r=h(r),i.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":r=c(r),i.push("/FlateDecode");break;default:throw'The filter: "'+e[n]+'" is not implemented'}return{data:r,reverseChain:i.reverse().join(" ")}},(
/**
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
r=lt.API).loadFile=function(t,e,n){var r;e=e||!0,n=n||function(){};try{r=function(t,e,n){var r=new XMLHttpRequest,i=[],o=0,a=function(t){var e=t.length,n=String.fromCharCode;for(o=0;o<e;o+=1)i.push(n(255&t.charCodeAt(o)));return i.join("")};if(r.open("GET",t,!e),r.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(r.onload=function(){return a(this.responseText)}),r.send(null),200===r.status)return e?a(r.responseText):void 0;console.warn('Unable to load file "'+t+'"')}(t,e)}catch(t){r=void 0}return r},r.loadImageFile=r.loadFile,
/**
   * Copyright (c) 2018 Erik Koopmans
   * Released under the MIT License.
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
i=lt.API,f="undefined"!=typeof window&&window||"undefined"!=typeof global&&global,g=function(t){var e=se(t);return"undefined"===e?"undefined":"string"===e||t instanceof String?"string":"number"===e||t instanceof Number?"number":"function"===e||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===e?"object":"unknown"},m=function(t,e){var n=document.createElement(t);if(e.className&&(n.className=e.className),e.innerHTML){n.innerHTML=e.innerHTML;for(var r=n.getElementsByTagName("script"),i=r.length;0<i--;null)r[i].parentNode.removeChild(r[i])}for(var o in e.style)n.style[o]=e.style[o];return n},(((y=function t(e){var n=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),r=t.convert(Promise.resolve(),n);return r=(r=r.setProgress(1,t,1,[t])).set(e)}).prototype=Object.create(Promise.prototype)).constructor=y).convert=function(t,e){return t.__proto__=e||y.prototype,t},y.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{}}},y.prototype.from=function(t,e){return this.then(function(){switch(e=e||function(t){switch(g(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.set({src:m("div",{innerHTML:t})});case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}})},y.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},y.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then(function(){var t={position:"relative",display:"inline-block",width:Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:"white"},e=function t(e,n){for(var r=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==n&&1===i.nodeType&&"SCRIPT"===i.nodeName||r.appendChild(t(i,n));return 1===e.nodeType&&("CANVAS"===e.nodeName?(r.width=e.width,r.height=e.height,r.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(r.value=e.value),r.addEventListener("load",function(){r.scrollTop=e.scrollTop,r.scrollLeft=e.scrollLeft},!0)),r}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=m("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=m("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(m("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"})},y.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=Object.assign({},this.opt.html2canvas);if(delete t.onrendered,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,t)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(function(){var t=this.opt.jsPDF,e=Object.assign({async:!0,allowTaint:!0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete e.onrendered,t.context2d.autoPaging=!0,t.context2d.posX=this.opt.x,t.context2d.posY=this.opt.y,e.windowHeight=e.windowHeight||0,e.windowHeight=0==e.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):e.windowHeight,this.isHtml2CanvasLoaded())return html2canvas(this.prop.container,e)}).then(function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)})},y.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then(function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t})},y.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then(function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF})},y.prototype.output=function(t,e,n){return"img"===(n=n||"pdf").toLowerCase()||"image"===n.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},y.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){return this.prop.pdf.output(t,e)})},y.prototype.outputImg=function(t,e){return this.thenList([function(){return this.prop.img||this.toImg()}]).then(function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}})},y.prototype.isHtml2CanvasLoaded=function(){var t=void 0!==f.html2canvas;return t||console.error("html2canvas not loaded."),t},y.prototype.save=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then(function(){this.prop.pdf.save(this.opt.filename)})},y.prototype.doCallback=function(t){if(this.isHtml2CanvasLoaded())return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then(function(){this.prop.callback(this.prop.pdf)})},y.prototype.set=function(e){if("object"!==g(e))return this;var t=Object.keys(e||{}).map(function(t){if(t in y.template.prop)return function(){this.prop[t]=e[t]};switch(t){case"margin":return this.setMargin.bind(this,e.margin);case"jsPDF":return function(){return this.opt.jsPDF=e.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,e.pageSize);default:return function(){this.opt[t]=e[t]}}},this);return this.then(function(){return this.thenList(t)})},y.prototype.get=function(e,n){return this.then(function(){var t=e in y.template.prop?this.prop[e]:this.opt[e];return n?n(t):t})},y.prototype.setMargin=function(t){return this.then(function(){switch(g(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t}).then(this.setPageSize)},y.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then(function(){(t=t||lt.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t})},y.prototype.setProgress=function(t,e,n,r){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=n&&(this.progress.n=n),null!=r&&(this.progress.stack=r),this.progress.ratio=this.progress.val/this.progress.state,this},y.prototype.updateProgress=function(t,e,n,r){return this.setProgress(t?this.progress.val+t:null,e||null,n?this.progress.n+n:null,r?this.progress.stack.concat(r):null)},y.prototype.then=function(t,e){var n=this;return this.thenCore(t,e,function(e,t){return n.updateProgress(null,null,1,[e]),Promise.prototype.then.call(this,function(t){return n.updateProgress(null,e),t}).then(e,t).then(function(t){return n.updateProgress(1),t})})},y.prototype.thenCore=function(t,e,n){n=n||Promise.prototype.then;var r=this;t&&(t=t.bind(r)),e&&(e=e.bind(r));var i=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?r:y.convert(Object.assign({},r),Promise.prototype),o=n.call(i,t,e);return y.convert(o,r.__proto__)},y.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},y.prototype.thenList=function(t){var e=this;return t.forEach(function(t){e=e.thenCore(t)}),e},y.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return y.convert(e,this)},y.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},y.prototype.error=function(t){return this.then(function(){throw new Error(t)})},y.prototype.using=y.prototype.set,y.prototype.saveAs=y.prototype.save,y.prototype.export=y.prototype.output,y.prototype.run=y.prototype.then,lt.getPageSize=function(t,e,n){if("object"===se(t)){var r=t;t=r.orientation,e=r.unit||e,n=r.format||n}e=e||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var i=(""+n).toLowerCase(),o={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(e){case"pt":var a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+e}if(o.hasOwnProperty(i))var s=o[i][1]/a,l=o[i][0]/a;else try{s=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t){if(t="p",s<l){var h=l;l=s,s=h}}else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",l<s&&(h=l,l=s,s=h)}return{width:l,height:s,unit:e,k:a}},i.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.jsPDF;var n=new y(e);return e.worker?n:n.from(t).doCallback()},lt.API.addJS=function(t){return b=t,this.internal.events.subscribe("postPutResources",function(t){v=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(v+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),w=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+b+")"),this.internal.out(">>"),this.internal.out("endobj")}),this.internal.events.subscribe("putCatalog",function(){void 0!==v&&void 0!==w&&this.internal.out("/Names <</JavaScript "+v+" 0 R>>")}),this},(
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
x=lt.API).events.push(["postPutResources",function(){var t=this,e=/^(\d+) 0 obj$/;if(0<this.outline.root.children.length)for(var n=t.outline.render().split(/\r\n/),r=0;r<n.length;r++){var i=n[r],o=e.exec(i);if(null!=o){var a=o[1];t.internal.newObjectDeferredBegin(a,!1)}t.internal.write(i)}if(this.outline.createNamedDestinations){var s=this.internal.pages.length,l=[];for(r=0;r<s;r++){var h=t.internal.newObject();l.push(h);var u=t.internal.getPageInfo(r+1);t.internal.write("<< /D["+u.objId+" 0 R /XYZ null null null]>> endobj")}var c=t.internal.newObject();for(t.internal.write("<< /Names [ "),r=0;r<l.length;r++)t.internal.write("(page_"+(r+1)+")"+l[r]+" 0 R");t.internal.write(" ] >>","endobj"),t.internal.newObject(),t.internal.write("<< /Dests "+c+" 0 R"),t.internal.write(">>","endobj")}}]),x.events.push(["putCatalog",function(){0<this.outline.root.children.length&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+namesOid+" 0 R"))}]),x.events.push(["initialized",function(){var a=this;a.outline={createNamedDestinations:!1,root:{children:[]}},a.outline.add=function(t,e,n){var r={title:e,options:n,children:[]};return null==t&&(t=this.root),t.children.push(r),r},a.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=a,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},a.outline.genIds_r=function(t){t.id=a.internal.newObjectDeferred();for(var e=0;e<t.children.length;e++)this.genIds_r(t.children[e])},a.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),0<t.children.length&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},a.outline.renderItems=function(t){this.ctx.pdf.internal.getCoordinateString;for(var e=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<t.children.length;n++){var r=t.children[n];this.objStart(r),this.line("/Title "+this.makeString(r.title)),this.line("/Parent "+this.makeRef(t)),0<n&&this.line("/Prev "+this.makeRef(t.children[n-1])),n<t.children.length-1&&this.line("/Next "+this.makeRef(t.children[n+1])),0<r.children.length&&(this.line("/First "+this.makeRef(r.children[0])),this.line("/Last "+this.makeRef(r.children[r.children.length-1])));var i=this.count=this.count_r({count:0},r);if(0<i&&this.line("/Count "+i),r.options&&r.options.pageNumber){var o=a.internal.getPageInfo(r.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+e(0)+" 0]")}this.objEnd()}for(n=0;n<t.children.length;n++)r=t.children[n],this.renderItems(r)},a.outline.line=function(t){this.ctx.val+=t+"\r\n"},a.outline.makeRef=function(t){return t.id+" 0 R"},a.outline.makeString=function(t){return"("+a.internal.pdfEscape(t)+")"},a.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},a.outline.objEnd=function(t){this.ctx.val+=">> \r\nendobj\r\n"},a.outline.count_r=function(t,e){for(var n=0;n<e.children.length;n++)t.count++,this.count_r(t,e.children[n]);return t.count}}]),
/**
   * @license
   * 
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * 
   * ====================================================================
   */
I=lt.API,C=function(){var t="function"==typeof Deflater;if(!t)throw new Error("requires deflate.js for compression");return t},B=function(t,e,n,r){var i=5,o=E;switch(r){case I.image_compression.FAST:i=3,o=j;break;case I.image_compression.MEDIUM:i=6,o=M;break;case I.image_compression.SLOW:i=9,o=O}t=A(t,e,n,o);var a=new Uint8Array(N(i)),s=L(t),l=new Deflater(i),h=l.append(t),u=l.flush(),c=a.length+h.length+u.length,f=new Uint8Array(c+4);return f.set(a),f.set(h,a.length),f.set(u,a.length+h.length),f[c++]=s>>>24&255,f[c++]=s>>>16&255,f[c++]=s>>>8&255,f[c++]=255&s,I.arrayBufferToBinaryString(f)},N=function(t,e){var n=Math.LOG2E*Math.log(32768)-8<<4|8,r=n<<8;return r|=Math.min(3,(e-1&255)>>1)<<6,r|=0,[n,255&(r+=31-r%31)]},L=function(t,e){for(var n,r=1,i=0,o=t.length,a=0;0<o;){for(o-=n=e<o?e:o;i+=r+=t[a++],--n;);r%=65521,i%=65521}return(i<<16|r)>>>0},A=function(t,e,n,r){for(var i,o,a,s=t.length/e,l=new Uint8Array(t.length+s),h=T(),u=0;u<s;u++){if(a=u*e,i=t.subarray(a,a+e),r)l.set(r(i,n,o),a+u);else{for(var c=0,f=h.length,p=[];c<f;c++)p[c]=h[c](i,n,o);var d=R(p.concat());l.set(p[d],a+u)}o=i}return l},S=function(t,e,n){var r=Array.apply([],t);return r.unshift(0),r},j=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=1;o<a;o++)r=t[o-e]||0,i[o+1]=t[o]-r+256&255;return i},E=function(t,e,n){var r,i=[],o=0,a=t.length;for(i[0]=2;o<a;o++)r=n&&n[o]||0,i[o+1]=t[o]-r+256&255;return i},M=function(t,e,n){var r,i,o=[],a=0,s=t.length;for(o[0]=3;a<s;a++)r=t[a-e]||0,i=n&&n[a]||0,o[a+1]=t[a]+256-(r+i>>>1)&255;return o},O=function(t,e,n){var r,i,o,a,s=[],l=0,h=t.length;for(s[0]=4;l<h;l++)r=t[l-e]||0,i=n&&n[l]||0,o=n&&n[l-e]||0,a=q(r,i,o),s[l+1]=t[l]-a+256&255;return s},q=function(t,e,n){var r=t+e-n,i=Math.abs(r-t),o=Math.abs(r-e),a=Math.abs(r-n);return i<=o&&i<=a?t:o<=a?e:n},T=function(){return[S,j,E,M,O]},R=function(t){for(var e,n,r,i=0,o=t.length;i<o;)((e=D(t[i].slice(1)))<n||!n)&&(n=e,r=i),i++;return r},D=function(t){for(var e=0,n=t.length,r=0;e<n;)r+=Math.abs(t[e++]);return r},I.processPNG=function(t,e,n,r,i){var o,a,s,l,h,u,c=this.color_spaces.DEVICE_RGB,f=this.decode.FLATE_DECODE,p=8;if(this.isArrayBuffer(t)&&(t=new Uint8Array(t)),this.isArrayBufferView(t)){if("function"!=typeof PNG||"function"!=typeof kt)throw new Error("PNG support requires png.js and zlib.js");if(t=(o=new PNG(t)).imgData,p=o.bits,c=o.colorSpace,l=o.colors,-1!==[4,6].indexOf(o.colorType)){if(8===o.bits)for(var d,g=(_=32==o.pixelBitlength?new Uint32Array(o.decodePixels().buffer):16==o.pixelBitlength?new Uint16Array(o.decodePixels().buffer):new Uint8Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*o.colors),y=new Uint8Array(g),v=o.pixelBitlength-o.bits,w=0,b=0;w<g;w++){for(x=_[w],d=0;d<v;)m[b++]=x>>>d&255,d+=o.bits;y[w]=x>>>d&255}if(16===o.bits){g=(_=new Uint32Array(o.decodePixels().buffer)).length,m=new Uint8Array(g*(32/o.pixelBitlength)*o.colors),y=new Uint8Array(g*(32/o.pixelBitlength));for(var x,N=1<o.colors,L=b=w=0;w<g;)x=_[w++],m[b++]=x>>>0&255,N&&(m[b++]=x>>>16&255,x=_[w++],m[b++]=x>>>0&255),y[L++]=x>>>16&255;p=8}r!==I.image_compression.NONE&&C()?(t=B(m,o.width*o.colors,o.colors,r),u=B(y,o.width,1,r)):(t=m,u=y,f=null)}if(3===o.colorType&&(c=this.color_spaces.INDEXED,h=o.palette,o.transparency.indexed)){var A=o.transparency.indexed,S=0;for(w=0,g=A.length;w<g;++w)S+=A[w];if((S/=255)==g-1&&-1!==A.indexOf(0))s=[A.indexOf(0)];else if(S!==g){var _=o.decodePixels();for(y=new Uint8Array(_.length),w=0,g=_.length;w<g;w++)y[w]=A[_[w]];u=B(y,o.width,1)}}var F=function(t){var e;switch(t){case I.image_compression.FAST:e=11;break;case I.image_compression.MEDIUM:e=13;break;case I.image_compression.SLOW:e=14;break;default:e=12}return e}(r);return a=f===this.decode.FLATE_DECODE?"/Predictor "+F+" /Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width:"/Colors "+l+" /BitsPerComponent "+p+" /Columns "+o.width,(this.isArrayBuffer(t)||this.isArrayBufferView(t))&&(t=this.arrayBufferToBinaryString(t)),(u&&this.isArrayBuffer(u)||this.isArrayBufferView(u))&&(u=this.arrayBufferToBinaryString(u)),this.createImageInfo(t,o.width,o.height,c,p,f,e,n,a,s,h,u,F)}throw new Error("Unsupported PNG image data, try using JPEG instead.")},(
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
U=lt.API).processGIF89A=function(t,e,n,r,i){var o=new At(t),a=o.width,s=o.height,l=[];o.decodeAndBlitFrameRGBA(0,l);var h={data:l,width:a,height:s},u=new _t(100).encode(h,100);return U.processJPEG.call(this,u,e,n,r)},U.processGIF87A=U.processGIF89A,(
/**
   * Copyright (c) 2018 Aras Abbasi 
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
z=lt.API).processBMP=function(t,e,n,r,i){var o=new Ft(t,!1),a=o.width,s=o.height,l={data:o.getData(),width:a,height:s},h=new _t(100).encode(l,100);return z.processJPEG.call(this,h,e,n,r)},lt.API.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"FYRO Macedonian",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")}),this.internal.languageSettings.isSubscribed=!0)),this},
/** @license
   * MIT license.
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Diego Casorran, https://github.com/diegocr
   *
   * 
   * ====================================================================
   */
H=lt.API,W=H.getCharWidthsArray=function(t,e){var n,r,i,o=(e=e||{}).font||this.internal.getFont(),a=e.fontSize||this.internal.getFontSize(),s=e.charSpace||this.internal.getCharSpace(),l=e.widths?e.widths:o.metadata.Unicode.widths,h=l.fof?l.fof:1,u=e.kerning?e.kerning:o.metadata.Unicode.kerning,c=u.fof?u.fof:1,f=0,p=l[0]||h,d=[];for(n=0,r=t.length;n<r;n++)i=t.charCodeAt(n),"function"==typeof o.metadata.widthOfString?d.push((o.metadata.widthOfGlyph(o.metadata.characterToGlyph(i))+s*(1e3/a)||0)/1e3):d.push((l[i]||p)/h+(u[i]&&u[i][f]||0)/c),f=i;return d},V=H.getArraySum=function(t){for(var e=t.length,n=0;e;)n+=t[--e];return n},G=H.getStringUnitWidth=function(t,e){var n=(e=e||{}).fontSize||this.internal.getFontSize(),r=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return"function"==typeof r.metadata.widthOfString?r.metadata.widthOfString(t,n,i)/n:V(W.apply(this,arguments))},Y=function(t,e,n,r){for(var i=[],o=0,a=t.length,s=0;o!==a&&s+e[o]<n;)s+=e[o],o++;i.push(t.slice(0,o));var l=o;for(s=0;o!==a;)s+e[o]>r&&(i.push(t.slice(l,o)),s=0,l=o),s+=e[o],o++;return l!==o&&i.push(t.slice(l,o)),i},J=function(t,e,n){n||(n={});var r,i,o,a,s,l,h=[],u=[h],c=n.textIndent||0,f=0,p=0,d=t.split(" "),g=W.apply(this,[" ",n])[0];if(l=-1===n.lineIndent?d[0].length+2:n.lineIndent||0){var m=Array(l).join(" "),y=[];d.map(function(t){1<(t=t.split(/\s*\n/)).length?y=y.concat(t.map(function(t,e){return(e&&t.length?"\n":"")+t})):y.push(t[0])}),d=y,l=G.apply(this,[m,n])}for(o=0,a=d.length;o<a;o++){var v=0;if(r=d[o],l&&"\n"==r[0]&&(r=r.substr(1),v=1),i=W.apply(this,[r,n]),e<c+f+(p=V(i))||v){if(e<p){for(s=Y.apply(this,[r,i,e-(c+f),e]),h.push(s.shift()),h=[s.pop()];s.length;)u.push([s.shift()]);p=V(i.slice(r.length-(h[0]?h[0].length:0)))}else h=[r];u.push(h),c=p+l,f=g}else h.push(r),c+=f+p,f=g}if(l)var w=function(t,e){return(e?m:"")+t.join(" ")};else w=function(t){return t.join(" ")};return u.map(w)},H.splitTextToSize=function(t,e,n){var r,i=(n=n||{}).fontSize||this.internal.getFontSize(),o=function(t){var e={0:1},n={};if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var r=this.internal.getFont(t.fontName,t.fontStyle),i="Unicode";return r.metadata[i]?{widths:r.metadata[i].widths||e,kerning:r.metadata[i].kerning||n}:{font:r.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,n);r=Array.isArray(t)?t:t.split(/\r?\n/);var a=1*this.internal.scaleFactor*e/i;o.textIndent=n.textIndent?1*n.textIndent*this.internal.scaleFactor/i:0,o.lineIndent=n.lineIndent;var s,l,h=[];for(s=0,l=r.length;s<l;s++)h=h.concat(J.apply(this,[r[s],a,o]));return h},
/** @license
   jsPDF standard_fonts_metrics plugin
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * MIT license.
   * 
   * ====================================================================
   */
X=lt.API,Z={codePages:["WinAnsiEncoding"],WinAnsiEncoding:(K=function(t){for(var e="klmnopqrstuvwxyz",n={},r=0;r<e.length;r++)n[e[r]]="0123456789abcdef"[r];var i,o,a,s,l,h={},u=1,c=h,f=[],p="",d="",g=t.length-1;for(r=1;r!=g;)l=t[r],r+=1,"'"==l?o=o?(s=o.join(""),i):[]:o?o.push(l):"{"==l?(f.push([c,s]),c={},s=i):"}"==l?((a=f.pop())[0][a[1]]=c,s=i,c=a[0]):"-"==l?u=-1:s===i?n.hasOwnProperty(l)?(p+=n[l],s=parseInt(p,16)*u,u=1,p=""):p+=l:n.hasOwnProperty(l)?(d+=n[l],c[s]=parseInt(d,16)*u,u=1,s=i,d=""):d+=l;return h})("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},Q={Unicode:{Courier:Z,"Courier-Bold":Z,"Courier-BoldOblique":Z,"Courier-Oblique":Z,Helvetica:Z,"Helvetica-Bold":Z,"Helvetica-BoldOblique":Z,"Helvetica-Oblique":Z,"Times-Roman":Z,"Times-Bold":Z,"Times-BoldItalic":Z,"Times-Italic":Z}},$={Unicode:{"Courier-Oblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":K("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":K("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:K("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":K("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:K("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":K("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":K("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":K("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":K("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}},X.events.push(["addFont",function(t){var e,n,r,i=t.font,o="Unicode";(e=$[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).widths=e.widths,n.kerning=e.kerning),(r=Q[o][i.postScriptName])&&((n=i.metadata[o]?i.metadata[o]:i.metadata[o]={}).encoding=r).codePages&&r.codePages.length&&(i.encoding=r.codePages[0])}]),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
tt=lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")(),tt.API.events.push(["addFont",function(t){var e=t.font,n=t.instance;if(void 0!==n&&n.existsFileInVFS(e.postScriptName)){var r=n.getFileFromVFS(e.postScriptName);if("string"!=typeof r)throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').");e.metadata=tt.API.TTFFont.open(e.postScriptName,e.fontName,r,e.encoding),e.metadata.Unicode=e.metadata.Unicode||{encoding:{},kerning:{},widths:[]},e.metadata.glyIdsUsed=[0]}else if(!1===e.isStandardFont)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+e.postScriptName+"').")}]),(
/** @license
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   * 
   * 
   * ====================================================================
   */
et=lt.API).addSvg=function(t,e,n,r,i){if(void 0===e||void 0===n)throw new Error("addSVG needs values for 'x' and 'y'");function o(t){for(var e=parseFloat(t[1]),n=parseFloat(t[2]),r=[],i=3,o=t.length;i<o;)"c"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2]),parseFloat(t[i+3]),parseFloat(t[i+4]),parseFloat(t[i+5]),parseFloat(t[i+6])]),i+=7):"l"===t[i]?(r.push([parseFloat(t[i+1]),parseFloat(t[i+2])]),i+=3):i+=1;return[e,n,r]}var a,s,l,h,u,c,f,p,d=(h=document,p=h.createElement("iframe"),u=".jsPDF_sillysvg_iframe {display:none;position:absolute;}",(f=(c=h).createElement("style")).type="text/css",f.styleSheet?f.styleSheet.cssText=u:f.appendChild(c.createTextNode(u)),c.getElementsByTagName("head")[0].appendChild(f),p.name="childframe",p.setAttribute("width",0),p.setAttribute("height",0),p.setAttribute("frameborder","0"),p.setAttribute("scrolling","no"),p.setAttribute("seamless","seamless"),p.setAttribute("class","jsPDF_sillysvg_iframe"),h.body.appendChild(p),p),g=(a=t,(l=((s=d).contentWindow||s.contentDocument).document).write(a),l.close(),l.getElementsByTagName("svg")[0]),m=[1,1],y=parseFloat(g.getAttribute("width")),v=parseFloat(g.getAttribute("height"));y&&v&&(r&&i?m=[r/y,i/v]:r?m=[r/y,r/y]:i&&(m=[i/v,i/v]));var w,b,x,N,L=g.childNodes;for(w=0,b=L.length;w<b;w++)(x=L[w]).tagName&&"PATH"===x.tagName.toUpperCase()&&((N=o(x.getAttribute("d").split(" ")))[0]=N[0]*m[0]+e,N[1]=N[1]*m[1]+n,this.lines.call(this,N[2],N[0],N[1],m));return this},et.addSVG=et.addSvg,et.addSvgAsImage=function(t,e,n,r,i,o,a,s){if(isNaN(e)||isNaN(n))throw console.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(r)||isNaN(i))throw console.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=r,l.height=i;var h=l.getContext("2d");return h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height),canvg(l,t,{ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0,ignoreClear:!0}),this.addImage(l.toDataURL("image/jpeg",1),e,n,r,i,a,s),this},lt.API.putTotalPages=function(t){var e,n=0;n=parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var r=1;r<=this.internal.getNumberOfPages();r++)for(var i=0;i<this.internal.pages[r].length;i++)this.internal.pages[r][i]=this.internal.pages[r][i].replace(e,n);return this},lt.API.viewerPreferences=function(t,e){var n;t=t||{},e=e||!1;var r,i,o={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},a=Object.keys(o),s=[],l=0,h=0,u=0,c=!0;function f(t,e){var n,r=!1;for(n=0;n<t.length;n+=1)t[n]===e&&(r=!0);return r}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(o)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===e){var p=a.length;for(u=0;u<p;u+=1)n[a[u]].value=n[a[u]].defaultValue,n[a[u]].explicitSet=!1}if("object"===se(t))for(r in t)if(i=t[r],f(a,r)&&void 0!==i){if("boolean"===n[r].type&&"boolean"==typeof i)n[r].value=i;else if("name"===n[r].type&&f(n[r].valueSet,i))n[r].value=i;else if("integer"===n[r].type&&Number.isInteger(i))n[r].value=i;else if("array"===n[r].type){for(l=0;l<i.length;l+=1)if(c=!0,1===i[l].length&&"number"==typeof i[l][0])s.push(String(i[l]-1));else if(1<i[l].length){for(h=0;h<i[l].length;h+=1)"number"!=typeof i[l][h]&&(c=!1);!0===c&&s.push([i[l][0]-1,i[l][1]-1].join(" "))}n[r].value="["+s.join(" ")+"]"}else n[r].value=n[r].defaultValue;n[r].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")}),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this},
/** ==================================================================== 
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   * 
   * 
   * ====================================================================
   */
nt=lt.API,ot=it=rt="",nt.addMetadata=function(t,e){return it=e||"http://jspdf.default.namespaceuri/",rt=t,this.internal.events.subscribe("postPutResources",function(){if(rt){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+it+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),n=unescape(encodeURIComponent(t)),r=unescape(encodeURIComponent(rt)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),o=unescape(encodeURIComponent("</x:xmpmeta>")),a=n.length+r.length+i.length+e.length+o.length;ot=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+a+" >>"),this.internal.write("stream"),this.internal.write(e+n+r+i+o),this.internal.write("endstream"),this.internal.write("endobj")}else ot=""}),this.internal.events.subscribe("putCatalog",function(){ot&&this.internal.write("/Metadata "+ot+" 0 R")}),this},function(f,t){var e=f.API;var m=e.pdfEscape16=function(t,e){for(var n,r=e.metadata.Unicode.widths,i=["","0","00","000","0000"],o=[""],a=0,s=t.length;a<s;++a){if(n=e.metadata.characterToGlyph(t.charCodeAt(a)),e.metadata.glyIdsUsed.push(n),e.metadata.toUnicode[n]=t.charCodeAt(a),-1==r.indexOf(n)&&(r.push(n),r.push([parseInt(e.metadata.widthOfGlyph(n),10)])),"0"==n)return o.join("");n=n.toString(16),o.push(i[4-n.length],n)}return o.join("")},p=function(t){var e,n,r,i,o,a,s;for(o="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",r=[],a=0,s=(n=Object.keys(t).sort(function(t,e){return t-e})).length;a<s;a++)e=n[a],100<=r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar",r=[]),i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),r.push("<"+e+"><"+i+">");return r.length&&(o+="\n"+r.length+" beginbfchar\n"+r.join("\n")+"\nendbfchar\n"),o+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"Identity-H"===t.encoding){for(var i=t.metadata.Unicode.widths,o=t.metadata.subset.encode(t.metadata.glyIdsUsed,1),a="",s=0;s<o.length;s++)a+=String.fromCharCode(o[s]);var l=n();r({data:a,addLength1:!0}),e("endobj");var h=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var u=n();e("<<"),e("/Type /FontDescriptor"),e("/FontName /"+t.fontName),e("/FontFile2 "+l+" 0 R"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/Flags "+t.metadata.flags),e("/StemV "+t.metadata.stemV),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e(">>"),e("endobj");var c=n();e("<<"),e("/Type /Font"),e("/BaseFont /"+t.fontName),e("/FontDescriptor "+u+" 0 R"),e("/W "+f.API.PDFObject.convert(i)),e("/CIDToGIDMap /Identity"),e("/DW 1000"),e("/Subtype /CIDFontType2"),e("/CIDSystemInfo"),e("<<"),e("/Supplement 0"),e("/Registry (Adobe)"),e("/Ordering ("+t.encoding+")"),e(">>"),e(">>"),e("endobj"),t.objectNumber=n(),e("<<"),e("/Type /Font"),e("/Subtype /Type0"),e("/ToUnicode "+h+" 0 R"),e("/BaseFont /"+t.fontName),e("/Encoding /"+t.encoding),e("/DescendantFonts ["+c+" 0 R]"),e(">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);e.events.push(["putFont",function(t){!function(t,e,n,r){if(t.metadata instanceof f.API.TTFFont&&"WinAnsiEncoding"===t.encoding){t.metadata.Unicode.widths;for(var i=t.metadata.rawData,o="",a=0;a<i.length;a++)o+=String.fromCharCode(i[a]);var s=n();r({data:o,addLength1:!0}),e("endobj");var l=n();r({data:p(t.metadata.toUnicode),addLength1:!0}),e("endobj");var h=n();for(e("<<"),e("/Descent "+t.metadata.decender),e("/CapHeight "+t.metadata.capHeight),e("/StemV "+t.metadata.stemV),e("/Type /FontDescriptor"),e("/FontFile2 "+s+" 0 R"),e("/Flags 96"),e("/FontBBox "+f.API.PDFObject.convert(t.metadata.bbox)),e("/FontName /"+t.fontName),e("/ItalicAngle "+t.metadata.italicAngle),e("/Ascent "+t.metadata.ascender),e(">>"),e("endobj"),t.objectNumber=n(),a=0;a<t.metadata.hmtx.widths.length;a++)t.metadata.hmtx.widths[a]=parseInt(t.metadata.hmtx.widths[a]*(1e3/t.metadata.head.unitsPerEm));e("<</Subtype/TrueType/Type/Font/ToUnicode "+l+" 0 R/BaseFont/"+t.fontName+"/FontDescriptor "+h+" 0 R/Encoding/"+t.encoding+" /FirstChar 29 /LastChar 255 /Widths "+f.API.PDFObject.convert(t.metadata.hmtx.widths)+">>"),e("endobj"),t.isAlreadyPutted=!0}}(t.font,t.out,t.newObject,t.putStream)}]);var h=function(t){var e,n,r=t.text||"",i=t.x,o=t.y,a=t.options||{},s=t.mutex||{},l=s.pdfEscape,h=s.activeFontKey,u=s.fonts,c=(s.activeFontSize,""),f=0,p="",d=u[n=h].encoding;if("Identity-H"!==u[n].encoding)return{text:r,x:i,y:o,options:a,mutex:s};for(p=r,n=h,"[object Array]"===Object.prototype.toString.call(r)&&(p=r[0]),f=0;f<p.length;f+=1)u[n].metadata.hasOwnProperty("cmap")&&(e=u[n].metadata.cmap.unicode.codeMap[p[f].charCodeAt(0)]),e?c+=p[f]:p[f].charCodeAt(0)<256&&u[n].metadata.hasOwnProperty("Unicode")?c+=p[f]:c+="";var g="";return parseInt(n.slice(1))<14||"WinAnsiEncoding"===d?g=function(t){for(var e="",n=0;n<t.length;n++)e+=""+t.charCodeAt(n).toString(16);return e}(l(c,n)):"Identity-H"===d&&(g=m(c,u[n])),s.isHex=!0,{text:g,x:i,y:o,options:a,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",n=t.x,r=t.y,i=t.options,o=t.mutex,a=(i.lang,[]),s={text:e,x:n,y:r,options:i,mutex:o};if("[object Array]"===Object.prototype.toString.call(e)){var l=0;for(l=0;l<e.length;l+=1)"[object Array]"===Object.prototype.toString.call(e[l])&&3===e[l].length?a.push([h(Object.assign({},s,{text:e[l][0]})).text,e[l][1],e[l][2]]):a.push(h(Object.assign({},s,{text:e[l]})).text);t.text=a}else t.text=h(Object.assign({},s,{text:e})).text}])}(lt,"undefined"!=typeof self&&self||"undefined"!=typeof global&&global||"undefined"!=typeof window&&window||Function("return this")()),at=lt.API,st=function(t){return void 0!==t&&(void 0===t.vFS&&(t.vFS={}),!0)},at.existsFileInVFS=function(t){return!!st(this.internal)&&void 0!==this.internal.vFS[t]},at.addFileToVFS=function(t,e){return st(this.internal),this.internal.vFS[t]=e,this},at.getFileFromVFS=function(t){return st(this.internal),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null},lt.API.addHTML=function(t,d,g,s,m){if("undefined"==typeof html2canvas&&"undefined"==typeof rasterizeHTML)throw new Error("You need either https://github.com/niklasvh/html2canvas or https://github.com/cburgmer/rasterizeHTML.js");"number"!=typeof d&&(s=d,m=g),"function"==typeof s&&(m=s,s=null),"function"!=typeof m&&(m=function(){});var e=this.internal,y=e.scaleFactor,v=e.pageSize.getWidth(),w=e.pageSize.getHeight();if((s=s||{}).onrendered=function(l){d=parseInt(d)||0,g=parseInt(g)||0;var t=s.dim||{},h=Object.assign({top:0,right:0,bottom:0,left:0,useFor:"content"},s.margin),e=t.h||Math.min(w,l.height/y),u=t.w||Math.min(v,l.width/y)-d,c=s.format||"JPEG",f=s.imageCompression||"SLOW";if(l.height>w-h.top-h.bottom&&s.pagesplit){var p=function(t,e,n,r,i){var o=document.createElement("canvas");o.height=i,o.width=r;var a=o.getContext("2d");return a.mozImageSmoothingEnabled=!1,a.webkitImageSmoothingEnabled=!1,a.msImageSmoothingEnabled=!1,a.imageSmoothingEnabled=!1,a.fillStyle=s.backgroundColor||"#ffffff",a.fillRect(0,0,r,i),a.drawImage(t,e,n,r,i,0,0,r,i),o},n=function(){for(var t,e,n=0,r=0,i={},o=!1;;){var a;if(r=0,i.top=0!==n?h.top:g,i.left=0!==n?h.left:d,o=(v-h.left-h.right)*y<l.width,"content"===h.useFor?0===n?(t=Math.min((v-h.left)*y,l.width),e=Math.min((w-h.top)*y,l.height-n)):(t=Math.min(v*y,l.width),e=Math.min(w*y,l.height-n),i.top=0):(t=Math.min((v-h.left-h.right)*y,l.width),e=Math.min((w-h.bottom-h.top)*y,l.height-n)),o)for(;;){"content"===h.useFor&&(0===r?t=Math.min((v-h.left)*y,l.width):(t=Math.min(v*y,l.width-r),i.left=0));var s=[a=p(l,r,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f];if(this.addImage.apply(this,s),(r+=t)>=l.width)break;this.addPage()}else s=[a=p(l,0,n,t,e),i.left,i.top,a.width/y,a.height/y,c,null,f],this.addImage.apply(this,s);if((n+=e)>=l.height)break;this.addPage()}m(u,n,null,s)}.bind(this);if("CANVAS"===l.nodeName){var r=new Image;r.onload=n,r.src=l.toDataURL("image/png"),l=r}else n()}else{var i=Math.random().toString(35),o=[l,d,g,u,e,c,i,f];this.addImage.apply(this,o),m(u,e,i,o)}}.bind(this),"undefined"!=typeof html2canvas&&!s.rstz)return html2canvas(t,s);if("undefined"==typeof rasterizeHTML)return null;var n="drawDocument";return"string"==typeof t&&(n=/^http/.test(t)?"drawURL":"drawHTML"),s.width=s.width||v*y,rasterizeHTML[n](t,void 0,s).then(function(t){s.onrendered(t.image)},function(t){m(null,t)})},
/**
   * jsPDF fromHTML plugin. BETA stage. API subject to change. Needs browser
   * Copyright (c) 2012 Willow Systems Corporation, willow-systems.com
   *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
   *               2014 Diego Casorran, https://github.com/diegocr
   *               2014 Daniel Husar, https://github.com/danielhusar
   *               2014 Wolfgang Gassler, https://github.com/woolfg
   *               2014 Steven Spungin, https://github.com/flamenco
   *
   * @license
   * 
   * ====================================================================
   */
function(t){var P,k,i,a,s,l,h,u,I,w,f,c,p,n,C,B,d,g,m,j;P=function(){return function(t){return e.prototype=t,new e};function e(){}}(),w=function(t){var e,n,r,i,o,a,s;for(n=0,r=t.length,e=void 0,a=i=!1;!i&&n!==r;)(e=t[n]=t[n].trimLeft())&&(i=!0),n++;for(n=r-1;r&&!a&&-1!==n;)(e=t[n]=t[n].trimRight())&&(a=!0),n--;for(o=/\s+$/g,s=!0,n=0;n!==r;)"\u2028"!=t[n]&&(e=t[n].replace(/\s+/g," "),s&&(e=e.trimLeft()),e&&(s=o.test(e)),t[n]=e),n++;return t},c=function(t){var e,n,r;for(e=void 0,n=(r=t.split(",")).shift();!e&&n;)e=i[n.trim().toLowerCase()],n=r.shift();return e},p=function(t){var e;return-1<(t="auto"===t?"0px":t).indexOf("em")&&!isNaN(Number(t.replace("em","")))&&(t=18.719*Number(t.replace("em",""))+"px"),-1<t.indexOf("pt")&&!isNaN(Number(t.replace("pt","")))&&(t=1.333*Number(t.replace("pt",""))+"px"),void 0,16,(e=n[t])?e:void 0!==(e={"xx-small":9,"x-small":11,small:13,medium:16,large:19,"x-large":23,"xx-large":28,auto:0}[t])?n[t]=e/16:(e=parseFloat(t))?n[t]=e/16:(e=t.match(/([\d\.]+)(px)/),Array.isArray(e)&&3===e.length?n[t]=parseFloat(e[1])/16:n[t]=1)},I=function(t){var e,n,r,i,o;return o=t,i=document.defaultView&&document.defaultView.getComputedStyle?document.defaultView.getComputedStyle(o,null):o.currentStyle?o.currentStyle:o.style,n=void 0,(e={})["font-family"]=c((r=function(t){return t=t.replace(/-\D/g,function(t){return t.charAt(1).toUpperCase()}),i[t]})("font-family"))||"times",e["font-style"]=a[r("font-style")]||"normal",e["text-align"]=s[r("text-align")]||"left","bold"===(n=l[r("font-weight")]||"normal")&&("normal"===e["font-style"]?e["font-style"]=n:e["font-style"]=n+e["font-style"]),e["font-size"]=p(r("font-size"))||1,e["line-height"]=p(r("line-height"))||1,e.display="inline"===r("display")?"inline":"block",n="block"===e.display,e["margin-top"]=n&&p(r("margin-top"))||0,e["margin-bottom"]=n&&p(r("margin-bottom"))||0,e["padding-top"]=n&&p(r("padding-top"))||0,e["padding-bottom"]=n&&p(r("padding-bottom"))||0,e["margin-left"]=n&&p(r("margin-left"))||0,e["margin-right"]=n&&p(r("margin-right"))||0,e["padding-left"]=n&&p(r("padding-left"))||0,e["padding-right"]=n&&p(r("padding-right"))||0,e["page-break-before"]=r("page-break-before")||"auto",e.float=h[r("cssFloat")]||"none",e.clear=u[r("clear")]||"none",e.color=r("color"),e},C=function(t,e,n){var r,i,o,a,s;if(o=!1,a=i=void 0,r=n["#"+t.id])if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;if(r=n[t.nodeName],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;for(s="string"==typeof t.className?t.className.split(" "):[],i=0;i<s.length;i++)if(r=n["."+s[i]],!o&&r)if("function"==typeof r)o=r(t,e);else for(i=0,a=r.length;!o&&i!==a;)o=r[i](t,e),i++;return o},j=function(t,e){var n,r,i,o,a,s,l,h,u;for(n=[],r=[],i=0,u=t.rows[0].cells.length,l=t.clientWidth;i<u;)h=t.rows[0].cells[i],r[i]={name:h.textContent.toLowerCase().replace(/\s+/g,""),prompt:h.textContent.replace(/\r?\n/g,""),width:h.clientWidth/l*e.pdf.internal.pageSize.getWidth()},i++;for(i=1;i<t.rows.length;){for(s=t.rows[i],a={},o=0;o<s.cells.length;)a[r[o].name]=s.cells[o].textContent.replace(/\r?\n/g,""),o++;n.push(a),i++}return{rows:n,headers:r}};var E={SCRIPT:1,STYLE:1,NOSCRIPT:1,OBJECT:1,EMBED:1,SELECT:1},M=1;k=function(t,i,e){var n,r,o,a,s,l,h,u;for(r=t.childNodes,n=void 0,(s="block"===(o=I(t)).display)&&(i.setBlockBoundary(),i.setBlockStyle(o)),a=0,l=r.length;a<l;){if("object"===se(n=r[a])){if(i.executeWatchFunctions(n),1===n.nodeType&&"HEADER"===n.nodeName){var c=n,f=i.pdf.margins_doc.top;i.pdf.internal.events.subscribe("addPage",function(t){i.y=f,k(c,i,e),i.pdf.margins_doc.top=i.y+10,i.y+=10},!1)}if(8===n.nodeType&&"#comment"===n.nodeName)~n.textContent.indexOf("ADD_PAGE")&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top);else if(1!==n.nodeType||E[n.nodeName])if(3===n.nodeType){var p=n.nodeValue;if(n.nodeValue&&"LI"===n.parentNode.nodeName)if("OL"===n.parentNode.parentNode.nodeName)p=M+++". "+p;else{var d=o["font-size"],g=(3-.75*d)*i.pdf.internal.scaleFactor,m=.75*d*i.pdf.internal.scaleFactor,y=1.74*d/i.pdf.internal.scaleFactor;u=function(t,e){this.pdf.circle(t+g,e+m,y,"FD")}}16&n.ownerDocument.body.compareDocumentPosition(n)&&i.addText(p,o)}else"string"==typeof n&&i.addText(n,o);else{var v;if("IMG"===n.nodeName){var w=n.getAttribute("src");v=B[i.pdf.sHashCode(w)||w]}if(v){i.pdf.internal.pageSize.getHeight()-i.pdf.margins_doc.bottom<i.y+n.height&&i.y>i.pdf.margins_doc.top&&(i.pdf.addPage(),i.y=i.pdf.margins_doc.top,i.executeWatchFunctions(n));var b=I(n),x=i.x,N=12/i.pdf.internal.scaleFactor,L=(b["margin-left"]+b["padding-left"])*N,A=(b["margin-right"]+b["padding-right"])*N,S=(b["margin-top"]+b["padding-top"])*N,_=(b["margin-bottom"]+b["padding-bottom"])*N;void 0!==b.float&&"right"===b.float?x+=i.settings.width-n.width-A:x+=L,i.pdf.addImage(v,x,i.y+S,n.width,n.height),v=void 0,"right"===b.float||"left"===b.float?(i.watchFunctions.push(function(t,e,n,r){return i.y>=e?(i.x+=t,i.settings.width+=n,!0):!!(r&&1===r.nodeType&&!E[r.nodeName]&&i.x+r.width>i.pdf.margins_doc.left+i.pdf.margins_doc.width)&&(i.x+=t,i.y=e,i.settings.width+=n,!0)}.bind(this,"left"===b.float?-n.width-L-A:0,i.y+n.height+S+_,n.width)),i.watchFunctions.push(function(t,e,n){return!(i.y<t&&e===i.pdf.internal.getNumberOfPages())||1===n.nodeType&&"both"===I(n).clear&&(i.y=t,!0)}.bind(this,i.y+n.height,i.pdf.internal.getNumberOfPages())),i.settings.width-=n.width+L+A,"left"===b.float&&(i.x+=n.width+L+A)):i.y+=n.height+S+_}else if("TABLE"===n.nodeName)h=j(n,i),i.y+=10,i.pdf.table(i.x,i.y,h.rows,h.headers,{autoSize:!1,printHeaders:e.printHeaders,margins:i.pdf.margins_doc,css:I(n)}),i.y=i.pdf.lastCellPos.y+i.pdf.lastCellPos.h+20;else if("OL"===n.nodeName||"UL"===n.nodeName)M=1,C(n,i,e)||k(n,i,e),i.y+=10;else if("LI"===n.nodeName){var F=i.x;i.x+=20/i.pdf.internal.scaleFactor,i.y+=3,C(n,i,e)||k(n,i,e),i.x=F}else"BR"===n.nodeName?(i.y+=o["font-size"]*i.pdf.internal.scaleFactor,i.addText("\u2028",P(o))):C(n,i,e)||k(n,i,e)}}a++}if(e.outY=i.y,s)return i.setBlockBoundary(u)},B={},d=function(t,o,e,n){var a,r=t.getElementsByTagName("img"),i=r.length,s=0;function l(){o.pdf.internal.events.publish("imagesLoaded"),n(a)}function h(e,n,r){if(e){var i=new Image;a=++s,i.crossOrigin="",i.onerror=i.onload=function(){if(i.complete&&(0===i.src.indexOf("data:image/")&&(i.width=n||i.width||0,i.height=r||i.height||0),i.width+i.height)){var t=o.pdf.sHashCode(e)||e;B[t]=B[t]||i}--s||l()},i.src=e}}for(;i--;)h(r[i].getAttribute("src"),r[i].width,r[i].height);return s||l()},g=function(t,o,a){var s=t.getElementsByTagName("footer");if(0<s.length){s=s[0];var e=o.pdf.internal.write,n=o.y;o.pdf.internal.write=function(){},k(s,o,a);var l=Math.ceil(o.y-n)+5;o.y=n,o.pdf.internal.write=e,o.pdf.margins_doc.bottom+=l;for(var r=function(t){var e=void 0!==t?t.pageNumber:1,n=o.y;o.y=o.pdf.internal.pageSize.getHeight()-o.pdf.margins_doc.bottom,o.pdf.margins_doc.bottom-=l;for(var r=s.getElementsByTagName("span"),i=0;i<r.length;++i)-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" pageCounter ")&&(r[i].innerHTML=e),-1<(" "+r[i].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&(r[i].innerHTML="###jsPDFVarTotalPages###");k(s,o,a),o.pdf.margins_doc.bottom+=l,o.y=n},i=s.getElementsByTagName("span"),h=0;h<i.length;++h)-1<(" "+i[h].className+" ").replace(/[\n\t]/g," ").indexOf(" totalPages ")&&o.pdf.internal.events.subscribe("htmlRenderingFinished",o.pdf.putTotalPages.bind(o.pdf,"###jsPDFVarTotalPages###"),!0);o.pdf.internal.events.subscribe("addPage",r,!1),r(),E.FOOTER=1}},m=function(t,e,n,r,i,o){if(!e)return!1;var a,s,l,h;"string"==typeof e||e.parentNode||(e=""+e.innerHTML),"string"==typeof e&&(a=e.replace(/<\/?script[^>]*?>/gi,""),h="jsPDFhtmlText"+Date.now().toString()+(1e3*Math.random()).toFixed(0),(l=document.createElement("div")).style.cssText="position: absolute !important;clip: rect(1px 1px 1px 1px); /* IE6, IE7 */clip: rect(1px, 1px, 1px, 1px);padding:0 !important;border:0 !important;height: 1px !important;width: 1px !important; top:auto;left:-100px;overflow: hidden;",l.innerHTML='<iframe style="height:1px;width:1px" name="'+h+'" />',document.body.appendChild(l),(s=window.frames[h]).document.open(),s.document.writeln(a),s.document.close(),e=s.document.body);var u,c=new f(t,n,r,i);return d.call(this,e,c,i.elementHandlers,function(t){g(e,c,i.elementHandlers),k(e,c,i.elementHandlers),c.pdf.internal.events.publish("htmlRenderingFinished"),u=c.dispose(),"function"==typeof o?o(u):t&&console.error("jsPDF Warning: rendering issues? provide a callback to fromHTML!")}),u||{x:c.x,y:c.y}},(f=function(t,e,n,r){return this.pdf=t,this.x=e,this.y=n,this.settings=r,this.watchFunctions=[],this.init(),this}).prototype.init=function(){return this.paragraph={text:[],style:[]},this.pdf.internal.write("q")},f.prototype.dispose=function(){return this.pdf.internal.write("Q"),{x:this.x,y:this.y,ready:!0}},f.prototype.executeWatchFunctions=function(t){var e=!1,n=[];if(0<this.watchFunctions.length){for(var r=0;r<this.watchFunctions.length;++r)!0===this.watchFunctions[r](t)?e=!0:n.push(this.watchFunctions[r]);this.watchFunctions=n}return e},f.prototype.splitFragmentsIntoLines=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g;for(12,c=this.pdf.internal.scaleFactor,o={},s=l=h=g=a=i=u=r=void 0,p=[f=[]],n=0,d=this.settings.width;t.length;)if(a=t.shift(),g=e.shift(),a)if((i=o[(r=g["font-family"])+(u=g["font-style"])])||(i=this.pdf.internal.getFont(r,u).metadata.Unicode,o[r+u]=i),h={widths:i.widths,kerning:i.kerning,fontSize:12*g["font-size"],textIndent:n},l=this.pdf.getStringUnitWidth(a,h)*h.fontSize/c,"\u2028"==a)f=[],p.push(f);else if(d<n+l){for(s=this.pdf.splitTextToSize(a,d,h),f.push([s.shift(),g]);s.length;)f=[[s.shift(),g]],p.push(f);n=this.pdf.getStringUnitWidth(f[0][0],h)*h.fontSize/c}else f.push([a,g]),n+=l;if(void 0!==g["text-align"]&&("center"===g["text-align"]||"right"===g["text-align"]||"justify"===g["text-align"]))for(var m=0;m<p.length;++m){var y=this.pdf.getStringUnitWidth(p[m][0][0],h)*h.fontSize/c;0<m&&(p[m][0][1]=P(p[m][0][1]));var v=d-y;if("right"===g["text-align"])p[m][0][1]["margin-left"]=v;else if("center"===g["text-align"])p[m][0][1]["margin-left"]=v/2;else if("justify"===g["text-align"]){var w=p[m][0][0].split(" ").length-1;p[m][0][1]["word-spacing"]=v/w,m===p.length-1&&(p[m][0][1]["word-spacing"]=0)}}return p},f.prototype.RenderTextFragment=function(t,e){var n,r;r=0,this.pdf.internal.pageSize.getHeight()-this.pdf.margins_doc.bottom<this.y+this.pdf.internal.getFontSize()&&(this.pdf.internal.write("ET","Q"),this.pdf.addPage(),this.y=this.pdf.margins_doc.top,this.pdf.internal.write("q","BT",this.getPdfColor(e.color),this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td"),r=Math.max(r,e["line-height"],e["font-size"]),this.pdf.internal.write(0,(-12*r).toFixed(2),"Td")),n=this.pdf.internal.getFont(e["font-family"],e["font-style"]);var i=this.getPdfColor(e.color);i!==this.lastTextColor&&(this.pdf.internal.write(i),this.lastTextColor=i),void 0!==e["word-spacing"]&&0<e["word-spacing"]&&this.pdf.internal.write(e["word-spacing"].toFixed(2),"Tw"),this.pdf.internal.write("/"+n.id,(12*e["font-size"]).toFixed(2),"Tf","("+this.pdf.internal.pdfEscape(t)+") Tj"),void 0!==e["word-spacing"]&&this.pdf.internal.write(0,"Tw")},f.prototype.getPdfColor=function(t){var e,n,r,i=/rgb\s*\(\s*(\d+),\s*(\d+),\s*(\d+\s*)\)/.exec(t);if(null!=i)e=parseInt(i[1]),n=parseInt(i[2]),r=parseInt(i[3]);else{if("string"==typeof t&&"#"!=t.charAt(0)){var o=new RGBColor(t);t=o.ok?o.toHex():"#000000"}e=t.substring(1,3),e=parseInt(e,16),n=t.substring(3,5),n=parseInt(n,16),r=t.substring(5,7),r=parseInt(r,16)}if("string"==typeof e&&/^#[0-9A-Fa-f]{6}$/.test(e)){var a=parseInt(e.substr(1),16);e=a>>16&255,n=a>>8&255,r=255&a}var s=this.f3;return 0===e&&0===n&&0===r||void 0===n?s(e/255)+" g":[s(e/255),s(n/255),s(r/255),"rg"].join(" ")},f.prototype.f3=function(t){return t.toFixed(3)},f.prototype.renderParagraph=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;if(r=w(this.paragraph.text),f=this.paragraph.style,e=this.paragraph.blockstyle,this.paragraph.priorblockstyle||{},this.paragraph={text:[],style:[],blockstyle:{},priorblockstyle:e},r.join("").trim()){s=this.splitFragmentsIntoLines(r,f),l=a=void 0,n=12/this.pdf.internal.scaleFactor,this.priorMarginBottom=this.priorMarginBottom||0,c=(Math.max((e["margin-top"]||0)-this.priorMarginBottom,0)+(e["padding-top"]||0))*n,u=((e["margin-bottom"]||0)+(e["padding-bottom"]||0))*n,this.priorMarginBottom=e["margin-bottom"]||0,"always"===e["page-break-before"]&&(this.pdf.addPage(),this.y=0,c=((e["margin-top"]||0)+(e["padding-top"]||0))*n),h=this.pdf.internal.write,o=i=void 0,this.y+=c,h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td");for(var d=0;s.length;){for(i=l=0,o=(a=s.shift()).length;i!==o;)a[i][0].trim()&&(l=Math.max(l,a[i][1]["line-height"],a[i][1]["font-size"]),p=7*a[i][1]["font-size"]),i++;var g=0,m=0;for(void 0!==a[0][1]["margin-left"]&&0<a[0][1]["margin-left"]&&(g=(m=this.pdf.internal.getCoordinateString(a[0][1]["margin-left"]))-d,d=m),h(g+Math.max(e["margin-left"]||0,0)*n,(-12*l).toFixed(2),"Td"),i=0,o=a.length;i!==o;)a[i][0]&&this.RenderTextFragment(a[i][0],a[i][1]),i++;if(this.y+=l*n,this.executeWatchFunctions(a[0][1])&&0<s.length){var y=[],v=[];s.forEach(function(t){for(var e=0,n=t.length;e!==n;)t[e][0]&&(y.push(t[e][0]+" "),v.push(t[e][1])),++e}),s=this.splitFragmentsIntoLines(w(y),v),h("ET","Q"),h("q","BT 0 g",this.pdf.internal.getCoordinateString(this.x),this.pdf.internal.getVerticalCoordinateString(this.y),"Td")}}return t&&"function"==typeof t&&t.call(this,this.x-9,this.y-p/2),h("ET","Q"),this.y+=u}},f.prototype.setBlockBoundary=function(t){return this.renderParagraph(t)},f.prototype.setBlockStyle=function(t){return this.paragraph.blockstyle=t},f.prototype.addText=function(t,e){return this.paragraph.text.push(t),this.paragraph.style.push(e)},i={helvetica:"helvetica","sans-serif":"helvetica","times new roman":"times",serif:"times",times:"times",monospace:"courier",courier:"courier"},l={100:"normal",200:"normal",300:"normal",400:"normal",500:"bold",600:"bold",700:"bold",800:"bold",900:"bold",normal:"normal",bold:"bold",bolder:"bold",lighter:"normal"},a={normal:"normal",italic:"italic",oblique:"italic"},s={left:"left",right:"right",center:"center",justify:"justify"},h={none:"none",right:"right",left:"left"},u={none:"none",both:"both"},n={normal:1},t.fromHTML=function(t,e,n,r,i,o){return this.margins_doc=o||{top:0,bottom:0},r||(r={}),r.elementHandlers||(r.elementHandlers={}),m(this,t,isNaN(e)?4:e,isNaN(n)?4:n,r,i)}}(lt.API),lt.API,("undefined"!=typeof window&&window||"undefined"!=typeof global&&global).html2pdf=function(t,a,e){var n=a.canvas;if(n){var r,i;if((n.pdf=a).annotations={_nameMap:[],createAnnotation:function(t,e){var n,r=a.context2d._wrapX(e.left),i=a.context2d._wrapY(e.top),o=(a.context2d._page(e.top),t.indexOf("#"));n=0<=o?{name:t.substring(o+1)}:{url:t},a.link(r,i,e.right-e.left,e.bottom-e.top,n)},setName:function(t,e){var n=a.context2d._wrapX(e.left),r=a.context2d._wrapY(e.top),i=a.context2d._page(e.top);this._nameMap[t]={page:i,x:n,y:r}}},n.annotations=a.annotations,a.context2d._pageBreakAt=function(t){this.pageBreaks.push(t)},a.context2d._gotoPage=function(t){for(;a.internal.getNumberOfPages()<t;)a.addPage();a.setPage(t)},"string"==typeof t){t=t.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,"");var o,s,l=document.createElement("iframe");document.body.appendChild(l),null!=(o=l.contentDocument)&&null!=o||(o=l.contentWindow.document),o.open(),o.write(t),o.close(),r=o.body,s=o.body||{},t=o.documentElement||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight)}else s=(r=t).body||{},i=Math.max(s.scrollHeight,s.offsetHeight,t.clientHeight,t.scrollHeight,t.offsetHeight);var h={async:!0,allowTaint:!0,backgroundColor:"#ffffff",canvas:n,imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1,windowHeight:i=a.internal.pageSize.getHeight(),scrollY:i};a.context2d.pageWrapYEnabled=!0,a.context2d.pageWrapY=a.internal.pageSize.getHeight(),html2canvas(r,h).then(function(t){e&&(l&&l.parentElement.removeChild(l),e(a))})}else alert("jsPDF canvas plugin not installed")},window.tmp=html2pdf,function(f){var r=f.BlobBuilder||f.WebKitBlobBuilder||f.MSBlobBuilder||f.MozBlobBuilder;f.URL=f.URL||f.webkitURL||function(t,e){return(e=document.createElement("a")).href=t,e};var n=f.Blob,p=URL.createObjectURL,d=URL.revokeObjectURL,o=f.Symbol&&f.Symbol.toStringTag,t=!1,e=!1,g=!!f.ArrayBuffer,i=r&&r.prototype.append&&r.prototype.getBlob;try{t=2===new Blob(["ä"]).size,e=2===new Blob([new Uint8Array([1,2])]).size}catch(t){}function a(t){return t.map(function(t){if(t.buffer instanceof ArrayBuffer){var e=t.buffer;if(t.byteLength!==e.byteLength){var n=new Uint8Array(t.byteLength);n.set(new Uint8Array(e,t.byteOffset,t.byteLength)),e=n.buffer}return e}return t})}function s(t,e){e=e||{};var n=new r;return a(t).forEach(function(t){n.append(t)}),e.type?n.getBlob(e.type):n.getBlob()}function l(t,e){return new n(a(t),e||{})}if(f.Blob&&(s.prototype=Blob.prototype,l.prototype=Blob.prototype),o)try{File.prototype[o]="File",Blob.prototype[o]="Blob",FileReader.prototype[o]="FileReader"}catch(t){}function h(){var t=!!f.ActiveXObject||"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style,e=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;t&&e&&(XMLHttpRequest.prototype.send=function(t){t instanceof Blob&&this.setRequestHeader("Content-Type",t.type),e.call(this,t)});try{new File([],"")}catch(t){try{var n=new Function('class File extends Blob {constructor(chunks, name, opts) {opts = opts || {};super(chunks, opts || {});this.name = name;this.lastModifiedDate = opts.lastModified ? new Date(opts.lastModified) : new Date;this.lastModified = +this.lastModifiedDate;}};return new File([], ""), File')();f.File=n}catch(t){n=function(t,e,n){var r=new Blob(t,n),i=n&&void 0!==n.lastModified?new Date(n.lastModified):new Date;return r.name=e,r.lastModifiedDate=i,r.lastModified=+i,r.toString=function(){return"[object File]"},o&&(r[o]="File"),r};f.File=n}}}t?(h(),f.Blob=e?f.Blob:l):i?(h(),f.Blob=s):function(){function a(t){for(var e=[],n=0;n<t.length;n++){var r=t.charCodeAt(n);r<128?e.push(r):r<2048?e.push(192|r>>6,128|63&r):r<55296||57344<=r?e.push(224|r>>12,128|r>>6&63,128|63&r):(n++,r=65536+((1023&r)<<10|1023&t.charCodeAt(n)),e.push(240|r>>18,128|r>>12&63,128|r>>6&63,128|63&r))}return e}function e(t){var e,n,r,i,o,a;for(e="",r=t.length,n=0;n<r;)switch((i=t[n++])>>4){case 0:case 1:case 2:case 3:case 4:case 5:case 6:case 7:e+=String.fromCharCode(i);break;case 12:case 13:o=t[n++],e+=String.fromCharCode((31&i)<<6|63&o);break;case 14:o=t[n++],a=t[n++],e+=String.fromCharCode((15&i)<<12|(63&o)<<6|(63&a)<<0)}return e}function s(t){for(var e=new Array(t.byteLength),n=new Uint8Array(t),r=e.length;r--;)e[r]=n[r];return e}function n(t){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",n=[],r=0;r<t.length;r+=3){var i=t[r],o=r+1<t.length,a=o?t[r+1]:0,s=r+2<t.length,l=s?t[r+2]:0,h=i>>2,u=(3&i)<<4|a>>4,c=(15&a)<<2|l>>6,f=63&l;s||(f=64,o||(c=64)),n.push(e[h],e[u],e[c],e[f])}return n.join("")}var t=Object.create||function(t){function e(){}return e.prototype=t,new e};if(g)var r=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],l=ArrayBuffer.isView||function(t){return t&&-1<r.indexOf(Object.prototype.toString.call(t))};function h(t,e){for(var n=0,r=(t=t||[]).length;n<r;n++){var i=t[n];i instanceof h?t[n]=i._buffer:"string"==typeof i?t[n]=a(i):g&&(ArrayBuffer.prototype.isPrototypeOf(i)||l(i))?t[n]=s(i):g&&(o=i)&&DataView.prototype.isPrototypeOf(o)?t[n]=s(i.buffer):t[n]=a(String(i))}var o;this._buffer=[].concat.apply([],t),this.size=this._buffer.length,this.type=e&&e.type||""}function i(t,e,n){var r=h.call(this,t,n=n||{})||this;return r.name=e,r.lastModifiedDate=n.lastModified?new Date(n.lastModified):new Date,r.lastModified=+r.lastModifiedDate,r}if(h.prototype.slice=function(t,e,n){return new h([this._buffer.slice(t||0,e||this._buffer.length)],{type:n})},h.prototype.toString=function(){return"[object Blob]"},(i.prototype=t(h.prototype)).constructor=i,Object.setPrototypeOf)Object.setPrototypeOf(i,h);else try{i.__proto__=h}catch(t){}function o(){if(!(this instanceof o))throw new TypeError("Failed to construct 'FileReader': Please use the 'new' operator, this DOM object constructor cannot be called as a function.");var n=document.createDocumentFragment();this.addEventListener=n.addEventListener,this.dispatchEvent=function(t){var e=this["on"+t.type];"function"==typeof e&&e(t),n.dispatchEvent(t)},this.removeEventListener=n.removeEventListener}function u(t,e,n){if(!(e instanceof h))throw new TypeError("Failed to execute '"+n+"' on 'FileReader': parameter 1 is not of type 'Blob'.");t.result="",setTimeout(function(){this.readyState=o.LOADING,t.dispatchEvent(new Event("load")),t.dispatchEvent(new Event("loadend"))})}i.prototype.toString=function(){return"[object File]"},o.EMPTY=0,o.LOADING=1,o.DONE=2,o.prototype.error=null,o.prototype.onabort=null,o.prototype.onerror=null,o.prototype.onload=null,o.prototype.onloadend=null,o.prototype.onloadstart=null,o.prototype.onprogress=null,o.prototype.readAsDataURL=function(t){u(this,t,"readAsDataURL"),this.result="data:"+t.type+";base64,"+n(t._buffer)},o.prototype.readAsText=function(t){u(this,t,"readAsText"),this.result=e(t._buffer)},o.prototype.readAsArrayBuffer=function(t){u(this,t,"readAsText"),this.result=t._buffer.slice()},o.prototype.abort=function(){},URL.createObjectURL=function(t){return t instanceof h?"data:"+t.type+";base64,"+n(t._buffer):p.call(URL,t)},URL.revokeObjectURL=function(t){d&&d.call(URL,t)};var c=f.XMLHttpRequest&&f.XMLHttpRequest.prototype.send;c&&(XMLHttpRequest.prototype.send=function(t){t instanceof h?(this.setRequestHeader("Content-Type",t.type),c.call(this,e(t._buffer))):c.call(this,t)}),f.FileReader=o,f.File=i,f.Blob=h}()}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")());var ht,ut,ct,ft,pt,dt,gt,mt,yt,vt,wt,bt,xt,Nt,Lt,le=le||function(s){if(!(void 0===s||"undefined"!=typeof navigator&&/MSIE [1-9]\./.test(navigator.userAgent))){var t=s.document,l=function(){return s.URL||s.webkitURL||s},h=t.createElementNS("http://www.w3.org/1999/xhtml","a"),u="download"in h,c=/constructor/i.test(s.HTMLElement)||s.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),p=s.setImmediate||s.setTimeout,d=function(t){p(function(){throw t},0)},g=function(t){setTimeout(function(){"string"==typeof t?l().revokeObjectURL(t):t.remove()},4e4)},m=function(t){return/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t},r=function(t,n,e){e||(t=m(t));var r,i=this,o="application/octet-stream"===t.type,a=function(){!function(t,e,n){for(var r=(e=[].concat(e)).length;r--;){var i=t["on"+e[r]];if("function"==typeof i)try{i.call(t,n||t)}catch(t){d(t)}}}(i,"writestart progress write writeend".split(" "))};if(i.readyState=i.INIT,u)return r=l().createObjectURL(t),void p(function(){var t,e;h.href=r,h.download=n,t=h,e=new MouseEvent("click"),t.dispatchEvent(e),a(),g(r),i.readyState=i.DONE},0);!function(){if((f||o&&c)&&s.FileReader){var e=new FileReader;return e.onloadend=function(){var t=f?e.result:e.result.replace(/^data:[^;]*;/,"data:attachment/file;");s.open(t,"_blank")||(s.location.href=t),t=void 0,i.readyState=i.DONE,a()},e.readAsDataURL(t),i.readyState=i.INIT}r||(r=l().createObjectURL(t)),o?s.location.href=r:s.open(r,"_blank")||(s.location.href=r);i.readyState=i.DONE,a(),g(r)}()},e=r.prototype;return"undefined"!=typeof navigator&&navigator.msSaveOrOpenBlob?function(t,e,n){return e=e||t.name||"download",n||(t=m(t)),navigator.msSaveOrOpenBlob(t,e)}:(e.abort=function(){},e.readyState=e.INIT=0,e.WRITING=1,e.DONE=2,e.error=e.onwritestart=e.onprogress=e.onwrite=e.onabort=e.onerror=e.onwriteend=null,function(t,e,n){return new r(t,e||t.name||"download",n)})}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||void 0);function At(x){var t=0;if(71!==x[t++]||73!==x[t++]||70!==x[t++]||56!==x[t++]||56!=(x[t++]+1&253)||97!==x[t++])throw"Invalid GIF 87a/89a header.";var N=x[t++]|x[t++]<<8,e=x[t++]|x[t++]<<8,n=x[t++],r=n>>7,i=1<<(7&n)+1;x[t++];x[t++];var o=null;r&&(o=t,t+=3*i);var a=!0,s=[],l=0,h=null,u=0,c=null;for(this.width=N,this.height=e;a&&t<x.length;)switch(x[t++]){case 33:switch(x[t++]){case 255:if(11!==x[t]||78==x[t+1]&&69==x[t+2]&&84==x[t+3]&&83==x[t+4]&&67==x[t+5]&&65==x[t+6]&&80==x[t+7]&&69==x[t+8]&&50==x[t+9]&&46==x[t+10]&&48==x[t+11]&&3==x[t+12]&&1==x[t+13]&&0==x[t+16])t+=14,c=x[t++]|x[t++]<<8,t++;else for(t+=12;;){if(0===(A=x[t++]))break;t+=A}break;case 249:if(4!==x[t++]||0!==x[t+4])throw"Invalid graphics extension block.";var f=x[t++];l=x[t++]|x[t++]<<8,h=x[t++],0==(1&f)&&(h=null),u=f>>2&7,t++;break;case 254:for(;;){if(0===(A=x[t++]))break;t+=A}break;default:throw"Unknown graphic control label: 0x"+x[t-1].toString(16)}break;case 44:var p=x[t++]|x[t++]<<8,d=x[t++]|x[t++]<<8,g=x[t++]|x[t++]<<8,m=x[t++]|x[t++]<<8,y=x[t++],v=y>>6&1,w=o,b=!1;if(y>>7){b=!0;w=t,t+=3*(1<<(7&y)+1)}var L=t;for(t++;;){var A;if(0===(A=x[t++]))break;t+=A}s.push({x:p,y:d,width:g,height:m,has_local_palette:b,palette_offset:w,data_offset:L,data_length:t-L,transparent_index:h,interlaced:!!v,delay:l,disposal:u});break;case 59:a=!1;break;default:throw"Unknown gif block: 0x"+x[t-1].toString(16)}this.numFrames=function(){return s.length},this.loopCount=function(){return c},this.frameInfo=function(t){if(t<0||t>=s.length)throw"Frame index out of range.";return s[t]},this.decodeAndBlitFrameBGRA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=b,e[f++]=w,e[f++]=v,e[f++]=255}--h}},this.decodeAndBlitFrameRGBA=function(t,e){var n=this.frameInfo(t),r=n.width*n.height,i=new Uint8Array(r);St(x,n.data_offset,i,r);var o=n.palette_offset,a=n.transparent_index;null===a&&(a=256);var s=n.width,l=N-s,h=s,u=4*(n.y*N+n.x),c=4*((n.y+n.height)*N+n.x),f=u,p=4*l;!0===n.interlaced&&(p+=4*(s+l)*7);for(var d=8,g=0,m=i.length;g<m;++g){var y=i[g];if(0===h&&(h=s,c<=(f+=p)&&(p=l+4*(s+l)*(d-1),f=u+(s+l)*(d<<1),d>>=1)),y===a)f+=4;else{var v=x[o+3*y],w=x[o+3*y+1],b=x[o+3*y+2];e[f++]=v,e[f++]=w,e[f++]=b,e[f++]=255}--h}}}function St(t,e,n,r){for(var i=t[e++],o=1<<i,a=o+1,s=a+1,l=i+1,h=(1<<l)-1,u=0,c=0,f=0,p=t[e++],d=new Int32Array(4096),g=null;;){for(;u<16&&0!==p;)c|=t[e++]<<u,u+=8,1===p?p=t[e++]:--p;if(u<l)break;var m=c&h;if(c>>=l,u-=l,m!==o){if(m===a)break;for(var y=m<s?m:g,v=0,w=y;o<w;)w=d[w]>>8,++v;var b=w;if(r<f+v+(y!==m?1:0))return void console.log("Warning, gif stream longer than expected.");n[f++]=b;var x=f+=v;for(y!==m&&(n[f++]=b),w=y;v--;)w=d[w],n[--x]=255&w,w>>=8;null!==g&&s<4096&&(d[s++]=g<<8|b,h+1<=s&&l<12&&(++l,h=h<<1|1)),g=m}else s=a+1,h=(1<<(l=i+1))-1,g=null}return f!==r&&console.log("Warning, gif stream shorter than expected."),n}try{exports.GifWriter=function(y,t,e,n){var v=0,r=void 0===(n=void 0===n?{}:n).loop?null:n.loop,w=void 0===n.palette?null:n.palette;if(t<=0||e<=0||65535<t||65535<e)throw"Width/Height invalid.";function b(t){var e=t.length;if(e<2||256<e||e&e-1)throw"Invalid code/color length, must be power of 2 and 2 .. 256.";return e}y[v++]=71,y[v++]=73,y[v++]=70,y[v++]=56,y[v++]=57,y[v++]=97;var i=0,o=0;if(null!==w){for(var a=b(w);a>>=1;)++i;if(a=1<<i,--i,void 0!==n.background){if(a<=(o=n.background))throw"Background index out of range.";if(0===o)throw"Background index explicitly passed as 0."}}if(y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=(null!==w?128:0)|i,y[v++]=o,y[v++]=0,null!==w)for(var s=0,l=w.length;s<l;++s){var h=w[s];y[v++]=h>>16&255,y[v++]=h>>8&255,y[v++]=255&h}if(null!==r){if(r<0||65535<r)throw"Loop count invalid.";y[v++]=33,y[v++]=255,y[v++]=11,y[v++]=78,y[v++]=69,y[v++]=84,y[v++]=83,y[v++]=67,y[v++]=65,y[v++]=80,y[v++]=69,y[v++]=50,y[v++]=46,y[v++]=48,y[v++]=3,y[v++]=1,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=0}var x=!1;this.addFrame=function(t,e,n,r,i,o){if(!0===x&&(--v,x=!1),o=void 0===o?{}:o,t<0||e<0||65535<t||65535<e)throw"x/y invalid.";if(n<=0||r<=0||65535<n||65535<r)throw"Width/Height invalid.";if(i.length<n*r)throw"Not enough pixels for the frame size.";var a=!0,s=o.palette;if(null==s&&(a=!1,s=w),null==s)throw"Must supply either a local or global palette.";for(var l=b(s),h=0;l>>=1;)++h;l=1<<h;var u=void 0===o.delay?0:o.delay,c=void 0===o.disposal?0:o.disposal;if(c<0||3<c)throw"Disposal out of range.";var f=!1,p=0;if(void 0!==o.transparent&&null!==o.transparent&&(f=!0,(p=o.transparent)<0||l<=p))throw"Transparent color index.";if((0!==c||f||0!==u)&&(y[v++]=33,y[v++]=249,y[v++]=4,y[v++]=c<<2|(!0===f?1:0),y[v++]=255&u,y[v++]=u>>8&255,y[v++]=p,y[v++]=0),y[v++]=44,y[v++]=255&t,y[v++]=t>>8&255,y[v++]=255&e,y[v++]=e>>8&255,y[v++]=255&n,y[v++]=n>>8&255,y[v++]=255&r,y[v++]=r>>8&255,y[v++]=!0===a?128|h-1:0,!0===a)for(var d=0,g=s.length;d<g;++d){var m=s[d];y[v++]=m>>16&255,y[v++]=m>>8&255,y[v++]=255&m}v=function(e,n,t,r){e[n++]=t;var i=n++,o=1<<t,a=o-1,s=o+1,l=s+1,h=t+1,u=0,c=0;function f(t){for(;t<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++)}function p(t){c|=t<<u,u+=h,f(8)}var d=r[0]&a,g={};p(o);for(var m=1,y=r.length;m<y;++m){var v=r[m]&a,w=d<<8|v,b=g[w];if(void 0===b){for(c|=d<<u,u+=h;8<=u;)e[n++]=255&c,c>>=8,u-=8,n===i+256&&(e[i]=255,i=n++);4096===l?(p(o),l=s+1,h=t+1,g={}):(1<<h<=l&&++h,g[w]=l++),d=v}else d=b}return p(d),p(s),f(1),i+1===n?e[i]=0:(e[i]=n-i-1,e[n++]=0),n}(y,v,h<2?2:h,i)},this.end=function(){return!1===x&&(y[v++]=59,x=!0),v}},exports.GifReader=At}catch(t){}
/*
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */
function _t(t){var N,L,A,S,e,c=Math.floor,_=new Array(64),F=new Array(64),P=new Array(64),k=new Array(64),y=new Array(65535),v=new Array(65535),Z=new Array(64),w=new Array(64),I=[],C=0,B=7,j=new Array(64),E=new Array(64),M=new Array(64),n=new Array(256),O=new Array(2048),b=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],q=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],T=[0,1,2,3,4,5,6,7,8,9,10,11],R=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],D=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],U=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],z=[0,1,2,3,4,5,6,7,8,9,10,11],H=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],W=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function r(t,e){for(var n=0,r=0,i=new Array,o=1;o<=16;o++){for(var a=1;a<=t[o];a++)i[e[r]]=[],i[e[r]][0]=n,i[e[r]][1]=o,r++,n++;n*=2}return i}function V(t){for(var e=t[0],n=t[1]-1;0<=n;)e&1<<n&&(C|=1<<B),n--,--B<0&&(255==C?(G(255),G(0)):G(C),B=7,C=0)}function G(t){I.push(t)}function Y(t){G(t>>8&255),G(255&t)}function J(t,e,n,r,i){for(var o,a=i[0],s=i[240],l=function(t,e){var n,r,i,o,a,s,l,h,u,c,f=0;for(u=0;u<8;++u){n=t[f],r=t[f+1],i=t[f+2],o=t[f+3],a=t[f+4],s=t[f+5],l=t[f+6];var p=n+(h=t[f+7]),d=n-h,g=r+l,m=r-l,y=i+s,v=i-s,w=o+a,b=o-a,x=p+w,N=p-w,L=g+y,A=g-y;t[f]=x+L,t[f+4]=x-L;var S=.707106781*(A+N);t[f+2]=N+S,t[f+6]=N-S;var _=.382683433*((x=b+v)-(A=m+d)),F=.5411961*x+_,P=1.306562965*A+_,k=.707106781*(L=v+m),I=d+k,C=d-k;t[f+5]=C+F,t[f+3]=C-F,t[f+1]=I+P,t[f+7]=I-P,f+=8}for(u=f=0;u<8;++u){n=t[f],r=t[f+8],i=t[f+16],o=t[f+24],a=t[f+32],s=t[f+40],l=t[f+48];var B=n+(h=t[f+56]),j=n-h,E=r+l,M=r-l,O=i+s,q=i-s,T=o+a,R=o-a,D=B+T,U=B-T,z=E+O,H=E-O;t[f]=D+z,t[f+32]=D-z;var W=.707106781*(H+U);t[f+16]=U+W,t[f+48]=U-W;var V=.382683433*((D=R+q)-(H=M+j)),G=.5411961*D+V,Y=1.306562965*H+V,J=.707106781*(z=q+M),X=j+J,K=j-J;t[f+40]=K+G,t[f+24]=K-G,t[f+8]=X+Y,t[f+56]=X-Y,f++}for(u=0;u<64;++u)c=t[u]*e[u],Z[u]=0<c?c+.5|0:c-.5|0;return Z}(t,e),h=0;h<64;++h)w[b[h]]=l[h];var u=w[0]-n;n=w[0],0==u?V(r[0]):(V(r[v[o=32767+u]]),V(y[o]));for(var c=63;0<c&&0==w[c];c--);if(0==c)return V(a),n;for(var f,p=1;p<=c;){for(var d=p;0==w[p]&&p<=c;++p);var g=p-d;if(16<=g){f=g>>4;for(var m=1;m<=f;++m)V(s);g&=15}o=32767+w[p],V(i[(g<<4)+v[o]]),V(y[o]),p++}return 63!=c&&V(a),n}function X(t){if(t<=0&&(t=1),100<t&&(t=100),e!=t){(function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],n=0;n<64;n++){var r=c((e[n]*t+50)/100);r<1?r=1:255<r&&(r=255),_[b[n]]=r}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],o=0;o<64;o++){var a=c((i[o]*t+50)/100);a<1?a=1:255<a&&(a=255),F[b[o]]=a}for(var s=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],l=0,h=0;h<8;h++)for(var u=0;u<8;u++)P[l]=1/(_[b[l]]*s[h]*s[u]*8),k[l]=1/(F[b[l]]*s[h]*s[u]*8),l++})(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),e=t}}this.encode=function(t,e){var n,r;(new Date).getTime();e&&X(e),I=new Array,C=0,B=7,Y(65496),Y(65504),Y(16),G(74),G(70),G(73),G(70),G(0),G(1),G(1),G(0),Y(1),Y(1),G(0),G(0),function(){Y(65499),Y(132),G(0);for(var t=0;t<64;t++)G(_[t]);G(1);for(var e=0;e<64;e++)G(F[e])}(),n=t.width,r=t.height,Y(65472),Y(17),G(8),Y(r),Y(n),G(3),G(1),G(17),G(0),G(2),G(17),G(1),G(3),G(17),G(1),function(){Y(65476),Y(418),G(0);for(var t=0;t<16;t++)G(q[t+1]);for(var e=0;e<=11;e++)G(T[e]);G(16);for(var n=0;n<16;n++)G(R[n+1]);for(var r=0;r<=161;r++)G(D[r]);G(1);for(var i=0;i<16;i++)G(U[i+1]);for(var o=0;o<=11;o++)G(z[o]);G(17);for(var a=0;a<16;a++)G(H[a+1]);for(var s=0;s<=161;s++)G(W[s])}(),Y(65498),Y(12),G(3),G(1),G(0),G(2),G(17),G(3),G(17),G(0),G(63),G(0);var i=0,o=0,a=0;C=0,B=7,this.encode.displayName="_encode_";for(var s,l,h,u,c,f,p,d,g,m=t.data,y=t.width,v=t.height,w=4*y,b=0;b<v;){for(s=0;s<w;){for(f=c=w*b+s,p=-1,g=d=0;g<64;g++)f=c+(d=g>>3)*w+(p=4*(7&g)),v<=b+d&&(f-=w*(b+1+d-v)),w<=s+p&&(f-=s+p-w+4),l=m[f++],h=m[f++],u=m[f++],j[g]=(O[l]+O[h+256>>0]+O[u+512>>0]>>16)-128,E[g]=(O[l+768>>0]+O[h+1024>>0]+O[u+1280>>0]>>16)-128,M[g]=(O[l+1280>>0]+O[h+1536>>0]+O[u+1792>>0]>>16)-128;i=J(j,P,i,N,A),o=J(E,k,o,L,S),a=J(M,k,a,L,S),s+=32}b+=8}if(0<=B){var x=[];x[1]=B+1,x[0]=(1<<B+1)-1,V(x)}return Y(65497),new Uint8Array(I)},function(){(new Date).getTime();t||(t=50),function(){for(var t=String.fromCharCode,e=0;e<256;e++)n[e]=t(e)}(),N=r(q,T),L=r(U,z),A=r(R,D),S=r(H,W),function(){for(var t=1,e=2,n=1;n<=15;n++){for(var r=t;r<e;r++)v[32767+r]=n,y[32767+r]=[],y[32767+r][1]=n,y[32767+r][0]=r;for(var i=-(e-1);i<=-t;i++)v[32767+i]=n,y[32767+i]=[],y[32767+i][1]=n,y[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)O[t]=19595*t,O[t+256>>0]=38470*t,O[t+512>>0]=7471*t+32768,O[t+768>>0]=-11059*t,O[t+1024>>0]=-21709*t,O[t+1280>>0]=32768*t+8421375,O[t+1536>>0]=-27439*t,O[t+1792>>0]=-5329*t}(),X(t),(new Date).getTime()}()}function Ft(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}window.tmp=At,lt.API.adler32cs=(dt="function"==typeof ArrayBuffer&&"function"==typeof Uint8Array,gt=null,mt=function(){if(!dt)return function(){return!1};try{var t={};"function"==typeof t.Buffer&&(gt=t.Buffer)}catch(t){}return function(t){return t instanceof ArrayBuffer||null!==gt&&t instanceof gt}}(),yt=null!==gt?function(t){return new gt(t,"utf8").toString("binary")}:function(t){return unescape(encodeURIComponent(t))},vt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+(255&e.charCodeAt(i)))%65521,r=(r+n)%65521;return(r<<16|n)>>>0},wt=function(t,e){for(var n=65535&t,r=t>>>16,i=0,o=e.length;i<o;i++)n=(n+e[i])%65521,r=(r+n)%65521;return(r<<16|n)>>>0},xt=(bt={}).Adler32=(((pt=(ft=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!isFinite(t=null==t?1:+t))throw new Error("First arguments needs to be a finite number.");this.checksum=t>>>0}).prototype={}).constructor=ft).from=((ht=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");this.checksum=vt(1,t.toString())}).prototype=pt,ht),ft.fromUtf8=((ut=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());this.checksum=vt(1,e)}).prototype=pt,ut),dt&&(ft.fromBuffer=((ct=function(t){if(!(this instanceof ft))throw new TypeError("Constructor cannot called be as a function.");if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(1,e)}).prototype=pt,ct)),pt.update=function(t){if(null==t)throw new Error("First argument needs to be a string.");return t=t.toString(),this.checksum=vt(this.checksum,t)},pt.updateUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return this.checksum=vt(this.checksum,e)},dt&&(pt.updateBuffer=function(t){if(!mt(t))throw new Error("First argument needs to be ArrayBuffer.");var e=new Uint8Array(t);return this.checksum=wt(this.checksum,e)}),pt.clone=function(){return new xt(this.checksum)},ft),bt.from=function(t){if(null==t)throw new Error("First argument needs to be a string.");return vt(1,t.toString())},bt.fromUtf8=function(t){if(null==t)throw new Error("First argument needs to be a string.");var e=yt(t.toString());return vt(1,e)},dt&&(bt.fromBuffer=function(t){if(!mt(t))throw new Error("First argument need to be ArrayBuffer.");var e=new Uint8Array(t);return wt(1,e)}),bt),function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var d,g,c,f,i,o,a,s=e,m=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],y=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],v={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},l={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},h=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],u=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),w=!1,b=0;this.__bidiEngine__={};var x=function(t){var e=t.charCodeAt(),n=e>>8,r=l[n];return void 0!==r?s[256*r+(255&e)]:252===n||253===n?"AL":u.test(n)?"L":8===n?"R":"N"},p=function(t){for(var e,n=0;n<t.length;n++){if("L"===(e=x(t.charAt(n))))return!1;if("R"===e)return!0}return!1},N=function(t,e,n,r){var i,o,a,s,l=e[r];switch(l){case"L":case"R":w=!1;break;case"N":case"AN":break;case"EN":w&&(l="AN");break;case"AL":w=!0,l="R";break;case"WS":l="N";break;case"CS":r<1||r+1>=e.length||"EN"!==(i=n[r-1])&&"AN"!==i||"EN"!==(o=e[r+1])&&"AN"!==o?l="N":w&&(o="AN"),l=o===i?o:"N";break;case"ES":l="EN"===(i=0<r?n[r-1]:"B")&&r+1<e.length&&"EN"===e[r+1]?"EN":"N";break;case"ET":if(0<r&&"EN"===n[r-1]){l="EN";break}if(w){l="N";break}for(a=r+1,s=e.length;a<s&&"ET"===e[a];)a++;l=a<s&&"EN"===e[a]?"EN":"N";break;case"NSM":if(c&&!f){for(s=e.length,a=r+1;a<s&&"NSM"===e[a];)a++;if(a<s){var h=t[r],u=1425<=h&&h<=2303||64286===h;if(i=e[a],u&&("R"===i||"AL"===i)){l="R";break}}}l=r<1||"B"===(i=e[r-1])?"N":n[r-1];break;case"B":d=!(w=!1),l=b;break;case"S":g=!0,l="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":w=!1;break;case"BN":l="N"}return l},L=function(t,e,n){var r=t.split("");return n&&A(r,n,{hiLevel:b}),r.reverse(),e&&e.reverse(),r.join("")},A=function(t,e,n){var r,i,o,a,s,l=-1,h=t.length,u=0,c=[],f=b?y:m,p=[];for(g=d=w=!1,i=0;i<h;i++)p[i]=x(t[i]);for(o=0;o<h;o++){if(s=u,c[o]=N(t,p,c,o),r=240&(u=f[s][v[c[o]]]),u&=15,e[o]=a=f[u][5],0<r)if(16===r){for(i=l;i<o;i++)e[i]=1;l=-1}else l=-1;if(f[u][6])-1===l&&(l=o);else if(-1<l){for(i=l;i<o;i++)e[i]=a;l=-1}"B"===p[o]&&(e[o]=0),n.hiLevel|=a}g&&function(t,e,n){for(var r=0;r<n;r++)if("S"===t[r]){e[r]=b;for(var i=r-1;0<=i&&"WS"===t[i];i--)e[i]=b}}(p,e,h)},S=function(t,e,n,r,i){if(!(i.hiLevel<t)){if(1===t&&1===b&&!d)return e.reverse(),void(n&&n.reverse());for(var o,a,s,l,h=e.length,u=0;u<h;){if(r[u]>=t){for(s=u+1;s<h&&r[s]>=t;)s++;for(l=u,a=s-1;l<a;l++,a--)o=e[l],e[l]=e[a],e[a]=o,n&&(o=n[l],n[l]=n[a],n[a]=o);u=s}u++}}},_=function(t,e,n){var r=t.split(""),i={hiLevel:b};return n||(n=[]),A(r,n,i),function(t,e,n){if(0!==n.hiLevel&&a)for(var r,i=0;i<t.length;i++)1===e[i]&&0<=(r=h.indexOf(t[i]))&&(t[i]=h[r+1])}(r,n,i),S(2,r,e,n,i),S(1,r,e,n,i),r.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,n){if(function(t,e){if(e)for(var n=0;n<t.length;n++)e[n]=n;void 0===f&&(f=p(t)),void 0===o&&(o=p(t))}(t,e),c||!i||o)if(c&&i&&f^o)b=f?1:0,t=L(t,e,n);else if(!c&&i&&o)b=f?1:0,t=_(t,e,n),t=L(t,e);else if(!c||f||i||o){if(c&&!i&&f^o)t=L(t,e),t=f?(b=0,_(t,e,n)):(b=1,t=_(t,e,n),L(t,e));else if(c&&f&&!i&&o)b=1,t=_(t,e,n),t=L(t,e);else if(!c&&!i&&f^o){var r=a;f?(b=1,t=_(t,e,n),b=0,a=!1,t=_(t,e,n),a=r):(b=0,t=_(t,e,n),t=L(t,e),a=!(b=1),t=_(t,e,n),a=r,t=L(t,e))}}else b=0,t=_(t,e,n);else b=f?1:0,t=_(t,e,n);return t},this.__bidiEngine__.setOptions=function(t){t&&(c=t.isInputVisual,i=t.isOutputVisual,f=t.isInputRtl,o=t.isOutputRtl,a=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],o=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),r=(t.mutex,n.lang,[]);if("[object Array]"===Object.prototype.toString.call(e)){var i=0;for(r=[],i=0;i<e.length;i+=1)"[object Array]"===Object.prototype.toString.call(e[i])?r.push([o.doBidiReorder(e[i][0]),e[i][1],e[i][2]]):r.push([o.doBidiReorder(e[i])]);t.text=r}else t.text=o.doBidiReorder(e)}])}(lt),window.tmp=_t,Ft.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var n=this.datav.getUint8(this.pos++,!0),r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:r,blue:n,quad:o}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},Ft.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){console.log("bit decode error:"+t)}},Ft.prototype.bit1=function(){var t=Math.ceil(this.width/8),e=t%4,n=0<=this.height?this.height-1:-this.height;for(n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++)for(var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var l=this.palette[o>>7-s&1];this.data[a+4*s]=l.blue,this.data[a+4*s+1]=l.green,this.data[a+4*s+2]=l.red,this.data[a+4*s+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<t;i++){var o=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+2*i*4,s=o>>4,l=15&o,h=this.palette[s];if(this.data[a]=h.blue,this.data[a+1]=h.green,this.data[a+2]=h.red,this.data[a+3]=255,2*i+1>=this.width)break;h=this.palette[l],this.data[a+4]=h.blue,this.data[a+4+1]=h.green,this.data[a+4+2]=h.red,this.data[a+4+3]=255}0!=e&&(this.pos+=4-e)}},Ft.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;0<=e;e--){for(var n=this.bottom_up?e:this.height-1-e,r=0;r<this.width;r++){var i=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+4*r;if(i<this.palette.length){var a=this.palette[i];this.data[o]=a.red,this.data[o+1]=a.green,this.data[o+2]=a.blue,this.data[o+3]=255}else this.data[o]=255,this.data[o+1]=255,this.data[o+2]=255,this.data[o+3]=255}0!=t&&(this.pos+=4-t)}},Ft.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),n=this.height-1;0<=n;n--){for(var r=this.bottom_up?n:this.height-1-n,i=0;i<this.width;i++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var a=(o&e)/e*255|0,s=(o>>5&e)/e*255|0,l=(o>>10&e)/e*255|0,h=o>>15?255:0,u=r*this.width*4+4*i;this.data[u]=l,this.data[u+1]=s,this.data[u+2]=a,this.data[u+3]=h}this.pos+=t}},Ft.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),n=parseInt("111111",2),r=this.height-1;0<=r;r--){for(var i=this.bottom_up?r:this.height-1-r,o=0;o<this.width;o++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(a&e)/e*255|0,l=(a>>5&n)/n*255|0,h=(a>>11)/e*255|0,u=i*this.width*4+4*o;this.data[u]=h,this.data[u+1]=l,this.data[u+2]=s,this.data[u+3]=255}this.pos+=t}},Ft.prototype.bit24=function(){for(var t=this.height-1;0<=t;t--){for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=e*this.width*4+4*n;this.data[a]=o,this.data[a+1]=i,this.data[a+2]=r,this.data[a+3]=255}this.pos+=this.width%4}},Ft.prototype.bit32=function(){for(var t=this.height-1;0<=t;t--)for(var e=this.bottom_up?t:this.height-1-t,n=0;n<this.width;n++){var r=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*n;this.data[s]=o,this.data[s+1]=i,this.data[s+2]=r,this.data[s+3]=a}},Ft.prototype.getData=function(){return this.data},window.tmp=Ft,
/*
   Copyright (c) 2013 Gildas Lormeau. All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions are met:

   1. Redistributions of source code must retain the above copyright notice,
   this list of conditions and the following disclaimer.

   2. Redistributions in binary form must reproduce the above copyright 
   notice, this list of conditions and the following disclaimer in 
   the documentation and/or other materials provided with the distribution.

   3. The names of the authors may not be used to endorse or promote products
   derived from this software without specific prior written permission.

   THIS SOFTWARE IS PROVIDED ``AS IS'' AND ANY EXPRESSED OR IMPLIED WARRANTIES,
   INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
   FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL JCRAFT,
   INC. OR ANY CONTRIBUTORS TO THIS SOFTWARE BE LIABLE FOR ANY DIRECT, INDIRECT,
   INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
   LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA,
   OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
   EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
   */
function(t){var d=15,g=573,e=[0,1,2,3,4,4,5,5,6,6,6,6,7,7,7,7,8,8,8,8,8,8,8,8,9,9,9,9,9,9,9,9,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,10,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,11,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,12,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,13,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,14,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,15,0,0,16,17,18,18,19,19,20,20,20,20,21,21,21,21,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29,29];function ct(){var p=this;function l(t,e){for(var n=0;n|=1&t,t>>>=1,n<<=1,0<--e;);return n>>>1}p.build_tree=function(t){var e,n,r,i=p.dyn_tree,o=p.stat_desc.static_tree,a=p.stat_desc.elems,s=-1;for(t.heap_len=0,t.heap_max=g,e=0;e<a;e++)0!==i[2*e]?(t.heap[++t.heap_len]=s=e,t.depth[e]=0):i[2*e+1]=0;for(;t.heap_len<2;)i[2*(r=t.heap[++t.heap_len]=s<2?++s:0)]=1,t.depth[r]=0,t.opt_len--,o&&(t.static_len-=o[2*r+1]);for(p.max_code=s,e=Math.floor(t.heap_len/2);1<=e;e--)t.pqdownheap(i,e);for(r=a;e=t.heap[1],t.heap[1]=t.heap[t.heap_len--],t.pqdownheap(i,1),n=t.heap[1],t.heap[--t.heap_max]=e,t.heap[--t.heap_max]=n,i[2*r]=i[2*e]+i[2*n],t.depth[r]=Math.max(t.depth[e],t.depth[n])+1,i[2*e+1]=i[2*n+1]=r,t.heap[1]=r++,t.pqdownheap(i,1),2<=t.heap_len;);t.heap[--t.heap_max]=t.heap[1],function(t){var e,n,r,i,o,a,s=p.dyn_tree,l=p.stat_desc.static_tree,h=p.stat_desc.extra_bits,u=p.stat_desc.extra_base,c=p.stat_desc.max_length,f=0;for(i=0;i<=d;i++)t.bl_count[i]=0;for(s[2*t.heap[t.heap_max]+1]=0,e=t.heap_max+1;e<g;e++)c<(i=s[2*s[2*(n=t.heap[e])+1]+1]+1)&&(i=c,f++),s[2*n+1]=i,n>p.max_code||(t.bl_count[i]++,o=0,u<=n&&(o=h[n-u]),a=s[2*n],t.opt_len+=a*(i+o),l&&(t.static_len+=a*(l[2*n+1]+o)));if(0!==f){do{for(i=c-1;0===t.bl_count[i];)i--;t.bl_count[i]--,t.bl_count[i+1]+=2,t.bl_count[c]--,f-=2}while(0<f);for(i=c;0!==i;i--)for(n=t.bl_count[i];0!==n;)(r=t.heap[--e])>p.max_code||(s[2*r+1]!=i&&(t.opt_len+=(i-s[2*r+1])*s[2*r],s[2*r+1]=i),n--)}}(t),function(t,e,n){var r,i,o,a=[],s=0;for(r=1;r<=d;r++)a[r]=s=s+n[r-1]<<1;for(i=0;i<=e;i++)0!==(o=t[2*i+1])&&(t[2*i]=l(a[o]++,o))}(i,p.max_code,t.bl_count)}}function ft(t,e,n,r,i){this.static_tree=t,this.extra_bits=e,this.extra_base=n,this.elems=r,this.max_length=i}ct._length_code=[0,1,2,3,4,5,6,7,8,8,9,9,10,10,11,11,12,12,12,12,13,13,13,13,14,14,14,14,15,15,15,15,16,16,16,16,16,16,16,16,17,17,17,17,17,17,17,17,18,18,18,18,18,18,18,18,19,19,19,19,19,19,19,19,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,20,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,21,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,22,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,23,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,24,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,25,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,26,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,27,28],ct.base_length=[0,1,2,3,4,5,6,7,8,10,12,14,16,20,24,28,32,40,48,56,64,80,96,112,128,160,192,224,0],ct.base_dist=[0,1,2,3,4,6,8,12,16,24,32,48,64,96,128,192,256,384,512,768,1024,1536,2048,3072,4096,6144,8192,12288,16384,24576],ct.d_code=function(t){return t<256?e[t]:e[256+(t>>>7)]},ct.extra_lbits=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],ct.extra_dbits=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],ct.extra_blbits=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],ct.bl_order=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],ft.static_ltree=[12,8,140,8,76,8,204,8,44,8,172,8,108,8,236,8,28,8,156,8,92,8,220,8,60,8,188,8,124,8,252,8,2,8,130,8,66,8,194,8,34,8,162,8,98,8,226,8,18,8,146,8,82,8,210,8,50,8,178,8,114,8,242,8,10,8,138,8,74,8,202,8,42,8,170,8,106,8,234,8,26,8,154,8,90,8,218,8,58,8,186,8,122,8,250,8,6,8,134,8,70,8,198,8,38,8,166,8,102,8,230,8,22,8,150,8,86,8,214,8,54,8,182,8,118,8,246,8,14,8,142,8,78,8,206,8,46,8,174,8,110,8,238,8,30,8,158,8,94,8,222,8,62,8,190,8,126,8,254,8,1,8,129,8,65,8,193,8,33,8,161,8,97,8,225,8,17,8,145,8,81,8,209,8,49,8,177,8,113,8,241,8,9,8,137,8,73,8,201,8,41,8,169,8,105,8,233,8,25,8,153,8,89,8,217,8,57,8,185,8,121,8,249,8,5,8,133,8,69,8,197,8,37,8,165,8,101,8,229,8,21,8,149,8,85,8,213,8,53,8,181,8,117,8,245,8,13,8,141,8,77,8,205,8,45,8,173,8,109,8,237,8,29,8,157,8,93,8,221,8,61,8,189,8,125,8,253,8,19,9,275,9,147,9,403,9,83,9,339,9,211,9,467,9,51,9,307,9,179,9,435,9,115,9,371,9,243,9,499,9,11,9,267,9,139,9,395,9,75,9,331,9,203,9,459,9,43,9,299,9,171,9,427,9,107,9,363,9,235,9,491,9,27,9,283,9,155,9,411,9,91,9,347,9,219,9,475,9,59,9,315,9,187,9,443,9,123,9,379,9,251,9,507,9,7,9,263,9,135,9,391,9,71,9,327,9,199,9,455,9,39,9,295,9,167,9,423,9,103,9,359,9,231,9,487,9,23,9,279,9,151,9,407,9,87,9,343,9,215,9,471,9,55,9,311,9,183,9,439,9,119,9,375,9,247,9,503,9,15,9,271,9,143,9,399,9,79,9,335,9,207,9,463,9,47,9,303,9,175,9,431,9,111,9,367,9,239,9,495,9,31,9,287,9,159,9,415,9,95,9,351,9,223,9,479,9,63,9,319,9,191,9,447,9,127,9,383,9,255,9,511,9,0,7,64,7,32,7,96,7,16,7,80,7,48,7,112,7,8,7,72,7,40,7,104,7,24,7,88,7,56,7,120,7,4,7,68,7,36,7,100,7,20,7,84,7,52,7,116,7,3,8,131,8,67,8,195,8,35,8,163,8,99,8,227,8],ft.static_dtree=[0,5,16,5,8,5,24,5,4,5,20,5,12,5,28,5,2,5,18,5,10,5,26,5,6,5,22,5,14,5,30,5,1,5,17,5,9,5,25,5,5,5,21,5,13,5,29,5,3,5,19,5,11,5,27,5,7,5,23,5],ft.static_l_desc=new ft(ft.static_ltree,ct.extra_lbits,257,286,d),ft.static_d_desc=new ft(ft.static_dtree,ct.extra_dbits,0,30,d),ft.static_bl_desc=new ft(null,ct.extra_blbits,0,19,7);function n(t,e,n,r,i){this.good_length=t,this.max_lazy=e,this.nice_length=n,this.max_chain=r,this.func=i}var pt=[new n(0,0,0,0,0),new n(4,4,8,4,1),new n(4,5,16,8,1),new n(4,6,32,32,1),new n(4,4,16,16,2),new n(8,16,32,32,2),new n(8,16,128,128,2),new n(8,32,128,256,2),new n(32,128,258,1024,2),new n(32,258,258,4096,2)],dt=["need dictionary","stream end","","","stream error","data error","","buffer error","",""];function gt(t,e,n,r){var i=t[2*e],o=t[2*n];return i<o||i==o&&r[e]<=r[n]}function r(){var l,h,u,c,f,p,d,g,i,m,y,v,w,a,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,s,O,q,T,R,D,U,o,z,H,W,V=this,G=new ct,Y=new ct,J=new ct;function X(){var t;for(t=0;t<286;t++)s[2*t]=0;for(t=0;t<30;t++)O[2*t]=0;for(t=0;t<19;t++)q[2*t]=0;s[512]=1,V.opt_len=V.static_len=0,D=o=0}function K(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),t[2*(e+1)+1]=65535,n=0;n<=e;n++)r=o,o=t[2*(n+1)+1],++a<s&&r==o||(a<l?q[2*r]+=a:0!==r?(r!=i&&q[2*r]++,q[32]++):a<=10?q[34]++:q[36]++,i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4))}function Z(t){V.pending_buf[V.pending++]=t}function Q(t){Z(255&t),Z(t>>>8&255)}function $(t,e){var n,r=e;16-r<W?(Q(H|=(n=t)<<W&65535),H=n>>>16-W,W+=r-16):(H|=t<<W&65535,W+=r)}function tt(t,e){var n=2*t;$(65535&e[n],65535&e[n+1])}function et(t,e){var n,r,i=-1,o=t[1],a=0,s=7,l=4;for(0===o&&(s=138,l=3),n=0;n<=e;n++)if(r=o,o=t[2*(n+1)+1],!(++a<s&&r==o)){if(a<l)for(;tt(r,q),0!=--a;);else 0!==r?(r!=i&&(tt(r,q),a--),tt(16,q),$(a-3,2)):a<=10?(tt(17,q),$(a-3,3)):(tt(18,q),$(a-11,7));i=r,l=(a=0)===o?(s=138,3):r==o?(s=6,3):(s=7,4)}}function nt(){16==W?(Q(H),W=H=0):8<=W&&(Z(255&H),H>>>=8,W-=8)}function rt(t,e){var n,r,i;if(V.pending_buf[U+2*D]=t>>>8&255,V.pending_buf[U+2*D+1]=255&t,V.pending_buf[T+D]=255&e,D++,0===t?s[2*e]++:(o++,t--,s[2*(ct._length_code[e]+256+1)]++,O[2*ct.d_code(t)]++),0==(8191&D)&&2<B){for(n=8*D,r=_-N,i=0;i<30;i++)n+=O[2*i]*(5+ct.extra_dbits[i]);if(n>>>=3,o<Math.floor(D/2)&&n<Math.floor(r/2))return!0}return D==R-1}function it(t,e){var n,r,i,o,a=0;if(0!==D)for(;n=V.pending_buf[U+2*a]<<8&65280|255&V.pending_buf[U+2*a+1],r=255&V.pending_buf[T+a],a++,0===n?tt(r,t):(tt((i=ct._length_code[r])+256+1,t),0!==(o=ct.extra_lbits[i])&&$(r-=ct.base_length[i],o),tt(i=ct.d_code(--n),e),0!==(o=ct.extra_dbits[i])&&$(n-=ct.base_dist[i],o)),a<D;);tt(256,t),z=t[513]}function ot(){8<W?Q(H):0<W&&Z(255&H),W=H=0}function at(t,e,n){var r,i,o;$(0+(n?1:0),3),r=t,i=e,o=!0,ot(),z=8,o&&(Q(i),Q(~i)),V.pending_buf.set(g.subarray(r,r+i),V.pending),V.pending+=i}function e(t,e,n){var r,i,o=0;0<B?(G.build_tree(V),Y.build_tree(V),o=function(){var t;for(K(s,G.max_code),K(O,Y.max_code),J.build_tree(V),t=18;3<=t&&0===q[2*ct.bl_order[t]+1];t--);return V.opt_len+=3*(t+1)+5+5+4,t}(),r=V.opt_len+3+7>>>3,(i=V.static_len+3+7>>>3)<=r&&(r=i)):r=i=e+5,e+4<=r&&-1!=t?at(t,e,n):i==r?($(2+(n?1:0),3),it(ft.static_ltree,ft.static_dtree)):($(4+(n?1:0),3),function(t,e,n){var r;for($(t-257,5),$(e-1,5),$(n-4,4),r=0;r<n;r++)$(q[2*ct.bl_order[r]+1],3);et(s,t-1),et(O,e-1)}(G.max_code+1,Y.max_code+1,o+1),it(s,O)),X(),n&&ot()}function st(t){e(0<=N?N:-1,_-N,t),N=_,l.flush_pending()}function lt(){var t,e,n,r;do{if(0===(r=i-P-_)&&0===_&&0===P)r=f;else if(-1==r)r--;else if(f+f-262<=_){for(g.set(g.subarray(f,f+f),0),F-=f,_-=f,N-=f,n=t=w;e=65535&y[--n],y[n]=f<=e?e-f:0,0!=--t;);for(n=t=f;e=65535&m[--n],m[n]=f<=e?e-f:0,0!=--t;);r+=f}if(0===l.avail_in)return;t=l.read_buf(g,_+P,r),3<=(P+=t)&&(v=((v=255&g[_])<<x^255&g[_+1])&b)}while(P<262&&0!==l.avail_in)}function ht(t){var e,n,r=I,i=_,o=k,a=f-262<_?_-(f-262):0,s=M,l=d,h=_+258,u=g[i+o-1],c=g[i+o];E<=k&&(r>>=2),P<s&&(s=P);do{if(g[(e=t)+o]==c&&g[e+o-1]==u&&g[e]==g[i]&&g[++e]==g[i+1]){i+=2,e++;do{}while(g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&g[++i]==g[++e]&&i<h);if(n=258-(h-i),i=h-258,o<n){if(F=t,s<=(o=n))break;u=g[i+o-1],c=g[i+o]}}}while((t=65535&m[t&l])>a&&0!=--r);return o<=P?o:P}function ut(t){return t.total_in=t.total_out=0,t.msg=null,V.pending=0,V.pending_out=0,h=113,c=0,G.dyn_tree=s,G.stat_desc=ft.static_l_desc,Y.dyn_tree=O,Y.stat_desc=ft.static_d_desc,J.dyn_tree=q,J.stat_desc=ft.static_bl_desc,W=H=0,z=8,X(),function(){var t;for(i=2*f,t=y[w-1]=0;t<w-1;t++)y[t]=0;C=pt[B].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain,L=k=2,v=S=P=N=_=0}(),0}V.depth=[],V.bl_count=[],V.heap=[],s=[],O=[],q=[],V.pqdownheap=function(t,e){for(var n=V.heap,r=n[e],i=e<<1;i<=V.heap_len&&(i<V.heap_len&&gt(t,n[i+1],n[i],V.depth)&&i++,!gt(t,r,n[i],V.depth));)n[e]=n[i],e=i,i<<=1;n[e]=r},V.deflateInit=function(t,e,n,r,i,o){return r||(r=8),i||(i=8),o||(o=0),t.msg=null,-1==e&&(e=6),i<1||9<i||8!=r||n<9||15<n||e<0||9<e||o<0||2<o?-2:(t.dstate=V,d=(f=1<<(p=n))-1,b=(w=1<<(a=i+7))-1,x=Math.floor((a+3-1)/3),g=new Uint8Array(2*f),m=[],y=[],R=1<<i+6,V.pending_buf=new Uint8Array(4*R),u=4*R,U=Math.floor(R/2),T=3*R,B=e,j=o,ut(t))},V.deflateEnd=function(){return 42!=h&&113!=h&&666!=h?-2:(V.pending_buf=null,g=m=y=null,V.dstate=null,113==h?-3:0)},V.deflateParams=function(t,e,n){var r=0;return-1==e&&(e=6),e<0||9<e||n<0||2<n?-2:(pt[B].func!=pt[e].func&&0!==t.total_in&&(r=t.deflate(1)),B!=e&&(C=pt[B=e].max_lazy,E=pt[B].good_length,M=pt[B].nice_length,I=pt[B].max_chain),j=n,r)},V.deflateSetDictionary=function(t,e,n){var r,i=n,o=0;if(!e||42!=h)return-2;if(i<3)return 0;for(f-262<i&&(o=n-(i=f-262)),g.set(e.subarray(o,o+i),0),N=_=i,v=((v=255&g[0])<<x^255&g[1])&b,r=0;r<=i-3;r++)v=(v<<x^255&g[r+2])&b,m[r&d]=y[v],y[v]=r;return 0},V.deflate=function(t,e){var n,r,i,o,a,s;if(4<e||e<0)return-2;if(!t.next_out||!t.next_in&&0!==t.avail_in||666==h&&4!=e)return t.msg=dt[4],-2;if(0===t.avail_out)return t.msg=dt[7],-5;if(l=t,o=c,c=e,42==h&&(r=8+(p-8<<4)<<8,3<(i=(B-1&255)>>1)&&(i=3),r|=i<<6,0!==_&&(r|=32),h=113,Z((s=r+=31-r%31)>>8&255),Z(255&s)),0!==V.pending){if(l.flush_pending(),0===l.avail_out)return c=-1,0}else if(0===l.avail_in&&e<=o&&4!=e)return l.msg=dt[7],-5;if(666==h&&0!==l.avail_in)return t.msg=dt[7],-5;if(0!==l.avail_in||0!==P||0!=e&&666!=h){switch(a=-1,pt[B].func){case 0:a=function(t){var e,n=65535;for(u-5<n&&(n=u-5);;){if(P<=1){if(lt(),0===P&&0==t)return 0;if(0===P)break}if(_+=P,e=N+n,((P=0)===_||e<=_)&&(P=_-e,_=e,st(!1),0===l.avail_out))return 0;if(f-262<=_-N&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 1:a=function(t){for(var e,n=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_),0!==n&&(_-n&65535)<=f-262&&2!=j&&(L=ht(n)),3<=L)if(e=rt(_-F,L-3),P-=L,L<=C&&3<=P){for(L--;v=(v<<x^255&g[++_+2])&b,n=65535&y[v],m[_&d]=y[v],y[v]=_,0!=--L;);_++}else _+=L,L=0,v=((v=255&g[_])<<x^255&g[_+1])&b;else e=rt(0,255&g[_]),P--,_++;if(e&&(st(!1),0===l.avail_out))return 0}return st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e);break;case 2:a=function(t){for(var e,n,r=0;;){if(P<262){if(lt(),P<262&&0==t)return 0;if(0===P)break}if(3<=P&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),k=L,A=F,L=2,0!==r&&k<C&&(_-r&65535)<=f-262&&(2!=j&&(L=ht(r)),L<=5&&(1==j||3==L&&4096<_-F)&&(L=2)),3<=k&&L<=k){for(n=_+P-3,e=rt(_-1-A,k-3),P-=k-1,k-=2;++_<=n&&(v=(v<<x^255&g[_+2])&b,r=65535&y[v],m[_&d]=y[v],y[v]=_),0!=--k;);if(S=0,L=2,_++,e&&(st(!1),0===l.avail_out))return 0}else if(0!==S){if((e=rt(0,255&g[_-1]))&&st(!1),_++,P--,0===l.avail_out)return 0}else S=1,_++,P--}return 0!==S&&(e=rt(0,255&g[_-1]),S=0),st(4==t),0===l.avail_out?4==t?2:0:4==t?3:1}(e)}if(2!=a&&3!=a||(h=666),0==a||2==a)return 0===l.avail_out&&(c=-1),0;if(1==a){if(1==e)$(2,3),tt(256,ft.static_ltree),nt(),1+z+10-W<9&&($(2,3),tt(256,ft.static_ltree),nt()),z=7;else if(at(0,0,!1),3==e)for(n=0;n<w;n++)y[n]=0;if(l.flush_pending(),0===l.avail_out)return c=-1,0}}return 4!=e?0:1}}function i(){this.next_in_index=0,this.next_out_index=0,this.avail_in=0,this.total_in=0,this.avail_out=0,this.total_out=0}i.prototype={deflateInit:function(t,e){return this.dstate=new r,e||(e=d),this.dstate.deflateInit(this,t,e)},deflate:function(t){return this.dstate?this.dstate.deflate(this,t):-2},deflateEnd:function(){if(!this.dstate)return-2;var t=this.dstate.deflateEnd();return this.dstate=null,t},deflateParams:function(t,e){return this.dstate?this.dstate.deflateParams(this,t,e):-2},deflateSetDictionary:function(t,e){return this.dstate?this.dstate.deflateSetDictionary(this,t,e):-2},read_buf:function(t,e,n){var r=this.avail_in;return n<r&&(r=n),0===r?0:(this.avail_in-=r,t.set(this.next_in.subarray(this.next_in_index,this.next_in_index+r),e),this.next_in_index+=r,this.total_in+=r,r)},flush_pending:function(){var t=this,e=t.dstate.pending;e>t.avail_out&&(e=t.avail_out),0!==e&&(t.next_out.set(t.dstate.pending_buf.subarray(t.dstate.pending_out,t.dstate.pending_out+e),t.next_out_index),t.next_out_index+=e,t.dstate.pending_out+=e,t.total_out+=e,t.avail_out-=e,t.dstate.pending-=e,0===t.dstate.pending&&(t.dstate.pending_out=0))}};var o=t.zip||t;o.Deflater=o._jzlib_Deflater=function(t){var s=new i,l=new Uint8Array(512),e=t?t.level:-1;void 0===e&&(e=-1),s.deflateInit(e),s.next_out=l,this.append=function(t,e){var n,r=[],i=0,o=0,a=0;if(t.length){s.next_in_index=0,s.next_in=t,s.avail_in=t.length;do{if(s.next_out_index=0,s.avail_out=512,0!=s.deflate(0))throw new Error("deflating: "+s.msg);s.next_out_index&&(512==s.next_out_index?r.push(new Uint8Array(l)):r.push(new Uint8Array(l.subarray(0,s.next_out_index)))),a+=s.next_out_index,e&&0<s.next_in_index&&s.next_in_index!=i&&(e(s.next_in_index),i=s.next_in_index)}while(0<s.avail_in||0===s.avail_out);return n=new Uint8Array(a),r.forEach(function(t){n.set(t,o),o+=t.length}),n}},this.flush=function(){var t,e,n=[],r=0,i=0;do{if(s.next_out_index=0,s.avail_out=512,1!=(t=s.deflate(4))&&0!=t)throw new Error("deflating: "+s.msg);0<512-s.avail_out&&n.push(new Uint8Array(l.subarray(0,s.next_out_index))),i+=s.next_out_index}while(0<s.avail_in||0===s.avail_out);return s.deflateEnd(),e=new Uint8Array(i),n.forEach(function(t){e.set(t,r),r+=t.length}),e}}}("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()),("undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")()).RGBColor=function(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6)),t=(t=t.replace(/ /g,"")).toLowerCase();var n={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"};for(var r in n)t==r&&(t=n[r]);for(var i=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],o=0;o<i.length;o++){var a=i[o].re,s=i[o].process,l=a.exec(t);l&&(e=s(l),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:255<this.r?255:this.r,this.g=this.g<0||isNaN(this.g)?0:255<this.g?255:this.g,this.b=this.b<0||isNaN(this.b)?0:255<this.b?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),n=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==n.length&&(n="0"+n),"#"+t+e+n}},function(t){var n="+".charCodeAt(0),r="/".charCodeAt(0),i="0".charCodeAt(0),o="a".charCodeAt(0),a="A".charCodeAt(0),s="-".charCodeAt(0),l="_".charCodeAt(0),u=function(t){var e=t.charCodeAt(0);return e===n||e===s?62:e===r||e===l?63:e<i?-1:e<i+10?e-i+26+26:e<a+26?e-a:e<o+26?e-o+26:void 0};t.API.TTFFont=function(){function i(t,e,n){var r;if(this.rawData=t,r=this.contents=new J(t),this.contents.pos=4,"ttcf"===r.readString(4)){if(!e)throw new Error("Must specify a font name for TTC files.");throw new Error("Font "+e+" not found in TTC file.")}r.pos=0,this.parse(),this.subset=new P(this),this.registerTTF()}return i.open=function(t,e,n,r){if("string"!=typeof n)throw new Error("Invalid argument supplied in TTFFont.open");return new i(function(t){var e,n,r,i,o,a;if(0<t.length%4)throw new Error("Invalid string. Length must be a multiple of 4");var s=t.length;o="="===t.charAt(s-2)?2:"="===t.charAt(s-1)?1:0,a=new Uint8Array(3*t.length/4-o),r=0<o?t.length-4:t.length;var l=0;function h(t){a[l++]=t}for(n=e=0;e<r;e+=4,n+=3)h((16711680&(i=u(t.charAt(e))<<18|u(t.charAt(e+1))<<12|u(t.charAt(e+2))<<6|u(t.charAt(e+3))))>>16),h((65280&i)>>8),h(255&i);return 2===o?h(255&(i=u(t.charAt(e))<<2|u(t.charAt(e+1))>>4)):1===o&&(h((i=u(t.charAt(e))<<10|u(t.charAt(e+1))<<4|u(t.charAt(e+2))>>2)>>8&255),h(255&i)),a}(n),e,r)},i.prototype.parse=function(){return this.directory=new e(this.contents),this.head=new p(this),this.name=new b(this),this.cmap=new y(this),this.toUnicode=new Map,this.hhea=new g(this),this.maxp=new x(this),this.hmtx=new N(this),this.post=new v(this),this.os2=new m(this),this.loca=new F(this),this.glyf=new A(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},i.prototype.registerTTF=function(){var i,t,e,n,r;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.bbox).length;t<e;t++)i=n[t],r.push(Math.round(i*this.scaleFactor));return r}.call(this),this.stemV=0,this.post.exists?(e=255&(n=this.post.italic_angle),!0&(t=n>>16)&&(t=-(1+(65535^t))),this.italicAngle=+(t+"."+e)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(r=this.familyClass)||2===r||3===r||4===r||5===r||7===r,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},i.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},i.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},i.prototype.widthOfString=function(t,e,n){var r,i,o,a,s;for(i=a=o=0,s=(t=""+t).length;0<=s?a<s:s<a;i=0<=s?++a:--a)r=t.charCodeAt(i),o+=this.widthOfGlyph(this.characterToGlyph(r))+n*(1e3/e)||0;return o*(e/1e3)},i.prototype.lineHeight=function(t,e){var n;return null==e&&(e=!1),n=e?this.lineGap:0,(this.ascender+n-this.decender)/1e3*t},i}();var h,J=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return 2147483648<=(t=this.readUInt32())?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return 32768<=(t=this.readUInt16())?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,n,r;for(n=[],e=r=0;0<=t?r<t:t<r;e=0<=t?++r:--r)n[e]=String.fromCharCode(this.readByte());return n.join("")},t.prototype.writeString=function(t){var e,n,r,i;for(i=[],e=n=0,r=t.length;0<=r?n<r:r<n;e=0<=r?++n:--n)i.push(this.writeByte(t.charCodeAt(e)));return i},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,n,r,i,o,a,s;return t=this.readByte(),e=this.readByte(),n=this.readByte(),r=this.readByte(),i=this.readByte(),o=this.readByte(),a=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^n)+4294967296*(255^r)+16777216*(255^i)+65536*(255^o)+256*(255^a)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*n+4294967296*r+16777216*i+65536*o+256*a+s},t.prototype.writeLongLong=function(t){var e,n;return e=Math.floor(t/4294967296),n=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(n>>24&255),this.writeByte(n>>16&255),this.writeByte(n>>8&255),this.writeByte(255&n)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,n;for(e=[],n=0;0<=t?n<t:t<n;0<=t?++n:--n)e.push(this.readByte());return e},t.prototype.write=function(t){var e,n,r,i;for(i=[],n=0,r=t.length;n<r;n++)e=t[n],i.push(this.writeByte(e));return i},t}(),e=function(){var d;function t(t){var e,n,r;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},n=0,r=this.tableCount;0<=r?n<r:r<n;0<=r?++n:--n)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return t.prototype.encode=function(t){var e,n,r,i,o,a,s,l,h,u,c,f,p;for(p in c=Object.keys(t).length,a=Math.log(2),h=16*Math.floor(Math.log(c)/a),i=Math.floor(h/a),l=16*c-h,(n=new J).writeInt(this.scalarType),n.writeShort(c),n.writeShort(h),n.writeShort(i),n.writeShort(l),r=16*c,s=n.pos+r,o=null,f=[],t)for(u=t[p],n.writeString(p),n.writeInt(d(u)),n.writeInt(s),n.writeInt(u.length),f=f.concat(u),"head"===p&&(o=s),s+=u.length;s%4;)f.push(0),s++;return n.write(f),e=2981146554-d(n.data),n.pos=o+8,n.writeUInt32(e),n.data},d=function(t){var e,n,r,i;for(t=L.call(t);t.length%4;)t.push(0);for(n=new J(t),r=e=0,i=t.length;r<i;r+=4)e+=n.readUInt32();return 4294967295&e},t}(),c={}.hasOwnProperty,f=function(t,e){for(var n in e)c.call(e,n)&&(t[n]=e[n]);function r(){this.constructor=t}return r.prototype=e.prototype,t.prototype=new r,t.__super__=e.prototype,t};h=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}();var p=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new J).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(),d=function(){function t(n,t){var e,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w;switch(this.platformID=n.readUInt16(),this.encodingID=n.readShort(),this.offset=t+n.readInt(),u=n.pos,n.pos=this.offset,this.format=n.readUInt16(),this.length=n.readUInt16(),this.language=n.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=m=0;m<256;s=++m)this.codeMap[s]=n.readByte();break;case 4:for(f=n.readUInt16(),c=f/2,n.pos+=6,i=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),n.pos+=2,d=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),l=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),h=function(){var t,e;for(e=[],s=t=0;0<=c?t<c:c<t;s=0<=c?++t:--t)e.push(n.readUInt16());return e}(),r=(this.length-n.pos+this.offset)/2,a=function(){var t,e;for(e=[],s=t=0;0<=r?t<r:r<t;s=0<=r?++t:--t)e.push(n.readUInt16());return e}(),s=y=0,w=i.length;y<w;s=++y)for(g=i[s],e=v=p=d[s];p<=g?v<=g:g<=v;e=p<=g?++v:--v)0===h[s]?o=e+l[s]:0!==(o=a[h[s]/2+(e-p)-(c-s)]||0)&&(o+=l[s]),this.codeMap[e]=65535&o}n.pos=u}return t.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S,_,F,P,k,I,C,B,j,E,M,O,q,T,R,D,U,z,H,W,V,G,Y;switch(k=new J,o=Object.keys(t).sort(function(t,e){return t-e}),e){case"macroman":for(d=0,g=function(){var t,e;for(e=[],p=t=0;t<256;p=++t)e.push(0);return e}(),y={0:0},i={},I=0,E=o.length;I<E;I++)null==y[W=t[r=o[I]]]&&(y[W]=++d),i[r]={old:t[r],new:y[t[r]]},g[r]=y[t[r]];return k.writeUInt16(1),k.writeUInt16(0),k.writeUInt32(12),k.writeUInt16(0),k.writeUInt16(262),k.writeUInt16(0),k.write(g),{charMap:i,subtable:k.data,maxGlyphID:d+1};case"unicode":for(F=[],u=[],y={},n={},m=l=null,C=v=0,M=o.length;C<M;C++)null==y[b=t[r=o[C]]]&&(y[b]=++v),n[r]={old:b,new:y[b]},a=y[b]-r,null!=m&&a===l||(m&&u.push(m),F.push(r),l=a),m=r;for(m&&u.push(m),u.push(65535),F.push(65535),S=2*(A=F.length),L=2*Math.pow(Math.log(A)/Math.LN2,2),c=Math.log(L/2)/Math.LN2,N=2*A-L,s=[],x=[],f=[],p=B=0,O=F.length;B<O;p=++B){if(_=F[p],h=u[p],65535===_){s.push(0),x.push(0);break}if(32768<=_-(P=n[_].new))for(s.push(0),x.push(2*(f.length+A-p)),r=j=_;_<=h?j<=h:h<=j;r=_<=h?++j:--j)f.push(n[r].new);else s.push(P-_),x.push(0)}for(k.writeUInt16(3),k.writeUInt16(1),k.writeUInt32(12),k.writeUInt16(4),k.writeUInt16(16+8*A+2*f.length),k.writeUInt16(0),k.writeUInt16(S),k.writeUInt16(L),k.writeUInt16(c),k.writeUInt16(N),z=0,q=u.length;z<q;z++)r=u[z],k.writeUInt16(r);for(k.writeUInt16(0),H=0,T=F.length;H<T;H++)r=F[H],k.writeUInt16(r);for(V=0,R=s.length;V<R;V++)a=s[V],k.writeUInt16(a);for(G=0,D=x.length;G<D;G++)w=x[G],k.writeUInt16(w);for(Y=0,U=f.length;Y<U;Y++)d=f[Y],k.writeUInt16(d);return{charMap:n,subtable:k.data,maxGlyphID:v+1}}},t}(),y=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,n,r;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:n<r;0<=n?++r:--r)e=new d(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var n,r;return null==e&&(e="macroman"),n=d.encode(t,e),(r=new J).writeUInt16(0),r.writeUInt16(1),n.table=r.data.concat(n.subtable),n},e}(),g=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(),m=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="OS/2",e.prototype.parse=function(n){if(n.pos=this.offset,this.version=n.readUInt16(),this.averageCharWidth=n.readShort(),this.weightClass=n.readUInt16(),this.widthClass=n.readUInt16(),this.type=n.readShort(),this.ySubscriptXSize=n.readShort(),this.ySubscriptYSize=n.readShort(),this.ySubscriptXOffset=n.readShort(),this.ySubscriptYOffset=n.readShort(),this.ySuperscriptXSize=n.readShort(),this.ySuperscriptYSize=n.readShort(),this.ySuperscriptXOffset=n.readShort(),this.ySuperscriptYOffset=n.readShort(),this.yStrikeoutSize=n.readShort(),this.yStrikeoutPosition=n.readShort(),this.familyClass=n.readShort(),this.panose=function(){var t,e;for(e=[],t=0;t<10;++t)e.push(n.readByte());return e}(),this.charRange=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(n.readInt());return e}(),this.vendorID=n.readString(4),this.selection=n.readShort(),this.firstCharIndex=n.readShort(),this.lastCharIndex=n.readShort(),0<this.version&&(this.ascent=n.readShort(),this.descent=n.readShort(),this.lineGap=n.readShort(),this.winAscent=n.readShort(),this.winDescent=n.readShort(),this.codePageRange=function(){var t,e;for(e=[],t=0;t<2;++t)e.push(n.readInt());return e}(),1<this.version))return this.xHeight=n.readShort(),this.capHeight=n.readShort(),this.defaultChar=n.readShort(),this.breakChar=n.readShort(),this.maxContext=n.readShort()},e}(),v=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="post",e.prototype.parse=function(r){var t,e,n,i;switch(r.pos=this.offset,this.format=r.readInt(),this.italicAngle=r.readInt(),this.underlinePosition=r.readShort(),this.underlineThickness=r.readShort(),this.isFixedPitch=r.readInt(),this.minMemType42=r.readInt(),this.maxMemType42=r.readInt(),this.minMemType1=r.readInt(),this.maxMemType1=r.readInt(),this.format){case 65536:break;case 131072:for(e=r.readUInt16(),this.glyphNameIndex=[],n=0;0<=e?n<e:e<n;0<=e?++n:--n)this.glyphNameIndex.push(r.readUInt16());for(this.names=[],i=[];r.pos<this.offset+this.length;)t=r.readByte(),i.push(this.names.push(r.readString(t)));return i;case 151552:return e=r.readUInt16(),this.offsets=r.read(e);case 196608:break;case 262144:return this.map=function(){var t,e,n;for(n=[],t=0,e=this.file.maxp.numGlyphs;0<=e?t<e:e<t;0<=e?++t:--t)n.push(r.readUInt32());return n}.call(this)}},e}(),w=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},b=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="name",e.prototype.parse=function(t){var e,n,r,i,o,a,s,l,h,u,c,f;for(t.pos=this.offset,t.readShort(),e=t.readShort(),a=t.readShort(),n=[],i=h=0;0<=e?h<e:e<h;i=0<=e?++h:--h)n.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+a+t.readShort()});for(s={},i=u=0,c=n.length;u<c;i=++u)r=n[i],t.pos=r.offset,l=t.readString(r.length),o=new w(l,r),null==s[f=r.nameID]&&(s[f]=[]),s[r.nameID].push(o);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(),x=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(),N=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="hmtx",e.prototype.parse=function(n){var t,r,i,e,o,a,s;for(n.pos=this.offset,this.metrics=[],e=0,a=this.file.hhea.numberOfMetrics;0<=a?e<a:a<e;0<=a?++e:--e)this.metrics.push({advance:n.readUInt16(),lsb:n.readInt16()});for(r=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var t,e;for(e=[],t=0;0<=r?t<r:r<t;0<=r?++t:--t)e.push(n.readInt16());return e}(),this.widths=function(){var t,e,n,r;for(r=[],t=0,e=(n=this.metrics).length;t<e;t++)i=n[t],r.push(i.advance);return r}.call(this),t=this.widths[this.widths.length-1],s=[],o=0;0<=r?o<r:r<o;0<=r?++o:--o)s.push(this.widths.push(t));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(),L=[].slice,A=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="glyf",e.prototype.parse=function(t){return this.cache={}},e.prototype.glyphFor=function(t){var e,n,r,i,o,a,s,l,h,u;return(t=t)in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,n=i.indexOf(t),0===(r=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+n,o=(a=new J(e.read(r))).readShort(),l=a.readShort(),u=a.readShort(),s=a.readShort(),h=a.readShort(),this.cache[t]=-1===o?new _(a,l,u,s,h):new S(a,o,l,u,s,h),this.cache[t]))},e.prototype.encode=function(t,e,n){var r,i,o,a,s;for(o=[],i=[],a=0,s=e.length;a<s;a++)r=t[e[a]],i.push(o.length),r&&(o=o.concat(r.encode(n)));return i.push(o.length),{table:o,offsets:i}},e}(),S=function(){function t(t,e,n,r,i,o){this.raw=t,this.numberOfContours=e,this.xMin=n,this.yMin=r,this.xMax=i,this.yMax=o,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),_=function(){function t(t,e,n,r,i){var o,a;for(this.raw=t,this.xMin=e,this.yMin=n,this.xMax=r,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],o=this.raw;a=o.readShort(),this.glyphOffsets.push(o.pos),this.glyphIDs.push(o.readShort()),32&a;)o.pos+=1&a?4:2,128&a?o.pos+=8:64&a?o.pos+=4:8&a&&(o.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(t){var e,n,r,i,o;for(n=new J(L.call(this.raw.data)),e=r=0,i=(o=this.glyphIDs).length;r<i;e=++r)o[e],n.pos=this.glyphOffsets[e];return n.data},t}(),F=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return f(e,h),e.prototype.tag="loca",e.prototype.parse=function(r){var t;return r.pos=this.offset,t=this.file.head.indexToLocFormat,this.offsets=0===t?function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=2)n.push(2*r.readUInt16());return n}.call(this):function(){var t,e,n;for(n=[],t=0,e=this.length;t<e;t+=4)n.push(r.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var n=new Uint32Array(this.offsets.length),r=0,i=0,o=0;o<n.length;++o)if(n[o]=r,i<e.length&&e[i]==o){++i,n[o]=r;var a=this.offsets[o],s=this.offsets[o+1]-a;0<s&&(r+=s)}for(var l=new Array(4*n.length),h=0;h<n.length;++h)l[4*h+3]=255&n[h],l[4*h+2]=(65280&n[h])>>8,l[4*h+1]=(16711680&n[h])>>16,l[4*h]=(4278190080&n[h])>>24;return l},e}(),P=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,n,r,i;for(e in r=this.font.cmap.tables[0].codeMap,t={},i=this.subset)n=i[e],t[e]=r[n];return t},t.prototype.glyphsFor=function(t){var e,n,r,i,o,a,s;for(r={},o=0,a=t.length;o<a;o++)r[i=t[o]]=this.font.glyf.glyphFor(i);for(i in e=[],r)(null!=(n=r[i])?n.compound:void 0)&&e.push.apply(e,n.glyphIDs);if(0<e.length)for(i in s=this.glyphsFor(e))n=s[i],r[i]=n;return r},t.prototype.encode=function(t,e){var n,r,i,o,a,s,l,h,u,c,f,p,d,g,m;for(r in n=y.encode(this.generateCmap(),"unicode"),o=this.glyphsFor(t),f={0:0},m=n.charMap)f[(s=m[r]).old]=s.new;for(p in c=n.maxGlyphID,o)p in f||(f[p]=c++);return h=function(t){var e,n;for(e in n={},t)n[t[e]]=e;return n}(f),u=Object.keys(h).sort(function(t,e){return t-e}),d=function(){var t,e,n;for(n=[],t=0,e=u.length;t<e;t++)a=u[t],n.push(h[a]);return n}(),i=this.font.glyf.encode(o,d,f),l=this.font.loca.encode(i.offsets,d),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:l,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();t.API.PDFObject=function(){var o;function a(){}return o=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},a.convert=function(r){var i,t,e,n;if(Array.isArray(r))return"["+function(){var t,e,n;for(n=[],t=0,e=r.length;t<e;t++)i=r[t],n.push(a.convert(i));return n}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+o(r.getUTCFullYear(),4)+o(r.getUTCMonth(),2)+o(r.getUTCDate(),2)+o(r.getUTCHours(),2)+o(r.getUTCMinutes(),2)+o(r.getUTCSeconds(),2)+"Z)";if("[object Object]"!=={}.toString.call(r))return""+r;for(t in e=["<<"],r)n=r[t],e.push("/"+t+" "+a.convert(n));return e.push(">>"),e.join("\n")},a}()}(lt),
/*
  # PNG.js
  # Copyright (c) 2011 Devon Govett
  # MIT LICENSE
  # 
  # 
  */
Nt="undefined"!=typeof self&&self||"undefined"!=typeof window&&window||"undefined"!=typeof global&&global||Function('return typeof this === "object" && this.content')()||Function("return this")(),Lt=function(){var h,n,r;function i(t){var e,n,r,i,o,a,s,l,h,u,c,f,p,d;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},a=null;;){switch(e=this.readUInt32(),h=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":a&&this.animation.frames.push(a),this.pos+=4,a={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},o=this.readUInt16(),i=this.readUInt16()||100,a.delay=1e3*o/i,a.disposeOp=this.data[this.pos++],a.blendOp=this.data[this.pos++],a.data=[];break;case"IDAT":case"fdAT":for("fdAT"===h&&(this.pos+=4,e-=4),t=(null!=a?a.data:void 0)||this.imgData,f=0;0<=e?f<e:e<f;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(r=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>r)throw new Error("More transparent colors than palette size");if(0<(u=r-this.transparency.indexed.length))for(p=0;0<=u?p<u:u<p;0<=u?++p:--p)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(c=this.read(e)).indexOf(0),l=String.fromCharCode.apply(String,c.slice(0,s)),this.text[l]=String.fromCharCode.apply(String,c.slice(s+1));break;case"IEND":return a&&this.animation.frames.push(a),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(d=this.colorType)||6===d,n=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*n,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.load=function(t,e,n){var r;return"function"==typeof e&&(n=e),(r=new XMLHttpRequest).open("GET",t,!0),r.responseType="arraybuffer",r.onload=function(){var t;return t=new i(new Uint8Array(r.response||r.mozResponseArrayBuffer)),"function"==typeof(null!=e?e.getContext:void 0)&&t.render(e),"function"==typeof n?n(t):void 0},r.send(null)},i.prototype.read=function(t){var e,n;for(n=[],e=0;0<=t?e<t:t<e;0<=t?++e:--e)n.push(this.data[this.pos++]);return n},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(C){var B=this.pixelBitlength/8,j=new Uint8Array(this.width*this.height*B),E=0,M=this;if(null==C&&(C=this.imgData),0===C.length)return new Uint8Array(0);function t(t,e,n,r){var i,o,a,s,l,h,u,c,f,p,d,g,m,y,v,w,b,x,N,L,A,S=Math.ceil((M.width-t)/n),_=Math.ceil((M.height-e)/r),F=M.width==S&&M.height==_;for(y=B*S,g=F?j:new Uint8Array(y*_),h=C.length,o=m=0;m<_&&E<h;){switch(C[E++]){case 0:for(s=b=0;b<y;s=b+=1)g[o++]=C[E++];break;case 1:for(s=x=0;x<y;s=x+=1)i=C[E++],l=s<B?0:g[o-B],g[o++]=(i+l)%256;break;case 2:for(s=N=0;N<y;s=N+=1)i=C[E++],a=(s-s%B)/B,v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(v+i)%256;break;case 3:for(s=L=0;L<y;s=L+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],v=m&&g[(m-1)*y+a*B+s%B],g[o++]=(i+Math.floor((l+v)/2))%256;break;case 4:for(s=A=0;A<y;s=A+=1)i=C[E++],a=(s-s%B)/B,l=s<B?0:g[o-B],0===m?v=w=0:(v=g[(m-1)*y+a*B+s%B],w=a&&g[(m-1)*y+(a-1)*B+s%B]),u=l+v-w,c=Math.abs(u-l),p=Math.abs(u-v),d=Math.abs(u-w),f=c<=p&&c<=d?l:p<=d?v:w,g[o++]=(i+f)%256;break;default:throw new Error("Invalid filter algorithm: "+C[E-1])}if(!F){var P=((e+m*r)*M.width+t)*B,k=m*y;for(s=0;s<S;s+=1){for(var I=0;I<B;I+=1)j[P++]=g[k++];P+=(n-1)*B}}m++}}return C=(C=new kt(C)).getBytes(),1==M.interlaceMethod?(t(0,0,8,8),t(4,0,8,8),t(0,4,4,8),t(2,0,4,4),t(0,2,2,4),t(1,0,2,2),t(0,1,1,2)):t(0,0,1,1),j},i.prototype.decodePalette=function(){var t,e,n,r,i,o,a,s,l;for(n=this.palette,o=this.transparency.indexed||[],i=new Uint8Array((o.length||0)+n.length),r=0,n.length,e=a=t=0,s=n.length;a<s;e=a+=3)i[r++]=n[e],i[r++]=n[e+1],i[r++]=n[e+2],i[r++]=null!=(l=o[t++])?l:255;return i},i.prototype.copyToImageData=function(t,e){var n,r,i,o,a,s,l,h,u,c,f;if(r=this.colors,u=null,n=this.hasAlphaChannel,this.palette.length&&(u=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),r=4,n=!0),h=(i=t.data||t).length,a=u||e,o=s=0,1===r)for(;o<h;)l=u?4*e[o/4]:s,c=a[l++],i[o++]=c,i[o++]=c,i[o++]=c,i[o++]=n?a[l++]:255,s=l;else for(;o<h;)l=u?4*e[o/4]:s,i[o++]=a[l++],i[o++]=a[l++],i[o++]=a[l++],i[o++]=n?a[l++]:255,s=l},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};try{n=Nt.document.createElement("canvas"),r=n.getContext("2d")}catch(t){return-1}return h=function(t){var e;return r.width=t.width,r.height=t.height,r.clearRect(0,0,t.width,t.height),r.putImageData(t,0,0),(e=new Image).src=n.toDataURL(),e},i.prototype.decodeFrames=function(t){var e,n,r,i,o,a,s,l;if(this.animation){for(l=[],n=o=0,a=(s=this.animation.frames).length;o<a;n=++o)e=s[n],r=t.createImageData(e.width,e.height),i=this.decodePixels(new Uint8Array(e.data)),this.copyToImageData(r,i),e.imageData=r,l.push(e.image=h(r));return l}},i.prototype.renderFrame=function(t,e){var n,r,i;return n=(r=this.animation.frames)[e],i=r[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===n.blendOp&&t.clearRect(n.xOffset,n.yOffset,n.width,n.height),t.drawImage(n.image,n.xOffset,n.yOffset)},i.prototype.animate=function(n){var r,i,o,a,s,t,l=this;return i=0,t=this.animation,a=t.numFrames,o=t.frames,s=t.numPlays,(r=function(){var t,e;if(t=i++%a,e=o[t],l.renderFrame(n,t),1<a&&i/a<s)return l.animation._timeout=setTimeout(r,e.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,n;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(n=e.createImageData(this.width,this.height),this.copyToImageData(n,this.decodePixels()),e.putImageData(n,0,0))},i}(),Nt.PNG=Lt;
/*
   * Extracted from pdf.js
   * https://github.com/andreasgal/pdf.js
   *
   * Copyright (c) 2011 Mozilla Foundation
   *
   * Contributors: Andreas Gal <gal@mozilla.com>
   *               Chris G Jones <cjones@mozilla.com>
   *               Shaon Barman <shaon.barman@gmail.com>
   *               Vivien Nicolas <21@vingtetun.org>
   *               Justin D'Arcangelo <justindarc@gmail.com>
   *               Yury Delendik
   *
   * 
   */
var Pt=function(){function t(){this.pos=0,this.bufferLength=0,this.eof=!1,this.buffer=null}return t.prototype={ensureBuffer:function(t){var e=this.buffer,n=e?e.byteLength:0;if(t<n)return e;for(var r=512;r<t;)r<<=1;for(var i=new Uint8Array(r),o=0;o<n;++o)i[o]=e[o];return this.buffer=i},getByte:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return this.buffer[this.pos++]},getBytes:function(t){var e=this.pos;if(t){this.ensureBuffer(e+t);for(var n=e+t;!this.eof&&this.bufferLength<n;)this.readBlock();var r=this.bufferLength;r<n&&(n=r)}else{for(;!this.eof;)this.readBlock();n=this.bufferLength}return this.pos=n,this.buffer.subarray(e,n)},lookChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos])},getChar:function(){for(var t=this.pos;this.bufferLength<=t;){if(this.eof)return null;this.readBlock()}return String.fromCharCode(this.buffer[this.pos++])},makeSubStream:function(t,e,n){for(var r=t+e;this.bufferLength<=r&&!this.eof;)this.readBlock();return new Stream(this.buffer,t,e,n)},skip:function(t){t||(t=1),this.pos+=t},reset:function(){this.pos=0}},t}(),kt=function(){if("undefined"!=typeof Uint32Array){var k=new Uint32Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),I=new Uint32Array([3,4,5,6,7,8,9,10,65547,65549,65551,65553,131091,131095,131099,131103,196643,196651,196659,196667,262211,262227,262243,262259,327811,327843,327875,327907,258,258,258]),C=new Uint32Array([1,2,3,4,65541,65543,131081,131085,196625,196633,262177,262193,327745,327777,393345,393409,459009,459137,524801,525057,590849,591361,657409,658433,724993,727041,794625,798721,868353,876545]),B=[new Uint32Array([459008,524368,524304,524568,459024,524400,524336,590016,459016,524384,524320,589984,524288,524416,524352,590048,459012,524376,524312,589968,459028,524408,524344,590032,459020,524392,524328,59e4,524296,524424,524360,590064,459010,524372,524308,524572,459026,524404,524340,590024,459018,524388,524324,589992,524292,524420,524356,590056,459014,524380,524316,589976,459030,524412,524348,590040,459022,524396,524332,590008,524300,524428,524364,590072,459009,524370,524306,524570,459025,524402,524338,590020,459017,524386,524322,589988,524290,524418,524354,590052,459013,524378,524314,589972,459029,524410,524346,590036,459021,524394,524330,590004,524298,524426,524362,590068,459011,524374,524310,524574,459027,524406,524342,590028,459019,524390,524326,589996,524294,524422,524358,590060,459015,524382,524318,589980,459031,524414,524350,590044,459023,524398,524334,590012,524302,524430,524366,590076,459008,524369,524305,524569,459024,524401,524337,590018,459016,524385,524321,589986,524289,524417,524353,590050,459012,524377,524313,589970,459028,524409,524345,590034,459020,524393,524329,590002,524297,524425,524361,590066,459010,524373,524309,524573,459026,524405,524341,590026,459018,524389,524325,589994,524293,524421,524357,590058,459014,524381,524317,589978,459030,524413,524349,590042,459022,524397,524333,590010,524301,524429,524365,590074,459009,524371,524307,524571,459025,524403,524339,590022,459017,524387,524323,589990,524291,524419,524355,590054,459013,524379,524315,589974,459029,524411,524347,590038,459021,524395,524331,590006,524299,524427,524363,590070,459011,524375,524311,524575,459027,524407,524343,590030,459019,524391,524327,589998,524295,524423,524359,590062,459015,524383,524319,589982,459031,524415,524351,590046,459023,524399,524335,590014,524303,524431,524367,590078,459008,524368,524304,524568,459024,524400,524336,590017,459016,524384,524320,589985,524288,524416,524352,590049,459012,524376,524312,589969,459028,524408,524344,590033,459020,524392,524328,590001,524296,524424,524360,590065,459010,524372,524308,524572,459026,524404,524340,590025,459018,524388,524324,589993,524292,524420,524356,590057,459014,524380,524316,589977,459030,524412,524348,590041,459022,524396,524332,590009,524300,524428,524364,590073,459009,524370,524306,524570,459025,524402,524338,590021,459017,524386,524322,589989,524290,524418,524354,590053,459013,524378,524314,589973,459029,524410,524346,590037,459021,524394,524330,590005,524298,524426,524362,590069,459011,524374,524310,524574,459027,524406,524342,590029,459019,524390,524326,589997,524294,524422,524358,590061,459015,524382,524318,589981,459031,524414,524350,590045,459023,524398,524334,590013,524302,524430,524366,590077,459008,524369,524305,524569,459024,524401,524337,590019,459016,524385,524321,589987,524289,524417,524353,590051,459012,524377,524313,589971,459028,524409,524345,590035,459020,524393,524329,590003,524297,524425,524361,590067,459010,524373,524309,524573,459026,524405,524341,590027,459018,524389,524325,589995,524293,524421,524357,590059,459014,524381,524317,589979,459030,524413,524349,590043,459022,524397,524333,590011,524301,524429,524365,590075,459009,524371,524307,524571,459025,524403,524339,590023,459017,524387,524323,589991,524291,524419,524355,590055,459013,524379,524315,589975,459029,524411,524347,590039,459021,524395,524331,590007,524299,524427,524363,590071,459011,524375,524311,524575,459027,524407,524343,590031,459019,524391,524327,589999,524295,524423,524359,590063,459015,524383,524319,589983,459031,524415,524351,590047,459023,524399,524335,590015,524303,524431,524367,590079]),9],j=[new Uint32Array([327680,327696,327688,327704,327684,327700,327692,327708,327682,327698,327690,327706,327686,327702,327694,0,327681,327697,327689,327705,327685,327701,327693,327709,327683,327699,327691,327707,327687,327703,327695,0]),5];return(t.prototype=Object.create(Pt.prototype)).getBits=function(t){for(var e,n=this.codeSize,r=this.codeBuf,i=this.bytes,o=this.bytesPos;n<t;)void 0===(e=i[o++])&&E("Bad encoding in flate stream"),r|=e<<n,n+=8;return e=r&(1<<t)-1,this.codeBuf=r>>t,this.codeSize=n-=t,this.bytesPos=o,e},t.prototype.getCode=function(t){for(var e=t[0],n=t[1],r=this.codeSize,i=this.codeBuf,o=this.bytes,a=this.bytesPos;r<n;){var s;void 0===(s=o[a++])&&E("Bad encoding in flate stream"),i|=s<<r,r+=8}var l=e[i&(1<<n)-1],h=l>>16,u=65535&l;return(0==r||r<h||0==h)&&E("Bad encoding in flate stream"),this.codeBuf=i>>h,this.codeSize=r-h,this.bytesPos=a,u},t.prototype.generateHuffmanTable=function(t){for(var e=t.length,n=0,r=0;r<e;++r)t[r]>n&&(n=t[r]);for(var i=1<<n,o=new Uint32Array(i),a=1,s=0,l=2;a<=n;++a,s<<=1,l<<=1)for(var h=0;h<e;++h)if(t[h]==a){var u=0,c=s;for(r=0;r<a;++r)u=u<<1|1&c,c>>=1;for(r=u;r<i;r+=l)o[r]=a<<16|h;++s}return[o,n]},t.prototype.readBlock=function(){function t(t,e,n,r,i){for(var o=t.getBits(n)+r;0<o--;)e[l++]=i}var e=this.getBits(3);if(1&e&&(this.eof=!0),0!=(e>>=1)){var n,r;if(1==e)n=B,r=j;else if(2==e){for(var i=this.getBits(5)+257,o=this.getBits(5)+1,a=this.getBits(4)+4,s=Array(k.length),l=0;l<a;)s[k[l++]]=this.getBits(3);for(var h=this.generateHuffmanTable(s),u=0,c=(l=0,i+o),f=new Array(c);l<c;){var p=this.getCode(h);16==p?t(this,f,2,3,u):17==p?t(this,f,3,3,u=0):18==p?t(this,f,7,11,u=0):f[l++]=u=p}n=this.generateHuffmanTable(f.slice(0,i)),r=this.generateHuffmanTable(f.slice(i,c))}else E("Unknown block type in flate stream");for(var d=(_=this.buffer)?_.length:0,g=this.bufferLength;;){var m=this.getCode(n);if(m<256)d<=g+1&&(d=(_=this.ensureBuffer(g+1)).length),_[g++]=m;else{if(256==m)return void(this.bufferLength=g);var y=(m=I[m-=257])>>16;0<y&&(y=this.getBits(y));u=(65535&m)+y;m=this.getCode(r),0<(y=(m=C[m])>>16)&&(y=this.getBits(y));var v=(65535&m)+y;d<=g+u&&(d=(_=this.ensureBuffer(g+u)).length);for(var w=0;w<u;++w,++g)_[g]=_[g-v]}}}else{var b,x=this.bytes,N=this.bytesPos;void 0===(b=x[N++])&&E("Bad block header in flate stream");var L=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),L|=b<<8,void 0===(b=x[N++])&&E("Bad block header in flate stream");var A=b;void 0===(b=x[N++])&&E("Bad block header in flate stream"),(A|=b<<8)!=(65535&~L)&&E("Bad uncompressed block length in flate stream"),this.codeBuf=0,this.codeSize=0;var S=this.bufferLength,_=this.ensureBuffer(S+L),F=S+L;this.bufferLength=F;for(var P=S;P<F;++P){if(void 0===(b=x[N++])){this.eof=!0;break}_[P]=b}this.bytesPos=N}},t}function E(t){throw new Error(t)}function t(t){var e=0,n=t[e++],r=t[e++];-1!=n&&-1!=r||E("Invalid header in flate stream"),8!=(15&n)&&E("Unknown compression method in flate stream"),((n<<8)+r)%31!=0&&E("Bad FCHECK in flate stream"),32&r&&E("FDICT bit set in flate stream"),this.bytes=t,this.bytesPos=2,this.codeSize=0,this.codeBuf=0,Pt.call(this)}}();window.tmp=kt});try{module.exports=jsPDF}catch(t){}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(343);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(360);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(359);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(353);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(370);


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(112);

var GetIntrinsic = __webpack_require__(4);

var $Function = GetIntrinsic('%Function%');
var $apply = $Function.apply;
var $call = $Function.call;

module.exports = function callBind() {
	return bind.apply($call, arguments);
};

module.exports.apply = function applyBind() {
	return bind.apply($apply, arguments);
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $test = GetIntrinsic('RegExp.prototype.test');

var callBind = __webpack_require__(212);

module.exports = function regexTester(regex) {
	return callBind($test, regex);
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isCallable(value) {
	if (!value) { return false; }
	if (typeof value !== 'function' && typeof value !== 'object') { return false; }
	if (typeof value === 'function' && !value.prototype) { return true; }
	if (hasToStringTag) { return tryFunctionObject(value); }
	if (isES6ClassFn(value)) { return false; }
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var IsInteger = __webpack_require__(88);
var Type = __webpack_require__(7);

var MAX_SAFE_INTEGER = __webpack_require__(217);

var $TypeError = GetIntrinsic('%TypeError%');

var $charCodeAt = __webpack_require__(16)('String.prototype.charCodeAt');

// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex

module.exports = function AdvanceStringIndex(S, index, unicode) {
	if (Type(S) !== 'String') {
		throw new $TypeError('Assertion failed: `S` must be a String');
	}
	if (!IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
		throw new $TypeError('Assertion failed: `length` must be an integer >= 0 and <= 2**53');
	}
	if (Type(unicode) !== 'Boolean') {
		throw new $TypeError('Assertion failed: `unicode` must be a Boolean');
	}
	if (!unicode) {
		return index + 1;
	}
	var length = S.length;
	if ((index + 1) >= length) {
		return index + 1;
	}

	var first = $charCodeAt(S, index);
	if (first < 0xD800 || first > 0xDBFF) {
		return index + 1;
	}

	var second = $charCodeAt(S, index + 1);
	if (second < 0xDC00 || second > 0xDFFF) {
		return index + 1;
	}

	return index + 2;
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var keys = __webpack_require__(110);
var bind = __webpack_require__(112);
var canBeObject = function (obj) {
	return typeof obj !== 'undefined' && obj !== null;
};
var hasSymbols = __webpack_require__(211)();
var toObject = Object;
var push = bind.call(Function.call, Array.prototype.push);
var propIsEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;

module.exports = function assign(target, source1) {
	if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
	var objTarget = toObject(target);
	var s, source, i, props, syms, value, key;
	for (s = 1; s < arguments.length; ++s) {
		source = toObject(arguments[s]);
		props = keys(source);
		var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			syms = getSymbols(source);
			for (i = 0; i < syms.length; ++i) {
				key = syms[i];
				if (propIsEnumerable(source, key)) {
					push(props, key);
				}
			}
		}
		for (i = 0; i < props.length; ++i) {
			key = props[i];
			value = source[key];
			if (propIsEnumerable(source, key)) {
				objTarget[key] = value;
			}
		}
	}
	return objTarget;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(218);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	// v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	// note: this does not detect the bug unless there's 20 characters
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	// Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	// which is 72% slower than our shim, and Firefox 40's native implementation.
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');
var $TypeError = GetIntrinsic('%TypeError%');

var isPropertyDescriptor = __webpack_require__(89);

var IsAccessorDescriptor = __webpack_require__(55);
var IsDataDescriptor = __webpack_require__(30);
var IsExtensible = __webpack_require__(91);
var IsPropertyKey = __webpack_require__(19);
var ToPropertyDescriptor = __webpack_require__(72);
var Type = __webpack_require__(7);
var ValidateAndApplyPropertyDescriptor = __webpack_require__(221);

// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinarydefineownproperty

module.exports = function OrdinaryDefineOwnProperty(O, P, Desc) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	var desc = $gOPD(O, P);
	var current = desc && ToPropertyDescriptor(desc);
	var extensible = IsExtensible(O);
	return ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current);
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(113);
var isPropertyDescriptor = __webpack_require__(89);
var isSamePropertyDescriptor = __webpack_require__(385);

var FromPropertyDescriptor = __webpack_require__(92);
var IsAccessorDescriptor = __webpack_require__(55);
var IsDataDescriptor = __webpack_require__(30);
var IsGenericDescriptor = __webpack_require__(146);
var IsPropertyKey = __webpack_require__(19);
var SameValue = __webpack_require__(74);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-validateandapplypropertydescriptor
// https://www.ecma-international.org/ecma-262/8.0/#sec-validateandapplypropertydescriptor

// eslint-disable-next-line max-lines-per-function, max-statements, max-params
module.exports = function ValidateAndApplyPropertyDescriptor(O, P, extensible, Desc, current) {
	// this uses the ES2017+ logic, since it fixes a number of bugs in the ES2015 logic.
	var oType = Type(O);
	if (oType !== 'Undefined' && oType !== 'Object') {
		throw new $TypeError('Assertion failed: O must be undefined or an Object');
	}
	if (Type(extensible) !== 'Boolean') {
		throw new $TypeError('Assertion failed: extensible must be a Boolean');
	}
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (Type(current) !== 'Undefined' && !isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, current)) {
		throw new $TypeError('Assertion failed: current must be a Property Descriptor, or undefined');
	}
	if (oType !== 'Undefined' && !IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: if O is not undefined, P must be a Property Key');
	}
	if (Type(current) === 'Undefined') {
		if (!extensible) {
			return false;
		}
		if (IsGenericDescriptor(Desc) || IsDataDescriptor(Desc)) {
			if (oType !== 'Undefined') {
				DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					{
						'[[Configurable]]': Desc['[[Configurable]]'],
						'[[Enumerable]]': Desc['[[Enumerable]]'],
						'[[Value]]': Desc['[[Value]]'],
						'[[Writable]]': Desc['[[Writable]]']
					}
				);
			}
		} else {
			if (!IsAccessorDescriptor(Desc)) {
				throw new $TypeError('Assertion failed: Desc is not an accessor descriptor');
			}
			if (oType !== 'Undefined') {
				return DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					Desc
				);
			}
		}
		return true;
	}
	if (IsGenericDescriptor(Desc) && !('[[Configurable]]' in Desc) && !('[[Enumerable]]' in Desc)) {
		return true;
	}
	if (isSamePropertyDescriptor({ SameValue: SameValue }, Desc, current)) {
		return true; // removed by ES2017, but should still be correct
	}
	// "if every field in Desc is absent, return true" can't really match the assertion that it's a Property Descriptor
	if (!current['[[Configurable]]']) {
		if (Desc['[[Configurable]]']) {
			return false;
		}
		if ('[[Enumerable]]' in Desc && !Desc['[[Enumerable]]'] === !!current['[[Enumerable]]']) {
			return false;
		}
	}
	if (IsGenericDescriptor(Desc)) {
		// no further validation is required.
	} else if (IsDataDescriptor(current) !== IsDataDescriptor(Desc)) {
		if (!current['[[Configurable]]']) {
			return false;
		}
		if (IsDataDescriptor(current)) {
			if (oType !== 'Undefined') {
				DefineOwnProperty(
					IsDataDescriptor,
					SameValue,
					FromPropertyDescriptor,
					O,
					P,
					{
						'[[Configurable]]': current['[[Configurable]]'],
						'[[Enumerable]]': current['[[Enumerable]]'],
						'[[Get]]': undefined
					}
				);
			}
		} else if (oType !== 'Undefined') {
			DefineOwnProperty(
				IsDataDescriptor,
				SameValue,
				FromPropertyDescriptor,
				O,
				P,
				{
					'[[Configurable]]': current['[[Configurable]]'],
					'[[Enumerable]]': current['[[Enumerable]]'],
					'[[Value]]': undefined
				}
			);
		}
	} else if (IsDataDescriptor(current) && IsDataDescriptor(Desc)) {
		if (!current['[[Configurable]]'] && !current['[[Writable]]']) {
			if ('[[Writable]]' in Desc && Desc['[[Writable]]']) {
				return false;
			}
			if ('[[Value]]' in Desc && !SameValue(Desc['[[Value]]'], current['[[Value]]'])) {
				return false;
			}
			return true;
		}
	} else if (IsAccessorDescriptor(current) && IsAccessorDescriptor(Desc)) {
		if (!current['[[Configurable]]']) {
			if ('[[Set]]' in Desc && !SameValue(Desc['[[Set]]'], current['[[Set]]'])) {
				return false;
			}
			if ('[[Get]]' in Desc && !SameValue(Desc['[[Get]]'], current['[[Get]]'])) {
				return false;
			}
			return true;
		}
	} else {
		throw new $TypeError('Assertion failed: current and Desc are not both data, both accessors, or one accessor and one data.');
	}
	if (oType !== 'Undefined') {
		return DefineOwnProperty(
			IsDataDescriptor,
			SameValue,
			FromPropertyDescriptor,
			O,
			P,
			Desc
		);
	}
	return true;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');
var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(16);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

var has = __webpack_require__(36);

var IsArray = __webpack_require__(54);
var IsPropertyKey = __webpack_require__(19);
var IsRegExp = __webpack_require__(223);
var ToPropertyDescriptor = __webpack_require__(72);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinarygetownproperty

module.exports = function OrdinaryGetOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: O must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	if (!has(O, P)) {
		return void 0;
	}
	if (!$gOPD) {
		// ES3 fallback
		var arrayLength = IsArray(O) && P === 'length';
		var regexLastIndex = IsRegExp(O) && P === 'lastIndex';
		return {
			'[[Configurable]]': !(arrayLength || regexLastIndex),
			'[[Enumerable]]': $isEnumerable(O, P),
			'[[Value]]': O[P],
			'[[Writable]]': true
		};
	}
	return ToPropertyDescriptor($gOPD(O, P));
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $match = GetIntrinsic('%Symbol.match%', true);

var hasRegExpMatcher = __webpack_require__(386);

var ToBoolean = __webpack_require__(73);

// https://ecma-international.org/ecma-262/6.0/#sec-isregexp

module.exports = function IsRegExp(argument) {
	if (!argument || typeof argument !== 'object') {
		return false;
	}
	if ($match) {
		var isRegExp = argument[$match];
		if (typeof isRegExp !== 'undefined') {
			return ToBoolean(isRegExp);
		}
	}
	return hasRegExpMatcher(argument);
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(26);

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.6

module.exports = function ToUint32(x) {
	return ToNumber(x) >>> 0;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');
var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(113);

var FromPropertyDescriptor = __webpack_require__(92);
var IsDataDescriptor = __webpack_require__(30);
var IsExtensible = __webpack_require__(91);
var IsPropertyKey = __webpack_require__(19);
var SameValue = __webpack_require__(74);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-createdataproperty

module.exports = function CreateDataProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var oldDesc = $gOPD(O, P);
	var extensible = oldDesc || IsExtensible(O);
	var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
	if (immutable || !extensible) {
		return false;
	}
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		{
			'[[Configurable]]': true,
			'[[Enumerable]]': true,
			'[[Value]]': V,
			'[[Writable]]': true
		}
	);
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MAX_SAFE_INTEGER = __webpack_require__(217);

var ToInteger = __webpack_require__(115);

module.exports = function ToLength(argument) {
	var len = ToInteger(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $EvalError = GetIntrinsic('%EvalError%');

var DayWithinYear = __webpack_require__(150);
var InLeapYear = __webpack_require__(152);
var MonthFromTime = __webpack_require__(153);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.5

module.exports = function DateFromTime(t) {
	var m = MonthFromTime(t);
	var d = DayWithinYear(t);
	if (m === 0) {
		return d + 1;
	}
	if (m === 1) {
		return d - 30;
	}
	var leap = InLeapYear(t);
	if (m === 2) {
		return d - 58 - leap;
	}
	if (m === 3) {
		return d - 89 - leap;
	}
	if (m === 4) {
		return d - 119 - leap;
	}
	if (m === 5) {
		return d - 150 - leap;
	}
	if (m === 6) {
		return d - 180 - leap;
	}
	if (m === 7) {
		return d - 211 - leap;
	}
	if (m === 8) {
		return d - 242 - leap;
	}
	if (m === 9) {
		return d - 272 - leap;
	}
	if (m === 10) {
		return d - 303 - leap;
	}
	if (m === 11) {
		return d - 333 - leap;
	}
	throw new $EvalError('Assertion failed: MonthFromTime returned an impossible value: ' + m);
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mod = __webpack_require__(31);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3

module.exports = function DaysInYear(y) {
	if (mod(y, 4) !== 0) {
		return 365;
	}
	if (mod(y, 100) !== 0) {
		return 366;
	}
	if (mod(y, 400) !== 0) {
		return 365;
	}
	return 366;
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Object = GetIntrinsic('%Object%');

var RequireObjectCoercible = __webpack_require__(148);

// https://www.ecma-international.org/ecma-262/6.0/#sec-toobject

module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(45);
var IsCallable = __webpack_require__(56);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinaryhasinstance

module.exports = function OrdinaryHasInstance(C, O) {
	if (IsCallable(C) === false) {
		return false;
	}
	if (Type(O) !== 'Object') {
		return false;
	}
	var P = Get(C, 'prototype');
	if (Type(P) !== 'Object') {
		throw new $TypeError('OrdinaryHasInstance called on an object with an invalid prototype property.');
	}
	return O instanceof C;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var $arraySlice = __webpack_require__(16)('Array.prototype.slice');

var Call = __webpack_require__(76);
var GetV = __webpack_require__(155);
var IsPropertyKey = __webpack_require__(19);

// https://ecma-international.org/ecma-262/6.0/#sec-invoke

module.exports = function Invoke(O, P) {
	if (!IsPropertyKey(P)) {
		throw new $TypeError('P must be a Property Key');
	}
	var argumentsList = $arraySlice(arguments, 2);
	var func = GetV(O, P);
	return Call(func, O, argumentsList);
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(45);
var ToBoolean = __webpack_require__(73);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete

module.exports = function IteratorComplete(iterResult) {
	if (Type(iterResult) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
	}
	return ToBoolean(Get(iterResult, 'done'));
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Invoke = __webpack_require__(231);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext

module.exports = function IteratorNext(iterator, value) {
	var result = Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
	if (Type(result) !== 'Object') {
		throw new $TypeError('iterator next must return an object');
	}
	return result;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Math = GetIntrinsic('%Math%');

var ToNumber = __webpack_require__(26);

var $isNaN = __webpack_require__(43);
var $isFinite = __webpack_require__(44);
var $sign = __webpack_require__(149);
var $mod = __webpack_require__(31);

var $floor = $Math.floor;
var $abs = $Math.abs;

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.7

module.exports = function ToUint16(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
	var posInt = $sign(number) * $floor($abs(number));
	return $mod(posInt, 0x10000);
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Math = GetIntrinsic('%Math%');

var ToNumber = __webpack_require__(26);

var $isNaN = __webpack_require__(43);
var $isFinite = __webpack_require__(44);
var $sign = __webpack_require__(149);
var $mod = __webpack_require__(31);

var $floor = $Math.floor;
var $abs = $Math.abs;

module.exports = function ToUint8(argument) {
	var number = ToNumber(argument);
	if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
	var posInt = $sign(number) * $floor($abs(number));
	return $mod(posInt, 0x100);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ES = __webpack_require__(210);

module.exports = function find(predicate) {
	var list = ES.ToObject(this);
	var length = ES.ToLength(list.length);
	if (!ES.IsCallable(predicate)) {
		throw new TypeError('Array#find: predicate must be a function');
	}
	if (length === 0) {
		return void 0;
	}
	var thisArg;
	if (arguments.length > 0) {
		thisArg = arguments[1];
	}

	for (var i = 0, value; i < length; i++) {
		value = list[i];
		// inlined for performance: if (ES.Call(predicate, thisArg, [value, i, list])) {
		if (predicate.apply(thisArg, [value, i, list])) {
			return value;
		}
	}
	return void 0;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function getPolyfill() {
	// Detect if an implementation exists
	// Detect early implementations which skipped holes in sparse arrays
	// eslint-disable-next-line no-sparse-arrays
	var implemented = Array.prototype.find && [, 1].find(function () {
		return true;
	}) !== 1;

	// eslint-disable-next-line global-require
	return implemented ? Array.prototype.find : __webpack_require__(236);
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jsCookie = __webpack_require__(456);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  get: function get(name) {
    return _jsCookie2.default.get(name);
  },
  set: function set(name, value, expires, path, domain, secure) {
    return _jsCookie2.default.set(name, value, { expires: expires, path: path, domain: domain, secure: secure });
  },
  remove: function remove(name, path, domain) {
    _jsCookie2.default.remove(name, { path: path, domain: domain });
  },
  has: function has(name) {
    return _jsCookie2.default.get(name) ? true : false;
  },
  keys: function keys() {
    return Object.keys(_jsCookie2.default.get());
  }
}; // (C) Copyright 2015-2018 Hewlett Packard Enterprise Development LP

module.exports = exports['default'];

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CHANGE_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DELETE_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return UPDATE_SESSION; });
/* unused harmony export UPDATE_WORKLOAD */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return SAVE_DATA; });
/* unused harmony export SERVER_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COUNTRY_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return TOGGLE_SIZE_BUTTON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return CLOSE_EULA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ERROR_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CLEAR_GUIDANCE_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return POSTSSET_PENDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CHECK_LOGIN; });
/* unused harmony export asyncActionType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return API_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return API_REQUEST_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_REQUEST_BLOB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return API_REQUEST_POST_BLOB; });
/* unused harmony export CANCEL_API_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return REDIRECT_CONFLICT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return EPA_ACTV_SOLN_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return OPENED_SAVEWORKLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return FETCH_WORKLOADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FETCH_BOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return FETCH_GR_INPUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return FETCH_GRBOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return FETCH_CONFIGDETAILS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return FETCH_DEFAULT_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return FETCH_SOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return FETCH_SOLUTION_ADVANCED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return SAVE_WORKLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return SAVE_SOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return LOAD_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return LOAD_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DELETE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return SAP_SOL_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return SAPHANA_SOL_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return SAPTDI_SOL_PREVIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FETCH_METRICS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return FETCH_COMPARE_METRICS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return FETCH_COMPARE_SOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return VALIDATE_WORKLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FETCH_RA_BOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EPA_FETCH_SUPPORTEDLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return EPA_DOWNLOAD_METRICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return EPA_EXPORT_COMPARESOLUTIONDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return UPDATE_LOOKUPSERVERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return POST_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return UNSUBSCRIBE_USER_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return FETCH_USER_BUSINESS_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMPARE_SOL_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPARE_GLGROWTH_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return SSOLOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return SHARE_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPT_WLSL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return REJECT_WLSL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return LOAD_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DOWNLOAD_FILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return FETCH_SETTINGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return GET_WORKLOAD_WITH_MAINSTREAM; });
var ADD_SESSION='ADD_SESSION';var CHANGE_SESSION='CHANGE_SESSION';var DELETE_SESSION='DELETE_SESSION';var UPDATE_SESSION='UPDATE_SESSION';var UPDATE_WORKLOAD='UPDATE_WORKLOAD';var SAVE_DATA='SAVE_DATA';var SERVER_ERROR='SERVER_ERROR';var COUNTRY_CHANGE='COUNTRY_CHANGE';var TOGGLE_SIZE_BUTTON='TOGGLE_SIZE_BUTTON';var CLOSE_EULA='CLOSE_EULA';var ERROR_SESSION='ERROR_SESSION';var CLEAR_GUIDANCE_ERROR='CLEAR_GUIDANCE_ERROR';var POSTSSET_PENDING='POSTSSET_PENDING';var CHECK_LOGIN='CHECK_LOGIN';var asyncActionType=function asyncActionType(type){return{PENDING:type+'_PENDING',SUCCESS:type+'_SUCCESS',ERROR:type+'_ERROR'};};// API
var API_REQUEST='API_REQUEST';var API_REQUEST_POST='API_REQUEST_POST';var API_REQUEST_BLOB='API_REQUEST_BLOB';var API_REQUEST_POST_BLOB='API_REQUEST_POST_BLOB';var CANCEL_API_REQUEST='CANCEL_API_REQUEST';var REDIRECT_CONFLICT='REDIRECT_CONFLICT';var EPA_ACTV_SOLN_CHANGE='EPA_ACTV_SOLN_CHANGE';var OPENED_SAVEWORKLOAD='OPENED_SAVEWORKLOAD';// Recipes
var FETCH_WORKLOADS=asyncActionType('FETCH_WORKLOADS');var FETCH_BOM=asyncActionType('FETCH_BOM');var FETCH_GR_INPUT=asyncActionType('FETCH_GR_INPUT');var FETCH_GRBOM=asyncActionType('FETCH_GRBOM');var FETCH_CONFIGDETAILS=asyncActionType('FETCH_CONFIGDETAILS');var FETCH_DEFAULT_DATA=asyncActionType('FETCH_DEFAULT_DATA');var FETCH_SOLUTION=asyncActionType('FETCH_SOLUTION');var FETCH_SOLUTION_ADVANCED=asyncActionType('FETCH_SOLUTION_ADVANCED');var SAVE_WORKLOAD=asyncActionType('SAVE_WORKLOAD');var SAVE_SOLUTION=asyncActionType('SAVE_SOLUTION');var LOAD_USER_DATA=asyncActionType('LOAD_USER_DATA');var LOAD_SELECTION=asyncActionType('LOAD_SELECTION');var DELETE_SELECTION=asyncActionType('DELETE_SELECTION');var SAP_SOL_PREVIEW=asyncActionType('SAP_SOL_PREVIEW');var SAPHANA_SOL_PREVIEW=asyncActionType('SAPHANA_SOL_PREVIEW');var SAPTDI_SOL_PREVIEW=asyncActionType('SAPTDI_SOL_PREVIEW');var FETCH_METRICS_DATA=asyncActionType('FETCH_METRICS_DATA');var FETCH_COMPARE_METRICS_DATA=asyncActionType('FETCH_COMPARE_METRICS_DATA');var FETCH_COMPARE_SOLUTION=asyncActionType('FETCH_COMPARE_SOLUTION');var VALIDATE_WORKLOAD=asyncActionType('VALIDATE_WORKLOAD');var FETCH_RA_BOM=asyncActionType('FETCH_RA_BOM');var EPA_FETCH_SUPPORTEDLIST=asyncActionType('EPA_FETCH_SUPPORTEDLIST');var EPA_DOWNLOAD_METRICS=asyncActionType('EPA_DOWNLOAD_METRICS');var EPA_EXPORT_COMPARESOLUTIONDATA=asyncActionType('EPA_EXPORT_COMPARESOLUTIONDATA');var UPDATE_LOOKUPSERVERS=asyncActionType('UPDATE_LOOKUPSERVERS');var POST_USER_DATA=asyncActionType('POST_USER_DATA');var UNSUBSCRIBE_USER_DATA=asyncActionType('UNSUBSCRIBE_USER_DATA');var FETCH_USER_BUSINESS_INFO=asyncActionType('FETCH_USER_BUSINESS_INFO');var COMPARE_SOL_DATA=asyncActionType('COMPARE_SOL_DATA');var LOGOUT=asyncActionType('LOGOUT');var COMPARE_GLGROWTH_DATA=asyncActionType('COMPARE_GLGROWTH_DATA');var LOGIN=asyncActionType('LOGIN');var SSOLOGIN=asyncActionType('SSOLOGIN');var SHARE_SELECTION=asyncActionType('SHARE_SELECTION');var ACCEPT_WLSL=asyncActionType('ACCEPT_WLSL');var REJECT_WLSL=asyncActionType('REJECT_WLSL');var LOAD_NOTIFICATIONS=asyncActionType('LOAD_NOTIFICATIONS');var DOWNLOAD_FILE=asyncActionType('DOWNLOAD_FILE');var FETCH_SETTINGS=asyncActionType('FETCH_SETTINGS');var GET_WORKLOAD_WITH_MAINSTREAM=asyncActionType('GET_WORKLOAD_WITH_MAINSTREAM');

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(240);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(120);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(244);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(156);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Prompt; });
/* unused harmony export Redirect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* unused harmony export withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var historyContext =
/*#__PURE__*/
createNamedContext("Router-History");

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext$1 = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext$1("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["default"])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Locale = __webpack_require__(483);

var _SkipLinks = __webpack_require__(485);

var _SkipLinks2 = _interopRequireDefault(_SkipLinks);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.APP;

var supportedLocales = ['en-US', 'pt-BR'];

function localesSupported() {
  return global.Intl && supportedLocales.every(function (locale) {
    return Intl.NumberFormat.supportedLocalesOf(locale)[0] === locale && Intl.DateTimeFormat.supportedLocalesOf(locale)[0] === locale;
  });
}

if (!localesSupported()) {
  __webpack_require__(505);
  __webpack_require__(508);
  __webpack_require__(509);
  Intl.NumberFormat = IntlPolyfill.NumberFormat;
  Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
}

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props, context) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));

    _this.state = {
      lang: 'en-US'
    };
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var lang = this.props.lang || (0, _Locale.getCurrentLocale)();

      if (!document.documentElement.getAttribute('lang')) {
        document.documentElement.setAttribute('lang', lang);
      }
      this.setState({ lang: lang });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          centered = _props.centered,
          children = _props.children,
          className = _props.className,
          inline = _props.inline,
          props = _objectWithoutProperties(_props, ['centered', 'children', 'className', 'inline']);

      var lang = this.state.lang;


      var classes = (0, _classnames3.default)('grommet', CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--centered', centered), _defineProperty(_classnames, CLASS_ROOT + '--inline', inline), _classnames), className);

      return _react2.default.createElement(
        'div',
        _extends({ lang: lang, className: classes }, props),
        children,
        _react2.default.createElement(_SkipLinks2.default, null),
        _react2.default.createElement('div', { className: CLASS_ROOT + '__announcer', 'aria-live': 'polite' })
      );
    }
  }]);

  return App;
}(_react.Component);

App.displayName = 'App';
exports.default = App;


App.propTypes = {
  centered: _propTypes2.default.bool,
  inline: _propTypes2.default.bool
};

App.defaultProps = {
  centered: true
};
module.exports = exports['default'];
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enUS = __webpack_require__(159);

Object.keys(_enUS).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _enUS[key];
    }
  });
});

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _frFR = __webpack_require__(160);

Object.keys(_frFR).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _frFR[key];
    }
  });
});

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _enUS = __webpack_require__(58);

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {מסננים}\n  =1 {מסנן\n  ' + 'other {# מסננים}\n}'
  }
}, _enUS2.default, {
  Active: 'פעיל',
  Activate: 'הפעל',
  Activated: 'מופעל',
  Add: 'הוסף',
  add: 'הוסף',
  Alerts: 'התראות',
  All: 'הכל',
  ampm: 'ampm',
  Arc: 'קשת',
  AxisLabel: '{orientation} ציר',
  area: 'אזור',
  Bar: 'בר',
  bar: 'בר',
  Blank: 'ריק',
  Box: 'מסגרת',
  Carousel: 'קרוסלה',
  Category: 'קטגוריה',
  Circle: 'מעגל',
  Chart: 'תרשים',
  Children: 'ילדים',
  Clear: 'נקה טופס',
  Cleared: 'טופס נוקה',
  Close: 'סגור',
  'Close Menu': 'סגור תפריט',
  Completed: 'הושלם',
  'Connects With': 'מתחבר',
  created: 'נוצר',
  Critical: 'קריטי',
  'Currently Active': 'בחירה נוכחית',
  'Date Selector': 'בחירת תאריך',
  'Date Time Icon': 'פתח בחירת תאריך ושעה',
  day: 'יום',
  Disabled: 'לא פעיל',
  Distribution: 'הפצה',
  Email: 'דוא״ל',
  'Enter Select': 'הקש Enter לבחירה',
  Error: 'שגיאה',
  Filter: 'סנן',
  Footer: 'כותרת תחתונה',
  Grommet: 'Grommet',
  HotSpotsLabel: 'נקודות חמות: השתמש במקשי החצים לאינטרקציה',
  'GraphValues': 'הגרף מכיל {count} ערכים, הערך הגבוה הינו {highest}' + ' והנמוך הינו {smallest}',
  hour: 'שעה',
  'Grommet Logo': 'Grommet לוגו',
  'Layer': 'שכבה',
  List: 'רשימה',
  line: 'קו',
  'Loading': 'טוען',
  loginInvalidPassword: 'הכנס שם משתמש וסיסמא',
  'Log In': 'התחבר',
  Logout: 'התנתק',
  'Main Content': 'תוכן עיקרי',
  Max: 'מקסימלי',
  Menu: 'תפריט',
  Meter: 'מונה',
  Min: 'מינמאלי',
  minute: 'דקה',
  model: 'מודל',
  modified: 'שונה',
  monitor: 'ניטור',
  month: 'חודש',
  'Multi Select': 'בחירה מרובה',
  Name: 'שם',
  'Navigation Help': 'התשמש בחיצים לניווט',
  'Next Month': 'חודש הבא',
  'Next Slide': 'שקופית הבאה',
  'No Relationship': 'ללא קשר',
  'Notification': 'התראה',
  OK: 'אשר',
  Open: 'פתח',
  Parent: 'מקור',
  Parents: 'מקורות',
  Parts: 'חלקים',
  Part: 'חלק',
  Password: 'סיסמא',
  'Previous Month': 'חודש קודם',
  'Previous Slide': 'שקופית קודמת',
  'Previous Tiles': 'אריחים קודמים',
  'Remember me': 'זכור אותי',
  Resource: 'משאב',
  Running: 'הרצה',
  Search: 'חפש',
  'Match Results': '\u05D9\u05E9 {count, plural,\n      =0 {\u05E8\u05D9\u05E7}\n      one {\u05EA\u05D5\u05E6\u05D0\u05D4 \u05D0\u05D7\u05EA}\n      other {# \u05EA\u05D5\u05E6\u05D0\u05D5\u05EA}\n  }',
  second: 'שנייה',
  'Select Icon': 'פתח בחירה',
  Selected: 'נבחר',
  'Selected Multiple': '{count, plural,\n      =0 {\u05E8\u05D9\u05E7}\n      one {# \u05E2\u05E8\u05DA}\n      other {# \u05E2\u05E8\u05DB\u05D9\u05DD}\n  }',
  'Skip to': 'קופץ ל',
  'Slide Number': 'שקופית {slideNumber}',
  Sort: 'מיין',
  Spinning: 'מסתובב',
  Spiral: 'ספירלי',
  State: 'מצב',
  Status: 'סטטוס',
  Subtract: 'לחסר',
  SunBurst: 'תרשים עוגה',
  'Tab Contents': '{activeTitle} תוכן',
  Table: 'טבלה',
  Tasks: 'משימות',
  Tiles: 'אריחים',
  Time: 'שעה',
  Title: 'כותרת',
  Today: 'היום',
  Topology: 'טופולוגיה',
  Total: 'סה"כ',
  Threshold: 'סף',
  Unknown: 'לא ידוע',
  Username: 'שם משתמש',
  uri: 'URI',
  Value: 'ערך',
  Warning: 'אזהרה',
  year: 'שנה'
});
module.exports = exports['default'];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enUS = __webpack_require__(58);

Object.keys(_enUS).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _enUS[key];
    }
  });
});

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _frFR = __webpack_require__(122);

Object.keys(_frFR).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _frFR[key];
    }
  });
});

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jaJP = __webpack_require__(161);

Object.keys(_jaJP).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _jaJP[key];
    }
  });
});

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _zhCN = __webpack_require__(163);

Object.keys(_zhCN).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _zhCN[key];
    }
  });
});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jaJP = __webpack_require__(164);

Object.keys(_jaJP).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _jaJP[key];
    }
  });
});

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var _nl = __webpack_require__(162);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _extends({
  IndexFilters: {
    filters: '{quantity, plural,\n  =0 {Filters}\n  =1 {\xE9\xE9n filter}\n  ' + 'other {# filters}\n}'
  }
}, _nl2.default, {
  Active: 'Actief',
  Activate: 'Activeer',
  Activated: 'Geactiveerd',
  Add: 'Voeg toe',
  add: 'voeg toe',
  Alerts: 'Alarmen',
  All: 'Alle',
  ampm: 'ampm',
  Arc: 'Boog',
  AxisLabel: '{orientation} as',
  area: 'gebied',
  Bar: 'Balk',
  bar: 'balk',
  Blank: 'Blank',
  Box: 'Box',
  Carousel: 'Carousel',
  Category: 'Categorie',
  Circle: 'Circel',
  Chart: 'Diagram',
  Children: 'Kinderen',
  Clear: 'Leeg maken',
  Cleared: 'Leeg gemaakt',
  Close: 'Sluiten',
  'Close Menu': 'Sluitmenu',
  Completed: 'Gereed',
  'Connects With': 'Verbindt met',
  created: 'Aangemaakt',
  Critical: 'Critisch',
  'Currently Active': 'Momenteel actief',
  'Date Selector': 'Keuze datum',
  'Date Time Icon': 'Open keuze datum en tijd',
  day: 'dag',
  Disabled: 'Uitgeschakeld',
  Distribution: 'Distributie',
  Email: 'E-mail',
  'Enter Select': 'Druk op enter om het te selecteren',
  Error: 'Fout',
  Filter: 'Filter',
  Footer: 'Footer',
  Grommet: 'Grommet',
  HotSpotsLabel: 'HotSpots: druk op de pijltjes om ermee te werken',
  'GraphValues': 'De grafiek heeft {count} elementen. Het grootste is {highest}' + ' en het kleinste is {smallest}',
  hour: 'uur',
  'Grommet Logo': 'Grommet logo',
  'Layer': 'Laag',
  List: 'Lijst',
  line: 'lijn',
  'Loading': 'Aan het laden',
  loginInvalidPassword: 'Gelieve een gebruikersnaam en wachtwoord te geven.',
  'Log In': 'Aanmelden',
  Logout: 'Afmelden',
  'Main Content': 'Hoofdinhoud',
  Max: 'Maximum',
  Menu: 'Menu',
  Meter: 'Meter',
  Min: 'Mininum',
  minute: 'minuut',
  model: 'Model',
  modified: 'Gewijzigd',
  monitor: 'monitor',
  month: 'maand',
  'Multi Select': 'Multi-select',
  Name: 'Naam',
  'Navigation Help': 'Gebruik de pijltjes om te navigeren',
  'Next Month': 'Volgende maand',
  'Next Slide': 'Volgende dia',
  'No Relationship': 'Geen relatie',
  'Notification': 'Notificatie',
  OK: 'OK',
  Open: 'Open',
  Parent: 'Ouder',
  Parents: 'Ouders',
  Parts: 'Onderdelen',
  Part: 'Onderdeel',
  Password: 'Wachtwoord',
  'Previous Month': 'Vorige maand',
  'Previous Slide': 'Vorige dia',
  'Previous Tiles': 'Vorige tegel',
  'Remember me': 'Onthoud mij',
  Resource: 'Middel',
  Running: 'Loopt',
  Search: 'Zoek',
  'Match Results': 'Er {count, plural,\n      =0 {is geen resultaat}\n      one {is # resultaat}\n      other {zijn # resultaten}\n  }',
  second: 'seconde',
  'Select Icon': 'Open selectiemenu',
  Selected: 'Geselecteerd',
  'Selected Multiple': '{count, plural,\n      =0 {geen}\n      one {# waarde}\n      other {# waarden}\n  }',
  'Skip to': 'Spring naar',
  'Slide Number': 'Dia {slideNumber}',
  Sort: 'Sorteer',
  Spinning: 'Aan het draaien',
  Spiral: 'Spiraal',
  State: 'Toestand',
  Status: 'Status',
  Subtract: 'Aftrekken',
  SunBurst: 'SunBurst',
  'Tab Contents': '{activeTitle} Tabinhoud',
  Table: 'Tabel',
  Tasks: 'Taken',
  Tiles: 'Tegels',
  Time: 'Tijd',
  Title: 'Titel',
  Today: 'Vandaag',
  Topology: 'Topologie',
  Total: 'Totaal',
  Threshold: 'Drempel',
  Unknown: 'Onbekend',
  Username: 'Gebruikersnaam',
  uri: 'URI',
  Value: 'Waarde',
  Warning: 'Waarschuwing',
  year: 'jaar'
});
module.exports = exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ptBR = __webpack_require__(165);

Object.keys(_ptBR).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ptBR[key];
    }
  });
});

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ruRU = __webpack_require__(166);

Object.keys(_ruRU).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ruRU[key];
    }
  });
});

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _zhCN = __webpack_require__(167);

Object.keys(_zhCN).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _zhCN[key];
    }
  });
});

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

// NOTE: This component is a temporary wrapper of react-intl FormattedMessage
// to avoid errors being thrown if the context hasn't been wrapped by
// IntlProvider. The hope is that react-intl will change to obviate the
// need for this component.

var GrommetFormattedMessage = function GrommetFormattedMessage(props, context) {
  return context.intl ? _react2.default.createElement(_reactIntl.FormattedMessage, props) : _react2.default.createElement(
    'span',
    null,
    props.defaultMessage || props.id
  );
};

GrommetFormattedMessage.contextTypes = {
  intl: _propTypes2.default.object
};

GrommetFormattedMessage.propTypes = {
  id: _propTypes2.default.string.isRequired,
  defaultMessage: _propTypes2.default.string
};

GrommetFormattedMessage.displayName = 'GrommetFormattedMessage';

exports.default = GrommetFormattedMessage;
module.exports = exports['default'];

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(488)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(495);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i, len, source, key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) { continue; }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;

var SkipLinkAnchor = function (_Component) {
  _inherits(SkipLinkAnchor, _Component);

  function SkipLinkAnchor() {
    _classCallCheck(this, SkipLinkAnchor);

    return _possibleConstructorReturn(this, (SkipLinkAnchor.__proto__ || Object.getPrototypeOf(SkipLinkAnchor)).apply(this, arguments));
  }

  _createClass(SkipLinkAnchor, [{
    key: 'render',
    value: function render() {
      var id = 'skip-link-' + this.props.label.toLowerCase().replace(/ /g, '_');

      return _react2.default.createElement(
        'a',
        { tabIndex: '-1', 'aria-hidden': 'true', id: id, className: CLASS_ROOT },
        this.props.label
      );
    }
  }]);

  return SkipLinkAnchor;
}(_react.Component);

SkipLinkAnchor.displayName = 'SkipLinkAnchor';
exports.default = SkipLinkAnchor;


SkipLinkAnchor.propTypes = {
  label: _propTypes2.default.node.isRequired
};
module.exports = exports['default'];

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'down');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 3.174 17.086 13.174 7.086 23.174', transform: 'scale(1 -1) rotate(-89 -1.32 0)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Down';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkLogin; });
/* unused harmony export getUserBasicInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ssoLogin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppConfig__ = __webpack_require__(13);
var checkLogin=function checkLogin(userData){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["h" /* CHECK_LOGIN */],payload:{username:userData.userName,password:userData.password,clang:userData.clang,createtimestamp:userData.createtimestamp,email:userData.email,hpclidnumber:userData.hpclidnumber,hpclname:userData.hpclname,hpresidentcountrycode:userData.hpresidentcountrycode,modifytimestamp:userData.modifytimestamp,preferredLanguage:userData.preferredLanguage,lastName:userData.lastName}};};var getUserBasicInfo=function getUserBasicInfo(hppSession){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/GetPassportUserInfo',//url: 'http://localhost:60058/SizingEngine/GetPassportUserInfo',
//data: {'sessionID' : hppSession},
next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["H" /* FETCH_USER_BUSINESS_INFO */]}};};var login=function login(isNonHPECOMDomain){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/Login',//url: 'http://localhost:60058/SizingEngine/Login',
next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["N" /* LOGIN */]}};};var logOut=function logOut(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["e" /* API_REQUEST_POST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/LogOut',//url: 'http://localhost:60058/SizingEngine/LogOut',
next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["O" /* LOGOUT */]}};};var ssoLogin=function ssoLogin(){return{type:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["c" /* API_REQUEST */],payload:{url:__WEBPACK_IMPORTED_MODULE_1__AppConfig__["g" /* serviceUrl */]+'SizingEngine/SSOLogin',//url: 'http://localhost:60058/SizingEngine/LogOut',
next:__WEBPACK_IMPORTED_MODULE_0__constants_actionTypes__["_1" /* SSOLOGIN */]}};};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = docPropType;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getArgs(args) {
  return args.map(function (arg) {
    if (arg.type && _propTypes2.default[arg.type]) {
      if (arg.args) {
        if (arg.type === 'shape') {
          return buildShapePropType(arg);
        }
        return _propTypes2.default[arg.type](arg.args);
      }
      return _propTypes2.default[arg.type];
    }
    return arg;
  });
}

function getPropType(validate) {
  return _propTypes2.default[validate.type](validate.args.type && _propTypes2.default[validate.args.type] ? _propTypes2.default[validate.args.type] : validate.args);
}

// function to recursively build the proptype for shape
function buildShapePropType(validate) {
  var args = {};
  Object.keys(validate.args).forEach(function (arg) {
    var element = validate.args[arg];
    if (element.type && _propTypes2.default[element.type]) {
      if (element.args) {
        if (element.type === 'oneOfType') {
          var elementArgs = getArgs(element.args);
          args[arg] = _propTypes2.default[element.type](elementArgs);
        } else if (element.type === 'shape') {
          args[arg] = buildShapePropType(element);
        } else {
          args[arg] = getPropType(element);
        }
      } else {
        args[arg] = _propTypes2.default[element.type];
      }
    } else if (element.type) {
      throw new Error('docPropType: unknown type ' + element.type);
    }
  });

  return _propTypes2.default[validate.type](args);
}

function docPropType(validate, description) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!description) {
    throw new Error('docPropType: description is required');
  }
  if (!validate) {
    throw new Error('docPropType: validate is required');
  }

  var required = options.required;

  var type = validate;
  if (validate.type && _propTypes2.default[validate.type]) {
    if (validate.args) {
      if (validate.type === 'oneOfType') {
        var args = getArgs(validate.args);
        type = _propTypes2.default[validate.type](args);
      } else if (validate.type === 'shape') {
        type = buildShapePropType(validate);
      } else if (validate.type === 'arrayOf' && validate.args.type === 'oneOfType') {
        var _args = getArgs(validate.args.args);
        var v = _extends({}, validate);
        v.args = _propTypes2.default[validate.args.type](_args);
        type = getPropType(v);
      } else {
        type = getPropType(validate);
      }
    } else {
      type = _propTypes2.default[validate.type];
    }
  } else if (validate.type) {
    throw new Error('docPropType: unknown type ' + validate.type);
  }
  // clone function
  var propType = type.bind(null);
  if (type.isRequired) {
    propType.isRequired = type.isRequired.bind(null);
  }
  if (required && propType.isRequired) {
    propType = propType.isRequired;
  }
  propType.$$reactDesc = { description: description, validate: validate, options: options };
  return propType;
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDocAsJSON;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function buildShapeFormat(validate) {
  var format = {};
  Object.keys(validate.args).forEach(function (arg) {
    var element = validate.args[arg];
    if (element.type === 'shape') {
      format[arg] = buildShapeFormat(element, true);
    } else {
      format[arg] = getFormat(element);
    }
  });
  return format;
}

function getFormat(validate) {
  switch (validate.type) {
    case 'arrayOf':
      return '[' + validate.args.type + ', ...]';
    case 'bool':
      return 'boolean';
    case 'func':
      return 'function';
    case 'instanceOf':
      return 'new ' + validate.args.name + '(...)';
    case 'objectOf':
      return '{ test: ' + validate.args.type + ', ... }';
    case 'oneOf':
      return validate.args;
    case 'oneOfType':
      return validate.args.map(function (arg) {
        return getFormat(arg);
      });
    case 'shape':
      return JSON.stringify(buildShapeFormat(validate));
    default:
      return validate.type ? validate.type : 'custom';
  }
}

function getPropTypeAsJson(propType, propName, defaultValue) {
  var _propType$$$reactDesc = propType.$$reactDesc.options,
      deprecated = _propType$$$reactDesc.deprecated,
      format = _propType$$$reactDesc.format,
      required = _propType$$$reactDesc.required,
      extras = _objectWithoutProperties(_propType$$$reactDesc, ['deprecated', 'format', 'required']);

  var validate = propType.$$reactDesc.validate;

  var documentation = {
    description: propType.$$reactDesc.description,
    name: propName
  };

  if (defaultValue) {
    documentation.defaultValue = defaultValue;
  }

  if (deprecated) {
    documentation.deprecated = deprecated;
  }

  if (required) {
    documentation.required = required;
  }

  if (Object.keys(extras).length > 0) {
    documentation.extras = extras;
  }

  documentation.format = format || getFormat(validate);

  return documentation;
}

function getDocAsJSON(component) {
  if (!component) {
    throw new Error('getDocAsJSON: component is required');
  }

  var documentation = {
    name: component.displayName || component.name
  };
  if (component.$$reactDesc) {
    Object.assign(documentation, component.$$reactDesc);

    if (component.propTypes) {
      var propTypes = [];
      Object.keys(component.propTypes).forEach(function (propName) {
        var propType = component.propTypes[propName];
        if (propType.$$reactDesc) {
          propTypes.push(getPropTypeAsJson(propType, propName, (component.defaultProps || {})[propName]));
        }
      });
      if (propTypes.length > 0) {
        documentation.properties = propTypes;
      }
    }
  }
  return documentation;
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(169);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _LinkDown = __webpack_require__(526);

var _LinkDown2 = _interopRequireDefault(_LinkDown);

var _LinkUp = __webpack_require__(527);

var _LinkUp2 = _interopRequireDefault(_LinkUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var TableHeader = function (_Component) {
  _inherits(TableHeader, _Component);

  function TableHeader() {
    _classCallCheck(this, TableHeader);

    return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
  }

  _createClass(TableHeader, [{
    key: '_onSort',
    value: function _onSort(index) {
      var _props = this.props,
          onSort = _props.onSort,
          sortAscending = _props.sortAscending,
          sortIndex = _props.sortIndex;

      var nextAscending = void 0;
      if (index !== sortIndex) {
        nextAscending = false;
      } else {
        nextAscending = !sortAscending;
      }
      onSort(index, nextAscending);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          labels = _props2.labels,
          onSort = _props2.onSort,
          sortAscending = _props2.sortAscending,
          sortIndex = _props2.sortIndex,
          props = _objectWithoutProperties(_props2, ['labels', 'onSort', 'sortAscending', 'sortIndex']);

      var cells = labels.map(function (label, index) {
        var content = void 0;
        var options = {};

        if (Array.isArray(label)) {
          var _label = _slicedToArray(label, 2);

          content = _label[0];
          var _label$ = _label[1];
          options = _label$ === undefined ? {} : _label$;
        } else {
          content = label;
          options.sortable = !!onSort;
        }

        if (sortIndex >= 0) {
          var sortIndicator = void 0;
          if (index === sortIndex) {
            sortIndicator = sortAscending ? _react2.default.createElement(_LinkDown2.default, null) : _react2.default.createElement(_LinkUp2.default, null);
          }
          content = _react2.default.createElement(
            _Box2.default,
            { direction: 'row', justify: 'start', align: 'center',
              pad: { between: 'small' } },
            _react2.default.createElement(
              'span',
              null,
              content
            ),
            sortIndicator
          );

          if (options.sortable) {
            content = _react2.default.createElement(
              _Button2.default,
              { plain: true, fill: true,
                onClick: _this2._onSort.bind(_this2, index) },
              content
            );
          }
        }

        return _react2.default.createElement(
          'th',
          { key: index },
          content
        );
      });

      return _react2.default.createElement(
        'thead',
        props,
        _react2.default.createElement(
          'tr',
          null,
          cells
        )
      );
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.displayName = 'TableHeader';
exports.default = TableHeader;


TableHeader.propTypes = {
  labels: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array])).isRequired,
  onSort: _propTypes2.default.func, // (index, ascending?)
  sortAscending: _propTypes2.default.bool,
  sortIndex: _propTypes2.default.number
};
module.exports = exports['default'];

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-user', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'user');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M8,24 L8,19 M16,24 L16,19 M3,24 L3,19 C3,14.0294373 7.02943725,11 12,11 C16.9705627,11 21,14.0294373 21,19 L21,24 M12,11 C14.7614237,11 17,8.76142375 17,6 C17,3.23857625 14.7614237,1 12,1 C9.23857625,1 7,3.23857625 7,6 C7,8.76142375 9.23857625,11 12,11 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'User';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16.1251884,2.42026615 C16.9095797,1.63587482 18.1818354,1.63638083 18.9643331,2.41887857 L21.5811214,5.03566688 C22.3647464,5.81929188 22.3723943,7.08215115 21.5797338,7.87481161 L17.8748116,11.5797338 C17.0904203,12.3641252 15.8181646,12.3636192 15.0356669,11.5811214 L12.4188786,8.96433312 C11.6352536,8.18070812 11.6276057,6.91784885 12.4202662,6.12518839 L16.1251884,2.42026615 Z M6.12518839,12.4202662 C6.90957973,11.6358748 8.18183538,11.6363808 8.96433312,12.4188786 L11.5811214,15.0356669 C12.3647464,15.8192919 12.3723943,17.0821512 11.5797338,17.8748116 L7.87481161,21.5797338 C7.09042027,22.3641252 5.81816462,22.3636192 5.03566688,21.5811214 L2.41887857,18.9643331 C1.63525357,18.1807081 1.6276057,16.9178488 2.42026615,16.1251884 L6.12518839,12.4202662 Z M7,17 L17,7' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Link';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-trash', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-trash');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M7.5,9 L16.5,9 L16.5,19 L7.5,19 L7.5,9 Z M5,9 L19,9 M9.36363636,6 L14.3636364,6 L14.3636364,9 L9.36363636,9 L9.36363636,6 Z M10.5455,11 L10.5455,17 M13.5455,11 L13.5455,17' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormTrash';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-edit', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-edit');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M11.9955241,8.33576576 L15.4932862,11.8335278 L11.9955241,8.33576576 Z M17.5365751,7.79609426 C17.9262629,8.18578207 17.9321949,8.81165877 17.5321697,9.21168397 L10.0807224,16.6631313 L6,17.829052 L7.16592069,13.7483296 L14.617368,6.29688224 C15.0094888,5.90476144 15.6393004,5.89881957 16.0329577,6.29247691 L17.5365751,7.79609426 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormEdit';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames4 = __webpack_require__(3);

var _classnames5 = _interopRequireDefault(_classnames4);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.HEADER;

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header(props, context) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props, context));

    _this._onResize = _this._onResize.bind(_this);
    _this._alignMirror = _this._alignMirror.bind(_this);
    return _this;
  }

  _createClass(Header, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fixed) {
        window.addEventListener('resize', this._onResize);
        this._onResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.fixed) {
        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.fixed) {
        clearTimeout(this._resizeTimer);
        window.removeEventListener('resize', this._onResize);
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      // give just a little time for the DOM to stabilize
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(this._alignMirror, 10);
    }
  }, {
    key: '_alignMirror',
    value: function _alignMirror() {
      var contentElement = _reactDom2.default.findDOMNode(this.contentRef);
      var mirrorElement = this.mirrorRef;

      // constrain fixed content to the width of the mirror
      var mirrorRect = mirrorElement.getBoundingClientRect();
      contentElement.style.width = Math.floor(mirrorRect.width) + 'px';

      // align the mirror height with the content's height
      var contentRect = contentElement.getBoundingClientRect();
      mirrorElement.style.height = Math.floor(contentRect.height) + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _classnames2,
          _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          colorIndex = _props.colorIndex,
          fixed = _props.fixed,
          float = _props.float,
          role = _props.role,
          size = _props.size,
          splash = _props.splash;

      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size && typeof size === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--float', float), _defineProperty(_classnames, CLASS_ROOT + '--splash', splash), _classnames), className);
      var containerClasses = (0, _classnames5.default)(CLASS_ROOT + '__container', (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__container--fixed', fixed), _defineProperty(_classnames2, CLASS_ROOT + '__container--fill', fixed && !colorIndex), _defineProperty(_classnames2, CLASS_ROOT + '__container--float', float), _classnames2));
      var wrapperClasses = (0, _classnames5.default)(CLASS_ROOT + '__wrapper', _defineProperty({}, CLASS_ROOT + '__wrapper--' + size, size && typeof size === 'string'));
      var other = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
      var restProps = _Props2.default.omit(this.props, Object.keys(Header.propTypes));
      if (size && typeof size === 'string') {
        // don't transfer size to Box since it means something different
        delete other.size;
      }

      if (fixed) {
        return _react2.default.createElement(
          'div',
          { className: containerClasses },
          _react2.default.createElement('div', { ref: function ref(_ref) {
              return _this2.mirrorRef = _ref;
            },
            className: CLASS_ROOT + '__mirror' }),
          _react2.default.createElement(
            'div',
            { className: wrapperClasses },
            _react2.default.createElement(
              _Box2.default,
              { pad: 'none', flex: false },
              _react2.default.createElement(
                _Box2.default,
                _extends({ ref: function ref(_ref2) {
                    return _this2.contentRef = _ref2;
                  }
                }, other, restProps, { tag: 'header',
                  className: classes }),
                children
              )
            )
          )
        );
      } else {
        return (
          // ie11 does not work with align center and min-height
          // adding a wrapper flex div with column direction fixes the issue
          // https://github.com/philipwalton/flexbugs
          _react2.default.createElement(
            _Box2.default,
            { pad: 'none', flex: false },
            _react2.default.createElement(
              _Box2.default,
              _extends({}, other, restProps, { tag: 'header', role: role,
                className: classes,
                containerClassName: containerClasses }),
              children
            )
          )
        );
      }
    }
  }]);

  return Header;
}(_react.Component);

Header.displayName = 'Header';
exports.default = Header;


Header.propTypes = _extends({
  fixed: _propTypes2.default.bool,
  float: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  splash: _propTypes2.default.bool
}, _Box2.default.propTypes);

Header.defaultProps = {
  pad: { horizontal: 'none', vertical: 'none', between: 'small' },
  direction: 'row',
  align: 'center',
  responsive: false
};
module.exports = exports['default'];

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

/*
 * Scroll provides smooth scrolling.
 */

var SCROLL_STEPS = 25;

function easeInOutQuad(t) {
  return t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

exports.default = {

  // component: component to scroll
  // property: 'scrollTop' | 'scrollLeft'
  // delta: amount to scroll
  // doneHandler: optional function called when the scroll is done

  scrollBy: function scrollBy(component, property, delta, doneHandler) {
    var _this = this;

    clearInterval(this._scrollToTimer);
    var start = component[property];
    var end = start + delta;
    var step = 1;
    this._scrollToTimer = setInterval(function () {
      var current = component[property];
      var next = void 0;
      var easing = easeInOutQuad(step / SCROLL_STEPS);
      if (end > start) {
        next = Math.min(end, Math.max(current, Math.round(start + (end - start) * easing)));
      } else {
        next = Math.max(end, Math.min(current, Math.round(start - (start - end) * easing)));
      }
      component[property] = next;
      step += 1;
      if (step > SCROLL_STEPS) {
        // we're done, but the browser/OS might still be easing from a
        // mouse wheel interaction. So, set it one more time after a bit.
        clearInterval(_this._scrollToTimer);
        _this._scrollToTimer = setTimeout(function () {
          component[property] = next;
          if (doneHandler) {
            doneHandler();
          }
        }, 200);
      }
    }, 8);
  }
};
module.exports = exports["default"];

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-previous', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-previous');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,12 L22,12 M13,3 L22,12 L13,21', transform: 'matrix(-1 0 0 1 24 0)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'LinkPrevious';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);

    // ReactTooltip.rebuild
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);

    // ReactTooltip.show
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
};

var _constant = __webpack_require__(279);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;

    return event || !!ele.getAttribute('data-event');
  };

  /* Bind listener for custom event */
  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff;

    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;

    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListeners.get(ele, event));
      var customListener = checkStatus.bind(_this, dataEventOff);
      customListeners.set(ele, event, customListener);
      ele.addEventListener(event, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };

  /* Unbind listener for custom event */
  target.prototype.customUnbindListener = function (ele) {
    var _state2 = this.state,
        event = _state2.event,
        eventOff = _state2.eventOff;

    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');

    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
};

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */

var checkStatus = exports.checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;

  var isCapture = this.isCapture(e.currentTarget);
  var currentItem = e.currentTarget.getAttribute('currentItem');

  if (!isCapture) e.stopPropagation();
  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListeners = {
  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
  set: function set(target, event, listener) {
    if (this.id in target) {
      var map = target[this.id];
      map[event] = listener;
    } else {
      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
      Object.defineProperty(target, this.id, {
        configurable: true,
        value: _defineProperty({}, event, listener)
      });
    }
  },
  get: function get(target, event) {
    var map = target[this.id];
    if (map !== undefined) {
      return map[event];
    }
  }
};

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export asyncActionType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EPA_FETCH_SUPPORTEDLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return EPA_FETCH_ACTIVEPARTNUMBERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FILTERED_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CONTROLLER_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ERROR_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CALC_DISABLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHANGE_GATEWAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SERVER_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_NODEQTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_DEFAULT_WRKLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARCVALUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return OSLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EPAVNEXT_FETCH_TEMPLATELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EPICREQUIREMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALCULATEBLUEDATACONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CALCULATEBLUEDATACONFIGFALSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_GATEWAYDLTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GETEXTRANODES_QTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return OSLISTBLUEDATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FETCH_ANALYTICSDATABASENODEQTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TENANTDRIVELIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GATEWAY_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CONTROLLER_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MASTER_RECOMMENDATIONS; });
var asyncActionType=function asyncActionType(type){return{PENDING:type+'_PENDING',SUCCESS:type+'_SUCCESS',ERROR:type+'_ERROR'};};var EPA_FETCH_SUPPORTEDLIST=asyncActionType('EPA_FETCH_SUPPORTEDLIST');var EPA_FETCH_ACTIVEPARTNUMBERS=asyncActionType('EPA_FETCH_ACTIVEPARTNUMBERS');var FILTERED_COMPONENTS='FILTERED_COMPONENTS';var CONTROLLER_CONFIG='CONTROLLER_CONFIG';var ERROR_CLOSE='ERROR_CLOSE';var CALC_DISABLED='CALC_DISABLED';var CHANGE_GATEWAY='CHANGE_GATEWAY';var SERVER_LIST=asyncActionType('SERVER_LIST');var FETCH_NODEQTY=asyncActionType('FETCH_NODEQTY');var FETCH_DEFAULT_WRKLD=asyncActionType('FETCH_DEFAULT_WRKLD');var ARCVALUE=asyncActionType('ARCVALUE');var OSLIST=asyncActionType('OSLIST');var EPAVNEXT_FETCH_TEMPLATELIST=asyncActionType('EPAVNEXT_FETCH_TEMPLATELIST');var EPICREQUIREMENTS=asyncActionType('EPICREQUIREMENTS');var CALCULATEBLUEDATACONFIG=asyncActionType('CALCULATEBLUEDATACONFIG');var CALCULATEBLUEDATACONFIGFALSE=asyncActionType('CALCULATEBLUEDATACONFIGFALSE');var FETCH_GATEWAYDLTS=asyncActionType('FETCH_GATEWAYDLTS');var GETEXTRANODES_QTY=asyncActionType('GETEXTRANODES_QTY');var OSLISTBLUEDATA=asyncActionType('OSLISTBLUEDATA');var FETCH_ANALYTICSDATABASENODEQTY=asyncActionType('FETCH_ANALYTICSDATABASENODEQTY');var TENANTDRIVELIST=asyncActionType('TENANTDRIVELIST');var GATEWAY_RECOMMENDATIONS=asyncActionType('GATEWAY_RECOMMENDATIONS');var CONTROLLER_RECOMMENDATIONS=asyncActionType('CONTROLLER_RECOMMENDATIONS');var MASTER_RECOMMENDATIONS=asyncActionType("MASTER_RECOMMENDATIONS");

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-form-checkmark', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'form-checkmark');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 13 10.2 16.6 18 7' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'FormCheckmark';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(100);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(52) && !__webpack_require__(179)(function () {
  return Object.defineProperty(__webpack_require__(557)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(132);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(101);
var toLength = __webpack_require__(133);
var toAbsoluteIndex = __webpack_require__(561);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 290 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(292);
var isObject = __webpack_require__(100);
var toLength = __webpack_require__(133);
var ctx = __webpack_require__(287);
var IS_CONCAT_SPREADABLE = __webpack_require__(185)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(289);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(563);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(131);
var toIObject = __webpack_require__(101);
var arrayIndexOf = __webpack_require__(288)(false);
var IE_PROTO = __webpack_require__(295)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(182)('keys');
var uid = __webpack_require__(181);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 296 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 297 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(52);
var getKeys = __webpack_require__(572);
var toIObject = __webpack_require__(101);
var isEnum = __webpack_require__(297).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(131);
var toObject = __webpack_require__(68);
var IE_PROTO = __webpack_require__(295)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(586)('createBrowserHistory');
module.exports = __webpack_require__(587).createBrowserHistory;


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AppConfig__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import {fetchLookupServersList} from '../Redux/actions/SAPactions';
var ServerType="new";var defaultserver=false;var defaultCpuspeed=false;var defaultNoofcpu=false;var SANStorage=function(_Component){_inherits(SANStorage,_Component);function SANStorage(props){_classCallCheck(this,SANStorage);var _this=_possibleConstructorReturn(this,(SANStorage.__proto__||Object.getPrototypeOf(SANStorage)).call(this,props));_this.state={LookupSAP:false,AllServersRadiobutton:false,OnlyNewServersRadiobutton:true,OnlyOldServersRadiobutton:false,NotNewServersRadiobutton:false,onEPH3:false,onEPH4:false,onEPH5:true,SAPversionvalue:'',SAPversionOptions:[],OperatingSystemvalue:'WINDOWS',OperatingSystemOptions:[],ServerTypevalue:'ProLiant',ServerTypeOptions:["ProLiant","Integrity"],ServerOptions:[],Servervalue:"",CpuspeedCachevalue:"",CpuspeedCacheoptions:[],NoofCPUSvalue:"",NoofCPUSvalueoptions:[]};_this.onLookupSAPClick=_this.onLookupSAPClick.bind(_this);_this.LookupSAPClose=_this.LookupSAPClose.bind(_this);_this.onAllServersRadiobuttonChange=_this.onAllServersRadiobuttonChange.bind(_this);_this.onOnlyNewServersRadiobuttonChange=_this.onOnlyNewServersRadiobuttonChange.bind(_this);_this.onOnlyOldServersRadiobuttonChange=_this.onOnlyOldServersRadiobuttonChange.bind(_this);_this.onNotNewServersRadiobuttonChange=_this.onNotNewServersRadiobuttonChange.bind(_this);_this.onEPH3RadiobuttonChange=_this.onEPH3RadiobuttonChange.bind(_this);_this.onEPH4RadiobuttonChange=_this.onEPH4RadiobuttonChange.bind(_this);_this.onEPH5RadiobuttonChange=_this.onEPH5RadiobuttonChange.bind(_this);_this.onSAPversionChange=_this.onSAPversionChange.bind(_this);_this.onOperatingSystemChange=_this.onOperatingSystemChange.bind(_this);_this.onServerTypeChange=_this.onServerTypeChange.bind(_this);_this.onServerChange=_this.onServerChange.bind(_this);_this.onCpuspeedCacheChange=_this.onCpuspeedCacheChange.bind(_this);_this.onNoofCPUSvalueChange=_this.onNoofCPUSvalueChange.bind(_this);return _this;}_createClass(SANStorage,[{key:'onNoofCPUSvalueChange',value:function onNoofCPUSvalueChange(e){defaultNoofcpu=true;this.setState({NoofCPUSvalue:e.value});}},{key:'onCpuspeedCacheChange',value:function onCpuspeedCacheChange(e){defaultCpuspeed=true;defaultNoofcpu=false;this.setState({CpuspeedCachevalue:e.value});}},{key:'onServerChange',value:function onServerChange(e){defaultserver=true;defaultCpuspeed=false;defaultNoofcpu=false;this.setState({Servervalue:e.value});}},{key:'onLookupSAPClick',value:function onLookupSAPClick(){this.setState({LookupSAP:true});}},{key:'LookupSAPClose',value:function LookupSAPClose(){this.setState({LookupSAP:false});}},{key:'onOperatingSystemChange',value:function onOperatingSystemChange(e){defaultserver=false;defaultCpuspeed=false;defaultNoofcpu=false;if(e.value==="HP-UX"){this.state.ServerTypeOptions=["Integrity","PA-RISC"];}else{this.state.ServerTypeOptions=["ProLiant","Integrity"];}this.setState({OperatingSystemvalue:e.value,ServerTypevalue:this.state.ServerTypeOptions[0]});}},{key:'onServerTypeChange',value:function onServerTypeChange(e){defaultserver=false;defaultNoofcpu=false;defaultCpuspeed=false;this.setState({ServerTypevalue:e.value});}},{key:'onAllServersRadiobuttonChange',value:function onAllServersRadiobuttonChange(){var flag=void 0;if(this.state.AllServersRadiobutton===false){flag=true;ServerType="new";}else{flag=false;}this.setState({AllServersRadiobutton:flag,OnlyNewServersRadiobutton:false,OnlyOldServersRadiobutton:false,NotNewServersRadiobutton:false});}},{key:'onOnlyNewServersRadiobuttonChange',value:function onOnlyNewServersRadiobuttonChange(){var flag=void 0;if(this.state.OnlyNewServersRadiobutton===false){flag=true;ServerType="new";}else{flag=false;}this.setState({AllServersRadiobutton:false,OnlyNewServersRadiobutton:flag,OnlyOldServersRadiobutton:false,NotNewServersRadiobutton:false});}},{key:'onOnlyOldServersRadiobuttonChange',value:function onOnlyOldServersRadiobuttonChange(){var flag=void 0;if(this.state.OnlyOldServersRadiobutton===false){flag=true;ServerType="old";}else{flag=false;}this.setState({AllServersRadiobutton:false,OnlyNewServersRadiobutton:false,OnlyOldServersRadiobutton:flag,NotNewServersRadiobutton:false});}},{key:'onNotNewServersRadiobuttonChange',value:function onNotNewServersRadiobuttonChange(){var flag=void 0;if(this.state.NotNewServersRadiobutton===false){flag=true;ServerType="not new";}else{flag=false;}this.setState({AllServersRadiobutton:false,OnlyNewServersRadiobutton:false,OnlyOldServersRadiobutton:false,NotNewServersRadiobutton:flag});}},{key:'onEPH3RadiobuttonChange',value:function onEPH3RadiobuttonChange(){var flag=void 0;if(this.state.onEPH3===false){flag=true;this.state.SAPversionOptions=["4.6","4.7","5.0","6.0"];this.state.SAPversionvalue=this.state.SAPversionOptions[3];}else{flag=false;}this.setState({onEPH3:flag,onEPH4:false,onEPH5:false});}},{key:'onEPH4RadiobuttonChange',value:function onEPH4RadiobuttonChange(){var flag=void 0;if(this.state.onEPH4===false){flag=true;this.state.SAPversionOptions=["4.6","4.7","5.0","6.0 EHP4"];this.state.SAPversionvalue=this.state.SAPversionOptions[3];}else{flag=false;}this.setState({onEPH4:flag,onEPH5:false,onEPH3:false});}},{key:'onEPH5RadiobuttonChange',value:function onEPH5RadiobuttonChange(){var flag=void 0;if(this.state.onEPH5===false){flag=true;this.state.SAPversionOptions=["4.6","4.7","5.0","6.0 EHP5"];this.state.SAPversionvalue=this.state.SAPversionOptions[3];}else{flag=false;}this.setState({onEPH5:flag,onEPH4:false,onEPH3:false});}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.LookupServers===null){this.props.OnFetchLookupServersList('LookUp');}if(this.state.ServerOptions.length>0)this.state.Servervalue=this.state.ServerOptions[0];this.setState({});}},{key:'onSAPversionChange',value:function onSAPversionChange(e){this.setState({SAPversionvalue:e.value});}},{key:'componentWillMount',value:function componentWillMount(){if(this.state.onEPH5===true){this.state.SAPversionOptions=["4.6","4.7","5.0","6.0 EHP5"];this.state.SAPversionvalue=this.state.SAPversionOptions[3];}if(this.state.ServerOptions.length>0)this.state.Servervalue=this.state.ServerOptions[0];if(__WEBPACK_IMPORTED_MODULE_15__AppConfig__["f" /* said */]==='SAPHANA'){this.state.OperatingSystemOptions=["LINUX","WINDOWS"];this.state.OperatingSystemvalue='LINUX';}else{this.state.OperatingSystemOptions=["WINDOWS","LINUX"];}}},{key:'render',value:function render(){var _this2=this;var LookupValue;var LookupTotalValue;var DbNewSap;var Cac=void 0;//let serverduplicate = false;
//Default Servers
if(this.props.LookupServers!==null){var OsType='';this.state.ServerOptions=[];this.state.CpuspeedCacheoptions=[];this.state.NoofCPUSvalueoptions=[];OsType=this.state.OperatingSystemvalue+" "+this.state.ServerTypevalue;//  console.log("AAAAA"+OsType)
this.props.LookupServers.Servers.Server.filter(function(item){// console.log("BBBBB"+item["@OSType"])
if(item["@OSType"]===OsType){if(item["@ServerType"]===ServerType){// if(this.state.ServerOptions.length >0){
//     this.state.ServerOptions.map((server)=>{
//         if(server===item["ServerName"]){
//             serverduplicate=true;
//         }
//     })  
// }
_this2.state.ServerOptions.push(item["ServerName"]);//if(!serverduplicate){
//   this.state.ServerOptions.push(item["ServerName"]);
//}
if(!defaultserver){_this2.state.Servervalue=_this2.state.ServerOptions[0];}//Default CPUSpeed and Cache                       
if(item["ServerName"]===_this2.state.Servervalue){var cache=parseInt(item["Cache"],10)/1024;if(_this2.state.OperatingSystemvalue!=="HP-UX"){_this2.state.CpuspeedCacheoptions.push(item["Speed"]+"/"+cache.toString()+"MB"+"/"+item["Model"]);}else{_this2.state.CpuspeedCacheoptions.push(item["Speed"]+"/"+cache.toString()+"MB");}if(!defaultCpuspeed){_this2.state.CpuspeedCachevalue=_this2.state.CpuspeedCacheoptions[0];}else{}//Default NoofCpu
if(_this2.state.CpuspeedCachevalue!==undefined&&_this2.state.CpuspeedCachevalue!==null&&_this2.state.CpuspeedCachevalue!==" "&&_this2.state.CpuspeedCachevalue!==""){var cpu=_this2.state.CpuspeedCachevalue.split("/");if(_this2.state.OperatingSystemvalue!=="HP-UX"){if(cpu!==undefined&&cpu!==null&&cpu!==" "&&cpu.length>1){if(cpu[2].toString()===item["Model"]){_this2.state.NoofCPUSvalueoptions=[];if(Array.isArray(item.Processors.P)){item.Processors.P.filter(function(num){_this2.state.NoofCPUSvalueoptions.push(num["@ProcModel"]);});}else{_this2.state.NoofCPUSvalueoptions.push(item.Processors.P["@ProcModel"]);}}else{}}}else{// this.state.NoofCPUSvalueoptions=[];
/* Changes by Vinay added cpu  !== undefined && cpu  !== null && cpu  !== " ", for CID:10089*/if(cpu!==undefined&&cpu!==null&&cpu!==" "&&cpu[0].toString()===item["Speed"]){_this2.state.NoofCPUSvalueoptions=[];if(Array.isArray(item.Processors.P)){item.Processors.P.filter(function(num){//Changes by Vinay if condition added to remove duplicate proc models.
if(_this2.state.NoofCPUSvalueoptions.indexOf(num["@procModel"])!==-1)_this2.state.NoofCPUSvalueoptions.push(num["@ProcModel"]);});}else{_this2.state.NoofCPUSvalueoptions.push(item.Processors.P["@ProcModel"]);}if(cpu!==undefined&&cpu!==null&&cpu!==" "&&cpu.length>1){Cac=cpu[1].split("MB");if((parseInt(Cac,10)*1024).toString()===item["Cache"]){item.Processors.P.filter(function(num){_this2.state.NoofCPUSvalueoptions.push(num["@ProcModel"]);});}}}}}if(_this2.state.NoofCPUSvalueoptions.length===0){_this2.state.NoofCPUSvalueoptions=[];if(Array.isArray(item.Processors.P)){item.Processors.P.filter(function(num){_this2.state.NoofCPUSvalueoptions.push(num["@ProcModel"]);});}else{_this2.state.NoofCPUSvalueoptions.push(item.Processors.P["@ProcModel"]);}}if(!defaultNoofcpu){_this2.state.NoofCPUSvalue=_this2.state.NoofCPUSvalueoptions[0];}if(cpu!==undefined&&cpu!==null&&cpu!==" "&&cpu.length>1){Cac=cpu[1].split("MB");/*Changes by Vinay for Crashing issue on selecting HP-UX*/var checkCondition=false;try{if(cpu[0].toString()===item["Speed"]&&parseInt(Cac[0]*1024,10).toString()===item["Cache"]&&cpu[2].toString()===item["Model"]){checkCondition=true;}}catch(e){if(e instanceof TypeError){console.log("TypeError");}if(cpu[0].toString()===item["Speed"]&&parseInt(Cac[0]*1024,10).toString()===item["Cache"]){checkCondition=true;}}//if ((cpu[0].toString() === item["Speed"]) && (parseInt(Cac[0] * 1024, 10).toString() === item["Cache"])) {
if(checkCondition){if(Array.isArray(item.Processors.P)){item.Processors.P.filter(function(num){if(_this2.state.NoofCPUSvalue===num["@ProcModel"]){LookupValue=num["#text"];LookupValue=Math.round(LookupValue/0.855)/0.721/0.95;LookupValue=Math.floor(LookupValue/10);LookupValue=parseInt(LookupValue*10,10);LookupTotalValue=LookupValue;if(_this2.state.SAPversionvalue==="5.0"){LookupTotalValue=parseInt(LookupTotalValue*0.9,10);}else if(_this2.state.SAPversionvalue==="6.0"||_this2.state.SAPversionvalue==="6.0 EHP4"||_this2.state.SAPversionvalue==="6.0 EHP5"){LookupTotalValue=parseInt(LookupTotalValue*0.855,10);}else if(_this2.state.SAPversionvalue==="4.6"){LookupTotalValue=parseInt(LookupTotalValue*1.052631579,10);}if(_this2.state.OperatingSystemvalue==="Linux"&&_this2.state.ServerTypevalue==="Integrity"){LookupTotalValue=parseInt(LookupTotalValue-LookupTotalValue*0.1,10);}if(__WEBPACK_IMPORTED_MODULE_15__AppConfig__["f" /* said */]==='SAPHANA'&&_this2.state.SAPversionvalue==="4.7"){LookupTotalValue=LookupValue;}else if(_this2.state.onEPH3===true){DbNewSap=LookupTotalValue/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;}else if(_this2.state.onEPH4===true){if(_this2.state.SAPversionvalue==="6.0"||_this2.state.SAPversionvalue==="6.0 EHP4"||_this2.state.SAPversionvalue==="6.0 EHP5"){DbNewSap=LookupTotalValue*0.721;/*Changes by Vinay, same code is being executed regardsless of condition, for CID:10022 (9/10) *//*if (this.state.OnlyNewServersRadiobutton === true) {*/DbNewSap=DbNewSap/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;/*}
                                                        else {
                                                            DbNewSap = DbNewSap / 10;
                                                            LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                            LookupValue = LookupTotalValue;
                                                        }*/}else{DbNewSap=LookupTotalValue*0.79/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;}}else if(_this2.state.onEPH5===true){if(_this2.state.SAPversionvalue==="6.0"||_this2.state.SAPversionvalue==="6.0 EHP4"||_this2.state.SAPversionvalue==="6.0 EHP5"){DbNewSap=LookupTotalValue*0.721*0.95;/*Changes by Vinay, same code is being executed regardsless of condition, for CID:10022 (10/10) *//*if (this.state.OnlyNewServersRadiobutton === true) {*/DbNewSap=DbNewSap/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;/*}
                                                        else {
                                                            DbNewSap = DbNewSap / 10;
                                                            LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                            LookupValue = LookupTotalValue;
                                                        }*/}else{DbNewSap=LookupTotalValue*0.79*0.79/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;}}if(LookupTotalValue===0){LookupValue="No entry found!";}}});}else{if(_this2.state.NoofCPUSvalue===item.Processors.P["@ProcModel"]){LookupValue=item.Processors.P["#text"];LookupValue=Math.round(LookupValue/0.855)/0.721/0.95;LookupValue=Math.floor(LookupValue/10);LookupValue=parseInt(LookupValue*10,10);LookupTotalValue=LookupValue;if(_this2.state.SAPversionvalue==="5.0"){LookupTotalValue=parseInt(LookupTotalValue*0.9,10);}else if(_this2.state.SAPversionvalue==="6.0"||_this2.state.SAPversionvalue==="6.0 EHP4"||_this2.state.SAPversionvalue==="6.0 EHP5"){LookupTotalValue=parseInt(LookupTotalValue*0.855,10);}else if(_this2.state.SAPversionvalue==="4.6"){LookupTotalValue=parseInt(LookupTotalValue*1.052631579,10);}if(_this2.state.OperatingSystemvalue==="Linux"&&_this2.state.ServerTypevalue==="Integrity"){LookupTotalValue=parseInt(LookupTotalValue-LookupTotalValue*0.1,10);}if(__WEBPACK_IMPORTED_MODULE_15__AppConfig__["f" /* said */]==='SAPHANA'&&_this2.state.SAPversionvalue==="4.7"){LookupTotalValue=LookupValue;}else if(_this2.state.onEPH3===true){DbNewSap=LookupTotalValue/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;}else if(_this2.state.onEPH4===true){if(_this2.state.SAPversionvalue==="6.0"||_this2.state.SAPversionvalue==="6.0 EHP4"||_this2.state.SAPversionvalue==="6.0 EHP5"){DbNewSap=LookupTotalValue*0.721;/*Changes by Vinay, same code is being executed regardsless of condition, for CID:10019 (9/10) *//*if (this.state.OnlyNewServersRadiobutton === true) {*/DbNewSap=DbNewSap/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;/*}
                                                    else {
                                                        DbNewSap = DbNewSap / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                    }*/}else{DbNewSap=LookupTotalValue*0.79/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;}}else if(_this2.state.onEPH5===true){if(_this2.state.SAPversionvalue==="6.0"||_this2.state.SAPversionvalue==="6.0 EHP4"||_this2.state.SAPversionvalue==="6.0 EHP5"){DbNewSap=LookupTotalValue*0.721*0.95;/*Changes by Vinay, same code is being executed regardsless of condition, for CID:10019 (10/10) *//*if (this.state.OnlyNewServersRadiobutton === true) {*/DbNewSap=DbNewSap/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;/*}
                                                    else {
                                                        DbNewSap = DbNewSap / 10;
                                                        LookupTotalValue = parseInt(Math.ceil(DbNewSap) * 10, 10);
                                                        LookupValue = LookupTotalValue;
                                                    }*/}else{DbNewSap=LookupTotalValue*0.79*0.79/10;LookupTotalValue=parseInt(Math.ceil(DbNewSap)*10,10);LookupValue=LookupTotalValue;}}if(LookupTotalValue===0){LookupValue="No entry found!";}}}}}}}}});var Severduplicates=[];var len=this.state.ServerOptions.length;for(var i=0;i<len;i++){if(Severduplicates.indexOf(this.state.ServerOptions[i])===-1){Severduplicates.push(this.state.ServerOptions[i]);}}this.state.ServerOptions=Severduplicates;// this.state.ServerOptions=[...new Set(this.state.ServerOptions)]
// this.state.CpuspeedCacheoptions=[...new Set(this.state.CpuspeedCacheoptions)]  
//  this.state.NoofCPUSvalueoptions=[...new Set(this.state.NoofCPUSvalueoptions)]  
if(this.state.ServerOptions.length===0||this.state.CpuspeedCacheoptions===0||this.state.NoofCPUSvalueoptions===0){this.state.Servervalue="No Data";this.state.CpuspeedCachevalue="No Data";this.state.NoofCPUSvalue="No Data";LookupValue="No entry found!";}// if(!defaultserver)
//     this.state.Servervalue= this.state.ServerOptions[0];
//Default CPUSpeed and Cache
//  this.props.LookupServers.Servers.Server.filter((item)=>{
//     console.log("BBBBB"+item["@OSType"])
//     if(item["@OSType"]===OsType){
//           if(item["@ServerType"]===ServerType){
//                 if(item["ServerName"]=== this.state.Servervalue){
//                     let cache=parseInt(item["Cache"], 10)/1024;
//                     if(this.state.OperatingSystemvalue!=="HP-UX")
//                         this.state.CpuspeedCacheoptions .push(item["Speed"]+"/"+cache.toString()+"MB"+"/"+ item["Model"])
//                     else
//                          this.state.CpuspeedCacheoptions .push(item["Speed"]+"/"+cache.toString()+"MB")
//              }
//           }
//     }      
// })
}var lookup="";if(this.state.LookupSAP===true){lookup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default.a,{className:'Lookuplayer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{separator:'none',size:'large',pad:{between:"small"},style:{border:"0px",width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',separator:'bottom',pad:{between:"small"},style:{backgroundColor:'#425563'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{width:"95%",margin:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',style:{marginBottom:'0px',color:'#fff'}},'SAPS Lookup ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:'informationiconbox',style:{marginTop:"10px"},direction:'row',margin:'none',pad:'none',justify:'end',onClick:this.LookupSAPClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_FormClose___default.a,{size:'small'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none',style:{padding:'0px',alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,null,LookupValue))));}if(this.state.CpuspeedCachevalue===""||this.state.CpuspeedCachevalue===undefined||this.state.CpuspeedCachevalue===null){this.state.CpuspeedCachevalue=this.state.CpuspeedCacheoptions[0];}if(this.state.NoofCPUSvalue===""||this.state.NoofCPUSvalue===undefined||this.state.NoofCPUSvalue===null){this.state.NoofCPUSvalue=this.state.NoofCPUSvalueoptions[0];// this.state.NoofCPUSvalue ="2"
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{separator:'none',size:'large',pad:{between:"small"},style:{border:"0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',separator:'bottom',pad:{between:"small"},style:{backgroundColor:'#425563'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{width:"95%",margin:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',style:{marginBottom:'0px',color:'#fff'}},'Select the required fields for the SAPS value')),this.props.isFromExternalApp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{id:'backToSSETyes',primary:false,plain:true,style:{position:'absolute',right:'0',color:'white'}/* icon={<Revert size="small" colorIndex='accent-3' />} */,label:'Close',onClick:function onClick(){window.location.replace(_this2.props.externalAppProps.ssetUrl);},className:'ReverseSavewrkloadbtn'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:'informationiconbox',style:{marginTop:"10px"},direction:'row',margin:'none',pad:'none',justify:'end',onClick:function onClick(){return _this2.props.onClose();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_FormClose___default.a,{size:'small'}))),lookup,!this.props.LookupServers?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{separator:'none',size:'large',pad:{between:"small"},style:{padding:'36%',border:"0px",overflow:"hidden"}},'Looking for SAPs value ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' Please wait.....'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},style:{padding:'0px',marginBottom:"0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{padding:'0px',width:"45%",marginLeft:"12px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'Types of Servers'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{label:'All Servers',checked:this.state.AllServersRadiobutton,onChange:this.onAllServersRadiobuttonChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{label:'Only New Servers',checked:this.state.OnlyNewServersRadiobutton,onChange:this.onOnlyNewServersRadiobuttonChange}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'Types of Enhancement Packages'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{label:'SAP ECC 6.0 EHP3',checked:this.state.onEPH3,onChange:this.onEPH3RadiobuttonChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{label:'SAP ECC 6.0 EHP4',checked:this.state.onEPH4,onChange:this.onEPH4RadiobuttonChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{label:'SAP ECC 6.0 EHP5',checked:this.state.onEPH5,onChange:this.onEPH5RadiobuttonChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,{style:{padding:'10px',width:"255px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'SAP Version'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:this.state.SAPversionvalue,options:this.state.SAPversionOptions,onChange:this.onSAPversionChange})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{padding:'0px',width:"45%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'Operating System',style:{width:"260px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:this.state.OperatingSystemvalue,options:this.state.OperatingSystemOptions,onChange:this.onOperatingSystemChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'Server Type',style:{width:"260px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:this.state.ServerTypevalue,options:this.state.ServerTypeOptions,onChange:this.onServerTypeChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'Server',style:{width:"260px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:this.state.Servervalue,options:this.state.ServerOptions,onChange:this.onServerChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'CPU speed/Cache',style:{width:"260px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:this.state.CpuspeedCachevalue,options:this.state.CpuspeedCacheoptions,onChange:this.onCpuspeedCacheChange})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'CustomInputFormField',label:'Nos of CPUs',style:{width:"260px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:this.state.NoofCPUSvalue,options:this.state.NoofCPUSvalueoptions,onChange:this.onNoofCPUSvalueChange})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',pad:{between:'none'},margin:'none',style:{marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Label___default.a,{size:'medium',margin:'none',style:{fontWeight:'bold',marginLeft:'10px',width:'60px'}},'Note :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Label___default.a,{size:'small',margin:'none',style:{fontWeight:'bold',marginLeft:'5px'}},'SAPS numbers on this tool are a mix of measured and calculated results, SD-2-tier with 1 sec RT @100% CPU usage.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},margin:'none',style:{alignSelf:"center",marginTop:'-5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{style:{margin:"10px",backgroundColor:"#01a982",color:"#fff"},label:'Lookup SAPS...',onClick:this.onLookupSAPClick}))));}}]);return SANStorage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{//ProductionEnvironment:state.sizerWorkload.workload.UserInputs.Environments.ProductionEnvironment,\
LookupServers:state.sizerWorkload.lookupservers};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnFetchLookupServersList:function OnFetchLookupServersList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__State_actions_sessions__["z" /* fetchLookupServersList */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SANStorage));

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(595);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(303);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(596);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(597);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(598);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-caret-next', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'caret-next');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 2 18 12 6 22' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CaretNext';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Animate__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SizerUI_SizerConfig_Config_js__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var title='';var SHARED_="Shared";var CustomArticle=function(_Component){_inherits(CustomArticle,_Component);function CustomArticle(props){_classCallCheck(this,CustomArticle);var _this=_possibleConstructorReturn(this,(CustomArticle.__proto__||Object.getPrototypeOf(CustomArticle)).call(this,props));_this.state={contentVisible:true};_this.onDivClick=_this.onDivClick.bind(_this);return _this;}_createClass(CustomArticle,[{key:'onDivClick',value:function onDivClick(){this.setState({contentVisible:!this.state.contentVisible});}},{key:'componentWillMount',value:function componentWillMount(){if(__WEBPACK_IMPORTED_MODULE_6__SizerUI_SizerConfig_Config_js__["d" /* _said */]==="EPAvNext"){this.state.contentVisible=false;}else{this.state.contentVisible=true;}}},{key:'onTitle',value:function onTitle(){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_6__SizerUI_SizerConfig_Config_js__["d" /* _said */]==="EPAvNext"){if(this.props.content.props.RoleData!==undefined&&this.props.title.indexOf(SHARED_)===-1){//let ServerDetails = []
var ProcDetails=[];var MemoryDetails=[];var Disks=0;// ServerDetails=this.props.content.props.RoleData.Processor.split("")
ProcDetails=this.props.content.props.RoleData.ProcessorDetails.split("C");MemoryDetails=this.props.content.props.RoleData.Memory.split("RAM");/*Changes by Vinay, Accessing a property and discarding the result, for CID:10691*///this.props.content.props.RoleData.ServerName['@Qty']
if(this.props.content.props.RoleData.DAS!==""&&this.props.content.props.RoleData.DAS.TableData!==""){if(Array.isArray(this.props.content.props.RoleData.DAS.TableData)){this.props.content.props.RoleData.DAS.TableData.filter(function(disk){Disks+=parseInt(disk.DiskQty,10)/parseInt(_this2.props.content.props.RoleData.ServerName['@Qty'],10);});}else{Disks+=parseInt(this.props.content.props.RoleData.DAS.TableData.DiskQty,10)/parseInt(this.props.content.props.RoleData.ServerName['@Qty'],10);}}var Displaytitle=this.props.title;if(this.props.title==="Storage : HDFS and HDFS-EC"){Displaytitle="Storage : HDFS";}title=Displaytitle+"  ( "+this.props.content.props.RoleData.Processor+", "+ProcDetails[0].trim()+"C, "+MemoryDetails[0].trim()+", "+Disks+" Disks )";// this.props.content.props.RoleData.Processor
// this.props.content.props.RoleData.ProcessorDetails
// this.props.content.props.RoleData.Memory
// this.props.content.props.RoleData.DAS.TableData
//title="Storage: HDFS  ( 19 x HPE Apollo 4200 Gen10, Intel Xeon-S 4214 /12C , 96 GB,  28 Disks)"
}else{title=this.props.title;}}else{title=this.props.title;}// title=this.props.title
}},{key:'render',value:function render(){this.onTitle();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{colorIndex:this.props.ArticleBackgroundColor,style:{padding:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'5px'},justify:'between',onClick:this.onDivClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},this.props.titleIcon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default.a,{tag:'h4',strong:true,margin:'none',style:{fontSize:'17px'}},title)),this.state.contentVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp___default.a,{size:'small'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown___default.a,{size:'small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Animate___default.a,{visible:this.state.contentVisible,keep:false,enter:{"animation":"slide-down","duration":200,"delay":0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',pad:'small',colorIndex:this.props.ContentBackgroundColor},this.props.content)));}}]);return CustomArticle;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CustomArticle);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var htmlParser = __webpack_require__(634);
var React = __webpack_require__(0);
var convertAttr = __webpack_require__(663);
var styleParser = __webpack_require__(664);

function renderNode(node, key) {
  if (node.nodeName === '#text') {
    return node.value;
  }

  if (node.nodeName === '#comment') {
    return node.value;
  }

  var attr = node.attrs.reduce(function (result, attr) {
    var name = convertAttr(attr.name);
    result[name] = name === 'style' ? styleParser(attr.value) : attr.value;
    return result;
  }, {key: key});

  if (node.childNodes.length === 0) {
    return React.createElement(node.tagName, attr);
  }

  if (node.nodeName === 'script') {
    attr.dangerouslySetInnerHTML = {__html: node.childNodes[0].value};
    return React.createElement('script', attr);
  }

  var children = node.childNodes.map(renderNode);
  return React.createElement(node.tagName, attr, children);
}

function renderHTML(html) {
  var htmlAST = htmlParser.parseFragment(html);

  if (htmlAST.childNodes.length === 0) {
    return null;
  }

  var result = htmlAST.childNodes.map(renderNode);

  return result.length === 1 ? result[0] : result;
}

module.exports = renderHTML;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(82),
    OpenElementStack = __webpack_require__(637),
    FormattingElementList = __webpack_require__(638),
    LocationInfoParserMixin = __webpack_require__(639),
    defaultTreeAdapter = __webpack_require__(190),
    mergeOptions = __webpack_require__(191),
    doctype = __webpack_require__(192),
    foreignContent = __webpack_require__(312),
    UNICODE = __webpack_require__(102),
    HTML = __webpack_require__(42);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;

var DEFAULT_OPTIONS = {
    locationInfo: false,
    treeAdapter: defaultTreeAdapter
};

//Misc constants
var HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
var AA_OUTER_LOOP_ITER = 8,
    AA_INNER_LOOP_ITER = 3;

//Insertion modes
var INITIAL_MODE = 'INITIAL_MODE',
    BEFORE_HTML_MODE = 'BEFORE_HTML_MODE',
    BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE',
    IN_HEAD_MODE = 'IN_HEAD_MODE',
    AFTER_HEAD_MODE = 'AFTER_HEAD_MODE',
    IN_BODY_MODE = 'IN_BODY_MODE',
    TEXT_MODE = 'TEXT_MODE',
    IN_TABLE_MODE = 'IN_TABLE_MODE',
    IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE',
    IN_CAPTION_MODE = 'IN_CAPTION_MODE',
    IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE',
    IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE',
    IN_ROW_MODE = 'IN_ROW_MODE',
    IN_CELL_MODE = 'IN_CELL_MODE',
    IN_SELECT_MODE = 'IN_SELECT_MODE',
    IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE',
    IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE',
    AFTER_BODY_MODE = 'AFTER_BODY_MODE',
    IN_FRAMESET_MODE = 'IN_FRAMESET_MODE',
    AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE',
    AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE',
    AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
var INSERTION_MODE_RESET_MAP = Object.create(null);

INSERTION_MODE_RESET_MAP[$.TR] = IN_ROW_MODE;
INSERTION_MODE_RESET_MAP[$.TBODY] =
INSERTION_MODE_RESET_MAP[$.THEAD] =
INSERTION_MODE_RESET_MAP[$.TFOOT] = IN_TABLE_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.CAPTION] = IN_CAPTION_MODE;
INSERTION_MODE_RESET_MAP[$.COLGROUP] = IN_COLUMN_GROUP_MODE;
INSERTION_MODE_RESET_MAP[$.TABLE] = IN_TABLE_MODE;
INSERTION_MODE_RESET_MAP[$.BODY] = IN_BODY_MODE;
INSERTION_MODE_RESET_MAP[$.FRAMESET] = IN_FRAMESET_MODE;

//Template insertion mode switch map
var TEMPLATE_INSERTION_MODE_SWITCH_MAP = Object.create(null);

TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.CAPTION] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COLGROUP] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TBODY] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TFOOT] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.THEAD] = IN_TABLE_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.COL] = IN_COLUMN_GROUP_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TR] = IN_TABLE_BODY_MODE;
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TD] =
TEMPLATE_INSERTION_MODE_SWITCH_MAP[$.TH] = IN_ROW_MODE;

//Token handlers map for insertion modes
var _ = Object.create(null);

_[INITIAL_MODE] = Object.create(null);
_[INITIAL_MODE][Tokenizer.CHARACTER_TOKEN] =
_[INITIAL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInInitialMode;
_[INITIAL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[INITIAL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[INITIAL_MODE][Tokenizer.DOCTYPE_TOKEN] = doctypeInInitialMode;
_[INITIAL_MODE][Tokenizer.START_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.END_TAG_TOKEN] =
_[INITIAL_MODE][Tokenizer.EOF_TOKEN] = tokenInInitialMode;

_[BEFORE_HTML_MODE] = Object.create(null);
_[BEFORE_HTML_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HTML_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HTML_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HTML_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHtml;
_[BEFORE_HTML_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHtml;

_[BEFORE_HEAD_MODE] = Object.create(null);
_[BEFORE_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[BEFORE_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[BEFORE_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[BEFORE_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagBeforeHead;
_[BEFORE_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenBeforeHead;

_[IN_HEAD_MODE] = Object.create(null);
_[IN_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInHead;
_[IN_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagInHead;
_[IN_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagInHead;
_[IN_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenInHead;

_[AFTER_HEAD_MODE] = Object.create(null);
_[AFTER_HEAD_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_HEAD_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_HEAD_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_HEAD_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_HEAD_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterHead;
_[AFTER_HEAD_MODE][Tokenizer.EOF_TOKEN] = tokenAfterHead;

_[IN_BODY_MODE] = Object.create(null);
_[IN_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInBody;
_[IN_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInBody;
_[IN_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[TEXT_MODE] = Object.create(null);
_[TEXT_MODE][Tokenizer.CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[TEXT_MODE][Tokenizer.START_TAG_TOKEN] = ignoreToken;
_[TEXT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInText;
_[TEXT_MODE][Tokenizer.EOF_TOKEN] = eofInText;

_[IN_TABLE_MODE] = Object.create(null);
_[IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTable;
_[IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTable;
_[IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_TEXT_MODE] = Object.create(null);
_[IN_TABLE_TEXT_MODE][Tokenizer.CHARACTER_TOKEN] = characterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TABLE_TEXT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInTableText;
_[IN_TABLE_TEXT_MODE][Tokenizer.COMMENT_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.DOCTYPE_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.START_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.END_TAG_TOKEN] =
_[IN_TABLE_TEXT_MODE][Tokenizer.EOF_TOKEN] = tokenInTableText;

_[IN_CAPTION_MODE] = Object.create(null);
_[IN_CAPTION_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CAPTION_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CAPTION_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CAPTION_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CAPTION_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCaption;
_[IN_CAPTION_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_COLUMN_GROUP_MODE] = Object.create(null);
_[IN_COLUMN_GROUP_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_COLUMN_GROUP_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_COLUMN_GROUP_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_COLUMN_GROUP_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_COLUMN_GROUP_MODE][Tokenizer.START_TAG_TOKEN] = startTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.END_TAG_TOKEN] = endTagInColumnGroup;
_[IN_COLUMN_GROUP_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TABLE_BODY_MODE] = Object.create(null);
_[IN_TABLE_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_TABLE_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_TABLE_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TABLE_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TABLE_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTableBody;
_[IN_TABLE_BODY_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_ROW_MODE] = Object.create(null);
_[IN_ROW_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.NULL_CHARACTER_TOKEN] =
_[IN_ROW_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = characterInTable;
_[IN_ROW_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_ROW_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_ROW_MODE][Tokenizer.START_TAG_TOKEN] = startTagInRow;
_[IN_ROW_MODE][Tokenizer.END_TAG_TOKEN] = endTagInRow;
_[IN_ROW_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_CELL_MODE] = Object.create(null);
_[IN_CELL_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_CELL_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_CELL_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_CELL_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_CELL_MODE][Tokenizer.START_TAG_TOKEN] = startTagInCell;
_[IN_CELL_MODE][Tokenizer.END_TAG_TOKEN] = endTagInCell;
_[IN_CELL_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_MODE] = Object.create(null);
_[IN_SELECT_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelect;
_[IN_SELECT_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelect;
_[IN_SELECT_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_SELECT_IN_TABLE_MODE] = Object.create(null);
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInSelectInTable;
_[IN_SELECT_IN_TABLE_MODE][Tokenizer.EOF_TOKEN] = eofInBody;

_[IN_TEMPLATE_MODE] = Object.create(null);
_[IN_TEMPLATE_MODE][Tokenizer.CHARACTER_TOKEN] = characterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[IN_TEMPLATE_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_TEMPLATE_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_TEMPLATE_MODE][Tokenizer.START_TAG_TOKEN] = startTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.END_TAG_TOKEN] = endTagInTemplate;
_[IN_TEMPLATE_MODE][Tokenizer.EOF_TOKEN] = eofInTemplate;

_[AFTER_BODY_MODE] = Object.create(null);
_[AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterBody;
_[AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToRootHtmlElement;
_[AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterBody;
_[AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[IN_FRAMESET_MODE] = Object.create(null);
_[IN_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[IN_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[IN_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[IN_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[IN_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagInFrameset;
_[IN_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = insertCharacters;
_[AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendComment;
_[AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = endTagAfterFrameset;
_[AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_BODY_MODE] = Object.create(null);
_[AFTER_AFTER_BODY_MODE][Tokenizer.CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_BODY_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_BODY_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.END_TAG_TOKEN] = tokenAfterAfterBody;
_[AFTER_AFTER_BODY_MODE][Tokenizer.EOF_TOKEN] = stopParsing;

_[AFTER_AFTER_FRAMESET_MODE] = Object.create(null);
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.CHARACTER_TOKEN] =
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.NULL_CHARACTER_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.WHITESPACE_CHARACTER_TOKEN] = whitespaceCharacterInBody;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.COMMENT_TOKEN] = appendCommentToDocument;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.DOCTYPE_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.START_TAG_TOKEN] = startTagAfterAfterFrameset;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.END_TAG_TOKEN] = ignoreToken;
_[AFTER_AFTER_FRAMESET_MODE][Tokenizer.EOF_TOKEN] = stopParsing;


//Parser
var Parser = module.exports = function (options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.treeAdapter = this.options.treeAdapter;
    this.pendingScript = null;

    if (this.options.locationInfo)
        new LocationInfoParserMixin(this);
};

// API
Parser.prototype.parse = function (html) {
    var document = this.treeAdapter.createDocument();

    this._bootstrap(document, null);
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    return document;
};

Parser.prototype.parseFragment = function (html, fragmentContext) {
    //NOTE: use <template> element as a fragment context if context element was not provided,
    //so we will parse in "forgiving" manner
    if (!fragmentContext)
        fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);

    //NOTE: create fake element which will be used as 'document' for fragment parsing.
    //This is important for jsdom there 'document' can't be recreated, therefore
    //fragment parsing causes messing of the main `document`.
    var documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);

    this._bootstrap(documentMock, fragmentContext);

    if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE)
        this._pushTmplInsertionMode(IN_TEMPLATE_MODE);

    this._initTokenizerForFragmentParsing();
    this._insertFakeRootElement();
    this._resetInsertionMode();
    this._findFormInFragmentContext();
    this.tokenizer.write(html, true);
    this._runParsingLoop(null);

    var rootElement = this.treeAdapter.getFirstChild(documentMock),
        fragment = this.treeAdapter.createDocumentFragment();

    this._adoptNodes(rootElement, fragment);

    return fragment;
};

//Bootstrap parser
Parser.prototype._bootstrap = function (document, fragmentContext) {
    this.tokenizer = new Tokenizer(this.options);

    this.stopped = false;

    this.insertionMode = INITIAL_MODE;
    this.originalInsertionMode = '';

    this.document = document;
    this.fragmentContext = fragmentContext;

    this.headElement = null;
    this.formElement = null;

    this.openElements = new OpenElementStack(this.document, this.treeAdapter);
    this.activeFormattingElements = new FormattingElementList(this.treeAdapter);

    this.tmplInsertionModeStack = [];
    this.tmplInsertionModeStackTop = -1;
    this.currentTmplInsertionMode = null;

    this.pendingCharacterTokens = [];
    this.hasNonWhitespacePendingCharacterToken = false;

    this.framesetOk = true;
    this.skipNextNewLine = false;
    this.fosterParentingEnabled = false;
};

//Parsing loop
Parser.prototype._runParsingLoop  = function (scriptHandler) {
    while (!this.stopped) {
        this._setupTokenizerCDATAMode();

        var token = this.tokenizer.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (this.skipNextNewLine) {
            this.skipNextNewLine = false;

            if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
                if (token.chars.length === 1)
                    continue;

                token.chars = token.chars.substr(1);
            }
        }

        this._processInputToken(token);

        if (scriptHandler && this.pendingScript)
            break;
    }
};

Parser.prototype.runParsingLoopForCurrentChunk = function (writeCallback, scriptHandler) {
    this._runParsingLoop(scriptHandler);

    if (scriptHandler && this.pendingScript) {
        var script = this.pendingScript;

        this.pendingScript = null;

        scriptHandler(script);

        return;
    }

    if (writeCallback)
        writeCallback();
};

//Text parsing
Parser.prototype._setupTokenizerCDATAMode = function () {
    var current = this._getAdjustedCurrentElement();

    this.tokenizer.allowCDATA = current && current !== this.document &&
                                this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
};

Parser.prototype._switchToTextParsing = function (currentToken, nextTokenizerState) {
    this._insertElement(currentToken, NS.HTML);
    this.tokenizer.state = nextTokenizerState;
    this.originalInsertionMode = this.insertionMode;
    this.insertionMode = TEXT_MODE;
};

Parser.prototype.switchToPlaintextParsing = function () {
    this.insertionMode = TEXT_MODE;
    this.originalInsertionMode = IN_BODY_MODE;
    this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
};

//Fragment parsing
Parser.prototype._getAdjustedCurrentElement = function () {
    return this.openElements.stackTop === 0 && this.fragmentContext ?
        this.fragmentContext :
        this.openElements.current;
};

Parser.prototype._findFormInFragmentContext = function () {
    var node = this.fragmentContext;

    do {
        if (this.treeAdapter.getTagName(node) === $.FORM) {
            this.formElement = node;
            break;
        }

        node = this.treeAdapter.getParentNode(node);
    } while (node);
};

Parser.prototype._initTokenizerForFragmentParsing = function () {
    if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
        var tn = this.treeAdapter.getTagName(this.fragmentContext);

        if (tn === $.TITLE || tn === $.TEXTAREA)
            this.tokenizer.state = Tokenizer.MODE.RCDATA;

        else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME ||
                 tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
            this.tokenizer.state = Tokenizer.MODE.RAWTEXT;

        else if (tn === $.SCRIPT)
            this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

        else if (tn === $.PLAINTEXT)
            this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }
};

//Tree mutation
Parser.prototype._setDocumentType = function (token) {
    this.treeAdapter.setDocumentType(this.document, token.name, token.publicId, token.systemId);
};

Parser.prototype._attachElementToTree = function (element) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentElement(element);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.appendChild(parent, element);
    }
};

Parser.prototype._appendElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
};

Parser.prototype._insertElement = function (token, namespaceURI) {
    var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertFakeElement = function (tagName) {
    var element = this.treeAdapter.createElement(tagName, NS.HTML, []);

    this._attachElementToTree(element);
    this.openElements.push(element);
};

Parser.prototype._insertTemplate = function (token) {
    var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs),
        content = this.treeAdapter.createDocumentFragment();

    this.treeAdapter.setTemplateContent(tmpl, content);
    this._attachElementToTree(tmpl);
    this.openElements.push(tmpl);
};

Parser.prototype._insertFakeRootElement = function () {
    var element = this.treeAdapter.createElement($.HTML, NS.HTML, []);

    this.treeAdapter.appendChild(this.openElements.current, element);
    this.openElements.push(element);
};

Parser.prototype._appendCommentNode = function (token, parent) {
    var commentNode = this.treeAdapter.createCommentNode(token.data);

    this.treeAdapter.appendChild(parent, commentNode);
};

Parser.prototype._insertCharacters = function (token) {
    if (this._shouldFosterParentOnInsertion())
        this._fosterParentText(token.chars);

    else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;

        this.treeAdapter.insertText(parent, token.chars);
    }
};

Parser.prototype._adoptNodes = function (donor, recipient) {
    while (true) {
        var child = this.treeAdapter.getFirstChild(donor);

        if (!child)
            break;

        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
    }
};

//Token processing
Parser.prototype._shouldProcessTokenInForeignContent = function (token) {
    var current = this._getAdjustedCurrentElement();

    if (!current || current === this.document)
        return false;

    var ns = this.treeAdapter.getNamespaceURI(current);

    if (ns === NS.HTML)
        return false;

    if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML &&
        token.type === Tokenizer.START_TAG_TOKEN && token.tagName === $.SVG)
        return false;

    var isCharacterToken = token.type === Tokenizer.CHARACTER_TOKEN ||
                           token.type === Tokenizer.NULL_CHARACTER_TOKEN ||
                           token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN,
        isMathMLTextStartTag = token.type === Tokenizer.START_TAG_TOKEN &&
                               token.tagName !== $.MGLYPH &&
                               token.tagName !== $.MALIGNMARK;

    if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML))
        return false;

    if ((token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML))
        return false;

    return token.type !== Tokenizer.EOF_TOKEN;
};

Parser.prototype._processToken = function (token) {
    _[this.insertionMode][token.type](this, token);
};

Parser.prototype._processTokenInBodyMode = function (token) {
    _[IN_BODY_MODE][token.type](this, token);
};

Parser.prototype._processTokenInForeignContent = function (token) {
    if (token.type === Tokenizer.CHARACTER_TOKEN)
        characterInForeignContent(this, token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN)
        nullCharacterInForeignContent(this, token);

    else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN)
        insertCharacters(this, token);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        appendComment(this, token);

    else if (token.type === Tokenizer.START_TAG_TOKEN)
        startTagInForeignContent(this, token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        endTagInForeignContent(this, token);
};

Parser.prototype._processInputToken = function (token) {
    if (this._shouldProcessTokenInForeignContent(token))
        this._processTokenInForeignContent(token);

    else
        this._processToken(token);
};

//Integration points
Parser.prototype._isIntegrationPoint = function (element, foreignNS) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element),
        attrs = this.treeAdapter.getAttrList(element);

    return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
};

//Active formatting elements reconstruction
Parser.prototype._reconstructActiveFormattingElements = function () {
    var listLength = this.activeFormattingElements.length;

    if (listLength) {
        var unopenIdx = listLength,
            entry = null;

        do {
            unopenIdx--;
            entry = this.activeFormattingElements.entries[unopenIdx];

            if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
                unopenIdx++;
                break;
            }
        } while (unopenIdx > 0);

        for (var i = unopenIdx; i < listLength; i++) {
            entry = this.activeFormattingElements.entries[i];
            this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
            entry.element = this.openElements.current;
        }
    }
};

//Close elements
Parser.prototype._closeTableCell = function () {
    this.openElements.generateImpliedEndTags();
    this.openElements.popUntilTableCellPopped();
    this.activeFormattingElements.clearToLastMarker();
    this.insertionMode = IN_ROW_MODE;
};

Parser.prototype._closePElement = function () {
    this.openElements.generateImpliedEndTagsWithExclusion($.P);
    this.openElements.popUntilTagNamePopped($.P);
};

//Insertion modes
Parser.prototype._resetInsertionMode = function () {
    for (var i = this.openElements.stackTop, last = false; i >= 0; i--) {
        var element = this.openElements.items[i];

        if (i === 0) {
            last = true;

            if (this.fragmentContext)
                element = this.fragmentContext;
        }

        var tn = this.treeAdapter.getTagName(element),
            newInsertionMode = INSERTION_MODE_RESET_MAP[tn];

        if (newInsertionMode) {
            this.insertionMode = newInsertionMode;
            break;
        }

        else if (!last && (tn === $.TD || tn === $.TH)) {
            this.insertionMode = IN_CELL_MODE;
            break;
        }

        else if (!last && tn === $.HEAD) {
            this.insertionMode = IN_HEAD_MODE;
            break;
        }

        else if (tn === $.SELECT) {
            this._resetInsertionModeForSelect(i);
            break;
        }

        else if (tn === $.TEMPLATE) {
            this.insertionMode = this.currentTmplInsertionMode;
            break;
        }

        else if (tn === $.HTML) {
            this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
            break;
        }

        else if (last) {
            this.insertionMode = IN_BODY_MODE;
            break;
        }
    }
};

Parser.prototype._resetInsertionModeForSelect = function (selectIdx) {
    if (selectIdx > 0) {
        for (var i = selectIdx - 1; i > 0; i--) {
            var ancestor = this.openElements.items[i],
                tn = this.treeAdapter.getTagName(ancestor);

            if (tn === $.TEMPLATE)
                break;

            else if (tn === $.TABLE) {
                this.insertionMode = IN_SELECT_IN_TABLE_MODE;
                return;
            }
        }
    }

    this.insertionMode = IN_SELECT_MODE;
};

Parser.prototype._pushTmplInsertionMode = function (mode) {
    this.tmplInsertionModeStack.push(mode);
    this.tmplInsertionModeStackTop++;
    this.currentTmplInsertionMode = mode;
};

Parser.prototype._popTmplInsertionMode = function () {
    this.tmplInsertionModeStack.pop();
    this.tmplInsertionModeStackTop--;
    this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
};

//Foster parenting
Parser.prototype._isElementCausesFosterParenting = function (element) {
    var tn = this.treeAdapter.getTagName(element);

    return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
};

Parser.prototype._shouldFosterParentOnInsertion = function () {
    return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
};

Parser.prototype._findFosterParentingLocation = function () {
    var location = {
        parent: null,
        beforeElement: null
    };

    for (var i = this.openElements.stackTop; i >= 0; i--) {
        var openElement = this.openElements.items[i],
            tn = this.treeAdapter.getTagName(openElement),
            ns = this.treeAdapter.getNamespaceURI(openElement);

        if (tn === $.TEMPLATE && ns === NS.HTML) {
            location.parent = this.treeAdapter.getTemplateContent(openElement);
            break;
        }

        else if (tn === $.TABLE) {
            location.parent = this.treeAdapter.getParentNode(openElement);

            if (location.parent)
                location.beforeElement = openElement;
            else
                location.parent = this.openElements.items[i - 1];

            break;
        }
    }

    if (!location.parent)
        location.parent = this.openElements.items[0];

    return location;
};

Parser.prototype._fosterParentElement = function (element) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
    else
        this.treeAdapter.appendChild(location.parent, element);
};

Parser.prototype._fosterParentText = function (chars) {
    var location = this._findFosterParentingLocation();

    if (location.beforeElement)
        this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
    else
        this.treeAdapter.insertText(location.parent, chars);
};

//Special elements
Parser.prototype._isSpecialElement = function (element) {
    var tn = this.treeAdapter.getTagName(element),
        ns = this.treeAdapter.getNamespaceURI(element);

    return HTML.SPECIAL_ELEMENTS[ns][tn];
};

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
    var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);

    if (formattingElementEntry) {
        if (!p.openElements.contains(formattingElementEntry.element)) {
            p.activeFormattingElements.removeEntry(formattingElementEntry);
            formattingElementEntry = null;
        }

        else if (!p.openElements.hasInScope(token.tagName))
            formattingElementEntry = null;
    }

    else
        genericEndTagInBody(p, token);

    return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
    var furthestBlock = null;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i];

        if (element === formattingElementEntry.element)
            break;

        if (p._isSpecialElement(element))
            furthestBlock = element;
    }

    if (!furthestBlock) {
        p.openElements.popUntilElementPopped(formattingElementEntry.element);
        p.activeFormattingElements.removeEntry(formattingElementEntry);
    }

    return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
    var lastElement = furthestBlock,
        nextElement = p.openElements.getCommonAncestor(furthestBlock);

    for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
        //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
        nextElement = p.openElements.getCommonAncestor(element);

        var elementEntry = p.activeFormattingElements.getElementEntry(element),
            counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER,
            shouldRemoveFromOpenElements = !elementEntry || counterOverflow;

        if (shouldRemoveFromOpenElements) {
            if (counterOverflow)
                p.activeFormattingElements.removeEntry(elementEntry);

            p.openElements.remove(element);
        }

        else {
            element = aaRecreateElementFromEntry(p, elementEntry);

            if (lastElement === furthestBlock)
                p.activeFormattingElements.bookmark = elementEntry;

            p.treeAdapter.detachNode(lastElement);
            p.treeAdapter.appendChild(element, lastElement);
            lastElement = element;
        }
    }

    return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(elementEntry.element),
        newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);

    p.openElements.replace(elementEntry.element, newElement);
    elementEntry.element = newElement;

    return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
    if (p._isElementCausesFosterParenting(commonAncestor))
        p._fosterParentElement(lastElement);

    else {
        var tn = p.treeAdapter.getTagName(commonAncestor),
            ns = p.treeAdapter.getNamespaceURI(commonAncestor);

        if (tn === $.TEMPLATE && ns === NS.HTML)
            commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);

        p.treeAdapter.appendChild(commonAncestor, lastElement);
    }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
    var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element),
        token = formattingElementEntry.token,
        newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);

    p._adoptNodes(furthestBlock, newElement);
    p.treeAdapter.appendChild(furthestBlock, newElement);

    p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
    p.activeFormattingElements.removeEntry(formattingElementEntry);

    p.openElements.remove(formattingElementEntry.element);
    p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
    var formattingElementEntry;

    for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
        formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);

        if (!formattingElementEntry)
            break;

        var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);

        if (!furthestBlock)
            break;

        p.activeFormattingElements.bookmark = formattingElementEntry;

        var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element),
            commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);

        p.treeAdapter.detachNode(lastElement);
        aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
        aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
    }
}


//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
    //NOTE: do nothing =)
}

function appendComment(p, token) {
    p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}

function appendCommentToRootHtmlElement(p, token) {
    p._appendCommentNode(token, p.openElements.items[0]);
}

function appendCommentToDocument(p, token) {
    p._appendCommentNode(token, p.document);
}

function insertCharacters(p, token) {
    p._insertCharacters(token);
}

function stopParsing(p) {
    p.stopped = true;
}

//12.2.5.4.1 The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
    p._setDocumentType(token);

    var mode = token.forceQuirks ?
        HTML.DOCUMENT_MODE.QUIRKS :
        doctype.getDocumentMode(token.name, token.publicId, token.systemId);

    p.treeAdapter.setDocumentMode(p.document, mode);

    p.insertionMode = BEFORE_HTML_MODE;
}

function tokenInInitialMode(p, token) {
    p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
    p.insertionMode = BEFORE_HTML_MODE;
    p._processToken(token);
}


//12.2.5.4.2 The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
    if (token.tagName === $.HTML) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = BEFORE_HEAD_MODE;
    }

    else
        tokenBeforeHtml(p, token);
}

function endTagBeforeHtml(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR)
        tokenBeforeHtml(p, token);
}

function tokenBeforeHtml(p, token) {
    p._insertFakeRootElement();
    p.insertionMode = BEFORE_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.3 The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.HEAD) {
        p._insertElement(token, NS.HTML);
        p.headElement = p.openElements.current;
        p.insertionMode = IN_HEAD_MODE;
    }

    else
        tokenBeforeHead(p, token);
}

function endTagBeforeHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenBeforeHead(p, token);
}

function tokenBeforeHead(p, token) {
    p._insertFakeElement($.HEAD);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.4 The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TITLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);

    //NOTE: here we assume that we always act as an interactive user agent with enabled scripting, so we parse
    //<noscript> as a rawtext.
    else if (tn === $.NOSCRIPT || tn === $.NOFRAMES || tn === $.STYLE)
        p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);

    else if (tn === $.SCRIPT)
        p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);

    else if (tn === $.TEMPLATE) {
        p._insertTemplate(token, NS.HTML);
        p.activeFormattingElements.insertMarker();
        p.framesetOk = false;
        p.insertionMode = IN_TEMPLATE_MODE;
        p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
    }

    else if (tn !== $.HEAD)
        tokenInHead(p, token);
}

function endTagInHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HEAD) {
        p.openElements.pop();
        p.insertionMode = AFTER_HEAD_MODE;
    }

    else if (tn === $.BODY || tn === $.BR || tn === $.HTML)
        tokenInHead(p, token);

    else if (tn === $.TEMPLATE && p.openElements.tmplCount > 0) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
    }
}

function tokenInHead(p, token) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
    p._processToken(token);
}


//12.2.5.4.6 The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.BODY) {
        p._insertElement(token, NS.HTML);
        p.framesetOk = false;
        p.insertionMode = IN_BODY_MODE;
    }

    else if (tn === $.FRAMESET) {
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }

    else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
             tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
        p.openElements.push(p.headElement);
        startTagInHead(p, token);
        p.openElements.remove(p.headElement);
    }

    else if (tn !== $.HEAD)
        tokenAfterHead(p, token);
}

function endTagAfterHead(p, token) {
    var tn = token.tagName;

    if (tn === $.BODY || tn === $.HTML || tn === $.BR)
        tokenAfterHead(p, token);

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

function tokenAfterHead(p, token) {
    p._insertFakeElement($.BODY);
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}


//12.2.5.4.7 The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
}

function characterInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertCharacters(token);
    p.framesetOk = false;
}

function htmlStartTagInBody(p, token) {
    if (p.openElements.tmplCount === 0)
        p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
}

function bodyStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (bodyElement && p.openElements.tmplCount === 0) {
        p.framesetOk = false;
        p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
    }
}

function framesetStartTagInBody(p, token) {
    var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();

    if (p.framesetOk && bodyElement) {
        p.treeAdapter.detachNode(bodyElement);
        p.openElements.popAllUpToHtmlElement();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_FRAMESET_MODE;
    }
}

function addressStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function numberedHeaderStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    var tn = p.openElements.currentTagName;

    if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function preStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.framesetOk = false;
}

function formStartTagInBody(p, token) {
    var inTemplate = p.openElements.tmplCount > 0;

    if (!p.formElement || inTemplate) {
        if (p.openElements.hasInButtonScope($.P))
            p._closePElement();

        p._insertElement(token, NS.HTML);

        if (!inTemplate)
            p.formElement = p.openElements.current;
    }
}

function listItemStartTagInBody(p, token) {
    p.framesetOk = false;

    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i >= 0; i--) {
        var element = p.openElements.items[i],
            elementTn = p.treeAdapter.getTagName(element),
            closeTn = null;

        if (tn === $.LI && elementTn === $.LI)
            closeTn = $.LI;

        else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT))
            closeTn = elementTn;

        if (closeTn) {
            p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
            p.openElements.popUntilTagNamePopped(closeTn);
            break;
        }

        if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element))
            break;
    }

    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
}

function plaintextStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}

function buttonStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.BUTTON)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped($.BUTTON);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
}

function aStartTagInBody(p, token) {
    var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);

    if (activeElementEntry) {
        callAdoptionAgency(p, token);
        p.openElements.remove(activeElementEntry.element);
        p.activeFormattingElements.removeEntry(activeElementEntry);
    }

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function bStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function nobrStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    if (p.openElements.hasInScope($.NOBR)) {
        callAdoptionAgency(p, token);
        p._reconstructActiveFormattingElements();
    }

    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.pushElement(p.openElements.current, token);
}

function appletStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
}

function tableStartTagInBody(p, token) {
    if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_TABLE_MODE;
}

function areaStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function inputStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._appendElement(token, NS.HTML);

    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE)
        p.framesetOk = false;

}

function paramStartTagInBody(p, token) {
    p._appendElement(token, NS.HTML);
}

function hrStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._appendElement(token, NS.HTML);
    p.framesetOk = false;
}

function imageStartTagInBody(p, token) {
    token.tagName = $.IMG;
    areaStartTagInBody(p, token);
}

function textareaStartTagInBody(p, token) {
    p._insertElement(token, NS.HTML);
    //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
    //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
    p.skipNextNewLine = true;
    p.tokenizer.state = Tokenizer.MODE.RCDATA;
    p.originalInsertionMode = p.insertionMode;
    p.framesetOk = false;
    p.insertionMode = TEXT_MODE;
}

function xmpStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    p._reconstructActiveFormattingElements();
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function iframeStartTagInBody(p, token) {
    p.framesetOk = false;
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

function selectStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;

    if (p.insertionMode === IN_TABLE_MODE ||
        p.insertionMode === IN_CAPTION_MODE ||
        p.insertionMode === IN_TABLE_BODY_MODE ||
        p.insertionMode === IN_ROW_MODE ||
        p.insertionMode === IN_CELL_MODE)

        p.insertionMode = IN_SELECT_IN_TABLE_MODE;

    else
        p.insertionMode = IN_SELECT_MODE;
}

function optgroupStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.OPTION)
        p.openElements.pop();

    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

function rbStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTags();

    p._insertElement(token, NS.HTML);
}

function rtStartTagInBody(p, token) {
    if (p.openElements.hasInScope($.RUBY))
        p.openElements.generateImpliedEndTagsWithExclusion($.RTC);

    p._insertElement(token, NS.HTML);
}

function menuitemStartTagInBody(p, token) {
    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    // TODO needs clarification, see https://github.com/whatwg/html/pull/907/files#r73505877
    p._reconstructActiveFormattingElements();

    p._insertElement(token, NS.HTML);
}

function menuStartTagInBody(p, token) {
    if (p.openElements.hasInButtonScope($.P))
        p._closePElement();

    if (p.openElements.currentTagName === $.MENUITEM)
        p.openElements.pop();

    p._insertElement(token, NS.HTML);
}

function mathStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenMathMLAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.MATHML);
    else
        p._insertElement(token, NS.MATHML);
}

function svgStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();

    foreignContent.adjustTokenSVGAttrs(token);
    foreignContent.adjustTokenXMLAttrs(token);

    if (token.selfClosing)
        p._appendElement(token, NS.SVG);
    else
        p._insertElement(token, NS.SVG);
}

function genericStartTagInBody(p, token) {
    p._reconstructActiveFormattingElements();
    p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.I || tn === $.S || tn === $.B || tn === $.U)
                bStartTagInBody(p, token);

            else if (tn === $.P)
                addressStartTagInBody(p, token);

            else if (tn === $.A)
                aStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.OL || tn === $.UL)
                addressStartTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderStartTagInBody(p, token);

            else if (tn === $.LI || tn === $.DD || tn === $.DT)
                listItemStartTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                bStartTagInBody(p, token);

            else if (tn === $.BR)
                areaStartTagInBody(p, token);

            else if (tn === $.HR)
                hrStartTagInBody(p, token);

            else if (tn === $.RB)
                rbStartTagInBody(p, token);

            else if (tn === $.RT || tn === $.RP)
                rtStartTagInBody(p, token);

            else if (tn !== $.TH && tn !== $.TD && tn !== $.TR)
                genericStartTagInBody(p, token);

            break;

        case 3:
            if (tn === $.DIV || tn === $.DIR || tn === $.NAV)
                addressStartTagInBody(p, token);

            else if (tn === $.PRE)
                preStartTagInBody(p, token);

            else if (tn === $.BIG)
                bStartTagInBody(p, token);

            else if (tn === $.IMG || tn === $.WBR)
                areaStartTagInBody(p, token);

            else if (tn === $.XMP)
                xmpStartTagInBody(p, token);

            else if (tn === $.SVG)
                svgStartTagInBody(p, token);

            else if (tn === $.RTC)
                rbStartTagInBody(p, token);

            else if (tn !== $.COL)
                genericStartTagInBody(p, token);

            break;

        case 4:
            if (tn === $.HTML)
                htmlStartTagInBody(p, token);

            else if (tn === $.BASE || tn === $.LINK || tn === $.META)
                startTagInHead(p, token);

            else if (tn === $.BODY)
                bodyStartTagInBody(p, token);

            else if (tn === $.MAIN)
                addressStartTagInBody(p, token);

            else if (tn === $.FORM)
                formStartTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT)
                bStartTagInBody(p, token);

            else if (tn === $.NOBR)
                nobrStartTagInBody(p, token);

            else if (tn === $.AREA)
                areaStartTagInBody(p, token);

            else if (tn === $.MATH)
                mathStartTagInBody(p, token);

            else if (tn === $.MENU)
                menuStartTagInBody(p, token);

            else if (tn !== $.HEAD)
                genericStartTagInBody(p, token);

            break;

        case 5:
            if (tn === $.STYLE || tn === $.TITLE)
                startTagInHead(p, token);

            else if (tn === $.ASIDE)
                addressStartTagInBody(p, token);

            else if (tn === $.SMALL)
                bStartTagInBody(p, token);

            else if (tn === $.TABLE)
                tableStartTagInBody(p, token);

            else if (tn === $.EMBED)
                areaStartTagInBody(p, token);

            else if (tn === $.INPUT)
                inputStartTagInBody(p, token);

            else if (tn === $.PARAM || tn === $.TRACK)
                paramStartTagInBody(p, token);

            else if (tn === $.IMAGE)
                imageStartTagInBody(p, token);

            else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD)
                genericStartTagInBody(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressStartTagInBody(p, token);

            else if (tn === $.BUTTON)
                buttonStartTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                bStartTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletStartTagInBody(p, token);

            else if (tn === $.KEYGEN)
                areaStartTagInBody(p, token);

            else if (tn === $.SOURCE)
                paramStartTagInBody(p, token);

            else if (tn === $.IFRAME)
                iframeStartTagInBody(p, token);

            else if (tn === $.SELECT)
                selectStartTagInBody(p, token);

            else if (tn === $.OPTION)
                optgroupStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 7:
            if (tn === $.BGSOUND)
                startTagInHead(p, token);

            else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY)
                addressStartTagInBody(p, token);

            else if (tn === $.LISTING)
                preStartTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletStartTagInBody(p, token);

            else if (tn === $.NOEMBED)
                noembedStartTagInBody(p, token);

            else if (tn !== $.CAPTION)
                genericStartTagInBody(p, token);

            break;

        case 8:
            if (tn === $.BASEFONT)
                startTagInHead(p, token);

            else if (tn === $.MENUITEM)
                menuitemStartTagInBody(p, token);

            else if (tn === $.FRAMESET)
                framesetStartTagInBody(p, token);

            else if (tn === $.FIELDSET)
                addressStartTagInBody(p, token);

            else if (tn === $.TEXTAREA)
                textareaStartTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else if (tn === $.NOSCRIPT)
                noembedStartTagInBody(p, token);

            else if (tn === $.OPTGROUP)
                optgroupStartTagInBody(p, token);

            else if (tn !== $.COLGROUP)
                genericStartTagInBody(p, token);

            break;

        case 9:
            if (tn === $.PLAINTEXT)
                plaintextStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressStartTagInBody(p, token);

            else
                genericStartTagInBody(p, token);

            break;

        default:
            genericStartTagInBody(p, token);
    }
}

function bodyEndTagInBody(p) {
    if (p.openElements.hasInScope($.BODY))
        p.insertionMode = AFTER_BODY_MODE;
}

function htmlEndTagInBody(p, token) {
    if (p.openElements.hasInScope($.BODY)) {
        p.insertionMode = AFTER_BODY_MODE;
        p._processToken(token);
    }
}

function addressEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function formEndTagInBody(p) {
    var inTemplate = p.openElements.tmplCount > 0,
        formElement = p.formElement;

    if (!inTemplate)
        p.formElement = null;

    if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
        p.openElements.generateImpliedEndTags();

        if (inTemplate)
            p.openElements.popUntilTagNamePopped($.FORM);

        else
            p.openElements.remove(formElement);
    }
}

function pEndTagInBody(p) {
    if (!p.openElements.hasInButtonScope($.P))
        p._insertFakeElement($.P);

    p._closePElement();
}

function liEndTagInBody(p) {
    if (p.openElements.hasInListItemScope($.LI)) {
        p.openElements.generateImpliedEndTagsWithExclusion($.LI);
        p.openElements.popUntilTagNamePopped($.LI);
    }
}

function ddEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTagsWithExclusion(tn);
        p.openElements.popUntilTagNamePopped(tn);
    }
}

function numberedHeaderEndTagInBody(p) {
    if (p.openElements.hasNumberedHeaderInScope()) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilNumberedHeaderPopped();
    }
}

function appletEndTagInBody(p, token) {
    var tn = token.tagName;

    if (p.openElements.hasInScope(tn)) {
        p.openElements.generateImpliedEndTags();
        p.openElements.popUntilTagNamePopped(tn);
        p.activeFormattingElements.clearToLastMarker();
    }
}

function brEndTagInBody(p) {
    p._reconstructActiveFormattingElements();
    p._insertFakeElement($.BR);
    p.openElements.pop();
    p.framesetOk = false;
}

function genericEndTagInBody(p, token) {
    var tn = token.tagName;

    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getTagName(element) === tn) {
            p.openElements.generateImpliedEndTagsWithExclusion(tn);
            p.openElements.popUntilElementPopped(element);
            break;
        }

        if (p._isSpecialElement(element))
            break;
    }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 1:
            if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U)
                callAdoptionAgency(p, token);

            else if (tn === $.P)
                pEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 2:
            if (tn === $.DL || tn === $.UL || tn === $.OL)
                addressEndTagInBody(p, token);

            else if (tn === $.LI)
                liEndTagInBody(p, token);

            else if (tn === $.DD || tn === $.DT)
                ddEndTagInBody(p, token);

            else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6)
                numberedHeaderEndTagInBody(p, token);

            else if (tn === $.BR)
                brEndTagInBody(p, token);

            else if (tn === $.EM || tn === $.TT)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 3:
            if (tn === $.BIG)
                callAdoptionAgency(p, token);

            else if (tn === $.DIR || tn === $.DIV || tn === $.NAV)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 4:
            if (tn === $.BODY)
                bodyEndTagInBody(p, token);

            else if (tn === $.HTML)
                htmlEndTagInBody(p, token);

            else if (tn === $.FORM)
                formEndTagInBody(p, token);

            else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR)
                callAdoptionAgency(p, token);

            else if (tn === $.MAIN || tn === $.MENU)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 5:
            if (tn === $.ASIDE)
                addressEndTagInBody(p, token);

            else if (tn === $.SMALL)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 6:
            if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP)
                addressEndTagInBody(p, token);

            else if (tn === $.APPLET || tn === $.OBJECT)
                appletEndTagInBody(p, token);

            else if (tn === $.STRIKE || tn === $.STRONG)
                callAdoptionAgency(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 7:
            if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY)
                addressEndTagInBody(p, token);

            else if (tn === $.MARQUEE)
                appletEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 8:
            if (tn === $.FIELDSET)
                addressEndTagInBody(p, token);

            else if (tn === $.TEMPLATE)
                endTagInHead(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        case 10:
            if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION)
                addressEndTagInBody(p, token);

            else
                genericEndTagInBody(p, token);

            break;

        default :
            genericEndTagInBody(p, token);
    }
}

function eofInBody(p, token) {
    if (p.tmplInsertionModeStackTop > -1)
        eofInTemplate(p, token);

    else
        p.stopped = true;
}

//12.2.5.4.8 The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
    if (token.tagName === $.SCRIPT)
        p.pendingScript = p.openElements.current;

    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
}


function eofInText(p, token) {
    p.openElements.pop();
    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.9 The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
    var curTn = p.openElements.currentTagName;

    if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
        p.pendingCharacterTokens = [];
        p.hasNonWhitespacePendingCharacterToken = false;
        p.originalInsertionMode = p.insertionMode;
        p.insertionMode = IN_TABLE_TEXT_MODE;
        p._processToken(token);
    }

    else
        tokenInTable(p, token);
}

function captionStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p.activeFormattingElements.insertMarker();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CAPTION_MODE;
}

function colgroupStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
}

function colStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.COLGROUP);
    p.insertionMode = IN_COLUMN_GROUP_MODE;
    p._processToken(token);
}

function tbodyStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_TABLE_BODY_MODE;
}

function tdStartTagInTable(p, token) {
    p.openElements.clearBackToTableContext();
    p._insertFakeElement($.TBODY);
    p.insertionMode = IN_TABLE_BODY_MODE;
    p._processToken(token);
}

function tableStartTagInTable(p, token) {
    if (p.openElements.hasInTableScope($.TABLE)) {
        p.openElements.popUntilTagNamePopped($.TABLE);
        p._resetInsertionMode();
        p._processToken(token);
    }
}

function inputStartTagInTable(p, token) {
    var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);

    if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE)
        p._appendElement(token, NS.HTML);

    else
        tokenInTable(p, token);
}

function formStartTagInTable(p, token) {
    if (!p.formElement && p.openElements.tmplCount === 0) {
        p._insertElement(token, NS.HTML);
        p.formElement = p.openElements.current;
        p.openElements.pop();
    }
}

function startTagInTable(p, token) {
    var tn = token.tagName;

    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH || tn === $.TR)
                tdStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 3:
            if (tn === $.COL)
                colStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 4:
            if (tn === $.FORM)
                formStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 5:
            if (tn === $.TABLE)
                tableStartTagInTable(p, token);

            else if (tn === $.STYLE)
                startTagInHead(p, token);

            else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD)
                tbodyStartTagInTable(p, token);

            else if (tn === $.INPUT)
                inputStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 6:
            if (tn === $.SCRIPT)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        case 7:
            if (tn === $.CAPTION)
                captionStartTagInTable(p, token);

            else
                tokenInTable(p, token);

            break;

        case 8:
            if (tn === $.COLGROUP)
                colgroupStartTagInTable(p, token);

            else if (tn === $.TEMPLATE)
                startTagInHead(p, token);

            else
                tokenInTable(p, token);

            break;

        default:
            tokenInTable(p, token);
    }

}

function endTagInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TABLE)) {
            p.openElements.popUntilTagNamePopped($.TABLE);
            p._resetInsertionMode();
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML &&
             tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        tokenInTable(p, token);
}

function tokenInTable(p, token) {
    var savedFosterParentingState = p.fosterParentingEnabled;

    p.fosterParentingEnabled = true;
    p._processTokenInBodyMode(token);
    p.fosterParentingEnabled = savedFosterParentingState;
}


//12.2.5.4.10 The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
}

function characterInTableText(p, token) {
    p.pendingCharacterTokens.push(token);
    p.hasNonWhitespacePendingCharacterToken = true;
}

function tokenInTableText(p, token) {
    var i = 0;

    if (p.hasNonWhitespacePendingCharacterToken) {
        for (; i < p.pendingCharacterTokens.length; i++)
            tokenInTable(p, p.pendingCharacterTokens[i]);
    }

    else {
        for (; i < p.pendingCharacterTokens.length; i++)
            p._insertCharacters(p.pendingCharacterTokens[i]);
    }

    p.insertionMode = p.originalInsertionMode;
    p._processToken(token);
}


//12.2.5.4.11 The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCaption(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.CAPTION)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped($.CAPTION);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_TABLE_MODE;

            if (tn === $.TABLE)
                p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY &&
             tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR)
        endTagInBody(p, token);
}


//12.2.5.4.12 The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.COL)
        p._appendElement(token, NS.HTML);

    else if (tn === $.TEMPLATE)
        startTagInHead(p, token);

    else
        tokenInColumnGroup(p, token);
}

function endTagInColumnGroup(p, token) {
    var tn = token.tagName;

    if (tn === $.COLGROUP) {
        if (p.openElements.currentTagName === $.COLGROUP) {
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);

    else if (tn !== $.COL)
        tokenInColumnGroup(p, token);
}

function tokenInColumnGroup(p, token) {
    if (p.openElements.currentTagName === $.COLGROUP) {
        p.openElements.pop();
        p.insertionMode = IN_TABLE_MODE;
        p._processToken(token);
    }
}

//12.2.5.4.13 The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        p.openElements.clearBackToTableBodyContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_ROW_MODE;
    }

    else if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableBodyContext();
        p._insertFakeElement($.TR);
        p.insertionMode = IN_ROW_MODE;
        p._processToken(token);
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP ||
             tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {

        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInTableBody(p, token) {
    var tn = token.tagName;

    if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasTableBodyContextInTableScope()) {
            p.openElements.clearBackToTableBodyContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR)
        endTagInTable(p, token);
}

//12.2.5.4.14 The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TH || tn === $.TD) {
        p.openElements.clearBackToTableRowContext();
        p._insertElement(token, NS.HTML);
        p.insertionMode = IN_CELL_MODE;
        p.activeFormattingElements.insertMarker();
    }

    else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
             tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else
        startTagInTable(p, token);
}

function endTagInRow(p, token) {
    var tn = token.tagName;

    if (tn === $.TR) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
        }
    }

    else if (tn === $.TABLE) {
        if (p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
            p.openElements.clearBackToTableRowContext();
            p.openElements.pop();
            p.insertionMode = IN_TABLE_BODY_MODE;
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP ||
             tn !== $.HTML && tn !== $.TD && tn !== $.TH)
        endTagInTable(p, token);
}


//12.2.5.4.15 The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY ||
        tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {

        if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else
        startTagInBody(p, token);
}

function endTagInCell(p, token) {
    var tn = token.tagName;

    if (tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.generateImpliedEndTags();
            p.openElements.popUntilTagNamePopped(tn);
            p.activeFormattingElements.clearToLastMarker();
            p.insertionMode = IN_ROW_MODE;
        }
    }

    else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
        if (p.openElements.hasInTableScope(tn)) {
            p._closeTableCell();
            p._processToken(token);
        }
    }

    else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML)
        endTagInBody(p, token);
}

//12.2.5.4.16 The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.OPTGROUP) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();

        p._insertElement(token, NS.HTML);
    }

    else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
        if (p.openElements.hasInSelectScope($.SELECT)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();

            if (tn !== $.SELECT)
                p._processToken(token);
        }
    }

    else if (tn === $.SCRIPT || tn === $.TEMPLATE)
        startTagInHead(p, token);
}

function endTagInSelect(p, token) {
    var tn = token.tagName;

    if (tn === $.OPTGROUP) {
        var prevOpenElement = p.openElements.items[p.openElements.stackTop - 1],
            prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);

        if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP)
            p.openElements.pop();

        if (p.openElements.currentTagName === $.OPTGROUP)
            p.openElements.pop();
    }

    else if (tn === $.OPTION) {
        if (p.openElements.currentTagName === $.OPTION)
            p.openElements.pop();
    }

    else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
    }

    else if (tn === $.TEMPLATE)
        endTagInHead(p, token);
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        p.openElements.popUntilTagNamePopped($.SELECT);
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        startTagInSelect(p, token);
}

function endTagInSelectInTable(p, token) {
    var tn = token.tagName;

    if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT ||
        tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
        if (p.openElements.hasInTableScope(tn)) {
            p.openElements.popUntilTagNamePopped($.SELECT);
            p._resetInsertionMode();
            p._processToken(token);
        }
    }

    else
        endTagInSelect(p, token);
}

//12.2.5.4.18 The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
    var tn = token.tagName;

    if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META ||
        tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE)
        startTagInHead(p, token);

    else {
        var newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;

        p._popTmplInsertionMode();
        p._pushTmplInsertionMode(newInsertionMode);
        p.insertionMode = newInsertionMode;
        p._processToken(token);
    }
}

function endTagInTemplate(p, token) {
    if (token.tagName === $.TEMPLATE)
        endTagInHead(p, token);
}

function eofInTemplate(p, token) {
    if (p.openElements.tmplCount > 0) {
        p.openElements.popUntilTagNamePopped($.TEMPLATE);
        p.activeFormattingElements.clearToLastMarker();
        p._popTmplInsertionMode();
        p._resetInsertionMode();
        p._processToken(token);
    }

    else
        p.stopped = true;
}


//12.2.5.4.19 The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterBody(p, token);
}

function endTagAfterBody(p, token) {
    if (token.tagName === $.HTML) {
        if (!p.fragmentContext)
            p.insertionMode = AFTER_AFTER_BODY_MODE;
    }

    else
        tokenAfterBody(p, token);
}

function tokenAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.20 The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.FRAMESET)
        p._insertElement(token, NS.HTML);

    else if (tn === $.FRAME)
        p._appendElement(token, NS.HTML);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagInFrameset(p, token) {
    if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
        p.openElements.pop();

        if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET)
            p.insertionMode = AFTER_FRAMESET_MODE;
    }
}

//12.2.5.4.21 The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}

function endTagAfterFrameset(p, token) {
    if (token.tagName === $.HTML)
        p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
}

//12.2.5.4.22 The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
    if (token.tagName === $.HTML)
        startTagInBody(p, token);

    else
        tokenAfterAfterBody(p, token);
}

function tokenAfterAfterBody(p, token) {
    p.insertionMode = IN_BODY_MODE;
    p._processToken(token);
}

//12.2.5.4.23 The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
    var tn = token.tagName;

    if (tn === $.HTML)
        startTagInBody(p, token);

    else if (tn === $.NOFRAMES)
        startTagInHead(p, token);
}


//12.2.5.5 The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
    token.chars = UNICODE.REPLACEMENT_CHARACTER;
    p._insertCharacters(token);
}

function characterInForeignContent(p, token) {
    p._insertCharacters(token);
    p.framesetOk = false;
}

function startTagInForeignContent(p, token) {
    if (foreignContent.causesExit(token) && !p.fragmentContext) {
        while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current))
            p.openElements.pop();

        p._processToken(token);
    }

    else {
        var current = p._getAdjustedCurrentElement(),
            currentNs = p.treeAdapter.getNamespaceURI(current);

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        if (token.selfClosing)
            p._appendElement(token, currentNs);
        else
            p._insertElement(token, currentNs);
    }
}

function endTagInForeignContent(p, token) {
    for (var i = p.openElements.stackTop; i > 0; i--) {
        var element = p.openElements.items[i];

        if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
            p._processToken(token);
            break;
        }

        if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
            p.openElements.popUntilElementPopped(element);
            break;
        }
    }
}


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(135),
    Tokenizer = __webpack_require__(82),
    PositionTrackingPreprocessorMixin = __webpack_require__(311),
    inherits = __webpack_require__(53).inherits;

var LocationInfoTokenizerMixin = module.exports = function (tokenizer) {
    Mixin.call(this, tokenizer);

    this.tokenizer = tokenizer;
    this.posTracker = new PositionTrackingPreprocessorMixin(tokenizer.preprocessor);
    this.currentAttrLocation = null;
    this.currentTokenLocation = null;
};

inherits(LocationInfoTokenizerMixin, Mixin);

LocationInfoTokenizerMixin.prototype._getCurrentLocation = function () {
    return {
        line: this.posTracker.line,
        col: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endOffset: -1
    };
};

LocationInfoTokenizerMixin.prototype._attachCurrentAttrLocationInfo = function () {
    this.currentAttrLocation.endOffset = this.posTracker.offset;

    var currentToken = this.tokenizer.currentToken,
        currentAttr = this.tokenizer.currentAttr;

    if (!currentToken.location.attrs)
        currentToken.location.attrs = Object.create(null);

    currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
};

LocationInfoTokenizerMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    var methods = {
        _createStartTagToken: function () {
            orig._createStartTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createEndTagToken: function () {
            orig._createEndTagToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCommentToken: function () {
            orig._createCommentToken.call(this);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createDoctypeToken: function (initialName) {
            orig._createDoctypeToken.call(this, initialName);
            this.currentToken.location = mxn.currentTokenLocation;
        },

        _createCharacterToken: function (type, ch) {
            orig._createCharacterToken.call(this, type, ch);
            this.currentCharacterToken.location = mxn.currentTokenLocation;
        },

        _createAttr: function (attrNameFirstCh) {
            orig._createAttr.call(this, attrNameFirstCh);
            mxn.currentAttrLocation = mxn._getCurrentLocation();
        },

        _leaveAttrName: function (toState) {
            orig._leaveAttrName.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _leaveAttrValue: function (toState) {
            orig._leaveAttrValue.call(this, toState);
            mxn._attachCurrentAttrLocationInfo();
        },

        _emitCurrentToken: function () {
            //NOTE: if we have pending character token make it's end location equal to the
            //current token's start location.
            if (this.currentCharacterToken)
                this.currentCharacterToken.location.endOffset = this.currentToken.location.startOffset;

            this.currentToken.location.endOffset = mxn.posTracker.offset + 1;
            orig._emitCurrentToken.call(this);
        },

        _emitCurrentCharacterToken: function () {
            //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
            //then set it's location at the current preprocessor position.
            //We don't need to increment preprocessor position, since character token
            //emission is always forced by the start of the next character token here.
            //So, we already have advanced position.
            if (this.currentCharacterToken && this.currentCharacterToken.location.endOffset === -1)
                this.currentCharacterToken.location.endOffset = mxn.posTracker.offset;

            orig._emitCurrentCharacterToken.call(this);
        }
    };

    //NOTE: patch initial states for each mode to obtain token start position
    Object.keys(Tokenizer.MODE).forEach(function (modeName) {
        var state = Tokenizer.MODE[modeName];

        methods[state] = function (cp) {
            mxn.currentTokenLocation = mxn._getCurrentLocation();
            orig[state].call(this, cp);
        };
    });

    return methods;
};



/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(135),
    inherits = __webpack_require__(53).inherits,
    UNICODE = __webpack_require__(102);

//Aliases
var $ = UNICODE.CODE_POINTS;

var PositionTrackingPreprocessorMixin = module.exports = function (preprocessor) {
    // NOTE: avoid installing tracker twice
    if (!preprocessor.__locTracker) {
        preprocessor.__locTracker = this;

        Mixin.call(this, preprocessor);

        this.preprocessor = preprocessor;
        this.isEol = false;
        this.lineStartPos = 0;
        this.droppedBufferSize = 0;

        this.col = -1;
        this.line = 1;
    }

    return preprocessor.__locTracker;
};

inherits(PositionTrackingPreprocessorMixin, Mixin);

Object.defineProperty(PositionTrackingPreprocessorMixin.prototype, 'offset', {
    get: function () {
        return this.droppedBufferSize + this.preprocessor.pos;
    }
});

PositionTrackingPreprocessorMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        advance: function () {
            var cp = orig.advance.call(this);

            //NOTE: LF should be in the last column of the line
            if (mxn.isEol) {
                mxn.isEol = false;
                mxn.line++;
                mxn.lineStartPos = mxn.offset;
            }

            if (cp === $.LINE_FEED)
                mxn.isEol = true;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;

            return cp;
        },

        retreat: function () {
            orig.retreat.call(this);
            mxn.isEol = false;

            mxn.col = mxn.offset - mxn.lineStartPos + 1;
        },

        dropParsedChunk: function () {
            var prevPos = this.pos;

            orig.dropParsedChunk.call(this);

            mxn.droppedBufferSize += prevPos - this.pos;
        }
    };
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(82),
    HTML = __webpack_require__(42);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES,
    ATTRS = HTML.ATTRS;


//MIME types
var MIME_TYPES = {
    TEXT_HTML: 'text/html',
    APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
var DEFINITION_URL_ATTR = 'definitionurl',
    ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL',
    SVG_ATTRS_ADJUSTMENT_MAP = {
        'attributename': 'attributeName',
        'attributetype': 'attributeType',
        'basefrequency': 'baseFrequency',
        'baseprofile': 'baseProfile',
        'calcmode': 'calcMode',
        'clippathunits': 'clipPathUnits',
        'diffuseconstant': 'diffuseConstant',
        'edgemode': 'edgeMode',
        'filterunits': 'filterUnits',
        'glyphref': 'glyphRef',
        'gradienttransform': 'gradientTransform',
        'gradientunits': 'gradientUnits',
        'kernelmatrix': 'kernelMatrix',
        'kernelunitlength': 'kernelUnitLength',
        'keypoints': 'keyPoints',
        'keysplines': 'keySplines',
        'keytimes': 'keyTimes',
        'lengthadjust': 'lengthAdjust',
        'limitingconeangle': 'limitingConeAngle',
        'markerheight': 'markerHeight',
        'markerunits': 'markerUnits',
        'markerwidth': 'markerWidth',
        'maskcontentunits': 'maskContentUnits',
        'maskunits': 'maskUnits',
        'numoctaves': 'numOctaves',
        'pathlength': 'pathLength',
        'patterncontentunits': 'patternContentUnits',
        'patterntransform': 'patternTransform',
        'patternunits': 'patternUnits',
        'pointsatx': 'pointsAtX',
        'pointsaty': 'pointsAtY',
        'pointsatz': 'pointsAtZ',
        'preservealpha': 'preserveAlpha',
        'preserveaspectratio': 'preserveAspectRatio',
        'primitiveunits': 'primitiveUnits',
        'refx': 'refX',
        'refy': 'refY',
        'repeatcount': 'repeatCount',
        'repeatdur': 'repeatDur',
        'requiredextensions': 'requiredExtensions',
        'requiredfeatures': 'requiredFeatures',
        'specularconstant': 'specularConstant',
        'specularexponent': 'specularExponent',
        'spreadmethod': 'spreadMethod',
        'startoffset': 'startOffset',
        'stddeviation': 'stdDeviation',
        'stitchtiles': 'stitchTiles',
        'surfacescale': 'surfaceScale',
        'systemlanguage': 'systemLanguage',
        'tablevalues': 'tableValues',
        'targetx': 'targetX',
        'targety': 'targetY',
        'textlength': 'textLength',
        'viewbox': 'viewBox',
        'viewtarget': 'viewTarget',
        'xchannelselector': 'xChannelSelector',
        'ychannelselector': 'yChannelSelector',
        'zoomandpan': 'zoomAndPan'
    },
    XML_ATTRS_ADJUSTMENT_MAP = {
        'xlink:actuate': {prefix: 'xlink', name: 'actuate', namespace: NS.XLINK},
        'xlink:arcrole': {prefix: 'xlink', name: 'arcrole', namespace: NS.XLINK},
        'xlink:href': {prefix: 'xlink', name: 'href', namespace: NS.XLINK},
        'xlink:role': {prefix: 'xlink', name: 'role', namespace: NS.XLINK},
        'xlink:show': {prefix: 'xlink', name: 'show', namespace: NS.XLINK},
        'xlink:title': {prefix: 'xlink', name: 'title', namespace: NS.XLINK},
        'xlink:type': {prefix: 'xlink', name: 'type', namespace: NS.XLINK},
        'xml:base': {prefix: 'xml', name: 'base', namespace: NS.XML},
        'xml:lang': {prefix: 'xml', name: 'lang', namespace: NS.XML},
        'xml:space': {prefix: 'xml', name: 'space', namespace: NS.XML},
        'xmlns': {prefix: '', name: 'xmlns', namespace: NS.XMLNS},
        'xmlns:xlink': {prefix: 'xmlns', name: 'xlink', namespace: NS.XMLNS}

    };

//SVG tag names adjustment map
var SVG_TAG_NAMES_ADJUSTMENT_MAP = exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
    'altglyph': 'altGlyph',
    'altglyphdef': 'altGlyphDef',
    'altglyphitem': 'altGlyphItem',
    'animatecolor': 'animateColor',
    'animatemotion': 'animateMotion',
    'animatetransform': 'animateTransform',
    'clippath': 'clipPath',
    'feblend': 'feBlend',
    'fecolormatrix': 'feColorMatrix',
    'fecomponenttransfer': 'feComponentTransfer',
    'fecomposite': 'feComposite',
    'feconvolvematrix': 'feConvolveMatrix',
    'fediffuselighting': 'feDiffuseLighting',
    'fedisplacementmap': 'feDisplacementMap',
    'fedistantlight': 'feDistantLight',
    'feflood': 'feFlood',
    'fefunca': 'feFuncA',
    'fefuncb': 'feFuncB',
    'fefuncg': 'feFuncG',
    'fefuncr': 'feFuncR',
    'fegaussianblur': 'feGaussianBlur',
    'feimage': 'feImage',
    'femerge': 'feMerge',
    'femergenode': 'feMergeNode',
    'femorphology': 'feMorphology',
    'feoffset': 'feOffset',
    'fepointlight': 'fePointLight',
    'fespecularlighting': 'feSpecularLighting',
    'fespotlight': 'feSpotLight',
    'fetile': 'feTile',
    'feturbulence': 'feTurbulence',
    'foreignobject': 'foreignObject',
    'glyphref': 'glyphRef',
    'lineargradient': 'linearGradient',
    'radialgradient': 'radialGradient',
    'textpath': 'textPath'
};

//Tags that causes exit from foreign content
var EXITS_FOREIGN_CONTENT = Object.create(null);

EXITS_FOREIGN_CONTENT[$.B] = true;
EXITS_FOREIGN_CONTENT[$.BIG] = true;
EXITS_FOREIGN_CONTENT[$.BLOCKQUOTE] = true;
EXITS_FOREIGN_CONTENT[$.BODY] = true;
EXITS_FOREIGN_CONTENT[$.BR] = true;
EXITS_FOREIGN_CONTENT[$.CENTER] = true;
EXITS_FOREIGN_CONTENT[$.CODE] = true;
EXITS_FOREIGN_CONTENT[$.DD] = true;
EXITS_FOREIGN_CONTENT[$.DIV] = true;
EXITS_FOREIGN_CONTENT[$.DL] = true;
EXITS_FOREIGN_CONTENT[$.DT] = true;
EXITS_FOREIGN_CONTENT[$.EM] = true;
EXITS_FOREIGN_CONTENT[$.EMBED] = true;
EXITS_FOREIGN_CONTENT[$.H1] = true;
EXITS_FOREIGN_CONTENT[$.H2] = true;
EXITS_FOREIGN_CONTENT[$.H3] = true;
EXITS_FOREIGN_CONTENT[$.H4] = true;
EXITS_FOREIGN_CONTENT[$.H5] = true;
EXITS_FOREIGN_CONTENT[$.H6] = true;
EXITS_FOREIGN_CONTENT[$.HEAD] = true;
EXITS_FOREIGN_CONTENT[$.HR] = true;
EXITS_FOREIGN_CONTENT[$.I] = true;
EXITS_FOREIGN_CONTENT[$.IMG] = true;
EXITS_FOREIGN_CONTENT[$.LI] = true;
EXITS_FOREIGN_CONTENT[$.LISTING] = true;
EXITS_FOREIGN_CONTENT[$.MENU] = true;
EXITS_FOREIGN_CONTENT[$.META] = true;
EXITS_FOREIGN_CONTENT[$.NOBR] = true;
EXITS_FOREIGN_CONTENT[$.OL] = true;
EXITS_FOREIGN_CONTENT[$.P] = true;
EXITS_FOREIGN_CONTENT[$.PRE] = true;
EXITS_FOREIGN_CONTENT[$.RUBY] = true;
EXITS_FOREIGN_CONTENT[$.S] = true;
EXITS_FOREIGN_CONTENT[$.SMALL] = true;
EXITS_FOREIGN_CONTENT[$.SPAN] = true;
EXITS_FOREIGN_CONTENT[$.STRONG] = true;
EXITS_FOREIGN_CONTENT[$.STRIKE] = true;
EXITS_FOREIGN_CONTENT[$.SUB] = true;
EXITS_FOREIGN_CONTENT[$.SUP] = true;
EXITS_FOREIGN_CONTENT[$.TABLE] = true;
EXITS_FOREIGN_CONTENT[$.TT] = true;
EXITS_FOREIGN_CONTENT[$.U] = true;
EXITS_FOREIGN_CONTENT[$.UL] = true;
EXITS_FOREIGN_CONTENT[$.VAR] = true;

//Check exit from foreign content
exports.causesExit = function (startTagToken) {
    var tn = startTagToken.tagName;
    var isFontWithAttrs = tn === $.FONT && (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null ||
                                            Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);

    return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        if (token.attrs[i].name === DEFINITION_URL_ATTR) {
            token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
            break;
        }
    }
};

exports.adjustTokenSVGAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrName)
            token.attrs[i].name = adjustedAttrName;
    }
};

exports.adjustTokenXMLAttrs = function (token) {
    for (var i = 0; i < token.attrs.length; i++) {
        var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];

        if (adjustedAttrEntry) {
            token.attrs[i].prefix = adjustedAttrEntry.prefix;
            token.attrs[i].name = adjustedAttrEntry.name;
            token.attrs[i].namespace = adjustedAttrEntry.namespace;
        }
    }
};

exports.adjustTokenSVGTagName = function (token) {
    var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];

    if (adjustedTagName)
        token.tagName = adjustedTagName;
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
    return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}

function isHtmlIntegrationPoint(tn, ns, attrs) {
    if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
        for (var i = 0; i < attrs.length; i++) {
            if (attrs[i].name === ATTRS.ENCODING) {
                var value = attrs[i].value.toLowerCase();

                return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
            }
        }
    }

    return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}

exports.isIntegrationPoint = function (tn, ns, attrs, foreignNS) {
    if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs))
        return true;

    if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns))
        return true;

    return false;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaultTreeAdapter = __webpack_require__(190),
    mergeOptions = __webpack_require__(191),
    doctype = __webpack_require__(192),
    HTML = __webpack_require__(42);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Default serializer options
var DEFAULT_OPTIONS = {
    treeAdapter: defaultTreeAdapter
};

//Escaping regexes
var AMP_REGEX = /&/g,
    NBSP_REGEX = /\u00a0/g,
    DOUBLE_QUOTE_REGEX = /"/g,
    LT_REGEX = /</g,
    GT_REGEX = />/g;

//Serializer
var Serializer = module.exports = function (node, options) {
    this.options = mergeOptions(DEFAULT_OPTIONS, options);
    this.treeAdapter = this.options.treeAdapter;

    this.html = '';
    this.startNode = node;
};

// NOTE: exported as static method for the testing purposes
Serializer.escapeString = function (str, attrMode) {
    str = str
        .replace(AMP_REGEX, '&amp;')
        .replace(NBSP_REGEX, '&nbsp;');

    if (attrMode)
        str = str.replace(DOUBLE_QUOTE_REGEX, '&quot;');

    else {
        str = str
            .replace(LT_REGEX, '&lt;')
            .replace(GT_REGEX, '&gt;');
    }

    return str;
};


//API
Serializer.prototype.serialize = function () {
    this._serializeChildNodes(this.startNode);

    return this.html;
};


//Internals
Serializer.prototype._serializeChildNodes = function (parentNode) {
    var childNodes = this.treeAdapter.getChildNodes(parentNode);

    if (childNodes) {
        for (var i = 0, cnLength = childNodes.length; i < cnLength; i++) {
            var currentNode = childNodes[i];

            if (this.treeAdapter.isElementNode(currentNode))
                this._serializeElement(currentNode);

            else if (this.treeAdapter.isTextNode(currentNode))
                this._serializeTextNode(currentNode);

            else if (this.treeAdapter.isCommentNode(currentNode))
                this._serializeCommentNode(currentNode);

            else if (this.treeAdapter.isDocumentTypeNode(currentNode))
                this._serializeDocumentTypeNode(currentNode);
        }
    }
};

Serializer.prototype._serializeElement = function (node) {
    var tn = this.treeAdapter.getTagName(node),
        ns = this.treeAdapter.getNamespaceURI(node);

    this.html += '<' + tn;
    this._serializeAttributes(node);
    this.html += '>';

    if (tn !== $.AREA && tn !== $.BASE && tn !== $.BASEFONT && tn !== $.BGSOUND && tn !== $.BR && tn !== $.BR &&
        tn !== $.COL && tn !== $.EMBED && tn !== $.FRAME && tn !== $.HR && tn !== $.IMG && tn !== $.INPUT &&
        tn !== $.KEYGEN && tn !== $.LINK && tn !== $.MENUITEM && tn !== $.META && tn !== $.PARAM && tn !== $.SOURCE &&
        tn !== $.TRACK && tn !== $.WBR) {

        var childNodesHolder = tn === $.TEMPLATE && ns === NS.HTML ?
            this.treeAdapter.getTemplateContent(node) :
            node;

        this._serializeChildNodes(childNodesHolder);
        this.html += '</' + tn + '>';
    }
};

Serializer.prototype._serializeAttributes = function (node) {
    var attrs = this.treeAdapter.getAttrList(node);

    for (var i = 0, attrsLength = attrs.length; i < attrsLength; i++) {
        var attr = attrs[i],
            value = Serializer.escapeString(attr.value, true);

        this.html += ' ';

        if (!attr.namespace)
            this.html += attr.name;

        else if (attr.namespace === NS.XML)
            this.html += 'xml:' + attr.name;

        else if (attr.namespace === NS.XMLNS) {
            if (attr.name !== 'xmlns')
                this.html += 'xmlns:';

            this.html += attr.name;
        }

        else if (attr.namespace === NS.XLINK)
            this.html += 'xlink:' + attr.name;

        else
            this.html += attr.namespace + ':' + attr.name;

        this.html += '="' + value + '"';
    }
};

Serializer.prototype._serializeTextNode = function (node) {
    var content = this.treeAdapter.getTextNodeContent(node),
        parent = this.treeAdapter.getParentNode(node),
        parentTn = void 0;

    if (parent && this.treeAdapter.isElementNode(parent))
        parentTn = this.treeAdapter.getTagName(parent);

    if (parentTn === $.STYLE || parentTn === $.SCRIPT || parentTn === $.XMP || parentTn === $.IFRAME ||
        parentTn === $.NOEMBED || parentTn === $.NOFRAMES || parentTn === $.PLAINTEXT || parentTn === $.NOSCRIPT)

        this.html += content;

    else
        this.html += Serializer.escapeString(content, false);
};

Serializer.prototype._serializeCommentNode = function (node) {
    this.html += '<!--' + this.treeAdapter.getCommentNodeContent(node) + '-->';
};

Serializer.prototype._serializeDocumentTypeNode = function (node) {
    var name = this.treeAdapter.getDocumentTypeNodeName(node);

    this.html += '<' + doctype.serializeContent(name, null, null) + '>';
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WritableStream = __webpack_require__(136).Writable,
    inherits = __webpack_require__(53).inherits,
    Parser = __webpack_require__(309);

var ParserStream = module.exports = function (options) {
    WritableStream.call(this);

    this.parser = new Parser(options);

    this.lastChunkWritten = false;
    this.writeCallback = null;
    this.pausedByScript = false;

    this.document = this.parser.treeAdapter.createDocument();

    this.pendingHtmlInsertions = [];

    this._resume = this._resume.bind(this);
    this._documentWrite = this._documentWrite.bind(this);
    this._scriptHandler = this._scriptHandler.bind(this);

    this.parser._bootstrap(this.document, null);
};

inherits(ParserStream, WritableStream);

//WritableStream implementation
ParserStream.prototype._write = function (chunk, encoding, callback) {
    this.writeCallback = callback;
    this.parser.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
    this._runParsingLoop();
};

ParserStream.prototype.end = function (chunk, encoding, callback) {
    this.lastChunkWritten = true;
    WritableStream.prototype.end.call(this, chunk || '', encoding, callback);
};

//Scriptable parser implementation
ParserStream.prototype._runParsingLoop = function () {
    this.parser.runParsingLoopForCurrentChunk(this.writeCallback, this._scriptHandler);
};

ParserStream.prototype._resume = function () {
    if (!this.pausedByScript)
        throw new Error('Parser was already resumed');

    while (this.pendingHtmlInsertions.length) {
        var html = this.pendingHtmlInsertions.pop();

        this.parser.tokenizer.insertHtmlAtCurrentPos(html);
    }

    this.pausedByScript = false;

    //NOTE: keep parsing if we don't wait for the next input chunk
    if (this.parser.tokenizer.active)
        this._runParsingLoop();
};

ParserStream.prototype._documentWrite = function (html) {
    if (!this.parser.stopped)
        this.pendingHtmlInsertions.push(html);
};

ParserStream.prototype._scriptHandler = function (scriptElement) {
    if (this.listeners('script').length) {
        this.pausedByScript = true;
        this.emit('script', scriptElement, this._documentWrite, this._resume);
    }
    else
        this._runParsingLoop();
};



/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(316);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(193).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(317);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(195).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = Object.create(__webpack_require__(104));
util.inherits = __webpack_require__(83);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(646);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(647);
var destroyImpl = __webpack_require__(318);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(69);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(319).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(69);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(319).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(103)))

/***/ }),
/* 316 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(193).EventEmitter;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(137);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(652).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(69);

/*<replacement>*/
var util = Object.create(__webpack_require__(104));
util.inherits = __webpack_require__(83);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Path = __webpack_require__(138);

var _textDecoration = __webpack_require__(198);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var addColorStops = function addColorStops(gradient, canvasGradient) {
    var maxStop = Math.max.apply(null, gradient.colorStops.map(function (colorStop) {
        return colorStop.stop;
    }));
    var f = 1 / Math.max(1, maxStop);
    gradient.colorStops.forEach(function (colorStop) {
        canvasGradient.addColorStop(f * colorStop.stop, colorStop.color.toString());
    });
};

var CanvasRenderer = function () {
    function CanvasRenderer(canvas) {
        _classCallCheck(this, CanvasRenderer);

        this.canvas = canvas ? canvas : document.createElement('canvas');
    }

    _createClass(CanvasRenderer, [{
        key: 'render',
        value: function render(options) {
            this.ctx = this.canvas.getContext('2d');
            this.options = options;
            this.canvas.width = Math.floor(options.width * options.scale);
            this.canvas.height = Math.floor(options.height * options.scale);
            this.canvas.style.width = options.width + 'px';
            this.canvas.style.height = options.height + 'px';

            this.ctx.scale(this.options.scale, this.options.scale);
            this.ctx.translate(-options.x, -options.y);
            this.ctx.textBaseline = 'bottom';
            options.logger.log('Canvas renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + this.options.scale);
        }
    }, {
        key: 'clip',
        value: function clip(clipPaths, callback) {
            var _this = this;

            if (clipPaths.length) {
                this.ctx.save();
                clipPaths.forEach(function (path) {
                    _this.path(path);
                    _this.ctx.clip();
                });
            }

            callback();

            if (clipPaths.length) {
                this.ctx.restore();
            }
        }
    }, {
        key: 'drawImage',
        value: function drawImage(image, source, destination) {
            this.ctx.drawImage(image, source.left, source.top, source.width, source.height, destination.left, destination.top, destination.width, destination.height);
        }
    }, {
        key: 'drawShape',
        value: function drawShape(path, color) {
            this.path(path);
            this.ctx.fillStyle = color.toString();
            this.ctx.fill();
        }
    }, {
        key: 'fill',
        value: function fill(color) {
            this.ctx.fillStyle = color.toString();
            this.ctx.fill();
        }
    }, {
        key: 'getTarget',
        value: function getTarget() {
            this.canvas.getContext('2d').setTransform(1, 0, 0, 1, 0, 0);
            return Promise.resolve(this.canvas);
        }
    }, {
        key: 'path',
        value: function path(_path) {
            var _this2 = this;

            this.ctx.beginPath();
            if (Array.isArray(_path)) {
                _path.forEach(function (point, index) {
                    var start = point.type === _Path.PATH.VECTOR ? point : point.start;
                    if (index === 0) {
                        _this2.ctx.moveTo(start.x, start.y);
                    } else {
                        _this2.ctx.lineTo(start.x, start.y);
                    }

                    if (point.type === _Path.PATH.BEZIER_CURVE) {
                        _this2.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                    }
                });
            } else {
                this.ctx.arc(_path.x + _path.radius, _path.y + _path.radius, _path.radius, 0, Math.PI * 2, true);
            }

            this.ctx.closePath();
        }
    }, {
        key: 'rectangle',
        value: function rectangle(x, y, width, height, color) {
            this.ctx.fillStyle = color.toString();
            this.ctx.fillRect(x, y, width, height);
        }
    }, {
        key: 'renderLinearGradient',
        value: function renderLinearGradient(bounds, gradient) {
            var linearGradient = this.ctx.createLinearGradient(bounds.left + gradient.direction.x1, bounds.top + gradient.direction.y1, bounds.left + gradient.direction.x0, bounds.top + gradient.direction.y0);

            addColorStops(gradient, linearGradient);
            this.ctx.fillStyle = linearGradient;
            this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
        }
    }, {
        key: 'renderRadialGradient',
        value: function renderRadialGradient(bounds, gradient) {
            var _this3 = this;

            var x = bounds.left + gradient.center.x;
            var y = bounds.top + gradient.center.y;

            var radialGradient = this.ctx.createRadialGradient(x, y, 0, x, y, gradient.radius.x);
            if (!radialGradient) {
                return;
            }

            addColorStops(gradient, radialGradient);
            this.ctx.fillStyle = radialGradient;

            if (gradient.radius.x !== gradient.radius.y) {
                // transforms for elliptical radial gradient
                var midX = bounds.left + 0.5 * bounds.width;
                var midY = bounds.top + 0.5 * bounds.height;
                var f = gradient.radius.y / gradient.radius.x;
                var invF = 1 / f;

                this.transform(midX, midY, [1, 0, 0, f, 0, 0], function () {
                    return _this3.ctx.fillRect(bounds.left, invF * (bounds.top - midY) + midY, bounds.width, bounds.height * invF);
                });
            } else {
                this.ctx.fillRect(bounds.left, bounds.top, bounds.width, bounds.height);
            }
        }
    }, {
        key: 'renderRepeat',
        value: function renderRepeat(path, image, imageSize, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = this.ctx.createPattern(this.resizeImage(image, imageSize), 'repeat');
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        }
    }, {
        key: 'renderTextNode',
        value: function renderTextNode(textBounds, color, font, textDecoration, textShadows) {
            var _this4 = this;

            this.ctx.font = [font.fontStyle, font.fontVariant, font.fontWeight, font.fontSize, font.fontFamily].join(' ');

            textBounds.forEach(function (text) {
                _this4.ctx.fillStyle = color.toString();
                if (textShadows && text.text.trim().length) {
                    textShadows.slice(0).reverse().forEach(function (textShadow) {
                        _this4.ctx.shadowColor = textShadow.color.toString();
                        _this4.ctx.shadowOffsetX = textShadow.offsetX * _this4.options.scale;
                        _this4.ctx.shadowOffsetY = textShadow.offsetY * _this4.options.scale;
                        _this4.ctx.shadowBlur = textShadow.blur;

                        _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                    });
                } else {
                    _this4.ctx.fillText(text.text, text.bounds.left, text.bounds.top + text.bounds.height);
                }

                if (textDecoration !== null) {
                    var textDecorationColor = textDecoration.textDecorationColor || color;
                    textDecoration.textDecorationLine.forEach(function (textDecorationLine) {
                        switch (textDecorationLine) {
                            case _textDecoration.TEXT_DECORATION_LINE.UNDERLINE:
                                // Draws a line at the baseline of the font
                                // TODO As some browsers display the line as more than 1px if the font-size is big,
                                // need to take that into account both in position and size
                                var _options$fontMetrics$ = _this4.options.fontMetrics.getMetrics(font),
                                    baseline = _options$fontMetrics$.baseline;

                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1, textDecorationColor);
                                break;
                            case _textDecoration.TEXT_DECORATION_LINE.OVERLINE:
                                _this4.rectangle(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1, textDecorationColor);
                                break;
                            case _textDecoration.TEXT_DECORATION_LINE.LINE_THROUGH:
                                // TODO try and find exact position for line-through
                                var _options$fontMetrics$2 = _this4.options.fontMetrics.getMetrics(font),
                                    middle = _options$fontMetrics$2.middle;

                                _this4.rectangle(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1, textDecorationColor);
                                break;
                        }
                    });
                }
            });
        }
    }, {
        key: 'resizeImage',
        value: function resizeImage(image, size) {
            if (image.width === size.width && image.height === size.height) {
                return image;
            }

            var canvas = this.canvas.ownerDocument.createElement('canvas');
            canvas.width = size.width;
            canvas.height = size.height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height);
            return canvas;
        }
    }, {
        key: 'setOpacity',
        value: function setOpacity(opacity) {
            this.ctx.globalAlpha = opacity;
        }
    }, {
        key: 'transform',
        value: function transform(offsetX, offsetY, matrix, callback) {
            this.ctx.save();
            this.ctx.translate(offsetX, offsetY);
            this.ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
            this.ctx.translate(-offsetX, -offsetY);

            callback();

            this.ctx.restore();
        }
    }]);

    return CanvasRenderer;
}();

exports.default = CanvasRenderer;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logger = function () {
    function Logger(enabled, id, start) {
        _classCallCheck(this, Logger);

        this.enabled = typeof window !== 'undefined' && enabled;
        this.start = start ? start : Date.now();
        this.id = id;
    }

    _createClass(Logger, [{
        key: 'child',
        value: function child(id) {
            return new Logger(this.enabled, id, this.start);
        }

        // eslint-disable-next-line flowtype/no-weak-types

    }, {
        key: 'log',
        value: function log() {
            if (this.enabled && window.console && window.console.log) {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                Function.prototype.bind.call(window.console.log, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
            }
        }

        // eslint-disable-next-line flowtype/no-weak-types

    }, {
        key: 'error',
        value: function error() {
            if (this.enabled && window.console && window.console.error) {
                for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                Function.prototype.bind.call(window.console.error, window.console).apply(window.console, [Date.now() - this.start + 'ms', this.id ? 'html2canvas (' + this.id + '):' : 'html2canvas:'].concat([].slice.call(args, 0)));
            }
        }
    }]);

    return Logger;
}();

exports.default = Logger;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parsePadding = exports.PADDING_SIDES = undefined;

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PADDING_SIDES = exports.PADDING_SIDES = {
    TOP: 0,
    RIGHT: 1,
    BOTTOM: 2,
    LEFT: 3
};

var SIDES = ['top', 'right', 'bottom', 'left'];

var parsePadding = exports.parsePadding = function parsePadding(style) {
    return SIDES.map(function (side) {
        return new _Length2.default(style.getPropertyValue('padding-' + side));
    });
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OVERFLOW_WRAP = exports.OVERFLOW_WRAP = {
    NORMAL: 0,
    BREAK_WORD: 1
};

var parseOverflowWrap = exports.parseOverflowWrap = function parseOverflowWrap(overflow) {
    switch (overflow) {
        case 'break-word':
            return OVERFLOW_WRAP.BREAK_WORD;
        case 'normal':
        default:
            return OVERFLOW_WRAP.NORMAL;
    }
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var POSITION = exports.POSITION = {
    STATIC: 0,
    RELATIVE: 1,
    ABSOLUTE: 2,
    FIXED: 3,
    STICKY: 4
};

var parsePosition = exports.parsePosition = function parsePosition(position) {
    switch (position) {
        case 'relative':
            return POSITION.RELATIVE;
        case 'absolute':
            return POSITION.ABSOLUTE;
        case 'fixed':
            return POSITION.FIXED;
        case 'sticky':
            return POSITION.STICKY;
    }

    return POSITION.STATIC;
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TEXT_TRANSFORM = exports.TEXT_TRANSFORM = {
    NONE: 0,
    LOWERCASE: 1,
    UPPERCASE: 2,
    CAPITALIZE: 3
};

var parseTextTransform = exports.parseTextTransform = function parseTextTransform(textTransform) {
    switch (textTransform) {
        case 'uppercase':
            return TEXT_TRANSFORM.UPPERCASE;
        case 'lowercase':
            return TEXT_TRANSFORM.LOWERCASE;
        case 'capitalize':
            return TEXT_TRANSFORM.CAPITALIZE;
    }

    return TEXT_TRANSFORM.NONE;
};

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reformatInputBounds = exports.inlineSelectElement = exports.inlineTextAreaElement = exports.inlineInputElement = exports.getInputBorderRadius = exports.INPUT_BACKGROUND = exports.INPUT_BORDERS = exports.INPUT_COLOR = undefined;

var _TextContainer = __webpack_require__(141);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _background = __webpack_require__(106);

var _border = __webpack_require__(199);

var _Circle = __webpack_require__(687);

var _Circle2 = _interopRequireDefault(_Circle);

var _Vector = __webpack_require__(139);

var _Vector2 = _interopRequireDefault(_Vector);

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

var _Bounds = __webpack_require__(71);

var _TextBounds = __webpack_require__(328);

var _Util = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INPUT_COLOR = exports.INPUT_COLOR = new _Color2.default([42, 42, 42]);
var INPUT_BORDER_COLOR = new _Color2.default([165, 165, 165]);
var INPUT_BACKGROUND_COLOR = new _Color2.default([222, 222, 222]);
var INPUT_BORDER = {
    borderWidth: 1,
    borderColor: INPUT_BORDER_COLOR,
    borderStyle: _border.BORDER_STYLE.SOLID
};
var INPUT_BORDERS = exports.INPUT_BORDERS = [INPUT_BORDER, INPUT_BORDER, INPUT_BORDER, INPUT_BORDER];
var INPUT_BACKGROUND = exports.INPUT_BACKGROUND = {
    backgroundColor: INPUT_BACKGROUND_COLOR,
    backgroundImage: [],
    backgroundClip: _background.BACKGROUND_CLIP.PADDING_BOX,
    backgroundOrigin: _background.BACKGROUND_ORIGIN.PADDING_BOX
};

var RADIO_BORDER_RADIUS = new _Length2.default('50%');
var RADIO_BORDER_RADIUS_TUPLE = [RADIO_BORDER_RADIUS, RADIO_BORDER_RADIUS];
var INPUT_RADIO_BORDER_RADIUS = [RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE, RADIO_BORDER_RADIUS_TUPLE];

var CHECKBOX_BORDER_RADIUS = new _Length2.default('3px');
var CHECKBOX_BORDER_RADIUS_TUPLE = [CHECKBOX_BORDER_RADIUS, CHECKBOX_BORDER_RADIUS];
var INPUT_CHECKBOX_BORDER_RADIUS = [CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE, CHECKBOX_BORDER_RADIUS_TUPLE];

var getInputBorderRadius = exports.getInputBorderRadius = function getInputBorderRadius(node) {
    return node.type === 'radio' ? INPUT_RADIO_BORDER_RADIUS : INPUT_CHECKBOX_BORDER_RADIUS;
};

var inlineInputElement = exports.inlineInputElement = function inlineInputElement(node, container) {
    if (node.type === 'radio' || node.type === 'checkbox') {
        if (node.checked) {
            var size = Math.min(container.bounds.width, container.bounds.height);
            container.childNodes.push(node.type === 'checkbox' ? [new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79), new _Vector2.default(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549), new _Vector2.default(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071), new _Vector2.default(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649), new _Vector2.default(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23), new _Vector2.default(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085), new _Vector2.default(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)] : new _Circle2.default(container.bounds.left + size / 4, container.bounds.top + size / 4, size / 4));
        }
    } else {
        inlineFormElement(getInputValue(node), node, container, false);
    }
};

var inlineTextAreaElement = exports.inlineTextAreaElement = function inlineTextAreaElement(node, container) {
    inlineFormElement(node.value, node, container, true);
};

var inlineSelectElement = exports.inlineSelectElement = function inlineSelectElement(node, container) {
    var option = node.options[node.selectedIndex || 0];
    inlineFormElement(option ? option.text || '' : '', node, container, false);
};

var reformatInputBounds = exports.reformatInputBounds = function reformatInputBounds(bounds) {
    if (bounds.width > bounds.height) {
        bounds.left += (bounds.width - bounds.height) / 2;
        bounds.width = bounds.height;
    } else if (bounds.width < bounds.height) {
        bounds.top += (bounds.height - bounds.width) / 2;
        bounds.height = bounds.width;
    }
    return bounds;
};

var inlineFormElement = function inlineFormElement(value, node, container, allowLinebreak) {
    var body = node.ownerDocument.body;
    if (value.length > 0 && body) {
        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
        (0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node, null), wrapper);
        wrapper.style.position = 'absolute';
        wrapper.style.left = container.bounds.left + 'px';
        wrapper.style.top = container.bounds.top + 'px';
        if (!allowLinebreak) {
            wrapper.style.whiteSpace = 'nowrap';
        }
        var text = node.ownerDocument.createTextNode(value);
        wrapper.appendChild(text);
        body.appendChild(wrapper);
        container.childNodes.push(_TextContainer2.default.fromTextNode(text, container));
        body.removeChild(wrapper);
    }
};

var getInputValue = function getInputValue(node) {
    var value = node.type === 'password' ? new Array(node.value.length + 1).join('\u2022') : node.value;

    return value.length === 0 ? node.placeholder || '' : value;
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextBounds = exports.TextBounds = undefined;

var _Bounds = __webpack_require__(71);

var _textDecoration = __webpack_require__(198);

var _Feature = __webpack_require__(142);

var _Feature2 = _interopRequireDefault(_Feature);

var _Unicode = __webpack_require__(330);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextBounds = exports.TextBounds = function TextBounds(text, bounds) {
    _classCallCheck(this, TextBounds);

    this.text = text;
    this.bounds = bounds;
};

var parseTextBounds = exports.parseTextBounds = function parseTextBounds(value, parent, node) {
    var letterRendering = parent.style.letterSpacing !== 0;
    var textList = letterRendering ? (0, _Unicode.toCodePoints)(value).map(function (i) {
        return (0, _Unicode.fromCodePoint)(i);
    }) : (0, _Unicode.breakWords)(value, parent);
    var length = textList.length;
    var defaultView = node.parentNode ? node.parentNode.ownerDocument.defaultView : null;
    var scrollX = defaultView ? defaultView.pageXOffset : 0;
    var scrollY = defaultView ? defaultView.pageYOffset : 0;
    var textBounds = [];
    var offset = 0;
    for (var i = 0; i < length; i++) {
        var text = textList[i];
        if (parent.style.textDecoration !== _textDecoration.TEXT_DECORATION.NONE || text.trim().length > 0) {
            if (_Feature2.default.SUPPORT_RANGE_BOUNDS) {
                textBounds.push(new TextBounds(text, getRangeBounds(node, offset, text.length, scrollX, scrollY)));
            } else {
                var replacementNode = node.splitText(text.length);
                textBounds.push(new TextBounds(text, getWrapperBounds(node, scrollX, scrollY)));
                node = replacementNode;
            }
        } else if (!_Feature2.default.SUPPORT_RANGE_BOUNDS) {
            node = node.splitText(text.length);
        }
        offset += text.length;
    }
    return textBounds;
};

var getWrapperBounds = function getWrapperBounds(node, scrollX, scrollY) {
    var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
    wrapper.appendChild(node.cloneNode(true));
    var parentNode = node.parentNode;
    if (parentNode) {
        parentNode.replaceChild(wrapper, node);
        var bounds = (0, _Bounds.parseBounds)(wrapper, scrollX, scrollY);
        if (wrapper.firstChild) {
            parentNode.replaceChild(wrapper.firstChild, wrapper);
        }
        return bounds;
    }
    return new _Bounds.Bounds(0, 0, 0, 0);
};

var getRangeBounds = function getRangeBounds(node, offset, length, scrollX, scrollY) {
    var range = node.ownerDocument.createRange();
    range.setStart(node, offset);
    range.setEnd(node, offset + length);
    return _Bounds.Bounds.fromClientRect(range.getBoundingClientRect(), scrollX, scrollY);
};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ForeignObjectRenderer = function () {
    function ForeignObjectRenderer(element) {
        _classCallCheck(this, ForeignObjectRenderer);

        this.element = element;
    }

    _createClass(ForeignObjectRenderer, [{
        key: 'render',
        value: function render(options) {
            var _this = this;

            this.options = options;
            this.canvas = document.createElement('canvas');
            this.ctx = this.canvas.getContext('2d');
            this.canvas.width = Math.floor(options.width) * options.scale;
            this.canvas.height = Math.floor(options.height) * options.scale;
            this.canvas.style.width = options.width + 'px';
            this.canvas.style.height = options.height + 'px';

            options.logger.log('ForeignObject renderer initialized (' + options.width + 'x' + options.height + ' at ' + options.x + ',' + options.y + ') with scale ' + options.scale);
            var svg = createForeignObjectSVG(Math.max(options.windowWidth, options.width) * options.scale, Math.max(options.windowHeight, options.height) * options.scale, options.scrollX * options.scale, options.scrollY * options.scale, this.element);

            return loadSerializedSVG(svg).then(function (img) {
                if (options.backgroundColor) {
                    _this.ctx.fillStyle = options.backgroundColor.toString();
                    _this.ctx.fillRect(0, 0, options.width * options.scale, options.height * options.scale);
                }

                _this.ctx.drawImage(img, -options.x * options.scale, -options.y * options.scale);
                return _this.canvas;
            });
        }
    }]);

    return ForeignObjectRenderer;
}();

exports.default = ForeignObjectRenderer;
var createForeignObjectSVG = exports.createForeignObjectSVG = function createForeignObjectSVG(width, height, x, y, node) {
    var xmlns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(xmlns, 'svg');
    var foreignObject = document.createElementNS(xmlns, 'foreignObject');
    svg.setAttributeNS(null, 'width', width);
    svg.setAttributeNS(null, 'height', height);

    foreignObject.setAttributeNS(null, 'width', '100%');
    foreignObject.setAttributeNS(null, 'height', '100%');
    foreignObject.setAttributeNS(null, 'x', x);
    foreignObject.setAttributeNS(null, 'y', y);
    foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
    svg.appendChild(foreignObject);

    foreignObject.appendChild(node);

    return svg;
};

var loadSerializedSVG = exports.loadSerializedSVG = function loadSerializedSVG(svg) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            return resolve(img);
        };
        img.onerror = reject;

        img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(svg));
    });
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.breakWords = exports.fromCodePoint = exports.toCodePoints = undefined;

var _cssLineBreak = __webpack_require__(683);

Object.defineProperty(exports, 'toCodePoints', {
    enumerable: true,
    get: function get() {
        return _cssLineBreak.toCodePoints;
    }
});
Object.defineProperty(exports, 'fromCodePoint', {
    enumerable: true,
    get: function get() {
        return _cssLineBreak.fromCodePoint;
    }
});

var _NodeContainer = __webpack_require__(84);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _overflowWrap = __webpack_require__(324);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakWords = exports.breakWords = function breakWords(str, parent) {
    var breaker = (0, _cssLineBreak.LineBreaker)(str, {
        lineBreak: parent.style.lineBreak,
        wordBreak: parent.style.overflowWrap === _overflowWrap.OVERFLOW_WRAP.BREAK_WORD ? 'break-word' : parent.style.wordBreak
    });

    var words = [];
    var bk = void 0;

    while (!(bk = breaker.next()).done) {
        words.push(bk.value.slice());
    }

    return words;
};

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FontMetrics = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Util = __webpack_require__(85);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SAMPLE_TEXT = 'Hidden Text';

var FontMetrics = exports.FontMetrics = function () {
    function FontMetrics(document) {
        _classCallCheck(this, FontMetrics);

        this._data = {};
        this._document = document;
    }

    _createClass(FontMetrics, [{
        key: '_parseMetrics',
        value: function _parseMetrics(font) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');

            var body = this._document.body;
            if (!body) {
                throw new Error( false ? 'No document found for font metrics' : '');
            }

            container.style.visibility = 'hidden';
            container.style.fontFamily = font.fontFamily;
            container.style.fontSize = font.fontSize;
            container.style.margin = '0';
            container.style.padding = '0';

            body.appendChild(container);

            img.src = _Util.SMALL_IMAGE;
            img.width = 1;
            img.height = 1;

            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';

            span.style.fontFamily = font.fontFamily;
            span.style.fontSize = font.fontSize;
            span.style.margin = '0';
            span.style.padding = '0';

            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;

            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));

            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';

            var middle = img.offsetTop - container.offsetTop + 2;

            body.removeChild(container);

            return { baseline: baseline, middle: middle };
        }
    }, {
        key: 'getMetrics',
        value: function getMetrics(font) {
            var key = font.fontFamily + ' ' + font.fontSize;
            if (this._data[key] === undefined) {
                this._data[key] = this._parseMetrics(font);
            }

            return this._data[key];
        }
    }]);

    return FontMetrics;
}();

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Proxy = undefined;

var _Feature = __webpack_require__(142);

var _Feature2 = _interopRequireDefault(_Feature);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Proxy = exports.Proxy = function Proxy(src, options) {
    if (!options.proxy) {
        return Promise.reject( false ? 'No proxy defined' : null);
    }
    var proxy = options.proxy;

    return new Promise(function (resolve, reject) {
        var responseType = _Feature2.default.SUPPORT_CORS_XHR && _Feature2.default.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
        var xhr = _Feature2.default.SUPPORT_CORS_XHR ? new XMLHttpRequest() : new XDomainRequest();
        xhr.onload = function () {
            if (xhr instanceof XMLHttpRequest) {
                if (xhr.status === 200) {
                    if (responseType === 'text') {
                        resolve(xhr.response);
                    } else {
                        var reader = new FileReader();
                        // $FlowFixMe
                        reader.addEventListener('load', function () {
                            return resolve(reader.result);
                        }, false);
                        // $FlowFixMe
                        reader.addEventListener('error', function (e) {
                            return reject(e);
                        }, false);
                        reader.readAsDataURL(xhr.response);
                    }
                } else {
                    reject( false ? 'Failed to proxy resource ' + src.substring(0, 256) + ' with status code ' + xhr.status : '');
                }
            } else {
                resolve(xhr.responseText);
            }
        };

        xhr.onerror = reject;
        xhr.open('GET', proxy + '?url=' + encodeURIComponent(src) + '&responseType=' + responseType);

        if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
            xhr.responseType = responseType;
        }

        if (options.imageTimeout) {
            var timeout = options.imageTimeout;
            xhr.timeout = timeout;
            xhr.ontimeout = function () {
                return reject( false ? 'Timed out (' + timeout + 'ms) proxying ' + src.substring(0, 256) : '');
            };
        }

        xhr.send();
    });
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GrRackServerPresentation__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GrRackServerInnerPresentation__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BOMGRpresentation__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AppConfig__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*Added by Vinay*/var GraphicalRepresentation=function(_Component){_inherits(GraphicalRepresentation,_Component);function GraphicalRepresentation(){_classCallCheck(this,GraphicalRepresentation);var _this=_possibleConstructorReturn(this,(GraphicalRepresentation.__proto__||Object.getPrototypeOf(GraphicalRepresentation)).call(this));_this.updateLoadingValue=function(){setTimeout(function(){_this.setState({isPageLoading:false});},3000);};_this.state={GrConditionalView:true,ActiveSitedata:'',isPageLoading:true};_this.RackView=_this.RackView.bind(_this);_this.ReverttoRackview=_this.ReverttoRackview.bind(_this);_this.onBomChange=_this.onBomChange.bind(_this);return _this;}_createClass(GraphicalRepresentation,[{key:'onBomChange',value:function onBomChange(){}},{key:'componentWillMount',value:function componentWillMount(){}},{key:'RackView',value:function RackView(e,a){//   console.log(a);
this.setState({GrConditionalView:e,ActiveSitedata:a});}},{key:'ReverttoRackview',value:function ReverttoRackview(e){this.setState({GrConditionalView:e});}},{key:'render',value:function render(){var _this2=this;var BOMDisplay=void 0;/*Changes by Vinay, checking said === 'CS750VirtSizer' condition to hide GRBOM for CS750 Sizing.*/if(this.props.listItem||__WEBPACK_IMPORTED_MODULE_9__AppConfig__["f" /* said */]==='CS750VirtSizer'){BOMDisplay='';}else{if(!this.props.isFromExternalApp){BOMDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tab___default.a,{title:'BOM'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',className:'GrTabInnerSection',justify:'start',align:'center',style:{height:'100%',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BOMGRpresentation__["a" /* default */],{actvSoln:this.props.actvSoln})));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'GRPResentPage GRPageLayoutsink',direction:'row',margin:'none',pad:'small',justify:'start',style:{width:'100% !import',height:'100%',marginTop:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Tabs___default.a,{justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tab___default.a,{title:'Solution Layout'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',className:'GrTabInnerSection',justify:'start',align:'center',style:{height:'100%',width:'100%!import'}},this.state.GrConditionalView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__GrRackServerPresentation__["a" /* default */],{externalAppProps:this.props.externalAppProps,isFromExternalApp:this.props.isFromExternalApp,actvSoln:this.props.actvSoln,StaticGRlist:this.props.listItem,RackserverView1:this.RackView,isPageLoading:this.updateLoadingValue}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GrRackServerInnerPresentation__["a" /* default */],{externalAppProps:this.props.externalAppProps,isFromExternalApp:this.props.isFromExternalApp,RackserverView:this.ReverttoRackview,PassActiveSite:this.state.ActiveSitedata,actvSoln:this.props.actvSoln}))),BOMDisplay),this.props.isFromExternalApp&&!this.state.isPageLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{id:'backToSSETyes',primary:false,plain:true,style:{position:'absolute',right:'0',color:'white'}/* icon={<Revert size="small" colorIndex='accent-3' />} */,label:'Close',onClick:function onClick(){return window.location.replace(_this2.props.externalAppProps.ssetUrl);},className:'ReverseSavewrkloadbtn'}):'');}}]);return GraphicalRepresentation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GraphicalRepresentation);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _List = __webpack_require__(48);

var _List2 = _interopRequireDefault(_List);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.ACCORDION;

var Accordion = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion(props, context) {
    _classCallCheck(this, Accordion);

    var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props, context));

    _this._onPanelChange = _this._onPanelChange.bind(_this);

    var active = void 0;
    // active in state should always be an array
    if (typeof _this.props.active === 'number') {
      active = [_this.props.active];
    } else {
      active = _this.props.active || [];
    }
    _this.state = {
      active: active
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.active !== this.props.active) {
        this.setState({ active: newProps.active || [] });
      }
    }
  }, {
    key: '_onPanelChange',
    value: function _onPanelChange(index) {
      var active = [].concat(_toConsumableArray(this.state.active));
      var _props = this.props,
          onActive = _props.onActive,
          openMulti = _props.openMulti;


      var activeIndex = active.indexOf(index);
      if (activeIndex > -1) {
        active.splice(activeIndex, 1);
      } else {
        if (openMulti) {
          active.push(index);
        } else {
          active = [index];
        }
      }
      this.setState({ active: active }, function () {
        if (onActive) {
          if (!openMulti) {
            onActive(active[0]);
          } else {
            onActive(active);
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          animate = _props2.animate,
          className = _props2.className,
          children = _props2.children;


      var classes = (0, _classnames2.default)(CLASS_ROOT, className);

      var accordionChildren = _react2.default.Children.map(children, function (child, index) {
        if (!child) return null;

        return _react2.default.cloneElement(child, {
          active: _this2.state.active.indexOf(index) > -1,
          onChange: function onChange() {
            _this2._onPanelChange(index);
          },
          animate: animate
        });
      });

      var restProps = _Props2.default.omit(this.props, Object.keys(Accordion.propTypes));
      return _react2.default.createElement(
        _List2.default,
        _extends({ role: 'tablist', className: classes }, restProps),
        accordionChildren
      );
    }
  }]);

  return Accordion;
}(_react.Component);

Accordion.displayName = 'Accordion';
exports.default = Accordion;


Accordion.propTypes = {
  active: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  animate: _propTypes2.default.bool,
  onActive: _propTypes2.default.func,
  openMulti: _propTypes2.default.bool
};

Accordion.defaultProps = {
  openMulti: false,
  animate: true
};
module.exports = exports['default'];

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Header = __webpack_require__(276);

var _Header2 = _interopRequireDefault(_Header);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _ListItem = __webpack_require__(49);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _CaretNext = __webpack_require__(306);

var _CaretNext2 = _interopRequireDefault(_CaretNext);

var _Collapsible = __webpack_require__(698);

var _Collapsible2 = _interopRequireDefault(_Collapsible);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.ACCORDION_PANEL;

var AccordionPanel = function (_Component) {
  _inherits(AccordionPanel, _Component);

  function AccordionPanel() {
    _classCallCheck(this, AccordionPanel);

    var _this = _possibleConstructorReturn(this, (AccordionPanel.__proto__ || Object.getPrototypeOf(AccordionPanel)).call(this));

    _this._onClickTab = _this._onClickTab.bind(_this);
    return _this;
  }

  _createClass(AccordionPanel, [{
    key: '_onClickTab',
    value: function _onClickTab(event) {
      var onChange = this.props.onChange;

      if (event) {
        event.preventDefault();
      }
      onChange();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          active = _props.active,
          animate = _props.animate,
          className = _props.className,
          children = _props.children,
          heading = _props.heading,
          pad = _props.pad;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, className, _defineProperty({}, CLASS_ROOT + '--active', active));

      var tabContentTitle = _Intl2.default.getMessage(intl, 'Tab Contents', {
        activeTitle: a11yTitle || heading
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _ListItem2.default,
          { className: classes, direction: 'column', pad: 'none',
            'aria-expanded': active, 'aria-selected': active, role: 'tab',
            'aria-label': a11yTitle || heading },
          _react2.default.createElement(
            _Button2.default,
            { fill: true, plain: true, onClick: this._onClickTab },
            _react2.default.createElement(
              _Header2.default,
              { pad: pad, direction: 'row',
                justify: 'between', align: 'center', responsive: false,
                className: CLASS_ROOT + '__header' },
              heading,
              _react2.default.createElement(_CaretNext2.default, {
                className: CLASS_ROOT + '__control' })
            )
          )
        ),
        _react2.default.createElement(
          _Collapsible2.default,
          { 'aria-label': tabContentTitle, role: 'tabpanel',
            active: active, animate: animate, pad: pad },
          children
        )
      );
    }
  }]);

  return AccordionPanel;
}(_react.Component);

AccordionPanel.displayName = 'AccordionPanel';
exports.default = AccordionPanel;


AccordionPanel.propTypes = {
  a11yTitle: _propTypes2.default.string,
  active: _propTypes2.default.bool, // set by Accordion
  animate: _propTypes2.default.bool,
  heading: _propTypes2.default.node.isRequired,
  onChange: _propTypes2.default.func,
  pad: _Header2.default.propTypes.pad
};

AccordionPanel.contextTypes = {
  intl: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-print', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'print');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,19 L1,19 L1,7 L23,7 L23,19 L18,19 M3,16 L21,16 M6,16 L6,23 L6,23 L18,23 L18,16 M18,7 L18,1 L6,1 L6,7 L6,7 M17,12 L19,12 L19,11 L17,11 L17,12 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Print';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__State_constants_CommonConstants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import TableHeader from 'grommet/components/TableHeader';
var getSSETData=false;//import Metricsdata from '../../Datafiles/Metricsdata_Latest1'
var list=[];var tempMetricsData=void 0;var MetricsData=function(_Component){_inherits(MetricsData,_Component);function MetricsData(props){_classCallCheck(this,MetricsData);var _this=_possibleConstructorReturn(this,(MetricsData.__proto__||Object.getPrototypeOf(MetricsData)).call(this,props));_this.state={ActvSolution:'',ActvSolutionObj:'',SolutionsList:[],showCompareSoln:false,TCOSelection:'',dataManipulation:{Performance:[true,true,true,true,true],Capacity:[true,true,true,true,true],Density:[true,true,true,true],Cost:[true,true,true,true],Power:[true],CapacityDefaults:{ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},DensityDefaults:{ComputePerf:null,StorageThroughput:null,ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},CostDefaults:{CPUPerf:null,RawStoragecapacity:null,ReplicationStoragecapacity:null,ErasureStoragecapacity:null},PowerDefaults:{CPUPerf:null},FunctionType:'',TagType:'',Servicelayer:false},dataManipulationExtra:{Performance:[true,true,true,true,true],Capacity:[true,true,true,true,true],Density:[true,true,true,true],Cost:[true,true,true,true],Power:[true],CapacityDefaults:{ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},DensityDefaults:{ComputePerf:null,StorageThroughput:null,ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},CostDefaults:{CPUPerf:null,RawStoragecapacity:null,ReplicationStoragecapacity:null,ErasureStoragecapacity:null},PowerDefaults:{CPUPerf:null}}};_this.onActvSolutionChange=_this.onActvSolutionChange.bind(_this);_this.onExport=_this.onExport.bind(_this);_this.onTCOChange=_this.onTCOChange.bind(_this);_this.manipulateData=_this.manipulateData.bind(_this);_this.manipulateDataExtra=_this.manipulateDataExtra.bind(_this);_this.Serviceleveldata=_this.Serviceleveldata.bind(_this);_this.ServiceDataClose=_this.ServiceDataClose.bind(_this);return _this;}// componentWillMount(){
// }
// componentWillReceiveProps(nextProps){
//   if(this.props.MetricsData !== nextProps.MetricsData){
//     this.state.ActvSolution = nextProps.MetricsData.Values.Value[0]['@Header'];
//     this.state.ActvSolutionObj = nextProps.MetricsData.Values.Value[0];
//     console.log(nextProps.CompareMetricsData);
//     nextProps.MetricsData.Values.Value.map( (item, index) => {      
//       if(item['TotalCost']['#text'] !== '' && item['TotalCost']['#text'] !== undefined ){
//         list.push(item['@Header']);
//       }      
//     });
//     if(nextProps.MetricsData.Values.Value.length > 1){
//       list.push('Compare Metrics Data');
//     }        
//     this.setState ({SolutionsList: list });
//   }
// }
_createClass(MetricsData,[{key:'manipulateData',value:function manipulateData(index,component,metrics){var _this2=this;var data=this.state.dataManipulation;var actvSol=this.state.ActvSolutionObj;var value;switch(component){case'Performance':data.Performance[index]=!data.Performance[index];actvSol['Performance']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Performance':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dStorageSpecINT):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dStorageSpecINT);item['#text']=value;break;case'Storage Throughput':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeThroughPut):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeThroughPut);item['#text']=value;break;case'Storage Read IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeReadIOPS):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeReadIOPS);item['#text']=value;break;case'Storage Write IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeWriteIOPS):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeWriteIOPS);item['#text']=value;break;}}});break;case'Capacity':data.Capacity[index]=!data.Capacity[index];actvSol['Capacity']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Cores':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.iStorageCores):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.iStorageCores);item['#text']=value;break;case'Memory':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.iStorageMemory):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.iStorageMemory);item['#text']=value;break;case'Raw Disk Capacity':if(data.Capacity[index]){value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2));}else{value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2));}item['#text']=value;break;case'Replication Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.ReplicationDiskCapacity):value=parseFloat((_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dReplication*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.ReplicationDiskCapacity===null){data.CapacityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.Erasure6DiskCapacity):value=parseFloat((_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/1.5*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.Erasure6DiskCapacity===null){data.CapacityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Density Metrics':data.Density[index]=!data.Density[index];actvSol['DensityMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Compute Perf':data.Density[index]?value=parseFloat(data.DensityDefaults.ComputePerf):value=(parseFloat(_this2.props.MetricsData.manipulationData.dComputeSpecINT)/parseFloat(_this2.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);if(data.DensityDefaults.ComputePerf===null){data.DensityDefaults.ComputePerf=item['#text'];}item['#text']=value;break;case'Raw Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.StorageThroughput):value=(parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity).toFixed(2)/parseFloat(_this2.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);if(data.DensityDefaults.StorageThroughput===null){data.DensityDefaults.StorageThroughput=item['#text'];}item['#text']=value;break;case'Replication Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.ReplicationDiskCapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dReplication*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.iTotalRackHeight).toFixed(2);if(data.DensityDefaults.ReplicationDiskCapacity===null){data.DensityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.Erasure6DiskCapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/1.5*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.iTotalRackHeight).toFixed(2);if(data.DensityDefaults.Erasure6DiskCapacity===null){data.DensityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Cost Metrics':data.Cost[index]=!data.Cost[index];actvSol['CostMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.CPUPerf):value=parseFloat(_this2.props.MetricsData.manipulationData.dComputeSpecINT/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.CPUPerf===null){data.CostDefaults.CPUPerf=item['#text'];}item['#text']=value;break;case'Raw Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.RawStoragecapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.RawStoragecapacity===null){data.CostDefaults.RawStoragecapacity=item['#text'];}item['#text']=value;break;case'Replication Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ReplicationStoragecapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dReplication*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.ReplicationStoragecapacity===null){data.CostDefaults.ReplicationStoragecapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ErasureStoragecapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/1.5*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.ErasureStoragecapacity===null){data.CostDefaults.ErasureStoragecapacity=item['#text'];}item['#text']=value;break;}}});break;case'Power Metrics':data.Power[index]=!data.Power[index];actvSol['PowerMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Watt':data.Power[index]?value=parseFloat(data.PowerDefaults.CPUPerf):value=parseFloat(_this2.props.MetricsData.manipulationData.dComputeSpecINT/_this2.props.MetricsData.manipulationData.dTotalPower*1000).toFixed(2);if(data.PowerDefaults.CPUPerf===null){data.PowerDefaults.CPUPerf=item['#text'];}item['#text']=value;break;}}});}this.setState({dataManipulation:data,ActvSolutionObj:actvSol});}},{key:'manipulateDataExtra',value:function manipulateDataExtra(index,component,metrics){var _this3=this;var data=this.state.dataManipulationExtra;var actvSol=this.state.ActvSolutionObj;var value;switch(component){case'Performance':data.Performance[index]=!data.Performance[index];actvSol['Performance']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Performance':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT);item['#text']=value;break;case'Storage Throughput':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeThroughPut):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeThroughPut);item['#text']=value;break;case'Storage Read IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeReadIOPS):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeReadIOPS);item['#text']=value;break;case'Storage Write IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeWriteIOPS):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeWriteIOPS);item['#text']=value;break;}}});break;case'Capacity':data.Capacity[index]=!data.Capacity[index];actvSol['Capacity']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Cores':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageCores):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageCores);item['#text']=value;break;case'Memory':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageMemory):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageMemory);item['#text']=value;break;case'Raw Disk Capacity':if(data.Capacity[index]){value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2));}else{value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2));}item['#text']=value;break;case'Replication Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.ReplicationDiskCapacity):value=parseFloat((_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dReplication*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.ReplicationDiskCapacity===null){data.CapacityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.Erasure6DiskCapacity):value=parseFloat((_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/1.5*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.Erasure6DiskCapacity===null){data.CapacityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Density Metrics':data.Density[index]=!data.Density[index];actvSol['DensityMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Compute Perf':data.Density[index]?value=parseFloat(data.DensityDefaults.ComputePerf):value=(parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeSpecINT-_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT)/parseFloat(_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);if(data.DensityDefaults.ComputePerf===null){data.DensityDefaults.ComputePerf=item['#text'];}item['#text']=value;break;case'Raw Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.StorageThroughput):value=(parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity).toFixed(2)/parseFloat(_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);if(data.DensityDefaults.StorageThroughput===null){data.DensityDefaults.StorageThroughput=item['#text'];}item['#text']=value;break;case'Replication Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.ReplicationDiskCapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dReplication*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight).toFixed(2);if(data.DensityDefaults.ReplicationDiskCapacity===null){data.DensityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.Erasure6DiskCapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/1.5*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight).toFixed(2);if(data.DensityDefaults.Erasure6DiskCapacity===null){data.DensityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Cost Metrics':data.Cost[index]=!data.Cost[index];actvSol['CostMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.CPUPerf):value=parseFloat((_this3.props.MetricsData.manipulationData.dExtraComputeSpecINT-_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT)/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.CPUPerf===null){data.CostDefaults.CPUPerf=item['#text'];}item['#text']=value;break;case'Raw Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.RawStoragecapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.RawStoragecapacity===null){data.CostDefaults.RawStoragecapacity=item['#text'];}item['#text']=value;break;case'Replication Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ReplicationStoragecapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dReplication*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.ReplicationStoragecapacity===null){data.CostDefaults.ReplicationStoragecapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ErasureStoragecapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/1.5*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.ErasureStoragecapacity===null){data.CostDefaults.ErasureStoragecapacity=item['#text'];}item['#text']=value;break;}}});break;case'Power Metrics':data.Power[index]=!data.Power[index];actvSol['PowerMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Watt':data.Power[index]?value=parseFloat(data.PowerDefaults.CPUPerf):value=Math.round(parseFloat((_this3.props.MetricsData.manipulationData.dExtraComputeSpecINT-_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT)/_this3.props.MetricsData.manipulationData.dTotalExtraPower*1000));if(data.PowerDefaults.CPUPerf===null){data.PowerDefaults.CPUPerf=item['#text'];}item['#text']=value;break;}}});}this.setState({dataManipulation:data,ActvSolutionObj:actvSol});}},{key:'componentWillMount',value:function componentWillMount(){//this.props.onFetchMetricsData({ 'SessionID': this.props.activeSession.id });
// this.props.onFetchCompareMetricsData({ 'SessionID': this.props.activeSession.id });
}},{key:'componentDidMount',value:function componentDidMount(){//   this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
if(!this.props.activeSession||this.props.activeSession.MetricsData==''){if(this.props.externalAppProps&&this.props.isFromExternalApp){getSSETData=true;var queryParameter=__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(window.location.search);var sessionObject={"SessionID":queryParameter.sizerReference};this.props.onFetchMetricsData(sessionObject);}}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){list=[];if(!this.props.FactoryExpressdata.workload.UserInputs){if(this.props.isFromExternalApp){var queryParameter=__WEBPACK_IMPORTED_MODULE_2_query_string___default.a.parse(window.location.search);var userData={"reference":queryParameter.reference,"isSizerAsEntry":queryParameter.isSizerAsEntry?true:false};if(nextProps.sessionDefaults&&nextProps.sessionDefaults.workload&&getSSETData){getSSETData=false;if(this.props.activeSession.MetricsData!==''){tempMetricsData=this.props.activeSession.MetricsData;}this.props.getSSETData(userData);}}if(nextProps.activeSession&&nextProps.activeSession.workload){var obj=nextProps.activeSession.workload;this.props.onNewSession(obj);}}if(this.props.MetricsData!==nextProps.MetricsData&&nextProps.MetricsData.output){// this.state.ActvSolution = nextProps.MetricsData.output.Values.Value[0]['@Header'];
// this.state.ActvSolutionObj = nextProps.MetricsData.output.Values.Value[0];
this.state.ActvSolution=nextProps.MetricsData.output.Values.Value['@Header'];this.state.ActvSolutionObj=nextProps.MetricsData.output.Values.Value;console.log(this.props.CompareMetricsData);if(Array.isArray(nextProps.MetricsData.output.Values.Value)){nextProps.MetricsData.output.Values.Value.map(function(item,index){if(item['TotalCost']['#text']!==''&&item['TotalCost']['#text']!==undefined&&item['@Header']!=='Traditional'){list.push(item['@Header']);}});}else{list.push(nextProps.MetricsData.output.Values.Value['@Header']);}// this.state.ActvSolution = nextProps.MetricsData.output.Values.Value[0]['@Header'];
// this.state.ActvSolutionObj = nextProps.MetricsData.output.Values.Value[0];
// if(nextProps.MetricsData.output.Values.Value.length > 1){
//   list.push('Compare Metrics Data');
// }
//  if(nextProps.activeSession.EPAArray.length >0){
//     list.push('Compare Metrics Data');
//   }
//   if (this.props.CompareMetricsData !== nextProps.CompareMetricsData ) {
//      this.props.onFetchCompareMetricsData({ 'SessionID': this.props.activeSession.id });
// }
this.setState({SolutionsList:list});}}},{key:'onActvSolutionChange',value:function onActvSolutionChange(e){// if (e.value === 'Compare Metrics Data') {
//   if (this.props.CompareMetricsData === '') {
//     this.props.onFetchCompareMetricsData({ 'SessionID': this.props.activeSession.id });
//   }
//   this.setState({ ActvSolution: e.value, showCompareSoln: true });
// } else {
//   this.props.MetricsData.output.Values.Value.map((item, index) => {
//     if (item['@Header'] === e.value) {
//       this.state.ActvSolutionObj = item;
//     }
//   });
//   this.setState({ ActvSolution: e.value, showCompareSoln: false });
// }
}},{key:'onExport',value:function onExport(){var _this4=this;var data;if(this.state.ActvSolution==='Compare Metrics Data'){var obj={root:{element:JSON.parse(JSON.stringify(this.props.CompareMetricsData)),additionalInfo:{isCompareSolution:true}}// var root = {
//   root :obj
// }
};data={"Data":obj};}else{var filter;if(tempMetricsData!==undefined){filter=JSON.parse(JSON.stringify(tempMetricsData.output));}else{filter=JSON.parse(JSON.stringify(this.props.MetricsData.output));}//filter = JSON.parse(JSON.stringify(this.props.MetricsData.output));
var temp;var content;if(Array.isArray(filter.Values.Value)){filter.Values.Value.forEach(function(item){if(item['@Header']===_this4.state.ActvSolution){temp=item;}});if(temp!==undefined){filter.Values.Value=[];filter.Values.Value.push(temp);}content={root:{filter:filter,additionalInfo:{FactoryExpress:this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress,isCompareSolution:false}}};}else{content={root:{filter:filter,additionalInfo:{FactoryExpress:this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress,isCompareSolution:false}}};}data={"Data":content};}this.props.onExportMetricsData(data);}},{key:'onTCOChange',value:function onTCOChange(e){var val='';this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map(function(item,index){if(item['@Text']===e.value)val=item['#text'];});this.setState({TCOValue:val,TCOSelection:e.value});}},{key:'ServiceDataClose',value:function ServiceDataClose(e){this.setState({Servicelayer:false});}},{key:'Serviceleveldata',value:function Serviceleveldata(e,FunctionService,Type){this.setState({Servicelayer:true,FunctionType:FunctionService,TagType:Type});}},{key:'render',value:function render(){var _this5=this;var MainData='';var tblRowStyle={border:'1px solid #ccc'};var tblRowBoldStyle={border:'1px solid #ccc',fontWeight:'bold'};var tbltdStyle={padding:'5px',textAlign:'left',width:'10px !important'};var tbltdStyle_btn={padding:'0px',textAlign:'left',borderColor:'white'};var btnStyle={padding:'0px',textAlign:'left',background:'rgb(255, 141, 109)',border:'1px solid',color:'white',marginLeft:'5px'};var tbltdBoldStyle={padding:'5px',textAlign:'left',width:'80px !important',fontWeight:'bold'};var totalcostItems='';var mainTotalCost='';var TCOList=[];var TCOItems='';var FactoryExpress='';var FactoryExpressPerc='';var perfItems=[];var performancedata=[];var TotalCostMetricsdata=[];var TotalCostMetricsItems=[];var capacitydata=[];var densitydata=[];var costdata=[];var powerdata=[];var capacityItems=[];var densityItems=[];var costItems=[];var powerItems=[];var rackItems=[];var performancedatafunctions=[];var perfItemsfunction=[];var ServiceName='';// Compare Metrics Variables
var compareMetricsItems='';var LoadingLayer='';if(this.props.isLoading&&this.props.LoadingMsg!==''){// LoadingLayer = <Layer className='Metricsdatalayer' style={{ zIndex: '500 !important' }}>
//   <Box direction='row' style={{ padding: '40px' }} size='medium' pad={{ 'between': 'small' }}>
//     <Spinning size='small' />
//     <Heading tag='h5' margin='none'>{this.props.LoadingMsg}</Heading>
//   </Box>
// </Layer>
MainData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'},style:{alignSelf:'center',marginTop:'16%',fontWeight:'600'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning___default.a,{size:'small',style:{marginRight:'3px'}}),this.props.LoadingMsg);}if(this.state.ActvSolutionObj!==''&&this.props.FactoryExpressdata.workload.UserInputs){totalcostItems=this.state.ActvSolutionObj['TotalCostMetrics']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{key:index,style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});mainTotalCost=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCost']['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCost']['#text']));if(this.state.TCOSelection===''){this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map(function(item,index){TCOList.push(item['@Text']);});this.state.TCOSelection=TCOList[0];this.state.TCOValue=this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'][0]['#text'];}else{this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map(function(item,index){TCOList.push(item['@Text']);});}if(this.props.FactoryExpressdata.workload.UserInputs){var FEOptCost='';var FEOptPerc='';this.state.ActvSolutionObj['ComboOptions']['FEOptionsCost']['Item'].filter(function(item,index){if(item['@Text']===_this5.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress){FEOptCost=item['#text'];}});this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['Item'].filter(function(item,index){if(item['@Text']===_this5.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress){FEOptPerc=item['#text'];}});FactoryExpress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},FEOptCost));FactoryExpressPerc=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.props.FactoryExpressdata.workload.UserInputs.Environments.Licenses.FactoryExpress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},FEOptPerc));}TCOItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{options:TCOList,onChange:this.onTCOChange,value:this.state.TCOSelection}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.TCOValue));if(this.props.CompareMetricsData!==''&&!this.props.isLoading){compareMetricsItems=this.props.CompareMetricsData.map(function(metItem,index){if(metItem['Unit']===null&&metItem['Metrics']!==' '||metItem['Unit']===" "&&metItem['Metrics']!==' '){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{key:index,style:tblRowBoldStyle,rowSpan:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:tbltdBoldStyle},metItem['Metrics']));}else if(metItem['Metrics']!==' '&&metItem['Unit']!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{key:index,style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['Metrics']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['WDO_Config']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['Traditional_Nodes']));}});}var metricsHeading=__WEBPACK_IMPORTED_MODULE_4__State_constants_CommonConstants__["d" /* EPA_METRICS_HEADER */];if(this.props.FactoryExpressdata.workload.UserInputs&&this.props.FactoryExpressdata.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_4__State_constants_CommonConstants__["a" /* BLUE_DATA */]){metricsHeading=__WEBPACK_IMPORTED_MODULE_4__State_constants_CommonConstants__["e" /* EZMERALCP_METRICS_HEADER */];}switch(this.state.ActvSolutionObj['@Header']){case metricsHeading:{var butn="";var functionName='';this.state.ActvSolutionObj['TotalCostMetrics']['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{onClick:function onClick(e){_this5.Serviceleveldata(e,item['@Name'],'TotalCostMetrics');},style:{textDecoration:'underline',marginLeft:'5px'}},'(View service level data)'));if(service['@Type']==="Total"&&(service['@TotalCost']!=="0"||service.Item[0]['#text']!=="0")){TotalCostMetricsItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});TotalCostMetricsdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),TotalCostMetricsItems));}});}else{functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']));if(item.Service['@Type']==="Total"&&(item.Service['@TotalCost']!=="0"||item.Service.Item[0]['#text']!=="0")){TotalCostMetricsItems=item.Service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});TotalCostMetricsdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),TotalCostMetricsItems));}}});this.state.ActvSolutionObj['Performance']['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{onClick:function onClick(e){_this5.Serviceleveldata(e,item['@Name'],'Performance');},style:{textDecoration:'underline',marginLeft:'5px'}},'(View service level data)'));if(service['@Type']==="Total"&&service['@TotalCost']!=="0"){if(service.Item[0]['#text']!=="0"){perfItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});performancedata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),perfItems));}}});}else{functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']));if(item.Service['@Type']==="Total"&&item.Service['@TotalCost']!=="0"){if(item.Service.Item[0]['#text']!=="0"){perfItems=item.Service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});performancedata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),perfItems));}}}});this.state.ActvSolutionObj['Capacity']['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{onClick:function onClick(e){_this5.Serviceleveldata(e,item['@Name'],'Capacity');},style:{textDecoration:'underline',marginLeft:'5px'}},'(View service level data)'));if(service['@Type']==="Total"&&service['@TotalCost']!=="0"){if(service.Item[0]['#text']!=="0"){capacityItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});capacitydata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),capacityItems));}}});}else{functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']));if(item.Service['@Type']==="Total"&&item.Service['@TotalCost']!=="0"){if(item.Service.Item[0]['#text']!=="0"){capacityItems=item.Service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});capacitydata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),capacityItems));}}}});this.state.ActvSolutionObj['DensityMetrics']['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{onClick:function onClick(e){_this5.Serviceleveldata(e,item['@Name'],'DensityMetrics');},style:{textDecoration:'underline',marginLeft:'5px'}},'(View service level data)'));if(service['@Type']==="Total"&&service['@TotalCost']!=="0"){if(service.Item[0]['#text']!=="0"){densityItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});densitydata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),densityItems));}}});}else{functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']));if(item.Service['@Type']==="Total"&&item.Service['@TotalCost']!=="0"){if(item.Service.Item[0]['#text']!=="0"){densityItems=item.Service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});densitydata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),densityItems));}}}});this.state.ActvSolutionObj['CostMetrics']['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{onClick:function onClick(e){_this5.Serviceleveldata(e,item['@Name'],'CostMetrics');},style:{textDecoration:'underline',marginLeft:'5px'}},'(View service level data)'));if(service['@Type']==="Total"&&(service['@TotalCost']!=="0"||service.Item[0]['#text']!=="0")){if(service.Item[0]['#text']!=="0"){costItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});costdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),costItems));}}});}else{functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']));if(item.Service['@Type']==="Total"&&item.Service['@TotalCost']!=="0"){if(item.Service.Item[0]['#text']!=="0"){costItems=item.Service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});costdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),costItems));}}}});this.state.ActvSolutionObj['PowerMetrics']['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{onClick:function onClick(e){_this5.Serviceleveldata(e,item['@Name'],'PowerMetrics');},style:{textDecoration:'underline',marginLeft:'5px'}},'(View service level data)'));if(service['@Type']==="Total"&&service['@TotalCost']!=="0"){if(service.Item[0]['#text']!=="0"){powerItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']),butn);});powerdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),powerItems));}}});}else{functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,item['@Name']));if(item.Service['@Type']==="Total"&&item.Service['@TotalCost']!=="0"){if(item.Service.Item[0]['#text']!=="0"){powerItems=item.Service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']),butn);});powerdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,functionName),powerItems));}}}});rackItems=this.state.ActvSolutionObj['RackSpace']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});break;}case'Extra Nodes':{var _butn="";perfItems=this.state.ActvSolutionObj['Performance']['Item'].map(function(item,index){var text='';_this5.state.dataManipulationExtra.Performance[index]?text='Remove':text='Add';item['@Text'].indexOf('Performance')>0?text+=' Custom':text+=' Edge';// butn = this.props.MetricsData.manipulationData="" ? "":<td style={tbltdStyle_btn} ><Button plain={true} style={btnStyle} label={text} onClick={()=>{this.manipulateDataExtra(index,'Performance',item['@Text'])}}/></td>  
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this5.props.MetricsData.manipulationData===""?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default.a,{plain:true,style:btnStyle,label:text,onClick:function onClick(){_this5.manipulateDataExtra(index,'Performance',item['@Text']);}})));});capacityItems=this.state.ActvSolutionObj['Capacity']['Item'].map(function(item,index){var text='';_this5.state.dataManipulationExtra.Capacity[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Edge':text+=' Custom';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this5.props.MetricsData.manipulationData===""?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default.a,{plain:true,style:btnStyle,label:text,onClick:function onClick(){_this5.manipulateDataExtra(index,'Capacity',item['@Text']);}})));});densityItems=this.state.ActvSolutionObj['DensityMetrics']['Item'].map(function(item,index){var text='';_this5.state.dataManipulationExtra.Density[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Edge':text+=' Custom';_butn=_this5.props.MetricsData.manipulationData===""?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this5.manipulateDataExtra(index,'Density Metrics',item['@Text']);}}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this5.state.dataManipulationExtra.Density[index]!==undefined?_butn:'');});costItems=this.state.ActvSolutionObj['CostMetrics']['Item'].map(function(item,index){var text='';_this5.state.dataManipulationExtra.Cost[index]?text='Remove':text='Add';item['@Text'].indexOf('capacity')>0?text+=' Edge':text+=' Custom';_butn=_this5.props.MetricsData.manipulationData===""?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this5.manipulateDataExtra(index,'Cost Metrics',item['@Text']);}}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this5.state.dataManipulationExtra.Cost[index]!==undefined?_butn:'');});powerItems=this.state.ActvSolutionObj['PowerMetrics']['Item'].map(function(item,index){var text='';_this5.state.dataManipulationExtra.Power[index]?text='Remove':text='Add';text+=' Custom';_butn=_this5.props.MetricsData.manipulationData===""?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this5.manipulateDataExtra(index,'Power Metrics',item['@Text']);}}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this5.state.dataManipulationExtra.Power[index]!==undefined?_butn:'');});break;}case'Traditional':{var _functionName='';if(Array.isArray(this.state.ActvSolutionObj['TotalCostMetrics']['Function']['Service'])){this.state.ActvSolutionObj['TotalCostMetrics']['Function']['Service'].map(function(service,index){_functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,service['@Type']));if(service['@Type']!=="Total"){TotalCostMetricsItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});TotalCostMetricsdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,_functionName),TotalCostMetricsItems));}});}if(Array.isArray(this.state.ActvSolutionObj['Performance']['Function']['Service'])){this.state.ActvSolutionObj['Performance']['Function']['Service'].map(function(service,index){_functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,service['@Type']));if(service['@Type']!=="Total"){perfItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});performancedata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,_functionName),perfItems));}});}if(Array.isArray(this.state.ActvSolutionObj['Capacity']['Function']['Service'])){this.state.ActvSolutionObj['Capacity']['Function']['Service'].map(function(service,index){_functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,service['@Type']));if(service['@Type']!=="Total"){capacityItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});capacitydata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,_functionName),capacityItems));}});}if(Array.isArray(this.state.ActvSolutionObj['DensityMetrics']['Function']['Service'])){this.state.ActvSolutionObj['DensityMetrics']['Function']['Service'].map(function(service,index){_functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,service['@Type']));if(service['@Type']!=="Total"){densityItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});densitydata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,_functionName),densityItems));}});}if(Array.isArray(this.state.ActvSolutionObj['CostMetrics']['Function']['Service'])){this.state.ActvSolutionObj['CostMetrics']['Function']['Service'].map(function(service,index){_functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,service['@Type']));if(service['@Type']!=="Total"){costItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});costdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,_functionName),costItems));}});}if(Array.isArray(this.state.ActvSolutionObj['PowerMetrics']['Function']['Service'])){this.state.ActvSolutionObj['PowerMetrics']['Function']['Service'].map(function(service,index){_functionName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,service['@Type']));if(service['@Type']!=="Total"){powerItems=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});powerdata.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,_functionName),powerItems));}});}rackItems=this.state.ActvSolutionObj['RackSpace']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});break;}default:break;}if(!this.state.showCompareSoln){MainData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Tabs___default.a,{justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Total Cost Metrics',style:{height:'100%',overFlow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{width:'100% !important',overflowX:'hidden',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{scrollable:true,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'35%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),TotalCostMetricsdata,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,totalcostItems,mainTotalCost,FactoryExpress,FactoryExpressPerc,TCOItems)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Performance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{width:'100% !important',overflowX:'hidden',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{scrollable:true,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),performancedata))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Capacity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{width:'100% !important',overflowX:'hidden',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{scrollable:true,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),capacitydata))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Density Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{width:'100% !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{scrollable:true,style:{height:'500px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),densitydata))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Cost Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{width:'100% !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{scrollable:true,style:{height:'500px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),costdata))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Power Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{width:'100% !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{scrollable:true,style:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),powerdata))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Tab___default.a,{title:'Rack Space'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable_Button',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'100%',width:'100%!import'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,rackItems)))));}else{if(this.props.CompareMetricsData!==''&&!this.props.isLoading){MainData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{separator:'bottom',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'600px',width:'50% !important',overflowX:'hidden',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,{className:'marginClassforIe',scrollable:true,style:{marginTop:'119px',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Elastic Config'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Traditional Nodes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,compareMetricsItems)));}}var Data="";if(this.state.Servicelayer){var tag='';tag=this.state.TagType;this.state.ActvSolutionObj[tag]['Function'].map(function(item,index){if(Array.isArray(item.Service)){item.Service.map(function(service){if(item['@Name']===_this5.state.FunctionType&&parseInt(item['TotalCost'],10)!==0&&item['TotalCost']!==''){if(service['@Type']!=="Total"&&service['@isSelected']!=='false'){ServiceName=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',pad:'none',margin:'none',style:{fontWeight:'600',margin:'5px 5px'}},service['@Type']);perfItemsfunction=service.Item.map(function(text){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},text['#text']));});performancedatafunctions.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,null,ServiceName),perfItemsfunction));}}});}else{}});Data=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,{className:'MetricsDataServicePage',onClose:this.ServiceDataClose,closer:true,flush:false,style:{width:'85% !imporatnt',zIndex:'10001 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{className:'TabInnerSection MetricsTable',margin:'none',pad:{'between':'small'},justify:'center',align:'center',style:{height:'100%',width:'100%! important',marginTop:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{style:{width:'100%',alignItems:'center'}},tag+"-"+this.state.FunctionType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{style:{overflowY:'auto',width:'100%',padding:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'))),performancedatafunctions))));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{width:'100% !important',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h5',margin:'small',strong:false},'Solutions : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{onChange:this.onActvSolutionChange.bind(this),options:this.state.SolutionsList,style:{maxWidth:'225px'},value:this.state.ActvSolution}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Button___default.a,{label:'Export to Excel',primary:true,onClick:this.onExport,style:{height:'40px',marginTop:'3px'}}),this.state.ActvSolution==='Compare Metrics Data'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{style:{margin:'12px 0px 0px 100px',color:'red'}},'Note: Extra node values are included in Elastic config value.'):''),LoadingLayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{width:'100% !important',height:'93%',overflowY:'auto'}},MainData),Data);}}]);return MetricsData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isLoading:state.sessions.isLoadingCompare,LoadingMsg:state.sessions.LoadingMsgCompare,activeSession:state.sessions.activeSession,MetricsData:state.sessions.activeSession.MetricsData,CompareMetricsData:state.sessions.activeSession.CompareMetricsData,FactoryExpressdata:state.sizerWorkload,sessionDefaults:state.sessions.sessionDefaults};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchMetricsData:function onFetchMetricsData(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["A" /* fetchMetricsData */])(obj));},onFetchCompareMetricsData:function onFetchCompareMetricsData(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["t" /* fetchCompareMetricsData */])(obj));},onExportMetricsData:function onExportMetricsData(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["n" /* downloadMetricsData */])(data));},getSSETData:function getSSETData(userData){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["I" /* loadSessionfromSSET */])(userData));},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MetricsData));

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Animate__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var INFERENCE_="Inference";var TRAINING='Training';var STORAGE_="Storage";var TRUE="true";var NONE_="None";var KUBERNETES_="Kubernetes";var EPIC_="EPIC";var HPE_CP="HPE Runtime Enterprise";var HPE_CP_EPIC_SOFTWARE="HPE Ezmeral Runtime Enterprise EPIC Software";var HPE_CP_ML_SOFTWARE="HPE Ezmeral ML Ops Software";var KUBERNETES_CM="Kubernetes CM";var CONTROLLER_HOSTS="Controller Hosts";var GATEWAY_HOSTS="Gateway Hosts";var MASTER_HOST="Master Hosts";var MLOPS="MLOps";var CAAS="CaaS";var ATTRIBUTE_SOLUTIONTYPE="@SolutionType";var NODE_='Ephemeral';var IMAGE_PROCESSING="Image Processing";var MLOPS_TEMPLATES="MLOps Templates";var MLOPS_IMAGE_PROCESSING="MLOps Image Processing";var IMAGE_PROCESSING_TEMPLATE="Image Processing Template";var HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR="HPE Ezmeral RE External Kubernetes Cluster Manager";var NONGPU_="NonGPU";var EZMERAL_GROWTH_HEADINGS=['Services','Growth','Total % of Host Yr 1','Total % of Host Yr 2','Total % of Host Yr 3','Total % of Host Yr 4'];var GPU_="GPU";var GATEWAY_="Gateway";var CONTROLLER_="Controller";var MASTER_="Master";var HPE_EZMERAL_DF_XD="HPE Ezmeral Data Fabric XD";var HPE_EZMERAL_DATAFABRIC_LICENSE="HPE Ezmeral Data Fabric License";var DATAFABRIC_XD="DataFabric XD";var DATAFABRIC_FILESTORE="DataFabric File Store";var HPE_EZMERAL="HPE Ezmeral ";var FALSE="false";var SOLUTION_PREVIEW="Solution Preview";var DATA_LAKE="Data Lake";var USABLE_CAPACITY="Usable capacity ";var ATTRIBUTE_TYPE="@Type";var ATTRIBUTE_INPUTMODE="@InputMode";var ATTRIBUTE_CATEGORY="@Category";var getSSETData=false;var CS750SizerSaid=['CS750VirtSizer','SynergySizer'];var SAPSizerSaid=['SAP','SAPHANA'];var ID_SOLUTION_PREVIEW="SolutionPreview";var tabsList=[];//let tabHeadings = "";
var labelsTobeBold=['Recommended','Host Configuration','Storage Configuration'];var SolutionPreviewBigData=function(_Component){_inherits(SolutionPreviewBigData,_Component);function SolutionPreviewBigData(props){_classCallCheck(this,SolutionPreviewBigData);var _this=_possibleConstructorReturn(this,(SolutionPreviewBigData.__proto__||Object.getPrototypeOf(SolutionPreviewBigData)).call(this,props));_this.populateDataDiskList=function(service){_this.state.consolidatedDiskQty=0;if(Array.isArray(service.DataDisks)){_this.state.DataDiskList=[];service.DataDisks.map(function(x,id){_this.state.consolidatedDiskQty+=parseInt(x.Item["@qty"],10);_this.state.DataDiskList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'secondary'},x.Item["@disk"]+" ("+x.Item["@qty"]+")"));});}else{_this.state.DataDiskList=service.Hardware['@DataDisk'];_this.state.consolidatedDiskQty=service.Hardware['@DiskQty'];}};_this.state={DataDiskList:"",consolidatedDiskQty:0};return _this;}_createClass(SolutionPreviewBigData,[{key:'render',value:function render(){var _this2=this;var Hdngwid='35%';var Datawid='65%';var txtalgn='left';var fntwght='600';var diskcapacityvalue=void 0,compression=void 0,ensurecodngdata=void 0,ensurecodngparity=void 0,overhead=void 0,strgwrkload=void 0,capacitytypevalue=void 0,replicationvalue=void 0,GrowthContent=void 0;var ARCvalue=void 0,Scalitydiskcapacityvalue=void 0,GreenLakevalue=void 0,Sitesvalue=void 0,ScalityPercentage=void 0,NetworkSwitch=void 0,NoofNetwrkSwitch=void 0,ScalityReplication=void 0;var FunctionsScreen=[];//let ExtraNodeScreen = [];
var InfrastructureScrn='';//let Extscrn = '';
//let Driveclassvalue, SKUvalue, Peakreadbw, Peakwritebw, Peakreadiops, Peakwriteiops, Usablestorage, DIMMcapacity, DATAdrivecapacity, Spareserver, Datadriverperserver, Noofservers
var Peakreadbw=void 0,Peakwritebw=void 0,Peakreadiops=void 0,Peakwriteiops=void 0,Usablestorage=void 0,DIMMcapacity=void 0,DATAdrivecapacity=void 0,Spareserver=void 0,Datadriverperserver=void 0,Noofservers=void 0;//  let Heading=''
var HadoopServicesScreen='';//let HadoopHeading = ''
var LicensingHeading='';//let ServiceHeading = ''
var HDFSndMapr='';var RepDisplay="";var DataParity=this.props.workload.UserInputs.Environments.Functions.Function.map(function(val){if(Array.isArray(val.Service)){val.Service.map(function(service){if(service['@Selected']==="true"){_this2.props.workload.UserInputs.Environments.Growth.Service.map(function(elem){if(service['@Type']===elem["@Service"]){return GrowthContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Growth Rate:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@GrowthRate"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Growth Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@GrowthType"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Y1:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@Nodes1Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Y2:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@Nodes2Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Y3:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@Nodes3Y"])));}});if(service['@Type']===DATA_LAKE||service['@Type']==="MapR and MapR-EC"){diskcapacityvalue=service.Inputs['@Capacity'];compression=service.Inputs['@Compression'];ensurecodngdata=service.Inputs['@ErasureData'];ensurecodngparity=service.Inputs['@ErasureParity'];overhead=service.Inputs['@OverHead'];strgwrkload=service.Inputs['@StorageWL'];capacitytypevalue=service.Inputs['@Type'];replicationvalue=service.Inputs['@Replication'];// Heading=val['@Type']+":"+"  "+service['@Type']
if(service.Inputs['@ErasureCoding']==="false"){DataParity="none";RepDisplay="Visible";}else{DataParity="Visible";RepDisplay="none";}HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Capacity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},diskcapacityvalue)),capacitytypevalue===USABLE_CAPACITY&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Compression:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},compression)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:DataParity}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Data:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},ensurecodngdata)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:DataParity}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Parity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},ensurecodngparity)),capacitytypevalue===USABLE_CAPACITY&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Overhead:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},overhead)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Capacity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},capacitytypevalue)),capacitytypevalue===USABLE_CAPACITY&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Replication:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},replicationvalue)),GrowthContent);}else if(service['@Type']==="Scality"){ARCvalue=service.Inputs['@ARC'];Scalitydiskcapacityvalue=service.Inputs['@Capacity'];GreenLakevalue=service.Inputs['@GreenLake'];Sitesvalue=service.Inputs['@NoOfSites'];ScalityReplication=service.Inputs['@Replication'];ScalityPercentage=service.Inputs['@StoragePerc'];NetworkSwitch=service.Inputs['@NwSwitch'];NoofNetwrkSwitch=service.Inputs['@NwSwitchQty'];//Heading=val['@Type']+":"+"  "+service['@Type']
HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Select Green Lake Flex Capacity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},GreenLakevalue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'How many sites do you want your primary data stored in ?:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Sitesvalue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Replication to a second site:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},ScalityReplication)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Percent of storage containing ARC encoded objects:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},ScalityPercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Capacity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Scalitydiskcapacityvalue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'calculated ARC(X,Y) level:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},ARCvalue)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Network Switch:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},NetworkSwitch)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'No. Of Network Switches :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},NoofNetwrkSwitch)),GrowthContent);}else if(val['@Type']==='Streaming'){//Heading=val['@Type']+":"+"  "+service['@Type']
HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Thousands of Message(Message size 250 bytes) :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@MessagesPerSec'])),GrowthContent);}else if(val['@Type']==="AI"){// Heading=val['@Type']+":"+"  "+service['@Type']
HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Processing Images Per Sec:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@ImagesPerSec'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Configuration Type :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@ConfigType'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'GPUs :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@GPU'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'no of GPUs:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@GPUQty'])),GrowthContent);}else if(val['@Type']==="IoT"){// Heading=val['@Type']+":"+"  "+service['@Type']
HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Thousands of Events Per Sec:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@EventsPerSec'])));}else if(val['@Type']==="Analytics"){// var QtyHeading = "Container Qty:"
// var CoreHeading = "Cores Per Container:"
// var MemoryHeading = "Memory Per Container:"
// if (service['@Type'] === "Yarn") {
//     if (service.Inputs['@ConfigType'] === "Containers") {
//         QtyHeading = "Number of Containers"
//     } else {
//         QtyHeading = "Number of Storage Nodes"
//     }
// } else if (service['@Type'] === "Spark") {
//     if (service.Inputs['@ConfigType'] === "Executors") {
//         QtyHeading = "Number of Executors"
//     } else {
//         QtyHeading = "Number of Storage Nodes"
//     }
// }
var data='';if(service['@Type']==="Yarn"&&service.Inputs['@ConfigType']==="Containers"){data=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Containers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@ContainersQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Cores Per Container:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@CoresPerContainer'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Memory Per Container:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@MemoryPerContainer'])));}else if(service['@Type']==="Yarn"&&service.Inputs['@ConfigType']==="Storage Ratio"){data=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Storage Nodes:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@StorageNodesQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Storage to Compute Ratio:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@SCRatio'])));}if(service['@Type']==="Spark"&&service.Inputs['@ConfigType']==="Executors"){data=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Executors:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@ContainersQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Cores Per Executors:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@CoresPerContainer'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Memory Per Executors:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@MemoryPerContainer'])));}else if(service['@Type']==="Spark"&&service.Inputs['@ConfigType']==="Storage Ratio"){data=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Storage Nodes:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@StorageNodesQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Storage to Compute Ratio:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@SCRatio'])));}// Heading=val['@Type']+":"+"  "+service['@Type']
HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Configuration Based on:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@ConfigType'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Node Local Storage (TB):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@NodeStorage'])),data,GrowthContent);}else if(val['@Type']==="Database"){//Heading=val['@Type']+":"+"  "+service['@Type']
var operatonsname="Operations per Sec(In Thousands)";if(service['@Type']==="Hive"){operatonsname="Queries Per Minute";}HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'40%'}},service['@Type']==="Hive"||service['@Type']==="HBase"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},operatonsname,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@OpsPerSec'])):"",service['@Type']==="Hive"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Database Size (TB):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@Capacity'])):"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Node Local Storage:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@NodeStorage'])),GrowthContent);}else if(service['@Type']==="Weka"){//SKUvalue = service.Inputs['@SKUInfo'];
//Driveclassvalue = service.Inputs['@DriveClass'];
Peakreadbw=service.Inputs['@PeakReadBW'];Peakwritebw=service.Inputs['@PeakWriteBW'];Peakreadiops=service.Inputs['@PeakReadIOPS'];Peakwriteiops=service.Inputs['@PeakWriteIOPS'];Usablestorage=service.Inputs['@Capacity'];DIMMcapacity=service.Inputs['@DIMMCapacity'];DATAdrivecapacity=service.Inputs['@DATADriveCapacity'];Spareserver=service.Inputs['@SpareServers'];Datadriverperserver=service.Inputs['@DATADrivePerServer'];Noofservers=service.Hardware['@NodesCount'];var Wekaforall='';Wekaforall=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Do you expect to add servers to this deployment?:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@AddServers'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Select how you will specify BOM and SKU information:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@SKUInfo'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'OS Environment:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@OS'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Support Year Count:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@SupportYears'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Is Edu/Govern Customer:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@IsEduCustomer'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Network Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@NetworkType'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Tiering Capacity Required:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Inputs['@TierCapacity'])));if(service.Inputs['@SKUInfo']=='Customer Requirements'&service.Inputs['@DriveClass']=='Mixed Use'){HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},Wekaforall,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Peak Read IOPS(Millions):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Peakreadiops)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Peak Write IOPS(Millions):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Peakwriteiops)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Total Usable Storage(Terabytes):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Usablestorage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Peak Read Bandwidth(GB/s):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Peakreadbw)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Peak Write Bandwidth(GB/s):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Peakwritebw)),GrowthContent);}else if(service.Inputs['@SKUInfo']=='Customer Requirements'&service.Inputs['@DriveClass']=='Read Intensive'){HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},Wekaforall,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Total Usable Storage(Terabytes):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Usablestorage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Peak Read Bandwidth(GB/s):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Peakreadbw)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Peak Read IOPS(Millions):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Peakreadiops)));}else if(service.Inputs['@SKUInfo']=='Predefined Configuration'&service.Inputs['@DriveClass']=='Read Intensive'){HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},Wekaforall,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DIMM Capacity(GB):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},DIMMcapacity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DATA Drive Capacity(TB):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},DATAdrivecapacity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Spare Servers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Spareserver)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DATA Drive Per Server:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Datadriverperserver)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Servers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Noofservers)));}else if(service.Inputs['@SKUInfo']=='Predefined Configuration'&service.Inputs['@DriveClass']=='Mixed Use'){HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},Wekaforall,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DIMM Capacity(GB):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},DIMMcapacity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DATA Drive Capacity(TB):'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},DATAdrivecapacity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Spare Servers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Spareserver)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DATA Drive Per Server:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Datadriverperserver)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Servers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},Noofservers)));}}var notforweka='';_this2.populateDataDiskList(service);if(service['@Type']!=="Weka"){notforweka=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DataDisk:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},_this2.state.DataDiskList)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'OSDisk:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@OSDisk'])));}FunctionsScreen.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},val['@Type']+":  "+service['@Type']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Server:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@Server'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Processor:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@Proc'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Processor Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@ProcQty'])),notforweka,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'No. of DataDisk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},_this2.state.consolidatedDiskQty)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'No. of OSDisk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@OSDiskQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Memory:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@Memory'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Count:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},service.Hardware['@NodesCount']))),HDFSndMapr)))));}});}else{_this2.props.workload.UserInputs.Environments.Growth.Service.map(function(elem){if(val['@Type']===elem["@Name"]){return GrowthContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Growth Rate:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@GrowthRate"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Growth Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@GrowthType"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Y1:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@Nodes1Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Y2:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@Nodes2Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{display:RepDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Y3:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},elem["@Nodes3Y"])));}});if(val.Service['@Selected']==='true'){if(val.Service['@Type']==="MiNifi"){// Heading=val['@Type']+":"+"  "+val.Service['@Type']
HDFSndMapr=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Events Per Sec:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Inputs['@EventsPerSec'])));}if(val['@Type']==="Gateway Node"){//  Heading="Gateway Node"
HDFSndMapr="";if(isNaN(val.Service.Hardware['@NodesCount'])){GrowthContent='';}}if(val['@Type']==="Edge Node"){// Heading="Edge Node"
HDFSndMapr="";}if(val['@Type']==="Master Node"){// Heading="Master Node"
HDFSndMapr="";}_this2.populateDataDiskList(val.Service);FunctionsScreen.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},val['@Type']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'90%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Server:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@Server'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Processor:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@Proc'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Processor Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@ProcQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'DataDisk:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},_this2.state.DataDiskList)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'OSDisk:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@OSDisk'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'No. of DataDisk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},_this2.state.consolidatedDiskQty)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'No. of OSDisk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@OSDiskQty'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Memory:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@Memory'])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Nodes Count:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},val.Service.Hardware['@NodesCount']))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'60%'}},HDFSndMapr,GrowthContent))))));}}});// if (this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['Weka'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['Scality'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@BlueData'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDSE'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEnt'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDW'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEntDH'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEntDH'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaODB'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEntPlus'] !== 'false') {
//     HadoopHeading = "Licenses and Support"
//     LicensingHeading = 'Licensing'
//     if (this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDSE'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEntDH'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEntPlus'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@BlueData'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaDW'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@ClouderaEss'] !== 'false' || this.props.workload.UserInputs.Environments.HadoopServices.Services['@HWEnt'] !== 'false')
//         ServiceHeading = 'Services'
// }
// if(this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None' || this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'] !== 'None'|| this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['Scality'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['Weka'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'] !== 'None'||this.props.workload.UserInputs.Environments.HadoopServices['HPCM'] !== 'None')
// {
//     LicensingHeading = 'Licensing'
// }
var Services=[];//    HadoopHeading=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected'] !=='false' ? "Cloudera":"Hortonworks"
//    if(HadoopHeading==='Cloudera')
//    {
//     this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.map((name)=>{
//           if(name['@IsSelected']==='true')
//            {
//     Services.push(<Box direction='row' pad={{ between: "small" }}>
//                 <span>{name['@Type']} :</span>
//                  <span>{name['@Description']}</span>
//     </Box>)
//            }
//        })
//    }else{
//        this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.map((name)=>{
//           if(name['@IsSelected']==='true')
//            {
//        Services.push(<Box direction='row' pad={{ between: "small" }}>
//                 <span>{name['@Type']} :</span>
//                  <span>{name['@Description']}</span>
//        </Box>)
//            }
//        })
//    }
if(this.props.workload.UserInputs.Environments.HadoopServices!==undefined){if(this.props.workload.UserInputs.Environments.HadoopServices.Deployment===undefined){this.props.workload.UserInputs.Environments.HadoopServices.Deployment='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.AppStore===undefined){this.props.workload.UserInputs.Environments.HadoopServices.AppStore='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.Installation===undefined){this.props.workload.UserInputs.Environments.HadoopServices.Installation='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage===undefined){this.props.workload.UserInputs.Environments.HadoopServices.SingleImage={"@Qty":"1","#text":"false"};}if(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage===undefined){this.props.workload.UserInputs.Environments.HadoopServices.CustomImage={"@Qty":"1","#text":"false"};}}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){var isDataFabricSelected=false;if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']!=='false'&&this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']==='false'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.map(function(name){if(name['@IsSelected']==='true'){//HadoopHeading = "Cloudera";
Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},name['@Type'],' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Hdngwid,textAlign:txtalgn}},name['@Description'])));}});}else if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']==='false'&&this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']!=='false'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.map(function(name){if(name['@IsSelected']==='true'){//HadoopHeading = "Hortonworks";
Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},name['@Type'],' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Hdngwid,textAlign:txtalgn}},name['@Description'])));}});}else if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric!==undefined){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected']==='true'){isDataFabricSelected=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.map(function(name){if(name['@IsSelected']==='true'){//HadoopHeading = "MapR";
var serviceName=name['@Type'];if(serviceName===DATAFABRIC_XD){serviceName=DATAFABRIC_FILESTORE;}Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},HPE_EZMERAL+serviceName)));}});}}// if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@IsSelected'] === 'true' && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Description'] !== 'None') {
//     let text = "BlueData EPIC Software"
//     if (this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Type'] !== "BlueData") {
//         text = this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Type']
//     }
//     Services.push(<Box direction='row' pad={{ between: "small" }}>
//         <span style={{ width: Datawid, textAlign: txtalgn, fontWeight: fntwght }}>{text} :</span>
//         <span style={{ width: Hdngwid, textAlign: txtalgn }}>{this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Description']}</span>
//     </Box>)
// }
if(Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.map(function(software){var text="";var includeLicense=true;if(software['@Description']!=='None'){if(software['@Type']===HPE_CP){text=HPE_CP_EPIC_SOFTWARE;}else if(software['@Type']==="BlueDataAI"){text=HPE_CP_ML_SOFTWARE;}else if(software["@Type"]===HPE_EZMERAL_DF_XD){text=HPE_EZMERAL_DATAFABRIC_LICENSE;includeLicense=isDataFabricSelected;}if(includeLicense){Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},text,' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn}},software['@Description'])));}}});}}HadoopServicesScreen=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:"small"},style:{width:'100%',padding:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textAlign:"center",fontWeight:fntwght}},'Licenses and Support'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:"small"},style:{width:'50%'}},Services),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:"small"},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,LicensingHeading),this.props.workload.UserInputs.Environments.HadoopServices['HPCM']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPCM :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['HPCM']))):'',this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HWSupport :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']))):'',this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HadoopLicense :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']))):'',this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'LinuxLicense :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']))):'',this.props.workload.UserInputs.Environments.HadoopServices['Scality']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Scality :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['Scality']))):'',this.props.workload.UserInputs.Environments.HadoopServices['Weka']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Weka :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['Weka']))):'',this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'iLoLicense :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']))):'',this.props.workload.UserInputs.Environments.HadoopServices['AppStore']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE CP App Store Development SVC'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['AppStore']))):'',this.props.workload.UserInputs.Environments.HadoopServices['Deployment']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE CP Deployment and Integration Services :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['Deployment']))):'',this.props.workload.UserInputs.Environments.HadoopServices['Installation']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Installation and Start-up Services :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['Installation']))):'',this.props.workload.UserInputs.Environments.HadoopServices.CustomImage!==undefined?this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE CP Custom Image Development SVC :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty']))):'':'',this.props.workload.UserInputs.Environments.HadoopServices.SingleImage!==undefined?this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE CP Single Image Development SVC :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty']))):'':'')));//ExtraNodes Screen
//  this.props.workload.UserInputs.Environments.Functions.Function.map((val) => {
//         if(val.Service['@Selected']==='true')
//         {
//             if(val.Service['@Type']==="MiNifi")
//             {
//             Extscrn = <Box style={{ width: '40%' }}>
//                             <Box direction="row">
//                                 <Box style={{ width: Hdngwid, textAlign: txtalgn,fontWeight: fntwght }} className='secondary'>Events Per Sec:</Box>
//                                 <Box style={{ width: Datawid, textAlign: txtalgn }} className='secondary'>{val.Service.Inputs['@EventsPerSec']}</Box>
//                             </Box>
//                       </Box>         
//             }
//              ExtraNodeScreen.push(Extscrn)
//         }
//let HPCM=this.props.workload.UserInputs.Environments.HadoopServices['HPCM'];
//InfraStructure Screen
InfrastructureScrn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},'Infrastructure'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Provision Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.ProvisionType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Network Speed:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.NetworkSpeed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Network Switch:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.NetworkSwitch)),this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Additional Network Switch:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch['#text'])):'',this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch!==undefined&&this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["#text"]!=="None"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Switches:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"])):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Factory Express:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.FactoryExpress))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Max Power:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.MaxPower)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Max Weight:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.MaxWeight)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Rack:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.Rack)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Rack Description:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.RackDescription)))))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,FunctionsScreen,HadoopServicesScreen,InfrastructureScrn);}}]);return SolutionPreviewBigData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SolutionPreviewBlue=function(_Component2){_inherits(SolutionPreviewBlue,_Component2);function SolutionPreviewBlue(){_classCallCheck(this,SolutionPreviewBlue);var _this3=_possibleConstructorReturn(this,(SolutionPreviewBlue.__proto__||Object.getPrototypeOf(SolutionPreviewBlue)).call(this));_this3.populateTenantDriveList=function(role){_this3.state.tenantDriveList='';_this3.state.consolidatedTenantDriveQty=0;if(Array.isArray(role.PersistentDisks)&&role["@mixedTenantStorage"]==="True"){_this3.state.tenantDriveList=[];role.PersistentDisks.map(function(x){_this3.state.consolidatedTenantDriveQty+=parseInt(x.Item["@qty"],10);_this3.state.tenantDriveList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Paragraph___default.a,null,x.Item["@disk"]+" ("+x.Item["@qty"]+")"));});}else{_this3.state.tenantDriveList=role['@TStorageDrive'];_this3.state.consolidatedTenantDriveQty=role['@TStorageDriveQty'];}};_this3.renderMainScreenandManagementHosts=function(){var mainScreenandManagementHosts=[];var createRole=function createRole(item,selectedSolution){var text=CONTROLLER_HOSTS;var GPUtext='';var totalgpustext='';var tenantstorage='';var tenantstorageqty='';var VMWareCheckBox='';var Soldisplay='';var driveType=NODE_;if(selectedSolution){text=item['@RoleName'];if(item['@Type']===NONGPU_){Soldisplay="";if(selectedSolution.Templates.Template.filter(function(x){return x[ATTRIBUTE_TYPE].indexOf(INFERENCE_)>-1;}).length>0){totalgpustext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'GPU Type:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@GPUType']),' ');}}if(item['@Type']===GPU_){Soldisplay="";if(selectedSolution.Templates.Template.filter(function(x){return x["@Type"]!==INFERENCE_&&x["@Type"].indexOf(INFERENCE_)>-1;}).length>=selectedSolution.Templates.Template.length-1){text=INFERENCE_;}GPUtext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'GPU Type:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@GPUType']),' ');totalgpustext=item['@GPUType']!='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'GPU Count Per Server:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item["@GPUcount"]),' '):'';}if(item["@Type"]===STORAGE_){text=item['@RoleName']+"s";Soldisplay="";}}_this3.populateTenantDriveList(item);if(item['@Type']!==GATEWAY_){if(item['@Type']===MASTER_){text=MASTER_HOST;}tenantstorage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Persistent Drive:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.tenantDriveList),' ');tenantstorageqty=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Persistent Drive Quantity:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,_this3.state.consolidatedTenantDriveQty),' ');}else{text=GATEWAY_HOSTS;}if(item['@Type']===GATEWAY_||item["@Type"]===CONTROLLER_||item["@Type"]===MASTER_){VMWareCheckBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'VMWare:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item["@VMWare"]));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{size:'xlarge',separator:'bottom',style:{display:Soldisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h4',align:'center',margin:'none',position:'fixed',width:'100%',style:{paddingTop:'1%',paddingRight:'5%'},strong:true},text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'35%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Host type:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@Name']),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Processor Type:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@Proc']),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Processor Family:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@ProcFamily']),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Memory:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@Memory']),' '),totalgpustext,tenantstorage,VMWareCheckBox))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Host Count:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@NodesCount']),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'OS Drive:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@OSDisk']),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,driveType,' Storage Drive:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@NodeDisk']),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,driveType,' Storage Drive Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,item['@StorageDiskQty']),' '),GPUtext,tenantstorageqty)))));};_this3.props.workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]==="yes";}).map(function(selectedSolution){var workloadTemplate="Select Workload Template";var virtualClustersLabel="Number of clusters (or Applications)";var virtualNodesLabel="Nodes/Containers (or pod) per cluster";var cpuCoresLabel="Cores per container (or pod)";var memoryLabel="Memory GB per container (or pod)";var nodeStorageLabel="Ephemeral Storage GB per container (or pod)";var persistentStorageLabel="Persistent Storage GB per cluster (or pod)";var gpusLabel="GPUs per container (or pod)";var inferenceImageProcessing='';var inferenceGPU='';var trainingImageProcessing='';var trainingGPU='';var MLOpsTemplateInput=false;var MLOpsImageProcessing=false;var HPECPWorkloadRequirementsHeading=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["j" /* HPECPWorkloadRequirements */].CP;var HPECPRequirementsHeading=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["j" /* HPECPWorkloadRequirements */].CP.replace(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["u" /* Workload */],"");if(!_this3.props.workload.UserInputs.Environments.WorkloadRequirementsHeading){_this3.props.workload.UserInputs.Environments.WorkloadRequirementsHeading=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["j" /* HPECPWorkloadRequirements */][_this3.props.workload.UserInputs.Environments.SSETMode];}HPECPWorkloadRequirementsHeading=_this3.props.workload.UserInputs.Environments.WorkloadRequirementsHeading;if(!_this3.props.workload.UserInputs.Environments.RequirementsHeading){_this3.props.workload.UserInputs.Environments.RequirementsHeading=HPECPWorkloadRequirementsHeading.replace(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["u" /* Workload */],"");}HPECPRequirementsHeading=_this3.props.workload.UserInputs.Environments.RequirementsHeading;if(selectedSolution[ATTRIBUTE_SOLUTIONTYPE]===CAAS){var index=selectedSolution.Templates.Template.findIndex(function(template){return template[ATTRIBUTE_TYPE]===IMAGE_PROCESSING_TEMPLATE;});if(index>-1){selectedSolution.Templates.Template.splice(index,1);}}var templatesTableBody=selectedSolution.Templates.Template.map(function(val){if(selectedSolution["@SolutionType"]!==MLOPS||selectedSolution["@SolutionType"]===MLOPS&&val["@InputMode"]===MLOPS){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val['@ConfigType']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val['@Type']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@vClusters']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@vNodesPerCluster']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@vCPUPerNode']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@vMemoryPerNode']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@StoragePervNode']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@PersistentStorage']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:'center'}},val.Nodes['@userGPUs']));}});if(selectedSolution["@SolutionType"]===MLOPS){if(selectedSolution.Templates.Template.find(function(template){return template["@Type"]!==NONE_&&template["@InputMode"]===MLOPS;})){MLOpsTemplateInput=true;}if(selectedSolution.Templates.Template.find(function(template){return template["@Type"]!==NONE_&&template["@InputMode"]===IMAGE_PROCESSING;})){MLOpsImageProcessing=true;}}var overallConfigType=EPIC_;if(selectedSolution["@SolutionType"]!==MLOPS||selectedSolution["@SolutionType"]===MLOPS&&MLOpsTemplateInput){if(selectedSolution.Templates.Template.filter(function(template){return template["@Type"]!==NONE_;}).length===0){overallConfigType=selectedSolution.Templates.Template.find(function(template){return template["@Type"]===NONE_;})["@ConfigType"];}else{var kubernetesTemplates=[];kubernetesTemplates=selectedSolution.Templates.Template.filter(function(template){return template["@ConfigType"]===KUBERNETES_&&template["@Type"]!==NONE_&&!(selectedSolution["@SolutionType"]===MLOPS&&template["@InputMode"]===IMAGE_PROCESSING);});if(kubernetesTemplates.length>0){overallConfigType=KUBERNETES_;}}}var requirementDetails=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{size:'xlarge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h5',align:'center',margin:'none',position:'fixed',style:{paddingTop:'1%',paddingRight:'5%'},width:'100%',strong:true},HPECPRequirementsHeading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Persistent Storage TB:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,selectedSolution.Templates.ServerDetails.Requirements['@HDFSRawSize']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Persistent Storage Replication Factor:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,selectedSolution.Templates.ServerDetails.Requirements['@HDFSRepFactor']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'vCPU to Physical Core ratio:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,selectedSolution.Templates.ServerDetails.Requirements['@AllocationRatio']),overallConfigType===KUBERNETES_?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Number of Kubernetes Cluster(s):'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,selectedSolution.Templates.ServerDetails.Requirements['@KubernetesClustersQty'])):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Configure Based on:'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,selectedSolution.Templates.ServerDetails.Requirements['@ConfigBasedOn']))))));if(!Array.isArray(selectedSolution.Templates.ServerDetails.Server)){var singleRole=selectedSolution.Templates.ServerDetails.Server;selectedSolution.Templates.ServerDetails.Server=[];selectedSolution.Templates.ServerDetails.Server.push(singleRole);}var allRoles=selectedSolution.Templates.ServerDetails.Server;var configuredRoles=[];if(selectedSolution.NonGPUValue===undefined){selectedSolution.NonGPUValue={isCalculated:FALSE};}if(selectedSolution.StorageValue===undefined){selectedSolution.StorageValue={isCalculated:FALSE};}if(selectedSolution.GPUValue===undefined){selectedSolution.GPUValue={isCalculated:FALSE};}allRoles.map(function(role){if(role["@Type"]===NONGPU_&&parseInt(role["@NodesCount"],10)>0){selectedSolution.NonGPUValue.isCalculated=TRUE;}if(role["@Type"]===GPU_&&parseInt(role["@NodesCount"],10)>0){selectedSolution.GPUValue.isCalculated=TRUE;}if(role["@Type"]===STORAGE_&&parseInt(role["@NodesCount"],10)>0){selectedSolution.StorageValue.isCalculated=TRUE;}if(_this3.validateServer(role,selectedSolution,MLOpsImageProcessing)){configuredRoles.push(createRole(role,selectedSolution));}});if(selectedSolution["@SolutionType"]===MLOPS){if(MLOpsImageProcessing){selectedSolution.Templates.Template.map(function(template){if(!selectedSolution.Templates.Template.find(function(template){return template[ATTRIBUTE_INPUTMODE]===IMAGE_PROCESSING&&template[ATTRIBUTE_TYPE]===INFERENCE_;})){if(template[ATTRIBUTE_INPUTMODE]===IMAGE_PROCESSING&&template[ATTRIBUTE_CATEGORY]===INFERENCE_&&template[ATTRIBUTE_TYPE]!==INFERENCE_){template[ATTRIBUTE_TYPE]=INFERENCE_;}}if(!selectedSolution.Templates.Template.find(function(template){return template[ATTRIBUTE_INPUTMODE]===IMAGE_PROCESSING&&template[ATTRIBUTE_TYPE]===TRAINING;})){if(template[ATTRIBUTE_INPUTMODE]===IMAGE_PROCESSING&&template[ATTRIBUTE_CATEGORY]===TRAINING&&template[ATTRIBUTE_TYPE]!==TRAINING){template[ATTRIBUTE_TYPE]=TRAINING;}}});var inferenceTemplate=selectedSolution.Templates.Template.find(function(template){return template["@Type"]===INFERENCE_;});var trainingTemplate=selectedSolution.Templates.Template.find(function(template){return template["@Type"]===TRAINING;});inferenceImageProcessing=inferenceTemplate.Nodes["@ImagesPerSec"];inferenceGPU=inferenceTemplate.Nodes["@GPUType"];trainingImageProcessing=trainingTemplate.Nodes["@ImagesPerSec"];trainingGPU=trainingTemplate.Nodes["@GPUType"];}}mainScreenandManagementHosts.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{borderBottom:'2px solid #01a982'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h4',align:'center',margin:'none',position:'fixed',width:'100%',style:{paddingTop:'1%',paddingRight:'5%'},strong:true},selectedSolution["@SolutionType"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h5',align:'center',margin:'none',position:'fixed',width:'100%',style:{paddingTop:'1%',paddingRight:'5%'},strong:true},HPECPWorkloadRequirementsHeading),selectedSolution["@SolutionType"]!==MLOPS||selectedSolution["@SolutionType"]===MLOPS&&MLOpsTemplateInput?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,selectedSolution["@SolutionType"]===MLOPS&&MLOpsTemplateInput?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h5',align:'center',margin:'none',position:'fixed',style:{paddingTop:'1%',paddingRight:'5%'},width:'100%',strong:true},MLOPS_TEMPLATES):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Configuration Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,workloadTemplate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,virtualClustersLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,virtualNodesLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,cpuCoresLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,memoryLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,nodeStorageLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,persistentStorageLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,gpusLabel))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,templatesTableBody))):'',selectedSolution["@SolutionType"]===MLOPS&&MLOpsImageProcessing?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h5',align:'center',margin:'none',position:'fixed',style:{paddingTop:'1%',paddingRight:'5%'},width:'100%',strong:true},MLOPS_IMAGE_PROCESSING),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h4',strong:true,align:'center'},INFERENCE_)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h4',align:'center',strong:true},TRAINING)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Image Processing Input:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,inferenceImageProcessing)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'GPUs:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,inferenceGPU))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Image Processing Input:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,trainingImageProcessing)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'GPUs:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,trainingGPU))))))):''),requirementDetails,configuredRoles));});var managementRoles=_this3.props.workload.UserInputs.Environments.ManagementHosts.Server.map(function(role){return createRole(role);});mainScreenandManagementHosts.push(managementRoles);return mainScreenandManagementHosts;};_this3.createRow=function(filteredItem){//(isNaN(this.props.defaultSizerWorkload.GatewayQty) || this.props.defaultSizerWorkload.GatewayQty === null)
var filteredItemType=void 0;filteredItemType=filteredItem["@RoleName"]?filteredItem["@SolutionType"]+'-'+filteredItem["@RoleName"]:filteredItem["@SolutionType"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,filteredItemType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Label___default.a,{style:{width:'30%'},id:'item1'},filteredItem["@GrowthRate"],' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes1Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes2Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes3Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes4Y"])));};_this3.state={tenantDriveList:'',consolidatedTenantDriveQty:0};_this3.validateServer=_this3.validateServer.bind(_this3);return _this3;}_createClass(SolutionPreviewBlue,[{key:'validateServer',value:function validateServer(item,selectedSolution,imageProcessing){var temp=false;if(item['@Type']===GPU_){var sum=0;selectedSolution.Templates.Template.map(function(x,id){sum+=parseInt(x.Nodes["@GPUs"],10);});if((sum>-1||imageProcessing)&&selectedSolution.GPUValue.isCalculated===TRUE){temp=true;}else{temp=false;}}else if(item['@Type']==="NonGPU"){if(selectedSolution.Templates.Template.filter(function(x){return x["@Type"].indexOf(INFERENCE_)>-1;}).length>0&&selectedSolution.Templates.Template.filter(function(x){return x["@Type"].indexOf('GPU')!==-1&&x["@Type"].indexOf(INFERENCE_)===-1;}).length>0){if(selectedSolution.NonGPUValue.isCalculated===TRUE){temp=true;}}selectedSolution.Templates.Template.map(function(x,id){if(x["@Type"]!=='None'&&x.Nodes["@vClusters"].toString()!=='0'&&x.Nodes["@vNodesPerCluster"].toString()!=='0'&&x.Nodes["@GPUs"].toString()==='0'&&!temp){if(selectedSolution.NonGPUValue.isCalculated===TRUE){temp=true;}}});if(parseInt(item["@NodesCount"],10)>0&&selectedSolution.NonGPUValue.isCalculated===TRUE){temp=true;}}else if(item["@Type"]===STORAGE_){if(selectedSolution.StorageValue.isCalculated===TRUE){temp=true;}}return temp;}},{key:'render',value:function render(){var _this4=this;var Hdngwid='50%';var Datawid='50%';var txtalgn='left';var fntwght='600';var HadoopServicesScreen='';var LicensingHeading='';var InfrastructureScrn='';var EzemeralGrowthScrn='';var displayGrowth=true;var Services=[];if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']!=='false'&&this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']==='false'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.map(function(name){if(name['@IsSelected']==='true'){Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},name['@Type'],' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn}},name['@Description'])));}});}else if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']==='false'&&this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']!=='false'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.map(function(name){if(name['@IsSelected']==='true'){Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},name['@Type'],' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn}},name['@Description'])));}});}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR!==undefined){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR['@IsSelected']==='true'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.map(function(name){if(name['@IsSelected']==='true'){Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},name['@Type'],' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn}},name['@Description'])));}});}}if(Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.map(function(software){var text="";if(software['@Description']!=='None'){if(software['@Type']===HPE_CP){text=HPE_CP_EPIC_SOFTWARE;}else if(software['@Type']==="BlueDataAI"){text=HPE_CP_ML_SOFTWARE;}else if(software["@Type"]===KUBERNETES_CM){text=HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR;}else{text=software['@Type'];}Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},text,' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn}},software['@Description'])));}});}if(this.props.workload.UserInputs.Environments.HadoopServices.VMWare){var VMWareLicenses=this.props.workload.UserInputs.Environments.HadoopServices.VMWare;for(var key in VMWareLicenses){if(VMWareLicenses[key]!==NONE_){Services.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn,fontWeight:fntwght}},'VMWare '+key.substring(1)+' :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:Datawid,textAlign:txtalgn}},VMWareLicenses[key])));}}}HadoopServicesScreen=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:"small"},style:{width:'100%',padding:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{textAlign:"center",fontWeight:fntwght}},'Licenses and Support'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:"small"},style:{width:'50%'}},Services),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:"small"},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,LicensingHeading),this.props.workload.UserInputs.Environments.HadoopServices['HPCM']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPCM :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['HPCM']))):'',this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HWSupport :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']))):'',this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HadoopLicense :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']))):'',this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'LinuxLicense :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']))):'',this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']!=='None'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'iLoLicense :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']))):'',this.props.workload.UserInputs.Environments.HadoopServices['AppStore']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE Ezmeral Runtime Enterprise App Store Development SVC :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['AppStore']))):'',this.props.workload.UserInputs.Environments.HadoopServices['Deployment']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE Ezmeral Runtime Enterprise Deployment and Integration Services  :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['Deployment']))):'',this.props.workload.UserInputs.Environments.HadoopServices['Installation']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Installation and Start-up Services :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices['Installation']))):'',this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE Ezmeral Runtime Enterprise Single Image Development SVC :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices.SingleImage["@Qty"]))):'',this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']!=='false'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'HPE Ezmeral Runtime Enterprise Custom Image Development SVC :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.HadoopServices.CustomImage["@Qty"]))):'')));this.props.workload.UserInputs.Environments.Growth.Host.map(function(x){if(x["@RoleName"]!==''&&x["@SolutionType"]!==''){EzemeralGrowthScrn=_this4.props.workload.UserInputs.Environments.Growth.Host.map(function(x){if(x["@RoleName"]!==''&&x["@SolutionType"]!==''){return _this4.createRow(x);}});}});if(this.props.isFromExternalApp){displayGrowth=false;}this.props.workload.UserInputs.Environments.displayGrowth=displayGrowth.toString();//InfraStructure Screen
InfrastructureScrn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},'Infrastructure'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Provision Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.ProvisionType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Network Speed:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.NetworkSpeed)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Network Switch:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.NetworkSwitch)),this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Additional Network Switch:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch['#text'])):'',this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch!==undefined&&this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["#text"]!=="None"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Switches:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"])):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Factory Express:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.FactoryExpress))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Max Power:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.MaxPower)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Max Weight:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.MaxWeight)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Rack:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.Rack)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Rack Description:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.workload.UserInputs.Environments.Licenses.RackDescription)))))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,this.renderMainScreenandManagementHosts(),HadoopServicesScreen,displayGrowth?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{separator:'horizontal',style:{width:'100%',textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontWeight:'600'}},'Growth'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,EZMERAL_GROWTH_HEADINGS.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{fontWeight:'600'}},item);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,EzemeralGrowthScrn))):null,InfrastructureScrn);}}]);return SolutionPreviewBlue;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SolutionPreviewSynergy=function(_Component3){_inherits(SolutionPreviewSynergy,_Component3);function SolutionPreviewSynergy(){_classCallCheck(this,SolutionPreviewSynergy);var _this5=_possibleConstructorReturn(this,(SolutionPreviewSynergy.__proto__||Object.getPrototypeOf(SolutionPreviewSynergy)).call(this));_this5.renderHost=_this5.renderHost.bind(_this5);_this5.renderStorage=_this5.renderStorage.bind(_this5);_this5.renderGPElement=_this5.renderGPElement.bind(_this5);_this5.GPHostContent=_this5.GPHostContent.bind(_this5);_this5.GPStorageContent=_this5.GPStorageContent.bind(_this5);_this5.renderHostModule=_this5.renderHostModule.bind(_this5);return _this5;}_createClass(SolutionPreviewSynergy,[{key:'renderGPElement',value:function renderGPElement(Hdngwid,Datawid,txtalgn,fntwght){var _this6=this;var sites=undefined;sites=this.props.preview.Sites.Site;if(sites!==undefined&&!Array.isArray(sites))sites=[sites];if(sites!==undefined){sites.forEach(function(element){labelsTobeBold.push(element.SiteName);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:'center'}},'Recommended'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:txtalgn}},'Host Configuration'),sites!==undefined?sites.map(function(site){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght},className:'secondary'},site.SiteName)),_this6.GPHostContent(site,fntwght,Hdngwid,txtalgn,Datawid),_this6.GPStorageContent(site,fntwght,Hdngwid,txtalgn,Datawid),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}):''));}},{key:'renderHostModule',value:function renderHostModule(modules,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement){var hideDetails=false;if(bIsGPElement)hideDetails=true;return modules!==undefined?modules.map(function(module){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,hideDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center'},className:'secondary'},module.ModuleName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'10px'},className:'secondary'},module.ModuleName)),hideDetails?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Server:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},module.Server)),hideDetails?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Processor:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},module.Processor)),hideDetails?'':module.GPU!==undefined&&module.GPU!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'GPU:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},module.GPU)):'',hideDetails?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Memory:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},module.Memory)),hideDetails?'':module.SystemDrive!==undefined&&module.SystemDrive!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'System Drive:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},module.SystemDrive)):'',hideDetails?'':module.DataDrive!==undefined&&module.DataDrive!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Data Drive:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},module.DataDrive)):'');}):'';}},{key:'GPHostContent',value:function GPHostContent(site,fntwght,Hdngwid,txtalgn,Datawid){var modules=site.Modules!==undefined?site.Modules.Module:undefined;if(modules!==undefined&&!Array.isArray(modules))modules=[modules];if(modules!==undefined){modules.forEach(function(element){labelsTobeBold.push(element.ModuleName);});}var virualHost=[];var headHost=[];var bareMetalHost=[];var containerHost=[];var gatewayHost=[];var otherModule=[];var controlPlane=[];var containersOnVM=[];var containersOnBareMetal=[];var headNode=[];var odfStorage=[];var coreosVM=[];var rehl_BM=[];if(this.props.workload.UserInputs.SizerMode===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["f" /* GPELEMENT */]&&modules!==undefined){modules.forEach(function(element){var moduleCount=element.Server.split('x')[0];if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].VIRTUAL_MACHINES)>-1){var moduleName=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+moduleName;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;virualHost.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERSONVM)>-1){var _moduleName=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;containersOnVM.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERSONBAREMETAL)>-1){var _moduleName2=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName2;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;containersOnBareMetal.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERS)>-1){var _moduleName3=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName3;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;containerHost.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].COREOS_VM)>-1){var _moduleName4=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName4;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;coreosVM.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].RHEL_BM)>-1){var _moduleName5=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName5;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;rehl_BM.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].BARE_METAL)>-1){var _moduleName6=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName6;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;bareMetalHost.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HEAD_NODES)>-1){var _moduleName7=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName7;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;headHost.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTROL_PLANE)>-1){var _moduleName8=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName8;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;controlPlane.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].GATEWAY)>-1){var _moduleName9=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName9;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;gatewayHost.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HEADNODE)>-1){var _moduleName10=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName10;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;headNode.push(element);}else if(element.ModuleName.indexOf(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].ODF_STORAGE)>-1){var _moduleName11=element.ModuleName.split('-')[0].trim();element.ModuleName=moduleCount+' x '+_moduleName11;if(element.ReplicationName!==undefined)element.ModuleName=element.ModuleName+element.ReplicationName;odfStorage.push(element);}else{otherModule.push(element);}});labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].VIRTUAL_MACHINES);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HEAD_NODES);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].BARE_METAL);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERS);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].GATEWAY);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTROL_PLANE);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERSONVM);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERSONBAREMETAL);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HEADNODE);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].ODF_STORAGE);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].COREOS_VM);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].RHEL_BM);}var bIsGPElement=false;if(virualHost.length>0||containerHost.length>0||containersOnVM.length>0||containersOnBareMetal.length>0||bareMetalHost.length>0)bIsGPElement=true;if(this.props.workload.UserInputs.SizerMode===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["f" /* GPELEMENT */]){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,virualHost.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].VIRTUAL_MACHINES)),this.renderHostModule(virualHost,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',containersOnVM.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERSONVM)),this.renderHostModule(containersOnVM,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',containersOnBareMetal.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERSONBAREMETAL)),this.renderHostModule(containersOnBareMetal,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',containerHost.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTAINERS)),this.renderHostModule(containerHost,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',bareMetalHost.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].BARE_METAL)),this.renderHostModule(bareMetalHost,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',headHost.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HEAD_NODES)),this.renderHostModule(headHost,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',controlPlane.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTROL_PLANE)),this.renderHostModule(controlPlane,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',gatewayHost.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].GATEWAY)),this.renderHostModule(gatewayHost,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',headNode.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HEADNODE)),this.renderHostModule(headNode,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',odfStorage.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].ODF_STORAGE)),this.renderHostModule(odfStorage,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',coreosVM.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].COREOS_VM)),this.renderHostModule(coreosVM,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',rehl_BM.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,marginTop:'5px'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].RHEL_BM)),this.renderHostModule(rehl_BM,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement)):'',otherModule.length>0?this.renderHostModule(otherModule,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement):'');}else{{this.renderHostModule(modules,fntwght,Hdngwid,txtalgn,Datawid,bIsGPElement);}}}},{key:'GPStorageContent',value:function GPStorageContent(site,fntwght,Hdngwid,txtalgn,Datawid){var storagemodules=site.StorageModules!==undefined&&site.StorageModules!==null?site.StorageModules.StorageModule:undefined;if(storagemodules!==undefined&&!Array.isArray(storagemodules))storagemodules=[storagemodules];if(this.props.workload.UserInputs.SizerMode!==__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["f" /* GPELEMENT */]&&storagemodules!==undefined){storagemodules.forEach(function(element){labelsTobeBold.push(element.StorageModuleName);});}var sharedHeading=undefined;var sharedStorageHeading=undefined;var hideStorageDetails=false;if(this.props.workload.UserInputs.SizerMode===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["f" /* GPELEMENT */]&&storagemodules!==undefined){hideStorageDetails=true;sharedHeading=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].SHARED;sharedStorageHeading=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].SHAREDSTORAGE;labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].SHARED);labelsTobeBold.push(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].SHAREDSTORAGE);}if(site.SiteName===''){hideStorageDetails=false;sharedHeading=undefined;sharedStorageHeading=undefined;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{position:"relative",top:"10px"}},storagemodules!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,position:"relative",bottom:"10px",marginTop:'5px'},className:'secondary'},sharedStorageHeading)))):'',storagemodules!==undefined?storagemodules.map(function(storagemodule){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,hideStorageDetails?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},storagemodule.StorageModuleName.search(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["k" /* PRIMERA */])>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:"100%",textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["r" /* STORAGEHEADING */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:"100%",textAlign:txtalgn,position:"absolute",left:"35%"},className:'secondary'},storagemodule.StorageModuleName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',position:"relative",bottom:"10px"},className:'secondary'},storagemodule.StorageModuleName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},storagemodule.StorageModuleName.search(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["k" /* PRIMERA */])>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:"100%",textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["r" /* STORAGEHEADING */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:"100%",textAlign:txtalgn,position:"absolute",left:"35%"},className:'secondary'},storagemodule.StorageModuleName)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,position:"relative",bottom:"10px"},className:'secondary'},storagemodule.StorageModuleName)),!hideStorageDetails&&storagemodule.NimbleStorage.Controller!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Controller:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},storagemodule.NimbleStorage.Controller)):'',!hideStorageDetails&&storagemodule.NimbleStorage.Capacities!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Capacity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},storagemodule.NimbleStorage.Capacities)):'',!hideStorageDetails&&storagemodule.NimbleStorage.Caches!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:'center',fontWeight:fntwght},className:'secondary'},'Cache:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},storagemodule.NimbleStorage.Caches)):'');}):'');}},{key:'renderHost',value:function renderHost(Hdngwid,Datawid,txtalgn,fntwght){var roleServer=this.props.preview.roles.serverRoles.serverRole;if(!Array.isArray(roleServer))roleServer=[roleServer];roleServer.forEach(function(element){labelsTobeBold.push(element.roleName);});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:'center'}},'Recommended'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:txtalgn}},'Host Configuration'),roleServer.map(function(serverRole){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',textAlign:'center',fontWeight:fntwght,lineHeight:'3rem'},className:'secondary'},serverRole.roleName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Server:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.server)),serverRole.vSANReadyNode!=undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Ready Node:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.vSANReadyNode)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Number of Servers:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.noOfserver)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Processor Model:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.CPUModel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Required Ram:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.memoryPerServer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Local Boot Drive Count:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.localBootDrive)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Local Boot Drive Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},serverRole.localBootDriveType)));})));}},{key:'renderStorage',value:function renderStorage(Hdngwid,Datawid,txtalgn,fntwght){if(this.props.preview.roles.storage===undefined||this.props.preview.roles.storage===null)return'';var volumes=this.props.preview.roles.storage.volumes;if(volumes!==undefined&&!Array.isArray(volumes.volume))volumes.volume=[volumes.volume];var frames=this.props.preview.roles.storage.frames;if(frames!==undefined&&!Array.isArray(frames.frame))frames.frame=[frames.frame];var NimbleStorage=this.props.preview.roles.storage.NimbleStorage;if(NimbleStorage!==undefined&&!Array.isArray(NimbleStorage))NimbleStorage=[NimbleStorage];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:txtalgn}},'Storage Configuration'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Storage Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.preview.roles.storage.storageType)),this.props.preview.roles.storage.arrayModel!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Array Model:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},this.props.preview.roles.storage.arrayModel)):'',volumes!==undefined?volumes.volume.map(function(vol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Volume Name:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.volumeName)),vol.lunType!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Lun Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.lunType)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.disk)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.diskQty)),vol.raidLevel!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Raid Level:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.raidLevel)):'');}):'',frames!==undefined?frames.frame.map(function(frm){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Frame Name:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},frm.frameName)),frm.volumes.volume!==undefined&&Array.isArray(frm.volumes.volume)?frm.volumes.volume.map(function(vol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Volume Name:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.volumeName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.disk)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},vol.diskQty)));}):frm.volumes.volume!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Volume Name:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},frm.volumes.volume.volumeName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Type:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},frm.volumes.volume.disk)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Disk Quantity:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},frm.volumes.volume.diskQty))):'');}):'',NimbleStorage!==undefined?NimbleStorage.map(function(nimbleStorage){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Controller:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},nimbleStorage.Controller)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Capacities:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},nimbleStorage.Capacities)),nimbleStorage.Caches!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Caches:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},nimbleStorage.Caches)):'',nimbleStorage.CapacitiesExpansions!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Capacities Expansions:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},nimbleStorage.CapacitiesExpansions)):'',nimbleStorage.Networking!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Hdngwid,textAlign:txtalgn,fontWeight:fntwght},className:'secondary'},'Networking:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:Datawid,textAlign:txtalgn},className:'secondary'},nimbleStorage.Networking)):'');}):'')));}},{key:'render',value:function render(){var Hdngwid='35%';var Datawid='65%';var txtalgn='left';var fntwght='600';var host=undefined;var storage=undefined;var previewGP=undefined;var sizermode='';if(this.props.workload!==undefined){if(this.props.workload.Workload!==undefined)sizermode=this.props.workload.Workload.UserInputs.SizerMode;else sizermode=this.props.workload.UserInputs.SizerMode;}if(sizermode!==__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["f" /* GPELEMENT */]){host=this.renderHost(Hdngwid,Datawid,txtalgn,fntwght);storage=this.renderStorage(Hdngwid,Datawid,txtalgn,fntwght);}else previewGP=this.renderGPElement(Hdngwid,Datawid,txtalgn,fntwght);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:ID_SOLUTION_PREVIEW},host,storage,previewGP);}}]);return SolutionPreviewSynergy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SolutionPreviewSAP=function(_Component4){_inherits(SolutionPreviewSAP,_Component4);function SolutionPreviewSAP(){_classCallCheck(this,SolutionPreviewSAP);var _this7=_possibleConstructorReturn(this,(SolutionPreviewSAP.__proto__||Object.getPrototypeOf(SolutionPreviewSAP)).call(this));_this7.renderSAPSolPreview=function(){var ProdCentralServerContent;var TestQASysContent;var TrainingSystem;var DevSysContent;var SandBoxContent;var roleServers;if(_this7.props.SAPSolPreview&&!Array.isArray(_this7.props.SAPSolPreview)){roleServers=[_this7.props.SAPSolPreview];}if(roleServers===undefined){return'';}if(!Array.isArray(_this7.props.SAPSolPreview.SolutionPreview.roles.serverRoles)){_this7.props.SAPSolPreview.SolutionPreview.roles.serverRoles=[_this7.props.SAPSolPreview.SolutionPreview.roles.serverRoles];}{roleServers.map(function(sol){return sol.SolutionPreview.roles.serverRoles.map(function(serverRole){return serverRole.serverRole.roleName==='ProdCentralServer'||serverRole.serverRole.roleName==='ProdCentralCluster'?ProdCentralServerContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{borderBottom:'1px solid rgba(0,0,0,.15)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',marginLeft:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontWeight:'600',margin:'10px 0'}},serverRole.serverRole.roleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.server)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Model:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUModel)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'SAPS:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.SAPS)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Data Base Size:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.DataBaseSize)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Configuration Type:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.ConfigurationType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'DB Server CPU Capacity:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.DBServerCPUCapacity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Data Base Type:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.DataBaseType)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Operating System:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.OperatingSystem))):'';});});}{roleServers.map(function(sol){return sol.SolutionPreview.roles.serverRoles.map(function(serverRole){return serverRole.serverRole.roleName==='Test/Quality Assurance System'?TestQASysContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{borderBottom:'1px solid rgba(0,0,0,.15)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',marginLeft:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontWeight:'600',margin:'10px 0'}},serverRole.serverRole.roleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.server)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUPercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Storage Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.StoragePercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Model:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUModel))):'';});});}// {
//     roleServers.map(sol =>
//         sol.SolutionPreview.roles.serverRoles.map(serverRole =>
//             serverRole.serverRole.roleName === 'Test/Quality Assurance System' ? TestQASysContent = <Box Pad={{ between: "small" }} style={{ width: '100%' }} separator='horizontal'>
//                 <Box direction="row">
//                     <Box style={{ width: '100%', marginLeft: '25%' }} className='secondary'><b>Role Name:</b> {serverRole.serverRole.roleName}</Box>
//                 </Box>
//                 <Box direction="row">
//                     <Box style={{ width: '100%' }} className='secondary'><b>Server:</b></Box>
//                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.Server}</Box>
//                 </Box>
//                 <Box direction="row">
//                     <Box style={{ width: '100%' }} className='secondary'><b>CPU Percentage:</b></Box>
//                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUPercentage}</Box>
//                 </Box>
//                 <Box direction="row">
//                     <Box style={{ width: '100%' }} className='secondary'><b>Storage Percentage:</b></Box>
//                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.StoragePercentage}</Box>
//                 </Box>
//                 <Box direction="row">
//                     <Box style={{ width: '100%' }} className='secondary'><b>CPU Model:</b></Box>
//                     <Box style={{ width: '100%' }} className='secondary'>{serverRole.serverRole.CPUModel}</Box>
//                 </Box>
//             </Box> : '')
//     )
// }
{roleServers.map(function(sol){return sol.SolutionPreview.roles.serverRoles.map(function(serverRole){return serverRole.serverRole.roleName==='Training System'?TrainingSystem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{borderBottom:'1px solid rgba(0,0,0,.15)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',marginLeft:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontWeight:'600',margin:'10px 0'}},serverRole.serverRole.roleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.server)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUPercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Storage Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.StoragePercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Model:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUModel))):'';});});}{roleServers.map(function(sol){return sol.SolutionPreview.roles.serverRoles.map(function(serverRole){return serverRole.serverRole.roleName==='Development System'?DevSysContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{borderBottom:'1px solid rgba(0,0,0,.15)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',marginLeft:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontWeight:'600',margin:'10px 0'}},serverRole.serverRole.roleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.server)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUPercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Storage Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.StoragePercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Model:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUModel))):'';});});}{roleServers.map(function(sol){return sol.SolutionPreview.roles.serverRoles.map(function(serverRole){return serverRole.serverRole.roleName==='Sandbox System'?SandBoxContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{borderBottom:'1px solid rgba(0,0,0,.15)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%',marginLeft:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontWeight:'600',margin:'10px 0'}},serverRole.serverRole.roleName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.server)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUPercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Storage Percentage:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.StoragePercentage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'CPU Model:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.CPUModel))):'';});});}roleServers[0].SolutionPreview.roles.serverRoles.forEach(function(element){labelsTobeBold.push(element.serverRole.roleName);});return[ProdCentralServerContent,TestQASysContent,TrainingSystem,DevSysContent,SandBoxContent];};return _this7;}_createClass(SolutionPreviewSAP,[{key:'render',value:function render(){var host=this.renderSAPSolPreview();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:ID_SOLUTION_PREVIEW},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:'center'}},'Recommended'),host)));}}]);return SolutionPreviewSAP;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SolutionPreviewSAPHANA=function(_Component5){_inherits(SolutionPreviewSAPHANA,_Component5);function SolutionPreviewSAPHANA(){_classCallCheck(this,SolutionPreviewSAPHANA);var _this8=_possibleConstructorReturn(this,(SolutionPreviewSAPHANA.__proto__||Object.getPrototypeOf(SolutionPreviewSAPHANA)).call(this));_this8.renderSAPHANASolPreview=function(){var ProdCentralServerContent;var TestQASysContent;var TrainingSystem;var DevSysContent;var SandBoxContent;var roleServers;if(_this8.props.SAPHANASolPreview&&!Array.isArray(_this8.props.SAPHANASolPreview)){roleServers=[_this8.props.SAPHANASolPreview];}if(roleServers===undefined){return'';}roleServers[0].SolutionPreview.roles.serverRoles.forEach(function(element){labelsTobeBold.push(element.serverRole.roleName);});return roleServers.map(function(solpre){return solpre.SolutionPreview.roles.serverRoles.map(function(serverRole){return(// serverRole.serverRole.roleName === 'Production Environment' ? ProdCentralServerContent = 
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{width:'100%',fontWeight:'600',textAlign:'center',borderBottom:'1px solid rgba(0,0,0,.15)',margin:'10px 0'}},serverRole.serverRole.roleName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.serverPlatform)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Processor Quantity :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.processorQuantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Processor Model :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.processorList)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Processor Family :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.processorFamily)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Memory (GB) :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.memoryList))));});});};return _this8;}_createClass(SolutionPreviewSAPHANA,[{key:'render',value:function render(){var host=this.renderSAPHANASolPreview();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:ID_SOLUTION_PREVIEW},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:'center'}},'Recommended'),host)));}}]);return SolutionPreviewSAPHANA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SolutionPreviewSAPTDI=function(_Component6){_inherits(SolutionPreviewSAPTDI,_Component6);function SolutionPreviewSAPTDI(){_classCallCheck(this,SolutionPreviewSAPTDI);var _this9=_possibleConstructorReturn(this,(SolutionPreviewSAPTDI.__proto__||Object.getPrototypeOf(SolutionPreviewSAPTDI)).call(this));_this9.renderSAPTDISolPreview=function(){var ProdCentralServerContent;var TestQASysContent;var TrainingSystem;var DevSysContent;var SandBoxContent;var roleServers;if(_this9.props.SAPTDISolPreview&&!Array.isArray(_this9.props.SAPTDISolPreview)){roleServers=[_this9.props.SAPTDISolPreview];}if(roleServers===undefined){return'';}roleServers[0].SolutionPreview.roles.serverRoles.forEach(function(element){labelsTobeBold.push(element.serverRole.roleName);});return roleServers.map(function(solpre){return solpre.SolutionPreview.roles.serverRoles.map(function(serverRole){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{Pad:{between:"small"},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{width:'100%',fontWeight:'600',textAlign:'center',borderBottom:'1px solid rgba(0,0,0,.15)',margin:'10px 0'}},serverRole.serverRole.roleName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Server :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.serverPlatform)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Processor Quantity :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.processorQuantity)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Processor Model :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.processorList)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Processor Family :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.processorFamily)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Memory (GB) :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'},className:'secondary'},serverRole.serverRole.memoryList)));});});};return _this9;}_createClass(SolutionPreviewSAPTDI,[{key:'render',value:function render(){var host=this.renderSAPTDISolPreview();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:ID_SOLUTION_PREVIEW},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_List___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{direction:'column',separator:'horizontal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{separator:'horizontal',style:{fontWeight:'600',textAlign:'center'}},'Recommended'),host)));}}]);return SolutionPreviewSAPTDI;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SolutionPreview=function(_Component7){_inherits(SolutionPreview,_Component7);function SolutionPreview(){_classCallCheck(this,SolutionPreview);var _this10=_possibleConstructorReturn(this,(SolutionPreview.__proto__||Object.getPrototypeOf(SolutionPreview)).call(this));_this10.closeSolutionPreview=_this10.closeSolutionPreview.bind(_this10);_this10.createPreviewArray=_this10.createPreviewArray.bind(_this10);return _this10;}_createClass(SolutionPreview,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.isFromExternalApp){getSSETData=true;}if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='SAP'){var value={"Workload":this.props.workload};var data={Workload:value,name:''};this.props.sapSolPreview(data);}else if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='SAPHANA'){var data={Workload:this.props.workload};if(this.props.workload.UserInputs.Environments.WorkloadType==='SAPHANA'){this.props.sapHanaSolPreview(data);}else{this.props.sapTdiSolPreview(data);}}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(!this.props.UserInputs){if(this.props.isFromExternalApp){var queryParameter=__WEBPACK_IMPORTED_MODULE_3_query_string___default.a.parse(window.location.search);var userData={"reference":queryParameter.reference,"isSizerAsEntry":queryParameter.isSizerAsEntry?true:false};if(nextProps.sessionDefaults.workload&&getSSETData){getSSETData=false;this.props.getSSETData(userData);}}if(nextProps.activeSession&&nextProps.activeSession.workload){var obj="";if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='SynergySizer'){obj={"Workload":nextProps.activeSession.workload};}else{obj=nextProps.activeSession.workload;}if(nextProps.activeSession.workload.UserInputs.SizerMode!==__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["f" /* GPELEMENT */])this.props.onNewSession(obj);}}}},{key:'closeSolutionPreview',value:function closeSolutionPreview(){this.props.onClose();}},{key:'redirectUrl',value:function redirectUrl(){console.log('redirecting to SSET');window.location.replace(this.props.externalAppProps.ssetUrl);}},{key:'createPreviewArray',value:function createPreviewArray(splitTitle){var solArr=[];var nextString='';for(var i=0;i<splitTitle.length;i++){if(splitTitle[i]===nextString)continue;if(splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].SERVER||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].PROCESSOR||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].MEMORY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].NUMSERVER||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].PROCMODEL||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].REQRAM||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].LOCALBOOTDRIVECOUNT||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].LOCALBOOTDRIVETYPE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].STORAGETYPE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].VOLNAME||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].DISK||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].DISKQTY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CONTROLLER||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CAPACITIES||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CACHES||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].NETWORKING||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CAPACITY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].CACHE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FRAMENAME||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].DISKTYPE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].ARRAYMODEL||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].LUNTYPE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].RAIDLEVEL||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].MODULE){nextString=splitTitle[i+1];solArr.push(splitTitle[i]+' '+splitTitle[i+1]);}else solArr.push(splitTitle[i]);}return solArr;}},{key:'createPreviewArrayForSAP',value:function createPreviewArrayForSAP(splitTitle){var solArr=[];var nextString='';for(var i=0;i<splitTitle.length;i++){if(splitTitle[i]===nextString)continue;if(splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].SERVER||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].PROCESSOR_QUANTITY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].PROCESSOR_MODEL||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].PROCESSOR_FAMILY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].MEMORY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].CPU_MODEL||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].SAPS||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].DATABASE_SIZE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].CONFIG_TYPE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].DB_SERVER_CPU_CAPACITY||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].DATABSE_TYPE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].OPERATING_SYSTEM||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].CPU_PERCENTAGE||splitTitle[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].STORAGE_PERCENTAGE){nextString=splitTitle[i+1];if(nextString.indexOf(':')>-1){nextString='';solArr.push(splitTitle[i]+' '+'');}else{solArr.push(splitTitle[i]+' '+splitTitle[i+1]);}}else solArr.push(splitTitle[i]);}return solArr;}},{key:'DownloadasPDF',value:function DownloadasPDF(){var pdfName=void 0;if(this.props.isFromExternalApp){pdfName=SOLUTION_PREVIEW;}else{if(this.props.activeSession){pdfName=this.props.activeSession.alias;}else{pdfName=SOLUTION_PREVIEW;}}pdfName+=" "+Date().substr(4).split('GMT')[0]+".pdf";if(CS750SizerSaid.indexOf(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */])>-1){var strHTML=document.querySelector('#'+ID_SOLUTION_PREVIEW).innerText;var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a();var splitTitle=doc.splitTextToSize(strHTML,270);var arrPre=this.createPreviewArray(splitTitle);var pageWidth=doc.internal.pageSize.getWidth();doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTSIZE_11);var y=30;var HeaderImg=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["v" /* imageProperties */].logoWithName;doc.addImage(HeaderImg,'PNG',10,5,30,10);var FooterImg=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["v" /* imageProperties */].logoUrl;for(var i=0;i<arrPre.length;i++){if(y>280){y=30;doc.addPage();doc.addImage(HeaderImg,'PNG',10,5,30,10);}if(labelsTobeBold.indexOf(arrPre[i])>-1){if(arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].RECOMMENDED){doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTSIZE_14);doc.text(arrPre[i],pageWidth/2-20,y);}else if(arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].HOSTCONFIG||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].STORAGECONFIG){doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTSIZE_14);doc.text(arrPre[i],pageWidth/2-25,y);}else{doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTTYPE_BOLD);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTSIZE_12);doc.text(arrPre[i],15,y);}}else{doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["s" /* SYNERGYSOLUTIONPREVIEWVARIABLES */].FONTSIZE_11);doc.text(arrPre[i],15,y);}doc.addImage(FooterImg,'PNG',0,280,40,20);y=y+7;}doc.save(pdfName);return;}else if(SAPSizerSaid.indexOf(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */])>-1){var strHTML=document.querySelector('#'+ID_SOLUTION_PREVIEW).innerText;var doc=new __WEBPACK_IMPORTED_MODULE_5_jspdf___default.a();var splitTitle=doc.splitTextToSize(strHTML,270);var arrPre=this.createPreviewArrayForSAP(splitTitle);var pageWidth=doc.internal.pageSize.getWidth();doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTSIZE_11);var y=30;var HeaderImg=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["v" /* imageProperties */].logoWithName;doc.addImage(HeaderImg,'PNG',10,5,30,10);var FooterImg=__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["v" /* imageProperties */].logoUrl;for(var i=0;i<arrPre.length;i++){if(y>280){y=30;doc.addPage();doc.addImage(HeaderImg,'PNG',10,5,30,10);}if(labelsTobeBold.indexOf(arrPre[i])>-1){if(arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].RECOMMENDED){doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTSIZE_14);doc.text(arrPre[i],pageWidth/2-20,y);}else if(arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_PRODUCITON_ENVIRONMENT||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_APPLICATION_ENVIRONMENT||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_PROD_CENTRAL_SERVER||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_TEST_ASSURANCE_SYSTEM||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_TRAINING_SYSTEM||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_DEVELOPMENT_SYSTEM||arrPre[i]===__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].ROLE_SANDBOX_SYSTEM){doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTTYPE_BOLD);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTSIZE_12);doc.text(arrPre[i],pageWidth/2-25,y);}else{doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTTYPE_BOLD);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTSIZE_12);doc.text(arrPre[i],15,y);}}else{doc.setFontType(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTTYPE_NORMAL);doc.setFontSize(__WEBPACK_IMPORTED_MODULE_19__State_constants_CommonConstants__["n" /* SAPSOLUTIONPREVIEWVARIABLES */].FONTSIZE_11);doc.text(arrPre[i],15,y);}doc.addImage(FooterImg,'PNG',0,280,40,20);y=y+7;}doc.save(pdfName);return;}var value={"Workload":this.props.workload};var data={Workload:value,name:pdfName};this.props.onPDFExport(data);}},{key:'render',value:function render(){var _this11=this;var content='';var displayDownloadButton=false;if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='EPAvNext'&&this.props.workload&&this.props.UserInputs){if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SolutionPreviewBigData,{onClose:this.closeSolutionPreview,workload:this.props.workload});}else if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SolutionPreviewBlue,{isFromExternalApp:this.props.isFromExternalApp,onClose:this.closeSolutionPreview,workload:this.props.workload});displayDownloadButton=true;}}else if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==="SAP"){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SolutionPreviewSAP,{onClose:this.closeSolutionPreview,workload:this.props.workload,SAPSolPreview:this.props.SAPSolPreview});displayDownloadButton=true;}else if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='SAPHANA'&&this.props.workload.UserInputs.Environments.WorkloadType==="SAPHANA"){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SolutionPreviewSAPHANA,{onClose:this.closeSolutionPreview,workload:this.props.workload,SAPHANASolPreview:this.props.SAPHANASolPreview});displayDownloadButton=true;}else if(__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='SAPHANA'&&this.props.workload.UserInputs.Environments.WorkloadType==="TDI"){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SolutionPreviewSAPTDI,{onClose:this.closeSolutionPreview,workload:this.props.workload,SAPTDISolPreview:this.props.SAPTDISolPreview});displayDownloadButton=true;}else if((__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_18__AppConfig__["f" /* said */]==='SynergySizer')&&this.props.workload&&this.props.UserInputs){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SolutionPreviewSynergy,{onClose:this.closeSolutionPreview,workload:this.props.workload,preview:this.props.SynergyPreview});displayDownloadButton=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{height:'98%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{colorIndex:'light-2',direction:'row',align:'start',pad:'none',separator:'left',style:{height:'98%',width:'100%',overflowY:'auto',position:'absolute',right:'0px',top:'0px',zIndex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Animate___default.a,{enter:{"animation":"slide-left","duration":200,"delay":0},leave:{"animation":"slide-left","duration":200,"delay":0},keep:true,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{backgroundColor:'#28ab8c'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{width:"95%",padding:'5px',color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Heading___default.a,{tag:'h4',align:'center',margin:'none',position:'fixed',width:'100%',strong:true},'Solution Preview')),this.props.isFromExternalApp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_Button___default.a,{id:'backToSSETyes',primary:false,plain:true,style:{position:'absolute',right:'0',color:'white'}/* icon={<Revert size="small" colorIndex='accent-3' />} */,label:'Close',onClick:function onClick(){_this11.redirectUrl();},className:'ReverseSavewrkloadbtn'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:'informationiconbox',style:{marginTop:"5px"},direction:'row',margin:'none',pad:'none',justify:'end',onClick:function onClick(){return _this11.props.onClose();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose___default.a,{size:'small'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,content),displayDownloadButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{alignItems:'center',padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_Button___default.a,{primary:false,label:'Save as PDF',onClick:function onClick(){return _this11.DownloadasPDF('pdf');}}))))));}}]);return SolutionPreview;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var userInputs=undefined;var workload=undefined;if(state.sizerWorkload.workload!==undefined){workload=state.sizerWorkload.workload;if(state.sizerWorkload.workload.Workload!==undefined)userInputs=state.sizerWorkload.workload.Workload.UserInputs;else userInputs=state.sizerWorkload.workload.UserInputs;}else if(state.sessions.activeSession.workload!==undefined){workload=state.sessions.activeSession.workload;userInputs=state.sessions.activeSession.workload.UserInputs;}var _SynergyPreview='';if(state.sizerWorkload.workload!==undefined&&state.sizerWorkload.workload.Workload!==undefined&&state.sizerWorkload.workload.Workload.UserInputs.SolutionPreview!==undefined)_SynergyPreview=state.sizerWorkload.workload.Workload.UserInputs.SolutionPreview;else if(state.sessions.activeSession.workload!==undefined&&state.sessions.activeSession.workload.UserInputs!==undefined&&state.sessions.activeSession.workload.UserInputs.SolutionPreview!==undefined)_SynergyPreview=state.sessions.activeSession.workload.UserInputs.SolutionPreview;return{//workload: state.sizerWorkload.workload,
workload:workload,ServiceError:state.sizerWorkload,GPUdetailsforcore:state.sessions.activeSession,activeSession:state.sessions.activeSession,SSETid:state.sessions.SSETid,UserInputs:userInputs,//UserInputs: state.sizerWorkload.workload.UserInputs,
sessionDefaults:state.sessions.sessionDefaults,stateObject:state,SynergyPreview:_SynergyPreview,SAPSolPreview:state.sessions.SAPSolPreview,SAPHANASolPreview:state.sessions.SAPHANASolPreview,SAPTDISolPreview:state.sessions.SAPTDISolPreview};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{sapSolPreview:function sapSolPreview(workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["O" /* sapSolPreview */])(workload));},sapHanaSolPreview:function sapHanaSolPreview(workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["N" /* sapHanaSolPreview */])(workload));},sapTdiSolPreview:function sapTdiSolPreview(workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["P" /* sapTdiSolPreview */])(workload));},getSSETData:function getSSETData(userData){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["I" /* loadSessionfromSSET */])(userData));},onUpdateActiveSession:function onUpdateActiveSession(workload){dispatch({type:'UPDATE_Active_WORKLOAD',payload:workload});},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});},onPDFExport:function onPDFExport(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["o" /* downloadSolutionPreview */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolutionPreview));

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return redirectToSSET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clearSSETDataAndRedirect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppConfig__ = __webpack_require__(13);
var url=__WEBPACK_IMPORTED_MODULE_0__AppConfig__["g" /* serviceUrl */]+'API/ExternalSizing/GetSSETUrl';var deleteUrl=__WEBPACK_IMPORTED_MODULE_0__AppConfig__["g" /* serviceUrl */]+'API/ExternalSizing/DeleteGuidance';var successString='SUCCESS';var tokenId='__antiForgeryToken';var getHeaders=function getHeaders(){var antiForgeryTokenField=document.getElementById(tokenId);//Creating headers only once
var myHeaders=new Headers();myHeaders.append("Content-Type","application/json");myHeaders.append("Cache","no-cache");myHeaders.append("CSRFToken",antiForgeryTokenField.value);return myHeaders;};var redirectToSSET=function redirectToSSET(id,isReviewed){var attribute='?&reviewed=';var isTrue='true';var isFalse='false';if(isReviewed){url+=attribute+isTrue;}else{url+=attribute+isFalse;}var verb='GET';fetch(url,{method:verb,headers:getHeaders(),credentials:'same-origin'}).then(function(response){return response.json();}).then(function(data){window.location.replace(data+id.trim());});};var clearSSETDataAndRedirect=function clearSSETDataAndRedirect(userId,id,isReviewed){var payload=[{"guidanceId":id,"userEmail":userId}];var raw=JSON.stringify(payload);var verb='POST';var requestOptions={method:verb,headers:getHeaders(),body:raw,credentials:'same-origin'};fetch(deleteUrl,requestOptions).then(function(response){return response.json();}).then(function(result){if(result.status.toUpperCase()===successString){redirectToSSET(id,isReviewed);}}).catch(function(error){return console.log(error);});};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(341);
module.exports = __webpack_require__(346);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(342).enable();
  window.Promise = __webpack_require__(344);
}

// fetch() polyfill for making API calls.
__webpack_require__(345);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(108);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(203);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(203);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 345 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_store__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scss_index_scss__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__scss_index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MyApp__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArrayFind__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ArrayFind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ArrayFind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ArrayFindIndex__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ArrayFindIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ArrayFindIndex__);
//import App from './Test';
var element=document.getElementById('Bodycontent');var render=function render(){__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_2__State_store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__MyApp__["a" /* default */],null)),element);};__WEBPACK_IMPORTED_MODULE_2__State_store__["a" /* default */].subscribe(render);render();document.body.classList.remove('loading');__WEBPACK_IMPORTED_MODULE_4_jquery___default()(window).on("navigate",function(event){event.preventDefault();window.history.forward(1);});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(108),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.13.1";


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(108),r=__webpack_require__(349);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.13.1",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.13.1";


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(350);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducers_root__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__middlewares_log__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middlewares_api__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middlewares_error__ = __webpack_require__(462);
// import sessionsReducer from './reducers/sessions';
var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_1__reducers_root__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_3__middlewares_api__["a" /* default */],__WEBPACK_IMPORTED_MODULE_2__middlewares_log__["a" /* default */],__WEBPACK_IMPORTED_MODULE_4__middlewares_error__["a" /* default */]));window.store=store;/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(356);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(354);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(206);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(358);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(362);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(361)(module)))

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(207);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(208);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sessions__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__workloads__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__solutions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__authentication__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SizerUI_Redux_reducers_sizerWorkload__ = __webpack_require__(457);
//  import csvirtualsizer  from '../../SizerUI/Redux/reducers/CSVirtualSizer';
//  import nimble from '../../SizerUI/Redux/reducers/nimble';
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({sessions:__WEBPACK_IMPORTED_MODULE_1__sessions__["a" /* default */],workloads:__WEBPACK_IMPORTED_MODULE_2__workloads__["a" /* default */],solutions:__WEBPACK_IMPORTED_MODULE_3__solutions__["a" /* default */],auth:__WEBPACK_IMPORTED_MODULE_4__authentication__["a" /* default */],//  csvirtualsizer,
//  nimble,                                      
sizerWorkload:__WEBPACK_IMPORTED_MODULE_5__SizerUI_Redux_reducers_sizerWorkload__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_prototype_find__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_array_prototype_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_array_prototype_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Datafiles_DrivesList_json__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Datafiles_DrivesList_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Datafiles_DrivesList_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonLogic__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__ = __webpack_require__(32);
var initialState={EULAPopUpState:true,activeSession:'',sessions:[],sessionDefaults:{workload:'',inputs:'',whatsNew:'',additionalInfo:'',Countries:'',blueDataWorkload:''},notifications:null,responseMsg:[],userData:[],RABOM:'',Saveworkloadopened:false,sessionCount:0,isLoading:false,LoadingMsg:'',feedback:{response:''},Country:'United States',overrideMsg:{isEnabled:false,msg:''},overrideSolMsg:{isEnabled:false,msg:''},notificationMsg:{isEnabled:false,msg:''},showNotifications:{enabled:false},redirect:{isEnabled:false,path:''},SSETid:undefined,SSETUrl:undefined,networkError:{isError:false,msg:'',ssetUrl:''},ssetConfigurations:{reviewed:false//CompareData:null
}};var defaultStorageNetworkSpeedObject={"#text":"100G","@isSelected":"no"};var driveList=__WEBPACK_IMPORTED_MODULE_1__Datafiles_DrivesList_json___default.a;var EPA_WORKLOADTYPES=["BigData","BlueData"];var tRUE_="true";var fALSE_="false";var NONE_="None";var EPIC_="EPIC";var GATEWAY="Gateway";var STORAGE="Storage";var MINIFI="MiNifi";var KUBERNETES_CM="Kubernetes CM";var GROWTH2YRole='(Growth - 2Y)';var GROWTH3YRole='(Growth - 3Y)';var GROWTH4YRole='(Growth - 4Y)';var epaLoadSolutionUpdates=function epaLoadSolutionUpdates(action){function createDataDiskArray(drive,workloadType){var volumeName="Persistent";if(workloadType===EPA_WORKLOADTYPES[0]){volumeName="Data_0";}var DataDiskArray=[{Item:{'@disk':drive.Item["@disk"],'@qty':drive.Item["@qty"],"@volumeName":volumeName}}];return DataDiskArray;}function updateDriveDescription(role){var index1=driveList.BlueData.Server.findIndex(function(drive){return drive["Name"]===role["@Name"]&&drive["OldDesc"]===role["@NodeDisk"];});if(index1>-1){role["@NodeDisk"]=driveList.BlueData.Server[index1]["NewDesc"];}if(role["@Type"]!==GATEWAY){var index2=driveList.BlueData.Server.findIndex(function(drive){return drive["Name"]===role["@Name"]&&drive["OldDesc"]===role["@TStorageDrive"];});if(index2>-1){role["@TStorageDrive"]=driveList.BlueData.Server[index2]["NewDesc"];}}var index3=driveList.BlueData.Server.findIndex(function(drive){return drive["Name"]===role["@Name"]&&drive["OldDesc"]===role["@OSDisk"];});if(index3>-1){role["@OSDisk"]=driveList.BlueData.Server[index3]["NewDesc"];}if(role["@Type"]===STORAGE){role.PersistentDisks.map(function(persistentDrive){var index=driveList.BlueData.Server.findIndex(function(drive){return drive["Name"]===role["@Name"]&&drive["OldDesc"]===persistentDrive.Item["@disk"];});if(index>-1){persistentDrive.Item["@disk"]=driveList.BlueData.Server[index]["NewDesc"];}});}}function updateDriveDescriptionEPA(service){var tagName="@Server";if(service["@Type"]===MINIFI){tagName="@ServerName";}var index1=driveList.BigData.Server.findIndex(function(drive){return drive["Name"]===service.Hardware[tagName]&&drive["OldDesc"]===service.Hardware["@DataDisk"];});if(index1>-1){service.Hardware["@DataDisk"]=driveList.BigData.Server[index1]["NewDesc"];}var index2=driveList.BigData.Server.findIndex(function(drive){return drive["Name"]===service.Hardware[tagName]&&drive["OldDesc"]===service.Hardware["@OSDisk"];});if(index2>-1){service.Hardware["@OSDisk"]=driveList.BigData.Server[index2]["NewDesc"];}if(Array.isArray(service.DataDisks)){service.DataDisks.map(function(dataDrive){var index=driveList.BigData.Server.findIndex(function(drive){return drive["Name"]===service.Hardware[tagName]&&drive["OldDesc"]===dataDrive.Item["@disk"];});if(index>-1){dataDrive.Item["@disk"]=driveList.BigData.Server[index]["NewDesc"];}});}}if(action.payload.Workload.UserInputs.Country===undefined){action.payload.Workload.UserInputs.Country=action.payload.Workload.UserInputs.Environments.Country;}if(action.payload.Workload.UserInputs.Environments.WorkloadType===EPA_WORKLOADTYPES[1]){if(action.payload.Workload.UserInputs.Environments.isWLorSLLoaded===undefined){action.payload.Workload.UserInputs.Environments.isWLorSLLoaded=tRUE_;}if(action.payload.Workload.UserInputs.Environments.displayNotePersistentDriveChange===undefined){action.payload.Workload.UserInputs.Environments.displayNotePersistentDriveChange=fALSE_;}if(action.payload.Workload.UserInputs.Environments.ManagementHosts){if(Array.isArray(action.payload.Workload.UserInputs.Environments.ManagementHosts.Server)){Object(__WEBPACK_IMPORTED_MODULE_2__commonLogic__["b" /* updateVMWareOption */])(action.payload.Workload.UserInputs.Environments.ManagementHosts.Server);}}if(action.payload.Workload.UserInputs.Environments.Growth){if(!Array.isArray(action.payload.Workload.UserInputs.Environments.Growth.Host)){var oldGrowthObject=action.payload.Workload.UserInputs.Environments.Growth.Host;action.payload.Workload.UserInputs.Environments.Growth.Host=[];action.payload.Workload.UserInputs.Environments.Growth.Host.push(oldGrowthObject);}}if(action.payload.Workload.UserInputs.Environments.Templates&&action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4]){if(action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4]["@Type"]==="Storage"){if(action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4].PersistentDisks){var persistentDrivesList=action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4].PersistentDisks;if(!Array.isArray(persistentDrivesList)){action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server[4].PersistentDisks=createDataDiskArray(persistentDrivesList,EPA_WORKLOADTYPES[1]);}}}}if(Array.isArray(action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){if(action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.findIndex(function(license){return license["@Type"]===KUBERNETES_CM;})===-1){var endIndex=action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.length;var IsSelected=tRUE_;if(action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration['@Type']===EPIC_){IsSelected=fALSE_;}action.payload.Workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[endIndex]={"@Type":KUBERNETES_CM,"@IsSelected":IsSelected,"@Description":NONE_};}}if(action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed===undefined||action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed&&typeof action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed==="string"){action.payload.Workload.UserInputs.Environments.Licenses.StorageNetworkSpeed=defaultStorageNetworkSpeedObject;}action.payload.Workload.UserInputs.Environments.Templates&&action.payload.Workload.UserInputs.Environments.Templates.ServerDetails.Server.map(function(role){updateDriveDescription(role);});}if(action.payload.Workload.UserInputs.Environments.WorkloadType===EPA_WORKLOADTYPES[0]){if(action.payload.Workload.UserInputs.Environments.Functions.Function){action.payload.Workload.UserInputs.Environments.Functions.Function.map(function(Function){if(Array.isArray(Function.Service)){Function.Service.map(function(service){if(service.DataDisks){if(!Array.isArray(service.DataDisks)){service.DataDisks=createDataDiskArray(service.DataDisks,EPA_WORKLOADTYPES[0]);}}updateDriveDescriptionEPA(service);});}else{if(Function.Service.DataDisks){if(!Array.isArray(Function.Service.DataDisks)){Function.Service.DataDisks=createDataDiskArray(Function.Service.DataDisks,EPA_WORKLOADTYPES[0]);}}updateDriveDescriptionEPA(Function.Service);}});}if(action.payload.TreeView&&action.payload.TreeView.Solutions.Solution){if(action.payload.TreeView.Solutions.Solution["@FirstRole"]){if(action.payload.TreeView.Solutions.Solution["@FirstRole"].indexOf(__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["i" /* HDFS_ */])>-1){action.payload.TreeView.Solutions.Solution["@FirstRole"]=action.payload.TreeView.Solutions.Solution["@FirstRole"].replace(__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["i" /* HDFS_ */],__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["b" /* DATA_LAKE */]);}}if(action.payload.TreeView.Solutions.Solution.Roles){if(action.payload.TreeView.Solutions.Solution.Roles["@FirstRole"].indexOf(__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["i" /* HDFS_ */])>-1){action.payload.TreeView.Solutions.Solution.Roles["@FirstRole"]=action.payload.TreeView.Solutions.Solution.Roles["@FirstRole"].replace(__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["i" /* HDFS_ */],__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["b" /* DATA_LAKE */]);}if(Array.isArray(action.payload.TreeView.Solutions.Solution.Roles.Role)){action.payload.TreeView.Solutions.Solution.Roles.Role.map(function(role){if(role[__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["l" /* ROLENAME_ */]]){if(role[__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["l" /* ROLENAME_ */]].indexOf(__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["i" /* HDFS_ */])>-1){role[__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["l" /* ROLENAME_ */]]=role[__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["l" /* ROLENAME_ */]].replace(__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["i" /* HDFS_ */],__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["b" /* DATA_LAKE */]);}}});}}}}return action;};var sessionsReducer=function sessionsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var allNotifications;var actvSession;switch(action.type){case'ADD_SESSION'://var currtime = new Date();
// var newAlias = currtime.getMilliseconds();
var newAlias=state.sessionCount+1;var newSession={};if(action.payload.name.indexOf('Default Session')!==0){newSession={id:action.payload.id,alias:action.payload.name,workload:'',treeView:'',bomView:'',configView:'',GRInput:'',GRBomInput:'',MetricsData:'',CompareMetricsData:'',CompareSolution:'',MultipleSolActiveTab:'',isSizeEnabled:false,globalError:{isError:false,errorMsg:''},EPAArray:[],sizingFailed:'',NonGPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:''},GPUValue:{TotalVMemory:'',TotalCore:'1',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:''},CompareData:null,SavedSolname:null,strmessage:null,FirstClik:{val:true//title:{value:"HDFS and HDFS-EC"}
}};}else{newSession={id:action.payload.id,alias:action.payload.name+' ('+newAlias+') ',workload:'',treeView:'',bomView:'',configView:'',GRInput:'',GRBomInput:'',MetricsData:'',CompareMetricsData:'',CompareSolution:'',MultipleSolActiveTab:'',isSizeEnabled:false,globalError:{isError:false,errorMsg:''},EPAArray:[],sizingFailed:'',NonGPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:''},GPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:''},CompareData:null,SavedSolname:null,strmessage:null,FirstClik:{val:true//title:{value:"HDFS and HDFS-EC"}  
}};}return Object.assign({},state,{activeSession:newSession,sessions:state.sessions.concat(newSession),sessionCount:newAlias});case'CHANGE_SESSION':return Object.assign({},state,{activeSession:__WEBPACK_IMPORTED_MODULE_0_array_prototype_find___default()(state.sessions,function(value){if(value.id===action.payload.id)return value;})});case'COUNTRY_CHANGE':return Object.assign({},state,{Country:action.payload.country});case'UPDATE_SESSION':return Object.assign({},state,{sessions:state.sessions.map(function(item){return item.id!==action.payload.session.id?item:Object.assign({},item,{alias:action.payload.session.alias});})});case'SAVE_DATA':return Object.assign({},state,{sessions:state.sessions.map(function(item){return item.id!==state.activeSession.id?item:JSON.parse(JSON.stringify(state.activeSession));})});case'OPENED_SAVEWORKLOAD':return Object.assign({},state,{Saveworkloadopened:action.payload.data});case'DELETE_SESSION':return Object.assign({},state,{sessions:state.sessions.filter(function(value,index){if(value.id!==action.payload.id)return value;}),activeSession:Object.assign({},state.activeSession,{id:action.payload.id===state.activeSession.id?'':state.activeSession.id,alias:action.payload.id===state.activeSession.id?'':state.activeSession.alias,workload:action.payload.id===state.activeSession.id?'':state.activeSession.workload,treeView:action.payload.id===state.activeSession.id?'':state.activeSession.treeView,bomView:action.payload.id===state.activeSession.id?'':state.activeSession.bomView,configView:action.payload.id===state.activeSession.id?'':state.activeSession.configView,GRInput:action.payload.id===state.activeSession.id?'':state.activeSession.GRInput,GRBomInput:action.payload.id===state.activeSession.id?'':state.activeSession.GRBomInput,MetricsData:action.payload.id===state.activeSession.id?'':state.activeSession.MetricsData,CompareMetricsData:action.payload.id===state.activeSession.id?'':state.activeSession.CompareMetricsData,CompareSolution:action.payload.id===state.activeSession.id?'':state.activeSession.CompareSolution})});case'ERROR_SESSION':// return Object.assign({}, state, {
//   globalError: action.payload.errorMsg
// });
//  return Object.assign({}, state, {
//      sessions : state.sessions.map((item) => item.id !== state.activeSession.id ? item : Object.assign({}, item, { globalError: action.payload.errorMsg }))
//  });
return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{globalError:action.payload.errorMsg})});case'TOGGLE_SIZE_BUTTON':return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{isSizeEnabled:action.payload.value})});case'EPA_ACTV_SOLN_CHANGE':var prevItem=Object.assign([],state.activeSession.EPAArray);var newEPAarr=[];var currentItem=prevItem.find(function(item){return item.treeView.Solutions.Solution.SolProfile['@ID']===state.activeSession.treeView.Solutions.Solution.SolProfile["@ID"];});currentItem.treeView=state.activeSession.treeView;currentItem.bomView=state.activeSession.bomView;currentItem.configView=state.activeSession.configView;currentItem.GRInput=state.activeSession.GRInput;currentItem.GRBomInput=state.activeSession.GRBomInput;newEPAarr=prevItem;var newitem=prevItem.find(function(item){return item.treeView.Solutions.Solution.SolProfile['@ID']===action.payload.data.actvItem.toString();});return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{EPAArray:newEPAarr,treeView:newitem.treeView,bomView:newitem.bomView,configView:newitem.configView,GRInput:newitem.GRInput,GRBomInput:newitem.GRBomInput})});case'FETCH_RA_BOM_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the RA BOM data.'});case'DOWNLOAD_FILE_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while downloading...'});case'DOWNLOAD_FILE_SUCCESS':return Object.assign({},state,{isLoading:false,LoadingMsg:''});case'FETCH_RA_BOM_SUCCESS':return Object.assign({},state,{RABOM:action.payload,isLoading:false,LoadingMsg:''});case'FETCH_DEFAULT_DATA_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while Initializing...'});case'LOAD_NOTIFICATIONS_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while checking for Notifications.'});case'LOAD_NOTIFICATIONS_SUCCESS':return Object.assign({},state,{notifications:action.payload,isLoading:false,LoadingMsg:''});case'REJECT_WLSL_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while Removing workload/solution.'});case'REJECT_WLSL_SUCCESS':allNotifications=state.notifications;for(var j=0;j<action.payload.length;j++){for(var i=0;i<allNotifications.length;i++){if(allNotifications[i].itemID===action.payload[j].itemID){allNotifications.splice(i,1);}}}return Object.assign({},state,{responseMsg:action.payload,notifications:allNotifications,isLoading:false,LoadingMsg:''});case'ACCEPT_WLSL_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while adding workload/solution.'});case'ACCEPT_WLSL_SUCCESS':allNotifications=state.notifications;for(var _j=0;_j<action.payload.length;_j++){for(var _i=0;_i<allNotifications.length;_i++){if(allNotifications[_i].itemID===action.payload[_j].itemID){allNotifications.splice(_i,1);}}}return Object.assign({},state,{responseMsg:action.payload,notifications:allNotifications,isLoading:false,LoadingMsg:''});case'FETCH_DEFAULT_DATA_SUCCESS':var bluedataWorkloadtemp=undefined;var whatsNewHPECPTag;var tdiWorkload=void 0;if(action.payload.BlueDataDefaults!==undefined){bluedataWorkloadtemp=action.payload.BlueDataDefaults.Workload;}if(action.payload.whatsNewHPECP!==undefined){whatsNewHPECPTag=action.payload.whatsNewHPECP;}if(action.payload.tdiWorkload){// action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ProductionEnvironment.ProcessorFamily.Item = action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ProductionEnvironment.ProcessorFamily.Item.filter((x)=> x==="CascadeLake");
// action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ApplicationEnvironment.ProcessorFamily.Item = action.payload.tdiWorkload.WorkLoad.UserInputs.Environments.ApplicationEnvironment.ProcessorFamily.Item.filter((x)=>x==="CascadeLake");
tdiWorkload=action.payload.tdiWorkload.WorkLoad;}return Object.assign({},state,{sessionDefaults:{workload:action.payload.workload.Workload,inputs:action.payload.input,whatsNew:action.payload.whatsNew,whatsNewHPECP:whatsNewHPECPTag,additionalInfo:action.payload.additionalInfo,Countries:action.payload.Countries,blueDataWorkload:bluedataWorkloadtemp,tdiWorkload:tdiWorkload},isLoading:false,LoadingMsg:''});case'FETCH_METRICS_DATA_PENDING':return Object.assign({},state,{isLoadingCompare:true,LoadingMsgCompare:'Please wait while fetching the Metrics data.'});case'FETCH_METRICS_DATA_SUCCESS':actvSession=state.activeSession;if(actvSession===""){actvSession={};}actvSession.MetricsData={output:action.payload.output,manipulationData:action.payload.addRemoveContent};return Object.assign({},state,{activeSession:actvSession,isLoadingCompare:false,LoadingMsgCompare:''});case'FETCH_COMPARE_METRICS_DATA_PENDING':return Object.assign({},state,{isLoadingCompare:true,LoadingMsgCompare:'Please wait while fetching the Compare Metrics data.'});case'FETCH_COMPARE_METRICS_DATA_SUCCESS':actvSession=state.activeSession;actvSession.CompareMetricsData=action.payload;return Object.assign({},state,{activeSession:actvSession,isLoadingCompare:false,LoadingMsgCompare:''});case'CLEAR_COMPARE_METRICS':actvSession=state.activeSession;actvSession.CompareMetricsData='';return Object.assign({},state,{activeSession:actvSession});case'FETCH_COMPARE_SOLUTION_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the Compare Solution data.'});case'FETCH_COMPARE_SOLUTION_SUCCESS':actvSession=state.activeSession;actvSession.CompareSolution=action.payload;return Object.assign({},state,{activeSession:actvSession,isLoading:false,LoadingMsg:''});case'FETCH_SOLUTION_ERROR':actvSession=state.activeSession;actvSession.sizingFailed=action.payload;return Object.assign({},state,Object.assign({},state,{activeSession:actvSession,isLoading:false,LoadingMsg:' '}));case'FETCH_SOLUTION_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while Sizing the Solution.'});case'FETCH_SOLUTION_ADVANCED_PENDING':var msg='Please wait while Sizing the Solution.';if(action.payload!==undefined&&action.payload.isSizerAsEntry){msg='Please wait while we create guidance.';}return Object.assign({},state,{isLoading:true,LoadingMsg:msg});case'FETCH_SOLUTION_ADVANCED_ERROR':var message=action.payload.statusMessage==="User authenticated anonymously."?"You need “SSET - User Access” to continue.":action.payload.statusMessage;return Object.assign({},state,{isLoading:false,LoadingMsg:' ',networkError:{isError:true,msg:message,ssetUrl:action.payload.url}});case'CLEAR_GUIDANCE_ERROR':return Object.assign({},state,{networkError:{isError:false,msg:'',ssetUrl:''}});case'POSTSSET_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:action.payload});case'POSTSSET_SUCCESS':return Object.assign({},state,{isLoading:false,LoadingMsg:'',SSETUrl:action.payload});case'FETCH_SOLUTION_SUCCESS':actvSession=state.activeSession;actvSession.sizingFailed='';actvSession.treeView=action.payload;//dj  included below line to clear the current 2 solutions.
actvSession.EPAArray=[];return Object.assign({},state,{activeSession:actvSession,sessions:state.sessions.map(function(item){return item.id!==state.activeSession.id?item:Object.assign({},actvSession);}),isLoading:false,LoadingMsg:''//     return Object.assign({}, state, {
//       activeSession : Object.assign({}, state.activeSession, { treeView: action.payload }),
//       // sessions: 
//       isLoading:false,
//       LoadingMsg: ''
// });
});case'FETCH_BOM_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the Bill of material.'});case'FETCH_BOM_SUCCESS':return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{bomView:action.payload}),isLoading:false,LoadingMsg:''});case'FETCH_CONFIGDETAILS_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the Configuration details.'});case'FETCH_CONFIGDETAILS_SUCCESS':return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{configView:action.payload}),isLoading:false,LoadingMsg:''});case'FETCH_GR_INPUT_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the Configuration details.'});case'FETCH_GR_INPUT_SUCCESS':return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{GRInput:action.payload.GraphicalInputs}),isLoading:false,LoadingMsg:''});case'FETCH_GRBOM_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the Configuration details.'});case'FETCH_GRBOM_SUCCESS':return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{GRBomInput:action.payload.Solution}),isLoading:false,LoadingMsg:''});case'SAVE_WORKLOAD_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while saving the current workload into the database.'});case'SAVE_WORKLOAD_SUCCESS':return Object.assign({},state,{isLoading:false,LoadingMsg:'',overrideMsg:{isEnabled:false,msg:''},notificationMsg:{isEnabled:true,msg:action.payload}});case'REDIRECT_CONFLICT':return Object.assign({},state,{redirect:{isEnabled:action.payload.isTrue,path:action.payload.path}});case'WORKLOAD_CONFLICT':return Object.assign({},state,{isLoading:false,LoadingMsg:'',overrideMsg:{isEnabled:true,msg:'The Workload with this name already exists in the database. Would you like to replace it?'}});case'SOLUTION_CONFLICT':return Object.assign({},state,{isLoading:false,LoadingMsg:'',overrideSolMsg:{isEnabled:true,msg:'The Solution with this name already exists in the database. Would you like to replace it?'}});case'DISMISS_CONFLICTS':{return Object.assign({},state,{overrideMsg:{isEnabled:false,msg:''},overrideSolMsg:{isEnabled:false,msg:''}});}case'DISMISS_TOAST':{return Object.assign({},state,{notificationMsg:{isEnabled:false,msg:''}});}case'UPDATE_SSETID':{return Object.assign({},state,{SSETid:action.payload});}case'SAVE_SOLUTION_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while saving the current solution into the database.'});case'SAVE_SOLUTION_SUCCESS':return Object.assign({},state,{isLoading:false,LoadingMsg:'',overrideSolMsg:{isEnabled:false,msg:''},notificationMsg:{isEnabled:true,msg:action.payload}});case'LOAD_USER_DATA_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the data from database.'});case'LOAD_USER_DATA_SUCCESS':return Object.assign({},state,{isLoading:false,LoadingMsg:'',userData:action.payload});case'DELETE_SELECTION_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while Deleting the user selection.'});case'DELETE_SELECTION_SUCCESS':var userdatatemp=[];userdatatemp=state.userData;var result=[];userdatatemp.filter(function(val,id){if(val.id===parseInt(action.payload,10)){userdatatemp.splice(id,1);}});result=userdatatemp;return Object.assign({},state,{isLoading:false,LoadingMsg:'',userData:result});case'LOAD_SELECTION_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while loading the user selection.'});case'UPDATE_Active_WORKLOAD':return Object.assign({},state,{activeSession:Object.assign({},state.activeSession,{workload:action.payload})});case'LOAD_SELECTION_SUCCESS':var atvSess={id:'',alias:'',workload:JSON.parse(JSON.stringify(state.sessionDefaults.workload)),treeView:'',bomView:'',configView:'',GRInput:'',GRBomInput:'',MetricsData:'',CompareMetricsData:'',CompareSolution:'',globalError:{isError:false,errorMsg:''},isSizeEnabled:false,EPAArray:[],NonGPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:''},GPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:''},strmessage:null,FirstClik:{val:true// isSizeEnabled: true,
}};if(atvSess.workload===""){atvSess.workload={UserInputs:''};}if(action.payload.Workload.UserInputs.Environments){if(EPA_WORKLOADTYPES.indexOf(action.payload.Workload.UserInputs.Environments.WorkloadType)>-1){action=epaLoadSolutionUpdates(action);}}if(__WEBPACK_IMPORTED_MODULE_3__AppConfig__["f" /* said */]===__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["t" /* SizerIds */].SAPHANA&&action.payload.Workload.UserInputs.Environments.WorkloadType===undefined&&action.payload.Workload.UserInputs.Environments.WorkLoadType!==undefined){action.payload.Workload.UserInputs.Environments.WorkloadType=action.payload.Workload.UserInputs.Environments.WorkLoadType;}if(__WEBPACK_IMPORTED_MODULE_3__AppConfig__["f" /* said */]===__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["t" /* SizerIds */].EPAVNEXT&&action.payload.Workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["a" /* BLUE_DATA */]){atvSess.workload.UserInputs=Object(__WEBPACK_IMPORTED_MODULE_2__commonLogic__["a" /* supportOldEpaWorkloads */])(state.sessionDefaults.blueDataWorkload,action.payload.Workload).UserInputs;}else if(__WEBPACK_IMPORTED_MODULE_3__AppConfig__["f" /* said */]===__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["t" /* SizerIds */].SAPHANA&&(!action.payload.Workload.UserInputs.Environments.WorkloadType||action.payload.Workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_4__constants_CommonConstants__["m" /* SAPHANA */])){if((!action.payload.Workload.UserInputs.Environments.WorkloadType||action.payload.Workload.UserInputs.Environments.WorkloadType&&action.payload.Workload.UserInputs.Environments.WorkloadType==="SAPHANA")&&!action.payload.Workload.UserInputs.Environments.ApplicationEnvironment){state.sessionDefaults.workload.UserInputs.Environments.CustomerInfo=action.payload.Workload.UserInputs.Environments.CustomerInfo;state.sessionDefaults.workload.UserInputs.Environments.ProductionEnvironment.DataBaseSize=action.payload.Workload.UserInputs.Environments.ProductionEnvironment.DataBaseSize;state.sessionDefaults.workload.UserInputs.Environments.ProductionEnvironment.GrowthYears=action.payload.Workload.UserInputs.Environments.ProductionEnvironment.GrowthYears;state.sessionDefaults.workload.UserInputs.Environments.ProductionEnvironment.YearlyGrowth=action.payload.Workload.UserInputs.Environments.ProductionEnvironment.YearlyGrowth;atvSess.workload.UserInputs=JSON.parse(JSON.stringify(state.sessionDefaults.workload.UserInputs));atvSess.workload.UserInputs.Environments.isOldWorkload=true;}else{atvSess.workload.UserInputs=action.payload.Workload.UserInputs;}}else{atvSess.workload.UserInputs=action.payload.Workload.UserInputs;}atvSess.id=action.payload.SessionID;atvSess.alias=action.payload.Alias;if(action.payload.EPAArray!==undefined&&action.payload.EPAArray.length>0){atvSess.EPAArray=action.payload.EPAArray;}if(action.payload.TreeView===null||state.SSETid!==undefined){atvSess.treeView="";}else{atvSess.treeView=action.payload.TreeView;}var SessionAvailable=0;state.sessions.forEach(function(item){if(item.alias.toString().indexOf(atvSess.alias)>=0){SessionAvailable++;}});if(SessionAvailable>0){atvSess.alias=atvSess.alias+' ('+SessionAvailable+')';return Object.assign({},state,{//  sessions: state.sessions.map((item) => item.id !== atvSess.id ? item : Object.assign(atvSess)),
sessions:state.sessions.concat(atvSess),activeSession:atvSess,isLoading:false,LoadingMsg:''});}else{return Object.assign({},state,{// sessions:state.sessions.map((item) => item.id !== state.activeSession.id ? item : Object.assign(atvSess)),
sessions:state.sessions.concat(atvSess),activeSession:atvSess,isLoading:false,LoadingMsg:''});}case'UPDATE_LOADED_OLD_SOLUTION':return Object.assign({},state,{loadedOldSolution:action.payload});case'SERVER_ERROR':return Object.assign({},state,{isLoading:false,LoadingMsg:'',isLoginPending:false,LoginMsg:''//  notificationMsg:{isEnabled:true,msg:'Something Went wrong...',isError:true}
});case'CLOSE_EULA':return Object.assign({},state,{EULAPopUpState:action.payload.data});case'LOGIN_PENDING':{return Object.assign({},state,{isLoginPending:true,LoginMsg:'Please wait while signing in.'});}case'LOGIN_SUCCESS':{return Object.assign({},state,{isLoginPending:false,LoginMsg:''});}case'LOGOUT_PENDING':{return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while logging out.'});}case'LOGOUT_SUCCESS':{return Object.assign({},state,{isLoading:false,LoadingMsg:''});}case'OSLISTBLUEDATA_SUCCESS':{return Object.assign({},state,{isLoading:false,LoadingMsg:''});}case'SHARE_SELECTION_SUCCESS':return Object.assign({},state,{feedback:Object.assign({},state.feedback,{response:action.payload})});case'CALCULATEBLUEDATACONFIG_SUCCESS':var type='';// var workloadtemp = '';
var GPUvaluetemp='';var NonGPUvaluetemp='';//  var Errormsgtemp=''
//  var isErrortemp=''
//state.workload.UserInputs.Environments.Templates.ServerDetails.Server.filter((val) => {
for(var key in action.payload){if(key==="NonGPU_Result"){type="NonGPU";state.activeSession.NonGPUValue.TotalVMemory=action.payload[key]['d_TotalVMemory'];state.activeSession.NonGPUValue.TotalCore=action.payload[key]['d_TotalVCPU'];state.activeSession.NonGPUValue.TotalStorage=action.payload[key]['d_TotalStorage'];}else if(key==="GPU_Result"){type="GPU";state.activeSession.GPUValue.TotalVMemory=action.payload[key]['d_TotalVMemory'];state.activeSession.GPUValue.TotalCore=action.payload[key]['d_TotalVCPU'];state.activeSession.GPUValue.TotalStorage=action.payload[key]['d_TotalStorage'];}//if (val['@Type'] === type) {
if(action.payload[key]['ErrorMsg']===null||action.payload[key]['ErrorMsg']===""||action.payload[key]['ErrorMsg']===undefined){//  isErrortemp=false
if(action.payload[key]['RecommendedServer']!==null){if(type==="NonGPU"){state.activeSession.NonGPUValue.Drive=action.payload[key]['RecommendedDriveDesc'];state.activeSession.NonGPUValue.DriveQty=action.payload[key]['RecommendedDriveQty'];state.activeSession.NonGPUValue.Memory=action.payload[key]['RecommendedMemory'];state.activeSession.NonGPUValue.Proc=action.payload[key]['RecommendedProc'];state.activeSession.NonGPUValue.Server=action.payload[key]['RecommendedServer'];state.activeSession.NonGPUValue.ServerQty=action.payload[key]['d_ServerQty'];}if(type==="GPU"){state.activeSession.GPUValue.Drive=action.payload[key]['RecommendedDriveDesc'];state.activeSession.GPUValue.DriveQty=action.payload[key]['RecommendedDriveQty'];state.activeSession.GPUValue.Memory=action.payload[key]['RecommendedMemory'];state.activeSession.GPUValue.Proc=action.payload[key]['RecommendedProc'];state.activeSession.GPUValue.Server=action.payload[key]['RecommendedServer'];state.activeSession.GPUValue.ServerQty=action.payload[key]['d_ServerQty'];}}}else{}//  Errormsgtemp=action.payload[key]['ErrorMsg'];
//  isErrortemp=true
// }
}// });
//  workloadtemp = state.workload
GPUvaluetemp=state.activeSession.GPUValue;NonGPUvaluetemp=state.activeSession.NonGPUValue;// let caltemprst=true
// let caltempcount=state.count-1
//  if(state.count-1===0)
//  {
//   caltemprst=false
// }
return Object.assign({},state,{// workload: workloadtemp,
activeSession:Object.assign({},state.activeSession,{GPUValue:GPUvaluetemp,NonGPUValue:NonGPUvaluetemp}),// GPUValue:GPUvaluetemp,
// NonGPUValue:NonGPUvaluetemp,
// BlueDataCal: action.payload,
isLoading:false//  isCal: caltemprst,
// count:caltempcount,
// Errormsg:Errormsgtemp,
//isError:isErrortemp
});//  case 'FETCH_NODEQTY_SUCCESS':
//   return Object.assign({}, state, {
//          activeSession : {...state.activeSession, strmessage:action.payload.strmessage},
//       });
case'EPA_MULTIPLE_SOLUTIONS_SUCCESS':actvSession=state.activeSession;actvSession.treeView=action.payload.data;actvSession.EPAArray=action.payload.multipleSolutions;return Object.assign({},state,Object.assign({},state,{activeSession:actvSession,sessions:state.sessions.map(function(item){return item.id!==state.activeSession.id?item:Object.assign({},actvSession);}),isLoading:false,LoadingMsg:''}));/*  case 'CALCULATEBLUEDATACONFIG_SUCCESS':
          var errmsg={
            isError:false,
            errorMsg:''
          }
            for (let key in action.payload) {
          if(action.payload[key]['d_ServerQty'] === 'Infinity')
          {
          errmsg={
                  isError:true, errorMsg:'Increase Drive Size. If drive size is larger than node storage will not fit on this server '
                }
          }
            }
          return{
              ...state,
              activeSession : {...state.activeSession, globalError:errmsg}
          }
         case 'COMPARE_SOL_DATA_PENDING':
           return Object.assign({}, state, {
             ...state,
               isLoading: true,
               LoadingMsg: 'Please wait while comparing data'   
       });
    */case'SAP_SOL_PREVIEW_SUCCESS':return Object.assign({},state,{SAPSolPreview:JSON.parse(JSON.stringify(action.payload)),isLoading:false});case'SAP_SOL_PREVIEW_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the data.'});case'SAP_SOL_PREVIEW_ERROR':return Object.assign({},state,{isLoading:false});case'SAPHANA_SOL_PREVIEW_SUCCESS':return Object.assign({},state,{SAPHANASolPreview:JSON.parse(JSON.stringify(action.payload)),isLoading:false});case'SAPHANA_SOL_PREVIEW_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the data.'});case'SAPHANA_SOL_PREVIEW_ERROR':return Object.assign({},state,{isLoading:false});case'SAPTDI_SOL_PREVIEW_SUCCESS':return Object.assign({},state,{SAPTDISolPreview:JSON.parse(JSON.stringify(action.payload)),isLoading:false});case'SAPTDI_SOL_PREVIEW_PENDING':return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching the data.'});case'SAPTDI_SOL_PREVIEW_ERROR':return Object.assign({},state,{isLoading:false});case'COMPARE_SOL_DATA_SUCCESS':if(action.payload!=="File Mismatch"&&action.payload!=="Different Pricing Region"){var _actvSession=state.activeSession;for(var _i2=0;_i2<2;_i2++){action.payload.Solutions.Solution[_i2]['@FirstRole']=action.payload.Solutions.Solution[_i2]['@FirstRole'].replace(GROWTH2YRole,'').replace(GROWTH3YRole,'').replace(GROWTH4YRole,'').trim();action.payload.Solutions.Solution[_i2]['Roles']['@FirstRole']=action.payload.Solutions.Solution[_i2]['Roles']['@FirstRole'].replace(GROWTH2YRole,'').replace(GROWTH3YRole,'').replace(GROWTH4YRole,'').trim();action.payload.Solutions.Solution[_i2].Roles.Role.map(function(item){item.RoleName=item.RoleName.replace(GROWTH2YRole,'').replace(GROWTH3YRole,'').replace(GROWTH4YRole,'').trim();});}_actvSession.CompareData={CompareData:action.payload.Solutions};return Object.assign({},state,{isLoading:false,LoadingMsg:'',activeSession:_actvSession// CompareData : {CompareData:action.payload.Solutions}
});}else{var _actvSession2=state.activeSession;_actvSession2.CompareData={CompareData:action.payload};return Object.assign({},state,{isLoading:false,LoadingMsg:'',activeSession:_actvSession2//CompareData : {CompareData:action.payload}
});}case'COMPARE_GLGROWTH_DATA_SUCCESS':state.activeSession=action.payload;return Object.assign({},state);case'CLEAR_COMPARE_DATA':actvSession=state.activeSession;actvSession.CompareData={CompareData:null};return Object.assign({},state,{activeSession:actvSession});case'SAVEDSOL_NAME':var actvSessionsave=state.activeSession;actvSessionsave.SavedSolname={SavedSol:action.payload.SavedSolutionName,savedId:action.payload.selectedselection};return Object.assign({},state,{activeSession:actvSessionsave//     case "SELECTED_SERVICE_VALUE":
//      let actvSessionservice = state.activeSession;
//     actvSessionservice.title = action.payload
//  return{
//          ...state,
//          activeSession:actvSessionservice
//     }
});}return state;};/* harmony default export */ __webpack_exports__["a"] = (sessionsReducer);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(109);
var ES = __webpack_require__(210);

var implementation = __webpack_require__(236);
var getPolyfill = __webpack_require__(237);
var shim = __webpack_require__(450);

var slice = Array.prototype.slice;

var polyfill = getPolyfill();

var boundFindShim = function find(array, predicate) { // eslint-disable-line no-unused-vars
	ES.RequireObjectCoercible(array);
	var args = slice.call(arguments, 1);
	return polyfill.apply(array, args);
};

define(boundFindShim, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundFindShim;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(209); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint global-require: 0 */
// https://www.ecma-international.org/ecma-262/6.0/#sec-abstract-operations
var ES6 = {
	'Abstract Equality Comparison': __webpack_require__(371),
	'Abstract Relational Comparison': __webpack_require__(378),
	'Strict Equality Comparison': __webpack_require__(380),
	AdvanceStringIndex: __webpack_require__(216),
	ArrayCreate: __webpack_require__(381),
	ArraySetLength: __webpack_require__(382),
	ArraySpeciesCreate: __webpack_require__(387),
	Call: __webpack_require__(76),
	CanonicalNumericIndexString: __webpack_require__(389),
	CompletePropertyDescriptor: __webpack_require__(390),
	CreateDataProperty: __webpack_require__(225),
	CreateDataPropertyOrThrow: __webpack_require__(391),
	CreateHTML: __webpack_require__(392),
	CreateIterResultObject: __webpack_require__(394),
	CreateListFromArrayLike: __webpack_require__(395),
	CreateMethodProperty: __webpack_require__(398),
	DateFromTime: __webpack_require__(227),
	Day: __webpack_require__(116),
	DayFromYear: __webpack_require__(151),
	DaysInYear: __webpack_require__(228),
	DayWithinYear: __webpack_require__(150),
	DefinePropertyOrThrow: __webpack_require__(154),
	DeletePropertyOrThrow: __webpack_require__(399),
	EnumerableOwnNames: __webpack_require__(400),
	FromPropertyDescriptor: __webpack_require__(92),
	Get: __webpack_require__(45),
	GetIterator: __webpack_require__(401),
	GetMethod: __webpack_require__(118),
	GetOwnPropertyKeys: __webpack_require__(403),
	GetPrototypeFromConstructor: __webpack_require__(404),
	GetSubstitution: __webpack_require__(405),
	GetV: __webpack_require__(155),
	HasOwnProperty: __webpack_require__(406),
	HasProperty: __webpack_require__(407),
	HourFromTime: __webpack_require__(408),
	InLeapYear: __webpack_require__(152),
	InstanceofOperator: __webpack_require__(409),
	Invoke: __webpack_require__(231),
	IsAccessorDescriptor: __webpack_require__(55),
	IsArray: __webpack_require__(54),
	IsCallable: __webpack_require__(56),
	IsConcatSpreadable: __webpack_require__(410),
	IsConstructor: __webpack_require__(114),
	IsDataDescriptor: __webpack_require__(30),
	IsExtensible: __webpack_require__(91),
	IsGenericDescriptor: __webpack_require__(146),
	IsInteger: __webpack_require__(88),
	IsPromise: __webpack_require__(411),
	IsPropertyDescriptor: __webpack_require__(412),
	IsPropertyKey: __webpack_require__(19),
	IsRegExp: __webpack_require__(223),
	IteratorClose: __webpack_require__(413),
	IteratorComplete: __webpack_require__(232),
	IteratorNext: __webpack_require__(233),
	IteratorStep: __webpack_require__(414),
	IteratorValue: __webpack_require__(415),
	MakeDate: __webpack_require__(416),
	MakeDay: __webpack_require__(417),
	MakeTime: __webpack_require__(418),
	MinFromTime: __webpack_require__(419),
	modulo: __webpack_require__(420),
	MonthFromTime: __webpack_require__(153),
	msFromTime: __webpack_require__(421),
	ObjectCreate: __webpack_require__(422),
	OrdinaryDefineOwnProperty: __webpack_require__(220),
	OrdinaryGetOwnProperty: __webpack_require__(222),
	OrdinaryHasInstance: __webpack_require__(230),
	OrdinaryHasProperty: __webpack_require__(423),
	RegExpExec: __webpack_require__(424),
	RequireObjectCoercible: __webpack_require__(148),
	SameValue: __webpack_require__(74),
	SameValueZero: __webpack_require__(425),
	SecFromTime: __webpack_require__(426),
	Set: __webpack_require__(427),
	SetFunctionName: __webpack_require__(428),
	SetIntegrityLevel: __webpack_require__(431),
	SpeciesConstructor: __webpack_require__(433),
	SymbolDescriptiveString: __webpack_require__(434),
	TestIntegrityLevel: __webpack_require__(435),
	thisBooleanValue: __webpack_require__(436),
	thisNumberValue: __webpack_require__(437),
	thisStringValue: __webpack_require__(438),
	thisTimeValue: __webpack_require__(439),
	TimeClip: __webpack_require__(440),
	TimeFromYear: __webpack_require__(441),
	TimeWithinDay: __webpack_require__(442),
	ToBoolean: __webpack_require__(73),
	ToDateString: __webpack_require__(443),
	ToInt16: __webpack_require__(444),
	ToInt32: __webpack_require__(445),
	ToInt8: __webpack_require__(446),
	ToInteger: __webpack_require__(115),
	ToLength: __webpack_require__(226),
	ToNumber: __webpack_require__(26),
	ToObject: __webpack_require__(229),
	ToPrimitive: __webpack_require__(87),
	ToPropertyDescriptor: __webpack_require__(72),
	ToPropertyKey: __webpack_require__(447),
	ToString: __webpack_require__(75),
	ToUint16: __webpack_require__(234),
	ToUint32: __webpack_require__(224),
	ToUint8: __webpack_require__(235),
	ToUint8Clamp: __webpack_require__(448),
	Type: __webpack_require__(7),
	ValidateAndApplyPropertyDescriptor: __webpack_require__(221),
	WeekDay: __webpack_require__(449),
	YearFromTime: __webpack_require__(117)
};

module.exports = ES6;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(26);
var ToPrimitive = __webpack_require__(87);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-abstract-equality-comparison

module.exports = function AbstractEqualityComparison(x, y) {
	var xType = Type(x);
	var yType = Type(y);
	if (xType === yType) {
		return x === y; // ES6+ specified this shortcut anyways.
	}
	if (x == null && y == null) {
		return true;
	}
	if (xType === 'Number' && yType === 'String') {
		return AbstractEqualityComparison(x, ToNumber(y));
	}
	if (xType === 'String' && yType === 'Number') {
		return AbstractEqualityComparison(ToNumber(x), y);
	}
	if (xType === 'Boolean') {
		return AbstractEqualityComparison(ToNumber(x), y);
	}
	if (yType === 'Boolean') {
		return AbstractEqualityComparison(x, ToNumber(y));
	}
	if ((xType === 'String' || xType === 'Number' || xType === 'Symbol') && yType === 'Object') {
		return AbstractEqualityComparison(x, ToPrimitive(y));
	}
	if (xType === 'Object' && (yType === 'String' || yType === 'Number' || yType === 'Symbol')) {
		return AbstractEqualityComparison(ToPrimitive(x), y);
	}
	return false;
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = __webpack_require__(374);
var isCallable = __webpack_require__(215);
var isDate = __webpack_require__(375);
var isSymbol = __webpack_require__(376);

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;
var hasSymbols = __webpack_require__(111)();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// https://www.ecma-international.org/ecma-262/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Number = GetIntrinsic('%Number%');
var $TypeError = GetIntrinsic('%TypeError%');

var $isNaN = __webpack_require__(43);
var $isFinite = __webpack_require__(44);
var isPrefixOf = __webpack_require__(379);

var ToNumber = __webpack_require__(26);
var ToPrimitive = __webpack_require__(87);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/5.1/#sec-11.8.5

// eslint-disable-next-line max-statements
module.exports = function AbstractRelationalComparison(x, y, LeftFirst) {
	if (Type(LeftFirst) !== 'Boolean') {
		throw new $TypeError('Assertion failed: LeftFirst argument must be a Boolean');
	}
	var px;
	var py;
	if (LeftFirst) {
		px = ToPrimitive(x, $Number);
		py = ToPrimitive(y, $Number);
	} else {
		py = ToPrimitive(y, $Number);
		px = ToPrimitive(x, $Number);
	}
	var bothStrings = Type(px) === 'String' && Type(py) === 'String';
	if (!bothStrings) {
		var nx = ToNumber(px);
		var ny = ToNumber(py);
		if ($isNaN(nx) || $isNaN(ny)) {
			return undefined;
		}
		if ($isFinite(nx) && $isFinite(ny) && nx === ny) {
			return false;
		}
		if (nx === 0 && ny === 0) {
			return false;
		}
		if (nx === Infinity) {
			return false;
		}
		if (ny === Infinity) {
			return true;
		}
		if (ny === -Infinity) {
			return false;
		}
		if (nx === -Infinity) {
			return true;
		}
		return nx < ny; // by now, these are both nonzero, finite, and not equal
	}
	if (isPrefixOf(py, px)) {
		return false;
	}
	if (isPrefixOf(px, py)) {
		return true;
	}
	return px < py; // both strings, neither a prefix of the other. shortcut for steps c-f
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $strSlice = __webpack_require__(16)('String.prototype.slice');

module.exports = function isPrefixOf(prefix, string) {
	if (prefix === string) {
		return true;
	}
	if (prefix.length > string.length) {
		return false;
	}
	return $strSlice(string, 0, prefix.length) === prefix;
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/5.1/#sec-11.9.6

module.exports = function StrictEqualityComparison(x, y) {
	var xType = Type(x);
	var yType = Type(y);
	if (xType !== yType) {
		return false;
	}
	if (xType === 'Undefined' || xType === 'Null') {
		return true;
	}
	return x === y; // shortcut for steps 4-7
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $ArrayPrototype = GetIntrinsic('%Array.prototype%');
var $RangeError = GetIntrinsic('%RangeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');

var IsInteger = __webpack_require__(88);

var MAX_ARRAY_LENGTH = Math.pow(2, 32) - 1;

var $setProto = GetIntrinsic('%Object.setPrototypeOf%', true) || (
	// eslint-disable-next-line no-proto, no-negated-condition
	[].__proto__ !== $ArrayPrototype
		? null
		: function (O, proto) {
			O.__proto__ = proto; // eslint-disable-line no-proto, no-param-reassign
			return O;
		}
);

// https://www.ecma-international.org/ecma-262/6.0/#sec-arraycreate

module.exports = function ArrayCreate(length) {
	if (!IsInteger(length) || length < 0) {
		throw new $TypeError('Assertion failed: `length` must be an integer Number >= 0');
	}
	if (length > MAX_ARRAY_LENGTH) {
		throw new $RangeError('length is greater than (2**32 - 1)');
	}
	var proto = arguments.length > 1 ? arguments[1] : $ArrayPrototype;
	var A = []; // steps 5 - 7, and 9
	if (proto !== $ArrayPrototype) { // step 8
		if (!$setProto) {
			throw new $SyntaxError('ArrayCreate: a `proto` argument that is not `Array.prototype` is not supported in an environment that does not support setting the [[Prototype]]');
		}
		$setProto(A, proto);
	}
	if (length !== 0) { // bypasses the need for step 2
		A.length = length;
	}
	/* step 10, the above as a shortcut for the below
    OrdinaryDefineOwnProperty(A, 'length', {
        '[[Configurable]]': false,
        '[[Enumerable]]': false,
        '[[Value]]': length,
        '[[Writable]]': true
    });
    */
	return A;
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $RangeError = GetIntrinsic('%RangeError%');
var $TypeError = GetIntrinsic('%TypeError%');

var assign = __webpack_require__(383);

var isPropertyDescriptor = __webpack_require__(89);

var IsArray = __webpack_require__(54);
var IsAccessorDescriptor = __webpack_require__(55);
var IsDataDescriptor = __webpack_require__(30);
var OrdinaryDefineOwnProperty = __webpack_require__(220);
var OrdinaryGetOwnProperty = __webpack_require__(222);
var ToNumber = __webpack_require__(26);
var ToString = __webpack_require__(75);
var ToUint32 = __webpack_require__(224);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-arraysetlength

// eslint-disable-next-line max-statements, max-lines-per-function
module.exports = function ArraySetLength(A, Desc) {
	if (!IsArray(A)) {
		throw new $TypeError('Assertion failed: A must be an Array');
	}
	if (!isPropertyDescriptor({
		Type: Type,
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor
	}, Desc)) {
		throw new $TypeError('Assertion failed: Desc must be a Property Descriptor');
	}
	if (!('[[Value]]' in Desc)) {
		return OrdinaryDefineOwnProperty(A, 'length', Desc);
	}
	var newLenDesc = assign({}, Desc);
	var newLen = ToUint32(Desc['[[Value]]']);
	var numberLen = ToNumber(Desc['[[Value]]']);
	if (newLen !== numberLen) {
		throw new $RangeError('Invalid array length');
	}
	newLenDesc['[[Value]]'] = newLen;
	var oldLenDesc = OrdinaryGetOwnProperty(A, 'length');
	if (!IsDataDescriptor(oldLenDesc)) {
		throw new $TypeError('Assertion failed: an array had a non-data descriptor on `length`');
	}
	var oldLen = oldLenDesc['[[Value]]'];
	if (newLen >= oldLen) {
		return OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
	}
	if (!oldLenDesc['[[Writable]]']) {
		return false;
	}
	var newWritable;
	if (!('[[Writable]]' in newLenDesc) || newLenDesc['[[Writable]]']) {
		newWritable = true;
	} else {
		newWritable = false;
		newLenDesc['[[Writable]]'] = true;
	}
	var succeeded = OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
	if (!succeeded) {
		return false;
	}
	while (newLen < oldLen) {
		oldLen -= 1;
		// eslint-disable-next-line no-param-reassign
		var deleteSucceeded = delete A[ToString(oldLen)];
		if (!deleteSucceeded) {
			newLenDesc['[[Value]]'] = oldLen + 1;
			if (!newWritable) {
				newLenDesc['[[Writable]]'] = false;
				OrdinaryDefineOwnProperty(A, 'length', newLenDesc);
				return false;
			}
		}
	}
	if (!newWritable) {
		return OrdinaryDefineOwnProperty(A, 'length', { '[[Writable]]': false });
	}
	return true;
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperties = __webpack_require__(109);

var implementation = __webpack_require__(218);
var getPolyfill = __webpack_require__(219);
var shim = __webpack_require__(384);

var polyfill = getPolyfill();

defineProperties(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(109);
var getPolyfill = __webpack_require__(219);

module.exports = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var every = __webpack_require__(145);

module.exports = function isSamePropertyDescriptor(ES, D1, D2) {
	var fields = [
		'[[Configurable]]',
		'[[Enumerable]]',
		'[[Get]]',
		'[[Set]]',
		'[[Value]]',
		'[[Writable]]'
	];
	return every(fields, function (field) {
		if ((field in D1) !== (field in D2)) {
			return false;
		}
		return ES.SameValue(D1[field], D2[field]);
	});
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(36);
var regexExec = RegExp.prototype.exec;
var gOPD = Object.getOwnPropertyDescriptor;

var tryRegexExecCall = function tryRegexExec(value) {
	try {
		var lastIndex = value.lastIndex;
		value.lastIndex = 0; // eslint-disable-line no-param-reassign

		regexExec.call(value);
		return true;
	} catch (e) {
		return false;
	} finally {
		value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
	}
};
var toStr = Object.prototype.toString;
var regexClass = '[object RegExp]';
var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';

module.exports = function isRegex(value) {
	if (!value || typeof value !== 'object') {
		return false;
	}
	if (!hasToStringTag) {
		return toStr.call(value) === regexClass;
	}

	var descriptor = gOPD(value, 'lastIndex');
	var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
	if (!hasLastIndexDataProperty) {
		return false;
	}

	return tryRegexExecCall(value);
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Array = GetIntrinsic('%Array%');
var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(45);
var IsArray = __webpack_require__(54);
var IsConstructor = __webpack_require__(114);
var IsInteger = __webpack_require__(88);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate

module.exports = function ArraySpeciesCreate(originalArray, length) {
	if (!IsInteger(length) || length < 0) {
		throw new $TypeError('Assertion failed: length must be an integer >= 0');
	}
	var len = length === 0 ? 0 : length;
	var C;
	var isArray = IsArray(originalArray);
	if (isArray) {
		C = Get(originalArray, 'constructor');
		// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
		// if (IsConstructor(C)) {
		// 	if C is another realm's Array, C = undefined
		// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
		// }
		if ($species && Type(C) === 'Object') {
			C = Get(C, $species);
			if (C === null) {
				C = void 0;
			}
		}
	}
	if (typeof C === 'undefined') {
		return $Array(len);
	}
	if (!IsConstructor(C)) {
		throw new $TypeError('C must be a constructor');
	}
	return new C(len); // Construct(C, len);
};



/***/ }),
/* 388 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var SameValue = __webpack_require__(74);
var ToNumber = __webpack_require__(26);
var ToString = __webpack_require__(75);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring

module.exports = function CanonicalNumericIndexString(argument) {
	if (Type(argument) !== 'String') {
		throw new $TypeError('Assertion failed: `argument` must be a String');
	}
	if (argument === '-0') { return -0; }
	var n = ToNumber(argument);
	if (SameValue(ToString(n), argument)) { return n; }
	return void 0;
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = __webpack_require__(36);

var assertRecord = __webpack_require__(90);

var IsDataDescriptor = __webpack_require__(30);
var IsGenericDescriptor = __webpack_require__(146);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor

module.exports = function CompletePropertyDescriptor(Desc) {
	/* eslint no-param-reassign: 0 */
	assertRecord(Type, 'Property Descriptor', 'Desc', Desc);

	if (IsGenericDescriptor(Desc) || IsDataDescriptor(Desc)) {
		if (!has(Desc, '[[Value]]')) {
			Desc['[[Value]]'] = void 0;
		}
		if (!has(Desc, '[[Writable]]')) {
			Desc['[[Writable]]'] = false;
		}
	} else {
		if (!has(Desc, '[[Get]]')) {
			Desc['[[Get]]'] = void 0;
		}
		if (!has(Desc, '[[Set]]')) {
			Desc['[[Set]]'] = void 0;
		}
	}
	if (!has(Desc, '[[Enumerable]]')) {
		Desc['[[Enumerable]]'] = false;
	}
	if (!has(Desc, '[[Configurable]]')) {
		Desc['[[Configurable]]'] = false;
	}
	return Desc;
};


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var CreateDataProperty = __webpack_require__(225);
var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

// // https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow

module.exports = function CreateDataPropertyOrThrow(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}
	var success = CreateDataProperty(O, P, V);
	if (!success) {
		throw new $TypeError('unable to create data property');
	}
	return success;
};


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(16);

var $replace = callBound('String.prototype.replace');

var RequireObjectCoercible = __webpack_require__(148);
var ToString = __webpack_require__(75);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-createhtml

module.exports = function CreateHTML(string, tag, attribute, value) {
	if (Type(tag) !== 'String' || Type(attribute) !== 'String') {
		throw new $TypeError('Assertion failed: `tag` and `attribute` must be strings');
	}
	var str = RequireObjectCoercible(string);
	var S = ToString(str);
	var p1 = '<' + tag;
	if (attribute !== '') {
		var V = ToString(value);
		var escapedV = $replace(V, /\x22/g, '&quot;');
		p1 += '\x20' + attribute + '\x3D\x22' + escapedV + '\x22';
	}
	return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject

module.exports = function CreateIterResultObject(value, done) {
	if (Type(done) !== 'Boolean') {
		throw new $TypeError('Assertion failed: Type(done) is not Boolean');
	}
	return {
		value: value,
		done: done
	};
};


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var callBound = __webpack_require__(16);

var $TypeError = GetIntrinsic('%TypeError%');
var $indexOf = callBound('Array.prototype.indexOf');
var $push = callBound('Array.prototype.push');

var Get = __webpack_require__(45);
var IsArray = __webpack_require__(54);
var ToLength = __webpack_require__(226);
var ToString = __webpack_require__(75);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-createlistfromarraylike
module.exports = function CreateListFromArrayLike(obj) {
	var elementTypes = arguments.length > 1
		? arguments[1]
		: ['Undefined', 'Null', 'Boolean', 'String', 'Symbol', 'Number', 'Object'];

	if (Type(obj) !== 'Object') {
		throw new $TypeError('Assertion failed: `obj` must be an Object');
	}
	if (!IsArray(elementTypes)) {
		throw new $TypeError('Assertion failed: `elementTypes`, if provided, must be an array');
	}
	var len = ToLength(Get(obj, 'length'));
	var list = [];
	var index = 0;
	while (index < len) {
		var indexName = ToString(index);
		var next = Get(obj, indexName);
		var nextType = Type(next);
		if ($indexOf(elementTypes, nextType) < 0) {
			throw new $TypeError('item type ' + nextType + ' is not a valid elementType');
		}
		$push(list, next);
		index += 1;
	}
	return list;
};


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Math = GetIntrinsic('%Math%');

var ToNumber = __webpack_require__(397);
var $isNaN = __webpack_require__(43);
var $isFinite = __webpack_require__(44);
var $sign = __webpack_require__(149);

var $floor = $Math.floor;
var $abs = $Math.abs;

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.4

module.exports = function ToInteger(value) {
	var number = ToNumber(value);
	if ($isNaN(number)) { return 0; }
	if (number === 0 || !$isFinite(number)) { return number; }
	return $sign(number) * $floor($abs(number));
};


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://www.ecma-international.org/ecma-262/5.1/#sec-9.3

module.exports = function ToNumber(value) {
	return +value; // eslint-disable-line no-implicit-coercion
};


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var DefineOwnProperty = __webpack_require__(113);

var FromPropertyDescriptor = __webpack_require__(92);
var IsDataDescriptor = __webpack_require__(30);
var IsPropertyKey = __webpack_require__(19);
var SameValue = __webpack_require__(74);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty

module.exports = function CreateMethodProperty(O, P, V) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	var newDesc = {
		'[[Configurable]]': true,
		'[[Enumerable]]': false,
		'[[Value]]': V,
		'[[Writable]]': true
	};
	return DefineOwnProperty(
		IsDataDescriptor,
		SameValue,
		FromPropertyDescriptor,
		O,
		P,
		newDesc
	);
};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow

module.exports = function DeletePropertyOrThrow(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
	}

	// eslint-disable-next-line no-param-reassign
	var success = delete O[P];
	if (!success) {
		throw new $TypeError('Attempt to delete property failed.');
	}
	return success;
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var keys = __webpack_require__(110);

var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames

module.exports = function EnumerableOwnNames(O) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}

	return keys(O);
};


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var getIteratorMethod = __webpack_require__(402);
var AdvanceStringIndex = __webpack_require__(216);
var Call = __webpack_require__(76);
var GetMethod = __webpack_require__(118);
var IsArray = __webpack_require__(54);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-getiterator

module.exports = function GetIterator(obj, method) {
	var actualMethod = method;
	if (arguments.length < 2) {
		actualMethod = getIteratorMethod(
			{
				AdvanceStringIndex: AdvanceStringIndex,
				GetMethod: GetMethod,
				IsArray: IsArray,
				Type: Type
			},
			obj
		);
	}
	var iterator = Call(actualMethod, obj);
	if (Type(iterator) !== 'Object') {
		throw new $TypeError('iterator must return an object');
	}

	return iterator;
};


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hasSymbols = __webpack_require__(111)();
var GetIntrinsic = __webpack_require__(4);
var callBound = __webpack_require__(16);

var $iterator = GetIntrinsic('%Symbol.iterator%', true);
var $stringSlice = callBound('String.prototype.slice');

module.exports = function getIteratorMethod(ES, iterable) {
	var usingIterator;
	if (hasSymbols) {
		usingIterator = ES.GetMethod(iterable, $iterator);
	} else if (ES.IsArray(iterable)) {
		usingIterator = function () {
			var i = -1;
			var arr = this; // eslint-disable-line no-invalid-this
			return {
				next: function () {
					i += 1;
					return {
						done: i >= arr.length,
						value: arr[i]
					};
				}
			};
		};
	} else if (ES.Type(iterable) === 'String') {
		usingIterator = function () {
			var i = 0;
			return {
				next: function () {
					var nextIndex = ES.AdvanceStringIndex(iterable, i, true);
					var value = $stringSlice(iterable, i, nextIndex);
					i = nextIndex;
					return {
						done: nextIndex > iterable.length,
						value: value
					};
				}
			};
		};
	}
	return usingIterator;
};


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var hasSymbols = __webpack_require__(111)();

var $TypeError = GetIntrinsic('%TypeError%');

var $gOPN = GetIntrinsic('%Object.getOwnPropertyNames%');
var $gOPS = hasSymbols && GetIntrinsic('%Object.getOwnPropertySymbols%');
var keys = __webpack_require__(110);

var esType = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-getownpropertykeys

module.exports = function GetOwnPropertyKeys(O, Type) {
	if (esType(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (Type === 'Symbol') {
		return $gOPS ? $gOPS(O) : [];
	}
	if (Type === 'String') {
		if (!$gOPN) {
			return keys(O);
		}
		return $gOPN(O);
	}
	throw new $TypeError('Assertion failed: `Type` must be `"String"` or `"Symbol"`');
};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Function = GetIntrinsic('%Function%');
var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(45);
var IsConstructor = __webpack_require__(114);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-getprototypefromconstructor

module.exports = function GetPrototypeFromConstructor(constructor, intrinsicDefaultProto) {
	var intrinsic = GetIntrinsic(intrinsicDefaultProto); // throws if not a valid intrinsic
	if (!IsConstructor(constructor)) {
		throw new $TypeError('Assertion failed: `constructor` must be a constructor');
	}
	var proto = Get(constructor, 'prototype');
	if (Type(proto) !== 'Object') {
		if (!(constructor instanceof $Function)) {
			// ignore other realms, for now
			throw new $TypeError('cross-realm constructors not currently supported');
		}
		proto = intrinsic;
	}
	return proto;
};


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');
var $parseInt = GetIntrinsic('%parseInt%');

var inspect = __webpack_require__(147);

var regexTester = __webpack_require__(213);
var callBound = __webpack_require__(16);
var every = __webpack_require__(145);

var isDigit = regexTester(/^[0-9]$/);

var strSlice = callBound('String.prototype.slice');

var IsArray = __webpack_require__(54);
var IsInteger = __webpack_require__(88);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-getsubstitution

// eslint-disable-next-line max-statements, max-params, max-lines-per-function
module.exports = function GetSubstitution(matched, str, position, captures, replacement) {
	if (Type(matched) !== 'String') {
		throw new $TypeError('Assertion failed: `matched` must be a String');
	}
	var matchLength = matched.length;

	if (Type(str) !== 'String') {
		throw new $TypeError('Assertion failed: `str` must be a String');
	}
	var stringLength = str.length;

	if (!IsInteger(position) || position < 0 || position > stringLength) {
		throw new $TypeError('Assertion failed: `position` must be a nonnegative integer, and less than or equal to the length of `string`, got ' + inspect(position));
	}

	var ES = this;
	var isStringOrHole = function (capture, index, arr) { return ES.Type(capture) === 'String' || !(index in arr); };
	if (!IsArray(captures) || !every(captures, isStringOrHole)) {
		throw new $TypeError('Assertion failed: `captures` must be a List of Strings, got ' + inspect(captures));
	}

	if (Type(replacement) !== 'String') {
		throw new $TypeError('Assertion failed: `replacement` must be a String');
	}

	var tailPos = position + matchLength;
	var m = captures.length;

	var result = '';
	for (var i = 0; i < replacement.length; i += 1) {
		// if this is a $, and it's not the end of the replacement
		var current = replacement[i];
		var isLast = (i + 1) >= replacement.length;
		var nextIsLast = (i + 2) >= replacement.length;
		if (current === '$' && !isLast) {
			var next = replacement[i + 1];
			if (next === '$') {
				result += '$';
				i += 1;
			} else if (next === '&') {
				result += matched;
				i += 1;
			} else if (next === '`') {
				result += position === 0 ? '' : strSlice(str, 0, position - 1);
				i += 1;
			} else if (next === "'") {
				result += tailPos >= stringLength ? '' : strSlice(str, tailPos);
				i += 1;
			} else {
				var nextNext = nextIsLast ? null : replacement[i + 2];
				if (isDigit(next) && next !== '0' && (nextIsLast || !isDigit(nextNext))) {
					// $1 through $9, and not followed by a digit
					var n = $parseInt(next, 10);
					// if (n > m, impl-defined)
					result += (n <= m && Type(captures[n - 1]) === 'Undefined') ? '' : captures[n - 1];
					i += 1;
				} else if (isDigit(next) && (nextIsLast || isDigit(nextNext))) {
					// $00 through $99
					var nn = next + nextNext;
					var nnI = $parseInt(nn, 10) - 1;
					// if nn === '00' or nn > m, impl-defined
					result += (nn <= m && Type(captures[nnI]) === 'Undefined') ? '' : captures[nnI];
					i += 2;
				} else {
					result += '$';
				}
			}
		} else {
			// the final $, or else not a $
			result += replacement[i];
		}
	}
	return result;
};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var has = __webpack_require__(36);

var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty

module.exports = function HasOwnProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return has(O, P);
};


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

module.exports = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $floor = GetIntrinsic('%Math.floor%');

var mod = __webpack_require__(31);
var timeConstants = __webpack_require__(46);
var msPerHour = timeConstants.msPerHour;
var HoursPerDay = timeConstants.HoursPerDay;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10

module.exports = function HourFromTime(t) {
	return mod($floor(t / msPerHour), HoursPerDay);
};


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var $hasInstance = GetIntrinsic('Symbol.hasInstance', true);

var Call = __webpack_require__(76);
var GetMethod = __webpack_require__(118);
var IsCallable = __webpack_require__(56);
var OrdinaryHasInstance = __webpack_require__(230);
var ToBoolean = __webpack_require__(73);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-instanceofoperator

module.exports = function InstanceofOperator(O, C) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	var instOfHandler = $hasInstance ? GetMethod(C, $hasInstance) : void 0;
	if (typeof instOfHandler !== 'undefined') {
		return ToBoolean(Call(instOfHandler, C, [O]));
	}
	if (!IsCallable(C)) {
		throw new $TypeError('`C` is not Callable');
	}
	return OrdinaryHasInstance(C, O);
};


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $isConcatSpreadable = GetIntrinsic('%Symbol.isConcatSpreadable%', true);

var Get = __webpack_require__(45);
var IsArray = __webpack_require__(54);
var ToBoolean = __webpack_require__(73);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable

module.exports = function IsConcatSpreadable(O) {
	if (Type(O) !== 'Object') {
		return false;
	}
	if ($isConcatSpreadable) {
		var spreadable = Get(O, $isConcatSpreadable);
		if (typeof spreadable !== 'undefined') {
			return ToBoolean(spreadable);
		}
	}
	return IsArray(O);
};


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(16);

var $PromiseThen = callBound('Promise.prototype.then', true);

var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-ispromise

module.exports = function IsPromise(x) {
	if (Type(x) !== 'Object') {
		return false;
	}
	if (!$PromiseThen) { // Promises are not supported
		return false;
	}
	try {
		$PromiseThen(x); // throws if not a promise
	} catch (e) {
		return false;
	}
	return true;
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPropertyDescriptor = __webpack_require__(89);

var Type = __webpack_require__(7);
var IsDataDescriptor = __webpack_require__(30);
var IsAccessorDescriptor = __webpack_require__(55);

// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type

module.exports = function IsPropertyDescriptor(Desc) {
	return isPropertyDescriptor({
		IsDataDescriptor: IsDataDescriptor,
		IsAccessorDescriptor: IsAccessorDescriptor,
		Type: Type
	}, Desc);
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Call = __webpack_require__(76);
var GetMethod = __webpack_require__(118);
var IsCallable = __webpack_require__(56);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose

module.exports = function IteratorClose(iterator, completion) {
	if (Type(iterator) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(iterator) is not Object');
	}
	if (!IsCallable(completion)) {
		throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
	}
	var completionThunk = completion;

	var iteratorReturn = GetMethod(iterator, 'return');

	if (typeof iteratorReturn === 'undefined') {
		return completionThunk();
	}

	var completionRecord;
	try {
		var innerResult = Call(iteratorReturn, iterator, []);
	} catch (e) {
		// if we hit here, then "e" is the innerResult completion that needs re-throwing

		// if the completion is of type "throw", this will throw.
		completionThunk();
		completionThunk = null; // ensure it's not called twice.

		// if not, then return the innerResult completion
		throw e;
	}
	completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
	completionThunk = null; // ensure it's not called twice.

	if (Type(innerResult) !== 'Object') {
		throw new $TypeError('iterator .return must return an object');
	}

	return completionRecord;
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var IteratorComplete = __webpack_require__(232);
var IteratorNext = __webpack_require__(233);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep

module.exports = function IteratorStep(iterator) {
	var result = IteratorNext(iterator);
	var done = IteratorComplete(result);
	return done === true ? false : result;
};



/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var Get = __webpack_require__(45);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue

module.exports = function IteratorValue(iterResult) {
	if (Type(iterResult) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
	}
	return Get(iterResult, 'value');
};



/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isFinite = __webpack_require__(44);
var msPerDay = __webpack_require__(46).msPerDay;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.13

module.exports = function MakeDate(day, time) {
	if (!$isFinite(day) || !$isFinite(time)) {
		return NaN;
	}
	return (day * msPerDay) + time;
};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $floor = GetIntrinsic('%Math.floor%');
var $DateUTC = GetIntrinsic('%Date.UTC%');

var mod = __webpack_require__(31);
var $isFinite = __webpack_require__(44);

var DateFromTime = __webpack_require__(227);
var Day = __webpack_require__(116);
var MonthFromTime = __webpack_require__(153);
var ToInteger = __webpack_require__(115);
var YearFromTime = __webpack_require__(117);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.12

module.exports = function MakeDay(year, month, date) {
	if (!$isFinite(year) || !$isFinite(month) || !$isFinite(date)) {
		return NaN;
	}
	var y = ToInteger(year);
	var m = ToInteger(month);
	var dt = ToInteger(date);
	var ym = y + $floor(m / 12);
	var mn = mod(m, 12);
	var t = $DateUTC(ym, mn, 1);
	if (YearFromTime(t) !== ym || MonthFromTime(t) !== mn || DateFromTime(t) !== 1) {
		return NaN;
	}
	return Day(t) + dt - 1;
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isFinite = __webpack_require__(44);
var timeConstants = __webpack_require__(46);
var msPerSecond = timeConstants.msPerSecond;
var msPerMinute = timeConstants.msPerMinute;
var msPerHour = timeConstants.msPerHour;

var ToInteger = __webpack_require__(115);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.11

module.exports = function MakeTime(hour, min, sec, ms) {
	if (!$isFinite(hour) || !$isFinite(min) || !$isFinite(sec) || !$isFinite(ms)) {
		return NaN;
	}
	var h = ToInteger(hour);
	var m = ToInteger(min);
	var s = ToInteger(sec);
	var milli = ToInteger(ms);
	var t = (h * msPerHour) + (m * msPerMinute) + (s * msPerSecond) + milli;
	return t;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $floor = GetIntrinsic('%Math.floor%');

var mod = __webpack_require__(31);
var timeConstants = __webpack_require__(46);
var msPerMinute = timeConstants.msPerMinute;
var MinutesPerHour = timeConstants.MinutesPerHour;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10

module.exports = function MinFromTime(t) {
	return mod($floor(t / msPerMinute), MinutesPerHour);
};


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mod = __webpack_require__(31);

// https://ecma-international.org/ecma-262/5.1/#sec-5.2

module.exports = function modulo(x, y) {
	return mod(x, y);
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mod = __webpack_require__(31);
var msPerSecond = __webpack_require__(46).msPerSecond;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10

module.exports = function msFromTime(t) {
	return mod(t, msPerSecond);
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $ObjectCreate = GetIntrinsic('%Object.create%', true);
var $TypeError = GetIntrinsic('%TypeError%');
var $SyntaxError = GetIntrinsic('%SyntaxError%');

var Type = __webpack_require__(7);

var hasProto = !({ __proto__: null } instanceof Object);

// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate

module.exports = function ObjectCreate(proto, internalSlotsList) {
	if (proto !== null && Type(proto) !== 'Object') {
		throw new $TypeError('Assertion failed: `proto` must be null or an object');
	}
	var slots = arguments.length < 2 ? [] : internalSlotsList;
	if (slots.length > 0) {
		throw new $SyntaxError('es-abstract does not yet support internal slots');
	}

	if ($ObjectCreate) {
		return $ObjectCreate(proto);
	}
	if (hasProto) {
		return { __proto__: proto };
	}

	if (proto === null) {
		throw new $SyntaxError('native Object.create support is required to create null objects');
	}
	var T = function T() {};
	T.prototype = proto;
	return new T();
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-ordinaryhasproperty

module.exports = function OrdinaryHasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: P must be a Property Key');
	}
	return P in O;
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var regexExec = __webpack_require__(16)('RegExp.prototype.exec');

var Call = __webpack_require__(76);
var Get = __webpack_require__(45);
var IsCallable = __webpack_require__(56);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec

module.exports = function RegExpExec(R, S) {
	if (Type(R) !== 'Object') {
		throw new $TypeError('Assertion failed: `R` must be an Object');
	}
	if (Type(S) !== 'String') {
		throw new $TypeError('Assertion failed: `S` must be a String');
	}
	var exec = Get(R, 'exec');
	if (IsCallable(exec)) {
		var result = Call(exec, R, [S]);
		if (result === null || Type(result) === 'Object') {
			return result;
		}
		throw new $TypeError('"exec" method must return `null` or an Object');
	}
	return regexExec(R, S);
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(43);

// https://www.ecma-international.org/ecma-262/6.0/#sec-samevaluezero

module.exports = function SameValueZero(x, y) {
	return (x === y) || ($isNaN(x) && $isNaN(y));
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $floor = GetIntrinsic('%Math.floor%');

var mod = __webpack_require__(31);
var timeConstants = __webpack_require__(46);
var msPerSecond = timeConstants.msPerSecond;
var SecondsPerMinute = timeConstants.SecondsPerMinute;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.10

module.exports = function SecFromTime(t) {
	return mod($floor(t / msPerSecond), SecondsPerMinute);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = __webpack_require__(19);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw

module.exports = function Set(O, P, V, Throw) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	if (Type(Throw) !== 'Boolean') {
		throw new $TypeError('Assertion failed: `Throw` must be a Boolean');
	}
	if (Throw) {
		O[P] = V; // eslint-disable-line no-param-reassign
		return true;
	} else {
		try {
			O[P] = V; // eslint-disable-line no-param-reassign
		} catch (e) {
			return false;
		}
	}
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var has = __webpack_require__(36);

var $TypeError = GetIntrinsic('%TypeError%');

var getSymbolDescription = __webpack_require__(429);

var DefinePropertyOrThrow = __webpack_require__(154);
var IsExtensible = __webpack_require__(91);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-setfunctionname

module.exports = function SetFunctionName(F, name) {
	if (typeof F !== 'function') {
		throw new $TypeError('Assertion failed: `F` must be a function');
	}
	if (!IsExtensible(F) || has(F, 'name')) {
		throw new $TypeError('Assertion failed: `F` must be extensible, and must not have a `name` own property');
	}
	var nameType = Type(name);
	if (nameType !== 'Symbol' && nameType !== 'String') {
		throw new $TypeError('Assertion failed: `name` must be a Symbol or a String');
	}
	if (nameType === 'Symbol') {
		var description = getSymbolDescription(name);
		// eslint-disable-next-line no-param-reassign
		name = typeof description === 'undefined' ? '' : '[' + description + ']';
	}
	if (arguments.length > 2) {
		var prefix = arguments[2];
		// eslint-disable-next-line no-param-reassign
		name = prefix + ' ' + name;
	}
	return DefinePropertyOrThrow(F, 'name', {
		'[[Value]]': name,
		'[[Writable]]': false,
		'[[Enumerable]]': false,
		'[[Configurable]]': true
	});
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var callBound = __webpack_require__(16);

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var symToStr = callBound('Symbol.prototype.toString', true);

var getInferredName = __webpack_require__(430);

module.exports = function getSymbolDescription(symbol) {
	if (!symToStr) {
		throw new $SyntaxError('Symbols are not supported in this environment');
	}
	var str = symToStr(symbol); // will throw if not a symbol

	if (getInferredName) {
		var name = getInferredName(symbol);
		if (name === '') { return; }
		// eslint-disable-next-line consistent-return
		return name.slice(1, -1); // name.slice('['.length, -']'.length);
	}

	var desc = str.slice(7, -1); // str.slice('Symbol('.length, -')'.length);
	if (desc) {
		// eslint-disable-next-line consistent-return
		return desc;
	}
};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getInferredName;
try {
	// eslint-disable-next-line no-new-func
	getInferredName = Function('s', 'return { [s]() {} }[s].name;');
} catch (e) {}

var inferred = function () {};
module.exports = getInferredName && inferred.name === 'inferred' ? getInferredName : null;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $SyntaxError = GetIntrinsic('%SyntaxError%');
var $TypeError = GetIntrinsic('%TypeError%');
var $preventExtensions = GetIntrinsic('%Object.preventExtensions%');
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');
var $gOPN = GetIntrinsic('%Object.getOwnPropertyNames%');

var forEach = __webpack_require__(432);

var DefinePropertyOrThrow = __webpack_require__(154);
var IsAccessorDescriptor = __webpack_require__(55);
var ToPropertyDescriptor = __webpack_require__(72);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-setintegritylevel

module.exports = function SetIntegrityLevel(O, level) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (level !== 'sealed' && level !== 'frozen') {
		throw new $TypeError('Assertion failed: `level` must be `"sealed"` or `"frozen"`');
	}
	if (!$preventExtensions) {
		throw new $SyntaxError('SetIntegrityLevel requires native `Object.preventExtensions` support');
	}
	var status = $preventExtensions(O);
	if (!status) {
		return false;
	}
	if (!$gOPN) {
		throw new $SyntaxError('SetIntegrityLevel requires native `Object.getOwnPropertyNames` support');
	}
	var theKeys = $gOPN(O);
	if (level === 'sealed') {
		forEach(theKeys, function (k) {
			DefinePropertyOrThrow(O, k, { configurable: false });
		});
	} else if (level === 'frozen') {
		forEach(theKeys, function (k) {
			var currentDesc = $gOPD(O, k);
			if (typeof currentDesc !== 'undefined') {
				var desc;
				if (IsAccessorDescriptor(ToPropertyDescriptor(currentDesc))) {
					desc = { configurable: false };
				} else {
					desc = { configurable: false, writable: false };
				}
				DefinePropertyOrThrow(O, k, desc);
			}
		});
	}
	return true;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function forEach(array, callback) {
	for (var i = 0; i < array.length; i += 1) {
		callback(array[i], i, array); // eslint-disable-line callback-return
	}
};


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $species = GetIntrinsic('%Symbol.species%', true);
var $TypeError = GetIntrinsic('%TypeError%');

var IsConstructor = __webpack_require__(114);
var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor

module.exports = function SpeciesConstructor(O, defaultConstructor) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	var C = O.constructor;
	if (typeof C === 'undefined') {
		return defaultConstructor;
	}
	if (Type(C) !== 'Object') {
		throw new $TypeError('O.constructor is not an Object');
	}
	var S = $species ? C[$species] : void 0;
	if (S == null) {
		return defaultConstructor;
	}
	if (IsConstructor(S)) {
		return S;
	}
	throw new $TypeError('no constructor found');
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');

var callBound = __webpack_require__(16);

var $SymbolToString = callBound('Symbol.prototype.toString', true);

var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-symboldescriptivestring

module.exports = function SymbolDescriptiveString(sym) {
	if (Type(sym) !== 'Symbol') {
		throw new $TypeError('Assertion failed: `sym` must be a Symbol');
	}
	return $SymbolToString(sym);
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%');
var $gOPN = GetIntrinsic('%Object.getOwnPropertyNames%');
var $TypeError = GetIntrinsic('%TypeError%');

var every = __webpack_require__(145);

var IsDataDescriptor = __webpack_require__(30);
var IsExtensible = __webpack_require__(91);
var ToPropertyDescriptor = __webpack_require__(72);
var Type = __webpack_require__(7);

// https://www.ecma-international.org/ecma-262/6.0/#sec-testintegritylevel

module.exports = function TestIntegrityLevel(O, level) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	if (level !== 'sealed' && level !== 'frozen') {
		throw new $TypeError('Assertion failed: `level` must be `"sealed"` or `"frozen"`');
	}
	var status = IsExtensible(O);
	if (status) {
		return false;
	}
	var theKeys = $gOPN(O);
	return theKeys.length === 0 || every(theKeys, function (k) {
		var currentDesc = $gOPD(O, k);
		if (typeof currentDesc !== 'undefined') {
			if (currentDesc.configurable) {
				return false;
			}
			if (level === 'frozen' && IsDataDescriptor(ToPropertyDescriptor(currentDesc)) && currentDesc.writable) {
				return false;
			}
		}
		return true;
	});
};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $BooleanValueOf = __webpack_require__(16)('Boolean.prototype.valueOf');

var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object

module.exports = function thisBooleanValue(value) {
	if (Type(value) === 'Boolean') {
		return value;
	}

	return $BooleanValueOf(value);
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBound = __webpack_require__(16);

var Type = __webpack_require__(7);

var $NumberValueOf = callBound('Number.prototype.valueOf');

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object

module.exports = function thisNumberValue(value) {
	if (Type(value) === 'Number') {
		return value;
	}

	return $NumberValueOf(value);
};



/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $StringValueOf = __webpack_require__(16)('String.prototype.valueOf');

var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object

module.exports = function thisStringValue(value) {
	if (Type(value) === 'String') {
		return value;
	}

	return $StringValueOf(value);
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $DateValueOf = __webpack_require__(16)('Date.prototype.valueOf');

// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object

module.exports = function thisTimeValue(value) {
	return $DateValueOf(value);
};


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Date = GetIntrinsic('%Date%');
var $Number = GetIntrinsic('%Number%');
var $abs = GetIntrinsic('%Math.abs%');

var $isFinite = __webpack_require__(44);

var ToNumber = __webpack_require__(26);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.14

module.exports = function TimeClip(time) {
	if (!$isFinite(time) || $abs(time) > 8.64e15) {
		return NaN;
	}
	return $Number(new $Date(ToNumber(time)));
};



/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var msPerDay = __webpack_require__(46).msPerDay;

var DayFromYear = __webpack_require__(151);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.3

module.exports = function TimeFromYear(y) {
	return msPerDay * DayFromYear(y);
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mod = __webpack_require__(31);
var msPerDay = __webpack_require__(46).msPerDay;

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.2

module.exports = function TimeWithinDay(t) {
	return mod(t, msPerDay);
};



/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $TypeError = GetIntrinsic('%TypeError%');
var $Date = GetIntrinsic('%Date%');

var $isNaN = __webpack_require__(43);

var Type = __webpack_require__(7);

// https://ecma-international.org/ecma-262/6.0/#sec-todatestring

module.exports = function ToDateString(tv) {
	if (Type(tv) !== 'Number') {
		throw new $TypeError('Assertion failed: `tv` must be a Number');
	}
	if ($isNaN(tv)) {
		return 'Invalid Date';
	}
	return $Date(tv);
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToUint16 = __webpack_require__(234);

// https://www.ecma-international.org/ecma-262/6.0/#sec-toint16

module.exports = function ToInt16(argument) {
	var int16bit = ToUint16(argument);
	return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToNumber = __webpack_require__(26);

// http://www.ecma-international.org/ecma-262/5.1/#sec-9.5

module.exports = function ToInt32(x) {
	return ToNumber(x) >> 0;
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ToUint8 = __webpack_require__(235);

// https://www.ecma-international.org/ecma-262/6.0/#sec-toint8

module.exports = function ToInt8(argument) {
	var int8bit = ToUint8(argument);
	return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $String = GetIntrinsic('%String%');

var ToPrimitive = __webpack_require__(87);
var ToString = __webpack_require__(75);

// https://www.ecma-international.org/ecma-262/6.0/#sec-topropertykey

module.exports = function ToPropertyKey(argument) {
	var key = ToPrimitive(argument, $String);
	return typeof key === 'symbol' ? key : ToString(key);
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(4);

var $Math = GetIntrinsic('%Math%');

var ToNumber = __webpack_require__(26);

var $isNaN = __webpack_require__(43);

var $floor = $Math.floor;

// https://www.ecma-international.org/ecma-262/6.0/#sec-touint8clamp

module.exports = function ToUint8Clamp(argument) {
	var number = ToNumber(argument);
	if ($isNaN(number) || number <= 0) { return 0; }
	if (number >= 0xFF) { return 0xFF; }
	var f = $floor(argument);
	if (f + 0.5 < number) { return f + 1; }
	if (number < f + 0.5) { return f; }
	if (f % 2 !== 0) { return f + 1; }
	return f;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mod = __webpack_require__(31);

var Day = __webpack_require__(116);

// https://ecma-international.org/ecma-262/5.1/#sec-15.9.1.6

module.exports = function WeekDay(t) {
	return mod(Day(t) + 4, 7);
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(109);
var getPolyfill = __webpack_require__(237);

module.exports = function shimArrayPrototypeFind() {
	var polyfill = getPolyfill();

	define(Array.prototype, { find: polyfill }, {
		find: function () {
			return Array.prototype.find !== polyfill;
		}
	});

	return polyfill;
};


/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = {"BigData":{"Server":[{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-B21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC 2.5in DS SSD","PartNumber":"P07922-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 480GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19947-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC MV SSD","PartNumber":"P18432-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-B21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 600GB SAS 15K 2.5in SC DS HDD","PartNumber":"870757-B21","NewDesc":"HPE 600GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe x4 MU 2.5in SN DS SSD","PartNumber":"P13668-B21","NewDesc":"HPE 800GB NVMe x4 MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20094-B21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22329-B21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P25953-B21","NewDesc":"HPE 800GB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 900GB 12G SAS 15K 2.5in SC DS HDD","PartNumber":"870759-B21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-B21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09716-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-B21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1TB 12G SAS 7.2K 2.5in MDL SC HDD","PartNumber":"832514-B21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe x4 Lanes MU 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10222-B21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13670-B21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20096-B21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20203-B21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22268-B21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-B21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09722-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB NVMe x4 Lanes RI 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10214-B21","NewDesc":"HPE 1.92TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-B21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-B21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-B21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe x4 Lanes MU 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10224-B21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13672-B21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20098-B21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20205-B21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22270-B21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB NVMe x4 Lanes RI 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10216-B21","NewDesc":"HPE 3.84TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC DS SSD","PartNumber":"P21517-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-B21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe x4 Lanes MU 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10226-B21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13674-B21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20100-B21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20207-B21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22272-B21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 7.68TB NVMe x4 Lanes RI 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10218-B21","NewDesc":"HPE 7.68TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 12.8TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20209-B21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22274-B21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 480GB SATA MU LFF SCC DS SSD","PartNumber":"P07924-B21","NewDesc":"HPE 480GB SATA 6G MU LFF SCC DS SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 480GB SATA MU 3.5in SCC SSD","PartNumber":"P19978-B21","NewDesc":"HPE 480GB SATA 6G MU LFF SCC 5300M SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 800GB SAS MU LFF SCC DS SSD","PartNumber":"P04529-B21","NewDesc":"HPE 800GB SAS 12G MU LFF SCC PM5 SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 960GB SATA MU LFF SCC DS SSD","PartNumber":"P09718-B21","NewDesc":"HPE 960GB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1.92TB SATA MU LFF SCC DS SSD","PartNumber":"P09724-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1.92TB SATA MU 3.5in SCC SSD","PartNumber":"P19982-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC 5300M SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2TB 6G SATA 7.2K LFF SC HDD","PartNumber":"872489-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2TB SAS 12G 7.2K 3.5in SC DS HDD","PartNumber":"872485-B21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 4TB SATA 6G 7.2K 3.5in SC DS HDD","PartNumber":"872491-B21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 4TB SAS 12G 7.2K 3.5in SC DS HDD","PartNumber":"872487-B21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 6TB 6G SATA 7.2K LFF MDL SC HDD","PartNumber":"846510-B21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 6TB 12G SAS 7.2K LFF MDL SC HDD","PartNumber":"846514-B21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 8TB 6G SATA 7.2K LFF 3.5in 512e SC MDL HDD","PartNumber":"819203-B21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 8TB SAS 7.2K LFF SC 512e DS HDD","PartNumber":"819201-B21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 10TB 6G SATA 7.2K 3.5in 512e SC HDD","PartNumber":"857648-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 10TB SAS 7.2K LFF SC He 512e DS HDD","PartNumber":"857644-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 12TB SATA 7.2K 3.5in SC He 512e DS HDD","PartNumber":"881785-B21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 12TB SAS 7.2K LFF SC He 512e DS HDD","PartNumber":"881779-B21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 16TB SATA 7.2K 3.5in ISE He LP HDD","PartNumber":"P23857-B21","NewDesc":"HPE 16TB SATA 6G BC 7.2K LFF SC 512e ISE HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 16TB SAS 7.2K 3.5in ISE He LP HDD","PartNumber":"P23863-B21","NewDesc":"HPE 16TB SAS 12G BC 7.2K LFF SC 512e ISE HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 480GB SATA MU 2.5inches SC DS SSD","PartNumber":"875470-B21","NewDesc":"HPE 480GB SATA MU SFF SC DS SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 1TB SATA 7.2K 2.5inches SC DS HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1TB SATA 7.2K 2.5inches SC DS HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 480GB SATA MU 2.5inches SC DS SSD","PartNumber":"875470-B21","NewDesc":"HPE 480GB SATA MU SFF SC DS SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1TB SATA 7.2K 2.5inches SC DS HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5inches SC 512e DS HDD","PartNumber":"872481-B21","NewDesc":"HPE 1.8TB SAS 10K SFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2TB SATA 7.2K 2.5inches SC 512e DS HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 2TB SATA 7.2K 2.5inches SC 512e DS HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 2TB SATA 7.2K 2.5inches SC 512e DS HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5inches SC 512e DS HDD","PartNumber":"881457-B21","NewDesc":"HPE 2.4TB SAS 12G 10K SFFS SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 480GB SATA MU LFF SCC DS SSD","PartNumber":"P07924-B21","NewDesc":"HPE 480GB SATA 6G MU LFF SCC DS SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 480GB SATA MU 3.5in SCC SSD","PartNumber":"P19978-B21","NewDesc":"HPE 480GB SATA 6G MU LFF SCC 5300M SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 800GB SAS MU LFF SCC DS SSD","PartNumber":"P04529-B21","NewDesc":"HPE 800GB SAS 12G MU LFF SCC PM5 SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 960GB SATA MU LFF SCC DS SSD","PartNumber":"P09718-B21","NewDesc":"HPE 960GB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 960GB SATA MU 3.5in SCC DS SSD","PartNumber":"P09718-B21","NewDesc":"HPE 960GB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 1.92TB SATA MU LFF SCC DS SSD","PartNumber":"P09724-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 1.92TB SATA MU 3.5in SCC SSD","PartNumber":"P19982-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC 5300M SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 1.92TB SATA MU 3.5in SCC DS SSD","PartNumber":"P09724-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 2TB 6G SATA 7.2K LFF SC HDD","PartNumber":"872489-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 2TB SAS 12G 7.2K 3.5in SC DS HDD","PartNumber":"872485-B21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 4TB SATA 6G 7.2K 3.5in SC DS HDD","PartNumber":"872491-B21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 4TB SAS 12G 7.2K 3.5in SC DS HDD","PartNumber":"872487-B21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 6TB SATA 7.2K 3.5in SC 512e DS HDD","PartNumber":"861750-B21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF SC 512e HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 6TB 12G SAS 7.2K LFF MDL SC HDD","PartNumber":"846514-B21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 8TB 6G SATA 7.2K LFF 3.5in 512e SC MDL HDD","PartNumber":"819203-B21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 8TB 12G SAS 7.2K LFF 3.5in 512e SC MDL HDD","PartNumber":"819201-B21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 10TB 6G SATA 7.2K 3.5in 512e SC HDD","PartNumber":"857648-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 10TB 12G SAS 7.2K 3.5in 512e SC HDD","PartNumber":"857644-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 12TB SATA 7.2K 3.5in SC He 512e DS HDD","PartNumber":"881785-B21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 12TB SAS 7.2K 3.5in SC He 512e DS HDD","PartNumber":"881779-B21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 16TB SATA 7.2K 3.5in ISE He LP HDD","PartNumber":"P23449-B21","NewDesc":"HPE 16TB SATA 6G BC 7.2K LFF 512e ISE HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 16TB SAS 7.2K 3.5in ISE He LP HDD","PartNumber":"P23608-B21","NewDesc":"HPE 16TB SAS 12G BC 7.2K LFF 512e ISE HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 480GB SATA RI 3.5in LPC DS SSD","PartNumber":"P04499-B21","NewDesc":"HPE 480GB SATA 6G RI LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 960GB SATA RI LFF 3.5in LFF LPC DS SSD","PartNumber":"P09691-B21","NewDesc":"HPE 960GB SATA 6G RI LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 960GB SAS MU 3.5in LPC VS DS SSD","PartNumber":"P10452-B21","NewDesc":"HPE 960GB SAS 12G MU LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1TB 6G SATA 7.2K 3.5in MDL LP HDD","PartNumber":"861686-B21","NewDesc":"HPE 1TB SATA 6G 7.2K LFF DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1.6TB SAS MU 3.5in LPC DS SSD","PartNumber":"P04535-B21","NewDesc":"HPE 1.6TB SAS 12G MU LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1.92TB SATA RI LFF 3.5in LFF LPC DS SSD","PartNumber":"P04501-B21","NewDesc":"HPE 1.92TB SATA 6G RI LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1.92TB SATA MULFF 3.5in LFF LPC DS SSD","PartNumber":"P07934-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1.92TB SATA MU LFF 3.5in LFF LPC DS SSD","PartNumber":"P09726-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1.92TB SAS MU 3.5in LPC VS DS SSD","PartNumber":"P10458-B21","NewDesc":"HPE 1.92TB SAS 12G MU LFF Value SAS DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 2TB 12G SAS 7.2K 3.5in MDL LP HDD","PartNumber":"833926-B21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 2TB 6G SATA 7.2K 3.5in MDL LP HDD","PartNumber":"861681-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 3.84TB SAS MU 3.5in LPC VS DS SSD","PartNumber":"P10462-B21","NewDesc":"HPE 3.84TB SAS 12G MU LFF Value SAS DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 4TB 12G SAS 7.2K 3.5in MDL LP HDD","PartNumber":"833928-B21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 4TB 6G SATA 7.2K 3.5in MDL LP HDD","PartNumber":"861683-B21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 6TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"861746-B21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF 512e HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 6TB 6G SATA 7.2K 3.5in 512e MDL LP HDD","PartNumber":"861742-B21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF 512e HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 8TB 12G SAS 7.2K LFF 3.5in 512e LP MDL HDD","PartNumber":"834031-B21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 8TB 6G SATA 7.2K LFF 3.5in 512e LP MDL HDD","PartNumber":"834028-B21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 10TB SAS 7.2K 3.5in LFF LP He 512e DS HDD","PartNumber":"P09149-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 10TB SAS 7.2K 3.5in LP DS 6pk FIO HDD","PartNumber":"P09799-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF He 512e DS 6-pack FIO HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 10TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09161-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 10TB SATA 7.2K 3.5in LP DS 6pk FIO HDD","PartNumber":"P09797-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF He 512e DS 6-pack FIO HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 12TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881781-B21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 12TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881787-B21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 14TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09155-B21","NewDesc":"HPE 14TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 14TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09165-B21","NewDesc":"HPE 14TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 16TB SAS 7.2K 3.5in ISE He LP HDD","PartNumber":"P23608-B21","NewDesc":"HPE 16TB SAS 12G BC 7.2K LFF 512e ISE HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 16TB SATA 7.2K 3.5in ISE He LP HDD","PartNumber":"P23449-B21","NewDesc":"HPE 16TB SATA 6G BC 7.2K LFF 512e ISE HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 960GB SATA RI 2.5inches SC DS SSD","PartNumber":"P04476-B21","NewDesc":"HPE 960GB SATA RI SFF SC DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1.92TB SATA RI 2.5inches SC DS SSD","PartNumber":"P04478-B21","NewDesc":"HPE 1.92TB SATA RI SFF SC DS SSD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 3.84TB SATA RI 2.5inches SC DS SSD","PartNumber":"P04480-B21","NewDesc":"HPE 3.84TB SATA RI SFFS SC DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC DS SSD","PartNumber":"P07922-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 480GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19947-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC MV SSD","PartNumber":"P18432-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22329-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20094-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 900GB SAS 15K 2.5in SC DS HDD","PartNumber":"870759-H21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC DS SSD","PartNumber":"875474-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-H21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1TB SAS 7.2K 2.5in SC DS HDD","PartNumber":"832514-H21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-H21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P10222-H21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22268-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20096-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20203-H21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-H21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC DS SSD","PartNumber":"P09722-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P10214-H21","NewDesc":"HPE 1.92TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-H21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-H21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-H21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P10224-H21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20098-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20205-H21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC DS SSD","PartNumber":"P00896-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P10216-H21","NewDesc":"HPE 3.84TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-H21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P10226-H21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22272-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20100-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20207-H21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 7.68TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P10218-H21","NewDesc":"HPE 7.68TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22274-H21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20209-H21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-H21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-H21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC DS SSD","PartNumber":"P09716-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-H21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-H21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC DS SSD","PartNumber":"P07922-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC MV SSD","PartNumber":"P18432-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 480GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19947-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22329-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20094-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 900GB SAS 15K 2.5in SC DS HDD","PartNumber":"870759-H21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC DS SSD","PartNumber":"P09716-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-H21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1TB SAS 7.2K 2.5in SC DS HDD","PartNumber":"832514-H21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-H21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22268-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20096-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20203-H21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-H21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC DS SSD","PartNumber":"P09722-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-H21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-H21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-H21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20205-H21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20098-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC DS SSD","PartNumber":"P00896-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-H21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22272-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20207-H21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20100-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22274-H21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20209-H21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC DS SSD","PartNumber":"P07922-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 480GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19947-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC MV SSD","PartNumber":"P18432-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 600GB SAS 15K 2.5in SC DS HDD","PartNumber":"870757-H21","NewDesc":"HPE 600GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P25953-H21","NewDesc":"HPE 800GB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22329-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20094-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 900GB SAS 15K 2.5in SC DS HDD","PartNumber":"870759-H21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC DS SSD","PartNumber":"P09716-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-H21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1TB SATA 7.2K 2.5in SC DS HDD","PartNumber":"655710-H21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-H21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P10222-H21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU 2.5in SCN SFF DS SSD","PartNumber":"P13699-H21","NewDesc":"HPE 1.6TB NVMe x4 MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22268-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20096-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20203-H21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC DS SSD","PartNumber":"P09722-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P10214-H21","NewDesc":"HPE 1.92TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-H21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-H21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-H21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-H21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P10224-H21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU 2.5in SCN SFF DS SSD","PartNumber":"P13701-H21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-H21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20205-H21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20098-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA SFF MU 2.5in SC DS SSD","PartNumber":"P21517-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P10216-H21","NewDesc":"HPE 3.84TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC DS SSD","PartNumber":"P00896-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-H21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P10226-H21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU 2.5in SCN SFF DS SSD","PartNumber":"P13703-H21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20207-H21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20100-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 7.68TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P10218-H21","NewDesc":"HPE 7.68TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22274-H21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20209-H21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC DS SSD","PartNumber":"P07922-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 480GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19947-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-B21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 400GB SAS 12G WI 2.5in SC DS SSD","PartNumber":"873351-B21","NewDesc":"HPE 400GB SAS 12G WI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 480GB SATA MU 2.5in SC 2.5in DS SSD","PartNumber":"P07922-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 480GB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04474-B21","NewDesc":"HPE 480GB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-B21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 800GB SAS 12G WI 2.5in SC DS SSD","PartNumber":"873355-B21","NewDesc":"HPE 800GB SAS 12G WI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 900GB 12G SAS 15K 2.5in SC DS HDD","PartNumber":"870759-B21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 960GB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09716-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 960GB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04476-B21","NewDesc":"HPE 960GB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 960GB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04517-B21","NewDesc":"HPE 960GB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-B21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-B21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09722-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.92TB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04478-B21","NewDesc":"HPE 1.92TB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.92TB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04519-B21","NewDesc":"HPE 1.92TB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-B21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 3.84TB SATA MU 2.5in SC DS SSD","PartNumber":"P00896-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 3.84TB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04521-B21","NewDesc":"HPE 3.84TB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 7.68TB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04482-B21","NewDesc":"HPE 7.68TB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 7.68TB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04523-B21","NewDesc":"HPE 7.68TB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 7.68TB SAS RI 2.5in SC 2.5in DS SSD","PartNumber":"P06590-B21","NewDesc":"HPE 7.68TB SAS 12G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 15.3TB SAS RI 2.5in SC 2.5in DS SSD","PartNumber":"P06592-B21","NewDesc":"HPE 15.3TB SAS 12G RI SFF SC DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 480GB SATA RI 3.5in LPC DS SSD","PartNumber":"P04499-K21","NewDesc":"HPE 480GB SATA 6G RI LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 480GB SATA RI 3.5in LFF LPC DS SSD","PartNumber":"P19974-K21","NewDesc":"HPE 480GB SATA 6G RI LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 480GB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18432-K21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 800GB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13668-K21","NewDesc":"HPE 800GB NVMe x4 MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 800GB SAS MU 3.5in LPC DS SSD","PartNumber":"P04531-K21","NewDesc":"HPE 800GB SAS 12G MU LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 800GB SAS MU 2.5INCH SC SSD","PartNumber":"P19913-K21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18434-K21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SATA RI 3.5in LPC DS SSD","PartNumber":"P09691-K21","NewDesc":"HPE 960GB SATA 6G RI LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13676-K21","NewDesc":"HPE 960GB NVMe x4 SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SATA MU 3.5in LPC DS SSD","PartNumber":"P19980-K21","NewDesc":"HPE 960GB SATA 6G MU LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SAS MU 3.5in LPC VS DS SSD","PartNumber":"P10452-K21","NewDesc":"HPE 960GB SAS 12G MU LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.6TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13699-K21","NewDesc":"HPE 1.6TB NVMe x4 MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.6TB SAS MU 3.5in LPC DS SSD","PartNumber":"P04535-K21","NewDesc":"HPE 1.6TB SAS 12G MU LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.6TB SAS MU 2.5INCH SC SSD","PartNumber":"P19915-K21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA MU 3.5in LPC DS SSD","PartNumber":"P09726-K21","NewDesc":"HPE 1.92TB SATA 6G MU LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18436-K21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13678-K21","NewDesc":"HPE 1.92TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA LFF MU 3.5in LFF LPC DS SSD","PartNumber":"P19984-K21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA RI 3.5in LFF LPC DS SSD","PartNumber":"P19976-K21","NewDesc":"HPE 1.92TB SATA 6G RI LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 2TB SATA 7.2K 3.5in LP DS HDD","PartNumber":"861681-K21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 2TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13695-K21","NewDesc":"HPE 2TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 2TB SAS 7.2K 3.5in LP DS HDD","PartNumber":"833926-K21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.2TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13701-K21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.2TB SAS MU 2.5INCH SC SSD","PartNumber":"P19917-K21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.84TB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18438-K21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.84TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13680-K21","NewDesc":"HPE 3.84TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.84TB SAS MU 3.5in LPC VS DS SSD","PartNumber":"P10462-K21","NewDesc":"HPE 3.84TB SAS 12G MU LFF Value SAS DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 4TB SATA 7.2K 3.5in LP DS HDD","PartNumber":"861683-K21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 4TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13697-K21","NewDesc":"HPE 4TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 4TB SAS 7.2K 3.5in LP DS HDD","PartNumber":"833928-K21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6TB SATA 7.2K 3.5in LP 512e DS HDD","PartNumber":"861742-K21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"861746-K21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6.4TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13703-K21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6.4TB SAS MU 2.5INCH SC SSD","PartNumber":"P19919-K21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 7.68TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13682-K21","NewDesc":"HPE 7.68TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 8TB SATA 7.2K 3.5in LP 512e DS HDD","PartNumber":"834028-K21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 8TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"834031-K21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SATA 6G Midline 7.2K 3.5in LP 1yr Wty He 512e DS 6-pack FIO HDD","PartNumber":"P09797-K21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF He 512e DS 6-pack FIO HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09161-K21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SAS 7.2K LFF LP He 512e DS HDD","PartNumber":"857646-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SAS 12G Midline 7.2K 3.5in LP 1yr Wty He 512e DS 6-pack FIO HDD","PartNumber":"P09799-K21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF He 512e DS 6-pack FIO HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09149-K21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 12TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881787-K21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 12TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881781-K21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 14TB SATA 6G Midline 7.2K 3.5in LP 1yr Wty Helium 512e DS Firmware HDD","PartNumber":"P09165-K21","NewDesc":"HPE 14TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 14TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09155-K21","NewDesc":"HPE 14TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 16TB SATA 7.2K 3.5in LP 512e ISE HDD","PartNumber":"P23449-K21","NewDesc":"HPE 16TB SATA 6G BC 7.2K LFF 512e ISE HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 16TB SAS 7.2K 3.5in LP 512e ISE HDD","PartNumber":"P23608-K21","NewDesc":"HPE 16TB SAS 12G BC 7.2K LFF 512e ISE HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 2TB SAS 7.2K 3.5in LP DS HDD","PartNumber":"833926-K21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 2TB SATA 7.2K 3.5in LP DS HDD","PartNumber":"861681-K21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 4TB SATA 7.2K 3.5in LP DS HDD","PartNumber":"861683-K21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 4TB SAS 7.2K 3.5in LP DS HDD","PartNumber":"833928-K21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 6TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"861746-K21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 6TB SATA 7.2K 3.5in LP 512e DS HDD","PartNumber":"861742-K21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 8TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"834031-K21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 8TB SATA 7.2K 3.5in LP 512e DS HDD","PartNumber":"834028-K21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 10TB SAS 7.2K LFF LP He 512e DS HDD","PartNumber":"857646-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 10TB SATA 7.2K LFF LP He 512e DS HDD","PartNumber":"857650-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 12TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881787-K21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 12TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881781-K21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-K21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-K21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-B21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"HPE EL300 Converged Edge System","OldDesc":"HPE EL 128GB SATA MU M.2 2242 WT DS SSD","PartNumber":"P09184-B21","NewDesc":"HPE Edgeline 128GB SATA 6G MU M.2 2242 DS SSD"},{"Name":"HPE EL300 Converged Edge System","OldDesc":"HPE EL 256GB SATA RI M.2 2242 WT DS SSD","PartNumber":"P09188-B21","NewDesc":"HPE Edgeline 256GB SATA 6G RI M.2 2242 SSD"},{"Name":"HPE EL300 Converged Edge System","OldDesc":"HPE EL 512GB SATA RI M.2 2280 WT DS SSD","PartNumber":"P08540-B21","NewDesc":"HPE Edgeline 512GB SATA 6G RI M.2 2280 DS SSD"},{"Name":"HPE EL300 Converged Edge System","OldDesc":"HPE EL 1TB SATA RI M.2 2280 WT DS SSD","PartNumber":"P08541-B21","NewDesc":"HPE Edgeline 1TB SATA 6G RI M.2 2280 DS SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE Moonshot m510 Cartridge Server","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE Moonshot m710x Cartridge Server","OldDesc":"HPE 256GB PCIe M.2 2280 SSD Kit","PartNumber":"862159-B21","NewDesc":"HPE 256GB PCIe M.2 2280 SSD"},{"Name":"HPE Moonshot m710x Cartridge Server","OldDesc":"HPE 512GB PCIe M.2 2280 SSD Kit","PartNumber":"862161-B21","NewDesc":""},{"Name":"HPE Moonshot m710x Cartridge Server","OldDesc":"HPE 1024GB PCIe M.2 2280 SSD Kit","PartNumber":"862163-B21","NewDesc":""},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 2U CTO Blade Server","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL1000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant m710x Server Cartridge EL4000 4x10G 2xQSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 400GB SAS SFF MU 2.5in SC DS SSD","PartNumber":"P04525-B21","NewDesc":"HPE 400GB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 400GB SAS MU 2.5in-SFF SC DS SSD","PartNumber":"P09088-B21","NewDesc":"HPE 400GB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 480GB SATA MU 2.5inches SC DS SSD","PartNumber":"P05976-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 480GB SATA MU 2.5in SC 2.5in DS SSD","PartNumber":"P07922-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 480GB SATA MU 2.5in-SFF SC DS SSD","PartNumber":"P13658-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC SE5031 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 480GB SATA MU 2.5in SC MV SSD","PartNumber":"P18432-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 480GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19947-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 750GB NVMe x4 WI 2.5in SCN DS SSD","PartNumber":"P06952-B21","NewDesc":"HPE 750GB NVMe x4 Lanes WI SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 800GB SAS MU 2.5in-SFF SC DS SSD","PartNumber":"P09090-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 800GB SAS SFF MU 2.5in SC DS SSD","PartNumber":"P04527-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 800GB NVMe x4 MU 2.5in SN DS SSD","PartNumber":"P13668-B21","NewDesc":"HPE 800GB NVMe x4 MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 800GB NVMe Perf MU 2.5inU.3 SC DS SSD","PartNumber":"P20084-B21","NewDesc":"HPE 800GB NVMe MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-B21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 960GB SATA MU 2.5inches SC DS SSD","PartNumber":"P05980-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 960GB SATA SFF MU 2.5in SC DS SSD","PartNumber":"P07926-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 960GB SATA MU 2.5in-SFF SC DS SSD","PartNumber":"P13660-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SE5031 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB SAS MU SFF 2.5inSFF SC DS SSD","PartNumber":"P04533-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB SAS MU 2.5in-SFF SC DS SSD","PartNumber":"P09092-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13670-B21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB NVMe x4 SFF MU 2.5in SCN DS SSD","PartNumber":"P13699-B21","NewDesc":"HPE 1.6TB NVMe x4 MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB NVMe Perf MU 2.5in SC U.3 SSD","PartNumber":"P16497-B21","NewDesc":"HPE 1.6TB NVMe MU SFF SC U.3 PM1735 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB NVMe Perf MU 2.5in U.3 SC SSD","PartNumber":"P20086-B21","NewDesc":"HPE 1.6TB NVMe MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.6TB NVMe Main MU 2.5in SC U.3 SSD","PartNumber":"P20195-B21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-B21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.92TB SATA MU 2.5inches SC DS SSD","PartNumber":"P05986-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.92TB SATA MU 2.5in-SFF SC DS SSD","PartNumber":"P13662-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SE5031 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.92TB SATA SFF MU 2.5in SC DS SSD","PartNumber":"P07930-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB SAS MU 2.5in-SFF SC DS SSD","PartNumber":"P09094-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB SAS MU SFF 2.5inSFF SC DS SSD","PartNumber":"P04537-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13672-B21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB NVMe x4 SFF MU 2.5in SCN DS SSD","PartNumber":"P13701-B21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB NVMe Perf MU 2.5in SC U.3 SSD","PartNumber":"P16499-B21","NewDesc":"HPE 3.2TB NVMe MU SFF SC U.3 PM1735 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB NVMe Perf MU 2.5in U.3 SC SSD","PartNumber":"P20088-B21","NewDesc":"HPE 3.2TB NVMe MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.2TB NVMe Main MU 2.5in SC U.3 SSD","PartNumber":"P20197-B21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-B21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.84TB SATA MU 2.5inches SC DS SSD","PartNumber":"P05994-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.84TB SATA MU 2.5in-SFF SC DS SSD","PartNumber":"P13664-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF RW SE5031 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC DS SSD","PartNumber":"P21517-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB SAS MU SFF 2.5inSFF SC DS SSD","PartNumber":"P04539-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB SAS MU 2.5in-SFF SC DS SSD","PartNumber":"P09096-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13674-B21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB NVMe x4 SFF MU 2.5in SCN DS SSD","PartNumber":"P13703-B21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB NVMe Perf MU 2.5in U.3 SC SSD","PartNumber":"P20090-B21","NewDesc":"HPE 6.4TB NVMe MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 6.4TB NVMe Main MU 2.5in SC U.3 SSD","PartNumber":"P20199-B21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SC UC SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 12.8TB NVMe Main MU 2.5in SC U.3 SSD","PartNumber":"P20201-B21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SC UC SSD"}]},"BlueData":{"Server":[{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-K21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 480GB SATA MU 2.5inches SC DS SSD","PartNumber":"875470-B21","NewDesc":"HPE 480GB SATA MU SFF SC DS SSD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 1TB SATA 7.2K 2.5inches SC DS HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 1TB SATA 7.2K 2.5inches SC DS HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 480GB SATA MU 2.5inches SC DS SSD","PartNumber":"875470-B21","NewDesc":"HPE 480GB SATA MU SFF SC DS SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1TB SATA 7.2K 2.5inches SC DS HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5inches SC 512e DS HDD","PartNumber":"872481-B21","NewDesc":"HPE 1.8TB SAS 10K SFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2TB SATA 7.2K 2.5inches SC 512e DS HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10","OldDesc":"HPE 2TB SATA 7.2K 2.5inches SC 512e DS HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL385 Gen10 Plus","OldDesc":"HPE 2TB SATA 7.2K 2.5inches SC 512e DS HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5inches SC 512e DS HDD","PartNumber":"881457-B21","NewDesc":"HPE 2.4TB SAS 12G 10K SFFS SC 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-K21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-B21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 480GB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18432-K21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 800GB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13668-K21","NewDesc":"HPE 800GB NVMe x4 MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 800GB SAS MU LFF LPC DS SSD","PartNumber":"P04531-K21","NewDesc":"HPE 800GB SAS 12G MU LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 800GB SAS MU 2.5INCH SC SSD","PartNumber":"P19913-K21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18434-K21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13676-K21","NewDesc":"HPE 960GB NVMe x4 SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SATA MU 3.5in LPC DS SSD","PartNumber":"P19980-K21","NewDesc":"HPE 960GB SATA 6G MU LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 960GB SAS MU 3.5in LPC VS DS SSD","PartNumber":"P10452-K21","NewDesc":"HPE 960GB SAS 12G MU LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1TB 6G SATA 7.2K LFF MDL LP HDD","PartNumber":"861686-K21","NewDesc":"HPE 1TB SATA 6G 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.6TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13699-K21","NewDesc":"HPE 1.6TB NVMe x4 MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.6TB SAS MU 2.5INCH SC SSD","PartNumber":"P19915-K21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.6TB SAS MU LFF LPC DS SSD","PartNumber":"P04535-K21","NewDesc":"HPE 1.6TB SAS 12G MU LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA MU 3.5in LPC DS SSD","PartNumber":"P09726-K21","NewDesc":"HPE 1.92TB SATA 6G MU LFF DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18436-K21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13678-K21","NewDesc":"HPE 1.92TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA LFF MU 3.5in LFF LPC DS SSD","PartNumber":"P19984-K21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 1.92TB SATA RI 3.5in LFF LPC DS SSD","PartNumber":"P19976-K21","NewDesc":"HPE 1.92TB SATA 6G RI LFF SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 2TB SATA 7.2K LFF LP DS HDD","PartNumber":"861681-K21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 2TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13695-K21","NewDesc":"HPE 2TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 2TB 12G SAS 7.2K 3.5in MDL LP HDD","PartNumber":"833926-K21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.2TB SAS MU 2.5INCH SC SSD","PartNumber":"P19917-K21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.84TB SATA MU 2.5INCH SC MV SSD","PartNumber":"P18438-K21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 3.84TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13680-K21","NewDesc":"HPE 3.84TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 4TB 6G SATA 7.2K LFF MDL LP HDD","PartNumber":"861683-K21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 4TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13697-K21","NewDesc":"HPE 4TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 4TB SAS 7.2K LFF LP DS HDD","PartNumber":"833928-K21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6TB SATA 7.2K LFF LP 512e DS HDD","PartNumber":"861742-K21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6TB SAS 7.2K LFF LP 512e DS HDD","PartNumber":"861746-K21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6.4TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13703-K21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 6.4TB SAS MU 2.5INCH SC SSD","PartNumber":"P19919-K21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 7.68TB NVMe x4 RI 2.5in SCN DS SSD","PartNumber":"P13682-K21","NewDesc":"HPE 7.68TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 8TB SATA 7.2K LFF LP 512e DS HDD","PartNumber":"834028-K21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 8TB SAS 7.2K LFF LP 512e DS HDD","PartNumber":"834031-K21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SATA 6G Midline 7.2K 3.5in LP 1yr Wty He 512e DS 6-pack FIO HDD","PartNumber":"P09797-K21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF He 512e DS 6-pack FIO HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09161-K21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SAS 7.2K LFF LP He 512e DS HDD","PartNumber":"857646-K21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SAS 12G Midline 7.2K 3.5in LP 1yr Wty He 512e DS 6-pack FIO HDD","PartNumber":"P09799-K21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF He 512e DS 6-pack FIO HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 10TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09149-K21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 12TB SATA 7.2K LFF LP He 512e DS HDD","PartNumber":"881787-K21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 12TB SAS 7.2K LFF LP He 512e DS HDD","PartNumber":"881781-K21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 14TB SATA 6G Midline 7.2K 3.5in LP 1yr Wty Helium 512e DS Firmware HDD","PartNumber":"P09165-K21","NewDesc":"HPE 14TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 14TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"P09155-K21","NewDesc":"HPE 14TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 16TB SATA 7.2K 3.5in LP 512e ISE HDD","PartNumber":"P23449-K21","NewDesc":"HPE 16TB SATA 6G BC 7.2K LFF 512e ISE HDD"},{"Name":"HPE Apollo 4200 Gen10 Server","OldDesc":"HPE 16TB SAS 7.2K 3.5in LP 512e ISE HDD","PartNumber":"P23608-K21","NewDesc":"HPE 16TB SAS 12G BC 7.2K LFF 512e ISE HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 2TB SATA 7.2K 3.5in LP DS HDD","PartNumber":"861681-K21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 2TB SAS 7.2K 3.5in LP DS HDD","PartNumber":"833926-K21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 4TB SATA 7.2K 3.5in LP DS HDD","PartNumber":"861683-K21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 4TB SAS 7.2K 3.5in LP DS HDD","PartNumber":"833928-K21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 6TB SATA 7.2K 3.5in LP 512e DS HDD","PartNumber":"861742-K21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 6TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"861746-K21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF 512e HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 8TB SATA 7.2K 3.5in LP 512e DS HDD","PartNumber":"834028-K21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 8TB SAS 7.2K 3.5in LP 512e DS HDD","PartNumber":"834031-K21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 10TB SATA 7.2K LFF LP He 512e DS HDD","PartNumber":"857650-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 10TB SAS 7.2K LFF LP He 512e DS HDD","PartNumber":"857646-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 12TB SATA 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881787-K21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE Apollo 4500 Gen10 System","OldDesc":"HPE 12TB SAS 7.2K 3.5in LP He 512e DS HDD","PartNumber":"881781-K21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF 512e DS HDD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 256GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880262-B21","NewDesc":"HPE 256GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 512GB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880264-B21","NewDesc":"HPE 512GB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 1TB NVMe x4 RI M.2 2280 X Temp SSD","PartNumber":"880266-B21","NewDesc":"HPE 1TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE 2048GB NVMe x4 RI M.2 2280 Extmp SSD","PartNumber":"P00375-B21","NewDesc":"HPE Edgeline 2TB NVMe x4 Lanes RI M.2 2280 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant e910 1U CTO Blade Server","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 960GB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05892-B21","NewDesc":"HPE Edgeline 960GB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 1.92TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05896-B21","NewDesc":"HPE Edgeline 1.92TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"HPE ProLiant m510-16c Server Cartridge EL4000 10G 2xSFP+","OldDesc":"HPE EL 3.84TB NVMe x4 MU M.2 22110XT SSD","PartNumber":"P05900-B21","NewDesc":"HPE Edgeline 3.84TB NVMe x4 Lanes MU M.2 22110 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-B21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC 2.5in DS SSD","PartNumber":"P07922-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-B21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 600GB SAS 15K 2.5in SC DS HDD","PartNumber":"870757-B21","NewDesc":"HPE 600GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe x4 MU 2.5in SN DS SSD","PartNumber":"P13668-B21","NewDesc":"HPE 800GB NVMe x4 MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20094-B21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-B21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22329-B21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 800GB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P25953-B21","NewDesc":"HPE 800GB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 900GB 12G SAS 15K 2.5in SC DS HDD","PartNumber":"870759-B21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-B21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09716-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-B21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1TB 12G SAS 7.2K 2.5in MDL SC HDD","PartNumber":"832514-B21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe x4 Lanes MU 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10222-B21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13670-B21","NewDesc":"HPE 1.6TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20096-B21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20203-B21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22268-B21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-B21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09722-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB NVMe x4 Lanes RI 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10214-B21","NewDesc":"HPE 1.92TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-B21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-B21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe x4 Lanes MU 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10224-B21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13672-B21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20098-B21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20205-B21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22270-B21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB NVMe x4 Lanes RI 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10216-B21","NewDesc":"HPE 3.84TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC DS SSD","PartNumber":"P21517-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL325 Gen10 Plus","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-B21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe x4 Lanes MU 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10226-B21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe SFF x4 MU 2.5in SCN DS SSD","PartNumber":"P13674-B21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in U.3 SCN SSD","PartNumber":"P20100-B21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20207-B21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22272-B21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 7.68TB NVMe x4 Lanes RI 2.5in SCN 3yr Wty DS SSD","PartNumber":"P10218-B21","NewDesc":"HPE 7.68TB NVMe x4 Lanes RI SFF SCN DS SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 12.8TB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20209-B21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant DL360 Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in SCN U.3 SSD","PartNumber":"P22274-B21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 480GB SATA MU LFF SCC DS SSD","PartNumber":"P07924-B21","NewDesc":"HPE 480GB SATA 6G MU LFF SCC DS SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 800GB SAS MU LFF SCC DS SSD","PartNumber":"P04529-B21","NewDesc":"HPE 800GB SAS 12G MU LFF SCC PM5 SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 960GB SATA MU LFF SCC DS SSD","PartNumber":"P09718-B21","NewDesc":"HPE 960GB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1.92TB SATA MU LFF SCC DS SSD","PartNumber":"P09724-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC SM883 SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 1.92TB SATA MU 3.5in SCC SSD","PartNumber":"P19982-B21","NewDesc":"HPE 1.92TB SATA 6G MU LFF SCC 5300M SSD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2TB 6G SATA 7.2K LFF SC HDD","PartNumber":"872489-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 2TB SAS 12G 7.2K 3.5in SC DS HDD","PartNumber":"872485-B21","NewDesc":"HPE 2TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 4TB SATA 6G 7.2K 3.5in SC DS HDD","PartNumber":"872491-B21","NewDesc":"HPE 4TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 4TB SAS 12G 7.2K 3.5in SC DS HDD","PartNumber":"872487-B21","NewDesc":"HPE 4TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 6TB 6G SATA 7.2K LFF MDL SC HDD","PartNumber":"846510-B21","NewDesc":"HPE 6TB SATA 6G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 6TB 12G SAS 7.2K LFF MDL SC HDD","PartNumber":"846514-B21","NewDesc":"HPE 6TB SAS 12G ML 7.2K LFF SC DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 8TB 6G SATA 7.2K LFF 3.5in 512e SC MDL HDD","PartNumber":"819203-B21","NewDesc":"HPE 8TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 8TB SAS 7.2K LFF SC 512e DS HDD","PartNumber":"819201-B21","NewDesc":"HPE 8TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 10TB 6G SATA 7.2K 3.5in 512e SC HDD","PartNumber":"857648-B21","NewDesc":"HPE 10TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 10TB SAS 7.2K LFF SC He 512e DS HDD","PartNumber":"857644-B21","NewDesc":"HPE 10TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 12TB SATA 7.2K 3.5in SC He 512e DS HDD","PartNumber":"881785-B21","NewDesc":"HPE 12TB SATA 6G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 12TB SAS 7.2K LFF SC He 512e DS HDD","PartNumber":"881779-B21","NewDesc":"HPE 12TB SAS 12G ML 7.2K LFF SC 512e DS HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 16TB SATA 7.2K 3.5in ISE He LP HDD","PartNumber":"P23857-B21","NewDesc":"HPE 16TB SATA 6G BC 7.2K LFF SC 512e ISE HDD"},{"Name":"ProLiant DL380 Gen10","OldDesc":"HPE 16TB SAS 7.2K 3.5in ISE He LP HDD","PartNumber":"P23863-B21","NewDesc":"HPE 16TB SAS 12G BC 7.2K LFF SC 512e ISE HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20094-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22329-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 900GB SAS 15K 2.5in SC DS HDD","PartNumber":"870759-H21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU SFF SC DS SSD","PartNumber":"P09716-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-H21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1TB SAS 7.2K 2.5in SC DS HDD","PartNumber":"832514-H21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","PartNumber":"655710-H21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22268-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20096-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20203-H21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB SAS MU SFF SC DS SSD","PartNumber":"P04533-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-H21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SATA MU SFF SC DS SSD","PartNumber":"P09722-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-H21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-H21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-H21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-H21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20098-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20205-H21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB SAS MU SFF SC DS SSD","PartNumber":"P04537-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SATA MU SFF SC DS SSD","PartNumber":"P00896-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-H21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22272-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20207-H21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20100-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB SAS MU SFF SC DS SSD","PartNumber":"P04539-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22274-H21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL170r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20209-H21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22329-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20094-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 900GB SAS 15K 2.5in SC DS HDD","PartNumber":"870759-H21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SATA MU SFF SC DS SSD","PartNumber":"P09716-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-H21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","PartNumber":"655710-H21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1TB SAS 7.2K 2.5in SC DS HDD","PartNumber":"832514-H21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22268-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20203-H21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20096-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB SAS MU SFF SC DS SSD","PartNumber":"P04533-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-H21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SATA MU SFF SC DS SSD","PartNumber":"P09722-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-H21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-H21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-H21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-H21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20205-H21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20098-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.2TB SAS MU SFF SC DS SSD","PartNumber":"P04537-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SATA MU SFF SC DS SSD","PartNumber":"P00896-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-H21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22272-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20207-H21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20100-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB SAS MU SFF SC DS SSD","PartNumber":"P04539-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22274-H21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL190r Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20209-H21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 480GB SATA MU 2.5in SC MV SSD","PartNumber":"P18432-H21","NewDesc":"HPE 480GB SATA 6G MU SFF SC MVSSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 600GB SAS 15K 2.5in SC DS HDD","PartNumber":"870757-H21","NewDesc":"HPE 600GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 800GB NVMe Main MU SFF 2.5in SCN U.3 SSD","PartNumber":"P25953-H21","NewDesc":"HPE 800GB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 800GB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22329-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 800GB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20094-H21","NewDesc":"HPE 800GB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 800GB SAS MU 2.5in SC SSD","PartNumber":"P19913-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 800GB SAS MU SFF 2.5in SC SSD","PartNumber":"P21131-H21","NewDesc":"HPE 800GB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 900GB SAS 15K 2.5in SC DS HDD","PartNumber":"870759-H21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SATA MU SFF SC DS SSD","PartNumber":"P09716-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SATA MU SFF 2.5in SC SSD","PartNumber":"P19949-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SATA MU 2.5in SC MV SSD","PartNumber":"P18434-H21","NewDesc":"HPE 960GB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 960GB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10448-H21","NewDesc":"HPE 960GB SAS 12G MU SC Value SAS DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1TB SATA 7.2K 2.5in SC DS HDD","PartNumber":"655710-H21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1TB SAS 7.2K SFF SC DS HDD","PartNumber":"832514-H21","NewDesc":"HPE 1TB SAS 12G ML 7.2K SFF SC DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13699-H21","NewDesc":"HPE 1.6TB NVMe x4 MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22268-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20096-H21","NewDesc":"HPE 1.6TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20203-H21","NewDesc":"HPE 1.6TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB SAS MU SFF SC DS SSD","PartNumber":"P04533-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.6TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21133-H21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SATA MU SFF SC DS SSD","PartNumber":"P09722-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19951-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SATA MU 2.5in SC MV SSD","PartNumber":"P18436-H21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 1.92TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10454-H21","NewDesc":"HPE 1.92TB SAS 12G MU SFF SC Value SAS DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 2TB SATA 7.2K SFF SC 512e DS HDD","PartNumber":"765455-H21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 2TB SAS 7.2K 2.5in SC 512e DS HDD","PartNumber":"765466-H21","NewDesc":"HPE 2TB SAS 12G ML 7.2K SFF SC 512e HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-H21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13701-H21","NewDesc":"HPE 3.2TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22270-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20205-H21","NewDesc":"HPE 3.2TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20098-H21","NewDesc":"HPE 3.2TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB SAS MU SFF SC DS SSD","PartNumber":"P04537-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.2TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21135-H21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA MU SFF SC DS SSD","PartNumber":"P00896-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA MU SFF 2.5in SC SSD","PartNumber":"P19953-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC 5300M SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA SFF MU 2.5in SC DS SSD","PartNumber":"P21517-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SATA MU 2.5in SC MV SSD","PartNumber":"P18438-H21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC MV SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 3.84TB SAS MU 2.5in SC VS DS SSD","PartNumber":"P10460-H21","NewDesc":"HPE 3.84TB SAS 12G MU SFF SC Value SAS RM5 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU 2.5in SCN DS SSD","PartNumber":"P13703-H21","NewDesc":"HPE 6.4TB NVMe x4 Lanes MU SFF SCN DS SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22272-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20207-H21","NewDesc":"HPE 6.4TB NVMe MP MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB NVMe Perf MU SFF 2.5in SCN U.3 SSD","PartNumber":"P20100-H21","NewDesc":"HPE 6.4TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB SAS MU SFF SC DS SSD","PartNumber":"P04539-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM5 SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 6.4TB SAS MU SFF 2.5in SC SSD","PartNumber":"P21137-H21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN SSD","PartNumber":"P22274-H21","NewDesc":"HPE 12.8TB NVMe MU SFF SCN UC SSD"},{"Name":"ProLiant XL270d Gen10","OldDesc":"HPE 12.8TB NVMe x4 MU SFF 2.5in U.3 SCN DS SSD","PartNumber":"P20209-H21","NewDesc":"HPE 12.8TB NVMe MP MU SFF SCN UC SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 300GB SAS 10K 2.5in SC DS HDD","PartNumber":"872475-B21","NewDesc":"HPE 300GB SAS 12G 10K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 400GB SAS 12G WI 2.5in SC DS SSD","PartNumber":"873351-B21","NewDesc":"HPE 400GB SAS 12G WI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 480GB SATA MU 2.5in SC 2.5in DS SSD","PartNumber":"P07922-B21","NewDesc":"HPE 480GB SATA 6G MU SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 480GB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04474-B21","NewDesc":"HPE 480GB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 600GB SAS 10K 2.5in SC DS HDD","PartNumber":"872477-B21","NewDesc":"HPE 600GB SAS 12G 10K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 800GB SAS 12G WI 2.5in SC DS SSD","PartNumber":"873355-B21","NewDesc":"HPE 800GB SAS 12G WI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 900GB 12G SAS 15K 2.5in SC DS HDD","PartNumber":"870759-B21","NewDesc":"HPE 900GB SAS 12G 15K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 960GB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09716-B21","NewDesc":"HPE 960GB SATA 6G MU SFF SC SM883 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 960GB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04476-B21","NewDesc":"HPE 960GB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 960GB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04517-B21","NewDesc":"HPE 960GB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","PartNumber":"655710-B21","NewDesc":"HPE 1TB SATA 6G ML 7.2K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.2TB SAS 10K 2.5in SC DS HDD","PartNumber":"872479-B21","NewDesc":"HPE 1.2TB SAS 12G 10K SFF SC DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.6TB SAS MU 2.5in SC SSD","PartNumber":"P19915-B21","NewDesc":"HPE 1.6TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.8TB SAS 10K 2.5in SC 512e DS HDD","PartNumber":"872481-B21","NewDesc":"HPE 1.8TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.92TB SATA MU SFF 2.5in SFF SC DS SSD","PartNumber":"P09722-B21","NewDesc":"HPE 1.92TB SATA 6G MU SFF SC SM883 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.92TB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04478-B21","NewDesc":"HPE 1.92TB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 1.92TB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04519-B21","NewDesc":"HPE 1.92TB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","PartNumber":"765455-B21","NewDesc":"HPE 2TB SATA 6G ML 7.2K SFF SC 512e DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 2.4TB SAS 12G 10K 2.5in SC 512e DS HDD","PartNumber":"881457-B21","NewDesc":"HPE 2.4TB SAS 12G 10K SFF SC 512e DS HDD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 3.2TB SAS MU 2.5in SC SSD","PartNumber":"P19917-B21","NewDesc":"HPE 3.2TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 3.84TB SATA MU 2.5in SC DS SSD","PartNumber":"P00896-B21","NewDesc":"HPE 3.84TB SATA 6G MU SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 3.84TB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04521-B21","NewDesc":"HPE 3.84TB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 6.4TB SAS MU 2.5in SC SSD","PartNumber":"P19919-B21","NewDesc":"HPE 6.4TB SAS 12G MU SFF SC PM1645a SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 7.68TB SATA RI 2.5in SC 2.5in DS SSD","PartNumber":"P04482-B21","NewDesc":"HPE 7.68TB SATA 6G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 7.68TB SAS RI SFF 2.5in SFF SC DS SSD","PartNumber":"P04523-B21","NewDesc":"HPE 7.68TB SAS 12G RI SFF SC PM5 SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 7.68TB SAS RI 2.5in SC 2.5in DS SSD","PartNumber":"P06590-B21","NewDesc":"HPE 7.68TB SAS 12G RI SFF SC DS SSD"},{"Name":"Synergy 480 Gen10 Server","OldDesc":"HPE 15.3TB SAS RI 2.5in SC 2.5in DS SSD","PartNumber":"P06592-B21","NewDesc":"HPE 15.3TB SAS 12G RI SFF SC DS SSD"}]}}

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportOldEpaWorkloads; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return updateVMWareOption; });
var supportOldEpaWorkloads=function supportOldEpaWorkloads(defaultWl,oldWorkload){if(Array.isArray(oldWorkload.UserInputs.Environments.Environment)){if(oldWorkload.UserInputs.Environments.isOldWorkload){oldWorkload.UserInputs.Environments.isOldWorkload=false;}return oldWorkload;}var clonedoldWl=JSON.parse(JSON.stringify(oldWorkload));var clonedDefaultWl=JSON.parse(JSON.stringify(defaultWl));var gandcRoles=['Gateway Host','Controller Host'];var GeneralPurpose="General Purpose";var roleName="@RoleName";var solutionType="@SolutionType";var KUBERNETES_="Kubernetes";var COST_="Cost";var STORAGE_="Storage";var ATTRIBUTE_CONFIGTYPE="@ConfigType";var EPIC_="EPIC";//get GPU item
//update templates
var roles=void 0;var generalPurposeObj=clonedDefaultWl.UserInputs.Environments.Environment.find(function(item){return item[solutionType]===GeneralPurpose;});if(generalPurposeObj){clonedoldWl.UserInputs.Environments.Templates.Template.map(function(template){if(!template["@ConfigType"]){template["@ConfigType"]=KUBERNETES_;}});if(!clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements["@ConfigBasedOn"]){clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements["@ConfigBasedOn"]=COST_;}if(!clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements[ATTRIBUTE_CONFIGTYPE]){clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Requirements[ATTRIBUTE_CONFIGTYPE]=EPIC_;}var defaultStorageRole=generalPurposeObj.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===STORAGE_;});generalPurposeObj.Templates=clonedoldWl.UserInputs.Environments.Templates;roles=JSON.parse(JSON.stringify(clonedoldWl.UserInputs.Environments.Templates.ServerDetails.Server));generalPurposeObj.Templates.ServerDetails.Server=roles.filter(function(item){return gandcRoles.indexOf(item[roleName])===-1;});if(!generalPurposeObj.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===STORAGE_;})){generalPurposeObj.Templates.ServerDetails.Server.push(defaultStorageRole);}generalPurposeObj.GPUValue=clonedoldWl.UserInputs.Environments.GPUValue;generalPurposeObj.NonGPUValue=clonedoldWl.UserInputs.Environments.NonGPUValue;generalPurposeObj.StorageValue=clonedoldWl.UserInputs.Environments.StorageValue;}//update management hosts
if(roles){clonedDefaultWl.UserInputs.Environments.ManagementHosts.Server=roles.filter(function(item){return gandcRoles.indexOf(item[roleName])!==-1;});updateVMWareOption(clonedDefaultWl.UserInputs.Environments.ManagementHosts.Server);}clonedDefaultWl.UserInputs.Environments.isOldWorkload=true;return clonedDefaultWl;};var updateVMWareOption=function updateVMWareOption(managementRoles){var fALSE_="false";managementRoles.map(function(role){if(!role["@VMWare"]){role["@VMWare"]=fALSE_;}});};

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={loading:false};var workloadsReducer=function workloadsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_WORKLOADS_PENDING':return Object.assign({},state,{loading:true});case'FETCH_WORKLOADS_SUCCESS':return Object.assign({},state,{loading:false,savedWorkLoads:action.payload.recipes.map(function(recipe){return recipe.name;})});case'FETCH_WORKLOADS_ERROR':return Object.assign({},state,{loading:false});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (workloadsReducer);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var initialState={loading:false,solutions:[]};var solutionsReducer=function solutionsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'FETCH_SOLUTIONS_PENDING':return Object.assign({},state,{loading:true});case'FETCH_SOLUTIONS_SUCCESS':return Object.assign({},state,{loading:false,savedSolutions:action.payload.recipes.map(function(recipe){return recipe.name;})});case'FETCH_SOLUTIONS_ERROR':return Object.assign({},state,{loading:false});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (solutionsReducer);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grommet_utils_Cookies__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_grommet_utils_Cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_grommet_utils_Cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppConfig__ = __webpack_require__(13);
var initialState={isAuthenticated:undefined,userData:{},userSettings:{emailNotification:false,isLoading:false}};var authenticationReducer=function authenticationReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'CHECK_LOGIN':{return Object.assign({},state,{isAuthenticated:true,userData:action.payload});}case'FETCH_USER_BUSINESS_INFO_SUCCESS':{if(action.payload.UserId===undefined){return Object.assign({},state,{isAuthenticated:false,userData:undefined,userDataFetchState:'FETCHED_FAILED'});}return Object.assign({},state,{userDataFetchState:'FETCHED_SUCCESS',userData:{givenname:action.payload.FirstName,password:undefined,clang:action.payload.CountryLanguage,createtimestamp:action.payload.AccountCreationDate,email:action.payload.EmailId,hpclidnumber:action.payload.UserId,hpclname:action.payload.EmailId,hpresidentcountrycode:action.payload.CountryCode,modifytimestamp:action.payload.AccountModificationDate,preferredlanguage:action.payload.PreferredLanguage,sn:action.payload.LastName}});}case'LOGIN_PENDING':{return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while authenticating.'});}case'FETCH_USER_BUSINESS_INFO_PENDING':{return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while fetching user information.'});}case'LOGIN_SUCCESS':{return Object.assign({},state,{isAuthenticated:true,userData:{username:action.payload.FirstName,password:"",clang:action.payload.CountryLanguage,createtimestamp:action.payload.AccountCreationDate,email:action.payload.EmailId,hpclidnumber:action.payload.UserId,hpclname:action.payload.EmailId,hpresidentcountrycode:action.payload.CountryCode,modifytimestamp:action.payload.AccountCreationDate,preferredLanguage:action.payload.PreferredLanguage,lastName:action.payload.LastName,uniqueId:action.payload.UniqueId}});}case'LOGOUT_SUCCESS':{var redirectUrl='https://cf.passport.hpe.com/hppcf/login.do?hpappid='+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["c" /* landingUrl */]+'&applandingpage=https%3A%2F%2F'+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["e" /* redirection_Link */]+'%2F'+__WEBPACK_IMPORTED_MODULE_1__AppConfig__["b" /* basename */].replace('/','');window.location.href=redirectUrl;return Object.assign({},state,{isAuthenticated:false,userData:undefined});}case'LOGOUT_PENDING':{return Object.assign({},state,{isLoading:true,LoadingMsg:'Please wait while loging out.'});}case'LOGOUT':{if(__WEBPACK_IMPORTED_MODULE_0_grommet_utils_Cookies___default.a.has('HPPSESSION')){document.cookie="HPPSESSION=LOGGEDOFF; path=/; domain=.hpe.com; secure";}//document.cookie = "HPPFEDSESSION=LOGGEDOFF; path=/; domain=.hpe.com;";
if(__WEBPACK_IMPORTED_MODULE_0_grommet_utils_Cookies___default.a.has('u_d')){document.cookie="u_d=; path=/; domain=.hpe.com; secure";}return Object.assign({},state,{isAuthenticated:false,userData:undefined});}case'LOAD_SELECTION_SUCCESS':{if(action.payload.userData&&state.userData.hpclname==="default@test.com"){return Object.assign({},state,{userData:{givenname:action.payload.userData.FirstName,password:undefined,email:action.payload.userData.EmailId,hpclname:action.payload.userData.EmailId,hpresidentcountrycode:action.payload.userData.CountryCode,modifytimestamp:action.payload.AccountModificationDate,sn:action.payload.userData.LastName}});}else return state;}case'FETCH_SETTINGS_PENDING':{return Object.assign({},state,{userSettings:Object.assign({},state.userSettings,{isLoading:true})});}case'FETCH_SETTINGS_SUCCESS':{return Object.assign({},state,{userSettings:Object.assign({},state.userSettings,{emailNotification:action.payload.EmailNotification,isLoading:false})});}}return state;};/* harmony default export */ __webpack_exports__["a"] = (authenticationReducer);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonLogic__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonLogic_js__ = __webpack_require__(33);
var initialState={guiState:{updateManagementDetails:false,computeHostChanged:false,GandCAPICount:0,displayWarning:false,currentTabActiveIndex:1},getExtraNodes:false,calculateBlueDataAPIcount:0,workload:{},sizerWorkloadforCalculation:{value:{}},nonGPUOldWorkload:{},GPUOldWorkload:{},StorageOldWorkload:{},sessionDefaults:null,supportedList:null,isLoading:false,isLoadingServers:false,isCal:false,currentTab:'',changeGateway:false,calculateWithUpdatedTenantDrive:false,currentRoleName:'',activepartnumbers:null,filteredComponents:null,ServicesChanged:{val:false},isWaiting:false,ComputeCheckbox:{val:false},serversList:[],Templates:null,GPUQty:'2',ServicesInput:'',ErasureCodingChkd:false,StorageCapacitytype:{HDFS:'',MAPR:''},EPICRequirements:null,BlueDataCal:null,Gatewaydetails:null,Controllerdetails:null,Masterdetails:null,Storagedetails:null,GPUdetails:null,NonGPUdetails:null,MasterQTY:null,GatewayQty:null,calbtn:false,duplicateOSlist:[],Indexes:{functions:0,extraConfiguration:0},prevValues:{MasterQTY:'',GatewayQty:''},bluedataOsDisk:{validate:false},HostCount:{GPUHostCount:0,NonGPUHostCount:0,StorageHostCount:0},GPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:'',isCalculated:'false'// GPUcountperserver:''
},NonGPUValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:'',isCalculated:'false'},StorageValue:{TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:'',isCalculated:'false'},ControllerConfigChanged:false,count:0,isError:false,Errormsg:'',iterationCount:1,strmessage:'',title:{value:"HDFS"},scrollsetting:{val:true}};var HPEAPOLLO4200GEN10SERVER="HPE Apollo 4200 Gen10 Server";var PROLIANTXL170RGEN10="ProLiant XL170r Gen10";var HPMOONSHOTSYSTEM="HP Moonshot System";var ZERO_="0";var ATTRIBUTE_NAME="@Name";var ATTRIBUTE_NODEDISK="@NodeDisk";var ATTRIBUTE_TSTORAGEDRIVE="@TStorageDrive";var ATTRIBUTE_OSDISK="@OSDisk";var updateGateWayDetails=function updateGateWayDetails(state){state.workload.UserInputs.Environments.ManagementHosts.Server.map(function(host){var serverName=Object(__WEBPACK_IMPORTED_MODULE_2__commonLogic_js__["d" /* getGatewayandControllerHost */])(state.workload,host["@Type"]);if(serverName===HPEAPOLLO4200GEN10SERVER){host["@Name"]=PROLIANTXL170RGEN10;}else{host["@Name"]=serverName;}if(host["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&host["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_14" /* E910 */])===-1){host["@ServerName"]=host["@Name"];}else{host["@ServerName"]=HPMOONSHOTSYSTEM;}});state.guiState.updateManagementDetails=true;state.guiState.computeHostChanged=false;};var updateGatewayandController=function updateGatewayandController(state,action,hostType){if(action.payload){var commomObject=state.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===hostType;});if(action.payload["ProcFamily"]){commomObject["@ProcFamily"]=action.payload["ProcFamily"];}if(action.payload["Processor"]){commomObject["@Proc"]=action.payload["Processor"];}if(action.payload["Memory"]){commomObject["@Memory"]=action.payload["Memory"];}if(action.payload["NodeStorageDrive"]){commomObject["@NodeDisk"]=action.payload["NodeStorageDrive"];}if(hostType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */]){if(action.payload["PersistentDrive"]){commomObject["@TStorageDrive"]=action.payload["PersistentDrive"];}if(action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["f" /* ATTRIBUTE_PERSISTENTDRIVEQTY */]]!==undefined){commomObject["@TStorageDriveQty"]=action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["f" /* ATTRIBUTE_PERSISTENTDRIVEQTY */]];}var CAASSolution=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["v" /* CAAS_ */];});if(CAASSolution){if(CAASSolution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */]){commomObject["@Memory"]=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["w" /* CAAS_MEMORY */];}}}if(hostType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */]){if(action.payload["PersistentDrive"]){commomObject["@TStorageDrive"]=action.payload["PersistentDrive"];}if(action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["f" /* ATTRIBUTE_PERSISTENTDRIVEQTY */]]!==undefined){commomObject["@TStorageDriveQty"]=action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["f" /* ATTRIBUTE_PERSISTENTDRIVEQTY */]];}var _CAASSolution=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["v" /* CAAS_ */];});if(_CAASSolution){if(_CAASSolution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */]){commomObject["@Memory"]=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["w" /* CAAS_MEMORY */];}}}if(action.payload["NodeDriveQty"]){commomObject["@StorageDiskQty"]=action.payload["NodeDriveQty"];}if(hostType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_29" /* GATEWAY_ */]){if(commomObject["@Name"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_175" /* SYN_480_GEN10 */]){commomObject["@StorageDiskQty"]=ZERO_;}}if(action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["e" /* ATTRIBUTE_OSDRIVE */]]){commomObject["@OSDisk"]=action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["e" /* ATTRIBUTE_OSDRIVE */]];}else{var osDriveList=[];if(hostType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_29" /* GATEWAY_ */]){osDriveList=state.Gatewaydetails[commomObject[ATTRIBUTE_NAME]].OSDriveList;}else if(hostType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */]){osDriveList=state.Controllerdetails[commomObject[ATTRIBUTE_NAME]].OSDriveList;}else if(hostType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */]){osDriveList=state.Masterdetails[commomObject[ATTRIBUTE_NAME]].OSDriveList;}var updateOSDrive=function updateOSDrive(){var isValidCombination=false;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=osDriveList[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var item=_step.value;if(!isValidCombination){if(Object(__WEBPACK_IMPORTED_MODULE_2__commonLogic_js__["q" /* validateDriveChange */])(commomObject[ATTRIBUTE_NODEDISK],commomObject[ATTRIBUTE_TSTORAGEDRIVE],item,commomObject[ATTRIBUTE_NAME])){isValidCombination=true;commomObject[ATTRIBUTE_OSDISK]=item;}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}};if(osDriveList.indexOf(commomObject[ATTRIBUTE_OSDISK])===-1){updateOSDrive();}else{if(!Object(__WEBPACK_IMPORTED_MODULE_2__commonLogic_js__["q" /* validateDriveChange */])(commomObject[ATTRIBUTE_NODEDISK],commomObject[ATTRIBUTE_TSTORAGEDRIVE],commomObject[ATTRIBUTE_OSDISK],commomObject[ATTRIBUTE_NAME])){updateOSDrive();}}}}state.guiState.GandCAPICount-=1;var loadinglayer=true;if(state.guiState.GandCAPICount===0){loadinglayer=false;}return loadinglayer;};var updatePersistentDriveArray=function updatePersistentDriveArray(roleType,role,action,key){if(roleType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]&&action.payload[key]['lstHDFSDrives'].length>0){role.PersistentDisks=[];action.payload[key][__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_87" /* LST_HDFS_DRIVES */]].map(function(drive){var newDrive={Item:{"@size":drive[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_8" /* DDRIVE_SIZE */]],"@disk":drive[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_174" /* STR_DRIVE */]],"@qty":drive[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_83" /* I_QTY */]],"@volumeName":__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_123" /* PERSISTENT_ */]}};role.PersistentDisks.push(newDrive);});}};var updateGPUsCount=function updateGPUsCount(action,templateType,key,currentTabObject){if(action.payload[key]['dTotalGPUs']){if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_98" /* MLOPS */]){var actionTemplate=currentTabObject.Templates.Template.find(function(template){return template["@Type"]===templateType&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */];});if(actionTemplate){actionTemplate.Nodes["@GPUs"]=action.payload[key]['dTotalGPUs'];}}}};var sizerWorkload=function sizerWorkload(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var temp=void 0;var type='';var workloadtemp='';var GPUvaluetemp='';var NonGPUvaluetemp='';var StorageValuetemp='';var Errormsgtemp='';var isErrortemp='';var shouldChangegateway=false;var calculateBlueDataAPIcount=void 0;var servicetemp='';switch(action.type){case'ITERATION_INCREASE':return Object.assign({},state,{iterationCount:action.payload});case'FETCH_DEFAULT_DATA_SUCCESS123':return Object.assign({},state,{workload:JSON.parse(JSON.stringify(action.payload))});case'UPDATE_SIZER_WORKLOAD':return Object.assign({},state,{workload:JSON.parse(JSON.stringify(action.payload))});case'UPDATE_SESSION_DEFAULTS':return Object.assign({},state,{sessionDefaults:action.payload});case'EPA_FETCH_SUPPORTEDLIST_PENDING':return Object.assign({},state,{isLoading:true});case'EPA_FETCH_SUPPORTEDLIST_SUCCESS':temp=state.isWaiting;return Object.assign({},state,{supportedList:action.payload,isLoading:temp});case'EPA_FETCH_SUPPORTEDLIST_ERROR':temp=state.isWaiting;return Object.assign({},state,{isLoading:temp});case'EPA_FETCH_ACTIVEPARTNUMBERS_PENDING':return Object.assign({},state,{isLoading:true,isWaiting:true});case'EPA_FETCH_ACTIVEPARTNUMBERS_SUCCESS':return Object.assign({},state,{activepartnumbers:action.payload,isLoading:false,isWaiting:false});case'EPA_FETCH_ACTIVEPARTNUMBERS_ERROR':return Object.assign({},state,{isLoading:false,isWaiting:false});case'FILTERED_COMPONENTS':return Object.assign({},state,{filteredComponents:action.payload.data});case'FETCH_DEFAULT_WRKLD_SUCCESS':return Object.assign({},state,{// serversList:JSON.parse(JSON.stringify(action.payload)),
//workload:JSON.parse(JSON.stringify(action.payload.workload)),
ServicesInput:JSON.parse(JSON.stringify(action.payload.input)),// sessionDefaults:JSON.parse(JSON.stringify(action.payload.input)),
isLoading:false});case'FETCH_DEFAULT_WRKLD_PENDING':return Object.assign({},state,{isLoading:true//isWaiting:false
});case'SERVER_LIST_SUCCESS':var serversList="";if(action.payload.filter(function(x){return x['functionName']==="Gateway Node";})[0]===undefined||state.serversList.filter(function(x){return x['functionName']==='Gateway Node';})[0]===undefined){serversList=state.serversList.concat(action.payload);}else{serversList=state.serversList;}return Object.assign({},state,{serversList:serversList,isLoadingServers:false});case'SERVER_LIST_PENDING':return Object.assign({},state,{isLoadingServers:true});case'FETCH_NODEQTY_SUCCESS':state.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===action.payload.function){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===action.payload.service){if(action.payload.service===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_7" /* DATA_LAKE */]&&state.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected']===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_210" /* tRUE_ */]){if(parseInt(action.payload.qty,10)<parseInt(__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_1" /* DATALAKE_MIN_NODES */],10)){action.payload.qty=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_1" /* DATALAKE_MIN_NODES */];state.workload.UserInputs.Environments.isDataLakeNodeCountUpdated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_204" /* fALSE_ */];state.workload.UserInputs.Environments.DataLakeNodeCount=action.payload.qty;state.workload.UserInputs.Environments.updateDataLakeRecommendations=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_204" /* fALSE_ */];}}service.Hardware['@NodesCount']=action.payload.qty;Object(__WEBPACK_IMPORTED_MODULE_0__commonLogic__["l" /* updateGrowthItem */])(action.payload.service,action.payload.qty,state.workload);if(action.payload.service==="Weka"){service.Hardware['@DataDisk']=action.payload.strDisk;service.Hardware['@DiskQty']=action.payload.iDiskQty;service.Inputs['@RawCapacity']=action.payload.dRawCapacity;}if(action.payload.function==="AI"){service.Inputs['@GPUQty']=action.payload.gpuQty;}if(action.payload.function==="Analytics"||action.payload.function==="Database"){if(service["@mixedStorage"]!=="True"){if(action.payload.datadisk!==''){service.Hardware['@DataDisk']=action.payload.datadisk;}if(action.payload.datadiskqty!==''&&action.payload.datadisk!==''){service.Hardware['@DiskQty']=action.payload.datadiskqty;}}}}});}}});/* Changes by Vinay, Same code is being executed irrespective of condition. for CID:10011*//*if( state.workload.UserInputs.Environments.strmessage ===undefined)
      {*/if(action.payload.service==="Hive"){state.workload.UserInputs.Environments.strmessage=action.payload.strmessage;}/*}else{ 
        if (action.payload.service === "Hive") {
          state.workload.UserInputs.Environments.strmessage=action.payload.strmessage
        }
      }*/servicetemp=state.workload;return Object.assign({},state,{isLoading:false,getExtraNodes:true,workload:servicetemp,GPUQty:action.payload.gpuQty// strmessage:action.payload.strmessage
});case'FETCH_NODEQTY_PENDING':return Object.assign({},state,{isLoading:true//serversList: state.serversList.concat(action.payload)          
});case'FETCH_NODEQTY_ERROR':return Object.assign({},state,{isLoading:false});case'SERVER_ERROR':return Object.assign({},state,{isLoading:false});case'ARCVALUE_SUCCESS':var ARCtemp='';state.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Storage"){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']==="Scality"){service.Inputs['@ARC']=action.payload;}});}}});ARCtemp=state.workload;return Object.assign({},state,{workload:ARCtemp//isLoading:false
});case'ARCVALUE_PENDING':return Object.assign({},state,{// isLoading:true                     
});case'OSLISTBLUEDATA_SUCCESS':if(action.payload.rolename==="NONGPU"){var oslisttemp1=state.workload;var NonGPUtemp=state.NonGPUdetails;NonGPUtemp[action.payload.Server].OSDriveList=action.payload.osList;if(action.payload.osList.indexOf(oslisttemp1.UserInputs.Environments.Environment.find(function(Solution){return Solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */];})["@OSDisk"])===-1){oslisttemp1.UserInputs.Environments.Environment.find(function(Solution){return Solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */];})["@OSDisk"]=action.payload.osList[0];}var temp_bluedataOsDisk=state.bluedataOsDisk;temp_bluedataOsDisk.validate=true;return Object.assign({},state,{NonGPUdetails:NonGPUtemp,workload:oslisttemp1,isLoading:false,bluedataOsDisk:temp_bluedataOsDisk});}else if(action.payload.rolename==="GPU"){var _oslisttemp=state.workload;var _GPUtemp=state.GPUdetails;_GPUtemp[action.payload.Server].OSDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp.UserInputs.Environments.Environment.find(function(Solution){return Solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */];})["@OSDisk"])===-1){_oslisttemp.UserInputs.Environments.Environment.find(function(Solution){return Solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */];})["@OSDisk"]=action.payload.osList[0];}//oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[1]["@OSDisk"] = action.payload.osList[0];
var _temp_bluedataOsDisk=state.bluedataOsDisk;_temp_bluedataOsDisk.validate=true;return Object.assign({},state,{GPUdetails:_GPUtemp,workload:_oslisttemp,isLoading:false,bluedataOsDisk:_temp_bluedataOsDisk});}else if(action.payload.rolename===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){var _oslisttemp2=state.workload;var Storagetemp=state.Storagedetails;Storagetemp[action.payload.Server].OSDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp2.UserInputs.Environments.Environment.find(function(Solution){return Solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */];})["@OSDisk"])===-1){_oslisttemp2.UserInputs.Environments.Environment.find(function(Solution){return Solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */];})["@OSDisk"]=action.payload.osList[0];}return Object.assign({},state,{Storagedetails:Storagetemp,workload:_oslisttemp2,isLoading:false});}else if(action.payload.rolename==="Gateway"){var _oslisttemp3=state.workload;var gateWaytemp=state.Gatewaydetails;gateWaytemp[action.payload.Server].OSDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp3.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@OSDisk"])===-1){_oslisttemp3.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@OSDisk"]=action.payload.osList[0];}//oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[2]["@OSDisk"] = action.payload.osList[0];
var _temp_bluedataOsDisk2=state.bluedataOsDisk;_temp_bluedataOsDisk2.validate=true;return Object.assign({},state,{Gatewaydetails:gateWaytemp,workload:_oslisttemp3,isLoading:false,bluedataOsDisk:_temp_bluedataOsDisk2});}else if(action.payload.rolename==="Controller"){var _oslisttemp4=state.workload;var _gateWaytemp=state.Controllerdetails;_gateWaytemp[action.payload.Server].OSDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp4.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@OSDisk"])===-1){_oslisttemp4.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@OSDisk"]=action.payload.osList[0];}// oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[3]["@OSDisk"] = action.payload.osList[0];
var _temp_bluedataOsDisk3=state.bluedataOsDisk;_temp_bluedataOsDisk3.validate=true;return Object.assign({},state,{Controllerdetails:_gateWaytemp,workload:_oslisttemp4,isLoading:false,bluedataOsDisk:_temp_bluedataOsDisk3});}else if(action.payload.rolename==="Master"){var _oslisttemp5=state.workload;var _gateWaytemp2=state.Masterdetails;_gateWaytemp2[action.payload.Server].OSDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp5.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@OSDisk"])===-1){_oslisttemp5.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@OSDisk"]=action.payload.osList[0];}// oslisttemp1.UserInputs.Environments.Templates.ServerDetails.Server[3]["@OSDisk"] = action.payload.osList[0];
var _temp_bluedataOsDisk4=state.bluedataOsDisk;_temp_bluedataOsDisk4.validate=true;return Object.assign({},state,{Masterdetails:_gateWaytemp2,workload:_oslisttemp5,isLoading:false,bluedataOsDisk:_temp_bluedataOsDisk4});}case'OSLISTBLUEDATA_PENDING'://  let ostemp;
// ostemp=state.count+1;
return Object.assign({},state,{isLoading:true// count:ostemp
});case'TENANTDRIVELIST_PENDING':return Object.assign({},state,{isLoading:true});case'TENANTDRIVELIST_SUCCESS':var toBeRecalculted=false;var roleType="";if(action.payload.rolename==="NONGPU"){var _oslisttemp6=state.workload;var _NonGPUtemp=state.NonGPUdetails;_NonGPUtemp[action.payload.Server].TenantDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp6.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */];})["@TStorageDrive"])===-1){_oslisttemp6.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */];})["@TStorageDrive"]=action.payload.osList[0];toBeRecalculted=true;roleType=action.payload.rolename;}return Object.assign({},state,{NonGPUdetails:_NonGPUtemp,workload:_oslisttemp6,isLoading:false,calculateWithUpdatedTenantDrive:toBeRecalculted,currentRoleName:roleType});}else if(action.payload.rolename==="GPU"){var _oslisttemp7=state.workload;var _GPUtemp2=state.GPUdetails;_GPUtemp2[action.payload.Server].TenantDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp7.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */];})["@TStorageDrive"])===-1){_oslisttemp7.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetailsServer.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */];})["@TStorageDrive"]=action.payload.osList[0];toBeRecalculted=true;roleType=action.payload.rolename;}return Object.assign({},state,{GPUdetails:_GPUtemp2,workload:_oslisttemp7,isLoading:false,calculateWithUpdatedTenantDrive:toBeRecalculted,currentRoleName:roleType});}else if(action.payload.rolename==="Controller"){var _oslisttemp8=state.workload;var _gateWaytemp3=state.Controllerdetails;_gateWaytemp3[action.payload.Server].TenantDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp8.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@TStorageDrive"])===-1){_oslisttemp8.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@TStorageDrive"]=action.payload.osList[0];}return Object.assign({},state,{Controllerdetails:_gateWaytemp3,workload:_oslisttemp8,isLoading:false});}else if(action.payload.rolename==="Master"){var _oslisttemp9=state.workload;var _gateWaytemp4=state.Masterdetails;_gateWaytemp4[action.payload.Server].TenantDriveList=action.payload.osList;if(action.payload.osList.indexOf(_oslisttemp9.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@TStorageDrive"])===-1){_oslisttemp9.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@TStorageDrive"]=action.payload.osList[0];}return Object.assign({},state,{Masterdetails:_gateWaytemp4,workload:_oslisttemp9,isLoading:false});}case'OSLIST_SUCCESS':var Oslisttemp='';var duplicateOSlisttemp=[];state.serversList.filter(function(val){if(val['functionName']===action.payload.Function){if(val['serviceName']===action.payload.Service){for(var key in val.totalList){if(key===action.payload.Server){val.totalList[key].OSDiskList=action.payload.osList;}}}}});duplicateOSlisttemp=action.payload.osList;Oslisttemp=state.workload;return Object.assign({},state,{duplicateOSlist:duplicateOSlisttemp,workload:Oslisttemp,isLoading:false});case'OSLIST_PENDING':return Object.assign({},state,{isLoading:true});case'EPAVNEXT_FETCH_TEMPLATELIST_SUCCESS':var resulttlisttemp=true;var rst=state.count-1;if(state.count-1===0){resulttlisttemp=false;}return Object.assign({},state,{Templates:action.payload,isLoading:resulttlisttemp,count:rst});case'EPAVNEXT_FETCH_TEMPLATELIST_PENDING':var tlisttemp=void 0;tlisttemp=state.count+1;return Object.assign({},state,{isLoading:true,count:tlisttemp});case'EPICREQUIREMENTS_SUCCESS':var epictemprst=true;var epictempcount=state.count-1;if(state.count-1===0){epictemprst=false;}calculateBlueDataAPIcount=state.calculateBlueDataAPIcount-1;return Object.assign({},state,{EPICRequirements:action.payload,isLoading:epictemprst,count:epictempcount,calculateBlueDataAPIcount:calculateBlueDataAPIcount});case'EPICREQUIREMENTS_PENDING':var epictemp=void 0;epictemp=state.count+1;return Object.assign({},state,{isLoading:true,count:epictemp});case'CALCULATEBLUEDATACONFIG_SUCCESS':var currentTabObject=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];});currentTabObject.NonGPUValue.isCalculated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_204" /* fALSE_ */];currentTabObject.GPUValue.isCalculated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_204" /* fALSE_ */];currentTabObject.StorageValue.isCalculated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_204" /* fALSE_ */];if(currentTabObject.Templates.Template.filter(function(x){return x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_78" /* INFERENCE_ */])>-1&&x.Nodes["@ImagesPerSec"]>0;}).length>0&&currentTabObject.Templates.Template.filter(function(x){return x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_78" /* INFERENCE_ */])===-1&&x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */])>-1;}).length===0){for(var key in action.payload){if(key===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_41" /* GPU_RESULT */]){if(!action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_115" /* NONGPU_RESULT */]]){action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_115" /* NONGPU_RESULT */]]=action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_41" /* GPU_RESULT */]];delete action.payload[__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_41" /* GPU_RESULT */]];}}}}currentTabObject.Templates.ServerDetails.Server.filter(function(val){for(var _key in action.payload){if(_key==="NonGPU_Result"){type=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */];currentTabObject.NonGPUValue.TotalVMemory=action.payload[_key]['d_TotalVMemory'];currentTabObject.NonGPUValue.TotalCore=action.payload[_key]['d_TotalVCPU'];currentTabObject.NonGPUValue.TotalStorage=action.payload[_key]['d_TotalStorage'];updateGPUsCount(action,__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_78" /* INFERENCE_ */],_key,currentTabObject);if(action.payload[_key]['ErrorMsg']===null||action.payload[_key]['ErrorMsg']===""||action.payload[_key]['ErrorMsg']===undefined){currentTabObject.NonGPUValue.isCalculated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_210" /* tRUE_ */];}}else if(_key==="GPU_Result"){type=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */];currentTabObject.GPUValue.TotalVMemory=action.payload[_key]['d_TotalVMemory'];currentTabObject.GPUValue.TotalCore=action.payload[_key]['d_TotalVCPU'];currentTabObject.GPUValue.TotalStorage=action.payload[_key]['d_TotalStorage'];updateGPUsCount(action,__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_187" /* TRAINING */],_key,currentTabObject);if(action.payload[_key]['ErrorMsg']===null||action.payload[_key]['ErrorMsg']===""||action.payload[_key]['ErrorMsg']===undefined){currentTabObject.GPUValue.isCalculated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_210" /* tRUE_ */];}//  state. GPUValue.GPUcountperserver=action.payload[key]['RecommendedGPUQty']
}else if(_key===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){type=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */];currentTabObject.StorageValue.TotalVMemory=action.payload[_key]['d_TotalVMemory'];currentTabObject.StorageValue.TotalCore=action.payload[_key]['d_TotalVCPU'];currentTabObject.StorageValue.TotalStorage=action.payload[_key]['d_TotalStorage'];if(action.payload[_key]['ErrorMsg']===null||action.payload[_key]['ErrorMsg']===""||action.payload[_key]['ErrorMsg']===undefined){currentTabObject.StorageValue.isCalculated=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_210" /* tRUE_ */];}}if(val['@Type']===type){if(action.payload[_key]['ErrorMsg']===null||action.payload[_key]['ErrorMsg']===""||action.payload[_key]['ErrorMsg']===undefined){shouldChangegateway=true;isErrortemp=false;val['@NodesCount']=action.payload[_key]['d_ServerQty'];val['@ProcQty']=action.payload[_key]['RecommendedProcQty'];val['@StorageDiskQty']=action.payload[_key]['RecommendedDriveQty'];if(action.payload[_key]['RecommendedMemory']!==null){val['@Memory']=action.payload[_key]['RecommendedMemory'];}if(action.payload[_key]['RecommendedServer']!==null){if(type===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */]){currentTabObject.NonGPUValue.Drive=action.payload[_key]['RecommendedDriveDesc'];currentTabObject.NonGPUValue.DriveQty=action.payload[_key]['RecommendedDriveQty'];currentTabObject.NonGPUValue.Memory=action.payload[_key]['RecommendedMemory'];currentTabObject.NonGPUValue.Proc=action.payload[_key]['RecommendedProc'];currentTabObject.NonGPUValue.Server=action.payload[_key]['RecommendedServer'];currentTabObject.NonGPUValue.ServerQty=action.payload[_key]['d_ServerQty'];state.HostCount.NonGPUHostCount=action.payload[_key]['d_ServerQty'];}if(type===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */]){currentTabObject.GPUValue.Drive=action.payload[_key]['RecommendedDriveDesc'];currentTabObject.GPUValue.DriveQty=action.payload[_key]['RecommendedDriveQty'];currentTabObject.GPUValue.Memory=action.payload[_key]['RecommendedMemory'];currentTabObject.GPUValue.Proc=action.payload[_key]['RecommendedProc'];currentTabObject.GPUValue.Server=action.payload[_key]['RecommendedServer'];currentTabObject.GPUValue.ServerQty=action.payload[_key]['d_ServerQty'];state.HostCount.GPUHostCount=action.payload[_key]['d_ServerQty'];val['@GPUcount']=action.payload[_key]['RecommendedGPUQty'].toString();}if(type===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){currentTabObject.StorageValue.Drive=action.payload[_key]['RecommendedDriveDesc'];currentTabObject.StorageValue.DriveQty=action.payload[_key]['RecommendedDriveQty'];currentTabObject.StorageValue.Memory=action.payload[_key]['RecommendedMemory'];currentTabObject.StorageValue.Proc=action.payload[_key]['RecommendedProc'];currentTabObject.StorageValue.Server=action.payload[_key]['RecommendedServer'];currentTabObject.StorageValue.ServerQty=action.payload[_key]['d_ServerQty'];state.HostCount.StorageHostCount=action.payload[_key]['d_ServerQty'];if(action.payload[_key]['RecommendedHDFSDriveType']!==null){val["@TenantDriveType"]=action.payload[_key]['RecommendedHDFSDriveType'];}}val['@NodeDisk']=action.payload[_key]['RecommendedDriveDesc'];val['@StorageDiskQty']=action.payload[_key]['RecommendedDriveQty'];val['@Proc']=action.payload[_key]['RecommendedProc'];val['@ProcFamily']=action.payload[_key]['RecommendedProcFamily'];val['@ApproxCost']=action.payload[_key]['dApproxCost'];val['@Name']=action.payload[_key]['RecommendedServer'];val['@ServerName']=val['@Name'];if(action.payload[_key]['RecommendedHDFSDrive']!==null){val['@TStorageDrive']=action.payload[_key]['RecommendedHDFSDrive'];val['@TStorageDriveQty']=action.payload[_key]['RecommendedHDFSDriveQty'];}else{//  val['@TStorageDrive'] ="None"
//   val['@TStorageDriveQty'] ="0"
}val['@TStorageDriveQty']=action.payload[_key]['RecommendedHDFSDriveQty'];}else{if(action.payload[_key]['RecommendedHDFSDrive']!==null){val['@TStorageDrive']=action.payload[_key]['RecommendedHDFSDrive'];val['@TStorageDriveQty']=action.payload[_key]['RecommendedHDFSDriveQty'];}else{//val['@TStorageDrive'] ="None"
//  val['@TStorageDriveQty'] ="0"
}val['@TStorageDriveQty']=action.payload[_key]['RecommendedHDFSDriveQty'];val['@StorageDiskQty']=action.payload[_key]['RecommendedDriveQty'];}updatePersistentDriveArray(type,val,action,_key);}else{Errormsgtemp=action.payload[_key]['ErrorMsg'];isErrortemp=true;}}}});workloadtemp=state.workload;var caltemprst=true;//  let caltempcount=state.count-1
// if(state.count-1===0)
// {
caltemprst=false;updateGateWayDetails(state);// }
return Object.assign({},state,{workload:workloadtemp,// GPUValue: GPUvaluetemp,
// NonGPUValue: NonGPUvaluetemp,
// StorageValue: StorageValuetemp,
BlueDataCal:action.payload,isLoading:false,isCal:caltemprst,// count:caltempcount,
Errormsg:Errormsgtemp,isError:isErrortemp,changeGateway:shouldChangegateway});case'CALCULATEBLUEDATACONFIG_PENDING':// let caltemp;
//caltemp=state.count+1;
return Object.assign({},state,{isLoading:true,isCal:true// count:caltemp
});case'CALCULATEBLUEDATACONFIGFALSE_PENDING'://let caltemp1;
//caltemp1=state.count+1;
return Object.assign({},state,{isLoading:true,isCal:true// count:caltemp1
});case'CALCULATEBLUEDATACONFIGFALSE_SUCCESS':var hostcount='';state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.filter(function(val){for(var _key2 in action.payload){if(_key2==="NonGPU_Result"){type="NonGPU";state.NonGPUValue.TotalVMemory=action.payload[_key2]['d_TotalVMemory'];state.NonGPUValue.TotalCore=action.payload[_key2]['d_TotalVCPU'];state.NonGPUValue.TotalStorage=action.payload[_key2]['d_TotalStorage'];state.HostCount.NonGPUHostCount=action.payload[_key2]['d_ServerQty'];if(action.payload[_key2]['ErrorMsg']===null||action.payload[_key2]['ErrorMsg']===""||action.payload[_key2]['ErrorMsg']===undefined){state.NonGPUValue.ServerQty=action.payload[_key2]['d_ServerQty'];}state.NonGPUValue.isCalculated='true';}else if(_key2==="GPU_Result"){type="GPU";state.GPUValue.TotalVMemory=action.payload[_key2]['d_TotalVMemory'];state.GPUValue.TotalCore=action.payload[_key2]['d_TotalVCPU'];state.GPUValue.TotalStorage=action.payload[_key2]['d_TotalStorage'];state.HostCount.GPUHostCount=action.payload[_key2]['d_ServerQty'];var _currentTabObject=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];});updateGPUsCount(action,__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_187" /* TRAINING */],_key2,_currentTabObject);if(action.payload[_key2]['ErrorMsg']===null||action.payload[_key2]['ErrorMsg']===""||action.payload[_key2]['ErrorMsg']===undefined){state.GPUValue.ServerQty=action.payload[_key2]['d_ServerQty'];}state.GPUValue.isCalculated='true';//  state. GPUValue.GPUcountperserver=action.payload[key]['RecommendedGPUQty']
}else if(_key2===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){type=__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */];state.HostCount.StorageHostCount=action.payload[_key2]['d_ServerQty'];if(action.payload[_key2]['ErrorMsg']===null||action.payload[_key2]['ErrorMsg']===""||action.payload[_key2]['ErrorMsg']===undefined){state.StorageValue.ServerQty=action.payload[_key2]['d_ServerQty'];}state.StorageValue.isCalculated='true';}if(val['@Type']===type){if(action.payload[_key2]['ErrorMsg']===null||action.payload[_key2]['ErrorMsg']===""||action.payload[_key2]['ErrorMsg']===undefined){isErrortemp=false;shouldChangegateway=true;val['@NodesCount']=action.payload[_key2]['d_ServerQty'];val['@ApproxCost']=action.payload[_key2]['dApproxCost'];val['@ProcQty']=action.payload[_key2]['RecommendedProcQty'];val['@StorageDiskQty']=action.payload[_key2]['RecommendedDriveQty'];if(action.payload[_key2]['RecommendedMemory']!==null){val['@Memory']=action.payload[_key2]['RecommendedMemory'];}if(action.payload[_key2]['RecommendedServer']!==null){if(type==="NonGPU"){state.NonGPUValue.Drive=action.payload[_key2]['RecommendedDriveDesc'];state.NonGPUValue.DriveQty=action.payload[_key2]['RecommendedDriveQty'];state.NonGPUValue.Memory=action.payload[_key2]['RecommendedMemory'];state.NonGPUValue.Proc=action.payload[_key2]['RecommendedProc'];state.NonGPUValue.Server=action.payload[_key2]['RecommendedServer'];state.NonGPUValue.ServerQty=action.payload[_key2]['d_ServerQty'];}if(type==="GPU"){state.GPUValue.Drive=action.payload[_key2]['RecommendedDriveDesc'];state.GPUValue.DriveQty=action.payload[_key2]['RecommendedDriveQty'];state.GPUValue.Memory=action.payload[_key2]['RecommendedMemory'];state.GPUValue.Proc=action.payload[_key2]['RecommendedProc'];state.GPUValue.Server=action.payload[_key2]['RecommendedServer'];state.GPUValue.ServerQty=action.payload[_key2]['d_ServerQty'];val['@GPUcount']=action.payload[_key2]['RecommendedGPUQty'].toString();}if(type===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){state.StorageValue.Drive=action.payload[_key2]['RecommendedDriveDesc'];//state.StorageValue.DriveQty = action.payload[key]['RecommendedDriveQty'];
state.StorageValue.Memory=action.payload[_key2]['RecommendedMemory'];state.StorageValue.Proc=action.payload[_key2]['RecommendedProc'];state.StorageValue.Server=action.payload[_key2]['RecommendedServer'];state.StorageValue.ServerQty=action.payload[_key2]['d_ServerQty'];}val['@NodeDisk']=action.payload[_key2]['RecommendedDriveDesc'];val['@StorageDiskQty']=action.payload[_key2]['RecommendedDriveQty'];val['@Proc']=action.payload[_key2]['RecommendedProc'];val['@ProcFamily']=action.payload[_key2]['RecommendedProcFamily'];val['@Name']=action.payload[_key2]['RecommendedServer'];val['@ServerName']=val['@Name'];if(action.payload[_key2]['RecommendedHDFSDrive']!==null&&type!==__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){val['@TStorageDrive']=action.payload[_key2]['RecommendedHDFSDrive'];val['@TStorageDriveQty']=action.payload[_key2]['RecommendedHDFSDriveQty'];}}else{if(action.payload[_key2]['RecommendedHDFSDrive']!==null&&type!==__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){val['@TStorageDrive']=action.payload[_key2]['RecommendedHDFSDrive'];val['@TStorageDriveQty']=action.payload[_key2]['RecommendedHDFSDriveQty'];}else{//val['@TStorageDrive'] ="None"
//  val['@TStorageDriveQty'] ="0"
}if(type!==__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_161" /* STORAGE_ */]){val['@TStorageDriveQty']=action.payload[_key2]['RecommendedHDFSDriveQty'];}val['@StorageDiskQty']=action.payload[_key2]['RecommendedDriveQty'];}updatePersistentDriveArray(type,val,action,_key2);}else{Errormsgtemp=action.payload[_key2]['ErrorMsg'];isErrortemp=true;}}}});workloadtemp=state.workload;GPUvaluetemp=state.GPUValue;NonGPUvaluetemp=state.NonGPUValue;StorageValuetemp=state.StorageValue;hostcount=state.HostCount;var caltemprst1=true;//  let caltempcount1=state.count-1
// if(state.count-1===0)
//   {
caltemprst1=false;if(state.guiState.computeHostChanged){updateGateWayDetails(state);}//  }
return Object.assign({},state,{workload:workloadtemp,GPUValue:GPUvaluetemp,NonGPUValue:NonGPUvaluetemp,StorageValue:StorageValuetemp,BlueDataCal:action.payload,HostCount:hostcount,isLoading:false,isCal:caltemprst1,//  count:caltempcount1,
Errormsg:Errormsgtemp,isError:isErrortemp,changeGateway:shouldChangegateway});case'FETCH_GATEWAYDLTS_SUCCESS':var Controllertemp='';var Mastertemp='';var GPUtemp='';//let NonGPUtemp = '';
calculateBlueDataAPIcount=state.calculateBlueDataAPIcount-1;var GPUandNonGPUCommonMethod=function GPUandNonGPUCommonMethod(roleId){var GPUandNonGPUtemp=action.payload.totalList;//let NonGPUList = NonGPUtemp
var temp=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server[roleId];var Serverlist=[];var processortemp=[];var processorList=[];var processorFamilyList=[];for(var _key3 in GPUandNonGPUtemp){Serverlist.push(_key3);}if(Serverlist.indexOf(temp['@Name'])===-1){temp['@Name']=Serverlist[0];}for(var procfamily in GPUandNonGPUtemp[Serverlist.filter(function(x){return x===temp['@Name'];})[0]].ProcessorList){processorFamilyList.push(procfamily);}if(processorFamilyList.indexOf(temp["@ProcFamily"])===-1){temp["@ProcFamily"]=processorFamilyList[0];}processortemp=GPUandNonGPUtemp[Serverlist.filter(function(x){return x===temp['@Name'];})[0]].ProcessorList[processorFamilyList.filter(function(x){return x===temp['@ProcFamily'];})[0]];for(var _key4 in processortemp){processorList.push(_key4);}if(processorList.indexOf(temp["@Proc"])===-1){temp["@Proc"]=processorList[0];}if(processortemp[Object.keys(processortemp).filter(function(x){return x===temp["@Proc"];})[0]].indexOf(temp["@Memory"])===-1){temp["@Memory"]=processortemp[Object.keys(processortemp).filter(function(x){return x===temp["@Proc"];})[0]][0];}if(GPUandNonGPUtemp[Serverlist.filter(function(x){return x===temp['@Name'];})[0]].OSDriveList.indexOf(temp["@OSDisk"])===-1){temp["@OSDisk"]=GPUandNonGPUtemp[Serverlist.filter(function(x){return x===temp['@Name'];})[0]].OSDriveList[0];}if(GPUandNonGPUtemp[Serverlist.filter(function(x){return x===temp['@Name'];})[0]].DataDriveList.indexOf(temp["@NodeDisk"])===-1){temp["@NodeDisk"]=GPUandNonGPUtemp[Serverlist.filter(function(x){return x===temp['@Name'];})[0]].DataDriveList[0];}};if(action.payload.Hosttype==="Gateway"){var Gatewaytemp=action.payload.totalList;var gatewaytemp=true;var gatewaytempcount=state.count-1;if(state.count-1===0){gatewaytemp=false;}return Object.assign({},state,{Gatewaydetails:Gatewaytemp,isLoading:gatewaytemp,count:gatewaytempcount});}else if(action.payload.Hosttype==="Controller"){Controllertemp=action.payload.totalList;var controllertemp=true;var controllertempcount=state.count-1;if(state.count-1===0){controllertemp=false;}return Object.assign({},state,{Controllerdetails:Controllertemp,isLoading:controllertemp,count:controllertempcount});}else if(action.payload.Hosttype==="Master"){Mastertemp=action.payload.totalList;var mastertemp=true;var mastertempcount=state.count-1;if(state.count-1===0){mastertemp=false;}return Object.assign({},state,{Masterdetails:Mastertemp,isLoading:mastertemp,count:mastertempcount});}else if(action.payload.Hosttype==="GPU"){GPUtemp=action.payload.totalList;var index=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.findIndex(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_37" /* GPU_ */];});if(index!==-1){GPUandNonGPUCommonMethod(index);}var wl=state.workload;var gputemp=true;var gputempcount=state.count-1;if(state.count-1===0){gputemp=false;}return Object.assign({},state,{GPUdetails:GPUtemp,workload:wl,isLoading:gputemp,count:gputempcount,calculateBlueDataAPIcount:calculateBlueDataAPIcount});}else if(action.payload.Hosttype==="NonGPU"){var _NonGPUtemp2=action.payload.totalList;var _index=state.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Server.findIndex(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_111" /* NONGPU_ */];});if(_index!==-1){GPUandNonGPUCommonMethod(_index);}var _wl=state.workload;var nongputemp=true;var nongputempcount=state.count-1;if(state.count-1===0){nongputemp=false;}return Object.assign({},state,{NonGPUdetails:_NonGPUtemp2,workload:_wl,isLoading:nongputemp,count:nongputempcount,calculateBlueDataAPIcount:calculateBlueDataAPIcount});}else if(action.payload.Hosttype===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_162" /* STORAGE_HOST_ROLE_NAME */]){var countTemp=state.count-1;var loadingTemp=true;if(countTemp===0){loadingTemp=false;}var storageDetailsTemp=Object.assign({},action.payload.totalList);return Object.assign({},state,{count:countTemp,isLoading:loadingTemp,Storagedetails:storageDetailsTemp});}case'FETCH_GATEWAYDLTS_PENDING':var gatetemp=void 0;gatetemp=state.count+1;return Object.assign({},state,{isLoading:true,count:gatetemp});case'GETEXTRANODES_QTY_SUCCESS':var extraqty='';var quantity=void 0;state.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Master Node"){quantity=action.payload.masterqty;val.Service.Recommendation['@NodesCount']=action.payload.masterqty;//val.Service.Hardware['@NodesCount'] = action.payload.masterqty
if(val.Service.Hardware['@NodesQty']==="Sizer Recommendation"){//val.Service.Hardware['@NodesCount'] = action.payload.gatewayqty //CID 10688 (#1 of 1): Copy-paste error, Coverity Fix by Aditya
val.Service.Hardware['@NodesCount']=action.payload.masterqty;}Object(__WEBPACK_IMPORTED_MODULE_0__commonLogic__["l" /* updateGrowthItem */])(val['@Type'],quantity,state.workload);}if(val['@Type']==="Gateway Node"){quantity=action.payload.gatewayqty;val.Service.Recommendation['@NodesCount']=action.payload.gatewayqty;if(val.Service.Hardware['@NodesQty']==="Sizer Recommendation"){val.Service.Hardware['@NodesCount']=action.payload.gatewayqty;}Object(__WEBPACK_IMPORTED_MODULE_0__commonLogic__["l" /* updateGrowthItem */])(val['@Type'],quantity,state.workload);}});var Savevalues={MasterQTY:action.payload.masterqty,GatewayQty:action.payload.gatewayqty};extraqty=state.workload;return Object.assign({},state,{workload:extraqty,MasterQTY:action.payload.masterqty,GatewayQty:action.payload.gatewayqty,prevValues:Savevalues,isLoading:false,getExtraNodes:false});case'GETEXTRANODES_QTY_PENDING':return Object.assign({},state,{isLoading:true});case'CONTROLLER_CONFIG':return Object.assign({},state,{ControllerConfigChanged:action.payload.data});case'ERROR_CLOSE':return Object.assign({},state,{isError:false,Errormsg:'error'});case'CALC_DISABLED':return Object.assign({},state,{calbtn:action.payload.data});case'UPDATE_CALCULATEBLUEDATAAPICOUNT':return Object.assign({},state,{calculateBlueDataAPIcount:action.payload});case"FETCH_ANALYTICSDATABASENODEQTY_PENDING":return Object.assign({},state,{isLoading:true});case"FETCH_ANALYTICSDATABASENODEQTY_SUCCESS":state.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===action.payload.function){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===action.payload.service){service.Hardware['@NodesCount']=action.payload.qty;}});}}});servicetemp=state.workload;return Object.assign({},state,{workload:servicetemp,isLoading:false});case'CHANGE_GATEWAY':return Object.assign({},state,{changeGateway:action.payload});case'LOAD_SELECTION_SUCCESS':if(action.payload.Workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["s" /* BLUE_DATA */]){if(Array.isArray(action.payload.Workload.UserInputs.Environments.Environment)){state.NonGPUValue=Object.assign({},action.payload.Workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).NonGPUValue);state.GPUValue=Object.assign({},action.payload.Workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_212" /* yES_ */];}).GPUValue);}else{state.NonGPUValue=Object.assign({},action.payload.Workload.UserInputs.Environments.GPUValue);state.GPUValue=Object.assign({},action.payload.Workload.UserInputs.Environments.NonGPUValue);}}var GPUvaluetempo=state.GPUValue;var NonGPUvaluetempo=state.NonGPUValue;return Object.assign({},state,{GPUValue:GPUvaluetempo,NonGPUValue:NonGPUvaluetempo});case'CALCULATE_WITHUPDATEDTENANTDRIVEACTION':return Object.assign({},state,{calculateWithUpdatedTenantDrive:action.payload});case'CURRENT_ROLENAMEACTION':return Object.assign({},state,{currentRoleName:action.payload});case'UPDATE_SCREEN':return Object.assign({},state,{currentTab:action.payload});case'GATEWAY_RECOMMENDATIONS_PENDING':return Object.assign({},state,{isLoading:true});case'CONTROLLER_RECOMMENDATIONS_PENDING':return Object.assign({},state,{isLoading:true});case'MASTER_RECOMMENDATIONS_PENDING':return Object.assign({},state,{isLoading:true});case'GATEWAY_RECOMMENDATIONS_SUCCESS':var shouldLoad=updateGatewayandController(state,action,__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_29" /* GATEWAY_ */]);workloadtemp=state.workload;return Object.assign({},state,{workload:workloadtemp,isLoading:shouldLoad});case'CONTROLLER_RECOMMENDATIONS_SUCCESS':var shouldload1=updateGatewayandController(state,action,__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["F" /* CONTROLLER_ */]);workloadtemp=state.workload;return Object.assign({},state,{workload:workloadtemp,isLoading:shouldload1});case'MASTER_RECOMMENDATIONS_SUCCESS':var shouldload2=updateGatewayandController(state,action,__WEBPACK_IMPORTED_MODULE_1__action_types_EPAConstants_js__["_89" /* MASTER_ */]);workloadtemp=state.workload;return Object.assign({},state,{workload:workloadtemp,isLoading:shouldload2});}return state;};/* harmony default export */ __webpack_exports__["a"] = (sizerWorkload);

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {"Cost":{"NonGPU":{"@procSpecInt":"90 SpecInt","@Memory":"192 GB","@Disk":"1.92TB SSD"},"GPU":{"@procSpecInt":"90 SpecInt","@Memory":"192 GB ","@Disk":"1.92TB SSD"},"Storage":{"@procSpecInt":"60 SpecInt","@Memory":"96 GB ","@Disk":"1.92TB SSD","@PersistentDisk":"8TB HDD"},"ManagementHosts":{"@procSpecInt":"40 SpecInt","@Memory":"64 GB ","@Disk":"2.4TB HDD"}},"Density":{"NonGPU":{"@procSpecInt":"90 SpecInt","@Memory":"384 GB","@Disk":"6.4TB SSD"},"GPU":{"@procSpecInt":"90 SpecInt","@Memory":"384 GB","@Disk":"6.4TB SSD"},"Storage":{"@procSpecInt":"60 SpecInt","@Memory":"96 GB","@Disk":"6.4TB SSD","@PersistentDisk":"8TB HDD"},"ManagementHosts":{"@procSpecInt":"40 SpecInt","@Memory":"64 GB ","@Disk":"2.4TB HDD"}},"Performance":{"NonGPU":{"@procSpecInt":"120 SpecInt","@Memory":"384 GB","@Disk":"6.4TB SSD"},"GPU":{"@procSpecInt":"130 SpecInt","@Memory":"768 GB","@Disk":"6.4TB SSD"},"Storage":{"@procSpecInt":"80 SpecInt","@Memory":"96 GB","@Disk":"6.4TB SSD","@PersistentDisk":"4TB HDD"},"ManagementHosts":{"@procSpecInt":"60 SpecInt","@Memory":"192 GB ","@Disk":"1.92TB SSD"}}}

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var logMiddleware=function logMiddleware(_ref){var getState=_ref.getState,dispatch=_ref.dispatch;return function(next){return function(action){console.log(action);next(action);};};};/* harmony default export */ __webpack_exports__["a"] = (logMiddleware);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__download__ = __webpack_require__(461);
//import summary from './summary.json'
//var GRinput = '';
//var summary = '';
var canceled={};var EZMERAL_SOLUTION_NAME="HPE Ezmeral Container Platform Configuration";var BLUE_DATA='BlueData';var apiMiddleware=function apiMiddleware(_ref){var dispatch=_ref.dispatch;return function(next){return function(action){var handleResponse=function handleResponse(data){if(action.payload.next.SUCCESS==='FETCH_SOLUTION_ADVANCED_SUCCESS'){if(data.status==='Error'){dispatch({type:action.payload.next.ERROR,payload:data});}else{window.location.replace(data);}//       $.ajax({
//       type: 'POST',
//       url: 'http://15.213.141.57:8080/UsherAPI/rest/ecoSystem/pushBomAndSolutionDetails',
//       dataType: 'json',
//       contentType: 'application/json; charset=utf-8',
//       data: JSON.stringify(data),          
//       success: function (response){
//            console.log(response);
//            dispatch({ type: 'POSTSSET_SUCCESS',payload: response}); 
//       },
//       error: function (response){            
//         dispatch({ type: 'SERVER_ERROR', payload: response })
//       }
//     });
//      dispatch({ type: 'POSTSSET_PENDING',payload:'Waiting for SSET...'});
}if(action.cancelable&&canceled[action.cancelable]){return;}if(action.payload.next.SUCCESS==='EPA_DOWNLOAD_METRICS_SUCCESS'){Object(__WEBPACK_IMPORTED_MODULE_3__download__["a" /* download */])(data,"MetricsData.xls","text/html");return;}if(action.payload.next.SUCCESS==='EPA_EXPORT_COMPARESOLUTIONDATA_SUCCESS'){Object(__WEBPACK_IMPORTED_MODULE_3__download__["a" /* download */])(data,"CompareSolutionData.xls","text/html");return;}if(data.isError&&action.payload.next.ERROR==='VALIDATE_WORKLOAD_ERROR'){var obj={isError:true,errorMsg:data.Message};dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_sessions__["p" /* errorValidataion */])(obj));}else if(action.payload.next.ERROR==='VALIDATE_WORKLOAD_ERROR'&&!data.isError){var _obj='';dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_sessions__["p" /* errorValidataion */])(_obj));}if(data==='WORKLOAD_CONFLICT'){dispatch({type:'WORKLOAD_CONFLICT',payload:data});}else if(data==='SOLUTION_CONFLICT'){dispatch({type:'SOLUTION_CONFLICT',payload:data});}else if((__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]==="EPA"||__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]==="EPAvNext")&&action.payload.next.SUCCESS==='LOAD_SELECTION_SUCCESS'&&!data.isFailed){if(data.Workload.UserInputs.Environments.WorkloadType===BLUE_DATA){if(!Array.isArray(data.Workload.UserInputs.Environments.Environment)){// return dispatch({ type: 'LOADED_OLD_SELECTION'});
}}if(data.TreeView!==null&&data.TreeView!==''&&Array.isArray(data.TreeView.Solutions.Solution)){// let toReducer = '';
var multipleSolutions=[];var WdoConfiguration={GRBomInput:'',GRInput:'',bomView:'',configView:'',treeView:''};var Traditional={GRBomInput:'',GRInput:'',bomView:'',configView:'',treeView:''};var EzmeralCPSolutions={GRBomInput:'',GRInput:'',bomView:'',configView:'',treeView:''};multipleSolutions=data.TreeView.Solutions.Solution.map(function(item,index){if(item.SolProfile['#text']=='Elastic Config'){var temp=JSON.parse(JSON.stringify(data));temp.TreeView.Solutions.Solution=item;WdoConfiguration.treeView=temp.TreeView;return Object.assign({},WdoConfiguration);}else if(item.SolProfile['#text']=='Traditional'){var _temp=JSON.parse(JSON.stringify(data));_temp.TreeView.Solutions.Solution=item;Traditional.treeView=_temp.TreeView;return Traditional;}else if(item.SolProfile['#text']===EZMERAL_SOLUTION_NAME){var _temp2=JSON.parse(JSON.stringify(data));_temp2.TreeView.Solutions.Solution=item;EzmeralCPSolutions.treeView=_temp2.TreeView;return Object.assign({},EzmeralCPSolutions);}});data.TreeView=multipleSolutions[0].treeView;data.EPAArray=multipleSolutions;dispatch({type:'LOAD_SELECTION_SUCCESS',payload:data});}else{dispatch({type:'LOAD_SELECTION_SUCCESS',payload:data});}}else if((__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]==="EPA"||__WEBPACK_IMPORTED_MODULE_1__AppConfig__["f" /* said */]==="EPAvNext")&&action.payload.next.SUCCESS==='FETCH_SOLUTION_SUCCESS'&&!data.isFailed){var _multipleSolutions=[];var _WdoConfiguration={GRBomInput:'',GRInput:'',bomView:'',configView:'',treeView:''};var _Traditional={GRBomInput:'',GRInput:'',bomView:'',configView:'',treeView:''};var _EzmeralCPSolutions={GRBomInput:'',GRInput:'',bomView:'',configView:'',treeView:''// let arr = [];
// if( action.payload.next.SUCCESS === 'LOAD_SELECTION_SUCCESS' ){
//     arr = data.TreeView.Solutions.Solution;
//     if(Array.isArray(arr))        
//     {
//       let toReducer = '';
//       multipleSolutions = arr.map((item)=>{
//         if(item.SolProfile['#text']== 'WDO Config')
//         {
//           var temp = JSON.parse(JSON.stringify(data.TreeView));
//           temp.Solutions.Solution = item;
//           WdoConfiguration.treeView = temp;
//           toReducer = WdoConfiguration;
//           return WdoConfiguration;
//         }
//         else if (item.SolProfile['#text']== 'Traditional')
//         {
//           var temp = JSON.parse(JSON.stringify(data.TreeView));
//           temp.Solutions.Solution = item;
//           Traditional.treeView = temp;
//           return Traditional;
//         }
//       });
//       var obj = {
//       data: toReducer.treeView,
//       multipleSolutions
//       }
//       dispatch({ type: 'EPA_MULTIPLE_SOLUTIONS_SUCCESS', payload: obj })
//     }
//     else{
//       dispatch({ type: action.payload.next.SUCCESS, payload: data })
//     }
// }else if( action.payload.next.SUCCESS === 'FETCH_SOLUTION_SUCCESS'){
//     arr = data.Solutions.Solution;
//     if(Array.isArray(arr))        
//     {
//       let toReducer = '';
//       multipleSolutions = arr.map((item)=>{
//         if(item.SolProfile['#text']== 'WDO Config')
//         {
//           var temp = JSON.parse(JSON.stringify(data));
//           temp.Solutions.Solution = item;
//           WdoConfiguration.treeView = temp;
//           toReducer = WdoConfiguration;
//           return WdoConfiguration;
//         }
//         else if (item.SolProfile['#text']== 'Traditional')
//         {
//           var temp = JSON.parse(JSON.stringify(data));
//           temp.Solutions.Solution = item;
//           Traditional.treeView = temp;
//           return Traditional;
//         }
//       });
//       var obj = {
//       data: toReducer.treeView,
//       multipleSolutions
//       }
//       dispatch({ type: 'EPA_MULTIPLE_SOLUTIONS_SUCCESS', payload: obj })
//     }
//     else{
//       dispatch({ type: action.payload.next.SUCCESS, payload: data })
//     }
// }
};if(Array.isArray(data.Solutions.Solution)){// let toReducer = '';
_multipleSolutions=data.Solutions.Solution.map(function(item,index){if(item.SolProfile['#text']=='Elastic Config'){var temp=JSON.parse(JSON.stringify(data));temp.Solutions.Solution=item;_WdoConfiguration.treeView=temp;return Object.assign({},_WdoConfiguration);}else if(item.SolProfile['#text']=='Traditional'){var _temp3=JSON.parse(JSON.stringify(data));_temp3.Solutions.Solution=item;_Traditional.treeView=_temp3;return _Traditional;}else if(item.SolProfile['#text']===EZMERAL_SOLUTION_NAME){var sizingResult=JSON.parse(JSON.stringify(data));sizingResult.Solutions.Solution=item;_EzmeralCPSolutions.treeView=sizingResult;return Object.assign({},_EzmeralCPSolutions);}});var _obj2={data:_multipleSolutions[0].treeView,multipleSolutions:_multipleSolutions};dispatch({type:'EPA_MULTIPLE_SOLUTIONS_SUCCESS',payload:_obj2});}else{dispatch({type:action.payload.next.SUCCESS,payload:data});}}else if(action.payload.next.SUCCESS==='FETCH_SOLUTION_SUCCESS'&&data.isFailed){dispatch({type:'FETCH_SOLUTION_ERROR',payload:data});}//else if (action.payload.next.SUCCESS === 'FETCH_SOLUTION_SUCCESS'){      
//  dispatch({ type: action.payload.next.SUCCESS, payload: summary })
// }
// else if (action.payload.next.SUCCESS === 'FETCH_GR_INPUT_SUCCESS')
//   {
//     dispatch({ type: action.payload.next.SUCCESS, payload: GRinput })
//   }
else{dispatch({type:action.payload.next.SUCCESS,payload:data});}};if(action.type==='API_REQUEST_BLOB'){var antiForgeryTokenField=document.getElementById('__antiForgeryToken');fetch(action.payload.url,{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','Cache':'no-cache','CSRFToken':antiForgeryTokenField.value},credentials:'same-origin'}).then(function(response){return response.blob();}).then(function(data){dispatch({type:action.payload.next.SUCCESS});Object(__WEBPACK_IMPORTED_MODULE_3__download__["a" /* download */])(data,action.payload.fileName,"text/html");});dispatch({type:action.payload.next.PENDING});}if(action.type==='API_REQUEST_POST_BLOB'){var _antiForgeryTokenField=document.getElementById('__antiForgeryToken');fetch(action.payload.url,{method:"POST",headers:{'Accept':'application/json','Content-Type':'application/json','Cache':'no-cache','CSRFToken':_antiForgeryTokenField.value},credentials:'same-origin',body:JSON.stringify(action.payload.data)}).then(function(response){return response.blob();}).then(function(data){dispatch({type:action.payload.next.SUCCESS});Object(__WEBPACK_IMPORTED_MODULE_3__download__["a" /* download */])(data,action.payload.fileName,"text/html");});dispatch({type:action.payload.next.PENDING});}if(action.type==='API_REQUEST'){var _antiForgeryTokenField2=document.getElementById('__antiForgeryToken');fetch(action.payload.url,{method:"GET",headers:{'Accept':'application/json','Content-Type':'application/json','Cache':'no-cache','CSRFToken':_antiForgeryTokenField2.value},credentials:'same-origin'}).then(function(response){return response.json();}).then(handleResponse);dispatch({type:action.payload.next.PENDING});}if(action.type==='API_REQUEST_POST'){var _antiForgeryTokenField3=document.getElementById('__antiForgeryToken');var header=null;if(_antiForgeryTokenField3!=null){header={'CSRFToken':_antiForgeryTokenField3.value//  XSRF-TOKEN
};}__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({type:'POST',url:action.payload.url,dataType:'json',contentType:'application/json; charset=utf-8',data:JSON.stringify(action.payload.data),headers:header,success:function success(response){// if (action.payload.url.indexOf('AdvancedSizing')) {
//   console.log('Inside redirect')
//   console.log(response.redirect);
//   window.location.replace(response)
// }
// else {
console.log('Outside Inside redirect');handleResponse(response);//}
},error:function error(response){if(action.payload.url.indexOf('GetSSETData')!==-1){window.location.replace(__WEBPACK_IMPORTED_MODULE_1__AppConfig__["a" /* appUrl */]);}dispatch({type:'SERVER_ERROR',payload:response});}});// fetch(action.payload.url,{
//     method: 'POST',
//     dataType: 'json',
//     contentType: 'application/json',
//     body: JSON.stringify(action.payload.data)
// })
// .then((response) => response.json())
// .then(handleResponse);    
action.payload.data!==undefined&&action.payload.data.isSizerAsEntry?dispatch({type:action.payload.next.PENDING,payload:{"isSizerAsEntry":true}}):dispatch({type:action.payload.next.PENDING});}if(action.type==='CANCEL_API_REQUEST'){canceled[action.id]=true;setTimeout(function(){return delete canceled[action.id];},5000);}return next(action);};};};/* harmony default export */ __webpack_exports__["a"] = (apiMiddleware);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = download;
//download.js v4.1, by dandavis; 2008-2015. [CCBY2] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// https://github.com/rndme/download
function download(data,strFileName,strMimeType){var self=window,// this script is only for browsers anyway...
u="application/octet-stream",// this default mime also triggers iframe downloads
m=strMimeType||u,x=data,url=!strFileName&&!strMimeType&&x,D=document,a=D.createElement("a"),z=function z(a){return String(a);},B=self.Blob||self.MozBlob||self.WebKitBlob||z,fn=strFileName||"download",blob,fr;B=B.call?B.bind(self):Blob;if(String(this)==="true"){//reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
x=[x,m];m=x[0];x=x[1];}if(url&&url.length<2048){fn=url.split("/").pop().split("?")[0];a.href=url;// assign href prop to temp anchor
if(a.href.indexOf(url)!==-1){// if the browser determines that it's a potentially valid url path:
var ajax=new XMLHttpRequest();ajax.open("GET",url,true);ajax.responseType='blob';ajax.onload=function(e){//Coverity defect fix 10001
//download(e.target.response, fn, u);
this.download(e.target.response,fn,u);};ajax.send();return ajax;}// end if valid url?
}// end if url?
//go ahead and download dataURLs right away
if(/^data:[\w+-]+\/[\w+-]+[,;]/.test(x)){return navigator.msSaveBlob?// IE10 can't do a[download], only Blobs:
navigator.msSaveBlob(d2b(x),fn):saver(x);// everyone else can save dataURLs un-processed
}//end if dataURL passed?
blob=x instanceof B?x:new B([x],{type:m});function d2b(u){var p=u.split(/[:;,]/),t=p[1],dec=p[2]=="base64"?atob:decodeURIComponent,bin=dec(p.pop()),mx=bin.length,//i= 0,
uia=new Uint8Array(mx);//Coverity defect fix 10015
//for(i;i<mx;++i) uia[i]= bin.charCodeAt(i);
for(var i=0;i<mx;++i){uia[i]=bin.charCodeAt(i);}return new B([uia],{type:t});}function saver(url,winMode){if('download'in a){//html5 A[download]
a.href=url;a.setAttribute("download",fn);a.className="download-js-link";a.innerHTML="downloading...";D.body.appendChild(a);setTimeout(function(){a.click();D.body.removeChild(a);if(winMode===true){setTimeout(function(){self.URL.revokeObjectURL(a.href);},250);}},66);return true;}// handle non-a[download] safari as best we can:
if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)){url=url.replace(/^data:([\w/\-+]+)/,u);if(!window.open(url)){// popup blocked, offer direct download:
if(window.confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){window.location.href=url;}}return true;}//do iframe dataURL download (old ch+FF):
var f=D.createElement("iframe");D.body.appendChild(f);if(!winMode){// force a mime that will download:
url="data:"+url.replace(/^data:([\w/\-+]+)/,u);}f.src=url;setTimeout(function(){D.body.removeChild(f);},333);}//end saver
if(navigator.msSaveBlob){// IE10+ : (has Blob, but not a[download] or URL)
return navigator.msSaveBlob(blob,fn);}if(self.URL){// simple fast and modern way using Blob and URL:
saver(self.URL.createObjectURL(blob),true);}else{// handle non-Blob()+non-URL browsers:
if(typeof blob==="string"||blob.constructor===z){try{return saver("data:"+m+";base64,"+self.btoa(blob));}catch(y){return saver("data:"+m+","+encodeURIComponent(blob));}}// Blob but not URL:
fr=new FileReader();fr.onload=function(e){saver(this.result);};fr.readAsDataURL(blob);}return true;};/* end download() */

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import {errorValidataion} from '../actions/sessions';
var errorMiddleware=function errorMiddleware(_ref){var getState=_ref.getState,dispatch=_ref.dispatch;return function(next){return function(action){// if (action.type === 'ADD_SESSION')
// {
//     if(action.payload.name === undefined || action.payload.name === '' || action.payload.name === null){     
//         dispatch(errorValidataion(true));
//         return;
//     }
//    else{      
//        dispatch(errorValidataion(false));              
//    }        
// }
return next(action);};};};/* harmony default export */ __webpack_exports__["a"] = (errorMiddleware);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(156);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(465);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(475);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(243);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(243);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(244);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(476);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(156);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/index.c43f9a4c.scss";

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_App__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SizingEngineUI_SizingEngineCommonScreens_Home__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SizingEngineUI_SizingEngineCommonScreens_Build__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_beforeunload_lib_Beforeunload__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_beforeunload_lib_Beforeunload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_beforeunload_lib_Beforeunload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__State_actions_authentication__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_idle_timer__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SizingEngineUI_SizingEngineCommonScreens_SizingProgressbar__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SizingEngineUI_SizingEngineCommonScreens_GraphicalRepresentation__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SizingEngineUI_SizingEngineCommonScreens_SolutionPreview__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__SizingEngineUI_SizingEngineCommonScreens_CompareSol__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__SizingEngineUI_SizingEngineCommonScreens_Utils__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__SizingEngineUI_SizingEngineCommonScreens_MetricsData_vNext__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__SizingEngineUI_SizingEngineCommonScreens_SAPLOOKUP__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__SizingEngineUI_SizingEngineCommonScreens_GlGrowth__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_tooltip_dist_decorators_windowListener__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_react_tooltip_dist_decorators_windowListener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_react_tooltip_dist_decorators_windowListener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__State_constants_CommonConstants__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Header from 'grommet/components/Header';
//import Headline from 'grommet/components/Headline';
//import BrandHpeStack from 'grommet/components/icons/base/BrandHpeStack';
//import Login from './SizingEngineUI/SizingEngineCommonScreens/Login';
//import Base64 from 'base-64';
// import LoginScr from './SizingEngineUI/UsherScreens/LoginForm';
// import RegistrationScr from './SizingEngineUI/UsherScreens/RegistrationForm';
// import ResetPasswordScr from './SizingEngineUI/UsherScreens/ResetPassword';
// import ForgotPasswordScr from './SizingEngineUI/UsherScreens/ForgotPassword';
// import ValidateUserScr from './SizingEngineUI/UsherScreens/ValidateUser';
//import Cookies from 'grommet/utils/Cookies';
var tRUE_="true";function SolutionLayout(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{className:'GRPage'/* closer={true} */,flush:false,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__SizingEngineUI_SizingEngineCommonScreens_GraphicalRepresentation__["a" /* default */],{externalAppProps:props.grProps,isFromExternalApp:true,listItem:false,actvSoln:'Traditional'}));}function renderSolutionPreview(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{className:'GRPage',flush:false,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__SizingEngineUI_SizingEngineCommonScreens_SolutionPreview__["a" /* default */],{externalAppProps:props.solutionPreviewProps,isFromExternalApp:true}));}function renderCompareSol(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{className:'GRPage',flush:false,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__SizingEngineUI_SizingEngineCommonScreens_CompareSol__["a" /* default */],{externalAppProps:props.compareSolProps,isFromExternalApp:true}));}function renderMetricsData(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{className:'GRPage',flush:false,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default.a,{id:'backToSSETyes',primary:false,plain:true,style:{position:'absolute',right:'0',color:'#ff8d6d'}/* icon={<Revert size="small" colorIndex='accent-3' />} */,label:'Close',onClick:function onClick(){window.location.replace(props.metricsDataProps.ssetUrl);},className:'ReverseSavewrkloadbtn'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__SizingEngineUI_SizingEngineCommonScreens_MetricsData_vNext__["a" /* default */],{externalAppProps:props.metricsDataProps,isFromExternalApp:true}));}function renderSAPLookUp(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{className:'SAPLookuplayer',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__SizingEngineUI_SizingEngineCommonScreens_SAPLOOKUP__["a" /* default */],{externalAppProps:props.SAPLookUpProps,isFromExternalApp:true}));}function renderGLGROWTH(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{className:'GRPage',flush:false,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__SizingEngineUI_SizingEngineCommonScreens_GlGrowth__["a" /* default */],{externalAppProps:props.GlGrowthProps,isFromExternalApp:true}));}// var globalVariableForCount=0;
var history=__WEBPACK_IMPORTED_MODULE_15_history_createBrowserHistory___default()();var idletimeoutpopup=false;var redirectUrlSSO='';var ssetURL='';var continueToSSET='False';var hideforSSET='False';var MyApp=function(_Component){_inherits(MyApp,_Component);function MyApp(){_classCallCheck(this,MyApp);var _this=_possibleConstructorReturn(this,(MyApp.__proto__||Object.getPrototypeOf(MyApp)).call(this));_this.state={MainFooter:true,isLoading:true,isAuthenticated:false,idleTimer:null,token:'',showGRView:false,grProps:{},showSolutionPreview:false,solutionPreviewProps:{},showMetricsData:false,metricsDataProps:{},showSAPLookUp:false,SAPLookUpProps:{},showCompareSol:false,compareSolProps:{},showGlGrowth:false,GlGrowthProps:{}};_this.checkAuthentication=_this.checkAuthentication.bind(_this);_this.setUserDefaultCountry=_this.setUserDefaultCountry.bind(_this);_this.onIdle=_this._onIdle.bind(_this);_this.Refresh=_this.Refresh.bind(_this);_this.validateSSOUser=_this.validateSSOUser.bind(_this);_this.reloadListener();return _this;}_createClass(MyApp,[{key:'Refresh',value:function Refresh(){if(this.props.sessionsState.SSETid){var id=this.props.sessionsState.activeSession.alias.split("#")[1];var isReviewed=this.props.sessionsState.ssetConfigurations.reviewed;Object(__WEBPACK_IMPORTED_MODULE_25__SizingEngineUI_SizingEngineCommonScreens_Utils__["b" /* redirectToSSET */])(id,isReviewed);}else{window.location=__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */];}}},{key:'_onIdle',value:function _onIdle(e){idletimeoutpopup=true;this.setState({});}},{key:'getDefaultUser',value:function getDefaultUser(){return{userName:'default',lastName:'default',password:undefined,preferredLanguage:'en',hpclname:'default@test.com',//hpclname:'test@hpe.com',
hpclidnumber:'d56c5196274c7f1bc5a6093c79e1822e',hpresidentcountrycode:'US',email:'default@test.com',createtimestamp:'2019-01-30 13:22:03',modifytimestamp:'2019-01-30 13:22:03',clang:'US-en'};}},{key:'componentDidMount',value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_16_jquery___default()("title").text(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["h" /* title */]);this.checkAuthentication();if(ssetURL===''){var queryParam=__WEBPACK_IMPORTED_MODULE_14_query_string___default.a.parse(window.location.search);if(queryParam!==undefined&&queryParam.reference!==undefined)hideforSSET='True';else hideforSSET='False';this.getSSETURL();}var queryParameter=__WEBPACK_IMPORTED_MODULE_14_query_string___default.a.parse(window.location.search);if(queryParameter!==""&&queryParameter.showGr===tRUE_||queryParameter.showPreview===tRUE_||queryParameter.showMetricsData===tRUE_||queryParameter.showLookUp===tRUE_||queryParameter.COMPARESOLUTION===tRUE_){var data={sizerReference:queryParameter.sizerReference,ssetUrl:queryParameter.ssetUrl+window.location.hash};if(queryParameter.showGr===tRUE_){this.setState({showGRView:true});this.setState({grProps:data});}else if(queryParameter.showPreview===tRUE_){this.setState({showSolutionPreview:true});this.setState({solutionPreviewProps:data});}else if(queryParameter.showMetricsData===tRUE_){this.setState({showMetricsData:true,metricsDataProps:data});}else if(queryParameter.showLookUp===tRUE_){this.setState({showSAPLookUp:true,SAPLookUpProps:data});}else if(queryParameter.COMPARESOLUTION===tRUE_&&window.location.href.toUpperCase().indexOf("SYNERGYSIZER")>-1){this.setState({showGlGrowth:true});this.setState({GlGrowthProps:data});}else if(queryParameter.COMPARESOLUTION===tRUE_){this.setState({showCompareSol:true});this.setState({compareSolProps:data});}}if(document.referrer==="")window.sessionStorage.setItem("IsParent","True");document.title=__WEBPACK_IMPORTED_MODULE_31__State_constants_CommonConstants__["p" /* SSETTITLE */];// this.props.fetchDefaultData();    
//  this.validateSSOUser(serviceUrl + 'SizingEngine/Gettoken','token')
//  .then((result)=> {
//         this.setState({ token: result.antiForgeryToken });           
//         this.checkAuthentication();
//         this.props.fetchDefaultData();  
//  }); 
// fetch(serviceUrl + 'SizingEngine/Gettoken',{
//       method: "GET",
//       headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//         'Cache': 'no-cache'
//       },
//       credentials: 'same-origin'
//     })
//   .then(function (response) {
//     return response.json();
//   })
//   .then(function (myJson) {
//     this.setState({ token: myJson.antiForgeryToken });           
//     this.checkAuthentication();
//     this.props.fetchDefaultData();  
//   }.bind(this));      
//this.props.fetchDefaultData();
}},{key:'getSSETURL',value:function getSSETURL(){var tokenUrl='SizingEngine/GetconfigDetails';var type='urlToken';var url=__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+tokenUrl;this.fetchSSETURL(url,type).then(function(result){console.log(result);ssetURL=result.redirectToken+'UsherAPI';continueToSSET=result.continuetoSSETToken;window.sessionStorage.setItem("featureFlag",result.continuetoSSETToken);window.sessionStorage.setItem("ssetURL",result.redirectToken);});}},{key:'fetchSSETURL',value:function fetchSSETURL(url,type){return new Promise(function(resolve,reject){fetch(url,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Cache':'no-cache'},credentials:'same-origin'}).then(function(response){console.log(response);if(!response.ok){throw Error(response.statusText);}if(type==='urlToken'){var data={};data.redirectToken=response.headers.get('redirectToken');data.continuetoSSETToken=response.headers.get('continueRedirectToken');resolve(data);//resolve(response.headers.get('redirectToken'));
}return response.json();});});}},{key:'validateSSOUser',value:function validateSSOUser(url,type,verb){return new Promise(function(resolve,reject){fetch(url,{method:verb,headers:{'Accept':'application/json','Content-Type':'application/json','Cache':'no-cache'},credentials:'same-origin'}).then(function(response){if(!response.ok){throw Error(response.statusText);}if(type==='token'){resolve(response.headers.get('AfToken'));}return response.json();}).then(function(myJson){resolve(myJson);}).catch(function(err){resolve('unAuthorized');});});}},{key:'checkAuthentication',value:function checkAuthentication(){var _this2=this;if(this.props.isAuthenticated===undefined){this.props.auth.isAuthenticated=false;var ssoValidation='SizingEngine/validateSSOUser';var passportValidation='SizingEngine/Login';var tokenUrl='SizingEngine/Gettoken';var verbGet='GET';var verbPost='POST';var ssoType='SSO';var passportType='Passport';var tokenType='token';var unAuthorized='unAuthorized';var ssoLogOut=localStorage.getItem(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["d" /* logOutAttribute */]);var hpe_com='hpe.com';var hpe_corp='hpecorp';var isNonHPECOMDomain=window.location.href.indexOf(hpe_com)<0&&window.location.href.indexOf(hpe_corp)<0;var queryParameter=__WEBPACK_IMPORTED_MODULE_14_query_string___default.a.parse(window.location.search);if(isNonHPECOMDomain||queryParameter.reference!==undefined&&(document.referrer.indexOf(hpe_com)>0||document.referrer.indexOf(hpe_corp)>0)){this.validateSSOUser(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+tokenUrl,tokenType).then(function(result){_this2.setState({token:result});_this2.props.fetchDefaultData();_this2.props.onLocalLogin(_this2.getDefaultUser());});}else if(ssoLogOut==null){this.props.onpassportLoggingIn();this.validateSSOUser(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+ssoValidation,ssoType,verbGet).then(function(result){if(result!==unAuthorized){var loggedInUser=result.loggedInUser;_this2.validateSSOUser(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+tokenUrl,tokenType,verbGet).then(function(result){_this2.setState({token:result});_this2.props.fetchDefaultData();_this2.props.onupdateSSOUser(loggedInUser);_this2.props.auth.ssoUser=true;});}else{_this2.validateSSOUser(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+passportValidation,passportType,verbPost).then(function(result){if(result!==unAuthorized){var passportResult=result;_this2.validateSSOUser(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+tokenUrl,tokenType,verbGet).then(function(result){_this2.setState({token:result});_this2.props.fetchDefaultData();_this2.props.onupdateSSOUser(passportResult);});}else if(result===unAuthorized){_this2.props.onserverError();}});}});}}}},{key:'reloadListener',value:function reloadListener(){if(window.performance){if(performance.navigation.type==1){window.location.href=__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */];}else{}}}// getUserPassportData(hppSession, isNonHPECOMDomain, isDigitalTokenUsed) {
//   let UserInfo = undefined;
//   if (isNonHPECOMDomain === true) {
//     UserInfo = {
//       preferredlanguage: 'en',
//       hpclname: 'default@test.com', // For non domain hosted websites 
//       hpclidnumber: 'd56c5196274c7f1bc5a6093c79e1822e', // Random ID
//       hpresidentcountrycode: 'US',
//       sn: 'default',
//       givenname: 'default',
//       email: 'default@test.com',
//       createtimestamp: '2019-01-30 13:22:03',
//       modifytimestamp: '2019-01-30 13:22:03',
//       clang: 'US-en',
//       isDigitalBadgeuser: 'True'
//     }
//   }
//Digital token case
//   else if (isDigitalTokenUsed) {
//     UserInfo = {
//       preferredlanguage: 'en',
//       hpclname: Cookies.get('uid'),
//       hpclidnumber: Cookies.get('employeeNumber'),
//       hpresidentcountrycode: Cookies.get('cc'),
//       sn: Cookies.get('sn'),
//       givenname: Cookies.get('givenName'),
//       email: Cookies.get('uid'),
//       createtimestamp: '',
//       modifytimestamp: '',
//       clang: 'US-en',
//       isDigitalBadgeuser: 'True'
//     }
//   }
//   else if (!Cookies.has('u_d') || Cookies.get('u_d') === undefined
//     || Cookies.get('u_d') === null || Cookies.get('u_d') === '') {
//     if (this.props.userDataFetchState === undefined) {
//       this.props.getUserBasicInfo(hppSession);
//       return;
//     }
//     if (this.props.userDataFetchState === 'FETCHED_SUCCESS') {
//       UserInfo = this.props.userData;
//     }
//   }
//   else {
//let cookieData = '=?UTF-8?B?PCV1c2VyYXR0cj0icHJlZmVycmVkbGFuZ3VhZ2U9ZW58aHBjbG5hbWU9anVuYWlkYWhtZWQuYW5zYXJpQGhwZS5jb218aHBjbGlkbnVtYmVyPTBhMDkwZDlhNzQ1OTFhMGQ0MDg1NTdiZTY2NTRiNWVhfGhwcmVzaWRlbnRjb3VudHJ5Y29kZT1JTnxzbj1BbnNhcml8Z2l2ZW5uYW1lPUp1bmFpZHxlbWFpbD1qdW5haWRhaG1lZC5hbnNhcmlAaHBlLmNvbXxjcmVhdGV0aW1lc3RhbXA9MjAxOS0wMS0wNCAxNDo0Njo0NHxtb2RpZnl0aW1lc3RhbXA9MjAxOS0wMS0wNCAxNDo0Njo0NHxjbGFuZz1JTi1lbg==?=';
//     let cookieData = undefined;
//     //hppSession === undefined ? 'undefined' : hppSession;
//     if (!Cookies.has('u_d')) {
//       return;
//     }
//     let temp = Cookies.get('u_d');
//     if (temp === undefined || temp === null) {
//       return;
//     }
//     try {
//       cookieData = temp;
//       var encodedTextRegex =
//         '(?:=\\?UTF-8\\?B\\?)(\\S*)(?:\\?=)';
//Extract encoded text from cookie content
//       var encodedContent =
//         cookieData.match(encodedTextRegex)[1];
//Decode encoded text from cookie content
//       var decodedContent =
//         Base64.decode(encodedContent);
//       var dataRegex =
//         '(?:preferredlanguage=)(\\S*)(?:\\|)(?:hpclname=)(\\S*)(?:\\|)(?:hpclidnumber=)(\\S*)(?:\\|)(?:hpresidentcountrycode=)(\\S*)(?:\\|)(?:sn=)(\\S*)(?:\\|)(?:givenname=)(\\S*)(?:\\|)(?:email=)(\\S*)(?:\\|)(?:createtimestamp=)([\\d\\D]*)(?:\\|)(?:modifytimestamp=)([\\d\\D]*)(?:\\|)(?:clang=)([\\D]*)';
//Extract authenticated email id from decoded text from cookie content
//       var userDetails =
//         decodedContent.match(dataRegex);
//       UserInfo = {
//         preferredlanguage:
//           userDetails[1],
//         hpclname:
//           userDetails[2],
//         hpclidnumber:
//           userDetails[3],
//         hpresidentcountrycode:
//           userDetails[4],
//         sn: userDetails[5],
//         givenname:
//           userDetails[6],
//         email: userDetails[7],
//         createtimestamp:
//           userDetails[8],
//         modifytimestamp:
//           userDetails[9],
//         clang: userDetails[10],
//         isDigitalBadgeuser: 'False'
//       };
//     }
//     catch (e) { return; }
//   }
//   this.props.onLocalLogin({
//     userName: UserInfo.givenname,
//     lastName: UserInfo.sn,
//     password: undefined,
//     preferredLanguage: UserInfo.preferredlanguage,
//     hpclname: UserInfo.hpclname,
//     hpclidnumber: UserInfo.hpclidnumber,
//     hpresidentcountrycode: UserInfo.hpresidentcountrycode,
//     email: UserInfo.email,
//     createtimestamp: UserInfo.createtimestamp,
//     modifytimestamp: UserInfo.modifytimestamp,
//     clang: UserInfo.clang
//   });
//   this.setState({ Country: UserInfo.clang });
//   var dataToSave = {
//     "firstName": UserInfo.givenname,
//     "lastName": UserInfo.sn,
//     "emailId": UserInfo.email,
//     "uniqueId": UserInfo.hpclidnumber,
//     "countryCode": UserInfo.hpresidentcountrycode,
//     "countryLanguage": UserInfo.clang,
//     "preferredLanguage": UserInfo.preferredlanguage,
//     "userId": UserInfo.hpclname,
//     "accountCreationDate": UserInfo.createtimestamp,
//     "accountModificationDate": UserInfo.modifytimestamp,
//     "authChannel": 'HPE Passport',
//     "isDigitalBadgeuser": UserInfo.isDigitalBadgeuser,
//     "sessionID": hppSession
//   }
//   this.props.onSaveUserData(dataToSave);
// }
},{key:'getUserName',value:function getUserName(){return'test@test.com';}//Update user Country 
},{key:'setUserDefaultCountry',value:function setUserDefaultCountry(){try{if(this.props.isAuthenticated===true&&this.props.countries!=''){//let countryCode = this.state.Country.split('-')[0];
var countryCode=this.props.auth.userData.clang.split('-')[0];var countryName=this.props.countries.Countries.Country.filter(function(p){return p.PricingCountry===countryCode;})[0].Name;if(this.props.country!==countryName&&this.props.userData.defaultCountrySet!==true){this.props.onCountryChange(countryName);this.props.userData.defaultCountrySet=true;}}}catch(e){}}// checkAuthentication() {
//   let url = window.location.href;
//   let isNonHPECOMDomain = url.indexOf('hpe.com') < 0;
//   let letDigitialToken = false;
//   if (!Cookies.has('HPPSESSION') && isNonHPECOMDomain !== true) {
//     this.setState({ isAuthenticated: false }); // false
//     return;
//   }
//   let count = Cookies.get('HPPSESSION');
//   let DigitalToken = Cookies.get('HPPFEDSESSION');
//   let isDigitalTokenUsed = false;
//   let logOut = Cookies.get('SizerLogout');
//   //isNonHPECOMDomain = false;
//   let redirectedFromPassportSite = url.indexOf('hpappid=' + landingUrl) >= 0;
//   if (DigitalToken !== undefined && DigitalToken !== null && DigitalToken !== 'LOGGEDOFF') {
//     isDigitalTokenUsed = true;
//   }
//   if (isNonHPECOMDomain || (count !== undefined && count !== null && count !== 'LOGGEDOFF' && (logOut === undefined || logOut === null || logOut === '' || redirectedFromPassportSite))) {
//     this.setState({ isAuthenticated: true }); // true
//     this.getUserPassportData(count, isNonHPECOMDomain, isDigitalTokenUsed);
//   }
//   else {
//     this.setState({ isAuthenticated: false }); // false
//   }
// }
},{key:'render',value:function render(){var _this3=this;var inputs=['Start Sizing','Processing the Inputs','Generating Server Configurations','Generating Processor Configurations','Generating Memory Configurations','Generating Storage Configurations','Generating Solution Summary'];var Time=1000;if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="CS750VirtSizer"){Time=23000;}else if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="EPAvNext"){Time=12000;inputs=['Start Sizing','Processing the Inputs','Generating Server, Processor, Memory and Storage Configurations','Generating Solution Summary'];}else if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="SAP"){Time=10000;inputs=['Start Sizing','Processing the Inputs','Generating Server, Processor, Memory and Storage Configurations','Generating Solution Summary'];}else if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="SAPHANA"){if(this.props.workload.UserInputs&&this.props.workload.UserInputs.Environments.WorkloadType==='SAPHANA'){Time=8000;}else{Time=16000;}inputs=['Start Sizing','Processing the Inputs','Generating Server, Processor, Memory and Storage Configurations','Generating Solution Summary'];}var field='';if(this.state.token!==''){field=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:'__antiForgeryToken',name:'antiForgeryToken',type:'hidden',value:this.state.token});}this.setUserDefaultCountry();//if (this.props.userDataFetchState === 'FETCHED_SUCCESS' && this.props.isAuthenticated !== true) {
//  this.checkAuthentication();
//}
var DefInputs=this.props.DefaultInputs;if(DefInputs===undefined){DefInputs={};}else{this.state.isLoading=false;}var layer='';var idlelayer='';if(this.props.isLoading){if(this.props.LoadingMsg!=="Please wait while Sizing the Solution."){layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:'#425563'},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_Spinning___default.a,{size:'small',className:'spinnerStyle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:'white'}},this.props.LoadingMsg)));}else{layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__SizingEngineUI_SizingEngineCommonScreens_SizingProgressbar__["a" /* default */],{inputs:inputs,TimeInterval:Time});}}else{}if(idletimeoutpopup){idlelayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{backgroundColor:'white'},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{padding:'10px',backgroundColor:'#425563',color:'white'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:'white'}},'Application Timed Out')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{justify:'between',margin:'none',pad:'small',align:'center',style:{display:"block"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,null,'The Application has been timed out due to inactivity. Please click below button to refresh.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default.a,{id:'refreshButton',style:{backgroundColor:'#425563',color:'white',width:'50%',marginLeft:'28%'},label:'Refresh',onClick:this.Refresh}))));}var componentToBeRendered=__WEBPACK_IMPORTED_MODULE_11__SizingEngineUI_SizingEngineCommonScreens_Home__["a" /* default */];if(this.state.showGRView){componentToBeRendered=SolutionLayout;}else if(this.state.showSolutionPreview){componentToBeRendered=renderSolutionPreview;}else if(this.state.showMetricsData){componentToBeRendered=renderMetricsData;}else if(this.state.showSAPLookUp){componentToBeRendered=renderSAPLookUp;}else if(this.state.showCompareSol){componentToBeRendered=renderCompareSol;}else if(this.state.showGlGrowth){componentToBeRendered=renderGLGROWTH;}var quePar=__WEBPACK_IMPORTED_MODULE_14_query_string___default.a.parse(window.location.search);var ignoreSSET=false;if(quePar!==undefined&&quePar.reference!==undefined){ignoreSSET=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_beforeunload_lib_Beforeunload___default.a,{onBeforeunload://  this.props.isAuthenticated === true ? () => "You'll loose your data!" : undefined
function(e){var idsToIgnore=['refreshButton','mailTo','SignInButton','backToSSETyes','sizeWorkloadBtn','start-guidance','logOutYes'];if(e.srcElement.activeElement.attributes['id']!==undefined&&idsToIgnore.indexOf(e.srcElement.activeElement.attributes['id'].value)!==-1||this.props.isAuthenticated===false||document.getElementById('sizeWorkloadBtn')!==null){return undefined;}else return"You'll loose your data!";}.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_idle_timer__["a" /* default */],{ref:function ref(_ref){_this3.idleTimer=_ref;},element:document,onActive:this.onActive,onIdle:this.onIdle,onAction:this.onAction,debounce:50,timeout:3600000}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_App___default.a,{centered:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:'everything',className:'everything'},field,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:'header',className:'header'}),layer,idlelayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],{basename:__WEBPACK_IMPORTED_MODULE_4__AppConfig__["b" /* basename */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{authed:this.props.isAuthenticated,exact:true,path:'/',component:componentToBeRendered,history:history,grPropData:this.state.grProps,solutionPreviewPropData:this.state.solutionPreviewProps,metricsDataPropData:this.state.metricsDataProps,SAPLookUpPropData:this.state.SAPLookUpProps,GLGrowthPropData:this.state.GlGrowthProps,compareSolPropsData:this.state.compareSolProps,ignoreSSET:ignoreSSET}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{authed:this.props.isAuthenticated,path:'/Home',component:__WEBPACK_IMPORTED_MODULE_11__SizingEngineUI_SizingEngineCommonScreens_Home__["a" /* default */],history:history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{authed:this.props.isAuthenticated,path:'/Build',component:__WEBPACK_IMPORTED_MODULE_12__SizingEngineUI_SizingEngineCommonScreens_Build__["a" /* default */],history:history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrivateRoute,{authed:this.props.isAuthenticated,component:__WEBPACK_IMPORTED_MODULE_11__SizingEngineUI_SizingEngineCommonScreens_Home__["a" /* default */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{id:'footer',className:'footer'})))));}}]);return MyApp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var isLoading=state.sessions.isLoading;var LoadingMsg=state.sessions.LoadingMsg;if(state.sessions.isLoginPending===true){isLoading=true;LoadingMsg=state.sessions.LoginMsg;}return{DefaultInputs:state.sessions.sessionDefaults.inputs.Sizers,isLoading:isLoading,LoadingMsg:LoadingMsg,countries:state.sessions.sessionDefaults.Countries,country:state.sessions.Country,workload:state.sizerWorkload.workload,userData:state.auth.userData,userDataFetchState:state.auth.userDataFetchState,isAuthenticated:state.auth.isAuthenticated,auth:state.auth,sessionsState:state.sessions};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDefaultData:function fetchDefaultData(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["w" /* fetchDefaultData */])());},onLocalLogin:function onLocalLogin(userData){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_authentication__["a" /* checkLogin */])(userData));},//getUserBasicInfo: (hppSession) => {
//  dispatch(getUserBasicInfo(hppSession));
//},
onCountryChange:function onCountryChange(country){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["X" /* updateCountry */])(country));},onSaveUserData:function onSaveUserData(userInfo){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["R" /* saveUserData */])(userInfo));},onLogin:function onLogin(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_authentication__["c" /* login */])());},onSSOLogin:function onSSOLogin(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_authentication__["d" /* ssoLogin */])());},onupdateSSOUser:function onupdateSSOUser(inputs){dispatch({type:'LOGIN_SUCCESS',payload:inputs});},onpassportLoggingIn:function onpassportLoggingIn(){dispatch({type:'LOGIN_PENDING',payload:''});},onserverError:function onserverError(){dispatch({type:'SERVER_ERROR',payload:''});}};};//  const PrivateRoute = ({component: Component, authed, ...rest}) => {
//   return (
//     <Route
//       {...rest}
//       render={(props) => authed === true
//         ? <Component {...props} />
//         : <Redirect to={{pathname: '/Registration', state: {from: props.location}}} />} />
//   )
// };
var clearSessions=function clearSessions(){localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["d" /* logOutAttribute */]);};var isSafe=function isSafe(param){return param;};var closeButton=function closeButton(){if(window.sessionStorage.getItem("IsParent")==="True"){window.open(window.location.protocol+'//'+window.location.host,'_self');}else{window.top.close();}};var continePopup=function continePopup(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Notification'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{margin:'4px 0px'}},'Information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'Thank you for your interest in \'',__WEBPACK_IMPORTED_MODULE_4__AppConfig__["h" /* title */],'\'.To provide a consistent user experience with presales tools,  All the individual sizer applications under presales tools category are now consolidated into Solution Sales Enablement Tool (SSET) with enhanced functionality. Please click the \u201CContinue to SSET\u201D button to navigate to SSET and follow the steps provided below to access the workload/infrastructure options for sizing your solution.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'To access the sizing tool through SSET:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'1. Login with your HPE Employee (SSO) or Partners (Passport) credentials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'2. If you are a first time SSET user, you need to request an access to the tool'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{marginBottom:'0px',marginLeft:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'An HPE SSET admin will validate the request and will notify the user by email of the status of the access request'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'3. On the landing page, click \u2018Start a new Guidance\u2019 button'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'4. On the dashboard page, select the Enterprise Solutions category. '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'5. Select the desired offering under Workload or Infrastructure Solutions and click Start.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'6. Fill out the General Inputs and then click on the Expert Sizing button to launch the Sizer.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'For more information refer SSET User Guide found under the Help icon in the SSET user interface or send an email to ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_grommet_components_Anchor___default.a,{id:'mailTo',href:"mailto:sset@hpe.com?Subject="+encodeURI(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["h" /* title */])+"%20(Online%20Client)",style:{textDecoration:"underline"}},'sset@hpe.com'),'.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{alignSelf:'center',direction:'row',margin:'small',justify:'between',style:{width:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default.a,{size:'small',primary:true,label:'Continue to SSET ',onClick:clearSessions,id:'SignInButton',href:ssetURL,target:'_self',style:{padding:'5px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default.a,{size:'small',primary:true,label:'Close ',onClick:closeButton,id:'ButtonClose'/* href={window.location.protocol+'//'+window.location.host} */,style:{padding:'5px'}}))));};var PrivateRoute=function PrivateRoute(_ref2){var Component=_ref2.component,grPropData=_ref2.grPropData,solutionPreviewPropData=_ref2.solutionPreviewPropData,metricsDataPropData=_ref2.metricsDataPropData,SAPLookUpPropData=_ref2.SAPLookUpPropData,GLGrowthPropData=_ref2.GLGrowthPropData,compareSolPropsData=_ref2.compareSolPropsData,authed=_ref2.authed,ignoreSSET=_ref2.ignoreSSET,rest=_objectWithoutProperties(_ref2,['component','grPropData','solutionPreviewPropData','metricsDataPropData','SAPLookUpPropData','GLGrowthPropData','compareSolPropsData','authed','ignoreSSET']);//var redirectUrl = 'https://cf.passport.hpe.com/hppcf/login.do?hpappid=' + landingUrl + '&applandingpage=https%3A%2F%2F' + redirection_Link + '%2F' + basename.replace('/', '');
var redirectUrl='https://cf.passport.hpe.com/hppcf/login.do?hpappid='+__WEBPACK_IMPORTED_MODULE_4__AppConfig__["c" /* landingUrl */]+'&applandingpage=https://'+__WEBPACK_IMPORTED_MODULE_4__AppConfig__["e" /* redirection_Link */]+'/'+__WEBPACK_IMPORTED_MODULE_4__AppConfig__["b" /* basename */].replace('/','');redirectUrlSSO=__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+'SizingEngine/SSOLogin';redirectUrl=encodeURI(redirectUrl);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */],Object.assign({},rest,{render:function render(props){return authed===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,Object.assign({},isSafe(props),{grProps:grPropData,solutionPreviewProps:solutionPreviewPropData,metricsDataProps:metricsDataPropData,SAPLookUpProps:SAPLookUpPropData,GlGrowthProps:GLGrowthPropData,compareSolProps:compareSolPropsData}))//{...props}   <Login/>}/>
:hideforSSET==='True'||ignoreSSET||window.sessionStorage.getItem("isReload")==="True"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:'#425563'},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_Spinning___default.a,{size:'small',className:'spinnerStyle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:'white'}},'Please wait while loading the data'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{width:'600px'},className:'AuthenticationLayer'},continueToSSET==='True'?continePopup():__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Sign in'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{margin:'4px 0px'}},'Authentication'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},'Thanks for visiting \'',__WEBPACK_IMPORTED_MODULE_4__AppConfig__["h" /* title */],'\'. To authenticate user credentials, you will be redirected to HPE authentication website. Once authenticated you will be redirected back to this site. Press Sign in button to continue.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{alignSelf:'center',direction:'row',margin:'small',justify:'between',style:{width:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default.a,{size:'small',primary:true,label:'HPE Employee Login ',onClick:clearSessions,id:'SignInButton',href:redirectUrlSSO,style:{padding:'5px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Button___default.a,{size:'small',primary:true,label:'HPE Passport Login ',onClick:clearSessions,id:'SignInButton',href:redirectUrl,style:{padding:'5px'}})))));}}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MyApp));

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(95);





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22)))

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(120);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

exports.setLocale = setLocale;
exports.getCurrentLocale = getCurrentLocale;
exports.getLocaleData = getLocaleData;

var _Cookies = __webpack_require__(238);

var _Cookies2 = _interopRequireDefault(_Cookies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentLocale = 'en-US';

function normalizeLocale(locale) {
  var locales = locale.replace(/_/g, '-').split('-');
  var normalizedLocale = locales[0];
  if (locales.length > 1) {
    normalizedLocale += '-' + locales[1].toUpperCase();
  }

  return normalizedLocale;
}

function setLocale(locale) {
  currentLocale = normalizeLocale(locale);
}

function getCurrentLocale() {
  try {
    var cookieLanguages = _Cookies2.default.get('languages');
    var locale = cookieLanguages ? JSON.parse(cookieLanguages)[0] : undefined;
    if (!locale) {
      locale = window.navigator.languages ? window.navigator.languages[0] : window.navigator.language || window.navigator.userLanguage;
    }

    return normalizeLocale(locale);
  } catch (e) {
    return currentLocale;
  }
}

function getLocaleData() {
  var appMessages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getCurrentLocale();

  var grommetMessages = void 0;
  try {
    grommetMessages = __webpack_require__(484)("./" + locale);
  } catch (e) {
    grommetMessages = {};
  }

  var messages = _extends({}, grommetMessages, appMessages);

  return { locale: locale, messages: messages };
}

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en": 249,
	"./en-US": 159,
	"./en-US.js": 159,
	"./en.js": 249,
	"./fr": 250,
	"./fr-FR": 160,
	"./fr-FR.js": 160,
	"./fr.js": 250,
	"./he": 251,
	"./he.js": 251,
	"./icons/en": 252,
	"./icons/en-US": 58,
	"./icons/en-US.js": 58,
	"./icons/en.js": 252,
	"./icons/fr": 253,
	"./icons/fr-FR": 122,
	"./icons/fr-FR.js": 122,
	"./icons/fr.js": 253,
	"./icons/ja": 254,
	"./icons/ja-JP": 161,
	"./icons/ja-JP.js": 161,
	"./icons/ja.js": 254,
	"./icons/nl": 162,
	"./icons/nl.js": 162,
	"./icons/zh": 255,
	"./icons/zh-CN": 163,
	"./icons/zh-CN.js": 163,
	"./icons/zh.js": 255,
	"./ja": 256,
	"./ja-JP": 164,
	"./ja-JP.js": 164,
	"./ja.js": 256,
	"./nl": 257,
	"./nl.js": 257,
	"./pt": 258,
	"./pt-BR": 165,
	"./pt-BR.js": 165,
	"./pt.js": 258,
	"./ru": 259,
	"./ru-RU": 166,
	"./ru-RU.js": 166,
	"./ru.js": 259,
	"./zh": 260,
	"./zh-CN": 167,
	"./zh-CN.js": 167,
	"./zh.js": 260
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 484;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormattedMessage = __webpack_require__(261);

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _Layer = __webpack_require__(15);

var _Layer2 = _interopRequireDefault(_Layer);

var _Menu = __webpack_require__(123);

var _Menu2 = _interopRequireDefault(_Menu);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SKIP_LINK_ANCHOR;

var SkipLinks = function (_Component) {
  _inherits(SkipLinks, _Component);

  function SkipLinks(props, context) {
    _classCallCheck(this, SkipLinks);

    var _this = _possibleConstructorReturn(this, (SkipLinks.__proto__ || Object.getPrototypeOf(SkipLinks)).call(this, props, context));

    _this._processTab = _this._processTab.bind(_this);
    _this._onFocus = _this._onFocus.bind(_this);
    _this._onClick = _this._onClick.bind(_this);
    _this._updateAnchors = _this._updateAnchors.bind(_this);
    _this._checkForSkipLink = _this._checkForSkipLink.bind(_this);
    _this.state = { anchors: [], showLayer: false };
    return _this;
  }

  _createClass(SkipLinks, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updateAnchors();

      this._keyboardHandlers = {
        tab: this._processTab
      };
      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);

      document.addEventListener('DOMNodeInserted', this._checkForSkipLink);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.setState({ routeChanged: true });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.routeChanged) {
        this.setState({ routeChanged: false }, this._updateAnchors);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
      document.removeEventListener('DOMNodeInserted', this._checkForSkipLink);
    }
  }, {
    key: '_checkForSkipLink',
    value: function _checkForSkipLink(event) {
      var skipLinks = document.querySelectorAll('.' + CLASS_ROOT);
      if (skipLinks.length > 0) {
        this._updateAnchors();
      } else if (this.state.anchors.length > 0) {
        this._updateAnchors();
      }
    }
  }, {
    key: '_updateAnchors',
    value: function _updateAnchors() {
      var anchorElements = document.querySelectorAll('.' + CLASS_ROOT);

      var anchors = Array.prototype.map.call(anchorElements, function (anchorElement) {
        return {
          id: anchorElement.getAttribute('id'),
          label: anchorElement.textContent
        };
      });

      this.setState({ anchors: anchors, routeChanged: false });
    }
  }, {
    key: '_onFocus',
    value: function _onFocus() {
      if (!this.state.showLayer) {
        this.setState({ showLayer: true });
      }
    }
  }, {
    key: '_processTab',
    value: function _processTab(event) {
      if (this.state.showLayer) {
        var currentAnchor = document.activeElement;
        var last = this.state.anchors.length - 1;

        var achorId = event.shiftKey ? this.state.anchors[0].id : this.state.anchors[last].id;

        var targetId = 'skipLayer_' + achorId;

        if (currentAnchor.id === targetId) {
          this.setState({ showLayer: false });
        }
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(destId, event) {
      event.preventDefault();
      var dest = document.getElementById(destId);
      this.setState({ showLayer: false }, function () {
        dest.focus();
        dest.scrollIntoView();
      });
    }
  }, {
    key: 'render',
    value: function render() {

      var anchorElements = this.state.anchors.map(function (anchor, index) {
        var skipToLabel = _Intl2.default.getMessage(this.context.intl, 'Skip to');
        var a11yLabel = skipToLabel + ' ' + anchor.label;
        return _react2.default.createElement(
          'a',
          { href: '#' + anchor.id,
            onFocus: this._onFocus,
            onClick: this._onClick.bind(this, anchor.id),
            id: 'skipLayer_' + anchor.id,
            key: 'skipLayerItem_' + index,
            'aria-label': a11yLabel },
          anchor.label
        );
      }.bind(this));

      var menuComponent = void 0;
      if (anchorElements.length > 0) {
        menuComponent = _react2.default.createElement(
          _Menu2.default,
          { direction: 'row', responsive: false, wrap: true },
          anchorElements
        );
      }

      return _react2.default.createElement(
        _Layer2.default,
        { id: 'skip-link-layer', hidden: !this.state.showLayer, align: 'top' },
        _react2.default.createElement(
          _Box2.default,
          { pad: { horizontal: 'small', vertical: 'medium' } },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement(_FormattedMessage2.default, { id: 'Skip to', defaultMessage: 'Skip to' })
          ),
          menuComponent
        )
      );
    }
  }]);

  return SkipLinks;
}(_react.Component);

SkipLinks.displayName = 'SkipLinks';
exports.default = SkipLinks;


SkipLinks.contextTypes = {
  intl: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLocaleData", function() { return addLocaleData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intlShape", function() { return intlShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectIntl", function() { return injectIntl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defineMessages", function() { return defineMessages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IntlProvider", function() { return IntlProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedDate", function() { return FormattedDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedTime", function() { return FormattedTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedRelative", function() { return FormattedRelative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedNumber", function() { return FormattedNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedPlural", function() { return FormattedPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedMessage", function() { return FormattedMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FormattedHTMLMessage", function() { return FormattedHTMLMessage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_intl_format_cache__ = __webpack_require__(503);
/*
 * Copyright 2019, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */










// GENERATED FILE
var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function addLocaleData() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var locales = Array.isArray(data) ? data : [data];

  locales.forEach(function (localeData) {
    if (localeData && localeData.locale) {
      __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__addLocaleData(localeData);
      __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__addLocaleData(localeData);
    }
  });
}

function hasLocaleData(locale) {
  var localeParts = (locale || '').split('-');

  while (localeParts.length > 0) {
    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
      return true;
    }

    localeParts.pop();
  }

  return false;
}

function hasIMFAndIRFLocaleData(locale) {
  var normalizedLocale = locale && locale.toLowerCase();

  return !!(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.__localeData__[normalizedLocale] && __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.__localeData__[normalizedLocale]);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var bool = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool;
var number = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number;
var string = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
var func = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func;
var object = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object;
var oneOf = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf;
var shape = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape;
var any = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any;
var oneOfType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType;

var localeMatcher = oneOf(['best fit', 'lookup']);
var narrowShortLong = oneOf(['narrow', 'short', 'long']);
var numeric2digit = oneOf(['numeric', '2-digit']);
var funcReq = func.isRequired;

var intlConfigPropTypes = {
  locale: string,
  timeZone: string,
  formats: object,
  messages: object,
  textComponent: any,

  defaultLocale: string,
  defaultFormats: object,

  onError: func
};

var intlFormatPropTypes = {
  formatDate: funcReq,
  formatTime: funcReq,
  formatRelative: funcReq,
  formatNumber: funcReq,
  formatPlural: funcReq,
  formatMessage: funcReq,
  formatHTMLMessage: funcReq
};

var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
  formatters: object,
  now: funcReq
}));

var messageDescriptorPropTypes = {
  id: string.isRequired,
  description: oneOfType([string, object]),
  defaultMessage: string
};

var dateTimeFormatPropTypes = {
  localeMatcher: localeMatcher,
  formatMatcher: oneOf(['basic', 'best fit']),

  timeZone: string,
  hour12: bool,

  weekday: narrowShortLong,
  era: narrowShortLong,
  year: numeric2digit,
  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
  day: numeric2digit,
  hour: numeric2digit,
  minute: numeric2digit,
  second: numeric2digit,
  timeZoneName: oneOf(['short', 'long'])
};

var numberFormatPropTypes = {
  localeMatcher: localeMatcher,

  style: oneOf(['decimal', 'currency', 'percent']),
  currency: string,
  currencyDisplay: oneOf(['symbol', 'code', 'name']),
  useGrouping: bool,

  minimumIntegerDigits: number,
  minimumFractionDigits: number,
  maximumFractionDigits: number,
  minimumSignificantDigits: number,
  maximumSignificantDigits: number
};

var relativeFormatPropTypes = {
  style: oneOf(['best fit', 'numeric']),
  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
};

var pluralFormatPropTypes = {
  style: oneOf(['cardinal', 'ordinal'])
};

/*
HTML escaping and shallow-equals implementations are the same as React's
(on purpose.) Therefore, it has the following Copyright and Licensing:

Copyright 2013-2014, Facebook, Inc.
All rights reserved.

This source code is licensed under the BSD-style license found in the LICENSE
file in the root directory of React's source tree.
*/

var intlConfigPropNames = Object.keys(intlConfigPropTypes);

var ESCAPED_CHARS = {
  '&': '&amp;',
  '>': '&gt;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#x27;'
};

var UNSAFE_CHARS_REGEX = /[&><"']/g;

function escape(str) {
  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
    return ESCAPED_CHARS[match];
  });
}

function filterProps(props, whitelist) {
  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return whitelist.reduce(function (filtered, name) {
    if (props.hasOwnProperty(name)) {
      filtered[name] = props[name];
    } else if (defaults$$1.hasOwnProperty(name)) {
      filtered[name] = defaults$$1[name];
    }

    return filtered;
  }, {});
}

function invariantIntlContext() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      intl = _ref.intl;

  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
}

function shallowEquals(objA, objB) {
  if (objA === objB) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  for (var i = 0; i < keysA.length; i++) {
    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
  var props = _ref2.props,
      state = _ref2.state,
      _ref2$context = _ref2.context,
      context = _ref2$context === undefined ? {} : _ref2$context;
  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _context$intl = context.intl,
      intl = _context$intl === undefined ? {} : _context$intl;
  var _nextContext$intl = nextContext.intl,
      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;


  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
}

function createError(message, exception) {
  var eMsg = exception ? '\n' + exception : '';
  return '[React Intl] ' + message + eMsg;
}

function defaultErrorHandler(error) {
  if (false) {
    console.error(error);
  }
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// Inspired by react-redux's `connect()` HOC factory function implementation:
// https://github.com/rackt/react-redux

function getDisplayName(Component$$1) {
  return Component$$1.displayName || Component$$1.name || 'Component';
}

function injectIntl(WrappedComponent) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$intlPropName = options.intlPropName,
      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var InjectIntl = function (_Component) {
    inherits(InjectIntl, _Component);

    function InjectIntl(props, context) {
      classCallCheck(this, InjectIntl);

      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));

      invariantIntlContext(context);
      return _this;
    }

    createClass(InjectIntl, [{
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_6_invariant___default()(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');

        return this._wrappedInstance;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
          ref: withRef ? /* istanbul ignore next */function (ref) {
            return _this2._wrappedInstance = ref;
          } : null
        }));
      }
    }]);
    return InjectIntl;
  }(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
  InjectIntl.contextTypes = {
    intl: intlShape
  };
  InjectIntl.WrappedComponent = WrappedComponent;


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(InjectIntl, WrappedComponent);
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

function defineMessages(messageDescriptors) {
  // This simply returns what's passed-in because it's meant to be a hook for
  // babel-plugin-react-intl.
  return messageDescriptors;
}

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

// This is a "hack" until a proper `intl-pluralformat` package is created.

function resolveLocale(locales) {
  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._resolveLocale(locales);
}

function findPluralFunction(locale) {
  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
  return __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a.prototype._findPluralRuleFunction(locale);
}

var IntlPluralFormat = function IntlPluralFormat(locales) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  classCallCheck(this, IntlPluralFormat);

  var useOrdinal = options.style === 'ordinal';
  var pluralFn = findPluralFunction(resolveLocale(locales));

  this.format = function (value) {
    return pluralFn(value, useOrdinal);
  };
};

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);

var RELATIVE_FORMAT_THRESHOLDS = {
  second: 60, // seconds to minute
  minute: 60, // minutes to hour
  hour: 24, // hours to day
  day: 30, // days to month
  month: 12 };

function updateRelativeFormatThresholds(newThresholds) {
  var thresholds = __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds;
  thresholds.second = newThresholds.second;
  thresholds.minute = newThresholds.minute;
  thresholds.hour = newThresholds.hour;
  thresholds.day = newThresholds.day;
  thresholds.month = newThresholds.month;
  thresholds['second-short'] = newThresholds['second-short'];
  thresholds['minute-short'] = newThresholds['minute-short'];
  thresholds['hour-short'] = newThresholds['hour-short'];
  thresholds['day-short'] = newThresholds['day-short'];
  thresholds['month-short'] = newThresholds['month-short'];
}

function getNamedFormat(formats, type, name, onError) {
  var format = formats && formats[type] && formats[type][name];
  if (format) {
    return format;
  }

  onError(createError('No ' + type + ' format named: ' + name));
}

function formatDate(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting date.', e));
  }

  return String(date);
}

function formatTime(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      timeZone = config.timeZone;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);

  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
    // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
  }

  try {
    return state.getDateTimeFormat(locale, filteredOptions).format(date);
  } catch (e) {
    onError(createError('Error formatting time.', e));
  }

  return String(date);
}

function formatRelative(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var date = new Date(value);
  var now = new Date(options.now);
  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);

  // Capture the current threshold values, then temporarily override them with
  // specific values just for this render.
  var oldThresholds = _extends({}, __WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a.thresholds);
  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);

  try {
    return state.getRelativeFormat(locale, filteredOptions).format(date, {
      now: isFinite(now) ? now : state.now()
    });
  } catch (e) {
    onError(createError('Error formatting relative time.', e));
  } finally {
    updateRelativeFormatThresholds(oldThresholds);
  }

  return String(date);
}

function formatNumber(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats;
  var format = options.format;


  var onError = config.onError || defaultErrorHandler;
  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);

  try {
    return state.getNumberFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting number.', e));
  }

  return String(value);
}

function formatPlural(config, state, value) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale;


  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
  var onError = config.onError || defaultErrorHandler;

  try {
    return state.getPluralFormat(locale, filteredOptions).format(value);
  } catch (e) {
    onError(createError('Error formatting plural.', e));
  }

  return 'other';
}

function formatMessage(config, state) {
  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var locale = config.locale,
      formats = config.formats,
      messages = config.messages,
      defaultLocale = config.defaultLocale,
      defaultFormats = config.defaultFormats;
  var id = messageDescriptor.id,
      defaultMessage = messageDescriptor.defaultMessage;

  // Produce a better error if the user calls `intl.formatMessage(element)`

  if (false) {
    invariant(!isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
  }

  // `id` is a required field of a Message Descriptor.
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(id, '[React Intl] An `id` must be provided to format a message.');

  var message = messages && messages[id];
  var hasValues = Object.keys(values).length > 0;

  // Avoid expensive message formatting for simple messages without values. In
  // development messages will always be formatted in case of missing values.
  if (!hasValues && "production" === 'production') {
    return message || defaultMessage || id;
  }

  var formattedMessage = void 0;
  var onError = config.onError || defaultErrorHandler;

  if (message) {
    try {
      var formatter = state.getMessageFormat(message, locale, formats);

      formattedMessage = formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
    }
  } else {
    // This prevents warnings from littering the console in development
    // when no `messages` are passed into the <IntlProvider> for the
    // default locale, and a default message is in the source.
    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
    }
  }

  if (!formattedMessage && defaultMessage) {
    try {
      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);

      formattedMessage = _formatter.format(values);
    } catch (e) {
      onError(createError('Error formatting the default message for: "' + id + '"', e));
    }
  }

  if (!formattedMessage) {
    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
  }

  return formattedMessage || message || defaultMessage || id;
}

function formatHTMLMessage(config, state, messageDescriptor) {
  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Process all the values before they are used when formatting the ICU
  // Message string. Since the formatted message might be injected via
  // `innerHTML`, all String-based values need to be HTML-escaped.
  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
    var value = rawValues[name];
    escaped[name] = typeof value === 'string' ? escape(value) : value;
    return escaped;
  }, {});

  return formatMessage(config, state, messageDescriptor, escapedValues);
}



var format = Object.freeze({
	formatDate: formatDate,
	formatTime: formatTime,
	formatRelative: formatRelative,
	formatNumber: formatNumber,
	formatPlural: formatPlural,
	formatMessage: formatMessage,
	formatHTMLMessage: formatHTMLMessage
});

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
var intlFormatPropNames = Object.keys(intlFormatPropTypes);

// These are not a static property on the `IntlProvider` class so the intl
// config values can be inherited from an <IntlProvider> ancestor.
var defaultProps = {
  formats: {},
  messages: {},
  timeZone: null,
  textComponent: 'span',

  defaultLocale: 'en',
  defaultFormats: {},

  onError: defaultErrorHandler
};

var IntlProvider = function (_Component) {
  inherits(IntlProvider, _Component);

  function IntlProvider(props) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, IntlProvider);

    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));

    __WEBPACK_IMPORTED_MODULE_6_invariant___default()(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');

    var intlContext = context.intl;

    // Used to stabilize time when performing an initial rendering so that
    // all relative times use the same reference "now" time.

    var initialNow = void 0;
    if (isFinite(props.initialNow)) {
      initialNow = Number(props.initialNow);
    } else {
      // When an `initialNow` isn't provided via `props`, look to see an
      // <IntlProvider> exists in the ancestry and call its `now()`
      // function to propagate its value for "now".
      initialNow = intlContext ? intlContext.now() : Date.now();
    }

    // Creating `Intl*` formatters is expensive. If there's a parent
    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
    // memoize the `Intl*` constructors and cache them for the lifecycle of
    // this IntlProvider instance.

    var _ref = intlContext || {},
        _ref$formatters = _ref.formatters,
        formatters = _ref$formatters === undefined ? {
      getDateTimeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.DateTimeFormat),
      getNumberFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(Intl.NumberFormat),
      getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a),
      getRelativeFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_intl_relativeformat___default.a),
      getPluralFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(IntlPluralFormat)
    } : _ref$formatters;

    _this.state = _extends({}, formatters, {

      // Wrapper to provide stable "now" time for initial render.
      now: function now() {
        return _this._didDisplay ? Date.now() : initialNow;
      }
    });
    return _this;
  }

  createClass(IntlProvider, [{
    key: 'getConfig',
    value: function getConfig() {
      var intlContext = this.context.intl;

      // Build a whitelisted config object from `props`, defaults, and
      // `context.intl`, if an <IntlProvider> exists in the ancestry.

      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);

      // Apply default props. This must be applied last after the props have
      // been resolved and inherited from any <IntlProvider> in the ancestry.
      // This matches how React resolves `defaultProps`.
      for (var propName in defaultProps) {
        if (config[propName] === undefined) {
          config[propName] = defaultProps[propName];
        }
      }

      if (!hasLocaleData(config.locale)) {
        var _config = config,
            locale = _config.locale,
            defaultLocale = _config.defaultLocale,
            defaultFormats = _config.defaultFormats,
            onError = _config.onError;


        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));

        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        config = _extends({}, config, {
          locale: defaultLocale,
          formats: defaultFormats,
          messages: defaultProps.messages
        });
      }

      return config;
    }
  }, {
    key: 'getBoundFormatFns',
    value: function getBoundFormatFns(config, state) {
      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
        boundFormatFns[name] = format[name].bind(null, config, state);
        return boundFormatFns;
      }, {});
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      var config = this.getConfig();

      // Bind intl factories and current config to the format functions.
      var boundFormatFns = this.getBoundFormatFns(config, this.state);

      var _state = this.state,
          now = _state.now,
          formatters = objectWithoutProperties(_state, ['now']);


      return {
        intl: _extends({}, config, boundFormatFns, {
          formatters: formatters,
          now: now
        })
      };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._didDisplay = true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_4_react__["Children"].only(this.props.children);
    }
  }]);
  return IntlProvider;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

IntlProvider.displayName = 'IntlProvider';
IntlProvider.contextTypes = {
  intl: intlShape
};
IntlProvider.childContextTypes = {
  intl: intlShape.isRequired
};
 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
  children: PropTypes.element.isRequired,
  initialNow: PropTypes.any
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedDate = function (_Component) {
  inherits(FormattedDate, _Component);

  function FormattedDate(props, context) {
    classCallCheck(this, FormattedDate);

    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedDate, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatDate = _context$intl.formatDate,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedDate = formatDate(value, this.props);

      if (typeof children === 'function') {
        return children(formattedDate);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedDate
      );
    }
  }]);
  return FormattedDate;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedDate.displayName = 'FormattedDate';
FormattedDate.contextTypes = {
  intl: intlShape
};
 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedTime = function (_Component) {
  inherits(FormattedTime, _Component);

  function FormattedTime(props, context) {
    classCallCheck(this, FormattedTime);

    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedTime, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatTime = _context$intl.formatTime,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedTime = formatTime(value, this.props);

      if (typeof children === 'function') {
        return children(formattedTime);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedTime
      );
    }
  }]);
  return FormattedTime;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedTime.displayName = 'FormattedTime';
FormattedTime.contextTypes = {
  intl: intlShape
};
 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

// The maximum timer delay value is a 32-bit signed integer.
// See: https://mdn.io/setTimeout
var MAX_TIMER_DELAY = 2147483647;

function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  }

  if (absDelta < HOUR) {
    return 'minute';
  }

  if (absDelta < DAY) {
    return 'hour';
  }

  // The maximum scheduled delay will be measured in days since the maximum
  // timer delay is less than the number of milliseconds in 25 days.
  return 'day';
}

function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_TIMER_DELAY;
  }
}

function isSameDate(a, b) {
  if (a === b) {
    return true;
  }

  var aTime = new Date(a).getTime();
  var bTime = new Date(b).getTime();

  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
}

var FormattedRelative = function (_Component) {
  inherits(FormattedRelative, _Component);

  function FormattedRelative(props, context) {
    classCallCheck(this, FormattedRelative);

    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));

    invariantIntlContext(context);

    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();

    // `now` is stored as state so that `render()` remains a function of
    // props + state, instead of accessing `Date.now()` inside `render()`.
    _this.state = { now: now };
    return _this;
  }

  createClass(FormattedRelative, [{
    key: 'scheduleNextUpdate',
    value: function scheduleNextUpdate(props, state) {
      var _this2 = this;

      // Cancel and pending update because we're scheduling a new update.
      clearTimeout(this._timer);

      var value = props.value,
          units = props.units,
          updateInterval = props.updateInterval;

      var time = new Date(value).getTime();

      // If the `updateInterval` is falsy, including `0` or we don't have a
      // valid date, then auto updates have been turned off, so we bail and
      // skip scheduling an update.
      if (!updateInterval || !isFinite(time)) {
        return;
      }

      var delta = time - state.now;
      var unitDelay = getUnitDelay(units || selectUnits(delta));
      var unitRemainder = Math.abs(delta % unitDelay);

      // We want the largest possible timer delay which will still display
      // accurate information while reducing unnecessary re-renders. The delay
      // should be until the next "interesting" moment, like a tick from
      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

      this._timer = setTimeout(function () {
        _this2.setState({ now: _this2.context.intl.now() });
      }, delay);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scheduleNextUpdate(this.props, this.state);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref) {
      var nextValue = _ref.value;

      // When the `props.value` date changes, `state.now` needs to be updated,
      // and the next update can be rescheduled.
      if (!isSameDate(nextValue, this.props.value)) {
        this.setState({ now: this.context.intl.now() });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      this.scheduleNextUpdate(nextProps, nextState);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._timer);
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatRelative = _context$intl.formatRelative,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));

      if (typeof children === 'function') {
        return children(formattedRelative);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedRelative
      );
    }
  }]);
  return FormattedRelative;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedRelative.displayName = 'FormattedRelative';
FormattedRelative.contextTypes = {
  intl: intlShape
};
FormattedRelative.defaultProps = {
  updateInterval: 1000 * 10
};
 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  updateInterval: PropTypes.number,
  initialNow: PropTypes.any,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedNumber = function (_Component) {
  inherits(FormattedNumber, _Component);

  function FormattedNumber(props, context) {
    classCallCheck(this, FormattedNumber);

    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedNumber, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatNumber = _context$intl.formatNumber,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          children = _props.children;


      var formattedNumber = formatNumber(value, this.props);

      if (typeof children === 'function') {
        return children(formattedNumber);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedNumber
      );
    }
  }]);
  return FormattedNumber;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedNumber.displayName = 'FormattedNumber';
FormattedNumber.contextTypes = {
  intl: intlShape
};
 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
  value: PropTypes.any.isRequired,
  format: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedPlural = function (_Component) {
  inherits(FormattedPlural, _Component);

  function FormattedPlural(props, context) {
    classCallCheck(this, FormattedPlural);

    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedPlural, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
        next[_key] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatPlural = _context$intl.formatPlural,
          Text = _context$intl.textComponent;
      var _props = this.props,
          value = _props.value,
          other = _props.other,
          children = _props.children;


      var pluralCategory = formatPlural(value, this.props);
      var formattedPlural = this.props[pluralCategory] || other;

      if (typeof children === 'function') {
        return children(formattedPlural);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        Text,
        null,
        formattedPlural
      );
    }
  }]);
  return FormattedPlural;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedPlural.displayName = 'FormattedPlural';
FormattedPlural.contextTypes = {
  intl: intlShape
};
FormattedPlural.defaultProps = {
  style: 'cardinal'
};
 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
  value: PropTypes.any.isRequired,

  other: PropTypes.node.isRequired,
  zero: PropTypes.node,
  one: PropTypes.node,
  two: PropTypes.node,
  few: PropTypes.node,
  many: PropTypes.node,

  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
  if (false) {
    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
  }
  return formatMessage({}, { getMessageFormat: Object(__WEBPACK_IMPORTED_MODULE_7_intl_format_cache__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a) }, descriptor, values);
};

var FormattedMessage = function (_Component) {
  inherits(FormattedMessage, _Component);

  function FormattedMessage(props, context) {
    classCallCheck(this, FormattedMessage);

    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));

    if (!props.defaultMessage) {
      invariantIntlContext(context);
    }
    return _this;
  }

  createClass(FormattedMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref = this.context.intl || {},
          _ref$formatMessage = _ref.formatMessage,
          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
          _ref$textComponent = _ref.textComponent,
          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;

      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          values = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var tokenDelimiter = void 0;
      var tokenizedValues = void 0;
      var elements = void 0;

      var hasValues = values && Object.keys(values).length > 0;
      if (hasValues) {
        // Creates a token with a random UID that should not be guessable or
        // conflict with other parts of the `message` string.
        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);

        var generateToken = function () {
          var counter = 0;
          return function () {
            return 'ELEMENT-' + uid + '-' + (counter += 1);
          };
        }();

        // Splitting with a delimiter to support IE8. When using a regex
        // with a capture group IE8 does not include the capture group in
        // the resulting array.
        tokenDelimiter = '@__' + uid + '__@';
        tokenizedValues = {};
        elements = {};

        // Iterates over the `props` to keep track of any React Element
        // values so they can be represented by the `token` as a placeholder
        // when the `message` is formatted. This allows the formatted
        // message to then be broken-up into parts with references to the
        // React Elements inserted back in.
        Object.keys(values).forEach(function (name) {
          var value = values[name];

          if (Object(__WEBPACK_IMPORTED_MODULE_4_react__["isValidElement"])(value)) {
            var token = generateToken();
            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
            elements[token] = value;
          } else {
            tokenizedValues[name] = value;
          }
        });
      }

      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);

      var nodes = void 0;

      var hasElements = elements && Object.keys(elements).length > 0;
      if (hasElements) {
        // Split the message into parts so the React Element values captured
        // above can be inserted back into the rendered message. This
        // approach allows messages to render with React Elements while
        // keeping React's virtual diffing working properly.
        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
          return !!part;
        }).map(function (part) {
          return elements[part] || part;
        });
      } else {
        nodes = [formattedMessage];
      }

      if (typeof children === 'function') {
        return children.apply(undefined, toConsumableArray(nodes));
      }

      // Needs to use `createElement()` instead of JSX, otherwise React will
      // warn about a missing `key` prop with rich-text message formatting.
      return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"].apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
    }
  }]);
  return FormattedMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedMessage.displayName = 'FormattedMessage';
FormattedMessage.contextTypes = {
  intl: intlShape
};
FormattedMessage.defaultProps = {
  values: {}
};
 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

var FormattedHTMLMessage = function (_Component) {
  inherits(FormattedHTMLMessage, _Component);

  function FormattedHTMLMessage(props, context) {
    classCallCheck(this, FormattedHTMLMessage);

    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));

    invariantIntlContext(context);
    return _this;
  }

  createClass(FormattedHTMLMessage, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var values = this.props.values;
      var nextValues = nextProps.values;


      if (!shallowEquals(nextValues, values)) {
        return true;
      }

      // Since `values` has already been checked, we know they're not
      // different, so the current `values` are carried over so the shallow
      // equals comparison on the other props isn't affected by the `values`.
      var nextPropsToCheck = _extends({}, nextProps, {
        values: values
      });

      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        next[_key - 1] = arguments[_key];
      }

      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
    }
  }, {
    key: 'render',
    value: function render() {
      var _context$intl = this.context.intl,
          formatHTMLMessage = _context$intl.formatHTMLMessage,
          Text = _context$intl.textComponent;
      var _props = this.props,
          id = _props.id,
          description = _props.description,
          defaultMessage = _props.defaultMessage,
          rawValues = _props.values,
          _props$tagName = _props.tagName,
          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
          children = _props.children;


      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);

      if (typeof children === 'function') {
        return children(formattedHTMLMessage);
      }

      // Since the message presumably has HTML in it, we need to set
      // `innerHTML` in order for it to be rendered and not escaped by React.
      // To be safe, all string prop values were escaped when formatting the
      // message. It is assumed that the message is not UGC, and came from the
      // developer making it more like a template.
      //
      // Note: There's a perf impact of using this component since there's no
      // way for React to do its virtual DOM diffing.
      var html = { __html: formattedHTMLMessage };
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component$$1, { dangerouslySetInnerHTML: html });
    }
  }]);
  return FormattedHTMLMessage;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
FormattedHTMLMessage.contextTypes = {
  intl: intlShape
};
FormattedHTMLMessage.defaultProps = {
  values: {}
};
 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
  values: PropTypes.object,
  tagName: PropTypes.string,
  children: PropTypes.func
}) : void 0;

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(defaultLocaleData);

/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */

addLocaleData(__WEBPACK_IMPORTED_MODULE_0__locale_data_index_js___default.a);




/***/ }),
/* 487 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */


var src$core$$ = __webpack_require__(489), src$en$$ = __webpack_require__(494);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(263), src$es5$$ = __webpack_require__(490), src$compiler$$ = __webpack_require__(491), intl$messageformat$parser$$ = __webpack_require__(492);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ?
            MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
      try {
        return messageFormat._format(pattern, values);
      } catch (e) {
        if (e.variableId) {
          throw new Error(
            'The intl string context variable \'' + e.variableId + '\'' +
            ' was not provided to the string \'' + message + '\''
          );
        } else {
          throw e;
        }
      }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day  : 'numeric',
                year : '2-digit'
            },

            'medium': {
                month: 'short',
                day  : 'numeric',
                year : 'numeric'
            },

            'long': {
                month: 'long',
                day  : 'numeric',
                year : 'numeric'
            },

            'full': {
                weekday: 'long',
                month  : 'long',
                day    : 'numeric',
                year   : 'numeric'
            }
        },

        time: {
            'short': {
                hour  : 'numeric',
                minute: 'numeric'
            },

            'medium':  {
                hour  : 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour        : 'numeric',
                minute      : 'numeric',
                second      : 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
    if (!(data && data.locale)) {
        throw new Error(
            'Locale data provided to IntlMessageFormat is missing a ' +
            '`locale` property'
        );
    }

    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
}});

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable  : true,
    value     : undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data       = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error(
        'Locale data added to IntlMessageFormat is missing a ' +
        '`pluralRuleFunction` for :' + locale
    );
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i, len, part, id, value, err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
          err = new Error('A value must be provided for: ' + id);
          err.variableId = id;
          throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type, mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) { continue; }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error(
        'No locale data has been added to IntlMessageFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale
    );
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


var src$utils$$ = __webpack_require__(263);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = (function () {
    try { return !!Object.defineProperty({}, 'a', {}); }
    catch (e) { return false; }
})();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty :
        function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */


exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales  = locales;
    this.formats  = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack        = [];
    this.currentPlural      = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern  = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(
                this.currentPlural.id,
                this.currentPlural.format.offset,
                this.pluralNumberFormat,
                element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats  = this.formats,
        locales  = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id    : element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id    : element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(
                element.id, format.ordinal, format.offset, options, pluralFn
            );

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format      = element.format,
        options     = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id         = id;
    this.useOrdinal = useOrdinal;
    this.offset     = offset;
    this.options    = options;
    this.pluralFn   = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] ||
            options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id           = id;
    this.offset       = offset;
    this.numberFormat = numberFormat;
    this.string       = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string
            .replace(/(^|[^\\])#/g, '$1' + number)
            .replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id      = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(493)['default'];
exports['default'] = exports;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = (function() {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() { this.constructor = child; }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message  = message;
    this.expected = expected;
    this.found    = found;
    this.location = location;
    this.name     = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser  = this,

        peg$FAILED = {},

        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction  = peg$parsestart,

        peg$c0 = function(elements) {
                return {
                    type    : 'messageFormatPattern',
                    elements: elements,
                    location: location()
                };
            },
        peg$c1 = function(text) {
                var string = '',
                    i, j, outerLen, inner, innerLen;

                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
                    inner = text[i];

                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
                        string += inner[j];
                    }
                }

                return string;
            },
        peg$c2 = function(messageText) {
                return {
                    type : 'messageTextElement',
                    value: messageText,
                    location: location()
                };
            },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function(id, format) {
                return {
                    type  : 'argumentElement',
                    id    : id,
                    format: format && format[2],
                    location: location()
                };
            },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function(type, style) {
                return {
                    type : type + 'Format',
                    style: style && style[2],
                    location: location()
                };
            },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: false,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                };
            },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function(pluralStyle) {
                return {
                    type   : pluralStyle.type,
                    ordinal: true,
                    offset : pluralStyle.offset || 0,
                    options: pluralStyle.options,
                    location: location()
                }
            },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function(options) {
                return {
                    type   : 'selectFormat',
                    options: options,
                    location: location()
                };
            },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function(selector, pattern) {
                return {
                    type    : 'optionalFormatPattern',
                    selector: selector,
                    value   : pattern,
                    location: location()
                };
            },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function(number) {
                return number;
            },
        peg$c34 = function(offset, options) {
                return {
                    type   : 'pluralFormat',
                    offset : offset,
                    options: options,
                    location: location()
                };
            },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function(digits) {
            return parseInt(digits, 10);
        },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function() { return '\\'; },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function() { return '\\#'; },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function() { return '\u007B'; },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function() { return '\u007D'; },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function(digits) {
                return String.fromCharCode(parseInt(digits, 16));
            },
        peg$c65 = function(chars) { return chars.join(''); },

        peg$currPos          = 0,
        peg$savedPos         = 0,
        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos       = 0,
        peg$maxFailExpected  = [],
        peg$silentFails      = 0,

        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(
        null,
        [{ type: "other", description: description }],
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function error(message) {
      throw peg$buildException(
        message,
        null,
        input.substring(peg$savedPos, peg$currPos),
        peg$computeLocation(peg$savedPos, peg$currPos)
      );
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p, ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line:   details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) { details.line++; }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails   = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line:   startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line:   endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) { return; }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function(a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }

          return s
            .replace(/\\/g,   '\\\\')
            .replace(/"/g,    '\\"')
            .replace(/\x08/g, '\\b')
            .replace(/\t/g,   '\\t')
            .replace(/\n/g,   '\\n')
            .replace(/\f/g,   '\\f')
            .replace(/\r/g,   '\\r')
            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc, foundDesc, i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1
          ? expectedDescs.slice(0, -1).join(", ")
              + " or "
              + expectedDescs[expected.length - 1]
          : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(
        message !== null ? message : buildMessage(expected, found),
        expected,
        found,
        location
      );
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c4); }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c4); }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c6); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c8); }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c13); }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c15); }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c17); }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c20); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c26); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c8); }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c29); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c6); }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c37); }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c37); }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c35); }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c38); }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c42); }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c46); }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c49); }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c51); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c54); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c57); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c60); }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(
        null,
        peg$maxFailExpected,
        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
        peg$maxFailPos < input.length
          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
      );
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse:       peg$parse
  };
})();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE

exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};

//# sourceMappingURL=en.js.map

/***/ }),
/* 495 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(497)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(502);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* jslint esnext: true */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(498);
var en_1 = __webpack_require__(501);
core_1.default.__addLocaleData(en_1.default);
core_1.default.defaultLocale = 'en';
exports.default = core_1.default;
//# sourceMappingURL=main.js.map

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var intl_messageformat_1 = __webpack_require__(262);
var diff_1 = __webpack_require__(499);
var es5_1 = __webpack_require__(500);
exports.default = RelativeFormat;
// -----------------------------------------------------------------------------
var FIELDS = [
    'second', 'second-short',
    'minute', 'minute-short',
    'hour', 'hour-short',
    'day', 'day-short',
    'month', 'month-short',
    'year', 'year-short'
];
var STYLES = ['best fit', 'numeric'];
// -- RelativeFormat -----------------------------------------------------------
function RelativeFormat(locales, options) {
    options = options || {};
    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (es5_1.isArray(locales)) {
        locales = locales.concat();
    }
    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    es5_1.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });
    es5_1.defineProperty(this, '_locales', { value: locales });
    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}
// Define internal private properties for dealing with locale data.
es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
        for (var i = 0; i < arguments.length; i++) {
            var datum = arguments[i];
            if (!(datum && datum.locale)) {
                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
                    '`locale` property value');
            }
            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
            // Add data to IntlMessageFormat.
            intl_messageformat_1.default.__addLocaleData(datum);
        }
    } });
// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});
// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
es5_1.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,
    value: {
        second: 45, 'second-short': 45,
        minute: 45, 'minute-short': 45,
        hour: 22, 'hour-short': 22,
        day: 26, 'day-short': 26,
        month: 11, 'month-short': 11 // months to year
    }
});
RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};
RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;
    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;
    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' +
                relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }
    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' +
                relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }
    var message = '{when, select, future {{0, plural, ' + future + '}}' +
        'past {{0, plural, ' + past + '}}}';
    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl_messageformat_1.default(message, locales);
};
RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;
    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }
    return messages[units];
};
RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];
    if (field.relative) {
        return field.relative[diff];
    }
};
RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];
    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }
        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }
    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
        locale);
};
RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
    if (date === undefined) {
        date = now;
    }
    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
            'in valid range.');
    }
    var diffReport = diff_1.default(now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];
    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }
    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};
RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }
    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
                'value, did you mean: ' + suggestion);
        }
    }
    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
        'must be one of: "' + FIELDS.join('", "') + '"');
};
RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }
    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);
    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;
    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');
        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }
            localeParts.pop();
        }
    }
    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
        locales.join(', ') + ', or the default locale: ' + defaultLocale);
};
RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }
    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }
    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
        'must be one of: "' + STYLES.join('", "') + '"');
};
RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });
    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];
        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }
    return units;
};
//# sourceMappingURL=core.js.map

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
var round = Math.round;
function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}
// Thanks to date-fns
// https://github.com/date-fns/date-fns
// MIT © Sasha Koss
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_DAY = 86400000;
function startOfDay(dirtyDate) {
    var date = new Date(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() -
        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    var timestampRight = startOfDayRight.getTime() -
        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
function default_1(from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;
    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
    // We expect a more precision in rounding when dealing with
    // days as it feels wrong when something happended 13 hours ago and
    // is regarded as "yesterday" even if the time was this morning.
    var day = differenceInCalendarDays(to, from);
    var week = round(day / 7);
    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
}
exports.default = default_1;
//# sourceMappingURL=diff.js.map

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/* jslint esnext: true */
// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License
var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;
var realDefineProp = (function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    }
    catch (e) {
        return false;
    }
})();
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
var defineProperty = realDefineProp ? Object.defineProperty :
    function (obj, name, desc) {
        if ('get' in desc && obj.__defineGetter__) {
            obj.__defineGetter__(name, desc.get);
        }
        else if (!hop.call(obj, name) || 'value' in desc) {
            obj[name] = desc.value;
        }
    };
exports.defineProperty = defineProperty;
var objCreate = Object.create || function (proto, props) {
    var obj, k;
    function F() { }
    F.prototype = proto;
    obj = new F();
    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }
    return obj;
};
exports.objCreate = objCreate;
var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }
    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }
    return -1;
};
exports.arrIndexOf = arrIndexOf;
var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};
exports.isArray = isArray;
var dateNow = Date.now || function () {
    return new Date().getTime();
};
exports.dateNow = dateNow;
//# sourceMappingURL=es5.js.map

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* @generated */
exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
        if (ord)
            return (n10 == 1 && n100 != 11) ? 'one'
                : (n10 == 2 && n100 != 12) ? 'two'
                    : (n10 == 3 && n100 != 13) ? 'few'
                        : 'other';
        return (n == 1 && v0) ? 'one' : 'other';
    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
//# sourceMappingURL=en.js.map

/***/ }),
/* 502 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/
var RelativeTimeFormat;
// -- Utilities ----------------------------------------------------------------
function getCacheId(inputs) {
    return JSON.stringify(inputs.map(function (input) {
        return input && typeof input === 'object' ? orderedProps(input) : input;
    }));
}
function orderedProps(obj) {
    return Object.keys(obj)
        .sort()
        .map(function (k) {
        var _a;
        return (_a = {}, _a[k] = obj[k], _a);
    });
}
var memoizeFormatConstructor = function (FormatConstructor, cache) {
    if (cache === void 0) { cache = {}; }
    return function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];
        if (!format) {
            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
            if (cacheId) {
                cache[cacheId] = format;
            }
        }
        return format;
    };
};
/* harmony default export */ __webpack_exports__["a"] = (memoizeFormatConstructor);
//# sourceMappingURL=index.js.map

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-more', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'more');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,13 L3,11 L5,11 L5,13 L3,13 Z M11,12.9995001 L11,11 L12.9995001,11 L12.9995001,12.9995001 L11,12.9995001 Z M19,12.9995001 L19,11 L20.9995001,11 L20.9995001,12.9995001 L19,12.9995001 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'More';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Expose `IntlPolyfill` as global to add locale data into runtime later on.
global.IntlPolyfill = __webpack_require__(506);

// Require all locale data for `Intl`. This module will be
// ignored when bundling for the browser with Browserify/Webpack.
__webpack_require__(507);

// hack to export the polyfill as global Intl if needed
if (!global.Intl) {
    global.Intl = global.IntlPolyfill;
    global.IntlPolyfill.__applyLocaleSensitivePrototypes();
}

// providing an idiomatic api for the nodejs version of this module
module.exports = global.IntlPolyfill;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
};

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            return step("next", value);
          }, function (err) {
            return step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineEnumerableProperties = function (obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  return obj;
};

var defaults = function (obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = Object.getOwnPropertyDescriptor(defaults, key);

    if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }

  return obj;
};

var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var _instanceof = function (left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
};

var interopRequireDefault = function (obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
};

var interopRequireWildcard = function (obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
};

var newArrowCheck = function (innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
};

var objectDestructuringEmpty = function (obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var selfGlobal = typeof global === "undefined" ? self : global;

var set = function set(object, property, value, receiver) {
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent !== null) {
      set(parent, property, value, receiver);
    }
  } else if ("value" in desc && desc.writable) {
    desc.value = value;
  } else {
    var setter = desc.set;

    if (setter !== undefined) {
      setter.call(receiver, value);
    }
  }

  return value;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var slicedToArrayLoose = function (arr, i) {
  if (Array.isArray(arr)) {
    return arr;
  } else if (Symbol.iterator in Object(arr)) {
    var _arr = [];

    for (var _iterator = arr[Symbol.iterator](), _step; !(_step = _iterator.next()).done;) {
      _arr.push(_step.value);

      if (i && _arr.length === i) break;
    }

    return _arr;
  } else {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
};

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

var temporalRef = function (val, name, undef) {
  if (val === undef) {
    throw new ReferenceError(name + " is not defined - temporal dead zone");
  } else {
    return val;
  }
};

var temporalUndefined = {};

var toArray = function (arr) {
  return Array.isArray(arr) ? arr : Array.from(arr);
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};



var babelHelpers$1 = Object.freeze({
  jsx: jsx,
  asyncToGenerator: asyncToGenerator,
  classCallCheck: classCallCheck,
  createClass: createClass,
  defineEnumerableProperties: defineEnumerableProperties,
  defaults: defaults,
  defineProperty: defineProperty$1,
  get: get,
  inherits: inherits,
  interopRequireDefault: interopRequireDefault,
  interopRequireWildcard: interopRequireWildcard,
  newArrowCheck: newArrowCheck,
  objectDestructuringEmpty: objectDestructuringEmpty,
  objectWithoutProperties: objectWithoutProperties,
  possibleConstructorReturn: possibleConstructorReturn,
  selfGlobal: selfGlobal,
  set: set,
  slicedToArray: slicedToArray,
  slicedToArrayLoose: slicedToArrayLoose,
  taggedTemplateLiteral: taggedTemplateLiteral,
  taggedTemplateLiteralLoose: taggedTemplateLiteralLoose,
  temporalRef: temporalRef,
  temporalUndefined: temporalUndefined,
  toArray: toArray,
  toConsumableArray: toConsumableArray,
  typeof: _typeof,
  extends: _extends,
  instanceof: _instanceof
});

var realDefineProp = function () {
    var sentinel = function sentinel() {};
    try {
        Object.defineProperty(sentinel, 'a', {
            get: function get() {
                return 1;
            }
        });
        Object.defineProperty(sentinel, 'prototype', { writable: false });
        return sentinel.a === 1 && sentinel.prototype instanceof Object;
    } catch (e) {
        return false;
    }
}();

// Need a workaround for getters in ES3
var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

// We use this a lot (and need it for proto-less objects)
var hop = Object.prototype.hasOwnProperty;

// Naive defineProperty for compatibility
var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
    if ('get' in desc && obj.__defineGetter__) obj.__defineGetter__(name, desc.get);else if (!hop.call(obj, name) || 'value' in desc) obj[name] = desc.value;
};

// Array.prototype.indexOf, as good as we need it to be
var arrIndexOf = Array.prototype.indexOf || function (search) {
    /*jshint validthis:true */
    var t = this;
    if (!t.length) return -1;

    for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
        if (t[i] === search) return i;
    }

    return -1;
};

// Create an object with the specified prototype (2nd arg required for Record)
var objCreate = Object.create || function (proto, props) {
    var obj = void 0;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (var k in props) {
        if (hop.call(props, k)) defineProperty(obj, k, props[k]);
    }

    return obj;
};

// Snapshot some (hopefully still) native built-ins
var arrSlice = Array.prototype.slice;
var arrConcat = Array.prototype.concat;
var arrPush = Array.prototype.push;
var arrJoin = Array.prototype.join;
var arrShift = Array.prototype.shift;

// Naive Function.prototype.bind for compatibility
var fnBind = Function.prototype.bind || function (thisObj) {
    var fn = this,
        args = arrSlice.call(arguments, 1);

    // All our (presently) bound functions have either 1 or 0 arguments. By returning
    // different function signatures, we can pass some tests in ES3 environments
    if (fn.length === 1) {
        return function () {
            return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
        };
    }
    return function () {
        return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
    };
};

// Object housing internal properties for constructors
var internals = objCreate(null);

// Keep internal properties internal
var secret = Math.random();

// Helper functions
// ================

/**
 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
 * causing issue #62.
 */
function log10Floor(n) {
    // ES6 provides the more accurate Math.log10
    if (typeof Math.log10 === 'function') return Math.floor(Math.log10(n));

    var x = Math.round(Math.log(n) * Math.LOG10E);
    return x - (Number('1e' + x) > n);
}

/**
 * A map that doesn't contain Object in its prototype chain
 */
function Record(obj) {
    // Copy only own properties over unless this object is already a Record instance
    for (var k in obj) {
        if (obj instanceof Record || hop.call(obj, k)) defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
    }
}
Record.prototype = objCreate(null);

/**
 * An ordered list
 */
function List() {
    defineProperty(this, 'length', { writable: true, value: 0 });

    if (arguments.length) arrPush.apply(this, arrSlice.call(arguments));
}
List.prototype = objCreate(null);

/**
 * Constructs a regular expression to restore tainted RegExp properties
 */
function createRegExpRestore() {
    if (internals.disableRegExpRestore) {
        return function () {/* no-op */};
    }

    var regExpCache = {
        lastMatch: RegExp.lastMatch || '',
        leftContext: RegExp.leftContext,
        multiline: RegExp.multiline,
        input: RegExp.input
    },
        has = false;

    // Create a snapshot of all the 'captured' properties
    for (var i = 1; i <= 9; i++) {
        has = (regExpCache['$' + i] = RegExp['$' + i]) || has;
    }return function () {
        // Now we've snapshotted some properties, escape the lastMatch string
        var esc = /[.?*+^$[\]\\(){}|-]/g,
            lm = regExpCache.lastMatch.replace(esc, '\\$&'),
            reg = new List();

        // If any of the captured strings were non-empty, iterate over them all
        if (has) {
            for (var _i = 1; _i <= 9; _i++) {
                var m = regExpCache['$' + _i];

                // If it's empty, add an empty capturing group
                if (!m) lm = '()' + lm;

                // Else find the string in lm and escape & wrap it to capture it
                else {
                        m = m.replace(esc, '\\$&');
                        lm = lm.replace(m, '(' + m + ')');
                    }

                // Push it to the reg and chop lm to make sure further groups come after
                arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
                lm = lm.slice(lm.indexOf('(') + 1);
            }
        }

        var exprStr = arrJoin.call(reg, '') + lm;

        // Shorten the regex by replacing each part of the expression with a match
        // for a string of that exact length.  This is safe for the type of
        // expressions generated above, because the expression matches the whole
        // match string, so we know each group and each segment between capturing
        // groups can be matched by its length alone.
        exprStr = exprStr.replace(/(\\\(|\\\)|[^()])+/g, function (match) {
            return '[\\s\\S]{' + match.replace('\\', '').length + '}';
        });

        // Create the regular expression that will reconstruct the RegExp properties
        var expr = new RegExp(exprStr, regExpCache.multiline ? 'gm' : 'g');

        // Set the lastIndex of the generated expression to ensure that the match
        // is found in the correct index.
        expr.lastIndex = regExpCache.leftContext.length;

        expr.exec(regExpCache.input);
    };
}

/**
 * Mimics ES5's abstract ToObject() function
 */
function toObject(arg) {
    if (arg === null) throw new TypeError('Cannot convert null or undefined to object');

    if ((typeof arg === 'undefined' ? 'undefined' : babelHelpers$1['typeof'](arg)) === 'object') return arg;
    return Object(arg);
}

function toNumber(arg) {
    if (typeof arg === 'number') return arg;
    return Number(arg);
}

function toInteger(arg) {
    var number = toNumber(arg);
    if (isNaN(number)) return 0;
    if (number === +0 || number === -0 || number === +Infinity || number === -Infinity) return number;
    if (number < 0) return Math.floor(Math.abs(number)) * -1;
    return Math.floor(Math.abs(number));
}

function toLength(arg) {
    var len = toInteger(arg);
    if (len <= 0) return 0;
    if (len === Infinity) return Math.pow(2, 53) - 1;
    return Math.min(len, Math.pow(2, 53) - 1);
}

/**
 * Returns "internal" properties for an object
 */
function getInternalProperties(obj) {
    if (hop.call(obj, '__getInternalProperties')) return obj.__getInternalProperties(secret);

    return objCreate(null);
}

/**
* Defines regular expressions for various operations related to the BCP 47 syntax,
* as defined at http://tools.ietf.org/html/bcp47#section-2.1
*/

// extlang       = 3ALPHA              ; selected ISO 639 codes
//                 *2("-" 3ALPHA)      ; permanently reserved
var extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}';

// language      = 2*3ALPHA            ; shortest ISO 639 code
//                 ["-" extlang]       ; sometimes followed by
//                                     ; extended language subtags
//               / 4ALPHA              ; or reserved for future use
//               / 5*8ALPHA            ; or registered language subtag
var language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})';

// script        = 4ALPHA              ; ISO 15924 code
var script = '[a-z]{4}';

// region        = 2ALPHA              ; ISO 3166-1 code
//               / 3DIGIT              ; UN M.49 code
var region = '(?:[a-z]{2}|\\d{3})';

// variant       = 5*8alphanum         ; registered variants
//               / (DIGIT 3alphanum)
var variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})';

//                                     ; Single alphanumerics
//                                     ; "x" reserved for private use
// singleton     = DIGIT               ; 0 - 9
//               / %x41-57             ; A - W
//               / %x59-5A             ; Y - Z
//               / %x61-77             ; a - w
//               / %x79-7A             ; y - z
var singleton = '[0-9a-wy-z]';

// extension     = singleton 1*("-" (2*8alphanum))
var extension = singleton + '(?:-[a-z0-9]{2,8})+';

// privateuse    = "x" 1*("-" (1*8alphanum))
var privateuse = 'x(?:-[a-z0-9]{1,8})+';

// irregular     = "en-GB-oed"         ; irregular tags do not match
//               / "i-ami"             ; the 'langtag' production and
//               / "i-bnn"             ; would not otherwise be
//               / "i-default"         ; considered 'well-formed'
//               / "i-enochian"        ; These tags are all valid,
//               / "i-hak"             ; but most are deprecated
//               / "i-klingon"         ; in favor of more modern
//               / "i-lux"             ; subtags or subtag
//               / "i-mingo"           ; combination
//               / "i-navajo"
//               / "i-pwn"
//               / "i-tao"
//               / "i-tay"
//               / "i-tsu"
//               / "sgn-BE-FR"
//               / "sgn-BE-NL"
//               / "sgn-CH-DE"
var irregular = '(?:en-GB-oed' + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)' + '|sgn-(?:BE-FR|BE-NL|CH-DE))';

// regular       = "art-lojban"        ; these tags match the 'langtag'
//               / "cel-gaulish"       ; production, but their subtags
//               / "no-bok"            ; are not extended language
//               / "no-nyn"            ; or variant subtags: their meaning
//               / "zh-guoyu"          ; is defined by their registration
//               / "zh-hakka"          ; and all of these are deprecated
//               / "zh-min"            ; in favor of a more modern
//               / "zh-min-nan"        ; subtag or sequence of subtags
//               / "zh-xiang"
var regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn' + '|zh-(?:guoyu|hakka|min|min-nan|xiang))';

// grandfathered = irregular           ; non-redundant tags registered
//               / regular             ; during the RFC 3066 era
var grandfathered = '(?:' + irregular + '|' + regular + ')';

// langtag       = language
//                 ["-" script]
//                 ["-" region]
//                 *("-" variant)
//                 *("-" extension)
//                 ["-" privateuse]
var langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-' + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';

// Language-Tag  = langtag             ; normal language tags
//               / privateuse          ; private use tag
//               / grandfathered       ; grandfathered tags
var expBCP47Syntax = RegExp('^(?:' + langtag + '|' + privateuse + '|' + grandfathered + ')$', 'i');

// Match duplicate variants in a language tag
var expVariantDupes = RegExp('^(?!x).*?-(' + variant + ')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');

// Match duplicate singletons in a language tag (except in private use)
var expSingletonDupes = RegExp('^(?!x).*?-(' + singleton + ')-(?:\\w+-(?!x-))*\\1\\b', 'i');

// Match all extension sequences
var expExtSequences = RegExp('-' + extension, 'ig');

// Default locale is the first-added locale data for us
var defaultLocale = void 0;
function setDefaultLocale(locale) {
    defaultLocale = locale;
}

// IANA Subtag Registry redundant tag and subtag maps
var redundantTags = {
    tags: {
        "art-lojban": "jbo",
        "i-ami": "ami",
        "i-bnn": "bnn",
        "i-hak": "hak",
        "i-klingon": "tlh",
        "i-lux": "lb",
        "i-navajo": "nv",
        "i-pwn": "pwn",
        "i-tao": "tao",
        "i-tay": "tay",
        "i-tsu": "tsu",
        "no-bok": "nb",
        "no-nyn": "nn",
        "sgn-BE-FR": "sfb",
        "sgn-BE-NL": "vgt",
        "sgn-CH-DE": "sgg",
        "zh-guoyu": "cmn",
        "zh-hakka": "hak",
        "zh-min-nan": "nan",
        "zh-xiang": "hsn",
        "sgn-BR": "bzs",
        "sgn-CO": "csn",
        "sgn-DE": "gsg",
        "sgn-DK": "dsl",
        "sgn-ES": "ssp",
        "sgn-FR": "fsl",
        "sgn-GB": "bfi",
        "sgn-GR": "gss",
        "sgn-IE": "isg",
        "sgn-IT": "ise",
        "sgn-JP": "jsl",
        "sgn-MX": "mfs",
        "sgn-NI": "ncs",
        "sgn-NL": "dse",
        "sgn-NO": "nsl",
        "sgn-PT": "psr",
        "sgn-SE": "swl",
        "sgn-US": "ase",
        "sgn-ZA": "sfs",
        "zh-cmn": "cmn",
        "zh-cmn-Hans": "cmn-Hans",
        "zh-cmn-Hant": "cmn-Hant",
        "zh-gan": "gan",
        "zh-wuu": "wuu",
        "zh-yue": "yue"
    },
    subtags: {
        BU: "MM",
        DD: "DE",
        FX: "FR",
        TP: "TL",
        YD: "YE",
        ZR: "CD",
        heploc: "alalc97",
        'in': "id",
        iw: "he",
        ji: "yi",
        jw: "jv",
        mo: "ro",
        ayx: "nun",
        bjd: "drl",
        ccq: "rki",
        cjr: "mom",
        cka: "cmr",
        cmk: "xch",
        drh: "khk",
        drw: "prs",
        gav: "dev",
        hrr: "jal",
        ibi: "opa",
        kgh: "kml",
        lcq: "ppr",
        mst: "mry",
        myt: "mry",
        sca: "hle",
        tie: "ras",
        tkk: "twm",
        tlw: "weo",
        tnf: "prs",
        ybd: "rki",
        yma: "lrr"
    },
    extLang: {
        aao: ["aao", "ar"],
        abh: ["abh", "ar"],
        abv: ["abv", "ar"],
        acm: ["acm", "ar"],
        acq: ["acq", "ar"],
        acw: ["acw", "ar"],
        acx: ["acx", "ar"],
        acy: ["acy", "ar"],
        adf: ["adf", "ar"],
        ads: ["ads", "sgn"],
        aeb: ["aeb", "ar"],
        aec: ["aec", "ar"],
        aed: ["aed", "sgn"],
        aen: ["aen", "sgn"],
        afb: ["afb", "ar"],
        afg: ["afg", "sgn"],
        ajp: ["ajp", "ar"],
        apc: ["apc", "ar"],
        apd: ["apd", "ar"],
        arb: ["arb", "ar"],
        arq: ["arq", "ar"],
        ars: ["ars", "ar"],
        ary: ["ary", "ar"],
        arz: ["arz", "ar"],
        ase: ["ase", "sgn"],
        asf: ["asf", "sgn"],
        asp: ["asp", "sgn"],
        asq: ["asq", "sgn"],
        asw: ["asw", "sgn"],
        auz: ["auz", "ar"],
        avl: ["avl", "ar"],
        ayh: ["ayh", "ar"],
        ayl: ["ayl", "ar"],
        ayn: ["ayn", "ar"],
        ayp: ["ayp", "ar"],
        bbz: ["bbz", "ar"],
        bfi: ["bfi", "sgn"],
        bfk: ["bfk", "sgn"],
        bjn: ["bjn", "ms"],
        bog: ["bog", "sgn"],
        bqn: ["bqn", "sgn"],
        bqy: ["bqy", "sgn"],
        btj: ["btj", "ms"],
        bve: ["bve", "ms"],
        bvl: ["bvl", "sgn"],
        bvu: ["bvu", "ms"],
        bzs: ["bzs", "sgn"],
        cdo: ["cdo", "zh"],
        cds: ["cds", "sgn"],
        cjy: ["cjy", "zh"],
        cmn: ["cmn", "zh"],
        coa: ["coa", "ms"],
        cpx: ["cpx", "zh"],
        csc: ["csc", "sgn"],
        csd: ["csd", "sgn"],
        cse: ["cse", "sgn"],
        csf: ["csf", "sgn"],
        csg: ["csg", "sgn"],
        csl: ["csl", "sgn"],
        csn: ["csn", "sgn"],
        csq: ["csq", "sgn"],
        csr: ["csr", "sgn"],
        czh: ["czh", "zh"],
        czo: ["czo", "zh"],
        doq: ["doq", "sgn"],
        dse: ["dse", "sgn"],
        dsl: ["dsl", "sgn"],
        dup: ["dup", "ms"],
        ecs: ["ecs", "sgn"],
        esl: ["esl", "sgn"],
        esn: ["esn", "sgn"],
        eso: ["eso", "sgn"],
        eth: ["eth", "sgn"],
        fcs: ["fcs", "sgn"],
        fse: ["fse", "sgn"],
        fsl: ["fsl", "sgn"],
        fss: ["fss", "sgn"],
        gan: ["gan", "zh"],
        gds: ["gds", "sgn"],
        gom: ["gom", "kok"],
        gse: ["gse", "sgn"],
        gsg: ["gsg", "sgn"],
        gsm: ["gsm", "sgn"],
        gss: ["gss", "sgn"],
        gus: ["gus", "sgn"],
        hab: ["hab", "sgn"],
        haf: ["haf", "sgn"],
        hak: ["hak", "zh"],
        hds: ["hds", "sgn"],
        hji: ["hji", "ms"],
        hks: ["hks", "sgn"],
        hos: ["hos", "sgn"],
        hps: ["hps", "sgn"],
        hsh: ["hsh", "sgn"],
        hsl: ["hsl", "sgn"],
        hsn: ["hsn", "zh"],
        icl: ["icl", "sgn"],
        ils: ["ils", "sgn"],
        inl: ["inl", "sgn"],
        ins: ["ins", "sgn"],
        ise: ["ise", "sgn"],
        isg: ["isg", "sgn"],
        isr: ["isr", "sgn"],
        jak: ["jak", "ms"],
        jax: ["jax", "ms"],
        jcs: ["jcs", "sgn"],
        jhs: ["jhs", "sgn"],
        jls: ["jls", "sgn"],
        jos: ["jos", "sgn"],
        jsl: ["jsl", "sgn"],
        jus: ["jus", "sgn"],
        kgi: ["kgi", "sgn"],
        knn: ["knn", "kok"],
        kvb: ["kvb", "ms"],
        kvk: ["kvk", "sgn"],
        kvr: ["kvr", "ms"],
        kxd: ["kxd", "ms"],
        lbs: ["lbs", "sgn"],
        lce: ["lce", "ms"],
        lcf: ["lcf", "ms"],
        liw: ["liw", "ms"],
        lls: ["lls", "sgn"],
        lsg: ["lsg", "sgn"],
        lsl: ["lsl", "sgn"],
        lso: ["lso", "sgn"],
        lsp: ["lsp", "sgn"],
        lst: ["lst", "sgn"],
        lsy: ["lsy", "sgn"],
        ltg: ["ltg", "lv"],
        lvs: ["lvs", "lv"],
        lzh: ["lzh", "zh"],
        max: ["max", "ms"],
        mdl: ["mdl", "sgn"],
        meo: ["meo", "ms"],
        mfa: ["mfa", "ms"],
        mfb: ["mfb", "ms"],
        mfs: ["mfs", "sgn"],
        min: ["min", "ms"],
        mnp: ["mnp", "zh"],
        mqg: ["mqg", "ms"],
        mre: ["mre", "sgn"],
        msd: ["msd", "sgn"],
        msi: ["msi", "ms"],
        msr: ["msr", "sgn"],
        mui: ["mui", "ms"],
        mzc: ["mzc", "sgn"],
        mzg: ["mzg", "sgn"],
        mzy: ["mzy", "sgn"],
        nan: ["nan", "zh"],
        nbs: ["nbs", "sgn"],
        ncs: ["ncs", "sgn"],
        nsi: ["nsi", "sgn"],
        nsl: ["nsl", "sgn"],
        nsp: ["nsp", "sgn"],
        nsr: ["nsr", "sgn"],
        nzs: ["nzs", "sgn"],
        okl: ["okl", "sgn"],
        orn: ["orn", "ms"],
        ors: ["ors", "ms"],
        pel: ["pel", "ms"],
        pga: ["pga", "ar"],
        pks: ["pks", "sgn"],
        prl: ["prl", "sgn"],
        prz: ["prz", "sgn"],
        psc: ["psc", "sgn"],
        psd: ["psd", "sgn"],
        pse: ["pse", "ms"],
        psg: ["psg", "sgn"],
        psl: ["psl", "sgn"],
        pso: ["pso", "sgn"],
        psp: ["psp", "sgn"],
        psr: ["psr", "sgn"],
        pys: ["pys", "sgn"],
        rms: ["rms", "sgn"],
        rsi: ["rsi", "sgn"],
        rsl: ["rsl", "sgn"],
        sdl: ["sdl", "sgn"],
        sfb: ["sfb", "sgn"],
        sfs: ["sfs", "sgn"],
        sgg: ["sgg", "sgn"],
        sgx: ["sgx", "sgn"],
        shu: ["shu", "ar"],
        slf: ["slf", "sgn"],
        sls: ["sls", "sgn"],
        sqk: ["sqk", "sgn"],
        sqs: ["sqs", "sgn"],
        ssh: ["ssh", "ar"],
        ssp: ["ssp", "sgn"],
        ssr: ["ssr", "sgn"],
        svk: ["svk", "sgn"],
        swc: ["swc", "sw"],
        swh: ["swh", "sw"],
        swl: ["swl", "sgn"],
        syy: ["syy", "sgn"],
        tmw: ["tmw", "ms"],
        tse: ["tse", "sgn"],
        tsm: ["tsm", "sgn"],
        tsq: ["tsq", "sgn"],
        tss: ["tss", "sgn"],
        tsy: ["tsy", "sgn"],
        tza: ["tza", "sgn"],
        ugn: ["ugn", "sgn"],
        ugy: ["ugy", "sgn"],
        ukl: ["ukl", "sgn"],
        uks: ["uks", "sgn"],
        urk: ["urk", "ms"],
        uzn: ["uzn", "uz"],
        uzs: ["uzs", "uz"],
        vgt: ["vgt", "sgn"],
        vkk: ["vkk", "ms"],
        vkt: ["vkt", "ms"],
        vsi: ["vsi", "sgn"],
        vsl: ["vsl", "sgn"],
        vsv: ["vsv", "sgn"],
        wuu: ["wuu", "zh"],
        xki: ["xki", "sgn"],
        xml: ["xml", "sgn"],
        xmm: ["xmm", "ms"],
        xms: ["xms", "sgn"],
        yds: ["yds", "sgn"],
        ysl: ["ysl", "sgn"],
        yue: ["yue", "zh"],
        zib: ["zib", "sgn"],
        zlm: ["zlm", "ms"],
        zmi: ["zmi", "ms"],
        zsl: ["zsl", "sgn"],
        zsm: ["zsm", "ms"]
    }
};

/**
 * Convert only a-z to uppercase as per section 6.1 of the spec
 */
function toLatinUpperCase(str) {
    var i = str.length;

    while (i--) {
        var ch = str.charAt(i);

        if (ch >= "a" && ch <= "z") str = str.slice(0, i) + ch.toUpperCase() + str.slice(i + 1);
    }

    return str;
}

/**
 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
 * argument (which must be a String value)
 *
 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
 *   2.1, or successor,
 * - does not include duplicate variant subtags, and
 * - does not include duplicate singleton subtags.
 *
 * The abstract operation returns true if locale can be generated from the ABNF
 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
 * contain duplicate variant or singleton subtags (other than as a private use
 * subtag). It returns false otherwise. Terminal value characters in the grammar are
 * interpreted as the Unicode equivalents of the ASCII octet values given.
 */
function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
    // represents a well-formed BCP 47 language tag as specified in RFC 5646
    if (!expBCP47Syntax.test(locale)) return false;

    // does not include duplicate variant subtags, and
    if (expVariantDupes.test(locale)) return false;

    // does not include duplicate singleton subtags.
    if (expSingletonDupes.test(locale)) return false;

    return true;
}

/**
 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
 * regularized form of the locale argument (which must be a String value that is
 * a structurally valid BCP 47 language tag as verified by the
 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
 * into canonical form, and to regularize the case of the subtags, but does not
 * take the steps to bring a language tag into “extlang form” and to reorder
 * variant subtags.

 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
 * may include canonicalization rules for the extension subtag sequences they
 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
 * Implementations are allowed, but not required, to apply these additional rules.
 */
function /* 6.2.3 */CanonicalizeLanguageTag(locale) {
    var match = void 0,
        parts = void 0;

    // A language tag is in 'canonical form' when the tag is well-formed
    // according to the rules in Sections 2.1 and 2.2

    // Section 2.1 says all subtags use lowercase...
    locale = locale.toLowerCase();

    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
    // appear at the start of the tag nor occur after singletons.  Such two-letter
    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
    parts = locale.split('-');
    for (var i = 1, max = parts.length; i < max; i++) {
        // Two-letter subtags are all uppercase
        if (parts[i].length === 2) parts[i] = parts[i].toUpperCase();

        // Four-letter subtags are titlecase
        else if (parts[i].length === 4) parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);

            // Is it a singleton?
            else if (parts[i].length === 1 && parts[i] !== 'x') break;
    }
    locale = arrJoin.call(parts, '-');

    // The steps laid out in RFC 5646 section 4.5 are as follows:

    // 1.  Extension sequences are ordered into case-insensitive ASCII order
    //     by singleton subtag.
    if ((match = locale.match(expExtSequences)) && match.length > 1) {
        // The built-in sort() sorts by ASCII order, so use that
        match.sort();

        // Replace all extensions with the joined, sorted array
        locale = locale.replace(RegExp('(?:' + expExtSequences.source + ')+', 'i'), arrJoin.call(match, ''));
    }

    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
    //     Value', if there is one.
    if (hop.call(redundantTags.tags, locale)) locale = redundantTags.tags[locale];

    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
    //     For extlangs, the original primary language subtag is also
    //     replaced if there is a primary language subtag in the 'Preferred-
    //     Value'.
    parts = locale.split('-');

    for (var _i = 1, _max = parts.length; _i < _max; _i++) {
        if (hop.call(redundantTags.subtags, parts[_i])) parts[_i] = redundantTags.subtags[parts[_i]];else if (hop.call(redundantTags.extLang, parts[_i])) {
            parts[_i] = redundantTags.extLang[parts[_i]][0];

            // For extlang tags, the prefix needs to be removed if it is redundant
            if (_i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
                parts = arrSlice.call(parts, _i++);
                _max -= 1;
            }
        }
    }

    return arrJoin.call(parts, '-');
}

/**
 * The DefaultLocale abstract operation returns a String value representing the
 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
 * host environment’s current locale.
 */
function /* 6.2.4 */DefaultLocale() {
    return defaultLocale;
}

// Sect 6.3 Currency Codes
// =======================

var expCurrencyCode = /^[A-Z]{3}$/;

/**
 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
 * code. The following steps are taken:
 */
function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
    // 1. Let `c` be ToString(currency)
    var c = String(currency);

    // 2. Let `normalized` be the result of mapping c to upper case as described
    //    in 6.1.
    var normalized = toLatinUpperCase(c);

    // 3. If the string length of normalized is not 3, return false.
    // 4. If normalized contains any character that is not in the range "A" to "Z"
    //    (U+0041 to U+005A), return false.
    if (expCurrencyCode.test(normalized) === false) return false;

    // 5. Return true
    return true;
}

var expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi; // See `extension` below

function /* 9.2.1 */CanonicalizeLocaleList(locales) {
    // The abstract operation CanonicalizeLocaleList takes the following steps:

    // 1. If locales is undefined, then a. Return a new empty List
    if (locales === undefined) return new List();

    // 2. Let seen be a new empty List.
    var seen = new List();

    // 3. If locales is a String value, then
    //    a. Let locales be a new array created as if by the expression new
    //    Array(locales) where Array is the standard built-in constructor with
    //    that name and locales is the value of locales.
    locales = typeof locales === 'string' ? [locales] : locales;

    // 4. Let O be ToObject(locales).
    var O = toObject(locales);

    // 5. Let lenValue be the result of calling the [[Get]] internal method of
    //    O with the argument "length".
    // 6. Let len be ToUint32(lenValue).
    var len = toLength(O.length);

    // 7. Let k be 0.
    var k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ToString(k).
        var Pk = String(k);

        // b. Let kPresent be the result of calling the [[HasProperty]] internal
        //    method of O with argument Pk.
        var kPresent = Pk in O;

        // c. If kPresent is true, then
        if (kPresent) {
            // i. Let kValue be the result of calling the [[Get]] internal
            //     method of O with argument Pk.
            var kValue = O[Pk];

            // ii. If the type of kValue is not String or Object, then throw a
            //     TypeError exception.
            if (kValue === null || typeof kValue !== 'string' && (typeof kValue === "undefined" ? "undefined" : babelHelpers$1["typeof"](kValue)) !== 'object') throw new TypeError('String or Object type expected');

            // iii. Let tag be ToString(kValue).
            var tag = String(kValue);

            // iv. If the result of calling the abstract operation
            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
            //     the argument, is false, then throw a RangeError exception.
            if (!IsStructurallyValidLanguageTag(tag)) throw new RangeError("'" + tag + "' is not a structurally valid language tag");

            // v. Let tag be the result of calling the abstract operation
            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
            //    argument.
            tag = CanonicalizeLanguageTag(tag);

            // vi. If tag is not an element of seen, then append tag as the last
            //     element of seen.
            if (arrIndexOf.call(seen, tag) === -1) arrPush.call(seen, tag);
        }

        // d. Increase k by 1.
        k++;
    }

    // 9. Return seen.
    return seen;
}

/**
 * The BestAvailableLocale abstract operation compares the provided argument
 * locale, which must be a String value with a structurally valid and
 * canonicalized BCP 47 language tag, against the locales in availableLocales and
 * returns either the longest non-empty prefix of locale that is an element of
 * availableLocales, or undefined if there is no such element. It uses the
 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
 */
function /* 9.2.2 */BestAvailableLocale(availableLocales, locale) {
    // 1. Let candidate be locale
    var candidate = locale;

    // 2. Repeat
    while (candidate) {
        // a. If availableLocales contains an element equal to candidate, then return
        // candidate.
        if (arrIndexOf.call(availableLocales, candidate) > -1) return candidate;

        // b. Let pos be the character index of the last occurrence of "-"
        // (U+002D) within candidate. If that character does not occur, return
        // undefined.
        var pos = candidate.lastIndexOf('-');

        if (pos < 0) return;

        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
        //    then decrease pos by 2.
        if (pos >= 2 && candidate.charAt(pos - 2) === '-') pos -= 2;

        // d. Let candidate be the substring of candidate from position 0, inclusive,
        //    to position pos, exclusive.
        candidate = candidate.substring(0, pos);
    }
}

/**
 * The LookupMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The following steps are taken:
 */
function /* 9.2.3 */LookupMatcher(availableLocales, requestedLocales) {
    // 1. Let i be 0.
    var i = 0;

    // 2. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;

    // 3. Let availableLocale be undefined.
    var availableLocale = void 0;

    var locale = void 0,
        noExtensionsLocale = void 0;

    // 4. Repeat while i < len and availableLocale is undefined:
    while (i < len && !availableLocale) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position i.
        locale = requestedLocales[i];

        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');

        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. Increase i by 1.
        i++;
    }

    // 5. Let result be a new Record.
    var result = new Record();

    // 6. If availableLocale is not undefined, then
    if (availableLocale !== undefined) {
        // a. Set result.[[locale]] to availableLocale.
        result['[[locale]]'] = availableLocale;

        // b. If locale and noExtensionsLocale are not the same String value, then
        if (String(locale) !== String(noExtensionsLocale)) {
            // i. Let extension be the String value consisting of the first
            //    substring of locale that is a Unicode locale extension sequence.
            var extension = locale.match(expUnicodeExSeq)[0];

            // ii. Let extensionIndex be the character position of the initial
            //     "-" of the first Unicode locale extension sequence within locale.
            var extensionIndex = locale.indexOf('-u-');

            // iii. Set result.[[extension]] to extension.
            result['[[extension]]'] = extension;

            // iv. Set result.[[extensionIndex]] to extensionIndex.
            result['[[extensionIndex]]'] = extensionIndex;
        }
    }
    // 7. Else
    else
        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
        //    operation (defined in 6.2.4).
        result['[[locale]]'] = DefaultLocale();

    // 8. Return result
    return result;
}

/**
 * The BestFitMatcher abstract operation compares requestedLocales, which must be
 * a List as returned by CanonicalizeLocaleList, against the locales in
 * availableLocales and determines the best available language to meet the
 * request. The algorithm is implementation dependent, but should produce results
 * that a typical user of the requested locales would perceive as at least as
 * good as those produced by the LookupMatcher abstract operation. Options
 * specified through Unicode locale extension sequences must be ignored by the
 * algorithm. Information about such subsequences is returned separately.
 * The abstract operation returns a record with a [[locale]] field, whose value
 * is the language tag of the selected locale, which must be an element of
 * availableLocales. If the language tag of the request locale that led to the
 * selected locale contained a Unicode locale extension sequence, then the
 * returned record also contains an [[extension]] field whose value is the first
 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
 * is the index of the first Unicode locale extension sequence within the request
 * locale language tag.
 */
function /* 9.2.4 */BestFitMatcher(availableLocales, requestedLocales) {
    return LookupMatcher(availableLocales, requestedLocales);
}

/**
 * The ResolveLocale abstract operation compares a BCP 47 language priority list
 * requestedLocales against the locales in availableLocales and determines the
 * best available language to meet the request. availableLocales and
 * requestedLocales must be provided as List values, options as a Record.
 */
function /* 9.2.5 */ResolveLocale(availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
    if (availableLocales.length === 0) {
        throw new ReferenceError('No locale data has been provided for this object yet.');
    }

    // The following steps are taken:
    // 1. Let matcher be the value of options.[[localeMatcher]].
    var matcher = options['[[localeMatcher]]'];

    var r = void 0;

    // 2. If matcher is "lookup", then
    if (matcher === 'lookup')
        // a. Let r be the result of calling the LookupMatcher abstract operation
        //    (defined in 9.2.3) with arguments availableLocales and
        //    requestedLocales.
        r = LookupMatcher(availableLocales, requestedLocales);

        // 3. Else
    else
        // a. Let r be the result of calling the BestFitMatcher abstract
        //    operation (defined in 9.2.4) with arguments availableLocales and
        //    requestedLocales.
        r = BestFitMatcher(availableLocales, requestedLocales);

    // 4. Let foundLocale be the value of r.[[locale]].
    var foundLocale = r['[[locale]]'];

    var extensionSubtags = void 0,
        extensionSubtagsLength = void 0;

    // 5. If r has an [[extension]] field, then
    if (hop.call(r, '[[extension]]')) {
        // a. Let extension be the value of r.[[extension]].
        var extension = r['[[extension]]'];
        // b. Let split be the standard built-in function object defined in ES5,
        //    15.5.4.14.
        var split = String.prototype.split;
        // c. Let extensionSubtags be the result of calling the [[Call]] internal
        //    method of split with extension as the this value and an argument
        //    list containing the single item "-".
        extensionSubtags = split.call(extension, '-');
        // d. Let extensionSubtagsLength be the result of calling the [[Get]]
        //    internal method of extensionSubtags with argument "length".
        extensionSubtagsLength = extensionSubtags.length;
    }

    // 6. Let result be a new Record.
    var result = new Record();

    // 7. Set result.[[dataLocale]] to foundLocale.
    result['[[dataLocale]]'] = foundLocale;

    // 8. Let supportedExtension be "-u".
    var supportedExtension = '-u';
    // 9. Let i be 0.
    var i = 0;
    // 10. Let len be the result of calling the [[Get]] internal method of
    //     relevantExtensionKeys with argument "length".
    var len = relevantExtensionKeys.length;

    // 11 Repeat while i < len:
    while (i < len) {
        // a. Let key be the result of calling the [[Get]] internal method of
        //    relevantExtensionKeys with argument ToString(i).
        var key = relevantExtensionKeys[i];
        // b. Let foundLocaleData be the result of calling the [[Get]] internal
        //    method of localeData with the argument foundLocale.
        var foundLocaleData = localeData[foundLocale];
        // c. Let keyLocaleData be the result of calling the [[Get]] internal
        //    method of foundLocaleData with the argument key.
        var keyLocaleData = foundLocaleData[key];
        // d. Let value be the result of calling the [[Get]] internal method of
        //    keyLocaleData with argument "0".
        var value = keyLocaleData['0'];
        // e. Let supportedExtensionAddition be "".
        var supportedExtensionAddition = '';
        // f. Let indexOf be the standard built-in function object defined in
        //    ES5, 15.4.4.14.
        var indexOf = arrIndexOf;

        // g. If extensionSubtags is not undefined, then
        if (extensionSubtags !== undefined) {
            // i. Let keyPos be the result of calling the [[Call]] internal
            //    method of indexOf with extensionSubtags as the this value and
            // an argument list containing the single item key.
            var keyPos = indexOf.call(extensionSubtags, key);

            // ii. If keyPos ≠ -1, then
            if (keyPos !== -1) {
                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
                //    result of calling the [[Get]] internal method of
                //    extensionSubtags with argument ToString(keyPos +1) is greater
                //    than 2, then
                if (keyPos + 1 < extensionSubtagsLength && extensionSubtags[keyPos + 1].length > 2) {
                    // a. Let requestedValue be the result of calling the [[Get]]
                    //    internal method of extensionSubtags with argument
                    //    ToString(keyPos + 1).
                    var requestedValue = extensionSubtags[keyPos + 1];
                    // b. Let valuePos be the result of calling the [[Call]]
                    //    internal method of indexOf with keyLocaleData as the
                    //    this value and an argument list containing the single
                    //    item requestedValue.
                    var valuePos = indexOf.call(keyLocaleData, requestedValue);

                    // c. If valuePos ≠ -1, then
                    if (valuePos !== -1) {
                        // i. Let value be requestedValue.
                        value = requestedValue,
                        // ii. Let supportedExtensionAddition be the
                        //     concatenation of "-", key, "-", and value.
                        supportedExtensionAddition = '-' + key + '-' + value;
                    }
                }
                // 2. Else
                else {
                        // a. Let valuePos be the result of calling the [[Call]]
                        // internal method of indexOf with keyLocaleData as the this
                        // value and an argument list containing the single item
                        // "true".
                        var _valuePos = indexOf(keyLocaleData, 'true');

                        // b. If valuePos ≠ -1, then
                        if (_valuePos !== -1)
                            // i. Let value be "true".
                            value = 'true';
                    }
            }
        }
        // h. If options has a field [[<key>]], then
        if (hop.call(options, '[[' + key + ']]')) {
            // i. Let optionsValue be the value of options.[[<key>]].
            var optionsValue = options['[[' + key + ']]'];

            // ii. If the result of calling the [[Call]] internal method of indexOf
            //     with keyLocaleData as the this value and an argument list
            //     containing the single item optionsValue is not -1, then
            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
                // 1. If optionsValue is not equal to value, then
                if (optionsValue !== value) {
                    // a. Let value be optionsValue.
                    value = optionsValue;
                    // b. Let supportedExtensionAddition be "".
                    supportedExtensionAddition = '';
                }
            }
        }
        // i. Set result.[[<key>]] to value.
        result['[[' + key + ']]'] = value;

        // j. Append supportedExtensionAddition to supportedExtension.
        supportedExtension += supportedExtensionAddition;

        // k. Increase i by 1.
        i++;
    }
    // 12. If the length of supportedExtension is greater than 2, then
    if (supportedExtension.length > 2) {
        // a.
        var privateIndex = foundLocale.indexOf("-x-");
        // b.
        if (privateIndex === -1) {
            // i.
            foundLocale = foundLocale + supportedExtension;
        }
        // c.
        else {
                // i.
                var preExtension = foundLocale.substring(0, privateIndex);
                // ii.
                var postExtension = foundLocale.substring(privateIndex);
                // iii.
                foundLocale = preExtension + supportedExtension + postExtension;
            }
        // d. asserting - skipping
        // e.
        foundLocale = CanonicalizeLanguageTag(foundLocale);
    }
    // 13. Set result.[[locale]] to foundLocale.
    result['[[locale]]'] = foundLocale;

    // 14. Return result.
    return result;
}

/**
 * The LookupSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
 * Locales appear in the same order in the returned list as in requestedLocales.
 * The following steps are taken:
 */
function /* 9.2.6 */LookupSupportedLocales(availableLocales, requestedLocales) {
    // 1. Let len be the number of elements in requestedLocales.
    var len = requestedLocales.length;
    // 2. Let subset be a new empty List.
    var subset = new List();
    // 3. Let k be 0.
    var k = 0;

    // 4. Repeat while k < len
    while (k < len) {
        // a. Let locale be the element of requestedLocales at 0-origined list
        //    position k.
        var locale = requestedLocales[k];
        // b. Let noExtensionsLocale be the String value that is locale with all
        //    Unicode locale extension sequences removed.
        var noExtensionsLocale = String(locale).replace(expUnicodeExSeq, '');
        // c. Let availableLocale be the result of calling the
        //    BestAvailableLocale abstract operation (defined in 9.2.2) with
        //    arguments availableLocales and noExtensionsLocale.
        var availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);

        // d. If availableLocale is not undefined, then append locale to the end of
        //    subset.
        if (availableLocale !== undefined) arrPush.call(subset, locale);

        // e. Increment k by 1.
        k++;
    }

    // 5. Let subsetArray be a new Array object whose elements are the same
    //    values in the same order as the elements of subset.
    var subsetArray = arrSlice.call(subset);

    // 6. Return subsetArray.
    return subsetArray;
}

/**
 * The BestFitSupportedLocales abstract operation returns the subset of the
 * provided BCP 47 language priority list requestedLocales for which
 * availableLocales has a matching locale when using the Best Fit Matcher
 * algorithm. Locales appear in the same order in the returned list as in
 * requestedLocales. The steps taken are implementation dependent.
 */
function /*9.2.7 */BestFitSupportedLocales(availableLocales, requestedLocales) {
    // ###TODO: implement this function as described by the specification###
    return LookupSupportedLocales(availableLocales, requestedLocales);
}

/**
 * The SupportedLocales abstract operation returns the subset of the provided BCP
 * 47 language priority list requestedLocales for which availableLocales has a
 * matching locale. Two algorithms are available to match the locales: the Lookup
 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
 * best-fit algorithm. Locales appear in the same order in the returned list as
 * in requestedLocales. The following steps are taken:
 */
function /*9.2.8 */SupportedLocales(availableLocales, requestedLocales, options) {
    var matcher = void 0,
        subset = void 0;

    // 1. If options is not undefined, then
    if (options !== undefined) {
        // a. Let options be ToObject(options).
        options = new Record(toObject(options));
        // b. Let matcher be the result of calling the [[Get]] internal method of
        //    options with argument "localeMatcher".
        matcher = options.localeMatcher;

        // c. If matcher is not undefined, then
        if (matcher !== undefined) {
            // i. Let matcher be ToString(matcher).
            matcher = String(matcher);

            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
            //     exception.
            if (matcher !== 'lookup' && matcher !== 'best fit') throw new RangeError('matcher should be "lookup" or "best fit"');
        }
    }
    // 2. If matcher is undefined or "best fit", then
    if (matcher === undefined || matcher === 'best fit')
        // a. Let subset be the result of calling the BestFitSupportedLocales
        //    abstract operation (defined in 9.2.7) with arguments
        //    availableLocales and requestedLocales.
        subset = BestFitSupportedLocales(availableLocales, requestedLocales);
        // 3. Else
    else
        // a. Let subset be the result of calling the LookupSupportedLocales
        //    abstract operation (defined in 9.2.6) with arguments
        //    availableLocales and requestedLocales.
        subset = LookupSupportedLocales(availableLocales, requestedLocales);

    // 4. For each named own property name P of subset,
    for (var P in subset) {
        if (!hop.call(subset, P)) continue;

        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
        //    method of subset with P.
        // b. Set desc.[[Writable]] to false.
        // c. Set desc.[[Configurable]] to false.
        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
        //    and true as arguments.
        defineProperty(subset, P, {
            writable: false, configurable: false, value: subset[P]
        });
    }
    // "Freeze" the array so no new elements can be added
    defineProperty(subset, 'length', { writable: false });

    // 5. Return subset
    return subset;
}

/**
 * The GetOption abstract operation extracts the value of the property named
 * property from the provided options object, converts it to the required type,
 * checks whether it is one of a List of allowed values, and fills in a fallback
 * value if necessary.
 */
function /*9.2.9 */GetOption(options, property, type, values, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Assert: type is "boolean" or "string".
        // b. If type is "boolean", then let value be ToBoolean(value).
        // c. If type is "string", then let value be ToString(value).
        value = type === 'boolean' ? Boolean(value) : type === 'string' ? String(value) : value;

        // d. If values is not undefined, then
        if (values !== undefined) {
            // i. If values does not contain an element equal to value, then throw a
            //    RangeError exception.
            if (arrIndexOf.call(values, value) === -1) throw new RangeError("'" + value + "' is not an allowed value for `" + property + '`');
        }

        // e. Return value.
        return value;
    }
    // Else return fallback.
    return fallback;
}

/**
 * The GetNumberOption abstract operation extracts a property value from the
 * provided options object, converts it to a Number value, checks whether it is
 * in the allowed range, and fills in a fallback value if necessary.
 */
function /* 9.2.10 */GetNumberOption(options, property, minimum, maximum, fallback) {
    // 1. Let value be the result of calling the [[Get]] internal method of
    //    options with argument property.
    var value = options[property];

    // 2. If value is not undefined, then
    if (value !== undefined) {
        // a. Let value be ToNumber(value).
        value = Number(value);

        // b. If value is NaN or less than minimum or greater than maximum, throw a
        //    RangeError exception.
        if (isNaN(value) || value < minimum || value > maximum) throw new RangeError('Value is not a number or outside accepted range');

        // c. Return floor(value).
        return Math.floor(value);
    }
    // 3. Else return fallback.
    return fallback;
}

// 8 The Intl Object
var Intl = {};

// 8.2 Function Properties of the Intl Object

// 8.2.1
// @spec[tc39/ecma402/master/spec/intl.html]
// @clause[sec-intl.getcanonicallocales]
function getCanonicalLocales(locales) {
    // 1. Let ll be ? CanonicalizeLocaleList(locales).
    var ll = CanonicalizeLocaleList(locales);
    // 2. Return CreateArrayFromList(ll).
    {
        var result = [];

        var len = ll.length;
        var k = 0;

        while (k < len) {
            result[k] = ll[k];
            k++;
        }
        return result;
    }
}

Object.defineProperty(Intl, 'getCanonicalLocales', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: getCanonicalLocales
});

// Currency minor units output from get-4217 grunt task, formatted
var currencyMinorUnits = {
    BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 4, CLP: 0, KMF: 0, DJF: 0,
    XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
    OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
};

// Define the NumberFormat constructor internally so it cannot be tainted
function NumberFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.NumberFormat(locales, options);
    }

    return InitializeNumberFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'NumberFormat', {
    configurable: true,
    writable: true,
    value: NumberFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(Intl.NumberFormat, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeNumberFormat accepts the arguments
 * numberFormat (which must be an object), locales, and options. It initializes
 * numberFormat as a NumberFormat object.
 */
function /*11.1.1.1 */InitializeNumberFormat(numberFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(numberFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
    // value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(numberFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. If options is undefined, then
    if (options === undefined)
        // a. Let options be the result of creating a new object as if by the
        // expression new Object() where Object is the standard built-in constructor
        // with that name.
        options = {};

        // 5. Else
    else
        // a. Let options be ToObject(options).
        options = toObject(options);

    // 6. Let opt be a new Record.
    var opt = new Record(),


    // 7. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
    //    a List containing the two String values "lookup" and "best fit", and
    //    "best fit".
    matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 8. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 9. Let NumberFormat be the standard built-in object that is the initial value
    //    of Intl.NumberFormat.
    // 10. Let localeData be the value of the [[localeData]] internal property of
    //     NumberFormat.
    var localeData = internals.NumberFormat['[[localeData]]'];

    // 11. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //     internal property of NumberFormat, and localeData.
    var r = ResolveLocale(internals.NumberFormat['[[availableLocales]]'], requestedLocales, opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData);

    // 12. Set the [[locale]] internal property of numberFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
    //     of r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let s be the result of calling the GetOption abstract operation with the
    //     arguments options, "style", "string", a List containing the three String
    //     values "decimal", "percent", and "currency", and "decimal".
    var s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');

    // 16. Set the [[style]] internal property of numberFormat to s.
    internal['[[style]]'] = s;

    // 17. Let c be the result of calling the GetOption abstract operation with the
    //     arguments options, "currency", "string", undefined, and undefined.
    var c = GetOption(options, 'currency', 'string');

    // 18. If c is not undefined and the result of calling the
    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
    //     argument c is false, then throw a RangeError exception.
    if (c !== undefined && !IsWellFormedCurrencyCode(c)) throw new RangeError("'" + c + "' is not a valid currency code");

    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
    if (s === 'currency' && c === undefined) throw new TypeError('Currency code is required when style is currency');

    var cDigits = void 0;

    // 20. If s is "currency", then
    if (s === 'currency') {
        // a. Let c be the result of converting c to upper case as specified in 6.1.
        c = c.toUpperCase();

        // b. Set the [[currency]] internal property of numberFormat to c.
        internal['[[currency]]'] = c;

        // c. Let cDigits be the result of calling the CurrencyDigits abstract
        //    operation (defined below) with argument c.
        cDigits = CurrencyDigits(c);
    }

    // 21. Let cd be the result of calling the GetOption abstract operation with the
    //     arguments options, "currencyDisplay", "string", a List containing the
    //     three String values "code", "symbol", and "name", and "symbol".
    var cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');

    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
    //     numberFormat to cd.
    if (s === 'currency') internal['[[currencyDisplay]]'] = cd;

    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
    //     and 1.
    var mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);

    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
    internal['[[minimumIntegerDigits]]'] = mnid;

    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
    //     be 0.
    var mnfdDefault = s === 'currency' ? cDigits : 0;

    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
    var mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);

    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
    internal['[[minimumFractionDigits]]'] = mnfd;

    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
    //     be max(mnfd, 3).
    var mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits) : s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3);

    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
    var mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);

    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
    internal['[[maximumFractionDigits]]'] = mxfd;

    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
    //     with argument "minimumSignificantDigits".
    var mnsd = options.minimumSignificantDigits;

    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
    //     with argument "maximumSignificantDigits".
    var mxsd = options.maximumSignificantDigits;

    // 33. If mnsd is not undefined or mxsd is not undefined, then:
    if (mnsd !== undefined || mxsd !== undefined) {
        // a. Let mnsd be the result of calling the GetNumberOption abstract
        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
        //    and 1.
        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);

        // b. Let mxsd be the result of calling the GetNumberOption abstract
        //     operation with arguments options, "maximumSignificantDigits", mnsd,
        //     21, and 21.
        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);

        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
        //    numberFormat to mxsd.
        internal['[[minimumSignificantDigits]]'] = mnsd;
        internal['[[maximumSignificantDigits]]'] = mxsd;
    }
    // 34. Let g be the result of calling the GetOption abstract operation with the
    //     arguments options, "useGrouping", "boolean", undefined, and true.
    var g = GetOption(options, 'useGrouping', 'boolean', undefined, true);

    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
    internal['[[useGrouping]]'] = g;

    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 37. Let patterns be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "patterns".
    var patterns = dataLocaleData.patterns;

    // 38. Assert: patterns is an object (see 11.2.3)

    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
    //     patterns with argument s.
    var stylePatterns = patterns[s];

    // 40. Set the [[positivePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "positivePattern".
    internal['[[positivePattern]]'] = stylePatterns.positivePattern;

    // 41. Set the [[negativePattern]] internal property of numberFormat to the
    //     result of calling the [[Get]] internal method of stylePatterns with the
    //     argument "negativePattern".
    internal['[[negativePattern]]'] = stylePatterns.negativePattern;

    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
    //     true.
    internal['[[initializedNumberFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) numberFormat.format = GetFormatNumber.call(numberFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return numberFormat;
}

function CurrencyDigits(currency) {
    // When the CurrencyDigits abstract operation is called with an argument currency
    // (which must be an upper case String value), the following steps are taken:

    // 1. If the ISO 4217 currency and funds code list contains currency as an
    // alphabetic code, then return the minor unit value corresponding to the
    // currency from the list; else return 2.
    return currencyMinorUnits[currency] !== undefined ? currencyMinorUnits[currency] : 2;
}

/* 11.2.3 */internals.NumberFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
 * following steps are taken:
 */
/* 11.2.2 */
defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * NumberFormat object.
 */
/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatNumber
});

function GetFormatNumber() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 11.3_b
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this NumberFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 1, that takes the argument value and
        //    performs the following steps:
        var F = function F(value) {
            // i. If value is not provided, then let value be undefined.
            // ii. Let x be ToNumber(value).
            // iii. Return the result of calling the FormatNumber abstract
            //      operation (defined below) with arguments this and x.
            return FormatNumber(this, /* x = */Number(value));
        };

        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);

        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);
    if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.NumberFormat object.');

    var x = Number(value);
    return FormatNumberToParts(this, x);
}

Object.defineProperty(Intl.NumberFormat.prototype, 'formatToParts', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: formatToParts
});

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumbertoparts]
 */
function FormatNumberToParts(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be ArrayCreate(0).
    var result = [];
    // 3. Let n be 0.
    var n = 0;
    // 4. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Let O be ObjectCreate(%ObjectPrototype%).
        var O = {};
        // a. Perform ? CreateDataPropertyOrThrow(O, "type", part.[[type]]).
        O.type = part['[[type]]'];
        // a. Perform ? CreateDataPropertyOrThrow(O, "value", part.[[value]]).
        O.value = part['[[value]]'];
        // a. Perform ? CreateDataPropertyOrThrow(result, ? ToString(n), O).
        result[n] = O;
        // a. Increment n by 1.
        n += 1;
    }
    // 5. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-partitionnumberpattern]
 */
function PartitionNumberPattern(numberFormat, x) {

    var internal = getInternalProperties(numberFormat),
        locale = internal['[[dataLocale]]'],
        nums = internal['[[numberingSystem]]'],
        data = internals.NumberFormat['[[localeData]]'][locale],
        ild = data.symbols[nums] || data.symbols.latn,
        pattern = void 0;

    // 1. If x is not NaN and x < 0, then:
    if (!isNaN(x) && x < 0) {
        // a. Let x be -x.
        x = -x;
        // a. Let pattern be the value of numberFormat.[[negativePattern]].
        pattern = internal['[[negativePattern]]'];
    }
    // 2. Else,
    else {
            // a. Let pattern be the value of numberFormat.[[positivePattern]].
            pattern = internal['[[positivePattern]]'];
        }
    // 3. Let result be a new empty List.
    var result = new List();
    // 4. Let beginIndex be Call(%StringProto_indexOf%, pattern, "{", 0).
    var beginIndex = pattern.indexOf('{', 0);
    // 5. Let endIndex be 0.
    var endIndex = 0;
    // 6. Let nextIndex be 0.
    var nextIndex = 0;
    // 7. Let length be the number of code units in pattern.
    var length = pattern.length;
    // 8. Repeat while beginIndex is an integer index into pattern:
    while (beginIndex > -1 && beginIndex < length) {
        // a. Set endIndex to Call(%StringProto_indexOf%, pattern, "}", beginIndex)
        endIndex = pattern.indexOf('}', beginIndex);
        // a. If endIndex = -1, throw new Error exception.
        if (endIndex === -1) throw new Error();
        // a. If beginIndex is greater than nextIndex, then:
        if (beginIndex > nextIndex) {
            // i. Let literal be a substring of pattern from position nextIndex, inclusive, to position beginIndex, exclusive.
            var literal = pattern.substring(nextIndex, beginIndex);
            // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
            arrPush.call(result, { '[[type]]': 'literal', '[[value]]': literal });
        }
        // a. Let p be the substring of pattern from position beginIndex, exclusive, to position endIndex, exclusive.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // a. If p is equal "number", then:
        if (p === "number") {
            // i. If x is NaN,
            if (isNaN(x)) {
                // 1. Let n be an ILD String value indicating the NaN value.
                var n = ild.nan;
                // 2. Add new part record { [[type]]: "nan", [[value]]: n } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'nan', '[[value]]': n });
            }
            // ii. Else if isFinite(x) is false,
            else if (!isFinite(x)) {
                    // 1. Let n be an ILD String value indicating infinity.
                    var _n = ild.infinity;
                    // 2. Add new part record { [[type]]: "infinity", [[value]]: n } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'infinity', '[[value]]': _n });
                }
                // iii. Else,
                else {
                        // 1. If the value of numberFormat.[[style]] is "percent" and isFinite(x), let x be 100 × x.
                        if (internal['[[style]]'] === 'percent' && isFinite(x)) x *= 100;

                        var _n2 = void 0;
                        // 2. If the numberFormat.[[minimumSignificantDigits]] and numberFormat.[[maximumSignificantDigits]] are present, then
                        if (hop.call(internal, '[[minimumSignificantDigits]]') && hop.call(internal, '[[maximumSignificantDigits]]')) {
                            // a. Let n be ToRawPrecision(x, numberFormat.[[minimumSignificantDigits]], numberFormat.[[maximumSignificantDigits]]).
                            _n2 = ToRawPrecision(x, internal['[[minimumSignificantDigits]]'], internal['[[maximumSignificantDigits]]']);
                        }
                        // 3. Else,
                        else {
                                // a. Let n be ToRawFixed(x, numberFormat.[[minimumIntegerDigits]], numberFormat.[[minimumFractionDigits]], numberFormat.[[maximumFractionDigits]]).
                                _n2 = ToRawFixed(x, internal['[[minimumIntegerDigits]]'], internal['[[minimumFractionDigits]]'], internal['[[maximumFractionDigits]]']);
                            }
                        // 4. If the value of the numberFormat.[[numberingSystem]] matches one of the values in the "Numbering System" column of Table 2 below, then
                        if (numSys[nums]) {
                            (function () {
                                // a. Let digits be an array whose 10 String valued elements are the UTF-16 string representations of the 10 digits specified in the "Digits" column of the matching row in Table 2.
                                var digits = numSys[nums];
                                // a. Replace each digit in n with the value of digits[digit].
                                _n2 = String(_n2).replace(/\d/g, function (digit) {
                                    return digits[digit];
                                });
                            })();
                        }
                        // 5. Else use an implementation dependent algorithm to map n to the appropriate representation of n in the given numbering system.
                        else _n2 = String(_n2); // ###TODO###

                        var integer = void 0;
                        var fraction = void 0;
                        // 6. Let decimalSepIndex be Call(%StringProto_indexOf%, n, ".", 0).
                        var decimalSepIndex = _n2.indexOf('.', 0);
                        // 7. If decimalSepIndex > 0, then:
                        if (decimalSepIndex > 0) {
                            // a. Let integer be the substring of n from position 0, inclusive, to position decimalSepIndex, exclusive.
                            integer = _n2.substring(0, decimalSepIndex);
                            // a. Let fraction be the substring of n from position decimalSepIndex, exclusive, to the end of n.
                            fraction = _n2.substring(decimalSepIndex + 1, decimalSepIndex.length);
                        }
                        // 8. Else:
                        else {
                                // a. Let integer be n.
                                integer = _n2;
                                // a. Let fraction be undefined.
                                fraction = undefined;
                            }
                        // 9. If the value of the numberFormat.[[useGrouping]] is true,
                        if (internal['[[useGrouping]]'] === true) {
                            // a. Let groupSepSymbol be the ILND String representing the grouping separator.
                            var groupSepSymbol = ild.group;
                            // a. Let groups be a List whose elements are, in left to right order, the substrings defined by ILND set of locations within the integer.
                            var groups = [];
                            // ----> implementation:
                            // Primary group represents the group closest to the decimal
                            var pgSize = data.patterns.primaryGroupSize || 3;
                            // Secondary group is every other group
                            var sgSize = data.patterns.secondaryGroupSize || pgSize;
                            // Group only if necessary
                            if (integer.length > pgSize) {
                                // Index of the primary grouping separator
                                var end = integer.length - pgSize;
                                // Starting index for our loop
                                var idx = end % sgSize;
                                var start = integer.slice(0, idx);
                                if (start.length) arrPush.call(groups, start);
                                // Loop to separate into secondary grouping digits
                                while (idx < end) {
                                    arrPush.call(groups, integer.slice(idx, idx + sgSize));
                                    idx += sgSize;
                                }
                                // Add the primary grouping digits
                                arrPush.call(groups, integer.slice(end));
                            } else {
                                arrPush.call(groups, integer);
                            }
                            // a. Assert: The number of elements in groups List is greater than 0.
                            if (groups.length === 0) throw new Error();
                            // a. Repeat, while groups List is not empty:
                            while (groups.length) {
                                // i. Remove the first element from groups and let integerGroup be the value of that element.
                                var integerGroup = arrShift.call(groups);
                                // ii. Add new part record { [[type]]: "integer", [[value]]: integerGroup } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integerGroup });
                                // iii. If groups List is not empty, then:
                                if (groups.length) {
                                    // 1. Add new part record { [[type]]: "group", [[value]]: groupSepSymbol } as a new element of the list result.
                                    arrPush.call(result, { '[[type]]': 'group', '[[value]]': groupSepSymbol });
                                }
                            }
                        }
                        // 10. Else,
                        else {
                                // a. Add new part record { [[type]]: "integer", [[value]]: integer } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'integer', '[[value]]': integer });
                            }
                        // 11. If fraction is not undefined, then:
                        if (fraction !== undefined) {
                            // a. Let decimalSepSymbol be the ILND String representing the decimal separator.
                            var decimalSepSymbol = ild.decimal;
                            // a. Add new part record { [[type]]: "decimal", [[value]]: decimalSepSymbol } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'decimal', '[[value]]': decimalSepSymbol });
                            // a. Add new part record { [[type]]: "fraction", [[value]]: fraction } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'fraction', '[[value]]': fraction });
                        }
                    }
        }
        // a. Else if p is equal "plusSign", then:
        else if (p === "plusSign") {
                // i. Let plusSignSymbol be the ILND String representing the plus sign.
                var plusSignSymbol = ild.plusSign;
                // ii. Add new part record { [[type]]: "plusSign", [[value]]: plusSignSymbol } as a new element of the list result.
                arrPush.call(result, { '[[type]]': 'plusSign', '[[value]]': plusSignSymbol });
            }
            // a. Else if p is equal "minusSign", then:
            else if (p === "minusSign") {
                    // i. Let minusSignSymbol be the ILND String representing the minus sign.
                    var minusSignSymbol = ild.minusSign;
                    // ii. Add new part record { [[type]]: "minusSign", [[value]]: minusSignSymbol } as a new element of the list result.
                    arrPush.call(result, { '[[type]]': 'minusSign', '[[value]]': minusSignSymbol });
                }
                // a. Else if p is equal "percentSign" and numberFormat.[[style]] is "percent", then:
                else if (p === "percentSign" && internal['[[style]]'] === "percent") {
                        // i. Let percentSignSymbol be the ILND String representing the percent sign.
                        var percentSignSymbol = ild.percentSign;
                        // ii. Add new part record { [[type]]: "percentSign", [[value]]: percentSignSymbol } as a new element of the list result.
                        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': percentSignSymbol });
                    }
                    // a. Else if p is equal "currency" and numberFormat.[[style]] is "currency", then:
                    else if (p === "currency" && internal['[[style]]'] === "currency") {
                            // i. Let currency be the value of numberFormat.[[currency]].
                            var currency = internal['[[currency]]'];

                            var cd = void 0;

                            // ii. If numberFormat.[[currencyDisplay]] is "code", then
                            if (internal['[[currencyDisplay]]'] === "code") {
                                // 1. Let cd be currency.
                                cd = currency;
                            }
                            // iii. Else if numberFormat.[[currencyDisplay]] is "symbol", then
                            else if (internal['[[currencyDisplay]]'] === "symbol") {
                                    // 1. Let cd be an ILD string representing currency in short form. If the implementation does not have such a representation of currency, use currency itself.
                                    cd = data.currencies[currency] || currency;
                                }
                                // iv. Else if numberFormat.[[currencyDisplay]] is "name", then
                                else if (internal['[[currencyDisplay]]'] === "name") {
                                        // 1. Let cd be an ILD string representing currency in long form. If the implementation does not have such a representation of currency, then use currency itself.
                                        cd = currency;
                                    }
                            // v. Add new part record { [[type]]: "currency", [[value]]: cd } as a new element of the list result.
                            arrPush.call(result, { '[[type]]': 'currency', '[[value]]': cd });
                        }
                        // a. Else,
                        else {
                                // i. Let literal be the substring of pattern from position beginIndex, inclusive, to position endIndex, inclusive.
                                var _literal = pattern.substring(beginIndex, endIndex);
                                // ii. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
                                arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal });
                            }
        // a. Set nextIndex to endIndex + 1.
        nextIndex = endIndex + 1;
        // a. Set beginIndex to Call(%StringProto_indexOf%, pattern, "{", nextIndex)
        beginIndex = pattern.indexOf('{', nextIndex);
    }
    // 9. If nextIndex is less than length, then:
    if (nextIndex < length) {
        // a. Let literal be the substring of pattern from position nextIndex, inclusive, to position length, exclusive.
        var _literal2 = pattern.substring(nextIndex, length);
        // a. Add new part record { [[type]]: "literal", [[value]]: literal } as a new element of the list result.
        arrPush.call(result, { '[[type]]': 'literal', '[[value]]': _literal2 });
    }
    // 10. Return result.
    return result;
}

/*
 * @spec[stasm/ecma402/number-format-to-parts/spec/numberformat.html]
 * @clause[sec-formatnumber]
 */
function FormatNumber(numberFormat, x) {
    // 1. Let parts be ? PartitionNumberPattern(numberFormat, x).
    var parts = PartitionNumberPattern(numberFormat, x);
    // 2. Let result be an empty String.
    var result = '';
    // 3. For each part in parts, do:
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        // a. Set result to a String value produced by concatenating result and part.[[value]].
        result += part['[[value]]'];
    }
    // 4. Return result.
    return result;
}

/**
 * When the ToRawPrecision abstract operation is called with arguments x (which
 * must be a finite non-negative number), minPrecision, and maxPrecision (both
 * must be integers between 1 and 21) the following steps are taken:
 */
function ToRawPrecision(x, minPrecision, maxPrecision) {
    // 1. Let p be maxPrecision.
    var p = maxPrecision;

    var m = void 0,
        e = void 0;

    // 2. If x = 0, then
    if (x === 0) {
        // a. Let m be the String consisting of p occurrences of the character "0".
        m = arrJoin.call(Array(p + 1), '0');
        // b. Let e be 0.
        e = 0;
    }
    // 3. Else
    else {
            // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
            //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
            //    possible. If there are two such sets of e and n, pick the e and n for
            //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
            e = log10Floor(Math.abs(x));

            // Easier to get to m from here
            var f = Math.round(Math.exp(Math.abs(e - p + 1) * Math.LN10));

            // b. Let m be the String consisting of the digits of the decimal
            //    representation of n (in order, with no leading zeroes)
            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
        }

    // 4. If e ≥ p, then
    if (e >= p)
        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
        return m + arrJoin.call(Array(e - p + 1 + 1), '0');

        // 5. If e = p-1, then
    else if (e === p - 1)
            // a. Return m.
            return m;

            // 6. If e ≥ 0, then
        else if (e >= 0)
                // a. Let m be the concatenation of the first e+1 characters of m, the character
                //    ".", and the remaining p–(e+1) characters of m.
                m = m.slice(0, e + 1) + '.' + m.slice(e + 1);

                // 7. If e < 0, then
            else if (e < 0)
                    // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
                    //    character "0", and the string m.
                    m = '0.' + arrJoin.call(Array(-(e + 1) + 1), '0') + m;

    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
        // a. Let cut be maxPrecision – minPrecision.
        var cut = maxPrecision - minPrecision;

        // b. Repeat while cut > 0 and the last character of m is "0":
        while (cut > 0 && m.charAt(m.length - 1) === '0') {
            //  i. Remove the last character from m.
            m = m.slice(0, -1);

            //  ii. Decrease cut by 1.
            cut--;
        }

        // c. If the last character of m is ".", then
        if (m.charAt(m.length - 1) === '.')
            //    i. Remove the last character from m.
            m = m.slice(0, -1);
    }
    // 9. Return m.
    return m;
}

/**
 * @spec[tc39/ecma402/master/spec/numberformat.html]
 * @clause[sec-torawfixed]
 * When the ToRawFixed abstract operation is called with arguments x (which must
 * be a finite non-negative number), minInteger (which must be an integer between
 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
 * 20) the following steps are taken:
 */
function ToRawFixed(x, minInteger, minFraction, maxFraction) {
    // 1. Let f be maxFraction.
    var f = maxFraction;
    // 2. Let n be an integer for which the exact mathematical value of n ÷ 10f – x is as close to zero as possible. If there are two such n, pick the larger n.
    var n = Math.pow(10, f) * x; // diverging...
    // 3. If n = 0, let m be the String "0". Otherwise, let m be the String consisting of the digits of the decimal representation of n (in order, with no leading zeroes).
    var m = n === 0 ? "0" : n.toFixed(0); // divering...

    {
        // this diversion is needed to take into consideration big numbers, e.g.:
        // 1.2344501e+37 -> 12344501000000000000000000000000000000
        var idx = void 0;
        var exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
        if (exp) {
            m = m.slice(0, idx).replace('.', '');
            m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0');
        }
    }

    var int = void 0;
    // 4. If f ≠ 0, then
    if (f !== 0) {
        // a. Let k be the number of characters in m.
        var k = m.length;
        // a. If k ≤ f, then
        if (k <= f) {
            // i. Let z be the String consisting of f+1–k occurrences of the character "0".
            var z = arrJoin.call(Array(f + 1 - k + 1), '0');
            // ii. Let m be the concatenation of Strings z and m.
            m = z + m;
            // iii. Let k be f+1.
            k = f + 1;
        }
        // a. Let a be the first k–f characters of m, and let b be the remaining f characters of m.
        var a = m.substring(0, k - f),
            b = m.substring(k - f, m.length);
        // a. Let m be the concatenation of the three Strings a, ".", and b.
        m = a + "." + b;
        // a. Let int be the number of characters in a.
        int = a.length;
    }
    // 5. Else, let int be the number of characters in m.
    else int = m.length;
    // 6. Let cut be maxFraction – minFraction.
    var cut = maxFraction - minFraction;
    // 7. Repeat while cut > 0 and the last character of m is "0":
    while (cut > 0 && m.slice(-1) === "0") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
        // a. Decrease cut by 1.
        cut--;
    }
    // 8. If the last character of m is ".", then
    if (m.slice(-1) === ".") {
        // a. Remove the last character from m.
        m = m.slice(0, -1);
    }
    // 9. If int < minInteger, then
    if (int < minInteger) {
        // a. Let z be the String consisting of minInteger–int occurrences of the character "0".
        var _z = arrJoin.call(Array(minInteger - int + 1), '0');
        // a. Let m be the concatenation of Strings z and m.
        m = _z + m;
    }
    // 10. Return m.
    return m;
}

// Sect 11.3.2 Table 2, Numbering systems
// ======================================
var numSys = {
    arab: ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
    arabext: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
    bali: ["᭐", "᭑", "᭒", "᭓", "᭔", "᭕", "᭖", "᭗", "᭘", "᭙"],
    beng: ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"],
    deva: ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"],
    fullwide: ["０", "１", "２", "３", "４", "５", "６", "７", "８", "９"],
    gujr: ["૦", "૧", "૨", "૩", "૪", "૫", "૬", "૭", "૮", "૯"],
    guru: ["੦", "੧", "੨", "੩", "੪", "੫", "੬", "੭", "੮", "੯"],
    hanidec: ["〇", "一", "二", "三", "四", "五", "六", "七", "八", "九"],
    khmr: ["០", "១", "២", "៣", "៤", "៥", "៦", "៧", "៨", "៩"],
    knda: ["೦", "೧", "೨", "೩", "೪", "೫", "೬", "೭", "೮", "೯"],
    laoo: ["໐", "໑", "໒", "໓", "໔", "໕", "໖", "໗", "໘", "໙"],
    latn: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
    limb: ["᥆", "᥇", "᥈", "᥉", "᥊", "᥋", "᥌", "᥍", "᥎", "᥏"],
    mlym: ["൦", "൧", "൨", "൩", "൪", "൫", "൬", "൭", "൮", "൯"],
    mong: ["᠐", "᠑", "᠒", "᠓", "᠔", "᠕", "᠖", "᠗", "᠘", "᠙"],
    mymr: ["၀", "၁", "၂", "၃", "၄", "၅", "၆", "၇", "၈", "၉"],
    orya: ["୦", "୧", "୨", "୩", "୪", "୫", "୬", "୭", "୮", "୯"],
    tamldec: ["௦", "௧", "௨", "௩", "௪", "௫", "௬", "௭", "௮", "௯"],
    telu: ["౦", "౧", "౨", "౩", "౪", "౫", "౬", "౭", "౮", "౯"],
    thai: ["๐", "๑", "๒", "๓", "๔", "๕", "๖", "๗", "๘", "๙"],
    tibt: ["༠", "༡", "༢", "༣", "༤", "༥", "༦", "༧", "༨", "༩"]
};

/**
 * This function provides access to the locale and formatting options computed
 * during initialization of the object.
 *
 * The function returns a new object whose properties and attributes are set as
 * if constructed by an object literal assigning to each of the following
 * properties the value of the corresponding internal property of this
 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
 * useGrouping. Properties whose corresponding internal properties are not present
 * are not assigned.
 */
/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
    configurable: true,
    writable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay', 'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits', 'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 11.3_b
        if (!internal || !internal['[[initializedNumberFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

/* jslint esnext: true */

// Match these datetime components in a CLDR pattern, except those in single quotes
var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
// trim patterns after transformations
var expPatternTrimmer = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
// Skip over patterns with these datetime components because we don't have data
// to back them up:
// timezone, weekday, amoung others
var unwantedDTCs = /[rqQASjJgwWIQq]/; // xXVO were removed from this list in favor of computing matches with timeZoneName values but printing as empty string

var dtKeys = ["era", "year", "month", "day", "weekday", "quarter"];
var tmKeys = ["hour", "minute", "second", "hour12", "timeZoneName"];

function isDateFormatOnly(obj) {
    for (var i = 0; i < tmKeys.length; i += 1) {
        if (obj.hasOwnProperty(tmKeys[i])) {
            return false;
        }
    }
    return true;
}

function isTimeFormatOnly(obj) {
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (obj.hasOwnProperty(dtKeys[i])) {
            return false;
        }
    }
    return true;
}

function joinDateAndTimeFormats(dateFormatObj, timeFormatObj) {
    var o = { _: {} };
    for (var i = 0; i < dtKeys.length; i += 1) {
        if (dateFormatObj[dtKeys[i]]) {
            o[dtKeys[i]] = dateFormatObj[dtKeys[i]];
        }
        if (dateFormatObj._[dtKeys[i]]) {
            o._[dtKeys[i]] = dateFormatObj._[dtKeys[i]];
        }
    }
    for (var j = 0; j < tmKeys.length; j += 1) {
        if (timeFormatObj[tmKeys[j]]) {
            o[tmKeys[j]] = timeFormatObj[tmKeys[j]];
        }
        if (timeFormatObj._[tmKeys[j]]) {
            o._[tmKeys[j]] = timeFormatObj._[tmKeys[j]];
        }
    }
    return o;
}

function computeFinalPatterns(formatObj) {
    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
    //  'In patterns, two single quotes represents a literal single quote, either
    //   inside or outside single quotes. Text within single quotes is not
    //   interpreted in any way (except for two adjacent single quotes).'
    formatObj.pattern12 = formatObj.extendedPattern.replace(/'([^']*)'/g, function ($0, literal) {
        return literal ? literal : "'";
    });

    // pattern 12 is always the default. we can produce the 24 by removing {ampm}
    formatObj.pattern = formatObj.pattern12.replace('{ampm}', '').replace(expPatternTrimmer, '');
    return formatObj;
}

function expDTComponentsMeta($0, formatObj) {
    switch ($0.charAt(0)) {
        // --- Era
        case 'G':
            formatObj.era = ['short', 'short', 'short', 'long', 'narrow'][$0.length - 1];
            return '{era}';

        // --- Year
        case 'y':
        case 'Y':
        case 'u':
        case 'U':
        case 'r':
            formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
            return '{year}';

        // --- Quarter (not supported in this polyfill)
        case 'Q':
        case 'q':
            formatObj.quarter = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{quarter}';

        // --- Month
        case 'M':
        case 'L':
            formatObj.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][$0.length - 1];
            return '{month}';

        // --- Week (not supported in this polyfill)
        case 'w':
            // week of the year
            formatObj.week = $0.length === 2 ? '2-digit' : 'numeric';
            return '{weekday}';
        case 'W':
            // week of the month
            formatObj.week = 'numeric';
            return '{weekday}';

        // --- Day
        case 'd':
            // day of the month
            formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
            return '{day}';
        case 'D': // day of the year
        case 'F': // day of the week
        case 'g':
            // 1..n: Modified Julian day
            formatObj.day = 'numeric';
            return '{day}';

        // --- Week Day
        case 'E':
            // day of the week
            formatObj.weekday = ['short', 'short', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'e':
            // local day of the week
            formatObj.weekday = ['numeric', '2-digit', 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';
        case 'c':
            // stand alone local day of the week
            formatObj.weekday = ['numeric', undefined, 'short', 'long', 'narrow', 'short'][$0.length - 1];
            return '{weekday}';

        // --- Period
        case 'a': // AM, PM
        case 'b': // am, pm, noon, midnight
        case 'B':
            // flexible day periods
            formatObj.hour12 = true;
            return '{ampm}';

        // --- Hour
        case 'h':
        case 'H':
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';
        case 'k':
        case 'K':
            formatObj.hour12 = true; // 12-hour-cycle time formats (using h or K)
            formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
            return '{hour}';

        // --- Minute
        case 'm':
            formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
            return '{minute}';

        // --- Second
        case 's':
            formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
            return '{second}';
        case 'S':
        case 'A':
            formatObj.second = 'numeric';
            return '{second}';

        // --- Timezone
        case 'z': // 1..3, 4: specific non-location format
        case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
        case 'O': // 1, 4: miliseconds in day short, long
        case 'v': // 1, 4: generic non-location format
        case 'V': // 1, 2, 3, 4: time zone ID or city
        case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
        case 'x':
            // 1, 2, 3, 4: The ISO8601 varios formats
            // this polyfill only supports much, for now, we are just doing something dummy
            formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
            return '{timeZoneName}';
    }
}

/**
 * Converts the CLDR availableFormats into the objects and patterns required by
 * the ECMAScript Internationalization API specification.
 */
function createDateTimeFormat(skeleton, pattern) {
    // we ignore certain patterns that are unsupported to avoid this expensive op.
    if (unwantedDTCs.test(pattern)) return undefined;

    var formatObj = {
        originalPattern: pattern,
        _: {}
    };

    // Replace the pattern string with the one required by the specification, whilst
    // at the same time evaluating it for the subsets and formats
    formatObj.extendedPattern = pattern.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj._);
    });

    // Match the skeleton string with the one required by the specification
    // this implementation is based on the Date Field Symbol Table:
    // http://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
    // Note: we are adding extra data to the formatObject even though this polyfill
    //       might not support it.
    skeleton.replace(expDTComponents, function ($0) {
        // See which symbol we're dealing with
        return expDTComponentsMeta($0, formatObj);
    });

    return computeFinalPatterns(formatObj);
}

/**
 * Processes DateTime formats from CLDR to an easier-to-parse format.
 * the result of this operation should be cached the first time a particular
 * calendar is analyzed.
 *
 * The specification requires we support at least the following subsets of
 * date/time components:
 *
 *   - 'weekday', 'year', 'month', 'day', 'hour', 'minute', 'second'
 *   - 'weekday', 'year', 'month', 'day'
 *   - 'year', 'month', 'day'
 *   - 'year', 'month'
 *   - 'month', 'day'
 *   - 'hour', 'minute', 'second'
 *   - 'hour', 'minute'
 *
 * We need to cherry pick at least these subsets from the CLDR data and convert
 * them into the pattern objects used in the ECMA-402 API.
 */
function createDateTimeFormats(formats) {
    var availableFormats = formats.availableFormats;
    var timeFormats = formats.timeFormats;
    var dateFormats = formats.dateFormats;
    var result = [];
    var skeleton = void 0,
        pattern = void 0,
        computed = void 0,
        i = void 0,
        j = void 0;
    var timeRelatedFormats = [];
    var dateRelatedFormats = [];

    // Map available (custom) formats into a pattern for createDateTimeFormats
    for (skeleton in availableFormats) {
        if (availableFormats.hasOwnProperty(skeleton)) {
            pattern = availableFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                // in some cases, the format is only displaying date specific props
                // or time specific props, in which case we need to also produce the
                // combined formats.
                if (isDateFormatOnly(computed)) {
                    dateRelatedFormats.push(computed);
                } else if (isTimeFormatOnly(computed)) {
                    timeRelatedFormats.push(computed);
                }
            }
        }
    }

    // Map time formats into a pattern for createDateTimeFormats
    for (skeleton in timeFormats) {
        if (timeFormats.hasOwnProperty(skeleton)) {
            pattern = timeFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                timeRelatedFormats.push(computed);
            }
        }
    }

    // Map date formats into a pattern for createDateTimeFormats
    for (skeleton in dateFormats) {
        if (dateFormats.hasOwnProperty(skeleton)) {
            pattern = dateFormats[skeleton];
            computed = createDateTimeFormat(skeleton, pattern);
            if (computed) {
                result.push(computed);
                dateRelatedFormats.push(computed);
            }
        }
    }

    // combine custom time and custom date formats when they are orthogonals to complete the
    // formats supported by CLDR.
    // This Algo is based on section "Missing Skeleton Fields" from:
    // http://unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
    for (i = 0; i < timeRelatedFormats.length; i += 1) {
        for (j = 0; j < dateRelatedFormats.length; j += 1) {
            if (dateRelatedFormats[j].month === 'long') {
                pattern = dateRelatedFormats[j].weekday ? formats.full : formats.long;
            } else if (dateRelatedFormats[j].month === 'short') {
                pattern = formats.medium;
            } else {
                pattern = formats.short;
            }
            computed = joinDateAndTimeFormats(dateRelatedFormats[j], timeRelatedFormats[i]);
            computed.originalPattern = pattern;
            computed.extendedPattern = pattern.replace('{0}', timeRelatedFormats[i].extendedPattern).replace('{1}', dateRelatedFormats[j].extendedPattern).replace(/^[,\s]+|[,\s]+$/gi, '');
            result.push(computeFinalPatterns(computed));
        }
    }

    return result;
}

// this represents the exceptions of the rule that are not covered by CLDR availableFormats
// for single property configurations, they play no role when using multiple properties, and
// those that are not in this table, are not exceptions or are not covered by the data we
// provide.
var validSyntheticProps = {
    second: {
        numeric: 's',
        '2-digit': 'ss'
    },
    minute: {
        numeric: 'm',
        '2-digit': 'mm'
    },
    year: {
        numeric: 'y',
        '2-digit': 'yy'
    },
    day: {
        numeric: 'd',
        '2-digit': 'dd'
    },
    month: {
        numeric: 'L',
        '2-digit': 'LL',
        narrow: 'LLLLL',
        short: 'LLL',
        long: 'LLLL'
    },
    weekday: {
        narrow: 'ccccc',
        short: 'ccc',
        long: 'cccc'
    }
};

function generateSyntheticFormat(propName, propValue) {
    if (validSyntheticProps[propName] && validSyntheticProps[propName][propValue]) {
        var _ref2;

        return _ref2 = {
            originalPattern: validSyntheticProps[propName][propValue],
            _: defineProperty$1({}, propName, propValue),
            extendedPattern: "{" + propName + "}"
        }, defineProperty$1(_ref2, propName, propValue), defineProperty$1(_ref2, "pattern12", "{" + propName + "}"), defineProperty$1(_ref2, "pattern", "{" + propName + "}"), _ref2;
    }
}

// An object map of date component keys, saves using a regex later
var dateWidths = objCreate(null, { narrow: {}, short: {}, long: {} });

/**
 * Returns a string for a date component, resolved using multiple inheritance as specified
 * as specified in the Unicode Technical Standard 35.
 */
function resolveDateString(data, ca, component, width, key) {
    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
    // 'In clearly specified instances, resources may inherit from within the same locale.
    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
    var obj = data[ca] && data[ca][component] ? data[ca][component] : data.gregory[component],


    // "sideways" inheritance resolves strings when a key doesn't exist
    alts = {
        narrow: ['short', 'long'],
        short: ['long', 'narrow'],
        long: ['short', 'narrow']
    },


    //
    resolved = hop.call(obj, width) ? obj[width] : hop.call(obj, alts[width][0]) ? obj[alts[width][0]] : obj[alts[width][1]];

    // `key` wouldn't be specified for components 'dayPeriods'
    return key !== null ? resolved[key] : resolved;
}

// Define the DateTimeFormat constructor internally so it cannot be tainted
function DateTimeFormatConstructor() {
    var locales = arguments[0];
    var options = arguments[1];

    if (!this || this === Intl) {
        return new Intl.DateTimeFormat(locales, options);
    }
    return InitializeDateTimeFormat(toObject(this), locales, options);
}

defineProperty(Intl, 'DateTimeFormat', {
    configurable: true,
    writable: true,
    value: DateTimeFormatConstructor
});

// Must explicitly set prototypes as unwritable
defineProperty(DateTimeFormatConstructor, 'prototype', {
    writable: false
});

/**
 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
 * DateTimeFormat object.
 */
function /* 12.1.1.1 */InitializeDateTimeFormat(dateTimeFormat, locales, options) {
    // This will be a internal properties object if we're not already initialized
    var internal = getInternalProperties(dateTimeFormat);

    // Create an object whose props can be used to restore the values of RegExp props
    var regexpRestore = createRegExpRestore();

    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
    //    value true, throw a TypeError exception.
    if (internal['[[initializedIntlObject]]'] === true) throw new TypeError('`this` object has already been initialized as an Intl object');

    // Need this to access the `internal` object
    defineProperty(dateTimeFormat, '__getInternalProperties', {
        value: function value() {
            // NOTE: Non-standard, for internal use only
            if (arguments[0] === secret) return internal;
        }
    });

    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
    internal['[[initializedIntlObject]]'] = true;

    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
    //    abstract operation (defined in 9.2.1) with argument locales.
    var requestedLocales = CanonicalizeLocaleList(locales);

    // 4. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined below) with arguments options, "any", and "date".
    options = ToDateTimeOptions(options, 'any', 'date');

    // 5. Let opt be a new Record.
    var opt = new Record();

    // 6. Let matcher be the result of calling the GetOption abstract operation
    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
    //    containing the two String values "lookup" and "best fit", and "best fit".
    var matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');

    // 7. Set opt.[[localeMatcher]] to matcher.
    opt['[[localeMatcher]]'] = matcher;

    // 8. Let DateTimeFormat be the standard built-in object that is the initial
    //    value of Intl.DateTimeFormat.
    var DateTimeFormat = internals.DateTimeFormat; // This is what we *really* need

    // 9. Let localeData be the value of the [[localeData]] internal property of
    //    DateTimeFormat.
    var localeData = DateTimeFormat['[[localeData]]'];

    // 10. Let r be the result of calling the ResolveLocale abstract operation
    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
    //      internal property of DateTimeFormat, and localeData.
    var r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales, opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);

    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
    //     r.[[locale]].
    internal['[[locale]]'] = r['[[locale]]'];

    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
    //     r.[[ca]].
    internal['[[calendar]]'] = r['[[ca]]'];

    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
    //     r.[[nu]].
    internal['[[numberingSystem]]'] = r['[[nu]]'];

    // The specification doesn't tell us to do this, but it's helpful later on
    internal['[[dataLocale]]'] = r['[[dataLocale]]'];

    // 14. Let dataLocale be the value of r.[[dataLocale]].
    var dataLocale = r['[[dataLocale]]'];

    // 15. Let tz be the result of calling the [[Get]] internal method of options with
    //     argument "timeZone".
    var tz = options.timeZone;

    // 16. If tz is not undefined, then
    if (tz !== undefined) {
        // a. Let tz be ToString(tz).
        // b. Convert tz to upper case as described in 6.1.
        //    NOTE: If an implementation accepts additional time zone values, as permitted
        //          under certain conditions by the Conformance clause, different casing
        //          rules apply.
        tz = toLatinUpperCase(tz);

        // c. If tz is not "UTC", then throw a RangeError exception.
        // ###TODO: accept more time zones###
        if (tz !== 'UTC') throw new RangeError('timeZone is not supported.');
    }

    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
    internal['[[timeZone]]'] = tz;

    // 18. Let opt be a new Record.
    opt = new Record();

    // 19. For each row of Table 3, except the header row, do:
    for (var prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, prop)) continue;

        // 20. Let prop be the name given in the Property column of the row.
        // 21. Let value be the result of calling the GetOption abstract operation,
        //     passing as argument options, the name given in the Property column of the
        //     row, "string", a List containing the strings given in the Values column of
        //     the row, and undefined.
        var value = GetOption(options, prop, 'string', dateTimeComponents[prop]);

        // 22. Set opt.[[<prop>]] to value.
        opt['[[' + prop + ']]'] = value;
    }

    // Assigned a value below
    var bestFormat = void 0;

    // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
    //     localeData with argument dataLocale.
    var dataLocaleData = localeData[dataLocale];

    // 24. Let formats be the result of calling the [[Get]] internal method of
    //     dataLocaleData with argument "formats".
    //     Note: we process the CLDR formats into the spec'd structure
    var formats = ToDateTimeFormats(dataLocaleData.formats);

    // 25. Let matcher be the result of calling the GetOption abstract operation with
    //     arguments options, "formatMatcher", "string", a List containing the two String
    //     values "basic" and "best fit", and "best fit".
    matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');

    // Optimization: caching the processed formats as a one time operation by
    // replacing the initial structure from localeData
    dataLocaleData.formats = formats;

    // 26. If matcher is "basic", then
    if (matcher === 'basic') {
        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
        //     operation (defined below) with opt and formats.
        bestFormat = BasicFormatMatcher(opt, formats);

        // 28. Else
    } else {
        {
            // diverging
            var _hr = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);
            opt.hour12 = _hr === undefined ? dataLocaleData.hour12 : _hr;
        }
        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
        //     abstract operation (defined below) with opt and formats.
        bestFormat = BestFitFormatMatcher(opt, formats);
    }

    // 30. For each row in Table 3, except the header row, do
    for (var _prop in dateTimeComponents) {
        if (!hop.call(dateTimeComponents, _prop)) continue;

        // a. Let prop be the name given in the Property column of the row.
        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
        //    bestFormat with argument prop.
        // c. If pDesc is not undefined, then
        if (hop.call(bestFormat, _prop)) {
            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
            //    with argument prop.
            var p = bestFormat[_prop];
            {
                // diverging
                p = bestFormat._ && hop.call(bestFormat._, _prop) ? bestFormat._[_prop] : p;
            }

            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
            internal['[[' + _prop + ']]'] = p;
        }
    }

    var pattern = void 0; // Assigned a value below

    // 31. Let hr12 be the result of calling the GetOption abstract operation with
    //     arguments options, "hour12", "boolean", undefined, and undefined.
    var hr12 = GetOption(options, 'hour12', 'boolean' /*, undefined, undefined*/);

    // 32. If dateTimeFormat has an internal property [[hour]], then
    if (internal['[[hour]]']) {
        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
        //    internal method of dataLocaleData with argument "hour12".
        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;

        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
        internal['[[hour12]]'] = hr12;

        // c. If hr12 is true, then
        if (hr12 === true) {
            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
            //    dataLocaleData with argument "hourNo0".
            var hourNo0 = dataLocaleData.hourNo0;

            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
            internal['[[hourNo0]]'] = hourNo0;

            // iii. Let pattern be the result of calling the [[Get]] internal method of
            //      bestFormat with argument "pattern12".
            pattern = bestFormat.pattern12;
        }

        // d. Else
        else
            // i. Let pattern be the result of calling the [[Get]] internal method of
            //    bestFormat with argument "pattern".
            pattern = bestFormat.pattern;
    }

    // 33. Else
    else
        // a. Let pattern be the result of calling the [[Get]] internal method of
        //    bestFormat with argument "pattern".
        pattern = bestFormat.pattern;

    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
    internal['[[pattern]]'] = pattern;

    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
    internal['[[boundFormat]]'] = undefined;

    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
    //     true.
    internal['[[initializedDateTimeFormat]]'] = true;

    // In ES3, we need to pre-bind the format() function
    if (es3) dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);

    // Restore the RegExp properties
    regexpRestore();

    // Return the newly initialised object
    return dateTimeFormat;
}

/**
 * Several DateTimeFormat algorithms use values from the following table, which provides
 * property names and allowable values for the components of date and time formats:
 */
var dateTimeComponents = {
    weekday: ["narrow", "short", "long"],
    era: ["narrow", "short", "long"],
    year: ["2-digit", "numeric"],
    month: ["2-digit", "numeric", "narrow", "short", "long"],
    day: ["2-digit", "numeric"],
    hour: ["2-digit", "numeric"],
    minute: ["2-digit", "numeric"],
    second: ["2-digit", "numeric"],
    timeZoneName: ["short", "long"]
};

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeFormats(formats) {
    if (Object.prototype.toString.call(formats) === '[object Array]') {
        return formats;
    }
    return createDateTimeFormats(formats);
}

/**
 * When the ToDateTimeOptions abstract operation is called with arguments options,
 * required, and defaults, the following steps are taken:
 */
function ToDateTimeOptions(options, required, defaults) {
    // 1. If options is undefined, then let options be null, else let options be
    //    ToObject(options).
    if (options === undefined) options = null;else {
        // (#12) options needs to be a Record, but it also needs to inherit properties
        var opt2 = toObject(options);
        options = new Record();

        for (var k in opt2) {
            options[k] = opt2[k];
        }
    }

    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
    var create = objCreate;

    // 3. Let options be the result of calling the [[Call]] internal method of create with
    //    undefined as the this value and an argument list containing the single item
    //    options.
    options = create(options);

    // 4. Let needDefaults be true.
    var needDefaults = true;

    // 5. If required is "date" or "any", then
    if (required === 'date' || required === 'any') {
        // a. For each of the property names "weekday", "year", "month", "day":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.weekday !== undefined || options.year !== undefined || options.month !== undefined || options.day !== undefined) needDefaults = false;
    }

    // 6. If required is "time" or "any", then
    if (required === 'time' || required === 'any') {
        // a. For each of the property names "hour", "minute", "second":
        // i. If the result of calling the [[Get]] internal method of options with the
        //    property name is not undefined, then let needDefaults be false.
        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined) needDefaults = false;
    }

    // 7. If needDefaults is true and defaults is either "date" or "all", then
    if (needDefaults && (defaults === 'date' || defaults === 'all'))
        // a. For each of the property names "year", "month", "day":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.year = options.month = options.day = 'numeric';

    // 8. If needDefaults is true and defaults is either "time" or "all", then
    if (needDefaults && (defaults === 'time' || defaults === 'all'))
        // a. For each of the property names "hour", "minute", "second":
        // i. Call the [[DefineOwnProperty]] internal method of options with the
        //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
        //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
        options.hour = options.minute = options.second = 'numeric';

    // 9. Return options.
    return options;
}

/**
 * When the BasicFormatMatcher abstract operation is called with two arguments options and
 * formats, the following steps are taken:
 */
function BasicFormatMatcher(options, formats) {
    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, property) ? format[property] : undefined;

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        // 5. If delta = 2, decrease score by longMorePenalty.
                        if (delta === 2) score -= longMorePenalty;

                        // 6. Else if delta = 1, decrease score by shortMorePenalty.
                        else if (delta === 1) score -= shortMorePenalty;

                            // 7. Else if delta = -1, decrease score by shortLessPenalty.
                            else if (delta === -1) score -= shortLessPenalty;

                                // 8. Else if delta = -2, decrease score by longLessPenalty.
                                else if (delta === -2) score -= longLessPenalty;
                    }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;

            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/**
 * When the BestFitFormatMatcher abstract operation is called with two arguments options
 * and formats, it performs implementation dependent steps, which should return a set of
 * component representations that a typical user of the selected locale would perceive as
 * at least as good as the one returned by BasicFormatMatcher.
 *
 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
 * with the addition of bonus points awarded where the requested format is of
 * the same data type as the potentially matching format.
 *
 * This algo relies on the concept of closest distance matching described here:
 * http://unicode.org/reports/tr35/tr35-dates.html#Matching_Skeletons
 * Typically a “best match” is found using a closest distance match, such as:
 *
 * Symbols requesting a best choice for the locale are replaced.
 *      j → one of {H, k, h, K}; C → one of {a, b, B}
 * -> Covered by cldr.js matching process
 *
 * For fields with symbols representing the same type (year, month, day, etc):
 *     Most symbols have a small distance from each other.
 *         M ≅ L; E ≅ c; a ≅ b ≅ B; H ≅ k ≅ h ≅ K; ...
 *     -> Covered by cldr.js matching process
 *
 *     Width differences among fields, other than those marking text vs numeric, are given small distance from each other.
 *         MMM ≅ MMMM
 *         MM ≅ M
 *     Numeric and text fields are given a larger distance from each other.
 *         MMM ≈ MM
 *     Symbols representing substantial differences (week of year vs week of month) are given much larger a distances from each other.
 *         d ≋ D; ...
 *     Missing or extra fields cause a match to fail. (But see Missing Skeleton Fields).
 *
 *
 * For example,
 *
 *     { month: 'numeric', day: 'numeric' }
 *
 * should match
 *
 *     { month: '2-digit', day: '2-digit' }
 *
 * rather than
 *
 *     { month: 'short', day: 'numeric' }
 *
 * This makes sense because a user requesting a formatted date with numeric parts would
 * not expect to see the returned format containing narrow, short or long part names
 */
function BestFitFormatMatcher(options, formats) {
    /** Diverging: this block implements the hack for single property configuration, eg.:
     *
     *      `new Intl.DateTimeFormat('en', {day: 'numeric'})`
     *
     * should produce a single digit with the day of the month. This is needed because
     * CLDR `availableFormats` data structure doesn't cover these cases.
     */
    {
        var optionsPropNames = [];
        for (var property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, property)) continue;

            if (options['[[' + property + ']]'] !== undefined) {
                optionsPropNames.push(property);
            }
        }
        if (optionsPropNames.length === 1) {
            var _bestFormat = generateSyntheticFormat(optionsPropNames[0], options['[[' + optionsPropNames[0] + ']]']);
            if (_bestFormat) {
                return _bestFormat;
            }
        }
    }

    // 1. Let removalPenalty be 120.
    var removalPenalty = 120;

    // 2. Let additionPenalty be 20.
    var additionPenalty = 20;

    // 3. Let longLessPenalty be 8.
    var longLessPenalty = 8;

    // 4. Let longMorePenalty be 6.
    var longMorePenalty = 6;

    // 5. Let shortLessPenalty be 6.
    var shortLessPenalty = 6;

    // 6. Let shortMorePenalty be 3.
    var shortMorePenalty = 3;

    var patternPenalty = 2;

    var hour12Penalty = 1;

    // 7. Let bestScore be -Infinity.
    var bestScore = -Infinity;

    // 8. Let bestFormat be undefined.
    var bestFormat = void 0;

    // 9. Let i be 0.
    var i = 0;

    // 10. Assert: formats is an Array object.

    // 11. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
    var len = formats.length;

    // 12. Repeat while i < len:
    while (i < len) {
        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
        var format = formats[i];

        // b. Let score be 0.
        var score = 0;

        // c. For each property shown in Table 3:
        for (var _property in dateTimeComponents) {
            if (!hop.call(dateTimeComponents, _property)) continue;

            // i. Let optionsProp be options.[[<property>]].
            var optionsProp = options['[[' + _property + ']]'];

            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
            //     with argument property.
            // iii. If formatPropDesc is not undefined, then
            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
            var formatProp = hop.call(format, _property) ? format[_property] : undefined;

            // Diverging: using the default properties produced by the pattern/skeleton
            // to match it with user options, and apply a penalty
            var patternProp = hop.call(format._, _property) ? format._[_property] : undefined;
            if (optionsProp !== patternProp) {
                score -= patternPenalty;
            }

            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
            //     additionPenalty.
            if (optionsProp === undefined && formatProp !== undefined) score -= additionPenalty;

            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
            //    removalPenalty.
            else if (optionsProp !== undefined && formatProp === undefined) score -= removalPenalty;

                // vi. Else
                else {
                        // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
                        //    "long"].
                        var values = ['2-digit', 'numeric', 'narrow', 'short', 'long'];

                        // 2. Let optionsPropIndex be the index of optionsProp within values.
                        var optionsPropIndex = arrIndexOf.call(values, optionsProp);

                        // 3. Let formatPropIndex be the index of formatProp within values.
                        var formatPropIndex = arrIndexOf.call(values, formatProp);

                        // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
                        var delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);

                        {
                            // diverging from spec
                            // When the bestFit argument is true, subtract additional penalty where data types are not the same
                            if (formatPropIndex <= 1 && optionsPropIndex >= 2 || formatPropIndex >= 2 && optionsPropIndex <= 1) {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 0) score -= longMorePenalty;else if (delta < 0) score -= longLessPenalty;
                            } else {
                                // 5. If delta = 2, decrease score by longMorePenalty.
                                if (delta > 1) score -= shortMorePenalty;else if (delta < -1) score -= shortLessPenalty;
                            }
                        }
                    }
        }

        {
            // diverging to also take into consideration differences between 12 or 24 hours
            // which is special for the best fit only.
            if (format._.hour12 !== options.hour12) {
                score -= hour12Penalty;
            }
        }

        // d. If score > bestScore, then
        if (score > bestScore) {
            // i. Let bestScore be score.
            bestScore = score;
            // ii. Let bestFormat be format.
            bestFormat = format;
        }

        // e. Increase i by 1.
        i++;
    }

    // 13. Return bestFormat.
    return bestFormat;
}

/* 12.2.3 */internals.DateTimeFormat = {
    '[[availableLocales]]': [],
    '[[relevantExtensionKeys]]': ['ca', 'nu'],
    '[[localeData]]': {}
};

/**
 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
 * following steps are taken:
 */
/* 12.2.2 */
defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
    configurable: true,
    writable: true,
    value: fnBind.call(function (locales) {
        // Bound functions only have the `this` value altered if being used as a constructor,
        // this lets us imitate a native function that has no constructor
        if (!hop.call(this, '[[availableLocales]]')) throw new TypeError('supportedLocalesOf() is not a constructor');

        // Create an object whose props can be used to restore the values of RegExp props
        var regexpRestore = createRegExpRestore(),


        // 1. If options is not provided, then let options be undefined.
        options = arguments[1],


        // 2. Let availableLocales be the value of the [[availableLocales]] internal
        //    property of the standard built-in object that is the initial value of
        //    Intl.NumberFormat.

        availableLocales = this['[[availableLocales]]'],


        // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
        //    abstract operation (defined in 9.2.1) with argument locales.
        requestedLocales = CanonicalizeLocaleList(locales);

        // Restore the RegExp properties
        regexpRestore();

        // 4. Return the result of calling the SupportedLocales abstract operation
        //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
        //    and options.
        return SupportedLocales(availableLocales, requestedLocales, options);
    }, internals.NumberFormat)
});

/**
 * This named accessor property returns a function that formats a number
 * according to the effective locale and the formatting options of this
 * DateTimeFormat object.
 */
/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
    configurable: true,
    get: GetFormatDateTime
});

function GetFormatDateTime() {
    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    // Satisfy test 12.3_b
    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');

    // The value of the [[Get]] attribute is a function that takes the following
    // steps:

    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
    //    is undefined, then:
    if (internal['[[boundFormat]]'] === undefined) {
        // a. Let F be a Function object, with internal properties set as
        //    specified for built-in functions in ES5, 15, or successor, and the
        //    length property set to 0, that takes the argument date and
        //    performs the following steps:
        var F = function F() {
            var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

            //   i. If date is not provided or is undefined, then let x be the
            //      result as if by the expression Date.now() where Date.now is
            //      the standard built-in function defined in ES5, 15.9.4.4.
            //  ii. Else let x be ToNumber(date).
            // iii. Return the result of calling the FormatDateTime abstract
            //      operation (defined below) with arguments this and x.
            var x = date === undefined ? Date.now() : toNumber(date);
            return FormatDateTime(this, x);
        };
        // b. Let bind be the standard built-in function object defined in ES5,
        //    15.3.4.5.
        // c. Let bf be the result of calling the [[Call]] internal method of
        //    bind with F as the this value and an argument list containing
        //    the single item this.
        var bf = fnBind.call(F, this);
        // d. Set the [[boundFormat]] internal property of this NumberFormat
        //    object to bf.
        internal['[[boundFormat]]'] = bf;
    }
    // Return the value of the [[boundFormat]] internal property of this
    // NumberFormat object.
    return internal['[[boundFormat]]'];
}

function formatToParts$1() {
    var date = arguments.length <= 0 || arguments[0] === undefined ? undefined : arguments[0];

    var internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

    if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for formatToParts() is not an initialized Intl.DateTimeFormat object.');

    var x = date === undefined ? Date.now() : toNumber(date);
    return FormatToPartsDateTime(this, x);
}

Object.defineProperty(Intl.DateTimeFormat.prototype, 'formatToParts', {
    enumerable: false,
    writable: true,
    configurable: true,
    value: formatToParts$1
});

function CreateDateTimeParts(dateTimeFormat, x) {
    // 1. If x is not a finite Number, then throw a RangeError exception.
    if (!isFinite(x)) throw new RangeError('Invalid valid date passed to format');

    var internal = dateTimeFormat.__getInternalProperties(secret);

    // Creating restore point for properties on the RegExp object... please wait
    /* let regexpRestore = */createRegExpRestore(); // ###TODO: review this

    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
    var locale = internal['[[locale]]'];

    // 3. Let nf be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    var nf = new Intl.NumberFormat([locale], { useGrouping: false });

    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
    // 11.1.3.
    var nf2 = new Intl.NumberFormat([locale], { minimumIntegerDigits: 2, useGrouping: false });

    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
    // and the value of the [[timeZone]] internal property of dateTimeFormat.
    var tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']);

    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
    var pattern = internal['[[pattern]]'];

    // 7.
    var result = new List();

    // 8.
    var index = 0;

    // 9.
    var beginIndex = pattern.indexOf('{');

    // 10.
    var endIndex = 0;

    // Need the locale minus any extensions
    var dataLocale = internal['[[dataLocale]]'];

    // Need the calendar data from CLDR
    var localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars;
    var ca = internal['[[calendar]]'];

    // 11.
    while (beginIndex !== -1) {
        var fv = void 0;
        // a.
        endIndex = pattern.indexOf('}', beginIndex);
        // b.
        if (endIndex === -1) {
            throw new Error('Unclosed pattern');
        }
        // c.
        if (beginIndex > index) {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(index, beginIndex)
            });
        }
        // d.
        var p = pattern.substring(beginIndex + 1, endIndex);
        // e.
        if (dateTimeComponents.hasOwnProperty(p)) {
            //   i. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
            var f = internal['[[' + p + ']]'];
            //  ii. Let v be the value of tm.[[<p>]].
            var v = tm['[[' + p + ']]'];
            // iii. If p is "year" and v ≤ 0, then let v be 1 - v.
            if (p === 'year' && v <= 0) {
                v = 1 - v;
            }
            //  iv. If p is "month", then increase v by 1.
            else if (p === 'month') {
                    v++;
                }
                //   v. If p is "hour" and the value of the [[hour12]] internal property of
                //      dateTimeFormat is true, then
                else if (p === 'hour' && internal['[[hour12]]'] === true) {
                        // 1. Let v be v modulo 12.
                        v = v % 12;
                        // 2. If v is 0 and the value of the [[hourNo0]] internal property of
                        //    dateTimeFormat is true, then let v be 12.
                        if (v === 0 && internal['[[hourNo0]]'] === true) {
                            v = 12;
                        }
                    }

            //  vi. If f is "numeric", then
            if (f === 'numeric') {
                // 1. Let fv be the result of calling the FormatNumber abstract operation
                //    (defined in 11.3.2) with arguments nf and v.
                fv = FormatNumber(nf, v);
            }
            // vii. Else if f is "2-digit", then
            else if (f === '2-digit') {
                    // 1. Let fv be the result of calling the FormatNumber abstract operation
                    //    with arguments nf2 and v.
                    fv = FormatNumber(nf2, v);
                    // 2. If the length of fv is greater than 2, let fv be the substring of fv
                    //    containing the last two characters.
                    if (fv.length > 2) {
                        fv = fv.slice(-2);
                    }
                }
                // viii. Else if f is "narrow", "short", or "long", then let fv be a String
                //     value representing f in the desired form; the String value depends upon
                //     the implementation and the effective locale and calendar of
                //     dateTimeFormat. If p is "month", then the String value may also depend
                //     on whether dateTimeFormat has a [[day]] internal property. If p is
                //     "timeZoneName", then the String value may also depend on the value of
                //     the [[inDST]] field of tm.
                else if (f in dateWidths) {
                        switch (p) {
                            case 'month':
                                fv = resolveDateString(localeData, ca, 'months', f, tm['[[' + p + ']]']);
                                break;

                            case 'weekday':
                                try {
                                    fv = resolveDateString(localeData, ca, 'days', f, tm['[[' + p + ']]']);
                                    // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
                                } catch (e) {
                                    throw new Error('Could not find weekday data for locale ' + locale);
                                }
                                break;

                            case 'timeZoneName':
                                fv = ''; // ###TODO
                                break;

                            case 'era':
                                try {
                                    fv = resolveDateString(localeData, ca, 'eras', f, tm['[[' + p + ']]']);
                                } catch (e) {
                                    throw new Error('Could not find era data for locale ' + locale);
                                }
                                break;

                            default:
                                fv = tm['[[' + p + ']]'];
                        }
                    }
            // ix
            arrPush.call(result, {
                type: p,
                value: fv
            });
            // f.
        } else if (p === 'ampm') {
            // i.
            var _v = tm['[[hour]]'];
            // ii./iii.
            fv = resolveDateString(localeData, ca, 'dayPeriods', _v > 11 ? 'pm' : 'am', null);
            // iv.
            arrPush.call(result, {
                type: 'dayPeriod',
                value: fv
            });
            // g.
        } else {
            arrPush.call(result, {
                type: 'literal',
                value: pattern.substring(beginIndex, endIndex + 1)
            });
        }
        // h.
        index = endIndex + 1;
        // i.
        beginIndex = pattern.indexOf('{', index);
    }
    // 12.
    if (endIndex < pattern.length - 1) {
        arrPush.call(result, {
            type: 'literal',
            value: pattern.substr(endIndex + 1)
        });
    }
    // 13.
    return result;
}

/**
 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
 * value), it returns a String value representing x (interpreted as a time value as
 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
 * options of dateTimeFormat.
 */
function FormatDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = '';

    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result += part.value;
    }
    return result;
}

function FormatToPartsDateTime(dateTimeFormat, x) {
    var parts = CreateDateTimeParts(dateTimeFormat, x);
    var result = [];
    for (var i = 0; parts.length > i; i++) {
        var part = parts[i];
        result.push({
            type: part.type,
            value: part.value
        });
    }
    return result;
}

/**
 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
 * timeZone, the following steps are taken:
 */
function ToLocalTime(date, calendar, timeZone) {
    // 1. Apply calendrical calculations on date for the given calendar and time zone to
    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
    //    The calculations should use best available information about the specified
    //    calendar and time zone. If the calendar is "gregory", then the calculations must
    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
    //    bound by the restrictions on the use of best available information on time zones
    //    for local time zone adjustment and daylight saving time adjustment imposed by
    //    ES5, 15.9.1.7 and 15.9.1.8.
    // ###TODO###
    var d = new Date(date),
        m = 'get' + (timeZone || '');

    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
    //    calculated value.
    return new Record({
        '[[weekday]]': d[m + 'Day'](),
        '[[era]]': +(d[m + 'FullYear']() >= 0),
        '[[year]]': d[m + 'FullYear'](),
        '[[month]]': d[m + 'Month'](),
        '[[day]]': d[m + 'Date'](),
        '[[hour]]': d[m + 'Hours'](),
        '[[minute]]': d[m + 'Minutes'](),
        '[[second]]': d[m + 'Seconds'](),
        '[[inDST]]': false // ###TODO###
    });
}

/**
 * The function returns a new object whose properties and attributes are set as if
 * constructed by an object literal assigning to each of the following properties the
 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
 * properties are not present are not assigned.
 */
/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
    writable: true,
    configurable: true,
    value: function value() {
        var prop = void 0,
            descs = new Record(),
            props = ['locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday', 'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'],
            internal = this !== null && babelHelpers$1["typeof"](this) === 'object' && getInternalProperties(this);

        // Satisfy test 12.3_b
        if (!internal || !internal['[[initializedDateTimeFormat]]']) throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');

        for (var i = 0, max = props.length; i < max; i++) {
            if (hop.call(internal, prop = '[[' + props[i] + ']]')) descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
        }

        return objCreate({}, descs);
    }
});

var ls = Intl.__localeSensitiveProtos = {
    Number: {},
    Date: {}
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.2.1 */ls.Number.toLocaleString = function () {
    // Satisfy test 13.2.1_1
    if (Object.prototype.toString.call(this) !== '[object Number]') throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');

    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
    // 2. If locales is not provided, then let locales be undefined.
    // 3. If options is not provided, then let options be undefined.
    // 4. Let numberFormat be the result of creating a new object as if by the
    //    expression new Intl.NumberFormat(locales, options) where
    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
    // 5. Return the result of calling the FormatNumber abstract operation
    //    (defined in 11.3.2) with arguments numberFormat and x.
    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
};

/**
 * When the toLocaleString method is called with optional arguments locales and options,
 * the following steps are taken:
 */
/* 13.3.1 */ls.Date.toLocaleString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
    options = ToDateTimeOptions(options, 'any', 'all');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleDateString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.2 */ls.Date.toLocaleDateString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0],


    // 4. If options is not provided, then let options be undefined.
    options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
    options = ToDateTimeOptions(options, 'date', 'date');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

/**
 * When the toLocaleTimeString method is called with optional arguments locales and
 * options, the following steps are taken:
 */
/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
    // Satisfy test 13.3.0_1
    if (Object.prototype.toString.call(this) !== '[object Date]') throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');

    // 1. Let x be this time value (as defined in ES5, 15.9.5).
    var x = +this;

    // 2. If x is NaN, then return "Invalid Date".
    if (isNaN(x)) return 'Invalid Date';

    // 3. If locales is not provided, then let locales be undefined.
    var locales = arguments[0];

    // 4. If options is not provided, then let options be undefined.
    var options = arguments[1];

    // 5. Let options be the result of calling the ToDateTimeOptions abstract
    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
    options = ToDateTimeOptions(options, 'time', 'time');

    // 6. Let dateTimeFormat be the result of creating a new object as if by the
    //    expression new Intl.DateTimeFormat(locales, options) where
    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
    var dateTimeFormat = new DateTimeFormatConstructor(locales, options);

    // 7. Return the result of calling the FormatDateTime abstract operation (defined
    //    in 12.3.2) with arguments dateTimeFormat and x.
    return FormatDateTime(dateTimeFormat, x);
};

defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
    writable: true,
    configurable: true,
    value: function value() {
        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
        // Need this here for IE 8, to avoid the _DontEnum_ bug
        defineProperty(Date.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Date.toLocaleString });

        for (var k in ls.Date) {
            if (hop.call(ls.Date, k)) defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
        }
    }
});

/**
 * Can't really ship a single script with data for hundreds of locales, so we provide
 * this __addLocaleData method as a means for the developer to add the data on an
 * as-needed basis
 */
defineProperty(Intl, '__addLocaleData', {
    value: function value(data) {
        if (!IsStructurallyValidLanguageTag(data.locale)) throw new Error("Object passed doesn't identify itself with a valid language tag");

        addLocaleData(data, data.locale);
    }
});

function addLocaleData(data, tag) {
    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
    if (!data.number) throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");

    var locale = void 0,
        locales = [tag],
        parts = tag.split('-');

    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
    if (parts.length > 2 && parts[1].length === 4) arrPush.call(locales, parts[0] + '-' + parts[2]);

    while (locale = arrShift.call(locales)) {
        // Add to NumberFormat internal properties as per 11.2.3
        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
        internals.NumberFormat['[[localeData]]'][locale] = data.number;

        // ...and DateTimeFormat internal properties as per 12.2.3
        if (data.date) {
            data.date.nu = data.number.nu;
            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
        }
    }

    // If this is the first set of locale data added, make it the default
    if (defaultLocale === undefined) setDefaultLocale(tag);
}

defineProperty(Intl, '__disableRegExpRestore', {
    value: function value() {
        internals.disableRegExpRestore = true;
    }
});

module.exports = Intl;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 507 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 508 */
/***/ (function(module, exports) {

IntlPolyfill.__addLocaleData({locale:"en-US",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:true,formats:{short:"{1}, {0}",medium:"{1}, {0}",full:"{1} 'at' {0}",long:"{1} 'at' {0}",availableFormats:{"d":"d","E":"ccc",Ed:"d E",Ehm:"E h:mm a",EHm:"E HH:mm",Ehms:"E h:mm:ss a",EHms:"E HH:mm:ss",Gy:"y G",GyMMM:"MMM y G",GyMMMd:"MMM d, y G",GyMMMEd:"E, MMM d, y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"M/d",MEd:"E, M/d",MMM:"LLL",MMMd:"MMM d",MMMEd:"E, MMM d",MMMMd:"MMMM d",ms:"mm:ss","y":"y",yM:"M/y",yMd:"M/d/y",yMEd:"E, M/d/y",yMMM:"MMM y",yMMMd:"MMM d, y",yMMMEd:"E, MMM d, y",yMMMM:"MMMM y",yQQQ:"QQQ y",yQQQQ:"QQQQ y"},dateFormats:{yMMMMEEEEd:"EEEE, MMMM d, y",yMMMMd:"MMMM d, y",yMMMd:"MMM d, y",yMd:"M/d/yy"},timeFormats:{hmmsszzzz:"h:mm:ss a zzzz",hmsz:"h:mm:ss a z",hms:"h:mm:ss a",hm:"h:mm a"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12"],long:["Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["B","A","BCE","CE"],short:["BC","AD","BCE","CE"],long:["Before Christ","Anno Domini","Before Common Era","Common Era"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],long:["January","February","March","April","May","June","July","August","September","October","November","December"]},days:{narrow:["S","M","T","W","T","F","S"],short:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],long:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"]},eras:{narrow:["Before R.O.C.","Minguo"],short:["Before R.O.C.","Minguo"],long:["Before R.O.C.","Minguo"]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:".",group:",",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"A$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",TWD:"NT$",USD:"$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 509 */
/***/ (function(module, exports) {

IntlPolyfill.__addLocaleData({locale:"pt-BR",date:{ca:["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc"],hourNo0:true,hour12:false,formats:{short:"{1} {0}",medium:"{1} {0}",full:"{1} {0}",long:"{1} {0}",availableFormats:{"d":"d","E":"ccc",Ed:"E, d",Ehm:"E, h:mm a",EHm:"E, HH:mm",Ehms:"E, h:mm:ss a",EHms:"E, HH:mm:ss",Gy:"y G",GyMMM:"MMM 'de' y G",GyMMMd:"d 'de' MMM 'de' y G",GyMMMEd:"E, d 'de' MMM 'de' y G","h":"h a","H":"HH",hm:"h:mm a",Hm:"HH:mm",hms:"h:mm:ss a",Hms:"HH:mm:ss",hmsv:"h:mm:ss a v",Hmsv:"HH:mm:ss v",hmv:"h:mm a v",Hmv:"HH:mm v","M":"L",Md:"d/M",MEd:"E, dd/MM",MMdd:"dd/MM",MMM:"LLL",MMMd:"d 'de' MMM",MMMEd:"E, d 'de' MMM",MMMMd:"d 'de' MMMM",MMMMEd:"E, d 'de' MMMM",ms:"mm:ss","y":"y",yM:"MM/y",yMd:"dd/MM/y",yMEd:"E, dd/MM/y",yMM:"MM/y",yMMM:"MMM 'de' y",yMMMd:"d 'de' MMM 'de' y",yMMMEd:"E, d 'de' MMM 'de' y",yMMMM:"MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMMEd:"E, d 'de' MMMM 'de' y",yQQQ:"y QQQ",yQQQQ:"y QQQQ"},dateFormats:{yMMMMEEEEd:"EEEE, d 'de' MMMM 'de' y",yMMMMd:"d 'de' MMMM 'de' y",yMMMd:"d 'de' MMM 'de' y",yMd:"dd/MM/yy"},timeFormats:{hmmsszzzz:"HH:mm:ss zzzz",hmsz:"HH:mm:ss z",hms:"HH:mm:ss",hm:"HH:mm"}},calendars:{buddhist:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["BE"],short:["BE"],long:["BE"]},dayPeriods:{am:"AM",pm:"PM"}},chinese:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"],long:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},dayPeriods:{am:"AM",pm:"PM"}},coptic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"],long:["Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},dangi:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"],long:["Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},dayPeriods:{am:"AM",pm:"PM"}},ethiopic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},ethioaa:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13"],short:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"],long:["Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0"],short:["ERA0"],long:["ERA0"]},dayPeriods:{am:"AM",pm:"PM"}},generic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"],long:["M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["ERA0","ERA1"],short:["ERA0","ERA1"],long:["ERA0","ERA1"]},dayPeriods:{am:"AM",pm:"PM"}},gregory:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["a.C.","d.C.","AEC","EC"],short:["a.C.","d.C.","AEC","EC"],long:["antes de Cristo","depois de Cristo","antes da Era Comum","Era Comum"]},dayPeriods:{am:"AM",pm:"PM"}},hebrew:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12","13","7"],short:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"],long:["Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AM"],short:["AM"],long:["AM"]},dayPeriods:{am:"AM",pm:"PM"}},indian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"],long:["Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["Saka"],short:["Saka"],long:["Saka"]},dayPeriods:{am:"AM",pm:"PM"}},islamic:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},islamicc:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H."],long:["Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AH"],short:["AH"],long:["AH"]},dayPeriods:{am:"AM",pm:"PM"}},japanese:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","M","T","S","H"],short:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"],long:["Taika (645–650)","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Keiun (704–708)","Wadō (708–715)","Reiki (715–717)","Yōrō (717–724)","Jinki (724–729)","Tenpyō (729–749)","Tenpyō-kampō (749-749)","Tenpyō-shōhō (749-757)","Tenpyō-hōji (757-765)","Tenpyō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770–780)","Ten-ō (781-782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Ninju (851–854)","Saikō (854–857)","Ten-an (857-859)","Jōgan (859–877)","Gangyō (877–885)","Ninna (885–889)","Kanpyō (889–898)","Shōtai (898–901)","Engi (901–923)","Enchō (923–931)","Jōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Tentoku (957–961)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Tenroku (970–973)","Ten’en (973–976)","Jōgen (976–978)","Tengen (978–983)","Eikan (983–985)","Kanna (985–987)","Eien (987–989)","Eiso (989–990)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Kantoku (1044–1046)","Eishō (1046–1053)","Tengi (1053–1058)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eihō (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Kahō (1094–1096)","Eichō (1096–1097)","Jōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Ten-ei (1110-1113)","Eikyū (1113–1118)","Gen’ei (1118–1120)","Hōan (1120–1124)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Hōen (1135–1141)","Eiji (1141–1142)","Kōji (1142–1144)","Ten’yō (1144–1145)","Kyūan (1145–1151)","Ninpei (1151–1154)","Kyūju (1154–1156)","Hōgen (1156–1159)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Eiman (1165–1166)","Nin’an (1166–1169)","Kaō (1169–1171)","Shōan (1171–1175)","Angen (1175–1177)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryaku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Ken’ei (1206–1207)","Jōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Jōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Jōei (1232–1233)","Tenpuku (1233–1234)","Bunryaku (1234–1235)","Katei (1235–1238)","Ryakunin (1238–1239)","En’ō (1239–1240)","Ninji (1240–1243)","Kangen (1243–1247)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun’ō (1260–1261)","Kōchō (1261–1264)","Bun’ei (1264–1275)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Einin (1293–1299)","Shōan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokuji (1306–1308)","Enkyō (1308–1311)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkō (1321–1324)","Shōchū (1324–1326)","Karyaku (1326–1329)","Gentoku (1329–1331)","Genkō (1331–1334)","Kenmu (1334–1336)","Engen (1336–1340)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Kentoku (1370–1372)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Kōō (1389–1390)","Meitoku (1390–1394)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Kakitsu (1441–1444)","Bun’an (1444–1449)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Bunmei (1469–1487)","Chōkyō (1487–1489)","Entoku (1489–1492)","Meiō (1492–1501)","Bunki (1501–1504)","Eishō (1504–1521)","Taiei (1521–1528)","Kyōroku (1528–1532)","Tenbun (1532–1555)","Kōji (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenshō (1573–1592)","Bunroku (1592–1596)","Keichō (1596–1615)","Genna (1615–1624)","Kan’ei (1624–1644)","Shōho (1644–1648)","Keian (1648–1652)","Jōō (1652–1655)","Meireki (1655–1658)","Manji (1658–1661)","Kanbun (1661–1673)","Enpō (1673–1681)","Tenna (1681–1684)","Jōkyō (1684–1688)","Genroku (1688–1704)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Genbun (1736–1741)","Kanpō (1741–1744)","Enkyō (1744–1748)","Kan’en (1748–1751)","Hōreki (1751–1764)","Meiwa (1764–1772)","An’ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kyōwa (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpō (1830–1844)","Kōka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man’en (1860–1861)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","Meiji","Taishō","Shōwa","Heisei"]},dayPeriods:{am:"AM",pm:"PM"}},persian:{months:{narrow:["1","2","3","4","5","6","7","8","9","10","11","12"],short:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"],long:["Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["AP"],short:["AP"],long:["AP"]},dayPeriods:{am:"AM",pm:"PM"}},roc:{months:{narrow:["J","F","M","A","M","J","J","A","S","O","N","D"],short:["jan","fev","mar","abr","mai","jun","jul","ago","set","out","nov","dez"],long:["janeiro","fevereiro","março","abril","maio","junho","julho","agosto","setembro","outubro","novembro","dezembro"]},days:{narrow:["D","S","T","Q","Q","S","S"],short:["dom","seg","ter","qua","qui","sex","sáb"],long:["domingo","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","sábado"]},eras:{narrow:["Antes de R.O.C.","R.O.C."],short:["Antes de R.O.C.","R.O.C."],long:["Antes de R.O.C.","R.O.C."]},dayPeriods:{am:"AM",pm:"PM"}}}},number:{nu:["latn"],patterns:{decimal:{positivePattern:"{number}",negativePattern:"{minusSign}{number}"},currency:{positivePattern:"{currency}{number}",negativePattern:"{minusSign}{currency}{number}"},percent:{positivePattern:"{number}{percentSign}",negativePattern:"{minusSign}{number}{percentSign}"}},symbols:{latn:{decimal:",",group:".",nan:"NaN",plusSign:"+",minusSign:"-",percentSign:"%",infinity:"∞"}},currencies:{AUD:"AU$",BRL:"R$",CAD:"CA$",CNY:"CN¥",EUR:"€",GBP:"£",HKD:"HK$",ILS:"₪",INR:"₹",JPY:"JP¥",KRW:"₩",MXN:"MX$",NZD:"NZ$",PTE:"Esc.",THB:"฿",TWD:"NT$",USD:"US$",VND:"₫",XAF:"FCFA",XCD:"EC$",XOF:"CFA",XPF:"CFPF"}}});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_authentication__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Footer__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Map__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_New__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_New___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_New__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_User__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Link__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_DocumentConfig__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_DocumentConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_DocumentConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Catalog__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Catalog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Catalog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_grommet_components_icons_base_FormTrash__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_grommet_components_icons_base_FormTrash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_grommet_components_icons_base_FormTrash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_grommet_components_icons_base_FormNextLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_grommet_components_icons_base_FormNextLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_grommet_components_icons_base_FormNextLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_grommet_components_icons_base_FormEdit__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_grommet_components_icons_base_FormEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_grommet_components_icons_base_FormEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__LoadFiles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Notifications__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__WhatsNew__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__UserDetails__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__SizerScreens__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_history_createBrowserHistory__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__SizerHome_ReferenceArchitecture__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__SizerUI_SizerScreens_ReferenceArchitecture__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__SAPLOOKUP__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_grommet_components_icons_base_Note__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_grommet_components_icons_base_Note___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_grommet_components_icons_base_Note__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_grommet_components_icons_base_CircleQuestion__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_grommet_components_icons_base_CircleQuestion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_grommet_components_icons_base_CircleQuestion__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import WorkshopIcon from 'grommet/components/icons/base/Workshop';
//import Select from 'grommet/components/Select';
//import CustomFooter from './CustomFooter';
//import WhatsNewPage from '../../SizerUI/SizerScreens/WhatsNew';
//import SAPLOOKUP from '../.././SizerUI/./SizerScreens/SAPLOOKUP';
//Commenting the below importas this is applicable only for cs750 and declearing again
//import { SIZING_MODES } from '../../SizerUI/Redux/reducers/sizerWorkload';
var SIZING_MODES=['CS750Sizing','SynergySizing','vSANSizing','VDISizing','OCPSizing'];var history=__WEBPACK_IMPORTED_MODULE_42_history_createBrowserHistory___default()();var AdditionalList='';var TotalCountyNames=[];var CountyList=[];//let About = [];
var EPASizingHomeMenuItems=void 0;var Screens=[];function CreateGuid(){function _p8(s){var p=(Math.random().toString(16)+"000000000").substr(2,8);return s?"-"+p.substr(0,4)+"-"+p.substr(4,4):p;}return _p8().toUpperCase()+_p8().toUpperCase()+_p8().toUpperCase()+_p8().toUpperCase();}var DisagreeScreen='';var HPECP_SIZER="EzmeralCPSizer".toUpperCase();var HPECP_HOMEPAGE_CONTENT="Build a HPE Ezmeral Runtime Enterprise Solution";var ssetURL='';var hideforSSET='False';var MyMain=function(_Component){_inherits(MyMain,_Component);function MyMain(){_classCallCheck(this,MyMain);var _this=_possibleConstructorReturn(this,(MyMain.__proto__||Object.getPrototypeOf(MyMain)).call(this));_this.buildAdditionalSolution=function(type){_this.props.onUpdateActiveSession(_this.props.sizerWorkLoad);_this.props.onSaveCurrentSession();_this.props.onAddSession(CreateGuid(),'Default Session');var temp=type;var specificPages=_this.state.RouteObj.filter(function(route,id){if(route.type===undefined)return route;else{if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'){if(route.type===temp){return route;}}}});_this.props.history.push(specificPages[0]['path']);_this.props.onNewSession(_this.props.blueDataworkloadTemplate);_this.props.onUpdateDefaultSession(_this.props.DefaultInputs);};_this.state={ProfileInformation:{"Name":'',"Email":'',"Country":''},WhatsnewJson:'',referenceArchitectureState:false,OtherReferalSites:false,whatsNew:false,HowTo:false,About:false,UserGuide:false,LoadItemTitle:'',LoadPopupScr:false,AdditionalInfoPop:false,HomePageJson:'',CountyName:TotalCountyNames,EULAInformation:false,selectedCountry:'United States',ShowCountryChangeAlert:false,Change_Session:'',showUpdateSession:false,showDelSession:false,SessionName:{},DelSession:{},SessionNameTxt:'',SAPLookuplayer:false,modeSelected:'CS750',notifications:[],userClosedNotifications:false,agreeDisagreeClicked:false};_this.closePopUps=_this.closePopUps.bind(_this);_this.WhatsNewParent=_this.WhatsNewParent.bind(_this);_this.AboutClick=_this.AboutClick.bind(_this);_this.UserGuideClick=_this.UserGuideClick.bind(_this);_this.WhatsNewClick=_this.WhatsNewClick.bind(_this);_this.HowToClick=_this.HowToClick.bind(_this);_this.UserDetailsClick=_this.UserDetailsClick.bind(_this);_this.AdditionalInfo=_this.AdditionalInfo.bind(_this);_this.LoadWorkloadPopupClick=_this.LoadWorkloadPopupClick.bind(_this);_this.LoadSolutionPopupClick=_this.LoadSolutionPopupClick.bind(_this);_this.getNewRoute=_this.getNewRoute.bind(_this);_this.EULAInformationPopUpClose=_this.EULAInformationPopUpClose.bind(_this);_this.ShowDelSession=_this.ShowDelSession.bind(_this);_this.CloseDelSession=_this.CloseDelSession.bind(_this);_this.SessionTxtChange=_this.SessionTxtChange.bind(_this);_this.Submit_Update_Session=_this.Submit_Update_Session.bind(_this);_this.Submit_Change_Session=_this.Submit_Change_Session.bind(_this);_this.Submit_Delete_Session=_this.Submit_Delete_Session.bind(_this);_this.ReferernceArchitecture=_this.ReferernceArchitecture.bind(_this);_this.udateScreens=_this.udateScreens.bind(_this);_this.onSizingModeChange=_this.onSizingModeChange.bind(_this);_this.onSAPLookupClick=_this.onSAPLookupClick.bind(_this);_this.BuildSolutionEvents=_this.BuildSolutionEvents.bind(_this);_this.getTile=_this.getTile.bind(_this);_this.closeNotifications=_this.closeNotifications.bind(_this);_this.DisagreeClicked=_this.DisagreeClicked.bind(_this);_this.yesorCancelClicked=_this.yesorCancelClicked.bind(_this);_this.updateValue=_this.updateValue.bind(_this);return _this;}_createClass(MyMain,[{key:'closeNotifications',value:function closeNotifications(){this.props.showNotifications.enabled=false;this.setState({userClosedNotifications:true});}},{key:'onSAPLookupClick',value:function onSAPLookupClick(){this.setState({SAPLookuplayer:true,LoadPopupScr:false,AdditionalInfoPop:false,whatsNew:false,HowTo:false,About:false});}},{key:'ReferernceArchitecture',value:function ReferernceArchitecture(){this.setState({referenceArchitectureState:true});}},{key:'componentDidMount',value:function componentDidMount(){Screens=__WEBPACK_IMPORTED_MODULE_41__SizerScreens__["a" /* interviewScreens */];this.state.RouteObj=__WEBPACK_IMPORTED_MODULE_41__SizerScreens__["a" /* interviewScreens */];var queryParameter=__WEBPACK_IMPORTED_MODULE_5_query_string___default.a.parse(this.props.location.search);var userData={"reference":queryParameter.reference,"isSizerAsEntry":queryParameter.isSizerAsEntry?true:false};if(userData.reference!=undefined&&!this.props.sset){this.setState({EULAInformation:false});this.props.onLoadSessionfromSSET(userData);if(!queryParameter.isSizerAsEntry){this.props.updateSSETId(queryParameter.reference);}if(this.props.guiState!==undefined){this.props.guiState.isSizerAsEntry=queryParameter.isSizerAsEntry?"True":"False";}if(queryParameter.reviewed){this.props.sessionsState.ssetConfigurations.reviewed=true;}if(queryParameter.uInfo){this.props.sessionsState.ssetConfigurations.uInfo=queryParameter.uInfo;}}else{if(this.props.guiState!==undefined){this.props.guiState.isSizerAsEntry=queryParameter.isSizerAsEntry?"True":"False";}this.setState({EULAInformation:this.props.EULAInformation});if(this.props.notifications==null){userData={"UserId":this.props.userData.email,//"UserId": "test@hpe.com",      
//"SizerId": "SAPSizer"
"SizerId":__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]};this.props.onLoadNotifications(userData);//this.props.onLoadNotifications(this.props.userData.email);       
}}if(this.props.sizerState&&!this.props.sizerState.LookupServers){this.props.OnFetchLookupServersList(this.props.country);}try{if(ssetURL===''){if(queryParameter.reference!==undefined)hideforSSET='True';else hideforSSET='False';this.getSSETURL();}}catch(e){}// if (said === 'SAPHANA') {
//   this.props.onUpdateDefaultSession(this.props.DefaultInputs);
// }
//this.setState({ EULAInformation: 'false' });
// if(this.state.HomePageJson.Sizers.Sizer["ProfileInformation"] ==undefined){
// }
// this.state.HomePageJson = HomeInformation;
// console.log(this.state.HomePageJson);
//   console.log(this.props.DefaultInputs);
// this.setState({HomePageJson: this.props.DefaultInputs});
//  console.log(this.state.HomePageJson);
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.notifications!=this.props.notifications){var data=nextProps.notifications;if(data.length===0){this.props.showNotifications.enabled=false;}else{this.props.showNotifications.enabled=true;}this.setState({notifications:data});}if(nextProps.activeSession!==""){if(nextProps.activeSession.id!==""){if(nextProps.activeSession.id!==this.props.activeSession.id){if(nextProps.activeSession.treeView!==''){var obj="";if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'){obj={"Workload":nextProps.activeSession.workload};}else{obj=nextProps.activeSession.workload;}this.props.onNewSession(obj);//this.props.redirectTo('/Build/SolnAlternative');
this.props.history.push('/Build/SolnAlternative');}else{var _obj="";if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'){_obj={"Workload":nextProps.activeSession.workload// this.props.guiState.SizingMode = nextProps.activeSession.workload.UserInputs.SizerMode;
};}else{_obj=nextProps.activeSession.workload;}this.props.onUpdateDefaultSession(this.props.DefaultInputs);this.props.onNewSession(_obj);var redirectionPath='';if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'){var specificPages=__WEBPACK_IMPORTED_MODULE_41__SizerScreens__["a" /* interviewScreens */].filter(function(route,id){if(route.type===nextProps.activeSession.workload.UserInputs.Environments.WorkloadType){return route;}});redirectionPath=specificPages[0].path;this.getNewRoute(redirectionPath);}else{if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer')redirectionPath=_obj.Workload.UserInputs.isSized==='True'?Screens[1].path:Screens[0].path;else redirectionPath=Screens[0].path;this.getNewRoute(redirectionPath);}// this.props.history.push('/Build/ContactInfo');
}}}}}},{key:'ShowDelSession',value:function ShowDelSession(delItem){this.setState({showDelSession:true,DelSession:delItem});}},{key:'udateScreens',value:function udateScreens(said,choice){var temp=[];switch(said){case'SAPHANA':temp=Screens;break;}}},{key:'CloseDelSession',value:function CloseDelSession(){this.setState({showDelSession:false,SessionName:{},DelSession:{},showUpdateSession:false});}},{key:'WhatsNewParent',value:function WhatsNewParent(){this.closePopUps();}},{key:'EULAInformationPopUpClose',value:function EULAInformationPopUpClose(){// this.props.EULAInformation = false;
this.props.onUpdateEULA(false);this.setState({EULAInformation:false});}},{key:'Submit_Delete_Session',value:function Submit_Delete_Session(SessionID){// if(this.props.GlobalErr !='' && this.props.GlobalErr.isError){
//   this.setState({ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg});
// }else{
this.props.onDeleteSession(SessionID);this.CloseDelSession();// }
}},{key:'getSSETURL',value:function getSSETURL(){var tokenUrl='SizingEngine/GetconfigDetails';var type='urlToken';console.log(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]);var url=__WEBPACK_IMPORTED_MODULE_4__AppConfig__["g" /* serviceUrl */]+tokenUrl;this.fetchSSETURL(url,type).then(function(result){console.log(result);try{ssetURL=result.redirectToken;window.sessionStorage.setItem("ssetURL",result.redirectToken);}catch(e){}});}},{key:'fetchSSETURL',value:function fetchSSETURL(url,type){return new Promise(function(resolve,reject){fetch(url,{method:'GET',headers:{'Accept':'application/json','Content-Type':'application/json','Cache':'no-cache'},credentials:'same-origin'}).then(function(response){console.log(response);if(!response.ok){throw Error(response.statusText);}if(type==='urlToken'){var data={};data.redirectToken=response.headers.get('redirectToken');data.continuetoSSETToken=response.headers.get('continueRedirectToken');resolve(data);}return response.json();});});}},{key:'updateValue',value:function updateValue(){//console.log('insideupdatevalue',ssetURL);
this.setState({});}},{key:'Submit_Change_Session',value:function Submit_Change_Session(SessionID){var _this2=this;// if(this.props.GlobalErr !='' && this.props.GlobalErr.isError){
//   this.setState({ErrorPopup: true, ErrorPopupMsg: this.props.GlobalErr.errorMsg});
// }else{
//   var errorObj = { isError:false, errorMsg:''};
//   this.props.updateError(errorObj);
var CurrentCountry=this.props.country;// this.props.onUpdateActiveSession(this.props.sizerWorkLoad);
// this.props.onSaveCurrentSession();
this.props.onChangeSession(SessionID);var workload='';this.props.allSessions.map(function(value,index){if(value.id===SessionID)workload=value.workload;});this.props.onNewSession(workload);this.props.allSessions.filter(function(sessionItem,index){if(sessionItem.id===SessionID){if(sessionItem.treeView!==''){if(CurrentCountry===sessionItem.treeView.Solutions['@Country']){_this2.props.history.push('/Build/SolnAlternative');__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').show();}else{_this2.setState({ShowCountryChangeAlert:true,Change_Session:sessionItem});__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').show();}}else{if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'){var specificPages=_this2.state.RouteObj.filter(function(route,id){if(route.type===sessionItem.workload.UserInputs.Environments.WorkloadType){return route;}});_this2.props.history.push(specificPages[0]['path']);}else{_this2.props.history.push(_this2.state.RouteObj[0]['path']);}__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();}}});// if(this.props.activeSession.treeView !== ''){
//   this.props.history.push('/Build/SolnAlternative');
// }else{
//   // this.props.history.push('/Build/ContactInfo');
//   this.props.history.push(this.state.RouteObj[0]['path']);
// }
// }
}},{key:'onSizingModeChange',value:function onSizingModeChange(e){this.setState({modeSelected:e.target.value});this.props.guiState.SizingMode=e.target.value;}},{key:'Submit_Update_Session',value:function Submit_Update_Session(){if(this.state.SessionNameTxt.trim()!==''){this.state.SessionName.alias=this.state.SessionNameTxt;this.props.onSaveCurrentSession();this.props.onUpdateSession(this.state.SessionName);if(this.props.activeSession.id===this.state.SessionName.id){this.props.onChangeSession(this.props.activeSession.id);}this.setState({showDelSession:false,showUpdateSession:false,SessionName:{},DelSession:''});}}},{key:'SessionTxtChange',value:function SessionTxtChange(e){if(e.target.value.length<=25){this.setState({SessionNameTxt:e.target.value});}}},{key:'onSelCountry',value:function onSelCountry(e){var obj=this.state.ProfileInformation;obj.Country=e.target.innerHTML.trim();this.props.onCountryChange(obj.Country);this.setState({//selectedCountry: obj.Country,
ProfileInformation:obj,HowTo:false,whatsNew:false,About:false,AdditionalInfoPop:false});}},{key:'closePopUps',value:function closePopUps(){this.setState({LoadItemTitle:'',LoadPopupScr:false,HowTo:false,whatsNew:false,About:false,AdditionalInfoPop:false,referenceArchitectureState:false,userDetailsPop:false,SAPLookuplayer:false,UserGuide:false});}},{key:'AdditionalInfo',value:function AdditionalInfo(){this.setState({HowTo:false,whatsNew:false,About:false,AdditionalInfoPop:true,userDetailsPop:false});}},{key:'AboutClick',value:function AboutClick(){this.setState({About:true,HowTo:false,whatsNew:false,userDetailsPop:false,UserGuide:false});}},{key:'UserGuideClick',value:function UserGuideClick(){this.setState({About:false,HowTo:false,whatsNew:false,userDetailsPop:false,UserGuide:true});}},{key:'WhatsNewClick',value:function WhatsNewClick(){this.setState({AdditionalInfoPop:false,whatsNew:true,HowTo:false,About:false,userDetailsPop:false});}},{key:'UserDetailsClick',value:function UserDetailsClick(){this.setState({AdditionalInfoPop:false,whatsNew:false,HowTo:false,About:false,userDetailsPop:true});}},{key:'HowToClick',value:function HowToClick(){this.setState({HowTo:false,whatsNew:false,About:false,userDetailsPop:false});}},{key:'getNewRoute',value:function getNewRoute(str){this.closePopUps();this.props.history.push(str);}},{key:'LoadWorkloadPopupClick',value:function LoadWorkloadPopupClick(){if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAP'){// this.props.onNewSession(this.props.workloadTemplate);
this.props.onUpdateDefaultSession(this.props.DefaultInputs);}this.setState({LoadItemTitle:'Workload',LoadPopupScr:true,AdditionalInfoPop:false,whatsNew:false,HowTo:false,About:false});}},{key:'LoadSolutionPopupClick',value:function LoadSolutionPopupClick(){// loadData = this.props.onLoadSolution('', '');
this.setState({LoadItemTitle:'Solution',LoadPopupScr:true,AdditionalInfoPop:false,whatsNew:false,HowTo:false,About:false});}},{key:'DisagreeClicked',value:function DisagreeClicked(){this.EULAInformationPopUpClose();this.setState({agreeDisagreeClicked:true});}},{key:'yesorCancelClicked',value:function yesorCancelClicked(e){DisagreeScreen='';this.closePopUps();this.setState({EULAInformation:true,agreeDisagreeClicked:false});if(e.target.id==='btnYes'){//window.open(appUrl,'_self');
//window.open(window.location.protocol+'//'+window.location.host,'_self')
if(window.sessionStorage.getItem("IsParent")==="True"){window.open(window.location.protocol+'//'+window.location.host,'_self');}else{window.top.close();}}}},{key:'BuildSolutionEvents',value:function BuildSolutionEvents(){this.udateScreens();console.log(Screens);__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();this.props.onUpdateActiveSession(this.props.sizerWorkLoad);this.props.onSaveCurrentSession();this.props.onAddSession(CreateGuid(),'Default Session');// this.props.history.push('/Build/ContactInfo');
this.props.history.push(Screens[0]['path']);if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPA'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAP'){this.props.onNewSession(this.props.workloadTemplate);this.props.onUpdateDefaultSession(this.props.DefaultInputs);}else if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'){this.props.guiState.isValueChanged=false;this.props.guiState.isNoPreferenceStorage='False';if(this.props.allSessions.length>0){var obj={"Workload":this.props.workloadTemplate};obj.Workload.UserInputs.SizerMode=this.props.guiState.SizingMode;this.props.onNewSession(obj);}}}},{key:'getTile',value:function getTile(title,method,text,btnText,mode){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{seperator:'bottom',tag:'h4',strong:true,style:{color:'#2ad2c9',marginBottom:'0px'}},' ',title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{size:'small',className:'customclass'},text),' ',title==='General Purpose Sizing'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{border:'2px solid #01a982',backgroundColor:'#01a982',width:'60%',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_grommet_components_icons_base_FormNextLink___default.a,{style:{stroke:'white'}}),style:{fontSize:'17px',margin:'2px',color:'white',fontWeight:'500'},label:btnText,onClick:function onClick(){if(mode!==undefined){_this3.props.guiState.SizingMode=mode;_this3.setState({modeSelected:mode});}method();},primary:true,reverse:true})));}},{key:'render',value:function render(){var _this4=this;//About = null;
var whatsnewButton=void 0;if(this.props.WhatsNewContent!==undefined&&this.props.WhatsNewContent!==''){this.state.WhatsnewJson=this.props.WhatsNewContent;whatsnewButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{className:'active WeightFontColor',onClick:this.WhatsNewClick,label:'What\'s New',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_New___default.a,{colorIndex:'#ff8d6d',size:'small'})});}var userDetails=void 0;if(this.props.userData!==undefined&&this.props.userData.username!=undefined//){
&&this.props.userData.email!=="default@test.com"&&this.props.userData.username!=="default"){userDetails=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{className:'active WeightFontColor',onClick:this.UserDetailsClick,label:'Hello '+this.props.userData.username,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_User___default.a,{colorIndex:'#ff8d6d',size:'small'})}));}var SizerCaption=void 0;if(this.props.DefaultInputs!==undefined&&this.props.DefaultInputs!==''){SizerCaption=this.props.DefaultInputs["Sizers"]["SizerCaption"];// if(basename.indexOf('GeneralPurposeSizer') !== -1)
// {
//   //this.state.HomePageJson.Sizers.Sizer.SizerCaption='General Purpose Sizer';
//   SizerCaption = 'HPE Sizer for Synergy Infrastructure';
// }
var docName=SizerCaption;var UserGuide=" UserGuide";switch(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]){case'EPAvNext':docName='HPE Sizing Tool for EPA ';break;}this.state.HomePageJson=this.props.DefaultInputs;if(TotalCountyNames.length==0){this.props.countries.Countries.Country.map(function(val){TotalCountyNames.push(val["Name"]);});}CountyList=TotalCountyNames.map(function(selCountry,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{key:index,onClick:this.onSelCountry.bind(this)},' ',selCountry,' ');}.bind(this));//About = this.props.DefaultInputs.Sizers.Sizer.About.Para1
/* display menu content dynamically stats here*/var that=this;var style={//backgroundColor:'rgba(66, 85, 99, 0.54)',
padding:'10px',width:'33%',borderTop:'3px solid #2ad2c9'//basename.indexOf('GeneralPurposeSizer') === -1 ?
};if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="EPAvNext"){UserGuide=" User Guide";var defaultsIndex;if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */].toUpperCase().indexOf(HPECP_SIZER)>-1){defaultsIndex=this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.findIndex(function(x){return x["@Title"]==="Build BigData Solution";});this.props.DefaultInputs["Sizers"]["SizerCaption"]=__WEBPACK_IMPORTED_MODULE_4__AppConfig__["h" /* title */];docName='EPA HPE Ezmeral Runtime Enterprise Sizer Online -';}else{defaultsIndex=this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.findIndex(function(x){return x["@Title"]===HPECP_HOMEPAGE_CONTENT;});docName='EPA BigData Sizer Online -';}if(defaultsIndex>=0){this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.splice(defaultsIndex,1);}}__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]!=='SynergySizer'?EPASizingHomeMenuItems=this.props.DefaultInputs.Sizers.Sizer.Index.Sections.Section.map(function(item){var SpaceforLoad='start';var ChooseRadiobutton;var onClickAction;var TitleIcon;var titleTag=item["@Title"];switch(titleTag){case'Load Previously Saved Solution':SpaceforLoad='center';onClickAction=_this4.LoadSolutionPopupClick;TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info___default.a,{size:'large',colorIndex:'accent-1'});break;case'Load Solution':SpaceforLoad='center';onClickAction=_this4.LoadSolutionPopupClick;TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info___default.a,{size:'large',colorIndex:'accent-1'});break;case'Load Previously Saved Workload':SpaceforLoad='center';onClickAction=_this4.LoadWorkloadPopupClick;TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_DocumentConfig___default.a,{size:'large',colorIndex:'accent-1'});break;case'Load Workload':SpaceforLoad='center';onClickAction=_this4.LoadWorkloadPopupClick;TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_DocumentConfig___default.a,{size:'large',colorIndex:'accent-1'});break;case'Build a New Solution':TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=function onClickAction(){_this4.BuildSolutionEvents();};break;case'Build Solution':TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=function onClickAction(){_this4.udateScreens();console.log(Screens);__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();_this4.props.onUpdateActiveSession(_this4.props.sizerWorkLoad);_this4.props.onSaveCurrentSession();_this4.props.onAddSession(CreateGuid(),'Default Session');// this.props.history.push('/Build/ContactInfo');
_this4.props.history.push(Screens[0]['path']);if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPA'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAP'){_this4.props.onNewSession(_this4.props.workloadTemplate);_this4.props.onUpdateDefaultSession(_this4.props.DefaultInputs);}else if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'){if(_this4.props.allSessions.length>0){var obj={"Workload":_this4.props.workloadTemplate};obj.Workload.UserInputs.SizerMode=_this4.props.guiState.SizingMode;_this4.props.onNewSession(obj);}}};break;case'Build SAP Appliance Solution':TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=function onClickAction(){_this4.udateScreens();console.log(Screens);__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();_this4.props.onUpdateActiveSession(_this4.props.sizerWorkLoad);_this4.props.onSaveCurrentSession();_this4.props.onAddSession(CreateGuid(),'Default Session');// this.props.history.push('/Build/ContactInfo');
_this4.props.history.push(Screens[0]['path']);if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'){_this4.props.onNewSession(_this4.props.workloadTemplate);// this.props.onUpdateDefaultSession(this.props.DefaultInputs);
_this4.props.GetWorkloadWithMainstream(_this4.props.country);}};break;case'Build BigData Solution':TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=function onClickAction(){__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();//this.props.onblueorbigUpdate("BigData")
_this4.props.onUpdateActiveSession(_this4.props.sizerWorkLoad);_this4.props.onSaveCurrentSession();_this4.props.onAddSession(CreateGuid(),'Default Session');_this4.props.history.push(_this4.state.RouteObj[0]['path']);_this4.props.onNewSession(_this4.props.workloadTemplate);_this4.props.onUpdateDefaultSession(_this4.props.DefaultInputs);};break;case HPECP_HOMEPAGE_CONTENT:TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=function onClickAction(){__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();// this.props.onblueorbigUpdate("BlueData")
_this4.props.onUpdateActiveSession(_this4.props.sizerWorkLoad);_this4.props.onSaveCurrentSession();_this4.props.onAddSession(CreateGuid(),'Default Session');var temp='BlueData';var specificPages=_this4.state.RouteObj.filter(function(route,id){if(route.type===undefined)return route;else{if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'){if(route.type===temp){return route;}}}});_this4.props.history.push(specificPages[0]['path']);_this4.props.onNewSession(_this4.props.blueDataworkloadTemplate);_this4.props.onUpdateDefaultSession(_this4.props.DefaultInputs);};break;case'Build SAP TDI Solution':TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_ObjectUngroup___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=function onClickAction(){__WEBPACK_IMPORTED_MODULE_40_jquery___default()('#footer').hide();// this.props.onblueorbigUpdate("BlueData")
_this4.buildAdditionalSolution('TDI');};break;case"SAPS Lookup":// SpaceforLoad='center';
TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46_grommet_components_icons_base_Note___default.a,{size:'large',colorIndex:'accent-1'});onClickAction=_this4.onSAPLookupClick;break;case'Choose Server Type':TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Link___default.a,{size:'large',colorIndex:'accent-1'});//ChooseRadiobutton = <RadioButton checked="true" className="SynergychooseRadiobtn" />
//   ChooseRadiobutton = <Select inline={true} value={that.props.guiState.SizingMode} options={SIZING_MODES} onChange={this.onSizingModeChange} />
ChooseRadiobutton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{marginLeft:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',style:{marginLeft:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{value:SIZING_MODES[0],checked:that.props.guiState.SizingMode==="CS750Sizing"?true:false,className:'RdioBtnName',style:{color:'white'},id:'CS750',label:'CS750Sizing',onChange:_this4.onSizingModeChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{value:SIZING_MODES[1],checked:that.props.guiState.SizingMode==="SynergySizing"?true:false,className:'RdioBtnName',id:'ESXi',label:'SynergySizing',onChange:_this4.onSizingModeChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',style:{marginTop:'18px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{value:SIZING_MODES[2],checked:that.props.guiState.SizingMode==="vSANSizing"?true:false,className:'RdioBtnName',id:'vSAN',label:'vSANSizing',onChange:_this4.onSizingModeChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{marginLeft:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{value:SIZING_MODES[3],checked:that.props.guiState.SizingMode==="VDISizing"?true:false,className:'RdioBtnName',id:'VDI',label:'VDISizing',onChange:_this4.onSizingModeChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{marginLeft:'7px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_RadioButton___default.a,{value:SIZING_MODES[4],checked:that.props.guiState.SizingMode==="OCPSizing"?true:false,className:'RdioBtnName',id:'RedHat',label:'OCPSizing',onChange:_this4.onSizingModeChange}))));break;case'View Preconfigured Systems':break;case' Build your own solutions':break;case'Reference Architecture':onClickAction=_this4.ReferernceArchitecture;_this4.props.onUpdateDefaultSession(_this4.props.DefaultInputs);TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Link___default.a,{size:'large',colorIndex:'accent-1'});break;case'Additional Information':onClickAction=_this4.AdditionalInfo;TitleIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Link___default.a,{size:'large',colorIndex:'accent-1'});break;default:}if(item["@Title"]=="   Check for a Newer Version"){}else if(item["@Title"]=="   View Preconfigured Systems"){}else if(item["@Title"]=="   Let us build one for you"){}else if(item["Text"]=="Customer Information"){}else if(item["Text"]=="Company Name"){}else if(item["Text"]=="Project Name"){}else if(item["Text"]=="Project Contact Person e-Mail"){}else if(item["Text"]=="SAPS Lookup"){onClickAction=_this4.onSAPLookupClick;}else if(item["Text"]=="Use SAPS Lookup table to view the SAP value of a specific server model."){}else{var text_=item["Text"];if(item["@Title"]==='Reference Architecture'){if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */].toUpperCase().indexOf(HPECP_SIZER)!==-1){text_=item["Text"].replace('EPA','HPE Ezmeral Runtime Enterprise');}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'small',onClick:onClickAction,key:titleTag,className:'onHoverTab',align:'center',wrap:true,pad:'small',basis:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,null,TitleIcon)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h3',align:'center',strong:true,style:{color:'#fff'}},item["@Title"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',alignContent:'center',align:'center',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'none',style:{color:'#fff',textAlign:SpaceforLoad,width:'100%'}},ChooseRadiobutton,'  ',item['@Title']==='Choose Server Type'?'':text_)));}}):EPASizingHomeMenuItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',style:{alignItems:'center',width:'100%',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{padding:'10px 10px 10px 0px',width:'33%',borderTop:'3px solid #2ad2c9'}},this.getTile('General Purpose Sizing',this.BuildSolutionEvents,'This option allows you to size a general purpose virtualized solution with VMware ESXi on the HPE Synergy hardware platform.','Build New Solution','SynergySizing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:style,margin:'small'},this.getTile('vSAN Sizing',this.BuildSolutionEvents,'This option allows you to size a virtualized solution with VMware VCF or VSAN on the HPE Synergy hardware platform with vSAN certified compute, memory and storage.','Build New Solution','vSANSizing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:style,margin:'small'},this.getTile('VDI Sizing',this.BuildSolutionEvents,'This option allows you to size a VDI solution with Citrix XenServer or VMware ESXi on the HPE Synergy hardware platform with D3940, 3PAR StoreServ Storage/Nimble Storage.','Build New Solution','VDISizing'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',style:{alignItems:'center',width:'100%',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{padding:'10px 10px 10px 0px',width:'33%',borderTop:'3px solid #2ad2c9',paddingLeft:'0px !important'}},this.getTile('Load Previously Saved Solution',this.LoadSolutionPopupClick,' Click on this button to open up a previously saved completed solution including the Recommended Solution, Configuration Details, and Bill Of Materials (BOM).','Load Solution')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:style,margin:'small'},this.getTile('Load Previously Saved Workload',this.LoadWorkloadPopupClick,'  Click on this button to open up a previously saved workload so the workload data can be viewed or edited. This option is normally used to alter the data.','Load Workload'))));//Changes for Synergy Home page
if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'){// this.state.Sizercontentone = "The Synergy sizing tool is designed to assist users in identifying the HPE HW and SW needed to support a workload defined by the user. The tool will produce a general sizing BOM that can be used for budgetary quoting and as the foundation for creating live order quotes.After a detailed interview process, the HPE Sizer for ConvergedSystems Virtualization will generate a solution that details the hardware, software, and services best suited for the specific requirements. The resulting solution will include HPE Watson configuration guidance."
this.state.Sizercontentone="The Synergy sizing tool is designed to assist users in identifying the HPE HW and SW needed to support a workload defined by the user. The tool will produce a general sizing BOM that can be used for budgetary quoting and as the foundation for creating live order quotes.After a detailed interview process, the HPE Sizer for ConvergedSystems Virtualization will generate a solution that details the hardware, software, and services best suited for the specific requirements.";}}/*Display menu content ends here */var Textcontent='';if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'){Textcontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{width:'100%',alignItems:'center',marginTop:'20px'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{width:'100%'},justify:'start',align:'center',wrap:false,pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'TextcontentparagraphHome'},this.state.Sizercontentone)));}var WhatsnewHere;var AboutHere;var UserGuideHere;var HowToHere;var AdditionalInformation;var EULAInformationPopUp;var UserDetailsRender;if(/*(said === 'CS750VirtSizer') &&*/this.state.agreeDisagreeClicked){DisagreeScreen=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,{className:'DisagreeLayer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small',separator:'bottom',style:{backgroundColor:'#425563'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',style:{marginBottom:'0px',color:'#fff'}},this.state.HomePageJson.Sizers!==undefined?this.state.HomePageJson.Sizers.SizerCaption:'HPE Sizer for ConvergedSystems Virtualization'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{pad:{"vertical":"small"},align:'center',textAlign:'center',direction:'row',style:{height:'100px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47_grommet_components_icons_base_CircleQuestion___default.a,{style:{marginLeft:'10%'},size:'medium',colorIndex:'#ff9374'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Label___default.a,{style:{marginLeft:'2%'}},'Are you sure you wish to exit the application ?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Footer___default.a,{pad:{"vertical":"small"},separator:'top',align:'center',textAlign:'center',direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{name:'btnYes',id:'btnYes',primary:true,style:{marginLeft:'25%',width:'120px',height:'40px'},onClick:this.yesorCancelClicked},'Yes'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{name:'btnCancel',primary:true,style:{marginLeft:'3%',width:'120px',height:'40px'},onClick:this.yesorCancelClicked},'Cancel'))));}if(this.state.EULAInformation){EULAInformationPopUp=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,{className:'EULAPOPupLayer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small',className:'EULAcontentScroll',style:{overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h5',strong:true,uppercase:false,truncate:false,style:{color:'#01a982'}},'PLEASE READ CAREFULLY:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'1.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Applicability.'),'This end user license agreement (the "Agreement")   governs the use of accompanying software, unless it is subject to a separate agreement between you  and Hewlett Packard Enterprise Company and its subsidiaries (\u201CHPE\u201D). By downloading, copying, or using the software   you agree to this Agreement. HPE provides translations of this Agreement in certain languages other than English, which may be found at:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.hpe.com/software/SWLicensing',target:'_blank'},'http://www.hpe.com/software/SWLicensing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'2.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Terms.'),'This Agreement includes supporting material accompanying the software or referenced by HPE,  which may be software license information, additional license authorizations, software specifications,  published warranties, supplier terms, open source software licenses and similar content (Supporting Material).  Additional license authorizations are at:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.hpe.com/software/SWLicensing',target:'_blank'},'http://www.hpe.com/software/SWLicensing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'3.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Authorization.'),'If you agree to this Agreement on behalf of another person or entity, you warrant you have authority to do so.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'4.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Consumer Rights.'),'If you obtained software as a consumer, nothing in this Agreement affects your statutory rights.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'5.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Electronic Delivery.'),'HPE may elect to deliver software and related software product or license information by electronic transmission or download.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'6.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'License Grant.'),'If you abide by this Agreement, HPE grants you a non-exclusive non-transferable license to use one copy of the version or release of the accompanying software for your internal purposes only, and is subject to any specific software licensing information that is in the software product or its Supporting Material. Your use is subject to the following restrictions, unless specifically allowed in Supporting Material:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'- You may not use software to provide services to third parties.'),'- You may not make copies and distribute, resell or sublicense software to third parties.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'- You may not download and use patches, enhancements, bug fixes, or similar updates unless you have a license to the underlying software. However, such license doesn\'t automatically give you a right to receive such updates and HPE reserves the right to make such updates only available to customers with support contracts.'),'- You may not copy software or make it available on a public or external distributed network.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'- You may not allow access on an intranet unless it is restricted to authorized users.'),'- You may make one copy of the software for archival purposes or when it is an essential step in authorized use.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'- You may not modify, reverse engineer, disassemble, decrypt, decompile or make derivative works of software. If you have a mandatory right to do so under statute, you must inform HPE in writing about such modifications.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'7.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Remote Monitoring.'),'Some software may require keys or other technical protection measures and HPE may monitor your compliance with the Agreement, remotely or otherwise. If HPE makes a license management program for recording and reporting license usage information, you will use such program no later than 180 days from the date it\'s made available.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'8.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Ownership.'),'No transfer of ownership of any intellectual property will occur under this Agreement.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'9.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Copyright Notices.'),'You must reproduce copyright notices on software and documentation for authorized copies.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'10.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Operating Systems.'),'Operating system software may only be used on approved hardware and configurations.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'11.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'90-day Limited Warranty for HPE Software.'),'- HPE-branded software materially conforms to its specifications, if any, and is free of malware at the time of delivery; if you notify HPE within 90 days of delivery of non-conformance to this warranty, HPE will replace your copy. This Agreement states all remedies for warranty claims.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'- HPE does not warrant that the operation of software will be uninterrupted or error free, or that software will operate in hardware and software combinations other than as authorized by HPE in Supporting Material. To the extent permitted by law, HPE disclaims all other warranties.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'12.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Intellectual Property Rights Infringement.'),'HPE will defend and/or settle any claims against you that allege that HPE-branded software as supplied under this Agreement infringes the intellectual property rights of a third party. HPE will rely on your prompt notification of the claim and cooperation   with our defense. HPE may modify the software so as to be non-infringing and materially equivalent, or we may procure a license.  If these options are not available, we will refund to you the amount paid for the affected product in the first year or the depreciated  value thereafter. HPE is not responsible for claims resulting from any unauthorized use of the software.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'13.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Limitation of Liability.'),'HPE\'s liability to you under this Agreement is limited to the amount actually paid by you to HPE for the relevant software, except for amounts in Section 12 ("Intellectual Property Rights Infringement"). Neither you nor HPE will be liable for lost revenues or profits, downtime costs, loss or damage to data or indirect, special or consequential costs or damages. This provision does not limit either party\'s liability for: unauthorized use of intellectual property, death or bodily injury caused by their negligence; acts of fraud; willful repudiation of the Agreement; or any liability that may not be excluded or limited by applicable law.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'14.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Termination.'),'This Agreement is effective until terminated or in the case of a limited-term license, upon expiration; however, your rights under this Agreement terminate if you fail to comply with it. Immediately upon termination or expiration, you will destroy the software and documentation and any copies, or return them to HPE. You may keep one copy of software and documentation for archival purposes. We may ask you to certify in writing you have complied with this section. Warranty disclaimers, the limitation of liability, this section on termination, and Section 15 ("General") will survive termination.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'15.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'General.'),'a.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Assignment.'),'You may not assign this Agreement without prior written consent of HPE, payment of transfer fees and compliance with HPE\'s software license transfer policies. Authorized assignments will terminate your license to the software and you must deliver software and documentation and copies thereof to the assignee. The assignee will agree in writing to this Agreement. You may only transfer firmware if you transfer associated hardware.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'b.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'U.S. Government.'),'If the software is licensed to you for use in the performance of a U.S. Government prime contract or subcontract, you agree that, consistent with FAR 12.211 and 12.212, commercial computer software, computer software documentation and technical data for commercial items are licensed under HPE\'s standard commercial license.'),'c.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Global Trade Compliance.'),'You agree to comply with the trade-related laws and regulations of the U.S. and other national governments. If you export, import or otherwise transfer products provided under this Agreement, you will be responsible for obtaining any required export or import authorizations. You confirm that you are not located in a country that is subject to trade control sanctions (currently Cuba, Iran, N. Korea, N. Sudan, and Syria) and further agree that you will not retransfer the products to any such country. HPE may suspend its performance under this Agreement to the extent required by laws applicable to either party.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'d.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Audit.'),'HPE may audit you for compliance with the software license terms. Upon reasonable notice, HPE may conduct an audit during normal business hours (with the auditor\'s costs being at HPE\'s expense). If an audit reveals underpayments then you will pay to HPE such underpayments. If underpayments discovered exceed five (5) percent, you will reimburse HPE for the auditor costs.'),'e.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Open Source Components.'),'To the extent the Supporting Material includes open source licenses, such licenses shall control over this Agreement with respect to the particular open source component. To the extent Supporting Material includes the GNU General Public License or the GNU Lesser General Public License: (a) the software includes a copy of the source code; or (b) if you downloaded the software from a website, a copy of the source code is available on the same website; or (c) if you send HPE written notice, HPE will send you a copy of the source code for a reasonable fee.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'f.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Notices.'),'Written notices under this Agreement may be provided to HPE via the method provided in the Supporting Material.'),'g.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Governing Law.'),'This Agreement will be governed by the laws of the state of California, U.S.A., excluding rules as to choice and conflict of law. You and HPE agree that the United Nations Convention on Contracts for the International Sale of Goods will not apply.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'EULAPOPupSubtexts'},'h.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Force Majeure.'),'Neither party will be liable for performance delays nor for non-performance due to causes beyond its reasonable control, except for payment obligations.'),'i.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('u',null,'Entire Agreement.'),'This Agreement represents our entire understanding with respect to its subject matter and supersedes any previous communication or agreements that may exist. Modifications to the Agreement will be made only through a written amendment signed by both parties. If HPE doesn\'t exercise its rights under this Agreement, such delay is not a waiver of its rights.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'16.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Australian Consumers.'),'If you acquired the software as a consumer within the meaning of the \'Australian Consumer Law\' under the Australian Competition and Consumer Act 2010 (Cth) then despite any other provision of this Agreement, the terms at this URL apply:',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://www.hpe.com/software/SWLicensing',target:'_blank'},'http://www.hpe.com/software/SWLicensing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{margin:'small'},'17.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Russian Consumers.'),'If you are based in the Russian Federation and the rights to use the software are provided to you under a separate license and/or sublicense agreement concluded between you and a duly authorized HPE partner, then this Agreement shall not be applicable.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Footer___default.a,{pad:{"vertical":"small"},separator:'top',align:'center',textAlign:'center',direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{label:'Agree',primary:true,style:{marginLeft:'35%'},onClick:this.EULAInformationPopUpClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{label:'Disagree',primary:true,style:{marginLeft:'3%'},onClick:this.DisagreeClicked}))));}var layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,{className:'LoadPopupLayer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__LoadFiles__["a" /* default */],{title:this.state.LoadItemTitle,history:history,redirectTo:this.getNewRoute,onClose:this.closePopUps}));var notificationLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,{className:'LoadPopupLayerNotification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__Notifications__["a" /* default */],{close:this.closeNotifications}));var layerelement;if(this.state.LoadPopupScr){layerelement=layer;}else if(this.props.showNotifications.enabled){layerelement=notificationLayer;}// <Paragraph style={{ margin: '2px 0px' }}>To allow solutions to be imported in one ConfigAdvanced, go to "Options" in the Main menu and enable "Show OCA buttons in Solution Alternatives"</Paragraph>
if(this.state.About){var AboutLoop;var aboutObject=this.state.HomePageJson.Sizers.Sizer.About.Para1;if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'&&__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */].toUpperCase().indexOf(HPECP_SIZER)!==-1){aboutObject=this.state.HomePageJson.Sizers.Sizer.About.Para2;}if(Array.isArray(aboutObject)){AboutLoop=aboutObject.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},item);});}else{AboutLoop=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px'}},aboutObject);}AboutHere=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',direction:'column',className:'AboutContent',style:{width:'45%',height:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',className:'triangle-up',style:{margin:'auto 88%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{backgroundColor:'#fff',borderBottom:'3px solid #01a982'},className:'ListItemAlign1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',separator:'bottom',style:{backgroundColor:'#425563'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',style:{marginBottom:'0px',color:'#fff'}},this.state.HomePageJson.Sizers.SizerCaption)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default.a,{size:'small',className:'CloseIconStyle',style:{stroke:'#fff'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'small',pad:'none',align:'start',style:{margin:'2px 12px'}},AboutLoop),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',separator:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default.a,{direction:'row',size:'small',dropAlign:{"right":"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{style:{cursor:'Default'}},' Version ',__WEBPACK_IMPORTED_MODULE_4__AppConfig__["i" /* version */],' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{id:'mailTo',href:"mailto:ese_aa_solutions@hpe.com?Subject="+encodeURI(this.state.HomePageJson.Sizers.SizerCaption)+"%20(Online%20Client)%20-%20v%20"+__WEBPACK_IMPORTED_MODULE_4__AppConfig__["i" /* version */],style:{textDecoration:"underline"}},' Contact ')))));}else{AboutHere="";}if(this.state.UserGuide){UserGuideHere=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',direction:'column',style:{width:'28%',height:'auto',position:"absolute",top:"175px",right:"27%",transition:"0.5s ease-in-out"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',className:'triangle-up',style:{margin:'auto 88%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{backgroundColor:'#fff',borderBottom:'3px solid #01a982'},className:'ListItemAlign1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',separator:'bottom',style:{backgroundColor:'#425563'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',style:{marginBottom:'0px',color:'#fff'}},'UserGuide')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default.a,{size:'small',className:'CloseIconStyle',style:{stroke:'#fff'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small',separator:'top'},__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default.a,{size:'small',dropAlign:{"right":"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{href:__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */]+'/Docs/EPA BigData Sizer Online - User Guide.pdf',target:'_blank',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default.a,{colorIndex:'accent-3',size:'small'}),style:{textDecoration:"underline"}},'User Guide to EPA BigData Solution'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{href:__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */]+'/Docs/EPA HPE Container Platform Sizer Online - User Guide.pdf',target:'_blank',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default.a,{colorIndex:'accent-3',size:'small'}),style:{textDecoration:"underline"}},'User Guide to EPA HPE Container Platform Solution')):'',__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default.a,{size:'small',dropAlign:{"right":"right"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{href:__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */]+'Docs/User Guide to SAP Appliance Solution.pdf',target:'_blank',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default.a,{colorIndex:'accent-3',size:'small'}),style:{textDecoration:"underline"}},'User Guide to SAP Appliance Solution'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{href:__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */]+'Docs/User Guide to SAP TDI Solution.pdf',target:'_blank',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default.a,{colorIndex:'accent-3',size:'small'}),style:{textDecoration:"underline"}},'User Guide to SAP TDI Solution')):'')));}else{UserGuideHere="";}if(this.state.AdditionalInfoPop){if(Array.isArray(this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc)){AdditionalList=this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc.map(function(val,id){// <td> {val["Name"]}  </td>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_TableRow___default.a,{key:id.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{style:{cursor:'pointer'},onClick:function onClick(){return window.open(decodeURIComponent(val["Url"]));}},'  ',val["Name"],'  ')));});}else{AdditionalList=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{style:{cursor:'pointer'},onClick:function onClick(){return window.open(decodeURIComponent(_this4.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc['Url']));}},'  ',this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc["Name"],'  ')));}AdditionalInformation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,{className:'AdditionalInflolayer',style:{width:'50%',height:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Additional Information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{margin:'4px 0px'}},'Learn More'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px',maxWidth:'100%'}},this.state.HomePageJson.Sizers.Sizer.AdditionalInformation["@Text"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Table___default.a,{style:{margin:'4px 0px',overflow:'initial'},selectable:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,AdditionalList)))));}else{AdditionalInformation="";}if(this.state.whatsNew){WhatsnewHere=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__WhatsNew__["a" /* default */],{click:this.WhatsNewParent});}else{WhatsnewHere="";}if(this.state.userDetailsPop){UserDetailsRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__UserDetails__["a" /* default */],{onLogOut:this.props.onLogout,userDetails:this.props.userData,click:this.WhatsNewParent});}else{UserDetailsRender="";}if(this.state.HowTo){HowToHere=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',direction:'column',className:'HOwTOContent',style:{width:'13%',height:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',className:'triangle-up',style:{margin:'auto'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{backgroundColor:'#fff'},className:'ListItemAlign'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'end',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default.a,{size:'small',className:'CloseIconStyle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_List___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_ListItem___default.a,{justify:'between'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' How To '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_ListItem___default.a,{justify:'between'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,' Eric '),' '))));}else{HowToHere="";}// var MainApp={maxWidth: '100%' }
var showDelSession;var showUpdateSession;if(this.state.showUpdateSession){showUpdateSession=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Update Session')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.CloseDelSession},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_grommet_components_TextInput___default.a,{value:this.state.SessionNameTxt,style:{width:'80%'},placeHolder:'Session Name',onDOMChange:this.SessionTxtChange}),this.state.SessionNameTxt===''||this.state.SessionNameTxt.trim()===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_grommet_components_icons_base_FormNextLink___default.a,{size:'small'})}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34_grommet_components_icons_base_FormNextLink___default.a,{size:'small'}),onClick:this.Submit_Update_Session}))));}else{showUpdateSession="";}if(this.state.showDelSession){showDelSession=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle',onClick:this.CloseDelSession}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},'Are you sure you want to delete the selected session:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h6',strong:true,margin:'none'},this.state.DelSession.alias)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:function onClick(){return _this4.Submit_Delete_Session(_this4.state.DelSession.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',critical:true,onClick:this.CloseDelSession}))));}else{showDelSession="";}var sessionsMenu="";if(this.props.allSessions.length>0){var s=this.props.allSessions.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_TableRow___default.a,{key:val.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{pad:'none',margin:'small',className:'UserSelectionAnchor',style:{width:'245px',margin:'0px 0px',fontWeight:'500'},onClick:function onClick(){return _this4.Submit_Change_Session(val.id);}},val.alias)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{primary:false,plain:true,onClick:function onClick(){return _this4.setState({SessionName:val,SessionNameTxt:val.alias,showUpdateSession:true,showAddSession:false});},icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35_grommet_components_icons_base_FormEdit___default.a,{size:'small',colorIndex:'#ff9374'})}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'   ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{primary:false,plain:true,onClick:function onClick(){return _this4.ShowDelSession(val);}// onClick ={ ()=>this.props.onDeleteSession(val.id) }
,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_grommet_components_icons_base_FormTrash___default.a,{size:'small',colorIndex:'#ff9374'})}),' '));});//  var s = this.props.allSessions.map((val) => {
//     return(<ListItem key={val.id} pad='none' >
//                      <Box direction="row" margin='none' pad='none' >
//                          <Anchor pad='none' margin='small' style={{margin:'12px 0px', fontWeight: '500'}}
//                                  onClick={() => this.Submit_Change_Session(val.id) }>
//                                  {val.alias}
//                          </Anchor>
//                          <Box direction="row" margin='none' pad='none' align='end'>
//                             <Button primary={false} plain={true} onClick = { () => this.setState({ SessionName: val, SessionNameTxt: val.alias, showUpdateSession: true }) }
//                                     icon={<FormEdit size="small" colorIndex='#ff9374' />}  />
//                             <Button primary={false} plain={true} onClick ={ () => this.ShowDelSession(val) }
//                                     // onClick ={ ()=>this.props.onDeleteSession(val.id) }
//                                     icon={<TrashIcon size="small" colorIndex='#ff9374' />}  />
//                          </Box>
//                      </Box>
//            </ListItem>
//     )
// });
}if(this.props.allSessions.length>0){sessionsMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default.a,{responsive:true,closeOnClick:true,size:'medium',margin:'none',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_User___default.a,{size:'small',colorIndex:'accent-3'}),label:'Organize',className:'OrganiseMenu'},s);}var CountryChangeAlert="";if(this.state.ShowCountryChangeAlert){CountryChangeAlert=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Notification'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},'Change in country is observed, you should resize the workload to get the updated country price details in solution summary.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',style:{padding:'0px 12px 12px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Button___default.a,{label:'Ok',className:'SessionOutBtns',onClick:function onClick(){_this4.state.ShowCountryChangeAlert=false;_this4.props.history.push('/Build/SolnAlternative');}}))));}var ReferenceArchitectureDisplay=void 0;if(this.state.referenceArchitectureState){if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="EPAvNext"){ReferenceArchitectureDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__SizerUI_SizerScreens_ReferenceArchitecture__["a" /* default */],{click:this.closePopUps,history:history,redirectTo:this.getNewRoute});}else{ReferenceArchitectureDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__SizerHome_ReferenceArchitecture__["a" /* default */],{click:this.closePopUps,history:history,redirectTo:this.getNewRoute});}}else{ReferenceArchitectureDisplay="";}var lookuplayer="";if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="SAP"||__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==="SAPHANA"){if(this.state.SAPLookuplayer===true){lookuplayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_Layer___default.a,{className:'SAPLookuplayer',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__SAPLOOKUP__["a" /* default */],{onClose:this.closePopUps}));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',className:'HomeScreen'},EULAInformationPopUp,DisagreeScreen,AdditionalInformation,ReferenceArchitectureDisplay,layerelement,showDelSession,showUpdateSession,CountryChangeAlert,lookuplayer,hideforSSET==='True'?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',className:'AppbackGroundImage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',className:'AppbackGround'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{style:{width:'82%',alignSelf:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{width:'100%',borderBottom:'1px solid #425563',padding:'6px'}},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Heading___default.a,{tag:'h3',strong:true,style:{textAlign:'center',color:'#fff',fontSize:'27px',margin:'0px'}},SizerCaption)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',pad:'none',justify:'between',margin:'none',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',pad:'none',justify:'between',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Label___default.a,{margin:'none',className:'WeightFontColor'},'Pricing Region'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default.a,{justify:'start',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Map___default.a,{size:'small',colorIndex:'accent-3'}),align:'start',className:'PricelistButton WeightFontColor',responsive:true,inline:false,label:this.props.country,size:'small',primary:false,pad:'none'},CountyList),sessionsMenu),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Menu___default.a,{dropAlign:{"right":"right"},direction:'row',className:'MenuBarList'},userDetails,__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{className:'active WeightFontColor',onClick:this.UserGuideClick,label:'User Guide',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default.a,{colorIndex:'accent-3',size:'small'})}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{className:'active WeightFontColor',href:__WEBPACK_IMPORTED_MODULE_4__AppConfig__["a" /* appUrl */]+'/Docs/'+docName+UserGuide+'.pdf',target:'_blank',label:'User Guide',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_DocumentUser___default.a,{colorIndex:'accent-3',size:'small'})}),whatsnewButton,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{className:'active WeightFontColor',onClick:this.AboutClick,label:'About',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Catalog___default.a,{colorIndex:'accent-3',size:'small'})}))),UserGuideHere,AboutHere,WhatsnewHere,HowToHere,__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SynergySizer'?'':Textcontent,UserDetailsRender,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{id:'OptionsSection',style:{width:'100%',height:'100%'},justify:'start',align:'center',wrap:false,pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Box___default.a,{direction:'row',wrap:true,margin:'none',pad:'none',justify:'center',style:{width:'100%'}},EPASizingHomeMenuItems)))))))));}}]);return MyMain;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var secondTemplate=void 0;if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='EPAvNext'){secondTemplate=state.sessions.sessionDefaults.blueDataWorkload;}else if(__WEBPACK_IMPORTED_MODULE_4__AppConfig__["f" /* said */]==='SAPHANA'){secondTemplate=state.sessions.sessionDefaults.tdiWorkload;}var Country=state.sessions.Country;try{if(state.sessions.activeSession!==undefined&&state.sessions.activeSession.workload.UserInputs.Country!==undefined)Country=state.sessions.activeSession.workload.UserInputs.Country;}catch(e){}return{allSessions:state.sessions.sessions,activeSession:state.sessions.activeSession,userData:state.auth.userData,DefaultInputs:state.sessions.sessionDefaults.inputs,WhatsNewContent:state.sessions.sessionDefaults.whatsNew,countries:state.sessions.sessionDefaults.Countries,country:Country,EULAInformation:state.sessions.EULAPopUpState,sizerWorkLoad:state.sizerWorkload.workload,workloadTemplate:state.sessions.sessionDefaults.workload,sessionDefaults:state.sizerWorkload.sessionDefaults,sset:state.sizerWorkload.SSETloaded,guiState:state.sizerWorkload.guiState,blueDataworkloadTemplate:secondTemplate,notifications:state.sessions.notifications,showNotifications:state.sessions.showNotifications,sessionsState:state.sessions,LookupServers:state.sizerWorkload.lookupservers};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSaveCurrentSession:function onSaveCurrentSession(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["c" /* SaveCurrentSession */])());},onLogout:function onLogout(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_authentication__["b" /* logOut */])());},onAddSession:function onAddSession(id,name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["e" /* addSession */])(id,name));},onChangeSession:function onChangeSession(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["f" /* changeSession */])(id));},onDeleteSession:function onDeleteSession(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["j" /* deleteSession */])(id));},onUpdateSession:function onUpdateSession(session){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["Z" /* updateSession */])(session));},onCountryChange:function onCountryChange(country){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["X" /* updateCountry */])(country));},onUpdateEULA:function onUpdateEULA(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["Y" /* updateEULA */])(data));},onLoadSessionfromSSET:function onLoadSessionfromSSET(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["I" /* loadSessionfromSSET */])(data));},onLoadNotifications:function onLoadNotifications(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["F" /* loadNotifications */])(data));},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});},onInsertSessionDefaults:function onInsertSessionDefaults(inputs){dispatch({type:'UPDATE_SESSION_DEFAULTS',payload:inputs});},onUpdateActiveSession:function onUpdateActiveSession(workload){dispatch({type:'UPDATE_Active_WORKLOAD',payload:workload});},onUpdateDefaultSession:function onUpdateDefaultSession(inputs){dispatch({type:'UPDATE_SESSION_DEFAULTS',payload:inputs});},updateSSETId:function updateSSETId(inputs){dispatch({type:'UPDATE_SSETID',payload:inputs});},GetWorkloadWithMainstream:function GetWorkloadWithMainstream(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["b" /* GetWorkloadWithMainstream */])(value));},OnFetchLookupServersList:function OnFetchLookupServersList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__State_actions_sessions__["z" /* fetchLookupServersList */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MyMain));

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp(token, 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return decodeURIComponent(components.join(''));
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher);

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher);
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames4 = __webpack_require__(3);

var _classnames5 = _interopRequireDefault(_classnames4);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _SkipLinkAnchor = __webpack_require__(264);

var _SkipLinkAnchor2 = _interopRequireDefault(_SkipLinkAnchor);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.FOOTER;

var Footer = function (_Component) {
  _inherits(Footer, _Component);

  function Footer(props, context) {
    _classCallCheck(this, Footer);

    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props, context));

    _this._alignMirror = _this._alignMirror.bind(_this);
    _this._onResize = _this._onResize.bind(_this);
    return _this;
  }

  _createClass(Footer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.fixed) {
        this._alignMirror();
        window.addEventListener('resize', this._onResize);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.fixed) {
        this._alignMirror();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.fixed) {
        window.removeEventListener('resize', this._onResize);
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      this._alignMirror();
    }
  }, {
    key: '_alignMirror',
    value: function _alignMirror() {
      var contentElement = _reactDom2.default.findDOMNode(this.contentRef);
      var mirrorElement = this.mirrorRef;

      // constrain fixed content to the width of the mirror
      var mirrorRect = mirrorElement.getBoundingClientRect();
      contentElement.style.width = Math.floor(mirrorRect.width) + 'px';

      // align the mirror height with the content's height
      var contentRect = contentElement.getBoundingClientRect();
      mirrorElement.style.height = Math.floor(contentRect.height) + 'px';
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _classnames2,
          _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          colorIndex = _props.colorIndex,
          fixed = _props.fixed,
          float = _props.float,
          primary = _props.primary,
          size = _props.size;

      var restProps = _Props2.default.omit(this.props, Object.keys(Footer.propTypes));
      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size && typeof size === 'string'), _defineProperty(_classnames, CLASS_ROOT + '--float', float), _classnames), className);

      var containerClasses = (0, _classnames5.default)(CLASS_ROOT + '__container', (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__container--float', float), _defineProperty(_classnames2, CLASS_ROOT + '__container--fixed', fixed), _defineProperty(_classnames2, CLASS_ROOT + '__container--fill',
      // add default color index if none is provided
      fixed && !colorIndex), _classnames2));

      var wrapperClasses = (0, _classnames5.default)(CLASS_ROOT + '__wrapper', _defineProperty({}, CLASS_ROOT + '__wrapper--' + size, size && typeof size === 'string'));

      var footerSkipLink = void 0;
      if (primary) {
        footerSkipLink = _react2.default.createElement(_SkipLinkAnchor2.default, { label: 'Footer' });
      }

      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));
      // don't transfer size to Box since it means something different
      delete boxProps.size;

      if (fixed) {
        return _react2.default.createElement(
          'div',
          _extends({ className: containerClasses }, restProps),
          _react2.default.createElement('div', { ref: function ref(_ref) {
              return _this2.mirrorRef = _ref;
            },
            className: CLASS_ROOT + '__mirror' }),
          _react2.default.createElement(
            'div',
            { className: wrapperClasses },
            _react2.default.createElement(
              _Box2.default,
              _extends({ ref: function ref(_ref2) {
                  return _this2.contentRef = _ref2;
                }
              }, boxProps, { tag: 'footer', className: classes,
                primary: false }),
              footerSkipLink,
              children
            )
          )
        );
      } else {
        return _react2.default.createElement(
          _Box2.default,
          _extends({}, restProps, boxProps, { tag: 'footer', className: classes,
            containerClassName: containerClasses,
            primary: false }),
          footerSkipLink,
          children
        );
      }
    }
  }]);

  return Footer;
}(_react.Component);

Footer.displayName = 'Footer';
exports.default = Footer;


Footer.propTypes = _extends({
  fixed: _propTypes2.default.bool,
  float: _propTypes2.default.bool,
  primary: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
}, _Box2.default.propTypes);

Footer.defaultProps = {
  align: 'center',
  direction: 'row',
  responsive: false
};
module.exports = exports['default'];

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _docPropType = __webpack_require__(267);

var _docPropType2 = _interopRequireDefault(_docPropType);

var _getDocAsJSON = __webpack_require__(268);

var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);

var _getDocAsMarkdown = __webpack_require__(515);

var _getDocAsMarkdown2 = _interopRequireDefault(_getDocAsMarkdown);

var _PropTypes = __webpack_require__(516);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _schema = __webpack_require__(517);

var _schema2 = _interopRequireDefault(_schema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.docPropType = _docPropType2.default;
exports.getDocAsJSON = _getDocAsJSON2.default;
exports.getDocAsMarkdown = _getDocAsMarkdown2.default;
exports.PropTypes = _PropTypes2.default;
exports.schema = _schema2.default;

exports.default = {
  docPropType: _docPropType2.default, getDocAsJSON: _getDocAsJSON2.default, getDocAsMarkdown: _getDocAsMarkdown2.default, PropTypes: _PropTypes2.default, schema: _schema2.default
};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDocAsMarkdown;

var _getDocAsJSON = __webpack_require__(268);

var _getDocAsJSON2 = _interopRequireDefault(_getDocAsJSON);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDocAsMarkdown(component) {
  if (!component) {
    throw new Error('getDocAsMarkdown: component is required');
  }

  var documentation = (0, _getDocAsJSON2.default)(component);
  var description = '';
  if (documentation.description) {
    description = '\n' + documentation.description;
  }
  var deprecatedNote = '';
  var deprecatedContent = '';
  if (documentation.deprecated) {
    deprecatedNote = '~~';
    deprecatedContent = '\n### Deprecated: ' + documentation.deprecated;
  }
  var properties = '';
  if (documentation.properties) {
    properties = '\n\n### Properties\n\n| Property | Description | Format | Default Value | Required | Details |\n| ---- | ---- | ---- | ---- | ---- | ---- |';
    documentation.properties.forEach(function (prop) {
      var propDeprecatedNote = '';
      var propDeprecatedContent = '';
      if (prop.deprecated) {
        propDeprecatedNote = '~~';
        propDeprecatedContent = '**Deprecated**: ' + prop.deprecated;
      }
      properties += '\n| **' + propDeprecatedNote + prop.name + propDeprecatedNote + '** | ' + prop.description + ' | ' + prop.format + ' | ' + (prop.defaultValue || '') + ' | ' + (prop.required ? 'Yes' : 'No') + ' | ' + propDeprecatedContent + ' |';
    });
  }
  return '## ' + deprecatedNote + documentation.name + deprecatedNote + ' Component' + deprecatedContent + description + properties;
}

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  any: { type: 'any' },
  array: { type: 'array' },
  bool: { type: 'bool' },
  element: { type: 'element' },
  func: { type: 'func' },
  node: { type: 'node' },
  number: { type: 'number' },
  object: { type: 'object' },
  string: { type: 'string' },
  symbol: { type: 'symbol' },
  arrayOf: function arrayOf(args) {
    return { type: 'arrayOf', args: args };
  },
  instanceOf: function instanceOf(args) {
    return { type: 'instanceOf', args: args };
  },
  objectOf: function objectOf(args) {
    return { type: 'objectOf', args: args };
  },
  oneOfType: function oneOfType(args) {
    return { type: 'oneOfType', args: args };
  },
  oneOf: function oneOf(args) {
    return { type: 'oneOf', args: args };
  },
  shape: function shape(args) {
    return { type: 'shape', args: args };
  }
};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = schema;

var _docPropType = __webpack_require__(267);

var _docPropType2 = _interopRequireDefault(_docPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function schema(component) {
  var metadata = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!component) {
    throw new Error('schema: component is required');
  }
  if (!metadata.description) {
    throw new Error('schema: description is required');
  }

  var reactDesc = _extends({}, metadata);
  delete reactDesc.props;
  var defaultProps = void 0;
  var propTypes = void 0;

  if (metadata.props) {
    Object.keys(metadata.props).forEach(function (propName) {
      var prop = metadata.props[propName];
      if (!propTypes) {
        propTypes = {};
      }
      // if it is an array it means that it is a react schema instance
      if (Array.isArray(prop)) {
        var validate = prop[0];
        var description = prop[1];
        var options = prop[2];

        if (options && options.defaultProp) {
          if (!defaultProps) {
            defaultProps = {};
          }
          defaultProps[propName] = options.defaultProp;
          delete options.defaultProp;
        }

        propTypes[propName] = (0, _docPropType2.default)(validate, description, options);
      } else {
        propTypes[propName] = prop;
      }
    });
  }

  /* eslint-disable no-param-reassign */
  component.$$reactDesc = reactDesc;
  if (propTypes) {
    component.propTypes = propTypes;
  }

  if (!component.defaultProps && defaultProps) {
    component.defaultProps = defaultProps;
  }
  /* eslint-enable no-param-reassign */
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "generatePath", function() { return __WEBPACK_IMPORTED_MODULE_7__generatePath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_8__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(168);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(269);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(168);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(169);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(270);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-down');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,2 L12,22 M3,11 L12,2 L21,11', transform: 'matrix(1 0 0 -1 0 24)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'LinkDown';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-link-up', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'link-up');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,2 L12,22 M3,11 L12,2 L21,11' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'LinkUp';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-map', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'map');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,15 L19,15 L22,22 L2,22 L5,15 L9,15 M13,8 C13,8.5525 12.5525,9 12,9 C11.4475,9 11,8.5525 11,8 C11,7.4475 11.4475,7 12,7 C12.5525,7 13,7.4475 13,8 M6,8 C6,13 12,18 12,18 C12,18 18,13 18,8 C18,4.58317221 15.3135725,2 12,2 C8.68642746,2 6,4.58317221 6,8 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Map';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-new', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'new');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,1 L12,23 M2,6 L22,18 M22.0000001,6 L2.00000008,18' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'New';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-object-ungroup', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'object-ungroup');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,1 L4,1 L4,4 L1,4 L1,1 Z M13,1 L16,1 L16,4 L13,4 L13,1 Z M4,2 L13,2 M15,9 L20,9 M4,15 L13,15 M1,13 L4,13 L4,16 L1,16 L1,13 Z M13,13 L16,13 L16,16 L13,16 L13,13 Z M2,4 L2,13 M15,4 L15,13 M20,8 L23,8 L23,11 L20,11 L20,8 Z M11,22 L20,22 M8,20 L11,20 L11,23 L8,23 L8,20 Z M20,20 L23,20 L23,23 L20,23 L20,20 Z M9,16 L9,20 M22,11 L22,20' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'ObjectUngroup';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-document-user', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'document-user');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M4.99787498,8.99999999 L4.99787498,0.999999992 L19.4999998,0.999999992 L22.9999998,4.50000005 L23,23 L16,23 M18,1 L18,6 L23,6 M8,11 C6.34325,11 5,12.34325 5,14 C5,15.65675 6.34325,17 8,17 C9.65675,17 11,15.65675 11,14 C11,12.34325 9.65675,11 8,11 L8,11 Z M3,23 L3,22 C3,18 6,17 8,17 C10,17 13,18 13,22 L13,23 L3,23 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'DocumentUser';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-catalog', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'catalog');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,6 L1,4.5 L1,18.443038 L12,23 L23,18.443038 L23,4 L19,6 M5,16 L5,2 L12,5 L19,2 L19,16 L12,19 L5,16 Z M11.95,5 L11.95,19' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Catalog';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-share', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'share');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M19,13 L19,23 L1,23 L1,5 L1,5 L11,5 M14,1 L23,1 L23,10 M10,14 L22.9999998,1 L10,14 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Share';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sizerScreens; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SizerScreens_HadoopServices__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SizerScreens_ExtraNodesConfiguration__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SizerScreens_HardWareAndLicenses__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SizerScreens_Functions__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SizerScreens_BlueData__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SizerScreens_HostServerConfiguration__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SizerScreens_Growth__ = __webpack_require__(582);
// import ContactInfo from '../SizerScreens/ContactInfo';
// import EnvironmentDetails from '../SizerScreens/EnvironmentDetails';
// import OtherEnvironmentDetails from '../SizerScreens/OtherEnvironmentDetails';
var sizerScreens=[{path:'/Build/Functions',component:__WEBPACK_IMPORTED_MODULE_3__SizerScreens_Functions__["a" /* default */],label:'Functions',isenabled:true,type:'BigData'},{path:'/Build/HadoopServices',component:__WEBPACK_IMPORTED_MODULE_0__SizerScreens_HadoopServices__["a" /* default */],label:'Licenses and Support',isenabled:true,type:'BigData'},{path:'/Build/ExtraNodesConfiguration',component:__WEBPACK_IMPORTED_MODULE_1__SizerScreens_ExtraNodesConfiguration__["a" /* default */],//label: 'Extra Nodes Configuration',
label:'Master and Gateway Nodes Configuration',isenabled:true,type:'BigData'},{path:'/Build/Growth',component:__WEBPACK_IMPORTED_MODULE_6__SizerScreens_Growth__["a" /* default */],label:'Growth',isenabled:true,type:'BigData'},{path:'/Build/Infrastructure',component:__WEBPACK_IMPORTED_MODULE_2__SizerScreens_HardWareAndLicenses__["a" /* default */],label:'Infrastructure',isenabled:true,type:'BigData'},{path:'/Build/HPEEzmeralRuntimeEnterprise',component:__WEBPACK_IMPORTED_MODULE_4__SizerScreens_BlueData__["a" /* default */],label:'Ezmeral Runtime Enterprise Workload Requirements',isenabled:true,type:'BlueData'},{path:'/Build/HostServerConfiguration',component:__WEBPACK_IMPORTED_MODULE_5__SizerScreens_HostServerConfiguration__["a" /* default */],label:'Gateway, Controller and Master Host Configurations',isenabled:true,type:'BlueData'},{path:'/Build/HadoopServices',component:__WEBPACK_IMPORTED_MODULE_0__SizerScreens_HadoopServices__["a" /* default */],label:'Licenses and Support',isenabled:true,type:'BlueData'},{path:'/Build/Growth',component:__WEBPACK_IMPORTED_MODULE_6__SizerScreens_Growth__["a" /* default */],label:'Growth',isenabled:true,type:'BlueData'},{path:'/Build/Infrastructure',component:__WEBPACK_IMPORTED_MODULE_2__SizerScreens_HardWareAndLicenses__["a" /* default */],label:'Infrastructure',isenabled:true,type:'BlueData'}];/*    var temp = [
         { path: '/Build/HadoopServices',
          component: HadoopServices,        
          label: 'Licenses and Support',
          isenabled: true,
          type:'BlueData'          
        },  
        { path: '/Build/Infrastructure',
          component: HardwareandLicense,        
          label: 'Infrastructure',
          isenabled: true,
          type:'BlueData'          
        }
    ]
*/

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonLogic__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { Prompt } from 'react-router-dom';
//import {errorValidataion,toggleSizeButton} from '../actions/sessions';
//import Toast from 'grommet/components/Toast';
//import { fetchDefaults } from '../Redux/actions/epaActions';
var Hortondisply='none';var Clouderadisply='none';var MapRContentdisplay='none';var HortonWorkEntValue='';var HortonWorkEntPlusValue='';var HortonWorkEntDataflowValue='';var ClouderaEssValue='';var ClouderaEntDataHubValue='';var ClouderaDataEngValue='';var ClouderaOpDbValue='';var ClouderaAnaDbValue='';var BluedataEpicsftwreValue='';var hpeEzmeralDataFabricLicense='';var BluedataMLsftwreValue='';var kubernetesCM='';var KubernetesHPECPValue='';var KubernetesDataAppsValue='';var KubernetesDataAppsUniversalValue='';var KubernetesDataAppswMLOpsValue='';var KubernetesDataAppsUniversalwMLOpsValue='';var HDFSSelected=void 0,ScalitySelected=void 0,WekaSelected=void 0,HiveSelected=void 0,CassandraSelected=void 0,ImpalaSelected=void 0,HBaseSelected=void 0;var SparkStreamSelected=void 0,KafkaSelected=void 0,FlumeSelected=void 0,NifiSelected=void 0,YarnSelected=void 0,SparkSelected=void 0,TensorflowSelected=void 0,PytorchSelected=void 0,MinifiSelected=void 0;var CustomQtyVal=void 0,SingleQtyVal=void 0;var Qtyvalue='';var overallConfigType="";var HadoopServices=function(_Component){_inherits(HadoopServices,_Component);function HadoopServices(props){_classCallCheck(this,HadoopServices);var _this=_possibleConstructorReturn(this,(HadoopServices.__proto__||Object.getPrototypeOf(HadoopServices)).call(this,props));_this.onKubernetesChBoxsChange=function(ChBox){switch(ChBox){case"HPECP":_this.state.KubernetesHPECPChBox=_this.state.KubernetesHPECPChBox?false:true;break;case"Data Apps":if(ChBox.isChecked||_this.state.KubernetesDataappswMLOpsChBox){_this.state.KubernetesDataappsChBox=_this.state.KubernetesDataappsChBox?false:true;}break;case"Data Apps Universal":_this.state.KubernetesDataappsUniversalChBox=_this.state.KubernetesDataappsUniversalChBox?false:true;break;case"Data Apps w/ML Ops":if(ChBox.isChecked||_this.state.KubernetesDataappsChBox)_this.state.KubernetesDataappswMLOpsChBox=_this.state.KubernetesDataappswMLOpsChBox?false:true;break;case"Data Apps Universal w/ML Ops":_this.state.KubernetesDataappsUniversalwMLOpsChBox=_this.state.KubernetesDataappsUniversalwMLOpsChBox?false:true;break;}_this.updateKubernetesChkboxtoWorkload(ChBox);};_this.updateKubernetesChkboxtoWorkload=function(ChBox){_this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter(function(Services){if(Services['@Type']==="Data Apps"&&Services['@Type']===ChBox){Services['@IsSelected']=_this.state.KubernetesDataappsChBox.toString();//Services['@Description'] = this.state.KubernetesDataappsChBox ? "9x5 1y" : "None";
Services['@Description']=_this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(item){return item['@Type']==='Data Apps';}).Item;}if(Services['@Type']==="Data Apps Universal"&&Services['@Type']===ChBox){Services['@IsSelected']=_this.state.KubernetesDataappsUniversalChBox.toString();}if(Services['@Type']==="Data Apps w/ML Ops"){Services['@IsSelected']=_this.state.KubernetesDataappswMLOpsChBox.toString();// Services['@Description'] = this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(item => item['@Type'] === 'Data Apps w/ML Ops').Item.filter(option => option !== 'None')[0];
Services['@Description']=_this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(item){return item['@Type']==='Data Apps w/ML Ops';}).Item;}if(Services['@Type']==="Data Apps Universal w/ML Ops"&&Services['@Type']===ChBox){Services['@IsSelected']=_this.state.KubernetesDataappsUniversalwMLOpsChBox.toString();}});_this.setState({});};_this.onKubernetesvalueChanges=function(e,serviceName){var value=e.option.toString();switch(serviceName){case'HPECP':KubernetesHPECPValue=value;//this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[2]['@Description'] = KubernetesHPECPValue
break;case'Data Apps':KubernetesDataAppsValue=value;//this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[3]['@Description'] = KubernetesDataAppsValue
break;case'Data Apps Universal':KubernetesDataAppsUniversalValue=value;//this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[4]['@Description'] = KubernetesDataAppsUniversalValue
break;case'Data Apps w/ML Ops':KubernetesDataAppswMLOpsValue=value;//this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[5]['@Description'] = KubernetesDataAppswMLOpsValue
break;case'Data Apps Universal w/ML Ops':KubernetesDataAppsUniversalwMLOpsValue=value;//this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[6]['@Description'] = KubernetesDataAppsUniversalwMLOpsValue
break;}_this.updateKubernetesvaluestoWorkload(serviceName,value);};_this.updateKubernetesvaluestoWorkload=function(serviceName,value){_this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter(function(Services){if(Services['@Type']===serviceName){Services['@Description']=value;}});_this.setState({});};_this.calculateBlueDataCount=function(role,BlueDataCount){if(role["@Type"]!==__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_29" /* GATEWAY_ */]&&parseInt(role["@NodesCount"],10)>0){var ProcContrl=[];var CoreContrl=[];ProcContrl=role["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");BlueDataCount+=parseInt(role["@NodesCount"],10)*role["@ProcQty"]*parseInt(CoreContrl[1],10);}return BlueDataCount;};_this.state={HortonWorksEnterpriseCheched:'',HortonWorksEnterprisePlusCheched:'',Radiobtn1:'',Radiobtn2:'',ClouderaDataScienceEngineeringCheched:'',ClouderaOperationalDBCheched:'',ClouderaEssentialsCheched:'',ClouderaDataWarehouseCheched:'',ClouderaEnterpriseDataHubCheched:'',BlueDataCheched:'',HPCMOptions:[],HWSupportOptions:[],MapROPtions:[],ScalityOptions:[],WekaOptions:[],iLOLicenseOptions:[],HadoopLicenseOptions:[],LinuxLicenseOptions:[],HortonRadioBtn2:'',HortonRadioBtn1:'',MapRRadioBtn:'',NoneRadioBtn:'',CloudEraRadioBtn1:'',HortonRadioBtn3:'',HortonChBox4:'',CloudEraChBox4:'',CloudEraChBox5:'',CloudEraChBox6:'',CloudEraChBox3:'',CloudEraChBox2:'',MapRXDChkBox:'',MapRAnalyticsChkBox:'',MapRAnalyticswithSparkChkBox:'',MapRStreamsChkBox:'',MapRDatabaseChkBox:'',MapRBundleChkBox:'',DataFabricServiceChkBox:'',AppStoreCheckbox:'',SingleImageCheckbox:'',EPICCustomCheckbox:'',DeploymentCheckbox:'',InstallationCheckbox:'',BlueDataEpicChecked:false,BlueDataMLChecked:false,KubernetesHPECPChBox:false,KubernetesDataappsChBox:false,KubernetesDataappsUniversalChBox:false,KubernetesDataappswMLOpsChBox:false,KubernetesDataappsUniversalwMLOpsChBox:false};_this.onHortonRadioBtnChange=_this.onHortonRadioBtnChange.bind(_this);_this.onHortoninsideRadioBtnChange=_this.onHortoninsideRadioBtnChange.bind(_this);_this.onBlueDataRadioBtnChange=_this.onBlueDataRadioBtnChange.bind(_this);return _this;}_createClass(HadoopServices,[{key:'onCheckboxChange',value:function onCheckboxChange(e,val){switch(val){case'HortonWorks Enterprise':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEnt"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEnt"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEnt"]="true";}break;case'HortonWorks Enterprise Plus':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEntPlus"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEntPlus"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@HWEntPlus"]="true";}break;case'Cloudera Data Science & Engineering':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDSE"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDSE"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDSE"]="true";}break;case'Cloudera Operational DB':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaODB"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaODB"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaODB"]="true";}break;case'Cloudera Essentials':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEss"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEss"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEss"]="true";}break;case'Cloudera Data Warehouse':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDW"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDW"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaDW"]="true";}break;case'Cloudera Enterprise Data Hub':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEntDH"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEntDH"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@ClouderaEntDH"]="true";}break;case'BlueData':if(this.props.workload.UserInputs.Environments.HadoopServices.Services["@BlueData"]==="true"){this.props.workload.UserInputs.Environments.HadoopServices.Services["@BlueData"]="false";}else{this.props.workload.UserInputs.Environments.HadoopServices.Services["@BlueData"]="true";}break;default:break;}this.setState({});}},{key:'componentWillMount',value:function componentWillMount(){if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR){if(Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License)){var bothUnselected=true;if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.findIndex(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_4" /* DATA_APPS */];})>-1){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_4" /* DATA_APPS */];})["@IsSelected"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){bothUnselected=false;}}if(bothUnselected){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.findIndex(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_5" /* DATA_APPS_wMLOPs */];})>-1){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_5" /* DATA_APPS_wMLOPs */];})["@IsSelected"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){bothUnselected=false;}}}if(bothUnselected){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.findIndex(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_4" /* DATA_APPS */];})>-1){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_4" /* DATA_APPS */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_4" /* DATA_APPS */];})["@Description"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_105" /* NINE_X_FIVE */];}}}}}}}},{key:'OnLicenseChange',value:function OnLicenseChange(e,service){switch(service){case"MapR":this.props.workload.UserInputs.Environments.HadoopServices['MapR']=e.value;break;case"Scality":this.props.workload.UserInputs.Environments.HadoopServices['Scality']=e.value;break;case"Weka":this.props.workload.UserInputs.Environments.HadoopServices['Weka']=e.value;break;case"HPCM":this.props.workload.UserInputs.Environments.HadoopServices['HPCM']=e.value;break;case"HWSupport":this.props.workload.UserInputs.Environments.HadoopServices['HWSupport']=e.value;break;case"LinuxLicense":this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense']=e.value;break;case"HadoopLicense":this.props.workload.UserInputs.Environments.HadoopServices['HadoopLicense']=e.value;break;case"iLoLicense":this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense']=e.value;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_191" /* VMWARE_VCENTER */]:this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vCenter"]=e.value;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_195" /* VMWARE_VSPHERE */]:this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vSphere"]=e.value;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_193" /* VMWARE_VREALIZE */]:this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vRealize"]=e.value;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_194" /* VMWARE_VSAN */]:this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vSAN"]=e.value;break;default:break;}this.setState({});}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){if(this.props.activeSession.isSizeEnabled)this.props.OnToggleSizeButton(false);}if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Storage"){val.Service.filter(function(servicename){switch(servicename['@Type']){case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]:HDFSSelected=/true/i.test(/true/i.test(servicename['@Selected']));break;case"Scality":ScalitySelected=/true/i.test(servicename['@Selected']);break;case"Weka":WekaSelected=/true/i.test(servicename['@Selected']);break;}});}if(val['@Type']==="Database"){val.Service.filter(function(servicename){switch(servicename['@Type']){case"Hive":HiveSelected=/true/i.test(servicename['@Selected']);break;case"Cassandra":CassandraSelected=/true/i.test(servicename['@Selected']);break;case"Impala":ImpalaSelected=/true/i.test(servicename['@Selected']);break;case"HBase":HBaseSelected=/true/i.test(servicename['@Selected']);break;}});}if(val['@Type']==="Streaming"){val.Service.filter(function(servicename){switch(servicename['@Type']){case"Spark Streaming":SparkStreamSelected=/true/i.test(servicename['@Selected']);break;case"Kafka":KafkaSelected=/true/i.test(servicename['@Selected']);break;case"Flume":FlumeSelected=/true/i.test(servicename['@Selected']);break;case"Nifi":NifiSelected=/true/i.test(servicename['@Selected']);break;}});}if(val['@Type']==="Analytics"){val.Service.filter(function(servicename){switch(servicename['@Type']){case"Yarn":YarnSelected=/true/i.test(servicename['@Selected']);break;case"Spark":SparkSelected=/true/i.test(servicename['@Selected']);break;}});}if(val['@Type']==="AI"){val.Service.filter(function(servicename){switch(servicename['@Type']){case"Tensorflow":TensorflowSelected=/true/i.test(servicename['@Selected']);break;case"PyTorch":PytorchSelected=/true/i.test(servicename['@Selected']);break;}});}if(val['@Type']==="IoT"){switch(val.Service['@Type']){case"MiNifi":MinifiSelected=/true/i.test(val.Service['@Selected']);break;}}});}if(Object(__WEBPACK_IMPORTED_MODULE_16__commonLogic__["k" /* updateFinishButton */])(this.props.workload,this.props.displayWarning,this.props.activeSession.isSizeEnabled)){this.props.OnToggleSizeButton(true);}this.setState({});}},{key:'onHortonChBoxChange',value:function onHortonChBoxChange(e,name){if(this.state.HortonChBox4===true){this.state.HortonChBox4=false;}else{this.state.HortonChBox4=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_48" /* HORTONWORKS_DATAFLOW */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_48" /* HORTONWORKS_DATAFLOW */];}).Item[0];}this.oncheckboxupdateWorkload(this.state.HortonChBox4,name);}},{key:'onClouderaESSChBoxChange',value:function onClouderaESSChBoxChange(e,name){if(this.state.CloudEraChBox2===true){this.state.CloudEraChBox2=false;}else{this.state.CloudEraChBox2=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["B" /* CLOUDERA_ESSENTIALS */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["B" /* CLOUDERA_ESSENTIALS */];}).Item[0];}this.oncheckboxupdateWorkload(this.state.CloudEraChBox2,name);}},{key:'onClouderaEntDataHubChBoxChange',value:function onClouderaEntDataHubChBoxChange(e,name){if(this.state.CloudEraChBox3===true){this.state.CloudEraChBox3=false;}else{this.state.CloudEraChBox3=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["A" /* CLOUDERA_ENT_DATAHUB */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["A" /* CLOUDERA_ENT_DATAHUB */];}).Item[0];}this.oncheckboxupdateWorkload(this.state.CloudEraChBox3,name);}},{key:'onClouderaDataEngChBoxChange',value:function onClouderaDataEngChBoxChange(e,name){if(this.state.CloudEraChBox4===true){this.state.CloudEraChBox4=false;}else{this.state.CloudEraChBox4=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["z" /* CLOUDERA_DATA_ENGINEERING */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["z" /* CLOUDERA_DATA_ENGINEERING */];}).Item[0];}this.oncheckboxupdateWorkload(this.state.CloudEraChBox4,name);}},{key:'onClouderaOpDBChBoxChange',value:function onClouderaOpDBChBoxChange(e,name){if(this.state.CloudEraChBox5===true){this.state.CloudEraChBox5=false;}else{this.state.CloudEraChBox5=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["C" /* CLOUDERA_OP_DATABASE */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["C" /* CLOUDERA_OP_DATABASE */];}).Item[0];}this.oncheckboxupdateWorkload(this.state.CloudEraChBox5,name);}},{key:'onClouderaAnaDBChBoxChange',value:function onClouderaAnaDBChBoxChange(e,name){if(this.state.CloudEraChBox6===true){this.state.CloudEraChBox6=false;}else{this.state.CloudEraChBox6=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["y" /* CLOUDERA_ANALYTICAL_DB */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["y" /* CLOUDERA_ANALYTICAL_DB */];}).Item[0];}this.oncheckboxupdateWorkload(this.state.CloudEraChBox6,name);}},{key:'OnBlueDataChange',value:function OnBlueDataChange(e,name){if(name==="BlueData EPIC Software"){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@Description']=e.value.toString();}else if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_67" /* HPE_EZMERAL_MLOPS */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@Description']=e.value.toString();}else if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_70" /* HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]==="Kubernetes CM";})['@Description']=e.value.toString();if(e.value===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_109" /* NONE_ */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_85" /* KUBERNETES_CM */];})[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["c" /* ATTRIBUTE_ISSELECTED */]]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}else{this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_85" /* KUBERNETES_CM */];})[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["c" /* ATTRIBUTE_ISSELECTED */]]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];}}else if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */];})['@Description']=e.value.toString();}this.setState({});}},{key:'oncheckboxupdateWorkload',value:function oncheckboxupdateWorkload(value,name){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Data Engineering":if(name==='ClouderaDataEngValue')Servicename['@IsSelected']=value.toString();break;case"Cloudera Operational Database":if(name==='ClouderaOpDbValue')Servicename['@IsSelected']=value.toString();break;case"Cloudera Analytical Database":if(name==='ClouderaAnaDbValue')Servicename['@IsSelected']=value.toString();break;case"Cloudera Enterprise Data Hub":if(name==='ClouderaEntDataHubValue')Servicename['@IsSelected']=value.toString();break;case"Cloudera Essentials":if(name==='ClouderaEssValue')Servicename['@IsSelected']=value.toString();break;case"BlueData":if(name==='BlueDataValue')Servicename['@IsSelected']=value.toString();break;}});this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"Hortonworks DataFlow":if(name==='HortonWorkEntDataflowValue')Servicename['@IsSelected']=value.toString();break;}});this.setState({});}},{key:'onMapRcheckBoxChange',value:function onMapRcheckBoxChange(e,name){switch(e.target.attributes["id"].value){case"XD":if(this.state.MapRXDChkBox&&(this.state.MapRAnalyticsChkBox||this.state.MapRAnalyticswithSparkChkBox||this.state.MapRStreamsChkBox||this.state.MapRDatabaseChkBox)){break;}this.state.MapRXDChkBox=this.state.MapRXDChkBox?false:true;break;case"Analytics":this.state.MapRAnalyticsChkBox=this.state.MapRAnalyticsChkBox?false:true;this.state.MapRXDChkBox=this.state.MapRAnalyticsChkBox?true:this.state.MapRXDChkBox;break;case"Spark":this.state.MapRAnalyticswithSparkChkBox=this.state.MapRAnalyticswithSparkChkBox?false:true;this.state.MapRXDChkBox=this.state.MapRAnalyticswithSparkChkBox?true:this.state.MapRXDChkBox;break;case"Streams":this.state.MapRStreamsChkBox=this.state.MapRStreamsChkBox?false:true;this.state.MapRXDChkBox=this.state.MapRStreamsChkBox?true:this.state.MapRXDChkBox;break;case"Database":this.state.MapRDatabaseChkBox=this.state.MapRDatabaseChkBox?false:true;this.state.MapRXDChkBox=this.state.MapRDatabaseChkBox?true:this.state.MapRXDChkBox;break;case"Bundle":this.state.MapRBundleChkBox=this.state.MapRBundleChkBox?false:true;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_156" /* SERVICES_ */]:this.state.DataFabricServiceChkBox=this.state.DataFabricServiceChkBox?false:true;break;}this.onMapRcheckboxupdateWorkload(name);}},{key:'onMapRcheckboxupdateWorkload',value:function onMapRcheckboxupdateWorkload(name){var _this2=this;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.filter(function(Servicename){switch(Servicename['@Type']){case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */]:Servicename['@IsSelected']=_this2.state.MapRXDChkBox.toString();break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["S" /* DATAFABRIC_ANALYTICS */]:if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["S" /* DATAFABRIC_ANALYTICS */])Servicename['@IsSelected']=_this2.state.MapRAnalyticsChkBox.toString();break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["W" /* DATAFABRIC_SPARK */]:if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["W" /* DATAFABRIC_SPARK */])Servicename['@IsSelected']=_this2.state.MapRAnalyticswithSparkChkBox.toString();break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["X" /* DATAFABRIC_STREAMS */]:if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["X" /* DATAFABRIC_STREAMS */])Servicename['@IsSelected']=_this2.state.MapRStreamsChkBox.toString();break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["U" /* DATAFABRIC_DATABASE */]:if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["U" /* DATAFABRIC_DATABASE */])Servicename['@IsSelected']=_this2.state.MapRDatabaseChkBox.toString();break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["T" /* DATAFABRIC_BUNDLE */]:if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["T" /* DATAFABRIC_BUNDLE */]){Servicename['@IsSelected']=_this2.state.MapRBundleChkBox.toString();_this2.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.forEach(function(element){if(element["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */]){element['@IsSelected']="false";}});}else if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */]){Servicename['@IsSelected']="false";}break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */]:if(name===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */]){Servicename['@IsSelected']=_this2.state.DataFabricServiceChkBox.toString();}}});this.setState({});}},{key:'onHortonRadioBtnChange',value:function onHortonRadioBtnChange(e){if(e.target.attributes["id"].value==="choice1-1"){this.state.HortonRadioBtn1=true;this.state.CloudEraRadioBtn1=false;this.state.MapRRadioBtn=false;this.state.NoneRadioBtn=false;}else if(e.target.attributes["id"].value==="choice1-2"){this.state.HortonRadioBtn1=false;this.state.CloudEraRadioBtn1=true;this.state.MapRRadioBtn=false;this.state.NoneRadioBtn=false;}else if(e.target.attributes["id"].value==="choice1-3"){this.state.HortonRadioBtn1=false;this.state.CloudEraRadioBtn1=false;this.state.MapRRadioBtn=true;this.state.NoneRadioBtn=false;}else if(e.target.attributes["id"].value===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_110" /* NONE_RADBTN_ID */]){this.state.HortonRadioBtn1=false;this.state.CloudEraRadioBtn1=false;this.state.MapRRadioBtn=false;this.state.NoneRadioBtn=true;}this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']=this.state.CloudEraRadioBtn1.toString();this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']=this.state.HortonRadioBtn1.toString();if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected']=this.state.MapRRadioBtn.toString();var dataLakeObject=this.props.workload.UserInputs.Environments.Functions.Function.find(function(tab){return tab["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_161" /* STORAGE_ */];}).Service.find(function(service){return service["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */];});if(this.state.MapRRadioBtn){if(parseInt(dataLakeObject.Hardware["@NodesCount"],10)<parseInt(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_1" /* DATALAKE_MIN_NODES */],10)){this.props.workload.UserInputs.Environments.isDataLakeNodeCountUpdated=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];this.props.workload.UserInputs.Environments.DataLakeNodeCount=dataLakeObject.Hardware["@NodesCount"];this.props.workload.UserInputs.Environments.updateDataLakeRecommendations=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];dataLakeObject.Hardware["@NodesCount"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_1" /* DATALAKE_MIN_NODES */];}}else{if(this.props.workload.UserInputs.Environments.isDataLakeNodeCountUpdated===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){this.props.workload.UserInputs.Environments.isDataLakeNodeCountUpdated=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];this.props.workload.UserInputs.Environments.updateDataLakeRecommendations=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];dataLakeObject.Hardware["@NodesCount"]=this.props.workload.UserInputs.Environments.DataLakeNodeCount;}}Object(__WEBPACK_IMPORTED_MODULE_16__commonLogic__["n" /* updateMasterandGatewayServices */])(this.props.workload);}this.setState({});}},{key:'onHortoninsideRadioBtnChange',value:function onHortoninsideRadioBtnChange(e){var _this3=this;if(e.target.attributes["id"].value==="Ent"){this.state.HortonRadioBtn2=true;this.state.HortonRadioBtn3=false;if(this.state.HortonRadioBtn2){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_49" /* HORTONWORK_ENT */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_49" /* HORTONWORK_ENT */];}).Item[0];}}else if(e.target.attributes["id"].value==="EntPlus"){this.state.HortonRadioBtn2=false;this.state.HortonRadioBtn3=true;if(this.state.HortonRadioBtn3){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(function(Servicename){return Servicename['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_50" /* HORTONWORK_ENT_PLUS */];})["@Description"]=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(name){return name["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_50" /* HORTONWORK_ENT_PLUS */];}).Item[0];}}else{}this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"HortonWork Enterprise":Servicename['@IsSelected']=_this3.state.HortonRadioBtn2.toString();break;case"HortonWork Enterprise Plus":Servicename['@IsSelected']=_this3.state.HortonRadioBtn3.toString();break;}});this.setState({});}},{key:'onBlueDataRadioBtnChange',value:function onBlueDataRadioBtnChange(e){if(e.target.attributes["id"].value==="BlueEPIC"){this.state.BlueDataEpicChecked=true;this.state.BlueDataMLChecked=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@Description']=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_105" /* NINE_X_FIVE */];//aditya
}else if(e.target.attributes["id"].value==="BlueML"){this.state.BlueDataEpicChecked=false;this.state.BlueDataMLChecked=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@Description']=this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(function(license){return license['@Type']===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_67" /* HPE_EZMERAL_MLOPS */];}).Item[0];}else{}this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@IsSelected']=this.state.BlueDataEpicChecked.toString();this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@IsSelected']=this.state.BlueDataMLChecked.toString();this.setState({});}},{key:'OnServicedrpdwnChange',value:function OnServicedrpdwnChange(e,Service){var value=e.value;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Data Engineering":if(Service==='ClouderaDataEngValue')Servicename['@Description']=value;break;case"Cloudera Operational Database":if(Service==='ClouderaOpDbValue')Servicename['@Description']=value;break;case"Cloudera Analytical Database":if(Service==='ClouderaAnaDbValue')Servicename['@Description']=value;break;case"Cloudera Enterprise Data Hub":if(Service==='ClouderaEntDataHubValue')Servicename['@Description']=value;break;case"Cloudera Essentials":if(Service==='ClouderaEssValue')Servicename['@Description']=value;break;}});this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"HortonWork Enterprise":if(Service==='HortonWorkEntValue')Servicename['@Description']=value;break;case"HortonWork Enterprise Plus":if(Service==='HortonWorkEntPlusValue')Servicename['@Description']=value;break;case"Hortonworks DataFlow":if(Service==='HortonWorkEntDataflowValue')Servicename['@Description']=value;break;}});this.setState({});}},{key:'onLicensesChanged',value:function onLicensesChanged(e,name){if(name==="AppStore"){if(this.state.AppStoreCheckbox){this.state.AppStoreCheckbox=false;}else{this.state.AppStoreCheckbox=true;}this.props.workload.UserInputs.Environments.HadoopServices['AppStore']=this.state.AppStoreCheckbox.toString();}else if(name==="SingleImage"){if(this.state.SingleImageCheckbox){this.state.SingleImageCheckbox=false;// if(! this.state.EPICCustomCheckbox){
//      this.state.DeploymentCheckbox = false
// }
}else{this.state.SingleImageCheckbox=true;this.state.DeploymentCheckbox=true;}this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']=this.state.SingleImageCheckbox.toString();this.props.workload.UserInputs.Environments.HadoopServices['Deployment']=this.state.DeploymentCheckbox.toString();}else if(name==="CustomImage"){if(this.state.EPICCustomCheckbox){this.state.EPICCustomCheckbox=false;//  if(! this.state.SingleImageCheckbox){
//      this.state.DeploymentCheckbox = false
// }
}else{this.state.EPICCustomCheckbox=true;this.state.DeploymentCheckbox=true;}this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']=this.state.EPICCustomCheckbox.toString();this.props.workload.UserInputs.Environments.HadoopServices['Deployment']=this.state.DeploymentCheckbox.toString();}else if(name==="Deployment"){if(this.state.DeploymentCheckbox){this.state.DeploymentCheckbox=false;}else{this.state.DeploymentCheckbox=true;}this.props.workload.UserInputs.Environments.HadoopServices['Deployment']=this.state.DeploymentCheckbox.toString();}else if(name==="Installation"){if(this.state.InstallationCheckbox){this.state.InstallationCheckbox=false;}else{this.state.InstallationCheckbox=true;}this.props.workload.UserInputs.Environments.HadoopServices['Installation']=this.state.InstallationCheckbox.toString();}this.setState({});}},{key:'onLicensesQtyChanged',value:function onLicensesQtyChanged(e,name,chblr){var text=parseInt(e.target.value,10);var number=/^[0-9]+$/;if(chblr==="Change"){if(isNaN(text)){Qtyvalue=" ";}else if(number.test(text)&&text<=9999&&text>=1||isNaN(text)){Qtyvalue=text.toString();}else{}}else{if(isNaN(text)){Qtyvalue="1";}else{Qtyvalue=text.toString();}}if(name==="SingleImage"){this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty']=Qtyvalue;}else if(name==="CustomImage"){this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty']=Qtyvalue;}// this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.BlueDataEPICLicenses.License.filter((Servicename) => {
//     switch (Servicename['@Type']) {
//         case "SingleImage":
//             if (name === Servicename['@Type']) {
//                 Servicename['@Value'] = value
//             }
//             break;
//         case "CustomImage":
//             if (name === Servicename['@Type']) {
//                 Servicename['@Value'] = value
//             }
//             break;
//     }
// })
this.setState({});}},{key:'render',value:function render(){var _this4=this;var scalitydisplay="none";var Wekadisplay="none";var HortonWorkEntOptions=[];var HortonWorkEntPlusOptions=[];var HortonWorkEntDataflowOptions=[];var ClouderaEssOptions=[];var ClouderaEntDataHubOptions=[];var ClouderaDataEngOptions=[];var ClouderaOpDbOptions=[];var ClouderaAnaDbOptions=[];var BluedataEpicsftwreOptions=[];var BluedataMLsftwreOptions=[];var externalK8sClusterMngrOptions=[];var hpeEzmeralDataFabricLicenseOptions=[];var BlueDataMLDisabled=false;var BlueDataEpicDisabled=false;var KubernetesHPECPOptions=[];var KubernetesDataAppsOptions=[];var KubernetesDataAppsUniversalOptions=[];var KubernetesDataAppswMLOpsOptions=[];var KubernetesDataAppsUniversalwMLOpsOptions=[];var VMWare_vCenter_Options=[];var VMWare_vSphere_Options=[];var VMWare_vRealize_Options=[];var VMWare_vSAN_Options=[];var VMWareLicenses="";var VMWare_VSphereTooltip='VMWare vSphere licenses';var VMWare_VCenterTooltip='VMWare vCenter licenses';var datalakeServiceNote='';if(this.props.workload!==undefined&&this.props.workload!==null){var HWEntDisabled=false;var HwEntPlusDisabled=false;var HwDataFlowDisabled=false;var CLEraDataSciNdEngDisabled=false;var CLEraOpDBDisabled=false;var CLEraAnalyDBDisabled=false;var CLEraEntDataHubDisabled=false;var CLEraESSDisabled=false;var ClouderaLicensesDisabled=false;var HortonLicensesDisabled=false;var MapRXDDisabled=true;var MapRAnalyticsDisabled=true;var MapRAnalyticswithSparkDisabled=true;var MapRStreamsDisabled=true;var MapRDatabaseDisabled=true;var MapRBundleDisabled=true;var DataFabricServicesDisabled=true;if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses===undefined){var ServiceLicenses={Hortonworks:{"@IsSelected":"false","License":[{"@IsSelected":"false","@Description":"HDE 24x7 1y"},{"@IsSelected":"false","@Description":"HDP 24x7 1y"},{"@IsSelected":"false","@Description":"HDF Ed 10 BO Nodes"}]},"Cloudera":{"@IsSelected":"false","License":[{"@IsSelected":"false","@Description":"CEDE 8x5 1yr"},{"@IsSelected":"false","@Description":"CEOD 8x5 1yr"},{"@IsSelected":"false","@Description":"CEAD 8x5 1yr"},{"@IsSelected":"false","@Description":"CEDH 24x7 1yr"},{"@IsSelected":"false","@Description":"CEE 24x7 1yr"}]},License:{"@IsSelected":"true","@Description":"None"}};this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses=ServiceLicenses;}if(this.props.workload.UserInputs.Environments.HadoopServices['AppStore']===undefined){var AppStore="false";var Deployment="false";var SingleImage={"@Qty":"1","#text":"false"};var CustomImage={"@Qty":"1","#text":"false"};var Installation="false";this.props.workload.UserInputs.Environments.HadoopServices['AppStore']=AppStore;this.props.workload.UserInputs.Environments.HadoopServices.SingleImage=SingleImage;this.props.workload.UserInputs.Environments.HadoopServices.CustomImage=CustomImage;this.props.workload.UserInputs.Environments.HadoopServices['Deployment']=Deployment;this.props.workload.UserInputs.Environments.HadoopServices['Installation']=Installation;}if(!Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){// BluedataAIsftwreValue=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[1]['@Description']
var License=[{"@Description":this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License['@Description'],"@IsSelected":"true","@Type":"BlueData"},{"@Description":"None","@IsSelected":"true","@Type":"BlueDataAI"}];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License=License;}if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){//////////////////1st Validation///////////////////////////////////////////
HWEntDisabled=true;if(HDFSSelected!==undefined){if((HDFSSelected||YarnSelected||FlumeSelected||HBaseSelected||HiveSelected)&&!KafkaSelected&&!SparkSelected){HWEntDisabled=false;}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){if(HWEntDisabled){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"HortonWork Enterprise":Servicename['@IsSelected']="false";break;}});}}}///////2nd Validation///////////////////////////////////
HwEntPlusDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||FlumeSelected||HBaseSelected||HiveSelected||KafkaSelected||SparkSelected){HwEntPlusDisabled=false;}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){if(HwEntPlusDisabled){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"HortonWork Enterprise Plus":Servicename['@IsSelected']="false";break;}});}}}//////3rd Validation////////////////////////////////////
HwDataFlowDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||FlumeSelected||HBaseSelected||HiveSelected||KafkaSelected||SparkSelected){HwDataFlowDisabled=false;}if(HwDataFlowDisabled){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"Hortonworks DataFlow":Servicename['@IsSelected']="false";break;}});}}}//////4th Validation////////////////////////////////////////////////////////
CLEraDataSciNdEngDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||KafkaSelected||SparkSelected){CLEraDataSciNdEngDisabled=false;}if(CLEraDataSciNdEngDisabled){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Data Engineering":Servicename['@IsSelected']="false";break;}});}}}//////5th Validation////////////////////////////////////////////////////////
CLEraOpDBDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||KafkaSelected||SparkSelected||HBaseSelected){CLEraOpDBDisabled=false;}if(CLEraOpDBDisabled){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Operational Database":Servicename['@IsSelected']="false";break;}});}}}//////6th Validation////////////////////////////////////////////////////////
CLEraAnalyDBDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||KafkaSelected||SparkSelected||ImpalaSelected){CLEraAnalyDBDisabled=false;}if(CLEraAnalyDBDisabled){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Analytical Database":Servicename['@IsSelected']="false";break;}});}}}//////7th Validation////////////////////////////////////////////////////////
CLEraEntDataHubDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||KafkaSelected||SparkSelected||ImpalaSelected||HBaseSelected){CLEraEntDataHubDisabled=false;}if(CLEraEntDataHubDisabled){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Enterprise Data Hub":Servicename['@IsSelected']="false";break;}});}}}//////8th Validation////////////////////////////////////////////////////////
CLEraESSDisabled=true;if(HDFSSelected!==undefined){if(HDFSSelected||YarnSelected||KafkaSelected||SparkSelected||ImpalaSelected||HBaseSelected){CLEraESSDisabled=false;}if(CLEraESSDisabled){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Essentials":Servicename['@IsSelected']="false";break;}});}}}//////////Common validations////////////////////////////////////////////////////////////////
ClouderaLicensesDisabled=true;HortonLicensesDisabled=true;if(HDFSSelected||ScalitySelected||WekaSelected||HiveSelected||CassandraSelected||ImpalaSelected||HBaseSelected||SparkStreamSelected||KafkaSelected||FlumeSelected||NifiSelected||YarnSelected||SparkSelected||TensorflowSelected||PytorchSelected||MinifiSelected){ClouderaLicensesDisabled=false;HortonLicensesDisabled=false;}if(HDFSSelected!==undefined){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){if(ClouderaLicensesDisabled){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']="false";}if(HortonLicensesDisabled){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']="false";}}}}//********************************************************************************************************************************************                   
var BludeDataLinuxOptins=[];if(this.props.ServicesInput.sessionDefaults!==undefined&&this.props.ServicesInput.sessionDefaults!==null){this.state.HPCMOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.HPCM.Item;this.state.HWSupportOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.HWSupport.Item;this.state.MapROPtions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.MapR.Item;this.state.LinuxLicenseOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.LinuxLicense.Item;this.state.ScalityOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.Scality.Item;this.state.WekaOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.Weka.Item;this.state.iLOLicenseOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.iLOLicense.Item;// this.state.HadoopLicenseOptions=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.Services.HadoopLicense.HortonWorks.Item;
VMWare_vCenter_Options=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_191" /* VMWARE_VCENTER */];}).Item;VMWare_vSphere_Options=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_195" /* VMWARE_VSPHERE */];}).Item;VMWare_vRealize_Options=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_193" /* VMWARE_VREALIZE */];}).Item;VMWare_vSAN_Options=this.props.ServicesInput.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_194" /* VMWARE_VSAN */];}).Item;}if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Storage"){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Selected']==="true"){MapRXDDisabled=false;if(service["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){DataFabricServicesDisabled=false;}}if(service['@Type']==="Scality"&&service['@Selected']==="false"){_this4.props.workload.UserInputs.Environments.HadoopServices['Scality']="None";}if(service['@Type']==="MapR and MapR-EC"&&service['@Selected']==="false"){_this4.props.workload.UserInputs.Environments.HadoopServices['MapR']="None";}if(service['@Type']==="Weka"&&service['@Selected']==="false"){_this4.props.workload.UserInputs.Environments.HadoopServices['Weka']="None";}});}}if(val['@Type']==="Database"){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Selected']==="true"){MapRDatabaseDisabled=false;}});}}if(val['@Type']==="Streaming"){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Selected']==="true"){MapRStreamsDisabled=false;}});}}if(val['@Type']==="Analytics"){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Selected']==="true"){MapRAnalyticsDisabled=false;}if(service["@Type"]=="Spark"&&service['@Selected']==="true"){MapRAnalyticswithSparkDisabled=false;}});}}});//Condition here is removed and written below if workoload type is BigData condition. 
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Storage"){val.Service.filter(function(service){if(service['@Type']==="Scality"){if(service['@Selected']==="true"){scalitydisplay="Visible";}else{scalitydisplay="none";}}if(service['@Type']==="Weka"){if(service['@Selected']==="true"){Wekadisplay="Visible";}else{Wekadisplay="none";}}});}});this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.filter(function(Servicename){switch(Servicename['@Type']){case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */]:_this4.state.MapRXDChkBox=/true/i.test(Servicename['@IsSelected']);break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["S" /* DATAFABRIC_ANALYTICS */]:_this4.state.MapRAnalyticsChkBox=/true/i.test(Servicename['@IsSelected']);break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["W" /* DATAFABRIC_SPARK */]:_this4.state.MapRAnalyticswithSparkChkBox=/true/i.test(Servicename['@IsSelected']);break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["X" /* DATAFABRIC_STREAMS */]:_this4.state.MapRStreamsChkBox=/true/i.test(Servicename['@IsSelected']);break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["U" /* DATAFABRIC_DATABASE */]:_this4.state.MapRDatabaseChkBox=/true/i.test(Servicename['@IsSelected']);break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["T" /* DATAFABRIC_BUNDLE */]:_this4.state.MapRBundleChkBox=/true/i.test(Servicename['@IsSelected']);break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */]:_this4.state.DataFabricServiceChkBox=/true/i.test(Servicename["@IsSelected"]);}});}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter(function(Services){if(Services['@Type']==="Data Apps"){KubernetesDataAppsValue=Services['@Description'];_this4.state.KubernetesDataappsChBox=/true/i.test(Services['@IsSelected']);}if(Services['@Type']==="Data Apps Universal"){_this4.state.KubernetesDataappsUniversalChBox=/true/i.test(Services['@IsSelected']);}if(Services['@Type']==="Data Apps w/ML Ops"){KubernetesDataAppswMLOpsValue=Services['@Description'];_this4.state.KubernetesDataappswMLOpsChBox=/true/i.test(Services['@IsSelected']);}if(Services['@Type']==="Data Apps Universal w/ML Ops"){_this4.state.KubernetesDataappsUniversalwMLOpsChBox=/true/i.test(Services['@IsSelected']);}});}this.state.CloudEraRadioBtn1=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera['@IsSelected']);this.state.HortonRadioBtn1=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks['@IsSelected']);if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR['@IsSelected']="true";overallConfigType=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_20" /* EPIC_ */];this.props.workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_212" /* yES_ */];}).map(function(selectedSolution){if(selectedSolution.Templates.Template.filter(function(template){return template["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_84" /* KUBERNETES_ */]&&template['@Type']!==__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_109" /* NONE_ */];}).length>0){overallConfigType=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_84" /* KUBERNETES_ */];}});}if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){this.state.MapRRadioBtn=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric['@IsSelected']);}if(!this.state.HortonRadioBtn1&&!this.state.CloudEraRadioBtn1&&!this.state.MapRRadioBtn){this.state.NoneRadioBtn=true;}if(this.props.services.sessionDefaults!==undefined){this.props.services.sessionDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.filter(function(name){switch(name['@Type']){case"HortonWork Enterprise":HortonWorkEntOptions=name.Item;break;// case "HortonWork Enterprise Plus":
//     HortonWorkEntPlusOptions = name.Item
//     break;
case"Hortonworks DataFlow":HortonWorkEntDataflowOptions=name.Item;break;case"Cloudera Data Engineering":ClouderaDataEngOptions=name.Item;break;case"Cloudera Operational Database":ClouderaOpDbOptions=name.Item;break;case"Cloudera Analytical Database":ClouderaAnaDbOptions=name.Item;break;case"Cloudera Enterprise Data Hub":ClouderaEntDataHubOptions=name.Item;break;case"Cloudera Essentials":ClouderaEssOptions=name.Item;break;case"HPE Container Platform":BluedataEpicsftwreOptions=name.Item;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_67" /* HPE_EZMERAL_MLOPS */]:BluedataMLsftwreOptions=name.Item;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_70" /* HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR */]:externalK8sClusterMngrOptions=name.Item;break;case __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */]:hpeEzmeralDataFabricLicenseOptions=name.Item;break;case"HPE Container Platform":KubernetesHPECPOptions=name.Item;break;case"Data Apps"://KubernetesDataAppsOptions = name.Item
KubernetesDataAppsOptions=[name.Item];break;case"Data Apps Universal":KubernetesDataAppsUniversalOptions=name.Item;break;case"Data Apps w/ML Ops":// KubernetesDataAppswMLOpsOptions = name.Item
KubernetesDataAppswMLOpsOptions=[name.Item];break;case"Data Apps Universal w/ML Ops":KubernetesDataAppsUniversalwMLOpsOptions=name.Item;break;}});}this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.filter(function(Servicename){switch(Servicename['@Type']){case"Cloudera Data Engineering":ClouderaDataEngValue=Servicename['@Description'];_this4.state.CloudEraChBox4=/true/i.test(Servicename['@IsSelected']);break;case"Cloudera Operational Database":ClouderaOpDbValue=Servicename['@Description'];_this4.state.CloudEraChBox5=/true/i.test(Servicename['@IsSelected']);break;case"Cloudera Analytical Database":ClouderaAnaDbValue=Servicename['@Description'];_this4.state.CloudEraChBox6=/true/i.test(Servicename['@IsSelected']);break;case"Cloudera Enterprise Data Hub":ClouderaEntDataHubValue=Servicename['@Description'];_this4.state.CloudEraChBox3=/true/i.test(Servicename['@IsSelected']);break;case"Cloudera Essentials":ClouderaEssValue=Servicename['@Description'];_this4.state.CloudEraChBox2=/true/i.test(Servicename['@IsSelected']);break;}});this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.filter(function(Servicename){switch(Servicename['@Type']){case"HortonWork Enterprise":HortonWorkEntValue=Servicename['@Description'];if(Servicename[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["b" /* ATTRIBUTE_DESCRIPTION */]]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_109" /* NONE_ */]){Servicename[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["c" /* ATTRIBUTE_ISSELECTED */]]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}else{Servicename[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["c" /* ATTRIBUTE_ISSELECTED */]]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];}_this4.state.HortonRadioBtn2=/true/i.test(Servicename['@IsSelected']);break;case"HortonWork Enterprise Plus":HortonWorkEntPlusValue=Servicename['@Description'];_this4.state.HortonRadioBtn3=/true/i.test(Servicename['@IsSelected']);break;case"Hortonworks DataFlow":HortonWorkEntDataflowValue=Servicename['@Description'];_this4.state.HortonChBox4=/true/i.test(Servicename['@IsSelected']);break;}});}Clouderadisply='none';Hortondisply='none';MapRContentdisplay='none';if(this.state.HortonRadioBtn1){Hortondisply=' ';Clouderadisply='none';MapRContentdisplay='none';}else if(this.state.CloudEraRadioBtn1){Hortondisply='none';Clouderadisply=' ';MapRContentdisplay='none';}else if(this.state.MapRRadioBtn){Hortondisply='none';Clouderadisply='none';MapRContentdisplay=' ';}else if(this.state.NoneRadioBtn){Hortondisply=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_206" /* nONE_ */];Clouderadisply=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_206" /* nONE_ */];MapRContentdisplay=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_206" /* nONE_ */];}if(!this.state.HortonRadioBtn2){HortonWorkEntValue='None';if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(function(x){return x["@Type"]==="HortonWork Enterprise";})["@Description"]="None";}}if(!this.state.HortonRadioBtn3){HortonWorkEntPlusValue='None';HortonWorkEntPlusOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(function(x){return x["@Type"]==="HortonWork Enterprise Plus";})["@Description"]="None";}}if(!this.state.HortonChBox4){HortonWorkEntDataflowValue='None';HortonWorkEntDataflowOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Hortonworks.License.find(function(x){return x["@Type"]==="Hortonworks DataFlow";})["@Description"]="None";}}if(!this.state.CloudEraChBox2){ClouderaEssValue='None';ClouderaEssOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(x){return x["@Type"]==="Cloudera Essentials";})["@Description"]="None";}}if(!this.state.CloudEraChBox3){ClouderaEntDataHubValue='None';ClouderaEntDataHubOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(x){return x["@Type"]==="Cloudera Enterprise Data Hub";})["@Description"]="None";}}if(!this.state.CloudEraChBox4){ClouderaDataEngValue='None';ClouderaDataEngOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(x){return x["@Type"]==="Cloudera Data Engineering";})["@Description"]="None";}}if(!this.state.CloudEraChBox5){ClouderaOpDbValue='None';ClouderaOpDbOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(x){return x["@Type"]==="Cloudera Operational Database";})["@Description"]="None";}}if(!this.state.CloudEraChBox6){ClouderaAnaDbValue='None';ClouderaAnaDbOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Cloudera.License.find(function(x){return x["@Type"]==="Cloudera Analytical Database";})["@Description"]="None";}}if(!this.state.KubernetesHPECPChBox){KubernetesHPECPValue='None';KubernetesHPECPOptions=[];}if(!this.state.KubernetesDataappsChBox){KubernetesDataAppsValue='None';KubernetesDataAppsOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(x){return x["@Type"]==="Data Apps";})["@Description"]="None";}}if(!this.state.KubernetesDataappsUniversalChBox){KubernetesDataAppsUniversalValue='None';KubernetesDataAppsUniversalOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(x){return x["@Type"]==="Data Apps Universal";})["@Description"]="None";}}if(!this.state.KubernetesDataappswMLOpsChBox){KubernetesDataAppswMLOpsValue='None';KubernetesDataAppswMLOpsOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(x){return x["@Type"]==="Data Apps w/ML Ops";})["@Description"]="None";}}if(!this.state.KubernetesDataappsUniversalwMLOpsChBox){KubernetesDataAppsUniversalwMLOpsValue='None';KubernetesDataAppsUniversalwMLOpsOptions=[];if(this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.find(function(x){return x["@Type"]==="Data Apps Universal w/ML Ops";})["@Description"]="None";}}if(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage!==undefined){SingleQtyVal=this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty'];CustomQtyVal=this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty'];this.state.AppStoreCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices['AppStore']);this.state.SingleImageCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']);this.state.EPICCustomCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']);this.state.DeploymentCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices['Deployment']);this.state.InstallationCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices['Installation']);if(this.state.SingleImageCheckbox){this.state.AppStoreCheckbox=true;this.props.workload.UserInputs.Environments.HadoopServices['AppStore']='true';}else{this.state.AppStoreCheckbox=false;this.props.workload.UserInputs.Environments.HadoopServices['AppStore']='false';}}//*************************************************************************************************************** */
// ToolTips//
var HWEntTooltip='Supported services : Data Lake, YARN, Flume, Hbase, Hive';var HWEntPlusTooltip='Supported services : Data Lake, YARN, Flume, Hbase, Hive, Kafka, Spark';var HWEntDataFlowTooltip='Supported services : Data Lake, YARN, Flume, Hbase, Hive, Kafka, Spark';var CLEraEssTooltip='Supported services : Data Lake, YARN, Spark, Impala, Kafka, Hbase';var CLEraEntDataHubTooltip='Supported services : Data Lake, YARN, Spark, Impala, Kafka, Hbase';var CLEraDataSciNdEngTooltip='Supported services : Data Lake, YARN, Spark, Kafka';var CLEraOptDBTooltip='Supported services : Data Lake, YARN, Spark, Kafka, Hbase';var CLEraAnalDBTooltip='Supported services : Data Lake, YARN, Spark, Impala, Kafka';var BigDataUI='';var BluedataUI='';if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){var EnableEPICandAI=false;var AddservicesInstallDissable=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(Array.isArray(val.Service)){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services.Inputs["@BlueData"]=="true"){EnableEPICandAI=true;}}});}else{if(val.Service["@Selected"]==="true"){if(val.Service.Inputs!==undefined&&val.Service.Inputs["@BlueData"]=="true"){EnableEPICandAI=true;}}}});if(!EnableEPICandAI){AddservicesInstallDissable=true;this.props.workload.UserInputs.Environments.HadoopServices['Installation']="false";this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@Description']=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_109" /* NONE_ */];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@Description']=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_109" /* NONE_ */];BluedataEpicsftwreOptions=[];BluedataMLsftwreOptions=[];BlueDataMLDisabled=true;BlueDataEpicDisabled=true;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@IsSelected']=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@IsSelected']=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}else{BlueDataMLDisabled=false;BlueDataEpicDisabled=false;}}if(Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){this.state.BlueDataEpicChecked=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@IsSelected']);if(this.state.BlueDataEpicChecked===false){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@Description']=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_109" /* NONE_ */];BluedataEpicsftwreOptions=[];}BluedataEpicsftwreValue=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];})['@Description'];if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){hpeEzmeralDataFabricLicense=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */];})['@Description'];}}//BlueData AI Software implementation 
if(Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){this.state.BlueDataMLChecked=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@IsSelected']);if(this.state.BlueDataMLChecked===false){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@Description']="None";BluedataMLsftwreOptions=[];}}BluedataMLsftwreValue=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@Description'];if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){kubernetesCM=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]==="Kubernetes CM";})['@Description'];}}BluedataUI=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{style:{width:'29%',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton___default.a,{disabled:BlueDataEpicDisabled,id:'BlueEPIC',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'HPE Ezmeral ',__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */],' Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'A HPE Ezmeral '+__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */]+' license is required. Select the term of the support desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.BlueDataEpicChecked,onChange:this.onBlueDataRadioBtnChange,style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:BluedataEpicsftwreValue,options:BluedataEpicsftwreOptions,onChange:function onChange(e){return _this4.OnBlueDataChange(e,"BlueData EPIC Software");}}));var AddservicesDissable=false;if(BluedataEpicsftwreValue==="None"&&this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration['@Type']==="EPIC"&&this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){this.props.workload.UserInputs.Environments.HadoopServices['AppStore']="false";this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']="false";this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']="false";this.props.workload.UserInputs.Environments.HadoopServices['Deployment']="false";//this.props.workload.UserInputs.Environments.HadoopServices['Installation']="false"
AddservicesDissable=true;}if(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage!==undefined){SingleQtyVal=this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['@Qty'];CustomQtyVal=this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['@Qty'];this.state.AppStoreCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices['AppStore']);this.state.SingleImageCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']);this.state.EPICCustomCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']);this.state.DeploymentCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices['Deployment']);this.state.InstallationCheckbox=/true/i.test(this.props.workload.UserInputs.Environments.HadoopServices['Installation']);if(this.state.SingleImageCheckbox){this.state.AppStoreCheckbox=true;this.props.workload.UserInputs.Environments.HadoopServices['AppStore']='true';}else{this.state.AppStoreCheckbox=false;this.props.workload.UserInputs.Environments.HadoopServices['AppStore']='false';}}var ExtraServices='';if(overallConfigType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_84" /* KUBERNETES_ */]||overallConfigType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_20" /* EPIC_ */]&&this.props.workload.UserInputs.Environments.WorkloadType==='BlueData'){AddservicesInstallDissable=false;AddservicesDissable=false;}if(this.state.DeploymentCheckbox){var quickStartChecked=false;var EssentialChecked=false;var AdvancedChecked=false;var PremiumChecked=false;var CustomChecked=false;var BludeDataCount=0;if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){this.props.workload.UserInputs.Environments.Environment.map(function(solution){solution.Templates.ServerDetails.Server.map(function(role){BludeDataCount=_this4.calculateBlueDataCount(role,BludeDataCount);});});this.props.workload.UserInputs.Environments.ManagementHosts.Server.map(function(role){BludeDataCount=_this4.calculateBlueDataCount(role,BludeDataCount);});}else if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]){var HDFSDataCount=0;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Storage"){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services["@Type"]==__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var ProcContrl=[];var CoreContrl=[];ProcContrl=services.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}if(services["@Type"]=="Scality"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl=[];var _CoreContrl=[];_ProcContrl=services.Hardware["@Proc"].split("/");_CoreContrl=_ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl[1],10);}if(services["@Type"]=="Weka"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl2=[];var _CoreContrl2=[];_ProcContrl2=services.Hardware["@Proc"].split("/");_CoreContrl2=_ProcContrl2[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl2[1],10);}}});}if(val['@Type']==="Database"){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services["@Type"]=="Hive"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var ProcContrl=[];var CoreContrl=[];ProcContrl=services.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}if(services["@Type"]=="Cassandra"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl3=[];var _CoreContrl3=[];_ProcContrl3=services.Hardware["@Proc"].split("/");_CoreContrl3=_ProcContrl3[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl3[1],10);}if(services["@Type"]=="Impala"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl4=[];var _CoreContrl4=[];_ProcContrl4=services.Hardware["@Proc"].split("/");_CoreContrl4=_ProcContrl4[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl4[1],10);}if(services["@Type"]=="HBase"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl5=[];var _CoreContrl5=[];_ProcContrl5=services.Hardware["@Proc"].split("/");_CoreContrl5=_ProcContrl5[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl5[1],10);}}});}if(val['@Type']==="Streaming"){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services["@Type"]=="Spark Streaming"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var ProcContrl=[];var CoreContrl=[];ProcContrl=services.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}if(services["@Type"]=="Kafka"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl6=[];var _CoreContrl6=[];_ProcContrl6=services.Hardware["@Proc"].split("/");_CoreContrl6=_ProcContrl6[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl6[1],10);}if(services["@Type"]=="Flink"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl7=[];var _CoreContrl7=[];_ProcContrl7=services.Hardware["@Proc"].split("/");_CoreContrl7=_ProcContrl7[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl7[1],10);}if(services["@Type"]=="Storm"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl8=[];var _CoreContrl8=[];_ProcContrl8=services.Hardware["@Proc"].split("/");_CoreContrl8=_ProcContrl8[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl8[1],10);}}});}if(val['@Type']==="Analytics"){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services["@Type"]=="Yarn"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var ProcContrl=[];var CoreContrl=[];ProcContrl=services.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}if(services["@Type"]=="Spark"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl9=[];var _CoreContrl9=[];_ProcContrl9=services.Hardware["@Proc"].split("/");_CoreContrl9=_ProcContrl9[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl9[1],10);}}});}if(val['@Type']==="AI"){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services["@Type"]=="Tensorflow"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var ProcContrl=[];var CoreContrl=[];ProcContrl=services.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}if(services["@Type"]=="PyTorch"&&services.Inputs["@BlueData"]=="true"&&__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(services.Hardware['@Server'])!==-1){var _ProcContrl10=[];var _CoreContrl10=[];_ProcContrl10=services.Hardware["@Proc"].split("/");_CoreContrl10=_ProcContrl10[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(_CoreContrl10[1],10);}}});}if(val['@Type']==="IoT"){if(Array.isArray(val)){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services["@Type"]=="MiNifi"&&services.Inputs["@BlueData"]=="true"&&(services.Hardware['@ServerName'].indexOf(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_14" /* E910 */])!==-1||services.Hardware['@ServerName'].indexOf(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_16" /* EL4000 */])!==-1)){var ProcContrl=[];var CoreContrl=[];ProcContrl=services.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(services.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}}});}else{if(val.Service["@Selected"]==="true"){if(val.Service["@Type"]=="MiNifi"&&val.Service.Inputs["@BlueData"]=="true"&&(val.Service.Hardware['@ServerName'].indexOf(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_14" /* E910 */])!==-1||val.Service.Hardware['@ServerName'].indexOf(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_16" /* EL4000 */])!==-1)){var ProcContrl=[];var CoreContrl=[];ProcContrl=val.Service.Hardware["@Proc"].split("/");CoreContrl=ProcContrl[2].split(" ");HDFSDataCount+=parseInt(val.Service.Hardware["@NodesCount"],10)*2*parseInt(CoreContrl[1],10);}}}}});BludeDataCount=HDFSDataCount;}if(BludeDataCount<=100){quickStartChecked=true;EssentialChecked=false;AdvancedChecked=false;PremiumChecked=false;CustomChecked=false;}else if(BludeDataCount>100&&BludeDataCount<=240){quickStartChecked=false;EssentialChecked=true;AdvancedChecked=false;PremiumChecked=false;CustomChecked=false;}else if(BludeDataCount>240&&BludeDataCount<=480){quickStartChecked=false;EssentialChecked=false;AdvancedChecked=true;PremiumChecked=false;CustomChecked=false;}else if(BludeDataCount>480&&BludeDataCount<=1200){quickStartChecked=false;EssentialChecked=false;AdvancedChecked=false;PremiumChecked=true;CustomChecked=false;}else if(BludeDataCount>1200){quickStartChecked=false;EssentialChecked=false;AdvancedChecked=false;PremiumChecked=false;CustomChecked=true;}ExtraServices=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{'between':'small'},style:{border:'2px solid rgba(0,0,0,0.48)',borderRadius:'20px',paddingBottom:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'},style:{marginLeft:'4.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:true,label:'QuickStart',checked:quickStartChecked,style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:true,label:'Essential',checked:EssentialChecked,style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:true,label:'Advanced',checked:AdvancedChecked,style:{overflow:"hidden"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'},style:{marginLeft:'4.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:true,label:'Premium',checked:PremiumChecked,style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'27px 0px 0px 9px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:true,label:'Custom',checked:CustomChecked,style:{overflow:"hidden"}}))));}if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){if(!MapRXDDisabled){var shouldEnableMapR=false;this.props.workload.UserInputs.Environments.Functions.Function.find(function(Function){return Function["@Type"]==="Storage";}).Service.map(function(val){if(val["@Selected"]==="true"){var storage=0;var diskQty=0;var updateStorageDisk=function updateStorageDisk(disk){var capacity=disk.Item["@disk"].split(' ')[1];if(disk.Item["@disk"].indexOf(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_181" /* TB_ */])!==-1){storage+=parseFloat(capacity.split(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_181" /* TB_ */])[0],10);}else if(disk.Item["@disk"].indexOf(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_35" /* GB_ */])!==-1){storage+=parseFloat(capacity.split(__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_35" /* GB_ */])[0]/1024,10);}diskQty+=disk.Item["@qty"];};if(Array.isArray(val.DataDisks)){if(val.DataDisks.length>0){val.DataDisks.map(function(disk){updateStorageDisk(disk);});}}else{updateStorageDisk(val.DataDisks);}var dataLakeStorageSize=parseInt(val.Hardware["@NodesCount"],10)*parseInt(storage,10)*parseInt(diskQty,10);if(dataLakeStorageSize>100){shouldEnableMapR=true;if(val["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]&&dataLakeStorageSize>10000){DataFabricServicesDisabled=true;datalakeServiceNote=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{style:{maxWidth:'100%',fontSize:'16px',marginTop:'15px',color:'red'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note : Contact HPE Solution Architect to request a quote for Data Fabric services.'));}}}});if(!shouldEnableMapR){MapRXDDisabled=true;}}if(MapRXDDisabled){MapRAnalyticsDisabled=true;MapRAnalyticswithSparkDisabled=true;MapRStreamsDisabled=true;MapRDatabaseDisabled=true;MapRBundleDisabled=true;}if(MapRXDDisabled===false||MapRAnalyticsDisabled===false||MapRAnalyticswithSparkDisabled===false||MapRStreamsDisabled===false||MapRDatabaseDisabled===false){MapRBundleDisabled=false;}if(MapRXDDisabled){this.state.MapRXDChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}if(MapRAnalyticsDisabled){this.state.MapRAnalyticsChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["S" /* DATAFABRIC_ANALYTICS */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}if(MapRAnalyticswithSparkDisabled){this.state.MapRAnalyticswithSparkChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["W" /* DATAFABRIC_SPARK */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}if(MapRStreamsDisabled){this.state.MapRStreamsChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["X" /* DATAFABRIC_STREAMS */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}if(MapRDatabaseDisabled){this.state.MapRDatabaseChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["U" /* DATAFABRIC_DATABASE */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}if(MapRBundleDisabled){this.state.MapRBundleChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["T" /* DATAFABRIC_BUNDLE */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}if(DataFabricServicesDisabled){this.state.DataFabricServiceChkBox=false;this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */];})["@IsSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}}if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["s" /* BLUE_DATA */]){VMWareLicenses=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',separator:'all',pad:'none',margin:'none',style:{width:'95%',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{marginLeft:'10px',marginTop:'5px'}},'VMWare Licenses'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',align:'start',wrap:false,pad:{between:'small'},margin:'medium',style:{marginTop:'10px',flexWrap:"wrap",width:'100%',marginLeft:'4.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_191" /* VMWARE_VCENTER */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':VMWare_VCenterTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px',width:'320px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vCenter"],options:VMWare_vCenter_Options,onChange:function onChange(e){return _this4.OnLicenseChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_191" /* VMWARE_VCENTER */]);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_195" /* VMWARE_VSPHERE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':VMWare_VSphereTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px',width:'320px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices.VMWare["@vSphere"],options:VMWare_vSphere_Options,onChange:function onChange(e){return _this4.OnLicenseChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_195" /* VMWARE_VSPHERE */]);}}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{position:'relative',width:'100%',overflow:"none",paddingLeft:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Warning__["a" /* default */],{message:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_54" /* HPECP_WARNING_MESSAGE */],isEnabled:!this.props.displayWarning,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default.a,{full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'96%',overflowX:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{align:'start',size:'',wrap:true,pad:'none',margin:'none',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',align:'start',size:'large',wrap:true,pad:'none',margin:'none',style:{width:'95%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{justify:'start',margin:'none',pad:{between:'small'},style:{paddingTop:'12px',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{borderBottom:'1px solid gray'},margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{style:{marginBottom:'5px'},tag:'h4',strong:true},'Licenses')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',separator:'all',pad:'none',margin:'none',style:{width:'95%',marginTop:'5px',display:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{align:'start',wrap:true,size:'xlarge',pad:'none',margin:'none',style:{width:'95%',paddingLeft:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{marginLeft:'5%',marginBottom:'1%',width:'95%',display:Hortondisply}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,_defineProperty({style:{width:'93%'},className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Hortonworks Enterprise'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':HWEntTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},'style',{overflow:"hidden",width:'62%'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:HortonWorkEntValue,options:HortonWorkEntOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'HortonWorkEntValue');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{disabled:HwDataFlowDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Hortonworks Ent Data Flow'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':HWEntDataFlowTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.HortonChBox4,onChange:function onChange(e){return _this4.onHortonChBoxChange(e,"HortonWorkEntDataflowValue");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:HortonWorkEntDataflowValue,options:HortonWorkEntDataflowOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'HortonWorkEntDataflowValue');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{align:'start',wrap:true,size:'xlarge',pad:'none',margin:'none',style:{width:'100%',display:Clouderadisply}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{marginLeft:'5%',marginBottom:'1%',width:'95%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{disabled:CLEraESSDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Cloudera Essentials'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':CLEraEssTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.CloudEraChBox2,onChange:function onChange(e){return _this4.onClouderaESSChBoxChange(e,"ClouderaEssValue");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:ClouderaEssValue,options:ClouderaEssOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'ClouderaEssValue');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{disabled:CLEraEntDataHubDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Cloudera Ent Data Hub'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':CLEraEntDataHubTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.CloudEraChBox3,onChange:function onChange(e){return _this4.onClouderaEntDataHubChBoxChange(e,"ClouderaEntDataHubValue");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:ClouderaEntDataHubValue,options:ClouderaEntDataHubOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'ClouderaEntDataHubValue');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{disabled:CLEraDataSciNdEngDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Cloudera Data Engineering'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':CLEraDataSciNdEngTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.CloudEraChBox4,onChange:function onChange(e){return _this4.onClouderaDataEngChBoxChange(e,"ClouderaDataEngValue");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:ClouderaDataEngValue,options:ClouderaDataEngOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'ClouderaDataEngValue');}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{marginLeft:'5%',marginBottom:'1%',width:'63%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{disabled:CLEraOpDBDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Cloudera Opt Database'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':CLEraOptDBTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.CloudEraChBox5,onChange:function onChange(e){return _this4.onClouderaOpDBChBoxChange(e,"ClouderaOpDbValue");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:ClouderaOpDbValue,options:ClouderaOpDbOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'ClouderaOpDbValue');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{disabled:CLEraAnalyDBDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Cloudera Analytical DB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':CLEraAnalDBTooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.CloudEraChBox6,onChange:function onChange(e){return _this4.onClouderaAnaDBChBoxChange(e,"ClouderaAnaDbValue");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:ClouderaAnaDbValue,options:ClouderaAnaDbOptions,onChange:function onChange(e){_this4.OnServicedrpdwnChange(e,'ClouderaAnaDbValue');}})))),this.props.workload.UserInputs.Environments.WorkloadType==='BigData'&&this.state.MapRRadioBtn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{align:'start',wrap:true,size:'xlarge',pad:'none',margin:'none',style:{width:'100%',display:MapRContentdisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%',marginBottom:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:'XD',disabled:MapRXDDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_63" /* HPE_EZMERAL_DF_FILE_STORE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Supported services: Data Lake, Scality and Weka','data-for':'XDt',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.MapRXDChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */]);},style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'XDt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:'Analytics',disabled:MapRAnalyticsDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_60" /* HPE_EZMERAL_DF_ANALYTICS */]),'         ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Supported services: Yarn and Spark','data-for':'Analyticst',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.MapRAnalyticsChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["S" /* DATAFABRIC_ANALYTICS */]);},style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'Analyticst'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:'Spark',disabled:MapRAnalyticswithSparkDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_64" /* HPE_EZMERAL_DF_SPARK */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Supported services: Spark','data-for':'Sparkt',colorIndex:'accent-3',style:{height:"20px"}})),checked:this.state.MapRAnalyticswithSparkChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["W" /* DATAFABRIC_SPARK */]);},style:{overflow:"hidden"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'Sparkt'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:'Streams',disabled:MapRStreamsDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_65" /* HPE_EZMERAL_DF_STREAMS */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Supported services: Spark Streaming, Kafka, Flink and Storm','data-for':'Streamst',colorIndex:'accent-3',style:{height:"20px"}})),checked:this.state.MapRStreamsChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["X" /* DATAFABRIC_STREAMS */]);},style:{overflow:"hidden",width:'6%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'Streamst'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:'Database',disabled:MapRDatabaseDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_62" /* HPE_EZMERAL_DF_DATABASE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Supported services: Hive, Cassandra, Impala and HBase','data-for':'Databaset',colorIndex:'accent-3',style:{height:"20px"}})),checked:this.state.MapRDatabaseChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["U" /* DATAFABRIC_DATABASE */]);},style:{overflow:"hidden",width:'6%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'Databaset'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:'Bundle',disabled:MapRBundleDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_61" /* HPE_EZMERAL_DF_BUNDLE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Bundle includes MapR XD, MapR Analytics, MapR Analytics with Spark, MapR Streams and MapR Database.','data-for':'Bundlet',colorIndex:'accent-3',style:{height:"20px"}})),checked:this.state.MapRBundleChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["T" /* DATAFABRIC_BUNDLE */]);},style:{overflow:"hidden",width:'6%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'Bundlet'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'HPE Ezmeral Data Fabric License'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px',marginTop:'5px',width:'30%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:hpeEzmeralDataFabricLicense,options:hpeEzmeralDataFabricLicenseOptions,onChange:function onChange(e){_this4.OnBlueDataChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */]);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'45%',marginTop:'15px',marginLeft:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{id:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_156" /* SERVICES_ */],disabled:DataFabricServicesDisabled,label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Supported services: Data Lake','data-for':__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_156" /* SERVICES_ */]+'t',colorIndex:'accent-3',style:{height:"20px"}})),checked:this.state.DataFabricServiceChkBox,onChange:function onChange(e){return _this4.onMapRcheckBoxChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */]);},style:{overflow:"hidden",width:'6%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_156" /* SERVICES_ */]+'t'}))),datalakeServiceNote):'')),this.props.workload.UserInputs.Environments.WorkloadType!=='BigData'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',separator:'all',pad:'none',margin:'none',style:{width:'95%',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{align:'start',wrap:true,size:'xlarge',pad:'none',margin:'none',style:{width:'95%',paddingLeft:"10px",marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{between:'small'},style:{marginBottom:'10px',display:'',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',align:'start',pad:{between:'small'},style:{width:'90%',marginLeft:'4.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */])),checked:this.state.KubernetesDataappsChBox,onChange:function onChange(){return _this4.onKubernetesChBoxsChange("Data Apps");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.state.KubernetesDataappsChBox?KubernetesDataAppsValue:'None',options:this.state.KubernetesDataappsChBox?KubernetesDataAppsOptions.filter(function(item){return item!=='None';}):['None'],onChange:function onChange(e){_this4.onKubernetesvalueChanges(e,'Data Apps');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'ML Ops')),checked:this.state.KubernetesDataappswMLOpsChBox,onChange:function onChange(){return _this4.onKubernetesChBoxsChange("Data Apps w/ML Ops");},style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.state.KubernetesDataappswMLOpsChBox?KubernetesDataAppswMLOpsValue:'None',options:this.state.KubernetesDataappswMLOpsChBox?KubernetesDataAppswMLOpsOptions.filter(function(item){return item!=='None';}):['None'],onChange:function onChange(e){_this4.onKubernetesvalueChanges(e,'Data Apps w/ML Ops');}})))))):'',overallConfigType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_84" /* KUBERNETES_ */]||this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["o" /* BIG_DATA */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',separator:'all',pad:'none',margin:'none',style:{width:'95%',marginTop:'5px',paddingLeft:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{marginLeft:'10px',marginTop:'5px'}},'Ezmeral ',__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */],' Additional Services'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',align:'start',wrap:false,pad:{between:'small'},margin:'medium',style:{marginTop:'10px',flexWrap:"wrap",width:'100%',marginLeft:'4.5%'}},this.props.workload.UserInputs.Environments.WorkloadType==='BigData'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{style:{width:'29%',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton___default.a,{disabled:BlueDataEpicDisabled,id:'BlueEPIC',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_68" /* HPE_E_CP */],' EPIC Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'A HPE Ezmeral '+__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */]+' license is required. Select the term of the support desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.BlueDataEpicChecked,onChange:this.onBlueDataRadioBtnChange,style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:BluedataEpicsftwreValue,options:BluedataEpicsftwreOptions,onChange:function onChange(e){return _this4.OnBlueDataChange(e,"BlueData EPIC Software");}})):'',this.props.workload.UserInputs.Environments.WorkloadType==='BigData'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{style:{width:'29%',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton___default.a,{disabled:BlueDataMLDisabled,id:'BlueML',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'HPE Ezmeral ML Ops Software '),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'A HPE Ezmeral '+__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */]+' ML license is required. Select the term of the support desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),checked:this.state.BlueDataMLChecked,onChange:this.onBlueDataRadioBtnChange,style:{overflow:"hidden",width:'62%'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:BluedataMLsftwreValue,options:BluedataMLsftwreOptions,onChange:function onChange(e){return _this4.OnBlueDataChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_67" /* HPE_EZMERAL_MLOPS */]);}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{style:{width:'42%',marginBottom:'10px'},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'HPE ',__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_147" /* RE_SHORT */],' External Kubernetes Cluster Manager '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'A HPE Ezmeral '+__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */]+' ML license is required. Select the term of the support desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:kubernetesCM,options:externalK8sClusterMngrOptions,onChange:function onChange(e){return _this4.OnBlueDataChange(e,__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_70" /* HPE_E_CP_EXTERNAL_K8S_CLUSTER_MNGR */]);}})))):'',VMWareLicenses,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',separator:'all',pad:'none',margin:'none',style:{width:'95%',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{marginLeft:'10px',marginTop:'5px'}},'Other Licenses'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',align:'start',wrap:false,pad:{between:'small'},margin:'medium',style:{marginTop:'10px',flexWrap:"wrap",width:'100%',marginLeft:'4.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Scality'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Scality RING licenses',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px',display:scalitydisplay,width:'320px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices['Scality'],options:this.state.ScalityOptions,onChange:function onChange(e){return _this4.OnLicenseChange(e,"Scality");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'HPCM/CMU License'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'HPCM: HPE Performance Cluster Manager provides complete provisioning, management and monitoring for clusters scaling to 100,000 nodes.  CMU: HPE Insight CMU is an integrated, easy-to-use tool for cluster administration, providing complete provisioning, management and monitoring for clusters of any scale.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px',width:'320px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices['HPCM'],options:this.state.HPCMOptions,onChange:function onChange(e){return _this4.OnLicenseChange(e,"HPCM");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:'Linux License',style:{marginBottom:'5px',width:"320px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices['LinuxLicense'],options:this.state.LinuxLicenseOptions,onChange:function onChange(e){return _this4.OnLicenseChange(e,"LinuxLicense");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',style:{marginBottom:'5px',width:"320px"},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'iLO License'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'iLO: HPE Integrated Lights-Out (iLO) provides the automated intelligence to maintain complete server control from any place, anywhere and ships with every ProLiant Server. Purchasing 1 or 3 year support licenses refers to the length of the support agreement for licensed iLO features."',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices['iLoLicense'],options:this.state.iLOLicenseOptions,onChange:function onChange(e){return _this4.OnLicenseChange(e,"iLoLicense");}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',separator:'all',pad:'none',margin:'none',style:{width:'95%',marginTop:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{align:'start',wrap:false,pad:{between:'small'},margin:'medium',style:{marginTop:'27px',marginLeft:'6px',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{marginLeft:'10px',marginTop:'5px',marginBottom:'0px'}},' HPE Ezmeral ',__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_145" /* RE */],' Additional Services'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'},style:{marginLeft:'4.5%',width:'95%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{'between':'small'},style:{width:'53%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:AddservicesInstallDissable,label:'Installation and Start-up Services',checked:this.state.InstallationCheckbox,onChange:function onChange(e){return _this4.onLicensesChanged(e,"Installation");},style:{overflow:"hidden"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:AddservicesDissable,label:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_68" /* HPE_E_CP */]+" Single Image Development SVC",checked:this.state.SingleImageCheckbox,onChange:function onChange(e){return _this4.onLicensesChanged(e,"SingleImage");},style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',alignContent:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput___default.a,{id:'UserDefined',value:SingleQtyVal,hidden:!this.state.SingleImageCheckbox,style:{width:'40%',border:'1px solid #01a982'},onDOMChange:function onDOMChange(e){return _this4.onLicensesQtyChanged(e,"SingleImage","Change");},onBlur:function onBlur(e){return _this4.onLicensesQtyChanged(e,"SingleImage","Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',hidden:!this.state.SingleImageCheckbox,style:{marginLeft:"7px"}},"Qty"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:AddservicesDissable,label:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_68" /* HPE_E_CP */]+" Custom Image Development SVC",checked:this.state.EPICCustomCheckbox,onChange:function onChange(e){return _this4.onLicensesChanged(e,"CustomImage");},style:{overflow:"hidden"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',alignContent:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TextInput___default.a,{id:'UserDefined',value:CustomQtyVal,hidden:!this.state.EPICCustomCheckbox,style:{width:'40%',border:'1px solid #01a982'},onDOMChange:function onDOMChange(e){return _this4.onLicensesQtyChanged(e,"CustomImage","Change");},onBlur:function onBlur(e){return _this4.onLicensesQtyChanged(e,"CustomImage","Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',hidden:!this.state.EPICCustomCheckbox,style:{marginLeft:"7px"}},"Qty"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:true,label:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_68" /* HPE_E_CP */]+" App Store Development SVC",checked:this.state.AppStoreCheckbox,onChange:function onChange(e){return _this4.onLicensesChanged(e,"AppStore");},style:{overflow:"hidden"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'LatestLicenses',disabled:AddservicesDissable,label:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants__["_68" /* HPE_E_CP */]+" Deployment and Integration Services",checked:this.state.DeploymentCheckbox,onChange:function onChange(e){return _this4.onLicensesChanged(e,"Deployment");},style:{overflow:"hidden"}}),ExtraServices))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{justify:'start',margin:'none',pad:'none',style:{paddingTop:'12px',width:'95%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{borderBottom:'1px solid gray'},margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{style:{marginBottom:'5px'},tag:'h4',strong:true},'Support'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',align:'start',pad:{between:'small'},margin:'small',style:{width:'92%',marginBottom:'16%',marginTop:'10px',marginLeft:'5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'HWSupport',label:'HW Support',style:{marginBottom:'5px',width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.workload.UserInputs.Environments.HadoopServices['HWSupport'],options:this.state.HWSupportOptions,onChange:function onChange(e){return _this4.OnLicenseChange(e,"HWSupport");}})))))));}}}]);return HadoopServices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{workload:state.sizerWorkload.workload,activeSession:state.sessions.activeSession,ServicesInput:state.sizerWorkload,services:state.sessions,ConfigButton:state.sizerWorkload.calbtn,GPUdetails:state.sizerWorkload.GPUdetails,NonGPUdetails:state.sizerWorkload.NonGPUdetails,GPUdetailsforcore:state.sizerWorkload.workload.UserInputs.Environments,displayWarning:state.sizerWorkload.guiState.displayWarning};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__["W" /* toggleSizeButton */])(value));},updateError:function updateError(errorMsg){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__["p" /* errorValidataion */])(errorMsg));},OntoggleSizeButton:function OntoggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__["W" /* toggleSizeButton */])(value));}//    OnFetchDefaults:()=>{
//     dispatch(fetchDefaults());
//   }
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(HadoopServices));

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-up', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'up');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polyline', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '7.086 1.174 17.086 11.174 7.086 21.174', transform: 'rotate(-89 12.086 11.174)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Up';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
  };

  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */
  target.rebuild = function () {
    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
  };

  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */
  target.show = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = { currentTarget: event.detail.target };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
    }
  };
};

var _constant = __webpack_require__(279);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatible with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event = void 0;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: opts });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
  };
};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isBodyMode = function () {
    return !!this.props.bodyMode;
  };

  target.prototype.bindBodyListener = function (targetArray) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff,
        possibleCustomEvents = _state.possibleCustomEvents,
        possibleCustomEventsOff = _state.possibleCustomEventsOff;

    var body = getBody();

    var customEvents = findCustomEvents(targetArray, 'data-event');
    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');

    if (event != null) customEvents[event] = true;
    if (eventOff != null) customEventsOff[eventOff] = true;
    possibleCustomEvents.split(' ').forEach(function (event) {
      return customEvents[event] = true;
    });
    possibleCustomEventsOff.split(' ').forEach(function (event) {
      return customEventsOff[event] = true;
    });

    this.unbindBodyListener(body);

    var listeners = this.bodyModeListeners = {};
    if (event == null) {
      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, { respectEffect: true });
      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
    }

    for (var _event in customEvents) {
      listeners[_event] = bodyListener.bind(this, function (e) {
        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
        _customEvent.checkStatus.call(_this, targetEventOff, e);
      }, { customEvent: true });
    }
    for (var _event2 in customEventsOff) {
      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, { customEvent: true });
    }
    for (var _event3 in listeners) {
      body.addEventListener(_event3, listeners[_event3]);
    }
  };

  target.prototype.unbindBodyListener = function (body) {
    body = body || getBody();

    var listeners = this.bodyModeListeners;
    for (var event in listeners) {
      body.removeEventListener(event, listeners[event]);
    }
  };
};

var _customEvent = __webpack_require__(281);

var makeProxy = function makeProxy(e) {
  var proxy = {};
  for (var key in e) {
    if (typeof e[key] === 'function') {
      proxy[key] = e[key].bind(e);
    } else {
      proxy[key] = e[key];
    }
  }
  return proxy;
}; /**
    * Util method to get effect
    */


var bodyListener = function bodyListener(callback, options, e) {
  var _options$respectEffec = options.respectEffect,
      respectEffect = _options$respectEffec === undefined ? false : _options$respectEffec,
      _options$customEvent = options.customEvent,
      customEvent = _options$customEvent === undefined ? false : _options$customEvent;
  var id = this.props.id;


  var tip = e.target.getAttribute('data-tip') || null;
  var forId = e.target.getAttribute('data-for') || null;

  var target = e.target;
  if (this.isCustomEvent(target) && !customEvent) {
    return;
  }

  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;

  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
    var proxy = makeProxy(e);
    proxy.currentTarget = target;
    callback(proxy);
  }
};

var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
  var events = {};
  targetArray.forEach(function (target) {
    var event = target.getAttribute(dataAttribute);
    if (event) event.split(' ').forEach(function (event) {
      return events[event] = true;
    });
  });

  return events;
};

var getBody = function getBody() {
  return document.getElementsByTagName('body')[0];
};

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;

    var observer = new MutationObserver(function (mutations) {
      for (var m1 = 0; m1 < mutations.length; m1++) {
        var mutation = mutations[m1];
        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
          var element = mutation.removedNodes[m2];
          if (element === _this.state.currentTarget) {
            _this.hideTooltip();
            return;
          }
        }
      }
    });

    observer.observe(window.document, { childList: true, subtree: true });

    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
};

/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */

// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
  var _getDimensions = getDimensions(node),
      tipWidth = _getDimensions.width,
      tipHeight = _getDimensions.height;

  var _getDimensions2 = getDimensions(target),
      targetWidth = _getDimensions2.width,
      targetHeight = _getDimensions2.height;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft;

  // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };
  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  };

  //
  // Functions to test whether the tooltip's sides are inside
  // the client window for a given orientation p
  //
  //  _____________
  // |             | <-- Right side
  // | p = 'left'  |\
  // |             |/  |\
  // |_____________|   |_\  <-- Mouse
  //      / \           |
  //       |
  //       |
  //  Bottom side
  //
  var outsideLeft = function outsideLeft(p) {
    return getTipOffsetLeft(p) < 0;
  };
  var outsideRight = function outsideRight(p) {
    return getTipOffsetRight(p) > windowWidth;
  };
  var outsideTop = function outsideTop(p) {
    return getTipOffsetTop(p) < 0;
  };
  var outsideBottom = function outsideBottom(p) {
    return getTipOffsetBottom(p) > windowHeight;
  };

  // Check whether the tooltip with orientation p is completely inside the client window
  var outside = function outside(p) {
    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
  };
  var inside = function inside(p) {
    return !outside(p);
  };

  var placesList = ['top', 'bottom', 'left', 'right'];
  var insideList = [];
  for (var i = 0; i < 4; i++) {
    var p = placesList[i];
    if (inside(p)) {
      insideList.push(p);
    }
  }

  var isNewState = false;
  var newPlace = void 0;
  var shouldUpdatePlace = desiredPlace !== place;
  if (inside(desiredPlace) && shouldUpdatePlace) {
    isNewState = true;
    newPlace = desiredPlace;
  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
    isNewState = true;
    newPlace = insideList[0];
  }

  if (isNewState) {
    return {
      isNewState: true,
      newState: { place: newPlace }
    };
  }

  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
};

var getDimensions = function getDimensions(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      height = _node$getBoundingClie.height,
      width = _node$getBoundingClie.width;

  return {
    height: parseInt(height, 10),
    width: parseInt(width, 10)
  };
};

// Get current mouse offset
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;

  var _getDimensions3 = getDimensions(currentTarget),
      targetWidth = _getDimensions3.width,
      targetHeight = _getDimensions3.height;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};

// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top = void 0;
  var right = void 0;
  var bottom = void 0;
  var left = void 0;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return { top: top, bottom: bottom, left: left, right: right };
};

// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
  }
  for (var key in offset) {
    if (key === 'top') {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
};

// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;

  return { parentTop: parentTop, parentLeft: parentLeft };
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
  if (getContent === null) return null; // Tip not exist and children is null or undefined

  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map(function (d, i) {
    return _react2.default.createElement(
      'span',
      { key: i, className: 'multi-line' },
      d
    );
  });
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return (/(^aria-\w+$|^role$)/.test(prop)
    );
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });

  return ariaObj;
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip.allow_hover,.__react_component_tooltip.allow_click{pointer-events:auto}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames4 = __webpack_require__(3);

var _classnames5 = _interopRequireDefault(_classnames4);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Drop = __webpack_require__(124);

var _Drop2 = _interopRequireDefault(_Drop);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _Responsive = __webpack_require__(78);

var _Responsive2 = _interopRequireDefault(_Responsive);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _Search = __webpack_require__(548);

var _Search2 = _interopRequireDefault(_Search);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SEARCH;
var INPUT = _CSSClassnames2.default.INPUT;
var BACKGROUND_COLOR_INDEX = _CSSClassnames2.default.BACKGROUND_COLOR_INDEX;

var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search(props, context) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props, context));

    _this._onAddDrop = _this._onAddDrop.bind(_this);
    _this._onRemoveDrop = _this._onRemoveDrop.bind(_this);
    _this._onFocusInput = _this._onFocusInput.bind(_this);
    _this._onChangeInput = _this._onChangeInput.bind(_this);
    _this._onClickBody = _this._onClickBody.bind(_this);
    _this._onNextSuggestion = _this._onNextSuggestion.bind(_this);
    _this._onPreviousSuggestion = _this._onPreviousSuggestion.bind(_this);
    _this._announceSuggestion = _this._announceSuggestion.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);
    _this._onClickSuggestion = _this._onClickSuggestion.bind(_this);
    _this._onMouseUp = _this._onMouseUp.bind(_this);
    _this._onInputKeyDown = _this._onInputKeyDown.bind(_this);
    _this._onSink = _this._onSink.bind(_this);
    _this._onResponsive = _this._onResponsive.bind(_this);
    _this._stopPropagation = _this._stopPropagation.bind(_this);

    _this.state = {
      announceChange: false,
      activeSuggestionIndex: -1,
      align: 'left',
      dropActive: false,
      inline: props.inline,
      small: false
    };
    return _this;
  }

  _createClass(Search, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          initialFocus = _props.initialFocus,
          inline = _props.inline,
          responsive = _props.responsive;

      if (inline && responsive) {
        this._responsive = _Responsive2.default.start(this._onResponsive);
      }
      if (initialFocus) {
        (0, _reactDom.findDOMNode)(this._inputRef).focus();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _state = this.state,
          dropActive = _state.dropActive,
          inline = _state.inline,
          small = _state.small;

      if (nextProps.suggestions && nextProps.suggestions.length > 0 && !dropActive && this._inputRef === document.activeElement) {
        this.setState({ dropActive: true });
      } else if ((!nextProps.suggestions || nextProps.suggestions.length === 0) && inline) {
        this.setState({ dropActive: false });
      }
      if (!small && nextProps.inline !== this.props.inline) {
        this.setState({ inline: nextProps.inline });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          dropAlign = _props2.dropAlign,
          suggestions = _props2.suggestions;
      var _state2 = this.state,
          announceChange = _state2.announceChange,
          dropActive = _state2.dropActive,
          inline = _state2.inline;
      var intl = this.context.intl;
      // Set up keyboard listeners appropriate to the current state.

      var activeKeyboardHandlers = {
        esc: this._onRemoveDrop,
        tab: this._onRemoveDrop,
        up: this._onPreviousSuggestion,
        down: this._onNextSuggestion,
        enter: this._onEnter,
        left: this._stopPropagation,
        right: this._stopPropagation
      };

      if (!dropActive && prevState.dropActive) {
        document.removeEventListener('click', this._onClickBody);
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, activeKeyboardHandlers);
        if (this._drop) {
          this._drop.remove();
          this._drop = undefined;
        }
      }

      if (dropActive && !prevState.dropActive) {
        document.addEventListener('click', this._onClickBody);
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, activeKeyboardHandlers);

        var baseElement = void 0;
        if (this._controlRef) {
          baseElement = (0, _reactDom.findDOMNode)(this._controlRef);
        } else {
          baseElement = this._inputRef;
        }
        var align = dropAlign || {
          top: inline ? 'bottom' : 'top',
          left: 'left'
        };
        this._drop = new _Drop2.default(baseElement, this._renderDropContent(), {
          align: align,
          focusControl: !inline,
          responsive: false // so suggestion changes don't re-align
        });

        if (this._inputRef) {
          this._inputRef.focus();
        }
      } else if (this._drop) {
        this._drop.render(this._renderDropContent());
      }

      if (announceChange && suggestions) {
        var matchResultsMessage = _Intl2.default.getMessage(intl, 'Match Results', {
          count: suggestions.length
        });
        var navigationHelpMessage = '';
        if (suggestions.length) {
          navigationHelpMessage = '(' + _Intl2.default.getMessage(intl, 'Navigation Help') + ')';
        }
        (0, _Announcer.announce)(matchResultsMessage + ' ' + navigationHelpMessage);
        this.setState({ announceChange: false });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this._onClickBody);
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this);
      if (this._responsive) {
        this._responsive.stop();
      }
      if (this._drop) {
        this._drop.remove();
      }
    }
  }, {
    key: 'focus',
    value: function focus() {
      var input = this._inputRef;
      if (input) {
        (0, _reactDom.findDOMNode)(input).focus();
      }
    }
  }, {
    key: '_stopPropagation',
    value: function _stopPropagation() {
      if (document.activeElement === this._inputRef) {
        return true;
      }
    }
  }, {
    key: '_onInputKeyDown',
    value: function _onInputKeyDown(event) {
      var _props3 = this.props,
          inline = _props3.inline,
          onSelect = _props3.onSelect,
          suggestions = _props3.suggestions,
          onKeyDown = _props3.onKeyDown;

      var enter = 13;
      var dropActive = this.state.dropActive;

      if (suggestions) {
        var up = 38;
        var down = 40;
        if (event.keyCode === up || event.keyCode === down) {
          // stop the input to move the cursor when suggestions are present
          event.preventDefault();

          if (event.keyCode === down && !dropActive && inline) {
            this._onAddDrop();
          }
        }
      }
      if (!dropActive && onSelect && event.keyCode === enter) {
        onSelect({
          target: this._inputRef || this._controlRef
        }, false);
      }
      if (onKeyDown) {
        onKeyDown(event);
      }
    }
  }, {
    key: '_onClickBody',
    value: function _onClickBody(event) {
      // don't close drop when clicking on input
      if (event.target !== this._inputRef) {
        this._onRemoveDrop();
      }
    }
  }, {
    key: '_onAddDrop',
    value: function _onAddDrop() {
      this.setState({ dropActive: true, activeSuggestionIndex: -1 });
    }
  }, {
    key: '_onRemoveDrop',
    value: function _onRemoveDrop() {
      this.setState({ dropActive: false });
    }
  }, {
    key: '_onFocusInput',
    value: function _onFocusInput(event) {
      var _props4 = this.props,
          onFocus = _props4.onFocus,
          suggestions = _props4.suggestions;

      if (onFocus) {
        onFocus(event);
      }
      if (suggestions && suggestions.length > 0) {
        this._onAddDrop();
      }
    }
  }, {
    key: '_fireDOMChange',
    value: function _fireDOMChange() {
      var onDOMChange = this.props.onDOMChange;

      var event = void 0;
      try {
        event = new Event('change', {
          'bubbles': true,
          'cancelable': true
        });
      } catch (e) {
        // IE11 workaround.
        event = document.createEvent('Event');
        event.initEvent('change', true, true);
      }
      var target = this._inputRef;
      target.dispatchEvent(event);
      onDOMChange(event);
    }
  }, {
    key: '_onChangeInput',
    value: function _onChangeInput(event) {
      var onDOMChange = this.props.onDOMChange;

      this.setState({ activeSuggestionIndex: -1, announceChange: true });
      if (onDOMChange) {
        this._fireDOMChange();
      }
    }
  }, {
    key: '_announceSuggestion',
    value: function _announceSuggestion(index) {
      var intl = this.context.intl;

      var labelMessage = this._renderLabel(this.props.suggestions[index]);
      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
      (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
    }
  }, {
    key: '_onNextSuggestion',
    value: function _onNextSuggestion() {
      var suggestions = this.props.suggestions;

      if (suggestions) {
        var index = this.state.activeSuggestionIndex;
        index = Math.min(index + 1, suggestions.length - 1);
        this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
      }
    }
  }, {
    key: '_onPreviousSuggestion',
    value: function _onPreviousSuggestion() {
      var suggestions = this.props.suggestions;

      if (suggestions) {
        var index = this.state.activeSuggestionIndex;
        index = Math.max(index - 1, 0);
        this.setState({ activeSuggestionIndex: index }, this._announceSuggestion.bind(this, index));
      }
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(event) {
      var _this2 = this;

      var _props5 = this.props,
          inline = _props5.inline,
          onSelect = _props5.onSelect,
          suggestions = _props5.suggestions;
      var activeSuggestionIndex = this.state.activeSuggestionIndex;
      var intl = this.context.intl;
      // for not inline search the enter should NOT submit the form
      // in this case double enter is required

      if (!inline) {
        event.preventDefault(); // prevent submitting forms
      }

      if (activeSuggestionIndex >= 0) {
        var suggestion = suggestions[activeSuggestionIndex];
        this.setState({ value: suggestion }, function () {
          var suggestionMessage = _this2._renderLabel(suggestion);
          var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
          (0, _Announcer.announce)(suggestionMessage + ' ' + selectedMessage);
        });
        if (onSelect) {
          onSelect({
            target: this._inputRef || this._controlRef,
            suggestion: suggestion
          }, true);
        }
      } else if (onSelect) {
        onSelect({
          target: this._inputRef || this._controlRef
        }, false);
      }

      this._onRemoveDrop();
    }
  }, {
    key: '_onClickSuggestion',
    value: function _onClickSuggestion(suggestion) {
      var onSelect = this.props.onSelect;

      this._onRemoveDrop();
      if (onSelect) {
        onSelect({
          target: this._inputRef || this._controlRef,
          suggestion: suggestion
        }, true);
      }
    }
  }, {
    key: '_onMouseUp',
    value: function _onMouseUp(event) {
      var onMouseUp = this.props.onMouseUp;
      // This fixes a Safari bug which prevents the input
      // text from being selected on focus.

      event.preventDefault();
      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: '_onSink',
    value: function _onSink(event) {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    }
  }, {
    key: '_onResponsive',
    value: function _onResponsive(small) {
      var inline = this.props.inline;

      if (small) {
        this.setState({ inline: false, small: small });
      } else {
        this.setState({ inline: inline, small: small });
      }
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel(suggestion) {
      if ((typeof suggestion === 'undefined' ? 'undefined' : _typeof(suggestion)) === 'object') {
        return suggestion.label || suggestion.value;
      } else {
        return suggestion;
      }
    }
  }, {
    key: '_renderDropContent',
    value: function _renderDropContent() {
      var _classnames,
          _this3 = this;

      var _props6 = this.props,
          defaultValue = _props6.defaultValue,
          dropAlign = _props6.dropAlign,
          dropColorIndex = _props6.dropColorIndex,
          suggestions = _props6.suggestions,
          value = _props6.value;
      var _state3 = this.state,
          inline = _state3.inline,
          activeSuggestionIndex = _state3.activeSuggestionIndex;

      var restProps = _Props2.default.omit(this.props, Object.keys(Search.propTypes));
      var classes = (0, _classnames5.default)(CLASS_ROOT + '__drop', (_classnames = {}, _defineProperty(_classnames, BACKGROUND_COLOR_INDEX + '-' + dropColorIndex, dropColorIndex), _defineProperty(_classnames, CLASS_ROOT + '__drop--controlled', !inline), _classnames));

      var input = void 0;
      if (!inline) {
        input = _react2.default.createElement('input', _extends({}, restProps, { key: 'input', ref: function ref(_ref) {
            return _this3._inputRef = _ref;
          },
          type: 'search', autoComplete: 'off', value: value,
          defaultValue: defaultValue, onChange: this._onChangeInput,
          className: INPUT + ' ' + CLASS_ROOT + '__input',
          onKeyDown: this._onInputKeyDown }));
      }

      var suggestionsNode = void 0;
      if (suggestions) {
        suggestionsNode = suggestions.map(function (suggestion, index) {
          var classes = (0, _classnames5.default)(CLASS_ROOT + '__suggestion', _defineProperty({}, CLASS_ROOT + '__suggestion--active', index === activeSuggestionIndex));

          return _react2.default.createElement(
            'div',
            { key: index, className: classes, tabIndex: '-1', role: 'button',
              onClick: _this3._onClickSuggestion.bind(_this3, suggestion),
              onFocus: function onFocus() {
                return _this3.setState({ activeSuggestionIndex: index });
              } },
            _this3._renderLabel(suggestion)
          );
        }, this);
        suggestionsNode = _react2.default.createElement(
          'div',
          { key: 'suggestions', className: CLASS_ROOT + '__suggestions' },
          suggestionsNode
        );
      }

      var contents = [input, suggestionsNode];

      if (!inline) {
        contents = [_react2.default.createElement(
          'div',
          { key: 'contents', className: CLASS_ROOT + '__drop-contents',
            onClick: this._onSink },
          contents
        )];
        if (!dropAlign || !dropAlign.top && !dropAlign.bottom) {
          var control = _react2.default.createElement(_Button2.default, { key: 'icon', icon: _react2.default.createElement(_Search2.default, null),
            className: CLASS_ROOT + '__drop-control',
            onClick: this._onRemoveDrop });
          if (!dropAlign || dropAlign.left === 'left') {
            contents.unshift(control);
          } else if (dropAlign.right === 'right') {
            contents.push(control);
          }
        }
      }

      return _react2.default.createElement(
        'div',
        { className: classes },
        contents
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames3,
          _this4 = this;

      var _props7 = this.props,
          className = _props7.className,
          defaultValue = _props7.defaultValue,
          iconAlign = _props7.iconAlign,
          id = _props7.id,
          fill = _props7.fill,
          pad = _props7.pad,
          placeHolder = _props7.placeHolder,
          size = _props7.size,
          value = _props7.value;
      var inline = this.state.inline;

      var restProps = _Props2.default.omit(this.props, Object.keys(Search.propTypes));
      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames3 = {}, _defineProperty(_classnames3, CLASS_ROOT + '--controlled', !inline), _defineProperty(_classnames3, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames3, CLASS_ROOT + '--icon-align-' + iconAlign, iconAlign), _defineProperty(_classnames3, CLASS_ROOT + '--pad-' + pad, pad), _defineProperty(_classnames3, CLASS_ROOT + '--inline', inline), _defineProperty(_classnames3, CLASS_ROOT + '--' + size, size), _classnames3), className);

      if (inline) {
        return _react2.default.createElement(
          'div',
          { className: classes },
          _react2.default.createElement('input', _extends({}, restProps, { ref: function ref(_ref2) {
              return _this4._inputRef = _ref2;
            },
            type: 'search', id: id, placeholder: placeHolder,
            autoComplete: 'off',
            defaultValue: this._renderLabel(defaultValue),
            value: this._renderLabel(value),
            className: INPUT + ' ' + CLASS_ROOT + '__input',
            onFocus: this._onFocusInput,
            onChange: this._onChangeInput,
            onMouseUp: this._onMouseUp,
            onKeyDown: this._onInputKeyDown })),
          _react2.default.createElement(_Search2.default, null)
        );
      } else {
        return _react2.default.createElement(_Button2.default, { ref: function ref(_ref3) {
            return _this4._controlRef = _ref3;
          },
          id: id, className: className, icon: _react2.default.createElement(_Search2.default, null),
          onClick: this._onAddDrop });
      }
    }
  }]);

  return Search;
}(_react.Component);

Search.displayName = 'Search';
exports.default = Search;


Search.contextTypes = {
  intl: _propTypes2.default.object
};

Search.defaultProps = {
  align: 'left',
  iconAlign: 'end',
  inline: false,
  responsive: true
};

Search.propTypes = {
  align: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  dropAlign: _Drop.dropAlignPropType,
  dropColorIndex: _propTypes2.default.string,
  fill: _propTypes2.default.bool,
  iconAlign: _propTypes2.default.oneOf(['start', 'end']),
  id: _propTypes2.default.string,
  initialFocus: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  onDOMChange: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  pad: _propTypes2.default.oneOf(['small', 'medium']),
  placeHolder: _propTypes2.default.string,
  responsive: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  suggestions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape({
    label: _propTypes2.default.node,
    value: _propTypes2.default.any
  }), _propTypes2.default.string])),
  value: _propTypes2.default.string
};
module.exports = exports['default'];

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-search', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'search');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M15,15 L22,22 L15,15 Z M9.5,17 C13.6421356,17 17,13.6421356 17,9.5 C17,5.35786438 13.6421356,2 9.5,2 C5.35786438,2 2,5.35786438 2,9.5 C2,13.6421356 5.35786438,17 9.5,17 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Search';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-caret-down', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'caret-down');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '22 8 12 20 2 8' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CaretDown';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_Trash__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_Trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_Trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonLogic__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DataDrive_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import find from 'array.prototype.find';
//import { Prompt } from 'react-router-dom';
//import {errorValidataion,toggleSizeButton} from '../actions/sessions';
//import Toast from 'grommet/components/Toast';
//import GetAllSupportedComponents from '../../Datafiles/GetAllSupportedComponents.json';
//import { fetchFilteredComps } from '../Redux/actions/epaActions';
//import Layer from 'grommet/components/Layer';
//import dataDriveOptions from '../../Datafiles/DataDrive.js';
var GatewayserverValue=void 0,GatewayprocessorValue=void 0,GatewayprocessorTypeValue=void 0,GatewaypocQtyValue=void 0,GatewaydatadisktypValue=void 0,GatewayosdisktypValue=void 0,GatewayDiskQtyvalue=void 0,GatewayOSDiskQtyvalue=void 0,GatewaymemoryValue=void 0;var EdgeserverValue=void 0,EdgeprocessorValue=void 0,EdgepocQtyValue=void 0,EdgedatadisktypValue=void 0,EdgeosdisktypValue=void 0,EdgenodeDiskQtyvalue=void 0,EdgememoryValue=void 0;var HeadserverValue=void 0,HeadprocessorValue=void 0,HeadprocessorTypeValue=void 0,HeadpocQtyValue=void 0,HeaddatadisktypValue=void 0,HeadosdisktypValue=void 0,HeadnodesQtyValue=void 0,HeadnodesOSDisksQtyValue=void 0,HeadmemoryValue=void 0,GatewayNodeQtyValue=void 0,EdgeNodeQtyValue=void 0;var GatewayServers=[];var GatewayDrives=[];var GatewayMemoryList=[];var GatewayOSDiskList=[];var GatewayProcList=[];var GatewayProcFamilyList=[];//let EdgeServers = []
//let EdgeDrives = []
//let EdgeOSDiskList = []
//let EdgeMemoryList = []
//let EdgeProcList = []
var HeadServers=[];var HeadDrives=[];var HeadMemoryList=[];var HeadOSDiskList=[];var HeadProcList=[];var HeadProcFamilyList=[];var GatewaySizerNodeQtyValue=void 0;var MasterNodeQtyValue=void 0,MasternodesQtyValue=void 0;//let GateNodeDatadiskqtynotchange = true
var GateNodeOSdiskqtynotchange=true;//let HeadDatadiskqtynotchange = true
var HeadOSdiskqtynotchange=true;var GateNodeMaxDriveQty="";var HeadNodeMaxDriveQty=" ";var maxlayer=false;var maxDrivevalue="";var functionnode="";var MasterdefaultNodevalue='';var GatewaydefaultNodevalue='';var NodeQtyvisible='';var GatewayNodeQtyvisible='';var MasterChecked=false;var GatewayChecked=false;var gatewayDataDriveType='';var masterNodeDataDriveType='';var editExisting=false;var isMixedStorageConfigurationgateWay="False";var isMixedStorageConfigurationmasterNode="False";var gatewayDataDriveConsolidatedOptions=[];var masterNodeDataDriveConsolidatedOptions=[];var serverChangeConfirmationlayer="";var HadoopServices=function(_Component){_inherits(HadoopServices,_Component);function HadoopServices(props){_classCallCheck(this,HadoopServices);var _this=_possibleConstructorReturn(this,(HadoopServices.__proto__||Object.getPrototypeOf(HadoopServices)).call(this,props));_this.populateDataDriveoptions=function(service){var drivesArray=[];var temp=[];var existingDriveTypes=[];var server=_this.state.activeIndex===0?HeadserverValue:GatewayserverValue;_this.props.defaultSizerWorkload.serversList.filter(function(x){return x['functionName']===service;})[0].totalList[server].DataDiskList.map(function(x){drivesArray.push(x);});var noOfExistingDataDisks=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.length;var isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service["@mixedStorage"];if(noOfExistingDataDisks>0&&isMixedStorageConfiguration==="True"){var existingDrives=[];_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.map(function(x){existingDrives.push(x.Item["@disk"]);});_this.props.defaultSizerWorkload.serversList.filter(function(x){return x['functionName']===service;})[0].totalList[server].DataDiskList.filter(function(x){if(existingDrives.indexOf(x.StrDrive)!==-1){x.Types.map(function(y){if(existingDriveTypes.indexOf(y)===-1){existingDriveTypes.push(y);}});}});if(existingDriveTypes.indexOf('LFF HDD')!==-1||existingDriveTypes.indexOf('LFF SSD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('SFF HDD')===-1&&x.Types.indexOf('SFF SSD')===-1){temp.push(x);}});}else if(existingDriveTypes.indexOf('SFF HDD')!==-1||existingDriveTypes.indexOf('SFF SSD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('LFF HDD')===-1&&x.Types.indexOf('LFF SSD')===-1){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}drivesArray=[];drivesArray=temp;temp=[];if(existingDriveTypes.indexOf('SFF SAS SSD')!==-1||existingDriveTypes.indexOf('SFF SAS HDD')!==-1||existingDriveTypes.indexOf('LFF SAS SSD')!==-1||existingDriveTypes.indexOf('LFF SAS HDD')!==-1||existingDriveTypes.indexOf('NVMe')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('LFF SATA HDD')===-1&&x.Types.indexOf('SFF SATA HDD')===-1){temp.push(x);}});}else if(existingDriveTypes.indexOf('SFF SATA HDD')!==-1||existingDriveTypes.indexOf('LFF SATA HDD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('SFF SAS SSD')===-1&&x.Types.indexOf('SFF SAS HDD')===-1&&x.Types.indexOf('LFF SAS SSD')===-1&&x.Types.indexOf('LFF SAS HDD')===-1&&x.Types.indexOf('NVMe')===-1){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}drivesArray=[];drivesArray=temp;temp=[];}if(service==="Gateway Node"){GatewayDrives=[];drivesArray.map(function(x){if(x.Types.indexOf(gatewayDataDriveType)!==-1){GatewayDrives.push(x.StrDrive);}});if(gatewayDataDriveConsolidatedOptions.length===0||_this.state.changeDriveTypeOptions){_this.state.changeDriveTypeOptions=false;gatewayDataDriveConsolidatedOptions=[];drivesArray.map(function(x){x.Types.map(function(y){if(gatewayDataDriveConsolidatedOptions.indexOf(y)===-1){gatewayDataDriveConsolidatedOptions.push(y);}});});}}else{HeadDrives=[];drivesArray.map(function(x){if(x.Types.indexOf(masterNodeDataDriveType)!==-1){HeadDrives.push(x.StrDrive);}});if(masterNodeDataDriveConsolidatedOptions.length===0||_this.state.changeDriveTypeOptions){_this.state.changeDriveTypeOptions=false;masterNodeDataDriveConsolidatedOptions=[];drivesArray.map(function(x){x.Types.map(function(y){if(masterNodeDataDriveConsolidatedOptions.indexOf(y)===-1){masterNodeDataDriveConsolidatedOptions.push(y);}});});}}};_this.onAddingDataDisk=function(){var service=_this.state.activeIndex===0?"Master Node":"Gateway Node";if(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DiskQty"]!="0"&&_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DataDisk"]!==undefined){var diskNumber="";var Hardware=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware;var isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service["@mixedStorage"];_this.maxDriveCountValidation(service);if(!maxlayer){if(isMixedStorageConfiguration!=="True"){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks=[];}if(service==="Gateway Node"){isMixedStorageConfigurationgateWay="True";}else{isMixedStorageConfigurationmasterNode="True";}_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service["@mixedStorage"]="True";var existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks;diskNumber=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.length;var pushDrive=true;if(diskNumber>0){existingDrivesArray.map(function(x){if(x.Item["@disk"]===_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DataDisk"]){x.Item["@qty"]=(parseInt(x.Item["@qty"],10)+parseInt(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DiskQty"],10)).toString();pushDrive=false;}});}if(pushDrive){var newDrive={Item:{"@disk":Hardware["@DataDisk"],"@qty":Hardware["@DiskQty"],"@volumeName":"Data_"+diskNumber}};_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.push(newDrive);}_this.state.changeDriveTypeOptions=true;_this.populateDataDriveoptions(service);}if(service==="Gateway Node"){GatewayDiskQtyvalue=_this.noOfDrivesleft(service,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DiskQty"]=GatewayDiskQtyvalue;}else{HeadnodesQtyValue=_this.noOfDrivesleft(service,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DiskQty"]=HeadnodesQtyValue;}_this.setState({});}};_this.deleteDrive=function(id,service){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.splice(id,1);if(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.length==0){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service["@mixedStorage"]="False";if(service==="Gateway Node"){isMixedStorageConfigurationgateWay="False";}else{isMixedStorageConfigurationmasterNode="False";}}_this.state.changeDriveTypeOptions=true;_this.populateDataDriveoptions(service);if(service==="Gateway Node"){GatewayDiskQtyvalue=_this.noOfDrivesleft(service,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DiskQty"]=GatewayDiskQtyvalue;}else{HeadnodesQtyValue=_this.noOfDrivesleft(service,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware["@DiskQty"]=HeadnodesQtyValue;}_this.setState({});};_this.renderTable=function(){var service=_this.state.activeIndex===0?"Master Node":"Gateway Node";var tableData=[];var tableDataArray="";tableDataArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks;tableDataArray.map(function(dataDrive,id){tableData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,dataDrive.Item["@disk"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput___default.a,{value:dataDrive.Item["@qty"],onDOMChange:function onDOMChange(e){return _this.onNoOfDisksChange(e,service,"","Change",true,id);},onBlur:function onBlur(e){return _this.onNoOfDisksChange(e,service,"","Blur",true,id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_Trash___default.a,{primary:true,onClick:function onClick(){return _this.deleteDrive(id,service);}}))));});return tableData;};_this.noOfDrivesleft=function(node,driveID){var maxDrives="";var maxDrivesLeft='';var server=_this.state.activeIndex===0?HeadserverValue:GatewayserverValue;var currentDrive=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DataDisk"];maxDrives=_this.props.defaultSizerWorkload.serversList.filter(function(service){return service.functionName===node;})[0].totalList[server].iDataDiskQty;var DataDisksArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.DataDisks;if(editExisting&&driveID!==""){currentDrive=DataDisksArray[driveID].Item["@disk"];}if(currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1){maxDrives=_this.props.defaultSizerWorkload.serversList.filter(function(service){return service.functionName===node;})[0].totalList[server].iMaxNVMeDrives;var noOfExistingNVMeDrives=0;if(DataDisksArray.length>0&&_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){DataDisksArray.map(function(x,id){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1){if(!(editExisting&&id===driveID)){noOfExistingNVMeDrives+=parseInt(x.Item["@qty"],10);}}});}maxDrivesLeft=maxDrives-noOfExistingNVMeDrives;}else{var noOfExistingDrives=0;if(DataDisksArray.length>0&&_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){DataDisksArray.map(function(x,id){if(!(editExisting&&id===driveID)){noOfExistingDrives+=parseInt(x.Item["@qty"],10);}});}maxDrivesLeft=maxDrives-noOfExistingDrives;}return maxDrivesLeft;};_this.ongatewayDataDriveTypeChange=function(e){gatewayDataDriveType=e.option;_this.populateDataDriveoptions("Gateway Node");if(GatewayDrives.indexOf(GatewaydatadisktypValue)===-1){GatewaydatadisktypValue=GatewayDrives[0];_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Gateway Node";})[0].Service.Hardware["@DataDisk"]=GatewaydatadisktypValue;}GatewayDiskQtyvalue=_this.noOfDrivesleft("Gateway Node","");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Gateway Node";})[0].Service.Hardware["@DiskQty"]=GatewayDiskQtyvalue;_this.setState({});};_this.onMasterNodeDataDriveTypeChange=function(e){masterNodeDataDriveType=e.option;_this.populateDataDriveoptions("Master Node");if(HeadDrives.indexOf(HeaddatadisktypValue)===-1){HeaddatadisktypValue=HeadDrives[0];_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Master Node";})[0].Service.Hardware["@DataDisk"]=HeaddatadisktypValue;}HeadnodesQtyValue=_this.noOfDrivesleft("Master Node","");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Master Node";})[0].Service.Hardware["@DiskQty"]=HeadnodesQtyValue;_this.setState({});};_this.onDataDiskChange=function(e,node){var OSInputs={};switch(node){case"Gateway Node":GatewaydatadisktypValue=e.value;//GatewayserverValue=e.value;
OSInputs={"strFunction":"Gateway Node","strService":"","strServer":GatewayserverValue,"strDataDisk":GatewaydatadisktypValue};_this.props.OnGetOSDiskList(OSInputs);break;case"Edge Node":EdgedatadisktypValue=e.value;break;case"Master Node":HeaddatadisktypValue=e.value;// HeadserverValue=e.value;
OSInputs={"strFunction":"Master Node","strService":"","strServer":HeadserverValue,"strDataDisk":HeaddatadisktypValue};_this.props.OnGetOSDiskList(OSInputs);break;}_this.onWorkloadUpdate();if(node==="Gateway Node"){GatewayDiskQtyvalue=_this.noOfDrivesleft(node,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DiskQty"]=GatewayDiskQtyvalue;}else{HeadnodesQtyValue=_this.noOfDrivesleft(node,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DiskQty"]=HeadnodesQtyValue;}};_this.onNoOfDisksChange=function(e,node,title,chorblr,editexisting,driveID){var maxDrivesLeft="";var globalValue="";editExisting=editexisting;maxDrivesLeft=_this.noOfDrivesleft(node,driveID);var number=/^[0-9]+$/;if(chorblr==="Change"){/* Changes by Vinay to check negative value */if(isNaN(e.target.value)||e.target.value<0){}else if(parseInt(e.target.value,10)>maxDrivesLeft){e.target.value=maxDrivesLeft.toString();globalValue=e.target.value;}else{globalValue=e.target.value;}}else{if(e.target.value.length<3){var value=parseInt(e.target.value,10);if(isNaN(value)||value==0){globalValue="0";if(editExisting){globalValue="1";}}else if(number.test(value)&&value<maxDrivesLeft&&value>=1||isNaN(value)){globalValue=value.toString();}else{globalValue=maxDrivesLeft.toString();}}if(value>maxDrivesLeft){_this.maxDriveCountValidation(node);}}if(editExisting){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.DataDisks[driveID].Item["@qty"]=globalValue;}else{if(node==="Gateway Node"){GatewayDiskQtyvalue=globalValue;}else{HeadnodesQtyValue=globalValue;}}if(chorblr===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){if(editExisting){if(node===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_31" /* GATEWAY_NODE */]){GatewayDiskQtyvalue=_this.noOfDrivesleft(node,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DiskQty"]=GatewayDiskQtyvalue;}else{HeadnodesQtyValue=_this.noOfDrivesleft(node,"");_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DiskQty"]=HeadnodesQtyValue;}}}_this.onWorkloadUpdate();editExisting=false;};_this.state={NodeQtyvisible:true,activeIndex:0,changeDriveTypeOptions:false};_this.maxDriveCountValidation=_this.maxDriveCountValidation.bind(_this);_this.layerclose=_this.layerclose.bind(_this);return _this;}_createClass(HadoopServices,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.workload!==undefined){if(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Gateway Node";})[0].Service!==undefined){if(!Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Gateway Node";})[0].Service.DataDisks)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Gateway Node";})[0].Service["@mixedStorage"]="False";}}if(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Master Node";})[0].Service!==undefined){if(!Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Master Node";})[0].Service.DataDisks)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]==="Master Node";})[0].Service["@mixedStorage"]="False";}}}}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.defaultSizerWorkload!==undefined&&this.props.defaultSizerWorkload!==null){var Input={"Workload":null};Input.Workload=this.props.workload;var Inputs={DefaultData:[{"function":"Gateway Node","service":"","workload":Input},{"function":"Master Node","service":"","workload":Input},{"PricingRegion":this.props.workload.UserInputs.Country}]};var pushservice=true;// this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
//   if (ServiceName.functionName === 'Gateway Node' || ServiceName.functionName === 'Master Node') {
//     pushservice = false;
//   }
// });
if(pushservice){this.props.OnDefaultFetchServerList(Inputs);}}if(!this.props.activeSession.isSizeEnabled)this.props.OnToggleSizeButton(true);var index=this.props.defaultSizerWorkload.Indexes.extraConfiguration;this.setState({activeIndex:index});}},{key:'layerclose',value:function layerclose(e,node){var _this2=this;maxlayer=false;this.props.defaultSizerWorkload.serversList.map(function(ServiceName){switch(node){case"Gateway Node":if(ServiceName.functionName==="Gateway Node"){var _loop=function _loop(key){if(key===GatewayserverValue){_this2.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Gateway Node"){// GatewayDiskQtyvalue = ServiceName.totalList[key].iDataDiskQty.toString();
// val.Service.Hardware['@DiskQty'] = GatewayDiskQtyvalue
GatewayOSDiskQtyvalue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=GatewayOSDiskQtyvalue;}});// GateNodeMaxDriveQty=ServiceName.totalList[key].iMaxDrives
}};for(var key in ServiceName.totalList){_loop(key);}}break;case"Master Node":if(ServiceName.functionName==="Master Node"){var _loop2=function _loop2(key){if(key===HeadserverValue){_this2.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Master Node"){// HeadnodesQtyValue = ServiceName.totalList[key].iDataDiskQty.toString();
// val.Service.Hardware['@DiskQty'] = HeadnodesQtyValue
HeadnodesOSDisksQtyValue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=HeadnodesOSDisksQtyValue;}});}};for(var key in ServiceName.totalList){_loop2(key);}}break;}});this.setState({});}},{key:'maxDriveCountValidation',value:function maxDriveCountValidation(e){var _this3=this;var noOfExistingNVMeDrives=0;var noOfExistingDrives=0;var qtyOfExistingDataDisks=0;var noOfExistingNonNVMeDrives=0;var FunctionName=e;var MaxDriveQty=0;var OSDiskQtyvalue=0;var DataDiskQtyvalue=0;var serverValue=void 0;this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.functionName===FunctionName){for(var key in ServiceName.totalList){serverValue=_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@Server"];if(key===serverValue){OSDiskQtyvalue=_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@OSDiskQty"];DataDiskQtyvalue=_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@DiskQty"];MaxDriveQty=ServiceName.totalList[key].iMaxDrives;var dataDisksArray=[];dataDisksArray=_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.DataDisks;if(_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@DataDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1){MaxDriveQty=ServiceName.totalList[key].iMaxNVMeDrives;if(dataDisksArray.length>0&&_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){dataDisksArray.map(function(x){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1){noOfExistingNVMeDrives+=parseInt(x.Item["@qty"],10);}else{noOfExistingNonNVMeDrives+=parseInt(x.Item["@qty"],10);}});}if(_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1){noOfExistingNVMeDrives+=parseInt(_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@OSDiskQty"],10);}else{noOfExistingNonNVMeDrives+=parseInt(_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service.Hardware["@OSDiskQty"],10);}if(editExisting){qtyOfExistingDataDisks=noOfExistingNVMeDrives;}else{qtyOfExistingDataDisks=noOfExistingNVMeDrives+parseInt(DataDiskQtyvalue,10);}if(qtyOfExistingDataDisks<=MaxDriveQty){MaxDriveQty=ServiceName.totalList[key].iMaxDrives;if(editExisting){qtyOfExistingDataDisks=noOfExistingNVMeDrives+noOfExistingNonNVMeDrives;}else{qtyOfExistingDataDisks=noOfExistingNVMeDrives+noOfExistingNonNVMeDrives+parseInt(DataDiskQtyvalue,10);}}}else{if(dataDisksArray.length>0&&_this3.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===FunctionName;})[0].Service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){dataDisksArray.map(function(x){noOfExistingDrives+=parseInt(x.Item["@qty"],10);});}if(editExisting){qtyOfExistingDataDisks=noOfExistingDrives+parseInt(OSDiskQtyvalue,10);}else{qtyOfExistingDataDisks=noOfExistingDrives+parseInt(DataDiskQtyvalue,10)+parseInt(OSDiskQtyvalue,10);}}if(MaxDriveQty<qtyOfExistingDataDisks){maxDrivevalue=MaxDriveQty;maxlayer=true;functionnode=FunctionName;}else{maxlayer=false;}}}}});}},{key:'onMasterNodevalueChange',value:function onMasterNodevalueChange(e){//MasternodesQtyValue=e.target.value;
//nodesQtyValue=e.target.value;
var number=/^[0-9]+$/;if(e.target.value.length<6){var value=parseInt(e.target.value,10);if(isNaN(value)){MasternodesQtyValue="";}else if(number.test(value)&&value<=99999&&value>=1||isNaN(value)){MasternodesQtyValue=value.toString();}else{}}this.onWorkloadUpdate();}},{key:'onGatewayNodevalueChange',value:function onGatewayNodevalueChange(e){var number=/^[0-9]+$/;if(e.target.value.length<6){var value=parseInt(e.target.value,10);if(isNaN(value)){GatewayNodeQtyValue="";}else if(number.test(value)&&value<=99999&&value>=1||isNaN(value)){GatewayNodeQtyValue=value.toString();}else{}}this.onWorkloadUpdate();}},{key:'onMasterNodevalueBlur',value:function onMasterNodevalueBlur(e){if(e.target.value===" "||e.target.value<MasterdefaultNodevalue){MasternodesQtyValue=MasterdefaultNodevalue;}Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["l" /* updateGrowthItem */])('Master Node',MasternodesQtyValue,this.props.defaultSizerWorkload.workload);this.onWorkloadUpdate();}},{key:'onGatewayNodevalueBlur',value:function onGatewayNodevalueBlur(e){if(e.target.value===" "||parseInt(e.target.value,10)<parseInt(GatewaydefaultNodevalue,10)){GatewayNodeQtyValue=GatewaydefaultNodevalue;}Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["l" /* updateGrowthItem */])('Gateway Node',GatewayNodeQtyValue,this.props.defaultSizerWorkload.workload);this.onWorkloadUpdate();}},{key:'onMasterNodeQtyValueChange',value:function onMasterNodeQtyValueChange(e){MasterNodeQtyValue=e.value;var visible=false;if(e.value==="Sizer Recommendation"){visible=true;Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["l" /* updateGrowthItem */])('Master Node',MasterdefaultNodevalue,this.props.defaultSizerWorkload.workload);}NodeQtyvisible=visible;this.onWorkloadUpdate();}},{key:'onGatewayNodeQtyValueChange',value:function onGatewayNodeQtyValueChange(e){GatewaySizerNodeQtyValue=e.value;var visible=false;if(e.value==="Sizer Recommendation"){visible=true;GatewayNodeQtyValue=GatewaydefaultNodevalue;Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["l" /* updateGrowthItem */])('Gateway Node',GatewayNodeQtyValue,this.props.defaultSizerWorkload.workload);}else{GatewayNodeQtyValue="1";}GatewayNodeQtyvisible=visible;this.onWorkloadUpdate();}},{key:'onServerChange',value:function onServerChange(e,node){var _this4=this;var validateServerChangeResponse=[true,''];var MixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service["@mixedStorage"];if(MixedStorageConfiguration==="True"){validateServerChangeResponse=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["g" /* serverChangeCompatibilityCheck */])(this.props.workload,e.value,this.props.defaultSizerWorkload.serversList,node,"");}if(!validateServerChangeResponse[0]){var closeLayer=function closeLayer(){serverChangeConfirmationlayer="";_this4.setState({});};serverChangeConfirmationlayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Warning')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){return closeLayer();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,validateServerChangeResponse[1])));this.setState({});}else{this.state.changeDriveTypeOptions=true;if(MixedStorageConfiguration!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){if(node==="Master Node"){isMixedStorageConfigurationmasterNode="False";masterNodeDataDriveType="";masterNodeDataDriveConsolidatedOptions=[];}else{gatewayDataDriveType='';isMixedStorageConfigurationgateWay="False";gatewayDataDriveConsolidatedOptions=[];}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service["@mixedStorage"]="False";this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.DataDisks=[];this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@dataDriveType"]="";}var processorQuantity="2";if(e.value===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */]){processorQuantity="1";}var OSInputs={};switch(node){case"Gateway Node":GatewayserverValue=e.value;GatewaypocQtyValue=processorQuantity;OSInputs={"strFunction":"Gateway Node","strService":"","strServer":GatewayserverValue,"strDataDisk":GatewaydatadisktypValue};this.props.OnGetOSDiskList(OSInputs);break;case"Edge Node":EdgeserverValue=e.value;break;case"Master Node":HeadserverValue=e.value;HeadpocQtyValue=processorQuantity;OSInputs={"strFunction":"Master Node","strService":"","strServer":HeadserverValue,"strDataDisk":HeaddatadisktypValue};this.props.OnGetOSDiskList(OSInputs);break;}if(this.props.defaultSizerWorkload.serversList!==""&&this.props.defaultSizerWorkload.serversList!==undefined&&this.props.defaultSizerWorkload.serversList!==null){this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.functionName===node){switch(ServiceName.functionName){case"Gateway Node":for(var key in ServiceName.totalList){if(key===GatewayserverValue){GatewayProcList=[];GatewayProcFamilyList=[];GatewayDrives=ServiceName.totalList[key].DataDiskList;if(MixedStorageConfiguration!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){GatewayDiskQtyvalue=ServiceName.totalList[key].iDataDiskQty;}else{GatewayDiskQtyvalue=_this4.noOfDrivesleft(node,"");}GatewayOSDiskList=ServiceName.totalList[key].OSDiskList;for(var proctype in ServiceName.totalList[key].ProcessorList){if(GatewayProcFamilyList.indexOf(proctype)===-1){GatewayProcFamilyList.push(proctype);}}if(GatewayProcFamilyList.indexOf(GatewayprocessorTypeValue)===-1){GatewayprocessorTypeValue=GatewayProcFamilyList[0];}for(var _proctype in ServiceName.totalList[key].ProcessorList){if(_proctype===GatewayprocessorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[_proctype]){if(GatewayProcList.indexOf(proc)===-1){GatewayProcList.push(proc);}}if(GatewayProcList.indexOf(GatewayprocessorValue)===-1){GatewayprocessorValue=GatewayProcList[0];}//if (proc === GatewayprocessorValue) {
//  GatewayMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
GatewayMemoryList=ServiceName.totalList[key].ProcessorList[_proctype][GatewayprocessorValue];if(GatewayserverValue==="Synergy 480 Gen10 Server"&&GatewayprocessorValue.indexOf("M")!==4&&GatewayprocessorValue.indexOf("L")!==4&&GatewayMemoryList.indexOf("3072 GB")!==-1){GatewayMemoryList.pop();}// }
//  }
}}}}if(GatewayProcFamilyList.indexOf(GatewayprocessorTypeValue)===-1){GatewayprocessorTypeValue=GatewayProcFamilyList[0];}if(GatewayProcList.indexOf(GatewayprocessorValue)===-1){GatewayprocessorValue=GatewayProcList[0];}if(GatewayDrives.indexOf(GatewaydatadisktypValue)===-1){GatewaydatadisktypValue=GatewayDrives[0];}if(GatewayOSDiskList.length>0&&GatewayOSDiskList.indexOf(GatewayosdisktypValue)===-1){GatewayosdisktypValue=GatewayOSDiskList[0];}// GatewaydatadisktypValue = GatewayDrives[0];
// GatewayosdisktypValue = GatewayOSDiskList[0];
// GatewaymemoryValue = GatewayMemoryList[0];
break;// case "Edge Node":
//   for (let key in ServiceName.totalList) {
//     if (key === EdgeserverValue) {
//       EdgeDrives = ServiceName.totalList[key].DataDiskList
//       EdgeMemoryList = ServiceName.totalList[key].MemoryList
//       EdgeOSDiskList = ServiceName.totalList[key].OSDiskList
//       EdgeProcList = ServiceName.totalList[key].ProcList
//     }
//     EdgeprocessorValue = EdgeProcList[0];
//     EdgedatadisktypValue = EdgeDrives[0];
//     EdgeosdisktypValue = EdgeOSDiskList[0];
//     EdgememoryValue = EdgeMemoryList[0];
//   }
//   break;
case"Master Node":for(var _key in ServiceName.totalList){if(_key===HeadserverValue){HeadProcList=[];HeadProcFamilyList=[];HeadDrives=ServiceName.totalList[_key].DataDiskList;if(MixedStorageConfiguration!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){HeadnodesQtyValue=ServiceName.totalList[_key].iDataDiskQty;}else{HeadnodesQtyValue=_this4.noOfDrivesleft(node,"");}HeadOSDiskList=ServiceName.totalList[_key].OSDiskList;for(var _proctype2 in ServiceName.totalList[_key].ProcessorList){if(HeadProcFamilyList.indexOf(_proctype2)===-1){HeadProcFamilyList.push(_proctype2);}}if(HeadProcFamilyList.indexOf(HeadprocessorTypeValue)===-1){HeadprocessorTypeValue=HeadProcFamilyList[0];}for(var _proctype3 in ServiceName.totalList[_key].ProcessorList){if(_proctype3===HeadprocessorTypeValue){var _proc=void 0;for(_proc in ServiceName.totalList[_key].ProcessorList[_proctype3]){if(HeadProcList.indexOf(_proc)===-1){HeadProcList.push(_proc);}}if(HeadProcList.indexOf(HeadprocessorValue)===-1){HeadprocessorValue=HeadProcList[0];}// if (proc === HeadprocessorValue) {
HeadMemoryList=ServiceName.totalList[_key].ProcessorList[_proctype3][_proc];HeadMemoryList=ServiceName.totalList[_key].ProcessorList[_proctype3][HeadprocessorValue];if(HeadserverValue==="Synergy 480 Gen10 Server"&&HeadprocessorValue.indexOf("M")!==4&&HeadprocessorValue.indexOf("L")!==4&&HeadMemoryList.indexOf("3072 GB")!==-1){HeadMemoryList.pop();}//}
// }
}}}//  HeadprocessorValue = HeadProcList[0]
if(HeadDrives.indexOf(HeaddatadisktypValue)===-1){HeaddatadisktypValue=HeadDrives[0];}if(HeadOSDiskList.length>0&&HeadOSDiskList.indexOf(HeadosdisktypValue)===-1){HeadosdisktypValue=HeadOSDiskList[0];}if(HeadMemoryList.length>0&&HeadMemoryList.indexOf(HeadmemoryValue)===-1){HeadmemoryValue=HeadMemoryList[0];}// HeaddatadisktypValue = HeadDrives[0]
// HeadosdisktypValue = HeadOSDiskList[0]
// HeadmemoryValue = HeadMemoryList[0]
}break;}}});}this.onWorkloadUpdate();}}},{key:'onOSDiskChange',value:function onOSDiskChange(e,node){switch(node){case"Gateway Node":GatewayosdisktypValue=e.value;break;case"Edge Node":EdgeosdisktypValue=e.value;break;case"Master Node":HeadosdisktypValue=e.value;break;}this.onWorkloadUpdate();if(node==="Gateway Node"){GatewayDiskQtyvalue=this.noOfDrivesleft(node,"");this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DiskQty"]=GatewayDiskQtyvalue;}else{HeadnodesQtyValue=this.noOfDrivesleft(node,"");this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===node;})[0].Service.Hardware["@DiskQty"]=HeadnodesQtyValue;}}},{key:'onProcessorChange',value:function onProcessorChange(e,node){switch(node){case"Gateway Node":GatewayprocessorValue=e.value;break;case"Edge Node":EdgeprocessorValue=e.value;break;case"Master Node":HeadprocessorValue=e.value;break;}this.onWorkloadUpdate();}},{key:'onProcessorFamilytypeChange',value:function onProcessorFamilytypeChange(e,node){switch(node){case"Gateway Node":GatewayprocessorTypeValue=e.value;GatewayProcList=[];this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.functionName===node){for(var key in ServiceName.totalList){if(key===HeadserverValue){GatewayProcList=[];for(var proctype in ServiceName.totalList[key].ProcessorList){if(proctype===GatewayprocessorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){if(GatewayProcList.indexOf(proc)===-1){GatewayProcList.push(proc);}GatewayprocessorValue=GatewayProcList[0];if(proc===GatewayprocessorValue){GatewayMemoryList=ServiceName.totalList[key].ProcessorList[proctype][proc];if(GatewayserverValue==="Synergy 480 Gen10 Server"&&GatewayprocessorValue.indexOf("M")!==4&&GatewayprocessorValue.indexOf("L")!==4&&GatewayMemoryList.indexOf("3072 GB")!==-1){GatewayMemoryList.pop();}}}}}}}}});break;case"Edge Node":EdgeprocessorValue=e.value;break;case"Master Node":HeadprocessorTypeValue=e.value;HeadProcList=[];this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.functionName===node){for(var key in ServiceName.totalList){if(key===HeadserverValue){HeadProcList=[];for(var proctype in ServiceName.totalList[key].ProcessorList){if(proctype===HeadprocessorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){if(HeadProcList.indexOf(proc)===-1){HeadProcList.push(proc);}HeadprocessorValue=HeadProcList[0];if(proc===HeadprocessorValue){HeadMemoryList=ServiceName.totalList[key].ProcessorList[proctype][proc];if(HeadserverValue==="Synergy 480 Gen10 Server"&&HeadprocessorValue.indexOf("M")!==4&&HeadprocessorValue.indexOf("L")!==4&&HeadMemoryList.indexOf("3072 GB")!==-1){HeadMemoryList.pop();}}}}}}}}});break;}// if (HeadMemoryList.indexOf(HeadmemoryValue) === -1) {
//   HeadmemoryValue = HeadMemoryList[0];
// }
this.onWorkloadUpdate();}},{key:'onMemoryChange',value:function onMemoryChange(e,node){switch(node){case"Gateway Node":GatewaymemoryValue=e.value;break;case"Edge Node":EdgememoryValue=e.value;break;case"Master Node":HeadmemoryValue=e.value;break;}this.onWorkloadUpdate();}// onNodeQtyChange(e, node) {
//   switch (node) {
//     case "Gateway Node":
//       GatewayNodeQtyValue = e.value;
//       break;
//     case "Edge Node":
//       EdgeNodeQtyValue = e.value;
//       break;
//   }
//   this.onWorkloadUpdate();
// }
},{key:'onNoOfOSDisksChange',value:function onNoOfOSDisksChange(e,node,chorblr){switch(node){case"Gateway Node":if(chorblr==="Change"){if(parseInt(e.target.value,10)>2){e.target.value="2";}}else{if(e.target.value==="")e.target.value="1";}GatewayOSDiskQtyvalue=e.target.value;GateNodeOSdiskqtynotchange=false;this.maxDriveCountValidation(node);break;case"Edge Node":EdgenodeDiskQtyvalue=e.target.value;break;case"Master Node":if(chorblr==="Change"){if(parseInt(e.target.value,10)>2){e.target.value="2";}}else{if(e.target.value==="")e.target.value="1";}HeadnodesOSDisksQtyValue=e.target.value;HeadOSdiskqtynotchange=false;this.maxDriveCountValidation(node);break;}this.onWorkloadUpdate();}},{key:'MasterCheckboxChange',value:function MasterCheckboxChange(e){var flag=void 0;if(MasterChecked){MasterChecked=false;flag='false';Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["f" /* removeObject */])('Master Node',false,this.props.workload);}else{MasterChecked=true;flag='true';}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Master Node":val.Service['@Selected']=MasterChecked.toString();}});this.setState({});}},{key:'GatewayCheckboxChange',value:function GatewayCheckboxChange(e){var flag=void 0;if(GatewayChecked){GatewayChecked=false;flag='false';Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["f" /* removeObject */])('Gateway Node',false,this.props.workload);}else{GatewayChecked=true;flag='true';}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Gateway Node":val.Service['@Selected']=GatewayChecked.toString();}});this.setState({});}},{key:'onWorkloadUpdate',value:function onWorkloadUpdate(e){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Gateway Node":val.Service.Hardware['@Server']=GatewayserverValue;val.Service.Hardware['@Proc']=GatewayprocessorValue;val.Service.Hardware['@ProcFamily']=GatewayprocessorTypeValue;val.Service.Hardware['@ProcQty']=GatewaypocQtyValue;val.Service.Hardware['@DataDisk']=GatewaydatadisktypValue;val.Service.Hardware['@OSDisk']=GatewayosdisktypValue;val.Service.Hardware['@DiskQty']=GatewayDiskQtyvalue;val.Service.Hardware['@OSDiskQty']=GatewayOSDiskQtyvalue;if(GatewayserverValue==="Synergy 480 Gen10 Server"&&GatewayprocessorValue.indexOf("M")!==4&&GatewayprocessorValue.indexOf("L")!==4&&GatewayMemoryList.indexOf("3072 GB")!==-1){GatewayMemoryList.pop();}if(GatewayMemoryList.length>0&&GatewayMemoryList.indexOf(GatewaymemoryValue)===-1){GatewaymemoryValue=GatewayMemoryList[0];}val.Service.Hardware['@Memory']=GatewaymemoryValue;val.Service.Hardware['@NodesCount']=GatewayNodeQtyValue;val.Service.Hardware['@NodesQty']=GatewaySizerNodeQtyValue;break;case"Edge Node":val.Service.Hardware['@Server']=EdgeserverValue;val.Service.Hardware['@Proc']=EdgeprocessorValue;val.Service.Hardware['@ProcQty']=EdgepocQtyValue;val.Service.Hardware['@DataDisk']=EdgedatadisktypValue;val.Service.Hardware['@OSDisk']=EdgeosdisktypValue;val.Service.Hardware['@DiskQty']=EdgenodeDiskQtyvalue;val.Service.Hardware['@Memory']=EdgememoryValue;val.Service.Hardware['@NodesQty']=EdgeNodeQtyValue;break;case"Master Node":val.Service.Hardware['@Server']=HeadserverValue;val.Service.Hardware['@Proc']=HeadprocessorValue;val.Service.Hardware['@ProcFamily']=HeadprocessorTypeValue;val.Service.Hardware['@ProcQty']=HeadpocQtyValue;val.Service.Hardware['@DataDisk']=HeaddatadisktypValue;val.Service.Hardware['@OSDisk']=HeadosdisktypValue;val.Service.Hardware['@DiskQty']=HeadnodesQtyValue;val.Service.Hardware['@OSDiskQty']=HeadnodesOSDisksQtyValue;if(HeadserverValue==="Synergy 480 Gen10 Server"&&HeadprocessorValue.indexOf("M")!==4&&HeadprocessorValue.indexOf("L")!==4&&HeadMemoryList.indexOf("3072 GB")!==-1){HeadMemoryList.pop();}if(HeadMemoryList.length>0&&HeadMemoryList.indexOf(HeadmemoryValue)===-1){HeadmemoryValue=HeadMemoryList[0];}val.Service.Hardware['@Memory']=HeadmemoryValue;val.Service.Hardware['@NodesQty']=MasterNodeQtyValue;val.Service.Hardware['@NodesCount']=MasternodesQtyValue;break;}});this.setState({});}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this5=this;var ServicesArray=["Master Node","Gateway Node"];this.props.defaultSizerWorkload.serversList.map(function(ServiceName,id){if(ServiceName.functionName==="Gateway Node"){_this5.props.defaultSizerWorkload.serversList.splice(id,1);//  id=id-1
}});this.props.defaultSizerWorkload.serversList.map(function(ServiceName,id){if(ServiceName.functionName==="Master Node"){_this5.props.defaultSizerWorkload.serversList.splice(id,1);// id=id-1
}});var Hardware="";var diskNumber="";ServicesArray.forEach(function(service){Hardware=_this5.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.Hardware;diskNumber=_this5.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.length;var isMixedStorageConfiguration=_this5.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service["@mixedStorage"];if(isMixedStorageConfiguration==="False"){var newDrive={Item:{"@disk":Hardware["@DataDisk"],"@qty":Hardware["@DiskQty"],"@volumeName":"Data_0"}};_this5.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks=[];_this5.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===service;})[0].Service.DataDisks.push(newDrive);}});// this.props.defaultSizerWorkload.serversList.map((ServiceName, id) => {
//   if (ServiceName.functionName === "Master Node") {
//     this.props.defaultSizerWorkload.serversList.splice(id, 1);
//     // id=id-1
//   }
// })
console.log(this.props.defaultSizerWorkload.serversList);}},{key:'render',value:function render(){var _this6=this;var GatewaySizerRecmdtnServer=void 0,GatewaySizerRecmdtnProcsr=void 0,GatewaySizerRecmdtnMemory=void 0,GatewaySizerRecmdtnDisktype=void 0;//let EdgeSizerRecmdtnServer, EdgeSizerRecmdtnProcsr, EdgeSizerRecmdtnMemory, EdgeSizerRecmdtnDisktype, EdgedefaultNodevalue;
var MasterSizerRecmdtnServer=void 0,MasterSizerRecmdtnProcsr=void 0,MasterSizerRecmdtnMemory=void 0,MasterSizerRecmdtnDisktype=void 0;var layer="";var MasterNodeNodeOtyOPtions=[];var GatewayNodeNodeOtyOPtions=[];GatewayServers=[];HeadServers=[];GatewayProcFamilyList=[];HeadProcList=[];this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Gateway Node":GatewayChecked=/true/i.test(val.Service['@Selected']);GatewayserverValue=val.Service.Hardware['@Server'];GatewayprocessorValue=val.Service.Hardware['@Proc'];GatewayprocessorTypeValue=val.Service.Hardware['@ProcFamily'];GatewaypocQtyValue=val.Service.Hardware['@ProcQty'];GatewaydatadisktypValue=val.Service.Hardware['@DataDisk'];GatewayosdisktypValue=val.Service.Hardware['@OSDisk'];GatewayDiskQtyvalue=val.Service.Hardware['@DiskQty'];GatewayOSDiskQtyvalue=val.Service.Hardware['@OSDiskQty'];GatewaymemoryValue=val.Service.Hardware['@Memory'];isMixedStorageConfigurationgateWay=val.Service["@mixedStorage"];if(GatewaySizerNodeQtyValue==="User Defined"&&GatewayNodeQtyValue==="1 Per Rack"){val.Service.Hardware['@NodesCount']="1";}else if(GatewaySizerNodeQtyValue==="Sizer Recommendation"){val.Service.Hardware['@NodesCount']=val.Service.Recommendation['@NodesCount'];}GatewayNodeQtyValue=val.Service.Hardware['@NodesCount'];GatewaySizerNodeQtyValue=val.Service.Hardware['@NodesQty'];GatewayNodeNodeOtyOPtions=["User Defined","Sizer Recommendation"];GatewaySizerRecmdtnServer=val.Service.Recommendation['@Name'];GatewaySizerRecmdtnProcsr=val.Service.Recommendation['@Proc'];GatewaySizerRecmdtnDisktype=val.Service.Recommendation['@DataDisk'];GatewaydefaultNodevalue=val.Service.Recommendation['@NodesCount'];GatewaySizerRecmdtnMemory=val.Service.Recommendation['@Memory'];break;case"Edge Node":EdgeserverValue=val.Service.Hardware['@Server'];EdgeprocessorValue=val.Service.Hardware['@Proc'];EdgepocQtyValue=val.Service.Hardware['@ProcQty'];EdgedatadisktypValue=val.Service.Hardware['@DataDisk'];EdgeosdisktypValue=val.Service.Hardware['@OSDisk'];EdgenodeDiskQtyvalue=val.Service.Hardware['@DiskQty'];EdgememoryValue=val.Service.Hardware['@Memory'];EdgeNodeQtyValue=val.Service.Hardware['@NodesQty'];//EdgeSizerRecmdtnServer = val.Service.Recommendation['@Name'];
//EdgeSizerRecmdtnProcsr = val.Service.Recommendation['@Proc'];
//EdgeSizerRecmdtnDisktype = val.Service.Recommendation['@DataDisk'];
//EdgedefaultNodevalue = val.Service.Recommendation['@NodesCount'];
//EdgeSizerRecmdtnMemory = val.Service.Recommendation['@Memory'];
break;case"Master Node":MasterChecked=/true/i.test(val.Service['@Selected']);HeadserverValue=val.Service.Hardware['@Server'];HeadprocessorValue=val.Service.Hardware['@Proc'];HeadprocessorTypeValue=val.Service.Hardware['@ProcFamily'];HeadpocQtyValue=val.Service.Hardware['@ProcQty'];HeaddatadisktypValue=val.Service.Hardware['@DataDisk'];HeadosdisktypValue=val.Service.Hardware['@OSDisk'];HeadnodesQtyValue=val.Service.Hardware['@DiskQty'];HeadnodesOSDisksQtyValue=val.Service.Hardware['@OSDiskQty'];HeadmemoryValue=val.Service.Hardware['@Memory'];MasterNodeQtyValue=val.Service.Hardware['@NodesQty'];isMixedStorageConfigurationmasterNode=val.Service["@mixedStorage"];MasterNodeNodeOtyOPtions=["User Defined","Sizer Recommendation"];//  if(parseInt(val.Service.Hardware['@NodesCount'], 10) < parseInt(val.Service.Recommendation['@NodesCount'], 10))
//   val.Service.Hardware['@NodesCount']=val.Service.Recommendation['@NodesCount'];
if(MasterNodeQtyValue==="Sizer Recommendation"){val.Service.Hardware['@NodesCount']=val.Service.Recommendation['@NodesCount'];}MasternodesQtyValue=val.Service.Hardware['@NodesCount'];MasterSizerRecmdtnServer=val.Service.Recommendation['@Name'];MasterSizerRecmdtnProcsr=val.Service.Recommendation['@Proc'];MasterSizerRecmdtnDisktype=val.Service.Recommendation['@DataDisk'];MasterdefaultNodevalue=val.Service.Recommendation['@NodesCount'];MasterSizerRecmdtnMemory=val.Service.Recommendation['@Memory'];break;}});if(this.props.defaultSizerWorkload.serversList!==""&&this.props.defaultSizerWorkload.serversList!==undefined&&this.props.defaultSizerWorkload.serversList!==null){this.props.defaultSizerWorkload.serversList.map(function(ServiceName){switch(ServiceName.functionName){case"Gateway Node":for(var key in ServiceName.totalList){if(key===GatewayserverValue){GatewayDrives=ServiceName.totalList[key].DataDiskList;if(gatewayDataDriveConsolidatedOptions.length===0){ServiceName.totalList[key].DataDiskList.map(function(x){x.Types.map(function(y){if(gatewayDataDriveConsolidatedOptions.indexOf(y)===-1){gatewayDataDriveConsolidatedOptions.push(y);}});});if(gatewayDataDriveType===""){gatewayDataDriveType=gatewayDataDriveConsolidatedOptions[0];}}_this6.populateDataDriveoptions("Gateway Node");GatewayOSDiskList=ServiceName.totalList[key].OSDiskList;for(var proctype in ServiceName.totalList[key].ProcessorList){if(GatewayProcFamilyList.indexOf(proctype)===-1){GatewayProcFamilyList.push(proctype);}if(proctype===GatewayprocessorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){if(GatewayProcList.indexOf(proc)===-1){GatewayProcList.push(proc);}if(proc===GatewayprocessorValue){GatewayMemoryList=ServiceName.totalList[key].ProcessorList[proctype][proc];if(GatewayserverValue==="Synergy 480 Gen10 Server"&&GatewayprocessorValue.indexOf("M")!==4&&GatewayprocessorValue.indexOf("L")!==4&&GatewayMemoryList.indexOf("3072 GB")!==-1){GatewayMemoryList.pop();}}}}}}if(GatewayServers.indexOf(key)===-1){GatewayServers.push(key);}if(GatewayOSDiskList.indexOf(GatewayosdisktypValue)===-1){GatewayosdisktypValue=GatewayOSDiskList[0];}}break;case"Master Node":for(var _key2 in ServiceName.totalList){if(_key2===HeadserverValue){HeadDrives=ServiceName.totalList[_key2].DataDiskList;if(masterNodeDataDriveConsolidatedOptions.length==0){ServiceName.totalList[_key2].DataDiskList.map(function(x){x.Types.map(function(y){if(masterNodeDataDriveConsolidatedOptions.indexOf(y)===-1){masterNodeDataDriveConsolidatedOptions.push(y);}});});if(masterNodeDataDriveType===""){masterNodeDataDriveType=masterNodeDataDriveConsolidatedOptions[0];}}_this6.populateDataDriveoptions("Master Node");// HeadMemoryList = ServiceName.totalList[key].MemoryList
HeadOSDiskList=ServiceName.totalList[_key2].OSDiskList;//   HeadProcList = ServiceName.totalList[key].ProcList
for(var _proctype4 in ServiceName.totalList[_key2].ProcessorList){if(HeadProcFamilyList.indexOf(_proctype4)===-1){HeadProcFamilyList.push(_proctype4);}if(_proctype4===HeadprocessorTypeValue){for(var _proc2 in ServiceName.totalList[_key2].ProcessorList[_proctype4]){if(HeadProcList.indexOf(_proc2)===-1){HeadProcList.push(_proc2);}if(_proc2===HeadprocessorValue){HeadMemoryList=ServiceName.totalList[_key2].ProcessorList[_proctype4][_proc2];if(HeadserverValue==="Synergy 480 Gen10 Server"&&HeadprocessorValue.indexOf("M")!==4&&HeadprocessorValue.indexOf("L")!==4&&HeadMemoryList.indexOf("3072 GB")!==-1){HeadMemoryList.pop();}}}}}}if(HeadServers.indexOf(_key2)===-1){HeadServers.push(_key2);}if(HeadOSDiskList.indexOf(HeadosdisktypValue)===-1){HeadosdisktypValue=HeadOSDiskList[0];}}break;}});}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Gateway Node":_this6.props.defaultSizerWorkload.serversList.filter(function(ServiceName){if(ServiceName.functionName==="Gateway Node"){var ServerPresent=false;for(var key in ServiceName.totalList){if(key===GatewayserverValue){ServerPresent=true;}}if(!ServerPresent){val.Service.Hardware['@Server']=GatewayServers[0];GatewayserverValue=val.Service.Hardware['@Server'];_this6.props.defaultSizerWorkload.serversList.filter(function(ServiceName){switch(ServiceName.functionName){case"Gateway Node":for(var _key3 in ServiceName.totalList){if(_key3===GatewayserverValue){GatewayProcFamilyList=[];GatewayProcList=[];GatewayDrives=ServiceName.totalList[_key3].DataDiskList;ServiceName.totalList[_key3].DataDiskList.map(function(x){if(gatewayDataDriveConsolidatedOptions.length===0){x.Types.map(function(y){if(gatewayDataDriveConsolidatedOptions.indexOf(y)===-1){gatewayDataDriveConsolidatedOptions.push(y);}});}if(gatewayDataDriveType===""){gatewayDataDriveType=gatewayDataDriveConsolidatedOptions[0];}});_this6.populateDataDriveoptions("Gateway Node");GatewayOSDiskList=ServiceName.totalList[_key3].OSDiskList;for(var proctype in ServiceName.totalList[_key3].ProcessorList){if(GatewayProcFamilyList.indexOf(proctype)===-1){GatewayProcFamilyList.push(proctype);}GatewayprocessorTypeValue=GatewayProcFamilyList[0];if(proctype===GatewayprocessorTypeValue){for(var proc in ServiceName.totalList[_key3].ProcessorList[proctype]){if(GatewayProcList.indexOf(proc)===-1){GatewayProcList.push(proc);}if(proc===GatewayprocessorValue){GatewayMemoryList=ServiceName.totalList[_key3].ProcessorList[proctype][proc];if(GatewayserverValue==="Synergy 480 Gen10 Server"&&GatewayprocessorValue.indexOf("M")!==4&&GatewayprocessorValue.indexOf("L")!==4&&GatewayMemoryList.indexOf("3072 GB")!==-1){GatewayMemoryList.pop();}}}}}}if(GatewayServers.indexOf(_key3)===-1){GatewayServers.push(_key3);}if(GatewayOSDiskList.indexOf(GatewayosdisktypValue)===-1){GatewayosdisktypValue=GatewayOSDiskList[0];}}break;}});val.Service.Hardware['@Proc']=GatewayProcList[0];GatewayprocessorValue=val.Service.Hardware['@Proc'];val.Service.Hardware['@ProcFamily']=GatewayProcFamilyList[0];GatewayprocessorTypeValue=val.Service.Hardware['@ProcFamily'];GatewaypocQtyValue=val.Service.Hardware['@ProcQty'];val.Service.Hardware['@DataDisk']=GatewayDrives[0];GatewaydatadisktypValue=val.Service.Hardware['@DataDisk'];val.Service.Hardware['@OSDisk']=GatewayosdisktypValue[0];GatewayosdisktypValue=val.Service.Hardware['@OSDisk'];val.Service.Hardware['@Memory']=GatewayMemoryList[0];GatewaymemoryValue=val.Service.Hardware['@Memory'];// GatewayDiskQtyvalue = val.Service.Hardware['@DiskQty'];
// GatewayOSDiskQtyvalue = val.Service.Hardware['@OSDiskQty'];
}}});break;case"Master Node":_this6.props.defaultSizerWorkload.serversList.filter(function(ServiceName){if(ServiceName.functionName==="Master Node"){var ServerPresent=false;for(var key in ServiceName.totalList){if(key===HeadserverValue){ServerPresent=true;}}if(!ServerPresent){val.Service.Hardware['@Server']=GatewayServers[0];HeadserverValue=val.Service.Hardware['@Server'];_this6.props.defaultSizerWorkload.serversList.filter(function(ServiceName){switch(ServiceName.functionName){case"Master Node":for(var _key4 in ServiceName.totalList){if(_key4===HeadserverValue){HeadProcFamilyList=[];HeadProcList=[];HeadDrives=ServiceName.totalList[_key4].DataDiskList;ServiceName.totalList[_key4].DataDiskList.map(function(x){if(masterNodeDataDriveConsolidatedOptions.length==0){x.Types.map(function(y){if(masterNodeDataDriveConsolidatedOptions.indexOf(y)===-1){masterNodeDataDriveConsolidatedOptions.push(y);}});}if(masterNodeDataDriveType===""){masterNodeDataDriveType=masterNodeDataDriveConsolidatedOptions[0];}});_this6.populateDataDriveoptions("Master Node");HeadOSDiskList=ServiceName.totalList[_key4].OSDiskList;for(var proctype in ServiceName.totalList[_key4].ProcessorList){if(HeadProcFamilyList.indexOf(proctype)===-1){HeadProcFamilyList.push(proctype);}HeadprocessorTypeValue=HeadProcFamilyList[0];if(proctype===HeadprocessorTypeValue){for(var proc in ServiceName.totalList[_key4].ProcessorList[proctype]){if(HeadProcList.indexOf(proc)===-1){HeadProcList.push(proc);}if(proc===HeadprocessorValue){HeadMemoryList=ServiceName.totalList[_key4].ProcessorList[proctype][proc];if(HeadserverValue==="Synergy 480 Gen10 Server"&&HeadprocessorValue.indexOf("M")!==4&&HeadprocessorValue.indexOf("L")!==4&&HeadMemoryList.indexOf("3072 GB")!==-1){HeadMemoryList.pop();}}}}}}if(HeadServers.indexOf(_key4)===-1){HeadServers.push(_key4);}if(HeadOSDiskList.indexOf(HeadosdisktypValue)===-1){HeadosdisktypValue=HeadOSDiskList[0];}}break;}});val.Service.Hardware['@Proc']=HeadProcList[0];HeadprocessorValue=val.Service.Hardware['@Proc'];val.Service.Hardware['@ProcFamily']=HeadProcFamilyList[0];HeadprocessorTypeValue=val.Service.Hardware['@ProcFamily'];HeadpocQtyValue=val.Service.Hardware['@ProcQty'];val.Service.Hardware['@DataDisk']=HeadDrives[0];HeaddatadisktypValue=val.Service.Hardware['@DataDisk'];val.Service.Hardware['@OSDisk']=HeadOSDiskList[0];HeadosdisktypValue=val.Service.Hardware['@OSDisk'];val.Service.Hardware['@Memory']=HeadMemoryList[0];HeadmemoryValue=val.Service.Hardware['@Memory'];// GatewayDiskQtyvalue = val.Service.Hardware['@DiskQty'];
// GatewayOSDiskQtyvalue = val.Service.Hardware['@OSDiskQty'];
}}});break;}});if(this.props.defaultSizerWorkload.serversList!==""&&this.props.defaultSizerWorkload.serversList!==undefined&&this.props.defaultSizerWorkload.serversList!==null){this.props.defaultSizerWorkload.serversList.map(function(ServiceName){switch(ServiceName.functionName){case"Gateway Node":var _loop3=function _loop3(key){if(key===GatewayserverValue){_this6.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Gateway Node"){if(GatewayDrives.indexOf(val.Service.Hardware["@DataDisk"])===-1){val.Service.Hardware["@DataDisk"]=GatewayDrives[0];GatewaydatadisktypValue=val.Service.Hardware["@DataDisk"];}// if(GateNodeDatadiskqtynotchange){
//GatewayDiskQtyvalue = ServiceName.totalList[key].iDataDiskQty.toString();
//  val.Service.Hardware['@DiskQty']= GatewayDiskQtyvalue
//  }else{
GatewayDiskQtyvalue=val.Service.Hardware['@DiskQty'];//     }
if(GateNodeOSdiskqtynotchange){GatewayOSDiskQtyvalue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=GatewayOSDiskQtyvalue;}else{GatewayOSDiskQtyvalue=val.Service.Hardware['@OSDiskQty'];}}});GateNodeMaxDriveQty=ServiceName.totalList[key].iMaxDrives;}};for(var key in ServiceName.totalList){_loop3(key);}break;case"Master Node":var _loop4=function _loop4(key){if(key===HeadserverValue){_this6.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Master Node"){if(HeadDrives.length>0&&HeadDrives.indexOf(val.Service.Hardware["@DataDisk"])===-1){val.Service.Hardware["@DataDisk"]=HeadDrives[0];HeaddatadisktypValue=val.Service.Hardware["@DataDisk"];}// if(HeadDatadiskqtynotchange){
//HeadnodesQtyValue = ServiceName.totalList[key].iDataDiskQty.toString();
//  val.Service.Hardware['@DiskQty']= HeadnodesQtyValue
// }else{
HeadnodesQtyValue=val.Service.Hardware['@DiskQty'];//  }
if(HeadOSdiskqtynotchange){HeadnodesOSDisksQtyValue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=HeadnodesOSDisksQtyValue;}else{HeadnodesOSDisksQtyValue=val.Service.Hardware['@OSDiskQty'];}}});HeadNodeMaxDriveQty=ServiceName.totalList[key].iMaxDrives;}};for(var key in ServiceName.totalList){_loop4(key);}break;}});if(maxlayer){layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(e){return _this6.layerclose(e,functionnode);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,'Disk Quantity requested exceeds the limit of ',maxDrivevalue,' for the selected server.')));}}var LoadindData='';if(this.props.isLoading){LoadindData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default.a,{className:'Spinning',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},'Initialising Configuration')));}if(MasterNodeQtyValue==="User Defined"){NodeQtyvisible=false;}else{NodeQtyvisible=true;}if(GatewaySizerNodeQtyValue==="User Defined"){GatewayNodeQtyvisible=false;}else{GatewayNodeQtyvisible=true;}if(!MasterChecked){HeadserverValue='None';HeadosdisktypValue='None';HeadprocessorValue='None';HeadprocessorTypeValue='None';HeaddatadisktypValue='None';HeadpocQtyValue='None';HeadmemoryValue='None';HeadnodesQtyValue='None';HeadnodesOSDisksQtyValue='None';MasterNodeQtyValue='None';HeadServers=[];HeadOSDiskList=[];HeadProcList=[];HeadProcFamilyList=[];HeadDrives=[];HeadMemoryList=[];MasterNodeNodeOtyOPtions=[];}if(MasterNodeQtyValue==='None'){NodeQtyvisible=true;}if(!GatewayChecked){GatewayserverValue='None';GatewayosdisktypValue='None';GatewayOSDiskList='None';GatewayprocessorValue='None';GatewayprocessorTypeValue='None';GatewaydatadisktypValue='None';//HeadmemoryValue = 'None'
GatewaypocQtyValue='None';GatewaymemoryValue='None';GatewayDiskQtyvalue='None';GatewayOSDiskQtyvalue='None';GatewayNodeQtyValue='None';GatewaySizerNodeQtyValue='None';GatewayServers=[];GatewayProcList=[];GatewayProcFamilyList=[];GatewayDrives=[];GatewayMemoryList=[];GatewayNodeNodeOtyOPtions=[];// GatewaydefaultNodevalue = ""
}var MasterSizerdispaly="none";var GatewaySizerdisplay="none";var GatewayOSDiskQtyvalue="None";var MasterOSDiskQtyvalue="None";if(MasterChecked){MasterSizerdispaly=" ";MasterOSDiskQtyvalue="2";}if(GatewayChecked){GatewaySizerdisplay=" ";GatewayOSDiskQtyvalue="2";}if(GatewaySizerNodeQtyValue==='None'){GatewayNodeQtyvisible=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{position:'relative',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_tooltip___default.a,{place:'right',multiline:true}),LoadindData,serverChangeConfirmationlayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default.a,{full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Tabs___default.a,{justify:'start',activeIndex:this.state.activeIndex,onActive:function onActive(e){_this6.setState({activeIndex:e});_this6.props.defaultSizerWorkload.Indexes.extraConfiguration=e;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Tab___default.a,{title:'Master Node'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none'},layer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{margin:"0px",paddingLeft:'10px',maxWidth:"700px"}},'Master Node nodes run Hadoop master processes such as the HDFS NameNode and YARN Resource Manager.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'small',style:{marginTop:'10px',padding:'0px',width:'15%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'CheckboxSeparate',label:'Add Master Node',style:{marginRight:'0px'},checked:MasterChecked,onChange:function onChange(e){return _this6.MasterCheckboxChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Server',error:this.state.DiskCapacityerror,style:{width:'30%',minWidth:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:HeadserverValue,options:HeadServers,onChange:function onChange(e){return _this6.onServerChange(e,"Master Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processor Family',style:{width:'20%',minWidth:'147px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:HeadprocessorTypeValue,options:HeadProcFamilyList,onChange:function onChange(e){return _this6.onProcessorFamilytypeChange(e,"Master Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processor',style:{width:'25%',minWidth:'127px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:HeadprocessorValue,options:HeadProcList,onChange:function onChange(e){return _this6.onProcessorChange(e,"Master Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Proc Qty',style:{width:'12%',minWidth:'110px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:HeadpocQtyValue,onChange:function onChange(e){return _this6.onProcQtyChange(e,"Master Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Memory',style:{width:'13%',minWidth:'141px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:HeadmemoryValue,options:HeadMemoryList,onChange:function onChange(e){return _this6.onMemoryChange(e,"Master Node");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DataDrive_js__["a" /* default */],{dataDriveType:masterNodeDataDriveType,dataDriveConsolidatedOptions:masterNodeDataDriveConsolidatedOptions,onDatadriveTypeChange:this.onMasterNodeDataDriveTypeChange,Drives:HeadDrives,dataDiskValue:HeaddatadisktypValue,type:'Master Node',title:'',onDataDiskChange:this.onDataDiskChange,noOfDisksValue:HeadnodesQtyValue,onNoOfDisksChange:this.onNoOfDisksChange,onAddingDataDisk:this.onAddingDataDisk,renderTable:this.renderTable,isMixedStorage:isMixedStorageConfigurationmasterNode,enableADDButton:true,workloadType:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'OS Disk',error:this.state.DiskCapacityerror},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:HeadosdisktypValue,options:HeadOSDiskList,onChange:function onChange(e){return _this6.onOSDiskChange(e,"Master Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'No. of OS Disks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput___default.a,{placeHolder:'None',value:MasterOSDiskQtyvalue})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'70%',paddingLeft:"9px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Nodes Quantity',style:{width:'44%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{className:'NodeSelect',placeHolder:'None',value:MasterNodeQtyValue,options:MasterNodeNodeOtyOPtions,onChange:function onChange(e){return _this6.onMasterNodeQtyValueChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',alignContent:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput___default.a,{id:'UserDefined',hidden:NodeQtyvisible,style:{width:'44%'},value:MasternodesQtyValue,onBlur:function onBlur(e){return _this6.onMasterNodevalueBlur(e);},onDOMChange:function onDOMChange(e){return _this6.onMasterNodevalueChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',hidden:NodeQtyvisible,style:{marginLeft:"10px",fontWeight:'600'}},"Minimum Nodes required:"+MasterdefaultNodevalue))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{display:MasterSizerdispaly}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Sizer Recommendation:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px'}},MasterSizerRecmdtnServer,' / ',MasterSizerRecmdtnProcsr,' / ',MasterSizerRecmdtnDisktype,' / ',MasterSizerRecmdtnMemory,' / ',MasterdefaultNodevalue+" Nodes")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Tab___default.a,{title:'Gateway Node'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none'},layer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{margin:"0px",paddingLeft:'10px'}},'Gateway Node nodes are client access points for launching jobs in the cluster.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Gateway Node quantity is calculated based on the total host count in the Function screen excluding Scality and AI (Tenserflow and PyTorch) service nodes.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px',marginLeft:'0.4%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'small',style:{marginTop:'10px',padding:'0px',width:'15%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_CheckBox___default.a,{className:'CheckboxSeparate',label:'Add Gateway Node',style:{marginRight:'0px'},checked:GatewayChecked,onChange:function onChange(e){return _this6.GatewayCheckboxChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Server',error:this.state.DiskCapacityerror,style:{width:'30%',minWidth:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:GatewayserverValue,options:GatewayServers,onChange:function onChange(e){return _this6.onServerChange(e,"Gateway Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processor Family',error:this.state.DiskCapacityerror,style:{width:'20%',minWidth:'147px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:GatewayprocessorTypeValue,options:GatewayProcFamilyList,onChange:function onChange(e){return _this6.onProcessorFamilytypeChange(e,"Gateway Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processor',error:this.state.DiskCapacityerror,style:{width:'25%',minWidth:'127px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:GatewayprocessorValue,options:GatewayProcList,onChange:function onChange(e){return _this6.onProcessorChange(e,"Gateway Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Proc Qty',style:{width:'12%',minWidth:'110px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:GatewaypocQtyValue,onChange:function onChange(e){return _this6.onProcQtyChange(e,"Gateway Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Memory',style:{width:'13%',minWidth:'141px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:GatewaymemoryValue,options:GatewayMemoryList,onChange:function onChange(e){return _this6.onMemoryChange(e,"Gateway Node");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DataDrive_js__["a" /* default */],{dataDriveType:gatewayDataDriveType,dataDriveConsolidatedOptions:gatewayDataDriveConsolidatedOptions,onDatadriveTypeChange:this.ongatewayDataDriveTypeChange,Drives:GatewayDrives,dataDiskValue:GatewaydatadisktypValue,type:'Gateway Node',title:'',onDataDiskChange:this.onDataDiskChange,noOfDisksValue:GatewayDiskQtyvalue,onNoOfDisksChange:this.onNoOfDisksChange,onAddingDataDisk:this.onAddingDataDisk,renderTable:this.renderTable,isMixedStorage:isMixedStorageConfigurationgateWay,enableADDButton:true,workloadType:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'OS Disk',error:this.state.DiskCapacityerror},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{placeHolder:'None',value:GatewayosdisktypValue,options:GatewayOSDiskList,onChange:function onChange(e){return _this6.onOSDiskChange(e,"Gateway Node");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'No. of OS Disks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput___default.a,{placeHolder:'None',value:GatewayOSDiskQtyvalue})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'70%',paddingLeft:"9px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Nodes Quantity',style:{width:'44%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Select___default.a,{className:'NodeSelect',placeHolder:'None',value:GatewaySizerNodeQtyValue,options:GatewayNodeNodeOtyOPtions,onChange:function onChange(e){return _this6.onGatewayNodeQtyValueChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',alignContent:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_TextInput___default.a,{id:'UserDefined',hidden:GatewayNodeQtyvisible,style:{width:'44%'},value:GatewayNodeQtyValue,onBlur:function onBlur(e){return _this6.onGatewayNodevalueBlur(e);},onDOMChange:function onDOMChange(e){return _this6.onGatewayNodevalueChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',hidden:GatewayNodeQtyvisible,style:{marginLeft:"10px",fontWeight:'600'}},"Minimum Nodes required:1"))),GatewayserverValue==="Synergy 480 Gen10 Server"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Note: With multi rack solution, single frame Synergy Server is not recommended as Gateway Node.')):" ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Note: Additional 1 Gateway Node will be configured if Scality is selected under Storage Function.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{display:GatewaySizerdisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Sizer Recommendation:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px'}},GatewaySizerRecmdtnServer,' / ',GatewaySizerRecmdtnProcsr,' / ',GatewaySizerRecmdtnDisktype,' / ',GatewaySizerRecmdtnMemory,' / ',GatewaydefaultNodevalue,'-Nodes')))))));}}]);return HadoopServices;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{defaultSizerWorkload:state.sizerWorkload,workload:state.sizerWorkload.workload,//    ExtranodeServerDetails:state.sizerWorkload.workload,
//  //  ExtranodeServerDetails:state.sizerWorkload.serversList.workload.WorkLoad.UserInputs.Environments.ServerDetails,
//    SupportedComponents:state.sizerWorkload.supportedList,
//    FilteredComps:state.sizerWorkload.filteredComponents,
//    ExtranodeRole:state.sizerWorkload.workload,
//   // ExtranodeRole:state.sizerWorkload.serversList.workload.WorkLoad.UserInputs.Environments.Roles.Role,
//    UpdatingExtranodesFromServerList:state.sizerWorkload.supportedList,
//    ActivePartNumbers:state.sizerWorkload.activepartnumbers,
isLoading:state.sizerWorkload.isLoading,activeSession:state.sessions.activeSession};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnDefaultFetchServerList:function OnDefaultFetchServerList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__Redux_actions_epaActions__["f" /* defaultfetchServerList */])(value));},//  getAllFilteredComps : () => {
//   dispatch(fetchFilteredComps(InputSupportedServers));
// },
//  OnFetchSupportedList:() =>{
//     dispatch(fetchSupportedList());
//   } ,
OnGetOSDiskList:function OnGetOSDiskList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__Redux_actions_epaActions__["r" /* getosdisklist */])(value));},OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_18__State_actions_sessions__["W" /* toggleSizeButton */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(HadoopServices));

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonLogic__ = __webpack_require__(33);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var iLOText=[];var Networktext=[];var FactoryExpresstext=[];var GetAllSupportedComponents;var NetworkSpeedList=[];var AdditionalSwitches=[];var FactoryExpressList=[];var MellanoxList=[];var displayStorageNetworkSpeed=false;var DesignRequirements=function(_Component){_inherits(DesignRequirements,_Component);function DesignRequirements(){_classCallCheck(this,DesignRequirements);var _this=_possibleConstructorReturn(this,(DesignRequirements.__proto__||Object.getPrototypeOf(DesignRequirements)).call(this));_this.StorageNetworkSpeedChange=function(e){_this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_185" /* TEXT_ATTRIBUTE */]]=e.value;_this.setState({});};_this.onNimbleStorageChange=function(){if(_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */];})["@isSelected"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_207" /* nO_ */]){if(_this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){_this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}else{_this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}_this.props.workload.UserInputs.Environments.NimbleUserChoice=_this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble;_this.setState({});}};_this.state={PrefereedRackhgtList:[],preferedRacksListObj:'',preferedRacksList:[],informationicon:false};_this.HWSupportChange=_this.HWSupportChange.bind(_this);_this.LinuxLicenceChange=_this.LinuxLicenceChange.bind(_this);_this.HadoopLicenseChage=_this.HadoopLicenseChage.bind(_this);_this.iLO_CMULicenseChage=_this.iLO_CMULicenseChage.bind(_this);_this.NetworkSpeedChage=_this.NetworkSpeedChage.bind(_this);_this.NetworkSwitchChage=_this.NetworkSwitchChage.bind(_this);_this.FactoryExpressChage=_this.FactoryExpressChage.bind(_this);_this.AdditionalSwitchChange=_this.AdditionalSwitchChange.bind(_this);_this.MaxPowerPerRack=_this.MaxPowerPerRack.bind(_this);_this.maxWeightPerRack=_this.maxWeightPerRack.bind(_this);_this.onRackHeightChange=_this.onRackHeightChange.bind(_this);_this.onRackListChange=_this.onRackListChange.bind(_this);_this.RackDetails=_this.RackDetails.bind(_this);_this.ConsolidateChassisChange=_this.ConsolidateChassisChange.bind(_this);_this.AddtnlNtwkSwtchChage=_this.AddtnlNtwkSwtchChage.bind(_this);return _this;}_createClass(DesignRequirements,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'NetworkSwitchChage',value:function NetworkSwitchChage(e){}},{key:'RackDetails',value:function RackDetails(){var _this2=this;if(this.state.PrefereedRackhgtList.length===0){this.props.DefaultSolution.Racks.Rack.map(function(v){_this2.state.PrefereedRackhgtList.push(v["@Height"]);//this.state.PrefereedRackhgtList=[...this.state.PrefereedRackhgtList,v["@Height"]];       
});// this.state.preferedRacksListObj= this.props.DefaultSolution.Racks.Rack.filter(x=>x["@Height"] ===this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack);               
this.props.DefaultSolution.Racks.Rack.map(function(x){if(x["@Height"]===_this2.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack){if(Array.isArray(x.RackItem.Item)){x.RackItem.Item.map(function(rack){_this2.state.preferedRacksList.push(rack['#text']);});}else{_this2.state.preferedRacksList.push(x.RackItem.Item['#text']);}}});}}},{key:'componentDidMount',value:function componentDidMount(){var _this3=this;NetworkSpeedList=this.props.DefaultSolution.Services.NetworkSpeed.Item;//NetworkSwitchList=DefaultSolution.Services.NetworkSpeed.Item;
if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){FactoryExpressList=this.props.DefaultSolution.FactoryExpress.Item;}else{FactoryExpressList=["No Factory Express"];}if(this.props.DefaultSolution.NwSwitches.Mellanox!==undefined){MellanoxList=this.props.DefaultSolution.NwSwitches.Mellanox.Item;}if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){if(!this.props.activeSession.isSizeEnabled)this.props.OnToggleSizeButton(true);}else{displayStorageNetworkSpeed=false;this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed["@isSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_207" /* nO_ */];var selectedServices=this.props.workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];});if(selectedServices.length>0){selectedServices.map(function(service){if(service.StorageValue.isCalculated===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){displayStorageNetworkSpeed=true;_this3.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed["@isSelected"]=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}});}var NoValues=true;this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]==="yes";}).Templates.Template.filter(function(x,id){if(x["@Type"]!=="Custom"&&x["@Type"]!=="Custom w/GPUs"){if(parseInt(x.Nodes["@vClusters"],10)!==0&&parseInt(x.Nodes["@vNodesPerCluster"],10)!==0){NoValues=false;}}else{if(parseInt(x.Nodes["@vClusters"],10)!==0&&parseInt(x.Nodes["@vNodesPerCluster"],10)!==0&&parseInt(x.Nodes["@vCPUPerNode"],10)!==0&&parseInt(x.Nodes["@vMemoryPerNode"],10)!==0&&parseInt(x.Nodes["@StoragePervNode"],10)!==0){NoValues=false;}}});if(Object(__WEBPACK_IMPORTED_MODULE_16__commonLogic__["k" /* updateFinishButton */])(this.props.workload,this.props.displayWarning,this.props.activeSession.isSizeEnabled)){this.props.OnToggleSizeButton(true);}}this.setState({});}},{key:'onRackHeightChange',value:function onRackHeightChange(e){var _this4=this;this.state.preferedRacksList=[];this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack=e.value;this.state.preferedRacksListObj=this.props.DefaultSolution.Racks.Rack.filter(function(x){return x["@Height"]==_this4.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack;});console.log(this.state.preferedRacksList);this.state.preferedRacksListObj.map(function(rack){console.log(_this4.state.preferedRacksListObj["@Height"]);if(rack['@Height']===_this4.state.preferedRacksListObj[0]["@Height"]){if(Array.isArray(rack.RackItem.Item)){rack.RackItem.Item.map(function(val){_this4.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription=val['#text'];_this4.state.preferedRacksList=[].concat(_toConsumableArray(_this4.state.preferedRacksList),[val['#text']]);});}else{_this4.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription=rack.RackItem.Item['#text'];_this4.state.preferedRacksList=[].concat(_toConsumableArray(_this4.state.preferedRacksList),[rack.RackItem.Item['#text']]);}}});this.setState({});}},{key:'onRackListChange',value:function onRackListChange(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription=e.value;this.setState({});}},{key:'MaxPowerPerRack',value:function MaxPowerPerRack(e){if(e.target.value.length<=5){var x=parseInt(e.target.value,10);if(isNaN(x)){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower=" ";}else if(x>20001){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower=x.toString();}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower=x.toString();}this.setState({});}else{}}},{key:'MaxPowerPerRackBlur',value:function MaxPowerPerRackBlur(e){var x=parseInt(e.target.value,10);if(isNaN(x)||e.target.value==""||e.target.value=="  "){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower="2000";}else if(x<2000){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower="2000";}else if(x>20000){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower="20000";}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower=x.toString();}this.setState({});}},{key:'onNumberOfSwitchesChage',value:function onNumberOfSwitchesChage(e){if(e.target.value.length<=2){var x=parseInt(e.target.value,10);if(isNaN(x)){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]=" ";}else if(x>9){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]="9".toString();}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]=x.toString();}this.setState({});}else{}}},{key:'onNumberOfSwitchesBlur',value:function onNumberOfSwitchesBlur(e){var x=parseInt(e.target.value,10);if(isNaN(x)||e.target.value==""||e.target.value=="  "){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]="1";}else if(x>9){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]="9";}/* Change by Vinay, checking negative value */else if(x<=0){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]="1".toString();}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]=x.toString();}this.setState({});}},{key:'maxWeightPerRack',value:function maxWeightPerRack(e){if(e.target.value.length<=4){var x=parseInt(e.target.value,10);if(isNaN(x)){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight=" ";}else if(x>5000){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight=x.toString();}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight=x.toString();}this.setState({});}else{}}},{key:'maxWeightPerRackBlur',value:function maxWeightPerRackBlur(e){var x=parseInt(e.target.value,10);if(isNaN(x)||e.target.value==""||e.target.value=="  "){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight="300";}else if(x<300){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight="300";}else if(x>5000){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight="5000";}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight=x.toString();}this.setState({});}},{key:'HWSupportChange',value:function HWSupportChange(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["HWSupport"]=e.value;this.setState({});}},{key:'LinuxLicenceChange',value:function LinuxLicenceChange(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["LinuxLicense"]=e.value;this.setState({});}},{key:'HadoopLicenseChage',value:function HadoopLicenseChage(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["HadoopLicense"]=e.value;this.setState({});}},{key:'iLO_CMULicenseChage',value:function iLO_CMULicenseChage(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["iLoLicense"]=e.value;this.setState({});}},{key:'NetworkSpeedChage',value:function NetworkSpeedChage(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"]=e.value;this.setState({});}},{key:'FactoryExpressChage',value:function FactoryExpressChage(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.FactoryExpress=e.value;this.setState({});}},{key:'AddtnlNtwkSwtchChage',value:function AddtnlNtwkSwtchChage(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch['#text']=e.value;/*added by Vinay*/this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"]="1";this.setState({});}},{key:'ConsolidateChassisChange',value:function ConsolidateChassisChange(e){if(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis==='true'){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis='false';}else{this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis='true';}this.setState({});}},{key:'AdditionalSwitchChange',value:function AdditionalSwitchChange(e){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"]=e.value;this.setState({});}},{key:'InformationIconClick',value:function InformationIconClick(e){var _this5=this;this.props.Informationicondescription.Text.map(function(name){switch(name["@Name"]){case"iLOLicense":{if(e==="informationbuttoniLO"){_this5.state.content=iLOText.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{margin:'none',style:{padding:'6px'}},val);});}break;}case"NetworkSpeed":{if(e==="informationbuttonNetworkspeed"){_this5.state.content=Networktext.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{margin:'none',style:{padding:'6px'}},val);});}break;}case"FactoryExpress":{if(e==="informationbuttonFactoryExpress"){_this5.state.content=FactoryExpresstext.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{margin:'none',style:{padding:'6px'}},val);});}break;}}});this.setState({heading:"Information",informationicon:true});}},{key:'render',value:function render(){var _this6=this;var nimbleStorageChecked=false;AdditionalSwitches=[];var type='';this.props.workload.UserInputs.Environments.WorkloadType==='BigData'?type=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{options:['Bare metal'],value:'Bare metal'}):type=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{options:['HPE Ezmeral'+__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_145" /* RE */]],value:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_69" /* HPE_E_CPDESC */]});this.RackDetails();if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["s" /* BLUE_DATA */]){if(this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */];})["@isSelected"]===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}if(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Nimble===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){nimbleStorageChecked=true;}}this.props.DefaultSolution.Services.NetworkSwitches.Item.map(function(val,id){AdditionalSwitches.push(val);if(val==="HPE Composable Fabric FM"&&_this6.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"]!=="25G"&&_this6.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"]!=="100G"){AdditionalSwitches.splice(id,1);}});if(AdditionalSwitches.indexOf(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"])===-1){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"]=AdditionalSwitches[0];}if(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis===undefined){this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis='true';}var ConsolidateChassisValue;ConsolidateChassisValue=/true/i.test(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.ConsolidateChassis);if(this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch===undefined){var AdditionalSwitch={"@Qty":"1","#text":"None"};this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch=AdditionalSwitch;//MellanoxList[0]
//this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch.Qty="1"
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'none',style:{position:'relative',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Warning__["a" /* default */],{message:__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_54" /* HPECP_WARNING_MESSAGE */],isEnabled:!this.props.displayWarning,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default.a,{full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:'none',style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Form___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Network Speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the desired network speed for the solution. Top of rack switches will be added to the BOM along with matching network cards and cables.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSpeed"],onChange:this.NetworkSpeedChage,options:NetworkSpeedList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:'Network Switches Vendor',style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses["NetworkSwitch"],onChange:this.AdditionalSwitchChange,options:AdditionalSwitches})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Additional Network Switch')),style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch['#text'],onChange:this.AddtnlNtwkSwtchChage,options:MellanoxList})),this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch['#text']==='None'?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Number of Switches')),error:'(1-9)',style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.AdditionalSwitch["@Qty"],onDOMChange:function onDOMChange(e){return _this6.onNumberOfSwitchesChage(e);},onBlur:function onBlur(e){return _this6.onNumberOfSwitchesBlur(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Factory Express'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Insure your solutions are up and running in your data centers at rapid speeds along with quality assurance. Factory Express is having your solution built, tested and integrated at an HPE Factory, delivered to your Customer\'s site ready to power ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.FactoryExpress,onChange:this.FactoryExpressChage,options:FactoryExpressList})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Provisioning Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Install bare-metal, HPE Ezmeral RE containers or other virtualized solution.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px'}},type),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'small',style:{marginLeft:'0px',padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_CheckBox___default.a,{className:'CheckboxSeparate',label:'Consolidate Chassis',style:{marginRight:'0px'},checked:ConsolidateChassisValue,onChange:this.ConsolidateChassisChange}),this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["s" /* BLUE_DATA */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{paddingTop:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_CheckBox___default.a,{className:'CheckboxSeparate',label:'Configure Nimble Storage',style:{marginRight:'0px'},checked:nimbleStorageChecked,onChange:this.onNimbleStorageChange})):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:'{horizontal:\'none\' ,vertical:\'small\'}',className:'BasicofHardware_licence',style:{width:'60%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Form___default.a,{style:{width:'100%'}},displayStorageNetworkSpeed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Storage Network Speed'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the desired storage network speed for the solution. Top of rack switches will be added to the BOM along with matching network cards and cables.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.StorageNetworkSpeed[__WEBPACK_IMPORTED_MODULE_14__Redux_action_types_EPAConstants_js__["_185" /* TEXT_ATTRIBUTE */]],options:NetworkSpeedList,onChange:this.StorageNetworkSpeedChange})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:'Max Power per Rack',style:{marginBottom:'5px'},error:"(2000-20000)Watts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxPower,onDOMChange:this.MaxPowerPerRack,onBlur:function onBlur(e){return _this6.MaxPowerPerRackBlur(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:'Max Weight Per Rack',style:{marginBottom:'5px'},error:"(300-5000)Lbs"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.MaxWeight,onDOMChange:this.maxWeightPerRack,onBlur:function onBlur(e){return _this6.maxWeightPerRackBlur(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:' Rack Units',style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.Rack,options:this.state.PrefereedRackhgtList,onChange:this.onRackHeightChange})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'HWSupport',label:'Preferred Rack',style:{marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{className:'Rackdropdown',placeHolder:'None',value:this.props.DefaultLicenceValues.UserInputs.Environments.Licenses.RackDescription,options:this.state.preferedRacksList,onChange:this.onRackListChange})))))));}}]);return DesignRequirements;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{workload:state.sizerWorkload.workload,DefaultLicenceValues:state.sizerWorkload.workload,DefaultSolution:state.sizerWorkload.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails,Informationicondescription:state.sizerWorkload.sessionDefaults.Sizers.Sizer.InfoIconDescriptions,//ActivePartNumbers:state.sizerWorkload.activepartnumbers,
isLoading:state.sizerWorkload.isLoading,SupportedComponents:state.sizerWorkload.supportedList,//SupportedComponentsRack:state.sizerWorkload.supportedList,
// FilteredComps:state.sizerWorkload.filteredComponents,
activeSession:state.sessions.activeSession,ConfigButton:state.sizerWorkload.calbtn,displayWarning:state.sizerWorkload.guiState.displayWarning};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAllActivePartNumbers:function getAllActivePartNumbers(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__Redux_actions_epaActions__["h" /* fetchActiveList */])());},getAllFilteredComps:function getAllFilteredComps(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__Redux_actions_epaActions__["i" /* fetchFilteredComps */])(GetAllSupportedComponents));},OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__State_actions_sessions__["W" /* toggleSizeButton */])(value));},OnFetchSupportedList:function OnFetchSupportedList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__Redux_actions_epaActions__["l" /* fetchSupportedList */])());}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DesignRequirements));

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Accordion__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonLogic_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { connect } from 'react-redux';
var serverList={storage:['Apollo 4200 28 LFF','Apollo 4510 60 LFF','DL380 Gen10 19 LFF'],databases:['Apollo 2000','DL360 Gen10','Synergy'],streaming:['Apollo 2000','DL360 Gen10','Synergy'],analytics:['Apollo 2000','DL360 Gen10','Synergy'],ai:['Apollo 2000','DL360 Gen10','Synergy'],iot:['Apollo 2000','DL360 Gen10','Synergy']};var country='';var Functions=function(_Component){_inherits(Functions,_Component);function Functions(){_classCallCheck(this,Functions);var _this=_possibleConstructorReturn(this,(Functions.__proto__||Object.getPrototypeOf(Functions)).call(this));_this.state={activeIndex:0};_this.getActive=_this.getActive.bind(_this);return _this;}_createClass(Functions,[{key:'getActive',value:function getActive(){var expandHiveService=false;var expandCassandraService=false;var expandImpalaService=false;var expandHBaseService=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Database":if(Array.isArray(val.Service)){val.Service.filter(function(service,id){if(id===0){if(service['@Selected']==="true"){expandHiveService=true;}}if(id===1){if(service['@Selected']==="true"){expandCassandraService=true;}}if(id===2){if(service['@Selected']==="true"){expandImpalaService=true;}}if(id===3){if(service['@Selected']==="true"){expandHBaseService=true;}}});}break;}});if(this.state.activeIndex===1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Hive',expanded:expandHiveService,isDefault:true,type:'Database',servers:serverList.databases}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Cassandra',expanded:expandCassandraService,isDefault:false,type:'Database',servers:serverList.databases}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Impala',expanded:expandImpalaService,isDefault:false,type:'Database',servers:serverList.databases}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'HBase',expanded:expandHBaseService,isDefault:false,type:'Database',servers:serverList.databases}));}else return'';}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.defaultSizerWorkload!==undefined&&this.props.defaultSizerWorkload!==null){if(this.props.defaultSizerWorkload.getExtraNodes){var value={"input":{"Workload":null}};value.input.Workload=this.props.workload;this.props.GetExtraNodesQty(value);}}}},{key:'componentWillMount',value:function componentWillMount(){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Storage"){val.Service.filter(function(service){if(service['@Type']===__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_47" /* HDFS_EC */]||service['@Type']===__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_46" /* HDFS_ */]){service['@Type']=__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */];}});}});if(this.props.workload.UserInputs.Environments.HadoopServices!==undefined){if(this.props.workload.UserInputs.Environments.HadoopServices.Deployment===undefined){this.props.workload.UserInputs.Environments.HadoopServices.Deployment='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.AppStore===undefined){this.props.workload.UserInputs.Environments.HadoopServices.AppStore='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.Installation===undefined){this.props.workload.UserInputs.Environments.HadoopServices.Installation='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage===undefined){this.props.workload.UserInputs.Environments.HadoopServices.SingleImage={"@Qty":"1","#text":"false"};}if(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage===undefined){this.props.workload.UserInputs.Environments.HadoopServices.CustomImage={"@Qty":"1","#text":"false"};}}this.props.workload.UserInputs.Environments.Functions.Function.map(function(Function){if(Array.isArray(Function.Service)){Function.Service.map(function(service){if(service["@mixedStorage"]===undefined){service["@mixedStorage"]="False";}if(service.Hardware["@dataDriveType"]===undefined){service.Hardware["@dataDriveType"]="";}if(service.DataDisks===undefined){var DataDiskArray=[{Item:{'@disk':service.Hardware['@DataDisk'],'@qty':service.Hardware['@DiskQty'],"@volumeName":"Data_0"}}];service.DataDisks=DataDiskArray;}if(!Array.isArray(service.DataDisks)){var _DataDiskArray=[{Item:{'@disk':service.DataDisks.Item["@disk"],'@qty':service.DataDisks.Item["@qty"],"@volumeName":"Data_0"}}];service.DataDisks=_DataDiskArray;}});}else{if(Function.Service["@mixedStorage"]===undefined){Function.Service["@mixedStorage"]="False";}if(Function.Service.Hardware["@dataDriveType"]===undefined){Function.Service.Hardware["@dataDriveType"]="";}if(Function.Service.DataDisks===undefined){var DataDiskArray=[{Item:{'@disk':Function.Service.Hardware['@DataDisk'],'@qty':Function.Service.Hardware['@DiskQty'],"@volumeName":"Data_0"}}];Function.Service.DataDisks=DataDiskArray;}if(!Array.isArray(Function.Service.DataDisks)){var _DataDiskArray2=[{Item:{'@disk':Function.Service.DataDisks.Item["@disk"],'@qty':Function.Service.DataDisks.Item["@qty"],"@volumeName":"Data_0"}}];Function.Service.DataDisks=_DataDiskArray2;}}});}},{key:'componentDidMount',value:function componentDidMount(){this.props.workload.ServicesInput===undefined&&this.props.sessionsDefaults.inputs!==""?this.props.onUpdateDefaultSession(this.props.sessionsDefaults.inputs):'';if(this.props.activeSession.isSizeEnabled)this.props.OnToggleSizeButton(false);var index=this.props.defaultSizerWorkload.Indexes.functions;this.setState({activeIndex:index});var value={"input":{"Workload":null}};var Iputs={DefaultData:[{"function":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_161" /* STORAGE_ */],"service":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */],"workload":value},{"function":"Storage","service":"Scality","workload":value},{"function":"Storage","service":"Weka","workload":value},{"function":"Database","service":"Hive","workload":value},{"function":"Database","service":"Cassandra","workload":value},{"function":"Database","service":"Impala","workload":value},{"function":"Database","service":"HBase","workload":value},{"function":"Streaming","service":"Spark Streaming","workload":value},{"function":"Streaming","service":"Kafka","workload":value},{"function":"Streaming","service":"Flink","workload":value},{"function":"Streaming","service":"Storm","workload":value},{"function":"Analytics","service":"Yarn","workload":value},{"function":"Analytics","service":"Spark","workload":value},{"function":"AI","service":"Tensorflow","workload":value},{"function":"AI","service":"PyTorch","workload":value},{"function":"IoT","service":"MiNifi","workload":value},{"PricingRegion":this.props.workload.UserInputs.Country}]};if(this.props.defaultSizerWorkload.serversList.length==0){if(this.props.iterationvalue===1){if(this.props.workload.UserInputs.Country!==country){country=this.props.workload.UserInputs.Country;}this.props.OnDefaultFetchServerList(Iputs);this.props.OnIterationCountIncrease(2);}}if(this.props.workload.UserInputs.Country!==country){country=this.props.workload.UserInputs.Country;this.props.OnDefaultFetchServerList(Iputs);}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined&&this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric===undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric={'@IsSelected':'false',License:[{'@Type':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["Y" /* DATAFABRIC_XD */],'@IsSelected':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],'@Description':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */]},{'@Type':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["S" /* DATAFABRIC_ANALYTICS */],'@IsSelected':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],'@Description':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */]},{'@Type':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["W" /* DATAFABRIC_SPARK */],'@IsSelected':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],'@Description':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */]},{'@Type':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["X" /* DATAFABRIC_STREAMS */],'@IsSelected':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],'@Description':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */]},{'@Type':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["U" /* DATAFABRIC_DATABASE */],'@IsSelected':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],'@Description':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */]},{'@Type':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["T" /* DATAFABRIC_BUNDLE */],'@IsSelected':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],'@Description':__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */]}]};}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses){if(!this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */];})){var dataFabricService={"@Type":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["V" /* DATAFABRIC_SERVICES */],"@IsSelected":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */]};this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.DataFabric.License.push(dataFabricService);}}if(!Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)||this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.length===2||this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License===undefined){// BluedataMLsftwreValue=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License[1]['@Description']
var License=[{"@Description":'None',"@IsSelected":"true","@Type":"BlueData"},{"@Description":"None","@IsSelected":"false","@Type":"BlueDataAI"},{"@Description":"24x7 1y","@IsSelected":"true","@Type":"HPE Container Platform"},{"@Description":"None","@IsSelected":"false","@Type":"Data Apps"},{"@Description":"None","@IsSelected":"false","@Type":"Data Apps Universal"},{"@Description":"None","@IsSelected":"false","@Type":"Data Apps w/ML Ops"},{"@Description":"None","@IsSelected":"false","@Type":"Data Apps Universal w/ML Ops"}];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License=License;}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses){if(Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){if(!this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */];})){var dataFabricLicense={"@Description":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_109" /* NONE_ */],"@IsSelected":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_204" /* fALSE_ */],"@Type":__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_66" /* HPE_EZMERAL_DF_XD */]};this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.push(dataFabricLicense);}}if(this.props.sessionsDefaults.inputs){Object(__WEBPACK_IMPORTED_MODULE_11__commonLogic_js__["o" /* updateServiceLicenses */])(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses,this.props.sessionsDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License);}}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration===undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration={'@Type':'EPIC'};}if(this.props.country!==undefined){this.props.workload.UserInputs.Country=this.props.country;// Selected country is not updated in the workload. - By Aditya
}if(!this.props.workload.UserInputs.Environments.Growth){this.props.workload.UserInputs.Environments.Growth=__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_9" /* DEFAULT_GROWTH_OBJECT */];}}},{key:'render',value:function render(){var _this2=this;var LoadindData="";var expandHDFSService=false;var expandScalityService=false;var expandWekaService=false;var expandSparkService=false;var expandKafkaService=false;var expandFlinkService=false;var expandStormService=false;var expandYarnService=false;var expandAnalyticsSparkService=false;var expandTensorflowService=false;var expandPyTorchService=false;var expandMiNifiService=false;if(this.props.isLoading){if(this.props.isLoading){LoadindData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},'Please wait while fetching the data.')));}}// if(this.props.SelectedService===undefined)
// {
//     let value={
//         "value":"Tabchanged"
//     }
//      this.props.SelectedServericeValue(value)
// }
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){switch(val['@Type']){case"Storage":if(Array.isArray(val.Service)){val.Service.filter(function(service,id){if(id===0){if(service['@Selected']==="true"){expandHDFSService=true;}}if(id===1){if(service['@Selected']==="true"){expandScalityService=true;}}if(id===2){if(service['@Selected']==="true"){expandWekaService=true;}}});}break;case"Streaming":if(Array.isArray(val.Service)){val.Service.filter(function(service,id){if(service['@Type']==="Flume"){service['@Type']="Flink";}else if(service['@Type']==="Nifi"){service['@Type']="Storm";}if(id===0){if(service['@Selected']==="true"){expandSparkService=true;}}if(id===1){if(service['@Selected']==="true"){expandKafkaService=true;}}if(id===2){if(service['@Selected']==="true"){expandFlinkService=true;}}if(id===3){if(service['@Selected']==="true"){expandStormService=true;}}});}break;case"Analytics":if(Array.isArray(val.Service)){val.Service.filter(function(service,id){if(id===0){if(service['@Selected']==="true"){expandYarnService=true;}}if(id===1){if(service['@Selected']==="true"){expandAnalyticsSparkService=true;}}});}break;case"AI":if(Array.isArray(val.Service)){val.Service.filter(function(service,id){if(id===0){if(service['@Selected']==="true"){expandTensorflowService=true;}}if(id===1){if(service['@Selected']==="true"){expandPyTorchService=true;}}});}break;case"IoT":if(Array.isArray(val.Service)){val.Service.filter(function(service,id){if(id===0){if(service['@Selected']==="true"){expandMiNifiService=true;}}});}else{if(val.Service['@Selected']==="true"){expandMiNifiService=true;}}break;}});var temp=this.getActive();//let a=JSON.parse(this.props. workload.UserInputs.Environments.Functions.Function[0].Service[0]['@Selected'])
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Article___default.a,{id:'scroll',full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'95%'},justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs___default.a,{justify:'start',activeIndex:this.state.activeIndex,onActive:function onActive(e){_this2.setState({activeIndex:e});_this2.props.defaultSizerWorkload.Indexes.functions=e;//this.props.SelectedService.value="Tabchanged"
}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Storage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'small',pad:{between:'small'}},LoadindData,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */],expanded:expandHDFSService,isDefault:true,type:'Storage',servers:serverList.storage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Scality',expanded:expandScalityService,isDefault:false,type:'Storage',servers:serverList.storage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Weka',expanded:expandWekaService,isDefault:false,type:'Storage',servers:serverList.storage}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Database'},temp),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Streaming'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Spark Streaming',type:'Streaming',expanded:expandSparkService,isDefault:true,servers:serverList.streaming}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Kafka',type:'Streaming',expanded:expandKafkaService,isDefault:false,servers:serverList.streaming}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Flink',type:'Streaming',expanded:expandFlinkService,isDefault:false,servers:serverList.streaming}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Storm',type:'Streaming',expanded:expandStormService,isDefault:false,servers:serverList.streaming}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Analytics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Yarn',expanded:expandYarnService,isDefault:true,type:'Analytics'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Spark',expanded:expandAnalyticsSparkService,isDefault:false,type:'Analytics'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'AI'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'Tensorflow',type:'AI',expanded:expandTensorflowService,isDefault:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'PyTorch',type:'AI',expanded:expandPyTorchService,isDefault:false}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'IoT'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Accordion__["a" /* default */],{title:'MiNifi',type:'IoT',expanded:expandMiNifiService,isDefault:false}))))));}}]);return Functions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isLoading:state.sizerWorkload.isLoading,workload:state.sizerWorkload.workload,activeSession:state.sessions.activeSession,defaultSizerWorkload:state.sizerWorkload,iterationvalue:state.sizerWorkload.iterationCount,country:state.sessions.Country,// Selected country is not updated in the workload. - By Aditya
sessionsDefaults:state.sessions.sessionDefaults// SelectedService:state.sizerWorkload.title,
//SelectedService:state.sessions.activeSession.title,
};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{// OnFetchDefaults:()=>{
//     dispatch(fetchDefaults());
//   },
OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__State_actions_sessions__["W" /* toggleSizeButton */])(value));},OnDefaultFetchServerList:function OnDefaultFetchServerList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__Redux_actions_epaActions__["f" /* defaultfetchServerList */])(value));},OnIterationCountIncrease:function OnIterationCountIncrease(value){dispatch({type:'ITERATION_INCREASE',payload:value});},onUpdateDefaultSession:function onUpdateDefaultSession(inputs){dispatch({type:'UPDATE_SESSION_DEFAULTS',payload:inputs});},GetExtraNodesQty:function GetExtraNodesQty(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__Redux_actions_epaActions__["q" /* getextranodesqty */])(value));}// SelectedServericeValue:(value)=>{
//     dispatch({type:'SELECTED_SERVICE_VALUE',payload:value})
// }
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Functions));

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_FormCheckmark__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_FormCheckmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_FormCheckmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Serverconfig__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commonLogic__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Anchor from 'grommet/components/Anchor';
var onBluedatachangebox=false;var ProcorDiskValue=null;var StroageNodeQtyCall=false;var DatabaseDatadiskChange=false;var defaultNodevalueChange=true;var HDFS_Change="";var Scality_Change="";var Weka_Change="";var Hive_Change="";var Cassandra_change="";var Impala_Change="";var HBase_Change="";var SparkStreaming_Change="";var Kafka_Change="";var Flink_Change="";var Storm_Change="";var Yarn_Change="";var Spark_Change="";var TensorFlow_Change="";var Py_Torch_Change="";var MiNifi_Change="";var serverValue=void 0,datadisktypValue=void 0;var inputs={function:"",service:""};var isMixedStorageConfiguration="";var AIConfigtypevalue="";var AI="AI";var GPUvalue="";//let EeasuredisabledHDFS=false
var Accordion=function(_Component){_inherits(Accordion,_Component);function Accordion(){_classCallCheck(this,Accordion);var _this=_possibleConstructorReturn(this,(Accordion.__proto__||Object.getPrototypeOf(Accordion)).call(this));_this.resetChangesToEmpty=function(){HDFS_Change="";Scality_Change="";Weka_Change="";Hive_Change="";Cassandra_change="";Impala_Change="";HBase_Change="";SparkStreaming_Change="";Kafka_Change="";Flink_Change="";Storm_Change="";Yarn_Change="";Spark_Change="";TensorFlow_Change="";Py_Torch_Change="";MiNifi_Change="";};_this.onWorkloadUpdate=function(type,title,tag){//this.props.SelectedService.value=title
_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===title){// service['@Selected']=this.props.isSelected;
var disksQtyinpayload=[];var existingDrivesArray=[];var Arg0=void 0,Arg1=void 0,Arg2=void 0;var earasure=false;var Databasedrives=[];Databasedrives.push(service.Hardware['@DataDisk']);var DatabaseandAnalyticsDiskQtyChange="";if(service['@Selected']==="true"){if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0]["@mixedStorage"];existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks;}else{isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service["@mixedStorage"];existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks;}if(isMixedStorageConfiguration==="True"){disksQtyinpayload=service.DataDisks;}var Inputs={};switch(_this.props.type){case'Storage':if(_this.props.title==="Weka"){Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"SKUInfo":service.Inputs['@SKUInfo'],"strServer":service.Hardware['@Server'],"strDriveClass":service.Inputs['@DriveClass'],"PeakReadIO":parseFloat(service.Inputs['@PeakReadIOPS']),"PeakWriteIO":parseFloat(service.Inputs['@PeakWriteIOPS']),"PeakReadBW":parseFloat(service.Inputs['@PeakReadBW']),"PeakWriteBW":parseFloat(service.Inputs['@PeakWriteBW']),"dUsableCapacity":parseFloat(service.Inputs['@Capacity'])};}else if(_this.props.title==="Scality"){Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"isGreenLake":service.Inputs['@GreenLake'],"strServer":service.Hardware['@Server'],"strDataDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"iDiskQty":parseFloat(service.Hardware['@DiskQty']),"dUsableCapacity":parseFloat(service.Inputs['@Capacity']),"dStoragePerc":parseFloat(service.Inputs['@StoragePerc']),"strSite":service.Inputs['@NoOfSites'],"strReplication":service.Inputs['@Replication']};}else{Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"Server":service.Hardware['@Server'],"dRawCapacity":parseFloat(service.Inputs['@Capacity']),"strDataDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"strCapacityType":service.Inputs['@Type'],"dReplication":parseFloat(service.Inputs['@Replication']),"dCompression":parseFloat(service.Inputs['@Compression']),"dOverhead":parseFloat(service.Inputs['@OverHead']),"bErasureCode":earasure,//"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
"dData":parseFloat(service.Inputs['@ErasureData']),"dParity":parseFloat(service.Inputs['@ErasureParity']),"iDiskQty":parseFloat(service.Hardware['@DiskQty'])};}break;case'Streaming':Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"Server":service.Hardware['@Server'],"dMessPerSec":parseFloat(service.Inputs['@MessagesPerSec'])};break;case'Database':Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"Server":service.Hardware['@Server'],"SelectedDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"DBSize":parseFloat(service.Inputs['@Capacity']),"dNodeStorage":parseFloat(service.Inputs['@NodeStorage']),"dQueriesPerMinute":parseFloat(service.Inputs['@OpsPerSec']),"lstDataDrives":Databasedrives,//"lstDataDrives":service.Hardware['@DataDisk'],
"iDataDiskQty":parseInt(service.Hardware['@DiskQty'],10),"bIsDiskChanged":true,"strProcessor":service.Hardware['@Proc'],"strCompChanged":ProcorDiskValue//"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
};break;case'AI':Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"strServer":service.Hardware['@Server'],"strConfigType":AIConfigtypevalue,"iGPUQty":"","dImagesPerSec":parseFloat(service.Inputs['@ImagesPerSec']),"strGPUSelected":service.Inputs['@GPU']};break;case'Analytics':Inputs={"strFunc":_this.props.type,"strService":_this.props.title,"strConfigType":service.Inputs['@ConfigType'],"arg0":Arg0,"arg1":Arg1,"arg2":Arg2,"strServer":service.Hardware['@Server'],"strDataDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"dNodeStorage":parseFloat(service.Inputs['@NodeStorage']),"lstDataDrives":Databasedrives,//"lstDataDrives":service.Hardware['@DataDisk'],
"iDataDiskQty":parseInt(service.Hardware['@DiskQty'],10),"bIsDiskChanged":DatabaseandAnalyticsDiskQtyChange,"strMemory":service.Hardware['@Memory'],"strProcessor":service.Hardware['@Proc'],"strCompChanged":ProcorDiskValue//"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
};break;}_this.props.OnFetchNodeQty(Inputs);}}});}}});};_this.state={title:'',toggle:'',isSelected:'',isBlueDataSelected:'',isErasureChkboxHDFSSelected:false,isErasureChkboxMAPRSelected:false};_this.onBlueDataChange=_this.onBlueDataChange.bind(_this);_this.onToggle=_this.onToggle.bind(_this);_this.onAddServiceChange=_this.onAddServiceChange.bind(_this);// this.isDefault=this.isDefault.bind(this);
return _this;}_createClass(Accordion,[{key:'onAddServiceChange',value:function onAddServiceChange(e){var _this2=this;// var flag=false;
// if(this.state.isSelected===false){
//     flag=true;
// }
//this.props.SelectedService.value=this.props.title;
var _isSelected;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this2.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this2.props.title){if(service['@Selected']===true||service['@Selected']==="true"){_isSelected=false;service['@Selected']="false";}else{_isSelected=true;service['@Selected']=__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_210" /* tRUE_ */];if(service['@Type']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]&&service.Inputs['@Type']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_144" /* RAW_ */]){service.Inputs['@ErasureCoding']=__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];// EeasuredisabledHDFS=true;
}}}});}else{if(val.Service['@Selected']===true||val.Service['@Selected']==="true"){_isSelected=false;val.Service['@Selected']="false";}else{_isSelected=true;val.Service['@Selected']="true";}}}});var inputs={function:this.props.type,service:this.props.title// this.props.OnFetchServerList(inputs);
};var pushservice=true;if(this.props.defaultSizerWorkload.serversList.length==0){this.props.OnFetchServerList(inputs);}else{this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this2.props.title){pushservice=false;}});if(pushservice){this.props.OnFetchServerList(inputs);}}///////
var AddServiceLayer=true;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Selected']==="true"&&val['@Type']!=="Gateway Node"&&val['@Type']!=="Master Node"){AddServiceLayer=false;}});}else{if(val.Service['@Selected']==="true"&&val['@Type']!=="Gateway Node"&&val['@Type']!=="Master Node"){AddServiceLayer=false;}}});if(AddServiceLayer){var value={isError:true,errorMsg:'    Please select atleast one Service '};this.props.updateError(value);}else{if(this.props.GlobalErr.isError){var _value={isError:false,errorMsg:''};this.props.updateError(_value);}// let value = {
//     isError: false, errorMsg: ''
// }
}// this.props.updateError(value);
///////  
//}
Object(__WEBPACK_IMPORTED_MODULE_16__commonLogic__["n" /* updateMasterandGatewayServices */])(this.props.workload);if(_isSelected){var Inputs={};var flagHDFS=false;if(!this.state.isErasureChkboxHDFSSelected||this.state.isErasureChkboxHDFSSelected==="false"){flagHDFS=true;}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this2.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this2.props.title){if(service['@Selected']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){if(service['@Type']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){service.Inputs['@ErasureCoding']=flagHDFS.toString();Inputs={"strFunc":_this2.props.type,"strService":_this2.props.title,"Server":service.Hardware['@Server'],"dRawCapacity":parseFloat(service.Inputs['@Capacity']),"strDataDisk":service.Hardware['@DataDisk'],"strCapacityType":service.Inputs['@Type'],"dReplication":parseFloat(service.Inputs['@Replication']),"dCompression":parseFloat(service.Inputs['@Compression']),"dOverhead":parseFloat(service.Inputs['@OverHead']),"bErasureCode":service.Inputs['@ErasureCoding'],//"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
"dData":parseFloat(service.Inputs['@ErasureData']),"dParity":parseFloat(service.Inputs['@ErasureParity']),"iDiskQty":parseFloat(service.Hardware['@DiskQty'])};}}}});}}});this.resetChangesToEmpty();datadisktypValue=e.value;StroageNodeQtyCall=true;if(this.props.type==="Analytics"||this.props.type==="Database"){ProcorDiskValue="Disk Changed";DatabaseDatadiskChange=true;}defaultNodevalueChange=true;this.props.defaultSizerWorkload.serversList.map(function(ServiceName){_this2.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val.Service['@Type']===_this2.props.title){if(val.Service['@Selected']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){datadisktypValue=val.Service.Hardware['@DataDisk'];serverValue=val.Service.Hardware['@Server'];}}});});var OSInputs={"strFunction":this.props.type,"strService":this.props.title,"strServer":serverValue,"strDataDisk":datadisktypValue};this.props.OnGetOSDiskList(OSInputs);this.onWorkloadUpdate(this.props.type,this.props.title,"datadisktypValue");}this.setState({isSelected:_isSelected});//this.setState({})
}},{key:'onToggle',value:function onToggle(){var temp=this.state.toggle;this.setState({toggle:!temp});}},{key:'onisErasureChkboxMAPRSelectedChange',value:function onisErasureChkboxMAPRSelectedChange(e){var _this3=this;var flagMAPR=false;if(!this.state.isErasureChkboxMAPRSelected||this.state.isErasureChkboxMAPRSelected==="false"){flagMAPR=true;}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this3.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this3.props.title){if(service['@Selected']==="true"){if(service['@Type']==="MapR and MapR-EC"){service.Inputs['@ErasureCoding']=flagMAPR.toString();}}}});}}});this.setState({isErasureChkboxMAPRSelected:flagMAPR});}},{key:'onisErasureChkboxHDFSSelectedChange',value:function onisErasureChkboxHDFSSelectedChange(e){var _this4=this;var Inputs={};var flagHDFS=false;if(!this.state.isErasureChkboxHDFSSelected||this.state.isErasureChkboxHDFSSelected==="false"){flagHDFS=true;}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this4.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this4.props.title){if(service['@Selected']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_210" /* tRUE_ */]){if(service['@Type']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){service.Inputs['@ErasureCoding']=flagHDFS.toString();Inputs={"strFunc":_this4.props.type,"strService":_this4.props.title,"Server":service.Hardware['@Server'],"dRawCapacity":parseFloat(service.Inputs['@Capacity']),"strDataDisk":service.Hardware['@DataDisk'],"strCapacityType":service.Inputs['@Type'],"dReplication":parseFloat(service.Inputs['@Replication']),"dCompression":parseFloat(service.Inputs['@Compression']),"dOverhead":parseFloat(service.Inputs['@OverHead']),"bErasureCode":service.Inputs['@ErasureCoding'],//"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
"dData":parseFloat(service.Inputs['@ErasureData']),"dParity":parseFloat(service.Inputs['@ErasureParity']),"iDiskQty":parseFloat(service.Hardware['@DiskQty'])};}}}});}}});this.props.OnFetchNodeQty(Inputs);this.setState({isErasureChkboxHDFSSelected:flagHDFS});}},{key:'onBlueDataChange',value:function onBlueDataChange(){var _this5=this;// onBluedatachangebox = true
// if(this.state.isBlueDataSelected){
//     this.state.isBlueDataSelected=false;
// }else{
//     this.state.isBlueDataSelected=true;
// }
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this5.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this5.props.title){if(service['@Selected']==="true"){onBluedatachangebox=true;}else{onBluedatachangebox=false;}}});}else{if(val.Service['@Type']===_this5.props.title){if(val.Service['@Selected']==="true"){onBluedatachangebox=true;}else{onBluedatachangebox=false;}}}}});this.setState({});}},{key:'componentDidMount',value:function componentDidMount(){var _this6=this;var _toggle=this.props.expanded;var _isSelected;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this6.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this6.props.title){if(service['@Selected']===true||service['@Selected']==="true"){_isSelected=true;}else{_isSelected=false;}}});}else{if(val.Service['@Type']===_this6.props.title){if(val.Service['@Selected']===true||val.Service['@Selected']==="true"){_isSelected=true;}else{_isSelected=false;}}}}});//  var Iputs={
//      DefaultData:[
//         {
//         "function": "Storage",
//         "service": "HDFS"
//         },
//         {
//         "function": "Database",
//         "service": "Hive"
//         },
//          {
//         "function": "Streaming",
//         "service": "Spark Streaming"
//         },
//          {
//         "function": "Analytics",
//         "service": "Yarn"
//         },
//          {
//         "function": "AI",
//         "service": "Tensorflow"
//         },
//          {
//         "function": "IoT",
//         "service": "MiNifi"
//         }
//     ]
//  }
//  if(this.props.defaultSizerWorkload.serversList.length == 0)
//  {
//     this.props.OnDefaultFetchServerList(Iputs);
//  }
this.setState({toggle:_toggle});this.setState({isSelected:_isSelected});//this.setState({})
}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(nextProps.title!==this.props.title){var _toggle=nextProps.expanded;var _isSelected;// if (nextProps.isDefault==='true') {
//     _isSelected = true;
// }
// else
//     _isSelected = false;
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===nextProps.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===nextProps.title){if(service['@Selected']===true||service['@Selected']==="true"){_isSelected=true;}else{_isSelected=false;}}});}else{if(val.Service['@Type']===nextProps.title){if(val.Service['@Selected']===true||val.Service['@Selected']==="true"){_isSelected=true;}else{_isSelected=false;}}}}});this.setState({toggle:_toggle});this.setState({isSelected:_isSelected});}}},{key:'render',value:function render(){var _this7=this;/* Changes by Vinay, added this.props.workload != null && this.props.workload != undefined condition , for CID:10644*/if(this.props.workload!=null&&this.props.workload!=undefined&&this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){var LoadindData="";if(this.props.isLoading){LoadindData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},'Please wait while fetching the data.')));}inputs.function=this.props.tabtitle;inputs.service=this.props.title;if(this.props.workload!=null&&this.props.workload!=undefined){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this7.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this7.props.title){if(service['@Selected']==="true"){if(onBluedatachangebox){if(_this7.state.isBlueDataSelected){_this7.state.isBlueDataSelected=false;service.Inputs['@BlueData']="false";}else{_this7.state.isBlueDataSelected=true;service.Inputs['@BlueData']="true";}onBluedatachangebox=false;}else{if(service.Inputs['@BlueData']==="true"){_this7.state.isBlueDataSelected=true;}else{_this7.state.isBlueDataSelected=false;}}if(service['@Type']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){_this7.state.isErasureChkboxHDFSSelected=/true/i.test(service.Inputs['@ErasureCoding']);}else if(service['@Type']==="MapR and MapR-EC"){_this7.state.isErasureChkboxMAPRSelected=/true/i.test(service.Inputs['@ErasureCoding']);}//this.state.isBlueDataSelected=service.Storage['@BlueData'];
}else{_this7.state.isBlueDataSelected=false;if(service['@Type']===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){_this7.state.isErasureChkboxHDFSSelected=false;}else if(service['@Type']==="MapR and MapR-EC"){_this7.state.isErasureChkboxMAPRSelected=false;}}}});}else{if(val.Service['@Type']===_this7.props.title){// if(this.state.isSelected===true){
//      val.Service['@Selected']="true";
// }else{
//      val.Service['@Selected']="false";
// }
if(val.Service['@Selected']==="true"){if(onBluedatachangebox){if(_this7.state.isBlueDataSelected){_this7.state.isBlueDataSelected=false;val.Service.Inputs['@BlueData']="false";}else{_this7.state.isBlueDataSelected=true;val.Service.Inputs['@BlueData']="true";}onBluedatachangebox=false;}else{if(val.Service.Inputs['@BlueData']==="true"){_this7.state.isBlueDataSelected=true;}else{_this7.state.isBlueDataSelected=false;}}}else{_this7.state.isBlueDataSelected=false;}}}}});//        this.props. workload.UserInputs.Environments.Functions.Function.filter((val)=>{
//       if(val['@Type']=== this.props.type)
//       {
//          if(Array.isArray(val.Service))
//         {
//              val.Service.filter((service)=>{
//               if(service['@Type']===this.props.title)
//               {
//                 //service['@Selected']=this.props.isSelected;
//                 if( service['@Selected']){
//                   service['@Selected']="true"
//                 }else{
//                   service['@Selected']="false"
//                 }
//               }
//              })
//             }
//           }
//   })
}var ErasureChkboxHDFS="";var ErasureChkboxMAPR="";var EeasuredisabledHDFS=false;var EeasuredisabledMAPR=false;//this.props.defaultSizerWorkload.StorageCapacitytype.HDFS==="Raw"
if(this.props.title===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]&&this.props.workload.UserInputs.Environments.Functions.Function[0]["Service"][0]['Inputs']['@Type']==="Raw"){EeasuredisabledHDFS=true;this.state.isErasureChkboxHDFSSelected=false;}if(this.props.title==="MapR and MapR-EC"&&this.props.defaultSizerWorkload.StorageCapacitytype.MAPR==="Raw"){EeasuredisabledMAPR=true;this.state.isErasureChkboxMAPRSelected=false;}if(this.props.title===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_7" /* DATA_LAKE */]){ErasureChkboxHDFS=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox___default.a,{label:'Erasure Coding',disabled:EeasuredisabledHDFS,checked:this.state.isErasureChkboxHDFSSelected,onChange:function onChange(e){return _this7.onisErasureChkboxHDFSSelectedChange(e);}});}if(this.props.title==="MapR and MapR-EC"){ErasureChkboxMAPR=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox___default.a,{label:'Erasure Coding',disabled:EeasuredisabledMAPR,checked:this.state.isErasureChkboxMAPRSelected,onChange:function onChange(e){return _this7.onisErasureChkboxMAPRSelectedChange(e);}});}var BlueDataChkbox='';if(/*this.props.type !== 'IoT' &&*/this.props.title!=='Scality'&&this.props.title!=='Weka')// if (this.props.type !== 'IoT')
{var BludeDataOptiondisable=true;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this7.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this7.props.title){if(service['@Selected']==="true"){if(__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(service.Hardware['@Server'])!==-1||service.Hardware['@Server'].indexOf(__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_14" /* E910 */])!==-1||service.Hardware['@Server'].indexOf(__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_16" /* EL4000 */])!==-1){BludeDataOptiondisable=false;}else{BludeDataOptiondisable=true;_this7.state.isBlueDataSelected=false;service.Inputs['@BlueData']="false";}}else{}}});}else{if(__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_53" /* HPECP_SUPPORTED_SERVERS_LIST */].indexOf(val.Service.Hardware['@Server'])!==-1||val.Service.Hardware['@ServerName'].indexOf(__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_14" /* E910 */])!==-1||val.Service.Hardware['@ServerName'].indexOf(__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_16" /* EL4000 */])!==-1){BludeDataOptiondisable=false;}else{BludeDataOptiondisable=true;_this7.state.isBlueDataSelected=false;val.Service.Inputs['@BlueData']="false";}}}});BlueDataChkbox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{style:{margin:"3px"}},'HPE Ezmeral CP Option'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_71" /* HPE_Ezmeral_CP_Option */],'data-for':__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_23" /* EZMERAL_CP_OPTION */],colorIndex:'accent-3',style:{width:"20px",height:"20px",margin:'3px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_tooltip___default.a,{place:'left',multiline:true,type:'dark',effect:'solid',id:__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_23" /* EZMERAL_CP_OPTION */]}))),disabled:BludeDataOptiondisable,checked:this.state.isBlueDataSelected,onChange:this.onBlueDataChange.bind(this)});// BlueDataChkbox = <CheckBox label='BlueData Option' disabled={BludeDataOptiondisable}checked={this.state.isBlueDataSelected} onChange={this.onBlueDataChange.bind(this)} />
}var bodycontent='';if(this.state.toggle){bodycontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',pad:'small',colorIndex:'light-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Serverconfig__["a" /* default */],{supportedList:this.props.servers,isSelected:this.state.isSelected,OSListChanged:this.state.isSelected,type:this.props.type,title:this.props.title,erasureHDFS:this.state.isErasureChkboxHDFSSelected,erasureMAPR:this.state.isErasureChkboxMAPRSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{height:"50%"},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_CheckBox___default.a,{checked:this.state.isSelected,label:'Add Service',onChange:this.onAddServiceChange//     () => {
//     var temp = this.state.isSelected;
// enter={{ "animation": "slide-down", "duration": 200, "delay": 0 }} 
//     if(temp)
//     {                                        
//     this.props.OnFetchServerList({                                    
//                     function:this.props.type,
//                     service:this.props.title                                                           
//                     });
//     }
//     this.setState({ isSelected: !temp });
// } }   
}),ErasureChkboxHDFS,ErasureChkboxMAPR,BlueDataChkbox));}}//BlueData Licenses 
if(this.props.workload.UserInputs.Environments.WorkloadType==='BigData'){var EnableEPICandAI=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(Array.isArray(val.Service)){val.Service.filter(function(services){if(services["@Selected"]==="true"){if(services.Inputs["@BlueData"]=="true"){EnableEPICandAI=true;}}});}else{if(val.Service["@Selected"]==="true"){if(val.Service.Inputs!==undefined&&val.Service.Inputs["@BlueData"]=="true"){EnableEPICandAI=true;}}}});if(!EnableEPICandAI){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined&&Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)){this.props.workload.UserInputs.Environments.HadoopServices['Installation']="false";var hpecpLicense=this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_58" /* HPE_CONTAINER_PLATFORM */];});if(hpecpLicense){hpecpLicense['@Description']=__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_109" /* NONE_ */];hpecpLicense['@IsSelected']=__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];}this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@Description']=__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_109" /* NONE_ */];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["r" /* BLUEDATA_AI */];})['@IsSelected']=__WEBPACK_IMPORTED_MODULE_17__Redux_action_types_EPAConstants__["_204" /* fALSE_ */];this.props.workload.UserInputs.Environments.HadoopServices['AppStore']="false";this.props.workload.UserInputs.Environments.HadoopServices.SingleImage['#text']="false";this.props.workload.UserInputs.Environments.HadoopServices.CustomImage['#text']="false";this.props.workload.UserInputs.Environments.HadoopServices['Deployment']="false";}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{colorIndex:'unknown',style:{padding:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',style:{padding:'5px'},justify:'between',onClick:this.onToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:this.props.id,direction:'row',pad:{between:'small'}},this.state.toggle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormUp___default.a,{size:'small'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_icons_base_FormDown___default.a,{size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',margin:'none',strong:true,style:{fontSize:'15px'}},' ',this.props.title,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row'},this.state.isSelected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_FormCheckmark___default.a,{colorIndex:'brand'}):'')),LoadindData,bodycontent);}}]);return Accordion;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{workload:state.sizerWorkload.workload,defaultSizerWorkload:state.sizerWorkload,isLoading:state.sizerWorkload.isLoading,//SelectedService:state.sizerWorkload.title,
// SelectedService:state.sessions.activeSession.title,
GlobalErr:state.sessions.activeSession.globalError//Functions:state.sizerWorkload.workload.WorkLoad.UserInputs.Environments.Functions,
// activeSession: state.sessions.activeSession,
//supportedList:state.sizerWorkload.supportedList,
//isLoading:state.sizerWorkload.isLoading,
//sessionsDefaults:state.sessions.sessionDefaults    
};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnFetchServerList:function OnFetchServerList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["k" /* fetchServerList */])(value));},OnDefaultFetchServerList:function OnDefaultFetchServerList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["f" /* defaultfetchServerList */])(value));},OnFetchNodeQty:function OnFetchNodeQty(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["j" /* fetchNodeQty */])(value));},OnGetOSDiskList:function OnGetOSDiskList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["r" /* getosdisklist */])(value));},updateError:function updateError(errorMsg){dispatch(Object(__WEBPACK_IMPORTED_MODULE_15__State_actions_sessions__["p" /* errorValidataion */])(errorMsg));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Accordion));

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Trash__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_es7_array__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_es7_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_es7_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_es7_object__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_es7_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_es7_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Datafiles_EPAvNextInput_json__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Datafiles_EPAvNextInput_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__Datafiles_EPAvNextInput_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonLogic__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__DataDrive_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import dataDriveOptions from '../../Datafiles/DataDrive.js';
var diskcapacityvalue="",capacitytypevalue="",ensurecodngdata="",ensurecodngparity="",overhead="",compression="",strgwrkload="";var replicationvalue="";//HardWare Selection variables
var procQuantity=void 0;var serverValue=void 0,processorValue=void 0,memoryValue=void 0,pocQtyValue=void 0,noOfDiskValue=void 0,noOfOSDiskValue=void 0,datadisktypValue=void 0,osdisktypValue=void 0,nodesQtyValue=void 0;var processorTypeValue=void 0;var nodeValue=void 0;var procValue=void 0;//Sizer recommendation variables
var SizerRecmdtnProcsr=void 0,SizerRecmdtnServer=void 0,SizerRecmdtnDisktype=void 0,SizerRecmdtnMemory=void 0;//Scality
var GreenLakevalue=void 0,GreenLakeoptions=void 0,Sitesvalue=void 0,Secondsitevalue=void 0,Secondsiteoptions=void 0,ARCvalue=void 0,Scalitydiskcapacityvalue=void 0,NetworkSwitchvalue=void 0,NetworkSwitchoptions=void 0,Quantityvalue=void 0,Quantityoptions=void 0;var MessagesPerSec=void 0,Sitesvalueoptions=void 0;var GPUQty=void 0,ImagesPerSec=void 0;var EventsPerSec=void 0;var AIConfigtypevalue="";var GPUvalue="";var GPUsOptions=[];var Analyticsvalue=void 0,Ansdiskcapacityvalue=void 0,ContainersQty=void 0,CoresPerContainer=void 0,MemoryPerContainer=void 0,NodelocalStorageValue=void 0,StorageNodesQty=void 0,Storagevalue=void 0,StorageOptions=void 0;var Storagevalue1=void 0,Storagevalue1disabled=void 0,Storagevalue2=void 0,Storagevalue2disabled=void 0;var StoragePerc=void 0;var QueryData=void 0,ResponseTime=void 0,ConcurrentQueries=void 0;//let DatabaseUsablecapacity;
var Servers=[];var Drives=[];var MemoryList=[];var OSDiskList=[];var ProcList=[];var ProcFamilyList=[];var StroageNodeQtyCall=false;var AnalyticsandDatabaseNodeQtyCall=false;var forRawdisabled=false;var defaultNodevalue='';var defaultNodevalueChange=true;var DriveClassChanged=false;var IDatadiskqtynotchange=false;var IOSDatadiskqtynotchange=true;var maxlayer=false;var maxlayerSecondServices=false;var maxlayerthirdServices=false;var maxlayerFourthServices=false;var MaxDriveQty='';var maxDrivesSupported='';var EducationCustomeroptions=void 0,Addserversoptions=void 0,SKUInformationList=void 0;var DIMMCapacity=void 0,DATADriveCapacity=void 0,DATADrivePerServer=void 0,SpareServers=void 0,NumServers=void 0;var DatabaseDatadiskChange=false;var DataDiskQtyChange=false;var ProcorDiskValue=null;var FirstServer=true;var recommDrive=true;var recommOSDisk=true;var recommProc=true;// let ProcessorChanged=false;
// let DataDiskChanged=false;
//Weka
var Addservers=void 0,SKUInformationValue=void 0,OSEnvironment=void 0,SupportYearCount=void 0,EducationCustomer=void 0,NetworkType=void 0,capacityrequired=void 0,ServerType=void 0,DriveClassValue=void 0;var Peakreadiops=void 0,Peakwriteiops=void 0,Totalusablestorage=void 0,Peakreadbandwdth=void 0,Peakwritebandwdth=void 0,NetworkTypeoptions=void 0,SupportYearCountoptions=void 0,OSEnvironmentoptions=void 0;var DATADrivePerServeroptions=void 0,SpareServersoptions=void 0,DIMMCapacityoptions=void 0;var DATADriveCapacityoptions=[];var DriveClassList=[];var SparkSynergyServerChanged=false;var KafkaSynergyServerChanged=false;var FlinkSynergyServerChanged=false;var StormSynergyServerChanged=false;var YarnSynergyServerChanged=false;var HiveSynergyServerChanged=false;var CassandraSynergyServerChanged=false;var ImpalaSynergyServerChanged=false;var HBaseSynergyServerChanged=false;var SynergyServerChanged=false;var SparkAnalyticsSynergyServerChanged=false;var ShowHiveLayer=false;var HDFS_Change="";var Scality_Change="";var Weka_Change="";var Hive_Change="";var Cassandra_change="";var Impala_Change="";var HBase_Change="";var SparkStreaming_Change="";var Kafka_Change="";var Flink_Change="";var Storm_Change="";var Yarn_Change="";var Spark_Change="";var TensorFlow_Change="";var Py_Torch_Change="";var MiNifi_Change="";var _noteTextOnChangeOfConfiguration="";var noteTextOnChangeOfConfigurationScality=" ";var noteTextOnChangeOfConfigurationPyTorch="";var noteTextOnChangeOfConfigurationWeka="";var noteTextOnChangeOfConfigurationHive="";var noteTextOnChangeOfConfigurationCassandra="";var noteTextOnChangeOfConfigurationImpala="";var noteTextOnChangeOfConfigurationHBase="";var noteTextOnChangeOfConfigurationSparkStreaming="";var noteTextOnChangeOfConfigurationKafka="";var noteTextOnChangeOfConfigurationFlink="";var noteTextOnChangeOfConfigurationStorm="";var noteTextOnChangeOfConfigurationYarn="";var noteTextOnChangeOfConfigurationSpark="";var noteTextOnChangeOfConfigurationTensorflow="";var noteTextOnChangeOfConfigurationMiNifi="";var OPSminvalue='';var editExisting=false;var isMixedStorageConfiguration="";var serverChangeConfirmationlayer="";var validCombination=true;var proLiantDL360Gen10="ProLiant DL360 Gen10";var training="Training";var INFERENCE="Inference";var CASCADELAKE="Cascade Lake";var AI="AI";var NA_="NA";var onChangeTriggered=false;var Serverconfig=function(_Component){_inherits(Serverconfig,_Component);function Serverconfig(){_classCallCheck(this,Serverconfig);var _this=_possibleConstructorReturn(this,(Serverconfig.__proto__||Object.getPrototypeOf(Serverconfig)).call(this));_this.onDatadriveTypeChange=function(e){_this.resetChangesToEmpty();if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware["@dataDriveType"]=e.option;}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@dataDriveType"]=e.option;}_this.state.dataDriveType=e.option;_this.populateDataDriveoptions();if(Drives.indexOf(datadisktypValue)===-1){datadisktypValue=Drives[0];if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware["@DataDisk"]=datadisktypValue;}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@DataDisk"]=datadisktypValue;}}StroageNodeQtyCall=true;_this.updateDriveQuantity();_this.onWorkloadUpdate(_this.props.type,_this.props.title,"noOfDiskValue");_this.setState({});};_this.updateDriveQuantity=function(){noOfDiskValue=_this.noOfDrivesleft("").toString();if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware["@DiskQty"]=noOfDiskValue;}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@DiskQty"]=noOfDiskValue;}};_this.renderTable=function(){var tableData=[];var tableDataArray="";if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){tableDataArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks;}else{tableDataArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks;}if(Array.isArray(tableDataArray)){tableDataArray.map(function(dataDrive,id){tableData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,dataDrive.Item["@disk"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:dataDrive.Item["@qty"],onDOMChange:function onDOMChange(e){return _this.onNoOfDisksChange(e,_this.props.type,_this.props.title,"Change",true,id);},onBlur:function onBlur(e){return _this.onNoOfDisksChange(e,_this.props.type,_this.props.title,"Blur",true,id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Trash___default.a,{primary:true,onClick:function onClick(){return _this.deleteDrive(id);}}))));});}return tableData;};_this.onAddingDataDisk=function(){if(noOfDiskValue!="0"&&datadisktypValue!==undefined){var existingDrivesArray=[];validCombination=true;if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(datadisktypValue.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])!==-1||datadisktypValue.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1)){if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0]["@mixedStorage"];existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks;}else{isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service["@mixedStorage"];existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks;}if(isMixedStorageConfiguration==="True"){var nonNVMeDrives=0;var NVMeDrives=0;var SFFDrives=0;existingDrivesArray.map(function(x){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])===-1&&x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])===-1){nonNVMeDrives+=parseInt(x.Item["@qty"],10);}else if(x.Item["@disk"].indexOf('NVMe')!==-1){NVMeDrives+=parseInt(x.Item["@qty"],10);}else{SFFDrives+=parseInt(x.Item["@qty"],10);}});if(datadisktypValue.indexOf("NVMe")!==-1&&SFFDrives>0){validCombination=false;}else if(datadisktypValue.indexOf("NVMe")===-1&&NVMeDrives>0){validCombination=false;}if(osdisktypValue.indexOf("M.2")!==-1){if(nonNVMeDrives>24){validCombination=false;}}else{if(nonNVMeDrives>22){validCombination=false;}}if(!validCombination){var text="Drive cannot be added as the maximum drives exceeded.";_this.serverChangeConfirmationlayerRoutine(text);}}}if(validCombination){var Hardware="";var diskNumber="";_this.maxDriveCountValidation();if(!maxlayer&&!maxlayerSecondServices&&!maxlayerthirdServices&&!maxlayerFourthServices){if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){Hardware=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware;isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0]["@mixedStorage"];if(isMixedStorageConfiguration!=="True"){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks=[];diskNumber=0;}isMixedStorageConfiguration="True";_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0]["@mixedStorage"]="True";existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks;diskNumber=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks.length;}else{Hardware=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware;isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service["@mixedStorage"];if(isMixedStorageConfiguration!=="True"){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks=[];diskNumber=0;}isMixedStorageConfiguration="True";_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service["@mixedStorage"]="True";existingDrivesArray=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks;diskNumber=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks.length;}var pushDrive=true;if(diskNumber>0){existingDrivesArray.map(function(x){if(x.Item["@disk"]===datadisktypValue){x.Item["@qty"]=(parseInt(x.Item["@qty"],10)+parseInt(noOfDiskValue,10)).toString();pushDrive=false;}});}if(pushDrive){var newDrive={Item:{"@disk":Hardware["@DataDisk"],"@qty":Hardware["@DiskQty"],"@volumeName":"Data_"+diskNumber}};if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks.push(newDrive);}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks.push(newDrive);}}_this.state.changeDriveTypeOptions=true;_this.populateDataDriveoptions();StroageNodeQtyCall=true;_this.onWorkloadUpdate(_this.props.type,_this.props.title,"noOfDiskValue");}_this.updateDriveQuantity();}_this.setState({});}};_this.populateDataDriveoptions=function(){var drivesArray=[];var temp=[];var existingDriveTypes=[];if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.state.dataDriveType=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware["@dataDriveType"];serverValue=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware["@Server"];isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0]["@mixedStorage"];}else{_this.state.dataDriveType=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@dataDriveType"];if(_this.props.type==="IoT"){serverValue=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@ServerName"];}else{serverValue=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@Server"];}isMixedStorageConfiguration=_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service["@mixedStorage"];}if(isMixedStorageConfiguration==="True"){_this.props.defaultSizerWorkload.serversList.filter(function(x){return x['serviceName']===_this.props.title;})[0].totalList[serverValue].DataDiskList.map(function(x){drivesArray.push(x);});var existingDrives=[];if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks.map(function(x){existingDrives.push(x.Item["@disk"]);});}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks.map(function(x){existingDrives.push(x.Item["@disk"]);});}_this.props.defaultSizerWorkload.serversList.filter(function(x){return x['serviceName']===_this.props.title;})[0].totalList[serverValue].DataDiskList.filter(function(x){if(existingDrives.indexOf(x.StrDrive)!==-1){x.Types.map(function(y){if(existingDriveTypes.indexOf(y)===-1){existingDriveTypes.push(y);}});}});if(serverValue!=="HPE Apollo 4200 Gen10 Server"){if(existingDriveTypes.indexOf('LFF HDD')!==-1||existingDriveTypes.indexOf('LFF SSD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('SFF HDD')===-1&&x.Types.indexOf('SFF SSD')===-1){temp.push(x);}});}else if(existingDriveTypes.indexOf('SFF HDD')!==-1||existingDriveTypes.indexOf('SFF SSD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('LFF HDD')===-1&&x.Types.indexOf('LFF HDD')===-1){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}drivesArray=[];drivesArray=temp;temp=[];}if(existingDriveTypes.indexOf('SFF SAS SSD')!==-1||existingDriveTypes.indexOf('SFF SAS HDD')!==-1||existingDriveTypes.indexOf('LFF SAS SSD')!==-1||existingDriveTypes.indexOf('LFF SAS HDD')!==-1||existingDriveTypes.indexOf('NVMe')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('LFF SATA HDD')===-1&&x.Types.indexOf('SFF SATA HDD')===-1){temp.push(x);}else if(existingDriveTypes.indexOf('SFF SAS SSD')===-1&&existingDriveTypes.indexOf('SFF SAS HDD')===-1&&existingDriveTypes.indexOf('LFF SAS SSD')===-1&&existingDriveTypes.indexOf('LFF SAS HDD')===-1&&existingDriveTypes.indexOf('NVMe')!==-1&&serverValue==="HPE Apollo 4200 Gen10 Server"){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}drivesArray=[];drivesArray=temp;temp=[];if(existingDriveTypes.indexOf('SFF SATA HDD')!==-1||existingDriveTypes.indexOf('LFF SATA HDD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('SFF SAS SSD')===-1&&x.Types.indexOf('SFF SAS HDD')===-1&&x.Types.indexOf('LFF SAS SSD')===-1&&x.Types.indexOf('LFF SAS HDD')===-1&&x.Types.indexOf('NVMe')===-1){temp.push(x);}else if(x.Types.indexOf('SFF SAS SSD')===-1&&x.Types.indexOf('SFF SAS HDD')===-1&&x.Types.indexOf('LFF SAS SSD')===-1&&x.Types.indexOf('LFF SAS HDD')===-1&&x.Types.indexOf('NVMe')!==-1&&serverValue==="HPE Apollo 4200 Gen10 Server"){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}drivesArray=[];drivesArray=temp;temp=[];}else{Drives=[];drivesArray=[];_this.props.defaultSizerWorkload.serversList.filter(function(x){return x['serviceName']===_this.props.title;})[0].totalList[serverValue].DataDiskList.map(function(x){drivesArray.push(x);});}if(_this.state.dataDriveConsolidatedOptions.length===0||_this.state.changeDriveTypeOptions){_this.state.changeDriveTypeOptions=false;_this.state.dataDriveConsolidatedOptions=[];drivesArray.map(function(x){x.Types.map(function(y){if(_this.state.dataDriveConsolidatedOptions.indexOf(y)===-1){_this.state.dataDriveConsolidatedOptions.push(y);}});});}if(_this.state.dataDriveType===""){_this.state.dataDriveType=_this.state.dataDriveConsolidatedOptions[0];if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].Hardware["@dataDriveType"]=_this.state.dataDriveType;}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.Hardware["@dataDriveType"]=_this.state.dataDriveType;}}Drives=[];drivesArray.map(function(x){if(x.Types.indexOf(_this.state.dataDriveType)!==-1)Drives.push(x.StrDrive);});};_this.deleteDrive=function(id){if(Array.isArray(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service)){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks.splice(id,1);if(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0].DataDisks.length==0){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this.props.title;})[0]["@mixedStorage"]="False";isMixedStorageConfiguration="False";}}else{_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks.splice(id,1);if(_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service.DataDisks.length==0){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this.props.type;})[0].Service["@mixedStorage"]="False";isMixedStorageConfiguration="False";}}_this.state.changeDriveTypeOptions=true;_this.populateDataDriveoptions();_this.updateDriveQuantity();_this.setState({});};_this.populateGPUOptions=function(){if(serverValue==="ProLiant XL190r Gen10"){GPUsOptions=["V100-PCIE-32GB"];if(processorTypeValue===CASCADELAKE&&AIConfigtypevalue===INFERENCE){GPUsOptions.push("T4-PCIE-16GB");}}else if(serverValue==='ProLiant XL270d Gen10'){GPUsOptions=["V100-PCIE-32GB","V100-SXM2-32GB","V100-SXM2-16GB"];if(processorTypeValue===CASCADELAKE&&AIConfigtypevalue===INFERENCE){GPUsOptions.push("T4-PCIE-16GB");}}else if(_this.props.type==='AI'&&serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_130" /* PROLIANT_DL360_GEN10_PLUS */]){GPUsOptions=["T4-PCIE-16GB"];}else if(_this.props.type==='AI'&&serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_133" /* PROLIANT_DL380_GEN10_PLUS */]){GPUsOptions=['V100-PCIE-32GB'];if(AIConfigtypevalue===INFERENCE){GPUsOptions=["T4-PCIE-16GB"];}}else if(_this.props.type==="AI"&&(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_132" /* PROLIANT_DL380_GEN10 */]||serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_134" /* PROLIANT_DL385_GEN10_PLUS */])){//DL380 Gen10 Supported for AI, GPUs
GPUsOptions=["V100-PCIE-32GB"];}else if(_this.props.type==="AI"&&(serverValue===proLiantDL360Gen10||serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */])){GPUsOptions=["T4-PCIE-16GB"];}else if(_this.props.type==="AI"&&serverValue==='ProLiant DL385 Gen10'){//DL385 Gen10 Supported for AI, GPUs
GPUsOptions=["V100-PCIE-32GB"];}};_this.noOfDrivesleft=function(driveID){var dryqty=0;var maxDrives=0;var noOfExistingDrives=0;var noOfExistingNVMeDrives=0;var arrayorObjectCommonMethod=function arrayorObjectCommonMethod(service,ServiceName){if(service['@Type']===_this.props.title){if(service['@Selected']==="true"){osdisktypValue=service.Hardware['@OSDisk'];if(_this.props.title==="MiNifi"){serverValue=service.Hardware["@ServerName"];}else{serverValue=service.Hardware['@Server'];}if(ServiceName.serviceName===_this.props.title){for(var key in ServiceName.totalList){if(key===serverValue){var currentDrive=service.Hardware["@DataDisk"];if(editExisting&&driveID!==""){currentDrive=service.DataDisks[driveID].Item["@disk"];}if(currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1||serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])!==-1||currentDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){maxDrives=ServiceName.totalList[key].iMaxNVMeDrives;var nonNVMeDrives=0;if(service.DataDisks.length>0&&service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){service.DataDisks.map(function(x,id){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1){if(!(editExisting&&id===driveID)){noOfExistingNVMeDrives+=parseInt(x.Item["@qty"],10);}}else if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])!==-1||x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){if(!(editExisting&&id===driveID)){nonNVMeDrives+=parseInt(x.Item["@qty"],10);}}if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){maxDrives=6;}});}dryqty=maxDrives-noOfExistingNVMeDrives-nonNVMeDrives;}else{maxDrives=ServiceName.totalList[key].iDataDiskQty;if(service.DataDisks.length>0&&service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){service.DataDisks.map(function(x,id){if(serverValue!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(!(editExisting&&id===driveID)){noOfExistingDrives+=parseInt(x.Item["@qty"],10);}}else{if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])===-1&&x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])===-1){if(!(editExisting&&id===driveID)){noOfExistingDrives+=parseInt(x.Item["@qty"],10);}}else{maxDrives=22;}}});}dryqty=maxDrives-noOfExistingDrives;if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&osdisktypValue.indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_103" /* M_2 */])!==-1){dryqty=dryqty+2;}}}}}}}};_this.props.defaultSizerWorkload.serversList.map(function(ServiceName){_this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){arrayorObjectCommonMethod(service,ServiceName);});}else{arrayorObjectCommonMethod(val.Service,ServiceName);}}});});return dryqty;};_this.closeLayer=function(){serverChangeConfirmationlayer="";validCombination=true;_this.setState({});};_this.serverChangeConfirmationlayerRoutine=function(text){serverChangeConfirmationlayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Warning')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){return _this.closeLayer();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,text)));_this.setState({});};_this.pushToServersList=function(key){if(Servers.indexOf(key)===-1){if(_this.props.type==="AI"&&AIConfigtypevalue===training){if(key!==proLiantDL360Gen10&&key!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */]){Servers.push(key);}}else{Servers.push(key);}}};_this.onBlurValidation=function(){if(onChangeTriggered){StroageNodeQtyCall=true;onChangeTriggered=false;}};_this.state={Node:"",NodeQtyvisible:true,HiveServerList:[],capacitytypevalueoptions:['Raw','Usable capacity '],Serverchange:false,dataDriveType:"",dataDriveConsolidatedOptions:[],enableADDButton:true,valueChanged:false,changeDriveTypeOptions:false};_this.onServerChange=_this.onServerChange.bind(_this);_this.onOSDiskChange=_this.onOSDiskChange.bind(_this);_this.onProcessorChange=_this.onProcessorChange.bind(_this);_this.onDataDiskChange=_this.onDataDiskChange.bind(_this);_this.onProcQtyChange=_this.onProcQtyChange.bind(_this);_this.onMemoryChange=_this.onMemoryChange.bind(_this);_this.onNoOfDisksChange=_this.onNoOfDisksChange.bind(_this);_this.onNodevalueChange=_this.onNodevalueChange.bind(_this);_this.onContainersQtyChange=_this.onContainersQtyChange.bind(_this);_this.onCoresPerContainerChange=_this.onCoresPerContainerChange.bind(_this);_this.onMemoryPerContainerChange=_this.onMemoryPerContainerChange.bind(_this);_this.onNodelocalStorageValueChange=_this.onNodelocalStorageValueChange.bind(_this);_this.onAnsdiskcapacityvalue=_this.onAnsdiskcapacityvalue.bind(_this);_this.onStorageNodesQtyChange=_this.onStorageNodesQtyChange.bind(_this);_this.onStorageOptionsChange=_this.onStorageOptionsChange.bind(_this);_this.onStoragevalueCahnge=_this.onStoragevalueCahnge.bind(_this);_this.oncapacitytypevalueChange=_this.oncapacitytypevalueChange.bind(_this);_this.textOnConfigurationChange=_this.textOnConfigurationChange.bind(_this);_this.ChangedValue=_this.ChangedValue.bind(_this);_this.onEnsuredataBlur=_this.onEnsuredataBlur.bind(_this);_this.onEnsureParityBlur=_this.onEnsureParityBlur.bind(_this);_this.onReplicationBlur=_this.onReplicationBlur.bind(_this);_this.resetChangesToEmpty=_this.resetChangesToEmpty.bind(_this);_this.onWorkloadUpdate=_this.onWorkloadUpdate.bind(_this);_this.layerclose=_this.layerclose.bind(_this);_this.noteTextOnChangeOfConfiguration=_this.noteTextOnChangeOfConfiguration.bind(_this);_this.noteContent=_this.noteContent.bind(_this);_this.NodeQtycahnge=_this.NodeQtycahnge.bind(_this);_this.onDiskCapacityChange=_this.onDiskCapacityChange.bind(_this);_this.onReplicationCahnge=_this.onReplicationCahnge.bind(_this);_this.onEnsuredataCahnge=_this.onEnsuredataCahnge.bind(_this);_this.onEnsureParityCahnge=_this.onEnsureParityCahnge.bind(_this);_this.ContainerdisplayChange=_this.ContainerdisplayChange.bind(_this);_this.maxDriveCountValidation=_this.maxDriveCountValidation.bind(_this);return _this;}_createClass(Serverconfig,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;if(this.props.workload!==undefined){if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this2.props.type;})[0].Service)){if(!Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this2.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this2.props.title;})[0].DataDisks)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this2.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this2.props.title;})[0]["@mixedStorage"]="False";}}else{if(!Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this2.props.type;})[0].Service.DataDisks)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this2.props.type;})[0].Service["@mixedStorage"]="False";}}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this3=this;var Hardware="";var diskNumber="";var MixedStorageConfiguration="";if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service)){Hardware=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this3.props.title;})[0].Hardware;diskNumber=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this3.props.title;})[0].DataDisks.length;MixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this3.props.title;})[0]["@mixedStorage"];}else{Hardware=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.Hardware;diskNumber=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.DataDisks.length;MixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service["@mixedStorage"];}if(MixedStorageConfiguration==="False"){var newDrive={Item:{"@disk":Hardware["@DataDisk"],"@qty":Hardware["@DiskQty"],"@volumeName":"Data_0"}};if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this3.props.title;})[0].DataDisks=[];this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this3.props.title;})[0].DataDisks.push(newDrive);}else{this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.DataDisks=[];this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this3.props.type;})[0].Service.DataDisks.push(newDrive);}}}},{key:'ChangedValue',value:function ChangedValue(valueChanged,PreviousValue){switch(valueChanged){case"ProcessorFamily":return"Processor Family("+PreviousValue+")";case"Processor":return"Processor("+PreviousValue+")";case"Processor Qty":return"Processor Quantity";case"Memory":return"Memory("+PreviousValue+")";case"DataDisk":return"Data Disk("+PreviousValue+")";case"OSDisk":return"OS Disk("+PreviousValue+")";case"DataDiskQty":return"Data Disk Quantity("+PreviousValue+")";case"OSDiskQty":return"OS Disk Quantity("+PreviousValue+")";case"NodeQty":return"Node Quantity("+PreviousValue+")";}}},{key:'noteContent',value:function noteContent(Final_Note,Service){var final_note=Final_Note.slice(0,Final_Note.indexOf('#'))+')';var final_text=" ";final_note=final_note.substr(1);if(final_note==="")return"";var text1=final_note.split(",");if(text1.length===1){final_text=text1[0]+" is changed";}else if(text1.length>1){for(var i=0;i<text1.length;i++){if(i==text1.length-2){final_text=final_text+text1[i]+" and ";}else if(i==text1.length-1){final_text=final_text+text1[i]+" are changed";}else{final_text=final_text+text1[i]+", ";}}}switch(Service){case __WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]:_noteTextOnChangeOfConfiguration=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Scality":noteTextOnChangeOfConfigurationScality=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"PyTorch":noteTextOnChangeOfConfigurationPyTorch=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Weka":noteTextOnChangeOfConfigurationWeka=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Hive":noteTextOnChangeOfConfigurationHive=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Cassandra":noteTextOnChangeOfConfigurationCassandra=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Impala":noteTextOnChangeOfConfigurationImpala=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"HBase":noteTextOnChangeOfConfigurationHBase=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Spark Streaming":noteTextOnChangeOfConfigurationSparkStreaming=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Kafka":noteTextOnChangeOfConfigurationKafka=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Flink":noteTextOnChangeOfConfigurationFlink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Storm":noteTextOnChangeOfConfigurationStorm=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Yarn":noteTextOnChangeOfConfigurationYarn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Spark":noteTextOnChangeOfConfigurationSpark=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"Tensorflow":noteTextOnChangeOfConfigurationTensorflow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;case"MiNifi":noteTextOnChangeOfConfigurationMiNifi=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{color:'rgb(255, 141, 109)',fontWeight:'600'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{marginLeft:'1%',marginTop:'27px',color:'rgb(255, 141, 109)',fontWeight:'600',maxWidth:"85%"}},final_text));break;}}},{key:'noteTextOnChangeOfConfiguration',value:function noteTextOnChangeOfConfiguration(Service){var final_Changes=HDFS_Change+Scality_Change+Weka_Change+Hive_Change+Cassandra_change+Impala_Change+HBase_Change+SparkStreaming_Change+Kafka_Change+Flink_Change+Storm_Change+Yarn_Change+Spark_Change+TensorFlow_Change+Py_Torch_Change+MiNifi_Change;final_Changes=final_Changes.substr(1);if(final_Changes===""){_noteTextOnChangeOfConfiguration="";noteTextOnChangeOfConfigurationScality="";noteTextOnChangeOfConfigurationPyTorch="";noteTextOnChangeOfConfigurationWeka="";noteTextOnChangeOfConfigurationHive="";noteTextOnChangeOfConfigurationCassandra="";noteTextOnChangeOfConfigurationImpala="";noteTextOnChangeOfConfigurationHBase="";noteTextOnChangeOfConfigurationSparkStreaming="";noteTextOnChangeOfConfigurationKafka="";noteTextOnChangeOfConfigurationFlink="";noteTextOnChangeOfConfigurationStorm="";noteTextOnChangeOfConfigurationYarn="";noteTextOnChangeOfConfigurationSpark="";noteTextOnChangeOfConfigurationTensorflow="";noteTextOnChangeOfConfigurationMiNifi="";}else{switch(Service){case __WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]:this.noteContent(HDFS_Change,Service);break;case"Scality":this.noteContent(Scality_Change,Service);break;case"PyTorch":this.noteContent(Py_Torch_Change,Service);break;case"Weka":this.noteContent(Weka_Change,Service);break;case"Hive":this.noteContent(Hive_Change,Service);break;case"Cassandra":this.noteContent(Cassandra_change,Service);break;case"Impala":this.noteContent(Impala_Change,Service);break;case"HBase":this.noteContent(HBase_Change,Service);break;case"Spark Streaming":this.noteContent(SparkStreaming_Change,Service);break;case"Kafka":this.noteContent(Kafka_Change,Service);break;case"Flink":this.noteContent(Flink_Change,Service);break;case"Storm":this.noteContent(Storm_Change,Service);break;case"Yarn":this.noteContent(Yarn_Change,Service);break;case"Spark":this.noteContent(Spark_Change,Service);break;case"Tensorflow":this.noteContent(TensorFlow_Change,Service);break;case"MiNifi":this.noteContent(MiNifi_Change,Service);break;}return _noteTextOnChangeOfConfiguration;}}},{key:'textOnConfigurationChange',value:function textOnConfigurationChange(Service,valueChanged,PreviousValue){var result=","+this.ChangedValue(valueChanged,PreviousValue);switch(Service){case __WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]:HDFS_Change=HDFS_Change+result;break;case"Scality":Scality_Change=Scality_Change+result;break;case"Weka":Weka_Change=Weka_Change+result;break;case"Hive":Hive_Change=Hive_Change+result;break;case"Cassandra":Cassandra_change=Cassandra_change+result;;break;case"Impala":Impala_Change=Impala_Change+result;;break;case"HBase":HBase_Change=HBase_Change+result;break;case"Spark Streaming":SparkStreaming_Change=SparkStreaming_Change+result;break;case"Kafka":Kafka_Change=Kafka_Change+result;break;case"Flink":Flink_Change=Flink_Change+result;break;case"Storm":Storm_Change=Storm_Change+result;break;case"Yarn":Yarn_Change=Yarn_Change+result;break;case"Spark":Spark_Change=Spark_Change+result;break;case"Tensorflow":TensorFlow_Change=TensorFlow_Change+result;break;case"PyTorch":Py_Torch_Change=Py_Torch_Change+result;break;case"MiNifi":MiNifi_Change=MiNifi_Change+result;break;}console.log(HDFS_Change);console.log(Scality_Change);console.log(Weka_Change);console.log(Hive_Change);console.log(Cassandra_change);console.log(Impala_Change);console.log(HBase_Change);console.log(SparkStreaming_Change);console.log(Kafka_Change);console.log(Flink_Change);console.log(Storm_Change);console.log(Yarn_Change);console.log(Spark_Change);console.log(TensorFlow_Change);console.log(Py_Torch_Change);console.log(MiNifi_Change);}},{key:'layerclose',value:function layerclose(e){var _this4=this;maxlayer=false;maxlayerSecondServices=false;maxlayerthirdServices=false;maxlayerFourthServices=false;this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this4.props.title&&ServiceName.Servers!==''){_this4.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this4.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this4.props.title){if(service['@Selected']==="true"){for(var key in ServiceName.totalList){if(key===serverValue){//noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
//  service.Hardware['@DiskQty'] = noOfDiskValue
noOfOSDiskValue=ServiceName.totalList[key].iOSDiskQty.toString();service.Hardware['@OSDiskQty']=noOfOSDiskValue;}}}}});}else{if(val.Service['@Type']===_this4.props.title){if(val.Service['@Selected']==="true"){for(var key in ServiceName.totalList){if(key===serverValue){// noOfDiskValue = ServiceName.totalList[key].iDataDiskQty.toString();
// val.Service.Hardware['@DiskQty'] = noOfDiskValue
noOfOSDiskValue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=noOfOSDiskValue;}}}}}}});}});StroageNodeQtyCall=true;this.onWorkloadUpdate(this.props.type,this.props.title,"noOfDiskValue");this.setState({});}},{key:'onAIConfigtypevalueChangeBlur',value:function onAIConfigtypevalueChangeBlur(e){}},{key:'onGPUvalueChangeBlur',value:function onGPUvalueChangeBlur(e){}},{key:'onScalitydiskcapacityvalue',value:function onScalitydiskcapacityvalue(e,type,title){var number=/^[0-9]+$/;if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){Scalitydiskcapacityvalue="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){Scalitydiskcapacityvalue=value.toString();}else{}}this.onWorkloadUpdate(type,title,"Scalitydiskcapacityvalue");}},{key:'onScalitydiskcapacityvalueBlur',value:function onScalitydiskcapacityvalueBlur(e,type,title){var number=/^[0-9]+$/;if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){Scalitydiskcapacityvalue="200";}else if(number.test(value)&&value<=999&&value>=200||isNaN(value)){Scalitydiskcapacityvalue=value.toString();}else{Scalitydiskcapacityvalue="200";}}StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"Scalitydiskcapacityvalue");}},{key:'onGreenLakeChange',value:function onGreenLakeChange(e,type,title){GreenLakevalue=e.value;StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"GreenLakevalue");}},{key:'onSitesvalueChange',value:function onSitesvalueChange(e,type,title){Sitesvalue=e.value;StroageNodeQtyCall=true;defaultNodevalueChange=true;var inputs={"siteName":Sitesvalue};this.props.OnGetARCValue(inputs);this.onWorkloadUpdate(type,title,"Sitesvalue");}},{key:'onSecondsitevalueChange',value:function onSecondsitevalueChange(e,type,title){Secondsitevalue=e.value;StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"Secondsitevalue");}},{key:'onStoragePercChange',value:function onStoragePercChange(e,type,title,netwrkcl){var number=/^[0-9]+$/;if(e.target.value===""){StoragePerc="1";e.target.value=StoragePerc;}if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){StoragePerc="0";}else if(number.test(value)&&value<=100&&value>=1||isNaN(value)){StoragePerc=value.toString();}else{}}if(netwrkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"StoragePerc");}},{key:'onAIConfigtypevalueChange',value:function onAIConfigtypevalueChange(e,type,title){var _this5=this;if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this5.props.type;})[0].Service)){serverValue=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this5.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this5.props.title;})[0].Hardware["@Server"];}else{serverValue=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this5.props.type;})[0].Service.Hardware["@ServerName"];}if((serverValue===proLiantDL360Gen10||serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */])&&e.value===training){var text="The selected configuration type does not support "+serverValue+" server. Please change the server to change the configuration type.";this.serverChangeConfirmationlayerRoutine(text);}else{AIConfigtypevalue=e.value;StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"AIConfigtypevalue");}}},{key:'onGPUvalueChange',value:function onGPUvalueChange(e,type,title){GPUvalue=e.value;StroageNodeQtyCall=true;this.onWorkloadUpdate(type,title,"GPUvalue");}},{key:'oncapacitytypevalueChange',value:function oncapacitytypevalueChange(e,type,title){capacitytypevalue=e.value;StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"capacitytypevalue");}},{key:'onResponseTimeChange',value:function onResponseTimeChange(e,type,title,nwtwkcl){ProcorDiskValue='Node Storage Change';var number=/^[0-9]+$/;if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){ResponseTime="";if(nwtwkcl==="Blur"){ResponseTime="1";}}else if(number.test(value)&&value<=999&&value>=1||isNaN(value)){ResponseTime=value.toString();}else{}}if(nwtwkcl==="Blur"){StroageNodeQtyCall=true;}this.onWorkloadUpdate(type,title,"ResponseTime");}},{key:'onQueryDataChange',value:function onQueryDataChange(e,type,title,nwtwkcl){ProcorDiskValue=null;var number=/^[0-9]+$/;if(e.target.value===""){QueryData="1";e.target.value=QueryData;}if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){QueryData="";}else if(number.test(value)&&value<=999&&value>=1||isNaN(value)){QueryData=value.toString();}else{}}if(nwtwkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"QueryData");}},{key:'onConcurrentQueriesChange',value:function onConcurrentQueriesChange(e,type,title,nwtwkcl){ProcorDiskValue=null;var number=/^[0-9]+$/;if(e.target.value===""){ConcurrentQueries="1";e.target.value=ConcurrentQueries;}if(e.target.value.length<7){var value=parseInt(e.target.value,10);if(isNaN(value)){ConcurrentQueries="";}else if(number.test(value)&&value<=999999&&value>=parseInt(e.target.min,10)||isNaN(value)){ConcurrentQueries=value.toString();}else{}}if(nwtwkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"ConcurrentQueries");}},{key:'onServerChange',value:function onServerChange(e,type,title){var _this6=this;var MixedStorageConfiguration="";if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this6.props.type;})[0].Service)){MixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this6.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this6.props.title;})[0]["@mixedStorage"];}else{MixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this6.props.type;})[0].Service["@mixedStorage"];}var validateServerChangeResponse=[true,''];if(MixedStorageConfiguration==="True"){validateServerChangeResponse=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["g" /* serverChangeCompatibilityCheck */])(this.props.workload,e.value,this.props.defaultSizerWorkload.serversList,this.props.type,this.props.title);}if(!validateServerChangeResponse[0]){this.serverChangeConfirmationlayerRoutine(validateServerChangeResponse[1]);}else{this.resetChangesToEmpty();serverValue=e.value;ProcorDiskValue=null;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this6.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this6.props.title){if(MixedStorageConfiguration!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){service["@mixedStorage"]="False";service.DataDisks=[];service.Hardware["@dataDriveType"]="";}service.Hardware["@Server"]=serverValue;if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */]){service.Hardware['@ProcQty']="1";}else{service.Hardware['@ProcQty']="2";}if(service['@Selected']==="true"&&service.Hardware['@Server'].indexOf("Synergy")!==-1){if(serverValue.indexOf("Synergy")===-1){SynergyServerChanged=true;}}}});}else{if(val.Service["@Type"]===_this6.props.title){if(MixedStorageConfiguration!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){val.Service["@mixedStorage"]="False";val.Service.DataDisks=[];val.Service.Hardware["@dataDriveType"]="";}if(val.Service["@Type"]==="MiNifi"){val.Service.Hardware["@ServerName"]=serverValue;}}}}});FirstServer=false;if(this.props.title==="Spark Streaming"){SparkSynergyServerChanged=true;}else if(this.props.title==="Kafka"){KafkaSynergyServerChanged=true;}else if(this.props.title==="Flink"){FlinkSynergyServerChanged=true;}else if(this.props.title==="Storm"){StormSynergyServerChanged=true;}if(this.props.title==="Yarn"){YarnSynergyServerChanged=true;}else if(this.props.title==="Spark"){SparkAnalyticsSynergyServerChanged=true;}else if(this.props.title==="Hive"){HiveSynergyServerChanged=true;}else if(this.props.title==="Cassandra"){CassandraSynergyServerChanged=true;}else if(this.props.title==="Impala"){ImpalaSynergyServerChanged=true;}else if(this.props.title==="HBase"){HBaseSynergyServerChanged=true;}//For retaining previous memory value----Rohith 
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this6.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this6.props.title){if(service['@Selected']==="true"){memoryValue=service.Hardware['@Memory'];processorValue=service.Hardware['@Proc'];processorTypeValue=service.Hardware['@ProcFamily'];}}});}else{if(val.Service['@Type']===_this6.props.title){if(val.Service['@Selected']==="true"){memoryValue=val.Service.Hardware['@Memory'];processorValue=val.Service.Hardware['@Proc'];processorTypeValue=val.Service.Hardware['@ProcFamily'];}}}}});this.state.Serverchange=true;ProcFamilyList=[];ProcList=[];if(this.props.defaultSizerWorkload.serversList!==""&&this.props.defaultSizerWorkload.serversList!==undefined&&this.props.defaultSizerWorkload.serversList!==null){this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this6.props.title&&ServiceName.Servers!==''){for(var key in ServiceName.totalList){if(key===serverValue){_this6.state.changeDriveTypeOptions=true;_this6.populateDataDriveoptions();if(_this6.props.type!=="Func"){//before wrote for IOT
for(var proctype in ServiceName.totalList[key].ProcessorList){if(ProcFamilyList.indexOf(proctype)===-1){ProcFamilyList.push(proctype);}}for(var _proctype in ServiceName.totalList[key].ProcessorList){if(ProcFamilyList.indexOf(processorTypeValue)===-1){processorTypeValue=ProcFamilyList[0];}if(_proctype===processorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[_proctype]){if(ProcList.indexOf(proc)===-1){ProcList.push(proc);}}if(ProcList.indexOf(processorValue)===-1){_this6.textOnConfigurationChange(_this6.props.title,"Processor",processorValue);processorValue=ProcList[0];}for(var _proc in ServiceName.totalList[key].ProcessorList[_proctype]){if(_proc===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[_proctype][_proc];}}}}}else{for(var _proc2 in ServiceName.totalList[key].ProcessorList[processorTypeValue]){if(ProcList.indexOf(_proc2)===-1){ProcList.push(_proc2);}}if(ProcList.indexOf(processorValue)===-1){_this6.textOnConfigurationChange(_this6.props.title,"Processor",processorValue);processorValue=ProcList[0];}for(var _proc3 in ServiceName.totalList[key].ProcessorList[processorTypeValue]){if(_proc3===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[processorTypeValue][_proc3];}}}}_this6.pushToServersList(key);}if(_this6.state.Serverchange){if(Drives.indexOf(datadisktypValue)===-1){_this6.textOnConfigurationChange(_this6.props.title,"DataDisk",datadisktypValue);datadisktypValue=Drives[0];}if(MemoryList.indexOf(memoryValue)===-1){_this6.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this6.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this6.props.title){if(service['@Selected']==="true"){_this6.textOnConfigurationChange(_this6.props.title,"Memory",memoryValue);memoryValue=service.Recommendation['@Memory'];}}});}else{if(val.Service['@Type']===_this6.props.title){if(val.Service['@Selected']==="true"){_this6.textOnConfigurationChange(_this6.props.title,"Memory",memoryValue);memoryValue=val.Service.Recommendation['@Memory'];}}}}});}if(ProcList.indexOf(processorValue)===-1){_this6.textOnConfigurationChange(_this6.props.title,"Processor",processorValue);processorValue=ProcList[0];}_this6.state.Serverchange=false;}}});}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this6.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this6.props.title){if(service['@Selected']==="true"){service.Hardware['@Server']=serverValue;service.Hardware['@Proc']=processorValue;if(ProcFamilyList.indexOf(processorTypeValue)==-1){processorTypeValue=ProcFamilyList[0];}service.Hardware['@ProcFamily']=processorTypeValue;service.Hardware['@DataDisk']=datadisktypValue;service.Hardware['@Memory']=memoryValue;}}});}else{if(val.Service['@Type']===_this6.props.title){if(val.Service['@Selected']==="true"){if(val.Service['@Type']==="MiNifi"){val.Service.Hardware['@ServerName']=serverValue;}else{val.Service.Hardware['@Server']=serverValue;}val.Service.Hardware['@Proc']=processorValue;val.Service.Hardware['@ProcFamily']=processorTypeValue;val.Service.Hardware['@DataDisk']=datadisktypValue;// val.Service.Hardware['@OSDisk'] = osdisktypValue;
val.Service.Hardware['@Memory']=memoryValue;}}}}});//Updating No.of Data Disks and OS Disks
this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this6.props.title&&ServiceName.Servers!==''&&MixedStorageConfiguration!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){_this6.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this6.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this6.props.title){if(service['@Selected']==="true"){for(var key in ServiceName.totalList){if(key===serverValue){noOfDiskValue=ServiceName.totalList[key].iDataDiskQty.toString();if(noOfDiskValue!==service.Hardware['@DiskQty']){_this6.textOnConfigurationChange(_this6.props.title,'DataDiskQty',service.Hardware['@DiskQty']);}service.DataDisks=[];service.DataDisks[0]={Item:{'@disk':datadisktypValue,'@qty':noOfDiskValue,"@volumeName":"Data_0"}};service.Hardware['@DiskQty']=noOfDiskValue;noOfOSDiskValue=ServiceName.totalList[key].iOSDiskQty.toString();if(noOfOSDiskValue!==service.Hardware['@OSDiskQty']){_this6.textOnConfigurationChange(_this6.props.title,'OSDiskQty',service.Hardware['@OSDiskQty']);}service.Hardware['@OSDiskQty']=noOfOSDiskValue;}}}}});}else{if(val.Service['@Type']===_this6.props.title){if(val.Service['@Selected']==="true"){for(var key in ServiceName.totalList){if(key===serverValue){noOfDiskValue=ServiceName.totalList[key].iDataDiskQty.toString();val.Service.DataDisks=[];val.Service.DataDisks[0]={Item:{'@disk':datadisktypValue,'@qty':noOfDiskValue,"@volumeName":"Data_0"}};val.Service.Hardware['@DiskQty']=noOfDiskValue;noOfOSDiskValue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=noOfOSDiskValue;}}}}}}});}});var OSInputs={"strFunction":type,"strService":title,"strServer":serverValue,"strDataDisk":datadisktypValue};this.props.OnGetOSDiskList(OSInputs);StroageNodeQtyCall=true;if(MixedStorageConfiguration===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){this.updateDriveQuantity();}defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"serverValue");}}},{key:'resetChangesToEmpty',value:function resetChangesToEmpty(){HDFS_Change="";Scality_Change="";Weka_Change="";Hive_Change="";Cassandra_change="";Impala_Change="";HBase_Change="";SparkStreaming_Change="";Kafka_Change="";Flink_Change="";Storm_Change="";Yarn_Change="";Spark_Change="";TensorFlow_Change="";Py_Torch_Change="";MiNifi_Change="";}},{key:'componentDidMount',value:function componentDidMount(){var _this7=this;this.resetChangesToEmpty();console.log("HDFS_Changes"+HDFS_Change);console.log(__WEBPACK_IMPORTED_MODULE_20__Datafiles_EPAvNextInput_json___default.a);var serviceselected=false;//this.props.SelectedService.value===this.props.title
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this7.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this7.props.title){if(service['@Selected']==="true"){serviceselected=true;}}});}else{if(val.Service['@Type']===_this7.props.title){if(val.Service['@Selected']==="true"){serviceselected=true;}}}}});if(OSDiskList.length===0&&serviceselected){var OSInputs={"strFunction":this.props.type,"strService":this.props.title,"strServer":serverValue,"strDataDisk":datadisktypValue};this.props.OnGetOSDiskList(OSInputs);}this.setState({});// IDatadiskqtynotchange=true;
//IOSDatadiskqtynotchange=true
// this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
//           if (val['@Type'] === this.props.type) {
//              if (Array.isArray(val.Service)) {
//                 val.Service.filter((service) => {
//                     if (service['@Type'] === this.props.title) {
//                       if (service['@Selected'] === "true") {
//                                 noOfDiskValue=service.Hardware['@DiskQty']; 
//                                  noOfOSDiskValue=service.Hardware['@OSDiskQty'];
//                                 }
//                               }
//                 })
//                       }
//                     }
//                 })
// if(!this.props.activeSession.isSizeEnabled) 
//  this.props.OnToggleSizeButton(true);
}},{key:'onOSDiskChange',value:function onOSDiskChange(e,type,title){var _this8=this;validCombination=true;var existingDrivesArray=[];if(serverValue==="HPE Apollo 4200 Gen10 Server"){if(osdisktypValue.indexOf('M.2')!==-1&&e.option.indexOf('M.2')===-1){if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this8.props.type;})[0].Service)){isMixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this8.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this8.props.title;})[0]["@mixedStorage"];existingDrivesArray=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this8.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this8.props.title;})[0].DataDisks;}else{isMixedStorageConfiguration=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this8.props.type;})[0].Service["@mixedStorage"];existingDrivesArray=this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this8.props.type;})[0].Service.DataDisks;}if(isMixedStorageConfiguration==="True"){var nonNVMeDrives=0;var NVMeDrives=0;var SFFDrives=0;existingDrivesArray.map(function(x){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])===-1&&x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])===-1){nonNVMeDrives+=parseInt(x.Item["@qty"],10);}else if(x.Item["@disk"].indexOf('NVMe')!==-1){NVMeDrives+=parseInt(x.Item["@qty"],10);}else{SFFDrives+=parseInt(x.Item["@qty"],10);}});if(nonNVMeDrives>26){validCombination=false;}if((NVMeDrives>0||SFFDrives>0)&&nonNVMeDrives>22){validCombination=false;}if(!validCombination){var text="Drive cannot be changed as the maximum drives exceeded.";this.serverChangeConfirmationlayerRoutine(text);}}}}if(validCombination){this.resetChangesToEmpty();osdisktypValue=e.value;var dryqty=0;var _serverValue=void 0;var DiskCount=void 0;this.props.defaultSizerWorkload.serversList.map(function(ServiceName){for(var key in ServiceName.totalList){_this8.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this8.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this8.props.title){if(service['@Selected']==="true"){//osdisktypValue= service.Hardware['@OSDisk'] ;
_serverValue=service.Hardware['@Server'];DiskCount=service.Hardware['@DiskQty'];}}});}}});if(key===_serverValue&&ServiceName.serviceName===_this8.props.title){dryqty=ServiceName.totalList[key].iDataDiskQty;if(_serverValue==="HPE Apollo 4200 Gen10 Server"&&osdisktypValue.indexOf("M.2")!==-1){dryqty=dryqty+2;}}}});if(parseInt(DiskCount,10)>dryqty){DiskCount=dryqty.toString();this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this8.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this8.props.title){if(service['@Selected']==="true"){service.Hardware['@DiskQty']=DiskCount;}}});}}});}this.onWorkloadUpdate(type,title,"osdisktypValue");this.updateDriveQuantity();}}},{key:'onProcessorChange',value:function onProcessorChange(e,type,title){var _this9=this;this.resetChangesToEmpty();processorValue=e.value;recommProc=false;if(serverValue==="Synergy 480 Gen10 Server"){MemoryList=[];this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this9.props.title&&ServiceName.Servers!==''){for(var key in ServiceName.totalList){if(key===serverValue){for(var proctype in ServiceName.totalList[key].ProcessorList){if(proctype===processorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){if(proc===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[proctype][proc];// memoryValue = MemoryList[0];
}}}}}}if(processorValue.indexOf("M")!==4&&processorValue.indexOf("L")!==4&&MemoryList.indexOf("3072 GB")!==-1){MemoryList.pop();}if(MemoryList.indexOf(memoryValue)===-1){_this9.textOnConfigurationChange(_this9.props.title,"Memory",memoryValue);memoryValue=MemoryList[0];}}});this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this9.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this9.props.title){if(service['@Selected']==="true"){service.Hardware['@Memory']=memoryValue;}}});}else{if(val.Service['@Type']===_this9.props.title){if(val.Service['@Selected']==="true"){val.Service.Hardware['@Memory']=memoryValue;}}}}});}if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_138" /* PROLIANT_XL225N_GEN10_PLUS */]){if(processorValue.indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_11" /* DLC */])>0){pocQtyValue=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_117" /* NUMERIC_ONE */];}else if(processorValue.indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["a" /* AC */])>0){pocQtyValue=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_118" /* NUMERIC_TWO */];}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===title){if(service['@Selected']===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){service.Hardware['@ProcQty']=pocQtyValue;}}});}else{if(val.Service['@Type']===_this9.props.title&&val.Service['@Selected']===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){val.Service.Hardware['@ProcQty']=pocQtyValue;}}}});this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this9.props.title&&ServiceName.Servers!==''){for(var key in ServiceName.totalList){if(key===serverValue){for(var proctype in ServiceName.totalList[key].ProcessorList){for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){if(proc===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[proctype][proc];}}}}}}});}if(this.props.type==="Analytics"||this.props.type==="Database"){StroageNodeQtyCall=true;ProcorDiskValue="Proc Changed";DatabaseDatadiskChange=true;}this.onWorkloadUpdate(type,title,"processorValue");}},{key:'onProcessorFamilyChange',value:function onProcessorFamilyChange(e,type,title){var _this10=this;this.resetChangesToEmpty();processorTypeValue=e.value;ProcList=[];this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this10.props.title&&ServiceName.Servers!==''){for(var key in ServiceName.totalList){if(key===serverValue){if(_this10.props.type!=="Func"){//before wrote for IOT
for(var proctype in ServiceName.totalList[key].ProcessorList){if(proctype===processorTypeValue){for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){if(ProcList.indexOf(proc)===-1){ProcList.push(proc);}if(ProcList.indexOf(processorValue)===-1){_this10.textOnConfigurationChange(_this10.props.title,"Processor",processorValue);processorValue=ProcList[0];}if(proc===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[proctype][proc];if(MemoryList.indexOf(memoryValue)===-1){_this10.textOnConfigurationChange(_this10.props.title,"Memory",memoryValue);memoryValue=MemoryList[0];}}}}}}else{for(var _proc4 in ServiceName.totalList[key].ProcessorList[processorTypeValue]){if(ProcList.indexOf(_proc4)===-1){ProcList.push(_proc4);}if(ProcList.indexOf(processorValue)===-1){_this10.textOnConfigurationChange(_this10.props.title,"Processor",processorValue);processorValue=ProcList[0];}if(_proc4===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[processorTypeValue][_proc4];}}}}}}});if(this.props.type==="Analytics"||this.props.type==="Database"){StroageNodeQtyCall=true;ProcorDiskValue="Proc Changed";DatabaseDatadiskChange=true;}this.onWorkloadUpdate(type,title,"processorTypeValue");}},{key:'onDataDiskChange',value:function onDataDiskChange(e,type,title){this.resetChangesToEmpty();datadisktypValue=e.value;StroageNodeQtyCall=true;if(this.props.type==="Analytics"||this.props.type==="Database"){ProcorDiskValue="Disk Changed";DatabaseDatadiskChange=true;}defaultNodevalueChange=true;var OSInputs={"strFunction":type,"strService":title,"strServer":serverValue,"strDataDisk":datadisktypValue};this.props.OnGetOSDiskList(OSInputs);this.onWorkloadUpdate(type,title,"datadisktypValue");this.updateDriveQuantity();}},{key:'onProcQtyChange',value:function onProcQtyChange(e,type,title){this.resetChangesToEmpty();pocQtyValue=e.value;this.onWorkloadUpdate(type,title,"pocQtyValue");}},{key:'onMemoryChange',value:function onMemoryChange(e,type,title){this.resetChangesToEmpty();memoryValue=e.value;ProcorDiskValue=null;if(this.props.type==="Analytics"){StroageNodeQtyCall=true;ProcorDiskValue="Memory Changed";}if(this.props.type==="Analytics"||this.props.type==="Database"){DatabaseDatadiskChange=true;ProcorDiskValue="Memory Changed";}this.onWorkloadUpdate(type,title,"memoryValue");}},{key:'onNoOfDisksChange',value:function onNoOfDisksChange(e,type,title,nwtwkcl,editexisting,driveID){var _this11=this;if(editexisting===true){editExisting=editexisting;}else{editExisting=false;}this.resetChangesToEmpty();// noOfDiskValue=e.target.value;
var dryqty="";var number=/^[0-9]+$/;var globalValue="";if(nwtwkcl==="Blur"){this.state.enableADDButton=true;if(e.target.value===""){//noOfDiskValue = noOfDiskValue;
e.target.value=editExisting?"1":'0';}if(this.state.valueChanged){StroageNodeQtyCall=true;this.state.valueChanged=false;}defaultNodevalueChange=true;//IDatadiskqtynotchange=false
dryqty=this.noOfDrivesleft(driveID);if(e.target.value.length<3){var value=parseInt(e.target.value,10);if(isNaN(value)){globalValue="";}else if(number.test(value)&&value<dryqty&&value>=1||isNaN(value)){//noOfDiskValue = dryqty.toString();
globalValue=value.toString();}else{// noOfDiskValue = value.toString();
globalValue=dryqty.toString();}if(value>dryqty&&!editExisting){this.maxDriveCountValidation(title);}if(editExisting){if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this11.props.title;})[0].DataDisks[driveID].Item["@qty"]=globalValue;}else{this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service.DataDisks[driveID].Item["@qty"]=globalValue;}}else{noOfDiskValue=globalValue;}}if(editExisting){editExisting=false;noOfDiskValue=this.noOfDrivesleft(driveID).toString();if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this11.props.title;})[0].Hardware["@DiskQty"]=noOfDiskValue;}else{this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service.Hardware["@DiskQty"]=noOfDiskValue;}}DataDiskQtyChange=true;}else{this.state.valueChanged=true;this.state.enableADDButton=false;if(e.target.value.length<3){var _value=parseInt(e.target.value,10);if(isNaN(_value)){globalValue="";}else if(number.test(_value)&&_value<=99&&_value>=1||isNaN(_value)){globalValue=_value.toString();}else{//noOfDiskValue = dryqty.toString();
}if(editExisting){if(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service)){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this11.props.title;})[0].DataDisks[driveID].Item["@qty"]=globalValue;}else{this.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this11.props.type;})[0].Service.DataDisks[driveID].Item["@qty"]=globalValue;}}else{noOfDiskValue=globalValue;}}}IDatadiskqtynotchange=false;if(this.props.type==="Analytics"||this.props.type==="Database"){ProcorDiskValue="Disk Qty Changed";DatabaseDatadiskChange=true;}//this.maxDriveCountValidation()
if(maxlayer||maxlayerSecondServices||maxlayerthirdServices||maxlayerFourthServices){StroageNodeQtyCall=false;}this.onWorkloadUpdate(type,title,"noOfDiskValue");editExisting=false;}// onNoOfDisksChangeBlur(e,type,title){
//   if(e.target.value===" ")
//   {
//     noOfDiskValue="1";
//   }
//   StroageNodeQtyCall=true
// defaultNodevalueChange=true
//   this.onWorkloadUpdate(type,title,"noOfDiskValue");
// }
},{key:'onNoOfOSDisksChange',value:function onNoOfOSDisksChange(e,type,title,nwtwkcl){this.resetChangesToEmpty();var dryqty="";var number=/^[0-9]+$/;if(nwtwkcl==="Blur"){if(e.target.value===""){noOfOSDiskValue="2";e.target.value=noOfOSDiskValue;}//IOSDatadiskqtynotchange=false
this.props.defaultSizerWorkload.serversList.map(function(ServiceName){for(var key in ServiceName.totalList){if(key===serverValue){dryqty=ServiceName.totalList[key].iOSDiskQty;}}});if(e.target.value.length<2){var value=parseInt(e.target.value,10);if(isNaN(value)){noOfOSDiskValue="";}else if(number.test(value)&&value<=dryqty&&value>1||isNaN(value)){//noOfOSDiskValue = dryqty.toString();
noOfOSDiskValue=value.toString();}else{// noOfOSDiskValue = value.toString();
noOfOSDiskValue=dryqty.toString();}}}else{if(e.target.value.length<4){var _value2=parseInt(e.target.value,10);if(isNaN(_value2)){noOfOSDiskValue="";}else if(number.test(_value2)&&_value2<=dryqty&&_value2>=1||isNaN(_value2)){noOfOSDiskValue=_value2.toString();}else{}}}IOSDatadiskqtynotchange=false;editExisting=true;this.maxDriveCountValidation(title);editExisting=false;this.onWorkloadUpdate(type,title,"noOfOSDiskValue");}},{key:'onNodevalueChange',value:function onNodevalueChange(e,type,title){var _this12=this;//this.onNoOfDisksChange()
//nodesQtyValue=e.target.value;
var number=/^[0-9]+$/;if(e.target.value.length<6){var value=parseInt(e.target.value,10);if(isNaN(value)){nodesQtyValue="";}else if(number.test(value)&&value<=99999&&value>=1||isNaN(value)){nodesQtyValue=value.toString();}else{}}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this12.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this12.props.title){if(service['@Selected']==="true"){service.Hardware['@NodesCount']=nodesQtyValue;}}});}else{if(val.Service['@Type']===_this12.props.title){if(val.Service['@Selected']==="true"){val.Service.Hardware['@NodesCount']=nodesQtyValue;}}}}});defaultNodevalueChange=false;this.onWorkloadUpdate(type,title,"nodesQtyValue");}},{key:'onNodevalueBlur',value:function onNodevalueBlur(e,type,title){var _this13=this;if(parseInt(defaultNodevalue,10)<=parseInt(e.target.value,10)||e.target.value===" "){nodesQtyValue=e.target.value;}else{nodesQtyValue=defaultNodevalue.toString();}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this13.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this13.props.title){if(service['@Selected']==="true"){service.Hardware['@NodesCount']=nodesQtyValue;}}});}else{if(val.Service['@Type']===_this13.props.title){if(val.Service['@Selected']==="true"){val.Service.Hardware['@NodesCount']=nodesQtyValue;}}}}});Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["l" /* updateGrowthItem */])(this.props.title,nodesQtyValue,this.props.workload);defaultNodevalueChange=false;this.onWorkloadUpdate(type,title,"nodesQtyValue");}},{key:'onStoragevalueCahnge',value:function onStoragevalueCahnge(e,val,type,title){var number=/^[0-9]+$/;if(e.target.value.length<2){var value=parseInt(e.target.value,10);if(isNaN(value)){if(val==="value1"){Storagevalue1='';}else{Storagevalue2='';}}else if(number.test(value)&&value<=9&&value>=1||isNaN(value)){if(val==="value1"){Storagevalue1=value.toString();}else{Storagevalue2=value.toString();}}else{}}this.onWorkloadUpdate(type,title,val);}},{key:'onStoragevalueCahngeBlur',value:function onStoragevalueCahngeBlur(e,val,type,title){if(e.target.value===''){if(val==="value1"){Storagevalue1="1";}else{Storagevalue2="1";}}else{if(val==="value1"){Storagevalue1=e.target.value;}else{Storagevalue2=e.target.value;}}// e.target.value=
StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,val);}},{key:'onWorkloadUpdate',value:function onWorkloadUpdate(type,title,tag){var _this14=this;//this.props.SelectedService.value=title
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===title){// service['@Selected']=this.props.isSelected;
if(service['@Selected']==="true"){//Hardware Selection
if(tag==="serverValue"){service.Hardware['@Server']=serverValue;service.Inputs['@GPU']=GPUsOptions[0];}else if(tag==="processorValue"){service.Hardware['@Proc']=processorValue;}else if(tag==="processorTypeValue"){service.Hardware['@ProcFamily']=processorTypeValue;service.Hardware['@Proc']=processorValue;service.Hardware['@Memory']=memoryValue;}else if(tag==="pocQtyValue"){service.Hardware['@ProcQty']=pocQtyValue;}else if(tag==="datadisktypValue"){service.Hardware['@DataDisk']=datadisktypValue;}else if(tag==="osdisktypValue"){service.Hardware['@OSDisk']=osdisktypValue;}else if(tag==="nodesQtyValue"){service.Hardware['@NodesCount']=nodesQtyValue;}if(tag==="memoryValue")service.Hardware['@Memory']=memoryValue;if(tag==="noOfDiskValue")service.Hardware['@DiskQty']=noOfDiskValue;if(tag==="noOfOSDiskValue")service.Hardware['@OSDiskQty']=noOfOSDiskValue;if(tag==="nodeValue"){service.Hardware['@NodesQty']=nodeValue;if(nodeValue==="Sizer Recommendation"){service.Hardware['@NodesCount']=defaultNodevalue;}}if(type===AI){_this14.populateGPUOptions();if(GPUsOptions.indexOf(GPUvalue)===-1){GPUvalue=GPUsOptions[0];service.Inputs['@GPU']=GPUvalue;StroageNodeQtyCall=true;}}//Storage Selection
if(_this14.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]||_this14.props.title==="MapR and MapR-EC"){if(tag==="diskcapacityvalue")service.Inputs['@Capacity']=diskcapacityvalue;if(tag==="compression")service.Inputs['@Compression']=compression;if(tag==="ensurecodngdata"){service.Inputs['@ErasureData']=ensurecodngdata;service.Inputs['@ErasureParity']=ensurecodngparity;}if(tag==="ensurecodngparity")service.Inputs['@ErasureParity']=ensurecodngparity;if(tag==="overhead")service.Inputs['@OverHead']=overhead;if(tag==="strgwrkload")service.Inputs['@StorageWL']=strgwrkload;if(tag==="capacitytypevalue"){service.Inputs['@Type']=capacitytypevalue;if(service.Inputs['@Type']==="Raw"){service.Inputs['@ErasureCoding']="false";}}if(tag==="replicationvalue")service.Inputs['@Replication']=replicationvalue;}else if(_this14.props.title==="Scality"){if(tag==="ARCvalue")service.Inputs['@ARC']=ARCvalue;if(tag==="Scalitydiskcapacityvalue")service.Inputs['@Capacity']=Scalitydiskcapacityvalue;if(tag==="GreenLakevalue")service.Inputs['@GreenLake']=GreenLakevalue;if(tag==="Sitesvalue")service.Inputs['@NoOfSites']=Sitesvalue;if(tag==="StoragePerc")service.Inputs['@StoragePerc']=StoragePerc;if(tag==="NetworkSwitchvalue")service.Inputs['@NwSwitch']=NetworkSwitchvalue;if(tag==="Quantityvalue")service.Inputs['@NwSwitchQty']=Quantityvalue;if(tag==="Secondsitevalue")service.Inputs['@Replication']=Secondsitevalue;}else if(_this14.props.type==='Streaming'){if(tag==="MessagesPerSec")service.Inputs['@MessagesPerSec']=MessagesPerSec;}else if(_this14.props.type==="AI"){if(tag==="GPUvalue")service.Inputs['@GPU']=GPUvalue;if(tag==="GPUQty")service.Inputs['@GPUQty']=GPUQty;if(tag==="ImagesPerSec")service.Inputs['@ImagesPerSec']=ImagesPerSec;if(tag==="AIConfigtypevalue")service.Inputs['@ConfigType']=AIConfigtypevalue;}else if(_this14.props.type==="IoT"){if(tag==="EventsPerSec")service.Inputs['@EventsPerSec']=EventsPerSec;}else if(_this14.props.type==="Analytics"){if(tag==="Analyticsvalue"){service.Inputs['@ConfigType']=Analyticsvalue;}else if(tag==="Ansdiskcapacityvalue"){service.Inputs['@UsableCapacity']=Ansdiskcapacityvalue;}else if(tag==="ContainersQty"){service.Inputs['@ContainersQty']=ContainersQty;}else if(tag==="CoresPerContainer"){service.Inputs['@CoresPerContainer']=CoresPerContainer;}else if(tag==="MemoryPerContainer"){service.Inputs['@MemoryPerContainer']=MemoryPerContainer;}else if(tag==="NodelocalStorageValue"){service.Inputs['@NodeStorage']=NodelocalStorageValue;}else if(tag==="StorageNodesQty"){service.Inputs['@StorageNodesQty']=StorageNodesQty;}else if(tag==="Storagevalue"){service.Inputs['@SCRatio']=Storagevalue;service.Inputs['@Storage']=Storagevalue1;service.Inputs['@Compute']=Storagevalue2;}else if(tag==="value1"){service.Inputs['@Storage']=Storagevalue1;}else if(tag==="value2"){service.Inputs['@Compute']=Storagevalue2;}}else if(_this14.props.type==="Database"){if(tag==="QueryData")service.Inputs['@Capacity']=QueryData;if(tag==="ResponseTime")service.Inputs['@NodeStorage']=ResponseTime;if(tag==="ConcurrentQueries")service.Inputs['@OpsPerSec']=ConcurrentQueries;// if (tag === "DatabaseUsablecapacity")
//   service.Inputs['@Capacity'] = DatabaseUsablecapacity;
}else if(_this14.props.title==="Weka"){if(tag==="DriveClassValue"){if(DriveClassChanged){DriveClassChanged=false;DATADriveCapacity=DATADriveCapacityoptions[0];service.Inputs['@DATADriveCapacity']=DATADriveCapacity;if(SKUInformationValue==="Predefined Configuration")service.Inputs['@RawCapacity']=(parseFloat(service.Inputs['@DATADriveCapacity'])*parseFloat(service.Hardware['@NodesCount'])*parseFloat(service.Inputs['@DATADrivePerServer'])).toString();}service.Inputs['@DriveClass']=DriveClassValue;}if(tag==="SKUInformationValue"){service.Inputs['@SKUInfo']=SKUInformationValue;if(SKUInformationValue==="Predefined Configuration"){service.Inputs['@RawCapacity']=(parseFloat(service.Inputs['@DATADriveCapacity'])*parseFloat(service.Hardware['@NodesCount'])*parseFloat(service.Inputs['@DATADrivePerServer'])).toString();// service.Hardware['@NodesCount'] = "1";
service.Hardware['@NodesCount']="6";}}if(tag==="Addservers")service.Inputs['@AddServers']=Addservers;if(tag==="OSEnvironment")service.Inputs['@OS']=OSEnvironment;if(tag==="SupportYearCount")service.Inputs['@SupportYears']=SupportYearCount;if(tag==="EducationCustomer")service.Inputs['@IsEduCustomer']=EducationCustomer;if(tag==="NetworkType")service.Inputs['@NetworkType']=NetworkType;if(tag==="Peakreadiops")service.Inputs['@PeakReadIOPS']=Peakreadiops;if(tag==="Peakwriteiops")service.Inputs['@PeakWriteIOPS']=Peakwriteiops;if(tag==="ServerType"){service.Hardware['@Server']=ServerType;service.Inputs['@DATADrivePerServer']=DATADrivePerServer;if(SKUInformationValue==="Predefined Configuration")service.Inputs['@RawCapacity']=(parseFloat(service.Inputs['@DATADriveCapacity'])*parseFloat(service.Hardware['@NodesCount'])*parseFloat(service.Inputs['@DATADrivePerServer'])).toString();}if(tag==="capacityrequired")service.Inputs['@TierCapacity']=capacityrequired;if(tag==="Peakreadbandwdth")service.Inputs['@PeakReadBW']=Peakreadbandwdth;if(tag==="Peakwritebandwdth")service.Inputs['@PeakWriteBW']=Peakwritebandwdth;if(tag==="Totalusablestorage")service.Inputs['@Capacity']=Totalusablestorage;if(tag==="DIMMCapacity")service.Inputs['@DIMMCapacity']=DIMMCapacity;if(tag==="DATADriveCapacity"){service.Inputs['@DATADriveCapacity']=DATADriveCapacity;if(SKUInformationValue==="Predefined Configuration")service.Inputs['@RawCapacity']=(parseInt(service.Inputs['@DATADriveCapacity'],10)*parseInt(service.Hardware['@NodesCount'],10)).toString();}if(tag==="DATADrivePerServer")service.Inputs['@DATADrivePerServer']=DATADrivePerServer;if(tag==="SpareServers")service.Inputs['@SpareServers']=SpareServers;if(tag==="NumServers")service.Hardware['@NodesCount']=NumServers;}}}});}else{if(val.Service['@Type']===_this14.props.title){if(val.Service['@Selected']==="true"){val.Service.Inputs['@EventsPerSec']=EventsPerSec;if(tag==="serverValue")if(val.Service['@Type']==="MiNifi"){val.Service.Hardware['@ServerName']=serverValue;}else{val.Service.Hardware['@Server']=serverValue;}// val.Service.Hardware['@Server'] = serverValue;
if(tag==="processorValue")val.Service.Hardware['@Proc']=processorValue;if(tag==="processorTypeValue"){val.Service.Hardware['@ProcFamily']=processorTypeValue;val.Service.Hardware['@Proc']=processorValue;val.Service.Hardware['@Memory']=memoryValue;}if(tag==="pocQtyValue")val.Service.Hardware['@ProcQty']=pocQtyValue;if(tag==="datadisktypValue")val.Service.Hardware['@DataDisk']=datadisktypValue;if(tag==="osdisktypValue")val.Service.Hardware['@OSDisk']=osdisktypValue;if(tag==="nodesQtyValue")val.Service.Hardware['@NodesCount']=nodesQtyValue;if(tag==="memoryValue")val.Service.Hardware['@Memory']=memoryValue;if(tag==="noOfDiskValue")val.Service.Hardware['@DiskQty']=noOfDiskValue;if(tag==="noOfOSDiskValue")val.Service.Hardware['@OSDiskQty']=noOfOSDiskValue;if(tag==="nodeValue"){val.Service.Hardware['@NodesQty']=nodeValue;if(nodeValue==="Sizer Recommendation"){val.Service.Hardware['@NodesCount']=defaultNodevalue;}}// val.Service.Hardware['@Server'] = serverValue;
//val.Service.Hardware['@Proc'] = processorValue;
//val.Service.Hardware['@ProcQty'] = pocQtyValue;
// val.Service.Hardware['@DataDisk'] = datadisktypValue;
//val.Service.Hardware['@OSDisk'] = osdisktypValue;
// val.Service.Hardware['@NodesCount'] = nodesQtyValue;
// val.Service.Hardware['@Memory'] = memoryValue;
// val.Service.Hardware['@DiskQty'] = noOfDiskValue;
//  val.Service.Hardware['@NodesQty']=nodeValue;
}else{EventsPerSec='';}}}}});if(AnalyticsandDatabaseNodeQtyCall){AnalyticsandDatabaseNodeQtyCall=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this14.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this14.props.title){if(service['@Selected']==="true"){var NodeInputs={};switch(_this14.props.type){case"Analytics":NodeInputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"strServer":service.Hardware['@Server'],"strDataDisk":service.Hardware['@DataDisk'],"dNodeStorage":parseFloat(service.Inputs['@NodeStorage']),"iDiskQty":parseInt(service.Hardware['@DiskQty'],10)};break;case"Database":NodeInputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"strServer":service.Hardware['@Server'],"strDataDisk":service.Hardware['@DataDisk'],"dNodeStorage":parseFloat(service.Inputs['@NodeStorage']),"iDiskQty":parseInt(service.Hardware['@DiskQty'],10)};break;}_this14.props.RecallAnalyticsandDatabaseNodeQty(NodeInputs);}}});}}});}if(StroageNodeQtyCall){StroageNodeQtyCall=false;// ProcorDiskValue=null
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){var Arg0=void 0,Arg1=void 0,Arg2=void 0;var earasure=false;if(val['@Type']===_this14.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this14.props.title){isMixedStorageConfiguration=service["@mixedStorage"];if(service['@Selected']==="true"){if(service.Inputs['@ConfigType']==="Containers"||service.Inputs['@ConfigType']==="Executors"){Arg0=parseFloat(service.Inputs['@ContainersQty']);Arg1=parseFloat(service.Inputs['@CoresPerContainer']);Arg2=parseFloat(service.Inputs['@MemoryPerContainer']);}else{Arg0=parseFloat(service.Inputs['@StorageNodesQty']);Arg1=parseFloat(Storagevalue1);Arg2=parseFloat(Storagevalue2);}var Databasedrives=[];var DatabaseandAnalyticsDiskQtyChange="";if(_this14.props.type==="Database"||_this14.props.type==="Analytics"){if(DatabaseDatadiskChange){DatabaseDatadiskChange=false;Databasedrives.push(service.Hardware['@DataDisk']);}else{Databasedrives=Drives;}if(DataDiskQtyChange){DataDiskQtyChange=false;DatabaseandAnalyticsDiskQtyChange=true;}else{DatabaseandAnalyticsDiskQtyChange=false;}}if(service['@Type']===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]){earasure=_this14.props.erasureHDFS;}else if(service['@Type']==="MapR and MapR-EC"){earasure=_this14.props.erasureMAPR;}var disksQtyinpayload=[];if(isMixedStorageConfiguration==="True"){disksQtyinpayload=service.DataDisks;}var Inputs={};switch(_this14.props.type){case'Storage':if(_this14.props.title==="Weka"){Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"SKUInfo":service.Inputs['@SKUInfo'],"strServer":service.Hardware['@Server'],"strDriveClass":service.Inputs['@DriveClass'],"PeakReadIO":parseFloat(service.Inputs['@PeakReadIOPS']),"PeakWriteIO":parseFloat(service.Inputs['@PeakWriteIOPS']),"PeakReadBW":parseFloat(service.Inputs['@PeakReadBW']),"PeakWriteBW":parseFloat(service.Inputs['@PeakWriteBW']),"dUsableCapacity":parseFloat(service.Inputs['@Capacity'])};}else if(_this14.props.title==="Scality"){Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"isGreenLake":service.Inputs['@GreenLake'],"strServer":service.Hardware['@Server'],"strDataDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"iDiskQty":parseFloat(service.Hardware['@DiskQty']),"dUsableCapacity":parseFloat(service.Inputs['@Capacity']),"dStoragePerc":parseFloat(service.Inputs['@StoragePerc']),"strSite":service.Inputs['@NoOfSites'],"strReplication":service.Inputs['@Replication']};}else{Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"Server":service.Hardware['@Server'],"dRawCapacity":parseFloat(service.Inputs['@Capacity']),"strDataDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"strCapacityType":service.Inputs['@Type'],"dReplication":parseFloat(service.Inputs['@Replication']),"dCompression":parseFloat(service.Inputs['@Compression']),"dOverhead":parseFloat(service.Inputs['@OverHead']),"bErasureCode":earasure,//"bErasureCode":this.props.defaultSizerWorkload.ErasureCodingChkd,
"dData":parseFloat(service.Inputs['@ErasureData']),"dParity":parseFloat(service.Inputs['@ErasureParity']),"iDiskQty":parseFloat(service.Hardware['@DiskQty'])};}break;case'Streaming':Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"Server":service.Hardware['@Server'],"dMessPerSec":parseFloat(service.Inputs['@MessagesPerSec'])};break;case'Database':if(_this14.props.title==="Hive"){ShowHiveLayer=true;}Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"Server":service.Hardware['@Server'],"SelectedDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"DBSize":parseFloat(service.Inputs['@Capacity']),"dNodeStorage":parseFloat(service.Inputs['@NodeStorage']),"dQueriesPerMinute":parseFloat(service.Inputs['@OpsPerSec']),"lstDataDrives":Databasedrives,//"lstDataDrives":service.Hardware['@DataDisk'],
"iDataDiskQty":parseInt(service.Hardware['@DiskQty'],10),"bIsDiskChanged":DatabaseandAnalyticsDiskQtyChange,"strProcessor":service.Hardware['@Proc'],"strCompChanged":ProcorDiskValue//"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
};break;case'AI':Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"strServer":service.Hardware['@Server'],"strConfigType":AIConfigtypevalue,"iGPUQty":"","dImagesPerSec":parseFloat(service.Inputs['@ImagesPerSec']),"strGPUSelected":service.Inputs['@GPU']};break;case'Analytics':Inputs={"strFunc":_this14.props.type,"strService":_this14.props.title,"strConfigType":service.Inputs['@ConfigType'],"arg0":Arg0,"arg1":Arg1,"arg2":Arg2,"strServer":service.Hardware['@Server'],"strDataDisk":service.Hardware['@DataDisk'],"Drives":disksQtyinpayload,"dNodeStorage":parseFloat(service.Inputs['@NodeStorage']),"lstDataDrives":Databasedrives,//"lstDataDrives":service.Hardware['@DataDisk'],
"iDataDiskQty":parseInt(service.Hardware['@DiskQty'],10),"bIsDiskChanged":DatabaseandAnalyticsDiskQtyChange,"strMemory":service.Hardware['@Memory'],"strProcessor":service.Hardware['@Proc'],"strCompChanged":ProcorDiskValue//"iDataDiskQtyChange":DatabaseandAnalyticsDiskQtyChange
};break;}_this14.props.OnFetchNodeQty(Inputs);}}});}}});}this.setState({});}},{key:'maxDriveCountValidation',value:function maxDriveCountValidation(title){var _this15=this;var noOfExistingNVMeDrives=0;var noOfExistingDrives=0;var qtyOfExistingDataDisks=0;var noOfExistingNonNVMeDrives=0;var arrayObjectCommonMethod=function arrayObjectCommonMethod(ServiceName,service){if(service['@Type']===_this15.props.title){if(service['@Selected']===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){osdisktypValue=service.Hardware['@OSDisk'];serverValue=service.Hardware['@Server'];if(ServiceName.serviceName===_this15.props.title){for(var key in ServiceName.totalList){if(key===serverValue){MaxDriveQty=ServiceName.totalList[key].iMaxDrives;if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&osdisktypValue.indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_103" /* M_2 */])!==-1){MaxDriveQty=MaxDriveQty+2;}if(service.Hardware["@DataDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1||serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(service.Hardware["@DataDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])!==-1||service.Hardware["@DataDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){var nonNVMeDrives=0;MaxDriveQty=ServiceName.totalList[key].iMaxNVMeDrives;if(service.DataDisks.length>0&&service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){service.DataDisks.map(function(x){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1){noOfExistingNVMeDrives+=parseInt(x.Item["@qty"],10);}else if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])!==-1||x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){nonNVMeDrives+=parseInt(x.Item["@qty"],10);}else{noOfExistingNonNVMeDrives+=parseInt(x.Item["@qty"],10);}});}if(service.Hardware["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])!==-1){noOfExistingNVMeDrives+=parseInt(service.Hardware["@OSDiskQty"],10);}else{noOfExistingNonNVMeDrives+=parseInt(service.Hardware["@OSDiskQty"],10);}if(editExisting){qtyOfExistingDataDisks=noOfExistingNVMeDrives+nonNVMeDrives;}else{qtyOfExistingDataDisks=noOfExistingNVMeDrives+nonNVMeDrives+parseInt(service.Hardware["@DiskQty"],10);}if(qtyOfExistingDataDisks<=MaxDriveQty){MaxDriveQty=ServiceName.totalList[key].iMaxDrives;if(serverValue===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(noOfExistingNVMeDrives>0||nonNVMeDrives>0){MaxDriveQty=24;qtyOfExistingDataDisks=noOfExistingNonNVMeDrives;}if(osdisktypValue.indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_103" /* M_2 */])>-1){MaxDriveQty=MaxDriveQty+2;}}else{if(editExisting){qtyOfExistingDataDisks=noOfExistingNVMeDrives+nonNVMeDrives+noOfExistingNonNVMeDrives;}else{qtyOfExistingDataDisks=noOfExistingNVMeDrives+nonNVMeDrives+noOfExistingNonNVMeDrives+parseInt(service.Hardware["@DiskQty"],10);}}}}else{if(service.DataDisks.length>0&&service["@mixedStorage"]===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){service.DataDisks.map(function(x){if(serverValue!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){noOfExistingDrives+=parseInt(x.Item["@qty"],10);}else{if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])===-1&&x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])===-1){noOfExistingDrives+=parseInt(x.Item["@qty"],10);}else{MaxDriveQty=24;if(osdisktypValue.indexOf(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_103" /* M_2 */])!==-1){MaxDriveQty+=2;}}}});}if(editExisting){qtyOfExistingDataDisks=noOfExistingDrives+parseInt(service.Hardware["@OSDiskQty"],10);}else{qtyOfExistingDataDisks=noOfExistingDrives+parseInt(noOfDiskValue,10)+parseInt(service.Hardware["@OSDiskQty"],10);}}}}}}}};this.props.defaultSizerWorkload.serversList.map(function(ServiceName){_this15.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this15.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){arrayObjectCommonMethod(ServiceName,service);});}else{arrayObjectCommonMethod(ServiceName,val.Service);}}});});if(MaxDriveQty<qtyOfExistingDataDisks){maxDrivesSupported=MaxDriveQty;if(this.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]||this.props.title==="Hive"||this.props.title==="Spark Streaming"||this.props.title==="Yarn"||this.props.title==="Tensorflow"||this.props.title==="MiNifi"){maxlayer=true;maxlayerSecondServices=false;maxlayerthirdServices=false;maxlayerFourthServices=false;}else if(this.props.title==="Scality"||this.props.title==="Cassandra"||this.props.title==="Kafka"||this.props.title==="Spark"||this.props.title==="PyTorch"){maxlayer=false;maxlayerSecondServices=true;maxlayerthirdServices=false;maxlayerFourthServices=false;}else if(this.props.title==="Impala"||this.props.title==="Flink"){maxlayer=false;maxlayerSecondServices=false;maxlayerthirdServices=true;maxlayerFourthServices=false;}else if(this.props.title==="HBase"||this.props.title==="Storm"){maxlayer=false;maxlayerSecondServices=false;maxlayerthirdServices=false;maxlayerFourthServices=true;}}else{}}},{key:'onMessagesPerSecChange',value:function onMessagesPerSecChange(e,type,title,nwtwkcl){// MessagesPerSec=e.target.value;
var number=/^[0-9]+$/;if(e.target.value==""){MessagesPerSec="0";e.target.value=MessagesPerSec;}if(e.target.value.length<=5){var value=parseInt(e.target.value,10);if(isNaN(value)){MessagesPerSec="";}else if(number.test(value)&&value<=99999&&value>=1||isNaN(value)){MessagesPerSec=value.toString();}else{}}if(nwtwkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}//StroageNodeQtyCall=true
this.onWorkloadUpdate(type,title,"MessagesPerSec");}// onMessagesPerSecBlur(e,type,title){
//     if(e.target.value==""){
//         MessagesPerSec="0";
//       }
// this.onWorkloadUpdate(type,title,"MessagesPerSec");   
// }
},{key:'NodeQtycahnge',value:function NodeQtycahnge(e,type,title){var visible=false;if(e.value==="Sizer Recommendation"){visible=true;Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic__["l" /* updateGrowthItem */])(title,defaultNodevalue,this.props.workload);}nodeValue=e.value;//    this.props. workload.UserInputs.Environments.Functions.Function.filter((val)=>{
//       if(val['@Type']=== this.props.type)
//       {
//         if(Array.isArray(val.Service))
//         {
//             val.Service.filter((service)=>{
//               if(service['@Type']===this.props.title)
//               {
//               if( service['@Selected']==="true"){
//                 service.Hardware['@NodesQty']= nodeValue;
//               }
//             }
//             })
//         } else{
//           if(val.Service['@Type']===this.props.title)
//               {
//                 if( val.Service['@Selected']==="true"){
//                 val.Service.Hardware['@NodesQty'] = nodeValue;
//                 }
//               }
//         }
//       }
// })
this.onWorkloadUpdate(type,title,"nodeValue");this.setState({NodeQtyvisible:visible});}},{key:'ContainerdisplayChange',value:function ContainerdisplayChange(e,type,title){Analyticsvalue=e.value;StroageNodeQtyCall=true;ProcorDiskValue=null;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"Analyticsvalue");}},{key:'onContainersQtyChange',value:function onContainersQtyChange(e,type,title,ntwrkcl){//ContainersQty=e.target.value;
var number=/^[0-9]+$/;// if (e.target.value === "") {
//   e.target.value = "1"
// }
if(e.target.value.length<=3){var value=parseInt(e.target.value,10);if(isNaN(value)){ContainersQty="";}else if(number.test(value)&&value<=999&&value>=1||isNaN(value)){ContainersQty=value.toString();}else{}}if(ntwrkcl==="Blur"){if(e.target.value===""){ContainersQty="1";}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"ContainersQty");}// onContainersQtyChangeBlur(e,type,title)
// {
//    if(e.target.value==="")
//    {
//      ContainersQty="1"
//    }
//    StroageNodeQtyCall=true;
//       defaultNodevalueChange=true
//   this.onWorkloadUpdate(type,title,"ContainersQty");
// }
},{key:'onCoresPerContainerChange',value:function onCoresPerContainerChange(e,type,title,ntwrkcl){//CoresPerContainer=e.target.value;
var number=/^[0-9]+$/;// if (e.target.value === "") {
//   CoresPerContainer = "1";
//   e.target.value = CoresPerContainer;
// }
if(e.target.value.length<3){var value=parseInt(e.target.value,10);if(isNaN(value)){CoresPerContainer="";}else if(number.test(value)&&value<=99&&value>=1||isNaN(value)){CoresPerContainer=value.toString();}else{}}if(ntwrkcl==="Blur"){if(e.target.value===""){CoresPerContainer="1";e.target.value=CoresPerContainer;}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"CoresPerContainer");}//  onCoresPerContainerChangeBlur(e,type,title){
//     if(e.target.value==="")
//    {
//      CoresPerContainer="1";
//    }
//     StroageNodeQtyCall=true;
//   defaultNodevalueChange=true
//   this.onWorkloadUpdate(type,title,"CoresPerContainer");
//  }
},{key:'onMemoryPerContainerChange',value:function onMemoryPerContainerChange(e,type,title,ntwrkcl){//  MemoryPerContainer=e.target.value;
var number=/^[0-9]+$/;// if (e.target.value === "") {
//   MemoryPerContainer = "1";
//   e.target.value = MemoryPerContainer;
// }
if(e.target.value.length<3){var value=parseInt(e.target.value,10);if(isNaN(value)){MemoryPerContainer="";}else if(number.test(value)&&value<=99&&value>=1||isNaN(value)){MemoryPerContainer=value.toString();}else{}}if(ntwrkcl==="Blur"){if(e.target.value===""){MemoryPerContainer="1";e.target.value=MemoryPerContainer;}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"MemoryPerContainer");}//  onMemoryPerContainerChangeBlur(e,type,title){
//    if(e.target.value==="")
//    {
//      MemoryPerContainer="1";
//    }
//    StroageNodeQtyCall=true;
//   defaultNodevalueChange=true
//   this.onWorkloadUpdate(type,title,"MemoryPerContainer");
//  }
},{key:'onNodelocalStorageValueChange',value:function onNodelocalStorageValueChange(e,type,title){//NodelocalStorageValue=e.target.value;
var number=/^[0-9]+$/;if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){NodelocalStorageValue="";}else if(number.test(value)&&value<=999&&value>=1||isNaN(value)){NodelocalStorageValue=value.toString();}else{}}this.onWorkloadUpdate(type,title,"NodelocalStorageValue");}},{key:'onNodelocalStorageValueChangeBlur',value:function onNodelocalStorageValueChangeBlur(e,type,title){//  if(e.target.value==="")
//  {
//    NodelocalStorageValue="1"
//  }
var number=/^[0-9]+$/;if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){NodelocalStorageValue='1';}else if(number.test(value)&&value<=999&&value>=1||isNaN(value)){NodelocalStorageValue=value.toString();}else{}}StroageNodeQtyCall=true;ProcorDiskValue="Node Storage Changed";this.onWorkloadUpdate(type,title,"NodelocalStorageValue");}},{key:'onAnsdiskcapacityvalue',value:function onAnsdiskcapacityvalue(e,type,title,ntwrkcl){// Ansdiskcapacityvalue=e.target.value;
var number=/^[0-9]+$/;if(e.target.value===""){Ansdiskcapacityvalue="0";e.target.value=Ansdiskcapacityvalue;}if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){Ansdiskcapacityvalue="";}else if(number.test(value)&&value<=999&&value>=0||isNaN(value)){Ansdiskcapacityvalue=value.toString();}else{}}if(ntwrkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"Ansdiskcapacityvalue");}//  onAnsdiskcapacityvalueBlur(e,type,title)
//  {
//     if(e.target.value==="")
//    {
//      Ansdiskcapacityvalue="0"
//    }
//   this.onWorkloadUpdate(type,title,"Ansdiskcapacityvalue");
//  }
},{key:'onStorageNodesQtyChange',value:function onStorageNodesQtyChange(e,type,title,ntwrkcl){// StorageNodesQty=e.target.value;
ProcorDiskValue=null;var number=/^[0-9]+$/;if(e.target.value===""){StorageNodesQty="1";e.target.value=StorageNodesQty;}if(e.target.value.length<4){var value=parseInt(e.target.value,10);if(isNaN(value)){StorageNodesQty="";}else if(number.test(value)&&value<=999&&value>=1||isNaN(value)){StorageNodesQty=value.toString();}else{}}if(ntwrkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"StorageNodesQty");}//  onStorageNodesQtyChangeBlur(e,type,title){
//    if(e.target.value==="")
//    {
//      StorageNodesQty="1"
//    }
//   this.onWorkloadUpdate(type,title,"StorageNodesQty");
//  }
},{key:'onStorageOptionsChange',value:function onStorageOptionsChange(e,type,title){Storagevalue=e.value;if(Storagevalue==="Balanced Workload"){Storagevalue1='1';Storagevalue2='2';}else if(Storagevalue==="IO intensive"){Storagevalue1='1';Storagevalue2='1';}else if(Storagevalue==="Compute Intensive"){Storagevalue1='1';Storagevalue2='3';}StroageNodeQtyCall=true;defaultNodevalueChange=true;ProcorDiskValue=null;this.onWorkloadUpdate(type,title,"Storagevalue");}},{key:'onDiskCapacityChange',value:function onDiskCapacityChange(e,type,title){var number=/^[0-9]+$/;if(e.target.value.length<7){var value=parseInt(e.target.value,10);if(isNaN(value)){diskcapacityvalue="";}else if(number.test(value)&&value<=999999&&value>=1||isNaN(value)){diskcapacityvalue=value.toString();}else{}}//diskcapacityvalue=e.target.value;
//StroageNodeQtyCall=true;
defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"diskcapacityvalue");}},{key:'onDiskCapacityBlur',value:function onDiskCapacityBlur(e,type,title){if(e.target.value==""){diskcapacityvalue="1024";}StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"diskcapacityvalue");}},{key:'onOverheadChange',value:function onOverheadChange(e,type,title){onChangeTriggered=true;var number=/^[0-9]+$/;var value=parseInt(e.target.value,10);if(isNaN(value)){overhead="";}else if(number.test(value)&&value<=100&&value>=0||isNaN(value)){overhead=value.toString();}else{}// overhead=e.target.value;
//StroageNodeQtyCall=true;
defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"overhead");}},{key:'onOverheadBlur',value:function onOverheadBlur(e,type,title){if(e.target.value==""){overhead=0;}this.onBlurValidation();defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"overhead");}},{key:'onStorageWorkloadChange',value:function onStorageWorkloadChange(e,type,title){var number=/^[0-9]+$/;var value=parseInt(e.target.value,10);if(isNaN(value)){strgwrkload="";}else if(number.test(value)&&value<=100&&value>=0||isNaN(value)){strgwrkload=value.toString();}else{}//strgwrkload=e.target.value;
this.onWorkloadUpdate(type,title,"strgwrkload");}},{key:'onStorageWorkloadBlur',value:function onStorageWorkloadBlur(e,type,title){if(e.target.value==""){strgwrkload=0;}this.onWorkloadUpdate(type,title,"strgwrkload");}},{key:'onCompressionChange',value:function onCompressionChange(e,type,title){onChangeTriggered=true;var alapha=/\d+(\.\d{1,2})?/;if(alapha.test(e.target.value)&&e.target.value<=parseFloat(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["Z" /* DATALAKE_COMPRESSION_MAXVLAUE */],10)&&e.target.value>=parseFloat(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_0" /* DATALAKE_COMPRESSION_MINVLAUE */],10)||e.target.value==""){var decimal=e.target.value;if(decimal.length<=2){compression=e.target.value.toString();}if(decimal.indexOf(".")>0){var result=decimal.split(".");var output1=result[0];var output2=result[1];if(output2.length<=2){compression=e.target.value.toString();}}}// compression=e.target.value;
// StroageNodeQtyCall=true;
defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"compression");}},{key:'onCompressionBlur',value:function onCompressionBlur(e,type,title){if(e.target.value==""){compression=1;}if(e.target.value.length===2){var arr=[];arr=e.target.value.split('.');compression=arr[0];}this.onBlurValidation();defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"compression");}},{key:'onReplicationCahnge',value:function onReplicationCahnge(e,type,title){// replicationvalue=e.target.value;
onChangeTriggered=true;var alapha=/\d+(\.\d{1,2})?/;if(alapha.test(e.target.value)&&e.target.value<=parseFloat(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_2" /* DATALAKE_REPLICATION_MAXVALUE */],10)&&e.target.value>=parseFloat(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_3" /* DATALAKE_REPLICATION_MINVALUE */],10)||e.target.value==""){var decimal=e.target.value;if(decimal.length<=2){replicationvalue=e.target.value.toString();}if(decimal.indexOf(".")>0){var result=decimal.split(".");var output1=result[0];var output2=result[1];if(output2.length<=2){replicationvalue=e.target.value.toString();}}}defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"replicationvalue");}},{key:'onReplicationBlur',value:function onReplicationBlur(e,type,title){if(e.target.value==""){replicationvalue=1;}if(e.target.value.length===2){var arr=[];arr=e.target.value.split('.');replicationvalue=arr[0];}this.onBlurValidation();defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"replicationvalue");}},{key:'onEnsuredataCahnge',value:function onEnsuredataCahnge(e,type,title){//ensurecodngdata=e.target.value;
var number=/^[0-9]+$/;if(e.target.value.length<3){var value=parseInt(e.target.value,10);if(isNaN(value)){ensurecodngdata="";}else if(number.test(value)&&value<=10&&value>=1||isNaN(value)){ensurecodngdata=value.toString();if(parseInt(ensurecodngparity,10)>=parseInt(ensurecodngdata,10)&&parseInt(ensurecodngdata,10)>=3){ensurecodngparity=parseInt(ensurecodngdata,10)-1;}}else{}}//StroageNodeQtyCall=true;
//defaultNodevalueChange=true
this.onWorkloadUpdate(type,title,"ensurecodngdata");}},{key:'onEnsuredataBlur',value:function onEnsuredataBlur(e,type,title){if(e.target.value===" "||e.target.value<3){ensurecodngdata="3";if(parseInt(ensurecodngparity,10)>parseInt(ensurecodngdata,10)-1){ensurecodngparity=parseInt(ensurecodngdata,10)-1;}}StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"ensurecodngdata");}},{key:'onEnsureParityCahnge',value:function onEnsureParityCahnge(e,type,title){// ensurecodngparity=e.target.value;
var number=/^[0-9]+$/;var val=parseInt(ensurecodngdata,10);if(e.target.value.length<=2){var value=parseInt(e.target.value,10);if(isNaN(value)){ensurecodngparity="";}else if(number.test(value)&&value<val&&value>=1||isNaN(value)){ensurecodngparity=value.toString();}else{ensurecodngparity=(parseInt(ensurecodngdata,10)-1).toString();}}// StroageNodeQtyCall=true;
// defaultNodevalueChange=true
this.onWorkloadUpdate(type,title,"ensurecodngparity");}},{key:'onEnsureParityBlur',value:function onEnsureParityBlur(e,type,title){if(e.target.value===""){ensurecodngparity=(parseInt(ensurecodngdata,10)-1).toString();}StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"ensurecodngparity");}},{key:'onImagesPerSecChange',value:function onImagesPerSecChange(e,type,title,nwtwkcl){//ImagesPerSec=e.target.value;
var number=/^[0-9]+$/;if(e.target.value===''){ImagesPerSec='0';e.target.value=ImagesPerSec;}//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=6){var value=parseInt(e.target.value,10);if(isNaN(value)){ImagesPerSec="";}else if(number.test(value)&&value<=999999&&value>=0||isNaN(value)){ImagesPerSec=value.toString();}else{ImagesPerSec=ensurecodngdata;}}if(nwtwkcl==="Blur"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"ImagesPerSec");}// onImagesPerSecChangeBlur(e,type,title){
//   if(e.target.value===''){
//     ImagesPerSec='1'
//   }
//   this.onWorkloadUpdate(type,title,"ImagesPerSec");
// }
// onGPUQtyChange(e){
//   GPUQty=e.target.value;
//   this.onWorkloadUpdate();
// }
},{key:'onEventsPerSecChange',value:function onEventsPerSecChange(e,type,title,nwtcal){var number=/^[0-9]+$/;if(nwtcal==="Blur"){if(e.target.value===''){EventsPerSec='1';}}else{if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){EventsPerSec="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){EventsPerSec=value.toString();}}}this.onWorkloadUpdate(type,title,"EventsPerSec");}//  onEventsPerSecChangeBlur(e,type,title){
//    if(e.target.value===''){
//     EventsPerSec='1'
//   }
//   this.onWorkloadUpdate(type,title,"EventsPerSec");
// }
// DefaultServers(title) {
//   switch (title) {
//     case "HDFS":
//     case "Scality":
//     case "Weka":
//     case "Hive":
//     case "Cassandra":
//     case "HDFS":
//     case "HDFS":
//     case "HDFS":
//     case "HDFS":
//     case "HDFS":
//     case "HDFS":
//     case "HDFS":
//   }
// }
},{key:'onSKUInformationChange',value:function onSKUInformationChange(e,type,title){SKUInformationValue=e.value;if(SKUInformationValue!=="Predefined Configuration"){StroageNodeQtyCall=true;defaultNodevalueChange=true;}else{StroageNodeQtyCall=false;//  defaultNodevalueChange = true
}this.onWorkloadUpdate(type,title,"SKUInformationValue");//this.setState({SKUInformationValue:e.value})
}},{key:'onDriveClassChange',value:function onDriveClassChange(e,type,title){DriveClassValue=e.value;StroageNodeQtyCall=true;defaultNodevalueChange=true;DriveClassChanged=true;DATADriveCapacityoptions=[];this.props.EPAInputs.Sizers.Sizer.Functions.Function.Input.map(function(val){switch(val["@Type"]){case"Drives Capacity":val.Item.map(function(capacity){// if (capacity["_DriveClass"] === DriveClassValue)
//   DATADriveCapacityoptions.push(capacity["__text"])
//Dheeraj              
if(capacity["@DriveClass"]===DriveClassValue)DATADriveCapacityoptions.push(capacity["#text"]);});break;}});this.onWorkloadUpdate(type,title,"DriveClassValue");// this.setState({DriveClassValue:e.value})
}},{key:'onDeploymentChange',value:function onDeploymentChange(e,type,title){Addservers=e.value;this.onWorkloadUpdate(type,title,"Addservers");}},{key:'onOSEnvironmentChange',value:function onOSEnvironmentChange(e,type,title){OSEnvironment=e.value;this.onWorkloadUpdate(type,title,"OSEnvironment");}},{key:'onSupportYearCountChange',value:function onSupportYearCountChange(e,type,title){SupportYearCount=e.value;this.onWorkloadUpdate(type,title,"SupportYearCount");}},{key:'onEducationCustomerChange',value:function onEducationCustomerChange(e,type,title){EducationCustomer=e.value;this.onWorkloadUpdate(type,title,"EducationCustomer");}},{key:'onNetworkTypeChange',value:function onNetworkTypeChange(e,type,title){NetworkType=e.value;this.onWorkloadUpdate(type,title,"NetworkType");}},{key:'onServerTypeChange',value:function onServerTypeChange(e,type,title){ServerType=e.value;if(ServerType==="ProLiant DL360 Gen10"){DATADrivePerServeroptions=["1","2","3","4","5","6","7","8","9","10"];DATADrivePerServer=DATADrivePerServeroptions[9];}else{if(ServerType==="ProLiant XL170r Gen10"){DATADrivePerServeroptions=["1","2","3","4"];DATADrivePerServer=DATADrivePerServeroptions[3];}}StroageNodeQtyCall=true;defaultNodevalueChange=true;this.onWorkloadUpdate(type,title,"ServerType");this.onWorkloadUpdate(type,title,"DATADrivePerServer");}},{key:'onPeakreadiopsChange',value:function onPeakreadiopsChange(e,type,title,nwtwkcl){//Peakreadiops=e.value;
var number=/^[0-9]+$/;//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){Peakreadiops="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){Peakreadiops=value.toString();}else{// EventsPerSec=ensurecodngdata
// EventsPerSec=" "
}}if(nwtwkcl==="Blur"){if(e.target.value===''){Peakreadiops='1';}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"Peakreadiops");}},{key:'onPeakwriteiopsChange',value:function onPeakwriteiopsChange(e,type,title,nwtwkcl){//Peakwriteiops=e.value;
var number=/^[0-9]+$/;//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){Peakwriteiops="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){Peakwriteiops=value.toString();}else{// EventsPerSec=ensurecodngdata
// EventsPerSec=" "
}}if(nwtwkcl==="Blur"){if(e.target.value===''){Peakwriteiops='1';}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"Peakwriteiops");}},{key:'onTotalusablestorageChange',value:function onTotalusablestorageChange(e,type,title,nwtwkcl){//Totalusablestorage=e.value;
var number=/^[0-9]+$/;//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){Totalusablestorage="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){Totalusablestorage=value.toString();}else{// EventsPerSec=ensurecodngdata
// EventsPerSec=" "
}}if(nwtwkcl==="Blur"){if(e.target.value===''){Totalusablestorage='1';}StroageNodeQtyCall=true;defaultNodevalueChange=true;}//this.onWorkloadUpdate(type,title,"Peakwriteiops");
this.onWorkloadUpdate(type,title,"Totalusablestorage");}},{key:'onPeakreadbandwdthChange',value:function onPeakreadbandwdthChange(e,type,title,nwtwkcl){// Peakreadbandwdth=e.value;
var number=/^[0-9]+$/;//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){Peakreadbandwdth="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){Peakreadbandwdth=value.toString();}else{// EventsPerSec=ensurecodngdata
// EventsPerSec=" "
}}if(nwtwkcl==="Blur"){if(e.target.value===''){Peakreadbandwdth='1';}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"Peakreadbandwdth");}},{key:'onPeakwritebandwdthChange',value:function onPeakwritebandwdthChange(e,type,title,nwtwkcl){//Peakwritebandwdth=e.value;
var number=/^[0-9]+$/;//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){Peakwritebandwdth="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){Peakwritebandwdth=value.toString();}else{// EventsPerSec=ensurecodngdata
// EventsPerSec=" "
}}if(nwtwkcl==="Blur"){if(e.target.value===''){Peakwritebandwdth='1';}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"Peakwritebandwdth");}},{key:'oncapacityrequiredChange',value:function oncapacityrequiredChange(e,type,title,nwtwkcl){var number=/^[0-9]+$/;//let val=parseInt(ensurecodngdata, 10);
if(e.target.value.length<=4){var value=parseInt(e.target.value,10);if(isNaN(value)){capacityrequired="";}else if(number.test(value)&&value<=9999&&value>=1||isNaN(value)){capacityrequired=value.toString();}else{}}if(nwtwkcl==="Blur"){if(e.target.value===''){capacityrequired='1';}StroageNodeQtyCall=true;defaultNodevalueChange=true;}this.onWorkloadUpdate(type,title,"capacityrequired");}},{key:'onNetworkSwitchvalueChange',value:function onNetworkSwitchvalueChange(e,type,title){NetworkSwitchvalue=e.value;this.onWorkloadUpdate(type,title,"NetworkSwitchvalue");}},{key:'onQuantityvalueChange',value:function onQuantityvalueChange(e,type,title){Quantityvalue=e.value;this.onWorkloadUpdate(type,title,"Quantityvalue");}},{key:'OnDIMMCapacityoptionsChange',value:function OnDIMMCapacityoptionsChange(e,type,title){DIMMCapacity=e.value;this.onWorkloadUpdate(type,title,"DIMMCapacity");}},{key:'OnDATADriveCapacityoptionsChange',value:function OnDATADriveCapacityoptionsChange(e,type,title){DATADriveCapacity=e.value;this.onWorkloadUpdate(type,title,"DATADriveCapacity");}},{key:'OnDATADrivePerServeroptionsChange',value:function OnDATADrivePerServeroptionsChange(e,type,title){DATADrivePerServer=e.value;this.onWorkloadUpdate(type,title,"DATADrivePerServer");}},{key:'OnSpareServersoptionsChange',value:function OnSpareServersoptionsChange(e,type,title){SpareServers=e.value;this.onWorkloadUpdate(type,title,"SpareServers");}},{key:'OnNumServersChange',value:function OnNumServersChange(e,type,title,nwtwkcl){var number=/^[0-9]+$/;if(nwtwkcl==="Change"){if(e.target.value.length<=2){var value=parseInt(e.target.value,10);if(isNaN(value)){NumServers="";}else if(number.test(value)&&value<=99&&value>=1||isNaN(value)){NumServers=value.toString();}}}else{if(e.target.value===''){NumServers='1';}}this.onWorkloadUpdate(type,title,"NumServers");}//  componentWillReceiveProps(nextProps, nextState){
//    if(nextProps.defaultSizerWorkload.serversList.length !==this.props.defaultSizerWorkload.serversList.length){
//      let inputs={
//                function:this.props.type,
//                service:this.props.title,
//               }
//            let pushservice=true;
//            nextProps.defaultSizerWorkload.serversList.map((ServiceName)=>{
//                if(ServiceName.serviceName===this.props.title)
//                {
//                    pushservice=false
//                }             
//            })
//              if(pushservice){
//                this.props.OnFetchServerList(inputs);
//                }  
//    }
//  }
},{key:'layercloseHive',value:function layercloseHive(){ShowHiveLayer=false;FirstServer=false;this.setState({});}},{key:'render',value:function render(){var _this16=this;//  inputs.function=this.props.type;
//   inputs.service=this.props.title;
var Deleteservers=false;Servers=[];Drives=[];MemoryList=[];OSDiskList=[];ProcList=[];var NodesQtyOptions=[];ProcFamilyList=[];var AIConfigTypeOptions=[];GPUsOptions=[];console.log(this.props);var layer="";var layerSecondService="";var layerThirdService="";var layerFourthService="";//  let ServerChangeNote1=""
//  let ServerChangeNote2=""
//  let ServerChangeNote3=""
//  let ServerChangeNote4=""
// let MaxDriveQty=" "
var AnlyOptions=[];// switch(this.props.title)
// {
//    case "HDFS":
//     noteTextOnChangeOfConfiguration = this.noteTextOnChangeOfConfiguration(this.props.title);
//     noteTextOnChangeOfConfigurationScality=''
//       break;
//     case "Scality":
//     noteTextOnChangeOfConfiguration=" "
//        noteTextOnChangeOfConfigurationScality = this.noteTextOnChangeOfConfiguration(this.props.title);
//       break;
// }
//noteTextOnChangeOfConfiguration = 
this.noteTextOnChangeOfConfiguration(this.props.title);if(this.props.workload!==undefined&&this.props.workload!==null&&this.props.EPAInputs.Sizers!==undefined){DATADriveCapacityoptions=[];this.props.EPAInputs.Sizers.Sizer.Functions.Function.Input.map(function(val){switch(val["@Type"]){case"OS Environment":OSEnvironmentoptions=val.Item;break;case"Support  Year":SupportYearCountoptions=val.Item;break;case"Network Type"://NetworkTypeoptions=val.Item;
NetworkTypeoptions=["100GbE"];break;case"Drive Per Server":if(ServerType==="ProLiant DL360 Gen10"){DATADrivePerServeroptions=val.Item;if(DATADrivePerServeroptions.indexOf(DATADrivePerServer)===-1){DATADrivePerServer=DATADrivePerServeroptions[0];}}else{if(ServerType==="ProLiant XL170r Gen10"){DATADrivePerServeroptions=["1","2","3","4"];if(DATADrivePerServeroptions.indexOf(DATADrivePerServer)===-1){DATADrivePerServer=DATADrivePerServeroptions[0];}}}break;case"Spare Servers":SpareServersoptions=val.Item;break;case"DIMM Capacity":DIMMCapacityoptions=val.Item;break;case"Drives Capacity":val.Item.map(function(capacity){//Dheeraj
// if (capacity["_DriveClass"] === DriveClassValue)
//   DATADriveCapacityoptions.push(capacity["__text"])
if(capacity["@DriveClass"]===DriveClassValue)DATADriveCapacityoptions.push(capacity["#text"]);});break;}});//Updating Values from workload to variables to render
this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this16.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this16.props.title){//service['@Selected']=this.props.isSelected;
if(service['@Selected']==="true"){isMixedStorageConfiguration=service["@mixedStorage"];//Hardware Selection
if(service.Hardware['@Server']==="HP Apollo 4200 Gen10 Server"){service.Hardware['@Server']="HPE Apollo 4200 Gen10 Server";}serverValue=service.Hardware['@Server'];processorValue=service.Hardware['@Proc'];if(service.Hardware['@ProcFamily']===undefined){service.Hardware['@ProcFamily']="Cascade Lake";}processorTypeValue=service.Hardware['@ProcFamily'];pocQtyValue=service.Hardware['@ProcQty'];datadisktypValue=service.Hardware['@DataDisk'];// if(OSDiskList.indexOf(service.Hardware['@OSDisk'])===-1 )
// {
//   service.Hardware['@OSDisk']=OSDiskList[0];
// }
// osdisktypValue = service.Hardware['@OSDisk'];
nodesQtyValue=service.Hardware['@NodesCount'];memoryValue=service.Hardware['@Memory'];//noOfDiskValue = service.Hardware['@DiskQty'];
nodeValue=service.Hardware['@NodesQty'];if(defaultNodevalueChange||service['@Type']===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]&&_this16.props.workload.UserInputs.Environments.updateDataLakeRecommendations===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){// defaultNodevalueChange=false
defaultNodevalue=service.Hardware['@NodesCount'];if(service['@Type']===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]){_this16.props.workload.UserInputs.Environments.updateDataLakeRecommendations=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}}//else{
//   defaultNodevalueChange=true
// }
//Storage Selection
if(_this16.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]||_this16.props.title==="MapR and MapR-EC"){diskcapacityvalue=service.Inputs['@Capacity'];if(parseFloat(service.Inputs['@Compression'],10)>parseFloat(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["Z" /* DATALAKE_COMPRESSION_MAXVLAUE */],10)){service.Inputs['@Compression']=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["Z" /* DATALAKE_COMPRESSION_MAXVLAUE */];compression=service.Inputs['@Compression'];var value={target:{value:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["Z" /* DATALAKE_COMPRESSION_MAXVLAUE */]}};_this16.onCompressionBlur(value,_this16.props.type,_this16.props.title);}compression=service.Inputs['@Compression'];ensurecodngdata=service.Inputs['@ErasureData'];ensurecodngparity=service.Inputs['@ErasureParity'];overhead=service.Inputs['@OverHead'];strgwrkload=service.Inputs['@StorageWL'];capacitytypevalue=service.Inputs['@Type'];if(parseFloat(service.Inputs['@Replication'],10)>parseFloat(__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_2" /* DATALAKE_REPLICATION_MAXVALUE */],10)){service.Inputs['@Replication']=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_2" /* DATALAKE_REPLICATION_MAXVALUE */];replicationvalue=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_2" /* DATALAKE_REPLICATION_MAXVALUE */];var _value3={target:{value:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_2" /* DATALAKE_REPLICATION_MAXVALUE */]}};onChangeTriggered=true;_this16.onReplicationBlur(_value3,_this16.props.type,_this16.props.title);}replicationvalue=service.Inputs['@Replication'];_this16.state.capacitytypevalueoptions=['Raw','Usable capacity '];}else if(_this16.props.title==="Scality"){ARCvalue=service.Inputs['@ARC'];Scalitydiskcapacityvalue=service.Inputs['@Capacity'];GreenLakevalue=service.Inputs['@GreenLake'];Sitesvalue=service.Inputs['@NoOfSites'];StoragePerc=service.Inputs['@StoragePerc'];NetworkSwitchvalue=service.Inputs['@NwSwitch'];Quantityvalue=service.Inputs['@NwSwitchQty'];Secondsitevalue=service.Inputs['@Replication'];Secondsiteoptions=["Yes","No"];Sitesvalueoptions=["1 (single site, most capacity)","1 (single site, most durability)","2 (two site stretched)","3 (three site stretched)"];Quantityoptions=["0","1","2","3","4","5","6","7","8","9"];GreenLakeoptions=["Yes","No"];}else if(_this16.props.type==='Streaming'){MessagesPerSec=service.Inputs['@MessagesPerSec'];}else if(_this16.props.type==="AI"){GPUvalue=service.Inputs['@GPU'];GPUQty=service.Inputs['@GPUQty'];ImagesPerSec=service.Inputs['@ImagesPerSec'];AIConfigtypevalue=service.Inputs['@ConfigType'];}else if(_this16.props.type==="IoT"){EventsPerSec=service.Inputs['@EventsPerSec'];defaultNodevalue='1';}else if(_this16.props.type==="Analytics"){Analyticsvalue=service.Inputs['@ConfigType'];Ansdiskcapacityvalue=service.Inputs['@UsableCapacity'];ContainersQty=service.Inputs['@ContainersQty'];CoresPerContainer=service.Inputs['@CoresPerContainer'];MemoryPerContainer=service.Inputs['@MemoryPerContainer'];NodelocalStorageValue=service.Inputs['@NodeStorage'];StorageNodesQty=service.Inputs['@StorageNodesQty'];Storagevalue=service.Inputs['@SCRatio'];Storagevalue1=service.Inputs['@Storage'];Storagevalue2=service.Inputs['@Compute'];StorageOptions=["Balanced Workload","IO intensive","Compute Intensive","Custom"];if(_this16.props.title==="Spark"){AnlyOptions=["Executors",'Storage Ratio'];}else{AnlyOptions=["Containers",'Storage Ratio'];}}else if(_this16.props.type==="Database"){QueryData=service.Inputs['@Capacity'];ResponseTime=service.Inputs['@NodeStorage'];if(service["@Type"]==="HBase"){if(service.Inputs['@OpsPerSec']===undefined){service.Inputs['@OpsPerSec']="1";}}ConcurrentQueries=service.Inputs['@OpsPerSec'];// DatabaseUsablecapacity = service.Inputs['@Capacity'];
}else if(_this16.props.title==="Weka"){Addservers=service.Inputs['@AddServers'];Totalusablestorage=service.Inputs['@Capacity'];DriveClassValue=service.Inputs['@DriveClass'];EducationCustomer=service.Inputs['@IsEduCustomer'];NetworkType=service.Inputs['@NetworkType'];OSEnvironment=service.Inputs['@OS'];Peakreadbandwdth=service.Inputs['@PeakReadBW'];Peakreadiops=service.Inputs['@PeakReadIOPS'];Peakwritebandwdth=service.Inputs['@PeakWriteBW'];Peakwriteiops=service.Inputs['@PeakWriteIOPS'];SKUInformationValue=service.Inputs['@SKUInfo'];ServerType=service.Hardware['@Server'];if(ServerType===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */]){service.Hardware["@ProcQty"]=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_142" /* QTY_ONE */];}else{service.Hardware["@ProcQty"]=__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_143" /* QTY_TWO */];}SupportYearCount=service.Inputs['@SupportYears'];capacityrequired=service.Inputs['@TierCapacity'];DIMMCapacity=service.Inputs['@DIMMCapacity'];DATADriveCapacity=service.Inputs['@DATADriveCapacity'];DATADrivePerServer=service.Inputs['@DATADrivePerServer'];SpareServers=service.Inputs['@SpareServers'];NumServers=service.Hardware['@NodesCount'];DriveClassList=['Mixed Use','Read Intensive'];}//for deleting servers
Deleteservers=false;NodesQtyOptions=["User Defined","Sizer Recommendation"];ProcFamilyList=[];AIConfigTypeOptions=["Training","Inference"];_this16.populateGPUOptions();if(GPUsOptions.indexOf(GPUvalue)===-1){GPUvalue=GPUsOptions[0];service.Inputs['@GPU']=GPUvalue;}EducationCustomeroptions=["Yes","No"];Addserversoptions=["Yes","No"];SKUInformationList=['Customer Requirements','Predefined Configuration'];NetworkSwitchoptions=_this16.props.sessions.inputs.Sizers.Sizer.OtherEnvirontmentDetails.NwSwitches.Scality.Item;//Sizer Recommendation
SizerRecmdtnServer=service.Recommendation['@Name'];SizerRecmdtnProcsr=service.Recommendation['@Proc'];SizerRecmdtnDisktype=service.Recommendation['@DataDisk'];SizerRecmdtnMemory=service.Recommendation['@Memory'];}else{//Hardware Selection
serverValue="";processorValue="";processorTypeValue="";pocQtyValue="";datadisktypValue="";osdisktypValue="";nodesQtyValue="";memoryValue="";noOfDiskValue="";noOfOSDiskValue="";nodeValue="";Servers=[];NodesQtyOptions=[];ProcFamilyList=[];AIConfigTypeOptions=[];GPUsOptions=[];AnlyOptions=[];//Storage Selection
diskcapacityvalue="";compression="";ensurecodngdata="";ensurecodngparity="";overhead="";replicationvalue='';strgwrkload="";capacitytypevalue="";_this16.state.capacitytypevalueoptions=[];ARCvalue="";Scalitydiskcapacityvalue='';GreenLakevalue='';StoragePerc='';Sitesvalue='';MessagesPerSec='';ImagesPerSec='';GPUvalue='';AIConfigtypevalue='';GPUQty='';EventsPerSec='';Sitesvalueoptions=[];GreenLakeoptions=[];Analyticsvalue='';Ansdiskcapacityvalue='';ContainersQty="";CoresPerContainer="";MemoryPerContainer="";NodelocalStorageValue="";StorageNodesQty='';StorageOptions="";Storagevalue='';QueryData='';ResponseTime='';ConcurrentQueries='';//DatabaseUsablecapacity = ""
EducationCustomeroptions=[];Addserversoptions=[];SKUInformationList=[];Addservers="";capacityrequired="";DriveClassValue="";EducationCustomer="";NetworkType="";OSEnvironment="";Peakreadbandwdth="";Peakreadiops="";Peakwritebandwdth="";Peakwriteiops="";SKUInformationValue="";ServerType="";SupportYearCount="";Totalusablestorage="";NetworkSwitchoptions=[];NetworkSwitchvalue="";Quantityvalue="";Secondsitevalue="";Secondsiteoptions=[];Quantityoptions=[];DIMMCapacity="";DATADriveCapacity="";DATADrivePerServer="";SpareServers="";NumServers="";OSEnvironmentoptions=[];SupportYearCountoptions=[];NetworkTypeoptions=[];DriveClassList=[];//for deleting servers
Deleteservers=true;//Sizer Recommendation
SizerRecmdtnServer="";SizerRecmdtnProcsr="";SizerRecmdtnDisktype="";SizerRecmdtnMemory="";}}});}else{if(val.Service['@Type']===_this16.props.title){// val.Service['@Selected']=this.props.isSelected;
if(val.Service['@Selected']==="true"){isMixedStorageConfiguration=val.Service["@mixedStorage"];if(_this16.props.type==="IoT"){if(val.Service.Hardware['@ServerName']===undefined){val.Service.Hardware['@ServerName']="HPE ProLiant m510-16c Server Cartridge EL1000 10G 2xSFP";}serverValue=val.Service.Hardware['@ServerName'];}else{serverValue=val.Service.Hardware['@Server'];}processorValue=val.Service.Hardware['@Proc'];if(val.Service.Hardware['@ProcFamily']===undefined){val.Service.Hardware['@ProcFamily']="Cascade Lake";}processorTypeValue=val.Service.Hardware['@ProcFamily'];pocQtyValue=val.Service.Hardware['@ProcQty'];datadisktypValue=val.Service.Hardware['@DataDisk'];//  if(OSDiskList.indexOf(val.Service.Hardware['@OSDisk'])===-1 )
//   {
//     val.Service.Hardware['@OSDisk']=OSDiskList[0];
//   }
// osdisktypValue = val.Service.Hardware['@OSDisk'];
nodesQtyValue=val.Service.Hardware['@NodesCount'];memoryValue=val.Service.Hardware['@Memory'];nodeValue=val.Service.Hardware['@NodesQty'];//noOfDiskValue = val.Service.Hardware['@DiskQty'];
//Storage Selection
diskcapacityvalue=val.Service.Inputs['@Capacity'];compression=val.Service.Inputs['@Compression'];ensurecodngdata=val.Service.Inputs['@ErasureData'];ensurecodngparity=val.Service.Inputs['@ErasureParity'];overhead=val.Service.Inputs['@OverHead'];replicationvalue=val.Service.Inputs['@Replication'];strgwrkload=val.Service.Inputs['@StorageWL'];capacitytypevalue=val.Service.Inputs['@Type'];EventsPerSec=val.Service.Inputs['@EventsPerSec'];_this16.state.capacitytypevalueoptions=['Raw','Usable capacity '];Deleteservers=false;NodesQtyOptions=["User Defined","Sizer Recommendation"];ProcFamilyList=[];AIConfigTypeOptions=["Training","Inference"];defaultNodevalue='1';//Sizer Recommendation
SizerRecmdtnServer=val.Service.Recommendation['@Name'];SizerRecmdtnProcsr=val.Service.Recommendation['@Proc'];SizerRecmdtnDisktype=val.Service.Recommendation['@DataDisk'];SizerRecmdtnMemory=val.Service.Recommendation['@Memory'];//As of now
}else{//Hardware Selection
serverValue="";processorValue="";processorTypeValue="";pocQtyValue="";datadisktypValue="";osdisktypValue="";nodesQtyValue="";memoryValue="";noOfDiskValue="";noOfOSDiskValue="";Servers=[];//Storage Selection
diskcapacityvalue="";compression="";ensurecodngdata="";ensurecodngparity="";overhead="";replicationvalue='';strgwrkload="";capacitytypevalue="";_this16.state.capacitytypevalueoptions=[];ARCvalue="";Scalitydiskcapacityvalue='';GreenLakevalue='';StoragePerc='';Sitesvalue='';EventsPerSec='';NodesQtyOptions=[];ProcFamilyList=[];AIConfigTypeOptions=[];Deleteservers=true;//Sizer Recommendation
SizerRecmdtnServer="";SizerRecmdtnProcsr="";SizerRecmdtnDisktype="";SizerRecmdtnMemory="";}}}}});if(this.props.defaultSizerWorkload.serversList!==""&&this.props.defaultSizerWorkload.serversList!==undefined&&this.props.defaultSizerWorkload.serversList!==null){this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this16.props.title&&ServiceName.Servers!==''){_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this16.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this16.props.title){if(service['@Selected']==="true"){for(var key in ServiceName.totalList){if(key===serverValue){if(IDatadiskqtynotchange&&parseInt(noOfDiskValue,10)<ServiceName.totalList[key].iDataDiskQty){noOfDiskValue=ServiceName.totalList[key].iDataDiskQty.toString();service.Hardware['@DiskQty']=noOfDiskValue;}else{noOfDiskValue=service.Hardware['@DiskQty'];}if(IOSDatadiskqtynotchange&&parseInt(noOfOSDiskValue,10)<ServiceName.totalList[key].iOSDiskQty){noOfOSDiskValue=ServiceName.totalList[key].iOSDiskQty.toString();service.Hardware['@OSDiskQty']=noOfOSDiskValue;}else{noOfOSDiskValue=service.Hardware['@OSDiskQty'];}MaxDriveQty=ServiceName.totalList[key].iMaxDrives;}if((_this16.props.type==="Streaming"||_this16.props.type==="Analytics"||_this16.props.type==="Database")&&serverValue==="Synergy 480 Gen10 Server"){if(_this16.props.title==="Yarn"&&YarnSynergyServerChanged){YarnSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(_this16.props.title==="Spark"&&SparkAnalyticsSynergyServerChanged){SparkAnalyticsSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(SparkSynergyServerChanged&&_this16.props.title==="Spark Streaming"){SparkSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(KafkaSynergyServerChanged&&_this16.props.title==="Kafka"){KafkaSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(FlinkSynergyServerChanged&&_this16.props.title==="Flink"){FlinkSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(StormSynergyServerChanged&&_this16.props.title==="Storm"){StormSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(HiveSynergyServerChanged&&_this16.props.title==="Hive"){HiveSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(CassandraSynergyServerChanged&&_this16.props.title==="Cassandra"){CassandraSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(ImpalaSynergyServerChanged&&_this16.props.title==="Impala"){ImpalaSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}if(HBaseSynergyServerChanged&&_this16.props.title==="HBase"){HBaseSynergyServerChanged=false;service.Hardware['@DiskQty']="4";noOfDiskValue="4";}}}}}});}else{if(val.Service['@Type']===_this16.props.title){if(val.Service['@Selected']==="true"){for(var key in ServiceName.totalList){if(key===serverValue){if(IDatadiskqtynotchange&&parseInt(noOfDiskValue,10)<ServiceName.totalList[key].iDataDiskQty){noOfDiskValue=ServiceName.totalList[key].iDataDiskQty.toString();val.Service.Hardware['@DiskQty']=noOfDiskValue;}else{noOfDiskValue=val.Service.Hardware['@DiskQty'];}if(IOSDatadiskqtynotchange&&parseInt(noOfOSDiskValue,10)<ServiceName.totalList[key].iOSDiskQty){noOfOSDiskValue=ServiceName.totalList[key].iOSDiskQty.toString();val.Service.Hardware['@OSDiskQty']=noOfOSDiskValue;}else{noOfOSDiskValue=val.Service.Hardware['@OSDiskQty'];}MaxDriveQty=ServiceName.totalList[key].iMaxDrives;}}}}}}});}});//if (maxlayer) {
if(this.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]||this.props.title==="Hive"||this.props.title==="Spark Streaming"||this.props.title==="Yarn"||this.props.title==="Tensorflow"||this.props.title==="MiNifi"){if(maxlayer){layerSecondService="";layerThirdService="";layerFourthService="";layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.layerclose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,'Disk Quantity requested exceeds the limit of ',maxDrivesSupported,' for the selected server.')));}}if(this.props.title==="Scality"||this.props.title==="Cassandra"||this.props.title==="Kafka"||this.props.title==="Spark"||this.props.title==="PyTorch"){if(maxlayerSecondServices){layer="";layerThirdService="";layerFourthService="";layerSecondService=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.layerclose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,'Disk Quantity requested exceeds the limit for the selected server.')));}}if(this.props.title==="Impala"||this.props.title==="Flink"){if(maxlayerthirdServices){layer="";layerSecondService="";layerFourthService="";layerThirdService=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.layerclose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,'Disk Quantity requested exceeds the limit for the selected server.')));}}if(this.props.title==="HBase"||this.props.title==="Storm"){if(maxlayerFourthServices){layer="";layerSecondService="";layerThirdService="";layerFourthService=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.layerclose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,null,'Disk Quantity requested exceeds the limit for the selected server.')));}}//}
}}//Replication Changes
var ReplicationData="";if(this.props.title==="Scality"||this.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]||this.props.title==="MapR and MapR-EC"){if(this.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]){this.props.defaultSizerWorkload.StorageCapacitytype.HDFS=capacitytypevalue;}else if(this.props.title==="MapR and MapR-EC"){this.props.defaultSizerWorkload.StorageCapacitytype.MAPR=capacitytypevalue;}if(this.props.erasureHDFS||this.props.erasureMAPR){ReplicationData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'DATA',error:'(3-10)',style:{width:'150%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',value:ensurecodngdata,onDOMChange:function onDOMChange(e){return _this16.onEnsuredataCahnge(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onEnsuredataBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'For Erasure Coding, the number of data fragments must be greater than or equal to 3 and less than or equal to 10.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'PARITY'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',value:ensurecodngparity,onDOMChange:function onDOMChange(e){return _this16.onEnsureParityCahnge(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onEnsureParityBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'For Erasure Coding, the number of parity fragments must be greater than 1 and less than (not equal to) the number of data fragments.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))));}else{if(this.props.title==="Scality"){ReplicationData='';}else{if(capacitytypevalue==="Raw"){forRawdisabled=true;}else{forRawdisabled=false;}ReplicationData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{height:'100%'},label:'Replication',error:'('+__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_3" /* DATALAKE_REPLICATION_MINVALUE */]+'-'+__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_2" /* DATALAKE_REPLICATION_MAXVALUE */]+')'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',value:replicationvalue,disabled:forRawdisabled,onDOMChange:function onDOMChange(e){return _this16.onReplicationCahnge(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onReplicationBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true,id:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_146" /* REPLICATION_ */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Number of replicas to store.','data-for':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_146" /* REPLICATION_ */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))));}}}else{ReplicationData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{height:'100%'},label:'Replication',error:'(1.0-99.99%)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',value:ensurecodngdata}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_149" /* Replication */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))));}var serviceselectedHive=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this16.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']==="Hive"){if(service['@Selected']==="true"){serviceselectedHive=true;}}});}}});var HiveLayerrdata='';if(serverValue==="ProLiant XL170r Gen10"&&serviceselectedHive){var text=" ";var note=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{fontWeight:'600',fontSize:'medium'}},'  NOTE :');text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{fontWeight:'600',fontSize:'medium'}},'  1 Node');HiveLayerrdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{fontWeight:'600',marginBottom:'0px'}},' ',note,' ',"Recommended Number of HDFS nodes with 24 SAS/SATA drives :",text));}if(ShowHiveLayer&&this.props.StringMessage!==undefined&&this.props.StringMessage!==null&&this.props.StringMessage!==''&&serviceselectedHive){var DriveText=[];DriveText=this.props.StringMessage.split(":");var _text=" ";var _note=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{fontWeight:'600',fontSize:'medium'}},'  NOTE :');_text=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Label___default.a,{style:{fontWeight:'600',fontSize:'medium'}},' ',DriveText[1]);HiveLayerrdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{fontWeight:'600',marginBottom:'0px'}},' ',_note," Recommended Number of HDFS nodes with 24 SAS/SATA drives :",' ',_text));}//Storage Selection is applicable only for Storge and Analytics
var StorageSelection=" ";if(this.props.type==="Storage"&this.props.title!=="Weka"&this.props.title!=="Scality"){if(capacitytypevalue==="Raw"){forRawdisabled=true;}else{forRawdisabled=false;}StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Storage capacity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Disk Capacity (TB)',error:'(1-999999)',style:{overflow:"hidden",width:'32.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:diskcapacityvalue,onDOMChange:function onDOMChange(e){return _this16.onDiskCapacityChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onDiskCapacityBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_13" /* DiskCapacity */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'CapacityType'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["P" /* CapacityType */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{overflow:"hidden",width:'32.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:capacitytypevalue,options:this.state.capacitytypevalueoptions,onChange:function onChange(e){return _this16.oncapacitytypevalueChange(e,_this16.props.type,_this16.props.title);}})),capacitytypevalue!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_144" /* RAW_ */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Overhead',error:'(0-100%)',style:{width:'32.5%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',disabled:forRawdisabled,value:overhead,onDOMChange:function onDOMChange(e){return _this16.onOverheadChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onOverheadBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'left',multiline:true,id:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_121" /* OVERHEAD_ */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_122" /* Overhead */],'data-for':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_121" /* OVERHEAD_ */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})))),capacitytypevalue!==__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_144" /* RAW_ */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{width:'32.5%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Compression',error:'('+__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_0" /* DATALAKE_COMPRESSION_MINVLAUE */]+'-'+__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["Z" /* DATALAKE_COMPRESSION_MAXVLAUE */]+')'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',disabled:forRawdisabled,value:compression,onDOMChange:function onDOMChange(e){return _this16.onCompressionChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onCompressionBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["Q" /* Compression */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})))),ReplicationData)));}else if(this.props.type==="Storage"&this.props.title==="Scality"){StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Storage capacity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Select Green Lake Flex Capacity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_178" /* Select_Green_Lake_Flex_Capacity */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{overflow:"hidden",width:'62%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:GreenLakevalue,options:GreenLakeoptions,onChange:function onChange(e){return _this16.onGreenLakeChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'How many sites do you want your primary data stored in?'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:Sitesvalue,options:Sitesvalueoptions,onChange:function onChange(e){return _this16.onSitesvalueChange(e,_this16.props.type,_this16.props.title);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Replication to a second site'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_150" /* Replication_to_a_second_site */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:Secondsitevalue,options:Secondsiteoptions,onChange:function onChange(e){return _this16.onSecondsitevalueChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Percent of storage containing ARC encoded objects',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:StoragePerc,onDOMChange:function onDOMChange(e){return _this16.onStoragePercChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onStoragePercChange(e,_this16.props.type,_this16.props.title,"Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Disk Capacity (TB)',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:Scalitydiskcapacityvalue,onDOMChange:function onDOMChange(e){return _this16.onScalitydiskcapacityvalue(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onScalitydiskcapacityvalueBlur(e,_this16.props.type,_this16.props.title);}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'calculated ARC(X,Y) level',style:{overflow:"hidden",width:'57%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:ARCvalue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_200" /* calculated_ARC_level */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Network Switch'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:NetworkSwitchvalue,options:NetworkSwitchoptions,onChange:function onChange(e){return _this16.onNetworkSwitchvalueChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'No. of Network Switches'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:Quantityvalue,options:Quantityoptions,onChange:function onChange(e){return _this16.onQuantityvalueChange(e,_this16.props.type,_this16.props.title);}}))),ReplicationData));}else if(this.props.type==="Analytics"){// let AnlyOptions = [];
// if (this.props.title === "Spark") {
//   AnlyOptions = ["Executors", 'Storage Ratio']
// }
// else {
//   AnlyOptions = ["Containers", 'Storage Ratio']
// }
var Info=' ';Storagevalue1disabled=true;Storagevalue2disabled=true;if(Storagevalue==="Custom"){Storagevalue1disabled=false;Storagevalue2disabled=false;Info="These workloads are distributed based on the custom ratio provided.";}else if(Storagevalue==="Balanced Workload"){Storagevalue1='1';Storagevalue2='2';Info='These workloads are distributed equally across the various job types (CPU bound, Disk I/O bound, or Network I/O bound)';}else if(Storagevalue==="IO intensive"){Storagevalue1='1';Storagevalue2='1';Info='These workload relies more on the I/O bound capacity of the cluster.';}else if(Storagevalue==="Compute Intensive"){Storagevalue1='1';Storagevalue2='3';Info='These workloads are CPU bound and are characterized by the need of a large number of CPUs and large amounts of memory to store in-process data.';}var Containerdisplay='';var forFlinkandStrom='';if(this.props.title==="Spark"||this.props.title==="Yarn"){forFlinkandStrom=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'70%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Configuration Based on',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{id:'StoraegWorkload',placeHolder:'None',value:Analyticsvalue,options:AnlyOptions,onChange:function onChange(e){return _this16.ContainerdisplayChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Node Local Storage (TB)',error:'(1-999)',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:NodelocalStorageValue,onDOMChange:function onDOMChange(e){return _this16.onNodelocalStorageValueChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onNodelocalStorageValueChangeBlur(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Total Disk storage needed on the local nodes. Number of local SSD drives needed for configuration.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))));}var AnInfo='';if(Analyticsvalue==='Containers'){AnInfo="Number of Total YARN containers for the cluster";}else{AnInfo="Number of Spark Executors";}if((Analyticsvalue==='Containers'||Analyticsvalue==='Executors')&&(this.props.title==="Spark"||this.props.title==="Yarn")){Containerdisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'90%',padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Number of '+Analyticsvalue,error:'(1-999)',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:ContainersQty,onDOMChange:function onDOMChange(e){return _this16.onContainersQtyChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onContainersQtyChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':AnInfo,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Cores Per  '+Analyticsvalue,style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:CoresPerContainer,onDOMChange:function onDOMChange(e){return _this16.onCoresPerContainerChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onCoresPerContainerChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'No. of virtual CPU cores per container',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Memory Per  '+Analyticsvalue+' (GB)',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:MemoryPerContainer,onDOMChange:function onDOMChange(e){return _this16.onMemoryPerContainerChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onMemoryPerContainerChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Amount of virtual memory per Map/Reduce task (in GB)',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))));}else if(Analyticsvalue==='Storage Ratio'&&(this.props.title==="Spark"||this.props.title==="Yarn")){Containerdisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{padding:'10px',width:'90%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'90%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Number of Storage Nodes',error:'(1-999)',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:StorageNodesQty,onDOMChange:function onDOMChange(e){return _this16.onStorageNodesQtyChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onStorageNodesQtyChange(e,_this16.props.type,_this16.props.title,"Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Storage to Compute Ratio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{multiline:true,place:'right',id:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_173" /* STORAGE_TO_COMPUTE_RATIO */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':Info,'data-for':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_173" /* STORAGE_TO_COMPUTE_RATIO */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{id:'StoraegWorkload',placeHolder:'None',value:Storagevalue,options:StorageOptions,onChange:function onChange(e){return _this16.onStorageOptionsChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{className:'Storageanalytics',value:Storagevalue1,disabled:Storagevalue1disabled,onDOMChange:function onDOMChange(e){return _this16.onStoragevalueCahnge(e,"value1",_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onStoragevalueCahngeBlur(e,"value1",_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'StorageanalyticsColon'},':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{className:'Storageanalytics',value:Storagevalue2,disabled:Storagevalue2disabled,onDOMChange:function onDOMChange(e){return _this16.onStoragevalueCahnge(e,"value2",_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onStoragevalueCahngeBlur(e,"value2",_this16.props.type,_this16.props.title,"Blur");}}))));}StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Storage capacity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'95%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'HDFS Data Size',error:'(1-999)',style:{overflow:"hidden",width:'50%',display:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:Ansdiskcapacityvalue,onDOMChange:function onDOMChange(e){return _this16.onAnsdiskcapacityvalue(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onAnsdiskcapacityvalue(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Additional storage will be added to HDFS service.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),forFlinkandStrom)),Containerdisplay);}else if(this.props.type==="Database"){//let OPSlabel='Operations Per Sec'
var OPSlabel='Queries Per Minute';var OPSdiabled="none";var Hivedisabled="none";var HiveError="(1-999999)";var wdth="33%";if(this.props.title==='Hive'){OPSlabel='Queries Per Minute';OPSdiabled="visible";OPSminvalue='1';Hivedisabled="visible";}else if(this.props.title==='HBase'){OPSlabel='Operations per Sec(In Thousands)';OPSdiabled="visible";OPSminvalue='1';HiveError="(1-999999)";HiveLayerrdata='';wdth="45%";}else{HiveLayerrdata='';}StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:OPSlabel,error:HiveError,style:{overflow:"hidden",display:OPSdiabled,width:wdth}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:ConcurrentQueries,onDOMChange:function onDOMChange(e){return _this16.onConcurrentQueriesChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onConcurrentQueriesChange(e,_this16.props.type,_this16.props.title,"Blur");},min:OPSminvalue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Number of operations to be performed.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Database Size (TB)',error:'(1-999)',style:{overflow:"hidden",display:Hivedisabled,width:"33%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:QueryData,onDOMChange:function onDOMChange(e){return _this16.onQueryDataChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onQueryDataChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Additional Storage will be added to HDFS service.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Node Local Storage (TB)',error:'(1-999)',style:{width:"33%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:ResponseTime,onDOMChange:function onDOMChange(e){return _this16.onResponseTimeChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onResponseTimeChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Total disk storage needed on the local nodes. Number of local drive storage (SSD) needed for the configuration.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})))),HiveLayerrdata));}else if(this.props.type==="Streaming"){StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'48%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Thousands of Message (Message size 250 bytes)',error:'(0-99999)',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:MessagesPerSec,onDOMChange:function onDOMChange(e){return _this16.onMessagesPerSecChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onMessagesPerSecChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Number of messages to be processed in thousands.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))))));}else if(this.props.type==="AI"){// this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
//   if (ServiceName.serviceName === this.props.title && ServiceName.Servers !== '') {
//     for (let key in ServiceName.totalList) {
//       if (key === serverValue) {
//         GPUsOptions = ServiceName.totalList[key].GPUList
//       }
//     }
//   }
// })
StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processing Images per Sec',error:'(0-999999)',style:{overflow:"hidden",width:'53%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:ImagesPerSec,onDOMChange:function onDOMChange(e){return _this16.onImagesPerSecChange(e,_this16.props.type,_this16.props.title);},onBlur:function onBlur(e){return _this16.onImagesPerSecChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Number of images need to be processed.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Configuration Type',style:{width:'32%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{id:'StoraegWorkload',placeHolder:'None',value:AIConfigtypevalue,options:AIConfigTypeOptions,onChange:function onChange(e){return _this16.onAIConfigtypevalueChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'GPUs',style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{id:'StoraegWorkload',placeHolder:'None',value:GPUvalue,options:GPUsOptions,onChange:function onChange(e){return _this16.onGPUvalueChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'No. of GPUs',style:{overflow:"hidden",width:'23%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',disabled:'true',value:GPUQty}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Number of GPUs need to be configured',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))))));}else if(this.props.type==="IoT"){StorageSelection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'33%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Thousands of Events Per Sec',style:{overflow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'StoraegWorkload',placeHolder:'None',value:EventsPerSec,onDOMChange:function onDOMChange(e){return _this16.onEventsPerSecChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onEventsPerSecChange(e,_this16.props.type,_this16.props.title,"Blur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Process thousands of events per sec',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))))));}var Wekaoptional='';var Wekaoptionalone='';if(SKUInformationValue==='Predefined Configuration'){Wekaoptionalone=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'71%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'DIMM Capacity(GB)',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:DIMMCapacity,options:DIMMCapacityoptions,onChange:function onChange(e){return _this16.OnDIMMCapacityoptionsChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Data Drive Capacity(TB)',style:{width:'59%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:DATADriveCapacity,options:DATADriveCapacityoptions,onChange:function onChange(e){return _this16.OnDATADriveCapacityoptionsChange(e,_this16.props.type,_this16.props.title);}})));Wekaoptional=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Data Drive Per Server',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:DATADrivePerServer,options:DATADrivePerServeroptions,onChange:function onChange(e){return _this16.OnDATADrivePerServeroptionsChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Spare Servers',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:SpareServers,options:SpareServersoptions,onChange:function onChange(e){return _this16.OnSpareServersoptionsChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Number of Servers',style:{width:'59%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:NumServers,onDOMChange:function onDOMChange(e){return _this16.OnNumServersChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.OnNumServersChange(e,_this16.props.type,_this16.props.title,"Blur");}})));}else if(SKUInformationValue==='Customer Requirements'&&DriveClassValue==='Mixed Use'){Wekaoptionalone=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'71%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Peak Read IOPS(Millions)',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Peakreadiops,onDOMChange:function onDOMChange(e){return _this16.onPeakreadiopsChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onPeakreadiopsChange(e,_this16.props.type,_this16.props.title,"Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Peak Read Bandwidth(GB/s)',style:{width:'59%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Peakreadbandwdth,onDOMChange:function onDOMChange(e){return _this16.onPeakreadbandwdthChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onPeakreadbandwdthChange(e,_this16.props.type,_this16.props.title,"Blur");}})));Wekaoptional=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Total Usable Storage(Terabytes)',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Totalusablestorage,onDOMChange:function onDOMChange(e){return _this16.onTotalusablestorageChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onTotalusablestorageChange(e,_this16.props.type,_this16.props.title,"Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Peak write IOPS(Millions)',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Peakwriteiops,onDOMChange:function onDOMChange(e){return _this16.onPeakwriteiopsChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onPeakwriteiopsChange(e,_this16.props.type,_this16.props.title,"Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Peak Write Bandwidth(GB/s)',style:{width:'59%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Peakwritebandwdth,onDOMChange:function onDOMChange(e){return _this16.onPeakwritebandwdthChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onPeakwritebandwdthChange(e,_this16.props.type,_this16.props.title,"Blur");}})));}else if(SKUInformationValue==='Customer Requirements'&&DriveClassValue==='Read Intensive'){Wekaoptionalone=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'71%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Peak Read IOPS(Millions)',style:{width:'41%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Peakreadiops,onDOMChange:function onDOMChange(e){return _this16.onPeakreadiopsChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onPeakreadiopsChange(e,_this16.props.type,_this16.props.title,"Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Peak Read Bandwidth(GB/s)',style:{width:'59%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Peakreadbandwdth,onDOMChange:function onDOMChange(e){return _this16.onPeakreadbandwdthChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onPeakreadbandwdthChange(e,_this16.props.type,_this16.props.title,"Blur");}})));Wekaoptional=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Total Usable Storage(Terabytes)',style:{width:'29%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:Totalusablestorage,onDOMChange:function onDOMChange(e){return _this16.onTotalusablestorageChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onTotalusablestorageChange(e,_this16.props.type,_this16.props.title,"Blur");}})));}var Sizerrecomd='';/*Changes by Vinay, changed the postion of comparision operations, for CID:10197 */if(this.props.defaultSizerWorkload.serversList!==""&&this.props.defaultSizerWorkload.serversList!==undefined&&this.props.defaultSizerWorkload.serversList.length!==0&&this.props.defaultSizerWorkload.serversList!==null){this.props.defaultSizerWorkload.serversList.map(function(ServiceName){if(ServiceName.serviceName===_this16.props.title&&ServiceName.Servers!==''){for(var key in ServiceName.totalList){if(key===serverValue){var tempDrives;var orignalValue;var tempOsDisk;var osIndex;(function(){MemoryList=[];var supportedDriveslist=[];if(Array.isArray(_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service)){_this16.state.dataDriveType=_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this16.props.title;})[0].Hardware["@dataDriveType"];}else{_this16.state.dataDriveType=_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.Hardware["@dataDriveType"];}if(_this16.state.dataDriveConsolidatedOptions.length==0&&_this16.state.dataDriveType===""){ServiceName.totalList[key].DataDiskList.map(function(x){supportedDriveslist.push(x.StrDrive);x.Types.map(function(y){if(_this16.state.dataDriveConsolidatedOptions.indexOf(y)===-1){_this16.state.dataDriveConsolidatedOptions.push(y);}});});if(Array.isArray(_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service)){_this16.state.dataDriveType=_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this16.props.title;})[0].Hardware["@dataDriveType"];if(_this16.state.dataDriveType===""){_this16.state.dataDriveType=_this16.state.dataDriveConsolidatedOptions[0];_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this16.props.title;})[0].Hardware["@dataDriveType"]=_this16.state.dataDriveType;}}else{_this16.state.dataDriveType=_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.Hardware["@dataDriveType"];if(_this16.state.dataDriveType===""){_this16.state.dataDriveType=_this16.state.dataDriveConsolidatedOptions[0];_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.Hardware["@dataDriveType"]=_this16.state.dataDriveType;}}}if(supportedDriveslist.length>0&&supportedDriveslist.indexOf(datadisktypValue)===-1){datadisktypValue=supportedDriveslist[0];if(Array.isArray(_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service)){_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.filter(function(x){return x["@Type"]===_this16.props.title;})[0].Hardware['@DataDisk']=datadisktypValue;}else{_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(x){return x["@Type"]===_this16.props.type;})[0].Service.Hardware['@DataDisk']=datadisktypValue;}}//Drives = this.populateDataDriveoptions(ServiceName.totalList[key].DataDiskList)
_this16.populateDataDriveoptions();tempDrives=[];Drives.map(function(drive){if(drive.indexOf("#MS")>-1&&drive.indexOf(datadisktypValue)>-1&&recommDrive){var index=drive.indexOf('#');datadisktypValue=drive.slice(0,index).trim();recommDrive=false;}var driveIndex=drive.indexOf("#");if(drive.indexOf("#")>-1){tempDrives.push(drive.slice(0,driveIndex).trim());}});Drives=tempDrives;if(Drives.indexOf(datadisktypValue)===-1&&_this16.props.title!=="Weka"){datadisktypValue=Drives[0];_this16.textOnConfigurationChange(_this16.props.title,"DataDisk",datadisktypValue);}if(_this16.props.type!=="Func"){//before wrote for IOT
for(var proctype in ServiceName.totalList[key].ProcessorList){if(ProcFamilyList.indexOf(proctype)===-1){ProcFamilyList.push(proctype);}if(proctype===processorTypeValue){var _loop=function _loop(_proc5){if(recommProc&&(_proc5.indexOf("#MS")>-1||_proc5.indexOf("#null")>-1)){var _index=_proc5.indexOf('#');processorValue?'':processorValue=_proc5.slice(0,_index).trim();recommProc=false;}orignalValue=_proc5;if(_proc5.indexOf(processorValue)>-1){orignalValue=_proc5;}var index=_proc5.indexOf('#');_proc5=_proc5.slice(0,index).trim();if(ProcList.indexOf(_proc5)===-1){ProcList.push(_proc5);}MemoryList=ServiceName.totalList[key].ProcessorList[proctype][orignalValue];var memIndex=void 0;var tempMemArr=[];if(MemoryList){MemoryList.map(function(mem){if(!memoryValue&&mem.indexOf("#MS")>-1){var _index2=mem.indexOf('#');memoryValue=mem.slice(0,_index2).trim();}memIndex=mem.indexOf("#");if(mem.indexOf("#")>-1){tempMemArr.push(mem.slice(0,memIndex).trim());}});MemoryList=tempMemArr;}// if (proc === processorValue) {
//   MemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
//   if(MemoryList.indexOf(memoryValue) === -1){
//     memoryValue=MemoryList[0]
//   }
// }
proc=_proc5;};for(var proc in ServiceName.totalList[key].ProcessorList[proctype]){_loop(proc);}if(ProcList.indexOf(processorValue)===-1){_this16.textOnConfigurationChange(_this16.props.title,"Processor",processorValue);processorValue=ProcList[0];}//if (proc === processorValue) {
if(MemoryList.indexOf(memoryValue)===-1){_this16.textOnConfigurationChange(_this16.props.title,"Memory",memoryValue);memoryValue=MemoryList[0];}//}
}}}else{for(var _proc6 in ServiceName.totalList[key].ProcessorList[processorTypeValue]){if(ProcList.indexOf(_proc6)===-1){ProcList.push(_proc6);}if(_proc6===processorValue){MemoryList=ServiceName.totalList[key].ProcessorList[processorTypeValue][_proc6];}}}if(ServiceName.totalList[key].OSDiskList.length!==0){OSDiskList=ServiceName.totalList[key].OSDiskList;_this16.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this16.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this16.props.title){if(service['@Selected']==="true"){osdisktypValue=service.Hardware['@OSDisk'];}}});}}});tempOsDisk=[];OSDiskList=ServiceName.totalList[key].OSDiskList;//osdisktypValue ='';
OSDiskList.map(function(osDisk){if(osDisk.indexOf("#MS")>-1&&recommOSDisk){var index=osDisk.indexOf('#');osdisktypValue=osDisk.slice(0,index).trim();recommOSDisk=false;}osIndex=osDisk.indexOf("#");tempOsDisk.push(osDisk.slice(0,osIndex).trim());});OSDiskList=tempOsDisk;if(OSDiskList.indexOf(osdisktypValue)===-1){_this16.textOnConfigurationChange(_this16.props.title,"OSDisk",osdisktypValue);osdisktypValue=OSDiskList[0];}}if(serverValue==="Synergy 480 Gen10 Server"&&processorValue.indexOf("M")!==4&&processorValue.indexOf("L")!==4&&MemoryList.indexOf("3072 GB")!==-1){MemoryList.pop();}})();}_this16.pushToServersList(key);}}});if(Deleteservers){Servers=[];Sizerrecomd="";}else{Sizerrecomd=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Sizer Recommendation:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{margin:"0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px'}},SizerRecmdtnServer,' / ',SizerRecmdtnProcsr,' / ',SizerRecmdtnMemory,' / ',SizerRecmdtnDisktype,' / ',defaultNodevalue,'-Nodes'));}this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this16.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this16.props.title){//service['@Selected']=this.props.isSelected;
if(service['@Selected']==="true"){service.Hardware['@Proc']=processorValue;service.Hardware['@Memory']=memoryValue;service.Hardware['@DataDisk']=datadisktypValue;service.Hardware['@OSDisk']=osdisktypValue;}}});}else{if(val.Service['@Type']===_this16.props.title){if(val.Service['@Selected']==="true"){val.Service.Hardware['@Proc']=processorValue;val.Service.Hardware['@Memory']=memoryValue;val.Service.Hardware['@DataDisk']=datadisktypValue;val.Service.Hardware['@OSDisk']=osdisktypValue;}}}}});}else{var dup=[];dup=this.props.DuplicateOSlist;OSDiskList=dup;}if(OSDiskList.length==0){OSDiskList=this.props.DuplicateOSlist;}if(OSDiskList!==undefined&&OSDiskList.length!==0){this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']===_this16.props.type){if(Array.isArray(val.Service)){val.Service.filter(function(service){if(service['@Type']===_this16.props.title){if(service['@Selected']==="true"){//OSDisks Selection
if(OSDiskList.indexOf(service.Hardware['@OSDisk'])===-1){_this16.textOnConfigurationChange(_this16.props.title,"OSDisk",service.Hardware['@OSDisk']);service.Hardware['@OSDisk']=OSDiskList[0];}osdisktypValue=service.Hardware['@OSDisk'];}else{osdisktypValue="";OSDiskList=[];}}});}else{if(val.Service['@Type']===_this16.props.title){// val.Service['@Selected']=this.props.isSelected;
if(val.Service['@Selected']==="true"){if(OSDiskList.indexOf(val.Service.Hardware['@OSDisk'])===-1){val.Service.Hardware['@OSDisk']=OSDiskList[0];}osdisktypValue=val.Service.Hardware['@OSDisk'];}else{osdisktypValue="";OSDiskList=[];}}}}});}var Loadingdata='';if(this.props.isLoading){var Data="Please wait while fetching os disks.";// if(firstTime=true)
// {
//    firstTime=false
//      Data=" Please wait while Initializing."
// }else{
//    Data=" Please wait while Calculating the Node Count."
// }
Loadingdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},Data)));}if(this.props.isLoadingServers){Loadingdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},"Please wait while fetching Default values.")));}var Content="";if(nodeValue==="User Defined"){this.state.NodeQtyvisible=false;}else{this.state.NodeQtyvisible=true;}// if((DataDiskChanged || ProcessorChanged) && !this.props.isLoadingServers &&  !this.props.isLoading){
//    if (this.props.title === "HDFS" || this.props.title === "Hive" || this.props.title === "Spark Streaming" || this.props.title === "Yarn" || this.props.title === "Tensorflow" || this.props.title === "MiNifi") {
//      ServerChangeNote2=""
//      ServerChangeNote3=""
//      ServerChangeNote4=""
//       ServerChangeNote1=<Layer style={{ zIndex: '500 !important' }}>
//           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
//             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
//               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
//             </Box>
//             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
//               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
//             </Box>
//           </Box>
//           <Box style={{ padding: "10px" }}>
//             <Paragraph>Note:</Paragraph>
//           </Box>
//         </Layer>
//       }else if (this.props.title === "Scality" || this.props.title === "Cassandra" || this.props.title === "Kafka" || this.props.title === "Spark" || this.props.title === "PyTorch") {
//         ServerChangeNote1=""
//      ServerChangeNote3=""
//      ServerChangeNote4=""
//            ServerChangeNote2=<Layer style={{ zIndex: '500 !important' }}>
//           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
//             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
//               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
//             </Box>
//             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
//               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
//             </Box>
//           </Box>
//           <Box style={{ padding: "10px" }}>
//             <Paragraph>Note:</Paragraph>
//           </Box>
//         </Layer>
//       }
//       else if (this.props.title === "Impala" || this.props.title === "Flink"){
//          ServerChangeNote1=""
//      ServerChangeNote2=""
//      ServerChangeNote4=""
//            ServerChangeNote3=<Layer style={{ zIndex: '500 !important' }}>
//           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
//             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
//               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
//             </Box>
//             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
//               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
//             </Box>
//           </Box>
//           <Box style={{ padding: "10px" }}>
//             <Paragraph>Note:</Paragraph>
//           </Box>
//         </Layer>
//       }else if (this.props.title === "HBase" || this.props.title === "Storm"){
//         ServerChangeNote1=""
//      ServerChangeNote2=""
//      ServerChangeNote3=""
//            ServerChangeNote4=<Layer style={{ zIndex: '500 !important' }}>
//           <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
//             <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
//               <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Alert</Heading>
//             </Box>
//             <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={this.onServerChangeLayerClose.bind(this)} >
//               <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
//             </Box>
//           </Box>
//           <Box style={{ padding: "10px" }}>
//             <Paragraph>Note:</Paragraph>
//           </Box>
//         </Layer>
//       }
//         }
if(this.props.title!=="Weka"){var exceptIOT='';var Iotwidth="45%";if(processorTypeValue!==NA_){Iotwidth="30%";exceptIOT=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processor Family',error:this.state.DiskCapacityerror,style:{width:'20%',minWidth:'147px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:ProcFamilyList,value:processorTypeValue,onChange:function onChange(e){return _this16.onProcessorFamilyChange(e,_this16.props.type,_this16.props.title);}}));}Content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),StorageSelection,layer,layerSecondService,layerThirdService,layerFourthService,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Hardware Selection'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'95%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Server',error:this.state.DiskCapacityerror,style:{width:Iotwidth,minWidth:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:Servers,value:serverValue,onChange:function onChange(e){return _this16.onServerChange(e,_this16.props.type,_this16.props.title);}})),exceptIOT,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Processor',error:this.state.DiskCapacityerror,style:{width:'25%',minWidth:'127px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:ProcList,value:processorValue,onChange:function onChange(e){return _this16.onProcessorChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Proc Qty',style:{width:'12%',minWidth:'110px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:procQuantity,value:pocQtyValue,onChange:function onChange(e){return _this16.onProcQtyChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Memory',style:{width:'13%',minWidth:'141px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:MemoryList,value:memoryValue,onChange:function onChange(e){return _this16.onMemoryChange(e,_this16.props.type,_this16.props.title);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__DataDrive_js__["a" /* default */],{Drives:Drives,dataDiskValue:datadisktypValue,type:this.props.type,title:this.props.title,onDataDiskChange:this.onDataDiskChange,noOfDisksValue:noOfDiskValue,onNoOfDisksChange:this.onNoOfDisksChange,dataDriveType:this.state.dataDriveType,onDatadriveTypeChange:this.onDatadriveTypeChange,renderTable:this.renderTable,onAddingDataDisk:this.onAddingDataDisk,dataDriveConsolidatedOptions:this.state.dataDriveConsolidatedOptions,isMixedStorage:isMixedStorageConfiguration,enableADDButton:this.state.enableADDButton,workloadType:__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'OS Disk',error:this.state.DiskCapacityerror},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:OSDiskList,value:osdisktypValue,onChange:function onChange(e){return _this16.onOSDiskChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'No. of OS Disks'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',value:noOfOSDiskValue,onDOMChange:function onDOMChange(e){return _this16.onNoOfOSDisksChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.onNoOfOSDisksChange(e,_this16.props.type,_this16.props.title,"Blur");}})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'70%',paddingLeft:"9px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Nodes Quantity',style:{width:'44%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{className:'NodeSelect',placeHolder:'None',options:NodesQtyOptions,value:nodeValue,onChange:function onChange(e){return _this16.NodeQtycahnge(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',alignContent:'center',align:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'UserDefined',hidden:this.state.NodeQtyvisible,value:nodesQtyValue,onBlur:function onBlur(e){return _this16.onNodevalueBlur(e,_this16.props.type,_this16.props.title);},style:{width:'44%'},onDOMChange:function onDOMChange(e){return _this16.onNodevalueChange(e,_this16.props.type,_this16.props.title);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',hidden:this.state.NodeQtyvisible,style:{marginLeft:"10px",fontWeight:'600'}},"Minimun Nodes required:"+defaultNodevalue))),this.props.title===__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["_7" /* DATA_LAKE */]?_noteTextOnChangeOfConfiguration:"",this.props.title==="Scality"?noteTextOnChangeOfConfigurationScality:"",this.props.title==="PyTorch"?noteTextOnChangeOfConfigurationPyTorch:"",this.props.title==="Weka"?noteTextOnChangeOfConfigurationWeka:"",this.props.title==="Hive"?noteTextOnChangeOfConfigurationHive:"",this.props.title==="Cassandra"?noteTextOnChangeOfConfigurationCassandra:"",this.props.title==="Impala"?noteTextOnChangeOfConfigurationImpala:"",this.props.title==="HBase"?noteTextOnChangeOfConfigurationHBase:"",this.props.title==="Spark Streaming"?noteTextOnChangeOfConfigurationSparkStreaming:"",this.props.title==="Kafka"?noteTextOnChangeOfConfigurationKafka:"",this.props.title==="Flink"?noteTextOnChangeOfConfigurationFlink:"",this.props.title==="Storm"?noteTextOnChangeOfConfigurationStorm:"",this.props.title==="Yarn"?noteTextOnChangeOfConfigurationYarn:"",this.props.title==="Spark"?noteTextOnChangeOfConfigurationSpark:"",this.props.title==="Tensorflow"?noteTextOnChangeOfConfigurationTensorflow:"",this.props.title==="MiNifi"?noteTextOnChangeOfConfigurationMiNifi:"",Sizerrecomd));}else{var weakinfo="";//ServerType=Servers
if(this.state.SKUInformationValue==="Predefined Configuration"){weakinfo="Sizing using selected hardware configuration and server count.";}else{weakinfo="Recommend using total usable storage (TB), read/write IOPs (millions) and read/write bandwidth (GB/s).";}Content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{overflow:'auto'}},layer,layerSecondService,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{style:{padding:"10px",overflow:'auto',width:'100%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Do you expect to add servers to this deployment?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["n" /* Add_servers_to_this_deployment */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),error:this.state.DiskCapacityerror},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:Addserversoptions,value:Addservers,onChange:function onChange(e){return _this16.onDeploymentChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Select how you will specify BOM and SKU information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_23__Redux_action_types_EPAConstants_js__["u" /* BOM_and_SKU_information */],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),error:this.state.DiskCapacityerror},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:SKUInformationList,value:SKUInformationValue,onChange:function onChange(e){return _this16.onSKUInformationChange(e,_this16.props.type,_this16.props.title);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'OS Environment',style:{width:'35%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:OSEnvironment,options:OSEnvironmentoptions,onChange:function onChange(e){return _this16.onOSEnvironmentChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Support Year Count',style:{width:'35%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:SupportYearCount,options:SupportYearCountoptions,onChange:function onChange(e){return _this16.onSupportYearCountChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Is this an Education or Government Customer',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:EducationCustomer,options:EducationCustomeroptions,onChange:function onChange(e){return _this16.onEducationCustomerChange(e,_this16.props.type,_this16.props.title);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{width:'100%'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Network Type',style:{width:'35%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:NetworkType,options:NetworkTypeoptions,onChange:function onChange(e){return _this16.onNetworkTypeChange(e,_this16.props.type,_this16.props.title);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Tiering capacity required',style:{width:'35%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{placeHolder:'None',style:{paddingLeft:'25px'},value:capacityrequired,onDOMChange:function onDOMChange(e){return _this16.oncapacityrequiredChange(e,_this16.props.type,_this16.props.title,"Change");},onBlur:function onBlur(e){return _this16.oncapacityrequiredChange(e,_this16.props.type,_this16.props.title,"onBlur");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Additional Weka tiering capacity license needed in addition to usable capacity.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Server Type',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',value:ServerType,options:Servers,onChange:function onChange(e){return _this16.onServerTypeChange(e,_this16.props.type,_this16.props.title);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Drive Class ',style:{width:'29%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Select___default.a,{placeHolder:'None',options:DriveClassList,value:DriveClassValue,onChange:function onChange(e){return _this16.onDriveClassChange(e,_this16.props.type,_this16.props.title);}})),Wekaoptionalone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},Wekaoptional)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null),Sizerrecomd));}var Synergyflag=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']!=="Master Node"&&val['@Type']!=="Gateway Node"){if(Array.isArray(val.Service)){val.Service.filter(function(service){// if (service['@Type'] === this.props.title) {
if(service['@Selected']==="true"&&service.Hardware['@Server'].indexOf("Synergy")!==-1){Synergyflag=true;}//  }
});}else{}}});if(!Synergyflag&&SynergyServerChanged){SynergyServerChanged=false;this.props.workload.UserInputs.Environments.Functions.Function.filter(function(val){if(val['@Type']==="Master Node"){val.Service.Hardware['@DataDisk']="HPE 900GB 12G SAS 15K 2.5in SC DS HDD";val.Service.Hardware['@DiskQty']="8";val.Service.Hardware['@Memory']="128 GB";val.Service.Hardware['@NodesCount']="3";val.Service.Hardware['@NodesQty']="Sizer Recommendation";val.Service.Hardware['@OSDisk']="HPE 480GB SATA MU 2.5in SC 2.5in DS SSD";val.Service.Hardware['@OSDiskQty']="2";val.Service.Hardware['@Proc']="4210 / 2.2 GHz / 10 Cores / 55 SpecInt";val.Service.Hardware['@ProcFamily']="Cascade Lake";val.Service.Hardware['@ProcQty']="2";val.Service.Hardware['@Server']="ProLiant DL360 Gen10";}else if(val['@Type']==="Gateway Node"){val.Service.Hardware['@DataDisk']="HPE 900GB 12G SAS 15K 2.5in SC DS HDD";val.Service.Hardware['@DiskQty']="1";val.Service.Hardware['@Memory']="128 GB";val.Service.Hardware['@NodesCount']="1 Per Rack";val.Service.Hardware['@NodesQty']="Sizer Recommendation";val.Service.Hardware['@OSDisk']="HPE 480GB SATA MU 2.5in SC 2.5in DS SSD";val.Service.Hardware['@OSDiskQty']="2";val.Service.Hardware['@Proc']="4210 / 2.2 GHz / 10 Cores / 55 SpecInt";val.Service.Hardware['@ProcFamily']="Cascade Lake";val.Service.Hardware['@ProcQty']="2";val.Service.Hardware['@Server']="ProLiant DL360 Gen10";}else{}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{position:'relative',width:'97%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_tooltip___default.a,{place:'right',multiline:true}),serverChangeConfirmationlayer,Content,Loadingdata);}}]);return Serverconfig;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{// isLoading:state.sizerWorkload.isLoading,
// Functions:state.sizerWorkload.serversList.workload.WorkLoad.UserInputs.Environments.Functions,
workload:state.sizerWorkload.workload,isLoading:state.sizerWorkload.isLoading,isLoadingServers:state.sizerWorkload.isLoadingServers,//:state.sizerWorkload.workload.Workload.UserInputs.Environments.Functions,
defaultSizerWorkload:state.sizerWorkload,sessions:state.sessions.sessionDefaults,activeSession:state.sessions.activeSession,EPAInputs:state.sessions.sessionDefaults.inputs,DuplicateOSlist:state.sizerWorkload.duplicateOSlist,StringMessage:state.sizerWorkload.workload.UserInputs.Environments.strmessage// StringMessage:state.sessions.activeSession.strmessage,
//SelectedService:state.sizerWorkload.title,
//SelectedService:state.sessions.activeSession.title,
};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnFetchNodeQty:function OnFetchNodeQty(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__Redux_actions_epaActions__["j" /* fetchNodeQty */])(value));},OnGetARCValue:function OnGetARCValue(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__Redux_actions_epaActions__["o" /* getARCValue */])(value));},OnGetOSDiskList:function OnGetOSDiskList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__Redux_actions_epaActions__["r" /* getosdisklist */])(value));},updateError:function updateError(errorMsg){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["p" /* errorValidataion */])(errorMsg));},OnFetchServerList:function OnFetchServerList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__Redux_actions_epaActions__["k" /* fetchServerList */])(value));},OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["W" /* toggleSizeButton */])(value));},RecallAnalyticsandDatabaseNodeQty:function RecallAnalyticsandDatabaseNodeQty(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__Redux_actions_epaActions__["w" /* recallAnalyticsandDatabasenodeQty */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Serverconfig));

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(556);
__webpack_require__(562);
__webpack_require__(564);
module.exports = __webpack_require__(99).Array;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(41);
var $includes = __webpack_require__(288)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(184)('includes');


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(100);
var document = __webpack_require__(67).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(67);
var hide = __webpack_require__(178);
var has = __webpack_require__(131);
var SRC = __webpack_require__(181)('src');
var $toString = __webpack_require__(559);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(99).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(182)('native-function-to-string', Function.toString);


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(289);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(183);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(41);
var flattenIntoArray = __webpack_require__(291);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(133);
var aFunction = __webpack_require__(132);
var arraySpeciesCreate = __webpack_require__(293);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(184)('flatMap');


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(100);
var isArray = __webpack_require__(292);
var SPECIES = __webpack_require__(185)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(41);
var flattenIntoArray = __webpack_require__(291);
var toObject = __webpack_require__(68);
var toLength = __webpack_require__(133);
var toInteger = __webpack_require__(183);
var arraySpeciesCreate = __webpack_require__(293);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(184)('flatten');


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(566);
__webpack_require__(571);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
module.exports = __webpack_require__(99).Object;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(41);
var ownKeys = __webpack_require__(567);
var toIObject = __webpack_require__(101);
var gOPD = __webpack_require__(186);
var createProperty = __webpack_require__(570);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(568);
var gOPS = __webpack_require__(569);
var anObject = __webpack_require__(284);
var Reflect = __webpack_require__(67).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(294);
var hiddenKeys = __webpack_require__(296).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 569 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(129);
var createDesc = __webpack_require__(180);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(41);
var $values = __webpack_require__(298)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(294);
var enumBugKeys = __webpack_require__(296);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(41);
var $entries = __webpack_require__(298)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(41);
var toObject = __webpack_require__(68);
var aFunction = __webpack_require__(132);
var $defineProperty = __webpack_require__(129);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(52) && $export($export.P + __webpack_require__(134), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(41);
var toObject = __webpack_require__(68);
var aFunction = __webpack_require__(132);
var $defineProperty = __webpack_require__(129);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(52) && $export($export.P + __webpack_require__(134), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(41);
var toObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(130);
var getPrototypeOf = __webpack_require__(299);
var getOwnPropertyDescriptor = __webpack_require__(186).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(52) && $export($export.P + __webpack_require__(134), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(41);
var toObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(130);
var getPrototypeOf = __webpack_require__(299);
var getOwnPropertyDescriptor = __webpack_require__(186).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(52) && $export($export.P + __webpack_require__(134), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = {"Sizers":{"SizerCaption":"HPE EPA vNext Sizing Tool","ReleaseDate":"Date: 19 February 2019","Sizer":{"Version":"19.4","SizerYear":"2000","ShowSizeSavedWorkloadButton":"False","ContactUs":{"Para1":"Please contact us if you have any comments, questions or need additional information of the product."},"About":{"Para1":"HPE has created this unique sizer/configurator to assist in deploying Big Data/Hadoop products on HPE Servers and is a quick and easy way to size user requirements."},"Index":{"Links":{"Link":{"Text":"Help","Url":""}},"Sections":{"Section":[{"Text":"The HPE Elastic Platform for Big Data Analytics (EPA) is a modular infrastructure foundation to accelerate business insights and enable organizations to rapidly deploy, efficiently scale and securely manage the explosive growth in volume, speed and variety of big data workloads. Use our tool to build a solution based on your specific Big Data/Hadoop workload requirements.","_Title":"Build Big Data Solution"},{"Text":"BlueData is transforming how enterprises deploy their Big Data applications and infrastructure. The BlueData EPIC software platform leverages Docker container technology and proprietary innovations to make it easier, faster, and more cost-effective for enterprises of all sizes to leverage Big Data � enabling Big-Data-as-a-Service either on-premises or in the cloud.","_Title":"Build Blue Data Solution"},{"Text":"Load your previously saved solution.","_Title":"Load Solution"},{"Text":"Load a previously saved sizer workload.","_Title":"Load Workload"}]}},"Functions":{"Function":{"Input":[{"Item":["Yes","No"],"_Type":"Add Servers"},{"Item":["Customer Requirements","Predefined Configuration"],"_Type":"SKU Information"},{"Item":["Cent OS","RHEL","Ubuntu"],"_Type":"OS Environment"},{"Item":["1","3","5"],"_Type":"Support  Year"},{"Item":["Yes","No"],"_Type":"IsEduGovt"},{"Item":"100G","_Type":"Network Type"},{"Item":["Mixed Use","Read Intensive"],"_Type":"Drive Class"},{"Item":["ProLiant XL170r Gen10","ProLiant DL360 Gen10"],"_Type":"Server Type"},{"Item":["8","16","32"],"_Type":"DIMM Capacity"},{"Item":[{"_DriveClass":"Read Intensive","__text":"1.92"},{"_DriveClass":"Read Intensive","__text":"3.84"},{"_DriveClass":"Read Intensive","__text":"7.68"},{"_DriveClass":"Mixed Use","__text":"1.6"},{"_DriveClass":"Mixed Use","__text":"3.2"},{"_DriveClass":"Mixed Use","__text":"6.4"}],"_Type":"Drives Capacity"},{"Item":["1","2","3","4","5","6","7","8","9","10"],"_Type":"Drive Per Server"},{"Item":["1","2"],"_Type":"Spare Servers"}],"_Type":"Weka"}},"HadoopServices":{"DistType":{"Item":["HortonWorks","Cloudera"]}},"OtherEnvirontmentDetails":{"StorageType":{"Item":["Raw","Usable"]},"Racks":{"Rack":[{"RackItem":{"Item":[{"_PartNumber":"P9K09A","__text":"HPE 42U 600mm x 1200mm G2 Kitted Advanced Pallet Rack with Side Panels and Baying"},{"_PartNumber":"P9K10A","__text":"HPE 42U 600mm x 1200mm G2 Kitted Advanced Shock Rack with Side Panels and Baying"},{"_PartNumber":"P9K15A","__text":"HPE 42U 800mm x 1200mm G2 Kitted Advanced Pallet Rack with Side Panels and Baying"},{"_PartNumber":"P9K39A","__text":"HPE 42U 600mm x 1200mm Enterprise G2 Pallet Rack"},{"_PartNumber":"P9K40A","_default":"yes","__text":"HPE 42U 600mm x 1200mm Enterprise G2 Shock Rack"},{"_PartNumber":"P9K45A","__text":"HPE 42U 800mm x 1200mm Enterprise G2 Pallet Rack"},{"_PartNumber":"P9K46A","__text":"HPE 42U 800mm x 1200mm Enterprise G2 Shock Rack"},{"_PartNumber":"P9K48A","__text":"HPE 42U 800mm x 1200mm Enterprise G2 Network Shock Rack"}]},"_Height":"42U"},{"RackItem":{"Item":{"_PartNumber":"P9K52A","_default":"yes","__text":"HPE 48U 600mm x 1200mm Enterprise G2 Shock Rack"}},"_Height":"48U"}],"_Name":"Racks"},"DiskDetails":{"DiskCapacity":"1024","DiskType":"Raw","Replication":"3.0","Overhead":"25","Compression":"1.0","Equal2PNodes":"18","StorageWL":"20"},"Services":{"HWSupport":{"Item":["None","9x5 1y","24x7 1y","9x5 3y","24x7 3y"]},"LinuxLicense":{"Item":["None","RHEL 9x5 1y","RHEL 24x7 1y","RHEL 9x5 3y","RHEL 24x7 3y","SLES 24x7 1y","SLES 24x7 3y"]},"iLOLicense":{"Item":["None","CMU 1y","CMU 3y","CMU + iLO 1y","CMU + iLO 3y","iLO 1y","iLO 3y"]},"NetworkSpeed":{"Item":["10G","25G","40G","100G"]},"Weka":{"Item":["None","Weka 9x5 1y","Weka 24x7 1y","Weka 9x5 3y","Weka 24x7 3y"]},"Scality":{"Item":["None","Scality 9x5 1y","Scality 24x7 1y","Scality 9x5 3y","Scality 24x7 3y"]},"HPCM":{"Item":["None","HPCM 1 Node 3yr 24x7 Support Perpetual E-LTU","HPCM 1 Node 3yr 24x7 Support Perpetual LTU"]},"MapR":{"Item":["None","MapR 9x5 1y","MapR 24x7 1y","MapR 9x5 3y","MapR 24x7 3y"]}},"FactoryExpress":{"Item":["No Factory Express","Factory Express FE3","Factory Express FE4"]},"NwSwitches":{"Scality":{"Item":["HPE StoreFabric SN2410M 25GbE 48SFP28 8QSFP28 Switch","HPE StoreFabric SN2410M 25GbE 24SFP28 4QSFP28 Switch","HPE StoreFabric SN2410bM 10GbE 48SFP+ 8QSFP28 Switch","HPE StoreFabric SN2410bM 10GbE 24SFP+ 4QSFP28 Switch","HPE StoreFabric SN2100M 100GbE 16QSFP28 Half Width Switch","HPE StoreFabric SN2100M 100GbE 8QSFP28 Half Width Switch","HPE StoreFabric SN2700M 100GbE 32QSFP28 Switch","HPE StoreFabric SN2700M 100GbE 16QSFP28 Switch"]}}},"InfoIconDescriptions":{"Text":[{"_Name":"StorageWorkload","__text":"StorageWorkload field allows you to fine tune sizing vs Equivalent 2P nodes.\n20% is the average value. If you know your workload is more storage oriented, you can increase this percentage in order to obtain more accurate sizing"},{"_Name":"Compression","__text":"It reduces the space needed to store files, and it speeds up data transfer across the network to or from disk."},{"_Name":"iLOLicense","__text":"iLO: HPE Integrated Lights-Out (iLO) provides the automated intelligence to maintain complete server control from any place, anywhere and ships with every ProLiant Server. Purchasing 1 or 3 year support licenses refers to the length of the support agreement for licensed iLO features.\n\nCMU: HPE Insight CMU is an integrated, easy-to-use tool for cluster administration, providing complete provisioning, management, and monitoring for clusters of any scale.\""},{"_Name":"NetworkSpeed","__text":"Select this option to know about the Network Speed Info.\""},{"_Name":"FactoryExpress","__text":"Insure your solutions are up and running in your data centers at rapid speeds along with quality assurance.     \n\nFactory Express is having your solution built, tested and integrated at an HPE Factory, delivered to your Customer's site ready to power on!\""},{"_Name":"EqNodes","__text":"Equivalent 2P Nodes: This selection will affect only Elastic Config (Compute Node)."},{"_Name":"Replication","__text":"Number of replicas to store. For Erasure Coding use values between 1 and 2. For example RS(6,3) has 50% overhead for parity so use 1.5"},{"_Name":"Overhead","__text":"It is the extra space needed to store the raw data, like temp files, metadata, logs, etc."}]},"ReferenceArchitecture":{"Doc":{"RASolName":"HPE RA for Hadoop on HPE EPA.xml","Name":"HPE RA for Hadoop on HPE EPA","Url":"http%3A%2F%2Fh20195.www2.hpe.com%2FV2%2FGetDocument.aspx%3Fdocname%3D4AA5-6136ENW"},"_Text":"HPE has produced EPA collateral (white papers, technical articles etc.) that provide information on reference configurations. HPE recommends that you consult the information sources provided by clicking on the URL below to learn more."},"AdditionalInformation":{"Doc":{"Name":"HPE Elastic Platform for Big Data Analytics","Url":"http%3A%2F%2Fh20195.www2.hpe.com%2FV2%2FGetDocument.aspx%3Fdocname%3D4AA6-8931ENW"},"_Text":"HPE has produced EPA collateral (white papers, technical articles etc.) that provide additional information on how to leverage the advanced features of the HPE Server family in configuring EPA business solutions.HPE recommends that you consult the information sources provided by clicking on the URL below to learn more."},"_name":"EPA vNext Sizing Tool"}}}

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_RadioButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Trash__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Trash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Trash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__DataDrive_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DisplayTabs_js__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__commonLogic_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HostChanged=false;var DatadriveChanged=false;var totalgpus=0;var ComptNodeType=void 0,ComptNodeList=void 0,NonGPUProcType=void 0,NonGPUProcFamilyType=void 0,NonGPUMemory=void 0,NonGPUNodeCount=void 0,NonGPUOSDrive=void 0,NonGPUStrDrivetype=void 0;var NonGPUProcList=[];var NonGPUProcFamilyList=[];var NonGPUMemoryList=[];var NonGPUOSDriveList=[];var NonGPUStrDrivetypeList=[];var NonGPUTenantStoragedrivelist=[];var EPICProclist=[];var EPICGPUlist=[];var List=[];var GPUDisplay='none';var NonGPUDisplay="none";var storageDisplay="none";var displayStorageTotals="none";var HAIncluded=void 0;var GPUNodeType=void 0,GPUNodeList=void 0,GPUProcType=void 0,GPUProcFamilyType=void 0,GPUProcList=void 0,GPUProcFamilyList=void 0,GPUMemory=void 0,GPUMemoryList=void 0,GPUNodeCoount=void 0,GPUOSDrive=void 0,GPUStrDrivetype=void 0,GPUOSDriveList=void 0,GPUStrDrivetypeList=void 0,GPUTenantStoragedrivelist=void 0,GPUNodeStorageDriveQuantity=void 0,GPUTenantStoragedrive=void 0,GPUTenantStorageDriveQuantity=void 0;var NonGPUNodeStorageDriveQuantity=void 0,NonGPUTenantStoragedrive=void 0,NonGPUTenantStorageDriveQuantity=void 0;var HDFSTenatStr=void 0,HDFSrepFac=void 0,Allocationratio=void 0,KubClusters=void 0,GPUType=void 0;var Globalvalue="";var selectchange="";var Templatedata='';var GPUList='';var NonGPUList='';var GPUcountList=[];var GPUCount='';var HoustcountExceded=false;var Minhostcount='';var Maxhostcount='';var nonGPUNoteText="";var GPUNoteText="";var StorageNoteText="";var nonGPUChanges="";var GPUChanges="";var StorageChanges="";var deleteTemplateConfirmation="";var nonGPUCost="";var GPUCost="";var proLiantDL360Gen10="ProLiant DL360 Gen10";var proLiantDL380Gen10="ProLiant DL380 Gen10";var PROLIANTXL190RGEN10="ProLiant XL190r Gen10";var PROLIANTXL270DGEN10="ProLiant XL270d Gen10";var HPE_APOLLO_4200_GEN10="HPE Apollo 4200 Gen10 Server";var PROLIANT_XL170R_GEN10="ProLiant XL170r Gen10";var HPE_MOONSHOT_SYSTEM="HP Moonshot System";var E920="e920";var VIRTUALCLUSTERS="Virtualclusters";var VIRTUALNODESPERCLUSTER="Virtualnodespercluster";var CPUCORES="CPUCores";var MEMORY="Memory";var NODESTORAGE="NodeStorage";var PERSISTENT_STORAGE="PersistentStorage";var GPUS="GPUs";var maxGPUCount=0;var nvmeString='NVME';var GPUTypeinComputeNode=false;var computeGPUType="";var computeGPUTypeOptions=[];var T4_GPU="T4-PCIE-16GB";var V100_32GB_GPU="V100-PCIE-32GB";var A100_40GB_GPU="A100-PCIE-40GB";var A100_PCIE_80GB_GPU="A100-PCIE-80GB";var A40_PCIE_48GB_GPU="A40-PCIE-48GB";var NON_GPU="NonGPU";var GPU="GPU";var Houstcountdata='';var storageHostsCheckBoxDisabled=true;var storageHostChecked=false;var storageMixedTenantStorage="";var saveWorkload=true;var isValueChanged=false;var updatePersistentStorage=true;var makeNetworkCall=false;var storageNodeType=void 0,STORAGE_HOST_OPTIONS=void 0,storageProcFamilyType=void 0,STORAGE_PROCESSORFAMILY_OPTIONS=void 0,storageProcType=void 0,STORAGE_PROCESSOR_OPTIONS=void 0,storageMemory=void 0,STORAGE_MEMORY_OPTIONS=void 0,storageNodeDrive=void 0,STORAGE_NODE_DRIVE_OPTIONS=void 0,storageNodeDriveQty=void 0,storageOSDrive=void 0,STORAGE_OSDRIVE_OPTIONS=void 0,storageTenantStorageDrive=void 0,STORAGE_TENANT_DRIVE_OPTIONS=void 0,storageTenantDriveQuantity=void 0,storageNodeCount=void 0,storageApproxCost=void 0,storageCost=void 0;var INFERENCE_POPUP_TEXT="Since \"Inference\" is added, Server platform can be either ProLiant DL360 Gen10 or ProLiant DL380 Gen10. Please remove the same and re-calculate the recommendations.";var NVMEMAX_POPUP_TEXT="Maximum number of NVMe drives are already added.";var OLDWL_TEXT="The workload inputs are for older version of templates, please review and update the solution templates to new versions for new solution sizing";var EOL_WORKLOAD_MESSAGE="This workload/solution had contained EOL servers. Please recalculate to generate updated solution.";var WARNING_TEXT="Warning";var ERROR_TEXT="Error";var COMPUTENODETYPE="ComptNodeType";var VISIBLE="flex";var NONE="none";var TRUE="true";var FALSE="false";var noteTextforLoadingOldSolutions="";var currentTabObject="";var configureInAllServicesText=false;var overallConfigType="";var updateInitialConfigurations=true;var defaultTemplate=void 0;var trainingGPUvalue=void 0;var isGPUvalueChanged=false;// let hideGatewayHostChecked = false;
var DesignRequirements=function(_Component){_inherits(DesignRequirements,_Component);function DesignRequirements(){_classCallCheck(this,DesignRequirements);var _this=_possibleConstructorReturn(this,(DesignRequirements.__proto__||Object.getPrototypeOf(DesignRequirements)).call(this));_this.updateMixedDrivesArray=function(){var storageObject=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0];if(storageObject["@mixedTenantStorage"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_27" /* FALSE_ */]){var persistentDriveSize='';var persistentDrivesArray='';if(currentTabObject.Templates.ServerDetails.Server.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})){persistentDrivesArray=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks;}if(!Array.isArray(persistentDrivesArray)){persistentDriveSize=persistentDrivesArray.Item[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_158" /* SIZE_ATTRIBUTE */]];}else if(persistentDrivesArray.length>0){persistentDriveSize=persistentDrivesArray[0].Item[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_158" /* SIZE_ATTRIBUTE */]];}currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks=[];var newDrive={Item:{"@size":persistentDriveSize,'@disk':storageObject["@TStorageDrive"],'@qty':storageObject["@TStorageDriveQty"],"@volumeName":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_123" /* PERSISTENT_ */]}};currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.push(newDrive);}};_this.makeisCalculatedFalse=function(){currentTabObject.NonGPUValue.isCalculated=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];currentTabObject.GPUValue.isCalculated=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];currentTabObject.StorageValue.isCalculated=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];if(currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];}).length>0){currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@mixedTenantStorage"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_27" /* FALSE_ */];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks=[];}};_this.onConfigurationChange=function(event){currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"]=event.value;_this.calculateRecommendationButtonValidation();_this.setState({});};_this.checkValues=function(){var NoValues=true;var MlopsImageProcessingCheck=false;var InferenceImagePerSec=true;var TrainingImagePerSec=true;currentTabObject.Templates.Template.filter(function(x,id){if(x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["N" /* CUSTOM_TEMPLATE */]&&x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["O" /* CUSTOM_WGPUS */]){if(parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["h" /* ATTRIBUTE_VCLUSTERS */]],10)!==0&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["d" /* ATTRIBUTE_NODESPERCLUSTER */]],10)!==0){NoValues=false;}}else{if(parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["h" /* ATTRIBUTE_VCLUSTERS */]],10)!==0&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["d" /* ATTRIBUTE_NODESPERCLUSTER */]],10)!==0&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["i" /* ATTRIBUTE_VCPUPERNODE */]],10)!==0&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["j" /* ATTRIBUTE_VMEMORYPERNODE */]],10)!==0&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["k" /* ATTRIBUTE_VSTORAGEPERNODE */]],10)!==0){NoValues=false;}}if(x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */]||x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */]){MlopsImageProcessingCheck=true;if(x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */]&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_73" /* IMAGE_PER_SEC */]],10)!==0){InferenceImagePerSec=false;}if(x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */]&&parseInt(x.Nodes[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_73" /* IMAGE_PER_SEC */]],10)!==0){TrainingImagePerSec=false;}}});if(MlopsImageProcessingCheck&&InferenceImagePerSec&&TrainingImagePerSec){NoValues=true;}return NoValues;};_this.saveOldWorkloads=function(){var index1=currentTabObject.Templates.ServerDetails.Server.findIndex(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */];});if(index1>=0){_this.props.ServiceError.nonGPUOldWorkload=JSON.parse(JSON.stringify(currentTabObject.Templates.ServerDetails.Server[index1]));}var index2=currentTabObject.Templates.ServerDetails.Server.findIndex(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */];});if(index2>=0){_this.props.ServiceError.GPUOldWorkload=JSON.parse(JSON.stringify(currentTabObject.Templates.ServerDetails.Server[index2]));}var index3=currentTabObject.Templates.ServerDetails.Server.findIndex(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];});if(index3>=0){_this.props.ServiceError.StorageOldWorkload=JSON.parse(JSON.stringify(currentTabObject.Templates.ServerDetails.Server[index3]));}};_this.setPersistentStorageMinValue=function(){var persistentStorageMinimumValue=0;currentTabObject.Templates.Template.map(function(x){if(x["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&!(_this.props.SSETid&&currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_6" /* DATA_FABRIC */])){persistentStorageMinimumValue+=parseInt(x.Nodes["@PersistentStorage"],10)*parseInt(x.Nodes["@vClusters"],10);}});persistentStorageMinimumValue=persistentStorageMinimumValue/1024;if(persistentStorageMinimumValue%1!=0){persistentStorageMinimumValue=parseInt(persistentStorageMinimumValue,10)+1;}if(_this.props.SSETid&&currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){var MLOpsStorageTemplate=currentTabObject.Templates.Template.find(function(template){return template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_6" /* DATA_FABRIC */];});if(MLOpsStorageTemplate){persistentStorageMinimumValue+=parseInt(MLOpsStorageTemplate.Nodes["@PersistentStorage"],10);}}return persistentStorageMinimumValue.toString();};_this.noOfNonStorageTemplates=function(){var nonStoragetemplates=currentTabObject.Templates.Template.filter(function(template){return template["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */])===-1&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];});return nonStoragetemplates.length;};_this.storageHostCheckBoxchange=function(){storageHostChecked=storageHostChecked?false:true;if(storageHostChecked){currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"]="yes";}else{currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"]="no";if(Array.isArray(currentTabObject.Templates.ServerDetails.Server)){var host=currentTabObject.Templates.ServerDetails.Server.filter(function(item){return item['@RoleName']==='Storage Host';})[0];if(host){var count=0;host['@NodesCount']=count;}}}_this.calculateRecommendationButtonValidation();_this.setState({});};_this.storageHostAllOptions=function(fromRender){STORAGE_HOST_OPTIONS=[];STORAGE_PROCESSORFAMILY_OPTIONS=[];STORAGE_PROCESSOR_OPTIONS=[];STORAGE_MEMORY_OPTIONS=[];STORAGE_NODE_DRIVE_OPTIONS=[];STORAGE_OSDRIVE_OPTIONS=[];STORAGE_TENANT_DRIVE_OPTIONS=[];var storageHostSupportedList=_this.props.Storagedetails;for(var key in storageHostSupportedList){STORAGE_HOST_OPTIONS.push(key);}if(STORAGE_HOST_OPTIONS.indexOf(storageNodeType)===-1){storageNodeType=STORAGE_HOST_OPTIONS[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@Name"]=storageNodeType;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"HostType");}for(var _key in storageHostSupportedList[storageNodeType].ProcessorList){STORAGE_PROCESSORFAMILY_OPTIONS.push(_key);}if(STORAGE_PROCESSORFAMILY_OPTIONS.indexOf(storageProcFamilyType)===-1){storageProcFamilyType=STORAGE_PROCESSORFAMILY_OPTIONS[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@ProcFamily"]=storageProcFamilyType;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"ProcessorFamily");}for(var _key2 in storageHostSupportedList[storageNodeType].ProcessorList[storageProcFamilyType]){STORAGE_PROCESSOR_OPTIONS.push(_key2);}STORAGE_PROCESSOR_OPTIONS=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(STORAGE_PROCESSOR_OPTIONS,currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_126" /* PROCESSOR_ */]);if(STORAGE_PROCESSOR_OPTIONS.filter(function(processor){return processor.indexOf(storageProcType)>-1;}).length==0){storageProcType=STORAGE_PROCESSOR_OPTIONS[0];_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"Processor");}else{storageProcType=STORAGE_PROCESSOR_OPTIONS.filter(function(processor){return processor.indexOf(storageProcType)>-1;})[0];}currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@Proc"]=storageProcType;STORAGE_MEMORY_OPTIONS=storageHostSupportedList[storageNodeType].ProcessorList[storageProcFamilyType][storageProcType];STORAGE_MEMORY_OPTIONS=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(STORAGE_MEMORY_OPTIONS,currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_96" /* MEMORY_ */]);if(STORAGE_MEMORY_OPTIONS.indexOf(storageMemory)===-1){storageMemory=STORAGE_MEMORY_OPTIONS[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@Memory"]=storageMemory;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"Memory");}STORAGE_NODE_DRIVE_OPTIONS=storageHostSupportedList[storageNodeType].DataDriveList;STORAGE_NODE_DRIVE_OPTIONS=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(STORAGE_NODE_DRIVE_OPTIONS,currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);if(STORAGE_NODE_DRIVE_OPTIONS.indexOf(storageNodeDrive)===-1){storageNodeDrive=STORAGE_NODE_DRIVE_OPTIONS[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@NodeDisk"]=storageNodeDrive;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"NodeStorageDrive");}STORAGE_OSDRIVE_OPTIONS=storageHostSupportedList[storageNodeType].OSDriveList;if(STORAGE_OSDRIVE_OPTIONS.indexOf(storageOSDrive)===-1){storageOSDrive=STORAGE_OSDRIVE_OPTIONS[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@OSDisk"]=storageOSDrive;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"OSDrive");}if(fromRender===true){_this.populateDrivesandResetIfRequired();}_this.updateMixedDrivesArray();};_this.populateDrivesandResetIfRequired=function(){_this.populateDriveOptions(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);STORAGE_TENANT_DRIVE_OPTIONS=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(STORAGE_TENANT_DRIVE_OPTIONS,currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_123" /* PERSISTENT_ */]+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);if(STORAGE_TENANT_DRIVE_OPTIONS.indexOf(storageTenantStorageDrive)===-1){storageTenantStorageDrive=STORAGE_TENANT_DRIVE_OPTIONS[0];makeNetworkCall=true;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDrive"]=storageTenantStorageDrive;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"LocalTenantDrive");}};_this.populateDriveOptions=function(roleName){var drivesArray=[];_this.state.storageTenantDriveType=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===roleName;})[0]["@TenantDriveType"];storageMixedTenantStorage=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===roleName;})[0]["@mixedTenantStorage"];var serverName=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===roleName;})[0]["@Name"];drivesArray=_this.props.Storagedetails[serverName].StorageTenantDrives;if(storageMixedTenantStorage==="True"){var existingDrives=[];var existingDriveTypes=[];var temp=[];var resetTemp=function resetTemp(){drivesArray=[];drivesArray=temp;temp=[];};currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===roleName;})[0].PersistentDisks.map(function(x){existingDrives.push(x.Item["@disk"]);});_this.props.Storagedetails[serverName].StorageTenantDrives.map(function(x){if(existingDrives.indexOf(x.StrDrive)!==-1){x.Types.map(function(y){if(existingDriveTypes.indexOf(y)===-1){existingDriveTypes.push(y);}});}});if(serverName!==HPE_APOLLO_4200_GEN10){if(existingDriveTypes.indexOf('LFF HDD')!==-1||existingDriveTypes.indexOf('LFF SSD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('SFF HDD')===-1&&x.Types.indexOf('SFF SSD')===-1){temp.push(x);}});}else if(existingDriveTypes.indexOf('SFF HDD')!==-1||existingDriveTypes.indexOf('SFF SSD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('LFF HDD')===-1&&x.Types.indexOf('LFF HDD')===-1){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}resetTemp();}if(existingDriveTypes.indexOf('SFF SAS SSD')!==-1||existingDriveTypes.indexOf('SFF SAS HDD')!==-1||existingDriveTypes.indexOf('LFF SAS SSD')!==-1||existingDriveTypes.indexOf('LFF SAS HDD')!==-1||existingDriveTypes.indexOf('NVMe')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('LFF SATA HDD')===-1&&x.Types.indexOf('SFF SATA HDD')===-1){temp.push(x);}else if(existingDriveTypes.indexOf('SFF SAS SSD')===-1&&existingDriveTypes.indexOf('SFF SAS HDD')===-1&&existingDriveTypes.indexOf('LFF SAS SSD')===-1&&existingDriveTypes.indexOf('LFF SAS HDD')===-1&&existingDriveTypes.indexOf('NVMe')!==-1&&serverName===HPE_APOLLO_4200_GEN10){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}resetTemp();if(existingDriveTypes.indexOf('SFF SATA HDD')!==-1||existingDriveTypes.indexOf('LFF SATA HDD')!==-1){drivesArray.map(function(x){if(x.Types.indexOf('SFF SAS SSD')===-1&&x.Types.indexOf('SFF SAS HDD')===-1&&x.Types.indexOf('LFF SAS SSD')===-1&&x.Types.indexOf('LFF SAS HDD')===-1&&x.Types.indexOf('NVMe')===-1){temp.push(x);}else if(x.Types.indexOf('SFF SAS SSD')===-1&&x.Types.indexOf('SFF SAS HDD')===-1&&x.Types.indexOf('LFF SAS SSD')===-1&&x.Types.indexOf('LFF SAS HDD')===-1&&x.Types.indexOf('NVMe')!==-1&&serverName===HPE_APOLLO_4200_GEN10){temp.push(x);}});}else{drivesArray.map(function(x){temp.push(x);});}resetTemp();}else{}if(roleName===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]){if(_this.state.storageTenantDriveConsolidatedOptions.length===0||_this.state.changeStorageTenantDriveTypeOptions){_this.state.changeStorageTenantDriveTypeOptions=false;_this.state.storageTenantDriveConsolidatedOptions=[];drivesArray.map(function(drive){drive.Types.map(function(type){if(_this.state.storageTenantDriveConsolidatedOptions.indexOf(type)===-1){_this.state.storageTenantDriveConsolidatedOptions.push(type);}});});}if(_this.state.storageTenantDriveType===""||_this.state.storageTenantDriveConsolidatedOptions.indexOf(_this.state.storageTenantDriveType)===-1){_this.state.storageTenantDriveType=_this.state.storageTenantDriveConsolidatedOptions[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===roleName;})[0]["@TenantDriveType"]=_this.state.storageTenantDriveType;_this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],"DriveType");}STORAGE_TENANT_DRIVE_OPTIONS=[];drivesArray.map(function(x){if(x.Types.indexOf(_this.state.storageTenantDriveType)!==-1)STORAGE_TENANT_DRIVE_OPTIONS.push(x.StrDrive);});}};_this.onStorageTenantDriveTypeChange=function(e){if(_this.state.storageTenantDriveType!==e.option){var isValid=true;var oldDriveType=_this.state.storageTenantDriveType;var oldPersitentDrive=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDrive"];_this.state.storageTenantDriveType=e.option;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TenantDriveType"]=_this.state.storageTenantDriveType;_this.populateDrivesandResetIfRequired();var storageObject=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0];isValid=_this.isCompatibleDrive(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);if(isValid){isValid=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["q" /* validateDriveChange */])(storageObject["@NodeDisk"],storageObject["@OSDisk"],storageObject["@TStorageDrive"],storageObject["@Name"]);}var array=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],false,false,"",true);if(!isValid||array[2]){_this.state.storageTenantDriveType=oldDriveType;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TenantDriveType"]=_this.state.storageTenantDriveType;_this.populateDrivesandResetIfRequired();makeNetworkCall=false;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDrive"]=oldPersitentDrive;if(array[2]){if(currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@OSDisk"].indexOf("M.2")>-1){array[1]=26;}else{array[1]=24;}Houstcountdata=_this.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][0]+array[1]+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][1],ERROR_TEXT);}else{var text="The selected drive type has no drives that are compatible with existing drives.";Houstcountdata=_this.renderErrorPopup(text,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_197" /* WARNING_TEXT */]);}}else{storageTenantDriveQuantity=array[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;}if(makeNetworkCall){currentTabObject.displayNotePersistentDriveChange=TRUE;makeNetworkCall=false;_this.updateMixedDrivesArray();_this.makeStorageHostCustomisationNetworkCall();}_this.setState({});}};_this.addStorageTenanatDrive=function(){if(storageTenantStorageDrive!==undefined&&storageTenantDriveQuantity!="0"){var existingDrivesArray=[];var validCombination=true;if(storageNodeType===HPE_APOLLO_4200_GEN10&&(storageTenantStorageDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])!==-1||storageTenantStorageDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){storageMixedTenantStorage=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@mixedTenantStorage"];existingDrivesArray=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks;if(storageMixedTenantStorage==="True"){var nonNVMeDrives=0;var NVMeDrives=0;var SFFDrives=0;existingDrivesArray.map(function(x){if(x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])===-1&&x.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])===-1){nonNVMeDrives+=parseInt(x.Item["@qty"],10);}else if(x.Item["@disk"].indexOf('NVMe')!==-1){NVMeDrives+=parseInt(x.Item["@qty"],10);}else{SFFDrives+=parseInt(x.Item["@qty"],10);}});if(storageTenantStorageDrive.indexOf("NVMe")!==-1&&SFFDrives>0){validCombination=false;}else if(storageTenantStorageDrive.indexOf("NVMe")===-1&&NVMeDrives>0){validCombination=false;}if(storageOSDrive.indexOf("M.2")!==-1){if(nonNVMeDrives>24){validCombination=false;}}else{if(nonNVMeDrives>22){validCombination=false;}}if(!validCombination){var text="Drive cannot be added as the maximum drives exceeded.";Houstcountdata=_this.renderErrorPopup(text,ERROR_TEXT);}}}if(validCombination){var drivesLeftArray=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],true,false,"",false);if(parseInt(storageTenantDriveQuantity,10)<=drivesLeftArray[0]){var numberOfDisks="";storageMixedTenantStorage=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@mixedTenantStorage"];if(storageMixedTenantStorage==="False"){currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks=[];}storageMixedTenantStorage="True";currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@mixedTenantStorage"]=storageMixedTenantStorage;existingDrivesArray=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks;numberOfDisks=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.length;var pushDrive=true;if(numberOfDisks>0){existingDrivesArray.map(function(x){if(x.Item["@disk"]===storageTenantStorageDrive){x.Item["@qty"]=(parseInt(x.Item["@qty"],10)+parseInt(storageTenantDriveQuantity,10)).toString();pushDrive=false;}});}if(pushDrive){var newDrive={Item:{'@disk':storageTenantStorageDrive,'@qty':storageTenantDriveQuantity,"@volumeName":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_123" /* PERSISTENT_ */]}};currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.push(newDrive);_this.state.changeStorageTenantDriveTypeOptions=true;}_this.updateStorageTenantDriveQuantity();_this.makeStorageHostCustomisationNetworkCall();//this.textOnChangeofConfiguration(Constants.STORAGE_,"LocalTenantDriveQty");
}else{Houstcountdata=_this.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][0]+drivesLeftArray[1]+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][1],ERROR_TEXT);}}_this.setState({});}};_this.renderStorageTenantDriveTable=function(){var tableData=[];var tableDataArray="";if(currentTabObject.Templates.ServerDetails.Server.find(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})){tableDataArray=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks;if(Array.isArray(tableDataArray)){tableDataArray.map(function(storageTenantDrive,id){tableData.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,storageTenantDrive.Item["@disk"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:storageTenantDrive.Item["@qty"],onDOMChange:function onDOMChange(e){return _this.storageTextChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_172" /* STORAGE_TENANT_DRIVE_QUANTITY */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["x" /* CHANGE */],true,id);},onBlur:function onBlur(e){return _this.storageTextChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_172" /* STORAGE_TENANT_DRIVE_QUANTITY */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */],true,id);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Trash___default.a,{primary:true,onClick:function onClick(){_this.deleteStorageTenantDrive(id);}}))));});}}return tableData;};_this.deleteStorageTenantDrive=function(id){if(currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.length===1){currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@mixedTenantStorage"]="False";_this.updateMixedDrivesArray();}storageTenantDriveQuantity=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],false,true,id,false)[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.splice(id,1);if(currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.length===0){storageMixedTenantStorage="False";currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@mixedTenantStorage"]=storageMixedTenantStorage;}_this.updateMixedDrivesArray();_this.state.changeStorageTenantDriveTypeOptions=true;//this.updateStorageTenantDriveQuantity();
_this.makeStorageHostCustomisationNetworkCall();_this.setState({});};_this.updateStorageTenantDriveQuantity=function(){storageTenantDriveQuantity=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],false,false,"",false)[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;};_this.noOfStorageTenantDrivesLeft=function(Drive,changingDriveQty,editExisting,driveID,driveTypeChanged){var storageObject=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0];var maxDrives=0;var noOfDrivesLeft=0;var noOfNVMEDrives=0;var noOfNonNVMEDrives=0;var mainDrive='';var maxDrivesAdded=false;if(Drive!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_106" /* NODE */]){if(storageObject["@NodeDisk"].toUpperCase().indexOf(nvmeString)>-1||storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(storageObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||storageObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){noOfNVMEDrives+=parseInt(storageObject["@StorageDiskQty"],10);}else{noOfNonNVMEDrives+=parseInt(storageObject["@StorageDiskQty"],10);}}if(storageObject["@OSDisk"].toUpperCase().indexOf(nvmeString)>-1){noOfNVMEDrives+=parseInt(storageObject["@OSDiskQty"],10);}else{noOfNonNVMEDrives+=parseInt(storageObject["@OSDiskQty"],10);}if(storageObject["@mixedTenantStorage"]==="True"){storageObject.PersistentDisks.map(function(drive,id){if(!(editExisting&&driveID==id)){if(drive.Item["@disk"].toUpperCase().indexOf(nvmeString)>-1||storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(drive.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_75" /* INCHES_ */])>-1||drive.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){noOfNVMEDrives+=parseInt(drive.Item["@qty"],10);}else{noOfNonNVMEDrives+=parseInt(drive.Item["@qty"],10);}}});}else{if(Drive===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_106" /* NODE */]||!changingDriveQty&&Drive===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */]&&!editExisting&&!driveTypeChanged){if(storageObject["@TStorageDrive"].toUpperCase().indexOf(nvmeString)>-1||storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(storageObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_75" /* INCHES_ */])>-1||storageObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){noOfNVMEDrives+=parseInt(storageObject["@TStorageDriveQty"],10);}else{noOfNonNVMEDrives+=parseInt(storageObject["@TStorageDriveQty"],10);}}}if(Drive===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */]){mainDrive=storageObject["@TStorageDrive"];if(editExisting){mainDrive=storageObject.PersistentDisks[driveID].Item["@disk"];}}else{mainDrive=storageObject["@NodeDisk"];}if(mainDrive.toUpperCase().indexOf(nvmeString)>-1||storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(mainDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_75" /* INCHES_ */])>-1||mainDrive.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){if(storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(storageObject["@OSDisk"].indexOf("M.2")>-1){if(noOfNonNVMEDrives>26){maxDrivesAdded=true;}}else{if(noOfNonNVMEDrives>24){maxDrivesAdded=true;}}}maxDrives=_this.props.Storagedetails[storageObject["@Name"]].MaxNVMeDrives;noOfDrivesLeft=maxDrives-noOfNVMEDrives;}else{maxDrives=_this.props.Storagedetails[storageObject["@Name"]].MaxDrives;if(storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&noOfNVMEDrives>0){maxDrives=storageObject["@OSDisk"].indexOf("M.2")>-1?26:24;}if(storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){noOfDrivesLeft=maxDrives-noOfNonNVMEDrives;}else{if(storageObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_134" /* PROLIANT_DL385_GEN10_PLUS */]&&(storageObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_86" /* LFF_ */])>-1||storageObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_76" /* INCHES_THREE */])>-1)&&(storageObject["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_86" /* LFF_ */])>-1||storageObject["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_76" /* INCHES_THREE */])>-1)&&(storageObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_86" /* LFF_ */])>-1||storageObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_76" /* INCHES_THREE */])>-1)){//this.props.Storagedetails[storageObject["@Name"]].MaxDrives = 16;
maxDrives=16;}noOfDrivesLeft=maxDrives-noOfNonNVMEDrives-noOfNVMEDrives;}}var array=[noOfDrivesLeft,maxDrives,maxDrivesAdded];return array;};_this.makeStorageHostCustomisationNetworkCall=function(){var value={"input":{"Workload":null},"Inputsnotchanged":false,"RoleType":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]};value.input.Workload=_this.props.workload;_this.props.CalculateBlueDataConfigurationfalse(value);};_this.isCompatibleDrive=function(role){var isCompatible=true;var roleObject=currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===role;})[0];if(roleObject["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(roleObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_75" /* INCHES_ */])>-1||roleObject["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString)>-1){if(roleObject["@mixedTenantStorage"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_189" /* TRUE_ */]){roleObject.PersistentDisks.map(function(drive){if(roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString)>-1){if((drive.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_75" /* INCHES_ */])>-1||drive.Item["@disk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)&&roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString)===-1){isCompatible=false;}}else{if(drive.Item["@disk"].toUpperCase().indexOf(nvmeString)>-1){isCompatible=false;}}});}if(roleObject["@NodeDisk"].toUpperCase().indexOf(nvmeString)>-1){if((roleObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_75" /* INCHES_ */])>-1||roleObject["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)&&roleObject["@TStorageDrive"].toUpperCase().indexOf(nvmeString)===-1){isCompatible=false;}}else{if(roleObject["@TStorageDrive"].toUpperCase().indexOf(nvmeString)>-1){isCompatible=false;}}}}return isCompatible;};_this.GPUChange=function(e,textinput,requirementType){if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_167" /* STORAGE_NODE_TYPE */]&&storageMixedTenantStorage==="True"){Houstcountdata=_this.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_97" /* MIXED_STORAGE_SERVER_CHANGE_WARNING */],WARNING_TEXT);_this.setState({});}else{_this.saveOldWorkloads();if(requirementType==="GPU"){GPUChanges="";}else if(requirementType==="nonGPU"){nonGPUChanges="";}else if(requirementType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]){StorageChanges="";}var valueChanged=false;selectchange=e.value;if(textinput==="GPUNodeType"||textinput==="ComptNodeType"){if(textinput==="GPUNodeType"){if(GPUNodeType!==selectchange){HostChanged=true;}}else{if(ComptNodeType!==selectchange){HostChanged=true;_this.props.ServiceError.guiState.computeHostChanged=true;}}}if(textinput==='NonGPUStrDrivetype'||textinput==='GPUStrDrivetype'){if(textinput==='GPUStrDrivetype'){if(GPUStrDrivetype!==selectchange){DatadriveChanged=true;}}else{if(NonGPUStrDrivetype!==selectchange){DatadriveChanged=true;}}}if(_this.props.controllerconfigChanged===true){_this.props.ContrlChanged(false);}if(textinput==="ComptNodeType"){if(ComptNodeType!==selectchange){valueChanged=true;}}else if(textinput==="NonGPUProcFamilyType"){if(NonGPUProcFamilyType!==selectchange){valueChanged=true;}}else if(textinput==="NonGPUProcType"){if(NonGPUProcType!==selectchange){valueChanged=true;}}else if(textinput==="NonGPUStrDrivetype"){if(NonGPUStrDrivetype!==selectchange){valueChanged=true;}}else if(textinput==="NonGPUOSDrive"){if(NonGPUOSDrive!==selectchange){valueChanged=true;}}else if(textinput==="NonGPUMemory"){if(NonGPUMemory!==selectchange){valueChanged=true;}}else if(textinput==="NonGPUTenantStoragedrive"){if(NonGPUTenantStoragedrive!==selectchange){valueChanged=true;}}else if(textinput==="GPUNodeType"){if(GPUNodeType!==selectchange){valueChanged=true;}}else if(textinput==="GPUProcFamilyType"){if(GPUProcFamilyType!==selectchange){valueChanged=true;}}else if(textinput==="GPUProcType"){if(GPUProcType!==selectchange){valueChanged=true;}}else if(textinput==="GPUStrDrivetype"){if(GPUStrDrivetype!==selectchange){valueChanged=true;}}else if(textinput==="GPUOSDrive"){if(GPUOSDrive!==selectchange){valueChanged=true;}}else if(textinput==="GPUMemory"){if(GPUMemory!==selectchange){valueChanged=true;}}else if(textinput==="GPUTenantStoragedrive"){if(GPUTenantStoragedrive!==selectchange){valueChanged=true;}}else if(textinput==="GPUType"){isGPUvalueChanged=true;if(GPUType!==selectchange){valueChanged=true;}}else if(textinput==="GPUCount"){if(GPUCount!==selectchange){valueChanged=true;}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_167" /* STORAGE_NODE_TYPE */]){if(storageNodeType!==selectchange){HostChanged=true;valueChanged=true;_this.state.changeStorageTenantDriveTypeOptions=true;}// this.storageTextChangeForHostChange();
// this.storageTextChange(e,'storageTenantDriveQuantity', 'Blur','', '');
}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_169" /* STORAGE_PROCESSOR_FAMILY */]&&storageProcFamilyType!==selectchange||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_170" /* STORAGE_PROCESSOR_TYPE */]&&storageProcType!==selectchange||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_163" /* STORAGE_MEMORY */]&&storageMemory!==selectchange||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_168" /* STORAGE_OSDRIVE */]&&storageOSDrive!==selectchange||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_171" /* STORAGE_TENANT_DRIVE */]&&storageTenantStorageDrive!==selectchange){valueChanged=true;}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_165" /* STORAGE_NODE_DRIVE */]&&storageNodeDrive!==selectchange){valueChanged=true;DatadriveChanged=true;}_this.onWrkUpdateselect(selectchange,textinput,valueChanged);}};_this.storageTextChangeForHostChange=function(){storageTenantDriveQuantity=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],false,false,"",false)[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;_this.setState({});};_this.storageTextChange=function(e,textinput,ChorBlr,editExisting,driveID){var minVal;var maxVal;if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_166" /* STORAGE_NODE_DRIVE_QTY */]){minVal=2;maxVal=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_106" /* NODE */],true,editExisting,driveID,false)[0];}else{minVal=0;maxVal=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],true,editExisting,driveID,false)[0];}var selectedChange="";if(ChorBlr===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]){_this.state.enableADDButton=false;if(saveWorkload){_this.saveOldWorkloads();saveWorkload=false;}if(isNaN(e.target.value)||e.target.value=="0"||e.target.value===""){selectedChange="";}else{if(parseInt(e.target.value,10)>=0&&parseInt(e.target.value,10)<=maxVal){selectedChange=e.target.value;}else if(parseInt(e.target.value,10)>maxVal){selectedChange=maxVal;}else{selectedChange=minVal;}}}else{_this.state.enableADDButton=true;if(e.target.value===""||parseInt(e.target.value,10)<minVal){e.target.value=minVal.toString();}if(editExisting&&(e.target.value===""||e.target.value==="0")){e.target.value="1";}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_172" /* STORAGE_TENANT_DRIVE_QUANTITY */]&&e.target.value==="0"&&maxVal>0){e.target.value="1";}selectedChange=e.target.value;}selectedChange=selectedChange.toString();if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_166" /* STORAGE_NODE_DRIVE_QTY */]){storageNodeDriveQty=selectedChange;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@StorageDiskQty"]=storageNodeDriveQty;if(ChorBlr===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){storageTenantDriveQuantity=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],true,false,"",false)[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;}}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_172" /* STORAGE_TENANT_DRIVE_QUANTITY */]){if(editExisting){currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0].PersistentDisks.map(function(drive,id){if(driveID===id){drive.Item["@qty"]=selectedChange;}});if(ChorBlr===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){storageTenantDriveQuantity=_this.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_182" /* TENANT */],false,false,"",false)[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;}}else{storageTenantDriveQuantity=selectedChange;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];})[0]["@TStorageDriveQty"]=storageTenantDriveQuantity;}}if(ChorBlr===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]&&!saveWorkload){_this.updateMixedDrivesArray();saveWorkload=true;if(!(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_172" /* STORAGE_TENANT_DRIVE_QUANTITY */]&&!editExisting&&storageMixedTenantStorage==="True")){_this.makeStorageHostCustomisationNetworkCall();}}_this.setState({});};_this.onCalcTempClick=function(){totalgpus=0;var inferenceAndOtherGPUsPresent=false;if((currentTabObject.GPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]||currentTabObject.Templates.Template.filter(function(x){return x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */])!==-1&&x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])===-1;}).length>0)&&currentTabObject.Templates.Template.filter(function(x){return x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])>-1;}).length>0){inferenceAndOtherGPUsPresent=true;}currentTabObject.Templates.Template.map(function(x,id){var clustersQty=KubClusters;if(x["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */]||x["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_20" /* EPIC_ */]){clustersQty=1;}if(inferenceAndOtherGPUsPresent){if(x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])===-1){totalgpus+=parseInt(x.Nodes["@GPUs"],10)*clustersQty;}}else{totalgpus+=parseInt(x.Nodes["@GPUs"],10)*clustersQty;}});//totalgpus = totalgpus*KubClusters;
};_this.onConfigTypeChange=function(e,templateNumber){if(currentTabObject.Templates.Template[templateNumber]["@ConfigType"]!==e.option){currentTabObject.Templates.Template[templateNumber]["@ConfigType"]=e.option;if(currentTabObject.Templates.Template[templateNumber]["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]){_this.calculateRecommendationButtonValidation();}Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["i" /* updateControllerHostCount */])(_this.props.workload,HAIncluded);Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["m" /* updateMasterHostCount */])(_this.props.workload,HAIncluded);_this.setState({});}};_this.renderTemplates=function(){if(_this.props.Templates){if(currentTabObject.Templates.Template.filter(function(item){return item['@Type']!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}).length>0){currentTabObject.Templates.Template.map(function(template){var SolutionType=currentTabObject["@SolutionType"];var templatesList=_this.props.Templates[SolutionType];if(template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]){if(templatesList&&Object.keys(templatesList).indexOf(template["@Type"])===-1){switch(template["@Type"]){case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_159" /* SPARK_JUPYTER_CONTAINER_GPU_LARGE */]:template["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_188" /* TRAINING_ */]+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_159" /* SPARK_JUPYTER_CONTAINER_GPU_LARGE */];break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_160" /* SPARK_JUPYTER_CONTAINER_GPU_MEDIUM */]:template["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_188" /* TRAINING_ */]+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_160" /* SPARK_JUPYTER_CONTAINER_GPU_MEDIUM */];break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_184" /* TENSORFLOW_JUPYPETER_CONTAINER_GPU_MEDIUM */]:template["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_80" /* INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_MEDIUM */];break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_183" /* TENSORFLOW_JUPYPETER_CONTAINER_GPU_LARGE */]:template["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_79" /* INFERENCE_TENSORFLOW_MODELSERVER_CONTAINER_GPU_LARGE */];break;}}}if(template&&templatesList&&Object.keys(templatesList).find(function(item){return item===template['@Type'];})===undefined){if(template['@Type']!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_36" /* GENERAL_PURPOSE */]){if(_this.props.SSETid){var itemToRename=template['@Type'];itemToRename=itemToRename.replace('CDH ','');if(itemToRename.toUpperCase().indexOf("CONTAINER")===-1){template['@Type']=itemToRename.replace(itemToRename.split(' ')[0],itemToRename.split(' ')[0]+'-Container');}}else{var customType="Custom";template['@Type']=customType;}}};if(template.Nodes["@PersistentStorage"]===undefined){if(template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["N" /* CUSTOM_TEMPLATE */]){template.Nodes["@PersistentStorage"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["M" /* CUSTOMTEMPLATE_DEFAULTVALUE */];}else{template.Nodes["@PersistentStorage"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_124" /* PERSISTENT_STORAGE_DEFAULTVALUE */];}}});}}var loadTemplates=[];var noOfTemplates=1;if(Array.isArray(currentTabObject.Templates.Template)){if(currentTabObject.Templates.Template.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}).length>1){currentTabObject.Templates.Template=currentTabObject.Templates.Template.filter(function(x){return x["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];});}_this.setDefaultTemplate();if(currentTabObject.Templates.Template.length===0){currentTabObject.Templates.Template.push(defaultTemplate);}noOfTemplates=currentTabObject.Templates.Template.length;if(currentTabObject.Templates.Template[noOfTemplates-1]["@Type"]!=="None"){var index=currentTabObject.Templates.Template.findIndex(function(template){return template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];});if(index>-1){currentTabObject.Templates.Template.splice(index,1);}currentTabObject.Templates.Template.push(defaultTemplate);}noOfTemplates=currentTabObject.Templates.Template.length;}var _loop=function _loop(templateNumber){var displayTemplate=true;if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){displayTemplate=false;if(currentTabObject.Templates.Template[templateNumber]["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&currentTabObject.Templates.Template[templateNumber]["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_6" /* DATA_FABRIC */]){displayTemplate=true;}}if(displayTemplate){var textBoxes12345disabled=currentTabObject.Templates.Template[templateNumber]["@Type"]==="None"?true:false;var textBoxes12345bgclr=textBoxes12345disabled?'1px solid rgba(0,0,0,.15)':'1px solid #01a982';var gpuTextBoxdisabled=currentTabObject.Templates.Template[templateNumber]["@Type"].indexOf("GPU")===-1&&currentTabObject.Templates.Template[templateNumber]["@Type"]!=="Custom"&&(currentTabObject["@SolutionType"]!=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]||textBoxes12345disabled)?true:false;var gpuTextBoxbgclr=gpuTextBoxdisabled?'1px solid rgba(0,0,0,.15)':'1px solid #01a982';var selectedTemplate=currentTabObject.Templates.Template[templateNumber]["@Type"];var configurationType=currentTabObject.Templates.Template[templateNumber]["@ConfigType"];loadTemplates.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_202" /* configurationWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{placeHolder:'Kuberenetes',style:{marginBottom:'1px'},value:configurationType,options:["EPIC","Kubernetes"],onChange:function onChange(e){return _this.onConfigTypeChange(e,templateNumber);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_211" /* templateWidth */]},'data-tip':selectedTemplate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{placeHolder:'None',style:{marginBottom:'1px'},value:selectedTemplate,options:List,onChange:function onChange(e){return _this.onNodeTemplateChange(e,templateNumber);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:textBoxes12345bgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_201" /* clustersWidth */]},disabled:textBoxes12345disabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,VIRTUALCLUSTERS,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,VIRTUALCLUSTERS,"Blur",templateNumber);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:textBoxes12345bgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_208" /* nodesPerClusterWidth */]},disabled:textBoxes12345disabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,VIRTUALNODESPERCLUSTER,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,VIRTUALNODESPERCLUSTER,"Blur",templateNumber);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:textBoxes12345bgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_203" /* coresWidth */]},disabled:textBoxes12345disabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@vCPUPerNode"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,CPUCORES,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,CPUCORES,"Blur",templateNumber);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:textBoxes12345bgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_205" /* memoryWidth */]},disabled:textBoxes12345disabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@vMemoryPerNode"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,MEMORY,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,MEMORY,"Blur",templateNumber);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:textBoxes12345bgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_25" /* EphemeralStorageWidth */]},disabled:textBoxes12345disabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@StoragePervNode"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,NODESTORAGE,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,NODESTORAGE,"Blur",templateNumber);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:textBoxes12345bgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_209" /* persistentStorageWidth */]},disabled:textBoxes12345disabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@PersistentStorage"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,PERSISTENT_STORAGE,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,PERSISTENT_STORAGE,"Blur",templateNumber);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{style:{border:gpuTextBoxbgclr,width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_43" /* GPUsWidth */]},disabled:gpuTextBoxdisabled,value:currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,GPUS,"Change",templateNumber);},onBlur:function onBlur(e){return _this.OnvalueChange(e,GPUS,"Blur",templateNumber);}})));}};for(var templateNumber=0;templateNumber<noOfTemplates;templateNumber++){_loop(templateNumber);}return loadTemplates;};_this.renderErrorPopup=function(msg,heading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},heading)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:_this.layerclose.bind(_this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,null,msg)));};_this.updateFinishButton=function(){var disableFinishButton=false;var displayText=true;var selectedServices=_this.props.workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];});if(selectedServices.length===0){disableFinishButton=true;}selectedServices.map(function(solution){if(solution.Templates.Template.filter(function(template){return template["@Type"]!=="None";}).length===0){if(selectedServices.length<2){displayText=false;}disableFinishButton=true;}else{if(solution.NonGPUValue.isCalculated==='false'&&solution.GPUValue.isCalculated==='false'&&solution.StorageValue.isCalculated==='false'){disableFinishButton=true;}}});if(disableFinishButton){if(displayText){_this.props.workload.UserInputs.Environments.configureInAllServicesText=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];configureInAllServicesText=true;}if(_this.props.activeSession.isSizeEnabled){_this.props.OnToggleSizeButton(false);}}else{if(!_this.props.activeSession.isSizeEnabled){_this.props.OnToggleSizeButton(true);}_this.props.workload.UserInputs.Environments.configureInAllServicesText=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];configureInAllServicesText=false;}};_this.updateGrowthObject=function(){if(_this.props.workload.UserInputs.Environments.Growth){if(!Array.isArray(_this.props.workload.UserInputs.Environments.Growth.Host)){var growthObject=_this.props.workload.UserInputs.Environments.Growth.Host;_this.props.workload.UserInputs.Environments.Growth.Host=[];_this.props.workload.UserInputs.Environments.Growth.Host.push(growthObject);}}};_this.onCheckBoxChange=function(correspondingTabName){var actionTab=_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===correspondingTabName;});if(actionTab["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){actionTab["@isSelected"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_207" /* nO_ */];}else{actionTab["@isSelected"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];updatePersistentStorage=true;}if(actionTab["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]){var VMWare=_this.props.workload.UserInputs.Environments.HadoopServices.VMWare;if(actionTab["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){var VMWareLicenses=_this.props.ServiceError.sessionDefaults.Sizers.Sizer.OtherEnvirontmentDetails.VMWareLicenses.License;VMWare["@vCenter"]=VMWareLicenses.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_191" /* VMWARE_VCENTER */];}).Item.find(function(license){return license!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&license!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_192" /* VMWARE_VCENTER_3YRS */];});VMWare["@vSphere"]=VMWareLicenses.find(function(license){return license["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_195" /* VMWARE_VSPHERE */];}).Item.find(function(license){return license!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&license!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_196" /* VMWARE_VSPHERE_3YRS */];});//   VMWare["@vRealize"] = VMWareLicenses.find(license => license["@Type"] === Constants.VMWARE_VREALIZE).Item.find(license => license !== Constants.NONE_);
//   VMWare["@vSAN"] = VMWareLicenses.find(license => license["@Type"] === Constants.VMWARE_VSAN).Item.find(license => license !== Constants.NONE_);
_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@VMWare"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@VMWare"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@VMWare"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];_this.props.workload.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}else{_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@VMWare"]=_this.props.workload.UserInputs.Environments.VMWareUserChoice;_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@VMWare"]=_this.props.workload.UserInputs.Environments.MasterVMWareUserChoice;_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@VMWare"]=_this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice;_this.props.workload.UserInputs.Environments.Licenses.Nimble=_this.props.workload.UserInputs.Environments.NimbleUserChoice;for(var key in VMWare){VMWare[key]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}}}if(actionTab["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_36" /* GENERAL_PURPOSE */]||actionTab["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){if(actionTab["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){if(_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@VMWare"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){_this.props.workload.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}}}// if (actionTab["@SolutionType"] === Constants.MLOPS && this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses !== undefined && this.props.workload.UserInputs.Environments.WorkloadType === Constants.BLUE_DATA) {
//     if (actionTab["@isSelected"] === Constants.yES_) {
//         this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
//             if (Services['@Type'] === "Data Apps w/ML Ops") {
//                 Services['@IsSelected'] = Constants.tRUE_.toString();
//                 Services['@Description'] = this.props.sessionsDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License.find(item => item['@Type'] === 'Data Apps w/ML Ops').Item.filter(option => option !== 'None')[0];
//             }
//         })
//     } else {
//         this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR.License.filter((Services) => {
//             if (Services['@Type'] === "Data Apps w/ML Ops") {
//                 Services['@IsSelected'] = Constants.fALSE_.toString();
//             }
//         })
//     }
// }
Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["i" /* updateControllerHostCount */])(_this.props.workload,HAIncluded);Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["m" /* updateMasterHostCount */])(_this.props.workload,HAIncluded);_this.props.workload.UserInputs.Environments.ManagementHosts.Server.map(function(host){var serverName=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["d" /* getGatewayandControllerHost */])(_this.props.workload,host["@Type"]);if(serverName!==host["@Name"]){host["@Name"]=serverName;_this.props.ServiceError.guiState.updateManagementDetails=true;}});_this.updateFinishButton();if(_this.props.currentTab){_this.props.changeCurrentTab(false);}else{_this.props.changeCurrentTab(true);}_this.setState({});};_this.MLOpsCheckBoxChange=function(event){_this.setDefaultTemplate();if(event.target.id===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_100" /* MLOPS_TEMPLATES */]){if(_this.state.MLOpsTemplatesCheckBox){_this.state.MLOpsTemplatesCheckBox=false;currentTabObject.Templates.Template=currentTabObject.Templates.Template.filter(function(template){return template["@InputMode"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */];});}else{_this.state.MLOpsTemplatesCheckBox=true;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]])[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;if(_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["isDefault"]){var newTemplate=JSON.parse(JSON.stringify(defaultTemplate));newTemplate["@InputMode"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */];newTemplate["@Type"]=key;newTemplate.Nodes["@vClusters"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["i_ClusterQty"].toString();newTemplate.Nodes["@vNodesPerCluster"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["i_NodesPerCluster"].toString();newTemplate.Nodes["@MinvNodes"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["i_MinvNodes"].toString();newTemplate.Nodes["@vCPUPerNode"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["i_vCPUs"].toString();newTemplate.Nodes["@vMemoryPerNode"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["d_vMemory"].toString();newTemplate.Nodes["@StoragePervNode"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["d_NodeStorage"].toString();newTemplate.Nodes["@PersistentStorage"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["d_PersistentStorage"].toString();newTemplate.Nodes["@userGPUs"]=_this.props.Templates[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]][key]["i_GPUs"].toString();newTemplate.Nodes["@GPUs"]=(parseInt(newTemplate.Nodes["@vClusters"],10)*parseInt(newTemplate.Nodes["@vNodesPerCluster"],10)*parseInt(newTemplate.Nodes["@userGPUs"],10)).toString();currentTabObject.Templates.Template.push(newTemplate);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}else if(event.target.id===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_99" /* MLOPS_IMAGE_PROCESSING */]){if(_this.state.MLOpsImageProcessingCheckBox){_this.state.MLOpsImageProcessingCheckBox=false;currentTabObject.Templates.Template=currentTabObject.Templates.Template.filter(function(template){return template["@InputMode"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */];});}else{_this.state.MLOpsImageProcessingCheckBox=true;var inferenceTemplate=Object.assign({},defaultTemplate);inferenceTemplate["@InputMode"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */];inferenceTemplate["@ConfigType"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_20" /* EPIC_ */];inferenceTemplate.Nodes["@ImagesPerSec"]="0";inferenceTemplate["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */];inferenceTemplate.Nodes["@GPUType"]=T4_GPU;inferenceTemplate.Nodes["@vClusters"]="1";inferenceTemplate.Nodes["@vNodesPerCluster"]="1";currentTabObject.Templates.Template.push(inferenceTemplate);var trainingTemplate=JSON.parse(JSON.stringify(inferenceTemplate));trainingTemplate["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */];trainingTemplate.Nodes["@GPUType"]=A100_PCIE_80GB_GPU;trainingGPUvalue=A100_PCIE_80GB_GPU;currentTabObject.Templates.Template.push(trainingTemplate);}}Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["i" /* updateControllerHostCount */])(_this.props.workload,HAIncluded);Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["m" /* updateMasterHostCount */])(_this.props.workload,HAIncluded);_this.calculateRecommendationButtonValidation();_this.setState({});};_this.onImageProcChange=function(e,templateType,DOMevent){if(DOMevent===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]){var value=parseInt(e.target.value,10);var maxValue=999999;if(isNaN(value)){e.target.value="";}else if(value>=0&&value<=maxValue){e.target.value=value.toString();}else if(value>maxValue){e.target.value=e.target.value.slice(0,-1);}}if(DOMevent===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){if(e.target.value===""){e.target.value="0";}}currentTabObject.Templates.Template.find(function(template){return template["@Type"]===templateType;}).Nodes["@ImagesPerSec"]=e.target.value;_this.calculateRecommendationButtonValidation();_this.setState({});};_this.onMLOPsGPUChange=function(e,templateType){var template=currentTabObject.Templates.Template.find(function(template){return template["@Type"]===templateType;});if(template.Nodes["@GPUType"]!==e.option){if(templateType==="Training"){trainingGPUvalue=e.option;isGPUvalueChanged=false;}template.Nodes["@GPUType"]=e.option;_this.calculateRecommendationButtonValidation();_this.setState({});}};_this.setDefaultTemplate=function(){defaultTemplate={"@Type":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */],"@ConfigType":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_84" /* KUBERNETES_ */],"Nodes":{"@vClusters":"0","@vNodesPerCluster":"0","@MinvNodes":"0","@vCPUPerNode":"0","@vMemoryPerNode":"0","@StoragePervNode":"0","@PersistentStorage":"0","@GPUs":"0","@userGPUs":"0"}};if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){defaultTemplate["@InputMode"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */];defaultTemplate.Nodes["@GPUType"]="";defaultTemplate.Nodes["@ImagesPerSec"]="";}};_this.renderImageProcessingUI=function(templateType,GPUOptions){var template=currentTabObject.Templates.Template.find(function(template){return template["@Type"]===templateType;});if(!template){_this.setDefaultTemplate();var Template=JSON.parse(JSON.stringify(defaultTemplate));Template["@InputMode"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */];Template["@ConfigType"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_20" /* EPIC_ */];Template.Nodes["@ImagesPerSec"]="0";Template["@Type"]=templateType;if(templateType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */]){Template.Nodes["@GPUType"]=T4_GPU;}else{Template.Nodes["@GPUType"]=A100_PCIE_80GB_GPU;}Template.Nodes["@vClusters"]="1";Template.Nodes["@vNodesPerCluster"]="1";currentTabObject.Templates.Template.push(Template);}var imageProcessingValue=template.Nodes["@ImagesPerSec"];var GPUValue=template.Nodes["@GPUType"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:'15%',marginTop:'26px'}},templateType,' Workload'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{height:'75px',width:'31%'},error:'(0-999999)',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processing Images per sec'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Number of images to be processed per sec. The sizer will recommend the number of GPUs required using ResNet50 Inference and Training benchmark results publised in HPE Deep Learning Performance Guide.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:imageProcessingValue,onDOMChange:function onDOMChange(e){_this.onImageProcChange(e,templateType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]);},onBlur:function onBlur(e){_this.onImageProcChange(e,templateType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{height:'75px',width:'31%'},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'GPUs'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:GPUValue,options:GPUOptions,onChange:function onChange(e){_this.onMLOPsGPUChange(e,templateType);}})));};_this.state={maxKubernetesMemory:930,maxEpicMemory:963,nvmeMaxedOut:false,storageTenantDriveType:"",storageTenantDriveConsolidatedOptions:[],changeStorageTenantDriveTypeOptions:false,enableADDButton:true,MLOpsTemplatesCheckBox:false,MLOpsImageProcessingCheckBox:false};_this.resetChangesToEmpty=_this.resetChangesToEmpty.bind(_this);_this.textOnChangeofConfiguration=_this.textOnChangeofConfiguration.bind(_this);_this.noteContent=_this.noteContent.bind(_this);return _this;}_createClass(DesignRequirements,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.workload){if(this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions===undefined){this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions=FALSE;}if(this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange===undefined){this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange=FALSE;}if(this.props.workload.UserInputs.Environments.Environment.filter(function(environment){return environment["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).length>0){if(this.props.activeSession.treeView&&this.props.workload.UserInputs.Environments.Environment.filter(function(environment){return environment["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];})[0].NonGPUValue===undefined){this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions=TRUE;}}if(this.props.workload.UserInputs.Environments.configureInAllServicesText===undefined){this.props.workload.UserInputs.Environments.configureInAllServicesText=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}if(this.props.workload.UserInputs.Environments.VMWareUserChoice===undefined){this.props.workload.UserInputs.Environments.VMWareUserChoice=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}if(this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice===undefined){this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}if(this.props.workload.UserInputs.Environments.NimbleUserChoice===undefined){this.props.workload.UserInputs.Environments.NimbleUserChoice=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}var roleDetailsObject={TotalVMemory:'',TotalCore:'',TotalStorage:'',Server:'',Proc:'',Memory:'',Drive:'',DriveQty:'',ServerQty:'',isCalculated:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]};this.props.workload.UserInputs.Environments.Environment.map(function(solution){if(!solution.NonGPUValue){solution.NonGPUValue=Object.assign({},roleDetailsObject);}if(!solution.GPUValue){solution.GPUValue=Object.assign({},roleDetailsObject);}if(!solution.StorageValue){solution.StorageValue=Object.assign({},roleDetailsObject);}if(!Array.isArray(solution.Templates.ServerDetails.Server)){var singleRole=solution.Templates.ServerDetails.Server;solution.Templates.ServerDetails.Server=[];solution.Templates.ServerDetails.Server.push(singleRole);}if(!Array.isArray(solution.Templates.Template)){var singleTemplate=solution.Templates.Template;solution.Templates.Template=[];solution.Templates.Template.push(singleTemplate);}solution.Templates.ServerDetails.Server.map(function(role){if(role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]){if(role["@mixedTenantStorage"]===undefined){role["@mixedTenantStorage"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_27" /* FALSE_ */];}if(role["@TenantDriveType"]===undefined){role["@TenantDriveType"]="";}if(role.PersistentDisks===undefined||!Array.isArray(role.PersistentDisks)){var persistentDriveSize='';if(role.PersistentDisks){persistentDriveSize=role.PersistentDisks.Item[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_158" /* SIZE_ATTRIBUTE */]];}var TenantDiskArray=[{Item:{"@size":persistentDriveSize,'@disk':role['@TStorageDrive'],'@qty':role['@TStorageDriveQty'],"@volumeName":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_123" /* PERSISTENT_ */]}}];role.PersistentDisks=TenantDiskArray;}}});});currentTabObject=this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];});HAIncluded=this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@HAIncluded"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]?false:true;if(HAIncluded){this.ChkboxChange(false,false);}}}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _this2=this;if(this.props.workload){this.props.ServiceError.guiState.displayWarning=false;this.props.workload.UserInputs.Environments.Environment.filter(function(service){return service["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).map(function(selectedService){if(selectedService.NonGPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]&&selectedService.GPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]&&selectedService.StorageValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]){_this2.props.ServiceError.guiState.displayWarning=true;}});}}},{key:'onKeyPressed',value:function onKeyPressed(e){if(e.keyCode==13){e.stopPropagation();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(this.props.ServiceError.guiState.updateManagementDetails){var gatewayServer=this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@Name"];var configMode=currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"];var gatewayPayload={"strServer":gatewayServer,"strHostType":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_30" /* GATEWAY_HOST */],"strConfigMode":configMode,"isControllerHostVMWareChecked":this.props.workload.UserInputs.Environments.VMWareUserChoice};this.props.GatewayRecommendations(gatewayPayload);var controllerServer=this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@Name"];var controllerPayload={"strServer":controllerServer,"strHostType":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["G" /* CONTROLLER_HOST */],"strConfigMode":configMode,"isControllerHostVMWareChecked":this.props.workload.UserInputs.Environments.VMWareUserChoice};this.props.ControllerRecommendations(controllerPayload);var masterServer=this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@Name"];var masterPayload={"strServer":masterServer,"strHostType":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_90" /* MASTER_HOST */],"strConfigMode":configMode,"isControllerHostVMWareChecked":this.props.workload.UserInputs.Environments.MasterVMWareUserChoice};this.props.MasterRecommendations(masterPayload);this.props.ServiceError.guiState.GandCAPICount=3;this.props.ServiceError.guiState.updateManagementDetails=false;}if(this.props.calculateBlueDataAPIcount!==nextProps.calculateBlueDataAPIcount&&nextProps.calculateBlueDataAPIcount!==undefined&&nextProps.calculateBlueDataAPIcount===0){this.props.CalculateBlueDataConfigurationtrue(this.props.sizerWorkloadforCalculation.value);}if(this.props.calculateWithUpdatedTenantDrive){var roleType=this.props.currentRoleName;var value={"input":{"Workload":null},"Inputsnotchanged":false,"RoleType":roleType};value.input.Workload=this.props.workload;this.props.calculateWithUpdatedTenantDriveAction(false);this.props.currentRoleNameAction("");this.props.CalculateBlueDataConfigurationfalse(value);}if(NonGPUOSDriveList!=nextProps.NonGPUList){this.setState({});}}},{key:'textOnChangeofConfiguration',value:function textOnChangeofConfiguration(requirementType,changedValue){var changes="";switch(changedValue){case"HostType":changes=",Host Type";break;case"ProcessorFamily":changes=",Processor Family";break;case"Processor":changes=",Processor Type";break;case"Memory":changes=",Memory";break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_107" /* NODE_STORAGE_DRIVE */]:changes=","+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_18" /* EPHEMERAL_STORAGE_DRIVE */];break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_108" /* NODE_STORAGE_DRIVE_QTY */]:changes=","+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_19" /* EPHEMERAL_STORAGE_DTIVE_QUANTITY */];break;case"OSDrive":changes=",OS Drive";break;case"DriveType":changes=",Persistent Drive Type";break;case"LocalTenantDrive":changes=",Persistent Drive";break;case"LocalTenantDriveQty":changes="Persistent Drive Quantity";break;case"GPUType":changes=",GPU Type";break;case"HostCount":changes=",Host Count";break;case"GPUCountPerServer":changes=",GPU Count Per server";break;}switch(requirementType){case"GPU":GPUChanges+=changes;break;case"nonGPU":nonGPUChanges+=changes;break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]:StorageChanges+=changes;}}},{key:'resetChangesToEmpty',value:function resetChangesToEmpty(){GPUChanges="";nonGPUChanges="";StorageChanges="";}},{key:'noteContent',value:function noteContent(Final_Note,requirementType){var final_note=Final_Note;var final_text=" ";if(final_note==="")return"";var text1=final_note.split(",");if(text1.length===1){final_text=text1[0]+" is changed";}else if(text1.length>1){for(var i=0;i<text1.length;i++){if(i==text1.length-2){final_text=final_text+text1[i]+" and ";}else if(i==text1.length-1){final_text=final_text+text1[i]+" are changed";}else{final_text=final_text+text1[i]+", ";}}}var noteTextOnChangeOfConfiguration=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_Label___default.a,{style:{color:'#01a982'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{maxWidth:'100%',marginLeft:'1%',marginTop:'27px',color:'#01a982'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note :'),final_text));if(requirementType==="GPU"){GPUNoteText=noteTextOnChangeOfConfiguration;}else if(requirementType==="nonGPU"){nonGPUNoteText=noteTextOnChangeOfConfiguration;}else if(requirementType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]){StorageNoteText=noteTextOnChangeOfConfiguration;}}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.workload.ServicesInput===undefined&&this.props.sessionsDefaults.inputs!==""){this.props.onUpdateDefaultSession(this.props.sessionsDefaults.inputs);}this.resetChangesToEmpty();document.addEventListener("keydown",this.onKeyPressed.bind(this));this.onCalcTempClick();var value={"strHostType":"GPU","strHDFSRawSize":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],"strHDFSRepFactor":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]};if(this.props.GPUdetails===null){this.props.OnGatewaydltsfetch(value);}var input={"strHostType":"NonGPU","strHDFSRawSize":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],"strHDFSRepFactor":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]};if(this.props.NonGPUdetails===null){this.props.OnGatewaydltsfetch(input);}var value1={"strHostType":"Gateway","strHDFSRawSize":null,"strHDFSRepFactor":null};if(this.props.gatewaydetails===null)this.props.OnGatewaydltsfetch(value1);var inputs1={"strHostType":"Controller","strHDFSRawSize":null,"strHDFSRepFactor":null};if(this.props.controllerdetails===null)this.props.OnGatewaydltsfetch(inputs1);var masterInputs={"strHostType":"Master","strHDFSRawSize":null,"strHDFSRepFactor":null};if(this.props.masterdetails===null)this.props.OnGatewaydltsfetch(masterInputs);var storageInputs={"strHostType":__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_162" /* STORAGE_HOST_ROLE_NAME */],"strHDFSRawSize":null,"strHDFSRepFactor":null};if(this.props.Storagedetails===null)this.props.OnGatewaydltsfetch(storageInputs);if(this.props.Templates===null)this.props.OnFetchTemplateList();var inputs={"dHDFSStorage":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],"dHDFSRepFactor":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]};if(this.props.Epicreq===null){this.props.EPICRequirements(inputs);}if(currentTabObject["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){var NoValues=this.checkValues();if(NoValues||this.props.ConfigButton){this.props.Calcbutton(true);}if(NoValues||!this.props.ConfigButton){if(this.props.activeSession.isSizeEnabled){this.props.OnToggleSizeButton(false);}}if(this.props.activeSession.isSizeEnabled){this.updateFinishButton();}else{if(currentTabObject.NonGPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]||currentTabObject.GPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]||currentTabObject.StorageValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){this.updateFinishButton();}}}if(updateInitialConfigurations){if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]){this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@VMWare"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}updateInitialConfigurations=false;}if(!Array.isArray(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License)||this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License.length===2||this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License===undefined){var License=[{"@Description":'None',"@IsSelected":"true","@Type":"BlueData"},{"@Description":"None","@IsSelected":"false","@Type":"BlueDataAI"},{"@Description":"24x7 1y","@IsSelected":"true","@Type":"HPE Container Platform"}];this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.License=License;}if(this.props.sessionsDefaults.inputs){Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["o" /* updateServiceLicenses */])(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses,this.props.sessionsDefaults.inputs.Sizers.Sizer.OtherEnvirontmentDetails.Services.ServiceLicenses.License);}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration===undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.Configuration={'@Type':'EPIC'};}if(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])!==-1){this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})['@OSDiskQty']="1";}if(this.props.workload.UserInputs.Environments.HadoopServices.Deployment===undefined){this.props.workload.UserInputs.Environments.HadoopServices.Deployment='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.AppStore===undefined){this.props.workload.UserInputs.Environments.HadoopServices.AppStore='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.Installation===undefined){this.props.workload.UserInputs.Environments.HadoopServices.Installation='false';}if(this.props.workload.UserInputs.Environments.HadoopServices.SingleImage===undefined){this.props.workload.UserInputs.Environments.HadoopServices.SingleImage={"@Qty":"1","#text":"false"};}if(this.props.workload.UserInputs.Environments.HadoopServices.CustomImage===undefined){this.props.workload.UserInputs.Environments.HadoopServices.CustomImage={"@Qty":"1","#text":"false"};}if(this.props.country!==undefined){this.props.workload.UserInputs.Country=this.props.country;}}// hideGatewayHostCheckBoxchange = () => {
//     hideGatewayHostChecked = hideGatewayHostChecked ? false : true;
//     this.setState({})
// }
},{key:'layerclose',value:function layerclose(){Houstcountdata="";HostChanged=false;HoustcountExceded=false;this.setState({nvmeMaxedOut:false});}},{key:'Errorclose',value:function Errorclose(){this.props.Errorclose();}},{key:'GPUtextchange',value:function GPUtextchange(e,textinput,chorBlr){var number=/^[0-9]+$/;var maxval=999999;var minval=1;var val=false;if(textinput==="NonGPUNodeCount"){maxval=currentTabObject.NonGPUValue.ServerQty+99;minval=currentTabObject.NonGPUValue.ServerQty;}if(textinput==="GPUNodeCoount"){// maxval = currentTabObject.GPUValue.ServerQty + 99;
// minval = currentTabObject.GPUValue.ServerQty;
maxval=this.props.GPUHostCount.GPUHostCount+99;minval=this.props.GPUHostCount.GPUHostCount;}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */]){maxval=currentTabObject.StorageValue.ServerQty+99;minval=currentTabObject.StorageValue.ServerQty;}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_113" /* NONGPU_NODE_STORAGE_DRIVE_QUANTITY */]||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_39" /* GPU_NODE_STORAGE_DRIVE_QUANTITY */]){minval=2;}var value=parseInt(e.target.value,10);if(chorBlr==="Change"){if(saveWorkload){this.saveOldWorkloads();saveWorkload=false;}if(e.target.value.length<5){if(isNaN(value)){selectchange="";}else if(number.test(value)&&value<=999999&&value>=1||isNaN(value)){selectchange=value.toString();}else{if(textinput==="NonGPUNodeCount"||textinput==="GPUNodeCoount"){selectchange="";}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */]){selectchange="";}}}}else{saveWorkload=true;if(e.target.value===""){if(textinput==="NonGPUNodeCount"||textinput==="GPUNodeCoount"){if(textinput==="NonGPUNodeCount"){selectchange=currentTabObject.NonGPUValue.ServerQty.toString();}if(textinput==="GPUNodeCoount"){selectchange=currentTabObject.GPUValue.ServerQty.toString();}}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */]){selectchange=currentTabObject.StorageValue.ServerQty.toString();}else{selectchange="1";}}else{if(number.test(value)&&value<=maxval&&value>=minval||isNaN(value)&&(textinput==="NonGPUNodeCount"||textinput==="GPUNodeCoount"||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */])){selectchange=e.target.value.toString();}else{if(textinput==="GPUNodeCoount"){//selectchange = currentTabObject.GPUValue.ServerQty.toString();
selectchange=this.props.GPUHostCount.GPUHostCount.toString();HoustcountExceded=true;Minhostcount=minval;Maxhostcount=maxval;}else if(textinput==="NonGPUNodeCount"){selectchange=currentTabObject.NonGPUValue.ServerQty.toString();HoustcountExceded=true;Minhostcount=minval;Maxhostcount=maxval;}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */]){selectchange=currentTabObject.StorageValue.ServerQty.toString();HoustcountExceded=true;Minhostcount=minval;Maxhostcount=maxval;}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_39" /* GPU_NODE_STORAGE_DRIVE_QUANTITY */]||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_113" /* NONGPU_NODE_STORAGE_DRIVE_QUANTITY */]){if(value<minval){selectchange=minval.toString();}}else{selectchange=e.target.value;}}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_113" /* NONGPU_NODE_STORAGE_DRIVE_QUANTITY */]||textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_39" /* GPU_NODE_STORAGE_DRIVE_QUANTITY */]){val=true;}}this.onWrkUpdateselect(selectchange,textinput,val,chorBlr);}},{key:'onWrkUpdateselect',value:function onWrkUpdateselect(value,textinput,valueChanged,chorBlr){var _this3=this;var GPUServer=GPUNodeType;var GPUDataDisk=value;var NonGPUServer=ComptNodeType;var NonGPUDataDisk=value;var roleType='';if(textinput==='ComptNodeType'||textinput.toUpperCase().indexOf('NONGPU')>-1){roleType='NonGPU';}else if(textinput.indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */].toLowerCase())>-1){roleType=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];}else{roleType='GPU';}currentTabObject.Templates.ServerDetails.Server.filter(function(x){var selectedDriveValidation=function selectedDriveValidation(drive1,drive2,maxDrives,serverName){var type=arguments.length>4&&arguments[4]!==undefined?arguments[4]:'';if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(value.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||value.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1)){valueChanged=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["p" /* validateApollo4200SFFDrives */])(drive1,drive2,value);}if(valueChanged){valueChanged=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["q" /* validateDriveChange */])(drive1,drive2,value,serverName,NonGPUTenantStorageDriveQuantity,type);}if(!valueChanged){Houstcountdata=_this3.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_12" /* DRIVE_CANNOTBE_MIXED */],ERROR_TEXT);}};switch(x["@Type"]){case"GPU":if(textinput==="GPUNodeType"){if(GPUNodeType!==value){x["@Name"]=value;if(value.indexOf('m510')===-1&&value.indexOf('e910')===-1&&value.indexOf(E920)===-1){x["@ServerName"]=value;}else{x["@ServerName"]="HP Moonshot System";}GPUServer=x["@Name"];GPUProcList=[];GPUOSDriveList=[];GPUStrDrivetypeList=[];GPUTenantStoragedrivelist=[];GPUProcFamilyList=[];GPUMemoryList=[];GPUList=_this3.props.GPUdetails;for(var key in GPUList){if(key===x["@Name"]){EPICGPUlist=GPUList[key].GPUList;if(EPICGPUlist.indexOf(x["@GPUType"])===-1){x["@GPUType"]=EPICGPUlist[0];_this3.textOnChangeofConfiguration("GPU","GPUType");}GPUStrDrivetypeList=GPUList[key].DataDriveList;GPUTenantStoragedrivelist=GPUList[key].TenantDriveList;if(GPUStrDrivetypeList.indexOf(x["@NodeDisk"])===-1){x["@NodeDisk"]=GPUStrDrivetypeList[0];_this3.textOnChangeofConfiguration("GPU","NodeStorageDriveQty");}if(GPUTenantStoragedrivelist.indexOf(x["@TStorageDrive"])===-1){x["@TStorageDrive"]=GPUTenantStoragedrivelist[0];_this3.textOnChangeofConfiguration("GPU","LocalTenantDrive");}GPUOSDriveList=GPUList[key].OSDriveList;if(GPUOSDriveList.indexOf(x["@OSDisk"])===-1){x["@OSDisk"]=GPUOSDriveList[0];_this3.textOnChangeofConfiguration("GPU","OSDrive");}for(var proctype in GPUList[x["@Name"]].ProcessorList){GPUProcFamilyList.push(proctype);}if(GPUProcFamilyList.indexOf(x["@ProcFamily"])===-1){x["@ProcFamily"]=GPUProcFamilyList[0];_this3.textOnChangeofConfiguration("GPU","ProcessorFamily");}for(var _proctype in GPUList[x["@Name"]].ProcessorList){if(_proctype===x["@ProcFamily"]){for(var proc in GPUList[x["@Name"]].ProcessorList[_proctype]){GPUProcList.push(proc);}}}if(GPUProcList.indexOf(x["@Proc"])===-1){x["@Proc"]=GPUProcList[0];_this3.textOnChangeofConfiguration("GPU","Processor");}GPUMemoryList=GPUList[x["@Name"]].ProcessorList[x["@ProcFamily"]][x["@Proc"]];if(GPUMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=GPUMemoryList[0];_this3.textOnChangeofConfiguration("GPU","Memory");}}}}}if(textinput==="GPUProcType"){x["@Proc"]=value;GPUMemoryList=[];GPUList=_this3.props.GPUdetails;for(var _key3 in GPUList){if(_key3===GPUNodeType){for(var procfamily in GPUList[_key3].ProcessorList){if(procfamily===x["@ProcFamily"]){for(var _proc in GPUList[_key3].ProcessorList[procfamily]){if(_proc===x["@Proc"]){GPUMemoryList=GPUList[_key3].ProcessorList[procfamily][_proc];if(GPUMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=GPUMemoryList[0];_this3.textOnChangeofConfiguration("GPU","Memory");}}}}}}}}if(textinput==="GPUProcFamilyType"){x["@ProcFamily"]=value;GPUMemoryList=[];GPUProcList=[];GPUList=_this3.props.GPUdetails;for(var _key4 in GPUList){if(_key4===GPUNodeType){for(var _procfamily in GPUList[_key4].ProcessorList){if(_procfamily===x["@ProcFamily"]){for(var _proc2 in GPUList[_key4].ProcessorList[_procfamily]){GPUProcList.push(_proc2);}x["@Proc"]=GPUProcList[0];_this3.textOnChangeofConfiguration("GPU","Processor");GPUMemoryList=GPUList[x["@Name"]].ProcessorList[_procfamily][x["@Proc"]];if(GPUMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=GPUMemoryList[0];_this3.textOnChangeofConfiguration("GPU","Memory");}}}}}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_38" /* GPU_NODE_STORAGE_DRIVE */]){if(GPUStrDrivetype!==value){var oldDrive=GPUStrDrivetype;x["@NodeDisk"]=value;selectedDriveValidation(x["@TStorageDrive"],x["@OSDisk"],_this3.props.GPUdetails[x["@Name"]].MaxNVMeDrives,x["@Name"],'ephemeral');if(!valueChanged){x["@NodeDisk"]=oldDrive;DatadriveChanged=false;}GPUStrDrivetype=x["@NodeDisk"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_42" /* GPU_TENANT_DRIVE */]){if(GPUTenantStoragedrive!==value){var _oldDrive=GPUTenantStoragedrive;x["@TStorageDrive"]=value;selectedDriveValidation(x["@NodeDisk"],x["@OSDisk"],_this3.props.GPUdetails[x["@Name"]].MaxNVMeDrives,x["@Name"],'persistent');if(!valueChanged){x["@TStorageDrive"]=_oldDrive;}GPUTenantStoragedrive=x["@TStorageDrive"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_40" /* GPU_OSDRIVE */]){if(GPUOSDrive!==value){var _oldDrive2=GPUOSDrive;x["@OSDisk"]=value;selectedDriveValidation(x["@NodeDisk"],x["@TStorageDrive"],_this3.props.GPUdetails[x["@Name"]].MaxNVMeDrives,x["@Name"],'osdrive');if(!valueChanged){x["@OSDisk"]=_oldDrive2;}GPUOSDrive=x["@OSDisk"];}}if(textinput==="GPUNodeCoount")x["@NodesCount"]=value;if(textinput==="GPUMemory")x["@Memory"]=value;if(textinput==="GPUType"){x["@GPUType"]=value;if(GPUNodeType==="ProLiant XL190r Gen10"){x["@GPUcount"]=2;}else if(GPUNodeType==="ProLiant XL270d Gen10"){x["@GPUcount"]=8;if(x["@GPUType"]===T4_GPU||x["@GPUType"]===A100_PCIE_80GB_GPU){x["@GPUcount"]=8;}}else if(GPUNodeType===proLiantDL360Gen10){x["@GPUcount"]=2;}else if(GPUNodeType===proLiantDL380Gen10){x["@GPUcount"]=3;if(x["@GPUType"]===T4_GPU){x["@GPUcount"]=7;}else if(x["@GPUType"]===A100_40GB_GPU||x["@GPUType"]===A40_PCIE_48GB_GPU){x["@GPUcount"]=2;}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_141" /* PROLIANT_XL675D_GEN10_PLUS */]){x["@GPUcount"]=10;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_140" /* PROLIANT_XL645D_GEN10_PLUS */]){x["@GPUcount"]=4;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_134" /* PROLIANT_DL385_GEN10_PLUS */]){if(x["@GPUType"]===T4_GPU){x["@GPUcount"]=8;}else{x["@GPUcount"]=3;}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_135" /* PROLIANT_E910T_2U_SERVER */]){x["@GPUcount"]=x["@GPUType"]===T4_GPU||x["@GPUType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_179" /* T4_TESLA_GPU */]?3:1;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_136" /* PROLIANT_E910_2U_SERVER */]){x["@GPUcount"]=x["@GPUType"]===T4_GPU||x["@GPUType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_179" /* T4_TESLA_GPU */]?3:1;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_139" /* PROLIANT_XL290N_GEN10_PLUS */]){if(x["@GPUType"]===T4_GPU){x["@GPUcount"]=4;}else{x["@GPUcount"]=2;}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */]){x["@GPUcount"]=3;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_130" /* PROLIANT_DL360_GEN10_PLUS */]){x["@GPUcount"]=2;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_133" /* PROLIANT_DL380_GEN10_PLUS */]){x["@GPUcount"]=3;if(GPUType===T4_GPU){x["@GPUcount"]=8;}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_131" /* PROLIANT_DL365_GEN10_PLUS */]){x["@GPUcount"]=2;}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_128" /* PROLIANT_DL325_GEN10_PLUS_V2 */]){x["@GPUcount"]=2;}else{x["@GPUcount"]=1;}}if(textinput==="GPUCount")x["@GPUcount"]=value;if(textinput==="GPUNodeStorageDriveQuantity"){if(chorBlr!=="Change"){if(value!==""){Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["e" /* nodeStorageDriveQuantityOnBlurValidation */])(x,value,_this3.props.GPUdetails);}else{x["@StorageDiskQty"]=" ";}}else{x["@StorageDiskQty"]=value;}}break;case"NonGPU":if(textinput==="ComptNodeType"){if(ComptNodeType!==value){x["@Name"]=value;if(value.indexOf('m510')===-1&&value.indexOf('e910')===-1&&value.indexOf(E920)===-1){x["@ServerName"]=value;}else{x["@ServerName"]="HP Moonshot System";}NonGPUServer=x["@Name"];NonGPUProcList=[];NonGPUProcFamilyList=[];NonGPUOSDriveList=[];NonGPUStrDrivetypeList=[];NonGPUTenantStoragedrivelist=[];NonGPUMemoryList=[];NonGPUList=_this3.props.NonGPUdetails;for(var _key5 in NonGPUList){ComptNodeList.push(_key5);if(_key5===x["@Name"]){computeGPUTypeOptions=NonGPUList[_key5].GPUList;NonGPUStrDrivetypeList=NonGPUList[_key5].DataDriveList;NonGPUTenantStoragedrivelist=NonGPUList[_key5].TenantDriveList;if(NonGPUStrDrivetypeList.indexOf(x["@NodeDisk"])===-1){x["@NodeDisk"]=NonGPUStrDrivetypeList[0];_this3.textOnChangeofConfiguration("nonGPU","NodeStorageDrive");}if(NonGPUTenantStoragedrivelist.indexOf(x["@TStorageDrive"])===-1){x["@TStorageDrive"]=NonGPUTenantStoragedrivelist[0];_this3.textOnChangeofConfiguration("nonGPU","LocalTenantDrive");}NonGPUOSDriveList=NonGPUList[_key5].OSDriveList;if(NonGPUOSDriveList.indexOf(x["@OSDisk"])===-1){x["@OSDisk"]=NonGPUOSDriveList[0];_this3.textOnChangeofConfiguration("nonGPU","OSDrive");}x["@StorageDiskQty"]=_this3.props.GPUdetailsforcore.NonGPUValue.DriveQty.toString();for(var _proctype2 in NonGPUList[x["@Name"]].ProcessorList){NonGPUProcFamilyList.push(_proctype2);}if(NonGPUProcFamilyList.indexOf(x["@ProcFamily"])===-1){x["@ProcFamily"]=NonGPUProcFamilyList[0];_this3.textOnChangeofConfiguration("nonGPU","ProcessorFamily");}for(var _proctype3 in NonGPUList[x["@Name"]].ProcessorList){if(_proctype3===x["@ProcFamily"]){for(var _proc3 in NonGPUList[x["@Name"]].ProcessorList[_proctype3]){NonGPUProcList.push(_proc3);}if(NonGPUProcList.indexOf(x["@Proc"])===-1){x["@Proc"]=NonGPUProcList[0];_this3.textOnChangeofConfiguration("nonGPU","Processor");}NonGPUMemoryList=NonGPUList[x["@Name"]].ProcessorList[_proctype3][x["@Proc"]];if(NonGPUMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=NonGPUMemoryList[0];_this3.textOnChangeofConfiguration("nonGPU","Memory");}}}}}}}if(textinput==="NonGPUProcType"){x["@Proc"]=value;NonGPUMemoryList=[];NonGPUList=_this3.props.NonGPUdetails;for(var _key6 in NonGPUList){if(_key6===ComptNodeType){for(var _procfamily2 in NonGPUList[_key6].ProcessorList){if(_procfamily2===x["@ProcFamily"]){for(var _proc4 in NonGPUList[_key6].ProcessorList[_procfamily2]){if(_proc4===x["@Proc"]){NonGPUMemoryList=NonGPUList[_key6].ProcessorList[_procfamily2][_proc4];if(NonGPUMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=NonGPUMemoryList[0];_this3.textOnChangeofConfiguration("nonGPU","Memory");}}}}}}}}if(textinput==="NonGPUProcFamilyType"){x["@ProcFamily"]=value;NonGPUMemoryList=[];NonGPUProcList=[];NonGPUList=_this3.props.NonGPUdetails;for(var _key7 in NonGPUList){if(_key7===ComptNodeType){for(var _procfamily3 in NonGPUList[_key7].ProcessorList){if(_procfamily3===x["@ProcFamily"]){for(var _proc5 in NonGPUList[_key7].ProcessorList[_procfamily3]){NonGPUProcList.push(_proc5);}x["@Proc"]=NonGPUProcList[0];_this3.textOnChangeofConfiguration("nonGPU","Processor");NonGPUMemoryList=NonGPUList[x["@Name"]].ProcessorList[_procfamily3][x["@Proc"]];if(NonGPUMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=NonGPUMemoryList[0];_this3.textOnChangeofConfiguration("nonGPU","Memory");}}}}}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_112" /* NONGPU_NODE_STORAGE_DRIVE */]){if(NonGPUStrDrivetype!==value){var _oldDrive3=NonGPUStrDrivetype;x["@NodeDisk"]=value;selectedDriveValidation(x["@TStorageDrive"],x["@OSDisk"],_this3.props.NonGPUdetails[x["@Name"]].MaxNVMeDrives,x["@Name"],'ephemeral');if(!valueChanged){x["@NodeDisk"]=_oldDrive3;DatadriveChanged=false;}NonGPUStrDrivetype=x["@NodeDisk"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_116" /* NONGPU_TENANT_DRIVE */]){if(NonGPUTenantStoragedrive!==value){var _oldDrive4=NonGPUStrDrivetype;x["@TStorageDrive"]=value;selectedDriveValidation(x["@NodeDisk"],x["@OSDisk"],_this3.props.NonGPUdetails[x["@Name"]].MaxNVMeDrives,x["@Name"],'persistent');if(!valueChanged){x["@TStorageDrive"]=_oldDrive4;}NonGPUTenantStoragedrive=x["@TStorageDrive"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_114" /* NONGPU_OSDRIVE */]){if(NonGPUOSDrive!==value){var _oldDrive5=NonGPUOSDrive;x["@OSDisk"]=value;selectedDriveValidation(x["@NodeDisk"],x["@TStorageDrive"],_this3.props.NonGPUdetails[x["@Name"]].MaxNVMeDrives,x["@Name"],'osdrive');if(!valueChanged){x["@OSDisk"]=_oldDrive5;}NonGPUTenantStoragedrive=x["@OSDisk"];}}if(textinput==="NonGPUNodeCount")x["@NodesCount"]=value;if(textinput==="NonGPUMemory")x["@Memory"]=value;if(textinput==="NonGPUNodeStorageDriveQuantity"){if(chorBlr!=="Change"){if(value!==""){Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["e" /* nodeStorageDriveQuantityOnBlurValidation */])(x,value,_this3.props.NonGPUdetails);}else{x["@StorageDiskQty"]=" ";}}else{x["@StorageDiskQty"]=value;}}break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]:if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_167" /* STORAGE_NODE_TYPE */]){if(storageNodeType!==value){x["@Name"]=value;storageNodeType=x["@Name"];_this3.storageHostAllOptions(true);var MaxDrives=0;if(x["@TStorageDrive"].indexOf(nvmeString)>-1){MaxDrives=_this3.props.Storagedetails[x["@Name"]].MaxNVMeDrives;}else{MaxDrives=_this3.props.Storagedetails[x["@Name"]].MaxDrives;}if(parseInt(x["@StorageDiskQty"],10)+parseInt(x["@TStorageDriveQty"],10)+parseInt(x["@OSDiskQty"],10)>MaxDrives){x["@StorageDiskQty"]="3";if(parseInt(x["@StorageDiskQty"],10)+parseInt(x["@TStorageDriveQty"],10)+parseInt(x["@OSDiskQty"],10)>MaxDrives){x["@TStorageDriveQty"]=MaxDrives-parseInt(x["@StorageDiskQty"],10)-parseInt(x["@OSDiskQty"],10);x["@TStorageDriveQty"]=x["@TStorageDriveQty"].toString();}}_this3.updateMixedDrivesArray();}_this3.props.workload.UserInputs.Environments.displayNotePersistentDriveChange=FALSE;}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_169" /* STORAGE_PROCESSOR_FAMILY */]){if(storageProcFamilyType!==value){x["@ProcFamily"]=value;storageProcFamilyType=x["@ProcFamily"];_this3.storageHostAllOptions();}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_170" /* STORAGE_PROCESSOR_TYPE */]){if(storageProcType!==value){x["@Proc"]=value;storageProcType=x["@Proc"];_this3.storageHostAllOptions();}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_163" /* STORAGE_MEMORY */]){if(storageMemory!==value){x["@Memory"]=value;storageMemory=x["@Memory"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_165" /* STORAGE_NODE_DRIVE */]){if(storageNodeDrive!==value){var oldNodeStorageDrive=x["@NodeDisk"];x["@NodeDisk"]=value;valueChanged=_this3.isCompatibleDrive(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);if(valueChanged){valueChanged=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["q" /* validateDriveChange */])(x["@TStorageDrive"],x["@OSDisk"],value,x["@Name"]);}if(!valueChanged){x["@NodeDisk"]=oldNodeStorageDrive;Houstcountdata=_this3.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_12" /* DRIVE_CANNOTBE_MIXED */],ERROR_TEXT);DatadriveChanged=false;}else{var array=_this3.noOfStorageTenantDrivesLeft(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_106" /* NODE */],false,false,"",false);if(array[0]<parseInt(x["@StorageDiskQty"],10)||array[2]){if(array[2]&&x["@Name"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]){if(x["@OSDisk"].indexOf("M.2")>-1){array[1]=26;}else{array[1]=24;}}Houstcountdata=_this3.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][0]+array[1]+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][1],ERROR_TEXT);DatadriveChanged=false;valueChanged=false;x["@NodeDisk"]=oldNodeStorageDrive;}}storageNodeDrive=x["@NodeDisk"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_171" /* STORAGE_TENANT_DRIVE */]){if(storageTenantStorageDrive!==value){var oldPersistentStorageDrive=x["@TStorageDrive"];x["@TStorageDrive"]=value;valueChanged=_this3.isCompatibleDrive(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);if(valueChanged){valueChanged=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["q" /* validateDriveChange */])(x["@NodeDisk"],x["@OSDisk"],value,x["@Name"]);}if(!valueChanged){x["@TStorageDrive"]=oldPersistentStorageDrive;Houstcountdata=_this3.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_12" /* DRIVE_CANNOTBE_MIXED */],ERROR_TEXT);}if(valueChanged){_this3.props.workload.UserInputs.Environments.displayNotePersistentDriveChange=TRUE;}storageTenantStorageDrive=x["@TStorageDrive"];_this3.updateMixedDrivesArray();}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_168" /* STORAGE_OSDRIVE */]){if(storageOSDrive!==value){var oldPersistentOSDrive=x["@OSDisk"];x["@OSDisk"]=value;valueChanged=_this3.isCompatibleDrive(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);if(valueChanged){valueChanged=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["q" /* validateDriveChange */])(x["@NodeDisk"],x["@TStorageDrive"],value,x["@Name"]);}if(!valueChanged){x["@OSDisk"]=oldPersistentOSDrive;Houstcountdata=_this3.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_12" /* DRIVE_CANNOTBE_MIXED */],ERROR_TEXT);}storageOSDrive=x["@OSDisk"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */]){x["@NodesCount"]=value;storageNodeCount=x["@NodesCount"];}}});if(DatadriveChanged){DatadriveChanged=false;var server='';var datadisk='';var rolename='';if(textinput==="NonGPUStrDrivetype"){server=NonGPUServer;datadisk=NonGPUDataDisk;rolename="NONGPU";}else if(textinput==="GPUStrDrivetype"){server=GPUServer;datadisk=GPUDataDisk;rolename="GPU";}else if(textinput===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_165" /* STORAGE_NODE_DRIVE */]){server=storageNodeType;datadisk=storageNodeDrive;rolename=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];}var data={"strServer":server,"strDataDisk":datadisk,"strConfigType":"BlueData","rolename":rolename};this.props.GetOSDiskList(data);var tenantInputs={"strServer":server,"strDataDisk":datadisk,"strConfigType":"BlueData","rolename":rolename,"localStorage":"Local Tenant"};if(textinput!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_165" /* STORAGE_NODE_DRIVE */]){this.props.getTenantStorageDriveList(tenantInputs);}}if(valueChanged){var _value={"input":{"Workload":null},"Inputsnotchanged":false,"RoleType":roleType,"HostChanged":HostChanged};_value.input.Workload=this.props.workload;this.props.CalculateBlueDataConfigurationfalse(_value);}var NoValues=this.checkValues();if(!NoValues){if(!this.props.activeSession.isSizeEnabled){var disableFinishButton=false;var selectedServices=this.props.workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];});selectedServices.map(function(solution){if(solution.NonGPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]&&solution.GPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]&&solution.StorageValue.isCalculated===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */]){disableFinishButton=true;}});if(!disableFinishButton){this.props.OnToggleSizeButton(true);}}}else if(this.props.activeSession.isSizeEnabled){this.props.OnToggleSizeButton(false);}this.setState({});}},{key:'OnvalueChange',value:function OnvalueChange(e,textinput,ChorBlr,templateNumber){var _this4=this;var minval=currentTabObject.Templates.Template[templateNumber]["@Type"]==="Custom"?0:1;var noOfGPUsMaxValue=8;if(currentTabObject.Templates.Template[templateNumber]["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])>-1){noOfGPUsMaxValue=2;}if(isNaN(parseInt(e.target.value,10))){e.target.value="";}var n=4;if(textinput===NODESTORAGE||textinput===PERSISTENT_STORAGE){if(textinput===PERSISTENT_STORAGE){minval=0;if(currentTabObject.Templates.Template[templateNumber]["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */])!==-1){minval=1;}}n=6;}else if(textinput===MEMORY){n=5;}else if(textinput===GPUS){minval=0;}Globalvalue=e.target.value;if(ChorBlr==="Change"){var number=/^[0-9]+$/;if(e.target.value.length<n){if(number.test(parseInt(e.target.value,10))&&parseInt(e.target.value,10)>=minval){if(textinput===GPUS&&parseInt(e.target.value,10)>noOfGPUsMaxValue){e.target.value=minval.toString();}else if(textinput===NODESTORAGE&&parseInt(e.target.value,10)>20000){e.target.value="1";}Globalvalue=parseInt(e.target.value,10).toString();}else{Globalvalue="";}}else{Globalvalue="";}}else{isValueChanged=true;if(Globalvalue===""){Globalvalue="1";}if(textinput===MEMORY){var maximumMemory=this.state.maxKubernetesMemory;if(currentTabObject.Templates.Template[templateNumber]["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_20" /* EPIC_ */]){maximumMemory=this.state.maxEpicMemory;}if(parseInt(e.target.value,10)>maximumMemory){Globalvalue=maximumMemory.toString();}}// if((textinput === VIRTUALCLUSTERS && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_ClusterQty"], 10)) || 
//     (textinput === VIRTUALNODESPERCLUSTER && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_MinvNodes"], 10)) ||
//     (textinput === CPUCORES && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_vCPUs"], 10)) ||
//     (textinput === MEMORY && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["d_vMemory"], 10)) ||
//     (textinput === NODESTORAGE && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["d_NodeStorage"], 10)) ||
//     (textinput === PERSISTENT_STORAGE && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["d_PersistentStorage"], 10)) ||
//     (textinput === GPUS && Globalvalue < parseInt(Templatedata[currentTabObject.Templates.Template[templateNumber]["@Type"]]["i_GPUs"], 10))) {
// }
}var assignGlobalValue=function assignGlobalValue(){if(textinput===VIRTUALCLUSTERS){currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"]=Globalvalue;currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"]=(parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"],10)).toString();}else if(textinput===VIRTUALNODESPERCLUSTER){currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"]=Globalvalue;currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"]=(parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"],10)).toString();}else if(textinput===CPUCORES){currentTabObject.Templates.Template[templateNumber].Nodes["@vCPUPerNode"]=Globalvalue;}else if(textinput===MEMORY){currentTabObject.Templates.Template[templateNumber].Nodes["@vMemoryPerNode"]=Globalvalue;}else if(textinput===NODESTORAGE){currentTabObject.Templates.Template[templateNumber].Nodes["@StoragePervNode"]=Globalvalue;}else if(textinput===PERSISTENT_STORAGE){currentTabObject.Templates.Template[templateNumber].Nodes["@PersistentStorage"]=Globalvalue;}else if(textinput===GPUS){currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"]=Globalvalue;currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"]=(parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"],10)).toString();}currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"]=_this4.setPersistentStorageMinValue();};var updateCalculateButton=function updateCalculateButton(){var NoValues=_this4.checkValues();if(NoValues){_this4.props.Calcbutton(true);}else{_this4.props.Calcbutton(false);}_this4.makeisCalculatedFalse();};assignGlobalValue();if(ChorBlr===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){updateCalculateButton();}this.setState({});}},{key:'calculateRecommendationButtonValidation',value:function calculateRecommendationButtonValidation(){var NoValues=this.checkValues();if(NoValues){this.props.Calcbutton(true);this.props.OnToggleSizeButton(false);}else{this.props.Calcbutton(false);}this.makeisCalculatedFalse();}},{key:'onNodeTemplateChange',value:function onNodeTemplateChange(e,templateNumber){var _this5=this;if(currentTabObject.Templates.Template[templateNumber]["@Type"]!==e.option){if(currentTabObject.Templates.Template[templateNumber]["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&e.option===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]){var deleteTemplate=function deleteTemplate(){isValueChanged=true;currentTabObject.Templates.Template.splice(templateNumber,1);deleteTemplateConfirmation="";_this5.calculateRecommendationButtonValidation();currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"]=_this5.setPersistentStorageMinValue();Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["i" /* updateControllerHostCount */])(_this5.props.workload,HAIncluded);Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["m" /* updateMasterHostCount */])(_this5.props.workload,HAIncluded);_this5.setState({});};var doNotdeleteTemplate=function doNotdeleteTemplate(){deleteTemplateConfirmation="";_this5.setState({});};deleteTemplateConfirmation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle',onClick:function onClick(){return doNotdeleteTemplate();}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:false},'Selecting ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'None'),' will remove the current template from the workload.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:false},'Do you want to proceed?'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:function onClick(){return deleteTemplate();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',onClick:function onClick(){return doNotdeleteTemplate();}})))));}else{isValueChanged=true;currentTabObject.Templates.Template[templateNumber]["@Type"]=e.option;currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"]=Templatedata[e.option]["i_ClusterQty"];currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"]=Templatedata[e.option]["i_NodesPerCluster"];currentTabObject.Templates.Template[templateNumber].Nodes["@vCPUPerNode"]=Templatedata[e.option]["i_vCPUs"];currentTabObject.Templates.Template[templateNumber].Nodes["@vMemoryPerNode"]=Templatedata[e.option]["d_vMemory"];currentTabObject.Templates.Template[templateNumber].Nodes["@StoragePervNode"]=Templatedata[e.option]["d_NodeStorage"];currentTabObject.Templates.Template[templateNumber].Nodes["@PersistentStorage"]=Templatedata[e.option]["d_PersistentStorage"];currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"]=Templatedata[e.option]["i_GPUs"];currentTabObject.Templates.Template[templateNumber].Nodes["@GPUs"]=(parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@userGPUs"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vNodesPerCluster"],10)*parseInt(currentTabObject.Templates.Template[templateNumber].Nodes["@vClusters"],10)).toString();this.calculateRecommendationButtonValidation();currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"]=this.setPersistentStorageMinValue();Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["i" /* updateControllerHostCount */])(this.props.workload,HAIncluded);Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["m" /* updateMasterHostCount */])(this.props.workload,HAIncluded);}this.setState({});}}},{key:'ChkboxChange',value:function ChkboxChange(change,shouldUpdate){var selectchange=" ";if(change){if(HAIncluded){HAIncluded=false;selectchange="false";}else{HAIncluded=true;selectchange="true";}}else{selectchange="true";}var textinput="HAIncluded";if(textinput==="HAIncluded"){this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@HAIncluded"]=selectchange;this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@HAIncluded"]=selectchange;var nodecountgateway=this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@NodesCount"];var nodecountcontroller=this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@NodesCount"];if(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@HAIncluded"]==="true"){if(parseInt(nodecountcontroller,10)<3){nodecountcontroller=(parseInt(nodecountcontroller,10)+2).toString();}if(parseInt(nodecountgateway,10)<3){if(!(HAIncluded&&nodecountgateway==="2")){nodecountgateway=(parseInt(nodecountgateway,10)+1).toString();}}}else{if(parseInt(nodecountcontroller,10)<=4){if(parseInt(nodecountcontroller,10)-2<1){nodecountcontroller='1';}else{nodecountcontroller=(parseInt(nodecountcontroller,10)-2).toString();}}if(parseInt(nodecountgateway,10)<=3){if(parseInt(nodecountgateway,10)-1<1){nodecountgateway='1';}else{nodecountgateway=(parseInt(nodecountgateway,10)-1).toString();}}}this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@NodesCount"]=nodecountgateway;this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@NodesCount"]=nodecountcontroller;Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["i" /* updateControllerHostCount */])(this.props.workload,HAIncluded);Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["m" /* updateMasterHostCount */])(this.props.workload,HAIncluded);}var NoValues=this.checkValues();if(NoValues){this.props.Calcbutton(true);this.makeisCalculatedFalse();}else{this.props.Calcbutton(false);if(shouldUpdate){this.makeisCalculatedFalse();}}}},{key:'Requirementstextchange',value:function Requirementstextchange(e,textinput,chorBlr){var minLimit=0;var maxLimit=0;if(textinput==="HDFSTenatStr"){minLimit=0;maxLimit=99999;}else if(textinput==="HDFSrepFac"){minLimit=1;maxLimit=10;}else if(textinput==="Allocationratio"){minLimit=1;maxLimit=6;}else if(textinput==="KubClusters"){minLimit=1;maxLimit=20;}var number=/^[0-9]+$/;var netwrkcal=false;if(chorBlr==="Change"){if(e.target.value.length<=5){var value=parseInt(e.target.value,10);if(isNaN(value)){Globalvalue="";}else if(number.test(value)&&value<=maxLimit&&value>=minLimit||isNaN(value)){Globalvalue=value.toString();}else{Globalvalue=minLimit.toString();}}}else{isValueChanged=true;var persistentStorageMinimumValue=this.setPersistentStorageMinValue();if(e.target.value===""){Globalvalue=textinput==="HDFSTenatStr"?persistentStorageMinimumValue:"1";}else{if(textinput==="HDFSTenatStr"){if(parseInt(e.target.value,10)<parseInt(persistentStorageMinimumValue,10)){e.target.value=persistentStorageMinimumValue;}}Globalvalue=e.target.value;}netwrkcal=true;this.calculateRecommendationButtonValidation();}if(textinput==="HDFSTenatStr"){currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"]=Globalvalue;}if(textinput==="HDFSrepFac"){currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]=Globalvalue;}if(textinput==="Allocationratio")currentTabObject.Templates.ServerDetails.Requirements["@AllocationRatio"]=Globalvalue;if(textinput==="KubClusters"){currentTabObject.Templates.ServerDetails.Requirements["@KubernetesClustersQty"]=Globalvalue;}this.setState({});}},{key:'onEpicClick',value:function onEpicClick(){if(this.props.workload&&this.props.workload.UserInputs.EOLServer&&this.props.workload.UserInputs.EOLServer==='yes'){this.props.workload.UserInputs.EOLServer='no';}this.props.sizerWorkloadforCalculation.value={"input":{"Workload":null},"Inputsnotchanged":true};if(this.props.workload.UserInputs.Environments.isOldWorkload){if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_36" /* GENERAL_PURPOSE */]){if(!currentTabObject.Templates.Template.find(function(template){return template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["N" /* CUSTOM_TEMPLATE */];})){this.props.workload.UserInputs.Environments.isOldWorkload=false;}}}this.props.sizerWorkloadforCalculation.value.input.Workload=JSON.parse(JSON.stringify(this.props.workload));this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions=FALSE;this.props.workload.UserInputs.Environments.isWLorSLLoaded=FALSE;this.props.workload.UserInputs.Environments.displayNotePersistentDriveChange=FALSE;this.props.sizerWorkloadforCalculation.value=Object.assign({},this.props.sizerWorkloadforCalculation.value);this.saveOldWorkloads();this.props.Calcbutton(true);this.onCalcTempClick();this.props.changeCalculateBlueDataAPIcount(3);var inputs={"dHDFSStorage":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],"dHDFSRepFactor":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]};this.props.EPICRequirements(inputs);var value={"strHostType":"GPU","strHDFSRawSize":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],"strHDFSRepFactor":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]};this.props.OnGatewaydltsfetch(value);var input={"strHostType":"NonGPU","strHDFSRawSize":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],"strHDFSRepFactor":currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"]};this.props.OnGatewaydltsfetch(input);if(this.props.controllerconfigChanged===true){this.props.ContrlChanged(false);}this.props.OnToggleSizeButton(true);this.setState({});}},{key:'render',value:function render(){var _this6=this;EPICProclist=[];EPICGPUlist=[];ComptNodeList=[];NonGPUProcList=[];NonGPUProcFamilyList=[];NonGPUMemoryList=[];NonGPUOSDriveList=[];NonGPUStrDrivetypeList=[];NonGPUTenantStoragedrivelist=[];GPUNodeList=[];GPUProcList=[];GPUProcFamilyList=[];GPUMemoryList=[];GPUOSDriveList=[];GPUStrDrivetypeList=[];GPUTenantStoragedrivelist=[];List=[];var NonGPUApproxCost='';var GPUApproxCost='';var configurationType=void 0;var displayNonGPUCost=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */];var displayGPUCost=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */];var displayStorageCost=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */];GPUcountList=[];var virtualClustersLabel="Number of clusters (or Applications)";var virtualClusterstoolTip="Enter the number of clusters (or applications) per workload template. Default is 1.";var virtualNodesLabel="Nodes/Containers (or pods) per cluster";var virtualNodestoolTip="Enter the number of nodes/containers (or pods) per cluster. This value is configured depending on the workload template.";var cpuCoresLabel="Cores per container (or pod)";var cpuCorestoolTip="Number of cores required per container (or pod)";var memoryLabel="Memory GB per container (or pod)";var memorytoolTip="Memory configured per container (or pod) in GB";var nodeStorageLabel="Ephemeral Storage GB per container (or pod)";var nodeStoragetoolTip="Enter the amount of Ephemeral storage in GB per container (or pod). Ephemeral storage is built from the local storage in each host. It is used for the disk volumes that back the local storage for each virtual node.";var persistentStorageLabel="Persistent Storage GB per cluster (or pod)";var persistentStoragetoolTip="Enter the total persistent storage required for the container in TB on the HPE Ezmeral "+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_145" /* RE */]+" platform (Calculating 1TB = 1024GB, value rounded up).";var gpusLabel="GPU per container (or pod)";var gpustoolTip="Number of GPUs required per container (or pod).";var NonGPURoleName="Compute Hosts";var GPURoleName="Compute Hosts with GPU";var nonGPUTotalsLabel="Compute Hosts without GPUs totals :";var GPUTotalsLabel="Compute Hosts with GPUs totals :";var displayTabs=true;var displayContent=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];var isCurrentTabChecked=false;var MLOpsContent=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];//let StorageRoleName = "Storage";
var CalcButtonToolTip="This button will determine the best solution based on price and performance for the workload entered.";var ConfigTypeToolTip="Select EPIC or Kubernetes Ezmeral "+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_145" /* RE */]+" configuration";var persistentStorageText='';var configurationMargin=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_199" /* ZERO_PERCENT */];var inferenceGPUOptions=[];var trainingGPUOptions=[];var HPECPWorkloadRequirementsHeading=__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["j" /* HPECPWorkloadRequirements */].CP;var HPECPRequirementsHeading=__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["j" /* HPECPWorkloadRequirements */].CP.replace(__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["u" /* Workload */],"");var inferenceGPUCount=0;var trainingGPUcount=0;if(this.props.workload!==undefined&&this.props.workload!==null&&this.props.workload!==""){currentTabObject=this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];});if(currentTabObject["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){displayContent=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */];isCurrentTabChecked=true;if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){MLOpsContent=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */];}}if(this.props.ServiceError.isError){var index1=currentTabObject.Templates.ServerDetails.Server.findIndex(function(x){return x['@Type']==="NonGPU";});if(index1>=0){currentTabObject.Templates.ServerDetails.Server[index1]=JSON.parse(JSON.stringify(this.props.ServiceError.nonGPUOldWorkload));}var index2=currentTabObject.Templates.ServerDetails.Server.findIndex(function(x){return x['@Type']==="GPU";});if(index2>=0){currentTabObject.Templates.ServerDetails.Server[index2]=JSON.parse(JSON.stringify(this.props.ServiceError.GPUOldWorkload));}var index3=currentTabObject.Templates.ServerDetails.Server.findIndex(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];});if(index3>=0){currentTabObject.Templates.ServerDetails.Server[index3]=JSON.parse(JSON.stringify(this.props.ServiceError.StorageOldWorkload));}}if(this.props.workload.UserInputs.Environments.displayNoteTextForOldSolutions===TRUE){noteTextforLoadingOldSolutions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{maxWidth:'100%',fontSize:'18px',marginTop:'15px',color:'red'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note : This Solution is loaded from a older version. Some of the inputs might not populate correctly in the sizer input screen. Please verify.')));}else{noteTextforLoadingOldSolutions="";}}if(nonGPUChanges[0]===",")nonGPUChanges=nonGPUChanges.substr(1);if(nonGPUChanges===""){nonGPUNoteText="";}else{this.noteContent(nonGPUChanges,"nonGPU");}if(GPUChanges[0]===",")GPUChanges=GPUChanges.substr(1);if(GPUChanges===""){GPUNoteText="";}else{this.noteContent(GPUChanges,"GPU");}if(StorageChanges[0]===","){StorageChanges=StorageChanges.substr(1);}if(StorageChanges===""){StorageNoteText="";}else{this.noteContent(StorageChanges,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}if(this.props.Templates!==null&&this.props.Templates!==''){var SolutionType=currentTabObject["@SolutionType"];Templatedata=this.props.Templates[SolutionType];for(var key in Templatedata){List.push(key);}}if(this.props.workload!==undefined&&this.props.workload!==null&&this.props.workload!==""){if(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})===undefined){var controllerhost={"@RoleName":"Controller Host","@Name":"ProLiant XL170r Gen10","@ProcFamily":"Cascade Lake","@Proc":"4210 / 2.2GHz / 10 Cores","@NodeDisk":"HPE 2TB 6G SATA 7.2k 2.5in 512e SC HDD","@OSDisk":"HPE 1TB 6G SATA 7.2k 2.5in SC MDL HDD","@TStorageDrive":"HPE 3.84TB SATA MU SFF SC DS SSD","@TStorageDriveQty":"1","@Memory":"64 GB","@OSDiskQty":"2","@HDFSDiskQty":"","@NonOSDiskQty":"2","@StorageDiskQty":"0","@NodesCount":"1","@HAIncluded":"false"};this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})[0]=controllerhost;}currentTabObject.Templates.Template.map(function(x,id){var UGPUs="0";if(x.Nodes["@userGPUs"]===undefined){x.Nodes["@userGPUs"]=UGPUs;}if(x["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])>-1){if(parseInt(x.Nodes["@userGPUs"])>2){x.Nodes["@userGPUs"]="1";}}});if(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@HAIncluded"]==="false"){HAIncluded=false;}else{HAIncluded=true;}currentTabObject.Templates.ServerDetails.Server.filter(function(x){switch(x["@Type"]){case"GPU":if(x["@Name"]==="HP Apollo 4200 Gen10 Server"){x["@Name"]="HPE Apollo 4200 Gen10 Server";}if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){GPURoleName=x["@RoleName"];GPUTotalsLabel=GPURoleName+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_186" /* TOTALS_TEXT */];}GPUNodeType=x["@Name"];if(x['@Name'].indexOf('m510')===-1&&x['@Name'].indexOf('e910')===-1&&x['@Name'].indexOf(E920)===-1){x['@ServerName']=x['@Name'];}else{x['@ServerName']="HP Moonshot System";}GPUProcType=x["@Proc"];GPUStrDrivetype=x["@NodeDisk"];GPUOSDrive=x["@OSDisk"];GPUNodeCoount=x["@NodesCount"];GPUMemory=x["@Memory"];GPUProcFamilyType=x["@ProcFamily"];GPUTenantStoragedrive=x["@TStorageDrive"];GPUTenantStorageDriveQuantity=x["@TStorageDriveQty"];if(x["@Name"].indexOf('m510')!==-1){if(x["@TStorageDriveQty"]!=="0"){x["@StorageDiskQty"]="1";}else{x["@StorageDiskQty"]="2";}}GPUNodeStorageDriveQuantity=x["@StorageDiskQty"];GPUApproxCost=x["@ApproxCost"];GPUCount=x["@GPUcount"];if(GPUNodeType==="ProLiant XL190r Gen10"){GPUcountList=["2"];}else if(GPUNodeType==="ProLiant XL270d Gen10"){GPUcountList=["8","4"];if(GPUType===T4_GPU||GPUType===A100_PCIE_80GB_GPU){GPUcountList=["8"];}}else if(GPUNodeType===proLiantDL360Gen10){GPUcountList=["2"];}else if(GPUNodeType===proLiantDL380Gen10){GPUcountList=["3"];if(GPUType===T4_GPU){GPUcountList=["7"];}else if(GPUType===A100_40GB_GPU||GPUType===A40_PCIE_48GB_GPU){GPUcountList=["2"];}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_141" /* PROLIANT_XL675D_GEN10_PLUS */]){GPUcountList=["10"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_140" /* PROLIANT_XL645D_GEN10_PLUS */]){GPUcountList=["4"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_134" /* PROLIANT_DL385_GEN10_PLUS */]){if(GPUType===T4_GPU){GPUcountList=["8"];}else{GPUcountList=["3"];}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_135" /* PROLIANT_E910T_2U_SERVER */]){GPUcountList=GPUType===T4_GPU||GPUType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_179" /* T4_TESLA_GPU */]?["3"]:["1"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_136" /* PROLIANT_E910_2U_SERVER */]){GPUcountList=GPUType===T4_GPU||GPUType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_179" /* T4_TESLA_GPU */]?["3"]:["1"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_139" /* PROLIANT_XL290N_GEN10_PLUS */]){if(GPUType===T4_GPU){GPUcountList=["4"];}else{GPUcountList=["2"];}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_127" /* PROLIANT_DL325_GEN10_PLUS */]){GPUcountList=["3"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_130" /* PROLIANT_DL360_GEN10_PLUS */]){GPUcountList=["2"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_133" /* PROLIANT_DL380_GEN10_PLUS */]){GPUcountList=["3"];if(GPUType===T4_GPU){GPUcountList=["8"];}}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_131" /* PROLIANT_DL365_GEN10_PLUS */]){GPUcountList=["2"];}else if(GPUNodeType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_128" /* PROLIANT_DL325_GEN10_PLUS_V2 */]){GPUcountList=["2"];}else{GPUcountList=["1"];}if(GPUcountList.indexOf(GPUCount)===-1){GPUCount=GPUcountList[0];_this6.textOnChangeofConfiguration("GPU","GPUCountPerServer");x["@GPUcount"]=GPUCount;}break;case"NonGPU":if(x["@Name"]==="HP Apollo 4200 Gen10 Server"){x["@Name"]="HPE Apollo 4200 Gen10 Server";}if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){NonGPURoleName=x["@RoleName"];nonGPUTotalsLabel=NonGPURoleName+__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_186" /* TOTALS_TEXT */];}ComptNodeType=x["@Name"];if(x['@Name'].indexOf('m510')===-1&&x['@Name'].indexOf('e910')===-1&&x['@Name'].indexOf(E920)===-1){x['@ServerName']=x['@Name'];}else{x['@ServerName']="HP Moonshot System";}NonGPUProcType=x["@Proc"];NonGPUStrDrivetype=x["@NodeDisk"];NonGPUOSDrive=x["@OSDisk"];NonGPUNodeCount=x["@NodesCount"];NonGPUMemory=x["@Memory"];NonGPUProcFamilyType=x["@ProcFamily"];NonGPUTenantStoragedrive=x["@TStorageDrive"];NonGPUTenantStorageDriveQuantity=x["@TStorageDriveQty"];if(x["@Name"].indexOf('m510')!==-1){if(x["@TStorageDriveQty"]!=="0"){x["@StorageDiskQty"]="1";}else{x["@StorageDiskQty"]="2";}}NonGPUNodeStorageDriveQuantity=x["@StorageDiskQty"];NonGPUApproxCost=x["@ApproxCost"];break;case __WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]:if(x["@Name"]==="HP Apollo 4200 Gen10 Server"){x["@Name"]=HPE_APOLLO_4200_GEN10;}//StorageRoleName = x["@RoleName"];
storageNodeType=x["@Name"];storageProcFamilyType=x["@ProcFamily"];storageProcType=x["@Proc"];storageMemory=x["@Memory"];storageNodeDrive=x["@NodeDisk"];storageNodeDriveQty=x["@StorageDiskQty"];storageOSDrive=x["@OSDisk"];storageTenantStorageDrive=x["@TStorageDrive"];storageTenantDriveQuantity=x["@TStorageDriveQty"];if(x.PersistentDisks.length>0){storageTenantDriveQuantity=x.PersistentDisks[0].Item['@qty'];}storageNodeCount=x["@NodesCount"];storageApproxCost=x["@ApproxCost"];storageMixedTenantStorage=x["@mixedTenantStorage"];_this6.state.storageTenantDriveType=x["@TenantDriveType"];break;}});// currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"] = storageTenantDriveQuantity;
// storageTenantDriveQuantity = currentTabObject.Templates.ServerDetails.Server.filter(x => x["@Type"] === Constants.STORAGE_)[0]["@TStorageDriveQty"]
if(updatePersistentStorage){if(parseInt(currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"],10)<parseInt(this.setPersistentStorageMinValue(),10)){currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"]=this.setPersistentStorageMinValue();}else{updatePersistentStorage=false;}}HDFSTenatStr=currentTabObject.Templates.ServerDetails.Requirements["@HDFSRawSize"];if(parseInt(HDFSTenatStr,10)>1200&&currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]){persistentStorageText=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{maxWidth:'100%',fontSize:'17px',marginTop:'15px',color:'red'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note : Persistent Storage exceeds maximum capacity configurable with the sizer. Please contact HPE Solution Architect.')));}HDFSrepFac=currentTabObject.Templates.ServerDetails.Requirements["@HDFSRepFactor"];if(currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty']===undefined){currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty']='1';}KubClusters=currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty'];// if (currentTabObject.Templates.ServerDetails.Requirements['@ConfigType'] === undefined) {
//     currentTabObject.Templates.ServerDetails.Requirements['@ConfigType'] = Constants.EPIC_;
// }
if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){currentTabObject.Templates.Template.map(function(template){if(template["@InputMode"]===""&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_6" /* DATA_FABRIC */]){template["@InputMode"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */];}});if(currentTabObject.Templates.Template.find(function(template){return template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */];})){this.state.MLOpsTemplatesCheckBox=true;}if(currentTabObject.Templates.Template.find(function(template){return template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */];})){this.state.MLOpsImageProcessingCheckBox=true;}if(this.state.MLOpsImageProcessingCheckBox){currentTabObject.Templates.Template.map(function(template){if(!currentTabObject.Templates.Template.find(function(template){return template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */]&&template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */];})){if(template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */]&&template["@Category"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */]){template["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */];}}if(!currentTabObject.Templates.Template.find(function(template){return template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */]&&template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */];})){if(template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */]&&template["@Category"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */]){template["@Type"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */];}}});inferenceGPUOptions=[T4_GPU];trainingGPUOptions=[A100_PCIE_80GB_GPU,V100_32GB_GPU,T4_GPU,A40_PCIE_48GB_GPU];}}overallConfigType=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_20" /* EPIC_ */];if(currentTabObject["@SolutionType"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]||currentTabObject['@SolutionType']===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&this.state.MLOpsTemplatesCheckBox){if(currentTabObject.Templates.Template.filter(function(template){return template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}).length===0){if(currentTabObject.Templates.Template.length>0){overallConfigType=currentTabObject.Templates.Template.find(function(template){return template["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];})["@ConfigType"];}}else{var kubernetesTemplates=currentTabObject.Templates.Template.filter(function(template){return template["@ConfigType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_84" /* KUBERNETES_ */]&&template["@Type"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]&&!(currentTabObject['@SolutionType']===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&template["@InputMode"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_74" /* IMAGE_PROCESSING */]);});if(kubernetesTemplates.length>0){overallConfigType=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_84" /* KUBERNETES_ */];}}}if(overallConfigType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_20" /* EPIC_ */]){currentTabObject.Templates.ServerDetails.Requirements['@KubernetesClustersQty']=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_142" /* QTY_ONE */];KubClusters=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_142" /* QTY_ONE */];}configurationType=currentTabObject.Templates.ServerDetails.Requirements["@ConfigBasedOn"];if(parseInt(HDFSTenatStr,10)>=1&&this.noOfNonStorageTemplates()>0){if(isValueChanged||updatePersistentStorage){isValueChanged=false;// if (parseInt(HDFSTenatStr, 10) * parseInt(HDFSrepFac, 10) > 60) {
if(parseInt(HDFSTenatStr,10)>0){if(currentTabObject["@SolutionType"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]){currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"]=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}}else{currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"]="no";}}// storageHostsCheckBoxDisabled = false;
}else{// storageHostsCheckBoxDisabled = true;
currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"]="no";}updatePersistentStorage=false;Allocationratio=currentTabObject.Templates.ServerDetails.Requirements["@AllocationRatio"];if(currentTabObject.Templates.ServerDetails.Requirements["@SeparatePersistentHosts"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){storageHostChecked=true;}else{storageHostChecked=false;}if(currentTabObject.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */];})){GPUType=currentTabObject.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */];})["@GPUType"];}if(currentTabObject.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */];})){if(this.props.NonGPUdetails!==null){NonGPUList=this.props.NonGPUdetails;for(var _key8 in NonGPUList){if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]){if(_key8===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_175" /* SYN_480_GEN10 */]||_key8===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_176" /* SYN_480_GEN10_PLUS */]){ComptNodeList.push(_key8);}}else if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){currentTabObject.Templates.Template.forEach(function(template){if(template["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])>-1){inferenceGPUCount+=parseInt(template.Nodes["@GPUs"],10);}else if(template["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */])>-1){trainingGPUcount+=parseInt(template.Nodes["@GPUs"],10);}});if(NonGPUList[_key8].GPUList.indexOf(T4_GPU)>-1){ComptNodeList.push(_key8);}}else{ComptNodeList.push(_key8);}if(_key8===ComptNodeType){computeGPUTypeOptions=NonGPUList[_key8].GPUList;if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&inferenceGPUCount===0){computeGPUTypeOptions=[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]];}NonGPUStrDrivetypeList=NonGPUList[_key8].DataDriveList;NonGPUStrDrivetypeList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(NonGPUStrDrivetypeList,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);NonGPUStrDrivetypeList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["b" /* filterDriveList */])(NonGPUStrDrivetypeList,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_148" /* RI */]);if(NonGPUStrDrivetypeList.length>0&&NonGPUStrDrivetypeList.indexOf(NonGPUStrDrivetype)===-1){NonGPUStrDrivetype=NonGPUStrDrivetypeList[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */];})[0]["@NodeDisk"]=NonGPUStrDrivetype;}NonGPUTenantStoragedrivelist=NonGPUList[_key8].TenantDriveList;NonGPUTenantStoragedrivelist=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(NonGPUTenantStoragedrivelist,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);NonGPUTenantStoragedrivelist=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["b" /* filterDriveList */])(NonGPUTenantStoragedrivelist,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_148" /* RI */]);if(NonGPUTenantStoragedrivelist.indexOf(NonGPUTenantStoragedrive)===-1){NonGPUTenantStoragedrive=NonGPUTenantStoragedrivelist[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */];})[0]["@TStorageDrive"]=NonGPUTenantStoragedrive;}NonGPUOSDriveList=NonGPUList[_key8].OSDriveList;for(var proctype in NonGPUList[ComptNodeType].ProcessorList){NonGPUProcFamilyList.push(proctype);if(proctype===NonGPUProcFamilyType){for(var proc in NonGPUList[ComptNodeType].ProcessorList[proctype]){NonGPUProcList.push(proc);if(proc===NonGPUProcType){NonGPUMemoryList=NonGPUList[ComptNodeType].ProcessorList[proctype][proc];}}}}NonGPUProcList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(NonGPUProcList,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_126" /* PROCESSOR_ */]);if(NonGPUProcList.filter(function(processor){return processor.indexOf(NonGPUProcType)>-1;}).length==0){NonGPUProcType=NonGPUProcList[0];this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */],"Processor");}else{NonGPUProcType=NonGPUProcList.filter(function(processor){return processor.indexOf(NonGPUProcType)>-1;})[0];}currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */];})[0]["@Proc"]=NonGPUProcType;NonGPUMemoryList=NonGPUList[ComptNodeType].ProcessorList[NonGPUProcFamilyType][NonGPUProcType];}}}}if(currentTabObject.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */];})){if(this.props.GPUdetails!==null){GPUNodeList=[];GPUList=this.props.GPUdetails;for(var _key9 in GPUList){GPUNodeList.push(_key9);if(_key9===GPUNodeType){EPICGPUlist=GPUList[_key9].GPUList;if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&trainingGPUcount===0){EPICGPUlist=[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */]];GPUType=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];currentTabObject.Templates.ServerDetails.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */];})["@GPUType"]=GPUType;}GPUStrDrivetypeList=GPUList[_key9].DataDriveList;GPUStrDrivetypeList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(GPUStrDrivetypeList,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);GPUStrDrivetypeList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["b" /* filterDriveList */])(GPUStrDrivetypeList,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_148" /* RI */]);if(GPUStrDrivetypeList.length>0&&GPUStrDrivetypeList.indexOf(GPUStrDrivetype)===-1){GPUStrDrivetype=GPUStrDrivetypeList[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===GPU;})[0]["@NodeDisk"]=GPUStrDrivetype;}GPUTenantStoragedrivelist=GPUList[_key9].TenantDriveList;GPUTenantStoragedrivelist=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(GPUTenantStoragedrivelist,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);GPUTenantStoragedrivelist=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["b" /* filterDriveList */])(GPUTenantStoragedrivelist,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_148" /* RI */]);if(GPUTenantStoragedrivelist.indexOf(GPUTenantStoragedrive)===-1){GPUTenantStoragedrive=GPUTenantStoragedrivelist[0];currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===GPU;})[0]["@TStorageDrive"]=GPUTenantStoragedrive;}GPUOSDriveList=GPUList[_key9].OSDriveList;for(var _proctype4 in GPUList[GPUNodeType].ProcessorList){GPUProcFamilyList.push(_proctype4);if(_proctype4===GPUProcFamilyType){for(var _proc6 in GPUList[GPUNodeType].ProcessorList[_proctype4]){GPUProcList.push(_proc6);if(_proc6===GPUProcType){GPUMemoryList=GPUList[GPUNodeType].ProcessorList[_proctype4][_proc6];}}}}GPUProcList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(GPUProcList,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_126" /* PROCESSOR_ */]);if(GPUProcList.filter(function(processor){return processor.indexOf(GPUProcType)>-1;}).length==0){GPUProcType=GPUProcList[0];this.textOnChangeofConfiguration(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */],"Processor");}else{GPUProcType=GPUProcList.filter(function(processor){return processor.indexOf(GPUProcType)>-1;})[0];}currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */];})[0]["@Proc"]=GPUProcType;GPUMemoryList=GPUList[GPUNodeType].ProcessorList[GPUProcFamilyType][GPUProcType];}}}}if(currentTabObject.Templates.ServerDetails.Server.find(function(role){return role["@Type"]==="Storage";})){if(this.props.Storagedetails!==null){if(currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */];}).length>0){this.storageHostAllOptions(true);}}}if(EPICGPUlist.indexOf(GPUType)===-1&&EPICGPUlist.length>0){GPUType=EPICGPUlist[0];currentTabObject.Templates.ServerDetails.Server[1]['@GPUType']=GPUType;}//Lohith's code
if(this.state.MLOpsImageProcessingCheckBox===true&&isGPUvalueChanged===false&&currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){GPUType=EPICGPUlist.find(function(x){return x===trainingGPUvalue;})?trainingGPUvalue:EPICGPUlist[0];currentTabObject.Templates.ServerDetails.Server[1]['@GPUType']=GPUType;}currentTabObject.Templates.ServerDetails.Server.filter(function(x){switch(x["@Type"]){case"GPU":if(GPUOSDriveList.length>0&&GPUOSDriveList.indexOf(GPUOSDrive)===-1){GPUOSDrive=GPUOSDriveList[0];_this6.textOnChangeofConfiguration("GPU","OSDrive");x["@OSDisk"]=GPUOSDrive;}if(GPUProcList.length>0&&GPUProcList.indexOf(GPUProcType)===-1){GPUProcType=GPUProcList[0];_this6.textOnChangeofConfiguration("GPU","Processor");x["@Proc"]=GPUProcType;}break;case"NonGPU":if(NonGPUOSDriveList.length>0&&NonGPUOSDriveList.indexOf(NonGPUOSDrive)===-1){NonGPUOSDrive=NonGPUOSDriveList[0];_this6.textOnChangeofConfiguration("nonGPU","OSDrive");x["@OSDisk"]=NonGPUOSDrive;}if(NonGPUProcList>0&&NonGPUProcList.indexOf(NonGPUProcType)===-1){NonGPUProcType=NonGPUProcList[0];_this6.textOnChangeofConfiguration("nonGPU","Processor");x["@Proc"]=NonGPUProcType;}break;}});if(this.props.NonGPUdetails!==null){NonGPUList=this.props.NonGPUdetails;for(var _key10 in NonGPUList){if(_key10===ComptNodeType){for(var _proctype5 in NonGPUList[ComptNodeType].ProcessorList){if(_proctype5===NonGPUProcFamilyType){for(var _proc7 in NonGPUList[ComptNodeType].ProcessorList[_proctype5]){if(_proc7===NonGPUProcType){NonGPUMemoryList=NonGPUList[ComptNodeType].ProcessorList[_proctype5][_proc7];NonGPUMemoryList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(NonGPUMemoryList,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_111" /* NONGPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_96" /* MEMORY_ */]);if(NonGPUMemoryList.indexOf(NonGPUMemory)===-1){NonGPUMemory=NonGPUMemoryList[0];}}}}}}}}if(this.props.GPUdetails!==null){GPUList=this.props.GPUdetails;GPUNodeList=[];for(var _key11 in GPUList){GPUNodeList.push(_key11);if(_key11===GPUNodeType){for(var _proctype6 in GPUList[GPUNodeType].ProcessorList){if(_proctype6===GPUProcFamilyType){for(var _proc8 in GPUList[GPUNodeType].ProcessorList[_proctype6]){if(_proc8===GPUProcType){GPUMemoryList=GPUList[GPUNodeType].ProcessorList[_proctype6][_proc8];GPUMemoryList=Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["c" /* filterOptions */])(GPUMemoryList,configurationType,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_37" /* GPU_ */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_96" /* MEMORY_ */]);}}}}}}}if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses!==undefined){if(this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR===undefined){this.props.workload.UserInputs.Environments.HadoopServices.ServiceLicenses.MapR={'@IsSelected':'false',License:[{'@Type':"Data Apps",'@IsSelected':"false",'@Description':"None"},{'@Type':"Data Apps Universal",'@IsSelected':"false",'@Description':"None"},{'@Type':"Data Apps w/ML Ops",'@IsSelected':"false",'@Description':"None"},{'@Type':"Data Apps Universal w/ML Ops",'@IsSelected':"false",'@Description':"None"}]};}}if(this.props.workload.UserInputs.Environments.SSETMode){if(this.props.workload.UserInputs.Environments.SSETMode!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_22" /* EZMERAL_ */]){displayTabs=false;}HPECPWorkloadRequirementsHeading=__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["j" /* HPECPWorkloadRequirements */][this.props.workload.UserInputs.Environments.SSETMode];HPECPRequirementsHeading=HPECPWorkloadRequirementsHeading.replace(__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["u" /* Workload */],"");}this.props.workload.UserInputs.Environments.WorkloadRequirementsHeading=HPECPWorkloadRequirementsHeading;this.props.workload.UserInputs.Environments.RequirementsHeading=HPECPRequirementsHeading;}if(__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["c" /* DisplayPrice */]){if(NonGPUApproxCost!==undefined&&NonGPUApproxCost!==null){nonGPUCost=NonGPUApproxCost.indexOf('$')===-1?NonGPUApproxCost:new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(NonGPUApproxCost.replace('$',''));}if(GPUApproxCost!==undefined&&GPUApproxCost!==null){GPUCost=GPUApproxCost.indexOf('$')===-1?GPUApproxCost:new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(GPUApproxCost.replace('$',''));}if(storageApproxCost!==undefined&&storageApproxCost!==null){storageCost=storageApproxCost.indexOf('$')===-1?storageApproxCost:new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(storageApproxCost.replace('$',''));}if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]){if(parseInt(nonGPUCost.slice(1),10)===0){displayNonGPUCost=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}if(parseInt(GPUCost.slice(1),10)===0){displayGPUCost=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}if(parseInt(storageCost.slice(1),10)===0){displayStorageCost=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}}}var Loadingdata='';if(this.props.isCal){var Data="Please wait while Calculating the Host Count.";Loadingdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},Data)));}var Loadinginitialdata='';if(this.props.isLoading){var _Data="Please wait while Fetching the data.";Loadinginitialdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},_Data)));}if(HoustcountExceded||this.state.nvmeMaxedOut){if(this.state.nvmeMaxedOut){Houstcountdata=this.renderErrorPopup(NVMEMAX_POPUP_TEXT,ERROR_TEXT);}else Houstcountdata=this.renderErrorPopup("Host count should be greater than or equal to "+Minhostcount+" and less than or equal to "+Maxhostcount,ERROR_TEXT);}var displynonvalidate="none";NonGPUDisplay="none";GPUDisplay='none';var totaldisplay="none";var nonGPURecommendationDisplay=NONE;var GPURecommendationDisplay=NONE;var storageRecommendationDisplay=NONE;var persistentDriveNoteDisplay="";storageDisplay=NONE;displayStorageTotals=NONE;if(currentTabObject.NonGPUValue.isCalculated==='true'||currentTabObject.GPUValue.isCalculated==='true'||currentTabObject.StorageValue.isCalculated==='true'){if(!this.props.ConfigButton){this.props.Calcbutton(true);}if(currentTabObject.displayNoteTextForOldSolutions!==TRUE){totaldisplay=VISIBLE;}if(currentTabObject.NonGPUValue.isCalculated==='true'){NonGPUDisplay=VISIBLE;displynonvalidate=VISIBLE;if(currentTabObject.displayNoteTextForOldSolutions!==TRUE){nonGPURecommendationDisplay=VISIBLE;}}if(currentTabObject.GPUValue.isCalculated==='true'){GPUDisplay=VISIBLE;if(currentTabObject.displayNoteTextForOldSolutions!==TRUE){GPURecommendationDisplay=VISIBLE;}}if(currentTabObject.StorageValue.isCalculated==='true'){storageDisplay=VISIBLE;if(currentTabObject.displayNoteTextForOldSolutions!==TRUE){storageRecommendationDisplay=VISIBLE;}if(currentTabObject.displayNotePersistentDriveChange===TRUE){persistentDriveNoteDisplay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px',maxWidth:'100%'}},'Note : Persistent Drive capacity was changed, please review the number of drives configured and adjust if required.'));}var storageTemplates=0;var nonStorageTemplates=0;currentTabObject.Templates.Template.map(function(template){if(template["@Type"]!=="None"){if(template["@Type"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */])!==-1){storageTemplates++;}else{nonStorageTemplates++;}}});if(currentTabObject.isWLorSLLoaded===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){if(storageTemplates>0&&nonStorageTemplates==0){displayStorageTotals=VISIBLE;}}else{displayStorageTotals=VISIBLE;}}// if (!this.props.activeSession.isSizeEnabled) {
//     this.props.OnToggleSizeButton(true);
// }
}else{if(currentTabObject.Templates.Template.filter(function(x){return x["@Type"]!=="None";}).length>0){if(this.props.ConfigButton){var NoValues=this.checkValues();if(!NoValues){this.props.Calcbutton(false);this.makeisCalculatedFalse();}}}else{if(!this.props.ConfigButton){this.props.Calcbutton(true);}}}if(displynonvalidate==="none"){currentTabObject.Templates.ServerDetails.Server.filter(function(x){if(x["@Type"]==="NonGPU"){x["@NodesCount"]='0';}});}if(GPUDisplay==="none"){currentTabObject.Templates.ServerDetails.Server.filter(function(x){if(x["@Type"]==="GPU"){x["@NodesCount"]='0';}});}if(storageDisplay===NONE){currentTabObject.Templates.ServerDetails.Server.filter(function(x){if(x["@Type"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]){x["@NodesCount"]='0';}});}if(GPUTenantStoragedrive==="None"){GPUTenantStoragedrivelist=[];}if(NonGPUTenantStoragedrive==="None"){NonGPUTenantStoragedrivelist=[];}var ErrorPopup='';if(this.props.ServiceError.isError){HostChanged=false;ErrorPopup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.Errorclose.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,null,this.props.ServiceError.Errormsg,'.')));}else{}var HDFSDisplay='none';if(parseInt(HDFSTenatStr,10)>0){HDFSDisplay="";}var Recomdbutn='';var notedispaly="none";if(!this.props.ConfigButton){notedispaly=" ";Recomdbutn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{accent:'true',label:'Calculate Sizer Recommendation',onClick:this.onEpicClick.bind(this)});configurationMargin=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["D" /* CONFIGURATION_MARGIN */];if(currentTabObject["@isSelected"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){if(this.props.activeSession.isSizeEnabled){this.props.OnToggleSizeButton(false);}}}else{Recomdbutn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{accent:'true',label:'Calculate Sizer Recommendation'});}var HostChangedLayer='';if(HostChanged&&!this.props.isCal){HostChanged=false;}if(this.props.ServiceError.isError||this.props.ServiceError.Errormsg!==""){if(currentTabObject.NonGPUValue.isCalculated==='false'||currentTabObject.GPUValue.isCalculated==='false'||currentTabObject.StorageValue.isCalculated==='false'){if(currentTabObject.GPUValue.isCalculated==='false'){GPUDisplay="none";GPURecommendationDisplay=NONE;}if(currentTabObject.NonGPUValue.isCalculated==='false'){NonGPUDisplay="none";displynonvalidate="none";nonGPURecommendationDisplay=NONE;}if(currentTabObject.StorageValue.isCalculated==='false'){storageDisplay=NONE;displayStorageTotals=NONE;storageRecommendationDisplay=NONE;}this.props.activeSession.FirstClik.val=true;if(currentTabObject.NonGPUValue.isCalculated==='false'&&currentTabObject.GPUValue.isCalculated==='false'&&currentTabObject.StorageValue.isCalculated==='false'){totaldisplay="none";if(this.props.activeSession.isSizeEnabled){this.props.OnToggleSizeButton(false);}}}}this.updateGrowthObject();// if (!this.props.controllerconfigChanged && this.props.controllerdetails !== null && (displynonvalidate !== NONE || GPUDisplay !== NONE || storageDisplay !== NONE)) {
//     this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter((x) => {
//         if (x["@Type"] === Constants.CONTROLLER_) {
//             let serverName = getGatewayandControllerHost(this.props.workload);
//             updateControllerHostCount(this.props.workload);
//             if (serverName === HPE_APOLLO_4200_GEN10) {
//                 x["@Name"] = PROLIANT_XL170R_GEN10;
//             } else {
//                 x["@Name"] = serverName; 
//             }
//             if(x["@Name"].indexOf('m510') === -1 && x["@Name"].indexOf('e910') === -1) {
//                 x["@ServerName"] = x["@Name"]
//             } else {
//                 x["@ServerName"] = HPE_MOONSHOT_SYSTEM;
//             }
//             for( var key in this.props.controllerdetails ) {
//                 if(key === x["@Name"]) {
//                     if (Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList).indexOf(x["@ProcFamily"]) === -1) {
//                         x["@ProcFamily"] = Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList)[0];
//                     }
//                     if (Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]]).indexOf(x["@Proc"]) === -1) {
//                         x["@Proc"] = Object.keys(this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]])[0];
//                     }
//                     if (this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]][x["@Proc"]].indexOf(x["@Memory"]) === -1) {
//                         x["@Memory"] = this.props.controllerdetails[x["@Name"]].ProcessorList[x["@ProcFamily"]][x["@Proc"]][0];
//                     }
//                     if (this.props.controllerdetails[x["@Name"]].DataDriveList.indexOf(x["@NodeDisk"]) === -1) {
//                         x["@NodeDisk"] = this.props.controllerdetails[x["@Name"]].DataDriveList[0];
//                     }
//                     if (this.props.controllerdetails[x["@Name"]].OSDriveList.indexOf(x["@OSDisk"]) === -1) {
//                         x["@OSDisk"] = this.props.controllerdetails[x["@Name"]].OSDriveList[0];
//                     }
//                     if (this.props.controllerdetails[x["@Name"]].TenantDriveList.indexOf(x["@TStorageDrive"])=== -1) {
//                         x["@TStorageDrive"] = this.props.controllerdetails[x["@Name"]].TenantDriveList[0];
//                     }
//                 }
//             }
//             if (parseInt(x["@StorageDiskQty"], 10)+parseInt(x["@OSDiskQty"], 10)+parseInt(x["@TStorageDriveQty"], 10) > this.props.controllerdetails[x["@Name"]].MaxDrives) {
//                 if(parseInt(x["@TStorageDriveQty"], 10) === 0) {
//                     x["@StorageDiskQty"] = (this.props.controllerdetails[x["@Name"]].MaxDrives - parseInt(x["@OSDiskQty"], 10)).toString();
//                 } else {
//                     if(parseInt(x["@StorageDiskQty"], 10) > 3) {
//                         x["@StorageDiskQty"] = "3";
//                     }
//                     x["@TStorageDriveQty"] = (this.props.controllerdetails[x["@Name"]].MaxDrives - parseInt(x["@OSDiskQty"], 10)- parseInt(x["@StorageDiskQty"], 10)).toString();
//                 }
//             }
//         }
//     })
// }
currentTabObject.Templates.ServerDetails.Server.map(function(x){if(x['@Name']!==undefined){if(x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1&&x['@Name'].indexOf(E920)===-1&&x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_102" /* MOONSHOT_750 */])===-1){x['@ServerName']=x['@Name'];x['@ProcQty']="2";}else{x['@ServerName']="HP Moonshot System";x['@ProcQty']="1";}}});this.onCalcTempClick();if(currentTabObject.Templates.ServerDetails.Server.find(function(x){return x["@Type"]===NON_GPU;})){if(currentTabObject.Templates.Template.filter(function(x){return x[__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["g" /* ATTRIBUTE_TYPE */]].indexOf(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */])>-1;}).length>0){GPUTypeinComputeNode=true;if(inferenceGPUCount===0){computeGPUType=__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];}else{computeGPUType=T4_GPU;}currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===NON_GPU;})[0]["@GPUType"]=computeGPUType;}else{GPUTypeinComputeNode=false;currentTabObject.Templates.ServerDetails.Server.filter(function(x){return x["@Type"]===NON_GPU;})[0]["@GPUType"]="";}}maxGPUCount=Math.max.apply(Math,_toConsumableArray(GPUcountList));maxGPUCount=maxGPUCount>0?maxGPUCount:1;Object(__WEBPACK_IMPORTED_MODULE_26__commonLogic_js__["j" /* updateEzemeralGrowthItems */])(this.props.workload);var loadedOldSolution=this.props.workload&&this.props.workload.UserInputs.Environments.isOldWorkload;var persistent_storage_replication_factor_tooltip='Persistent storage replication. Default: 3';if(currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]){persistent_storage_replication_factor_tooltip='Persistent storage replication. Default: 1';}var isEOLWorkloadLoaded=this.props.workload&&this.props.workload.UserInputs.EOLServer&&this.props.workload.UserInputs.EOLServer==='yes';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'none',style:{position:'relative',width:'100%'}},displayTabs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__DisplayTabs_js__["a" /* default */],{checkBoxDisplay:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'11%',marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox___default.a,{label:'Add Service',checked:isCurrentTabChecked,onChange:function onChange(){_this6.onCheckBoxChange(currentTabObject["@SolutionType"]);},style:{}})))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default.a,{id:'scroll',full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'95%',display:displayContent},justify:'between'},loadedOldSolution?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',direction:'row',margin:'none',pad:'small',style:{backgroundColor:'yellow'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Alert___default.a,{size:'small',margin:'small',type:'status'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_Label___default.a,{style:{marginLeft:'10px'},size:'medium',margin:'none'},OLDWL_TEXT)):null,isEOLWorkloadLoaded?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',direction:'row',margin:'none',pad:'small',style:{backgroundColor:'yellow'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Alert___default.a,{size:'small',margin:'small',type:'status'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_Label___default.a,{style:{marginLeft:'10px'},size:'medium',margin:'none'},EOL_WORKLOAD_MESSAGE)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Warning__["a" /* default */],{message:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_54" /* HPECP_WARNING_MESSAGE */],isEnabled:this.props.ConfigButton,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{marginRight:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'small',style:{marginTop:'0px'}},HPECPWorkloadRequirementsHeading))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{separator:'all',margin:'none',pad:{between:'small'},style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'15%',marginBottom:'5px',display:MLOpsContent}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox___default.a,{id:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_100" /* MLOPS_TEMPLATES */],label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{marginBottom:'6px'}},__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_100" /* MLOPS_TEMPLATES */]),checked:this.state.MLOpsTemplatesCheckBox,onChange:this.MLOpsCheckBoxChange})),currentTabObject["@SolutionType"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]||currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&this.state.MLOpsTemplatesCheckBox?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_202" /* configurationWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},' Configuration Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':ConfigTypeToolTip,colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_211" /* templateWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},' Select Workload Template'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_177" /* SelectWorkloadTemp */],colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_201" /* clustersWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true},virtualClustersLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':virtualClusterstoolTip,colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 10px 0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_208" /* nodesPerClusterWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},virtualNodesLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':virtualNodestoolTip,colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 10px 0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_203" /* coresWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},cpuCoresLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':cpuCorestoolTip,colorIndex:'accent-3','data-for':'cores',style:{width:"17px",height:"20px",position:'relative',margin:'0px 10px 0px 5px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'cores'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_205" /* memoryWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},memoryLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':memorytoolTip,colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 10px 0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_25" /* EphemeralStorageWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},nodeStorageLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':nodeStoragetoolTip,colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 10px 0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_209" /* persistentStorageWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},persistentStorageLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':persistentStoragetoolTip,colorIndex:'accent-3',style:{width:"17px",height:"20px",position:'relative',margin:'0px 10px 0px 5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{width:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_43" /* GPUsWidth */]}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,style:{width:"maxContent"}},gpusLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':gpustoolTip,colorIndex:'accent-3','data-for':gpusLabel,style:{width:"17px",height:"20px",position:'relative',margin:'0px 0px 0px 5px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'left',multiline:true,type:'dark',effect:'solid',id:gpusLabel}))),this.renderTemplates(),deleteTemplateConfirmation):''),currentTabObject["@SolutionType"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]||currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]&&this.state.MLOpsTemplatesCheckBox?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'small',style:{marginTop:'10px',display:totaldisplay}},'Total Virtual Configurations'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{separator:'all',margin:'5px',pad:{between:'small'},style:{padding:'15px',paddingBottom:"0px",display:totaldisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{display:displynonvalidate}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{width:'26%',fontWeight:'600',marginRight:'0px'}},nonGPUTotalsLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px'}},' Cores :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.NonGPUValue.TotalCore,'  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |  Memory : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.NonGPUValue.TotalVMemory,' GB  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |  Storage : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.NonGPUValue.TotalStorage,' TB  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{display:GPUDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{width:'26%',fontWeight:'600',marginRight:'0px'}},GPUTotalsLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px'}},' Cores :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.GPUValue.TotalCore,'  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |  Memory : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.GPUValue.TotalVMemory,' GB  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |   Storage : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.GPUValue.TotalStorage,' TB '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |   GPUs : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},totalgpus,'  ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{display:displayStorageTotals}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{width:'26%',fontWeight:'600',marginRight:'0px'}},'Storage Hosts Totals :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px'}},' Cores :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.StorageValue.TotalCore,'  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |  Memory : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.StorageValue.TotalVMemory,' GB  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'450',paddingTop:'0px',paddingLeft:'5px'}},' |  Node Storage : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'DesignrequirementsPara',style:{color:'black',margin:"0px",fontWeight:'600',paddingTop:'0px',paddingLeft:'5px'}},this.props.StorageValue.TotalStorage,' TB  ')))):'',currentTabObject["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{separator:'all',pad:{between:'small'},style:{marginTop:'5px',padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'20%',marginBottom:'5px',marginTop:'10px',display:MLOpsContent}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox___default.a,{id:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_99" /* MLOPS_IMAGE_PROCESSING */],label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{marginBottom:'6px'}},__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_99" /* MLOPS_IMAGE_PROCESSING */]),checked:this.state.MLOpsImageProcessingCheckBox,onChange:this.MLOpsCheckBoxChange})),this.state.MLOpsImageProcessingCheckBox?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},style:{width:'100%'}},this.renderImageProcessingUI(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_78" /* INFERENCE_ */],inferenceGPUOptions)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'}},this.renderImageProcessingUI(__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_187" /* TRAINING */],trainingGPUOptions))):''):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{paddingTop:'30px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'small',style:{marginTop:'0px'}},HPECPRequirementsHeading),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{width:"33%"},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Persistent Storage TB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Enter the total persistent storage required in TB on the HPE Ezmeral Runtime Enterprise (Calculating 1TB = 1024GB, value rounded up)',e:true,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:HDFSTenatStr,onDOMChange:function onDOMChange(e){return _this6.Requirementstextchange(e,"HDFSTenatStr","Change");},onBlur:function onBlur(e){return _this6.Requirementstextchange(e,"HDFSTenatStr","Blur");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{width:"33%",display:HDFSDisplay},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Persistent Storage Replication Factor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':persistent_storage_replication_factor_tooltip,colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'Compression',disabled:true,value:HDFSrepFac,onDOMChange:function onDOMChange(e){return _this6.Requirementstextchange(e,"HDFSrepFac","Change");},onBlur:function onBlur(e){return _this6.Requirementstextchange(e,"HDFSrepFac","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{width:"33%"},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'vCPU to Physical Core ratio'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Enter the virtual CPU to physical core ratio. The CPU allocation ratio defines how many node vCPUs map to a physical CPU. By default, HPE Ezmeral Runtime Enterprise assumes a vCPU allocation ratio of 1 to 1.','data-for':'vCPUtoPhyCore',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'vCPUtoPhyCore'}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row '},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'Compression',value:Allocationratio,onDOMChange:function onDOMChange(e){return _this6.Requirementstextchange(e,"Allocationratio","Change");},onBlur:function onBlur(e){return _this6.Requirementstextchange(e,"Allocationratio","Blur");}}))),overallConfigType===__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_84" /* KUBERNETES_ */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{width:"33%"},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Number of Kubernetes Cluster(s)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Enter\xA0the\xA0number\xA0of\xA0Kubernetes\xA0Clusters\xA0within\xA0the\xA0range\xA01-20 in the solution. The core/memory/storage calculated from the workload template is calculated as one unit. The value in this field is multiplied with that unit. The default is 1.','data-for':'NoofKubClusters',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'top',type:'dark',effect:'solid',id:'NoofKubClusters'}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{id:'KubClusters',value:KubClusters,onDOMChange:function onDOMChange(e){return _this6.Requirementstextchange(e,"KubClusters","Change");},onBlur:function onBlur(e){return _this6.Requirementstextchange(e,"KubClusters","Blur");}})):''),persistentStorageText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_44" /* HARDWARELICENSE_PARAGRAPH_CLASSNAME */],style:{margin:"0px"}},'Include High Availability'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_77" /* INCLUDE_HA_TOOLTIP */],colorIndex:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_81" /* INFOICON_COLORINDEX */],style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{padding:'10px'},checked:HAIncluded,onChange:function onChange(){_this6.ChkboxChange(true,true);}}),currentTabObject["@SolutionType"]!==__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["v" /* CAAS_ */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_44" /* HARDWARELICENSE_PARAGRAPH_CLASSNAME */],style:{margin:"0px"}},'Separate Storage Hosts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_153" /* SEPARATE_STORAGE_HOSTS_TOOLTIP */],style:{height:"20px"},colorIndex:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_81" /* INFOICON_COLORINDEX */]})),disabled:storageHostsCheckBoxDisabled,checked:storageHostChecked,onChange:function onChange(){_this6.storageHostCheckBoxchange();}}):''// <CheckBox label={<Box direction="row"><Paragraph className={Constants.HARDWARELICENSE_PARAGRAPH_CLASSNAME} style={{ margin: "0px" }}>Hide Gateway Hosts</Paragraph>
//     <CircleInformationIcon data-tip={Constants.SEPARATE_STORAGE_HOSTS_TOOLTIP} style={{ height: "20px" }} colorIndex={Constants.INFOICON_COLORINDEX} /></Box>} checked={hideGatewayHostChecked} onChange={() => { this.hideGatewayHostCheckBoxchange() }} />
),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',style:{width:'25%',height:'75px',marginBottom:configurationMargin},label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Configure Based on'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:configurationType,options:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["E" /* CONFIGURATION_OPTIONS */],onChange:function onChange(e){_this6.onConfigurationChange(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:"small"},style:{width:'40%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',style:{width:'100%'}},Recomdbutn,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':CalcButtonToolTip,colorIndex:'accent-3',style:{marginTop:'10px',marginLeft:'5px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{display:notedispaly,margin:'0px 0px 0px 40px'}},'Note: Click on \'Calculate Sizer Recommendation\' button for sizer recommendations.'))))),Loadinginitialdata,Loadingdata,Houstcountdata,ErrorPopup,HostChangedLayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{paddingTop:'30px',display:displynonvalidate}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'small',style:{marginTop:'0px',display:NonGPUDisplay}},NonGPURoleName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select\xA0the\xA0server\xA0model\xA0desired',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:ComptNodeType,options:ComptNodeList,onChange:function onChange(e){return _this6.GPUChange(e,"ComptNodeType","nonGPU");}})),NonGPUProcFamilyType!='NA'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor family desired.',colorIndex:'accent-3','data-for':'procfamily',style:{width:"20px",height:"20px",marginBottom:'6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'procfamily'}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:NonGPUProcFamilyType,options:NonGPUProcFamilyList,onChange:function onChange(e){return _this6.GPUChange(e,"NonGPUProcFamilyType","nonGPU");}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor type based on the processor family requested.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:NonGPUProcType,options:NonGPUProcList,onChange:function onChange(e){return _this6.GPUChange(e,"NonGPUProcType","nonGPU");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the amount of memory desired per server.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:NonGPUMemory,options:NonGPUMemoryList,onChange:function onChange(e){return _this6.GPUChange(e,"NonGPUMemory","nonGPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_18" /* EPHEMERAL_STORAGE_DRIVE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the ephemeral storage drive size desired..',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:NonGPUStrDrivetype,options:NonGPUStrDrivetypeList,onChange:function onChange(e){return _this6.GPUChange(e,"NonGPUStrDrivetype","nonGPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_19" /* EPHEMERAL_STORAGE_DTIVE_QUANTITY */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:NonGPUNodeStorageDriveQuantity,disabled:false,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,"NonGPUNodeStorageDriveQuantity","Change");},onBlur:function onBlur(e){return _this6.GPUtextchange(e,"NonGPUNodeStorageDriveQuantity","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'OS Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the operating system drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:NonGPUOSDrive,options:NonGPUOSDriveList,onChange:function onChange(e){return _this6.GPUChange(e,"NonGPUOSDrive","nonGPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Persistent Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the persistent drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:NonGPUTenantStoragedrive,options:NonGPUTenantStoragedrivelist,onChange:function onChange(e){return _this6.GPUChange(e,"NonGPUTenantStoragedrive","nonGPU","Change");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Persistent Drive Quantity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:NonGPUTenantStorageDriveQuantity,disabled:true,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,"NonGPUTenantStorageDriveQuantity","Change");},onBlur:function onBlur(e){return _this6.GPUtextchange(e,"NonGPUTenantStorageDriveQuantity","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},GPUTypeinComputeNode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'GPU Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the GPU type desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:computeGPUType,options:computeGPUTypeOptions/*onChange={(e) => {this.computeGPUTypeChange(e)}}*/})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'The number of servers required to meet the workload requirements, based on the CPU, Memory, and drives selected.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:"33%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:NonGPUNodeCount,disabled:false,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,"NonGPUNodeCount","Change");},onBlur:function onBlur(e){return _this6.GPUtextchange(e,"NonGPUNodeCount","Blur");}}))),nonGPUNoteText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{display:displayNonGPUCost,margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px",marginRight:'5px'}},'Approx. Configuration            Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'This is an approximate configuration cost. Please refer BOM Details for the actual Bill of Materials and Cost.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginRight:'3px'}}),': ',nonGPUCost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{display:nonGPURecommendationDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Sizer Recommendation:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px',maxWidth:'100%'}},this.props.NonGPUValue.Server,' / ',this.props.NonGPUValue.Proc,' / ',this.props.NonGPUValue.Memory,' / ',this.props.NonGPUValue.Drive,' / ',this.props.NonGPUValue.ServerQty,' - Hosts '))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{paddingTop:'30px',display:GPUDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'small',style:{marginTop:'0px'}},GPURoleName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the server model desired. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:GPUNodeType,options:GPUNodeList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUNodeType","GPU");}})),GPUProcFamilyType!='NA'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor family desired.','data-for':'procfamilygpu',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'procfamilygpu'}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUProcFamilyType,options:GPUProcFamilyList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUProcFamilyType","GPU");}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor type based on the processor family requested.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUProcType,options:GPUProcList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUProcType","GPU");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the amount of memory desired per server.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUMemory,options:GPUMemoryList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUMemory","GPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_18" /* EPHEMERAL_STORAGE_DRIVE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the ephemeral storage drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUStrDrivetype,options:GPUStrDrivetypeList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUStrDrivetype","GPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_19" /* EPHEMERAL_STORAGE_DTIVE_QUANTITY */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:GPUNodeStorageDriveQuantity,disabled:false,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,"GPUNodeStorageDriveQuantity","Change");},onBlur:function onBlur(e){return _this6.GPUtextchange(e,"GPUNodeStorageDriveQuantity","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'OS Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the operating system drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUOSDrive,options:GPUOSDriveList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUOSDrive","GPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Persistent Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the persistent drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUTenantStoragedrive,options:GPUTenantStoragedrivelist,onChange:function onChange(e){return _this6.GPUChange(e,"GPUTenantStoragedrive","GPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Persistent Drive Quantity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:GPUTenantStorageDriveQuantity,disabled:true,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,"GPUTenantStorageDriveQuantity","Change");},onBlur:function onBlur(e){return _this6.GPUtextchange(e,"GPUTenantStorageDriveQuantity","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'GPU Type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the GPU type desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33.33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUType,options:EPICGPUlist,onChange:function onChange(e){return _this6.GPUChange(e,"GPUType","GPU");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host  Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'The number of servers required to meet the workload requirements, based on the CPU, Memory, and drives selected.  ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'22%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:GPUNodeCoount,disabled:false,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,"GPUNodeCoount","Change");},onBlur:function onBlur(e){return _this6.GPUtextchange(e,"GPUNodeCoount","Blur");}})),trainingGPUcount!='0'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Max '+maxGPUCount+' GPU(s) per server',style:{width:'22%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:GPUCount,options:GPUcountList,onChange:function onChange(e){return _this6.GPUChange(e,"GPUCount","GPU");}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'No. of GPUs',style:{width:'22%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:totalgpus,disabled:true}))),GPUNoteText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{display:displayGPUCost,margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px",marginRight:'5px'}},'Approx. Configuration            Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'This is an approximate configuration cost. Please refer BOM Details for the actual Bill of Materials and Cost.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginRight:'3px'}}),': ',GPUCost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{display:GPURecommendationDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Sizer Recommendation:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px',maxWidth:'100%'}},this.props.GPUValue.Server,' / ',this.props.GPUValue.Proc,' / ',this.props.GPUValue.Memory,' / ',this.props.GPUValue.Drive,' / ',this.props.GPUValue.ServerQty,' - Hosts'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{paddingTop:'30px',display:storageDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'small',style:{marginTop:'0px'}},'Storage Hosts'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the server model desired. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{value:storageNodeType,options:STORAGE_HOST_OPTIONS,onChange:function onChange(e){return _this6.GPUChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_167" /* STORAGE_NODE_TYPE */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}})),storageProcFamilyType!='NA'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor family desired.','data-for':'procfamilygpu',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_react_tooltip___default.a,{place:'right',type:'dark',effect:'solid',id:'procfamilygpu'}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:storageProcFamilyType,options:STORAGE_PROCESSORFAMILY_OPTIONS,onChange:function onChange(e){return _this6.GPUChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_169" /* STORAGE_PROCESSOR_FAMILY */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor type based on the processor family requested.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:storageProcType,options:STORAGE_PROCESSOR_OPTIONS,onChange:function onChange(e){return _this6.GPUChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_170" /* STORAGE_PROCESSOR_TYPE */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the amount of memory desired per server.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:storageMemory,options:STORAGE_MEMORY_OPTIONS,onChange:function onChange(e){return _this6.GPUChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_163" /* STORAGE_MEMORY */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_18" /* EPHEMERAL_STORAGE_DRIVE */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the ephemeral storage drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:storageNodeDrive,options:STORAGE_NODE_DRIVE_OPTIONS,onChange:function onChange(e){return _this6.GPUChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_165" /* STORAGE_NODE_DRIVE */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_19" /* EPHEMERAL_STORAGE_DTIVE_QUANTITY */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:storageNodeDriveQty,disabled:false,onDOMChange:function onDOMChange(e){return _this6.storageTextChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_166" /* STORAGE_NODE_DRIVE_QTY */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]);},onBlur:function onBlur(e){return _this6.storageTextChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_166" /* STORAGE_NODE_DRIVE_QTY */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__DataDrive_js__["a" /* default */],{isMixedStorage:storageMixedTenantStorage,dataDriveType:this.state.storageTenantDriveType,dataDriveConsolidatedOptions:this.state.storageTenantDriveConsolidatedOptions,onDatadriveTypeChange:this.onStorageTenantDriveTypeChange,Drives:STORAGE_TENANT_DRIVE_OPTIONS,dataDiskValue:storageTenantStorageDrive,onDataDiskChange:this.GPUChange,noOfDisksValue:storageTenantDriveQuantity,onNoOfDisksChange:this.storageTextChange,onAddingDataDisk:this.addStorageTenanatDrive,renderTable:this.renderStorageTenantDriveTable,driveChangeMethodParam1:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_171" /* STORAGE_TENANT_DRIVE */],driveQtyChangeMethodParam1:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_172" /* STORAGE_TENANT_DRIVE_QUANTITY */],roleName:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */],enableADDButton:this.state.enableADDButton,workloadType:__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */],isEPIC:this.state.EPICRadioBtn}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'OS Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the operating system drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Select___default.a,{id:'DiskCapacity',value:storageOSDrive,options:STORAGE_OSDRIVE_OPTIONS,onChange:function onChange(e){return _this6.GPUChange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_168" /* STORAGE_OSDRIVE */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_161" /* STORAGE_ */]);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host  Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'The number of servers required to meet the workload requirements, based on the CPU, Memory, and drives selected.  ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'22%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_TextInput___default.a,{value:storageNodeCount,disabled:false,onDOMChange:function onDOMChange(e){return _this6.GPUtextchange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]);},onBlur:function onBlur(e){return _this6.GPUtextchange(e,__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["_164" /* STORAGE_NODE_COUNT */],__WEBPACK_IMPORTED_MODULE_25__Redux_action_types_EPAConstants_js__["t" /* BLUR */]);}}))),StorageNoteText,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_28__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{display:displayStorageCost,margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px",marginRight:'5px'}},'Approx. Configuration Cost'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'This is an approximate configuration cost. Please refer BOM Details for the actual Bill of Materials and Cost.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginRight:'3px'}}),': ',storageCost)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{display:storageRecommendationDisplay}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}},'Sizer Recommendation:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{margin:"0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px',maxWidth:'100%'}},this.props.StorageValue.Server,' / ',this.props.StorageValue.Proc,' / ',this.props.StorageValue.Memory,' / ',this.props.StorageValue.Drive,' / ',this.props.StorageValue.ServerQty,' - Hosts'))),persistentDriveNoteDisplay))))));}}]);return DesignRequirements;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var tabObject=state.sizerWorkload.workload.UserInputs.Environments;if(Array.isArray(state.sizerWorkload.workload.UserInputs.Environments.Environment)){tabObject=state.sizerWorkload.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]==="yes";});}var CountryTemp=state.sessions.Country;try{if(state.sizerWorkload.workload.UserInputs.Country!==CountryTemp)CountryTemp=state.sizerWorkload.workload.UserInputs.Country;}catch(e){}return{workload:state.sizerWorkload.workload,activeSession:state.sessions.activeSession,Templates:state.sizerWorkload.Templates,Epicreq:state.sizerWorkload.EPICRequirements,isLoading:state.sizerWorkload.isLoading,sessionsDefaults:state.sessions.sessionDefaults,GlobalErr:state.sessions.activeSession.globalError,GPUdetails:state.sizerWorkload.GPUdetails,NonGPUdetails:state.sizerWorkload.NonGPUdetails,isCal:state.sizerWorkload.isCal,calculateWithUpdatedTenantDrive:state.sizerWorkload.calculateWithUpdatedTenantDrive,currentRoleName:state.sizerWorkload.currentRoleName,country:CountryTemp,ServiceError:state.sizerWorkload,GPUValue:tabObject.GPUValue||state.sizerWorkload.GPUValue,NonGPUValue:tabObject.NonGPUValue||state.sizerWorkload.NonGPUValue,StorageValue:tabObject.StorageValue||state.sizerWorkload.StorageValue,GPUdetailsforcore:tabObject||state.sizerWorkload,controllerconfigChanged:state.sizerWorkload.ControllerConfigChanged,scroll:state.sizerWorkload.scrollsetting,ConfigButton:state.sizerWorkload.calbtn,OpenedSaveWorkload:state.sessions.Saveworkloadopened,calculateBlueDataAPIcount:state.sizerWorkload.calculateBlueDataAPIcount,sizerWorkloadforCalculation:state.sizerWorkload.sizerWorkloadforCalculation,gatewaydetails:state.sizerWorkload.Gatewaydetails,controllerdetails:state.sizerWorkload.Controllerdetails,masterdetails:state.sizerWorkload.Masterdetails,Storagedetails:state.sizerWorkload.Storagedetails,currentTab:state.sizerWorkload.currentTab,SSETid:state.sessions.SSETid,GPUHostCount:tabObject.HostCount||state.sizerWorkload.HostCount};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__["W" /* toggleSizeButton */])(value));},OnFetchTemplateList:function OnFetchTemplateList(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["m" /* fetchTemplateList */])());},EPICRequirements:function EPICRequirements(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["v" /* onepicequirements */])(value));},CalculateBlueDataConfigurationtrue:function CalculateBlueDataConfigurationtrue(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["u" /* oncalbluedataconfigtrue */])(value));},CalculateBlueDataConfigurationfalse:function CalculateBlueDataConfigurationfalse(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["t" /* oncalbluedataconfigfalse */])(value));},OnGatewaydltsfetch:function OnGatewaydltsfetch(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["n" /* fetchgatewaydlts */])(value));},ErrorValidation:function ErrorValidation(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_13__State_actions_sessions__["p" /* errorValidataion */])(value));},GetOSDiskList:function GetOSDiskList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["s" /* getosdisklistBlueData */])(value));},ContrlChanged:function ContrlChanged(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["e" /* controllerchnaged */])(value));},Errorclose:function Errorclose(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["g" /* errorclose */])());},Calcbutton:function Calcbutton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["a" /* Calbutn */])(value));},onUpdateDefaultSession:function onUpdateDefaultSession(inputs){dispatch({type:'UPDATE_SESSION_DEFAULTS',payload:inputs});},changeCalculateBlueDataAPIcount:function changeCalculateBlueDataAPIcount(value){dispatch({type:'UPDATE_CALCULATEBLUEDATAAPICOUNT',payload:value});},getTenantStorageDriveList:function getTenantStorageDriveList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["p" /* getTenantStorageDiskList */])(value));},calculateWithUpdatedTenantDriveAction:function calculateWithUpdatedTenantDriveAction(value){dispatch({type:'CALCULATE_WITHUPDATEDTENANTDRIVEACTION',payload:value});},currentRoleNameAction:function currentRoleNameAction(value){dispatch({type:'CURRENT_ROLENAMEACTION',payload:value});},changeCurrentTab:function changeCurrentTab(value){dispatch({type:'UPDATE_SCREEN',payload:value});},GatewayRecommendations:function GatewayRecommendations(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["c" /* GetGatewayRecommendations */])(value));},ControllerRecommendations:function ControllerRecommendations(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["b" /* GetControllerRecommendations */])(value));},MasterRecommendations:function MasterRecommendations(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__Redux_actions_epaActions__["d" /* GetMasterRecommendations */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DesignRequirements));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormCheckmark__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormCheckmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormCheckmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isCurrentTabChecked=void 0;var DisplayTabs=function(_Component){_inherits(DisplayTabs,_Component);function DisplayTabs(){_classCallCheck(this,DisplayTabs);var _this=_possibleConstructorReturn(this,(DisplayTabs.__proto__||Object.getPrototypeOf(DisplayTabs)).call(this));_this.onTabChange=function(correspondingTabName){_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]==="yes";})["@isCurrentTab"]="no";_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===correspondingTabName;})["@isCurrentTab"]="yes";if(_this.props.currentTab){_this.props.changeCurrentTab(false);}else{_this.props.changeCurrentTab(true);}_this.setState({});};return _this;}_createClass(DisplayTabs,[{key:'render',value:function render(){var _this2=this;var TabToolTip='';var currentTabObject=this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];});if(currentTabObject["@isSelected"]===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){isCurrentTabChecked=true;}else{isCurrentTabChecked=false;}var tabsList=this.props.workload.UserInputs.Environments.Environment.map(function(solution,id){var tabBackgroundColor=__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_198" /* WHITE_COLOR */];var isChecked=false;var needToCalculate=false;var checkBoxDisplay=__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_109" /* NONE_ */];var fontColors=__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["p" /* BLACK_COLOR */];if(solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){tabBackgroundColor=__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_180" /* TAB_BACKGROUND */];fontColors=__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_198" /* WHITE_COLOR */];}if(solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){checkBoxDisplay=__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["q" /* BLOCK_ */];if(solution.NonGPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]||solution.GPUValue.isCalculated===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]||solution.StorageValue.isCalculated===__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){isChecked=true;}else{needToCalculate=true;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_tooltip___default.a,{place:'right',multiline:true,id:solution['@SolutionType']}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{style:{width:'30px',padding:'10px 5px',display:checkBoxDisplay,background:tabBackgroundColor}},isChecked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormCheckmark___default.a,{style:{stroke:'rgb(1, 169, 130)'}}):'',needToCalculate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Alert___default.a,{style:{stroke:'#ff8d6d'}}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginRight:'6px',marginBottom:'0px',padding:'10px',background:tabBackgroundColor,color:fontColors},onClick:function onClick(){return _this2.onTabChange(solution["@SolutionType"]);}},solution["@SolutionType"],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':__WEBPACK_IMPORTED_MODULE_2__Redux_action_types_EPAConstants_js__["_26" /* EzemeralServicesToolTips */][solution["@SolutionType"]],'data-for':solution['@SolutionType'],colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Box___default.a,{direction:'row',style:{marginBottom:'10px',borderBottom:'2px solid #01a982'}},tabsList));}}]);return DisplayTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{currentTab:state.sizerWorkload.currentTab,workload:state.sizerWorkload.workload};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{changeCurrentTab:function changeCurrentTab(value){dispatch({type:'UPDATE_SCREEN',payload:value});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DisplayTabs));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Redux_action_types_epaActionTypes__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commonLogic_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Warning__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import CheckBox from 'grommet/components/CheckBox';
//let gatewayhostcount = 0;
//let controllerhostcount = 0;
var HostChanged=false;var selectchange="";var Gatewaylist='';var Controllerlist='';var Masterlist='';var GatewayHostType=void 0,GatewayHostlist=void 0,GatewayCPUtype=void 0,GatewayCPUFamilytype=void 0,GatewayMemory=void 0,GatewayMemoryList=void 0,GatewayOSDrive=void 0,GatewayOSDriveList=void 0,GatewayStrDrvtype=void 0,GatewayStrDrvList=void 0,GatewayStrDrvCount=void 0,GatewayCount=void 0,HAIncluded=void 0;var GatewayCPUList=[];var GatewayCPUFamilyList=[];var ControllerHostType=void 0,ControllerHostlist=void 0,ControllerCPUtype=void 0,ControllerCPUFamilytype=void 0,ControllerCPUList=void 0,ControllerCPUFamilyList=void 0,ControllerMemory=void 0,ControllerMemoryList=void 0,ControllerOSDrive=void 0,ControllerOSDriveList=void 0,ControllerStrDrvtype=void 0,ControllerStrDrvList=void 0,TenantStrDrvtypelist=void 0,ControllerStrDrvCount=void 0,ControllerCount=void 0;var MasterHostType=void 0,MasterHostlist=void 0,MasterCPUtype=void 0,MasterCPUFamilytype=void 0,MasterCPUList=void 0,MasterCPUFamilyList=void 0,MasterMemory=void 0,MasterMemoryList=void 0,MasterOSDrive=void 0,MasterOSDriveList=void 0,MasterStrDrvtype=void 0,MasterStrDrvList=void 0,MasterTenantStrDrvtypelist=void 0,MasterStrDrvCount=void 0,MasterCount=void 0;var TenantStrDrvtype=void 0,TenantStrDrvQty=void 0,MasterTenantStrDrvtype=void 0,MasterTenantStrDrvQty=void 0;var MaxDrives='';var NVMEMaxDrives="";var ControllerMaxDrives='';var ControllerNVMEMaxDrives="";var MasterMaxDrives='';var MasterNVMEMaxDrives="";var GatewayDatadriveChanged=false;var ControllerDatadriveChanged=false;var MasterDatadriveChanged=false;var NVMESTRING="NVME";var warningText="";var DesignRequirements=function(_Component){_inherits(DesignRequirements,_Component);function DesignRequirements(){_classCallCheck(this,DesignRequirements);var _this=_possibleConstructorReturn(this,(DesignRequirements.__proto__||Object.getPrototypeOf(DesignRequirements)).call(this));_this.onWrkUpdateselect=function(value,textinput,chorBlr){var controllerdatadisk=value;var masterdatadisk=value;var gatewaydatadisk=value;var isValidDriveCombination=true;_this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter(function(x){var selectedDriveValidation=function selectedDriveValidation(drive1,drive2,maxDrives,serverName){if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(value.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||value.toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1)){isValidDriveCombination=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["p" /* validateApollo4200SFFDrives */])(drive1,drive2,value);}if(isValidDriveCombination){isValidDriveCombination=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["q" /* validateDriveChange */])(drive1,drive2,value,serverName);}if(!isValidDriveCombination){warningText=_this.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_12" /* DRIVE_CANNOTBE_MIXED */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_21" /* ERROR_TEXT */]);}if(isValidDriveCombination){isValidDriveCombination=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["r" /* validateNVMEorSFFDrivesCount */])(x,maxDrives);if(!isValidDriveCombination){warningText=_this.renderErrorPopup(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][0]+maxDrives+__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_95" /* MAXDRIVEQTY_EXCEEDED */][1],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_21" /* ERROR_TEXT */]);}}};switch(x["@Type"]){case"Gateway":if(textinput==="GatewayHostType"){if(GatewayHostType!==value){x["@Name"]=value;if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_102" /* MOONSHOT_750 */])===-1){x["@ServerName"]=x["@Name"];x["@ProcQty"]="2";}else{x["@ServerName"]="HP Moonshot System";x["@ProcQty"]="1";}x["@OSDiskQty"]=x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])>-1?"1":"2";GatewayCPUList=[];GatewayCPUFamilyList=[];GatewayMemoryList=[];GatewayOSDriveList=[];GatewayStrDrvList=[];for(var key in Gatewaylist){if(key===x["@Name"]){MaxDrives=Gatewaylist[key].MaxDrives;NVMEMaxDrives=Gatewaylist[key].MaxNVMeDrives;GatewayStrDrvList=Gatewaylist[key].DataDriveList;if(GatewayStrDrvList.indexOf(x["@NodeDisk"])===-1){x["@NodeDisk"]=GatewayStrDrvList[0];}GatewayOSDriveList=Gatewaylist[key].OSDriveList;if(GatewayOSDriveList.indexOf(x["@OSDisk"])===-1){x["@OSDisk"]=GatewayOSDriveList[0];}for(var proctype in Gatewaylist[x["@Name"]].ProcessorList){GatewayCPUFamilyList.push(proctype);}if(GatewayCPUFamilyList.indexOf(x["@ProcFamily"])===-1){x["@ProcFamily"]=GatewayCPUFamilyList[0];}for(var _proctype in Gatewaylist[x["@Name"]].ProcessorList){if(_proctype===x["@ProcFamily"]){for(var proc in Gatewaylist[x["@Name"]].ProcessorList[_proctype]){GatewayCPUList.push(proc);}if(GatewayCPUList.indexOf(x["@Proc"])===-1){x["@Proc"]=GatewayCPUList[0];}GatewayMemoryList=Gatewaylist[x["@Name"]].ProcessorList[_proctype][x["@Proc"]];if(GatewayMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=GatewayMemoryList[0];}}}}}x["@StorageDiskQty"]="0";}}if(textinput==="GatewayCPUtype"){x["@Proc"]=value;}if(textinput==="GatewayCPUFamilytype"){x["@ProcFamily"]=value;GatewayMemoryList=[];GatewayCPUList=[];for(var _key in Gatewaylist){if(_key===x["@Name"]){for(var procfamily in Gatewaylist[_key].ProcessorList){if(procfamily===x["@ProcFamily"]){for(var _proc in Gatewaylist[_key].ProcessorList[procfamily]){GatewayCPUList.push(_proc);}x["@Proc"]=GatewayCPUList[0];GatewayMemoryList=Gatewaylist[x["@Name"]].ProcessorList[procfamily][x["@Proc"]];if(GatewayMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=GatewayMemoryList[0];}}}}}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_32" /* GATEWAY_NODE_STORAGE_DRIVE */]){if(GatewayStrDrvtype!==value){var oldDrive=GatewayStrDrvtype;x["@NodeDisk"]=value;selectedDriveValidation(x["@TStorageDrive"],x["@OSDisk"],_this.props.gatewaydetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@NodeDisk"]=oldDrive;}GatewayStrDrvtype=x["@NodeDisk"];GatewayDatadriveChanged=false;}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_34" /* GATEWAY_OSDRIVE */]){if(GatewayOSDrive!==value){var _oldDrive=GatewayOSDrive;x["@OSDisk"]=value;selectedDriveValidation(x["@TStorageDrive"],x["@NodeDisk"],_this.props.gatewaydetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@OSDisk"]=_oldDrive;}GatewayOSDrive=x["@OSDisk"];}}if(textinput==="GatewayStrDrvCount"){if(value&&(x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1)){var qty=NVMEMaxDrives;if(x["@OSDisk"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1){qty-=parseInt(x['OSDiskQty'],10);}if(parseInt(value,10)<qty){x["@StorageDiskQty"]=value;}else x["@StorageDiskQty"]=qty.toString();}else if(MaxDrives-parseInt(x["@OSDiskQty"],10)<parseInt(value,10)&&x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING)===-1){x["@StorageDiskQty"]=(MaxDrives-parseInt(x["@OSDiskQty"],10)).toString();}else{x["@StorageDiskQty"]=value;}}if(textinput==="GatewayCount"){if(_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@HAIncluded"]==="true"){if(parseInt(value,10)<2){x["@NodesCount"]="2";}else{x["@NodesCount"]=value;}}else{x["@NodesCount"]=value;}}if(textinput==="GatewayMemory")x["@Memory"]=value;break;case"Controller":if(textinput==="ControllerHostType"){if(ControllerHostType!==value){x["@Name"]=value;if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_102" /* MOONSHOT_750 */])===-1){x["@ServerName"]=x["@Name"];x["@ProcQty"]="2";}else{x["@ServerName"]="HP Moonshot System";x["@ProcQty"]="1";}x["@OSDiskQty"]=x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])>-1?"1":"2";ControllerCPUList=[];ControllerMemoryList=[];ControllerOSDriveList=[];ControllerStrDrvList=[];TenantStrDrvtypelist=[];ControllerCPUFamilyList=[];for(var _key2 in Controllerlist){if(_key2===x["@Name"]){ControllerMaxDrives=Controllerlist[_key2].MaxDrives;ControllerNVMEMaxDrives=Controllerlist[_key2].MaxNVMeDrives;ControllerStrDrvList=Controllerlist[_key2].DataDriveList;TenantStrDrvtypelist=Controllerlist[_key2].TenantDriveList;if(ControllerStrDrvList.indexOf(x["@NodeDisk"])===-1){x["@NodeDisk"]=ControllerStrDrvList[0];}if(TenantStrDrvtypelist.indexOf(x["@TStorageDrive"])===-1){x["@TStorageDrive"]=TenantStrDrvtypelist[0];}ControllerOSDriveList=Controllerlist[_key2].OSDriveList;if(ControllerOSDriveList.indexOf(x["@OSDisk"])===-1){x["@OSDisk"]=ControllerOSDriveList[0];}for(var _proctype2 in Controllerlist[x["@Name"]].ProcessorList){ControllerCPUFamilyList.push(_proctype2);}if(ControllerCPUFamilyList.indexOf(x["@ProcFamily"])===-1){x["@ProcFamily"]=ControllerCPUFamilyList[0];}ControllerCPUFamilytype=x["@ProcFamily"];for(var _proctype3 in Controllerlist[x["@Name"]].ProcessorList){if(_proctype3===x["@ProcFamily"]){for(var _proc2 in Controllerlist[x["@Name"]].ProcessorList[_proctype3]){ControllerCPUList.push(_proc2);}if(ControllerCPUList.indexOf(x["@Proc"])===-1){x["@Proc"]=ControllerCPUList[0];}ControllerMemoryList=Controllerlist[x["@Name"]].ProcessorList[_proctype3][x["@Proc"]];if(ControllerMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=ControllerMemoryList[0];}}}}}if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])>-1){if(x["@TStorageDriveQty"]=="0"){x["@StorageDiskQty"]="2";}else{x["@TStorageDriveQty"]="1";x["@StorageDiskQty"]="1";}}else{x["@StorageDiskQty"]="2";}}}if(textinput==="ControllerCPUtype")x["@Proc"]=value;if(textinput==="ControllerCPUFamilytype"){x["@ProcFamily"]=value;ControllerMemoryList=[];ControllerCPUList=[];for(var _key3 in Controllerlist){if(_key3===x["@Name"]){for(var _procfamily in Controllerlist[_key3].ProcessorList){if(_procfamily===x["@ProcFamily"]){for(var _proc3 in Controllerlist[_key3].ProcessorList[_procfamily]){ControllerCPUList.push(_proc3);}if(ControllerCPUList.indexOf(x["@Proc"])===-1){x["@Proc"]=ControllerCPUList[0];}ControllerMemoryList=Controllerlist[x["@Name"]].ProcessorList[_procfamily][x["@Proc"]];if(ControllerMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=ControllerMemoryList[0];}}}}}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["H" /* CONTROLLER_NODE_STORAGE_DRIVE */]){if(ControllerStrDrvtype!==value){var _oldDrive2=ControllerStrDrvtype;x["@NodeDisk"]=value;selectedDriveValidation(x["@TStorageDrive"],x["@OSDisk"],_this.props.controllerdetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@NodeDisk"]=_oldDrive2;ControllerDatadriveChanged=false;}ControllerStrDrvtype=x["@NodeDisk"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["K" /* CONTROLLER_TENANT_DRIVE */]){if(TenantStrDrvtype!==value){var _oldDrive3=TenantStrDrvtype;x["@TStorageDrive"]=value;selectedDriveValidation(x["@NodeDisk"],x["@OSDisk"],_this.props.controllerdetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@TStorageDrive"]=_oldDrive3;}TenantStrDrvtype=x["@TStorageDrive"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["J" /* CONTROLLER_OSDRIVE */]){if(ControllerOSDrive!==value){var _oldDrive4=ControllerOSDrive;x["@OSDisk"]=value;selectedDriveValidation(x["@NodeDisk"],x["@TStorageDrive"],_this.props.controllerdetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@OSDisk"]=_oldDrive4;}ControllerOSDrive=x["@OSDisk"];}}if(textinput==="ControllerStrDrvCount"){if(x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){ControllerNVMEMaxDrives=_this.props.controllerdetails[x["@Name"]].MaxNVMeDrives;if(value){var _qty=ControllerNVMEMaxDrives;if(x["@OSDisk"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){_qty-=parseInt(x['@OSDiskQty'],10);}if(x["@TStorageDrive"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){_qty-=parseInt(x['@TStorageDriveQty'],10);}if(parseInt(value,10)<2&&_qty>1){value="2";}if(parseInt(value,10)<_qty){x["@StorageDiskQty"]=value;}else x["@StorageDiskQty"]=_qty.toString();}else x["@StorageDiskQty"]=value;}else{ControllerMaxDrives=_this.props.controllerdetails[x["@Name"]].MaxDrives;if(chorBlr===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){if(parseInt(value,10)<2){value="2";}}if(ControllerMaxDrives-parseInt(x["@TStorageDriveQty"],10)-parseInt(x["@OSDiskQty"],10)<parseInt(value,10)){x["@StorageDiskQty"]=(ControllerMaxDrives-parseInt(x["@TStorageDriveQty"],10)-parseInt(x["@OSDiskQty"],10)).toString();}else{x["@StorageDiskQty"]=value;}}}if(textinput==="TenantStrDrvCount"){ControllerMaxDrives=_this.props.controllerdetails[x["@Name"]].MaxDrives;var nodeStorageDiskQty=parseInt(x["@StorageDiskQty"],10);if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1)){if(x["@OSDisk"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_103" /* M_2 */])>-1){ControllerMaxDrives=26;}else{ControllerMaxDrives=24;}nodeStorageDiskQty=0;}if(ControllerMaxDrives-2<parseInt(value,10)){x["@TStorageDriveQty"]=(ControllerMaxDrives-2).toString();}if(ControllerMaxDrives-nodeStorageDiskQty-parseInt(x["@OSDiskQty"],10)-parseInt(value,10)<0){value=(ControllerMaxDrives-nodeStorageDiskQty-parseInt(x["@OSDiskQty"],10)).toString();}x["@TStorageDriveQty"]=value;}if(textinput==="ControllerCount"){if(x["@HAIncluded"]==="true"){if(parseInt(value,10)<3){x["@NodesCount"]="3";}else{x["@NodesCount"]=value;}}else{x["@NodesCount"]=value;}}if(textinput==="ControllerMemory")x["@Memory"]=value;break;case"Master":if(textinput==="MasterHostType"){if(MasterHostType!==value){x["@Name"]=value;if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_102" /* MOONSHOT_750 */])===-1){x["@ServerName"]=x["@Name"];x["@ProcQty"]="2";}else{x["@ServerName"]="HP Moonshot System";x["@ProcQty"]="1";}x["@OSDiskQty"]=x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])>-1?"1":"2";MasterCPUList=[];MasterMemoryList=[];MasterOSDriveList=[];MasterStrDrvList=[];MasterTenantStrDrvtypelist=[];MasterCPUFamilyList=[];for(var _key4 in Masterlist){if(_key4===x["@Name"]){MasterMaxDrives=Masterlist[_key4].MaxDrives;MasterNVMEMaxDrives=Masterlist[_key4].MaxNVMeDrives;MasterStrDrvList=Masterlist[_key4].DataDriveList;MasterTenantStrDrvtypelist=Masterlist[_key4].TenantDriveList;if(MasterStrDrvList.indexOf(x["@NodeDisk"])===-1){x["@NodeDisk"]=MasterStrDrvList[0];}if(MasterTenantStrDrvtypelist.indexOf(x["@TStorageDrive"])===-1){x["@TStorageDrive"]=MasterTenantStrDrvtypelist[0];}MasterOSDriveList=Masterlist[_key4].OSDriveList;if(MasterOSDriveList.indexOf(x["@OSDisk"])===-1){x["@OSDisk"]=MasterOSDriveList[0];}for(var _proctype4 in Masterlist[x["@Name"]].ProcessorList){MasterCPUFamilyList.push(_proctype4);}if(MasterCPUFamilyList.indexOf(x["@ProcFamily"])===-1){x["@ProcFamily"]=MasterCPUFamilyList[0];}MasterCPUFamilytype=x["@ProcFamily"];for(var _proctype5 in Masterlist[x["@Name"]].ProcessorList){if(_proctype5===x["@ProcFamily"]){for(var _proc4 in Masterlist[x["@Name"]].ProcessorList[_proctype5]){MasterCPUList.push(_proc4);}if(MasterCPUList.indexOf(x["@Proc"])===-1){x["@Proc"]=MasterCPUList[0];}MasterMemoryList=Masterlist[x["@Name"]].ProcessorList[_proctype5][x["@Proc"]];if(MasterMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=MasterMemoryList[0];}}}}}if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])>-1){if(x["@TStorageDriveQty"]=="0"){x["@StorageDiskQty"]="2";}else{x["@TStorageDriveQty"]="1";x["@StorageDiskQty"]="1";}}else{x["@StorageDiskQty"]="2";}}}if(textinput==="MasterCPUtype")x["@Proc"]=value;if(textinput==="MasterCPUFamilytype"){x["@ProcFamily"]=value;MasterMemoryList=[];MasterCPUList=[];for(var _key5 in Masterlist){if(_key5===x["@Name"]){for(var _procfamily2 in Masterlist[_key5].ProcessorList){if(_procfamily2===x["@ProcFamily"]){for(var _proc5 in Masterlist[_key5].ProcessorList[_procfamily2]){MasterCPUList.push(_proc5);}if(MasterCPUList.indexOf(x["@Proc"])===-1){x["@Proc"]=MasterCPUList[0];}MasterMemoryList=Masterlist[x["@Name"]].ProcessorList[_procfamily2][x["@Proc"]];if(MasterMemoryList.indexOf(x["@Memory"])===-1){x["@Memory"]=MasterMemoryList[0];}}}}}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_92" /* MASTER_NODE_STORAGE_DRIVE */]){if(MasterStrDrvtype!==value){var _oldDrive5=MasterStrDrvtype;x["@NodeDisk"]=value;selectedDriveValidation(x["@TStorageDrive"],x["@OSDisk"],_this.props.masterdetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@NodeDisk"]=_oldDrive5;MasterDatadriveChanged=false;}MasterStrDrvtype=x["@NodeDisk"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_94" /* MASTER_TENANT_DRIVE */]){if(MasterTenantStrDrvtype!==value){var _oldDrive6=MasterTenantStrDrvtype;x["@TStorageDrive"]=value;selectedDriveValidation(x["@NodeDisk"],x["@OSDisk"],_this.props.masterdetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@TStorageDrive"]=_oldDrive6;}MasterTenantStrDrvtype=x["@TStorageDrive"];}}if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_93" /* MASTER_OSDRIVE */]){if(MasterOSDrive!==value){var _oldDrive7=MasterOSDrive;x["@OSDisk"]=value;selectedDriveValidation(x["@NodeDisk"],x["@TStorageDrive"],_this.props.masterdetails[x["@Name"]].MaxNVMeDrives,x["@Name"]);if(!isValidDriveCombination){x["@OSDisk"]=_oldDrive7;}MasterOSDrive=x["@OSDisk"];}}if(textinput==="MasterStrDrvCount"){if(x["@NodeDisk"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){MasterNVMEMaxDrives=_this.props.masterdetails[x["@Name"]].MaxNVMeDrives;if(value){var _qty2=MasterNVMEMaxDrives;if(x["@OSDisk"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@OSDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){_qty2-=parseInt(x['@OSDiskQty'],10);}if(x["@TStorageDrive"].toUpperCase().indexOf(NVMESTRING)!==-1||x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@TStorageDrive"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1)){_qty2-=parseInt(x['@TStorageDriveQty'],10);}if(parseInt(value,10)<2&&_qty2>1){value="2";}if(parseInt(value,10)<_qty2){x["@StorageDiskQty"]=value;}else x["@StorageDiskQty"]=_qty2.toString();}else x["@StorageDiskQty"]=value;}else{MasterMaxDrives=_this.props.masterdetails[x["@Name"]].MaxDrives;if(chorBlr===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["t" /* BLUR */]){if(parseInt(value,10)<2){value="2";}}if(MasterMaxDrives-parseInt(x["@TStorageDriveQty"],10)-parseInt(x["@OSDiskQty"],10)<parseInt(value,10)){x["@StorageDiskQty"]=(MasterMaxDrives-parseInt(x["@TStorageDriveQty"],10)-parseInt(x["@OSDiskQty"],10)).toString();}else{x["@StorageDiskQty"]=value;}}}if(textinput==="MasterTenantStrDrvCount"){MasterMaxDrives=_this.props.masterdetails[x["@Name"]].MaxDrives;var _nodeStorageDiskQty=parseInt(x["@StorageDiskQty"],10);if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1)){if(x["@OSDisk"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_103" /* M_2 */])>-1){MasterMaxDrives=26;}else{MasterMaxDrives=24;}_nodeStorageDiskQty=0;}if(MasterMaxDrives-2<parseInt(value,10)){x["@TStorageDriveQty"]=(MasterMaxDrives-2).toString();}if(MasterMaxDrives-_nodeStorageDiskQty-parseInt(x["@OSDiskQty"],10)-parseInt(value,10)<0){value=(MasterMaxDrives-_nodeStorageDiskQty-parseInt(x["@OSDiskQty"],10)).toString();}x["@TStorageDriveQty"]=value;}if(textinput==="MasterCount"){if(x["@HAIncluded"]==="true"){if(parseInt(value,10)<3){x["@NodesCount"]="3";}else{x["@NodesCount"]=value;}}else{x["@NodesCount"]=value;}}if(textinput==="MasterMemory")x["@Memory"]=value;break;}});if(_this.props.controllerconfigChanged===false){_this.props.ContrlChanged(true);}if(GatewayDatadriveChanged){GatewayDatadriveChanged=false;var data={"strServer":GatewayHostType,"strDataDisk":gatewaydatadisk,"strConfigType":"BlueData","rolename":"Gateway"};_this.props.GetOSDiskList(data);}if(ControllerDatadriveChanged){ControllerDatadriveChanged=false;var inputs={"strServer":ControllerHostType,"strDataDisk":controllerdatadisk,"strConfigType":"BlueData","rolename":"Controller"};_this.props.GetOSDiskList(inputs);var tenantInputs={"strServer":ControllerHostType,"strDataDisk":controllerdatadisk,"strConfigType":"BlueData","rolename":"Controller","localStorage":"Local Tenant"};_this.props.getTenantStorageDriveList(tenantInputs);}if(MasterDatadriveChanged){MasterDatadriveChanged=false;var inputs={"strServer":MasterHostType,"strDataDisk":masterdatadisk,"strConfigType":"BlueData","rolename":"Master"};_this.props.GetOSDiskList(inputs);var tenantInputs={"strServer":MasterHostType,"strDataDisk":masterdatadisk,"strConfigType":"BlueData","rolename":"Master","localStorage":"Local Tenant"};_this.props.getTenantStorageDriveList(tenantInputs);}_this.setState({});};_this.renderErrorPopup=function(msg,heading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',separator:'bottom',style:{padding:"none",backgroundColor:"#425563"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%',padding:"10px",color:"#fff"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px'}},heading)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{marginTop:"10px",padding:"5px"},margin:'none',pad:'none',align:'start',alignContent:'start',onClick:_this.layerClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_FormClose___default.a,{size:'small',colorIndex:'light-2',style:{stroke:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,null,msg)));};_this.layerClose=function(){warningText="";_this.setState({inValidDrive:false});};_this.onVMWareCheckBoxChange=function(){var controllerObject=_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];});if(controllerObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){controllerObject["@VMWare"]=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];_this.props.workload.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}else{var generalPurposeSelected=false;var MLOpsSelected=false;if(_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_36" /* GENERAL_PURPOSE */];})["@isSelected"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){generalPurposeSelected=true;}if(_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */];})["@isSelected"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){MLOpsSelected=true;}if(generalPurposeSelected||MLOpsSelected){_this.props.workload.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}controllerObject["@VMWare"]=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}_this.props.workload.UserInputs.Environments.VMWareUserChoice=controllerObject["@VMWare"];Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["i" /* updateControllerHostCount */])(_this.props.workload);var configMode=_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Requirements["@ConfigBasedOn"];var controllerServer=_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@Name"];var controllerPayload={"strServer":controllerServer,"strHostType":__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["G" /* CONTROLLER_HOST */],"strConfigMode":configMode,"isControllerHostVMWareChecked":_this.props.workload.UserInputs.Environments.VMWareUserChoice};_this.props.ControllerRecommendations(controllerPayload);_this.props.ServiceError.guiState.GandCAPICount=1;_this.props.ServiceError.guiState.updateManagementDetails=false;_this.setState({});};_this.onMasterVMWareCheckBoxChange=function(){var masterObject=_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];});if(masterObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){masterObject["@VMWare"]=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];_this.props.workload.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}else{var generalPurposeSelected=false;var MLOpsSelected=false;if(_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_36" /* GENERAL_PURPOSE */];})["@isSelected"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){generalPurposeSelected=true;}if(_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@SolutionType"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_98" /* MLOPS */];})["@isSelected"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */]){MLOpsSelected=true;}if(generalPurposeSelected||MLOpsSelected){_this.props.workload.UserInputs.Environments.Licenses.Nimble=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}masterObject["@VMWare"]=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}_this.props.workload.UserInputs.Environments.MasterVMWareUserChoice=masterObject["@VMWare"];Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["m" /* updateMasterHostCount */])(_this.props.workload);var configMode=_this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Requirements["@ConfigBasedOn"];var masterServer=_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@Name"];var masterPayload={"strServer":masterServer,"strHostType":__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_90" /* MASTER_HOST */],"strConfigMode":configMode,"isControllerHostVMWareChecked":_this.props.workload.UserInputs.Environments.MasterVMWareUserChoice};_this.props.MasterRecommendations(masterPayload);_this.props.ServiceError.guiState.GandCAPICount=1;_this.props.ServiceError.guiState.updateManagementDetails=false;_this.setState({});};_this.onGatewayVMWareCheckBoxChange=function(){var gatewayObject=_this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];});if(gatewayObject["@VMWare"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){gatewayObject["@VMWare"]=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_204" /* fALSE_ */];}else{gatewayObject["@VMWare"]=__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */];}_this.props.workload.UserInputs.Environments.GatewayVMWareUserChoice=gatewayObject["@VMWare"];_this.setState({});};_this.handleTabChanges=function(e){// this.setState({ currentTabActiveIndex: e });
_this.props.guiState.currentTabActiveIndex=e;_this.setState({});};_this.state={currentTabActiveIndex:2};return _this;}_createClass(DesignRequirements,[{key:'componentDidMount',value:function componentDidMount(){if(Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["k" /* updateFinishButton */])(this.props.workload,this.props.displayWarning,this.props.activeSession.isSizeEnabled)){this.props.OnToggleSizeButton(true);}}},{key:'layerclose',value:function layerclose(){// Minlayer = false
HostChanged=false;this.setState({});}},{key:'GPUChange',value:function GPUChange(e,textinput){selectchange=e.value;if(textinput==="GatewayHostType"||textinput==="ControllerHostType"||textinput==="MasterHostType"){if(textinput==="GatewayHostType"){if(GatewayHostType!==selectchange)HostChanged=true;}else{if(ControllerHostType!==selectchange||MasterHostType!==selectchange){HostChanged=true;if(this.props.workload.UserInputs.Environments.VMWareUserChoice==="true"&&textinput==="ControllerHostType"){var configMode=this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Requirements["@ConfigBasedOn"];var controllerServer=e.value;var controllerPayload={"strServer":controllerServer,"strHostType":__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["G" /* CONTROLLER_HOST */],"strConfigMode":configMode,"isControllerHostVMWareChecked":this.props.workload.UserInputs.Environments.VMWareUserChoice};this.props.ControllerRecommendations(controllerPayload);this.props.ServiceError.guiState.GandCAPICount=1;this.props.ServiceError.guiState.updateManagementDetails=false;//this.setState({});
}if(this.props.workload.UserInputs.Environments.MasterVMWareUserChoice==="true"&&textinput==="MasterHostType"){var _configMode=this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Requirements["@ConfigBasedOn"];var masterServer=e.value;var masterPayload={"strServer":masterServer,"strHostType":__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_90" /* MASTER_HOST */],"strConfigMode":_configMode,"isControllerHostVMWareChecked":this.props.workload.UserInputs.Environments.MasterVMWareUserChoice};this.props.MasterRecommendations(masterPayload);this.props.ServiceError.guiState.GandCAPICount=1;this.props.ServiceError.guiState.updateManagementDetails=false;//this.setState({});
}}}}if(textinput==='GatewayStrDrvtype'){if(GatewayStrDrvtype!==selectchange){GatewayDatadriveChanged=true;}}else if(textinput==='ControllerStrDrvtype'){if(ControllerStrDrvtype!==selectchange){ControllerDatadriveChanged=true;}}else if(textinput==='MasterStrDrvtype'){if(MasterStrDrvtype!==selectchange){MasterDatadriveChanged=true;}}this.onWrkUpdateselect(selectchange,textinput);}},{key:'ChkboxChange',value:function ChkboxChange(e){if(HAIncluded){HAIncluded=false;selectchange="false";}else{HAIncluded=true;selectchange="true";}var textinput="HAIncluded";this.onWrkUpdateselect(selectchange,textinput);}},{key:'GPUtextchange',value:function GPUtextchange(e,textinput,chorBlr){var number=/^[0-9]+$/;var minval=1;if(textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_33" /* GATEWAY_NODE_STORAGE_DRIVE_COUNT */]||textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["I" /* CONTROLLER_NODE_STORAGE_DRIVE_COUNT */]||textinput===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["L" /* CONTROLLER_TENANT_DRIVE_COUNT */]&&parseInt(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@TStorageDriveQty"],10)==0){minval=0;}if(chorBlr===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["x" /* CHANGE */]){if(e.target.value.length<3){var value=parseInt(e.target.value,10);if(isNaN(value)){selectchange="";}else if(number.test(value)&&value<=99&&value>=minval||isNaN(value)){selectchange=value.toString();}else{selectchange='1';}}}else{if(e.target.value===""){selectchange="1";}else{selectchange=e.target.value;}}this.onWrkUpdateselect(selectchange,textinput);}},{key:'render',value:function render(){var _this2=this;GatewayHostlist=[];GatewayCPUList=[];GatewayCPUFamilyList=[];GatewayStrDrvList=[];GatewayOSDriveList=[];GatewayMemoryList=[];ControllerHostlist=[];ControllerCPUList=[];ControllerCPUFamilyList=[];ControllerStrDrvList=[];TenantStrDrvtypelist=[];ControllerOSDriveList=[];ControllerMemoryList=[];MasterHostlist=[];MasterCPUList=[];MasterCPUFamilyList=[];MasterStrDrvList=[];MasterTenantStrDrvtypelist=[];MasterOSDriveList=[];MasterMemoryList=[];var edit='';var VMWareCheckBox=false;var gatewayVMWareCheckBox=false;var MasterVMWareCheckBox=false;var configurationType=this.props.workload.UserInputs.Environments.Environment.find(function(solution){return solution["@isCurrentTab"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).Templates.ServerDetails.Requirements["@ConfigBasedOn"];if(this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])!==-1){this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(role){return role["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})['@OSDiskQty']="1";}if(this.props.gatewaydetails!==null){this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter(function(x){switch(x["@Type"]){case"Gateway":if(x["@Name"]==="HP Apollo 4200 Gen10 Server"){x["@Name"]="HPE Apollo 4200 Gen10 Server";}if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1&&x['@Name'].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_102" /* MOONSHOT_750 */])===-1){x["@ServerName"]=x["@Name"];x["@ProcQty"]="2";}else{x["@ServerName"]="HP Moonshot System";x["@ProcQty"]="1";}GatewayHostType=x["@Name"];GatewayCPUtype=x["@Proc"];GatewayStrDrvtype=x["@NodeDisk"];GatewayOSDrive=x["@OSDisk"];GatewayStrDrvCount=x["@StorageDiskQty"];GatewayMemory=x["@Memory"];GatewayCount=x["@NodesCount"];GatewayCPUFamilytype=x["@ProcFamily"];if(x["@VMWare"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){gatewayVMWareCheckBox=true;}// HAIncluded = (/true/i).test(x["@HAIncluded"]);
break;case"Controller":if(x["@Name"]==="HP Apollo 4200 Gen10 Server"){x["@Name"]="HPE Apollo 4200 Gen10 Server";}ControllerHostType=x["@Name"];ControllerCPUtype=x["@Proc"];ControllerStrDrvtype=x["@NodeDisk"];ControllerOSDrive=x["@OSDisk"];ControllerStrDrvCount=x["@StorageDiskQty"];ControllerMemory=x["@Memory"];ControllerCount=x["@NodesCount"];ControllerCPUFamilytype=x["@ProcFamily"];TenantStrDrvtype=x["@TStorageDrive"];if(TenantStrDrvtype!=="None"){TenantStrDrvQty=x["@TStorageDriveQty"];edit=false;}else{TenantStrDrvQty="0";x["@TStorageDriveQty"]="0";edit=true;}// if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_)["@isSelected"] === Constants.yES_) {
//     x["@VMWare"] = Constants.tRUE_;
// }
if(x["@VMWare"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){VMWareCheckBox=true;}break;case"Master":if(x["@Name"]==="HP Apollo 4200 Gen10 Server"){x["@Name"]="HPE Apollo 4200 Gen10 Server";}MasterHostType=x["@Name"];MasterCPUtype=x["@Proc"];MasterStrDrvtype=x["@NodeDisk"];MasterOSDrive=x["@OSDisk"];MasterStrDrvCount=x["@StorageDiskQty"];MasterMemory=x["@Memory"];MasterCount=x["@NodesCount"];MasterCPUFamilytype=x["@ProcFamily"];MasterTenantStrDrvtype=x["@TStorageDrive"];if(MasterTenantStrDrvtype!=="None"){MasterTenantStrDrvQty=x["@TStorageDriveQty"];edit=false;}else{MasterTenantStrDrvQty="0";x["@TStorageDriveQty"]="0";edit=true;}// if (this.props.workload.UserInputs.Environments.Environment.find(solution => solution["@SolutionType"] === Constants.CAAS_)["@isSelected"] === Constants.yES_) {
//     x["@VMWare"] = Constants.tRUE_;
// }
if(x["@VMWare"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_210" /* tRUE_ */]){MasterVMWareCheckBox=true;}break;}});Gatewaylist=this.props.gatewaydetails;for(var key in Gatewaylist){GatewayHostlist.push(key);if(key===GatewayHostType){MaxDrives=Gatewaylist[key].MaxDrives;NVMEMaxDrives=Gatewaylist[key].MaxNVMeDrives;GatewayStrDrvList=Gatewaylist[key].DataDriveList;GatewayStrDrvList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(GatewayStrDrvList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);GatewayOSDriveList=Gatewaylist[key].OSDriveList;for(var proctype in Gatewaylist[GatewayHostType].ProcessorList){GatewayCPUFamilyList.push(proctype);}if(GatewayCPUFamilyList.indexOf(GatewayCPUFamilytype)===-1){GatewayCPUFamilytype=GatewayCPUFamilyList[0];this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@ProcFamily"]=GatewayCPUFamilytype;}for(var _proctype6 in Gatewaylist[GatewayHostType].ProcessorList){if(_proctype6===GatewayCPUFamilytype){for(var proc in Gatewaylist[GatewayHostType].ProcessorList[_proctype6]){GatewayCPUList.push(proc);}GatewayCPUList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(GatewayCPUList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_126" /* PROCESSOR_ */]);GatewayCPUtype=GatewayCPUList.indexOf(GatewayCPUtype)===-1?GatewayCPUList[0]:GatewayCPUtype;this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})["@Proc"]=GatewayCPUtype;for(var _proc6 in Gatewaylist[GatewayHostType].ProcessorList[_proctype6]){if(_proc6===GatewayCPUtype){GatewayMemoryList=Gatewaylist[GatewayHostType].ProcessorList[_proctype6][_proc6];}}}}if(GatewayCPUList.filter(function(processor){return processor.indexOf(GatewayCPUtype)>-1;}).length==0){GatewayCPUtype=GatewayCPUList[0];}else{GatewayCPUtype=GatewayCPUList.filter(function(processor){return processor.indexOf(GatewayCPUtype)>-1;})[0];}this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter(function(x){return x["@Type"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_29" /* GATEWAY_ */];})[0]["@Proc"]=GatewayCPUtype;GatewayMemoryList=Gatewaylist[GatewayHostType].ProcessorList[GatewayCPUFamilytype][GatewayCPUtype];GatewayMemoryList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(GatewayMemoryList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_96" /* MEMORY_ */]);}}Controllerlist=this.props.controllerdetails;for(var _key6 in Controllerlist){ControllerHostlist.push(_key6);if(_key6===ControllerHostType){ControllerMaxDrives=Controllerlist[_key6].MaxDrives,ControllerNVMEMaxDrives=Controllerlist[_key6].MaxNVMeDrives,ControllerStrDrvList=Controllerlist[_key6].DataDriveList;ControllerStrDrvList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(ControllerStrDrvList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);TenantStrDrvtypelist=Controllerlist[_key6].TenantDriveList;TenantStrDrvtypelist=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(TenantStrDrvtypelist,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);ControllerOSDriveList=Controllerlist[_key6].OSDriveList;for(var _proctype7 in Controllerlist[ControllerHostType].ProcessorList){ControllerCPUFamilyList.push(_proctype7);if(_proctype7===ControllerCPUFamilytype){for(var _proc7 in Controllerlist[ControllerHostType].ProcessorList[_proctype7]){ControllerCPUList.push(_proc7);if(_proc7===ControllerCPUtype){ControllerMemoryList=Controllerlist[ControllerHostType].ProcessorList[_proctype7][_proc7];}}}}ControllerCPUList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(ControllerCPUList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_126" /* PROCESSOR_ */]);if(ControllerCPUList.filter(function(processor){return processor.indexOf(ControllerCPUtype)>-1;}).length==0){ControllerCPUtype=ControllerCPUList[0];}else{ControllerCPUtype=ControllerCPUList.filter(function(processor){return processor.indexOf(ControllerCPUtype)>-1;})[0];}this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["F" /* CONTROLLER_ */];})["@Proc"]=ControllerCPUtype;ControllerMemoryList=Controllerlist[ControllerHostType].ProcessorList[ControllerCPUFamilytype][ControllerCPUtype];}}Masterlist=this.props.masterdetails;for(var _key7 in Masterlist){MasterHostlist.push(_key7);if(_key7===MasterHostType){MasterMaxDrives=Masterlist[_key7].MaxDrives,MasterNVMEMaxDrives=Masterlist[_key7].MaxNVMeDrives,MasterStrDrvList=Masterlist[_key7].DataDriveList;MasterStrDrvList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(MasterStrDrvList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);MasterTenantStrDrvtypelist=Masterlist[_key7].TenantDriveList;MasterTenantStrDrvtypelist=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(MasterTenantStrDrvtypelist,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_10" /* DISK_ */]);MasterOSDriveList=Masterlist[_key7].OSDriveList;for(var _proctype8 in Masterlist[MasterHostType].ProcessorList){MasterCPUFamilyList.push(_proctype8);if(_proctype8===MasterCPUFamilytype){for(var _proc8 in Masterlist[MasterHostType].ProcessorList[_proctype8]){MasterCPUList.push(_proc8);if(_proc8===MasterCPUtype){MasterMemoryList=Masterlist[MasterHostType].ProcessorList[_proctype8][_proc8];}}}}MasterCPUList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(MasterCPUList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_126" /* PROCESSOR_ */]);if(MasterCPUList.filter(function(processor){return processor.indexOf(MasterCPUtype)>-1;}).length==0){MasterCPUtype=MasterCPUList[0];}else{MasterCPUtype=MasterCPUList.filter(function(processor){return processor.indexOf(MasterCPUtype)>-1;})[0];}this.props.workload.UserInputs.Environments.ManagementHosts.Server.find(function(x){return x['@Type']===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_89" /* MASTER_ */];})["@Proc"]=MasterCPUtype;MasterMemoryList=Masterlist[MasterHostType].ProcessorList[MasterCPUFamilytype][MasterCPUtype];}}this.props.workload.UserInputs.Environments.ManagementHosts.Server.filter(function(x){switch(x["@Type"]){case"Gateway":if(GatewayMemoryList.indexOf(GatewayMemory)===-1&&GatewayMemoryList.length>0){GatewayMemory=GatewayMemoryList[0];x["@Memory"]=GatewayMemory;}if(GatewayStrDrvList.indexOf(GatewayStrDrvtype)===-1&&GatewayStrDrvList.length>0){GatewayStrDrvtype=GatewayStrDrvList[0];x['@NodeDisk']=GatewayStrDrvtype;}if(GatewayOSDriveList.indexOf(GatewayOSDrive)===-1&&GatewayOSDriveList.length>0){GatewayOSDrive=GatewayOSDriveList[0];x['@OSDisk']=GatewayOSDrive;}if(GatewayCPUList.indexOf(GatewayCPUtype)===-1&&GatewayCPUList.length>0){GatewayCPUtype=GatewayCPUList[0];x['@Proc']=GatewayCPUtype;}break;case"Controller":if(ControllerMemoryList&&ControllerMemoryList.indexOf(ControllerMemory)===-1&&ControllerMemoryList.length>0){ControllerMemory=ControllerMemoryList[0];x["@Memory"]=ControllerMemory;}if(ControllerStrDrvList.indexOf(ControllerStrDrvtype)===-1&&ControllerStrDrvList.length>0){ControllerStrDrvtype=ControllerStrDrvList[0];x["@NodeDisk"]=ControllerStrDrvtype;}if(TenantStrDrvtypelist.indexOf(TenantStrDrvtype)===-1&&TenantStrDrvtypelist.length>0){TenantStrDrvtype=TenantStrDrvtypelist[0];x["@TStorageDrive"]=TenantStrDrvtype;}if(ControllerOSDriveList.indexOf(ControllerOSDrive)===-1&&ControllerOSDriveList.length>0){ControllerOSDrive=ControllerOSDriveList[0];x["@OSDisk"]=ControllerOSDrive;}if(ControllerCPUList.indexOf(ControllerCPUtype)===-1&&ControllerCPUList.length>0){ControllerCPUtype=ControllerCPUList[0];x["@Proc"]=ControllerCPUtype;for(var _key8 in Controllerlist){if(_key8===ControllerHostType){for(var _proctype9 in Controllerlist[ControllerHostType].ProcessorList){if(_proctype9===ControllerCPUFamilytype){for(var _proc9 in Controllerlist[ControllerHostType].ProcessorList[_proctype9]){if(_proc9===ControllerCPUtype){ControllerMemoryList=Controllerlist[ControllerHostType].ProcessorList[_proctype9][_proc9];ControllerMemoryList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(ControllerMemoryList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_96" /* MEMORY_ */]);ControllerMemory=ControllerMemoryList[0];x["@Memory"]=ControllerMemory;}}}}}}}var nodeStorageDiskQty=parseInt(x["@StorageDiskQty"],10);if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1)){if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1){nodeStorageDiskQty=0;}}if(nodeStorageDiskQty+parseInt(x["@TStorageDriveQty"],10)+parseInt(x["@OSDiskQty"],10)>ControllerMaxDrives){if(x["@Name"].indexOf('m510')===-1){x["@StorageDiskQty"]="2";ControllerStrDrvCount="2";if(x["@TStorageDriveQty"]!==0){x["@TStorageDriveQty"]="2";TenantStrDrvQty="2";}}else{if(x["@TStorageDriveQty"]===0){x["@StorageDiskQty"]="2";ControllerStrDrvCount="2";}else{x["@StorageDiskQty"]="1";ControllerStrDrvCount="1";x["@TStorageDriveQty"]="1";TenantStrDrvQty="1";}}}break;case"Master":if(MasterMemoryList&&MasterMemoryList.indexOf(MasterMemory)===-1&&MasterMemoryList.length>0){MasterMemory=MasterMemoryList[0];x["@Memory"]=MasterMemory;}if(MasterStrDrvList.indexOf(MasterStrDrvtype)===-1&&MasterStrDrvList.length>0){MasterStrDrvtype=MasterStrDrvList[0];x["@NodeDisk"]=MasterStrDrvtype;}if(MasterTenantStrDrvtypelist.indexOf(MasterTenantStrDrvtype)===-1&&MasterTenantStrDrvtypelist.length>0){MasterTenantStrDrvtype=MasterTenantStrDrvtypelist[0];x["@TStorageDrive"]=MasterTenantStrDrvtype;}if(MasterOSDriveList.indexOf(MasterOSDrive)===-1&&MasterOSDriveList.length>0){MasterOSDrive=MasterOSDriveList[0];x["@OSDisk"]=MasterOSDrive;}if(MasterCPUList.indexOf(MasterCPUtype)===-1&&MasterCPUList.length>0){MasterCPUtype=MasterCPUList[0];x["@Proc"]=MasterCPUtype;for(var _key9 in Masterlist){if(_key9===MasterHostType){for(var _proctype10 in Masterlist[MasterHostType].ProcessorList){if(_proctype10===MasterCPUFamilytype){for(var _proc10 in Masterlist[MasterHostType].ProcessorList[_proctype10]){if(_proc10===MasterCPUtype){MasterMemoryList=Masterlist[MasterHostType].ProcessorList[_proctype10][_proc10];MasterMemoryList=Object(__WEBPACK_IMPORTED_MODULE_21__commonLogic_js__["c" /* filterOptions */])(MasterMemoryList,configurationType,__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_88" /* MANAGEMENT_HOSTS */],__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_96" /* MEMORY_ */]);MasterMemory=MasterMemoryList[0];x["@Memory"]=MasterMemory;}}}}}}}var nodeStorageDiskQty1=parseInt(x["@StorageDiskQty"],10);if(x["@Name"]===__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_55" /* HPE_APOLLO_4200_GEN10 */]&&(x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][1])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_157" /* SFF_DESCRIPTIONS */][0])>-1||x["@NodeDisk"].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_119" /* NVME_ */])>-1)){if(x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_101" /* MOONSHOT_510 */])===-1&&x["@Name"].indexOf(__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_14" /* E910 */])===-1){nodeStorageDiskQty1=0;}}if(nodeStorageDiskQty1+parseInt(x["@TStorageDriveQty"],10)+parseInt(x["@OSDiskQty"],10)>MasterMaxDrives){if(x["@Name"].indexOf('m510')===-1){x["@StorageDiskQty"]="2";MasterStrDrvCount="2";if(x["@TStorageDriveQty"]!==0){x["@TStorageDriveQty"]="2";TenantStrDrvQty="2";}}else{if(x["@TStorageDriveQty"]===0){x["@StorageDiskQty"]="2";MasterStrDrvCount="2";}else{x["@StorageDiskQty"]="1";MasterStrDrvCount="1";x["@TStorageDriveQty"]="1";TenantStrDrvQty="1";}}}}});}var Loadingdata='';if(this.props.isLoading){Loadingdata=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},'Please wait fetching OS Drives.')));}if(TenantStrDrvtype==="None"){TenantStrDrvtypelist=[];}if(MasterTenantStrDrvtype==="None"){MasterTenantStrDrvtypelist=[];}var HostChangedLayer='';if(HostChanged&&!this.props.isLoading){HostChanged=false;}var currentSelectedIndex=this.props.guiState.currentTabActiveIndex||0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'none',style:{position:'relative',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Warning__["a" /* default */],{message:__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_54" /* HPECP_WARNING_MESSAGE */],isEnabled:!this.props.displayWarning,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Article___default.a,{full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'95%'},justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_tooltip___default.a,{place:'right',multiline:true}),Loadingdata,warningText,HostChangedLayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Tabs___default.a,{justify:'start',onActive:function onActive(e){return _this2.handleTabChanges(e);},activeIndex:currentSelectedIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Tab___default.a,{title:'Gateway Hosts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px',marginBottom:'100px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},' Host type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select\xA0the\xA0server\xA0model\xA0to\xA0use\xA0as\xA0a\xA0Controller\xA0server.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:GatewayHostType,options:GatewayHostlist,onChange:function onChange(e){return _this2.GPUChange(e,"GatewayHostType");}})),GatewayCPUFamilytype==="NA"?"":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor family desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:GatewayCPUFamilytype,options:GatewayCPUFamilyList,onChange:function onChange(e){return _this2.GPUChange(e,"GatewayCPUFamilytype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor type based on the processor family requested.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:GatewayCPUtype,options:GatewayCPUList,onChange:function onChange(e){return _this2.GPUChange(e,"GatewayCPUtype");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the amount of memory desired per server. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'Compression',value:GatewayMemory,options:GatewayMemoryList,onChange:function onChange(e){return _this2.GPUChange(e,"GatewayMemory");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Storage Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the local storage drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:GatewayStrDrvtype,options:GatewayStrDrvList,onChange:function onChange(e){return _this2.GPUChange(e,"GatewayStrDrvtype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Storage Drive Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the number of drives desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:GatewayStrDrvCount,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"GatewayStrDrvCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"GatewayStrDrvCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'OS Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the operating system drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:GatewayOSDrive,options:GatewayOSDriveList,onChange:function onChange(e){return _this2.GPUChange(e,"GatewayOSDrive");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},' Host Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the number of gateway hosts desired. Selecting HA on the HPE Ezmeral Runtime Enterprise Workload Requirements screen will set the minimum gateway hosts to 2.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:GatewayCount,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"GatewayCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"GatewayCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_190" /* VMWARE */],checked:gatewayVMWareCheckBox,onChange:function onChange(){_this2.onGatewayVMWareCheckBoxChange();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Tab___default.a,{title:'Controller Hosts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the server model to use as a Controller server. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',options:ControllerHostlist,value:ControllerHostType,onChange:function onChange(e){return _this2.GPUChange(e,"ControllerHostType");}})),ControllerCPUFamilytype==="NA"?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor family desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:ControllerCPUFamilytype,options:ControllerCPUFamilyList,onChange:function onChange(e){return _this2.GPUChange(e,"ControllerCPUFamilytype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor type '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor type based on the processor family requested.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:ControllerCPUtype,options:ControllerCPUList,onChange:function onChange(e){return _this2.GPUChange(e,"ControllerCPUtype");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the amount of memory desired per server. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'Compression',value:ControllerMemory,options:ControllerMemoryList,onChange:function onChange(e){return _this2.GPUChange(e,"ControllerMemory");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Ephemeral Storage Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the Ephemeral storage drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:ControllerStrDrvtype,options:ControllerStrDrvList,onChange:function onChange(e){return _this2.GPUChange(e,"ControllerStrDrvtype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Ephemeral Storage Drive Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the number of drives desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:ControllerStrDrvCount,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"ControllerStrDrvCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"ControllerStrDrvCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'OS Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the operating system drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:ControllerOSDrive,options:ControllerOSDriveList,onChange:function onChange(e){return _this2.GPUChange(e,"ControllerOSDrive");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Persistent Storage Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the Persistent drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity'//options={TenantStrDrvtypelist} 
,value:TenantStrDrvtype,onChange:function onChange(e){return _this2.GPUChange(e,"TenantStrDrvtype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Persistent Drive Quantity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:TenantStrDrvQty,disabled:edit,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"TenantStrDrvCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"TenantStrDrvCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the number of controller hosts desired. Selecting HA on the HPE Ezmeral Runtime Enterprise Workload Requirements screen will set the minimum controller hosts to 3.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:ControllerCount,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"ControllerCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"ControllerCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_190" /* VMWARE */],checked:VMWareCheckBox,onChange:function onChange(){_this2.onVMWareCheckBoxChange();}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Tab___default.a,{title:'Master Hosts'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'all',style:{padding:'15px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host type'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the server model to use as a Controller server. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',options:MasterHostlist,value:MasterHostType,onChange:function onChange(e){return _this2.GPUChange(e,"MasterHostType");}})),MasterCPUFamilytype==="NA"?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor family'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor family desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:MasterCPUFamilytype,options:MasterCPUFamilyList,onChange:function onChange(e){return _this2.GPUChange(e,"MasterCPUFamilytype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Processor type '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the processor type based on the processor family requested.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:MasterCPUtype,options:MasterCPUList,onChange:function onChange(e){return _this2.GPUChange(e,"MasterCPUtype");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the amount of memory desired per server. ',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'Compression',value:MasterMemory,options:MasterMemoryList,onChange:function onChange(e){return _this2.GPUChange(e,"MasterMemory");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Ephemeral Storage Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the Ephemeral storage drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:MasterStrDrvtype,options:MasterStrDrvList,onChange:function onChange(e){return _this2.GPUChange(e,"MasterStrDrvtype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Ephemeral Storage Drive Quantity'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the number of drives desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:MasterStrDrvCount,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"MasterStrDrvCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"MasterStrDrvCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'OS Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the operating system drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity',value:MasterOSDrive,options:MasterOSDriveList,onChange:function onChange(e){return _this2.GPUChange(e,"MasterOSDrive");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Persistent Storage Drive'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the Persistent drive size desired.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{id:'DiskCapacity'//options={TenantStrDrvtypelist} 
,value:MasterTenantStrDrvtype,onChange:function onChange(e){return _this2.GPUChange(e,"MasterTenantStrDrvtype");}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:'Persistent Drive Quantity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:MasterTenantStrDrvQty,disabled:edit,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"MasterTenantStrDrvCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"MasterTenantStrDrvCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_tooltip___default.a,{place:'right',multiline:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_FormField___default.a,{className:'DiskCapacityDetails',label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{height:'25px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Paragraph___default.a,{className:'HardwareLicensesParagraph',style:{margin:"0px"}},'Host Count'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_CircleInformation___default.a,{'data-tip':'Select the number of controller hosts desired. Selecting HA on the HPE Ezmeral Runtime Enterprise Workload Requirements screen will set the minimum controller hosts to 3.',colorIndex:'accent-3',style:{width:"20px",height:"20px",marginBottom:'6px'}})),style:{width:'33%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{id:'DiskCapacity',value:MasterCount,onDOMChange:function onDOMChange(e){return _this2.GPUtextchange(e,"MasterCount","Change");},onBlur:function onBlur(e){return _this2.GPUtextchange(e,"ControllerCount","Blur");}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_CheckBox___default.a,{label:__WEBPACK_IMPORTED_MODULE_20__Redux_action_types_EPAConstants_js__["_190" /* VMWARE */],checked:MasterVMWareCheckBox,onChange:function onChange(){_this2.onMasterVMWareCheckBoxChange();}})))))));}}]);return DesignRequirements;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{workload:state.sizerWorkload.workload,activeSession:state.sessions.activeSession,gatewaydetails:state.sizerWorkload.Gatewaydetails,controllerdetails:state.sizerWorkload.Controllerdetails,masterdetails:state.sizerWorkload.Masterdetails,isLoading:state.sizerWorkload.isLoading,controllerconfigChanged:state.sizerWorkload.ControllerConfigChanged,ConfigButton:state.sizerWorkload.calbtn,changeGatewayServer:state.sizerWorkload.changeGateway,updateScreen:state.sizerWorkload.updateScreen,displayWarning:state.sizerWorkload.guiState.displayWarning,ServiceError:state.sizerWorkload,guiState:state.sizerWorkload.guiState};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__State_actions_sessions__["W" /* toggleSizeButton */])(value));},OnGatewaydltsfetch:function OnGatewaydltsfetch(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__["n" /* fetchgatewaydlts */])(value));},GetOSDiskList:function GetOSDiskList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__["s" /* getosdisklistBlueData */])(value));},ContrlChanged:function ContrlChanged(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__["e" /* controllerchnaged */])(value));},changeGateway:function changeGateway(value){dispatch({type:__WEBPACK_IMPORTED_MODULE_13__Redux_action_types_epaActionTypes__["e" /* CHANGE_GATEWAY */],payload:value});},getTenantStorageDriveList:function getTenantStorageDriveList(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__["p" /* getTenantStorageDiskList */])(value));},//      OnFetchDefaults:()=>{
//     dispatch(fetchDefaults());
//   },
ControllerRecommendations:function ControllerRecommendations(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__["b" /* GetControllerRecommendations */])(value));},MasterRecommendations:function MasterRecommendations(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_12__Redux_actions_epaActions__["d" /* GetMasterRecommendations */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(DesignRequirements));

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Article__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonLogic__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Warning__ = __webpack_require__(98);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Growth=function(_Component){_inherits(Growth,_Component);function Growth(){_classCallCheck(this,Growth);var _this=_possibleConstructorReturn(this,(Growth.__proto__||Object.getPrototypeOf(Growth)).call(this));_this.removeObject=function(itemToRemove,isService){var rest=void 0;isService?rest=_this.props.workload.UserInputs.Environments['Growth'].Service.filter(function(item){return item['@Service']!==itemToRemove;}):rest=_this.props.workload.UserInputs.Environments['Growth'].Service.filter(function(item){return item['@Name']!==itemToRemove;});_this.props.workload.UserInputs.Environments['Growth'].Service=rest;};_this.updateObject=function(getObject,functionName,service,nodesCount){if(!getObject){var item={};if(_this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]){item['@Name']=functionName;item['@Service']=service;item['@GrowthType']='Nodes';item['@GrowthRate']='0';item['@Nodes1Y']=nodesCount;item['@Nodes2Y']="";item['@Nodes3Y']="";_this.props.workload.UserInputs.Environments['Growth'].Service.push(Object.assign({},item));}else{item["@GrowthRate"]="0";item["@Nodes1Y"]=nodesCount;item["@Nodes2Y"]="-";item["@Nodes3Y"]="-";item["@Nodes4Y"]="-";item["@RoleName"]=service;item["@SolutionType"]=functionName;_this.props.workload.UserInputs.Environments.Growth.Host.push(Object.assign({},item));}}else{if(getObject['@Nodes1Y']!==nodesCount){getObject['@Nodes1Y']=nodesCount.toString();Object(__WEBPACK_IMPORTED_MODULE_10__commonLogic__["h" /* updateCalculations */])(getObject,_this.props.workload);}}};_this.createRow=function(filteredItem){//(isNaN(this.props.defaultSizerWorkload.GatewayQty) || this.props.defaultSizerWorkload.GatewayQty === null)
var filteredItemType=void 0;if(_this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]){if(!(filteredItem["@Name"]==__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_31" /* GATEWAY_NODE */]&&isNaN(_this.props.workload.UserInputs.Environments.Functions.Function.find(function(service){return service["@Type"]===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_31" /* GATEWAY_NODE */];}).Service.Hardware["@NodesCount"]))){filteredItemType=filteredItem["@Service"]?filteredItem["@Service"]:filteredItem["@Name"];}}else{filteredItemType=filteredItem["@RoleName"]?filteredItem["@SolutionType"]+'-'+filteredItem["@RoleName"]:filteredItem["@SolutionType"];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,filteredItemType),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TextInput___default.a,{style:{width:'38%'},id:'item1',value:filteredItem["@GrowthRate"],onDOMChange:function onDOMChange(e){return _this.OnvalueChange(e,filteredItem["@Name"],filteredItemType,"Change");},onBlur:function onBlur(e){return _this.OnvalueChange(e,filteredItem["@Name"],filteredItemType,"Blur");}})),_this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_CheckBox___default.a,{checked:filteredItem["@GrowthType"]==="Percentage"?true:false,onChange:function onChange(e){_this.ChkboxChange(filteredItem["@Name"],filteredItemType,e.target.checked);}})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes1Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes2Y"])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes3Y"])),_this.props.workload.UserInputs.Environments.WorkloadType==="BlueData"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Label___default.a,{style:{marginLeft:'30%'}},filteredItem["@Nodes4Y"])):'');};_this.updateNode2yrNode3yr=function(){var hyphen="-";var servicewithNonZeroGrowth=void 0;if(_this.props.workload.UserInputs.Environments.WorkloadType==="BigData"){servicewithNonZeroGrowth=_this.props.workload.UserInputs.Environments['Growth'].Service.find(function(service){return service["@GrowthRate"]!="0";});}else{if(Array.isArray(_this.props.workload.UserInputs.Environments['Growth'].Host)){servicewithNonZeroGrowth=_this.props.workload.UserInputs.Environments['Growth'].Host.find(function(service){return service["@GrowthRate"]!="0";});}else{servicewithNonZeroGrowth=_this.props.workload.UserInputs.Environments['Growth'].Host["@GrowthRate"]!="0";}}if(servicewithNonZeroGrowth){if(_this.props.workload.UserInputs.Environments.WorkloadType==="BigData"){_this.props.workload.UserInputs.Environments['Growth'].Service.map(function(service){if(service["@GrowthRate"]=="0"){service["@Nodes2Y"]=service["@Nodes1Y"];service["@Nodes3Y"]=service["@Nodes1Y"];}});}else{if(Array.isArray(_this.props.workload.UserInputs.Environments['Growth'].Host)){_this.props.workload.UserInputs.Environments['Growth'].Host.map(function(service){if(service["@GrowthRate"]=="0"){service["@Nodes2Y"]=service["@Nodes1Y"];service["@Nodes3Y"]=service["@Nodes1Y"];service["@Nodes4Y"]=service["@Nodes1Y"];}});}else{var service=_this.props.workload.UserInputs.Environments['Growth'].Host;if(service["@GrowthRate"]=="0"){service["@Nodes2Y"]=service["@Nodes1Y"];service["@Nodes3Y"]=service["@Nodes1Y"];service["@Nodes4Y"]=service["@Nodes1Y"];}}}}else{if(_this.props.workload.UserInputs.Environments.WorkloadType==="BigData"){_this.props.workload.UserInputs.Environments['Growth'].Service.map(function(service){service["@Nodes2Y"]=hyphen;service["@Nodes3Y"]=hyphen;});}else{if(Array.isArray(_this.props.workload.UserInputs.Environments['Growth'].Host)){_this.props.workload.UserInputs.Environments['Growth'].Host.map(function(service){service["@Nodes2Y"]=hyphen;service["@Nodes3Y"]=hyphen;service["@Nodes4Y"]=hyphen;});}else{var _service=_this.props.workload.UserInputs.Environments['Growth'].Host;_service["@Nodes2Y"]=hyphen;_service["@Nodes3Y"]=hyphen;_service["@Nodes4Y"]=hyphen;}}}};_this.state={DisplayNote:true};return _this;}_createClass(Growth,[{key:'componentDidUpdate',value:function componentDidUpdate(previousProps){if(this.props.defaultSizerWorkload.GatewayQty!==previousProps.defaultSizerWorkload.GatewayQty){!isNaN(this.props.defaultSizerWorkload.GatewayQty)?this.state.DisplayNote=false:this.state.DisplayNote=true;this.setState({});}}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(this.props.workload.UserInputs.Environments.Growth===undefined){this.props.workload.UserInputs.Environments['Growth']=this.props.defaultWorkload.UserInputs.Environments.Growth;}var getObject=void 0;var nodesCount=void 0;Object(__WEBPACK_IMPORTED_MODULE_10__commonLogic__["a" /* cleanupGrowth */])(this.props.workload);if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]){this.props.workload.UserInputs.Environments.Functions.Function.forEach(function(x){if(Array.isArray(x.Service)){x.Service.filter(function(elem){return elem["@Selected"]=="true";}).forEach(function(filteredItem){getObject=_this2.props.workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Service']===filteredItem['@Type'];});nodesCount=filteredItem.Hardware["@NodesCount"];_this2.updateObject(getObject,x["@Type"],filteredItem["@Type"],nodesCount);});}else{if(x.Service["@Selected"]=="true"&&x["@Type"]!=="Gateway Node"&&x["@Type"]!=="Master Node"){getObject=_this2.props.workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Service']===x.Service['@Type'];});nodesCount=x.Service.Hardware["@NodesCount"];_this2.updateObject(getObject,x["@Type"],x.Service['@Type'],nodesCount);}else if(x.Service["@Selected"]==="true"&&x["@Type"]==="Master Node"){getObject=_this2.props.workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Name']===x['@Type'];});nodesCount=x.Service.Hardware["@NodesCount"];_this2.updateObject(getObject,x["@Type"],"",nodesCount);}else if(x.Service["@Selected"]==="true"&&x["@Type"]==="Gateway Node"&&isNaN(x.Service.Hardware["@NodesCount"])){_this2.state.DisplayNote=true;}else if(x.Service["@Selected"]==="true"&&x["@Type"]==="Gateway Node"&&!isNaN(x.Service.Hardware["@NodesCount"])){getObject=_this2.props.workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Name']===x['@Type'];});nodesCount=x.Service.Hardware["@NodesCount"];_this2.state.DisplayNote=false;_this2.updateObject(getObject,x["@Type"],"",nodesCount);}}});}else{this.props.workload.UserInputs.Environments.Environment.filter(function(solution){return solution["@isSelected"]===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_212" /* yES_ */];}).map(function(selectedSolution){selectedSolution.Templates.ServerDetails.Server.map(function(role){if(role["@NodesCount"]!=="0"){getObject=_this2.props.workload.UserInputs.Environments.Growth.Host.find(function(serviceRole){return serviceRole["@SolutionType"]===selectedSolution["@SolutionType"]&&serviceRole["@RoleName"]===role["@RoleName"];});nodesCount=role["@NodesCount"];_this2.updateObject(getObject,selectedSolution["@SolutionType"],role["@RoleName"],nodesCount);}});});if(Object(__WEBPACK_IMPORTED_MODULE_10__commonLogic__["k" /* updateFinishButton */])(this.props.workload,this.props.displayWarning,this.props.activeSession.isSizeEnabled)){this.props.OnToggleSizeButton(true);}}this.setState({});}},{key:'OnvalueChange',value:function OnvalueChange(e,functionName,serviceName,changeType){var itemToUpdate=void 0;var maxValue=void 0;if(changeType==="Blur"){if(e.target.value===""){e.target.value="0";}}if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["o" /* BIG_DATA */]){itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Service.find(function(item){return item["@Service"]===serviceName;});if(!itemToUpdate){itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Service.find(function(item){return item["@Name"]===functionName;});}maxValue=itemToUpdate["@GrowthType"]==="Percentage"?500:99;if(!isNaN(parseInt(e.target.value,10))&&parseInt(e.target.value,10)<=maxValue){itemToUpdate["@GrowthRate"]=parseInt(e.target.value,10);Object(__WEBPACK_IMPORTED_MODULE_10__commonLogic__["h" /* updateCalculations */])(itemToUpdate,this.props.workload);}else{if(e.target.value==""){itemToUpdate["@GrowthRate"]="";}}}else{maxValue=100;if(serviceName===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["G" /* CONTROLLER_HOST */]||serviceName===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_30" /* GATEWAY_HOST */]){itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Host.find(function(item){return item["@SolutionType"]===serviceName;});if(!itemToUpdate){itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Host.find(function(item){return item["@SolutionType"]===serviceName;});}}else{itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Host.find(function(item){return item["@SolutionType"]+'-'+item["@RoleName"]===serviceName;});if(!itemToUpdate){itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Host.find(function(item){return item["@SolutionType"]+'-'+item["@RoleName"]===serviceName;});}}}if(!isNaN(parseInt(e.target.value,10))&&parseInt(e.target.value,10)<=maxValue){itemToUpdate["@GrowthRate"]=e.target.value;Object(__WEBPACK_IMPORTED_MODULE_10__commonLogic__["h" /* updateCalculations */])(itemToUpdate,this.props.workload);}else{if(e.target.value==""){itemToUpdate["@GrowthRate"]="";}}this.setState({});}},{key:'ChkboxChange',value:function ChkboxChange(functionName,serviceName,change){var itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Service.find(function(item){return item["@Service"]===serviceName;});if(!itemToUpdate){itemToUpdate=this.props.workload.UserInputs.Environments.Growth.Service.find(function(item){return item["@Name"]===functionName;});}itemToUpdate["@GrowthType"]=change?"Percentage":"Nodes";if(itemToUpdate["@GrowthRate"]===500&&itemToUpdate["@GrowthType"]!=="Percentage"){itemToUpdate["@GrowthRate"]=99;}Object(__WEBPACK_IMPORTED_MODULE_10__commonLogic__["h" /* updateCalculations */])(itemToUpdate,this.props.workload);this.setState({});}},{key:'render',value:function render(){var _this3=this;var note='';var headings=__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_17" /* EPA_GROWTH_HEADINGS */];if(this.state.DisplayNote&&this.props.workload.UserInputs.Environments.WorkloadType==="BigData"){note=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Paragraph___default.a,null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note : '),'  Gateway Node will be added as "',this.props.workload.UserInputs.Environments.Functions.Function.find(function(service){return service["@Type"]===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_31" /* GATEWAY_NODE */];}).Service.Hardware["@NodesCount"],'" for 2nd and 3rd Year Growth solutions. ');}else{note='';if(this.props.workload.UserInputs.Environments.WorkloadType===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["s" /* BLUE_DATA */]){headings=__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_24" /* EZMERAL_GROWTH_HEADINGS */];}}var LoadindData='';if(this.props.defaultSizerWorkload.isLoading){LoadindData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning___default.a,{className:'Spinning',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},'Loading... Please Wait')));}var getObj;var nodecount;if(this.props.workload.UserInputs.Environments.WorkloadType==="BigData"&&this.props.workload.UserInputs.Environments['Growth']){this.props.workload.UserInputs.Environments.Functions.Function.forEach(function(x){if(!Array.isArray(x.Service)&&x.Service["@Selected"]==="true"&&x["@Type"]==="Gateway Node"&&!isNaN(_this3.props.workload.UserInputs.Environments.Functions.Function.find(function(service){return service["@Type"]===__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_31" /* GATEWAY_NODE */];}).Service.Hardware["@NodesCount"])){getObj=_this3.props.workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Name']===x['@Type'];});nodecount=x.Service.Hardware["@NodesCount"];_this3.state.DisplayNote=false;_this3.updateObject(getObj,x["@Type"],"",nodecount);}else if(x.Service["@Selected"]==="true"&&x["@Type"]==="Gateway Node"&&isNaN(x.Service.Hardware["@NodesCount"])){getObj=_this3.props.workload.UserInputs.Environments['Growth'].Service.find(function(item){return item['@Name']===x['@Type'];});if(getObj){_this3.removeObject(getObj['@Name'],false);}}});}var content=void 0;this.updateNode2yrNode3yr();if(this.props.workload.UserInputs.Environments.WorkloadType==="BigData"){content=this.props.workload.UserInputs.Environments.Growth&&this.props.workload.UserInputs.Environments.Growth.Service.map(function(x){return _this3.createRow(x);});}if(this.props.workload.UserInputs.Environments.WorkloadType==="BlueData"){if(this.props.workload.UserInputs.Environments.Growth){if(Array.isArray(this.props.workload.UserInputs.Environments.Growth.Host)){content=this.props.workload.UserInputs.Environments.Growth.Host.map(function(x){if(x["@SolutionType"]!==__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_30" /* GATEWAY_HOST */]&&x['@SolutionType']!==__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["G" /* CONTROLLER_HOST */]&&x["@RoleName"]!==''&&x["@SolutionType"]!==''){return _this3.createRow(x);}});}else{content=this.createRow(this.props.workload.UserInputs.Environments.Growth.Host);}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{pad:'small',margin:'none',style:{position:'relative',width:'100%'}},LoadindData,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Article___default.a,{id:'scroll',full:true,margin:'none',pad:{between:'small'},style:{maxHeight:'95%'},justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'GrowthTable',margin:'none',pad:{between:'small'},style:{marginRight:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Warning__["a" /* default */],{message:__WEBPACK_IMPORTED_MODULE_12__Redux_action_types_EPAConstants_js__["_54" /* HPECP_WARNING_MESSAGE */],isEnabled:!this.props.displayWarning,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,headings.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{fontWeight:'600'}},item);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,content)),note))));}}]);return Growth;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__State_actions_sessions__["W" /* toggleSizeButton */])(value));}};};var mapStateToProps=function mapStateToProps(state){return{workload:state.sizerWorkload.workload,activeSession:state.sessions.activeSession,defaultWorkload:state.sessions.sessionDefaults.workload,defaultSizerWorkload:state.sizerWorkload,ConfigButton:state.sizerWorkload.calbtn,displayWarning:state.sizerWorkload.guiState.displayWarning};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Growth));

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notifications=function(_Component){_inherits(Notifications,_Component);function Notifications(){_classCallCheck(this,Notifications);var _this=_possibleConstructorReturn(this,(Notifications.__proto__||Object.getPrototypeOf(Notifications)).call(this));_this.getText=_this.getText.bind(_this);_this.accept=_this.accept.bind(_this);return _this;}_createClass(Notifications,[{key:'reject',value:function reject(id){var accptedUser=this.props.data.filter(function(item){if(item.SourceID===id)return item;});this.props.onRejectwlsl(accptedUser[0].ID);}},{key:'accept',value:function accept(id){var accptedUser=this.props.data.filter(function(item){if(item.SourceID===id)return item;});this.props.onAcceptwlsl(accptedUser[0].ID);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(this.props.data!==nextProps.data||this.responseMsg!==nextProps.responseMsg){this.setState({});}}},{key:'getText',value:function getText(id){var text=id+' wants to share ';var workloads=this.props.data.filter(function(item){if(item.SourceID===id&&item.SubType=='Workload'){return item;}});var solutions=this.props.data.filter(function(item){if(item.SourceID===id&&item.SubType=='Solution'){return item;}});if(workloads.length==1){text+='a workload ';}else if(workloads.length>1){text+='workloads ';}if(workloads.length>0&&solutions.length>0){text+='and ';}if(solutions.length==1){text+='a solution ';}else if(solutions.length>1){text+='solutions ';}return text+'with you.  Do you want to allow?';}},{key:'render',value:function render(){var _this2=this;var allIds=[];this.props.data.map(function(item){if(allIds.indexOf(item.SourceID)===-1){allIds.push(item.SourceID);}});var notificatinos=allIds.map(function(item){var textContent=_this2.getText(item);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'small',pad:'small',colorIndex:'light-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default.a,{tag:'h5',strong:true},textContent),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{alignSelf:"flex-end"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default.a,{label:'Accept',style:{color:'#01a982'},plain:true,onClick:function onClick(e){return _this2.accept(item);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default.a,{critical:true,plain:true,label:'Reject',style:{color:'#f04953'},onClick:function onClick(e){_this2.reject(item);}})));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Notifications')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle',onClick:this.props.close}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,notificatinos.length>0?notificatinos:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default.a,{size:'medium'},'You do not have any notifications.'))));}}]);return Notifications;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{data:state.sessions.notifications,responseMsg:state.sessions.responseMsg};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onAcceptwlsl:function onAcceptwlsl(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__State_actions_sessions__["d" /* acceptwlsl */])(data));},onRejectwlsl:function onRejectwlsl(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__State_actions_sessions__["M" /* rejectwlsl */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Notifications));

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import latestWhatsNew from '../../Datafiles/latestWhatsNew';
//import latestWhatsNew from '../../Datafiles/WhatsNewEPA';
var WhatsNewComponent=function(_Component){_inherits(WhatsNewComponent,_Component);function WhatsNewComponent(props){_classCallCheck(this,WhatsNewComponent);var _this=_possibleConstructorReturn(this,(WhatsNewComponent.__proto__||Object.getPrototypeOf(WhatsNewComponent)).call(this,props));_this.getReleaseItems=function(items){var itemarray=[];items.map(function(x){if((typeof x==='undefined'?'undefined':_typeof(x))!=="object"){itemarray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem___default.a,{justify:'between',separator:'none',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{margin:'none',pad:'none'},' ',x,' '))));}else{var heading=x["@heading"];var objectArray=[];if(Array.isArray(x.SubItem)){x.SubItem.map(function(subvalue){objectArray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem___default.a,{justify:'between',separator:'none',style:{padding:'0px',marginLeft:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{style:{maxWidth:'100%'},margin:'none',pad:'none'},' ',subvalue,' ')));});}else{objectArray=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem___default.a,{justify:'between',separator:'none',style:{padding:'0px',marginLeft:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{margin:'none',pad:'none'},' ',x.SubItem,' '));}console.log(objectArray);itemarray.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{justify:'between',separator:'none',style:{padding:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{marginLeft:'0px',marginBottom:'0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h5',strong:false,style:{margin:'4px 0px'}},' ',heading)),objectArray));}});return itemarray;};_this.state={WhatsnewJson:''};_this.closePopUps=_this.closePopUps.bind(_this);return _this;}_createClass(WhatsNewComponent,[{key:'closePopUps',value:function closePopUps(e){this.props.click();}},{key:'render',value:function render(){var _this2=this;var content='';//let itemarray = [];
var whatsNewHeight='';if(__WEBPACK_IMPORTED_MODULE_7__AppConfig__["f" /* said */]!=='SAPHANA'){whatsNewHeight='500px';}var allItems=[];var whatsNewObject=this.props.WhatsNewContent;if(__WEBPACK_IMPORTED_MODULE_7__AppConfig__["a" /* appUrl */].toUpperCase().indexOf('EZMERALCPSIZER')!==-1){whatsNewObject=this.props.WhatsNewContentHPECP;}if(whatsNewObject!==undefined&&whatsNewObject!==''){this.state.WhatsnewJson=whatsNewObject;if(Array.isArray(this.state.WhatsnewJson.Screen.ItemList)){allItems=this.state.WhatsnewJson.Screen.ItemList;}else{allItems.push(this.state.WhatsnewJson.Screen.ItemList);}content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',direction:'column',className:'WhatsNewContent',style:{width:'45%',height:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{backgroundColor:'#fff',borderBottom:'3px solid #01a982',height:whatsNewHeight},className:'ListItemAlign1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',separator:'bottom',style:{backgroundColor:'rgb(66, 85, 99)',color:'white'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},this.props.DefaultInputs.SizerCaption)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close___default.a,{className:'CloseIconStyle',size:'small',style:{stroke:'#fff'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{pad:'none',align:'start',style:{margin:'2px 12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{margin:'none',pad:'none'},'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h5',strong:false,style:{marginBottom:'0px'}},this.state.WhatsnewJson.Screen.Intro),' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{margin:'12px'}},allItems.map(function(releaseItem){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{margin:'none',pad:'none',style:{fontWeight:'510'}},'     ',releaseItem['@heading']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_List___default.a,{style:{overflow:'initial'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{style:{marginLeft:'20px',padding:'0px'}},_this2.getReleaseItems(releaseItem.Item))));})))));// }else{
//     content = '';
}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none'},content,'   ');}}]);return WhatsNewComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession,DefaultInputs:state.sessions.sessionDefaults.inputs.Sizers,WhatsNewContent:state.sessions.sessionDefaults.whatsNew,WhatsNewContentHPECP:state.sessions.sessionDefaults.whatsNewHPECP};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(WhatsNewComponent));

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_CheckBox__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_CheckBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_CheckBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { said,landingUrl,basename } from '../../AppConfig';
var SSO='SSO';var PASSPORT='HPE Passport';var UserDetailsComponent=function(_Component){_inherits(UserDetailsComponent,_Component);function UserDetailsComponent(props){_classCallCheck(this,UserDetailsComponent);var _this=_possibleConstructorReturn(this,(UserDetailsComponent.__proto__||Object.getPrototypeOf(UserDetailsComponent)).call(this,props));_this.getUserType=function(){return _this.props.auth.ssoUser?SSO:PASSPORT;};_this.onPrefenceChanged=function(){var inputs={userId:_this.props.userDetails.email,authChannel:_this.getUserType(),EmailNotification:!_this.props.auth.userSettings.emailNotification};_this.props.onUpdatePreference(inputs);};_this.state={userDetails:''};_this.closePopUps=_this.closePopUps.bind(_this);_this.deleteUser=_this.deleteUser.bind(_this);return _this;}_createClass(UserDetailsComponent,[{key:'closePopUps',value:function closePopUps(e){this.props.click();}},{key:'deleteUser',value:function deleteUser(){var input={"emailId":this.props.auth.userData.email,"uniqueId":this.props.auth.userData.uniqueId,"userId":this.props.auth.userData.hpclname};this.setState({showDeleteWarning:false});this.props.ondeleteUserData(input);}},{key:'renderConfirmationBox',value:function renderConfirmationBox(){var _this2=this;//let redirectUrl = 'https://cf.passport.hpe.com/hppcf/login.do?hpappid=' + landingUrl + '&applandingpage=https%3A%2F%2F'+redirection_Link+'%2F' + basename.replace('/', '');
if(this.state.showLogoutWarning!==true){return undefined;}var message='Logout action will close the existing session. If want to save your changes click cancel button. Click Ok to Logout';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Alert___default.a,{colorIndex:'warning',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Logout Confirmation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{margin:'small'},message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Ok',id:'logOutYes',onClick:function onClick(){if(_this2.props.auth.ssoUser){localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["d" /* logOutAttribute */],"true");window.location.reload();}else{_this2.props.onLogOut();}//window.location.href = redirectUrl;
}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{size:'small',label:'Cancel',onClick:function onClick(){_this2.setState({showLogoutWarning:false});}})))));}},{key:'renderunSubscribeWarning',value:function renderunSubscribeWarning(){var _this3=this;if(this.state.showDeleteWarning!==true){return undefined;}var message='All your data will be lost from the Sizers Database.  Would you like to continue?';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_base_Alert___default.a,{colorIndex:'warning',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Delete Confirmation'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Paragraph___default.a,{margin:'small'},message)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Ok',id:'logOutYes',onClick:function onClick(){_this3.deleteUser();if(_this3.props.auth.ssoUser){localStorage.setItem(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["d" /* logOutAttribute */],"true");window.location.reload();}else{_this3.props.onLogOut();}}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{size:'small',label:'Cancel',onClick:function onClick(){_this3.setState({showDeleteWarning:false});}})))));}},{key:'componentDidMount',value:function componentDidMount(){var queryString='?userId='+this.props.userDetails.email+'&authChannel='+this.getUserType();this.props.onFetchPreferences(queryString);}},{key:'render',value:function render(){var _this4=this;var content='';if(this.props.userDetails!==undefined&&this.props.userDetails!==null){this.state.userDetails=this.props.userDetails;content="";content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',direction:'column',className:'UserDetailsContent',style:{width:'25%',height:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',className:'triangle-up',style:{margin:'auto 88%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{backgroundColor:'#fff',borderBottom:'3px solid #01a982'},className:'ListItemAlign1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',separator:'bottom',style:{backgroundColor:'rgb(66, 85, 99)',color:'white'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'User Details')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Close___default.a,{size:'small',className:'CloseIconStyle',style:{stroke:'#fff'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h3',padding:'none',margin:'none',style:{fontSize:'20px'}},this.props.userDetails.username+' '+this.props.userDetails.lastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h5',padding:'none'},this.props.userDetails.email)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{display:'flex',flexDirection:'row'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_CheckBox___default.a,{label:'Email Notification',disabled:this.props.auth.userSettings.isLoading,toggle:true,reverse:true,checked:this.props.auth.userSettings.emailNotification,onChange:this.onPrefenceChanged}),this.props.auth.userSettings.isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_Spinning___default.a,{style:{marginLeft:'30px'}}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',style:{display:'flex',justifyContent:'flex-end',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{className:'Userdetailsbox',label:'Logout',plain:true,onClick:function onClick(){_this4.setState({showLogoutWarning:true});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{className:'Userdetailsbox',pad:'none',margin:'none',label:'Unsubscribe here',plain:true,onClick:function onClick(){_this4.setState({showDeleteWarning:true});}}))));}else{content='';}var warning=this.renderConfirmationBox();var unSubscribeWarning=this.renderunSubscribeWarning();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none'},content,warning,unSubscribeWarning);}}]);return UserDetailsComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession,DefaultInputs:state.sessions.sessionDefaults.inputs.Sizers,WhatsNewContent:state.sessions.sessionDefaults.whatsNew,auth:state.auth};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRedirectPage:function onRedirectPage(isTrue,path){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__State_actions_sessions__["J" /* redirectPage */])(isTrue,path));},ondeleteUserData:function ondeleteUserData(inputs){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__State_actions_sessions__["l" /* deleteUserData */])(inputs));},onFetchPreferences:function onFetchPreferences(inputs){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__State_actions_sessions__["B" /* fetchSettings */])(inputs));},onUpdatePreference:function onUpdatePreference(inputs){dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__State_actions_sessions__["_0" /* updateSettings */])(inputs));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(UserDetailsComponent));

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(588);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(246)),valueEqual=_interopDefault(__webpack_require__(247));__webpack_require__(95);var invariant=_interopDefault(__webpack_require__(121));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//function CreateGuid() {  
//   function _p8(s) {  
//      var p = (Math.random().toString(16)+"000000000").substr(2,8);  
//      return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p ;  
//   }  
//   return _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase() + _p8().toUpperCase();  
//}
var AdditionalReferenceComponent=function(_Component){_inherits(AdditionalReferenceComponent,_Component);function AdditionalReferenceComponent(props){_classCallCheck(this,AdditionalReferenceComponent);var _this=_possibleConstructorReturn(this,(AdditionalReferenceComponent.__proto__||Object.getPrototypeOf(AdditionalReferenceComponent)).call(this,props));_this.state={WhatsnewJson:''};_this.closePopUps=_this.closePopUps.bind(_this);_this.callRAContent=_this.callRAContent.bind(_this);return _this;}_createClass(AdditionalReferenceComponent,[{key:'closePopUps',value:function closePopUps(e){this.props.click();}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){// RABOM
if(nextProps.activeSession.id!=""){if(nextProps.activeSession.id!==this.props.activeSession.id){if(nextProps.activeSession.treeView!==''){var obj="";obj=nextProps.activeSession.workload;this.props.onNewSession(obj);this.props.redirectTo('/Build/SolnAlternative');// this.props.history.push('/Build/SolnAlternative');
}else{// var obj ="";              
// obj = nextProps.activeSession.workload;                
// this.props.onNewSession(obj);          
// this.props.redirectTo(interviewScreens[0].path);
// this.props.history.push('/Build/ContactInfo');
}}if(nextProps.referenceArchitectBOM!==this.props.referenceArchitectBOM){// nextProps.referenceArchitectBOM
var newWindow=window.open();newWindow.document.write(nextProps.referenceArchitectBOM);}}}},{key:'callRAContent',value:function callRAContent(obj){this.props.onRAClick(obj);}},{key:'render',value:function render(){var _this2=this;var RefArchList=void 0;if(this.props.referenceArchitect!==undefined&&this.props.referenceArchitect!==''){RefArchList=this.props.referenceArchitect.Doc.map(function(val,id){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_TableRow___default.a,{key:id.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Anchor___default.a,{style:{cursor:'pointer'},onClick:function onClick(){return window.open(decodeURIComponent(val["Url"]));}},' ',val["Name"],' '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Anchor___default.a,{primary:true,onClick:function onClick(){_this2.props.onRAClick({"UserId":"Madhukar","Architecture":val["Name"],"Option":"Solution"});}},' Customize this RA Solution '),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Anchor___default.a,{primary:true,onClick:function onClick(){_this2.props.onRAClick({"UserId":"Madhukar","Architecture":val["Name"],"Option":"BOM"});},target:'_blank'},' BOM (Bill of Material) '),' '));});}var content='';if(this.props.referenceArchitect!==undefined&&this.props.referenceArchitect!==''){content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default.a,{className:'ReferececeArchitcture',style:{width:'50%',height:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Reference Architecture')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_FormClose___default.a,{colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{margin:'4px 0px'}},'Learn More'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px',maxWidth:'100%'}},this.props.referenceArchitect["@Text"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Table___default.a,{style:{margin:'4px 0px',overflow:'initial'},selectable:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,RefArchList)))));}else{content='';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none'},content,'   ');}}]);return AdditionalReferenceComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession,DefaultInputs:state.sessions.sessionDefaults.inputs.Sizers.Sizer,referenceArchitect:state.sessions.sessionDefaults.inputs.Sizers.Sizer.ReferenceArchitecture,referenceArchitectBOM:state.sessions.RABOM};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onRAClick:function onRAClick(data){if(data["Option"]==="BOM"){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["K" /* refArchBOM */])(data));}else if(data["Option"]==="Solution"){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["L" /* refArchSession */])(data));}},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AdditionalReferenceComponent));

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppConfig_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import { refArchSession, refArchBOM } from '../../State/actions/sessions';
var HPE_CP_='HPE Ezmeral Runtime Enterprise';var Doc=[{Name:"HPE Reference Architecture for real-time streaming analytics with HPE Elastic Platform for Analytics (EPA) and MapR Data Platform (MapR)",Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00066812enw"},{Name:"HPE Reference Architecture for Apache Spark 2.1 on HPE Elastic Platform for Big Data Analytics (EPA)",Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00041363enw"},{Name:"HPE Reference Architecture for running analytics and data science workloads on BlueData EPIC platform",Url:"http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00077915enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for delivering a Self-Service Experience: Running Analytics, Data Science and AI/ML workloads on the BlueData EPIC Platform",Url:"http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00072257enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for enabling GPU-as-a-Service for Enterprise AI deployments with BlueData",Url:"http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00078919enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for "+__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_69" /* HPE_E_CPDESC */]+" on HPE Edgeline Converged Edge Systems",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001287enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for Red Hat OpenShift Container Platform 4 on HPE Synergy",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001254enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for "+__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_69" /* HPE_E_CPDESC */]+" on HPE Apollo Gen10 Servers",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001145enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for "+__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_69" /* HPE_E_CPDESC */]+" on HPE Synergy",Url:"http://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a50001072enw",workloadType:__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]},{Name:"HPE Reference Configuration for HPE AI Data Node",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00065979enw"},{Name:"HPE Reference Configuration for Elastic Platform for Big Data Analytics (EPA)",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-8931ENW"},{Name:"HPE Reference Configuration for MapR on HPE Elastic Platform for Big Data Analytics (EPA)",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00048919enw"},{Name:"HPE Reference Configuration for Hortonworks Data Platform on HPE Elastic Platform for Big Data Analytics (EPA)",Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00043453enw"},{Name:"HPE Reference Configuration for Fast Data Analytics on Mesosphere DC/OS",Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00036351enw"},{Name:"HPE Reference Configuration for MapR on HPE Apollo 4200",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00055864enw"},{Name:"HPE Reference Architecture for AI on HPE Elastic Platform for Analytics (EPA) with TensorFlow and Spark",Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00060456enw"},{Name:"HPE Reference Architecture for Apache Spark 2.1 on HPE Elastic Platform for Big Data Analytics (EPA)",Url:"     https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00041363enw"},{Name:"HPE Reference Configuration for Cloudera Enterprise on HPE Elastic Platform for Big Data Analytics (EPA)",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00042050enw"},{Name:"HPE Reference Configuration for the Elastic Platform for Big Data Analytics: ProLiant DL300-series modular building blocks of compute and storage optimized for modern workloads",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00005869enw"},{Name:"HPE Reference Configuration for networking best practices on the HPE Elastic Platform for Big Data Analytics (EPA) Hadoop ecosystem",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00004216enw"},{Name:"HPE Reference Architecture for MapR Converged Data Platform on HPE Elastic Platform for Big Data Analytics (EPA)",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=a00020201enw"},{Name:"HPE Reference Configuration for Big-Data-as-a-Service with "+__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_69" /* HPE_E_CPDESC */]+" software: Accelerating Big Data infrastructure deployments on HPE Elastic Platform for Big Data Analytics (EPA)",Url:"    https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-7823ENW"},{Name:"HPE Reference Configuration for HBase on HPE Elastic Platform for Big Data Analytics (EPA)",Url:"     https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-8757ENW"},{Name:"Spark - A modern data processing framework for cross platform analytics: Deploying Spark on HPE Elastic Platform for Big Data Analytics",Url:"    https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-8143ENW"},{Name:"HPE Reference Architecture for SAP HANA Vora with Spark and Hadoop: Using HPE ConvergedSystem for SAP HANA and HPE Elastic Platform for Big Data Analytics",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-7739ENW"},{Name:"HPE Reference Architecture for SAP HANA Vora with Hortonworks HDP",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-8601ENW"},{Name:"HPE Reference Architecture for Hortonworks HDP 2.4 on HPE Apollo 4200 Gen9 servers",Url:"  https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-7444ENW"},{Name:"HPE Reference Architecture for Hortonworks HDP 2.4 on HPE ProLiant DL380 Gen9 servers",Url:"      https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-9017ENW"},{Name:"HPE Reference Architecture for Hadoop on HPE Elastic Platform for Big Data Analytics (EPA): Deploying Hortonworks HDP with HPE Workload and Density Optimized (WDO) system                   ",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-6136ENW"},{Name:"HPE Reference Architecture for Cloudera Enterprise 5.7 with HPE Apollo 2000 and HPE Apollo 4200 Gen9 servers                   ",Url:"https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-3366ENW"},{Name:"HPE Reference Architecture for Cloudera Enterprise 5 on HPE ProLiant DL380 Gen9 servers                           ",Url:" https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA5-9086ENW"},{Name:"HPE Reference Architecture for Cloudera Enterprise 5 on HPE Apollo 4200 Gen9 servers       ",Url:"   https://h20195.www2.hpe.com/V2/GetDocument.aspx?docname=4AA6-6588ENW"}];var AdditionalReferenceComponent=function(_Component){_inherits(AdditionalReferenceComponent,_Component);function AdditionalReferenceComponent(props){_classCallCheck(this,AdditionalReferenceComponent);var _this=_possibleConstructorReturn(this,(AdditionalReferenceComponent.__proto__||Object.getPrototypeOf(AdditionalReferenceComponent)).call(this,props));_this.state={WhatsnewJson:''};_this.closePopUps=_this.closePopUps.bind(_this);//this.callRAContent = this.callRAContent.bind(this);
return _this;}// componentDidMount()
//   {
//     if(this.props.SupportedComponents === null)
//         this.props.OnFetchSupportedList(); 
//   }
_createClass(AdditionalReferenceComponent,[{key:'closePopUps',value:function closePopUps(e){this.props.click();}//    componentWillReceiveProps(nextProps){
//       // RABOM
//       if(nextProps.activeSession.id!="") {      
//         if(nextProps.activeSession.id !== this.props.activeSession.id){
//           if(nextProps.activeSession.treeView !== ''){
//             var obj = "";
//             obj = nextProps.activeSession.workload;            
//             this.props.onNewSession(obj);
//             this.props.redirectTo('/Build/SolnAlternative');
//             // this.props.history.push('/Build/SolnAlternative');
//           }else{
//             // var obj ="";              
//             // obj = nextProps.activeSession.workload;                
//             // this.props.onNewSession(obj);          
//             // this.props.redirectTo(interviewScreens[0].path);
//             // this.props.history.push('/Build/ContactInfo');
//           }    
//         }
//         if(nextProps.referenceArchitectBOM !== this.props.referenceArchitectBOM){
//           // nextProps.referenceArchitectBOM
//           var newWindow = window.open();
//           newWindow.document.write(nextProps.referenceArchitectBOM);
//         }
//       }
//    }
//  callRAContent(obj){
//       this.props.onRAClick( obj );
//  }
},{key:'render',value:function render(){var RefArchList=void 0;var sizerName="EPA";// if( this.props.referenceArchitect !== undefined && this.props.referenceArchitect !== '' ){
RefArchList=Doc.map(function(val,id){var shouldBeinReferenceArchitecture=false;if(__WEBPACK_IMPORTED_MODULE_2__AppConfig_js__["a" /* appUrl */].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_52" /* HPECP_SIZER */].toUpperCase())>-1&&val["workloadType"]===__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]||__WEBPACK_IMPORTED_MODULE_2__AppConfig_js__["a" /* appUrl */].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_52" /* HPECP_SIZER */].toUpperCase())===-1&&val["workloadType"]!==__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_59" /* HPE_CP */]){shouldBeinReferenceArchitecture=true;}if(shouldBeinReferenceArchitecture){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_TableRow___default.a,{key:id.toString()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Anchor___default.a,{style:{cursor:'pointer'},onClick:function onClick(){return window.open(decodeURIComponent(val["Url"]));}},' ',val["Name"],' '),' '));}});//}
if(__WEBPACK_IMPORTED_MODULE_2__AppConfig_js__["a" /* appUrl */].toUpperCase().indexOf(__WEBPACK_IMPORTED_MODULE_3__Redux_action_types_EPAConstants_js__["_52" /* HPECP_SIZER */].toUpperCase())>-1){sizerName=HPE_CP_;}var content='';// if( this.props.referenceArchitect !== undefined && this.props.referenceArchitect !== '' ){
content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Layer___default.a,{className:'ReferececeArchitcture',style:{width:'50%',height:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none',style:{overFlow:"hidden"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Reference Architecture')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_FormClose___default.a,{colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{overflow:"auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{margin:'4px 0px'}},'Learn More'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px',maxWidth:'100%'}},'HPE has produced ',sizerName,' collateral (white papers, technical articles etc.) that provide information on reference configurations.HPE recommends that you consult the information sources provided by clicking on the URL below to learn more.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Table___default.a,{style:{margin:'4px 0px',overflow:'initial'},selectable:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,RefArchList)))));// }else{
//   content = '';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none'},content,'   ');}}]);return AdditionalReferenceComponent;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{// activeSession: state.sessions.activeSession,
// DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers.Sizer,
// referenceArchitect: state.sessions.sessionDefaults.inputs.Sizers.Sizer.ReferenceArchitecture,
// referenceArchitectBOM: state.sessions.RABOM,
// SupportedComponents:state.sizerWorkload.supportedList,
};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{// onRAClick : (data) => {
//     if( data["Option"] === "BOM" ) {
//       dispatch( refArchBOM (data) );
//     }else if( data["Option"] === "Solution" ) {
//       dispatch( refArchSession(data) );
//     }
// },
// onNewSession:(workload) => {
//   dispatch({ type:'UPDATE_SIZER_WORKLOAD', payload: workload })
// },
};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AdditionalReferenceComponent));

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-note', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'note');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,23 L16,23 L23,16 L23,1 L1,1 L1,23 Z M15,23 L15,15 L23,15' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Note';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-circle-question', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'circle-question');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 Z M12,15 L12,14 C12,13 12,12.5 13,12 C14,11.5 15,11 15,9.5 C15,8.5 14,7 12,7 C10,7 9,8.26413718 9,10 M12,16 L12,18' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CircleQuestion';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Split__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Animate__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Status__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Home__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_User__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_User___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_User__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_UserAdd__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_UserAdd___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_UserAdd__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_FormTrash__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_FormTrash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_FormTrash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Contract__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Contract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Contract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_Save__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_CaretNext__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_CaretNext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_CaretNext__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Services__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Services__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_CaretPrevious__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_CaretPrevious___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_CaretPrevious__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_FormEdit__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_FormEdit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_FormEdit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Menu__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__CustomFooter__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__SolnAlternative__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__SizerScreens__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__SolutionPreview__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Utils__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_grommet_components_icons_base_DocumentConfig__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_grommet_components_icons_base_DocumentConfig___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_grommet_components_icons_base_DocumentConfig__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__LoadFiles__ = __webpack_require__(126);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import List from 'grommet/components/List';
//import ListItem from 'grommet/components/ListItem';
//import RadioButton from 'grommet/components/RadioButton';
//import Toast from 'grommet/components/Toast';
//import FormClose from 'grommet/components/icons/base/FormClose';
//import Select from 'grommet/components/Select';
//import Label from 'grommet/components/Label';
//import {version,said,sizerType,sizerName,launcher,launcherClass} from '../../AppConfig';
var _NextBtnVisible=true;var fromsoln=false;var HPECP_SIZER='EzmeralCPSizer'.toUpperCase();var EPA_SIZING='EPASizing';function CreateGuid(){function _p8(s){var p=(Math.random().toString(16)+"000000000").substr(2,8);return s?"-"+p.substr(0,4)+"-"+p.substr(4,4):p;}return _p8().toUpperCase()+_p8().toUpperCase()+_p8().toUpperCase()+_p8().toUpperCase();}var Build=function(_Component){_inherits(Build,_Component);function Build(){_classCallCheck(this,Build);var _this=_possibleConstructorReturn(this,(Build.__proto__||Object.getPrototypeOf(Build)).call(this));_this.state={ShowRightLayer:false,showFooter:true,ShowProgressBar:false,showAddSession:false,showUpdateSession:false,showDelSession:false,showSaveWorkload:false,SessionName:{},SessionNameTxt:'',activeSession:0,DelSession:'',ToggleMinimize:false,RouteObj:[],ErrorPopup:false,ErrorPopupMsg:'',RedirectPopup:false,RedirectMsg:'',showDupWLPopup:false,DupAvailable:'',TitleofSizer:'',isTryingToNavigate:false,sizingFailed:false,sizingFailedMsg:'',typeChoice:'',bigdataChecked:true,bluedataChecked:false,showRedirectConfirm:false,LoadItemTitle:'',LoadPopupScr:false};_this.goHome=_this.goHome.bind(_this);_this.onPrevClick=_this.onPrevClick.bind(_this);_this.onNextClick=_this.onNextClick.bind(_this);_this.onFinish=_this.onFinish.bind(_this);// this.SetTimeoutFinish = this.SetTimeoutFinish.bind(this);
_this.RightNavLayer=_this.RightNavLayer.bind(_this);_this.NextBtnVisible=_this.NextBtnVisible.bind(_this);_this.ShowDelSession=_this.ShowDelSession.bind(_this);_this.CloseDelSession=_this.CloseDelSession.bind(_this);_this.SessionTxtChange=_this.SessionTxtChange.bind(_this);_this.SaveWorkloadSubmit=_this.SaveWorkloadSubmit.bind(_this);_this.onSaveWorkloadIconClick=_this.onSaveWorkloadIconClick.bind(_this);_this.SaveWorkload=_this.SaveWorkload.bind(_this);_this.AddUserClick=_this.AddUserClick.bind(_this);_this.Submit_Add_Session=_this.Submit_Add_Session.bind(_this);_this.Submit_Update_Session=_this.Submit_Update_Session.bind(_this);_this.Submit_Change_Session=_this.Submit_Change_Session.bind(_this);_this.Submit_Delete_Session=_this.Submit_Delete_Session.bind(_this);_this.ToggleMinimize=_this.ToggleMinimize.bind(_this);_this.onSolnLostPopupYes=_this.onSolnLostPopupYes.bind(_this);_this.onSolnLostPopupClose=_this.onSolnLostPopupClose.bind(_this);_this.OverrideMsgYesClick=_this.OverrideMsgYesClick.bind(_this);_this.OverrideMsgNoClick=_this.OverrideMsgNoClick.bind(_this);_this.onBackButtonEvent=_this.onBackButtonEvent.bind(_this);_this.pushNext=_this.pushNext.bind(_this);_this.pushBack=_this.pushBack.bind(_this);_this.sizeFailedClose=_this.sizeFailedClose.bind(_this);_this.isModified=_this.isModified.bind(_this);_this._handleOnPaste=_this._handleOnPaste.bind(_this);_this.goBackToSSET=_this.goBackToSSET.bind(_this);_this.updateTitle=_this.updateTitle.bind(_this);_this.LoadWorkloadPopupClick=_this.LoadWorkloadPopupClick.bind(_this);_this.getNewRoute=_this.getNewRoute.bind(_this);_this.closePopUps=_this.closePopUps.bind(_this);return _this;}_createClass(Build,[{key:'componentWillMount',value:function componentWillMount(){this.state.RouteObj=__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */];// window.onpopstate = function (e) { window.history.forward(1); }
}},{key:'_handleOnPaste',value:function _handleOnPaste(e){e.preventDefault();}},{key:'onBackButtonEvent',value:function onBackButtonEvent(e){e.preventDefault();window.history.forward();}// goBackToSSET() {    
//     fetch(serviceUrl+'API/ExternalSizing/GetSSETUrl', {
//       method: "GET",
//       headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//         'Cache': 'no-cache'
//       },
//       credentials: 'same-origin'
//     })
//       .then((response) => {window.location.replace(response)})
//       .then(console.log('Error'));    
// }
},{key:'goBackToSSET',value:function goBackToSSET(){this.setState({showRedirectConfirm:true});}},{key:'goBackToSSETno',value:function goBackToSSETno(){this.setState({showRedirectConfirm:false});}},{key:'goBackToSSETyes',value:function goBackToSSETyes(){var id=this.props.activeSession.alias.split("#")[1];var isReviewed=this.props.sessionsData.reviewed;if(!isReviewed){this.setState({showRedirectConfirm:false});this.props.onShowLoading();Object(__WEBPACK_IMPORTED_MODULE_40__Utils__["a" /* clearSSETDataAndRedirect */])(this.props.UserID,id,isReviewed);}else{Object(__WEBPACK_IMPORTED_MODULE_40__Utils__["b" /* redirectToSSET */])(id,isReviewed);}}},{key:'updateTitle',value:function updateTitle(e){var mode='';var title='';//this.props.TitleCaption["SizerCaption"];  
if(e===undefined)this.props.sizerWorkLoad!==undefined&&this.props.sizerWorkLoad!==''?mode=this.props.sizerWorkLoad.Workload.UserInputs.SizerMode:mode=undefined;else mode=e;switch(mode){//case 'CS750Sizing': title = this.props.TitleCaption["SizerCaption"]; break;
// case 'CS750Sizing': title = 'HPE Sizer for ConvergedSystems Virtualization'; break;
case'CS750Sizing':title=this.props.SSETid===undefined?'HPE Sizer for ConvergedSystems Virtualization':'HPE CS750/CA750 SY Gen10 for Virtualization';break;case'SynergySizing':title='VMware ESXi on HPE Platform';break;case'vSANSizing':title=this.props.sizerWorkLoad.Workload.UserInputs.ConfigureVMwareCloudFoundation==='True'?'VCF on HPE Platform':'vSAN on HPE Platform';break;case'VDISizing':title='VDI on HPE Platform';break;case'BareMetalSizing':title='Bare Metal on HPE Rack (DL) Servers';break;case'OCPSizing':title=/* Advance Sizing Inputs for  */'Red Hat OpenShift on HPE Synergy';break;// added by aditya to display header for OCPSizing mode
case EPA_SIZING:title='HPE Elastic Platform for Big Data Analytics (EPA)';break;case HPECP_SIZER:title=this.props.SSETid&&this.props.sizerWorkLoad.UserInputs.Environments.SSETMode===__WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__["o" /* SSETSizingModes */].epaMLOps?__WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__["q" /* SSETTitles */].epaMLOps:__WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__["q" /* SSETTitles */].hpeCP;break;}if(this.state.TitleofSizer===''||this.state.TitleofSizer!==title)this.setState({TitleofSizer:title});}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["a" /* appUrl */].toUpperCase().indexOf(HPECP_SIZER)>-1){this.setState({bigdataChecked:false,blueDataworkloadTemplate:true});}else{this.setState({bigdataChecked:true,bluedataChecked:false});}if(this.props.TitleCaption!==undefined&&this.props.TitleCaption["SizerCaption"]!==undefined&&this.props.TitleCaption["SizerCaption"]!==''){if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){this.updateTitle();}else{this.setState({TitleofSizer:this.props.TitleCaption["SizerCaption"]});}}window.onpopstate=this.onBackButtonEvent;fromsoln=false;if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'&&!this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType){this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType='SAPHANA';}//Update route object
var specificPages=__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */].filter(function(route,id){if(route.type===undefined)return route;else{if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'){if(!(route.label===__WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__["g" /* GROWTH */]&&_this2.props.sizerWorkLoad.UserInputs.GROWTHSCREEN==='False')){if(route.type===_this2.props.sizerWorkLoad.UserInputs.Environments.WorkloadType){return route;}}}}});if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){var temp=[];if(this.props.sizerWorkLoad!==undefined&&this.props.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode==='Simple'){temp.push(__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */][0]);this.setState({RouteObj:temp});if(!this.props.activeSession.globalError.isError){this.props.OnToggleSizeButton(true);}else{this.props.OnToggleSizeButton(false);}this.props.history.push(temp[0].path);}else{this.setState({RouteObj:__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */]});this.props.history.push(__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */][0].path);this.props.OnToggleSizeButton(false);}}else{this.setState({RouteObj:specificPages});this.props.history.push(specificPages[0].path);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){var _this3=this;if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){if(nextProps.sizerWorkLoad!==undefined&&this.props.sizerWorkLoad!==undefined){this.updateTitle(nextProps.sizerWorkLoad.Workload.UserInputs.SizerMode);}if(this.props.sizerWorkLoad!==undefined){if(nextProps.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode!==this.props.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode){var _temp=[];if(nextProps.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode==='Simple'){_temp.push(__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */][0]);this.setState({RouteObj:_temp});if(!nextProps.activeSession.globalError.isError){this.props.OnToggleSizeButton(true);}else{this.props.OnToggleSizeButton(false);}}else{this.setState({RouteObj:__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */]});this.props.OnToggleSizeButton(false);}}}// else if( nextProps.sizerWorkLoad!==undefined && this.props.sizerWorkLoad!== undefined && this.props.sizerWorkLoad.Workload.UserInputs.SizerMode !== nextProps.sizerWorkLoad.Workload.UserInputs.SizerMode)
// {
//   this.updateTitle(nextProps.sizerWorkLoad.Workload.UserInputs.SizerMode);
// }
}if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'&&this.props.SSETid!==undefined){if(nextProps.sizerWorkLoad!==undefined&&this.props.sizerWorkLoad!==undefined){if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["a" /* appUrl */].toUpperCase().indexOf(HPECP_SIZER)>-1){this.updateTitle(HPECP_SIZER);}else{this.updateTitle(EPA_SIZING);}}}if(nextProps.SSETUrl!==undefined){window.location.replace(nextProps.SSETUrl);}if(nextProps.activeSession.sizingFailed!==undefined&&nextProps.activeSession.sizingFailed.isFailed){if(nextProps.activeSession.sizingFailed.isFailed){this.setState({sizingFailed:true,sizingFailedMsg:nextProps.activeSession.sizingFailed.Exception});}}if(this.state.isTryingToNavigate&&this.props.validation.required){if(nextProps.activeSession.globalError.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:nextProps.activeSession.globalError.errorMsg,isTryingToNavigate:false});return;}else{this.setState({isTryingToNavigate:false});this.pushNext();return;}}if(nextProps.activeSession.id===''){if(nextProps.allSessions.length>0){this.props.onChangeSession(nextProps.allSessions[0].id);this.props.onNewSession(nextProps.allSessions[0].workload);if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.props.indexes.functions=0;this.props.indexes.extraConfiguration=0;var specificPages=__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */].filter(function(route,id){if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){if(route.type===nextProps.allSessions[0].workload.UserInputs.Environments.WorkloadType){return route;}}});this.setState({RouteObj:specificPages});this.props.history.push(specificPages[0].path);}else{this.props.history.push(this.state.RouteObj[0]['path']);}__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').hide();}else{if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.props.indexes.functions=0;this.props.indexes.extraConfiguration=0;if(this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType==='BigData'){this.props.onNewSession(this.props.workloadTemplate);}else{this.props.onNewSession(this.props.blueDataworkloadTemplate);}}else{this.props.onNewSession(this.props.workloadTemplate);}this.props.history.push('/Home');__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').show();}}else{__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').hide();if(nextProps.activeSession.treeView!==''&&!fromsoln){if(!window.location.pathname.match("/SolnAlternative")){this.props.history.push('/Build/SolnAlternative');__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').show();}}else if(window.location.pathname.match("/SolnAlternative")&&!fromsoln){this.props.history.push(this.state.RouteObj[0]['path']);__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').hide();}else{if(nextProps.OverrideMsg.isEnabled){this.state.showDupWLPopup=true;this.state.showSaveWorkload=true;}else{// this.state.showSaveWorkload = false;
this.state.showDupWLPopup=false;}if(nextProps.toastNotification.isEnabled){this.state.showSaveWorkload=false;}}}if(nextProps.Redirect.isEnabled){this.props.history.push(nextProps.Redirect.path);this.props.onRedirectPage(false,'');}if(nextProps.activeSession.id!==""&&this.props.activeSession.id!==nextProps.activeSession.id){var _specificPages=__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */].filter(function(route,id){if(route.type===undefined)return route;else{if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'){if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){_this3.props.indexes.functions=0;_this3.props.indexes.extraConfiguration=0;}if(route.type===nextProps.sizerWorkLoad.UserInputs.Environments.WorkloadType){return route;}}}});if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){var temp=[];if(nextProps.sizerWorkLoad!==undefined&&nextProps.sizerWorkLoad.Workload.UserInputs.WorkloadInputMode==='Simple'){temp.push(__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */][0]);this.setState({RouteObj:temp});if(!this.props.activeSession.globalError.isError){this.props.OnToggleSizeButton(true);}else{this.props.OnToggleSizeButton(false);}this.props.history.push(temp[0].path);}else{this.setState({RouteObj:__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */]});this.props.history.push(__WEBPACK_IMPORTED_MODULE_38__SizerScreens__["a" /* interviewScreens */][0].path);this.props.OnToggleSizeButton(false);}}else{this.setState({RouteObj:_specificPages});this.props.history.push(_specificPages[0].path);}}}},{key:'onSolnLostPopupYes',value:function onSolnLostPopupYes(selLabel){var _this4=this;this.state.RouteObj.map(function(route,id){if(route.label===selLabel){_this4.props.history.push(route.path);// new addition
fromsoln=true;// this.props.activeSession.isSizeEnabled = false;
// this.props.activeSession.treeView = '';
// this.props.activeSession.bomView = '';
// this.props.activeSession.configView = '';
// this.props.activeSession.GRInput = '';
// this.props.activeSession.GRBomInput = '';
}});this.props.onSaveCurrentSession();this.setState({ShowSolnLostMsg:false,NavSelection:''});}},{key:'onSolnLostPopupClose',value:function onSolnLostPopupClose(){this.setState({ShowSolnLostMsg:false,NavSelection:''});}},{key:'isModified',value:function isModified(){var _this5=this;var savedWl=this.props.allSessions.filter(function(item){if(item.id===_this5.props.activeSession.id){return item;}});if(savedWl.length>0){if(JSON.stringify(this.props.sizerWorkLoad)===JSON.stringify(savedWl[0].workload))return false;else if(this.props.sizerWorkLoad!==undefined&&JSON.stringify(this.props.sizerWorkLoad.Workload)===JSON.stringify(savedWl[0].workload))return false;else return true;}else return true;}},{key:'onSolutionSummaryclick',value:function onSolutionSummaryclick(){if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else if(this.props.activeSession.isSizeEnabled){if(!this.isModified()){fromsoln=false;if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.setState({ShowRightLayer:false});}this.props.history.push('/Build/SolnAlternative');}else{this.props.activeSession.treeView='';this.onFinish();}}else if(!this.isModified()){fromsoln=false;if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.setState({ShowRightLayer:false});}this.props.history.push('/Build/SolnAlternative');}else{this.setState({sizingFailed:true,sizingFailedMsg:"Workload inputs has been Modified.  Please Navigate to next page and re-size."});}}},{key:'onLeftNavSelection',value:function onLeftNavSelection(e){var _this6=this;__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').hide();// console.log(e.target.id);
if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{if(window.location.pathname.match('/Build/SolnAlternative')){//Show Solution will be lost msg
this.onSolnLostPopupYes(e.target.id);//this.setState({ShowSolnLostMsg: true, NavSelection: e.target.id });
}else{// if(this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.ProcessorSelected === 'Select Processor'){
//   this.setState({ErrorPopup: true, ErrorPopupMsg: 'Please select the processor from the dropdown.' });
//   this.props.history.push('/Build/EnvironmentDetails');
// }else{
this.state.RouteObj.map(function(route,id){if(route.label===e.target.id){_this6.props.history.push(route.path);// this.props.history.push(route.id);
// if( !window.location.pathname.match('/Build/SolnAlternative') ){
//   this.props.activeSession.treeView = '';
// }
}});// }
}}if(this.state.ShowRightLayer)this.setState({ShowRightLayer:false});}},{key:'onPrevClick',value:function onPrevClick(){if(!this.props.GlobalErr.isError&&this.props.validation!==undefined&&this.props.validation.required){this.setState({isTryingToNavigate:true});this.props.onValidateWorkload(this.props.validation.url,this.props.sizerWorkLoad);}else{this.pushBack();}if(this.state.ShowRightLayer)this.setState({ShowRightLayer:false});}},{key:'pushNext',value:function pushNext(){var index;this.state.RouteObj.map(function(route,id){if(window.location.pathname.match(route.path)){index=id;}});// if(this.state.RouteObj[index+1].isenabled){
//   this.props.history.push(this.state.RouteObj[index+1].path);
// }
if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.history.push(this.state.RouteObj[index+1].path);}}},{key:'pushBack',value:function pushBack(){var index;this.state.RouteObj.map(function(route,id){if(window.location.pathname.match(route.path)){index=id;}});// this.props.history.push(this.state.RouteObj[index-1].path);
if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.history.push(this.state.RouteObj[index-1].path);}}},{key:'onNextClick',value:function onNextClick(){if(!this.props.GlobalErr.isError&&this.props.validation!==undefined&&this.props.validation.required){this.setState({isTryingToNavigate:true});this.props.onValidateWorkload(this.props.validation.url,this.props.sizerWorkLoad);}else{this.pushNext();}if(this.state.ShowRightLayer)this.setState({ShowRightLayer:false});}},{key:'goHome',value:function goHome(){// this.props.history.push('/Home');
if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.props.indexes.functions=0;this.props.indexes.extraConfiguration=0;}this.props.onUpdateActiveSession(this.props.sizerWorkLoad);this.props.onSaveCurrentSession();this.props.history.push('/Home');__WEBPACK_IMPORTED_MODULE_37_jquery___default()('#footer').show();}}// SetTimeoutFinish(){
//   this.setState({showFooter: false, ShowProgressBar:false, ShowRightLayer:false})
//   clearInterval(xx);
//   this.props.history.push('/Build/SolnAlternative');
// }
},{key:'onFinish',value:function onFinish(){// this.setState({ShowProgressBar: false});
// xx = setInterval( this.SetTimeoutFinish, 3000);
var obj;if(this.props.activeSession.id!==this.props.SSETid&&this.props.SSETid===undefined){fromsoln=false;this.props.activeSession.treeView='';this.props.activeSession.bomView='';this.props.activeSession.configView='';this.props.activeSession.GRInput='';this.props.activeSession.GRBomInput='';this.state.ShowProgressBar=false;var workload={"WorkLoad":{}};this.props.activeSession.workload=JSON.parse(JSON.stringify(this.props.sizerWorkLoad));workload.WorkLoad=this.props.activeSession.workload;var userId=this.props.UserID;var userName=this.props.UserName;if(userId===undefined){userId='TestUser@test.com';userName='TestUSer';}obj={"Workload":workload,"SessionID":this.props.activeSession.id,"UserId":userId,"SizerId":__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */],"Country":this.props.country,"UserName":userName//}
// obj.data.workload.WorkLoad = this.props.activeSession.workload;
// var x = JSON.stringify(obj).replace('"','\"');TitleCaption
//if (this.props.DefaultInputs['@name'] === "SAP Sizing Tool") {
};if(this.props.TitleCaption.Sizer['@name']==="SAP Sizing Tool"){//  var ProdEnv = this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment;
var ProdEnv=this.props.sizerWorkLoad.UserInputs.Environments.ProductionEnvironment;if(ProdEnv['SelectedProdDBServerOS']===null){this.setState({ShowRightLayer:false,RedirectPopup:true,RedirectMsg:'Sizing is not allowed. \nPlease check your configuration .'});return;}}if(this.props.TitleCaption.Sizer['@name']==='SAP HANA Sizing Tool'){//  var ProdEnv = this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment;
var _ProdEnv=this.props.sizerWorkLoad.UserInputs.Environments.ProductionEnvironment;if(_ProdEnv['ProcessorSelected']==='Select Processor'){this.setState({RedirectPopup:true,RedirectMsg:'Sizing is not allowed. \nPlease check your configuration .',ShowRightLayer:false});return;}}if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.OnToggleSizeButton(false);obj.Workload=obj.Workload.WorkLoad;this.props.onGetSolution(obj);}}else{if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.OnToggleSizeButton(false);this.props.onGetSolution(obj);}}if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.props.ClearCompareData(false);this.setState({ShowRightLayer:false});}if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAP'){this.setState({ShowRightLayer:false});}}else{var _workload={"WorkLoad":{}};this.props.activeSession.workload=JSON.parse(JSON.stringify(this.props.sizerWorkLoad));_workload.WorkLoad=this.props.activeSession.workload;obj={"Workload":_workload,"ReferenceId":this.props.SSETid===undefined?this.props.activeSession.id:this.props.SSETid,"isSizerAsEntry":false,"uInfo":this.props.sessionsData.uInfo};var expertSizingModes=['CS750VirtSizer','SynergySizer',"EPAvNext",'SAPHANA','SAP'];if(expertSizingModes.indexOf(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */])!==-1){if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.OnToggleSizeButton(false);if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'){obj.Workload=obj.Workload.WorkLoad;obj.Workload.Workload.UserInputs.isSized='True';this.props.onGetAdvancedSolution(obj);}else{obj.Workload.WorkLoad.strSizerName=function(){var epaSizer="EPA vNext Sizing Tool";var sapSizer="SAP Sizing Tool";var hanaSizer="SAP HANA Sizing Tool";if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]===__WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__["t" /* SizerIds */].EPAVNEXT)return epaSizer;else if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]===__WEBPACK_IMPORTED_MODULE_41__State_constants_CommonConstants__["t" /* SizerIds */].SAP)return sapSizer;else return hanaSizer;}();this.props.onGetAdvancedSolution(obj);}}}}}},{key:'ShowDelSession',value:function ShowDelSession(delItem){this.setState({showDelSession:true,DelSession:delItem});}},{key:'CloseDelSession',value:function CloseDelSession(){this.setState({DupAvailable:'',SessionNameTxt:'',showSaveWorkload:false,showDelSession:false,showAddSession:false,SessionName:{},DelSession:'',showUpdateSession:false});this.props.onDisableconflicts();this.props.OpenedSaveWorkload(false);}},{key:'Submit_Delete_Session',value:function Submit_Delete_Session(SessionID){if(this.props.GlobalErr!==''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.onDeleteSession(SessionID);this.CloseDelSession();}}},{key:'Submit_Change_Session',value:function Submit_Change_Session(SessionID){if(this.props.GlobalErr!=''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{if(this.props.activeSession.id!==SessionID){var errorObj={isError:false,errorMsg:''};this.props.updateError(errorObj);this.props.onUpdateActiveSession(this.props.sizerWorkLoad);this.props.onSaveCurrentSession();this.props.onChangeSession(SessionID);var workload='';this.props.allSessions.map(function(value,index){if(value.id===SessionID)workload=value.workload;});this.props.onNewSession(workload);// if(this.props.activeSession.treeView !== ''){
//   this.props.history.push('/Build/SolnAlternative');
// }else{
//   this.props.history.push(this.state.RouteObj[0]['path']);
// }
fromsoln=false;}}if(this.state.ShowRightLayer)this.setState({ShowRightLayer:false});}},{key:'AddUserClick',value:function AddUserClick(){if(this.props.GlobalErr!=''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{this.props.OpenedSaveWorkload(true);this.setState({showAddSession:true,showUpdateSession:false,SessionNameTxt:''});}}},{key:'Submit_Add_Session',value:function Submit_Add_Session(){if(this.state.SessionNameTxt.trim()!==''){this.state.SessionName.alias=this.state.SessionNameTxt;this.props.onUpdateActiveSession(this.props.sizerWorkLoad);this.props.onSaveCurrentSession();if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){var obj={"Workload":this.props.workloadTemplate};this.props.onNewSession(obj);}else if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){this.state.bigdataChecked?this.props.onNewSession(this.props.workloadTemplate):this.props.onNewSession(this.props.blueDataworkloadTemplate);this.props.OpenedSaveWorkload(false);}else if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'){if(this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType==='TDI'){this.props.onNewSession(this.props.tdiWorkloadTemplate);}else{this.props.onNewSession(this.props.workloadTemplate);}}else{this.props.onNewSession(this.props.workloadTemplate);}this.props.onAddSession(CreateGuid(),this.state.SessionName.alias);fromsoln=false;this.props.history.push(this.state.RouteObj[0]['path']);this.setState({showAddSession:false,showUpdateSession:false,showDelSession:false,SessionName:{},DelSession:'',ShowRightLayer:false});}}},{key:'Submit_Update_Session',value:function Submit_Update_Session(){if(this.state.SessionNameTxt.trim()!==''){this.state.SessionName.alias=this.state.SessionNameTxt;this.props.onUpdateActiveSession(this.props.sizerWorkLoad);this.props.onSaveCurrentSession();this.props.onUpdateSession(this.state.SessionName);if(this.props.activeSession.id===this.state.SessionName.id){this.props.onChangeSession(this.props.activeSession.id);}this.setState({showDelSession:false,showAddSession:false,showUpdateSession:false,DelSession:'',ShowRightLayer:false});}}},{key:'SessionTxtChange',value:function SessionTxtChange(e){var _this7=this;var duplicate=false;this.props.allSessions.filter(function(sessItem,index){if(sessItem.alias!==_this7.state.SessionName.alias&&sessItem.alias.toLowerCase().trim()===e.target.value.toLowerCase().trim()){duplicate=true;}});if(duplicate){if(e.target.value.length<=25){this.setState({SessionNameTxt:e.target.value,DupAvailable:'Session name already exists. Please choose a different name.'});}}else{if(e.target.value.length<=25){this.setState({SessionNameTxt:e.target.value,DupAvailable:''});}}// this.setState({ SessionNameTxt: e.target.value });
}},{key:'ToggleMinimize',value:function ToggleMinimize(){this.setState({ToggleMinimize:!this.state.ToggleMinimize});}},{key:'RightNavLayer',value:function RightNavLayer(){if(this.state.ShowRightLayer){this.setState({ShowRightLayer:false});}else{this.setState({ShowRightLayer:true});}}},{key:'NextBtnVisible',value:function NextBtnVisible(){var currentPage;this.state.RouteObj.map(function(route,id){if(window.location.pathname.indexOf(route.path)>0)currentPage=id;});if(currentPage!==undefined){if(this.state.RouteObj.length-1!==currentPage){if(this.state.RouteObj[currentPage+1].isenabled===true){_NextBtnVisible=true;}else{_NextBtnVisible=false;}}else{_NextBtnVisible=false;}}else{_NextBtnVisible=false;}return _NextBtnVisible;}},{key:'onSaveWorkloadIconClick',value:function onSaveWorkloadIconClick(){if(this.props.GlobalErr!=''&&this.props.GlobalErr.isError){this.setState({ErrorPopup:true,ErrorPopupMsg:this.props.GlobalErr.errorMsg});}else{// if(this.props.activeSession.alias.indexOf('Default Session') === 0){
this.props.OpenedSaveWorkload(true);this.setState({showSaveWorkload:true,SessionNameTxt:this.props.activeSession.alias});// }else{
// this.SaveWorkload();
// }
}}},{key:'SaveWorkloadSubmit',value:function SaveWorkloadSubmit(){// this.state.SessionName = this.props.activeSession;
// this.Submit_Update_Session();
this.props.OpenedSaveWorkload(false);this.props.onUpdateActiveSession(this.props.sizerWorkLoad);if(this.state.SessionNameTxt!==null&&this.state.SessionNameTxt.trim()!==''){var initialCheck=false;this.SaveWorkload(initialCheck);}}},{key:'SaveWorkload',value:function SaveWorkload(overrideParam){var workload={"WorkLoad":{}};this.props.activeSession.workload=this.props.sizerWorkLoad;if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]=="CS750VirtSizer"||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'){workload.WorkLoad=this.props.activeSession.workload.Workload;}else{workload.WorkLoad=this.props.activeSession.workload;}var userId=this.props.UserID;if(userId===undefined){userId='TestUser@test.com';}var sessionObject={"Workload":workload,"SessionID":this.props.activeSession.id,//"UserId": "Madhukar",
"UserId":userId,//"SizerType": sizerType,
"SizerId":__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */],"Alias":this.state.SessionNameTxt,"Override":overrideParam// var sessionObject = { "SessionID": this.props.activeSession.id };
};this.props.onSaveWorkload(sessionObject);}},{key:'OverrideMsgYesClick',value:function OverrideMsgYesClick(){this.SaveWorkload(true);this.state.showSaveWorkload=false;this.setState({showDupWLPopup:false});}},{key:'OverrideMsgNoClick',value:function OverrideMsgNoClick(){this.state.showSaveWorkload=true;this.setState({showDupWLPopup:false});this.props.onDisableconflicts();}},{key:'sizeFailedClose',value:function sizeFailedClose(){this.setState({sizingFailed:false,sizingFailedMsg:''});if(this.props.sizeError!==undefined&&this.props.sizeError!=='')this.props.sizeError.isFailed=false;}},{key:'LoadWorkloadPopupClick',value:function LoadWorkloadPopupClick(){if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAP'){// this.props.onNewSession(this.props.workloadTemplate);
this.props.onUpdateDefaultSession(this.props.DefaultInputs);}this.setState({LoadItemTitle:'All',LoadPopupScr:true});}},{key:'getNewRoute',value:function getNewRoute(str){this.closePopUps();this.props.history.push(str);}},{key:'closePopUps',value:function closePopUps(){this.setState({LoadItemTitle:'',LoadPopupScr:false});}},{key:'render',value:function render(){var _this8=this;var ToogleBtn=void 0;var LayerRight;var showDelSession;var showAddSession;var showSaveWorkload;var showDupWLPopupContent;// if(this.props.GlobalErr !='' && this.props.GlobalErr.isError){
// }
var SizingButton='';var buttonId=this.props.SSETid!==undefined?'sizeWorkloadBtn':'';//var rslt = this.props.SSETid !== undefined ? buttonId = 'sizeWorkloadBtn' : '';
// if(!this.props.isSizeEnabled){
if(!this.props.activeSession.isSizeEnabled){SizingButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,label:'Finish',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Services___default.a,null),style:{padding:'6px 6px',width:'100%'}});}else{SizingButton=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,label:'Finish',id:buttonId,onClick:this.onFinish,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Services___default.a,null),style:{padding:'6px 6px',width:'100%'}});}var RouteWithSubRoutes=function RouteWithSubRoutes(route){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{path:route.path,render:function render(props){return(// pass the sub-routes down to keep nesting
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(route.component,Object.assign({},props,{routes:route.routes})));}});};var links=this.state.RouteObj.map(function(route,id){if(window.location.pathname.match(route.path)){activeLinkClass='active';}else{activeLinkClass='';}var displa="Visible";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{key:id,direction:'row',margin:'none',pad:'none',style:{display:displa}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{id:id,className:activeLinkClass,style:{color:'transparent',width:'4%'}},'a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:id,style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{id:route.label,label:route.label,onClick:_this8.onLeftNavSelection.bind(_this8)})));});var activeLinkClass='';if(window.location.pathname.match('Build/SolnAlternative')){activeLinkClass='active';}else{activeLinkClass='';}//let disable = '';
// var modified = this.isModified();
// if(this.props.activeSession.isSizeEnabled ||  window.location.pathname.match("/SolnAlternative")  || (!this.props.activeSession.isSizeEnabled && !modified))
// {
//   disable = false;
// }
// else {
//   disable = true;
// }
var solSummaryLink=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{key:'Summary',direction:'row',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{id:'Summary',className:activeLinkClass,style:{color:'transparent',width:'4%'}},'a'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{id:'Summary',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{id:'Summary',label:'Solution Summary',onClick:this.onSolutionSummaryclick.bind(this)})));//var temp = window.location.pathname.match("/SolnAlternative") || fromsoln ? links.push(solSummaryLink) : null
if(window.location.pathname.match("/SolnAlternative")||fromsoln){links.push(solSummaryLink);}var SolnLostPopup='';if(this.state.ShowSolnLostMsg){SolnLostPopup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.onSolnLostPopupClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},'Solution will be lost, are you sure you want to continue ?')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:function onClick(){return _this8.onSolnLostPopupYes(_this8.state.NavSelection);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',critical:true,onClick:this.onSolnLostPopupClose}))));}var toast='';if(this.props.toastNotification.isEnabled){toast=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_CircleInformation___default.a,{colorIndex:'accent-1-t',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.props.onCloseToast},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},this.props.toastNotification.isError?undefined:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_Status___default.a,{value:'ok',style:{margin:'12px 12px 0px 0px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default.a,{margin:'small'},this.props.toastNotification.msg))));// <Box pad="small" justify="between" direction="row" colorIndex="light-2" >
//              <Box pad={{between:'small'}} justify="between" direction="row" >
//                 <Status value='ok' />
//                 <Heading tag='h5' strong={false} margin='none'> {this.props.toastNotification.msg} </Heading>
//              </Box>
//              <Box pad="none" direction="row" onClick={this.props.onCloseToast} ><FormClose size="small"/></Box>
//           </Box>
// toast =  <Toast status='ok' onClose={ this.props.onCloseToast} style={{zIndex: '100007'}}> {this.props.toastNotification.msg} </Toast>
}else{toast='';}var RedirectPopup='';if(this.state.RedirectPopup){RedirectPopup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){_this8.props.onRedirectPage(true,_this8.state.RouteObj[1]['path']);// this.props.history.push(this.state.RouteObj[1]['path']);
_this8.setState({RedirectPopup:false,RedirectMsg:''});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default.a,{margin:'small'},this.state.RedirectMsg))));}var sizingFailed='';if(this.state.sizingFailed){sizingFailed=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Alert')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.sizeFailedClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default.a,{margin:'small'},this.state.sizingFailedMsg))));}var ErrorPopup='';if(this.state.ErrorPopup){ErrorPopup=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){return _this8.setState({ErrorPopup:false,ErrorPopupMsg:''});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default.a,{margin:'small'},this.state.ErrorPopupMsg))));}if(this.state.ToggleMinimize){ToogleBtn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{'data-tip':'Expand',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Menu___default.a,{colorIndex:'accent-3',size:'small'}),onClick:this.ToggleMinimize});}else{ToogleBtn=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{'data-tip':'Minimize',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_Contract___default.a,{colorIndex:'accent-3',size:'small'}),onClick:this.ToggleMinimize});}if(this.state.ShowRightLayer){LayerRight=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__SolutionPreview__["a" /* default */],{onClose:this.RightNavLayer});//       LayerRight = <Box colorIndex="light-2" direction="row" align='start' pad='none' separator="left"
//                         style={{height:'100%', width:'300px', overflowY: 'auto',
//                         position:'absolute',right:'0px',top:'0px',zIndex:3}}>
//              <Animate enter={{"animation": "slide-left", "duration": 200, "delay": 0}}
//                       leave={{"animation": "slide-left", "duration": 200, "delay": 0}}
//                       keep={true} style={{width:'100%'}} >
//                   <Box direction='row'>
//                    <List style={{width:'100%'}}>
//                      <Heading tag="h4" align="center" margin="none" strong={true} style={{backgroundColor:'#28ab8c',padding:'4px',color:'#fff'}}>Solution Preview</Heading>
// {/*this.props.DefaultInputs.SolutionPreview.PageCaption*/}
//                      <ListItem justify='between' direction="column" separator='horizontal'>
//                         <span> Solution Profile Recommended </span>
//                         <span style={{width:'100%',textAlign:'center'}} className='secondary'> (Role:Mailbox(log and database isolated) server -Site1 -No DAG) </span>
//                       </ListItem>
//                       <ListItem justify='between' direction="column" separator='horizontal'>
//                         <span> Server Type </span>
//                         <span className='secondary'> Proliant </span>
//                       </ListItem>
//                       <ListItem justify='between' direction="column" separator='horizontal'>
//                         <span> ServerPlatform  </span>
//                         <span className='secondary'> Tower </span>
//                       </ListItem>
//                        <ListItem justify='between' direction="column" separator='horizontal'>
//                         <span> Processor Vendor </span>
//                         <span className='secondary' > Intel </span>
//                       </ListItem>
//                        <ListItem justify='between' direction="column" separator='horizontal'>
//                         <span> Server </span>
//                         <span className='secondary'> Proliant ML350 Gen9(CTO) </span>
//                       </ListItem>
//                     </List>
//                  </Box>
//              </Animate>
//       </Box>
}else{LayerRight="";}if(window.location.pathname.match("/SolnAlternative")){this.state.showFooter=_NextBtnVisible=false;}else if(!window.location.pathname.match("/Home")){_NextBtnVisible=this.NextBtnVisible();this.state.showFooter=true;}if(this.props.OverrideMsg.isEnabled&&this.state.showDupWLPopup||this.state.showRedirectConfirm){var messageToDisplay='';var yesMethod='';var noMethod='';if(this.state.showRedirectConfirm){messageToDisplay="All your changes will be lost if you select yes to continue. Would you like to continue?";yesMethod=this.goBackToSSETyes.bind(this);noMethod=this.goBackToSSETno.bind(this);}else{messageToDisplay=this.props.OverrideMsg.msg;yesMethod=this.OverrideMsgYesClick;noMethod=this.OverrideMsgNoClick;}showDupWLPopupContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},messageToDisplay)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{id:'backToSSETyes',label:'Yes',className:'SessionOutBtns',onClick:yesMethod}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',critical:true,onClick:noMethod}))));}else{showDupWLPopupContent="";}if(this.state.showSaveWorkload){showSaveWorkload=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please name your workload:')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.CloseDelSession},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TextInput___default.a,{onPaste:this._handleOnPaste,value:this.state.SessionNameTxt,style:{width:'80%'},placeHolder:'Session Name',onDOMChange:this.SessionTxtChange}),this.state.SessionNameTxt===''||this.state.SessionNameTxt.trim()===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink___default.a,{size:'small'})}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink___default.a,{size:'small'}),onClick:this.SaveWorkloadSubmit}))));}else{showSaveWorkload="";}var tempText='';var tempMethod='';if(this.state.showUpdateSession){tempText='Update Session';tempMethod=this.Submit_Update_Session;}if(this.state.showAddSession){tempText='Add Your Session';tempMethod=this.Submit_Add_Session;}if(this.state.showAddSession||this.state.showUpdateSession){showAddSession=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false},tempText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.CloseDelSession},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_TextInput___default.a,{onPaste:this._handleOnPaste,value:this.state.SessionNameTxt,style:{width:'80%'},placeHolder:'Session Name',onDOMChange:this.SessionTxtChange}),this.state.SessionNameTxt===''||this.state.SessionNameTxt.trim()===''||this.state.DupAvailable!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink___default.a,{size:'small'})}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink___default.a,{size:'small'}),onClick:tempMethod})),this.state.DupAvailable!==''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h5',strong:false,className:'SessionExtPopup'},this.state.DupAvailable)):''));}else{showAddSession="";}if(this.state.showDelSession){showDelSession=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.CloseDelSession},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},'Are you sure you want to delete the selected session:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h6',strong:true,margin:'none'},this.state.DelSession.alias)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:function onClick(){return _this8.Submit_Delete_Session(_this8.state.DelSession.id);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',critical:true,onClick:this.CloseDelSession}))));}else{showDelSession="";}var sessionsMenu="";if(this.props.allSessions.length>0){var s=this.props.allSessions.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_grommet_components_TableRow___default.a,{key:val.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{pad:'none',margin:'small',className:'UserSelectionAnchor',style:{margin:'0px 0px',fontWeight:'500'},onClick:function onClick(){return _this8.Submit_Change_Session(val.id);}},val.alias)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'  ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:false,plain:true,onClick:function onClick(){return _this8.setState({SessionName:val,SessionNameTxt:val.alias,showUpdateSession:true,showAddSession:false});},icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_FormEdit___default.a,{size:'small',colorIndex:'#ff9374'})}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'   ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:false,plain:true,onClick:function onClick(){return _this8.ShowDelSession(val);}// onClick ={ ()=>this.props.onDeleteSession(val.id) }     
,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_FormTrash___default.a,{size:'small',colorIndex:'#ff9374'})}),' '));});//  var s = this.props.allSessions.map((val) => {
//     return(
//           <TableRow key={val.id} >
//             <td>
//               <Box direction='row' >
//                    <Anchor pad='none' margin='none' className="UserSelectionAnchor"style={{margin:'12px 0px', fontWeight: '500'}}
//                            onClick={() => this.Submit_Change_Session(val.id) }>
//                            {val.alias}
//                    </Anchor>
//                    <Button primary={false} plain={true} onClick = { () => this.setState({ SessionName: val, SessionNameTxt: val.alias, showUpdateSession: true, showAddSession: false }) }
//                            icon={<FormEdit size="small" colorIndex='#ff9374' />}  />
//                    <Button primary={false} plain={true} onClick ={ () => this.ShowDelSession(val) }
//                            // onClick ={ ()=>this.props.onDeleteSession(val.id) }
//                            icon={<TrashIcon size="small" colorIndex='#ff9374' />}  />
//               </Box>
//                </td>
//          </TableRow> 
//     )
// });
}sessionsMenu=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Menu___default.a,{className:'SessionsList',responsive:true,closeOnClick:true,size:'medium',margin:'none',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_User___default.a,{size:'small',colorIndex:'accent-3'}),label:this.props.activeSession.alias},this.props.SSETid===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32_grommet_components_Table___default.a,{className:'UserSelectDropdownItems'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Anchor___default.a,{className:'UserSelectionAnchor',style:{margin:'0px 0px',fontWeight:'500'},onClick:this.AddUserClick},'Add New'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:false,plain:true,onClick:this.AddUserClick,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_UserAdd___default.a,{size:'small',colorIndex:'brand'})}))),s)):'');var SolutionPreviewContent='';//if(this.props.DefaultInputs["@name"] === "SAP HANA Sizing Tool"){
if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==="CS750VirtSizer"||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SynergySizer'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPA'){SolutionPreviewContent='';}else{if(!window.location.pathname.match("/SolnAlternative")){SolutionPreviewContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,label:'Solution Preview',onClick:this.RightNavLayer,style:{padding:'6px 6px',width:'100%',marginBottom:'10px'}});}}var stylefooter='';if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext'){stylefooter='NextPrevSecVNext';//  { position: 'fixed', bottom: '0px', height: '6%', width: '100%', backgroundColor: 'rgba(66, 85, 99, 0.82)',zIndex: '1000000' }
}else{stylefooter='NextPrevSec';//  { position: 'fixed', bottom: '0px', height: '6%', width: '100%', backgroundColor: 'rgba(66, 85, 99, 0.82)'}
}if(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'){if(this.props.sizerWorkLoad.UserInputs.Environments.WorkloadType==='TDI'){this.state.TitleofSizer='HPE Sizing Tool for SAP TDI';}else{this.state.TitleofSizer=__WEBPACK_IMPORTED_MODULE_36__AppConfig__["h" /* title */];}}var layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Layer___default.a,{className:'LoadPopupLayer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__LoadFiles__["a" /* default */],{title:this.state.LoadItemTitle// history={history}
,redirectTo:this.getNewRoute,onClose:this.closePopUps}));var layerelement;if(this.state.LoadPopupScr){layerelement=layer;}var featureFlag=window.sessionStorage.getItem("featureFlag");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,null,toast,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',className:'',margin:'none',pad:'none',justify:'end',separator:'bottom',style:{backgroundColor:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',size:'small',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_tooltip___default.a,{place:'right',multiline:true}),ToogleBtn,sizingFailed,ErrorPopup,RedirectPopup,SolnLostPopup,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{'data-tip':'Home',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Home___default.a,{size:'small',colorIndex:'accent-3'}),onClick:this.props.SSETid===undefined?this.goHome:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{basis:'xxlarge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{align:'start',tag:'h4',strong:true,style:{fontSize:'23px',margin:'auto 0%',paddingLeft:'6px',color:'#01a982',borderLeft:'1px solid #bdbcbc'}},this.state.TitleofSizer,' '),showDelSession,showAddSession,showSaveWorkload,showDupWLPopupContent,layerelement),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{align:'center',basis:'large',direction:'row',margin:'none',pad:{horizontal:"large",between:'small'}},this.props.sessionsData!==undefined&&!this.props.sessionsData.reviewed&&featureFlag==="True"&&this.props.SSETid&&(__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAP'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='SAPHANA'||__WEBPACK_IMPORTED_MODULE_36__AppConfig__["f" /* said */]==='EPAvNext')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},style:{width:'175px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42_grommet_components_icons_base_DocumentConfig___default.a,{size:'small',colorIndex:'accent-3'}),label:'Load Workload',onClick:this.LoadWorkloadPopupClick,className:'ReverseSavewrkloadbtn'})):null,this.state.showFooter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,null,!this.props.SSETid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},style:{width:'175px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_Save___default.a,{size:'small',colorIndex:'accent-3'}),label:'Save Workload',onClick:this.onSaveWorkloadIconClick,className:'ReverseSavewrkloadbtn'})):null):null,sessionsMenu)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Split___default.a,{flex:'right',style:{width:'100%',overflow:"hidden"},pad:'small',className:'LeftSec',showOnResponsive:'both'},!this.state.ToggleMinimize?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Animate___default.a,{enter:{"animation":"slide-right","duration":500,"delay":0,"height":'100%'},leave:{"animation":"slide-right","duration":500,"delay":0,"height":'100%'},style:{height:'100%'},keep:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{justify:'between',style:{width:'100%',height:'100%'},basis:'large',className:'MenuToggle',align:'center',pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{justify:'between',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'LeftNav'},links)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,null,SolutionPreviewContent))),'  '):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',className:'RightSec',justify:'start',style:{width:'100%',height:'100%'},align:'center',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',style:{height:'100%',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{className:'Togglebtncls'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Switch */],null,this.state.RouteObj.map(function(route,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RouteWithSubRoutes,Object.assign({key:i},route));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Route */],{exact:true,path:'/Build/SolnAlternative',component:__WEBPACK_IMPORTED_MODULE_35__SolnAlternative__["a" /* default */]}))),LayerRight))),this.state.ShowProgressBar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none',style:{width:'100%',position:'fixed',bottom:'5.8%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Heading___default.a,{tag:'h3'},' 100%')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{className:'ProgressBar',style:{width:'100%',backgroundColor:'rgba(98, 113, 125, 0.57)',bottom:'6%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{width:'20%'},className:'ProgressBarAfter'}))):null,this.state.showFooter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{className:stylefooter,direction:'row',justify:'between',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',basis:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',justify:'center',basis:'xxlarge'},window.location.pathname.match(this.state.RouteObj[0]['path'])?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{align:'center',direction:'row',className:'NextPrevIconDisabled',alignContent:'center',style:{justifyContent:'center',width:'10%'},separator:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_CaretPrevious___default.a,{size:'small',colorIndex:'brand'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{style:{color:'darkgray'},pad:'none',margin:'none'},'Previous')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',align:'center',className:'NextPrevIcon',alignContent:'center',onClick:this.onPrevClick,style:{justifyContent:'center',backgroundColor:'#01a982',width:'10%'},separator:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_CaretPrevious___default.a,{size:'small',colorIndex:'brand'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{color:'white'}},'Previous')),_NextBtnVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',align:'center',className:'NextPrevIcon',alignContent:'center',onClick:this.onNextClick,style:{justifyContent:'center',backgroundColor:'#01a982',width:'10%',marginLeft:'2px'},separator:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{backgroundColor:'#01a982',color:'white'}},'Next'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_CaretNext___default.a,{size:'small',colorIndex:'brand'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',align:'center',className:'NextPrevIconDisabled',alignContent:'center',style:{justifyContent:'center',width:'10%',marginLeft:'2px'},separator:'all'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{color:'darkgray'}},' Next '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_CaretNext___default.a,{size:'small',colorIndex:'brand'}))),!this.props.SSETid?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',style:{color:'#ffff',justifyContent:"center",position:'absolute',right:'16%',padding:'8px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{color:"white"}},'Click here to generate the Solution '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_icons_base_FormNextLink___default.a,{style:{stroke:'#ff8d6d'}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Button___default.a,{primary:true,label:'Cancel',id:buttonId,onClick:this.goBackToSSET,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_Revert___default.a,null),style:{width:'200px',color:'white',marginRight:'10px'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Box___default.a,{direction:'row',basis:'small',className:'NextPrevIcon',style:{flexBasis:'222px'}},SizingButton)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__CustomFooter__["a" /* default */],null));}}]);return Build;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{allSessions:state.sessions.sessions,activeSession:state.sessions.activeSession,treeView:state.sessions.activeSession.treeView,TitleCaption:state.sessions.sessionDefaults.inputs.Sizers,//DefaultInputs: state.sessions.sessionDefaults.inputs.Sizers.Sizer,
GlobalErr:state.sessions.activeSession.globalError,isSizeEnabled:state.sessions.activeSession.isSizeEnabled,country:state.sessions.Country,OverrideMsg:state.sessions.overrideMsg,toastNotification:state.sessions.notificationMsg,Redirect:state.sessions.redirect,UserID:state.auth.userData.hpclname,UserName:state.auth.userData.username,sizerWorkLoad:state.sizerWorkload.workload,workloadTemplate:state.sessions.sessionDefaults.workload,validation:state.sizerWorkload.validation,sizeError:state.sessions.activeSession.sizingFailed,blueDataworkloadTemplate:state.sessions.sessionDefaults.blueDataWorkload,tdiWorkloadTemplate:state.sessions.sessionDefaults.tdiWorkload,indexes:state.sizerWorkload.Indexes,SSETid:state.sessions.SSETid,SSETUrl:state.sessions.SSETUrl,guiState:state.sizerWorkload.guiState,sessionsData:state.sessions.ssetConfigurations,DefaultInputs:state.sessions.sessionDefaults.inputs};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onShowLoading:function onShowLoading(){var message='Please Wait..';dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["V" /* showLoading */])(message));},onAddSession:function onAddSession(id,name){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["e" /* addSession */])(id,name));},onChangeSession:function onChangeSession(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["f" /* changeSession */])(id));},onDeleteSession:function onDeleteSession(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["j" /* deleteSession */])(id));},onUpdateSession:function onUpdateSession(session){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["Z" /* updateSession */])(session));},updateError:function updateError(errorMsg){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["p" /* errorValidataion */])(errorMsg));},onGetSolution:function onGetSolution(workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["E" /* getSolution */])(workload));},onGetAdvancedSolution:function onGetAdvancedSolution(workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["D" /* getAdvancedSolution */])(workload));},onSaveCurrentSession:function onSaveCurrentSession(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["c" /* SaveCurrentSession */])());},onSaveWorkload:function onSaveWorkload(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["S" /* saveWorkload */])(sessionID));},onDisableconflicts:function onDisableconflicts(){dispatch({type:'DISMISS_CONFLICTS'});},onCloseToast:function onCloseToast(){dispatch({type:'DISMISS_TOAST'});},OnToggleSizeButton:function OnToggleSizeButton(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["W" /* toggleSizeButton */])(value));},onRedirectPage:function onRedirectPage(isTrue,path){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["J" /* redirectPage */])(isTrue,path));},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});},onUpdateActiveSession:function onUpdateActiveSession(workload){dispatch({type:'UPDATE_Active_WORKLOAD',payload:workload});},onValidateWorkload:function onValidateWorkload(url,workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["_1" /* validateWorkload */])(url,workload));},OpenedSaveWorkload:function OpenedSaveWorkload(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["T" /* saveworkloadopened */])(value));},ClearCompareData:function ClearCompareData(){dispatch({type:'CLEAR_COMPARE_DATA'});},onUpdateDefaultSession:function onUpdateDefaultSession(inputs){dispatch({type:'UPDATE_SESSION_DEFAULTS',payload:inputs});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Build));

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Responsive = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SPLIT;

var Split = function (_Component) {
  _inherits(Split, _Component);

  function Split(props, context) {
    _classCallCheck(this, Split);

    var _this = _possibleConstructorReturn(this, (Split.__proto__ || Object.getPrototypeOf(Split)).call(this, props, context));

    _this._onResize = _this._onResize.bind(_this);
    _this._layout = _this._layout.bind(_this);

    _this.state = { responsive: undefined };
    return _this;
  }

  _createClass(Split, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this._onResize);
      this._layout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If we change the number of visible children, trigger a resize event
      // so things like Table header can adjust. This will go away once
      // CSS supports per element media queries.
      // The 500ms delay is loosely tied to the CSS animation duration.
      // We want any animations to finish before triggering the resize.
      // TODO: consider using an animation end event instead of a timer.
      if (this._nonNullChildCount(nextProps) !== this._nonNullChildCount(this.props)) {
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(function () {
          var event = document.createEvent('HTMLEvents');
          event.initEvent('resize', true, false);
          window.dispatchEvent(event);
        }, 500);
      }
      this.setState({ relayout: true });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.relayout) {
        this.setState({ relayout: false });
        this._layout();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._onResize);
    }

    // Support function for componentWillReceiveProps()

  }, {
    key: '_nonNullChildCount',
    value: function _nonNullChildCount(props) {
      var result = 0;
      _react2.default.Children.forEach(props.children, function (child) {
        if (child) result += 1;
      });
      return result;
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      // debounce
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(this._layout, 50);
    }
  }, {
    key: '_setResponsive',
    value: function _setResponsive(responsive) {
      if (this.state.responsive !== responsive) {
        this.setState({ responsive: responsive });
        if (this.props.onResponsive) {
          this.props.onResponsive(responsive);
        }
      }
    }
  }, {
    key: '_layout',
    value: function _layout() {
      var splitElement = this.splitRef;
      if (splitElement) {
        if (splitElement.offsetWidth <= (0, _Responsive.smallSize)() && this.props.showOnResponsive === 'priority') {
          this._setResponsive('single');
        } else {
          this._setResponsive('multiple');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          fixed = _props.fixed,
          flex = _props.flex,
          priority = _props.priority,
          separator = _props.separator,
          props = _objectWithoutProperties(_props, ['children', 'className', 'fixed', 'flex', 'priority', 'separator']);

      delete props.onResponsive;
      delete props.showOnResponsive;
      var responsive = this.state.responsive;

      var classes = (0, _classnames3.default)(CLASS_ROOT, className);

      var boxedChildren = !Array.isArray(children) ? children : children.map(function (child, index) {
        var _classnames;

        if (!child) {
          // skip the empty children but keep original index
          // this avoid the right element to remount
          return undefined;
        }
        var lastChild = index === children.length - 1;
        var hidden = void 0;
        var childFlex = true;
        // When we only have room to show one child, hide the appropriate one
        if ('single' === responsive && ('left' === priority && index > 0 || 'right' === priority && index === 0 && children.length > 1)) {
          hidden = true;
        } else if (children.length > 1 && (flex === 'right' && index === 0 || flex === 'left' && lastChild)) {
          childFlex = false;
        } else {
          childFlex = true;
        }
        var classes = (0, _classnames3.default)(CLASS_ROOT + '__column', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__column--fixed', fixed), _defineProperty(_classnames, CLASS_ROOT + '__column--hidden', hidden), _defineProperty(_classnames, CLASS_ROOT + '__column--flex', childFlex), _defineProperty(_classnames, CLASS_ROOT + '__column--separator', separator && !lastChild), _classnames));
        // Don't use a Box here because we don't want to constrain the child
        // in a flexbox container.
        return _react2.default.createElement(
          'div',
          { key: index, className: classes },
          child
        );
      });

      return _react2.default.createElement(
        'div',
        _extends({ ref: function ref(_ref) {
            return _this2.splitRef = _ref;
          } }, props, { className: classes }),
        boxedChildren
      );
    }
  }]);

  return Split;
}(_react.Component);

Split.displayName = 'Split';
exports.default = Split;


Split.propTypes = {
  children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
  fixed: _propTypes2.default.bool,
  flex: _propTypes2.default.oneOf(['left', 'right', 'both']),
  onResponsive: _propTypes2.default.func,
  priority: _propTypes2.default.oneOf(['left', 'right']),
  separator: _propTypes2.default.bool,
  showOnResponsive: _propTypes2.default.oneOf(['priority', 'both'])
};

Split.defaultProps = {
  fixed: true,
  flex: 'both',
  priority: 'right',
  showOnResponsive: 'priority'
};
module.exports = exports['default'];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(303);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(599);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 596 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(600);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(602);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(603);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(604);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _PropTypes = __webpack_require__(305);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(187);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(601));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(187);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(304));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(187);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(304));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _OK = __webpack_require__(606);

var _OK2 = _interopRequireDefault(_OK);

var _CriticalStatus = __webpack_require__(607);

var _CriticalStatus2 = _interopRequireDefault(_CriticalStatus);

var _Warning = __webpack_require__(608);

var _Warning2 = _interopRequireDefault(_Warning);

var _Disabled = __webpack_require__(609);

var _Disabled2 = _interopRequireDefault(_Disabled);

var _Unknown = __webpack_require__(610);

var _Unknown2 = _interopRequireDefault(_Unknown);

var _Blank = __webpack_require__(611);

var _Blank2 = _interopRequireDefault(_Blank);

var _Label = __webpack_require__(612);

var _Label2 = _interopRequireDefault(_Label);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var Status = function (_Component) {
  _inherits(Status, _Component);

  function Status() {
    _classCallCheck(this, Status);

    return _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).apply(this, arguments));
  }

  _createClass(Status, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          size = _props.size,
          value = _props.value,
          props = _objectWithoutProperties(_props, ['className', 'size', 'value']);

      var classes = (0, _classnames3.default)(_defineProperty({}, CLASS_ROOT + '--' + size, size), className);

      var icon = _react2.default.createElement(
        'span',
        null,
        '?'
      );
      switch (value.toLowerCase()) {
        case 'ok':
        case 'normal':
          icon = _react2.default.createElement(_OK2.default, _extends({}, props, { className: classes }));
          break;
        case 'warning':
          icon = _react2.default.createElement(_Warning2.default, _extends({}, props, { className: classes }));
          break;
        case 'critical':
          icon = _react2.default.createElement(_CriticalStatus2.default, _extends({}, props, { className: classes }));
          break;
        case 'disabled':
          icon = _react2.default.createElement(_Disabled2.default, _extends({}, props, { className: classes }));
          break;
        case 'unknown':
          icon = _react2.default.createElement(_Unknown2.default, _extends({}, props, { className: classes }));
          break;
        case 'blank':
          icon = _react2.default.createElement(_Blank2.default, _extends({}, props, { className: classes }));
          break;
        case 'label':
          icon = _react2.default.createElement(_Label2.default, _extends({}, props, { className: classes }));
          break;
      }
      return icon;
    }
  }]);

  return Status;
}(_react.Component);

Status.displayName = 'Status';
exports.default = Status;


Status.propTypes = {
  a11yTitle: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  value: _propTypes2.default.oneOf(['critical', 'warning', 'ok', 'unknown', 'disabled', 'label', 'Critical', 'Warning', 'OK', 'Unknown', 'Disabled', 'Label', 'blank'])
};

Status.defaultProps = {
  value: 'unknown'
};
module.exports = exports['default'];

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var _lastId = 0;

var OK = function (_Component) {
  _inherits(OK, _Component);

  function OK() {
    _classCallCheck(this, OK);

    return _possibleConstructorReturn(this, (OK.__proto__ || Object.getPrototypeOf(OK)).apply(this, arguments));
  }

  _createClass(OK, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-ok', className);
      // generate an id to avoid duplication in the DOM
      var maskId = 'mask-ok-' + _lastId++;
      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
          'aria-label': a11yTitle, version: '1.1' }),
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement(
            'mask',
            { id: maskId },
            _react2.default.createElement(
              'g',
              { className: CLASS_ROOT + '__detail' },
              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
              _react2.default.createElement('path', { d: 'M10,17.4 L5.3,12.7 L6.7,11.3 L10,14.6 L17.3,7.3 ' + 'L18.7,8.7 L10,17.4 Z', stroke: 'none', fill: '#000' })
            )
          )
        ),
        _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', stroke: 'none' })
        )
      );
    }
  }]);

  return OK;
}(_react.Component);

OK.displayName = 'OK';
exports.default = OK;


OK.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string
};

OK.defaultProps = {
  a11yTitle: 'OK'
};
module.exports = exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var _lastId = 0;

var CriticalStatus = function (_Component) {
  _inherits(CriticalStatus, _Component);

  function CriticalStatus() {
    _classCallCheck(this, CriticalStatus);

    return _possibleConstructorReturn(this, (CriticalStatus.__proto__ || Object.getPrototypeOf(CriticalStatus)).apply(this, arguments));
  }

  _createClass(CriticalStatus, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-critical', className);
      // generate an id to avoid duplication in the DOM
      var maskId = 'mask-critical-' + _lastId++;
      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
          version: '1.1', 'aria-label': a11yTitle }),
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement(
            'mask',
            { id: maskId },
            _react2.default.createElement(
              'g',
              { className: CLASS_ROOT + '__detail' },
              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
              _react2.default.createElement('path', { d: 'M8,8 L16,16', strokeWidth: '2', stroke: '#000', fill: 'none' }),
              _react2.default.createElement('path', { d: 'M8,16 L16,8', strokeWidth: '2', stroke: '#000', fill: 'none' })
            )
          )
        ),
        _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
          _react2.default.createElement('path', { d: 'M12,0 L24,12 L12,24 L0,12 Z', stroke: 'none' })
        )
      );
    }
  }]);

  return CriticalStatus;
}(_react.Component);

CriticalStatus.displayName = 'CriticalStatus';
exports.default = CriticalStatus;


CriticalStatus.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string
};

CriticalStatus.defaultProps = {
  a11yTitle: 'Critical'
};
module.exports = exports['default'];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var _lastId = 0;

var Warning = function (_Component) {
  _inherits(Warning, _Component);

  function Warning() {
    _classCallCheck(this, Warning);

    return _possibleConstructorReturn(this, (Warning.__proto__ || Object.getPrototypeOf(Warning)).apply(this, arguments));
  }

  _createClass(Warning, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-warning', className);
      // generate an id to avoid duplication in the DOM
      var maskId = 'mask-warning-' + _lastId++;
      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
          'aria-label': a11yTitle, version: '1.1' }),
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement(
            'mask',
            { id: maskId },
            _react2.default.createElement(
              'g',
              { className: CLASS_ROOT + '__detail' },
              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
              _react2.default.createElement(
                'g',
                { strokeWidth: '2', stroke: '#000',
                  transform: 'translate(11.000000, 8.000000)' },
                _react2.default.createElement('path', { role: 'presentation', d: 'M1,0 L1,6', fill: 'none' }),
                _react2.default.createElement('path', { role: 'presentation', d: 'M1,8 L1,10', fill: 'none' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
          _react2.default.createElement('path', { role: 'presentation', d: 'M12,0 L0,22 L24,22 L12,0 L12,0 Z',
            stroke: 'none' })
        )
      );
    }
  }]);

  return Warning;
}(_react.Component);

Warning.displayName = 'Warning';
exports.default = Warning;


Warning.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string
};

Warning.defaultProps = {
  a11yTitle: 'Warning'
};
module.exports = exports['default'];

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var _lastId = 0;

var Disabled = function (_Component) {
  _inherits(Disabled, _Component);

  function Disabled() {
    _classCallCheck(this, Disabled);

    return _possibleConstructorReturn(this, (Disabled.__proto__ || Object.getPrototypeOf(Disabled)).apply(this, arguments));
  }

  _createClass(Disabled, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-disabled', className);
      // generate an id to avoid duplication in the DOM
      var maskId = 'mask-disabled-' + _lastId++;
      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
          version: '1.1', 'aria-label': a11yTitle }),
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement(
            'mask',
            { id: maskId },
            _react2.default.createElement(
              'g',
              { className: CLASS_ROOT + '__detail' },
              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
              _react2.default.createElement('path', { d: 'M6,12 L18,12', strokeWidth: '2', stroke: '#000' })
            )
          )
        ),
        _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
          _react2.default.createElement('path', { stroke: 'none',
            d: 'M21,24 L3,24 C1.3,24 0,22.7 0,21 L0,3 C0,1.3 1.3,0 3,0 ' + 'L21,0 C22.7,0 24,1.3 24,3 L24,21 C24,22.7 22.7,24 21,24 ' + 'L21,24 Z' })
        )
      );
    }
  }]);

  return Disabled;
}(_react.Component);

Disabled.displayName = 'Disabled';
exports.default = Disabled;


Disabled.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string
};

Disabled.defaultProps = {
  a11yTitle: 'Disabled'
};
module.exports = exports['default'];

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var _lastId = 0;

var Unknown = function (_Component) {
  _inherits(Unknown, _Component);

  function Unknown() {
    _classCallCheck(this, Unknown);

    return _possibleConstructorReturn(this, (Unknown.__proto__ || Object.getPrototypeOf(Unknown)).apply(this, arguments));
  }

  _createClass(Unknown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-unknown', className);
      // generate an id to avoid duplication in the DOM
      var maskId = 'mask-uknown-' + _lastId++;
      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
          'aria-label': a11yTitle, version: '1.1' }),
        _react2.default.createElement(
          'defs',
          null,
          _react2.default.createElement(
            'mask',
            { id: maskId },
            _react2.default.createElement(
              'g',
              { className: CLASS_ROOT + '__detail' },
              _react2.default.createElement('rect', { x: '0', y: '0', width: '24', height: '24', fill: '#fff' }),
              _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10', stroke: 'none', fill: '#000' }),
              _react2.default.createElement('path', {
                d: 'M9,10.4 C9,8.8 10.4,7.6 12,7.6 C13.6,7.6 14.9,9 15,10.4 ' + 'C15,11.7 14.1,12.7 12.9,13.1 C12.4,13.2 12,13.7 12,14.2 ' + 'L12,15.5', fill: 'none', strokeWidth: '2', stroke: '#fff' }),
              _react2.default.createElement('circle', { stroke: 'none', cx: '12', cy: '17.6', r: '1', fill: '#fff' })
            )
          )
        ),
        _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__base', mask: 'url(#' + maskId + ')' },
          _react2.default.createElement('circle', { className: CLASS_ROOT + '__normal',
            cx: '12', cy: '12', r: '12', stroke: 'none' }),
          _react2.default.createElement('circle', { className: CLASS_ROOT + '__small',
            cx: '12', cy: '12', r: '11', strokeWidth: '3', fill: 'none' })
        )
      );
    }
  }]);

  return Unknown;
}(_react.Component);

Unknown.displayName = 'Unknown';
exports.default = Unknown;


Unknown.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string
};

Unknown.defaultProps = {
  a11yTitle: 'Unknown'
};
module.exports = exports['default'];

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var Blank = function (_Component) {
  _inherits(Blank, _Component);

  function Blank() {
    _classCallCheck(this, Blank);

    return _possibleConstructorReturn(this, (Blank.__proto__ || Object.getPrototypeOf(Blank)).apply(this, arguments));
  }

  _createClass(Blank, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['a11yTitle', 'className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-blank', className);
      return _react2.default.createElement('svg', _extends({}, props, { className: classes, viewBox: '0 0 24 24', role: 'img',
        version: '1.1', 'aria-label': a11yTitle }));
    }
  }]);

  return Blank;
}(_react.Component);

Blank.displayName = 'Blank';
exports.default = Blank;


Blank.propTypes = {
  a11yTitle: _propTypes2.default.string,
  className: _propTypes2.default.string
};

Blank.defaultProps = {
  a11yTitle: 'Blank'
};
module.exports = exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.STATUS_ICON;

var Label = function (_Component) {
  _inherits(Label, _Component);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['className']);

      var classes = (0, _classnames2.default)(CLASS_ROOT, CLASS_ROOT + '-label', className);
      return _react2.default.createElement(
        'svg',
        _extends({}, props, { className: classes, viewBox: '0 0 24 24', version: '1.1' }),
        _react2.default.createElement(
          'g',
          { className: CLASS_ROOT + '__base' },
          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', stroke: 'none' })
        )
      );
    }
  }]);

  return Label;
}(_react.Component);

Label.displayName = 'Label';
exports.default = Label;
module.exports = exports['default'];

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-home', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'home');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,11 L12,2 L23,11 M15,23 L15,15 L15,15 L9,15 L9,23 M4,23 L4,9 M20,23 L20,9' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Home';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-user-add', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'user-add');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M5,24 L5,19 M11,24 L11,19 M1,24 L1,18 C1,13.0294373 4.13400675,11 8,11 C11.8659932,11 15,13 15,18 L15,24 M8,11 C10.7614237,11 13,8.76142375 13,6 C13,3.23857625 10.7614237,1 8,1 C5.23857625,1 3,3.23857625 3,6 C3,8.76142375 5.23857625,11 8,11 Z M16,11 L24,11 M20,7 L20,15' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'UserAdd';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-contract', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'contract');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,14 L10,14 L10,22 M1,23 L10,14 M23,1 L14,10 M22,10 L14,10 L14,2' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Contract';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-services', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'services');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M6,9 C7.65685425,9 9,7.65685425 9,6 C9,4.34314575 7.65685425,3 6,3 C4.34314575,3 3,4.34314575 3,6 C3,7.65685425 4.34314575,9 6,9 Z M6,3 L6,0 M6,12 L6,9 M0,6 L3,6 M9,6 L12,6 M2,2 L4,4 M8,8 L10,10 M10,2 L8,4 M4,8 L2,10 M18,12 C19.6568542,12 21,10.6568542 21,9 C21,7.34314575 19.6568542,6 18,6 C16.3431458,6 15,7.34314575 15,9 C15,10.6568542 16.3431458,12 18,12 Z M18,6 L18,3 M18,15 L18,12 M12,9 L15,9 M21,9 L24,9 M14,5 L16,7 M20,11 L22,13 M22,5 L20,7 M16,11 L14,13 M9,21 C10.6568542,21 12,19.6568542 12,18 C12,16.3431458 10.6568542,15 9,15 C7.34314575,15 6,16.3431458 6,18 C6,19.6568542 7.34314575,21 9,21 Z M9,15 L9,12 M9,24 L9,21 M3,18 L6,18 M12,18 L15,18 M5,14 L7,16 M11,20 L13,22 M13,14 L11,16 M7,20 L5,22' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Services';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-caret-previous', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'caret-previous');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('polygon', { fill: 'none', stroke: '#000', strokeWidth: '2', points: '6 2 18 12 6 22', transform: 'matrix(-1 0 0 1 24 0)' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'CaretPrevious';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-menu', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'menu');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2,19 L22,19 M2,5 L22,5 M2,12 L22,12' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Menu';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Close__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Footer from 'grommet/components/Footer';
//import Paragraph from 'grommet/components/Paragraph';
//import Menu from 'grommet/components/Menu';
//import Anchor from 'grommet/components/Anchor';
//import BrandHpeElementPath from 'grommet/components/icons/base/BrandHpeElementPath';
var CustomFooter=function(_Component){_inherits(CustomFooter,_Component);function CustomFooter(props){_classCallCheck(this,CustomFooter);var _this=_possibleConstructorReturn(this,(CustomFooter.__proto__||Object.getPrototypeOf(CustomFooter)).call(this,props));_this.state={OtherSizers:false};_this.closePopUps=_this.closePopUps.bind(_this);_this.OtherSizersClick=_this.OtherSizersClick.bind(_this);return _this;}_createClass(CustomFooter,[{key:'OtherSizersClick',value:function OtherSizersClick(){this.setState({OtherSizers:true});}},{key:'closePopUps',value:function closePopUps(){this.setState({OtherSizers:false});}},{key:'render',value:function render(){var OtherSizersPlaceHolder;if(this.state.OtherSizers){OtherSizersPlaceHolder=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',className:'OtherSizersContent',style:{width:'13%',height:'20%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{backgroundColor:'#fff',border:'2px solid #614767'},className:''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'end',onClick:this.closePopUps},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Close___default.a,{size:'small',className:'CloseIconStyle'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'small',align:'end'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',textAlign:'center'},className:'secondary'},'Information on Other Sizers available '))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',className:'triangle-down',style:{margin:'auto'}})));}else{OtherSizersPlaceHolder="";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none'});}}]);return CustomFooter;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,null)(CustomFooter));

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__State_constants_CommonConstants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_TextInput__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_TextInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TextInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_DocumentDownload__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_DocumentDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_DocumentDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_Directions__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_Directions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_Directions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Link__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Link___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Link__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_Bundle__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_Bundle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_Bundle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_FormNextLink__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_FormNextLink___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_FormNextLink__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Money__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Money___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Money__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_Troubleshoot__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_Troubleshoot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_Troubleshoot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_CircleInformation__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_CircleInformation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_CircleInformation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Analytics__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__CustomArticle__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Recom_Soln__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__BOM__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__LoadFiles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ConfigurationDetails__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__GraphicalRepresentation__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__MetricsData__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__MetricsData_vNext__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__SimpleWarning__ = __webpack_require__(710);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Label from 'grommet/components/Label';
// import Image from 'grommet/components/Image';
//import CatalogIcon from 'grommet/components/icons/base/Catalog';
//import Compare from './Compare';
//let CompareSolutionFirstCall = false
var MetricsDataFirstClick=false;//let PreviousName = '';
var SolutionAlternativeTabsContent=void 0;var ArraysCount=false;//var TraditionalArray = [];
var Com='';var showDelLayer='';var CombineRack=[];var CombineRackSecond=[];var ComputeNodeArray=[];var ComputeNodeSecondSolArray=[];var totalNumOfRows=[];var RolesList=[];//let dumm = [];
var data=[];var Note='';var SavedSolutionname='';var compare='';var compareSolution1Options=["Growth - 1Y","Growth - 2Y","Growth - 3Y"];var compareSolution2Options=[];var compareSolution1value=compareSolution1Options[0];var compareSolution2value="Growth - 2Y";var EPAId='EPAvNext';var BLUE_DATA="BlueData";var growthWarning='The loaded solution was associated with growth sizing.  To re-generate all 3 solutions, go to the Infrastructure screen and resize.';var EPA_SOLUTION_ITEMS=['Elastic Config','Growth - 2Y','Growth - 3Y','Compare Solution'];var EZMERAL_SOLUTION_ITEMS=['Elastic Config','Growth - 2Y','Growth - 3Y','Growth - 4Y','Compare Solution'];var NONGROWTH_SOLUTION_ITEMS=['Elastic Config','Compare Solution'];var GROWTH_4Y="Growth - 4Y";var OLDWL_TEXT="The workload inputs are for older version of SAPHANA Appliance, please review and update the workload inputs to build new SAPHANA Appliance solution";var SolnAlternative=function(_Component){_inherits(SolnAlternative,_Component);function SolnAlternative(props){_classCallCheck(this,SolnAlternative);var _this=_possibleConstructorReturn(this,(SolnAlternative.__proto__||Object.getPrototypeOf(SolnAlternative)).call(this,props));_this.compareSolution12Change=function(e){if(e.target.name==="compareSolution1"){compareSolution1value=e.option;}else if(e.target.name==="compareSolution2"){compareSolution2value=e.option;if(e.option==="Browse"){_this.compareSolnMethod(e,true);}}_this.setState({dropDownState:true});};_this.populateStorageVolumes=function(tableData){var StorageVolume=[];var strVolume="";tableData.map(function(Volume){StorageVolume.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});StorageVolume.map(function(disk,id){if(id===StorageVolume.length-1){strVolume+=disk;}else{strVolume+=disk+"   ";}});return strVolume;};_this.state={showSaveSolution:false,showDupSoLPopup:false,SessionName:'',CurrentSession:{},SolutionObj:'',RoleObj:'',RoleItems:'',SharedRoleObj:'',SharedRoleItems:'',activeTab:0,ServQty:0,HomePageJson:[],AdditionalInfoPop:false,GRPresent:false,GRPresentStatic:false,MetricsDataPresent:false,ActiveSoln:null,ActiveSolTabClass:'',RackItem:'',showDelSession:true,activeSoltab:0,ComapareSolState:false,compareSolutionTabactive:false,CloseErrorLayer:false,flag:false,header1:'',dropDownState:false};_this.GrClose=_this.GrClose.bind(_this);_this.ClosePopup=_this.ClosePopup.bind(_this);_this.SessionTxtChange=_this.SessionTxtChange.bind(_this);_this.SaveSolution=_this.SaveSolution.bind(_this);_this.ShowDelSession=_this.ShowDelSession.bind(_this);_this.onSaveSolutionSubmit=_this.onSaveSolutionSubmit.bind(_this);_this.onSaveSolutionIconClick=_this.onSaveSolutionIconClick.bind(_this);_this.Submit_Update_Session=_this.Submit_Update_Session.bind(_this);_this.OverrideSolMsgYesClick=_this.OverrideSolMsgYesClick.bind(_this);_this.OverrideSolMsgNoClick=_this.OverrideSolMsgNoClick.bind(_this);_this.MetricsDataBtnClick=_this.MetricsDataBtnClick.bind(_this);_this.MetricsDataClose=_this.MetricsDataClose.bind(_this);_this.GrPresentation=_this.GrPresentation.bind(_this);_this.GrPresentationStatic=_this.GrPresentationStatic.bind(_this);_this.downloadFiles=_this.downloadFiles.bind(_this);_this.updateSolutionTreeView=_this.updateSolutionTreeView.bind(_this);_this.SelectActiveSolutionTab=_this.SelectActiveSolutionTab.bind(_this);_this.CompareSolution=_this.CompareSolution.bind(_this);_this._handleOnPaste=_this._handleOnPaste.bind(_this);_this.compareSolnMethod=_this.compareSolnMethod.bind(_this);_this.CloseDelSession=_this.CloseDelSession.bind(_this);_this.handleClose=_this.handleClose.bind(_this);_this.onStartGuidance=_this.onStartGuidance.bind(_this);return _this;}_createClass(SolnAlternative,[{key:'handleClose',value:function handleClose(){Com='';this.setState({flag:false});}},{key:'SaveSolname',value:function SaveSolname(value,id){SavedSolutionname=value;var compareSolutionObj={SavedSolutionName:value,selectedselection:id};this.props.SavedSolname(compareSolutionObj);compareSolution2value=value;this.props.activeSession.selectedTitles.compareSolution2value=value;}},{key:'compareSolnMethod',value:function compareSolnMethod(e,isfromBrowse){if(this.props.activeSession.EPAArray.length>0&&!isfromBrowse){var value=void 0;if(this.props.activeSession.SavedSolname&&this.props.activeSession.SavedSolname.SavedSol===compareSolution2value){value={"SessionID":this.props.activeSession.id,"SessionIDsaved":this.props.activeSession.SavedSolname.savedId,"EPASolutionType":compareSolution1value.split('-')[1].trim()[0]};}else{var solutionType=compareSolution1value.split('-')[1].trim()[0];solutionType+=':';solutionType+=compareSolution2value.split('-')[1].trim()[0];value={"SessionID":this.props.activeSession.id,"EPASolutionType":solutionType//this.SaveSolname(compareSolution2value);
};}this.props.OnComparedata(value);}else{this.state.flag=true;compareSolution2value='Growth - 1Y';Com=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{margin:'none',pad:'small',style:{width:'100% !important',zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__LoadFiles__["a" /* default */],{title:"Solution",onClose:this.handleClose,flag:this.state.flag,Savedname:this.SaveSolname.bind(this),solutionIndex:isfromBrowse?compareSolution1value.split('-')[1].trim()[0]:null}));}this.props.activeSession.selectedTitles={compareSolution1value:compareSolution1value,compareSolution2value:compareSolution2value};this.setState({header1:compareSolution1value,dropDownState:false});}},{key:'_handleOnPaste',value:function _handleOnPaste(e){e.preventDefault();}},{key:'onStartGuidance',value:function onStartGuidance(){showDelLayer='';var workload={"WorkLoad":{}};this.props.activeSession.workload=JSON.parse(JSON.stringify(this.props.workload));workload.WorkLoad=this.props.activeSession.workload;var obj={"Workload":workload,"SizerSessionId":this.props.activeSession.id,"ReferenceId":1,"isSizerAsEntry":true,"GuidanceName":"testName","EPASolutionType":this.props.activeSession.EPAArray.length>0?(this.state.ActiveSoln+1).toString():null};if(['CS750VirtSizer','SynergySizer',"EPAvNext",'SAPHANA'].indexOf(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */])!==-1){//  this.props.OnToggleSizeButton(false);       
if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPAvNext'){obj.Workload.WorkLoad.strSizerName="EPA vNext Sizing Tool";}else if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='SAPHANA'){var toolName="SAP HANA Sizing Tool";obj.Workload.WorkLoad.strSizerName=toolName;}else{obj.Workload=obj.Workload.WorkLoad;}this.props.onGetAdvancedSolution(obj);}this.setState({showDelSession:true});}},{key:'ShowDelSession',value:function ShowDelSession(networkError){showDelLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StartGuidanceLayer,{errorDisplay:networkError,showDelSession:this.state.showDelSession,CloseDelSession:this.CloseDelSession,StartGuidance:this.onStartGuidance,sessionsCount:this.props.allSessions.length});this.setState({showDelSession:true});}},{key:'SelectActiveSolutionTab',value:function SelectActiveSolutionTab(val,id){if(this.state.ActiveSoln!==id){this.state.activeSoltab=id;if(this.props.activeSession.EPAArray.length>0&&val!=="Compare Solution"){this.state.ComapareSolState=false;this.setState({ActiveSoln:id});id=id+1;if(this.props.activeSession.treeView.Solutions.Solution.SolProfile["@ID"]!==id.toString()){this.state.activeTab=0;this.props.onEPAActvSolnChange({"actvItem":id});RolesList=[];totalNumOfRows=[];ComputeNodeArray=[];//TraditionalArray = [];
this.state.ComapareSolState=false;this.props.activeSession.MultipleSolActiveTab=val;}}else{// RolesList=[];
// totalNumOfRows= [];
this.setState({ActiveSoln:id});if(id>0){this.CompareSolution();}else{this.state.ComapareSolState=false;}// ComputeNodeArray=[];
// TraditionalArray=[];   
}}}},{key:'CompareSolution',value:function CompareSolution(){// if (said === 'EPA' || said === 'EPAvNext') {
//   if (CompareSolutionFirstCall) {
//     CompareSolutionFirstCall = false
//     this.props.onFetchCompareSolution({ 'SessionID': this.props.activeSession.id })
//   }
// }
this.setState({ComapareSolState:true});}},{key:'downloadFiles',value:function downloadFiles(fileType,said){var sessionObject=this.props.activeSession.id;var id;switch(said){case'SAPHANA':id='Sap Hana Sizing Tool';break;case'CS750VirtSizer':id='CS750VirtSizer';break;case'SynergySizer':id='SynergySizer';break;case'EPA':id='EPA';break;}var mapForm=document.createElement("form");mapForm.id="FormExportBOM";mapForm.setAttribute("method","GET");mapForm.setAttribute("action",__WEBPACK_IMPORTED_MODULE_39__AppConfig__["g" /* serviceUrl */]+"SizingEngine/GenerateOCADocument");mapForm.target="_blank";var mapInput1=document.createElement("input");mapInput1.id="BomHTMLTemp1";mapInput1.type="text";mapInput1.name="format";mapInput1.value=fileType;mapForm.appendChild(mapInput1);var mapInput=document.createElement("input");mapInput.id="BomHTMLTemp";mapInput.type="text";mapInput.name="sessionId";mapInput.value=sessionObject.toString();mapForm.appendChild(mapInput);var mapInput2=document.createElement("input");mapInput2.id="BomHTMLTemp";mapInput2.type="text";mapInput2.name="said";mapInput2.value=id;mapForm.appendChild(mapInput2);var mapInput3=document.createElement("input");mapInput3.id="BomHTMLTemp";mapInput3.type="text";mapInput3.name="version";mapInput3.value=__WEBPACK_IMPORTED_MODULE_39__AppConfig__["i" /* version */];mapForm.appendChild(mapInput3);document.body.appendChild(mapForm);mapForm.submit();__WEBPACK_IMPORTED_MODULE_40_jquery___default()("#FormExportBOM").remove();}},{key:'componentDidMount',value:function componentDidMount(){// if( this.props.DefaultInputs.Sizers.Sizer['@name'] === 'SAP HANA Sizing Tool'){
//     if( this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.OracleProfileData['RequestorEmail'] === '' ||
//       this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.OracleProfileData['RequestorEmail'] === null ){
//       this.props.activeSession.workload.UserInputs.Environments.ProductionEnvironment.OracleProfileData['RequestorEmail'] = '';
//     }
// }
if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPA'||__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPAvNext'){//      CompareSolutionFirstCall = true
MetricsDataFirstClick=true;this.state.activeSoltab=parseInt(this.props.activeSession.treeView.Solutions.Solution.SolProfile['@ID'],10)-1;this.state.ActiveSoln=this.state.activeSoltab;//   this.props.onFetchCompareSolution({'SessionID': this.props.activeSession.id}) 
//   this.props.onFetchMetricsData({'SessionID': this.props.activeSession.id}) 
//  this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id}) 
}// if ((said === 'EPA' && this.props.activeSession.EPAArray.length > 0) || (said === 'EPAvNext' && this.props.activeSession.EPAArray.length > 0) || (said === 'EPAvNext')) {
//   this.setState({ ActiveSoln: 'Elastic Config' });
// }
this.state.CurrentSession=this.props.activeSession;this.state.SessionName=this.props.activeSession.alias;if(this.props.activeSession.treeView!==''){this.state.HomePageJson=this.props.DefaultInputs;this.updateSolutionTreeView(this.props.activeSession.treeView.Solutions);// this.updateSolutionTreeView(CSVirtTreeView.Solutions); 
}}},{key:'updateSolutionTreeView',value:function updateSolutionTreeView(SolTreeView){var _this2=this;this.state.SolutionObj=SolTreeView;// this.state.SolutionObj = CSVirtSoln;
this.state.RoleObj={};this.state.SharedRoleObj={};this.state.RoleItems=this.state.SolutionObj.Solution.Roles.Role;this.state.SharedRoleItems=this.state.SolutionObj.Solution.Roles.SharedRole;if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='CS750VirtSizer'&&this.props.workload.Workload.UserInputs.WorkloadInputMode==="Simple"&&this.props.workload.Workload.UserInputs.ThreePAR==="True"&&this.state.SharedRoleItems!==undefined&&this.state.SharedRoleItems!==''&&this.state.SharedRoleItems.SAN.StorageBoxes>2){ArraysCount=true;}else{ArraysCount=false;}var ServQty=0;if(Array.isArray(this.state.RoleItems)){this.state.RoleItems.map(function(roleitem,index){if(roleitem['@DisplayName']===undefined||roleitem['@DisplayName']===''){_this2.state.RoleObj[roleitem['RoleName']]=roleitem;if(roleitem['RoleName']!=='HPE ConvergedSystem'){if(roleitem['ServerName']!==undefined&&roleitem['ServerName']!==null){ServQty+=parseInt(roleitem['ServerName']['@Qty'],10);}}}else{_this2.state.RoleObj[roleitem['@DisplayName']]=roleitem;if(roleitem['@DisplayName']!=='HPE ConvergedSystem'){if(roleitem['ServerName']!==undefined&&roleitem['ServerName']!==null){ServQty+=parseInt(roleitem['ServerName']['@Qty'],10);}}}});}else{if(this.state.RoleItems['@DisplayName']===undefined||this.state.RoleItems['@DisplayName']===''){this.state.RoleObj[this.state.RoleItems.RoleName]=this.state.RoleItems;if(this.state.RoleItems['RoleName']!=='HPE ConvergedSystem'){if(this.state.RoleItems.ServerName!==undefined&&this.state.RoleItems.ServerName!==null){ServQty+=parseInt(this.state.RoleItems.ServerName['@Qty'],10);}}}else{this.state.RoleObj[this.state.RoleItems['@DisplayName']]=this.state.RoleItems;if(this.state.RoleItems['@DisplayName']!=='HPE ConvergedSystem'){if(this.state.RoleItems.ServerName!==undefined&&this.state.RoleItems.ServerName!==null){ServQty+=parseInt(this.state.RoleItems.ServerName['@Qty'],10);}}}}if(this.state.SharedRoleItems!==undefined){// if ( Array.isArray(this.state.SharedRoleItems) ) {
//     this.state.SharedRoleItems.map((sharedroleitem, index) => {
//       if(sharedroleitem['@DisplayName'] === undefined || sharedroleitem['@DisplayName'] === ''){
//         this.state.SharedRoleObj[ sharedroleitem['RoleName'] ] = sharedroleitem;
//       }else{
//         this.state.SharedRoleObj[ sharedroleitem['@DisplayName'] ] = sharedroleitem;
//       }
//     });
// }else{
if(!Array.isArray(this.state.SharedRoleItems)){if(this.state.SharedRoleItems['@DisplayName']===undefined||this.state.SharedRoleItems['@DisplayName']===''){this.state.SharedRoleObj[this.state.SharedRoleItems['RoleName']]=this.state.SharedRoleItems;}else{this.state.SharedRoleObj[this.state.SharedRoleItems['@DisplayName']]=this.state.SharedRoleItems;}}else{var temp=[];var sharedObj={};this.state.SharedRoleItems.forEach(function(element){if(element['@DisplayName']===undefined||element['@DisplayName']===''){sharedObj[element['RoleName']]=element;}else{sharedObj[element['@DisplayName']]=element;}temp.push(sharedObj);sharedObj={};});this.state.SharedRoleObj=temp;}// }
}if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPA'){this.state.RackItem=this.state.SolutionObj.Solution.RackSelected['@CompDesc'];}this.setState({ServQty:ServQty});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(nextProps.networkError!==this.props.networkError){if(nextProps.networkError.isError){this.ShowDelSession(nextProps.networkError);}}if(nextProps.activeSession.treeView!==''){if(nextProps.activeSession.treeView!==this.props.activeSession.treeView){if(nextProps.activeSession.treeView!==undefined){this.updateSolutionTreeView(nextProps.activeSession.treeView.Solutions);}if(nextProps.activeSession.id!=this.props.activeSession.id){if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPA'||__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPAvNext'){this.state.activeSoltab=parseInt(nextProps.activeSession.treeView.Solutions.Solution.SolProfile['@ID'],10)-1;RolesList=[];data=[];// dumm = [];
totalNumOfRows=[];ComputeNodeArray=[];//TraditionalArray = [];
this.state.ComapareSolState=false;// this.props.activeSession.MultipleSolActiveTab = 'Elastic Config';
// this.state.ActiveSoln = 'Elastic Config';            
// if (nextProps.activeSession.treeView.Solutions.Solution.SolProfile['#text'] === 'Elastic Config') {
//   this.state.activeSoltab = 0;
//   RolesList = [];
//   data = [];
//   // dumm = [];
//   totalNumOfRows = [];
//   ComputeNodeArray = [];
//   TraditionalArray = [];
//   this.state.ComapareSolState = false;
//   this.props.activeSession.MultipleSolActiveTab = 'Elastic Config';
//   this.state.ActiveSoln = 'Elastic Config';
// }
// else if (nextProps.activeSession.treeView.Solutions.Solution.SolProfile['#text'] === 'Traditional') {
//   this.state.activeSoltab = 1;
//   RolesList = [];
//   data = [];
//   // dumm = [];
//   totalNumOfRows = [];
//   ComputeNodeArray = [];
//   TraditionalArray = [];
//   this.state.ComapareSolState = false;
//   this.props.activeSession.MultipleSolActiveTab = 'Traditional';
//   this.state.ActiveSoln = 'Traditional';
// }
}}}}if(nextProps.OverrideSolMsg.isEnabled){this.state.showSaveSolution=true;this.state.showDupSoLPopup=true;}else{//this.state.showSaveSolution = false;
this.state.showDupSoLPopup=false;}if(nextProps.toastNotification.isEnabled){this.state.showSaveSolution=false;}}},{key:'AdditionalInfo',value:function AdditionalInfo(){this.setState({AdditionalInfoPop:true});}},{key:'GrPresentationStatic',value:function GrPresentationStatic(){this.state.GRPresentStatic=true;this.setState({GRPresent:true});}},{key:'GrPresentation',value:function GrPresentation(a){this.state.GRPresentStatic=false;this.setState({GRPresent:true});}},{key:'MetricsDataBtnClick',value:function MetricsDataBtnClick(){if(MetricsDataFirstClick){var obj={'SessionID':this.props.activeSession.id,'EPASolutionType':this.props.activeSession.EPAArray.length>0?(this.state.ActiveSoln+1).toString():null};this.props.onFetchMetricsData(obj);}this.setState({MetricsDataPresent:true});}},{key:'MetricsDataClose',value:function MetricsDataClose(){this.props.onClearCompareMetricsData();this.setState({MetricsDataPresent:false});}},{key:'ClosePopup',value:function ClosePopup(){this.setState({showSaveSolution:false});this.props.onDisableconflicts();}},{key:'GrClose',value:function GrClose(){this.setState({GRPresent:false,GRPresentStatic:false});}},{key:'SessionTxtChange',value:function SessionTxtChange(e){if(e.target.value.length<=25){this.setState({SessionName:e.target.value});}}},{key:'Submit_Update_Session',value:function Submit_Update_Session(){if(this.state.SessionName.trim()!==''){this.state.CurrentSession.alias=this.state.SessionName;this.props.onSaveCurrentSession();this.props.onUpdateSession(this.state.CurrentSession);if(this.props.activeSession.id===this.state.CurrentSession.id){this.props.onChangeSession(this.props.activeSession.id);}this.setState({showSaveSolution:false});}}},{key:'onSaveSolutionIconClick',value:function onSaveSolutionIconClick(){// PreviousName = this.props.activeSession.alias;
this.setState({showSaveSolution:true,SessionName:this.props.activeSession.alias});}},{key:'onSaveSolutionSubmit',value:function onSaveSolutionSubmit(){// this.state.CurrentSession = this.props.activeSession;
// this.Submit_Update_Session();
/* Changes by Vinay, changed the position of comparision operations, for CID:10016*/if(this.state.SessionName!==null&&this.state.SessionName.trim()!==''){var initialCheck=false;this.SaveSolution(initialCheck);}}},{key:'SaveSolution',value:function SaveSolution(overrideParam){var sessionObject={"UserId":this.props.UserID,// "UserId": this.props.UserID,
"SizerId":__WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__["d" /* _said */],"SessionID":this.props.activeSession.id,"Alias":this.state.SessionName,"Override":overrideParam,"ParentAlias":'',"SolutionId":this.props.activeSession.EPAArray.length>0?(this.state.ActiveSoln+1).toString():null// "ParentAlias": PreviousName
};this.props.onSaveSolution(sessionObject);}},{key:'OverrideSolMsgYesClick',value:function OverrideSolMsgYesClick(){this.SaveSolution(true);this.state.showSaveSolution=false;//    PreviousName = '';
this.setState({showDupSoLPopup:false});}},{key:'OverrideSolMsgNoClick',value:function OverrideSolMsgNoClick(){this.props.onDisableconflicts();this.setState({showDupSoLPopup:false});}},{key:'ChangeActvSoln',value:function ChangeActvSoln(actvitem){this.props.onEPAActvSolnChange({"actvItem":actvitem});//this.setState({ ActiveSoln: actvitem })
}},{key:'handleCloseError',value:function handleCloseError(){compare='';this.props.comparedata.CompareData=null;this.setState({CloseErrorLayer:true});}},{key:'CloseDelSession',value:function CloseDelSession(){showDelLayer='';this.setState({showDelSession:true});if(this.props.networkError.isError){this.props.ClearGuidanceError();}}},{key:'onExport',value:function onExport(){var text={Data:{input:{"content":data,"currencyone":'$ '+this.props.comparedata.CompareData.Solution[1].SolPrice,"currencytwo":'$ '+this.props.comparedata.CompareData.Solution[0].SolPrice,"Solution1":this.props.activeSession.alias,"Solution2":this.props.activeSession.selectedTitles.compareSolution2value,"Rack1":this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"],"Rack2":this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"]}}//let jsontext=JSON.stringify(text)
//dumm.push(text)
};this.props.onExportCompaeSolution(text);}},{key:'render',value:function render(){var _this3=this;compare='';var SolutionCost='';var countryDetails='';var MultipleSolutionTabs='';if(this.props.activeSession.EPAArray.length>0&&!this.state.dropDownState){if(this.props.activeSession.selectedTitles){compareSolution1value=this.props.activeSession.selectedTitles.compareSolution1value;compareSolution2value=this.props.activeSession.selectedTitles.compareSolution2value;}}if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]===EPAId&&this.props.workload.UserInputs.Environments.WorkloadType===BLUE_DATA){if(compareSolution1Options.indexOf(GROWTH_4Y)===-1){compareSolution1Options.push(GROWTH_4Y);}}compareSolution2Options=compareSolution1Options.concat(["Browse"]);if(this.props.activeSession.SavedSolname&&this.props.activeSession.SavedSolname.savedId){compareSolution2Options=compareSolution2Options.concat(this.props.activeSession.SavedSolname.SavedSol);}compareSolution2Options.splice(compareSolution2Options.indexOf(compareSolution1value),1);compareSolution2value=compareSolution2Options.indexOf(compareSolution2value)!==-1?compareSolution2value:compareSolution2Options[0];if(__WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__["d" /* _said */]==='EPAvNext'){if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&(this.props.comparedata.CompareData==='File Mismatch'||this.props.comparedata.CompareData==='Different Pricing Region')){this.state.CloseErrorLayer=false;}if(this.props.comparedata!==undefined&&this.props.comparedata!==null&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData!=='File Mismatch'&&this.props.comparedata.CompareData!=='Different Pricing Region'){var FirstSolRoles=[];var ExtraSeconSolroles=[];ComputeNodeArray=[];ComputeNodeSecondSolArray=[];CombineRack=[];CombineRackSecond=[];ComputeNodeArray=[];ComputeNodeSecondSolArray=[];totalNumOfRows=[];RolesList=[];data=[];//dumm = []
var Type=this.props.workload.UserInputs.Environments.WorkloadType;console.log(this.props.comparedata);var backgrdclrrack='none';if(this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"]!==this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"]){backgrdclrrack='#ffd144';}else{backgrdclrrack='#fff';}CombineRack=this.props.comparedata.CompareData.Solution.map(function(val){if(val.RackSelected!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{backgroundColor:backgrdclrrack}},val.RackSelected["@CompDesc"]);}});CombineRackSecond=CombineRack.reverse();if(Array.isArray(this.props.comparedata.CompareData.Solution[0].Roles.Role)){this.props.comparedata.CompareData.Solution[0].Roles.Role.map(function(val){var strVolume=void 0;if(val["RoleName"]==="Compute hosts"||val["RoleName"]==="Compute Node"){val["RoleName"]="Compute Hosts";}else if(val["RoleName"].toLowerCase()==="compute hosts with gpus"||val["RoleName"]==="GPU Node"){val["RoleName"]="Compute Hosts With GPUs";}else if(val["RoleName"]==="Gateway Node"){val["RoleName"]="Gateway Host";}else if(val["RoleName"]==="Controller Node"){val["RoleName"]="Controller Host";}else if(val["RoleName"]==="Storage : HDFS and HDFS-EC"){val["RoleName"]="Storage : HDFS";}FirstSolRoles.push(val["RoleName"]);if(Array.isArray(val.DAS.TableData)){strVolume=this.populateStorageVolumes(val.DAS.TableData);}else{strVolume=val.DAS.TableData["VolumeName"]+" - "+val.DAS.TableData["DiskQty"]+" X "+val.DAS.TableData["Disk"];}val["Memory"]=val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeArray.push({"Role Name":val["RoleName"]},{"Server Name":val.ServerName["@Qty"]+" X "+val.ServerName["#text"]},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});}else{var SerName=val.ServerName["@Qty"]+" X "+val.ServerName["#text"];val.Processor=val.Processor.replace("1P"," ");if(val.ServerName["#text"]==="HP Moonshot System"){SerName=val.Processor;}ComputeNodeArray.push({"Role Name":val["RoleName"]},{"Server Name":SerName},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});if(val.CPUPerf!==undefined&&val.StorageTP!==undefined&&val.StorageReadIO!==undefined&&val.StorageWriteIO!==undefined&&val.CPUPerfPrice!==undefined&&val.RawStoragePrice!==undefined&&val.StoragePerfPrice!==undefined&&val.CPUPerfWatt!==undefined&&val.StoragePerfWatt!==undefined){ComputeNodeArray.push({"CPU Performance (SPECint)":val.CPUPerf["#text"]},{"Storage Throughput (MB/s)":val.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":val.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":val.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":val.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":val.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":val.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":val.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":val.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}.bind(this));}else{var roleobj=this.props.comparedata.CompareData.Solution[0].Roles.Role;var StorageVolume=[];var strVolume=void 0;if(roleobj["RoleName"]==="Compute hosts"||roleobj["RoleName"]==="Compute Node"){roleobj["RoleName"]="Compute Hosts";}else if(roleobj["RoleName"].toLowerCase()==="compute hosts with gpus"||roleobj["RoleName"]==="GPU Node"){roleobj["RoleName"]="Compute Hosts With GPUs";}else if(roleobj["RoleName"]==="Gateway Node"){roleobj["RoleName"]="Gateway Host";}else if(roleobj["RoleName"]==="Controller Node"){roleobj["RoleName"]="Controller Host";}else if(roleobj["RoleName"]==="Storage : HDFS and HDFS-ECC"){roleobj["RoleName"]="Storage : HDFS";}FirstSolRoles.push(roleobj["RoleName"]);if(Array.isArray(roleobj.DAS.TableData)){roleobj.DAS.TableData.map(function(Volume){StorageVolume.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});if(StorageVolume[2]!==undefined){strVolume=StorageVolume[0]+"    "+StorageVolume[1]+"    "+StorageVolume[2];}else{strVolume=StorageVolume[0]+"    "+StorageVolume[1];}}else{strVolume=roleobj.DAS.TableData["VolumeName"]+" - "+roleobj.DAS.TableData["DiskQty"]+" X "+roleobj.DAS.TableData["Disk"];}roleobj["Memory"]=roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"]},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});}else{var SerName=roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"];roleobj.Processor=roleobj.Processor.replace("1P"," ");if(roleobj.ServerName["#text"]==="HP Moonshot System"){SerName=roleobj.Processor;}ComputeNodeArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":SerName},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});if(roleobj.CPUPerf!==undefined&&roleobj.StorageTP!==undefined&&roleobj.StorageReadIO!==undefined&&roleobj.StorageWriteIO!==undefined&&roleobj.CPUPerfPrice!==undefined&&roleobj.RawStoragePrice!==undefined&&roleobj.StoragePerfPrice!==undefined&&roleobj.CPUPerfWatt!==undefined&&roleobj.StoragePerfWatt!==undefined){ComputeNodeArray.push({"CPU Performance (SPECint)":roleobj.CPUPerf["#text"]},{"Storage Throughput (MB/s)":roleobj.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":roleobj.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":roleobj.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":roleobj.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":roleobj.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":roleobj.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":roleobj.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":roleobj.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}var RolnotPrst=false;FirstSolRoles.filter(function(rol){RolnotPrst=false;if(Array.isArray(_this3.props.comparedata.CompareData.Solution[1].Roles.Role)){_this3.props.comparedata.CompareData.Solution[1].Roles.Role.map(function(val){if(val["RoleName"]==="Compute hosts"||val["RoleName"]==="Compute Node"){val["RoleName"]="Compute Hosts";}else if(val["RoleName"].toLowerCase()==="compute hosts with gpus"||val["RoleName"]==="GPU Node"){val["RoleName"]="Compute Hosts With GPUs";}else if(val["RoleName"]==="Gateway Node"){val["RoleName"]="Gateway Host";}else if(val["RoleName"]==="Controller Node"){val["RoleName"]="Controller Host";}else if(val["RoleName"]==="Storage : HDFS and HDFS-ECC"){val["RoleName"]="Storage : HDFS";}if(rol.toLowerCase()===val["RoleName"].toLowerCase()){RolnotPrst=true;var _strVolume=void 0;if(Array.isArray(val.DAS.TableData)){_strVolume=this.populateStorageVolumes(val.DAS.TableData);}else{_strVolume=val.DAS.TableData["VolumeName"]+" - "+val.DAS.TableData["DiskQty"]+" X "+val.DAS.TableData["Disk"];}val["Memory"]=val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":val.ServerName["@Qty"]+" X "+val.ServerName["#text"]},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume});}else{var _SerName=val.ServerName["@Qty"]+" X "+val.ServerName["#text"];val.Processor=val.Processor.replace("1P"," ");if(val.ServerName["#text"]==="HP Moonshot System"){_SerName=val.Processor;}ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":_SerName},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume});if(val.CPUPerf!==undefined&&val.StorageTP!==undefined&&val.StorageReadIO!==undefined&&val.StorageWriteIO!==undefined&&val.CPUPerfPrice!==undefined&&val.RawStoragePrice!==undefined&&val.StoragePerfPrice!==undefined&&val.CPUPerfWatt!==undefined&&val.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":val.CPUPerf["#text"]},{"Storage Throughput (MB/s)":val.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":val.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":val.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":val.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":val.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":val.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":val.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":val.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}.bind(_this3));}else{var roleobject=_this3.props.comparedata.CompareData.Solution[1].Roles.Role;if(roleobject["RoleName"]==="Compute hosts"||roleobject["RoleName"]==="Compute Node"){roleobject["RoleName"]="Compute Hosts";}else if(roleobject["RoleName"].toLowerCase()==="compute hosts with gpus"||roleobject["RoleName"]==="GPU Node"){roleobject["RoleName"]="Compute Hosts With GPUs";}else if(roleobject["RoleName"]==="Gateway Node"){roleobject["RoleName"]="Gateway Host";}else if(roleobject["RoleName"]==="Controller Node"){roleobject["RoleName"]="Controller Host";}if(rol.toLowerCase()===roleobject["RoleName"].toLowerCase()){RolnotPrst=true;var _StorageVolume=[];var _strVolume2=void 0;if(Array.isArray(roleobject.DAS.TableData)){roleobject.DAS.TableData.map(function(Volume){_StorageVolume.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});if(_StorageVolume[2]!==undefined){_strVolume2=_StorageVolume[0]+"    "+_StorageVolume[1]+"    "+_StorageVolume[2];}else{_strVolume2=_StorageVolume[0]+"    "+_StorageVolume[1];}}else{_strVolume2=roleobject.DAS.TableData["VolumeName"]+" - "+roleobject.DAS.TableData["DiskQty"]+" X "+roleobject.DAS.TableData["Disk"];}roleobject["Memory"]=roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":roleobject["RoleName"]},{"Server Name":roleobject.ServerName["@Qty"]+" X "+roleobject.ServerName["#text"]},{"Processor":roleobject["ProcessorDetails"]},{"Memory":roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume2});}else{var _SerName2=roleobject.ServerName["@Qty"]+" X "+roleobject.ServerName["#text"];roleobj.Processor=roleobj.Processor.replace("1P"," ");if(roleobject.ServerName["#text"]==="HP Moonshot System"){_SerName2=roleobject.Processor;}ComputeNodeSecondSolArray.push({"Role Name":roleobject["RoleName"]},{"Server Name":_SerName2},{"Processor":roleobject["ProcessorDetails"]},{"Memory":roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume2});if(roleobject.CPUPerf!==undefined&&roleobject.StorageTP!==undefined&&roleobject.StorageReadIO!==undefined&&roleobject.StorageWriteIO!==undefined&&roleobject.CPUPerfPrice!==undefined&&roleobject.RawStoragePrice!==undefined&&roleobject.StoragePerfPrice!==undefined&&roleobject.CPUPerfWatt!==undefined&&roleobject.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":roleobject.CPUPerf["#text"]},{"Storage Throughput (MB/s)":roleobject.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":roleobject.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":roleobject.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":roleobject.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":roleobject.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":roleobject.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":roleobject.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":roleobject.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}if(!RolnotPrst){if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":"NA"},{"Server Name":"NA"},{"Processor":"NA"},{"Memory":"NA"},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":"NA"});}else{ComputeNodeSecondSolArray.push({"Role Name":"NA"},{"Server Name":"NA"},{"Processor":"NA"},{"Memory":"NA"},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":"NA"},{"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}});FirstSolRoles.filter(function(rol){if(Array.isArray(_this3.props.comparedata.CompareData.Solution[1].Roles.Role)){_this3.props.comparedata.CompareData.Solution[1].Roles.Role.map(function(val){if(val["RoleName"]==="Compute hosts"||val["RoleName"]==="Compute Node"){val["RoleName"]="Compute Hosts";}else if(val["RoleName"].toLowerCase()==="compute hosts with gpus"||val["RoleName"]==="GPU Node"){val["RoleName"]="Compute Hosts With GPUs";}else if(val["RoleName"]==="Gateway Node"){val["RoleName"]="Gateway Host";}else if(val["RoleName"]==="Controller Node"){val["RoleName"]="Controller Host";}else if(val["RoleName"]==="Storage : HDFS and HDFS-ECC"){val["RoleName"]="Storage : HDFS";}if(FirstSolRoles.indexOf(val["RoleName"])===-1){if(ExtraSeconSolroles.indexOf(val["RoleName"])===-1){ExtraSeconSolroles.push(val["RoleName"]);}}});}else{var roleobject=_this3.props.comparedata.CompareData.Solution[1].Roles.Role;if(roleobject["RoleName"]==="Compute hosts"||roleobject["RoleName"]==="Compute Node"){roleobject["RoleName"]="Compute Hosts";}else if(roleobject["RoleName"].toLowerCase()==="compute hosts with gpus"||roleobject["RoleName"]==="GPU Node"){roleobject["RoleName"]="Compute Hosts With GPUs";}else if(roleobject["RoleName"]==="Gateway Node"){roleobject["RoleName"]="Gateway Host";}else if(roleobject["RoleName"]==="Controller Node"){roleobject["RoleName"]="Controller Host";}if(FirstSolRoles.indexOf(roleobject["RoleName"])===-1){if(ExtraSeconSolroles.indexOf(roleobject["RoleName"])===-1){ExtraSeconSolroles.push(roleobject["RoleName"]);}}}});ExtraSeconSolroles.filter(function(extrarol){if(Array.isArray(_this3.props.comparedata.CompareData.Solution[1].Roles.Role)){_this3.props.comparedata.CompareData.Solution[1].Roles.Role.map(function(val){if(extrarol.toLowerCase()===val["RoleName"].toLowerCase()){var _strVolume3=void 0;if(Array.isArray(val.DAS.TableData)){_strVolume3=this.populateStorageVolumes(val.DAS.TableData);}else{_strVolume3=val.DAS["VolumeName"]+" - "+val.DAS["DiskQty"]+" X "+val.DAS["Disk"];}val["Memory"]=val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":val.ServerName["@Qty"]+" X "+val.ServerName["#text"]},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume3});}else{var _SerName3=val.ServerName["@Qty"]+" X "+val.ServerName["#text"];val.Processor=val.Processor.replace("1P"," ");if(val.ServerName["#text"]==="HP Moonshot System"){_SerName3=val.Processor;}ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":_SerName3},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume3});if(val.CPUPerf!==undefined&&val.StorageTP!==undefined&&val.StorageReadIO!==undefined&&val.StorageWriteIO!==undefined&&val.CPUPerfPrice!==undefined&&val.RawStoragePrice!==undefined&&val.StoragePerfPrice!==undefined&&val.CPUPerfWatt!==undefined&&val.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":val.CPUPerf["#text"]},{"Storage Throughput (MB/s)":val.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":val.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":val.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":val.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":val.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":val.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":val.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":val.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}.bind(_this3));}else{var roleobj=_this3.props.comparedata.CompareData.Solution[1].Roles.Role;if(extrarol.toLowerCase()===roleobj["RoleName"].toLowerCase()){var _StorageVolume2=[];var _strVolume4=void 0;if(Array.isArray(roleobj.DAS.TableData)){roleobj.DAS.TableData.map(function(Volume){_StorageVolume2.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});if(_StorageVolume2[2]!==undefined){_strVolume4=_StorageVolume2[0]+"    "+_StorageVolume2[1]+"    "+_StorageVolume2[2];}else{_strVolume4=_StorageVolume2[0]+"    "+_StorageVolume2[1];}}else{_strVolume4=roleobj.DAS["VolumeName"]+" - "+roleobj.DAS["DiskQty"]+" X "+roleobj.DAS["Disk"];}roleobj["Memory"]=roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"]},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume4});}else{var _SerName4=roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"];roleobj.Processor=roleobj.Processor.replace("1P"," ");if(roleobj.ServerName["#text"]==="HP Moonshot System"){_SerName4=roleobj.Processor;}ComputeNodeSecondSolArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":_SerName4},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume4});if(roleobj.CPUPerf!==undefined&&roleobj.StorageTP!==undefined&&roleobj.StorageReadIO!==undefined&&roleobj.StorageWriteIO!==undefined&&roleobj.CPUPerfPrice!==undefined&&roleobj.RawStoragePrice!==undefined&&roleobj.StoragePerfPrice!==undefined&&roleobj.CPUPerfWatt!==undefined&&roleobj.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":roleobj.CPUPerf["#text"]},{"Storage Throughput (MB/s)":roleobj.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":roleobj.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":roleobj.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":roleobj.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":roleobj.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":roleobj.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":roleobj.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":roleobj.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}});var x=ComputeNodeArray.length;var y=ComputeNodeSecondSolArray.length;if(x>y){totalNumOfRows.length=x;}else{totalNumOfRows.length=y;}var RoleItems=[];if(Type==="BlueData"){RoleItems=["Role Name","Server Name","Processor","Memory","Storage"];}else{RoleItems=["Role Name","Server Name","Processor","Memory","Storage","CPU Performance (SPECint)","Storage Throughput (MB/s)","Storage Read IOPs (IOPs)","Storage Write IOPs (IOPs)","CPU Perf/Price (SPECint/$1k)","Raw Storage capacity/Price (TB/$1k)","Storage Perf/Price (MB/s per $1k)","CPU Perf/Watt (SPECint/KW)","Storage Perf/Watt (MB/s per KW)"];}var countRole=0;for(var i=0;i<totalNumOfRows.length;i++){var ComputeValue;var ComputeValueSecond;if(i>=ComputeNodeSecondSolArray.length){ComputeValueSecond="NA";}else{ComputeValueSecond=ComputeNodeSecondSolArray[i][RoleItems[countRole]];}if(i>=ComputeNodeArray.length){ComputeValue="NA";}else{ComputeValue=ComputeNodeArray[i][RoleItems[countRole]];}var textspace='';var textspacetwo='';if(ComputeValueSecond==="NA"){textspace='center';}if(ComputeValue==="NA"){textspacetwo='center';}var backgrdclr='#fff';if(ComputeValueSecond!==ComputeValue&&ComputeValueSecond!=='NA'&&ComputeValue!=='NA'){backgrdclr='#ffd144';}else{backgrdclr='#fff';}RolesList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,RoleItems[countRole]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:textspace,backgroundColor:backgrdclr}},ComputeValueSecond),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:{textAlign:textspacetwo,backgroundColor:backgrdclr}},ComputeValue)));data.push({"role":RoleItems[countRole],"computevaluesecond":ComputeValueSecond,"computevalue":ComputeValue});countRole++;if(Type==="BlueData"){if(countRole==5){countRole=0;}}else{if(countRole==14){countRole=0;}}}var Currencyone='';var Currencytwo='';if(this.props.comparedata.CompareData['@Currency']==='UD'){Currencyone='$ '+this.props.comparedata.CompareData.Solution[1].SolPrice;Currencytwo='$ '+this.props.comparedata.CompareData.Solution[0].SolPrice;}else{Currencyone=this.props.comparedata.CompareData['@Currency']+" "+this.props.comparedata.CompareData.Solution[1].SolPrice;Currencytwo=this.props.comparedata.CompareData['@Currency']+" "+this.props.comparedata.CompareData.Solution[0].SolPrice;}}else if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&!this.props.isLoading&&!this.state.CloseErrorLayer&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData==='File Mismatch'){this.state.CloseErrorLayer=false;compare=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.handleCloseError.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{margin:'small'},'Current solution is configured with different platform. Kindly select the solution with same platform to compare'))));}else if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&!this.props.isLoading&&!this.state.CloseErrorLayer&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData==='Different Pricing Region'){this.state.CloseErrorLayer=false;compare=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert___default.a,{colorIndex:'critical',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Error')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.handleCloseError.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'small',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{margin:'small'},'Current solution is configured with different Price Region. Kindly select the solution with same Price Region to compare'))));}}if(__WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__["d" /* _said */]==='EPAvNext'){var SolutionItemsList=void 0;if(this.props.activeSession.EPAArray.length>0){if(this.props.workload.UserInputs.Environments.WorkloadType===BLUE_DATA){SolutionItemsList=EZMERAL_SOLUTION_ITEMS;}else{SolutionItemsList=EPA_SOLUTION_ITEMS;}}else{SolutionItemsList=NONGROWTH_SOLUTION_ITEMS;}MultipleSolutionTabs=SolutionItemsList.map(function(val,id){if(_this3.state.activeSoltab==id){_this3.state.ActiveSolTabClass="MultipleSolTabsClass";}else{_this3.state.ActiveSolTabClass="";}if(val==='Elastic Config'){val='Recommended Solution';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor___default.a,{primary:false,label:val,plain:true,id:id,className:_this3.state.ActiveSolTabClass,onClick:function onClick(e){return _this3.SelectActiveSolutionTab(val,id);},style:{padding:'3.6px 7px',position:'absolute',left:id*250+'px',textDecoration:'none',fontSize:'18px'}});});}else{MultipleSolutionTabs='';}if(this.state.SolutionObj!==''){SolutionCost=this.state.SolutionObj.Solution.SolPrice;if(__WEBPACK_IMPORTED_MODULE_5__State_constants_CommonConstants__["c" /* DisplayPrice */]){countryDetails=this.state.SolutionObj['@PriceList'].split(' ')[0]+" Internet Price [ "+this.state.SolutionObj['@Country']+" ]";}else{countryDetails="[ "+this.state.SolutionObj['@Country']+" ]";}}//Rack
var Rackitem='';if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==="EPA"){Rackitem=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'},style:{marginLeft:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_Bundle___default.a,{size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},'Rack - '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},this.state.RackItem));}var CsvsSolutionSummarycontent='';if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==="CS750VirtSizer"||__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==="SynergySizer"){var content='The information above is a summary of the key solution components. You may save this solution for future recall by pressing the “Save” button. Press the “Configuration Details” button to generate an HTML page summarizing your workload inputs. That page may also be opened in MS-Word or emailed. See further information on that page.';CsvsSolutionSummarycontent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{'between':'small'},style:{marginLeft:'12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"red",margin:"0px",maxWidth:'100%'}},content));}// let SolutionCost = this.state.SolutionObj.Solution.SolPrice;
// let PriceListDetails = this.state.SolutionObj['@PriceList'].split(' ')[0]+" Internet Price [ "+this.state.SolutionObj['@Country']+" ]";
var AdditionalInformation='';var AdditionalList='';var prompt='';var showSaveSolutionContent=null;var showDupNameContent=null;var OCAPopupContent='';if(this.state.showSaveSolution){showSaveSolutionContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'solutionPopup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please name your solution')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.ClosePopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TextInput___default.a,{onPaste:this._handleOnPaste,value:this.state.SessionName,style:{width:'80%'},placeHolder:'Session Name',onDOMChange:this.SessionTxtChange}),this.state.SessionName===''||this.state.SessionName.trim()===''?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_FormNextLink___default.a,{size:'small'})}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_grommet_components_icons_base_FormNextLink___default.a,{size:'small'}),onClick:this.onSaveSolutionSubmit}))));}else{showSaveSolutionContent="";}if(this.props.OverrideSolMsg.isEnabled&&this.state.showDupSoLPopup){showDupNameContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'WarningPopup'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:false},'Please Confirm'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},this.props.OverrideSolMsg.msg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:this.OverrideSolMsgYesClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'No',className:'SessionOutBtns',critical:true,onClick:this.OverrideSolMsgNoClick}))));}else{showDupNameContent='';}if(window.location.pathname.match("/SolnAlternative")){prompt=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Prompt */],{when:false,message:function message(location){return'Solution will be lost, do you still want to continue ?';}});}else{prompt=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Prompt */],{when:false,message:function message(location){return'Solution will be lost, do you still want to continue ?';}});}if(this.state.OCAPopup){OCAPopupContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'medium'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29_grommet_components_icons_base_CircleInformation___default.a,{colorIndex:'accent-1-t',size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:false,style:{marginBottom:'0px'}},'Please select')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){return _this3.setState({OCAPopup:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{margin:'12px 0px 12px 12px'},pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor___default.a,{primary:true,onClick:function onClick(){return _this3.downloadFiles('xml',__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]);}},'Download an XML file'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:{between:'small'},separator:'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor___default.a,{style:{margin:'5px 0px 0px 0px'},primary:true,onClick:function onClick(){return _this3.downloadFiles('xls',__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]);}},'Download an Excel file'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{margin:'none'},'Please perform Save As for the downloaded file in excel application before uploading to OCA Tool, if excel is your choice. ')))));}else{OCAPopupContent='';}if(this.state.AdditionalInfoPop){AdditionalList=this.state.HomePageJson.Sizers.Sizer.AdditionalInformation.Doc.map(function(val,id){//  <td> {val["Name"]}  </td>
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_TableRow___default.a,{key:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'secondary'},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:val["Url"],target:'_blank'},' ',val["Name"],' '),' '));});AdditionalInformation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'AdditionalInflolayer',style:{width:'50%',height:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',pad:'small',separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:true,style:{marginBottom:'0px',color:'#01a982'}},'Additional Information')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:function onClick(){_this3.setState({AdditionalInfoPop:false});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h6',strong:true,style:{margin:'4px 0px'}},'Learn More'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{style:{margin:'2px 0px',maxWidth:'100%'}},this.state.HomePageJson.Sizers.Sizer.AdditionalInformation["@Text"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Table___default.a,{style:{margin:'4px 0px',overflow:'initial'},selectable:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,AdditionalList)))));}else{AdditionalInformation="";AdditionalList='';}var RoleObjContent=null;if(this.state.RoleObj!==''){RoleObjContent=Object.keys(this.state.RoleObj).map(function(key,index){if(this.state.RoleObj[key].ServerName===undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{key:index,pad:{between:'small'},margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{between:'small'},colorIndex:'light-2',style:{padding:'5px 10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView___default.a,{size:'small',colorIndex:'#69506f'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:true,margin:'none',style:{fontSize:'15px'}},key)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{key:index,pad:{between:'small'},margin:'none',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__CustomArticle__["a" /* default */],{key:index,ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:key,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__Recom_Soln__["a" /* default */],{RoleData:this.state.RoleObj[key],WorkloadType:this.props.workload.UserInputs?this.props.workload.UserInputs.Environments.WorkloadType:''})}));}}.bind(this));}var SharedRoleObjContent=null;if(this.state.SharedRoleObj!==''){if(!Array.isArray(this.state.SharedRoleObj)){SharedRoleObjContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:'small'},margin:'none',justify:'between'},Object.keys(this.state.SharedRoleObj).map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__CustomArticle__["a" /* default */],{key:index,ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:key,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__Recom_Soln__["a" /* default */],{RoleData:this.state.SharedRoleObj[key]})});}.bind(this)));}else{SharedRoleObjContent=this.state.SharedRoleObj.map(function(eachRole){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:'small'},margin:'none',justify:'between'},Object.keys(eachRole).map(function(key,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__CustomArticle__["a" /* default */],{key:index,ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:key,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_grommet_components_icons_base_StreetView___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__Recom_Soln__["a" /* default */],{RoleData:eachRole[key]})});}));});}}var sizerSpecificData=null;if(this.state.SolutionObj!==undefined&&this.state.SolutionObj!==''&&this.state.SolutionObj.Solution.Roles['SizerSpecificData']!=null&&this.state.SolutionObj.Solution.Roles['SizerSpecificData'].trim().length>0)sizerSpecificData=this.state.SolutionObj.Solution.Roles['SizerSpecificData'];if(this.state.ComapareSolState){var StyleTable="CompareTable";if(Type==="BlueData"){StyleTable="CompareTable";}else{StyleTable="CompareTableBig";}var backgrdclrtotal='#fff';if(Currencyone!==Currencytwo&&Currencyone!=='NA'&&Currencytwo!=='NA'){backgrdclrtotal='#ffd144';}else{backgrdclrtotal='#fff';}// var link = serviceUrl+said+"/ExportCompareSolution?sessionId="+this.props.activeSession.id;
SolutionAlternativeTabsContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'small',className:'CompareSolutionTable'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{"between":"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{"between":"small"},justify:'center'},this.props.activeSession.EPAArray.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_grommet_components_Select___default.a,{name:'compareSolution1',value:compareSolution1value,options:compareSolution1Options,onChange:function onChange(e){_this3.compareSolution12Change(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41_grommet_components_Select___default.a,{name:'compareSolution2',value:compareSolution2value,options:compareSolution2Options,onChange:function onChange(e){_this3.compareSolution12Change(e);}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:'small'},'Click on Compare button to select the solution to be compared with'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:true,label:'Compare',onClick:this.compareSolnMethod})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{marginLeft:'44%'}})),Currencyone!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{className:StyleTable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},' Details'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,this.props.activeSession.EPAArray.length>0?this.props.activeSession.selectedTitles.compareSolution1value:this.props.activeSession.alias),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,this.props.activeSession.selectedTitles.compareSolution2value))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Rack'),CombineRackSecond),RolesList),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'center',backgroundColor:backgrdclrtotal}},Currencyone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{textAlign:'center',backgroundColor:backgrdclrtotal}},Currencytwo)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Export to Excel',primary:true,onClick:this.onExport.bind(this),style:{height:'40px',marginTop:'20px',width:'27%'}})):'');}else{var RecommendedHeading='Solution Recommended';if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPAvNext'){Type=this.props.workload.UserInputs.Environments.WorkloadType;RecommendedHeading="Recommended Solution";}Note='';if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==="SAPHANA"&&this.props.workload.UserInputs.Environments.WorkloadType==="SAPHANA"){if(this.props.workload.UserInputs.Environments.isOldWorkload===true||this.props.workload.UserInputs.Environments.isOldWorkload==='true'){Note=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{size:'xlarge',direction:'row',margin:'none',pad:'small',style:{backgroundColor:'yellow'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert___default.a,{size:'small',margin:'small',type:'status'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_Label___default.a,{style:{marginLeft:'10px'},size:'medium',margin:'none'},OLDWL_TEXT));}else{Note='';}}else{Note='';}SolutionAlternativeTabsContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{justify:'between',direction:'row',className:'SolAlternativeHeadingsec'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',style:{color:'#01a982',marginTop:'13px',fontSize:'19px'},strong:true,margin:'none'},'Solution Summary'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',justify:'between',margin:'none',pad:{between:'small'},className:'SolAlterNativeGrpBtns'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_DocumentDownload___default.a,{size:'small',colorIndex:'accent-3'}),label:'Save Solution',onClick:this.onSaveSolutionIconClick}),['CS750VirtSizer',"EPAvNext",'SAPHANA'].indexOf(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */])!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{id:'start-guidance',primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19_grommet_components_icons_base_Directions___default.a,{size:'small',colorIndex:'accent-3'}),label:'Continue to Guidance',onClick:function onClick(){return _this3.ShowDelSession(_this3.props.networkError);}}):'',__WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__["d" /* _said */]==='EPA'||__WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__["d" /* _said */]==='EPAvNext'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30_grommet_components_icons_base_Analytics___default.a,{size:'small',colorIndex:'accent-3'}),onClick:this.MetricsDataBtnClick.bind(this),label:'Metrics Data'}):null,__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='SAPHANA'&&this.props.workload.UserInputs.Environments.WorkloadType!=='TDI'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_grommet_components_icons_base_Link___default.a,{size:'small',colorIndex:'accent-3'}),onClick:this.AdditionalInfo.bind(this),label:'Additional Information'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{primary:false,plain:true,icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_grommet_components_icons_base_Bundle___default.a,{size:'small',colorIndex:'accent-3'}),onClick:this.GrPresentation.bind(this),label:'Solution Layout'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',className:'SolalternativeTabsecs',pad:'none',style:{height:'95%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Tabs___default.a,{className:'Tabsec',style:{width:'100%',margin:'0px 0'},activeIndex:this.state.activeTab,onActive:function onActive(i){return _this3.setState({activeTab:i});},justify:'start',responsive:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Tab___default.a,{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_grommet_components_icons_base_Info___default.a,{size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',margin:'none'},RecommendedHeading))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:{between:'small'},margin:'none',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',justify:'between',pad:'none',style:{marginTop:'12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},'Total Server Count :'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},this.state.ServQty)),!__WEBPACK_IMPORTED_MODULE_5__State_constants_CommonConstants__["c" /* DisplayPrice */]?" ":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},'Solution Cost :'),this.state.SolutionObj["@Currency"]==='UD'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'$ '+SolutionCost):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},this.state.SolutionObj["@Currency"]+" "+SolutionCost)),__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==="CS750VirtSizer"||__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==="SynergySizer"?" ":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},countryDetails,' ')),Rackitem,RoleObjContent,SharedRoleObjContent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{style:{marginLeft:'1%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"black",margin:"0px",maxWidth:'100%'}},sizerSpecificData)),CsvsSolutionSummarycontent,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:'small'},__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='CS750VirtSizer'&&(this.props.workload.Workload.UserInputs.Nimble==="True"&&this.props.workload.Workload.UserInputs.Nimble_Nodes_Count>2||this.props.workload.Workload.UserInputs.ThreePAR==="True"&&(this.props.workload.Workload.UserInputs.StorageArrayCount>2||ArraysCount))?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"black",margin:"0px",maxWidth:'100%',fontWeight:'600'}},'Note:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{style:{maxWidth:'100%',margin:'0% 0% 0% 3%'}},' More than two arrays configured. Please get solution reviewed.')):''))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Tab___default.a,{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26_grommet_components_icons_base_Money___default.a,{size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',margin:'none'},'BOM Details'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__BOM__["a" /* default */],{actvSoln:this.props.activeSession.EPAArray.length>0?this.state.ActiveSoln+1:null}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Tab___default.a,{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_grommet_components_icons_base_Troubleshoot___default.a,{size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',margin:'none'},'Configuration Details'))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',align:'center',justify:'between'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__ConfigurationDetails__["a" /* default */],{actvSoln:this.props.activeSession.EPAArray.length>0?this.state.ActiveSoln+1:null}))))));}var MutpleSolPresnt=[];//if(this.props.activeSession.EPAArray.length){
if(__WEBPACK_IMPORTED_MODULE_4__SizerUI_SizerConfig_Config_js__["d" /* _said */]==='EPAvNext'){MutpleSolPresnt.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',style:{height:'35px',paddingBottom:'35px',borderBottom:'1px solid #614767'}},MultipleSolutionTabs));}var metricsComponent=null;if(this.state.MetricsDataPresent&&__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPA'){metricsComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'MetricsDataPage',closer:true,flush:false,onClose:this.MetricsDataClose,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__MetricsData__["a" /* default */],null));}else if(this.state.MetricsDataPresent&&__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]==='EPAvNext'){metricsComponent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'MetricsDataPage',closer:true,flush:false,onClose:this.MetricsDataClose,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__MetricsData_vNext__["a" /* default */],null));}var showGrowthWarning=void 0;if(__WEBPACK_IMPORTED_MODULE_39__AppConfig__["f" /* said */]===EPAId&&this.props.activeSession.EPAArray.length===0&&this.props.workload.UserInputs.Environments.Growth){var growthServices=this.props.workload.UserInputs.Environments.Growth.Service;if(this.props.workload.UserInputs.Environments.WorkloadType===BLUE_DATA){growthServices=this.props.workload.UserInputs.Environments.Growth.Host;}showGrowthWarning=Array.isArray(growthServices)&&growthServices.reduce(function(acc,item){var growth=parseInt(item['@GrowthRate'],10);if(!isNaN(growth)){return acc+growth;}},0)>0?true:false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{pad:'none',margin:'none',style:{width:'100%',position:'relative',margin:'12px 24px 24px 24px'}},prompt,AdditionalInformation,OCAPopupContent,showSaveSolutionContent,showDelLayer,this.state.GRPresent?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'GRPage',closer:true,flush:false,onClose:this.GrClose,style:{zIndex:101}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__GraphicalRepresentation__["a" /* default */],{listItem:this.state.GRPresentStatic,actvSoln:this.state.ActiveSoln+1})):null//<Button primary={false} plain={true} icon={<ViewIcon size="small" colorIndex='accent-3'/>} label='GR Demo' onClick={this.GrPresentationStatic}/>  
,metricsComponent,showDupNameContent,showGrowthWarning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__SimpleWarning__["a" /* default */],{message:growthWarning}):'',MutpleSolPresnt,Note,SolutionAlternativeTabsContent,Com,compare);}}]);return SolnAlternative;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var StartGuidanceLayer=function(_Component2){_inherits(StartGuidanceLayer,_Component2);function StartGuidanceLayer(){_classCallCheck(this,StartGuidanceLayer);return _possibleConstructorReturn(this,(StartGuidanceLayer.__proto__||Object.getPrototypeOf(StartGuidanceLayer)).apply(this,arguments));}_createClass(StartGuidanceLayer,[{key:'render',value:function render(){var showDelSession;if(this.props.showDelSession){showDelSession=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'none',size:'large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',colorIndex:'neutral-1',margin:'none',style:{padding:'12px 12px 0px 12px'},separator:'bottom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},align:'start',style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28_grommet_components_icons_base_Alert___default.a,{size:'small',colorIndex:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h4',strong:false},this.props.errorDisplay.isError?'Error':'Please Confirm')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',align:'start',alignContent:'start',onClick:this.props.CloseDelSession},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23_grommet_components_icons_base_Close___default.a,{size:'small',colorIndex:'light-2',className:'CloseIconStyle'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{margin:'none',pad:'small'},this.props.errorDisplay.isError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.errorDisplay.msg)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{direction:'row'},'Please login and request for access at ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Anchor___default.a,{id:'backToSSETyes',href:this.props.errorDisplay.ssetUrl},'HPE SSET'),', if you have not done yet.')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:'h6',strong:false,margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,this.props.errorDisplay.isError>1?"Your unsaved workloads will be discarded.":'',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'You will be directed to SSET guidance for further guidance with this solution. Do you want to continue?'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,{direction:'row',justify:'end',margin:'none',pad:'small'},this.props.errorDisplay.isError?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Yes',className:'SessionOutBtns',onClick:this.props.StartGuidance}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:this.props.errorDisplay.isError?'Close':'No',className:'SessionOutBtns',critical:this.props.errorDisplay.isError?false:true,onClick:this.props.CloseDelSession}))));}else if(!this.props.showDelSession){showDelSession="";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Box___default.a,null,showDelSession);}}]);return StartGuidanceLayer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{allSessions:state.sessions.sessions,activeSession:state.sessions.activeSession,DefaultInputs:state.sessions.sessionDefaults.inputs,OverrideSolMsg:state.sessions.overrideSolMsg,toastNotification:state.sessions.notificationMsg,UserID:state.auth.userData.email,workload:state.sizerWorkload.workload,CompareMetricsData:state.sessions.activeSession.CompareMetricsData,//comparedata: state.sessions.CompareData,
comparedata:state.sessions.activeSession.CompareData,networkError:state.sessions.networkError};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onSaveSolution:function onSaveSolution(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["Q" /* saveSolution */])(sessionID));},onSaveCurrentSession:function onSaveCurrentSession(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["c" /* SaveCurrentSession */])());},onUpdateSession:function onUpdateSession(session){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["Z" /* updateSession */])(session));},onChangeSession:function onChangeSession(id){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["f" /* changeSession */])(id));},onDisableconflicts:function onDisableconflicts(){dispatch({type:'DISMISS_CONFLICTS'});},onFetchMetricsData:function onFetchMetricsData(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["A" /* fetchMetricsData */])(obj));},onFetchCompareMetricsData:function onFetchCompareMetricsData(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["t" /* fetchCompareMetricsData */])(obj));},onFetchCompareSolution:function onFetchCompareSolution(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["u" /* fetchCompareSolution */])(obj));},onEPAActvSolnChange:function onEPAActvSolnChange(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["a" /* EPAActvSolnChange */])(obj));},onClearCompareMetricsData:function onClearCompareMetricsData(){dispatch({type:'CLEAR_COMPARE_METRICS'});},SavedSolname:function SavedSolname(value){dispatch({type:'SAVEDSOL_NAME',payload:value});},onGetAdvancedSolution:function onGetAdvancedSolution(workload){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["D" /* getAdvancedSolution */])(workload));},onExportCompaeSolution:function onExportCompaeSolution(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["q" /* exportCompareSolution */])(text));},ClearGuidanceError:function ClearGuidanceError(){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["g" /* clearGuidance */])());},OnComparedata:function OnComparedata(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["i" /* comparedata */])(value));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(SolnAlternative));

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-document-download', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'document-download');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M2.99787498,0.999999992 L17.4999998,0.999999992 L20.9999998,4.50000005 L21,23 L3,23 L2.99787498,0.999999992 Z M16,1 L16,6 L21,6 M12,9 L12,18 M8,15 L12,19 L16,15' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'DocumentDownload';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-directions', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'directions');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,11 L22,6 L17,1 M22,6 L18,6 C14.686,6 12,8.686 12,12 L12,24 M7,6 L2,11 L7,16 M2,11 L6,11 C9.314,11 12,13.686 12,17 L12,24' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Directions';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-bundle', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'bundle');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M17,14 L7,14 L17,14 Z M17,3 L23,3 L23,13 L17,13 M1,13 L1,17 L7,17 M17,17 L23,17 L23,13 M1,17 L1,21 L7,21 M23,17 L23,21 L17,21 M7,22 L17,22 L17,2 L7,2 L7,22 Z M7,13 L1,13 L1,3 L7,3' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Bundle';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-street-view', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'street-view');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,5 C16,7.209 14.209,9 12,9 C9.791,9 8,7.209 8,5 C8,2.791 9.791,1 12,1 C14.209,1 16,2.791 16,5 L16,5 Z M15,23 L15,17 L18,17 L18,15 C18,11.66 15.24,9.03 12,9 C8.79,9.03 6,11.66 6,15 L6,17 L9,17 L9,23 M3.5,23 L20.5,23 L3.5,23 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'StreetView';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-money', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'money');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 C16,14.8954305 12.8659932,14 9,14 C5.13400675,14 2,14.8954305 2,16 C2,17.1045695 5.13400675,18 9,18 C12.8659932,18 16,17.1045695 16,16 Z M2,16 L2,20.9367547 C2,22.0762536 5.13400675,23 9,23 C12.8659932,23 16,22.0762537 16,20.9367548 L16,16 M9,5 C4.581722,5 1,5.8954305 1,7 C1,8.1045695 4.581722,9 9,9 M1,7 L1,12.0000002 C1,13.0128881 4.581722,14 9,14 M23,4 C23,2.8954305 19.9004329,2 16.0769231,2 C12.2534133,2 9.15384615,2.8954305 9.15384615,4 C9.15384615,5.1045695 12.2534133,6 16.0769231,6 C19.9004329,6 23,5.1045695 23,4 Z M16,16 C19.8235098,16 23.0000002,15.0128879 23.0000002,14 L23,4 M9.15384615,3.99999999 L9.15384615,14.1660042 M8.99999999,9.00000001 C8.99999999,10.0128879 12.2534135,11 16.0769233,11 C19.9004331,11 23.0000004,10.0128879 23.0000004,9.00000001' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Money';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-troubleshoot', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'troubleshoot');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M1,5 C1,3.00000024 2,1 3,1 C3,1 5,5 5,5 L7,5 C7,5 9,1 9,1 C10,1 11,3.00000006 11,5 C11,7.25400025 10,9.0000003 8,10 L8,21 C8,22 8,23 6,23 C4,23 4,22 4,21 L4,10 C2,9.0000003 1,7.25400042 1,5 Z M19,12 L19,18 M17,18 L18,23 L20,23 L21,18 L17,18 Z M14,12 L24,12 L14,12 Z M21,12 L21,3 C21,1.895 20.105,1 19,1 C17.895,1 17,1.895 17,3 L17,12' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Troubleshoot';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-analytics', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'analytics');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M20,7 C21.25,8.67 22,10.75 22,13 C22,18.52 17.52,23 12,23 C6.48,23 2,18.52 2,13 C2,7.48 6.48,3 12,3 M12,1 L12,13 L21.6,5.8 C19.41,2.89 15.92,1 12,1 L12,1 Z' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Analytics';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Tiles__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Tiles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Tiles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tile__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Image__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomArticle__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AppConfig__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RecomSoln=function(_Component){_inherits(RecomSoln,_Component);function RecomSoln(props){_classCallCheck(this,RecomSoln);var _this=_possibleConstructorReturn(this,(RecomSoln.__proto__||Object.getPrototypeOf(RecomSoln)).call(this,props));_this.state={currentObj:_this.props.RoleData};return _this;}_createClass(RecomSoln,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(this.props.RoleData!==nextProps.RoleData){this.setState({currentObj:nextProps.RoleData});}}},{key:'render',value:function render(){var RoleObj=this.state.currentObj;var MainServerName=null;var ProcDetails=null;var StorageDetails=null;var StorageVolumeDetails=null;var MemoryDetails=null;var MemoryDIMMDetails=null;var rlName='';if(RoleObj['@DisplayName']===undefined||RoleObj['@DisplayName']===''){rlName=RoleObj['RoleName'];}else{rlName=RoleObj['@DisplayName'];}if(rlName!=='SharedStorage'&&rlName!=='Shared Storage'){if(!Array.isArray(RoleObj['Processor'])){if(RoleObj['Processor']!==undefined&&RoleObj['Processor']!==null&&RoleObj['Processor']!==''){MainServerName=RoleObj['Processor'];}}if(!Array.isArray(RoleObj['ProcessorDetails'])){if(RoleObj['ProcessorDetails']!==undefined&&RoleObj['ProcessorDetails']!==null&&RoleObj['ProcessorDetails']!==''){ProcDetails=RoleObj['ProcessorDetails'];}}if(RoleObj['Memory']!==undefined&&(RoleObj['HANA']===undefined||RoleObj['HANA']==='false')&&RoleObj['Memory']!==null&&!Array.isArray(RoleObj['Memory'])){MemoryDetails=RoleObj['Memory']+' (Per Server)';}else if(RoleObj['Memory']!==undefined||RoleObj['MemoryDIMMS']!==undefined){if(RoleObj['Memory']!==undefined&&RoleObj['Memory']!==null&&RoleObj['Memory']!==''&&!Array.isArray(RoleObj['Memory'])){MemoryDetails=RoleObj['Memory'];}if(RoleObj['MemoryDIMMS']!==''&&RoleObj['MemoryDIMMS']!==undefined&&RoleObj['MemoryDIMMS']!==null&&!Array.isArray(RoleObj['MemoryDIMMS'])){MemoryDIMMDetails=RoleObj['MemoryDIMMS'];}MemoryDetails=RoleObj['Memory'];MemoryDIMMDetails=RoleObj['MemoryDIMMS'];}if(RoleObj['Storage']!==undefined&&RoleObj['Storage']!==null&&RoleObj['Storage']!==''&&RoleObj['Storage'].trim()!=='GB Storage'&&RoleObj['Storage'].length!==0){if(RoleObj['Storage']==="HPE SAP HANA Scale-up Storage"||RoleObj['Storage']==="HPE SAP HANA BC/TDI D3710 Storage"){StorageDetails=RoleObj['Storage']+" "+RoleObj['StorageNode'];}else{StorageDetails=RoleObj['Storage'];}}if(RoleObj['StorageVolume']!==undefined&&RoleObj['StorageVolume']!==''&&RoleObj['StorageVolume'].trim()!=='GB Storage'&&RoleObj['StorageVolume']!==null){StorageVolumeDetails=RoleObj['StorageVolume'];}}var DASData='';var SANData='';if(RoleObj.DAS!==null&&RoleObj.DAS!==''&&RoleObj.DAS.length!==0){// DAS variables
var DASIntOnlineSpareQty=0;var DASExtOnlineSpareQty=0;var DASExtArrayType='';var DAS_InternalStorages=[];var DAS_ExternalStorages=[];var DASIntDiskQty=0;var DASExtDiskQty=0;var ServerCount=void 0;// if DAS.TableData is available
if(RoleObj.DAS.TableData!==undefined){if(RoleObj.ServerName!==undefined){ServerCount=parseInt(RoleObj.ServerName['@Qty'],10);}else ServerCount=1;if(Array.isArray(RoleObj.DAS.TableData)){// if DAS.TableData is an array                
RoleObj.DAS.TableData.map(function(DASobj,index){if(DASobj.ArrayType===undefined){DASIntDiskQty+=parseInt(DASobj.DiskQty,10);DASIntOnlineSpareQty+=parseInt(DASobj.OnlineSpare,10);if(DASobj.DiskQty==='1'){if(DASobj.RaidLevel!==undefined){DAS_InternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel);}else if(__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]==="EPAvNext"){DAS_InternalStorages.push(DASobj.VolumeName+" -"+DASobj.DiskQty+" Disk ("+DASobj.Disk+") "+DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ");}}else{if(DASobj.VolumeName==="Data (D)"){var content=DASobj.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";if(DASobj.RAIDLevel!==undefined&&DASobj.RAIDLevel.trim().length>0){content+=DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";}DAS_InternalStorages.push(content);}else if(DASobj.VolumeName==="OS (Os)"){var _content=DASobj.VolumeName+" - "+DASobj.DiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";if(DASobj.RAIDLevel!==undefined&&DASobj.RAIDLevel.trim().length>0){_content+=DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";}DAS_InternalStorages.push(_content);}else if(DASobj.VolumeName==="Tenant (T)"){var _content2=DASobj.VolumeName+" - "+DASobj.DiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";if(DASobj.RAIDLevel!==undefined&&DASobj.RAIDLevel.trim().length>0){_content2+=DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";}DAS_InternalStorages.push(_content2);}else{var _content3=DASobj.VolumeName+" - "+DASobj.DiskQty/ServerCount+" Disks ("+DASobj.Disk+") ";if(DASobj.RAIDLevel!==undefined&&DASobj.RAIDLevel.trim().length>0){_content3+=DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";}DAS_InternalStorages.push(_content3);}}}else{DASExtArrayType=DASobj.ArrayType;var ServerQty="";if(__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]==="EPAvNext"){if(RoleObj['Processor'].indexOf("Synergy")===-1){DASExtDiskQty+=parseInt(DASobj.DiskQty,10);}else{if(DASobj["ArrayType"]==="D3940"){ServerQty=parseInt(DASobj.DiskQty,10)/parseInt(RoleObj.ServerName["@Qty"],10);DASExtDiskQty+=parseInt(ServerQty,10);//DASobj.DiskQty=ServerQty.toString();
}else{DASExtDiskQty+=parseInt(DASobj.DiskQty,10);ServerQty=parseInt(DASobj.DiskQty,10);}}}else{DASExtDiskQty+=parseInt(DASobj.DiskQty,10);ServerQty=parseInt(DASobj.DiskQty,10);}DASExtOnlineSpareQty+=parseInt(DASobj.OnlineSpare,10);if(DASobj.DiskQty==='1'){DAS_ExternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel);}else{var _content4=DASobj.VolumeName+" - "+ServerQty.toString()+" Disks ("+DASobj.Disk+") ";if(DASobj.RAIDLevel!==undefined&&DASobj.RAIDLevel.trim().length>0){_content4+=DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ";}DAS_ExternalStorages.push(_content4);}}});}else{// if DAS.TableData is an object
if(RoleObj.DAS.TableData.ArrayType===undefined){DASIntDiskQty+=parseInt(RoleObj.DAS.TableData.DiskQty,10);DASIntOnlineSpareQty+=parseInt(RoleObj.DAS.TableData.OnlineSpare,10);if(RoleObj.DAS.TableData.DiskQty==='1'){//DAS_ExternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RaidLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");
DAS_InternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RaidLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");}else{DAS_InternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RAIDLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");}}else{DASExtArrayType=RoleObj.DAS.TableData.ArrayType;DASExtDiskQty+=parseInt(RoleObj.DAS.TableData.DiskQty,10);DASExtOnlineSpareQty+=parseInt(RoleObj.DAS.TableData.OnlineSpare,10);if(RoleObj.DAS.TableData.DiskQty==='1'){DAS_ExternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RaidLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");}else{DAS_ExternalStorages.push(RoleObj.DAS.TableData.VolumeName+" - "+RoleObj.DAS.TableData.DiskQty+" Disks ("+RoleObj.DAS.TableData.Disk+") "+RoleObj.DAS.TableData.RAIDLevel+" Spares ("+RoleObj.DAS.TableData.OnlineSpare+") ");}}}}else{// if DAS.TableData is not available          
RoleObj.DAS.map(function(DASobj,index){if(DASobj.ArrayType===undefined){DASIntDiskQty+=parseInt(DASobj.DiskQty,10);DASIntOnlineSpareQty+=parseInt(DASobj.OnlineSpare,10);if(DASobj.DiskQty==='1'){DAS_InternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel+" Spares ("+DASobj.OnlineSpare+") ");}else{DAS_InternalStorages.push(DASobj.VolumeName+" - "+DASIntDiskQty/ServerCount+" Disks ("+DASobj.Disk+") "+DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ");}}else{DASExtArrayType=DASobj.ArrayType;DASExtDiskQty+=parseInt(DASobj.DiskQty,10);DASExtOnlineSpareQty+=parseInt(DASobj.OnlineSpare,10);if(DASobj.DiskQty==='1'){DAS_ExternalStorages.push(DASobj.VolumeName+" - ("+DASobj.Disk+") "+DASobj.RaidLevel+" Spares ("+DASobj.OnlineSpare+") ");}else{DAS_ExternalStorages.push(DASobj.VolumeName+" - "+DASobj.DiskQty+" Disks ("+DASobj.Disk+") "+DASobj.RAIDLevel+" Spares ("+DASobj.OnlineSpare+") ");}}});}var DASIntHeader="Disk(DAS) - "+DASIntDiskQty/ServerCount+" Disks Spares ("+DASIntOnlineSpareQty+") (Per Server)";var DASExtHeader='';if(RoleObj.DAS.StorageBoxes!==undefined){DASExtHeader="Disk(DAS) - "+DASExtDiskQty+" Disks ("+RoleObj.DAS.StorageBoxes+" x "+DASExtArrayType+")";}else{DASExtHeader="Disk(DAS) - "+DASExtDiskQty+" Disks ("+DASExtArrayType+") Spares ("+DASExtOnlineSpareQty+") (Per Server)";}// DASExtHeader = "Disk(DAS) - "+DASExtDiskQty+" Disks ("+DASExtArrayType+") Spares ("+DASExtOnlineSpareQty+") (Per Server)";
var DASIntContent='';var DASExtContent='';if(DASIntDiskQty!==0){DASIntContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CustomArticle__["a" /* default */],{ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:DASIntHeader,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,DAS_InternalStorages.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,style:{maxWidth:'100%'}},value);}))});}if(DASExtDiskQty!==0){DASExtContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CustomArticle__["a" /* default */],{ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:DASExtHeader,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,DAS_ExternalStorages.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,style:{maxWidth:'100%'}},value);}))});}DASData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{id:'CustomArticlesContainer',margin:'none',pad:{between:'small'}},DASIntContent,DASExtContent);}// if SAN has Nimble Storage 
if(RoleObj.SAN!==undefined&&RoleObj.SAN['TableData']!==undefined){// SAN variables
//let SANExtOnlineSpareQty = 0;
var SANExtArrayQty='';var SANExtArrayType='';var SAN_ExternalStorages=[];var SANExtDiskQty=0;// if SAN.TableData is not available
var SANExtHeader='';var SANExtContent='';if(RoleObj.SAN.TableData===undefined){}else{var nimbleor3par='';// if SAN.TableData is available 
// if SAN.Nimble is available 
if(RoleObj.SAN['NimbleStorage']!==undefined){SANExtHeader=RoleObj.SAN.StorageBoxes+' [Nimble] ';if(Array.isArray(RoleObj.SAN.TableData)){// if SAN.TableData is an array
RoleObj.SAN.TableData.map(function(SANobj,index){SAN_ExternalStorages.push(SANobj.VolumeName);});}else{SAN_ExternalStorages.push(RoleObj.SAN.TableData.VolumeName);}SANExtContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CustomArticle__["a" /* default */],{ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:SANExtHeader,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,SAN_ExternalStorages.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,style:{maxWidth:'100%'}},value);}))});}else{SANExtArrayQty=RoleObj.SAN.StorageBoxes;if(Array.isArray(RoleObj.SAN.TableData)){if(RoleObj.SAN.TableData[0]!==undefined&&RoleObj.SAN.TableData[0]!==null){nimbleor3par='[ '+RoleObj.SAN.TableData[0]['StorageType']+' ]';}// if SAN.TableData is an array
RoleObj.SAN.TableData.map(function(SANobj,index){SANExtArrayType=SANobj.ArrayType;SANExtDiskQty+=parseInt(SANobj.DiskQty,10);//SANExtOnlineSpareQty += parseInt(SANobj.OnlineSpare, 10);
if(SANobj.DiskQty==='1'){SAN_ExternalStorages.push(SANobj.VolumeName+" - ("+SANobj.Disk+") "+SANobj.RaidLevel);}else{SAN_ExternalStorages.push(SANobj.VolumeName+" - "+SANobj.DiskQty+" Disks ("+SANobj.Disk+") "+SANobj.RaidLevel);}});}else{// if SAN.TableData is an object
if(RoleObj.SAN.TableData['StorageType'].trim().length>0){nimbleor3par='[ '+RoleObj.SAN.TableData['StorageType']+' ]';}SANExtArrayType=RoleObj.SAN.TableData.ArrayType;SANExtDiskQty+=parseInt(RoleObj.SAN.TableData.DiskQty,10);//SANExtOnlineSpareQty += parseInt(RoleObj.SAN.TableData.OnlineSpare, 10);
if(RoleObj.SAN.TableData.DiskQty==='1'){SAN_ExternalStorages.push(RoleObj.SAN.TableData.VolumeName+" - ("+RoleObj.SAN.TableData.Disk+") "+RoleObj.SAN.TableData.RaidLevel);}else{SAN_ExternalStorages.push(RoleObj.SAN.TableData.VolumeName+" - "+RoleObj.SAN.TableData.DiskQty+" Disks ("+RoleObj.SAN.TableData.Disk+") "+RoleObj.SAN.TableData.RaidLevel);}}SANExtHeader="Disk(SAN) - "+SANExtDiskQty+" Disks ("+SANExtArrayQty+" x "+SANExtArrayType+")"+nimbleor3par;SANExtContent='';if(SANExtDiskQty!==0){SANExtContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__CustomArticle__["a" /* default */],{ArticleBackgroundColor:'light-2',ContentBackgroundColor:'light-1',title:SANExtHeader,titleIcon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_Storage___default.a,{size:'small',colorIndex:'#69506f'}),content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,SAN_ExternalStorages.map(function(value,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,style:{maxWidth:'100%'}},value);}))});}}}SANData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{id:'CustomArticlesContainer',margin:'none',pad:{between:'small'}},SANExtContent);}var widthproc='80%';var paddingproc='0px 12px';if(__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]==="EPAvNext"){widthproc="100%";paddingproc='0px 0px';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',className:'RecomSolnBox'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',margin:'none',pad:'none',align:'start'},MainServerName===null?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{fontWeight:'500'},margin:'none'},' ',MainServerName,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Tiles___default.a,{selectable:false,fill:true,flush:true,align:'start',direction:'row',margin:'none',pad:{between:"small"}},ProcDetails===null||ProcDetails===''?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tile___default.a,{basis:'1/3',style:{maxHeight:'220px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'between',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]!=="EPAvNext"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default.a,{style:{height:'100%',width:'20%'},src:'../img/Generic Processor.jpg'}):"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{width:widthproc,padding:paddingproc}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Processor'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{fontWeight:'500'},margin:'none'},' ',ProcDetails,' ')))),MemoryDetails===null||MemoryDetails===''?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tile___default.a,{basis:'1/3',style:{maxHeight:'220px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'between',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]!=="EPAvNext"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default.a,{src:'../img/Generic Memory.jpg',style:{height:'100%',width:'20%'}}):"",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{width:widthproc,padding:paddingproc}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Memory'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{fontWeight:'500'},margin:'none'},' ',MemoryDetails,' ',MemoryDIMMDetails,' ')))),StorageDetails===null||StorageDetails===''||__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]!=='SAPHANA'||__WEBPACK_IMPORTED_MODULE_8__AppConfig__["f" /* said */]==='SAPHANA'&&this.props.WorkloadType==="TDI"?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tile___default.a,{basis:'1/3',style:{maxHeight:'220px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'between',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default.a,{style:{height:'100%',width:'20%'},src:'../img/Generic Storage.jpg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},style:{width:'80%',padding:'0px 12px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',strong:true,margin:'none'},'Storage'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{fontWeight:'500',marginBottom:'0px'},margin:'none'},' ',StorageDetails,' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Heading___default.a,{tag:'h5',style:{fontWeight:'500'},margin:'none'},'  ',StorageVolumeDetails,' ')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:{between:"small"}},DASData,SANData));}}]);return RecomSoln;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RecomSoln);

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _Button = __webpack_require__(12);

var _Button2 = _interopRequireDefault(_Button);

var _Spinning = __webpack_require__(17);

var _Spinning2 = _interopRequireDefault(_Spinning);

var _Scroll = __webpack_require__(277);

var _Scroll2 = _interopRequireDefault(_Scroll);

var _InfiniteScroll = __webpack_require__(171);

var _InfiniteScroll2 = _interopRequireDefault(_InfiniteScroll);

var _Selection = __webpack_require__(172);

var _Selection2 = _interopRequireDefault(_Selection);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Announcer = __webpack_require__(34);

var _LinkPrevious = __webpack_require__(278);

var _LinkPrevious2 = _interopRequireDefault(_LinkPrevious);

var _LinkNext = __webpack_require__(170);

var _LinkNext2 = _interopRequireDefault(_LinkNext);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TILES;
var TILE = _CSSClassnames2.default.TILE;
var SELECTED_CLASS = TILE + '--selected';
var ACTIVE_CLASS = TILE + '--active';

var Tiles = function (_Component) {
  _inherits(Tiles, _Component);

  function Tiles(props, context) {
    _classCallCheck(this, Tiles);

    var _this = _possibleConstructorReturn(this, (Tiles.__proto__ || Object.getPrototypeOf(Tiles)).call(this, props, context));

    _this._onLeft = _this._onLeft.bind(_this);
    _this._onRight = _this._onRight.bind(_this);
    _this._onScrollHorizontal = _this._onScrollHorizontal.bind(_this);
    _this._onWheel = _this._onWheel.bind(_this);
    _this._onResize = _this._onResize.bind(_this);
    _this._layout = _this._layout.bind(_this);
    _this._onClick = _this._onClick.bind(_this);
    _this._fireClick = _this._fireClick.bind(_this);
    _this._announceTile = _this._announceTile.bind(_this);
    _this._onPreviousTile = _this._onPreviousTile.bind(_this);
    _this._onNextTile = _this._onNextTile.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);

    _this.state = {
      activeTile: undefined,
      mouseActive: false,
      overflow: false,
      selected: _Selection2.default.normalizeIndexes(props.selected)
    };
    return _this;
  }

  _createClass(Tiles, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          direction = _props.direction,
          onMore = _props.onMore,
          selectable = _props.selectable;

      if (onMore) {
        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
      }
      if ('row' === direction) {
        window.addEventListener('resize', this._onResize);
        document.addEventListener('wheel', this._onWheel, { passive: true });
        this._trackHorizontalScroll();
        // give browser a chance to stabilize
        this._layoutTimer = setTimeout(this._layout, 10);
      }
      if (selectable) {
        // only listen for navigation keys if the tile row can be selected
        this._keyboardHandlers = {
          left: this._onPreviousTile,
          up: this._onPreviousTile,
          right: this._onNextTile,
          down: this._onNextTile,
          enter: this._onEnter,
          space: this._onEnter
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selected !== undefined) {
        this.setState({
          selected: _Selection2.default.normalizeIndexes(nextProps.selected)
        });
      }
      if (this._scroll) {
        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
        this._scroll = undefined;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          direction = _props2.direction,
          onMore = _props2.onMore,
          selectable = _props2.selectable;

      if (onMore && !this._scroll) {
        this._scroll = _InfiniteScroll2.default.startListeningForScroll(this.moreRef, onMore);
      }
      if ('row' === direction) {
        this._trackHorizontalScroll();
        // give browser a chance to stabilize
        this._layoutTimer = setTimeout(this._layout, 10);
      }
      if (selectable) {
        // only listen for navigation keys if the list row can be selected
        this._keyboardHandlers = {
          left: this._onPreviousTile,
          up: this._onPreviousTile,
          right: this._onNextTile,
          down: this._onNextTile,
          enter: this._onEnter,
          space: this._onEnter
        };
        _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props3 = this.props,
          direction = _props3.direction,
          selectable = _props3.selectable;

      if (this._scroll) {
        _InfiniteScroll2.default.stopListeningForScroll(this._scroll);
      }
      if ('row' === direction) {
        window.removeEventListener('resize', this._onResize);
        document.removeEventListener('wheel', this._onWheel);
        if (this._tracking) {
          var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
          tiles.removeEventListener('scroll', this._onScrollHorizontal);
        }
      }
      if (selectable) {
        _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);
      }
      if (this._layoutTimer) {
        clearTimeout(this._layoutTimer);
      }
    }
  }, {
    key: '_announceTile',
    value: function _announceTile(label) {
      var intl = this.context.intl;

      var enterSelectMessage = _Intl2.default.getMessage(intl, 'Enter Select');
      // avoid a long text to be read by the screen reader
      var labelMessage = label.length > 15 ? label.substring(0, 15) + '...' : label;
      (0, _Announcer.announce)(labelMessage + ' ' + enterSelectMessage);
    }
  }, {
    key: '_onPreviousTile',
    value: function _onPreviousTile(event) {
      var _this2 = this;

      if ((0, _reactDom.findDOMNode)(this.tilesRef).contains(document.activeElement)) {
        event.preventDefault();
        var activeTile = this.state.activeTile;

        var rows = (0, _reactDom.findDOMNode)(this.tilesRef).querySelectorAll('.' + TILE);
        if (rows && rows.length > 0) {
          if (activeTile === undefined) {
            rows[0].classList.add(ACTIVE_CLASS);
            this.setState({ activeTile: 0 }, function () {
              _this2._announceTile(rows[_this2.state.activeTile].innerText);
            });
          } else if (activeTile - 1 >= 0) {
            rows[activeTile].classList.remove(ACTIVE_CLASS);
            rows[activeTile - 1].classList.add(ACTIVE_CLASS);
            this.setState({ activeTile: activeTile - 1 }, function () {
              _this2._announceTile(rows[_this2.state.activeTile].innerText);
            });
          }
        }

        //stop event propagation
        return true;
      }
    }
  }, {
    key: '_onNextTile',
    value: function _onNextTile(event) {
      var _this3 = this;

      if ((0, _reactDom.findDOMNode)(this.tilesRef).contains(document.activeElement)) {
        event.preventDefault();
        var activeTile = this.state.activeTile;

        var rows = (0, _reactDom.findDOMNode)(this.tilesRef).querySelectorAll('.' + TILE);
        if (rows && rows.length > 0) {
          if (activeTile === undefined) {
            rows[0].classList.add(ACTIVE_CLASS);
            this.setState({ activeTile: 0 }, function () {
              _this3._announceTile(rows[_this3.state.activeTile].innerText);
            });
          } else if (activeTile + 1 <= rows.length - 1) {
            rows[activeTile].classList.remove(ACTIVE_CLASS);
            rows[activeTile + 1].classList.add(ACTIVE_CLASS);
            this.setState({ activeTile: activeTile + 1 }, function () {
              _this3._announceTile(rows[_this3.state.activeTile].innerText);
            });
          }
        }

        //stop event propagation
        return true;
      }
    }
  }, {
    key: '_fireClick',
    value: function _fireClick(element, shiftKey) {
      var event = void 0;
      try {
        event = new MouseEvent('click', {
          'bubbles': true,
          'cancelable': true,
          'shiftKey': shiftKey
        });
      } catch (e) {
        // IE11 workaround.
        event = document.createEvent('Event');
        event.initEvent('click', true, true);
      }
      // We use dispatchEvent to have the browser fill out the event fully.
      element.dispatchEvent(event);
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(event) {
      var activeTile = this.state.activeTile;
      var intl = this.context.intl;

      if ((0, _reactDom.findDOMNode)(this.tilesRef).contains(document.activeElement) && activeTile !== undefined) {
        var rows = (0, _reactDom.findDOMNode)(this.tilesRef).querySelectorAll('.' + TILE);
        this._fireClick(rows[activeTile], event.shiftKey);
        rows[activeTile].classList.remove(ACTIVE_CLASS);
        var label = rows[activeTile].innerText;
        // avoid a long text to be read by the screen reader
        var labelMessage = label.length > 15 ? label.substring(0, 15) + '...' : label;
        var selectedMessage = _Intl2.default.getMessage(intl, 'Selected');
        (0, _Announcer.announce)(labelMessage + ' ' + selectedMessage);
      }
    }
  }, {
    key: '_onLeft',
    value: function _onLeft() {
      var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
      _Scroll2.default.scrollBy(tiles, 'scrollLeft', -tiles.offsetWidth);
    }
  }, {
    key: '_onRight',
    value: function _onRight() {
      var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
      _Scroll2.default.scrollBy(tiles, 'scrollLeft', tiles.offsetWidth);
    }
  }, {
    key: '_onScrollHorizontal',
    value: function _onScrollHorizontal() {
      // debounce
      clearTimeout(this._layoutTimer);
      this._layoutTimer = setTimeout(this._layout, 50);
    }
  }, {
    key: '_onWheel',
    value: function _onWheel(event) {
      if (Math.abs(event.deltaX) > 100) {
        clearInterval(this._scrollTimer);
      } else if (event.deltaX > 5) {
        this._onRight();
      } else if (event.deltaX < -5) {
        this._onLeft();
      }
    }
  }, {
    key: '_layout',
    value: function _layout() {
      var direction = this.props.direction;


      if ('row' === direction) {
        // determine if we have more tiles than room to fit
        var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);

        // 20 is to allow some fuzziness as scrollbars come and go
        var newState = {
          overflow: tiles.scrollWidth > tiles.offsetWidth + 20,
          overflowStart: tiles.scrollLeft <= 20,
          overflowEnd: tiles.scrollLeft >= tiles.scrollWidth - tiles.offsetWidth,
          scrollWidth: tiles.scrollWidth
        };

        var state = {
          overflow: this.state.overflow,
          overflowStart: this.state.overflowStart,
          overflowEnd: this.state.overflowEnd,
          scrollWidth: this.state.scrollWidth
        };

        // Shallow compare states.
        if (JSON.stringify(newState) !== JSON.stringify(state)) {
          this.setState(_extends({}, newState));
        }

        // mark any tiles that might be clipped
        var rect = tiles.getBoundingClientRect();
        var children = tiles.querySelectorAll('.' + TILE);

        Array.from(children).map(function (child, index) {
          var childRect = child.getBoundingClientRect();
          // 12 accounts for padding
          if (childRect.left + 12 < rect.left || childRect.right - 12 > rect.right) {
            child.classList.add(TILE + '--eclipsed');
          } else {
            child.classList.remove(TILE + '--eclipsed');
          }
        });
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      // debounce
      clearTimeout(this._layoutTimer);
      this._layoutTimer = setTimeout(this._layout, 50);
    }
  }, {
    key: '_trackHorizontalScroll',
    value: function _trackHorizontalScroll() {
      var overflow = this.state.overflow;

      if (overflow && !this._tracking) {
        var tiles = (0, _reactDom.findDOMNode)(this.tilesRef);
        tiles.addEventListener('scroll', this._onScrollHorizontal);
        this._tracking = true;
      }
    }
  }, {
    key: '_onClick',
    value: function _onClick(event) {
      var _props4 = this.props,
          onSelect = _props4.onSelect,
          selectable = _props4.selectable,
          selected = _props4.selected;

      var selection = _Selection2.default.onClick(event, {
        containerElement: (0, _reactDom.findDOMNode)(this.tilesRef),
        childSelector: '.' + TILE,
        selectedClass: SELECTED_CLASS,
        multiSelect: 'multiple' === selectable,
        priorSelectedIndexes: this.state.selected
      });
      // only set the selected state and classes if the caller isn't managing it.
      if (selected === undefined) {
        this.setState({ selected: selection });
      }

      if (onSelect) {
        onSelect(selection.length === 1 ? selection[0] : selection);
      }
    }
  }, {
    key: '_renderChild',
    value: function _renderChild(element, elementIndex) {
      var flush = this.props.flush;
      var selectedArray = this.state.selected;

      var selected = element.props.selected;

      if (selectedArray && selectedArray.indexOf(elementIndex) > -1) {
        selected = true;
      }

      if (element) {
        // only clone tile children
        if (element.type && element.type._tile) {
          var elementClone = _react2.default.cloneElement(element, {
            hoverBorder: !flush,
            selected: selected
          });

          return elementClone;
        }
        return element;
      }

      return undefined;
    }

    // children should be an array of Tile

  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this4 = this;

      var _props5 = this.props,
          a11yTitle = _props5.a11yTitle,
          className = _props5.className,
          children = _props5.children,
          direction = _props5.direction,
          fill = _props5.fill,
          flush = _props5.flush,
          _onBlur = _props5.onBlur,
          _onFocus = _props5.onFocus,
          onMore = _props5.onMore,
          _onMouseDown = _props5.onMouseDown,
          _onMouseUp = _props5.onMouseUp,
          selectable = _props5.selectable;
      var _state = this.state,
          activeTile = _state.activeTile,
          focus = _state.focus,
          mouseActive = _state.mouseActive,
          overflow = _state.overflow,
          overflowEnd = _state.overflowEnd,
          overflowStart = _state.overflowStart;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--fill', fill), _defineProperty(_classnames, CLASS_ROOT + '--flush', flush), _defineProperty(_classnames, CLASS_ROOT + '--focus', focus), _defineProperty(_classnames, CLASS_ROOT + '--selectable', selectable), _defineProperty(_classnames, CLASS_ROOT + '--moreable', onMore), _defineProperty(_classnames, CLASS_ROOT + '--overflowed', overflow), _classnames), className);

      var other = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));

      var more = void 0;
      if (onMore) {
        more = _react2.default.createElement(
          'div',
          { ref: function ref(_ref) {
              return _this4.moreRef = _ref;
            }, className: CLASS_ROOT + '__more' },
          _react2.default.createElement(_Spinning2.default, null)
        );
      }

      var tileContents = _react.Children.toArray(children).filter(function (child) {
        return child;
      }).map(function (element, index) {
        return _this4._renderChild(element, index);
      });

      var selectableProps = void 0;
      if (selectable) {
        var multiSelectMessage = selectable === 'multiple' ? '(' + _Intl2.default.getMessage(intl, 'Multi Select') + ')' : '';
        var tilesMessage = a11yTitle || _Intl2.default.getMessage(intl, 'Tiles');
        var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');
        selectableProps = {
          'aria-label': tilesMessage + ' ' + multiSelectMessage + ' ' + navigationHelpMessage,
          tabIndex: '0',
          onClick: this._onClick,
          onMouseDown: function onMouseDown(event) {
            _this4.setState({ mouseActive: true });
            if (_onMouseDown) {
              _onMouseDown(event);
            }
          },
          onMouseUp: function onMouseUp(event) {
            _this4.setState({ mouseActive: false });
            if (_onMouseUp) {
              _onMouseUp(event);
            }
          },
          onFocus: function onFocus(event) {
            if (mouseActive === false) {
              _this4.setState({ focus: true });
            }
            if (_onFocus) {
              _onFocus(event);
            }
          },
          onBlur: function onBlur(event) {
            if (activeTile) {
              var rows = (0, _reactDom.findDOMNode)(_this4.tilesRef).querySelectorAll('.' + TILE);
              rows[activeTile].classList.remove(ACTIVE_CLASS);
            }
            _this4.setState({ focus: false, activeTile: undefined });
            if (_onBlur) {
              _onBlur(event);
            }
          }
        };
      }

      var contents = _react2.default.createElement(
        _Box2.default,
        _extends({ ref: function ref(_ref2) {
            return _this4.tilesRef = _ref2;
          } }, other, {
          wrap: direction ? false : true,
          direction: direction ? direction : 'row',
          className: classes, focusable: false }, selectableProps),
        tileContents,
        more
      );

      if (overflow) {
        var left = void 0;
        var right = void 0;

        if (!overflowStart) {
          var previousTilesMessage = _Intl2.default.getMessage(intl, 'Previous Tiles');
          left = _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__left',
            icon: _react2.default.createElement(_LinkPrevious2.default, null),
            a11yTitle: previousTilesMessage, onClick: this._onLeft });
        }
        if (!overflowEnd) {
          var nextTilesMessage = _Intl2.default.getMessage(intl, 'Next Tiles');
          right = _react2.default.createElement(_Button2.default, { className: CLASS_ROOT + '__right',
            icon: _react2.default.createElement(_LinkNext2.default, null),
            a11yTitle: nextTilesMessage, onClick: this._onRight });
        }

        contents = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + '__container' },
          left,
          contents,
          right
        );
      }

      return contents;
    }
  }]);

  return Tiles;
}(_react.Component);

Tiles.displayName = 'Tiles';
exports.default = Tiles;


Tiles.contextTypes = {
  intl: _propTypes2.default.object
};

Tiles.propTypes = _extends({
  fill: _propTypes2.default.bool,
  flush: _propTypes2.default.bool,
  onMore: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  selectable: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['multiple'])]),
  selected: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)])
}, _Box2.default.propTypes);

Tiles.defaultProps = {
  flush: true,
  justify: 'start',
  pad: 'small'
};
module.exports = exports['default'];

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.TILE;
var NAMESPACE = _CSSClassnames2.default.NAMESPACE;

var Tile = function (_Component) {
  _inherits(Tile, _Component);

  function Tile() {
    _classCallCheck(this, Tile);

    return _possibleConstructorReturn(this, (Tile.__proto__ || Object.getPrototypeOf(Tile)).apply(this, arguments));
  }

  _createClass(Tile, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          onClick = _props.onClick,
          wide = _props.wide,
          status = _props.status,
          hoverStyle = _props.hoverStyle,
          hoverColorIndex = _props.hoverColorIndex,
          hoverBorder = _props.hoverBorder,
          hoverBorderSize = _props.hoverBorderSize,
          selected = _props.selected;

      var restProps = _Props2.default.omit(this.props, Object.keys(Tile.propTypes));

      var statusClass = status ? status.toLowerCase() : undefined;
      // if Tiles flush is true, default borderSize to small (1px)
      var borderSize = hoverBorder ? hoverBorderSize ? hoverBorderSize : 'large' : 'small';

      var classes = (0, _classnames3.default)(CLASS_ROOT, className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--status-' + statusClass, status), _defineProperty(_classnames, CLASS_ROOT + '--selected', selected), _defineProperty(_classnames, CLASS_ROOT + '--wide', wide), _defineProperty(_classnames, CLASS_ROOT + '--selectable', onClick), _defineProperty(_classnames, '' + NAMESPACE + hoverStyle + (hoverStyle == 'border' ? borderSize ? '-' + borderSize : '-medium' : '') + '-hover-color-index-' + hoverColorIndex, hoverStyle), _defineProperty(_classnames, CLASS_ROOT + '--hover-border-' + borderSize, borderSize), _classnames));

      var boxProps = _Props2.default.pick(this.props, Object.keys(_Box2.default.propTypes));

      return _react2.default.createElement(
        _Box2.default,
        _extends({}, restProps, boxProps, { className: classes }),
        children
      );
    }
  }]);

  return Tile;
}(_react.Component);

// add a strong and more reliable link between Tiles and Tile


Tile.displayName = 'Tile';
exports.default = Tile;
Tile._tile = true;

Tile.propTypes = _extends({
  hoverStyle: _propTypes2.default.oneOf(['border', 'background', 'none']),
  hoverColorIndex: _propTypes2.default.string,
  hoverBorder: _propTypes2.default.bool,
  hoverBorderSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  selected: _propTypes2.default.bool,
  wide: _propTypes2.default.bool }, _Box2.default.propTypes);

Tile.defaultProps = {
  pad: 'none',
  direction: 'column',
  align: 'center',
  hoverStyle: 'none',
  hoverColorIndex: 'disabled'
};
module.exports = exports['default'];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-storage', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'storage');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M3,24 L3,1 L21,1 L21,24 M9,6 L15,6 M9,16 L15,16 M3,11 L21,11 M3,21 L21,21' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Storage';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Datafiles_BOMPriceFile_json__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Datafiles_BOMPriceFile_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Datafiles_BOMPriceFile_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_render_html__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_render_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_render_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jspdf__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AppConfig__ = __webpack_require__(13);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Heading from 'grommet/components/Heading';
var TableContentMap=void 0;var PartNumberText=void 0;var TotalTableContentMap=void 0;var TotalPrice=void 0;var StringX;var BOM=function(_Component){_inherits(BOM,_Component);function BOM(props){_classCallCheck(this,BOM);var _this=_possibleConstructorReturn(this,(BOM.__proto__||Object.getPrototypeOf(BOM)).call(this,props));_this.state={BOMTableData:[]};_this.tableDataBind=_this.tableDataBind.bind(_this);_this.onBomSavePdf=_this.onBomSavePdf.bind(_this);_this.downloadPDF=_this.downloadPDF.bind(_this);_this.PDFConvertionDownload=_this.PDFConvertionDownload.bind(_this);_this.exportToExcel=_this.exportToExcel.bind(_this);return _this;}_createClass(BOM,[{key:'componentWillMount',value:function componentWillMount(){this.tableDataBind();}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.activeSession.bomView==''){var sessionObject=void 0;if(this.props.actvSoln===undefined||this.props.actvSoln===null){sessionObject={"SessionID":this.props.activeSession.id};}else{//var sessionObject = {"SessionID":this.props.activeSession.id };//Rohith-Removed Traditional from backend
sessionObject={"SessionID":this.props.activeSession.id,"EPASolutionType":this.props.actvSoln.toString()};}this.props.onFetchBOMString(sessionObject);}}},{key:'exportToExcel',value:function exportToExcel(){// var sessionObject = {"SessionID":this.props.activeSession.id, "EPASolutionType": this.props.actvSoln };
//commented by dheeraj as this way of download doesnot surpport to add token to header
// if(this.props.actvSoln === undefined || this.props.actvSoln === null){
//     var sessionObject = {"SessionID":this.props.activeSession.id };
// }else{
//     var sessionObject = {"SessionID":this.props.activeSession.id, "EPASolutionType": this.props.actvSoln };
// }
// var mapForm = document.createElement("form");
// mapForm.id = "FormExportBOM";
// mapForm.setAttribute("method","GET")
// mapForm.setAttribute("action",serviceUrl+"/SizingEngine/GenerateBOMDocumet");
// mapForm.target = "_blank";
// var mapInput = document.createElement("input");
// mapInput.id = "BomHTMLTemp";
// mapInput.type = "text";
// mapInput.name = "value";
// mapInput.value = this.props.activeSession.id.toString();
// mapForm.appendChild(mapInput);
// if(said === 'EPA')
// {
//     var mapInput1 = document.createElement("input");
//     mapInput1.id = "BomHTMLTemp";
//     mapInput1.type = "text";
//     mapInput1.name = "EPASolutionType";
//     mapInput1.value = null;
//     if(this.props.actvSoln!==null)
//     {
//         mapInput1.value = this.props.actvSoln.toString();
//     }                    
//     mapForm.appendChild(mapInput1);
// }
// document.body.appendChild(mapForm);
// mapForm.submit();
// $("#FormExportBOM").remove();
//commented - end by dheeraj as this way of download doesnot surpport to add token to header
var exportUrl=void 0;if(this.props.actvSoln){exportUrl=__WEBPACK_IMPORTED_MODULE_11__AppConfig__["g" /* serviceUrl */]+"/SizingEngine/GenerateBOMDocumet?value="+this.props.activeSession.id.toString()+"&EPASolutionType="+this.props.actvSoln.toString();}else{exportUrl=__WEBPACK_IMPORTED_MODULE_11__AppConfig__["g" /* serviceUrl */]+"/SizingEngine/GenerateBOMDocumet?value="+this.props.activeSession.id.toString();}var data={url:exportUrl,name:'BillOfMaterials.xls'};this.props.onBomExport(data);}},{key:'tableDataBind',value:function tableDataBind(){TotalPrice=0;this.state.BOMTableData=__WEBPACK_IMPORTED_MODULE_6__Datafiles_BOMPriceFile_json___default.a;TotalTableContentMap=this.state.BOMTableData.Solution.RoleBOM.map(function(val,id){TableContentMap=val.ConsolidatedBOM.TableData.map(function(data,index){TotalPrice=TotalPrice+parseInt(data["CostAtQty"].replace(/,/g,""),10);if(_typeof(data["PartNumber"])==="object"){PartNumberText=data["PartNumber"]["#text"];}else{PartNumberText=data["PartNumber"];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data["Qty"]),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data["Status"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data["Price"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,data["CostAtQty"]));});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,' ',TableContentMap,' ');});}},{key:'onBomSavePdf',value:function onBomSavePdf(){__WEBPACK_IMPORTED_MODULE_8_html2canvas___default()(document.querySelector("#PrintBOM")).then(function(canvas){var imgData=canvas.toDataURL('image/png');var doc;if(canvas.width>canvas.height){doc=new __WEBPACK_IMPORTED_MODULE_9_jspdf___default.a('l','mm',[500,700]);doc.addImage(imgData,'JPEG',50,50);}else{doc=new __WEBPACK_IMPORTED_MODULE_9_jspdf___default.a('p','mm',[380,canvas.width]);doc.addImage(imgData,'JPEG',15,15);}doc.save("BOM.pdf");});}},{key:'downloadPDF',value:function downloadPDF(url,name){}},{key:'PDFConvertionDownload',value:function PDFConvertionDownload(url){}},{key:'render',value:function render(){StringX=this.props.activeSession.bomView;var decoaded=__WEBPACK_IMPORTED_MODULE_10_jquery___default()('<div />').html(StringX).text();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:'PrintBOM',style:{width:'100%',position:'relative'},margin:'none',pad:'none',className:'StringSection'},__WEBPACK_IMPORTED_MODULE_7_react_render_html___default()(decoaded),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',className:'StringSection',alignSelf:'start',align:'start',alignContent:'start',style:{marginLeft:'1%',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{primary:false,label:'Download BOM as Excel',style:{marginRight:'15px'},onClick:this.exportToExcel})));}}]);return BOM;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchBOMString:function onFetchBOMString(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["s" /* fetchBOMString */])(sessionID));},onBomExport:function onBomExport(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__State_actions_sessions__["m" /* downloadFile */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(BOM));

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = {"Solution":{"-ID":"1","RoleBOM":[{"-Name":"Mailbox (log and database combined) server - Site 1 - DAG 1","-SiteName":"Site 1","ConsolidatedBOM":{"-xmlns:html":"http://www.w3.org/TR/REC-html40","-xmlns:msxml":"urn:schemas-microsoft-com:xslt","-ConfigType":"2","-Country":"United States","-Currency":"UD","-PriceFileDate":"1/15/2018","-CurrencyCode":"$","TableData":[{"-ID":"0.1","-Type":"ModelsTotal","Qty":"1","PartNumber":"BW899A","Description":"HP 636 1200mm Pallet Intelligent Series Rack","Price":"1649","CostAtQty":"1649","Status":"Active"},{"-ID":"9","-Type":"ServerFamilyTotal","Qty":"2","PartNumber":"786593-B21","Description":"HPE XL450 Gen9 1x Node Svr","Price":"1750","CostAtQty":"3500","Status":"Active"},{"-ID":"11","-Type":"ModelsTotal","Qty":"8","PartNumber":"720620-B21","Description":"HP 1400W FS Plat Hot Plug Pwr Supply Kit","Price":"429","CostAtQty":"3432","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"842993-L21","Description":"HPE XL450 Gen9 E5-2630Lv4 FIO Kit","Price":"919","CostAtQty":"1838","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"799581-B21","Description":"HP Apollo 4510 Gen9 CTO Chassis","Price":"8000","CostAtQty":"16000","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"681254-B21","Description":"HP 4.3U Server Rail Kit","Price":"300","CostAtQty":"600","Status":"Active"},{"-ID":"14","-Type":"MemoryTotal","Qty":"2","PartNumber":{"-CTOFORMAT":"1","#text":"805358-B21"},"Description":"HPE 64GB 4Rx4 PC4-2400T-L Kit","Price":"1799","CostAtQty":"3598","Status":"Active"},{"-ID":"18","-Type":"ModelsTotal","Qty":"2","PartNumber":{"-CTOFORMAT":"1","#text":"726821-B21"},"Description":"HP Smart Array P440/4G Controller","Price":"899","CostAtQty":"1798","Status":"Active"},{"-ID":"19","-Type":"DiskTotal","Qty":"4","CostAtQty":"1996","PartNumber":{"-CTOFORMAT":"1","#text":"655710-B21"},"Description":"1TB 6G SATA 7.2k 2.5in SC MDL HDD","Price":"499","Status":"Active"},{"-ID":"19","-Type":"DiskTotal","Qty":"10","CostAtQty":"7690","PartNumber":{"-CTOFORMAT":"1","#text":"797277-B21"},"Description":"3TB 6G SAS 7.2K 3.5in  MDL LP HDD","Price":"769","Status":"Active"},{"-ID":"21","-Type":"ModelsTotal","Qty":"2","CostAtQty":"138","PartNumber":{"-CTOFORMAT":"1","#text":"808969-B21"},"Description":"HP Apollo 4510 P440 Cable Kit","Price":"69","Status":"Active"},{"-ID":"21","-Type":"ModelsTotal","Qty":"2","CostAtQty":"858","PartNumber":{"-CTOFORMAT":"1","#text":"799377-B21"},"Description":"HP XL4510 8HDD Cage Kit","Price":"429","Status":"Active"}]}},{"-Name":"Consolidated BOM","-SiteName":"Consolidated BOM","ConsolidatedBOM":{"-xmlns:html":"http://www.w3.org/TR/REC-html40","-xmlns:msxml":"urn:schemas-microsoft-com:xslt","-Country":"United States","-Currency":"UD","-PriceFileDate":"1/15/2018","-CurrencyCode":"$","TableData":[{"-ID":"0.1","-Type":"ModelsTotal","Qty":"1","PartNumber":"BW899A","Description":"HP 636 1200mm Pallet Intelligent Series Rack","Price":"1,649","CostAtQty":"1,649","Status":"Active"},{"-ID":"9","-Type":"ServerFamilyTotal","Qty":"2","PartNumber":"786593-B21","Description":"HPE XL450 Gen9 1x Node Svr","Price":"1,750","CostAtQty":"3,500","Status":"Active"},{"-ID":"11","-Type":"ModelsTotal","Qty":"8","PartNumber":"720620-B21","Description":"HP 1400W FS Plat Hot Plug Pwr Supply Kit","Price":"429","CostAtQty":"3,432","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"842993-L21","Description":"HPE XL450 Gen9 E5-2630Lv4 FIO Kit","Price":"919","CostAtQty":"1,838","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"799581-B21","Description":"HP Apollo 4510 Gen9 CTO Chassis","Price":"8,000","CostAtQty":"16,000","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"681254-B21","Description":"HP 4.3U Server Rail Kit","Price":"300","CostAtQty":"600","Status":"Active"},{"-ID":"14","-Type":"MemoryTotal","Qty":"2","PartNumber":"805358-B21","Description":"HPE 64GB 4Rx4 PC4-2400T-L Kit","Price":"1,799","CostAtQty":"3,598","Status":"Active"},{"-ID":"18","-Type":"ModelsTotal","Qty":"2","PartNumber":"726821-B21","Description":"HP Smart Array P440/4G Controller","Price":"899","CostAtQty":"1,798","Status":"Active"},{"-ID":"19","-Type":"DiskTotal","Qty":"4","PartNumber":"655710-B21","Description":"1TB 6G SATA 7.2k 2.5in SC MDL HDD","Price":"499","CostAtQty":"1,996","Status":"Active"},{"-ID":"19","-Type":"DiskTotal","Qty":"10","PartNumber":"797277-B21","Description":"3TB 6G SAS 7.2K 3.5in  MDL LP HDD","Price":"769","CostAtQty":"7,690","Status":"Active"},{"-ID":"21","-Type":"ModelsTotal","Qty":"2","PartNumber":"808969-B21","Description":"HP Apollo 4510 P440 Cable Kit","Price":"69","CostAtQty":"138","Status":"Active"},{"-ID":"21","-Type":"ModelsTotal","Qty":"2","PartNumber":"799377-B21","Description":"HP XL4510 8HDD Cage Kit","Price":"429","CostAtQty":"858","Status":"Active"}],"TotalPrice":"43,097"}},{"-Name":"Consolidated BOM","-SiteName":"Site 1","ConsolidatedBOM":{"-xmlns:html":"http://www.w3.org/TR/REC-html40","-xmlns:msxml":"urn:schemas-microsoft-com:xslt","-ConfigType":"2","-Country":"United States","-Currency":"UD","-PriceFileDate":"1/15/2018","-CurrencyCode":"$","TableData":[{"-ID":"0.1","-Type":"ModelsTotal","Qty":"1","PartNumber":"BW899A","Description":"HP 636 1200mm Pallet Intelligent Series Rack","Price":"1649","CostAtQty":"1649","Status":"Active"},{"-ID":"9","-Type":"ServerFamilyTotal","Qty":"2","PartNumber":"786593-B21","Description":"HPE XL450 Gen9 1x Node Svr","Price":"1750","CostAtQty":"3500","Status":"Active"},{"-ID":"11","-Type":"ModelsTotal","Qty":"8","PartNumber":"720620-B21","Description":"HP 1400W FS Plat Hot Plug Pwr Supply Kit","Price":"429","CostAtQty":"3432","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"842993-L21","Description":"HPE XL450 Gen9 E5-2630Lv4 FIO Kit","Price":"919","CostAtQty":"1838","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"799581-B21","Description":"HP Apollo 4510 Gen9 CTO Chassis","Price":"8000","CostAtQty":"16000","Status":"Active"},{"-ID":"12","-Type":"ModelsTotal","Qty":"2","PartNumber":"681254-B21","Description":"HP 4.3U Server Rail Kit","Price":"300","CostAtQty":"600","Status":"Active"},{"-ID":"14","-Type":"MemoryTotal","Qty":"2","PartNumber":{"-CTOFORMAT":"1","#text":"805358-B21"},"Description":"HPE 64GB 4Rx4 PC4-2400T-L Kit","Price":"1799","CostAtQty":"3598","Status":"Active"},{"-ID":"18","-Type":"ModelsTotal","Qty":"2","PartNumber":{"-CTOFORMAT":"1","#text":"726821-B21"},"Description":"HP Smart Array P440/4G Controller","Price":"899","CostAtQty":"1798","Status":"Active"},{"-ID":"19","-Type":"DiskTotal","Qty":"4","CostAtQty":"1996","PartNumber":{"-CTOFORMAT":"1","#text":"655710-B21"},"Description":"1TB 6G SATA 7.2k 2.5in SC MDL HDD","Price":"499","Status":"Active"},{"-ID":"19","-Type":"DiskTotal","Qty":"10","CostAtQty":"7690","PartNumber":{"-CTOFORMAT":"1","#text":"797277-B21"},"Description":"3TB 6G SAS 7.2K 3.5in  MDL LP HDD","Price":"769","Status":"Active"},{"-ID":"21","-Type":"ModelsTotal","Qty":"2","CostAtQty":"138","PartNumber":{"-CTOFORMAT":"1","#text":"808969-B21"},"Description":"HP Apollo 4510 P440 Cable Kit","Price":"69","Status":"Active"},{"-ID":"21","-Type":"ModelsTotal","Qty":"2","CostAtQty":"858","PartNumber":{"-CTOFORMAT":"1","#text":"799377-B21"},"Description":"HP XL4510 8HDD Cage Kit","Price":"429","Status":"Active"}]}}]}}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Parser = __webpack_require__(309),
    Serializer = __webpack_require__(313);


// Shorthands
exports.parse = function parse(html, options) {
    var parser = new Parser(options);

    return parser.parse(html);
};

exports.parseFragment = function parseFragment(fragmentContext, html, options) {
    if (typeof fragmentContext === 'string') {
        options = html;
        html = fragmentContext;
        fragmentContext = null;
    }

    var parser = new Parser(options);

    return parser.parseFragment(html, fragmentContext);
};

exports.serialize = function (node, options) {
    var serializer = new Serializer(node, options);

    return serializer.serialize();
};


// Tree adapters
exports.treeAdapters = {
    default: __webpack_require__(190),
    htmlparser2: __webpack_require__(643)
};


// Streaming
exports.ParserStream = __webpack_require__(314);
exports.PlainTextConversionStream = __webpack_require__(658);
exports.SerializerStream = __webpack_require__(659);
exports.SAXParser = __webpack_require__(660);


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var UNICODE = __webpack_require__(102);

//Aliases
var $ = UNICODE.CODE_POINTS;

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isSurrogatePair(cp1, cp2) {
    return cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF;
}

function getSurrogatePairCodePoint(cp1, cp2) {
    return (cp1 - 0xD800) * 0x400 + 0x2400 + cp2;
}


//Const
var DEFAULT_BUFFER_WATERLINE = 1 << 16;


//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
var Preprocessor = module.exports = function () {
    this.html = null;

    this.pos = -1;
    this.lastGapPos = -1;
    this.lastCharPos = -1;

    this.gapStack = [];

    this.skipNextNewLine = false;

    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
};

Preprocessor.prototype.dropParsedChunk = function () {
    if (this.pos > this.bufferWaterline) {
        this.lastCharPos -= this.pos;
        this.html = this.html.substring(this.pos);
        this.pos = 0;
        this.lastGapPos = -1;
        this.gapStack = [];
    }
};

Preprocessor.prototype._addGap = function () {
    this.gapStack.push(this.lastGapPos);
    this.lastGapPos = this.pos;
};

Preprocessor.prototype._processHighRangeCodePoint = function (cp) {
    //NOTE: try to peek a surrogate pair
    if (this.pos !== this.lastCharPos) {
        var nextCp = this.html.charCodeAt(this.pos + 1);

        if (isSurrogatePair(cp, nextCp)) {
            //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
            this.pos++;
            cp = getSurrogatePairCodePoint(cp, nextCp);

            //NOTE: add gap that should be avoided during retreat
            this._addGap();
        }
    }

    // NOTE: we've hit the end of chunk, stop processing at this point
    else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return $.EOF;
    }

    return cp;
};

Preprocessor.prototype.write = function (chunk, isLastChunk) {
    if (this.html)
        this.html += chunk;

    else
        this.html = chunk;

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
    this.lastChunkWritten = isLastChunk;
};

Preprocessor.prototype.insertHtmlAtCurrentPos = function (chunk) {
    this.html = this.html.substring(0, this.pos + 1) +
                chunk +
                this.html.substring(this.pos + 1, this.html.length);

    this.lastCharPos = this.html.length - 1;
    this.endOfChunkHit = false;
};


Preprocessor.prototype.advance = function () {
    this.pos++;

    if (this.pos > this.lastCharPos) {
        if (!this.lastChunkWritten)
            this.endOfChunkHit = true;

        return $.EOF;
    }

    var cp = this.html.charCodeAt(this.pos);

    //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
    //must be ignored.
    if (this.skipNextNewLine && cp === $.LINE_FEED) {
        this.skipNextNewLine = false;
        this._addGap();
        return this.advance();
    }

    //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
    if (cp === $.CARRIAGE_RETURN) {
        this.skipNextNewLine = true;
        return $.LINE_FEED;
    }

    this.skipNextNewLine = false;

    //OPTIMIZATION: first perform check if the code point in the allowed range that covers most common
    //HTML input (e.g. ASCII codes) to avoid performance-cost operations for high-range code points.
    return cp >= 0xD800 ? this._processHighRangeCodePoint(cp) : cp;
};

Preprocessor.prototype.retreat = function () {
    if (this.pos === this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
    }

    this.pos--;
};



/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate_named_entity_data/README.md)
module.exports = new Uint16Array([4,52,65,66,67,68,69,70,71,72,73,74,75,76,77,78,79,80,81,82,83,84,85,86,87,88,89,90,97,98,99,100,101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,106,303,412,810,1432,1701,1796,1987,2114,2360,2420,2484,3170,3251,4140,4393,4575,4610,5106,5512,5728,6117,6274,6315,6345,6427,6516,7002,7910,8733,9323,9870,10170,10631,10893,11318,11386,11467,12773,13092,14474,14922,15448,15542,16419,17666,18166,18611,19004,19095,19298,19397,4,16,69,77,97,98,99,102,103,108,109,110,111,112,114,115,116,117,140,150,158,169,176,194,199,210,216,222,226,242,256,266,283,294,108,105,103,5,198,1,59,148,1,198,80,5,38,1,59,156,1,38,99,117,116,101,5,193,1,59,167,1,193,114,101,118,101,59,1,258,4,2,105,121,182,191,114,99,5,194,1,59,189,1,194,59,1,1040,114,59,3,55349,56580,114,97,118,101,5,192,1,59,208,1,192,112,104,97,59,1,913,97,99,114,59,1,256,100,59,1,10835,4,2,103,112,232,237,111,110,59,1,260,102,59,3,55349,56632,112,108,121,70,117,110,99,116,105,111,110,59,1,8289,105,110,103,5,197,1,59,264,1,197,4,2,99,115,272,277,114,59,3,55349,56476,105,103,110,59,1,8788,105,108,100,101,5,195,1,59,292,1,195,109,108,5,196,1,59,301,1,196,4,8,97,99,101,102,111,114,115,117,321,350,354,383,388,394,400,405,4,2,99,114,327,336,107,115,108,97,115,104,59,1,8726,4,2,118,119,342,345,59,1,10983,101,100,59,1,8966,121,59,1,1041,4,3,99,114,116,362,369,379,97,117,115,101,59,1,8757,110,111,117,108,108,105,115,59,1,8492,97,59,1,914,114,59,3,55349,56581,112,102,59,3,55349,56633,101,118,101,59,1,728,99,114,59,1,8492,109,112,101,113,59,1,8782,4,14,72,79,97,99,100,101,102,104,105,108,111,114,115,117,442,447,456,504,542,547,569,573,577,616,678,784,790,796,99,121,59,1,1063,80,89,5,169,1,59,454,1,169,4,3,99,112,121,464,470,497,117,116,101,59,1,262,4,2,59,105,476,478,1,8914,116,97,108,68,105,102,102,101,114,101,110,116,105,97,108,68,59,1,8517,108,101,121,115,59,1,8493,4,4,97,101,105,111,514,520,530,535,114,111,110,59,1,268,100,105,108,5,199,1,59,528,1,199,114,99,59,1,264,110,105,110,116,59,1,8752,111,116,59,1,266,4,2,100,110,553,560,105,108,108,97,59,1,184,116,101,114,68,111,116,59,1,183,114,59,1,8493,105,59,1,935,114,99,108,101,4,4,68,77,80,84,591,596,603,609,111,116,59,1,8857,105,110,117,115,59,1,8854,108,117,115,59,1,8853,105,109,101,115,59,1,8855,111,4,2,99,115,623,646,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8754,101,67,117,114,108,121,4,2,68,81,658,671,111,117,98,108,101,81,117,111,116,101,59,1,8221,117,111,116,101,59,1,8217,4,4,108,110,112,117,688,701,736,753,111,110,4,2,59,101,696,698,1,8759,59,1,10868,4,3,103,105,116,709,717,722,114,117,101,110,116,59,1,8801,110,116,59,1,8751,111,117,114,73,110,116,101,103,114,97,108,59,1,8750,4,2,102,114,742,745,59,1,8450,111,100,117,99,116,59,1,8720,110,116,101,114,67,108,111,99,107,119,105,115,101,67,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8755,111,115,115,59,1,10799,99,114,59,3,55349,56478,112,4,2,59,67,803,805,1,8915,97,112,59,1,8781,4,11,68,74,83,90,97,99,101,102,105,111,115,834,850,855,860,865,888,903,916,921,1011,1415,4,2,59,111,840,842,1,8517,116,114,97,104,100,59,1,10513,99,121,59,1,1026,99,121,59,1,1029,99,121,59,1,1039,4,3,103,114,115,873,879,883,103,101,114,59,1,8225,114,59,1,8609,104,118,59,1,10980,4,2,97,121,894,900,114,111,110,59,1,270,59,1,1044,108,4,2,59,116,910,912,1,8711,97,59,1,916,114,59,3,55349,56583,4,2,97,102,927,998,4,2,99,109,933,992,114,105,116,105,99,97,108,4,4,65,68,71,84,950,957,978,985,99,117,116,101,59,1,180,111,4,2,116,117,964,967,59,1,729,98,108,101,65,99,117,116,101,59,1,733,114,97,118,101,59,1,96,105,108,100,101,59,1,732,111,110,100,59,1,8900,102,101,114,101,110,116,105,97,108,68,59,1,8518,4,4,112,116,117,119,1021,1026,1048,1249,102,59,3,55349,56635,4,3,59,68,69,1034,1036,1041,1,168,111,116,59,1,8412,113,117,97,108,59,1,8784,98,108,101,4,6,67,68,76,82,85,86,1065,1082,1101,1189,1211,1236,111,110,116,111,117,114,73,110,116,101,103,114,97,108,59,1,8751,111,4,2,116,119,1089,1092,59,1,168,110,65,114,114,111,119,59,1,8659,4,2,101,111,1107,1141,102,116,4,3,65,82,84,1117,1124,1136,114,114,111,119,59,1,8656,105,103,104,116,65,114,114,111,119,59,1,8660,101,101,59,1,10980,110,103,4,2,76,82,1149,1177,101,102,116,4,2,65,82,1158,1165,114,114,111,119,59,1,10232,105,103,104,116,65,114,114,111,119,59,1,10234,105,103,104,116,65,114,114,111,119,59,1,10233,105,103,104,116,4,2,65,84,1199,1206,114,114,111,119,59,1,8658,101,101,59,1,8872,112,4,2,65,68,1218,1225,114,114,111,119,59,1,8657,111,119,110,65,114,114,111,119,59,1,8661,101,114,116,105,99,97,108,66,97,114,59,1,8741,110,4,6,65,66,76,82,84,97,1264,1292,1299,1352,1391,1408,114,114,111,119,4,3,59,66,85,1276,1278,1283,1,8595,97,114,59,1,10515,112,65,114,114,111,119,59,1,8693,114,101,118,101,59,1,785,101,102,116,4,3,82,84,86,1310,1323,1334,105,103,104,116,86,101,99,116,111,114,59,1,10576,101,101,86,101,99,116,111,114,59,1,10590,101,99,116,111,114,4,2,59,66,1345,1347,1,8637,97,114,59,1,10582,105,103,104,116,4,2,84,86,1362,1373,101,101,86,101,99,116,111,114,59,1,10591,101,99,116,111,114,4,2,59,66,1384,1386,1,8641,97,114,59,1,10583,101,101,4,2,59,65,1399,1401,1,8868,114,114,111,119,59,1,8615,114,114,111,119,59,1,8659,4,2,99,116,1421,1426,114,59,3,55349,56479,114,111,107,59,1,272,4,16,78,84,97,99,100,102,103,108,109,111,112,113,115,116,117,120,1466,1470,1478,1489,1515,1520,1525,1536,1544,1593,1609,1617,1650,1664,1668,1677,71,59,1,330,72,5,208,1,59,1476,1,208,99,117,116,101,5,201,1,59,1487,1,201,4,3,97,105,121,1497,1503,1512,114,111,110,59,1,282,114,99,5,202,1,59,1510,1,202,59,1,1069,111,116,59,1,278,114,59,3,55349,56584,114,97,118,101,5,200,1,59,1534,1,200,101,109,101,110,116,59,1,8712,4,2,97,112,1550,1555,99,114,59,1,274,116,121,4,2,83,86,1563,1576,109,97,108,108,83,113,117,97,114,101,59,1,9723,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9643,4,2,103,112,1599,1604,111,110,59,1,280,102,59,3,55349,56636,115,105,108,111,110,59,1,917,117,4,2,97,105,1624,1640,108,4,2,59,84,1631,1633,1,10869,105,108,100,101,59,1,8770,108,105,98,114,105,117,109,59,1,8652,4,2,99,105,1656,1660,114,59,1,8496,109,59,1,10867,97,59,1,919,109,108,5,203,1,59,1675,1,203,4,2,105,112,1683,1689,115,116,115,59,1,8707,111,110,101,110,116,105,97,108,69,59,1,8519,4,5,99,102,105,111,115,1713,1717,1722,1762,1791,121,59,1,1060,114,59,3,55349,56585,108,108,101,100,4,2,83,86,1732,1745,109,97,108,108,83,113,117,97,114,101,59,1,9724,101,114,121,83,109,97,108,108,83,113,117,97,114,101,59,1,9642,4,3,112,114,117,1770,1775,1781,102,59,3,55349,56637,65,108,108,59,1,8704,114,105,101,114,116,114,102,59,1,8497,99,114,59,1,8497,4,12,74,84,97,98,99,100,102,103,111,114,115,116,1822,1827,1834,1848,1855,1877,1882,1887,1890,1896,1978,1984,99,121,59,1,1027,5,62,1,59,1832,1,62,109,109,97,4,2,59,100,1843,1845,1,915,59,1,988,114,101,118,101,59,1,286,4,3,101,105,121,1863,1869,1874,100,105,108,59,1,290,114,99,59,1,284,59,1,1043,111,116,59,1,288,114,59,3,55349,56586,59,1,8921,112,102,59,3,55349,56638,101,97,116,101,114,4,6,69,70,71,76,83,84,1915,1933,1944,1953,1959,1971,113,117,97,108,4,2,59,76,1925,1927,1,8805,101,115,115,59,1,8923,117,108,108,69,113,117,97,108,59,1,8807,114,101,97,116,101,114,59,1,10914,101,115,115,59,1,8823,108,97,110,116,69,113,117,97,108,59,1,10878,105,108,100,101,59,1,8819,99,114,59,3,55349,56482,59,1,8811,4,8,65,97,99,102,105,111,115,117,2005,2012,2026,2032,2036,2049,2073,2089,82,68,99,121,59,1,1066,4,2,99,116,2018,2023,101,107,59,1,711,59,1,94,105,114,99,59,1,292,114,59,1,8460,108,98,101,114,116,83,112,97,99,101,59,1,8459,4,2,112,114,2055,2059,102,59,1,8461,105,122,111,110,116,97,108,76,105,110,101,59,1,9472,4,2,99,116,2079,2083,114,59,1,8459,114,111,107,59,1,294,109,112,4,2,68,69,2097,2107,111,119,110,72,117,109,112,59,1,8782,113,117,97,108,59,1,8783,4,14,69,74,79,97,99,100,102,103,109,110,111,115,116,117,2144,2149,2155,2160,2171,2189,2194,2198,2209,2245,2307,2329,2334,2341,99,121,59,1,1045,108,105,103,59,1,306,99,121,59,1,1025,99,117,116,101,5,205,1,59,2169,1,205,4,2,105,121,2177,2186,114,99,5,206,1,59,2184,1,206,59,1,1048,111,116,59,1,304,114,59,1,8465,114,97,118,101,5,204,1,59,2207,1,204,4,3,59,97,112,2217,2219,2238,1,8465,4,2,99,103,2225,2229,114,59,1,298,105,110,97,114,121,73,59,1,8520,108,105,101,115,59,1,8658,4,2,116,118,2251,2281,4,2,59,101,2257,2259,1,8748,4,2,103,114,2265,2271,114,97,108,59,1,8747,115,101,99,116,105,111,110,59,1,8898,105,115,105,98,108,101,4,2,67,84,2293,2300,111,109,109,97,59,1,8291,105,109,101,115,59,1,8290,4,3,103,112,116,2315,2320,2325,111,110,59,1,302,102,59,3,55349,56640,97,59,1,921,99,114,59,1,8464,105,108,100,101,59,1,296,4,2,107,109,2347,2352,99,121,59,1,1030,108,5,207,1,59,2358,1,207,4,5,99,102,111,115,117,2372,2386,2391,2397,2414,4,2,105,121,2378,2383,114,99,59,1,308,59,1,1049,114,59,3,55349,56589,112,102,59,3,55349,56641,4,2,99,101,2403,2408,114,59,3,55349,56485,114,99,121,59,1,1032,107,99,121,59,1,1028,4,7,72,74,97,99,102,111,115,2436,2441,2446,2452,2467,2472,2478,99,121,59,1,1061,99,121,59,1,1036,112,112,97,59,1,922,4,2,101,121,2458,2464,100,105,108,59,1,310,59,1,1050,114,59,3,55349,56590,112,102,59,3,55349,56642,99,114,59,3,55349,56486,4,11,74,84,97,99,101,102,108,109,111,115,116,2508,2513,2520,2562,2585,2981,2986,3004,3011,3146,3167,99,121,59,1,1033,5,60,1,59,2518,1,60,4,5,99,109,110,112,114,2532,2538,2544,2548,2558,117,116,101,59,1,313,98,100,97,59,1,923,103,59,1,10218,108,97,99,101,116,114,102,59,1,8466,114,59,1,8606,4,3,97,101,121,2570,2576,2582,114,111,110,59,1,317,100,105,108,59,1,315,59,1,1051,4,2,102,115,2591,2907,116,4,10,65,67,68,70,82,84,85,86,97,114,2614,2663,2672,2728,2735,2760,2820,2870,2888,2895,4,2,110,114,2620,2633,103,108,101,66,114,97,99,107,101,116,59,1,10216,114,111,119,4,3,59,66,82,2644,2646,2651,1,8592,97,114,59,1,8676,105,103,104,116,65,114,114,111,119,59,1,8646,101,105,108,105,110,103,59,1,8968,111,4,2,117,119,2679,2692,98,108,101,66,114,97,99,107,101,116,59,1,10214,110,4,2,84,86,2699,2710,101,101,86,101,99,116,111,114,59,1,10593,101,99,116,111,114,4,2,59,66,2721,2723,1,8643,97,114,59,1,10585,108,111,111,114,59,1,8970,105,103,104,116,4,2,65,86,2745,2752,114,114,111,119,59,1,8596,101,99,116,111,114,59,1,10574,4,2,101,114,2766,2792,101,4,3,59,65,86,2775,2777,2784,1,8867,114,114,111,119,59,1,8612,101,99,116,111,114,59,1,10586,105,97,110,103,108,101,4,3,59,66,69,2806,2808,2813,1,8882,97,114,59,1,10703,113,117,97,108,59,1,8884,112,4,3,68,84,86,2829,2841,2852,111,119,110,86,101,99,116,111,114,59,1,10577,101,101,86,101,99,116,111,114,59,1,10592,101,99,116,111,114,4,2,59,66,2863,2865,1,8639,97,114,59,1,10584,101,99,116,111,114,4,2,59,66,2881,2883,1,8636,97,114,59,1,10578,114,114,111,119,59,1,8656,105,103,104,116,97,114,114,111,119,59,1,8660,115,4,6,69,70,71,76,83,84,2922,2936,2947,2956,2962,2974,113,117,97,108,71,114,101,97,116,101,114,59,1,8922,117,108,108,69,113,117,97,108,59,1,8806,114,101,97,116,101,114,59,1,8822,101,115,115,59,1,10913,108,97,110,116,69,113,117,97,108,59,1,10877,105,108,100,101,59,1,8818,114,59,3,55349,56591,4,2,59,101,2992,2994,1,8920,102,116,97,114,114,111,119,59,1,8666,105,100,111,116,59,1,319,4,3,110,112,119,3019,3110,3115,103,4,4,76,82,108,114,3030,3058,3070,3098,101,102,116,4,2,65,82,3039,3046,114,114,111,119,59,1,10229,105,103,104,116,65,114,114,111,119,59,1,10231,105,103,104,116,65,114,114,111,119,59,1,10230,101,102,116,4,2,97,114,3079,3086,114,114,111,119,59,1,10232,105,103,104,116,97,114,114,111,119,59,1,10234,105,103,104,116,97,114,114,111,119,59,1,10233,102,59,3,55349,56643,101,114,4,2,76,82,3123,3134,101,102,116,65,114,114,111,119,59,1,8601,105,103,104,116,65,114,114,111,119,59,1,8600,4,3,99,104,116,3154,3158,3161,114,59,1,8466,59,1,8624,114,111,107,59,1,321,59,1,8810,4,8,97,99,101,102,105,111,115,117,3188,3192,3196,3222,3227,3237,3243,3248,112,59,1,10501,121,59,1,1052,4,2,100,108,3202,3213,105,117,109,83,112,97,99,101,59,1,8287,108,105,110,116,114,102,59,1,8499,114,59,3,55349,56592,110,117,115,80,108,117,115,59,1,8723,112,102,59,3,55349,56644,99,114,59,1,8499,59,1,924,4,9,74,97,99,101,102,111,115,116,117,3271,3276,3283,3306,3422,3427,4120,4126,4137,99,121,59,1,1034,99,117,116,101,59,1,323,4,3,97,101,121,3291,3297,3303,114,111,110,59,1,327,100,105,108,59,1,325,59,1,1053,4,3,103,115,119,3314,3380,3415,97,116,105,118,101,4,3,77,84,86,3327,3340,3365,101,100,105,117,109,83,112,97,99,101,59,1,8203,104,105,4,2,99,110,3348,3357,107,83,112,97,99,101,59,1,8203,83,112,97,99,101,59,1,8203,101,114,121,84,104,105,110,83,112,97,99,101,59,1,8203,116,101,100,4,2,71,76,3389,3405,114,101,97,116,101,114,71,114,101,97,116,101,114,59,1,8811,101,115,115,76,101,115,115,59,1,8810,76,105,110,101,59,1,10,114,59,3,55349,56593,4,4,66,110,112,116,3437,3444,3460,3464,114,101,97,107,59,1,8288,66,114,101,97,107,105,110,103,83,112,97,99,101,59,1,160,102,59,1,8469,4,13,59,67,68,69,71,72,76,78,80,82,83,84,86,3492,3494,3517,3536,3578,3657,3685,3784,3823,3860,3915,4066,4107,1,10988,4,2,111,117,3500,3510,110,103,114,117,101,110,116,59,1,8802,112,67,97,112,59,1,8813,111,117,98,108,101,86,101,114,116,105,99,97,108,66,97,114,59,1,8742,4,3,108,113,120,3544,3552,3571,101,109,101,110,116,59,1,8713,117,97,108,4,2,59,84,3561,3563,1,8800,105,108,100,101,59,3,8770,824,105,115,116,115,59,1,8708,114,101,97,116,101,114,4,7,59,69,70,71,76,83,84,3600,3602,3609,3621,3631,3637,3650,1,8815,113,117,97,108,59,1,8817,117,108,108,69,113,117,97,108,59,3,8807,824,114,101,97,116,101,114,59,3,8811,824,101,115,115,59,1,8825,108,97,110,116,69,113,117,97,108,59,3,10878,824,105,108,100,101,59,1,8821,117,109,112,4,2,68,69,3666,3677,111,119,110,72,117,109,112,59,3,8782,824,113,117,97,108,59,3,8783,824,101,4,2,102,115,3692,3724,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3709,3711,3717,1,8938,97,114,59,3,10703,824,113,117,97,108,59,1,8940,115,4,6,59,69,71,76,83,84,3739,3741,3748,3757,3764,3777,1,8814,113,117,97,108,59,1,8816,114,101,97,116,101,114,59,1,8824,101,115,115,59,3,8810,824,108,97,110,116,69,113,117,97,108,59,3,10877,824,105,108,100,101,59,1,8820,101,115,116,101,100,4,2,71,76,3795,3812,114,101,97,116,101,114,71,114,101,97,116,101,114,59,3,10914,824,101,115,115,76,101,115,115,59,3,10913,824,114,101,99,101,100,101,115,4,3,59,69,83,3838,3840,3848,1,8832,113,117,97,108,59,3,10927,824,108,97,110,116,69,113,117,97,108,59,1,8928,4,2,101,105,3866,3881,118,101,114,115,101,69,108,101,109,101,110,116,59,1,8716,103,104,116,84,114,105,97,110,103,108,101,4,3,59,66,69,3900,3902,3908,1,8939,97,114,59,3,10704,824,113,117,97,108,59,1,8941,4,2,113,117,3921,3973,117,97,114,101,83,117,4,2,98,112,3933,3952,115,101,116,4,2,59,69,3942,3945,3,8847,824,113,117,97,108,59,1,8930,101,114,115,101,116,4,2,59,69,3963,3966,3,8848,824,113,117,97,108,59,1,8931,4,3,98,99,112,3981,4000,4045,115,101,116,4,2,59,69,3990,3993,3,8834,8402,113,117,97,108,59,1,8840,99,101,101,100,115,4,4,59,69,83,84,4015,4017,4025,4037,1,8833,113,117,97,108,59,3,10928,824,108,97,110,116,69,113,117,97,108,59,1,8929,105,108,100,101,59,3,8831,824,101,114,115,101,116,4,2,59,69,4056,4059,3,8835,8402,113,117,97,108,59,1,8841,105,108,100,101,4,4,59,69,70,84,4080,4082,4089,4100,1,8769,113,117,97,108,59,1,8772,117,108,108,69,113,117,97,108,59,1,8775,105,108,100,101,59,1,8777,101,114,116,105,99,97,108,66,97,114,59,1,8740,99,114,59,3,55349,56489,105,108,100,101,5,209,1,59,4135,1,209,59,1,925,4,14,69,97,99,100,102,103,109,111,112,114,115,116,117,118,4170,4176,4187,4205,4212,4217,4228,4253,4259,4292,4295,4316,4337,4346,108,105,103,59,1,338,99,117,116,101,5,211,1,59,4185,1,211,4,2,105,121,4193,4202,114,99,5,212,1,59,4200,1,212,59,1,1054,98,108,97,99,59,1,336,114,59,3,55349,56594,114,97,118,101,5,210,1,59,4226,1,210,4,3,97,101,105,4236,4241,4246,99,114,59,1,332,103,97,59,1,937,99,114,111,110,59,1,927,112,102,59,3,55349,56646,101,110,67,117,114,108,121,4,2,68,81,4272,4285,111,117,98,108,101,81,117,111,116,101,59,1,8220,117,111,116,101,59,1,8216,59,1,10836,4,2,99,108,4301,4306,114,59,3,55349,56490,97,115,104,5,216,1,59,4314,1,216,105,4,2,108,109,4323,4332,100,101,5,213,1,59,4330,1,213,101,115,59,1,10807,109,108,5,214,1,59,4344,1,214,101,114,4,2,66,80,4354,4380,4,2,97,114,4360,4364,114,59,1,8254,97,99,4,2,101,107,4372,4375,59,1,9182,101,116,59,1,9140,97,114,101,110,116,104,101,115,105,115,59,1,9180,4,9,97,99,102,104,105,108,111,114,115,4413,4422,4426,4431,4435,4438,4448,4471,4561,114,116,105,97,108,68,59,1,8706,121,59,1,1055,114,59,3,55349,56595,105,59,1,934,59,1,928,117,115,77,105,110,117,115,59,1,177,4,2,105,112,4454,4467,110,99,97,114,101,112,108,97,110,101,59,1,8460,102,59,1,8473,4,4,59,101,105,111,4481,4483,4526,4531,1,10939,99,101,100,101,115,4,4,59,69,83,84,4498,4500,4507,4519,1,8826,113,117,97,108,59,1,10927,108,97,110,116,69,113,117,97,108,59,1,8828,105,108,100,101,59,1,8830,109,101,59,1,8243,4,2,100,112,4537,4543,117,99,116,59,1,8719,111,114,116,105,111,110,4,2,59,97,4555,4557,1,8759,108,59,1,8733,4,2,99,105,4567,4572,114,59,3,55349,56491,59,1,936,4,4,85,102,111,115,4585,4594,4599,4604,79,84,5,34,1,59,4592,1,34,114,59,3,55349,56596,112,102,59,1,8474,99,114,59,3,55349,56492,4,12,66,69,97,99,101,102,104,105,111,114,115,117,4636,4642,4650,4681,4704,4763,4767,4771,5047,5069,5081,5094,97,114,114,59,1,10512,71,5,174,1,59,4648,1,174,4,3,99,110,114,4658,4664,4668,117,116,101,59,1,340,103,59,1,10219,114,4,2,59,116,4675,4677,1,8608,108,59,1,10518,4,3,97,101,121,4689,4695,4701,114,111,110,59,1,344,100,105,108,59,1,342,59,1,1056,4,2,59,118,4710,4712,1,8476,101,114,115,101,4,2,69,85,4722,4748,4,2,108,113,4728,4736,101,109,101,110,116,59,1,8715,117,105,108,105,98,114,105,117,109,59,1,8651,112,69,113,117,105,108,105,98,114,105,117,109,59,1,10607,114,59,1,8476,111,59,1,929,103,104,116,4,8,65,67,68,70,84,85,86,97,4792,4840,4849,4905,4912,4972,5022,5040,4,2,110,114,4798,4811,103,108,101,66,114,97,99,107,101,116,59,1,10217,114,111,119,4,3,59,66,76,4822,4824,4829,1,8594,97,114,59,1,8677,101,102,116,65,114,114,111,119,59,1,8644,101,105,108,105,110,103,59,1,8969,111,4,2,117,119,4856,4869,98,108,101,66,114,97,99,107,101,116,59,1,10215,110,4,2,84,86,4876,4887,101,101,86,101,99,116,111,114,59,1,10589,101,99,116,111,114,4,2,59,66,4898,4900,1,8642,97,114,59,1,10581,108,111,111,114,59,1,8971,4,2,101,114,4918,4944,101,4,3,59,65,86,4927,4929,4936,1,8866,114,114,111,119,59,1,8614,101,99,116,111,114,59,1,10587,105,97,110,103,108,101,4,3,59,66,69,4958,4960,4965,1,8883,97,114,59,1,10704,113,117,97,108,59,1,8885,112,4,3,68,84,86,4981,4993,5004,111,119,110,86,101,99,116,111,114,59,1,10575,101,101,86,101,99,116,111,114,59,1,10588,101,99,116,111,114,4,2,59,66,5015,5017,1,8638,97,114,59,1,10580,101,99,116,111,114,4,2,59,66,5033,5035,1,8640,97,114,59,1,10579,114,114,111,119,59,1,8658,4,2,112,117,5053,5057,102,59,1,8477,110,100,73,109,112,108,105,101,115,59,1,10608,105,103,104,116,97,114,114,111,119,59,1,8667,4,2,99,104,5087,5091,114,59,1,8475,59,1,8625,108,101,68,101,108,97,121,101,100,59,1,10740,4,13,72,79,97,99,102,104,105,109,111,113,115,116,117,5134,5150,5157,5164,5198,5203,5259,5265,5277,5283,5374,5380,5385,4,2,67,99,5140,5146,72,99,121,59,1,1065,121,59,1,1064,70,84,99,121,59,1,1068,99,117,116,101,59,1,346,4,5,59,97,101,105,121,5176,5178,5184,5190,5195,1,10940,114,111,110,59,1,352,100,105,108,59,1,350,114,99,59,1,348,59,1,1057,114,59,3,55349,56598,111,114,116,4,4,68,76,82,85,5216,5227,5238,5250,111,119,110,65,114,114,111,119,59,1,8595,101,102,116,65,114,114,111,119,59,1,8592,105,103,104,116,65,114,114,111,119,59,1,8594,112,65,114,114,111,119,59,1,8593,103,109,97,59,1,931,97,108,108,67,105,114,99,108,101,59,1,8728,112,102,59,3,55349,56650,4,2,114,117,5289,5293,116,59,1,8730,97,114,101,4,4,59,73,83,85,5306,5308,5322,5367,1,9633,110,116,101,114,115,101,99,116,105,111,110,59,1,8851,117,4,2,98,112,5329,5347,115,101,116,4,2,59,69,5338,5340,1,8847,113,117,97,108,59,1,8849,101,114,115,101,116,4,2,59,69,5358,5360,1,8848,113,117,97,108,59,1,8850,110,105,111,110,59,1,8852,99,114,59,3,55349,56494,97,114,59,1,8902,4,4,98,99,109,112,5395,5420,5475,5478,4,2,59,115,5401,5403,1,8912,101,116,4,2,59,69,5411,5413,1,8912,113,117,97,108,59,1,8838,4,2,99,104,5426,5468,101,101,100,115,4,4,59,69,83,84,5440,5442,5449,5461,1,8827,113,117,97,108,59,1,10928,108,97,110,116,69,113,117,97,108,59,1,8829,105,108,100,101,59,1,8831,84,104,97,116,59,1,8715,59,1,8721,4,3,59,101,115,5486,5488,5507,1,8913,114,115,101,116,4,2,59,69,5498,5500,1,8835,113,117,97,108,59,1,8839,101,116,59,1,8913,4,11,72,82,83,97,99,102,104,105,111,114,115,5536,5546,5552,5567,5579,5602,5607,5655,5695,5701,5711,79,82,78,5,222,1,59,5544,1,222,65,68,69,59,1,8482,4,2,72,99,5558,5563,99,121,59,1,1035,121,59,1,1062,4,2,98,117,5573,5576,59,1,9,59,1,932,4,3,97,101,121,5587,5593,5599,114,111,110,59,1,356,100,105,108,59,1,354,59,1,1058,114,59,3,55349,56599,4,2,101,105,5613,5631,4,2,114,116,5619,5627,101,102,111,114,101,59,1,8756,97,59,1,920,4,2,99,110,5637,5647,107,83,112,97,99,101,59,3,8287,8202,83,112,97,99,101,59,1,8201,108,100,101,4,4,59,69,70,84,5668,5670,5677,5688,1,8764,113,117,97,108,59,1,8771,117,108,108,69,113,117,97,108,59,1,8773,105,108,100,101,59,1,8776,112,102,59,3,55349,56651,105,112,108,101,68,111,116,59,1,8411,4,2,99,116,5717,5722,114,59,3,55349,56495,114,111,107,59,1,358,4,14,97,98,99,100,102,103,109,110,111,112,114,115,116,117,5758,5789,5805,5823,5830,5835,5846,5852,5921,5937,6089,6095,6101,6108,4,2,99,114,5764,5774,117,116,101,5,218,1,59,5772,1,218,114,4,2,59,111,5781,5783,1,8607,99,105,114,59,1,10569,114,4,2,99,101,5796,5800,121,59,1,1038,118,101,59,1,364,4,2,105,121,5811,5820,114,99,5,219,1,59,5818,1,219,59,1,1059,98,108,97,99,59,1,368,114,59,3,55349,56600,114,97,118,101,5,217,1,59,5844,1,217,97,99,114,59,1,362,4,2,100,105,5858,5905,101,114,4,2,66,80,5866,5892,4,2,97,114,5872,5876,114,59,1,95,97,99,4,2,101,107,5884,5887,59,1,9183,101,116,59,1,9141,97,114,101,110,116,104,101,115,105,115,59,1,9181,111,110,4,2,59,80,5913,5915,1,8899,108,117,115,59,1,8846,4,2,103,112,5927,5932,111,110,59,1,370,102,59,3,55349,56652,4,8,65,68,69,84,97,100,112,115,5955,5985,5996,6009,6026,6033,6044,6075,114,114,111,119,4,3,59,66,68,5967,5969,5974,1,8593,97,114,59,1,10514,111,119,110,65,114,114,111,119,59,1,8645,111,119,110,65,114,114,111,119,59,1,8597,113,117,105,108,105,98,114,105,117,109,59,1,10606,101,101,4,2,59,65,6017,6019,1,8869,114,114,111,119,59,1,8613,114,114,111,119,59,1,8657,111,119,110,97,114,114,111,119,59,1,8661,101,114,4,2,76,82,6052,6063,101,102,116,65,114,114,111,119,59,1,8598,105,103,104,116,65,114,114,111,119,59,1,8599,105,4,2,59,108,6082,6084,1,978,111,110,59,1,933,105,110,103,59,1,366,99,114,59,3,55349,56496,105,108,100,101,59,1,360,109,108,5,220,1,59,6115,1,220,4,9,68,98,99,100,101,102,111,115,118,6137,6143,6148,6152,6166,6250,6255,6261,6267,97,115,104,59,1,8875,97,114,59,1,10987,121,59,1,1042,97,115,104,4,2,59,108,6161,6163,1,8873,59,1,10982,4,2,101,114,6172,6175,59,1,8897,4,3,98,116,121,6183,6188,6238,97,114,59,1,8214,4,2,59,105,6194,6196,1,8214,99,97,108,4,4,66,76,83,84,6209,6214,6220,6231,97,114,59,1,8739,105,110,101,59,1,124,101,112,97,114,97,116,111,114,59,1,10072,105,108,100,101,59,1,8768,84,104,105,110,83,112,97,99,101,59,1,8202,114,59,3,55349,56601,112,102,59,3,55349,56653,99,114,59,3,55349,56497,100,97,115,104,59,1,8874,4,5,99,101,102,111,115,6286,6292,6298,6303,6309,105,114,99,59,1,372,100,103,101,59,1,8896,114,59,3,55349,56602,112,102,59,3,55349,56654,99,114,59,3,55349,56498,4,4,102,105,111,115,6325,6330,6333,6339,114,59,3,55349,56603,59,1,926,112,102,59,3,55349,56655,99,114,59,3,55349,56499,4,9,65,73,85,97,99,102,111,115,117,6365,6370,6375,6380,6391,6405,6410,6416,6422,99,121,59,1,1071,99,121,59,1,1031,99,121,59,1,1070,99,117,116,101,5,221,1,59,6389,1,221,4,2,105,121,6397,6402,114,99,59,1,374,59,1,1067,114,59,3,55349,56604,112,102,59,3,55349,56656,99,114,59,3,55349,56500,109,108,59,1,376,4,8,72,97,99,100,101,102,111,115,6445,6450,6457,6472,6477,6501,6505,6510,99,121,59,1,1046,99,117,116,101,59,1,377,4,2,97,121,6463,6469,114,111,110,59,1,381,59,1,1047,111,116,59,1,379,4,2,114,116,6483,6497,111,87,105,100,116,104,83,112,97,99,101,59,1,8203,97,59,1,918,114,59,1,8488,112,102,59,1,8484,99,114,59,3,55349,56501,4,16,97,98,99,101,102,103,108,109,110,111,112,114,115,116,117,119,6550,6561,6568,6612,6622,6634,6645,6672,6699,6854,6870,6923,6933,6963,6974,6983,99,117,116,101,5,225,1,59,6559,1,225,114,101,118,101,59,1,259,4,6,59,69,100,105,117,121,6582,6584,6588,6591,6600,6609,1,8766,59,3,8766,819,59,1,8767,114,99,5,226,1,59,6598,1,226,116,101,5,180,1,59,6607,1,180,59,1,1072,108,105,103,5,230,1,59,6620,1,230,4,2,59,114,6628,6630,1,8289,59,3,55349,56606,114,97,118,101,5,224,1,59,6643,1,224,4,2,101,112,6651,6667,4,2,102,112,6657,6663,115,121,109,59,1,8501,104,59,1,8501,104,97,59,1,945,4,2,97,112,6678,6692,4,2,99,108,6684,6688,114,59,1,257,103,59,1,10815,5,38,1,59,6697,1,38,4,2,100,103,6705,6737,4,5,59,97,100,115,118,6717,6719,6724,6727,6734,1,8743,110,100,59,1,10837,59,1,10844,108,111,112,101,59,1,10840,59,1,10842,4,7,59,101,108,109,114,115,122,6753,6755,6758,6762,6814,6835,6848,1,8736,59,1,10660,101,59,1,8736,115,100,4,2,59,97,6770,6772,1,8737,4,8,97,98,99,100,101,102,103,104,6790,6793,6796,6799,6802,6805,6808,6811,59,1,10664,59,1,10665,59,1,10666,59,1,10667,59,1,10668,59,1,10669,59,1,10670,59,1,10671,116,4,2,59,118,6821,6823,1,8735,98,4,2,59,100,6830,6832,1,8894,59,1,10653,4,2,112,116,6841,6845,104,59,1,8738,59,1,197,97,114,114,59,1,9084,4,2,103,112,6860,6865,111,110,59,1,261,102,59,3,55349,56658,4,7,59,69,97,101,105,111,112,6886,6888,6891,6897,6900,6904,6908,1,8776,59,1,10864,99,105,114,59,1,10863,59,1,8778,100,59,1,8779,115,59,1,39,114,111,120,4,2,59,101,6917,6919,1,8776,113,59,1,8778,105,110,103,5,229,1,59,6931,1,229,4,3,99,116,121,6941,6946,6949,114,59,3,55349,56502,59,1,42,109,112,4,2,59,101,6957,6959,1,8776,113,59,1,8781,105,108,100,101,5,227,1,59,6972,1,227,109,108,5,228,1,59,6981,1,228,4,2,99,105,6989,6997,111,110,105,110,116,59,1,8755,110,116,59,1,10769,4,16,78,97,98,99,100,101,102,105,107,108,110,111,112,114,115,117,7036,7041,7119,7135,7149,7155,7219,7224,7347,7354,7463,7489,7786,7793,7814,7866,111,116,59,1,10989,4,2,99,114,7047,7094,107,4,4,99,101,112,115,7058,7064,7073,7080,111,110,103,59,1,8780,112,115,105,108,111,110,59,1,1014,114,105,109,101,59,1,8245,105,109,4,2,59,101,7088,7090,1,8765,113,59,1,8909,4,2,118,119,7100,7105,101,101,59,1,8893,101,100,4,2,59,103,7113,7115,1,8965,101,59,1,8965,114,107,4,2,59,116,7127,7129,1,9141,98,114,107,59,1,9142,4,2,111,121,7141,7146,110,103,59,1,8780,59,1,1073,113,117,111,59,1,8222,4,5,99,109,112,114,116,7167,7181,7188,7193,7199,97,117,115,4,2,59,101,7176,7178,1,8757,59,1,8757,112,116,121,118,59,1,10672,115,105,59,1,1014,110,111,117,59,1,8492,4,3,97,104,119,7207,7210,7213,59,1,946,59,1,8502,101,101,110,59,1,8812,114,59,3,55349,56607,103,4,7,99,111,115,116,117,118,119,7241,7262,7288,7305,7328,7335,7340,4,3,97,105,117,7249,7253,7258,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,4,3,100,112,116,7270,7275,7281,111,116,59,1,10752,108,117,115,59,1,10753,105,109,101,115,59,1,10754,4,2,113,116,7294,7300,99,117,112,59,1,10758,97,114,59,1,9733,114,105,97,110,103,108,101,4,2,100,117,7318,7324,111,119,110,59,1,9661,112,59,1,9651,112,108,117,115,59,1,10756,101,101,59,1,8897,101,100,103,101,59,1,8896,97,114,111,119,59,1,10509,4,3,97,107,111,7362,7436,7458,4,2,99,110,7368,7432,107,4,3,108,115,116,7377,7386,7394,111,122,101,110,103,101,59,1,10731,113,117,97,114,101,59,1,9642,114,105,97,110,103,108,101,4,4,59,100,108,114,7411,7413,7419,7425,1,9652,111,119,110,59,1,9662,101,102,116,59,1,9666,105,103,104,116,59,1,9656,107,59,1,9251,4,2,49,51,7442,7454,4,2,50,52,7448,7451,59,1,9618,59,1,9617,52,59,1,9619,99,107,59,1,9608,4,2,101,111,7469,7485,4,2,59,113,7475,7478,3,61,8421,117,105,118,59,3,8801,8421,116,59,1,8976,4,4,112,116,119,120,7499,7504,7517,7523,102,59,3,55349,56659,4,2,59,116,7510,7512,1,8869,111,109,59,1,8869,116,105,101,59,1,8904,4,12,68,72,85,86,98,100,104,109,112,116,117,118,7549,7571,7597,7619,7655,7660,7682,7708,7715,7721,7728,7750,4,4,76,82,108,114,7559,7562,7565,7568,59,1,9559,59,1,9556,59,1,9558,59,1,9555,4,5,59,68,85,100,117,7583,7585,7588,7591,7594,1,9552,59,1,9574,59,1,9577,59,1,9572,59,1,9575,4,4,76,82,108,114,7607,7610,7613,7616,59,1,9565,59,1,9562,59,1,9564,59,1,9561,4,7,59,72,76,82,104,108,114,7635,7637,7640,7643,7646,7649,7652,1,9553,59,1,9580,59,1,9571,59,1,9568,59,1,9579,59,1,9570,59,1,9567,111,120,59,1,10697,4,4,76,82,108,114,7670,7673,7676,7679,59,1,9557,59,1,9554,59,1,9488,59,1,9484,4,5,59,68,85,100,117,7694,7696,7699,7702,7705,1,9472,59,1,9573,59,1,9576,59,1,9516,59,1,9524,105,110,117,115,59,1,8863,108,117,115,59,1,8862,105,109,101,115,59,1,8864,4,4,76,82,108,114,7738,7741,7744,7747,59,1,9563,59,1,9560,59,1,9496,59,1,9492,4,7,59,72,76,82,104,108,114,7766,7768,7771,7774,7777,7780,7783,1,9474,59,1,9578,59,1,9569,59,1,9566,59,1,9532,59,1,9508,59,1,9500,114,105,109,101,59,1,8245,4,2,101,118,7799,7804,118,101,59,1,728,98,97,114,5,166,1,59,7812,1,166,4,4,99,101,105,111,7824,7829,7834,7846,114,59,3,55349,56503,109,105,59,1,8271,109,4,2,59,101,7841,7843,1,8765,59,1,8909,108,4,3,59,98,104,7855,7857,7860,1,92,59,1,10693,115,117,98,59,1,10184,4,2,108,109,7872,7885,108,4,2,59,101,7879,7881,1,8226,116,59,1,8226,112,4,3,59,69,101,7894,7896,7899,1,8782,59,1,10926,4,2,59,113,7905,7907,1,8783,59,1,8783,4,15,97,99,100,101,102,104,105,108,111,114,115,116,117,119,121,7942,8021,8075,8080,8121,8126,8157,8279,8295,8430,8446,8485,8491,8707,8726,4,3,99,112,114,7950,7956,8007,117,116,101,59,1,263,4,6,59,97,98,99,100,115,7970,7972,7977,7984,7998,8003,1,8745,110,100,59,1,10820,114,99,117,112,59,1,10825,4,2,97,117,7990,7994,112,59,1,10827,112,59,1,10823,111,116,59,1,10816,59,3,8745,65024,4,2,101,111,8013,8017,116,59,1,8257,110,59,1,711,4,4,97,101,105,117,8031,8046,8056,8061,4,2,112,114,8037,8041,115,59,1,10829,111,110,59,1,269,100,105,108,5,231,1,59,8054,1,231,114,99,59,1,265,112,115,4,2,59,115,8069,8071,1,10828,109,59,1,10832,111,116,59,1,267,4,3,100,109,110,8088,8097,8104,105,108,5,184,1,59,8095,1,184,112,116,121,118,59,1,10674,116,5,162,2,59,101,8112,8114,1,162,114,100,111,116,59,1,183,114,59,3,55349,56608,4,3,99,101,105,8134,8138,8154,121,59,1,1095,99,107,4,2,59,109,8146,8148,1,10003,97,114,107,59,1,10003,59,1,967,114,4,7,59,69,99,101,102,109,115,8174,8176,8179,8258,8261,8268,8273,1,9675,59,1,10691,4,3,59,101,108,8187,8189,8193,1,710,113,59,1,8791,101,4,2,97,100,8200,8223,114,114,111,119,4,2,108,114,8210,8216,101,102,116,59,1,8634,105,103,104,116,59,1,8635,4,5,82,83,97,99,100,8235,8238,8241,8246,8252,59,1,174,59,1,9416,115,116,59,1,8859,105,114,99,59,1,8858,97,115,104,59,1,8861,59,1,8791,110,105,110,116,59,1,10768,105,100,59,1,10991,99,105,114,59,1,10690,117,98,115,4,2,59,117,8288,8290,1,9827,105,116,59,1,9827,4,4,108,109,110,112,8305,8326,8376,8400,111,110,4,2,59,101,8313,8315,1,58,4,2,59,113,8321,8323,1,8788,59,1,8788,4,2,109,112,8332,8344,97,4,2,59,116,8339,8341,1,44,59,1,64,4,3,59,102,108,8352,8354,8358,1,8705,110,59,1,8728,101,4,2,109,120,8365,8371,101,110,116,59,1,8705,101,115,59,1,8450,4,2,103,105,8382,8395,4,2,59,100,8388,8390,1,8773,111,116,59,1,10861,110,116,59,1,8750,4,3,102,114,121,8408,8412,8417,59,3,55349,56660,111,100,59,1,8720,5,169,2,59,115,8424,8426,1,169,114,59,1,8471,4,2,97,111,8436,8441,114,114,59,1,8629,115,115,59,1,10007,4,2,99,117,8452,8457,114,59,3,55349,56504,4,2,98,112,8463,8474,4,2,59,101,8469,8471,1,10959,59,1,10961,4,2,59,101,8480,8482,1,10960,59,1,10962,100,111,116,59,1,8943,4,7,100,101,108,112,114,118,119,8507,8522,8536,8550,8600,8697,8702,97,114,114,4,2,108,114,8516,8519,59,1,10552,59,1,10549,4,2,112,115,8528,8532,114,59,1,8926,99,59,1,8927,97,114,114,4,2,59,112,8545,8547,1,8630,59,1,10557,4,6,59,98,99,100,111,115,8564,8566,8573,8587,8592,8596,1,8746,114,99,97,112,59,1,10824,4,2,97,117,8579,8583,112,59,1,10822,112,59,1,10826,111,116,59,1,8845,114,59,1,10821,59,3,8746,65024,4,4,97,108,114,118,8610,8623,8663,8672,114,114,4,2,59,109,8618,8620,1,8631,59,1,10556,121,4,3,101,118,119,8632,8651,8656,113,4,2,112,115,8639,8645,114,101,99,59,1,8926,117,99,99,59,1,8927,101,101,59,1,8910,101,100,103,101,59,1,8911,101,110,5,164,1,59,8670,1,164,101,97,114,114,111,119,4,2,108,114,8684,8690,101,102,116,59,1,8630,105,103,104,116,59,1,8631,101,101,59,1,8910,101,100,59,1,8911,4,2,99,105,8713,8721,111,110,105,110,116,59,1,8754,110,116,59,1,8753,108,99,116,121,59,1,9005,4,19,65,72,97,98,99,100,101,102,104,105,106,108,111,114,115,116,117,119,122,8773,8778,8783,8821,8839,8854,8887,8914,8930,8944,9036,9041,9058,9197,9227,9258,9281,9297,9305,114,114,59,1,8659,97,114,59,1,10597,4,4,103,108,114,115,8793,8799,8805,8809,103,101,114,59,1,8224,101,116,104,59,1,8504,114,59,1,8595,104,4,2,59,118,8816,8818,1,8208,59,1,8867,4,2,107,108,8827,8834,97,114,111,119,59,1,10511,97,99,59,1,733,4,2,97,121,8845,8851,114,111,110,59,1,271,59,1,1076,4,3,59,97,111,8862,8864,8880,1,8518,4,2,103,114,8870,8876,103,101,114,59,1,8225,114,59,1,8650,116,115,101,113,59,1,10871,4,3,103,108,109,8895,8902,8907,5,176,1,59,8900,1,176,116,97,59,1,948,112,116,121,118,59,1,10673,4,2,105,114,8920,8926,115,104,116,59,1,10623,59,3,55349,56609,97,114,4,2,108,114,8938,8941,59,1,8643,59,1,8642,4,5,97,101,103,115,118,8956,8986,8989,8996,9001,109,4,3,59,111,115,8965,8967,8983,1,8900,110,100,4,2,59,115,8975,8977,1,8900,117,105,116,59,1,9830,59,1,9830,59,1,168,97,109,109,97,59,1,989,105,110,59,1,8946,4,3,59,105,111,9009,9011,9031,1,247,100,101,5,247,2,59,111,9020,9022,1,247,110,116,105,109,101,115,59,1,8903,110,120,59,1,8903,99,121,59,1,1106,99,4,2,111,114,9048,9053,114,110,59,1,8990,111,112,59,1,8973,4,5,108,112,116,117,119,9070,9076,9081,9130,9144,108,97,114,59,1,36,102,59,3,55349,56661,4,5,59,101,109,112,115,9093,9095,9109,9116,9122,1,729,113,4,2,59,100,9102,9104,1,8784,111,116,59,1,8785,105,110,117,115,59,1,8760,108,117,115,59,1,8724,113,117,97,114,101,59,1,8865,98,108,101,98,97,114,119,101,100,103,101,59,1,8966,110,4,3,97,100,104,9153,9160,9172,114,114,111,119,59,1,8595,111,119,110,97,114,114,111,119,115,59,1,8650,97,114,112,111,111,110,4,2,108,114,9184,9190,101,102,116,59,1,8643,105,103,104,116,59,1,8642,4,2,98,99,9203,9211,107,97,114,111,119,59,1,10512,4,2,111,114,9217,9222,114,110,59,1,8991,111,112,59,1,8972,4,3,99,111,116,9235,9248,9252,4,2,114,121,9241,9245,59,3,55349,56505,59,1,1109,108,59,1,10742,114,111,107,59,1,273,4,2,100,114,9264,9269,111,116,59,1,8945,105,4,2,59,102,9276,9278,1,9663,59,1,9662,4,2,97,104,9287,9292,114,114,59,1,8693,97,114,59,1,10607,97,110,103,108,101,59,1,10662,4,2,99,105,9311,9315,121,59,1,1119,103,114,97,114,114,59,1,10239,4,18,68,97,99,100,101,102,103,108,109,110,111,112,113,114,115,116,117,120,9361,9376,9398,9439,9444,9447,9462,9495,9531,9585,9598,9614,9659,9755,9771,9792,9808,9826,4,2,68,111,9367,9372,111,116,59,1,10871,116,59,1,8785,4,2,99,115,9382,9392,117,116,101,5,233,1,59,9390,1,233,116,101,114,59,1,10862,4,4,97,105,111,121,9408,9414,9430,9436,114,111,110,59,1,283,114,4,2,59,99,9421,9423,1,8790,5,234,1,59,9428,1,234,108,111,110,59,1,8789,59,1,1101,111,116,59,1,279,59,1,8519,4,2,68,114,9453,9458,111,116,59,1,8786,59,3,55349,56610,4,3,59,114,115,9470,9472,9482,1,10906,97,118,101,5,232,1,59,9480,1,232,4,2,59,100,9488,9490,1,10902,111,116,59,1,10904,4,4,59,105,108,115,9505,9507,9515,9518,1,10905,110,116,101,114,115,59,1,9191,59,1,8467,4,2,59,100,9524,9526,1,10901,111,116,59,1,10903,4,3,97,112,115,9539,9544,9564,99,114,59,1,275,116,121,4,3,59,115,118,9554,9556,9561,1,8709,101,116,59,1,8709,59,1,8709,112,4,2,49,59,9571,9583,4,2,51,52,9577,9580,59,1,8196,59,1,8197,1,8195,4,2,103,115,9591,9594,59,1,331,112,59,1,8194,4,2,103,112,9604,9609,111,110,59,1,281,102,59,3,55349,56662,4,3,97,108,115,9622,9635,9640,114,4,2,59,115,9629,9631,1,8917,108,59,1,10723,117,115,59,1,10865,105,4,3,59,108,118,9649,9651,9656,1,949,111,110,59,1,949,59,1,1013,4,4,99,115,117,118,9669,9686,9716,9747,4,2,105,111,9675,9680,114,99,59,1,8790,108,111,110,59,1,8789,4,2,105,108,9692,9696,109,59,1,8770,97,110,116,4,2,103,108,9705,9710,116,114,59,1,10902,101,115,115,59,1,10901,4,3,97,101,105,9724,9729,9734,108,115,59,1,61,115,116,59,1,8799,118,4,2,59,68,9741,9743,1,8801,68,59,1,10872,112,97,114,115,108,59,1,10725,4,2,68,97,9761,9766,111,116,59,1,8787,114,114,59,1,10609,4,3,99,100,105,9779,9783,9788,114,59,1,8495,111,116,59,1,8784,109,59,1,8770,4,2,97,104,9798,9801,59,1,951,5,240,1,59,9806,1,240,4,2,109,114,9814,9822,108,5,235,1,59,9820,1,235,111,59,1,8364,4,3,99,105,112,9834,9838,9843,108,59,1,33,115,116,59,1,8707,4,2,101,111,9849,9859,99,116,97,116,105,111,110,59,1,8496,110,101,110,116,105,97,108,101,59,1,8519,4,12,97,99,101,102,105,106,108,110,111,112,114,115,9896,9910,9914,9921,9954,9960,9967,9989,9994,10027,10036,10164,108,108,105,110,103,100,111,116,115,101,113,59,1,8786,121,59,1,1092,109,97,108,101,59,1,9792,4,3,105,108,114,9929,9935,9950,108,105,103,59,1,64259,4,2,105,108,9941,9945,103,59,1,64256,105,103,59,1,64260,59,3,55349,56611,108,105,103,59,1,64257,108,105,103,59,3,102,106,4,3,97,108,116,9975,9979,9984,116,59,1,9837,105,103,59,1,64258,110,115,59,1,9649,111,102,59,1,402,4,2,112,114,10000,10005,102,59,3,55349,56663,4,2,97,107,10011,10016,108,108,59,1,8704,4,2,59,118,10022,10024,1,8916,59,1,10969,97,114,116,105,110,116,59,1,10765,4,2,97,111,10042,10159,4,2,99,115,10048,10155,4,6,49,50,51,52,53,55,10062,10102,10114,10135,10139,10151,4,6,50,51,52,53,54,56,10076,10083,10086,10093,10096,10099,5,189,1,59,10081,1,189,59,1,8531,5,188,1,59,10091,1,188,59,1,8533,59,1,8537,59,1,8539,4,2,51,53,10108,10111,59,1,8532,59,1,8534,4,3,52,53,56,10122,10129,10132,5,190,1,59,10127,1,190,59,1,8535,59,1,8540,53,59,1,8536,4,2,54,56,10145,10148,59,1,8538,59,1,8541,56,59,1,8542,108,59,1,8260,119,110,59,1,8994,99,114,59,3,55349,56507,4,17,69,97,98,99,100,101,102,103,105,106,108,110,111,114,115,116,118,10206,10217,10247,10254,10268,10273,10358,10363,10374,10380,10385,10406,10458,10464,10470,10497,10610,4,2,59,108,10212,10214,1,8807,59,1,10892,4,3,99,109,112,10225,10231,10244,117,116,101,59,1,501,109,97,4,2,59,100,10239,10241,1,947,59,1,989,59,1,10886,114,101,118,101,59,1,287,4,2,105,121,10260,10265,114,99,59,1,285,59,1,1075,111,116,59,1,289,4,4,59,108,113,115,10283,10285,10288,10308,1,8805,59,1,8923,4,3,59,113,115,10296,10298,10301,1,8805,59,1,8807,108,97,110,116,59,1,10878,4,4,59,99,100,108,10318,10320,10324,10345,1,10878,99,59,1,10921,111,116,4,2,59,111,10332,10334,1,10880,4,2,59,108,10340,10342,1,10882,59,1,10884,4,2,59,101,10351,10354,3,8923,65024,115,59,1,10900,114,59,3,55349,56612,4,2,59,103,10369,10371,1,8811,59,1,8921,109,101,108,59,1,8503,99,121,59,1,1107,4,4,59,69,97,106,10395,10397,10400,10403,1,8823,59,1,10898,59,1,10917,59,1,10916,4,4,69,97,101,115,10416,10419,10434,10453,59,1,8809,112,4,2,59,112,10426,10428,1,10890,114,111,120,59,1,10890,4,2,59,113,10440,10442,1,10888,4,2,59,113,10448,10450,1,10888,59,1,8809,105,109,59,1,8935,112,102,59,3,55349,56664,97,118,101,59,1,96,4,2,99,105,10476,10480,114,59,1,8458,109,4,3,59,101,108,10489,10491,10494,1,8819,59,1,10894,59,1,10896,5,62,6,59,99,100,108,113,114,10512,10514,10527,10532,10538,10545,1,62,4,2,99,105,10520,10523,59,1,10919,114,59,1,10874,111,116,59,1,8919,80,97,114,59,1,10645,117,101,115,116,59,1,10876,4,5,97,100,101,108,115,10557,10574,10579,10599,10605,4,2,112,114,10563,10570,112,114,111,120,59,1,10886,114,59,1,10616,111,116,59,1,8919,113,4,2,108,113,10586,10592,101,115,115,59,1,8923,108,101,115,115,59,1,10892,101,115,115,59,1,8823,105,109,59,1,8819,4,2,101,110,10616,10626,114,116,110,101,113,113,59,3,8809,65024,69,59,3,8809,65024,4,10,65,97,98,99,101,102,107,111,115,121,10653,10658,10713,10718,10724,10760,10765,10786,10850,10875,114,114,59,1,8660,4,4,105,108,109,114,10668,10674,10678,10684,114,115,112,59,1,8202,102,59,1,189,105,108,116,59,1,8459,4,2,100,114,10690,10695,99,121,59,1,1098,4,3,59,99,119,10703,10705,10710,1,8596,105,114,59,1,10568,59,1,8621,97,114,59,1,8463,105,114,99,59,1,293,4,3,97,108,114,10732,10748,10754,114,116,115,4,2,59,117,10741,10743,1,9829,105,116,59,1,9829,108,105,112,59,1,8230,99,111,110,59,1,8889,114,59,3,55349,56613,115,4,2,101,119,10772,10779,97,114,111,119,59,1,10533,97,114,111,119,59,1,10534,4,5,97,109,111,112,114,10798,10803,10809,10839,10844,114,114,59,1,8703,116,104,116,59,1,8763,107,4,2,108,114,10816,10827,101,102,116,97,114,114,111,119,59,1,8617,105,103,104,116,97,114,114,111,119,59,1,8618,102,59,3,55349,56665,98,97,114,59,1,8213,4,3,99,108,116,10858,10863,10869,114,59,3,55349,56509,97,115,104,59,1,8463,114,111,107,59,1,295,4,2,98,112,10881,10887,117,108,108,59,1,8259,104,101,110,59,1,8208,4,15,97,99,101,102,103,105,106,109,110,111,112,113,115,116,117,10925,10936,10958,10977,10990,11001,11039,11045,11101,11192,11220,11226,11237,11285,11299,99,117,116,101,5,237,1,59,10934,1,237,4,3,59,105,121,10944,10946,10955,1,8291,114,99,5,238,1,59,10953,1,238,59,1,1080,4,2,99,120,10964,10968,121,59,1,1077,99,108,5,161,1,59,10975,1,161,4,2,102,114,10983,10986,59,1,8660,59,3,55349,56614,114,97,118,101,5,236,1,59,10999,1,236,4,4,59,105,110,111,11011,11013,11028,11034,1,8520,4,2,105,110,11019,11024,110,116,59,1,10764,116,59,1,8749,102,105,110,59,1,10716,116,97,59,1,8489,108,105,103,59,1,307,4,3,97,111,112,11053,11092,11096,4,3,99,103,116,11061,11065,11088,114,59,1,299,4,3,101,108,112,11073,11076,11082,59,1,8465,105,110,101,59,1,8464,97,114,116,59,1,8465,104,59,1,305,102,59,1,8887,101,100,59,1,437,4,5,59,99,102,111,116,11113,11115,11121,11136,11142,1,8712,97,114,101,59,1,8453,105,110,4,2,59,116,11129,11131,1,8734,105,101,59,1,10717,100,111,116,59,1,305,4,5,59,99,101,108,112,11154,11156,11161,11179,11186,1,8747,97,108,59,1,8890,4,2,103,114,11167,11173,101,114,115,59,1,8484,99,97,108,59,1,8890,97,114,104,107,59,1,10775,114,111,100,59,1,10812,4,4,99,103,112,116,11202,11206,11211,11216,121,59,1,1105,111,110,59,1,303,102,59,3,55349,56666,97,59,1,953,114,111,100,59,1,10812,117,101,115,116,5,191,1,59,11235,1,191,4,2,99,105,11243,11248,114,59,3,55349,56510,110,4,5,59,69,100,115,118,11261,11263,11266,11271,11282,1,8712,59,1,8953,111,116,59,1,8949,4,2,59,118,11277,11279,1,8948,59,1,8947,59,1,8712,4,2,59,105,11291,11293,1,8290,108,100,101,59,1,297,4,2,107,109,11305,11310,99,121,59,1,1110,108,5,239,1,59,11316,1,239,4,6,99,102,109,111,115,117,11332,11346,11351,11357,11363,11380,4,2,105,121,11338,11343,114,99,59,1,309,59,1,1081,114,59,3,55349,56615,97,116,104,59,1,567,112,102,59,3,55349,56667,4,2,99,101,11369,11374,114,59,3,55349,56511,114,99,121,59,1,1112,107,99,121,59,1,1108,4,8,97,99,102,103,104,106,111,115,11404,11418,11433,11438,11445,11450,11455,11461,112,112,97,4,2,59,118,11413,11415,1,954,59,1,1008,4,2,101,121,11424,11430,100,105,108,59,1,311,59,1,1082,114,59,3,55349,56616,114,101,101,110,59,1,312,99,121,59,1,1093,99,121,59,1,1116,112,102,59,3,55349,56668,99,114,59,3,55349,56512,4,23,65,66,69,72,97,98,99,100,101,102,103,104,106,108,109,110,111,112,114,115,116,117,118,11515,11538,11544,11555,11560,11721,11780,11818,11868,12136,12160,12171,12203,12208,12246,12275,12327,12509,12523,12569,12641,12732,12752,4,3,97,114,116,11523,11528,11532,114,114,59,1,8666,114,59,1,8656,97,105,108,59,1,10523,97,114,114,59,1,10510,4,2,59,103,11550,11552,1,8806,59,1,10891,97,114,59,1,10594,4,9,99,101,103,109,110,112,113,114,116,11580,11586,11594,11600,11606,11624,11627,11636,11694,117,116,101,59,1,314,109,112,116,121,118,59,1,10676,114,97,110,59,1,8466,98,100,97,59,1,955,103,4,3,59,100,108,11615,11617,11620,1,10216,59,1,10641,101,59,1,10216,59,1,10885,117,111,5,171,1,59,11634,1,171,114,4,8,59,98,102,104,108,112,115,116,11655,11657,11669,11673,11677,11681,11685,11690,1,8592,4,2,59,102,11663,11665,1,8676,115,59,1,10527,115,59,1,10525,107,59,1,8617,112,59,1,8619,108,59,1,10553,105,109,59,1,10611,108,59,1,8610,4,3,59,97,101,11702,11704,11709,1,10923,105,108,59,1,10521,4,2,59,115,11715,11717,1,10925,59,3,10925,65024,4,3,97,98,114,11729,11734,11739,114,114,59,1,10508,114,107,59,1,10098,4,2,97,107,11745,11758,99,4,2,101,107,11752,11755,59,1,123,59,1,91,4,2,101,115,11764,11767,59,1,10635,108,4,2,100,117,11774,11777,59,1,10639,59,1,10637,4,4,97,101,117,121,11790,11796,11811,11815,114,111,110,59,1,318,4,2,100,105,11802,11807,105,108,59,1,316,108,59,1,8968,98,59,1,123,59,1,1083,4,4,99,113,114,115,11828,11832,11845,11864,97,59,1,10550,117,111,4,2,59,114,11840,11842,1,8220,59,1,8222,4,2,100,117,11851,11857,104,97,114,59,1,10599,115,104,97,114,59,1,10571,104,59,1,8626,4,5,59,102,103,113,115,11880,11882,12008,12011,12031,1,8804,116,4,5,97,104,108,114,116,11895,11913,11935,11947,11996,114,114,111,119,4,2,59,116,11905,11907,1,8592,97,105,108,59,1,8610,97,114,112,111,111,110,4,2,100,117,11925,11931,111,119,110,59,1,8637,112,59,1,8636,101,102,116,97,114,114,111,119,115,59,1,8647,105,103,104,116,4,3,97,104,115,11959,11974,11984,114,114,111,119,4,2,59,115,11969,11971,1,8596,59,1,8646,97,114,112,111,111,110,115,59,1,8651,113,117,105,103,97,114,114,111,119,59,1,8621,104,114,101,101,116,105,109,101,115,59,1,8907,59,1,8922,4,3,59,113,115,12019,12021,12024,1,8804,59,1,8806,108,97,110,116,59,1,10877,4,5,59,99,100,103,115,12043,12045,12049,12070,12083,1,10877,99,59,1,10920,111,116,4,2,59,111,12057,12059,1,10879,4,2,59,114,12065,12067,1,10881,59,1,10883,4,2,59,101,12076,12079,3,8922,65024,115,59,1,10899,4,5,97,100,101,103,115,12095,12103,12108,12126,12131,112,112,114,111,120,59,1,10885,111,116,59,1,8918,113,4,2,103,113,12115,12120,116,114,59,1,8922,103,116,114,59,1,10891,116,114,59,1,8822,105,109,59,1,8818,4,3,105,108,114,12144,12150,12156,115,104,116,59,1,10620,111,111,114,59,1,8970,59,3,55349,56617,4,2,59,69,12166,12168,1,8822,59,1,10897,4,2,97,98,12177,12198,114,4,2,100,117,12184,12187,59,1,8637,4,2,59,108,12193,12195,1,8636,59,1,10602,108,107,59,1,9604,99,121,59,1,1113,4,5,59,97,99,104,116,12220,12222,12227,12235,12241,1,8810,114,114,59,1,8647,111,114,110,101,114,59,1,8990,97,114,100,59,1,10603,114,105,59,1,9722,4,2,105,111,12252,12258,100,111,116,59,1,320,117,115,116,4,2,59,97,12267,12269,1,9136,99,104,101,59,1,9136,4,4,69,97,101,115,12285,12288,12303,12322,59,1,8808,112,4,2,59,112,12295,12297,1,10889,114,111,120,59,1,10889,4,2,59,113,12309,12311,1,10887,4,2,59,113,12317,12319,1,10887,59,1,8808,105,109,59,1,8934,4,8,97,98,110,111,112,116,119,122,12345,12359,12364,12421,12446,12467,12474,12490,4,2,110,114,12351,12355,103,59,1,10220,114,59,1,8701,114,107,59,1,10214,103,4,3,108,109,114,12373,12401,12409,101,102,116,4,2,97,114,12382,12389,114,114,111,119,59,1,10229,105,103,104,116,97,114,114,111,119,59,1,10231,97,112,115,116,111,59,1,10236,105,103,104,116,97,114,114,111,119,59,1,10230,112,97,114,114,111,119,4,2,108,114,12433,12439,101,102,116,59,1,8619,105,103,104,116,59,1,8620,4,3,97,102,108,12454,12458,12462,114,59,1,10629,59,3,55349,56669,117,115,59,1,10797,105,109,101,115,59,1,10804,4,2,97,98,12480,12485,115,116,59,1,8727,97,114,59,1,95,4,3,59,101,102,12498,12500,12506,1,9674,110,103,101,59,1,9674,59,1,10731,97,114,4,2,59,108,12517,12519,1,40,116,59,1,10643,4,5,97,99,104,109,116,12535,12540,12548,12561,12564,114,114,59,1,8646,111,114,110,101,114,59,1,8991,97,114,4,2,59,100,12556,12558,1,8651,59,1,10605,59,1,8206,114,105,59,1,8895,4,6,97,99,104,105,113,116,12583,12589,12594,12597,12614,12635,113,117,111,59,1,8249,114,59,3,55349,56513,59,1,8624,109,4,3,59,101,103,12606,12608,12611,1,8818,59,1,10893,59,1,10895,4,2,98,117,12620,12623,59,1,91,111,4,2,59,114,12630,12632,1,8216,59,1,8218,114,111,107,59,1,322,5,60,8,59,99,100,104,105,108,113,114,12660,12662,12675,12680,12686,12692,12698,12705,1,60,4,2,99,105,12668,12671,59,1,10918,114,59,1,10873,111,116,59,1,8918,114,101,101,59,1,8907,109,101,115,59,1,8905,97,114,114,59,1,10614,117,101,115,116,59,1,10875,4,2,80,105,12711,12716,97,114,59,1,10646,4,3,59,101,102,12724,12726,12729,1,9667,59,1,8884,59,1,9666,114,4,2,100,117,12739,12746,115,104,97,114,59,1,10570,104,97,114,59,1,10598,4,2,101,110,12758,12768,114,116,110,101,113,113,59,3,8808,65024,69,59,3,8808,65024,4,14,68,97,99,100,101,102,104,105,108,110,111,112,115,117,12803,12809,12893,12908,12914,12928,12933,12937,13011,13025,13032,13049,13052,13069,68,111,116,59,1,8762,4,4,99,108,112,114,12819,12827,12849,12887,114,5,175,1,59,12825,1,175,4,2,101,116,12833,12836,59,1,9794,4,2,59,101,12842,12844,1,10016,115,101,59,1,10016,4,2,59,115,12855,12857,1,8614,116,111,4,4,59,100,108,117,12869,12871,12877,12883,1,8614,111,119,110,59,1,8615,101,102,116,59,1,8612,112,59,1,8613,107,101,114,59,1,9646,4,2,111,121,12899,12905,109,109,97,59,1,10793,59,1,1084,97,115,104,59,1,8212,97,115,117,114,101,100,97,110,103,108,101,59,1,8737,114,59,3,55349,56618,111,59,1,8487,4,3,99,100,110,12945,12954,12985,114,111,5,181,1,59,12952,1,181,4,4,59,97,99,100,12964,12966,12971,12976,1,8739,115,116,59,1,42,105,114,59,1,10992,111,116,5,183,1,59,12983,1,183,117,115,4,3,59,98,100,12995,12997,13000,1,8722,59,1,8863,4,2,59,117,13006,13008,1,8760,59,1,10794,4,2,99,100,13017,13021,112,59,1,10971,114,59,1,8230,112,108,117,115,59,1,8723,4,2,100,112,13038,13044,101,108,115,59,1,8871,102,59,3,55349,56670,59,1,8723,4,2,99,116,13058,13063,114,59,3,55349,56514,112,111,115,59,1,8766,4,3,59,108,109,13077,13079,13087,1,956,116,105,109,97,112,59,1,8888,97,112,59,1,8888,4,24,71,76,82,86,97,98,99,100,101,102,103,104,105,106,108,109,111,112,114,115,116,117,118,119,13142,13165,13217,13229,13247,13330,13359,13414,13420,13508,13513,13579,13602,13626,13631,13762,13767,13855,13936,13995,14214,14285,14312,14432,4,2,103,116,13148,13152,59,3,8921,824,4,2,59,118,13158,13161,3,8811,8402,59,3,8811,824,4,3,101,108,116,13173,13200,13204,102,116,4,2,97,114,13181,13188,114,114,111,119,59,1,8653,105,103,104,116,97,114,114,111,119,59,1,8654,59,3,8920,824,4,2,59,118,13210,13213,3,8810,8402,59,3,8810,824,105,103,104,116,97,114,114,111,119,59,1,8655,4,2,68,100,13235,13241,97,115,104,59,1,8879,97,115,104,59,1,8878,4,5,98,99,110,112,116,13259,13264,13270,13275,13308,108,97,59,1,8711,117,116,101,59,1,324,103,59,3,8736,8402,4,5,59,69,105,111,112,13287,13289,13293,13298,13302,1,8777,59,3,10864,824,100,59,3,8779,824,115,59,1,329,114,111,120,59,1,8777,117,114,4,2,59,97,13316,13318,1,9838,108,4,2,59,115,13325,13327,1,9838,59,1,8469,4,2,115,117,13336,13344,112,5,160,1,59,13342,1,160,109,112,4,2,59,101,13352,13355,3,8782,824,59,3,8783,824,4,5,97,101,111,117,121,13371,13385,13391,13407,13411,4,2,112,114,13377,13380,59,1,10819,111,110,59,1,328,100,105,108,59,1,326,110,103,4,2,59,100,13399,13401,1,8775,111,116,59,3,10861,824,112,59,1,10818,59,1,1085,97,115,104,59,1,8211,4,7,59,65,97,100,113,115,120,13436,13438,13443,13466,13472,13478,13494,1,8800,114,114,59,1,8663,114,4,2,104,114,13450,13454,107,59,1,10532,4,2,59,111,13460,13462,1,8599,119,59,1,8599,111,116,59,3,8784,824,117,105,118,59,1,8802,4,2,101,105,13484,13489,97,114,59,1,10536,109,59,3,8770,824,105,115,116,4,2,59,115,13503,13505,1,8708,59,1,8708,114,59,3,55349,56619,4,4,69,101,115,116,13523,13527,13563,13568,59,3,8807,824,4,3,59,113,115,13535,13537,13559,1,8817,4,3,59,113,115,13545,13547,13551,1,8817,59,3,8807,824,108,97,110,116,59,3,10878,824,59,3,10878,824,105,109,59,1,8821,4,2,59,114,13574,13576,1,8815,59,1,8815,4,3,65,97,112,13587,13592,13597,114,114,59,1,8654,114,114,59,1,8622,97,114,59,1,10994,4,3,59,115,118,13610,13612,13623,1,8715,4,2,59,100,13618,13620,1,8956,59,1,8954,59,1,8715,99,121,59,1,1114,4,7,65,69,97,100,101,115,116,13647,13652,13656,13661,13665,13737,13742,114,114,59,1,8653,59,3,8806,824,114,114,59,1,8602,114,59,1,8229,4,4,59,102,113,115,13675,13677,13703,13725,1,8816,116,4,2,97,114,13684,13691,114,114,111,119,59,1,8602,105,103,104,116,97,114,114,111,119,59,1,8622,4,3,59,113,115,13711,13713,13717,1,8816,59,3,8806,824,108,97,110,116,59,3,10877,824,4,2,59,115,13731,13734,3,10877,824,59,1,8814,105,109,59,1,8820,4,2,59,114,13748,13750,1,8814,105,4,2,59,101,13757,13759,1,8938,59,1,8940,105,100,59,1,8740,4,2,112,116,13773,13778,102,59,3,55349,56671,5,172,3,59,105,110,13787,13789,13829,1,172,110,4,4,59,69,100,118,13800,13802,13806,13812,1,8713,59,3,8953,824,111,116,59,3,8949,824,4,3,97,98,99,13820,13823,13826,59,1,8713,59,1,8951,59,1,8950,105,4,2,59,118,13836,13838,1,8716,4,3,97,98,99,13846,13849,13852,59,1,8716,59,1,8958,59,1,8957,4,3,97,111,114,13863,13892,13899,114,4,4,59,97,115,116,13874,13876,13883,13888,1,8742,108,108,101,108,59,1,8742,108,59,3,11005,8421,59,3,8706,824,108,105,110,116,59,1,10772,4,3,59,99,101,13907,13909,13914,1,8832,117,101,59,1,8928,4,2,59,99,13920,13923,3,10927,824,4,2,59,101,13929,13931,1,8832,113,59,3,10927,824,4,4,65,97,105,116,13946,13951,13971,13982,114,114,59,1,8655,114,114,4,3,59,99,119,13961,13963,13967,1,8603,59,3,10547,824,59,3,8605,824,103,104,116,97,114,114,111,119,59,1,8603,114,105,4,2,59,101,13990,13992,1,8939,59,1,8941,4,7,99,104,105,109,112,113,117,14011,14036,14060,14080,14085,14090,14106,4,4,59,99,101,114,14021,14023,14028,14032,1,8833,117,101,59,1,8929,59,3,10928,824,59,3,55349,56515,111,114,116,4,2,109,112,14045,14050,105,100,59,1,8740,97,114,97,108,108,101,108,59,1,8742,109,4,2,59,101,14067,14069,1,8769,4,2,59,113,14075,14077,1,8772,59,1,8772,105,100,59,1,8740,97,114,59,1,8742,115,117,4,2,98,112,14098,14102,101,59,1,8930,101,59,1,8931,4,3,98,99,112,14114,14157,14171,4,4,59,69,101,115,14124,14126,14130,14133,1,8836,59,3,10949,824,59,1,8840,101,116,4,2,59,101,14141,14144,3,8834,8402,113,4,2,59,113,14151,14153,1,8840,59,3,10949,824,99,4,2,59,101,14164,14166,1,8833,113,59,3,10928,824,4,4,59,69,101,115,14181,14183,14187,14190,1,8837,59,3,10950,824,59,1,8841,101,116,4,2,59,101,14198,14201,3,8835,8402,113,4,2,59,113,14208,14210,1,8841,59,3,10950,824,4,4,103,105,108,114,14224,14228,14238,14242,108,59,1,8825,108,100,101,5,241,1,59,14236,1,241,103,59,1,8824,105,97,110,103,108,101,4,2,108,114,14254,14269,101,102,116,4,2,59,101,14263,14265,1,8938,113,59,1,8940,105,103,104,116,4,2,59,101,14279,14281,1,8939,113,59,1,8941,4,2,59,109,14291,14293,1,957,4,3,59,101,115,14301,14303,14308,1,35,114,111,59,1,8470,112,59,1,8199,4,9,68,72,97,100,103,105,108,114,115,14332,14338,14344,14349,14355,14369,14376,14408,14426,97,115,104,59,1,8877,97,114,114,59,1,10500,112,59,3,8781,8402,97,115,104,59,1,8876,4,2,101,116,14361,14365,59,3,8805,8402,59,3,62,8402,110,102,105,110,59,1,10718,4,3,65,101,116,14384,14389,14393,114,114,59,1,10498,59,3,8804,8402,4,2,59,114,14399,14402,3,60,8402,105,101,59,3,8884,8402,4,2,65,116,14414,14419,114,114,59,1,10499,114,105,101,59,3,8885,8402,105,109,59,3,8764,8402,4,3,65,97,110,14440,14445,14468,114,114,59,1,8662,114,4,2,104,114,14452,14456,107,59,1,10531,4,2,59,111,14462,14464,1,8598,119,59,1,8598,101,97,114,59,1,10535,4,18,83,97,99,100,101,102,103,104,105,108,109,111,112,114,115,116,117,118,14512,14515,14535,14560,14597,14603,14618,14643,14657,14662,14701,14741,14747,14769,14851,14877,14907,14916,59,1,9416,4,2,99,115,14521,14531,117,116,101,5,243,1,59,14529,1,243,116,59,1,8859,4,2,105,121,14541,14557,114,4,2,59,99,14548,14550,1,8858,5,244,1,59,14555,1,244,59,1,1086,4,5,97,98,105,111,115,14572,14577,14583,14587,14591,115,104,59,1,8861,108,97,99,59,1,337,118,59,1,10808,116,59,1,8857,111,108,100,59,1,10684,108,105,103,59,1,339,4,2,99,114,14609,14614,105,114,59,1,10687,59,3,55349,56620,4,3,111,114,116,14626,14630,14640,110,59,1,731,97,118,101,5,242,1,59,14638,1,242,59,1,10689,4,2,98,109,14649,14654,97,114,59,1,10677,59,1,937,110,116,59,1,8750,4,4,97,99,105,116,14672,14677,14693,14698,114,114,59,1,8634,4,2,105,114,14683,14687,114,59,1,10686,111,115,115,59,1,10683,110,101,59,1,8254,59,1,10688,4,3,97,101,105,14709,14714,14719,99,114,59,1,333,103,97,59,1,969,4,3,99,100,110,14727,14733,14736,114,111,110,59,1,959,59,1,10678,117,115,59,1,8854,112,102,59,3,55349,56672,4,3,97,101,108,14755,14759,14764,114,59,1,10679,114,112,59,1,10681,117,115,59,1,8853,4,7,59,97,100,105,111,115,118,14785,14787,14792,14831,14837,14841,14848,1,8744,114,114,59,1,8635,4,4,59,101,102,109,14802,14804,14817,14824,1,10845,114,4,2,59,111,14811,14813,1,8500,102,59,1,8500,5,170,1,59,14822,1,170,5,186,1,59,14829,1,186,103,111,102,59,1,8886,114,59,1,10838,108,111,112,101,59,1,10839,59,1,10843,4,3,99,108,111,14859,14863,14873,114,59,1,8500,97,115,104,5,248,1,59,14871,1,248,108,59,1,8856,105,4,2,108,109,14884,14893,100,101,5,245,1,59,14891,1,245,101,115,4,2,59,97,14901,14903,1,8855,115,59,1,10806,109,108,5,246,1,59,14914,1,246,98,97,114,59,1,9021,4,12,97,99,101,102,104,105,108,109,111,114,115,117,14948,14992,14996,15033,15038,15068,15090,15189,15192,15222,15427,15441,114,4,4,59,97,115,116,14959,14961,14976,14989,1,8741,5,182,2,59,108,14968,14970,1,182,108,101,108,59,1,8741,4,2,105,108,14982,14986,109,59,1,10995,59,1,11005,59,1,8706,121,59,1,1087,114,4,5,99,105,109,112,116,15009,15014,15019,15024,15027,110,116,59,1,37,111,100,59,1,46,105,108,59,1,8240,59,1,8869,101,110,107,59,1,8241,114,59,3,55349,56621,4,3,105,109,111,15046,15057,15063,4,2,59,118,15052,15054,1,966,59,1,981,109,97,116,59,1,8499,110,101,59,1,9742,4,3,59,116,118,15076,15078,15087,1,960,99,104,102,111,114,107,59,1,8916,59,1,982,4,2,97,117,15096,15119,110,4,2,99,107,15103,15115,107,4,2,59,104,15110,15112,1,8463,59,1,8462,118,59,1,8463,115,4,9,59,97,98,99,100,101,109,115,116,15140,15142,15148,15151,15156,15168,15171,15179,15184,1,43,99,105,114,59,1,10787,59,1,8862,105,114,59,1,10786,4,2,111,117,15162,15165,59,1,8724,59,1,10789,59,1,10866,110,5,177,1,59,15177,1,177,105,109,59,1,10790,119,111,59,1,10791,59,1,177,4,3,105,112,117,15200,15208,15213,110,116,105,110,116,59,1,10773,102,59,3,55349,56673,110,100,5,163,1,59,15220,1,163,4,10,59,69,97,99,101,105,110,111,115,117,15244,15246,15249,15253,15258,15334,15347,15367,15416,15421,1,8826,59,1,10931,112,59,1,10935,117,101,59,1,8828,4,2,59,99,15264,15266,1,10927,4,6,59,97,99,101,110,115,15280,15282,15290,15299,15303,15329,1,8826,112,112,114,111,120,59,1,10935,117,114,108,121,101,113,59,1,8828,113,59,1,10927,4,3,97,101,115,15311,15319,15324,112,112,114,111,120,59,1,10937,113,113,59,1,10933,105,109,59,1,8936,105,109,59,1,8830,109,101,4,2,59,115,15342,15344,1,8242,59,1,8473,4,3,69,97,115,15355,15358,15362,59,1,10933,112,59,1,10937,105,109,59,1,8936,4,3,100,102,112,15375,15378,15404,59,1,8719,4,3,97,108,115,15386,15392,15398,108,97,114,59,1,9006,105,110,101,59,1,8978,117,114,102,59,1,8979,4,2,59,116,15410,15412,1,8733,111,59,1,8733,105,109,59,1,8830,114,101,108,59,1,8880,4,2,99,105,15433,15438,114,59,3,55349,56517,59,1,968,110,99,115,112,59,1,8200,4,6,102,105,111,112,115,117,15462,15467,15472,15478,15485,15491,114,59,3,55349,56622,110,116,59,1,10764,112,102,59,3,55349,56674,114,105,109,101,59,1,8279,99,114,59,3,55349,56518,4,3,97,101,111,15499,15520,15534,116,4,2,101,105,15506,15515,114,110,105,111,110,115,59,1,8461,110,116,59,1,10774,115,116,4,2,59,101,15528,15530,1,63,113,59,1,8799,116,5,34,1,59,15540,1,34,4,21,65,66,72,97,98,99,100,101,102,104,105,108,109,110,111,112,114,115,116,117,120,15586,15609,15615,15620,15796,15855,15893,15931,15977,16001,16039,16183,16204,16222,16228,16285,16312,16318,16363,16408,16416,4,3,97,114,116,15594,15599,15603,114,114,59,1,8667,114,59,1,8658,97,105,108,59,1,10524,97,114,114,59,1,10511,97,114,59,1,10596,4,7,99,100,101,110,113,114,116,15636,15651,15656,15664,15687,15696,15770,4,2,101,117,15642,15646,59,3,8765,817,116,101,59,1,341,105,99,59,1,8730,109,112,116,121,118,59,1,10675,103,4,4,59,100,101,108,15675,15677,15680,15683,1,10217,59,1,10642,59,1,10661,101,59,1,10217,117,111,5,187,1,59,15694,1,187,114,4,11,59,97,98,99,102,104,108,112,115,116,119,15721,15723,15727,15739,15742,15746,15750,15754,15758,15763,15767,1,8594,112,59,1,10613,4,2,59,102,15733,15735,1,8677,115,59,1,10528,59,1,10547,115,59,1,10526,107,59,1,8618,112,59,1,8620,108,59,1,10565,105,109,59,1,10612,108,59,1,8611,59,1,8605,4,2,97,105,15776,15781,105,108,59,1,10522,111,4,2,59,110,15788,15790,1,8758,97,108,115,59,1,8474,4,3,97,98,114,15804,15809,15814,114,114,59,1,10509,114,107,59,1,10099,4,2,97,107,15820,15833,99,4,2,101,107,15827,15830,59,1,125,59,1,93,4,2,101,115,15839,15842,59,1,10636,108,4,2,100,117,15849,15852,59,1,10638,59,1,10640,4,4,97,101,117,121,15865,15871,15886,15890,114,111,110,59,1,345,4,2,100,105,15877,15882,105,108,59,1,343,108,59,1,8969,98,59,1,125,59,1,1088,4,4,99,108,113,115,15903,15907,15914,15927,97,59,1,10551,100,104,97,114,59,1,10601,117,111,4,2,59,114,15922,15924,1,8221,59,1,8221,104,59,1,8627,4,3,97,99,103,15939,15966,15970,108,4,4,59,105,112,115,15950,15952,15957,15963,1,8476,110,101,59,1,8475,97,114,116,59,1,8476,59,1,8477,116,59,1,9645,5,174,1,59,15975,1,174,4,3,105,108,114,15985,15991,15997,115,104,116,59,1,10621,111,111,114,59,1,8971,59,3,55349,56623,4,2,97,111,16007,16028,114,4,2,100,117,16014,16017,59,1,8641,4,2,59,108,16023,16025,1,8640,59,1,10604,4,2,59,118,16034,16036,1,961,59,1,1009,4,3,103,110,115,16047,16167,16171,104,116,4,6,97,104,108,114,115,116,16063,16081,16103,16130,16143,16155,114,114,111,119,4,2,59,116,16073,16075,1,8594,97,105,108,59,1,8611,97,114,112,111,111,110,4,2,100,117,16093,16099,111,119,110,59,1,8641,112,59,1,8640,101,102,116,4,2,97,104,16112,16120,114,114,111,119,115,59,1,8644,97,114,112,111,111,110,115,59,1,8652,105,103,104,116,97,114,114,111,119,115,59,1,8649,113,117,105,103,97,114,114,111,119,59,1,8605,104,114,101,101,116,105,109,101,115,59,1,8908,103,59,1,730,105,110,103,100,111,116,115,101,113,59,1,8787,4,3,97,104,109,16191,16196,16201,114,114,59,1,8644,97,114,59,1,8652,59,1,8207,111,117,115,116,4,2,59,97,16214,16216,1,9137,99,104,101,59,1,9137,109,105,100,59,1,10990,4,4,97,98,112,116,16238,16252,16257,16278,4,2,110,114,16244,16248,103,59,1,10221,114,59,1,8702,114,107,59,1,10215,4,3,97,102,108,16265,16269,16273,114,59,1,10630,59,3,55349,56675,117,115,59,1,10798,105,109,101,115,59,1,10805,4,2,97,112,16291,16304,114,4,2,59,103,16298,16300,1,41,116,59,1,10644,111,108,105,110,116,59,1,10770,97,114,114,59,1,8649,4,4,97,99,104,113,16328,16334,16339,16342,113,117,111,59,1,8250,114,59,3,55349,56519,59,1,8625,4,2,98,117,16348,16351,59,1,93,111,4,2,59,114,16358,16360,1,8217,59,1,8217,4,3,104,105,114,16371,16377,16383,114,101,101,59,1,8908,109,101,115,59,1,8906,105,4,4,59,101,102,108,16394,16396,16399,16402,1,9657,59,1,8885,59,1,9656,116,114,105,59,1,10702,108,117,104,97,114,59,1,10600,59,1,8478,4,19,97,98,99,100,101,102,104,105,108,109,111,112,113,114,115,116,117,119,122,16459,16466,16472,16572,16590,16672,16687,16746,16844,16850,16924,16963,16988,17115,17121,17154,17206,17614,17656,99,117,116,101,59,1,347,113,117,111,59,1,8218,4,10,59,69,97,99,101,105,110,112,115,121,16494,16496,16499,16513,16518,16531,16536,16556,16564,16569,1,8827,59,1,10932,4,2,112,114,16505,16508,59,1,10936,111,110,59,1,353,117,101,59,1,8829,4,2,59,100,16524,16526,1,10928,105,108,59,1,351,114,99,59,1,349,4,3,69,97,115,16544,16547,16551,59,1,10934,112,59,1,10938,105,109,59,1,8937,111,108,105,110,116,59,1,10771,105,109,59,1,8831,59,1,1089,111,116,4,3,59,98,101,16582,16584,16587,1,8901,59,1,8865,59,1,10854,4,7,65,97,99,109,115,116,120,16606,16611,16634,16642,16646,16652,16668,114,114,59,1,8664,114,4,2,104,114,16618,16622,107,59,1,10533,4,2,59,111,16628,16630,1,8600,119,59,1,8600,116,5,167,1,59,16640,1,167,105,59,1,59,119,97,114,59,1,10537,109,4,2,105,110,16659,16665,110,117,115,59,1,8726,59,1,8726,116,59,1,10038,114,4,2,59,111,16679,16682,3,55349,56624,119,110,59,1,8994,4,4,97,99,111,121,16697,16702,16716,16739,114,112,59,1,9839,4,2,104,121,16708,16713,99,121,59,1,1097,59,1,1096,114,116,4,2,109,112,16724,16729,105,100,59,1,8739,97,114,97,108,108,101,108,59,1,8741,5,173,1,59,16744,1,173,4,2,103,109,16752,16770,109,97,4,3,59,102,118,16762,16764,16767,1,963,59,1,962,59,1,962,4,8,59,100,101,103,108,110,112,114,16788,16790,16795,16806,16817,16828,16832,16838,1,8764,111,116,59,1,10858,4,2,59,113,16801,16803,1,8771,59,1,8771,4,2,59,69,16812,16814,1,10910,59,1,10912,4,2,59,69,16823,16825,1,10909,59,1,10911,101,59,1,8774,108,117,115,59,1,10788,97,114,114,59,1,10610,97,114,114,59,1,8592,4,4,97,101,105,116,16860,16883,16891,16904,4,2,108,115,16866,16878,108,115,101,116,109,105,110,117,115,59,1,8726,104,112,59,1,10803,112,97,114,115,108,59,1,10724,4,2,100,108,16897,16900,59,1,8739,101,59,1,8995,4,2,59,101,16910,16912,1,10922,4,2,59,115,16918,16920,1,10924,59,3,10924,65024,4,3,102,108,112,16932,16938,16958,116,99,121,59,1,1100,4,2,59,98,16944,16946,1,47,4,2,59,97,16952,16954,1,10692,114,59,1,9023,102,59,3,55349,56676,97,4,2,100,114,16970,16985,101,115,4,2,59,117,16978,16980,1,9824,105,116,59,1,9824,59,1,8741,4,3,99,115,117,16996,17028,17089,4,2,97,117,17002,17015,112,4,2,59,115,17009,17011,1,8851,59,3,8851,65024,112,4,2,59,115,17022,17024,1,8852,59,3,8852,65024,117,4,2,98,112,17035,17062,4,3,59,101,115,17043,17045,17048,1,8847,59,1,8849,101,116,4,2,59,101,17056,17058,1,8847,113,59,1,8849,4,3,59,101,115,17070,17072,17075,1,8848,59,1,8850,101,116,4,2,59,101,17083,17085,1,8848,113,59,1,8850,4,3,59,97,102,17097,17099,17112,1,9633,114,4,2,101,102,17106,17109,59,1,9633,59,1,9642,59,1,9642,97,114,114,59,1,8594,4,4,99,101,109,116,17131,17136,17142,17148,114,59,3,55349,56520,116,109,110,59,1,8726,105,108,101,59,1,8995,97,114,102,59,1,8902,4,2,97,114,17160,17172,114,4,2,59,102,17167,17169,1,9734,59,1,9733,4,2,97,110,17178,17202,105,103,104,116,4,2,101,112,17188,17197,112,115,105,108,111,110,59,1,1013,104,105,59,1,981,115,59,1,175,4,5,98,99,109,110,112,17218,17351,17420,17423,17427,4,9,59,69,100,101,109,110,112,114,115,17238,17240,17243,17248,17261,17267,17279,17285,17291,1,8834,59,1,10949,111,116,59,1,10941,4,2,59,100,17254,17256,1,8838,111,116,59,1,10947,117,108,116,59,1,10945,4,2,69,101,17273,17276,59,1,10955,59,1,8842,108,117,115,59,1,10943,97,114,114,59,1,10617,4,3,101,105,117,17299,17335,17339,116,4,3,59,101,110,17308,17310,17322,1,8834,113,4,2,59,113,17317,17319,1,8838,59,1,10949,101,113,4,2,59,113,17330,17332,1,8842,59,1,10955,109,59,1,10951,4,2,98,112,17345,17348,59,1,10965,59,1,10963,99,4,6,59,97,99,101,110,115,17366,17368,17376,17385,17389,17415,1,8827,112,112,114,111,120,59,1,10936,117,114,108,121,101,113,59,1,8829,113,59,1,10928,4,3,97,101,115,17397,17405,17410,112,112,114,111,120,59,1,10938,113,113,59,1,10934,105,109,59,1,8937,105,109,59,1,8831,59,1,8721,103,59,1,9834,4,13,49,50,51,59,69,100,101,104,108,109,110,112,115,17455,17462,17469,17476,17478,17481,17496,17509,17524,17530,17536,17548,17554,5,185,1,59,17460,1,185,5,178,1,59,17467,1,178,5,179,1,59,17474,1,179,1,8835,59,1,10950,4,2,111,115,17487,17491,116,59,1,10942,117,98,59,1,10968,4,2,59,100,17502,17504,1,8839,111,116,59,1,10948,115,4,2,111,117,17516,17520,108,59,1,10185,98,59,1,10967,97,114,114,59,1,10619,117,108,116,59,1,10946,4,2,69,101,17542,17545,59,1,10956,59,1,8843,108,117,115,59,1,10944,4,3,101,105,117,17562,17598,17602,116,4,3,59,101,110,17571,17573,17585,1,8835,113,4,2,59,113,17580,17582,1,8839,59,1,10950,101,113,4,2,59,113,17593,17595,1,8843,59,1,10956,109,59,1,10952,4,2,98,112,17608,17611,59,1,10964,59,1,10966,4,3,65,97,110,17622,17627,17650,114,114,59,1,8665,114,4,2,104,114,17634,17638,107,59,1,10534,4,2,59,111,17644,17646,1,8601,119,59,1,8601,119,97,114,59,1,10538,108,105,103,5,223,1,59,17664,1,223,4,13,97,98,99,100,101,102,104,105,111,112,114,115,119,17694,17709,17714,17737,17742,17749,17754,17860,17905,17957,17964,18090,18122,4,2,114,117,17700,17706,103,101,116,59,1,8982,59,1,964,114,107,59,1,9140,4,3,97,101,121,17722,17728,17734,114,111,110,59,1,357,100,105,108,59,1,355,59,1,1090,111,116,59,1,8411,108,114,101,99,59,1,8981,114,59,3,55349,56625,4,4,101,105,107,111,17764,17805,17836,17851,4,2,114,116,17770,17786,101,4,2,52,102,17777,17780,59,1,8756,111,114,101,59,1,8756,97,4,3,59,115,118,17795,17797,17802,1,952,121,109,59,1,977,59,1,977,4,2,99,110,17811,17831,107,4,2,97,115,17818,17826,112,112,114,111,120,59,1,8776,105,109,59,1,8764,115,112,59,1,8201,4,2,97,115,17842,17846,112,59,1,8776,105,109,59,1,8764,114,110,5,254,1,59,17858,1,254,4,3,108,109,110,17868,17873,17901,100,101,59,1,732,101,115,5,215,3,59,98,100,17884,17886,17898,1,215,4,2,59,97,17892,17894,1,8864,114,59,1,10801,59,1,10800,116,59,1,8749,4,3,101,112,115,17913,17917,17953,97,59,1,10536,4,4,59,98,99,102,17927,17929,17934,17939,1,8868,111,116,59,1,9014,105,114,59,1,10993,4,2,59,111,17945,17948,3,55349,56677,114,107,59,1,10970,97,59,1,10537,114,105,109,101,59,1,8244,4,3,97,105,112,17972,17977,18082,100,101,59,1,8482,4,7,97,100,101,109,112,115,116,17993,18051,18056,18059,18066,18072,18076,110,103,108,101,4,5,59,100,108,113,114,18009,18011,18017,18032,18035,1,9653,111,119,110,59,1,9663,101,102,116,4,2,59,101,18026,18028,1,9667,113,59,1,8884,59,1,8796,105,103,104,116,4,2,59,101,18045,18047,1,9657,113,59,1,8885,111,116,59,1,9708,59,1,8796,105,110,117,115,59,1,10810,108,117,115,59,1,10809,98,59,1,10701,105,109,101,59,1,10811,101,122,105,117,109,59,1,9186,4,3,99,104,116,18098,18111,18116,4,2,114,121,18104,18108,59,3,55349,56521,59,1,1094,99,121,59,1,1115,114,111,107,59,1,359,4,2,105,111,18128,18133,120,116,59,1,8812,104,101,97,100,4,2,108,114,18143,18154,101,102,116,97,114,114,111,119,59,1,8606,105,103,104,116,97,114,114,111,119,59,1,8608,4,18,65,72,97,98,99,100,102,103,104,108,109,111,112,114,115,116,117,119,18204,18209,18214,18234,18250,18268,18292,18308,18319,18343,18379,18397,18413,18504,18547,18553,18584,18603,114,114,59,1,8657,97,114,59,1,10595,4,2,99,114,18220,18230,117,116,101,5,250,1,59,18228,1,250,114,59,1,8593,114,4,2,99,101,18241,18245,121,59,1,1118,118,101,59,1,365,4,2,105,121,18256,18265,114,99,5,251,1,59,18263,1,251,59,1,1091,4,3,97,98,104,18276,18281,18287,114,114,59,1,8645,108,97,99,59,1,369,97,114,59,1,10606,4,2,105,114,18298,18304,115,104,116,59,1,10622,59,3,55349,56626,114,97,118,101,5,249,1,59,18317,1,249,4,2,97,98,18325,18338,114,4,2,108,114,18332,18335,59,1,8639,59,1,8638,108,107,59,1,9600,4,2,99,116,18349,18374,4,2,111,114,18355,18369,114,110,4,2,59,101,18363,18365,1,8988,114,59,1,8988,111,112,59,1,8975,114,105,59,1,9720,4,2,97,108,18385,18390,99,114,59,1,363,5,168,1,59,18395,1,168,4,2,103,112,18403,18408,111,110,59,1,371,102,59,3,55349,56678,4,6,97,100,104,108,115,117,18427,18434,18445,18470,18475,18494,114,114,111,119,59,1,8593,111,119,110,97,114,114,111,119,59,1,8597,97,114,112,111,111,110,4,2,108,114,18457,18463,101,102,116,59,1,8639,105,103,104,116,59,1,8638,117,115,59,1,8846,105,4,3,59,104,108,18484,18486,18489,1,965,59,1,978,111,110,59,1,965,112,97,114,114,111,119,115,59,1,8648,4,3,99,105,116,18512,18537,18542,4,2,111,114,18518,18532,114,110,4,2,59,101,18526,18528,1,8989,114,59,1,8989,111,112,59,1,8974,110,103,59,1,367,114,105,59,1,9721,99,114,59,3,55349,56522,4,3,100,105,114,18561,18566,18572,111,116,59,1,8944,108,100,101,59,1,361,105,4,2,59,102,18579,18581,1,9653,59,1,9652,4,2,97,109,18590,18595,114,114,59,1,8648,108,5,252,1,59,18601,1,252,97,110,103,108,101,59,1,10663,4,15,65,66,68,97,99,100,101,102,108,110,111,112,114,115,122,18643,18648,18661,18667,18847,18851,18857,18904,18909,18915,18931,18937,18943,18949,18996,114,114,59,1,8661,97,114,4,2,59,118,18656,18658,1,10984,59,1,10985,97,115,104,59,1,8872,4,2,110,114,18673,18679,103,114,116,59,1,10652,4,7,101,107,110,112,114,115,116,18695,18704,18711,18720,18742,18754,18810,112,115,105,108,111,110,59,1,1013,97,112,112,97,59,1,1008,111,116,104,105,110,103,59,1,8709,4,3,104,105,114,18728,18732,18735,105,59,1,981,59,1,982,111,112,116,111,59,1,8733,4,2,59,104,18748,18750,1,8597,111,59,1,1009,4,2,105,117,18760,18766,103,109,97,59,1,962,4,2,98,112,18772,18791,115,101,116,110,101,113,4,2,59,113,18784,18787,3,8842,65024,59,3,10955,65024,115,101,116,110,101,113,4,2,59,113,18803,18806,3,8843,65024,59,3,10956,65024,4,2,104,114,18816,18822,101,116,97,59,1,977,105,97,110,103,108,101,4,2,108,114,18834,18840,101,102,116,59,1,8882,105,103,104,116,59,1,8883,121,59,1,1074,97,115,104,59,1,8866,4,3,101,108,114,18865,18884,18890,4,3,59,98,101,18873,18875,18880,1,8744,97,114,59,1,8891,113,59,1,8794,108,105,112,59,1,8942,4,2,98,116,18896,18901,97,114,59,1,124,59,1,124,114,59,3,55349,56627,116,114,105,59,1,8882,115,117,4,2,98,112,18923,18927,59,3,8834,8402,59,3,8835,8402,112,102,59,3,55349,56679,114,111,112,59,1,8733,116,114,105,59,1,8883,4,2,99,117,18955,18960,114,59,3,55349,56523,4,2,98,112,18966,18981,110,4,2,69,101,18973,18977,59,3,10955,65024,59,3,8842,65024,110,4,2,69,101,18988,18992,59,3,10956,65024,59,3,8843,65024,105,103,122,97,103,59,1,10650,4,7,99,101,102,111,112,114,115,19020,19026,19061,19066,19072,19075,19089,105,114,99,59,1,373,4,2,100,105,19032,19055,4,2,98,103,19038,19043,97,114,59,1,10847,101,4,2,59,113,19050,19052,1,8743,59,1,8793,101,114,112,59,1,8472,114,59,3,55349,56628,112,102,59,3,55349,56680,59,1,8472,4,2,59,101,19081,19083,1,8768,97,116,104,59,1,8768,99,114,59,3,55349,56524,4,14,99,100,102,104,105,108,109,110,111,114,115,117,118,119,19125,19146,19152,19157,19173,19176,19192,19197,19202,19236,19252,19269,19286,19291,4,3,97,105,117,19133,19137,19142,112,59,1,8898,114,99,59,1,9711,112,59,1,8899,116,114,105,59,1,9661,114,59,3,55349,56629,4,2,65,97,19163,19168,114,114,59,1,10234,114,114,59,1,10231,59,1,958,4,2,65,97,19182,19187,114,114,59,1,10232,114,114,59,1,10229,97,112,59,1,10236,105,115,59,1,8955,4,3,100,112,116,19210,19215,19230,111,116,59,1,10752,4,2,102,108,19221,19225,59,3,55349,56681,117,115,59,1,10753,105,109,101,59,1,10754,4,2,65,97,19242,19247,114,114,59,1,10233,114,114,59,1,10230,4,2,99,113,19258,19263,114,59,3,55349,56525,99,117,112,59,1,10758,4,2,112,116,19275,19281,108,117,115,59,1,10756,114,105,59,1,9651,101,101,59,1,8897,101,100,103,101,59,1,8896,4,8,97,99,101,102,105,111,115,117,19316,19335,19349,19357,19362,19367,19373,19379,99,4,2,117,121,19323,19332,116,101,5,253,1,59,19330,1,253,59,1,1103,4,2,105,121,19341,19346,114,99,59,1,375,59,1,1099,110,5,165,1,59,19355,1,165,114,59,3,55349,56630,99,121,59,1,1111,112,102,59,3,55349,56682,99,114,59,3,55349,56526,4,2,99,109,19385,19389,121,59,1,1102,108,5,255,1,59,19395,1,255,4,10,97,99,100,101,102,104,105,111,115,119,19419,19426,19441,19446,19462,19467,19472,19480,19486,19492,99,117,116,101,59,1,378,4,2,97,121,19432,19438,114,111,110,59,1,382,59,1,1079,111,116,59,1,380,4,2,101,116,19452,19458,116,114,102,59,1,8488,97,59,1,950,114,59,3,55349,56631,99,121,59,1,1078,103,114,97,114,114,59,1,8669,112,102,59,3,55349,56683,99,114,59,3,55349,56527,4,2,106,110,19498,19501,59,1,8205,106,59,1,8204]);

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HTML = __webpack_require__(42);

//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
    switch (tn.length) {
        case 1:
            return tn === $.P;

        case 2:
            return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;

        case 3:
            return tn === $.RTC;

        case 6:
            return tn === $.OPTION;

        case 8:
            return tn === $.OPTGROUP || tn === $.MENUITEM;
    }

    return false;
}

function isScopingElement(tn, ns) {
    switch (tn.length) {
        case 2:
            if (tn === $.TD || tn === $.TH)
                return ns === NS.HTML;

            else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS)
                return ns === NS.MATHML;

            break;

        case 4:
            if (tn === $.HTML)
                return ns === NS.HTML;

            else if (tn === $.DESC)
                return ns === NS.SVG;

            break;

        case 5:
            if (tn === $.TABLE)
                return ns === NS.HTML;

            else if (tn === $.MTEXT)
                return ns === NS.MATHML;

            else if (tn === $.TITLE)
                return ns === NS.SVG;

            break;

        case 6:
            return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;

        case 7:
            return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;

        case 8:
            return tn === $.TEMPLATE && ns === NS.HTML;

        case 13:
            return tn === $.FOREIGN_OBJECT && ns === NS.SVG;

        case 14:
            return tn === $.ANNOTATION_XML && ns === NS.MATHML;
    }

    return false;
}

//Stack of open elements
var OpenElementStack = module.exports = function (document, treeAdapter) {
    this.stackTop = -1;
    this.items = [];
    this.current = document;
    this.currentTagName = null;
    this.currentTmplContent = null;
    this.tmplCount = 0;
    this.treeAdapter = treeAdapter;
};

//Index of element
OpenElementStack.prototype._indexOf = function (element) {
    var idx = -1;

    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            idx = i;
            break;
        }
    }
    return idx;
};

//Update current element
OpenElementStack.prototype._isInTemplate = function () {
    return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
};

OpenElementStack.prototype._updateCurrentElement = function () {
    this.current = this.items[this.stackTop];
    this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);

    this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
};

//Mutations
OpenElementStack.prototype.push = function (element) {
    this.items[++this.stackTop] = element;
    this._updateCurrentElement();

    if (this._isInTemplate())
        this.tmplCount++;

};

OpenElementStack.prototype.pop = function () {
    this.stackTop--;

    if (this.tmplCount > 0 && this._isInTemplate())
        this.tmplCount--;

    this._updateCurrentElement();
};

OpenElementStack.prototype.replace = function (oldElement, newElement) {
    var idx = this._indexOf(oldElement);

    this.items[idx] = newElement;

    if (idx === this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.insertAfter = function (referenceElement, newElement) {
    var insertionIdx = this._indexOf(referenceElement) + 1;

    this.items.splice(insertionIdx, 0, newElement);

    if (insertionIdx === ++this.stackTop)
        this._updateCurrentElement();
};

OpenElementStack.prototype.popUntilTagNamePopped = function (tagName) {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === tagName && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilElementPopped = function (element) {
    while (this.stackTop > -1) {
        var poppedElement = this.current;

        this.pop();

        if (poppedElement === element)
            break;
    }
};

OpenElementStack.prototype.popUntilNumberedHeaderPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popUntilTableCellPopped = function () {
    while (this.stackTop > -1) {
        var tn = this.currentTagName,
            ns = this.treeAdapter.getNamespaceURI(this.current);

        this.pop();

        if (tn === $.TD || tn === $.TH && ns === NS.HTML)
            break;
    }
};

OpenElementStack.prototype.popAllUpToHtmlElement = function () {
    //NOTE: here we assume that root <html> element is always first in the open element stack, so
    //we perform this fast stack clean up.
    this.stackTop = 0;
    this._updateCurrentElement();
};

OpenElementStack.prototype.clearBackToTableContext = function () {
    while (this.currentTagName !== $.TABLE &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableBodyContext = function () {
    while (this.currentTagName !== $.TBODY &&
           this.currentTagName !== $.TFOOT &&
           this.currentTagName !== $.THEAD &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.clearBackToTableRowContext = function () {
    while (this.currentTagName !== $.TR &&
           this.currentTagName !== $.TEMPLATE &&
           this.currentTagName !== $.HTML ||
           this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML)
        this.pop();
};

OpenElementStack.prototype.remove = function (element) {
    for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
            this.items.splice(i, 1);
            this.stackTop--;
            this._updateCurrentElement();
            break;
        }
    }
};

//Search
OpenElementStack.prototype.tryPeekProperlyNestedBodyElement = function () {
    //Properly nested <body> element (should be second element in stack).
    var element = this.items[1];

    return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
};

OpenElementStack.prototype.contains = function (element) {
    return this._indexOf(element) > -1;
};

OpenElementStack.prototype.getCommonAncestor = function (element) {
    var elementIdx = this._indexOf(element);

    return --elementIdx >= 0 ? this.items[elementIdx] : null;
};

OpenElementStack.prototype.isRootHtmlElementCurrent = function () {
    return this.stackTop === 0 && this.currentTagName === $.HTML;
};

//Element in scope
OpenElementStack.prototype.hasInScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasNumberedHeaderInScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML)
            return true;

        if (isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInListItemScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInButtonScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (tn === tagName && ns === NS.HTML)
            return true;

        if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns))
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInTableScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasTableBodyContextInTableScope = function () {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT)
            return true;

        if (tn === $.TABLE || tn === $.HTML)
            return false;
    }

    return true;
};

OpenElementStack.prototype.hasInSelectScope = function (tagName) {
    for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]),
            ns = this.treeAdapter.getNamespaceURI(this.items[i]);

        if (ns !== NS.HTML)
            continue;

        if (tn === tagName)
            return true;

        if (tn !== $.OPTION && tn !== $.OPTGROUP)
            return false;
    }

    return true;
};

//Implied end tags
OpenElementStack.prototype.generateImpliedEndTags = function () {
    while (isImpliedEndTagRequired(this.currentTagName))
        this.pop();
};

OpenElementStack.prototype.generateImpliedEndTagsWithExclusion = function (exclusionTagName) {
    while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName)
        this.pop();
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Const
var NOAH_ARK_CAPACITY = 3;

//List of formatting elements
var FormattingElementList = module.exports = function (treeAdapter) {
    this.length = 0;
    this.entries = [];
    this.treeAdapter = treeAdapter;
    this.bookmark = null;
};

//Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';

//Noah Ark's condition
//OPTIMIZATION: at first we try to find possible candidates for exclusion using
//lightweight heuristics without thorough attributes check.
FormattingElementList.prototype._getNoahArkConditionCandidates = function (newElement) {
    var candidates = [];

    if (this.length >= NOAH_ARK_CAPACITY) {
        var neAttrsLength = this.treeAdapter.getAttrList(newElement).length,
            neTagName = this.treeAdapter.getTagName(newElement),
            neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);

        for (var i = this.length - 1; i >= 0; i--) {
            var entry = this.entries[i];

            if (entry.type === FormattingElementList.MARKER_ENTRY)
                break;

            var element = entry.element,
                elementAttrs = this.treeAdapter.getAttrList(element),
                isCandidate = this.treeAdapter.getTagName(element) === neTagName &&
                              this.treeAdapter.getNamespaceURI(element) === neNamespaceURI &&
                              elementAttrs.length === neAttrsLength;

            if (isCandidate)
                candidates.push({idx: i, attrs: elementAttrs});
        }
    }

    return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
};

FormattingElementList.prototype._ensureNoahArkCondition = function (newElement) {
    var candidates = this._getNoahArkConditionCandidates(newElement),
        cLength = candidates.length;

    if (cLength) {
        var neAttrs = this.treeAdapter.getAttrList(newElement),
            neAttrsLength = neAttrs.length,
            neAttrsMap = Object.create(null);

        //NOTE: build attrs map for the new element so we can perform fast lookups
        for (var i = 0; i < neAttrsLength; i++) {
            var neAttr = neAttrs[i];

            neAttrsMap[neAttr.name] = neAttr.value;
        }

        for (i = 0; i < neAttrsLength; i++) {
            for (var j = 0; j < cLength; j++) {
                var cAttr = candidates[j].attrs[i];

                if (neAttrsMap[cAttr.name] !== cAttr.value) {
                    candidates.splice(j, 1);
                    cLength--;
                }

                if (candidates.length < NOAH_ARK_CAPACITY)
                    return;
            }
        }

        //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
        for (i = cLength - 1; i >= NOAH_ARK_CAPACITY - 1; i--) {
            this.entries.splice(candidates[i].idx, 1);
            this.length--;
        }
    }
};

//Mutations
FormattingElementList.prototype.insertMarker = function () {
    this.entries.push({type: FormattingElementList.MARKER_ENTRY});
    this.length++;
};

FormattingElementList.prototype.pushElement = function (element, token) {
    this._ensureNoahArkCondition(element);

    this.entries.push({
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.insertElementAfterBookmark = function (element, token) {
    var bookmarkIdx = this.length - 1;

    for (; bookmarkIdx >= 0; bookmarkIdx--) {
        if (this.entries[bookmarkIdx] === this.bookmark)
            break;
    }

    this.entries.splice(bookmarkIdx + 1, 0, {
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
    });

    this.length++;
};

FormattingElementList.prototype.removeEntry = function (entry) {
    for (var i = this.length - 1; i >= 0; i--) {
        if (this.entries[i] === entry) {
            this.entries.splice(i, 1);
            this.length--;
            break;
        }
    }
};

FormattingElementList.prototype.clearToLastMarker = function () {
    while (this.length) {
        var entry = this.entries.pop();

        this.length--;

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            break;
    }
};

//Search
FormattingElementList.prototype.getElementEntryInScopeWithTagName = function (tagName) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.MARKER_ENTRY)
            return null;

        if (this.treeAdapter.getTagName(entry.element) === tagName)
            return entry;
    }

    return null;
};

FormattingElementList.prototype.getElementEntry = function (element) {
    for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];

        if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element)
            return entry;
    }

    return null;
};


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(135),
    Tokenizer = __webpack_require__(82),
    LocationInfoTokenizerMixin = __webpack_require__(310),
    PositionTrackingPreprocessorMixin = __webpack_require__(311),
    LocationInfoOpenElementStackMixin = __webpack_require__(642),
    HTML = __webpack_require__(42),
    inherits = __webpack_require__(53).inherits;


//Aliases
var $ = HTML.TAG_NAMES;

var LocationInfoParserMixin = module.exports = function (parser) {
    Mixin.call(this, parser);

    this.parser = parser;
    this.posTracker = null;
    this.lastStartTagToken = null;
    this.lastFosterParentingLocation = null;
    this.currentToken = null;
};

inherits(LocationInfoParserMixin, Mixin);


LocationInfoParserMixin.prototype._setStartLocation = function (element) {
    if (this.lastStartTagToken) {
        element.__location = Object.create(this.lastStartTagToken.location);
        element.__location.startTag = this.lastStartTagToken.location;
    }
    else
        element.__location = null;
};

LocationInfoParserMixin.prototype._setEndLocation = function (element, closingToken) {
    var loc = element.__location;

    if (loc) {
        if (closingToken.location) {
            var ctLoc = closingToken.location,
                tn = this.parser.treeAdapter.getTagName(element);

            // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
            // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
            var isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;

            if (isClosingEndTag) {
                loc.endTag = Object.create(ctLoc);
                loc.endOffset = ctLoc.endOffset;
            }

            else
                loc.endOffset = ctLoc.startOffset;
        }

        else if (closingToken.type === Tokenizer.EOF_TOKEN)
            loc.endOffset = this.posTracker.offset;
    }
};

LocationInfoParserMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        _bootstrap: function (document, fragmentContext) {
            orig._bootstrap.call(this, document, fragmentContext);

            mxn.lastStartTagToken = null;
            mxn.lastFosterParentingLocation = null;
            mxn.currentToken = null;
            mxn.posTracker = new PositionTrackingPreprocessorMixin(this.tokenizer.preprocessor);

            new LocationInfoTokenizerMixin(this.tokenizer);

            new LocationInfoOpenElementStackMixin(this.openElements, {
                onItemPop: function (element) {
                    mxn._setEndLocation(element, mxn.currentToken);
                }
            });
        },

        _runParsingLoop: function (scriptHandler) {
            orig._runParsingLoop.call(this, scriptHandler);

            // NOTE: generate location info for elements
            // that remains on open element stack
            for (var i = this.openElements.stackTop; i >= 0; i--)
                mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
        },


        //Token processing
        _processTokenInForeignContent: function (token) {
            mxn.currentToken = token;
            orig._processTokenInForeignContent.call(this, token);
        },

        _processToken: function (token) {
            mxn.currentToken = token;
            orig._processToken.call(this, token);

            //NOTE: <body> and <html> are never popped from the stack, so we need to updated
            //their end location explicitly.
            var requireExplicitUpdate = token.type === Tokenizer.END_TAG_TOKEN &&
                                        (token.tagName === $.HTML ||
                                         token.tagName === $.BODY && this.openElements.hasInScope($.BODY));

            if (requireExplicitUpdate) {
                for (var i = this.openElements.stackTop; i >= 0; i--) {
                    var element = this.openElements.items[i];

                    if (this.treeAdapter.getTagName(element) === token.tagName) {
                        mxn._setEndLocation(element, token);
                        break;
                    }
                }
            }
        },


        //Doctype
        _setDocumentType: function (token) {
            orig._setDocumentType.call(this, token);

            var documentChildren = this.treeAdapter.getChildNodes(this.document),
                cnLength = documentChildren.length;

            for (var i = 0; i < cnLength; i++) {
                var node = documentChildren[i];

                if (this.treeAdapter.isDocumentTypeNode(node)) {
                    node.__location = token.location;
                    break;
                }
            }
        },


        //Elements
        _attachElementToTree: function (element) {
            //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
            //So we will use token location stored in this methods for the element.
            mxn._setStartLocation(element);
            mxn.lastStartTagToken = null;
            orig._attachElementToTree.call(this, element);
        },

        _appendElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._appendElement.call(this, token, namespaceURI);
        },

        _insertElement: function (token, namespaceURI) {
            mxn.lastStartTagToken = token;
            orig._insertElement.call(this, token, namespaceURI);
        },

        _insertTemplate: function (token) {
            mxn.lastStartTagToken = token;
            orig._insertTemplate.call(this, token);

            var tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);

            tmplContent.__location = null;
        },

        _insertFakeRootElement: function () {
            orig._insertFakeRootElement.call(this);
            this.openElements.current.__location = null;
        },

        //Comments
        _appendCommentNode: function (token, parent) {
            orig._appendCommentNode.call(this, token, parent);

            var children = this.treeAdapter.getChildNodes(parent),
                commentNode = children[children.length - 1];

            commentNode.__location = token.location;
        },

        //Text
        _findFosterParentingLocation: function () {
            //NOTE: store last foster parenting location, so we will be able to find inserted text
            //in case of foster parenting
            mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);

            return mxn.lastFosterParentingLocation;
        },

        _insertCharacters: function (token) {
            orig._insertCharacters.call(this, token);

            var hasFosterParent = this._shouldFosterParentOnInsertion(),
                parent = hasFosterParent && mxn.lastFosterParentingLocation.parent ||
                         this.openElements.currentTmplContent ||
                         this.openElements.current,
                siblings = this.treeAdapter.getChildNodes(parent),
                textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ?
                siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 :
                siblings.length - 1,
                textNode = siblings[textNodeIdx];

            //NOTE: if we have location assigned by another token, then just update end position
            if (textNode.__location)
                textNode.__location.endOffset = token.location.endOffset;

            else
                textNode.__location = token.location;
        }
    };
};



/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 641 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Mixin = __webpack_require__(135),
    inherits = __webpack_require__(53).inherits;

var LocationInfoOpenElementStackMixin = module.exports = function (stack, options) {
    Mixin.call(this, stack);

    this.onItemPop = options.onItemPop;
};

inherits(LocationInfoOpenElementStackMixin, Mixin);

LocationInfoOpenElementStackMixin.prototype._getOverriddenMethods = function (mxn, orig) {
    return {
        pop: function () {
            mxn.onItemPop(this.current);
            orig.pop.call(this);
        },

        popAllUpToHtmlElement: function () {
            for (var i = this.stackTop; i > 0; i--)
                mxn.onItemPop(this.items[i]);

            orig.popAllUpToHtmlElement.call(this);
        },

        remove: function (element) {
            mxn.onItemPop(this.current);
            orig.remove.call(this, element);
        }
    };
};



/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var doctype = __webpack_require__(192),
    DOCUMENT_MODE = __webpack_require__(42).DOCUMENT_MODE;


//Conversion tables for DOM Level1 structure emulation
var nodeTypes = {
    element: 1,
    text: 3,
    cdata: 4,
    comment: 8
};

var nodePropertyShorthands = {
    tagName: 'name',
    childNodes: 'children',
    parentNode: 'parent',
    previousSibling: 'prev',
    nextSibling: 'next',
    nodeValue: 'data'
};

//Node
var Node = function (props) {
    for (var key in props) {
        if (props.hasOwnProperty(key))
            this[key] = props[key];
    }
};

Node.prototype = {
    get firstChild() {
        var children = this.children;

        return children && children[0] || null;
    },

    get lastChild() {
        var children = this.children;

        return children && children[children.length - 1] || null;
    },

    get nodeType() {
        return nodeTypes[this.type] || nodeTypes.element;
    }
};

Object.keys(nodePropertyShorthands).forEach(function (key) {
    var shorthand = nodePropertyShorthands[key];

    Object.defineProperty(Node.prototype, key, {
        get: function () {
            return this[shorthand] || null;
        },
        set: function (val) {
            this[shorthand] = val;
            return val;
        }
    });
});


//Node construction
exports.createDocument = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: [],
        'x-mode': DOCUMENT_MODE.NO_QUIRKS
    });
};

exports.createDocumentFragment = function () {
    return new Node({
        type: 'root',
        name: 'root',
        parent: null,
        prev: null,
        next: null,
        children: []
    });
};

exports.createElement = function (tagName, namespaceURI, attrs) {
    var attribs = Object.create(null),
        attribsNamespace = Object.create(null),
        attribsPrefix = Object.create(null);

    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        attribs[attrName] = attrs[i].value;
        attribsNamespace[attrName] = attrs[i].namespace;
        attribsPrefix[attrName] = attrs[i].prefix;
    }

    return new Node({
        type: tagName === 'script' || tagName === 'style' ? tagName : 'tag',
        name: tagName,
        namespace: namespaceURI,
        attribs: attribs,
        'x-attribsNamespace': attribsNamespace,
        'x-attribsPrefix': attribsPrefix,
        children: [],
        parent: null,
        prev: null,
        next: null
    });
};

exports.createCommentNode = function (data) {
    return new Node({
        type: 'comment',
        data: data,
        parent: null,
        prev: null,
        next: null
    });
};

var createTextNode = function (value) {
    return new Node({
        type: 'text',
        data: value,
        parent: null,
        prev: null,
        next: null
    });
};


//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
    var prev = parentNode.children[parentNode.children.length - 1];

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    parentNode.children.push(newNode);
    newNode.parent = parentNode;
};

var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
    var insertionIdx = parentNode.children.indexOf(referenceNode),
        prev = referenceNode.prev;

    if (prev) {
        prev.next = newNode;
        newNode.prev = prev;
    }

    referenceNode.prev = newNode;
    newNode.next = referenceNode;

    parentNode.children.splice(insertionIdx, 0, newNode);
    newNode.parent = parentNode;
};

exports.setTemplateContent = function (templateElement, contentElement) {
    appendChild(templateElement, contentElement);
};

exports.getTemplateContent = function (templateElement) {
    return templateElement.children[0];
};

exports.setDocumentType = function (document, name, publicId, systemId) {
    var data = doctype.serializeContent(name, publicId, systemId),
        doctypeNode = null;

    for (var i = 0; i < document.children.length; i++) {
        if (document.children[i].type === 'directive' && document.children[i].name === '!doctype') {
            doctypeNode = document.children[i];
            break;
        }
    }

    if (doctypeNode) {
        doctypeNode.data = data;
        doctypeNode['x-name'] = name;
        doctypeNode['x-publicId'] = publicId;
        doctypeNode['x-systemId'] = systemId;
    }

    else {
        appendChild(document, new Node({
            type: 'directive',
            name: '!doctype',
            data: data,
            'x-name': name,
            'x-publicId': publicId,
            'x-systemId': systemId
        }));
    }

};

exports.setDocumentMode = function (document, mode) {
    document['x-mode'] = mode;
};

exports.getDocumentMode = function (document) {
    return document['x-mode'];
};

exports.detachNode = function (node) {
    if (node.parent) {
        var idx = node.parent.children.indexOf(node),
            prev = node.prev,
            next = node.next;

        node.prev = null;
        node.next = null;

        if (prev)
            prev.next = next;

        if (next)
            next.prev = prev;

        node.parent.children.splice(idx, 1);
        node.parent = null;
    }
};

exports.insertText = function (parentNode, text) {
    var lastChild = parentNode.children[parentNode.children.length - 1];

    if (lastChild && lastChild.type === 'text')
        lastChild.data += text;
    else
        appendChild(parentNode, createTextNode(text));
};

exports.insertTextBefore = function (parentNode, text, referenceNode) {
    var prevNode = parentNode.children[parentNode.children.indexOf(referenceNode) - 1];

    if (prevNode && prevNode.type === 'text')
        prevNode.data += text;
    else
        insertBefore(parentNode, createTextNode(text), referenceNode);
};

exports.adoptAttributes = function (recipient, attrs) {
    for (var i = 0; i < attrs.length; i++) {
        var attrName = attrs[i].name;

        if (typeof recipient.attribs[attrName] === 'undefined') {
            recipient.attribs[attrName] = attrs[i].value;
            recipient['x-attribsNamespace'][attrName] = attrs[i].namespace;
            recipient['x-attribsPrefix'][attrName] = attrs[i].prefix;
        }
    }
};


//Tree traversing
exports.getFirstChild = function (node) {
    return node.children[0];
};

exports.getChildNodes = function (node) {
    return node.children;
};

exports.getParentNode = function (node) {
    return node.parent;
};

exports.getAttrList = function (element) {
    var attrList = [];

    for (var name in element.attribs) {
        attrList.push({
            name: name,
            value: element.attribs[name],
            namespace: element['x-attribsNamespace'][name],
            prefix: element['x-attribsPrefix'][name]
        });
    }

    return attrList;
};


//Node data
exports.getTagName = function (element) {
    return element.name;
};

exports.getNamespaceURI = function (element) {
    return element.namespace;
};

exports.getTextNodeContent = function (textNode) {
    return textNode.data;
};

exports.getCommentNodeContent = function (commentNode) {
    return commentNode.data;
};

exports.getDocumentTypeNodeName = function (doctypeNode) {
    return doctypeNode['x-name'];
};

exports.getDocumentTypeNodePublicId = function (doctypeNode) {
    return doctypeNode['x-publicId'];
};

exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
    return doctypeNode['x-systemId'];
};


//Node types
exports.isTextNode = function (node) {
    return node.type === 'text';
};

exports.isCommentNode = function (node) {
    return node.type === 'comment';
};

exports.isDocumentTypeNode = function (node) {
    return node.type === 'directive' && node.name === '!doctype';
};

exports.isElementNode = function (node) {
    return !!node.attribs;
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 645 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 646 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(195).Buffer;
var util = __webpack_require__(648);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 648 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(650);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(103)))

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(196)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(320);

/*<replacement>*/
var util = Object.create(__webpack_require__(104));
util.inherits = __webpack_require__(83);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(197);


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(69);


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(194).Transform


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(194).PassThrough


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ParserStream = __webpack_require__(314),
    inherits = __webpack_require__(53).inherits,
    $ = __webpack_require__(42).TAG_NAMES;

var PlainTextConversionStream = module.exports = function (options) {
    ParserStream.call(this, options);

    // NOTE: see https://html.spec.whatwg.org/#read-text
    this.parser._insertFakeElement($.HTML);
    this.parser._insertFakeElement($.HEAD);
    this.parser.openElements.pop();
    this.parser._insertFakeElement($.BODY);
    this.parser._insertFakeElement($.PRE);
    this.parser.treeAdapter.insertText(this.parser.openElements.current, '\n');
    this.parser.switchToPlaintextParsing();
};

inherits(PlainTextConversionStream, ParserStream);


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ReadableStream = __webpack_require__(136).Readable,
    inherits = __webpack_require__(53).inherits,
    Serializer = __webpack_require__(313);

var SerializerStream = module.exports = function (node, options) {
    ReadableStream.call(this);

    this.serializer = new Serializer(node, options);

    Object.defineProperty(this.serializer, 'html', {
        //NOTE: To make `+=` concat operator work properly we define
        //getter which always returns empty string
        get: function () {
            return '';
        },
        set: this.push.bind(this)
    });
};

inherits(SerializerStream, ReadableStream);

//Readable stream implementation
SerializerStream.prototype._read = function () {
    this.serializer.serialize();
    this.push(null);
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TransformStream = __webpack_require__(136).Transform,
    DevNullStream = __webpack_require__(661),
    inherits = __webpack_require__(53).inherits,
    Tokenizer = __webpack_require__(82),
    LocationInfoTokenizerMixin = __webpack_require__(310),
    ParserFeedbackSimulator = __webpack_require__(662),
    mergeOptions = __webpack_require__(191);

var DEFAULT_OPTIONS = {
    locationInfo: false
};

var SAXParser = module.exports = function (options) {
    TransformStream.call(this);

    this.options = mergeOptions(DEFAULT_OPTIONS, options);

    this.tokenizer = new Tokenizer(options);

    if (this.options.locationInfo)
        new LocationInfoTokenizerMixin(this.tokenizer);

    this.parserFeedbackSimulator = new ParserFeedbackSimulator(this.tokenizer);

    this.pendingText = null;
    this.currentTokenLocation = void 0;

    this.lastChunkWritten = false;
    this.stopped = false;

    // NOTE: always pipe stream to the /dev/null stream to avoid
    // `highWaterMark` hit even if we don't have consumers.
    // (see: https://github.com/inikulin/parse5/issues/97#issuecomment-171940774)
    this.pipe(new DevNullStream());
};

inherits(SAXParser, TransformStream);

//TransformStream implementation
SAXParser.prototype._transform = function (chunk, encoding, callback) {
    if (!this.stopped) {
        this.tokenizer.write(chunk.toString('utf8'), this.lastChunkWritten);
        this._runParsingLoop();
    }

    this.push(chunk);

    callback();
};

SAXParser.prototype._flush = function (callback) {
    callback();
};

SAXParser.prototype.end = function (chunk, encoding, callback) {
    this.lastChunkWritten = true;
    TransformStream.prototype.end.call(this, chunk, encoding, callback);
};

SAXParser.prototype.stop = function () {
    this.stopped = true;
};

//Internals
SAXParser.prototype._runParsingLoop = function () {
    do {
        var token = this.parserFeedbackSimulator.getNextToken();

        if (token.type === Tokenizer.HIBERNATION_TOKEN)
            break;

        if (token.type === Tokenizer.CHARACTER_TOKEN ||
            token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN ||
            token.type === Tokenizer.NULL_CHARACTER_TOKEN) {

            if (this.options.locationInfo) {
                if (this.pendingText === null)
                    this.currentTokenLocation = token.location;

                else
                    this.currentTokenLocation.endOffset = token.location.endOffset;
            }

            this.pendingText = (this.pendingText || '') + token.chars;
        }

        else {
            this._emitPendingText();
            this._handleToken(token);
        }
    } while (!this.stopped && token.type !== Tokenizer.EOF_TOKEN);
};

SAXParser.prototype._handleToken = function (token) {
    if (this.options.locationInfo)
        this.currentTokenLocation = token.location;

    if (token.type === Tokenizer.START_TAG_TOKEN)
        this.emit('startTag', token.tagName, token.attrs, token.selfClosing, this.currentTokenLocation);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        this.emit('endTag', token.tagName, this.currentTokenLocation);

    else if (token.type === Tokenizer.COMMENT_TOKEN)
        this.emit('comment', token.data, this.currentTokenLocation);

    else if (token.type === Tokenizer.DOCTYPE_TOKEN)
        this.emit('doctype', token.name, token.publicId, token.systemId, this.currentTokenLocation);
};

SAXParser.prototype._emitPendingText = function () {
    if (this.pendingText !== null) {
        this.emit('text', this.pendingText, this.currentTokenLocation);
        this.pendingText = null;
    }
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var WritableStream = __webpack_require__(136).Writable,
    util = __webpack_require__(53);

var DevNullStream = module.exports = function () {
    WritableStream.call(this);
};

util.inherits(DevNullStream, WritableStream);

DevNullStream.prototype._write = function (chunk, encoding, cb) {
    cb();
};


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Tokenizer = __webpack_require__(82),
    foreignContent = __webpack_require__(312),
    UNICODE = __webpack_require__(102),
    HTML = __webpack_require__(42);


//Aliases
var $ = HTML.TAG_NAMES,
    NS = HTML.NAMESPACES;


//ParserFeedbackSimulator
//Simulates adjustment of the Tokenizer which performed by standard parser during tree construction.
var ParserFeedbackSimulator = module.exports = function (tokenizer) {
    this.tokenizer = tokenizer;

    this.namespaceStack = [];
    this.namespaceStackTop = -1;
    this._enterNamespace(NS.HTML);
};

ParserFeedbackSimulator.prototype.getNextToken = function () {
    var token = this.tokenizer.getNextToken();

    if (token.type === Tokenizer.START_TAG_TOKEN)
        this._handleStartTagToken(token);

    else if (token.type === Tokenizer.END_TAG_TOKEN)
        this._handleEndTagToken(token);

    else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN && this.inForeignContent) {
        token.type = Tokenizer.CHARACTER_TOKEN;
        token.chars = UNICODE.REPLACEMENT_CHARACTER;
    }

    else if (this.skipNextNewLine) {
        if (token.type !== Tokenizer.HIBERNATION_TOKEN)
            this.skipNextNewLine = false;

        if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
            if (token.chars.length === 1)
                return this.getNextToken();

            token.chars = token.chars.substr(1);
        }
    }

    return token;
};

//Namespace stack mutations
ParserFeedbackSimulator.prototype._enterNamespace = function (namespace) {
    this.namespaceStackTop++;
    this.namespaceStack.push(namespace);

    this.inForeignContent = namespace !== NS.HTML;
    this.currentNamespace = namespace;
    this.tokenizer.allowCDATA = this.inForeignContent;
};

ParserFeedbackSimulator.prototype._leaveCurrentNamespace = function () {
    this.namespaceStackTop--;
    this.namespaceStack.pop();

    this.currentNamespace = this.namespaceStack[this.namespaceStackTop];
    this.inForeignContent = this.currentNamespace !== NS.HTML;
    this.tokenizer.allowCDATA = this.inForeignContent;
};

//Token handlers
ParserFeedbackSimulator.prototype._ensureTokenizerMode = function (tn) {
    if (tn === $.TEXTAREA || tn === $.TITLE)
        this.tokenizer.state = Tokenizer.MODE.RCDATA;

    else if (tn === $.PLAINTEXT)
        this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;

    else if (tn === $.SCRIPT)
        this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;

    else if (tn === $.STYLE || tn === $.IFRAME || tn === $.XMP ||
             tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT)
        this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
};

ParserFeedbackSimulator.prototype._handleStartTagToken = function (token) {
    var tn = token.tagName;

    if (tn === $.SVG)
        this._enterNamespace(NS.SVG);

    else if (tn === $.MATH)
        this._enterNamespace(NS.MATHML);

    if (this.inForeignContent) {
        if (foreignContent.causesExit(token)) {
            this._leaveCurrentNamespace();
            return;
        }

        var currentNs = this.currentNamespace;

        if (currentNs === NS.MATHML)
            foreignContent.adjustTokenMathMLAttrs(token);

        else if (currentNs === NS.SVG) {
            foreignContent.adjustTokenSVGTagName(token);
            foreignContent.adjustTokenSVGAttrs(token);
        }

        foreignContent.adjustTokenXMLAttrs(token);

        tn = token.tagName;

        if (!token.selfClosing && foreignContent.isIntegrationPoint(tn, currentNs, token.attrs))
            this._enterNamespace(NS.HTML);
    }

    else {
        if (tn === $.PRE || tn === $.TEXTAREA || tn === $.LISTING)
            this.skipNextNewLine = true;

        else if (tn === $.IMAGE)
            token.tagName = $.IMG;

        this._ensureTokenizerMode(tn);
    }
};

ParserFeedbackSimulator.prototype._handleEndTagToken = function (token) {
    var tn = token.tagName;

    if (!this.inForeignContent) {
        var previousNs = this.namespaceStack[this.namespaceStackTop - 1];

        if (previousNs === NS.SVG && foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn])
            tn = foreignContent.SVG_TAG_NAMES_ADJUSTMENT_MAP[tn];

        //NOTE: check for exit from integration point
        if (foreignContent.isIntegrationPoint(tn, previousNs, token.attrs))
            this._leaveCurrentNamespace();
    }

    else if (tn === $.SVG && this.currentNamespace === NS.SVG ||
             tn === $.MATH && this.currentNamespace === NS.MATHML)
        this._leaveCurrentNamespace();

    // NOTE: adjust end tag name as well for consistency
    if (this.currentNamespace === NS.SVG)
        foreignContent.adjustTokenSVGTagName(token);
};


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Copied from https://facebook.github.io/react/docs/dom-elements.html
var map = {
  // Specials
  for: 'htmlFor',
  class: 'className',

  // HTML attributes
  accept: 'accept',
  acceptcharset: 'acceptCharset',
  accesskey: 'accessKey',
  action: 'action',
  allowfullscreen: 'allowFullScreen',
  allowtransparency: 'allowTransparency',
  alt: 'alt',
  async: 'async',
  autocomplete: 'autoComplete',
  autofocus: 'autoFocus',
  autoplay: 'autoPlay',
  capture: 'capture',
  cellpadding: 'cellPadding',
  cellspacing: 'cellSpacing',
  challenge: 'challenge',
  charset: 'charSet',
  checked: 'checked',
  cite: 'cite',
  classid: 'classID',
  classname: 'className',
  colspan: 'colSpan',
  cols: 'cols',
  content: 'content',
  contenteditable: 'contentEditable',
  contextmenu: 'contextMenu',
  controls: 'controls',
  coords: 'coords',
  crossorigin: 'crossOrigin',
  data: 'data',
  datetime: 'dateTime',
  default: 'default',
  defer: 'defer',
  dir: 'dir',
  disabled: 'disabled',
  download: 'download',
  draggable: 'draggable',
  enctype: 'encType',
  form: 'form',
  formaction: 'formAction',
  formenctype: 'formEncType',
  formmethod: 'formMethod',
  formnovalidate: 'formNoValidate',
  formtarget: 'formTarget',
  frameborder: 'frameBorder',
  headers: 'headers',
  height: 'height',
  hidden: 'hidden',
  high: 'high',
  href: 'href',
  hreflang: 'hrefLang',
  htmlfor: 'htmlFor',
  httpequiv: 'httpEquiv',
  icon: 'icon',
  id: 'id',
  inputmode: 'inputMode',
  integrity: 'integrity',
  is: 'is',
  keyparams: 'keyParams',
  keytype: 'keyType',
  kind: 'kind',
  label: 'label',
  lang: 'lang',
  list: 'list',
  loop: 'loop',
  low: 'low',
  manifest: 'manifest',
  marginheight: 'marginHeight',
  marginwidth: 'marginWidth',
  max: 'max',
  maxlength: 'maxLength',
  media: 'media',
  mediagroup: 'mediaGroup',
  method: 'method',
  min: 'min',
  minlength: 'minLength',
  multiple: 'multiple',
  muted: 'muted',
  name: 'name',
  novalidate: 'noValidate',
  nonce: 'nonce',
  open: 'open',
  optimum: 'optimum',
  pattern: 'pattern',
  placeholder: 'placeholder',
  poster: 'poster',
  preload: 'preload',
  profile: 'profile',
  radiogroup: 'radioGroup',
  readonly: 'readOnly',
  rel: 'rel',
  required: 'required',
  reversed: 'reversed',
  role: 'role',
  rowspan: 'rowSpan',
  rows: 'rows',
  sandbox: 'sandbox',
  scope: 'scope',
  scoped: 'scoped',
  scrolling: 'scrolling',
  seamless: 'seamless',
  selected: 'selected',
  shape: 'shape',
  size: 'size',
  sizes: 'sizes',
  span: 'span',
  spellcheck: 'spellCheck',
  src: 'src',
  srcdoc: 'srcDoc',
  srclang: 'srcLang',
  srcset: 'srcSet',
  start: 'start',
  step: 'step',
  style: 'style',
  summary: 'summary',
  tabindex: 'tabIndex',
  target: 'target',
  title: 'title',
  type: 'type',
  usemap: 'useMap',
  value: 'value',
  width: 'width',
  wmode: 'wmode',
  wrap: 'wrap',

  // SVG attributes
  accentheight: 'accentHeight',
  accumulate: 'accumulate',
  additive: 'additive',
  alignmentbaseline: 'alignmentBaseline',
  allowreorder: 'allowReorder',
  alphabetic: 'alphabetic',
  amplitude: 'amplitude',
  arabicform: 'arabicForm',
  ascent: 'ascent',
  attributename: 'attributeName',
  attributetype: 'attributeType',
  autoreverse: 'autoReverse',
  azimuth: 'azimuth',
  basefrequency: 'baseFrequency',
  baseprofile: 'baseProfile',
  baselineshift: 'baselineShift',
  bbox: 'bbox',
  begin: 'begin',
  bias: 'bias',
  by: 'by',
  calcmode: 'calcMode',
  capheight: 'capHeight',
  clip: 'clip',
  clippath: 'clipPath',
  clippathunits: 'clipPathUnits',
  cliprule: 'clipRule',
  colorinterpolation: 'colorInterpolation',
  colorinterpolationfilters: 'colorInterpolationFilters',
  colorprofile: 'colorProfile',
  colorrendering: 'colorRendering',
  contentscripttype: 'contentScriptType',
  contentstyletype: 'contentStyleType',
  cursor: 'cursor',
  cx: 'cx',
  cy: 'cy',
  d: 'd',
  decelerate: 'decelerate',
  descent: 'descent',
  diffuseconstant: 'diffuseConstant',
  direction: 'direction',
  display: 'display',
  divisor: 'divisor',
  dominantbaseline: 'dominantBaseline',
  dur: 'dur',
  dx: 'dx',
  dy: 'dy',
  edgemode: 'edgeMode',
  elevation: 'elevation',
  enablebackground: 'enableBackground',
  end: 'end',
  exponent: 'exponent',
  externalresourcesrequired: 'externalResourcesRequired',
  fill: 'fill',
  fillopacity: 'fillOpacity',
  fillrule: 'fillRule',
  filter: 'filter',
  filterres: 'filterRes',
  filterunits: 'filterUnits',
  floodcolor: 'floodColor',
  floodopacity: 'floodOpacity',
  focusable: 'focusable',
  fontfamily: 'fontFamily',
  fontsize: 'fontSize',
  fontsizeadjust: 'fontSizeAdjust',
  fontstretch: 'fontStretch',
  fontstyle: 'fontStyle',
  fontvariant: 'fontVariant',
  fontweight: 'fontWeight',
  format: 'format',
  from: 'from',
  fx: 'fx',
  fy: 'fy',
  g1: 'g1',
  g2: 'g2',
  glyphname: 'glyphName',
  glyphorientationhorizontal: 'glyphOrientationHorizontal',
  glyphorientationvertical: 'glyphOrientationVertical',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  hanging: 'hanging',
  horizadvx: 'horizAdvX',
  horizoriginx: 'horizOriginX',
  ideographic: 'ideographic',
  imagerendering: 'imageRendering',
  in: 'in',
  in2: 'in2',
  intercept: 'intercept',
  k: 'k',
  k1: 'k1',
  k2: 'k2',
  k3: 'k3',
  k4: 'k4',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  kerning: 'kerning',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  letterspacing: 'letterSpacing',
  lightingcolor: 'lightingColor',
  limitingconeangle: 'limitingConeAngle',
  local: 'local',
  markerend: 'markerEnd',
  markerheight: 'markerHeight',
  markermid: 'markerMid',
  markerstart: 'markerStart',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  mask: 'mask',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  mathematical: 'mathematical',
  mode: 'mode',
  numoctaves: 'numOctaves',
  offset: 'offset',
  opacity: 'opacity',
  operator: 'operator',
  order: 'order',
  orient: 'orient',
  orientation: 'orientation',
  origin: 'origin',
  overflow: 'overflow',
  overlineposition: 'overlinePosition',
  overlinethickness: 'overlineThickness',
  paintorder: 'paintOrder',
  panose1: 'panose1',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointerevents: 'pointerEvents',
  points: 'points',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  r: 'r',
  radius: 'radius',
  refx: 'refX',
  refy: 'refY',
  renderingintent: 'renderingIntent',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  restart: 'restart',
  result: 'result',
  rotate: 'rotate',
  rx: 'rx',
  ry: 'ry',
  scale: 'scale',
  seed: 'seed',
  shaperendering: 'shapeRendering',
  slope: 'slope',
  spacing: 'spacing',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  speed: 'speed',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stemh: 'stemh',
  stemv: 'stemv',
  stitchtiles: 'stitchTiles',
  stopcolor: 'stopColor',
  stopopacity: 'stopOpacity',
  strikethroughposition: 'strikethroughPosition',
  strikethroughthickness: 'strikethroughThickness',
  string: 'string',
  stroke: 'stroke',
  strokedasharray: 'strokeDasharray',
  strokedashoffset: 'strokeDashoffset',
  strokelinecap: 'strokeLinecap',
  strokelinejoin: 'strokeLinejoin',
  strokemiterlimit: 'strokeMiterlimit',
  strokeopacity: 'strokeOpacity',
  strokewidth: 'strokeWidth',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textanchor: 'textAnchor',
  textdecoration: 'textDecoration',
  textlength: 'textLength',
  textrendering: 'textRendering',
  to: 'to',
  transform: 'transform',
  u1: 'u1',
  u2: 'u2',
  underlineposition: 'underlinePosition',
  underlinethickness: 'underlineThickness',
  unicode: 'unicode',
  unicodebidi: 'unicodeBidi',
  unicoderange: 'unicodeRange',
  unitsperem: 'unitsPerEm',
  valphabetic: 'vAlphabetic',
  vhanging: 'vHanging',
  videographic: 'vIdeographic',
  vmathematical: 'vMathematical',
  values: 'values',
  vectoreffect: 'vectorEffect',
  version: 'version',
  vertadvy: 'vertAdvY',
  vertoriginx: 'vertOriginX',
  vertoriginy: 'vertOriginY',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  visibility: 'visibility',
  widths: 'widths',
  wordspacing: 'wordSpacing',
  writingmode: 'writingMode',
  x: 'x',
  x1: 'x1',
  x2: 'x2',
  xchannelselector: 'xChannelSelector',
  xheight: 'xHeight',
  xlinkactuate: 'xlinkActuate',
  xlinkarcrole: 'xlinkArcrole',
  xlinkhref: 'xlinkHref',
  xlinkrole: 'xlinkRole',
  xlinkshow: 'xlinkShow',
  xlinktitle: 'xlinkTitle',
  xlinktype: 'xlinkType',
  xmlns: 'xmlns',
  xmlnsxlink: 'xmlnsXlink',
  xmlbase: 'xmlBase',
  xmllang: 'xmlLang',
  xmlspace: 'xmlSpace',
  y: 'y',
  y1: 'y1',
  y2: 'y2',
  ychannelselector: 'yChannelSelector',
  z: 'z',
  zoomandpan: 'zoomAndPan',

  // Events
  onabort: 'onAbort',
  onanimationend: 'onAnimationEnd',
  onanimationiteration: 'onAnimationIteration',
  onanimationstart: 'onAnimationStart',
  onblur: 'onBlur',
  oncanplay: 'onCanPlay',
  oncanplaythrough: 'onCanPlayThrough',
  onchange: 'onChange',
  onclick: 'onClick',
  oncompositionend: 'onCompositionEnd',
  oncompositionstart: 'onCompositionStart',
  oncompositionupdate: 'onCompositionUpdate',
  oncontextmenu: 'onContextMenu',
  oncopy: 'onCopy',
  oncut: 'onCut',
  ondoubleclick: 'onDoubleClick',
  ondrag: 'onDrag',
  ondragend: 'onDragEnd',
  ondragenter: 'onDragEnter',
  ondragexit: 'onDragExit',
  ondragleave: 'onDragLeave',
  ondragover: 'onDragOver',
  ondragstart: 'onDragStart',
  ondrop: 'onDrop',
  ondurationchange: 'onDurationChange',
  onemptied: 'onEmptied',
  onencrypted: 'onEncrypted',
  onended: 'onEnded',
  onerror: 'onError',
  onfocus: 'onFocus',
  oninput: 'onInput',
  onkeydown: 'onKeyDown',
  onkeypress: 'onKeyPress',
  onkeyup: 'onKeyUp',
  onload: 'onLoad',
  onloadeddata: 'onLoadedData',
  onloadedmetadata: 'onLoadedMetadata',
  onloadstart: 'onLoadStart',
  onmousedown: 'onMouseDown',
  onmouseenter: 'onMouseEnter',
  onmouseleave: 'onMouseLeave',
  onmousemove: 'onMouseMove',
  onmouseout: 'onMouseOut',
  onmouseover: 'onMouseOver',
  onmouseup: 'onMouseUp',
  onpaste: 'onPaste',
  onpause: 'onPause',
  onplay: 'onPlay',
  onplaying: 'onPlaying',
  onprogress: 'onProgress',
  onratechange: 'onRateChange',
  onscroll: 'onScroll',
  onseeked: 'onSeeked',
  onseeking: 'onSeeking',
  onselect: 'onSelect',
  onstalled: 'onStalled',
  onsubmit: 'onSubmit',
  onsuspend: 'onSuspend',
  ontimeupdate: 'onTimeUpdate',
  ontouchcancel: 'onTouchCancel',
  ontouchend: 'onTouchEnd',
  ontouchmove: 'onTouchMove',
  ontouchstart: 'onTouchStart',
  ontransitionend: 'onTransitionEnd',
  onvolumechange: 'onVolumeChange',
  onwaiting: 'onWaiting',
  onwheel: 'onWheel'
};

var extraCharRegex = /[-:]/g;

var convert = function (attr) {
  if (/^(data-|aria-)/.test(attr)) {
    return attr;
  }
  var key = attr.replace(extraCharRegex, '').toLowerCase();
  return map[key] || attr;
};

module.exports = convert;
module.exports.convert = convert;


/***/ }),
/* 664 */
/***/ (function(module, exports) {

function hyphenToCamelcase(str) {
  var result = '';
  var upper = false;

  for (var i = 0; i < str.length; i++) {
    var c = str[i];

    if (c === '-') {
      upper = true;
      continue;
    }

    if (upper) {
      c = c.toUpperCase();
      upper = false;
    }

    result += c;
  }

  return result;
}

function convertKey(key) {
  var res = hyphenToCamelcase(key);

  if (key.indexOf('-ms-') === 0) {
    res = res[0].toLowerCase() + res.slice(1);
  }

  return res;
}

module.exports = function (styleStr) {
  return styleStr
    .split(';')
    .reduce(function (res, token) {
      if (token.slice(0, 7) === 'base64,') {
        res[res.length - 1] += ';' + token;
      } else {
        res.push(token);
      }
      return res;
    }, [])
    .reduce(function (obj, str) {
      var tokens = str.split(':');
      var key = tokens[0].trim();
      if (key) {
        var value = tokens.slice(1).join(':').trim();
        obj[convertKey(key)] = value;
      }
      return obj;
    }, {});
};


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.renderElement = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Logger = __webpack_require__(322);

var _Logger2 = _interopRequireDefault(_Logger);

var _NodeParser = __webpack_require__(666);

var _Renderer = __webpack_require__(688);

var _Renderer2 = _interopRequireDefault(_Renderer);

var _ForeignObjectRenderer = __webpack_require__(329);

var _ForeignObjectRenderer2 = _interopRequireDefault(_ForeignObjectRenderer);

var _Feature = __webpack_require__(142);

var _Feature2 = _interopRequireDefault(_Feature);

var _Bounds = __webpack_require__(71);

var _Clone = __webpack_require__(691);

var _Font = __webpack_require__(331);

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderElement = exports.renderElement = function renderElement(element, options, logger) {
    var ownerDocument = element.ownerDocument;

    var windowBounds = new _Bounds.Bounds(options.scrollX, options.scrollY, options.windowWidth, options.windowHeight);

    // http://www.w3.org/TR/css3-background/#special-backgrounds
    var documentBackgroundColor = ownerDocument.documentElement ? new _Color2.default(getComputedStyle(ownerDocument.documentElement).backgroundColor) : _Color.TRANSPARENT;
    var bodyBackgroundColor = ownerDocument.body ? new _Color2.default(getComputedStyle(ownerDocument.body).backgroundColor) : _Color.TRANSPARENT;

    var backgroundColor = element === ownerDocument.documentElement ? documentBackgroundColor.isTransparent() ? bodyBackgroundColor.isTransparent() ? options.backgroundColor ? new _Color2.default(options.backgroundColor) : null : bodyBackgroundColor : documentBackgroundColor : options.backgroundColor ? new _Color2.default(options.backgroundColor) : null;

    return (options.foreignObjectRendering ? // $FlowFixMe
    _Feature2.default.SUPPORT_FOREIGNOBJECT_DRAWING : Promise.resolve(false)).then(function (supportForeignObject) {
        return supportForeignObject ? function (cloner) {
            if (false) {
                logger.log('Document cloned, using foreignObject rendering');
            }

            return cloner.inlineFonts(ownerDocument).then(function () {
                return cloner.resourceLoader.ready();
            }).then(function () {
                var renderer = new _ForeignObjectRenderer2.default(cloner.documentElement);

                var defaultView = ownerDocument.defaultView;
                var scrollX = defaultView.pageXOffset;
                var scrollY = defaultView.pageYOffset;

                var isDocument = element.tagName === 'HTML' || element.tagName === 'BODY';

                var _ref = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(element, scrollX, scrollY),
                    width = _ref.width,
                    height = _ref.height,
                    left = _ref.left,
                    top = _ref.top;

                return renderer.render({
                    backgroundColor: backgroundColor,
                    logger: logger,
                    scale: options.scale,
                    x: typeof options.x === 'number' ? options.x : left,
                    y: typeof options.y === 'number' ? options.y : top,
                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
                    height: typeof options.height === 'number' ? options.height : Math.ceil(height),
                    windowWidth: options.windowWidth,
                    windowHeight: options.windowHeight,
                    scrollX: options.scrollX,
                    scrollY: options.scrollY
                });
            });
        }(new _Clone.DocumentCloner(element, options, logger, true, renderElement)) : (0, _Clone.cloneWindow)(ownerDocument, windowBounds, element, options, logger, renderElement).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 3),
                container = _ref3[0],
                clonedElement = _ref3[1],
                resourceLoader = _ref3[2];

            if (false) {
                logger.log('Document cloned, using computed rendering');
            }

            var stack = (0, _NodeParser.NodeParser)(clonedElement, resourceLoader, logger);
            var clonedDocument = clonedElement.ownerDocument;

            if (backgroundColor === stack.container.style.background.backgroundColor) {
                stack.container.style.background.backgroundColor = _Color.TRANSPARENT;
            }

            return resourceLoader.ready().then(function (imageStore) {
                var fontMetrics = new _Font.FontMetrics(clonedDocument);
                if (false) {
                    logger.log('Starting renderer');
                }

                var defaultView = clonedDocument.defaultView;
                var scrollX = defaultView.pageXOffset;
                var scrollY = defaultView.pageYOffset;

                var isDocument = clonedElement.tagName === 'HTML' || clonedElement.tagName === 'BODY';

                var _ref4 = isDocument ? (0, _Bounds.parseDocumentSize)(ownerDocument) : (0, _Bounds.parseBounds)(clonedElement, scrollX, scrollY),
                    width = _ref4.width,
                    height = _ref4.height,
                    left = _ref4.left,
                    top = _ref4.top;

                var renderOptions = {
                    backgroundColor: backgroundColor,
                    fontMetrics: fontMetrics,
                    imageStore: imageStore,
                    logger: logger,
                    scale: options.scale,
                    x: typeof options.x === 'number' ? options.x : left,
                    y: typeof options.y === 'number' ? options.y : top,
                    width: typeof options.width === 'number' ? options.width : Math.ceil(width),
                    height: typeof options.height === 'number' ? options.height : Math.ceil(height)
                };

                if (Array.isArray(options.target)) {
                    return Promise.all(options.target.map(function (target) {
                        var renderer = new _Renderer2.default(target, renderOptions);
                        return renderer.render(stack);
                    }));
                } else {
                    var renderer = new _Renderer2.default(options.target, renderOptions);
                    var canvas = renderer.render(stack);
                    if (options.removeContainer === true) {
                        if (container.parentNode) {
                            container.parentNode.removeChild(container);
                        } else if (false) {
                            logger.log('Cannot detach cloned iframe as it is not in the DOM anymore');
                        }
                    }

                    return canvas;
                }
            });
        });
    });
};

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NodeParser = undefined;

var _StackingContext = __webpack_require__(667);

var _StackingContext2 = _interopRequireDefault(_StackingContext);

var _NodeContainer = __webpack_require__(84);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _TextContainer = __webpack_require__(141);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _Input = __webpack_require__(327);

var _ListItem = __webpack_require__(201);

var _listStyle = __webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NodeParser = exports.NodeParser = function NodeParser(node, resourceLoader, logger) {
    if (false) {
        logger.log('Starting node parsing');
    }

    var index = 0;

    var container = new _NodeContainer2.default(node, null, resourceLoader, index++);
    var stack = new _StackingContext2.default(container, null, true);

    parseNodeTree(node, container, stack, resourceLoader, index);

    if (false) {
        logger.log('Finished parsing node tree');
    }

    return stack;
};

var IGNORED_NODE_NAMES = ['SCRIPT', 'HEAD', 'TITLE', 'OBJECT', 'BR', 'OPTION'];

var parseNodeTree = function parseNodeTree(node, parent, stack, resourceLoader, index) {
    if (false) {
        throw new Error('Recursion error while parsing node tree');
    }

    for (var childNode = node.firstChild, nextNode; childNode; childNode = nextNode) {
        nextNode = childNode.nextSibling;
        var defaultView = childNode.ownerDocument.defaultView;
        if (childNode instanceof defaultView.Text || childNode instanceof Text || defaultView.parent && childNode instanceof defaultView.parent.Text) {
            if (childNode.data.trim().length > 0) {
                parent.childNodes.push(_TextContainer2.default.fromTextNode(childNode, parent));
            }
        } else if (childNode instanceof defaultView.HTMLElement || childNode instanceof HTMLElement || defaultView.parent && childNode instanceof defaultView.parent.HTMLElement) {
            if (IGNORED_NODE_NAMES.indexOf(childNode.nodeName) === -1) {
                var container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
                if (container.isVisible()) {
                    if (childNode.tagName === 'INPUT') {
                        // $FlowFixMe
                        (0, _Input.inlineInputElement)(childNode, container);
                    } else if (childNode.tagName === 'TEXTAREA') {
                        // $FlowFixMe
                        (0, _Input.inlineTextAreaElement)(childNode, container);
                    } else if (childNode.tagName === 'SELECT') {
                        // $FlowFixMe
                        (0, _Input.inlineSelectElement)(childNode, container);
                    } else if (container.style.listStyle && container.style.listStyle.listStyleType !== _listStyle.LIST_STYLE_TYPE.NONE) {
                        (0, _ListItem.inlineListItemElement)(childNode, container, resourceLoader);
                    }

                    var SHOULD_TRAVERSE_CHILDREN = childNode.tagName !== 'TEXTAREA';
                    var treatAsRealStackingContext = createsRealStackingContext(container, childNode);
                    if (treatAsRealStackingContext || createsStackingContext(container)) {
                        // for treatAsRealStackingContext:false, any positioned descendants and descendants
                        // which actually create a new stacking context should be considered part of the parent stacking context
                        var parentStack = treatAsRealStackingContext || container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                        var childStack = new _StackingContext2.default(container, parentStack, treatAsRealStackingContext);
                        parentStack.contexts.push(childStack);
                        if (SHOULD_TRAVERSE_CHILDREN) {
                            parseNodeTree(childNode, container, childStack, resourceLoader, index);
                        }
                    } else {
                        stack.children.push(container);
                        if (SHOULD_TRAVERSE_CHILDREN) {
                            parseNodeTree(childNode, container, stack, resourceLoader, index);
                        }
                    }
                }
            }
        } else if (childNode instanceof defaultView.SVGSVGElement || childNode instanceof SVGSVGElement || defaultView.parent && childNode instanceof defaultView.parent.SVGSVGElement) {
            var _container = new _NodeContainer2.default(childNode, parent, resourceLoader, index++);
            var _treatAsRealStackingContext = createsRealStackingContext(_container, childNode);
            if (_treatAsRealStackingContext || createsStackingContext(_container)) {
                // for treatAsRealStackingContext:false, any positioned descendants and descendants
                // which actually create a new stacking context should be considered part of the parent stacking context
                var _parentStack = _treatAsRealStackingContext || _container.isPositioned() ? stack.getRealParentStackingContext() : stack;
                var _childStack = new _StackingContext2.default(_container, _parentStack, _treatAsRealStackingContext);
                _parentStack.contexts.push(_childStack);
            } else {
                stack.children.push(_container);
            }
        }
    }
};

var createsRealStackingContext = function createsRealStackingContext(container, node) {
    return container.isRootElement() || container.isPositionedWithZIndex() || container.style.opacity < 1 || container.isTransformed() || isBodyWithTransparentRoot(container, node);
};

var createsStackingContext = function createsStackingContext(container) {
    return container.isPositioned() || container.isFloating();
};

var isBodyWithTransparentRoot = function isBodyWithTransparentRoot(container, node) {
    return node.nodeName === 'BODY' && container.parent instanceof _NodeContainer2.default && container.parent.style.background.backgroundColor.isTransparent();
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NodeContainer = __webpack_require__(84);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _position = __webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StackingContext = function () {
    function StackingContext(container, parent, treatAsRealStackingContext) {
        _classCallCheck(this, StackingContext);

        this.container = container;
        this.parent = parent;
        this.contexts = [];
        this.children = [];
        this.treatAsRealStackingContext = treatAsRealStackingContext;
    }

    _createClass(StackingContext, [{
        key: 'getOpacity',
        value: function getOpacity() {
            return this.parent ? this.container.style.opacity * this.parent.getOpacity() : this.container.style.opacity;
        }
    }, {
        key: 'getRealParentStackingContext',
        value: function getRealParentStackingContext() {
            return !this.parent || this.treatAsRealStackingContext ? this : this.parent.getRealParentStackingContext();
        }
    }]);

    return StackingContext;
}();

exports.default = StackingContext;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Size = function Size(width, height) {
    _classCallCheck(this, Size);

    this.width = width;
    this.height = height;
};

exports.default = Size;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Path = __webpack_require__(138);

var _Vector = __webpack_require__(139);

var _Vector2 = _interopRequireDefault(_Vector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var lerp = function lerp(a, b, t) {
    return new _Vector2.default(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
};

var BezierCurve = function () {
    function BezierCurve(start, startControl, endControl, end) {
        _classCallCheck(this, BezierCurve);

        this.type = _Path.PATH.BEZIER_CURVE;
        this.start = start;
        this.startControl = startControl;
        this.endControl = endControl;
        this.end = end;
    }

    _createClass(BezierCurve, [{
        key: 'subdivide',
        value: function subdivide(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        }
    }, {
        key: 'reverse',
        value: function reverse() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        }
    }]);

    return BezierCurve;
}();

exports.default = BezierCurve;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseBorderRadius = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIDES = ['top-left', 'top-right', 'bottom-right', 'bottom-left'];

var parseBorderRadius = exports.parseBorderRadius = function parseBorderRadius(style) {
    return SIDES.map(function (side) {
        var value = style.getPropertyValue('border-' + side + '-radius');

        var _value$split$map = value.split(' ').map(_Length2.default.create),
            _value$split$map2 = _slicedToArray(_value$split$map, 2),
            horizontal = _value$split$map2[0],
            vertical = _value$split$map2[1];

        return typeof vertical === 'undefined' ? [horizontal, horizontal] : [horizontal, vertical];
    });
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var DISPLAY = exports.DISPLAY = {
    NONE: 1 << 0,
    BLOCK: 1 << 1,
    INLINE: 1 << 2,
    RUN_IN: 1 << 3,
    FLOW: 1 << 4,
    FLOW_ROOT: 1 << 5,
    TABLE: 1 << 6,
    FLEX: 1 << 7,
    GRID: 1 << 8,
    RUBY: 1 << 9,
    SUBGRID: 1 << 10,
    LIST_ITEM: 1 << 11,
    TABLE_ROW_GROUP: 1 << 12,
    TABLE_HEADER_GROUP: 1 << 13,
    TABLE_FOOTER_GROUP: 1 << 14,
    TABLE_ROW: 1 << 15,
    TABLE_CELL: 1 << 16,
    TABLE_COLUMN_GROUP: 1 << 17,
    TABLE_COLUMN: 1 << 18,
    TABLE_CAPTION: 1 << 19,
    RUBY_BASE: 1 << 20,
    RUBY_TEXT: 1 << 21,
    RUBY_BASE_CONTAINER: 1 << 22,
    RUBY_TEXT_CONTAINER: 1 << 23,
    CONTENTS: 1 << 24,
    INLINE_BLOCK: 1 << 25,
    INLINE_LIST_ITEM: 1 << 26,
    INLINE_TABLE: 1 << 27,
    INLINE_FLEX: 1 << 28,
    INLINE_GRID: 1 << 29
};

var parseDisplayValue = function parseDisplayValue(display) {
    switch (display) {
        case 'block':
            return DISPLAY.BLOCK;
        case 'inline':
            return DISPLAY.INLINE;
        case 'run-in':
            return DISPLAY.RUN_IN;
        case 'flow':
            return DISPLAY.FLOW;
        case 'flow-root':
            return DISPLAY.FLOW_ROOT;
        case 'table':
            return DISPLAY.TABLE;
        case 'flex':
            return DISPLAY.FLEX;
        case 'grid':
            return DISPLAY.GRID;
        case 'ruby':
            return DISPLAY.RUBY;
        case 'subgrid':
            return DISPLAY.SUBGRID;
        case 'list-item':
            return DISPLAY.LIST_ITEM;
        case 'table-row-group':
            return DISPLAY.TABLE_ROW_GROUP;
        case 'table-header-group':
            return DISPLAY.TABLE_HEADER_GROUP;
        case 'table-footer-group':
            return DISPLAY.TABLE_FOOTER_GROUP;
        case 'table-row':
            return DISPLAY.TABLE_ROW;
        case 'table-cell':
            return DISPLAY.TABLE_CELL;
        case 'table-column-group':
            return DISPLAY.TABLE_COLUMN_GROUP;
        case 'table-column':
            return DISPLAY.TABLE_COLUMN;
        case 'table-caption':
            return DISPLAY.TABLE_CAPTION;
        case 'ruby-base':
            return DISPLAY.RUBY_BASE;
        case 'ruby-text':
            return DISPLAY.RUBY_TEXT;
        case 'ruby-base-container':
            return DISPLAY.RUBY_BASE_CONTAINER;
        case 'ruby-text-container':
            return DISPLAY.RUBY_TEXT_CONTAINER;
        case 'contents':
            return DISPLAY.CONTENTS;
        case 'inline-block':
            return DISPLAY.INLINE_BLOCK;
        case 'inline-list-item':
            return DISPLAY.INLINE_LIST_ITEM;
        case 'inline-table':
            return DISPLAY.INLINE_TABLE;
        case 'inline-flex':
            return DISPLAY.INLINE_FLEX;
        case 'inline-grid':
            return DISPLAY.INLINE_GRID;
    }

    return DISPLAY.NONE;
};

var setDisplayBit = function setDisplayBit(bit, display) {
    return bit | parseDisplayValue(display);
};

var parseDisplay = exports.parseDisplay = function parseDisplay(display) {
    return display.split(' ').reduce(setDisplayBit, 0);
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FLOAT = exports.FLOAT = {
    NONE: 0,
    LEFT: 1,
    RIGHT: 2,
    INLINE_START: 3,
    INLINE_END: 4
};

var parseCSSFloat = exports.parseCSSFloat = function parseCSSFloat(float) {
    switch (float) {
        case 'left':
            return FLOAT.LEFT;
        case 'right':
            return FLOAT.RIGHT;
        case 'inline-start':
            return FLOAT.INLINE_START;
        case 'inline-end':
            return FLOAT.INLINE_END;
    }
    return FLOAT.NONE;
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var parseFontWeight = function parseFontWeight(weight) {
    switch (weight) {
        case 'normal':
            return 400;
        case 'bold':
            return 700;
    }

    var value = parseInt(weight, 10);
    return isNaN(value) ? 400 : value;
};

var parseFont = exports.parseFont = function parseFont(style) {
    var fontFamily = style.fontFamily;
    var fontSize = style.fontSize;
    var fontStyle = style.fontStyle;
    var fontVariant = style.fontVariant;
    var fontWeight = parseFontWeight(style.fontWeight);

    return {
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight
    };
};

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseLetterSpacing = exports.parseLetterSpacing = function parseLetterSpacing(letterSpacing) {
    if (letterSpacing === 'normal') {
        return 0;
    }
    var value = parseFloat(letterSpacing);
    return isNaN(value) ? 0 : value;
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LINE_BREAK = exports.LINE_BREAK = {
    NORMAL: 'normal',
    STRICT: 'strict'
};

var parseLineBreak = exports.parseLineBreak = function parseLineBreak(wordBreak) {
    switch (wordBreak) {
        case 'strict':
            return LINE_BREAK.STRICT;
        case 'normal':
        default:
            return LINE_BREAK.NORMAL;
    }
};

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseMargin = undefined;

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIDES = ['top', 'right', 'bottom', 'left'];

var parseMargin = exports.parseMargin = function parseMargin(style) {
    return SIDES.map(function (side) {
        return new _Length2.default(style.getPropertyValue('margin-' + side));
    });
};

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OVERFLOW = exports.OVERFLOW = {
    VISIBLE: 0,
    HIDDEN: 1,
    SCROLL: 2,
    AUTO: 3
};

var parseOverflow = exports.parseOverflow = function parseOverflow(overflow) {
    switch (overflow) {
        case 'hidden':
            return OVERFLOW.HIDDEN;
        case 'scroll':
            return OVERFLOW.SCROLL;
        case 'auto':
            return OVERFLOW.AUTO;
        case 'visible':
        default:
            return OVERFLOW.VISIBLE;
    }
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTextShadow = undefined;

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NUMBER = /^([+-]|\d|\.)$/i;

var parseTextShadow = exports.parseTextShadow = function parseTextShadow(textShadow) {
    if (textShadow === 'none' || typeof textShadow !== 'string') {
        return null;
    }

    var currentValue = '';
    var isLength = false;
    var values = [];
    var shadows = [];
    var numParens = 0;
    var color = null;

    var appendValue = function appendValue() {
        if (currentValue.length) {
            if (isLength) {
                values.push(parseFloat(currentValue));
            } else {
                color = new _Color2.default(currentValue);
            }
        }
        isLength = false;
        currentValue = '';
    };

    var appendShadow = function appendShadow() {
        if (values.length && color !== null) {
            shadows.push({
                color: color,
                offsetX: values[0] || 0,
                offsetY: values[1] || 0,
                blur: values[2] || 0
            });
        }
        values.splice(0, values.length);
        color = null;
    };

    for (var i = 0; i < textShadow.length; i++) {
        var c = textShadow[i];
        switch (c) {
            case '(':
                currentValue += c;
                numParens++;
                break;
            case ')':
                currentValue += c;
                numParens--;
                break;
            case ',':
                if (numParens === 0) {
                    appendValue();
                    appendShadow();
                } else {
                    currentValue += c;
                }
                break;
            case ' ':
                if (numParens === 0) {
                    appendValue();
                } else {
                    currentValue += c;
                }
                break;
            default:
                if (currentValue.length === 0 && NUMBER.test(c)) {
                    isLength = true;
                }
                currentValue += c;
        }
    }

    appendValue();
    appendShadow();

    if (shadows.length === 0) {
        return null;
    }

    return shadows;
};

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseTransform = undefined;

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var toFloat = function toFloat(s) {
    return parseFloat(s.trim());
};

var MATRIX = /(matrix|matrix3d)\((.+)\)/;

var parseTransform = exports.parseTransform = function parseTransform(style) {
    var transform = parseTransformMatrix(style.transform || style.webkitTransform || style.mozTransform ||
    // $FlowFixMe
    style.msTransform ||
    // $FlowFixMe
    style.oTransform);
    if (transform === null) {
        return null;
    }

    return {
        transform: transform,
        transformOrigin: parseTransformOrigin(style.transformOrigin || style.webkitTransformOrigin || style.mozTransformOrigin ||
        // $FlowFixMe
        style.msTransformOrigin ||
        // $FlowFixMe
        style.oTransformOrigin)
    };
};

// $FlowFixMe
var parseTransformOrigin = function parseTransformOrigin(origin) {
    if (typeof origin !== 'string') {
        var v = new _Length2.default('0');
        return [v, v];
    }
    var values = origin.split(' ').map(_Length2.default.create);
    return [values[0], values[1]];
};

// $FlowFixMe
var parseTransformMatrix = function parseTransformMatrix(transform) {
    if (transform === 'none' || typeof transform !== 'string') {
        return null;
    }

    var match = transform.match(MATRIX);
    if (match) {
        if (match[1] === 'matrix') {
            var matrix = match[2].split(',').map(toFloat);
            return [matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]];
        } else {
            var matrix3d = match[2].split(',').map(toFloat);
            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
        }
    }
    return null;
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var VISIBILITY = exports.VISIBILITY = {
    VISIBLE: 0,
    HIDDEN: 1,
    COLLAPSE: 2
};

var parseVisibility = exports.parseVisibility = function parseVisibility(visibility) {
    switch (visibility) {
        case 'hidden':
            return VISIBILITY.HIDDEN;
        case 'collapse':
            return VISIBILITY.COLLAPSE;
        case 'visible':
        default:
            return VISIBILITY.VISIBLE;
    }
};

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var WORD_BREAK = exports.WORD_BREAK = {
    NORMAL: 'normal',
    BREAK_ALL: 'break-all',
    KEEP_ALL: 'keep-all'
};

var parseWordBreak = exports.parseWordBreak = function parseWordBreak(wordBreak) {
    switch (wordBreak) {
        case 'break-all':
            return WORD_BREAK.BREAK_ALL;
        case 'keep-all':
            return WORD_BREAK.KEEP_ALL;
        case 'normal':
        default:
            return WORD_BREAK.NORMAL;
    }
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var parseZIndex = exports.parseZIndex = function parseZIndex(zIndex) {
    var auto = zIndex === 'auto';
    return {
        auto: auto,
        order: auto ? 0 : parseInt(zIndex, 10)
    };
};

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Util = __webpack_require__(200);

Object.defineProperty(exports, 'toCodePoints', {
  enumerable: true,
  get: function get() {
    return _Util.toCodePoints;
  }
});
Object.defineProperty(exports, 'fromCodePoint', {
  enumerable: true,
  get: function get() {
    return _Util.fromCodePoint;
  }
});

var _LineBreak = __webpack_require__(684);

Object.defineProperty(exports, 'LineBreaker', {
  enumerable: true,
  get: function get() {
    return _LineBreak.LineBreaker;
  }
});

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LineBreaker = exports.inlineBreakOpportunities = exports.lineBreakAtIndex = exports.codePointsToCharacterClasses = exports.UnicodeTrie = exports.BREAK_ALLOWED = exports.BREAK_NOT_ALLOWED = exports.BREAK_MANDATORY = exports.classes = exports.LETTER_NUMBER_MODIFIER = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _Trie = __webpack_require__(685);

var _linebreakTrie = __webpack_require__(686);

var _linebreakTrie2 = _interopRequireDefault(_linebreakTrie);

var _Util = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LETTER_NUMBER_MODIFIER = exports.LETTER_NUMBER_MODIFIER = 50;

// Non-tailorable Line Breaking Classes
var BK = 1; //  Cause a line break (after)
var CR = 2; //  Cause a line break (after), except between CR and LF
var LF = 3; //  Cause a line break (after)
var CM = 4; //  Prohibit a line break between the character and the preceding character
var NL = 5; //  Cause a line break (after)
var SG = 6; //  Do not occur in well-formed text
var WJ = 7; //  Prohibit line breaks before and after
var ZW = 8; //  Provide a break opportunity
var GL = 9; //  Prohibit line breaks before and after
var SP = 10; // Enable indirect line breaks
var ZWJ = 11; // Prohibit line breaks within joiner sequences
// Break Opportunities
var B2 = 12; //  Provide a line break opportunity before and after the character
var BA = 13; //  Generally provide a line break opportunity after the character
var BB = 14; //  Generally provide a line break opportunity before the character
var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
var CB = 16; //   Provide a line break opportunity contingent on additional information
// Characters Prohibiting Certain Breaks
var CL = 17; //  Prohibit line breaks before
var CP = 18; //  Prohibit line breaks before
var EX = 19; //  Prohibit line breaks before
var IN = 20; //  Allow only indirect line breaks between pairs
var NS = 21; //  Allow only indirect line breaks before
var OP = 22; //  Prohibit line breaks after
var QU = 23; //  Act like they are both opening and closing
// Numeric Context
var IS = 24; //  Prevent breaks after any and before numeric
var NU = 25; //  Form numeric expressions for line breaking purposes
var PO = 26; //  Do not break following a numeric expression
var PR = 27; //  Do not break in front of a numeric expression
var SY = 28; //  Prevent a break before; and allow a break after
// Other Characters
var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
var EB = 32; //  Do not break from following Emoji Modifier
var EM = 33; //  Do not break from preceding Emoji Base
var H2 = 34; //  Form Korean syllable blocks
var H3 = 35; //  Form Korean syllable blocks
var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
var ID = 37; //  Break before or after; except in some numeric context
var JL = 38; //  Form Korean syllable blocks
var JV = 39; //  Form Korean syllable blocks
var JT = 40; //  Form Korean syllable blocks
var RI = 41; //  Keep pairs together. For pairs; break before and after other classes
var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions

var classes = exports.classes = {
    BK: BK,
    CR: CR,
    LF: LF,
    CM: CM,
    NL: NL,
    SG: SG,
    WJ: WJ,
    ZW: ZW,
    GL: GL,
    SP: SP,
    ZWJ: ZWJ,
    B2: B2,
    BA: BA,
    BB: BB,
    HY: HY,
    CB: CB,
    CL: CL,
    CP: CP,
    EX: EX,
    IN: IN,
    NS: NS,
    OP: OP,
    QU: QU,
    IS: IS,
    NU: NU,
    PO: PO,
    PR: PR,
    SY: SY,
    AI: AI,
    AL: AL,
    CJ: CJ,
    EB: EB,
    EM: EM,
    H2: H2,
    H3: H3,
    HL: HL,
    ID: ID,
    JL: JL,
    JV: JV,
    JT: JT,
    RI: RI,
    SA: SA,
    XX: XX
};

var BREAK_MANDATORY = exports.BREAK_MANDATORY = '!';
var BREAK_NOT_ALLOWED = exports.BREAK_NOT_ALLOWED = '×';
var BREAK_ALLOWED = exports.BREAK_ALLOWED = '÷';
var UnicodeTrie = exports.UnicodeTrie = (0, _Trie.createTrieFromBase64)(_linebreakTrie2.default);

var ALPHABETICS = [AL, HL];
var HARD_LINE_BREAKS = [BK, CR, LF, NL];
var SPACE = [SP, ZW];
var PREFIX_POSTFIX = [PR, PO];
var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE);
var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
var HYPHEN = [HY, BA];

var codePointsToCharacterClasses = exports.codePointsToCharacterClasses = function codePointsToCharacterClasses(codePoints) {
    var lineBreak = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'strict';

    var types = [];
    var indicies = [];
    var categories = [];
    codePoints.forEach(function (codePoint, index) {
        var classType = UnicodeTrie.get(codePoint);
        if (classType > LETTER_NUMBER_MODIFIER) {
            categories.push(true);
            classType -= LETTER_NUMBER_MODIFIER;
        } else {
            categories.push(false);
        }

        if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
            // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                indicies.push(index);
                return types.push(CB);
            }
        }

        if (classType === CM || classType === ZWJ) {
            // LB10 Treat any remaining combining mark or ZWJ as AL.
            if (index === 0) {
                indicies.push(index);
                return types.push(AL);
            }

            // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
            // the base character in all of the following rules. Treat ZWJ as if it were CM.
            var prev = types[index - 1];
            if (LINE_BREAKS.indexOf(prev) === -1) {
                indicies.push(indicies[index - 1]);
                return types.push(prev);
            }
            indicies.push(index);
            return types.push(AL);
        }

        indicies.push(index);

        if (classType === CJ) {
            return types.push(lineBreak === 'strict' ? NS : ID);
        }

        if (classType === SA) {
            return types.push(AL);
        }

        if (classType === AI) {
            return types.push(AL);
        }

        // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
        // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
        // to take into account the actual line breaking properties for these characters.
        if (classType === XX) {
            if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) {
                return types.push(ID);
            } else {
                return types.push(AL);
            }
        }

        types.push(classType);
    });

    return [indicies, types, categories];
};

var isAdjacentWithSpaceIgnored = function isAdjacentWithSpaceIgnored(a, b, currentIndex, classTypes) {
    var current = classTypes[currentIndex];
    if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
        var i = currentIndex;
        while (i <= classTypes.length) {
            i++;
            var next = classTypes[i];

            if (next === b) {
                return true;
            }

            if (next !== SP) {
                break;
            }
        }
    }

    if (current === SP) {
        var _i = currentIndex;

        while (_i > 0) {
            _i--;
            var prev = classTypes[_i];

            if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                var n = currentIndex;
                while (n <= classTypes.length) {
                    n++;
                    var _next = classTypes[n];

                    if (_next === b) {
                        return true;
                    }

                    if (_next !== SP) {
                        break;
                    }
                }
            }

            if (prev !== SP) {
                break;
            }
        }
    }
    return false;
};

var previousNonSpaceClassType = function previousNonSpaceClassType(currentIndex, classTypes) {
    var i = currentIndex;
    while (i >= 0) {
        var type = classTypes[i];
        if (type === SP) {
            i--;
        } else {
            return type;
        }
    }
    return 0;
};

var _lineBreakAtIndex = function _lineBreakAtIndex(codePoints, classTypes, indicies, index, forbiddenBreaks) {
    if (indicies[index] === 0) {
        return BREAK_NOT_ALLOWED;
    }

    var currentIndex = index - 1;
    if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
        return BREAK_NOT_ALLOWED;
    }

    var beforeIndex = currentIndex - 1;
    var afterIndex = currentIndex + 1;
    var current = classTypes[currentIndex];

    // LB4 Always break after hard line breaks.
    // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
    var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
    var next = classTypes[afterIndex];

    if (current === CR && next === LF) {
        return BREAK_NOT_ALLOWED;
    }

    if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
        return BREAK_MANDATORY;
    }

    // LB6 Do not break before hard line breaks.
    if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB7 Do not break before spaces or zero width space.
    if (SPACE.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
    if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
        return BREAK_ALLOWED;
    }

    // LB8a Do not break between a zero width joiner and an ideograph, emoji base or emoji modifier.
    if (UnicodeTrie.get(codePoints[currentIndex]) === ZWJ && (next === ID || next === EB || next === EM)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB11 Do not break before or after Word joiner and related characters.
    if (current === WJ || next === WJ) {
        return BREAK_NOT_ALLOWED;
    }

    // LB12 Do not break after NBSP and related characters.
    if (current === GL) {
        return BREAK_NOT_ALLOWED;
    }

    // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
    if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
        return BREAK_NOT_ALLOWED;
    }

    // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
    if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB14 Do not break after ‘[’, even after spaces.
    if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
        return BREAK_NOT_ALLOWED;
    }

    // LB15 Do not break within ‘”[’, even with intervening spaces.
    if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
    if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB17 Do not break within ‘——’, even with intervening spaces.
    if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
        return BREAK_NOT_ALLOWED;
    }

    // LB18 Break after spaces.
    if (current === SP) {
        return BREAK_ALLOWED;
    }

    // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
    if (current === QU || next === QU) {
        return BREAK_NOT_ALLOWED;
    }

    // LB20 Break before and after unresolved CB.
    if (next === CB || current === CB) {
        return BREAK_ALLOWED;
    }

    // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
    if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
        return BREAK_NOT_ALLOWED;
    }

    // LB21a Don't break after Hebrew + Hyphen.
    if (before === HL && HYPHEN.indexOf(current) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB21b Don’t break between Solidus and Hebrew letters.
    if (current === SY && next === HL) {
        return BREAK_NOT_ALLOWED;
    }

    // LB22 Do not break between two ellipses, or between letters, numbers or exclamations and ellipsis.
    if (next === IN && ALPHABETICS.concat(IN, EX, NU, ID, EB, EM).indexOf(current) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB23 Do not break between digits and letters.
    if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) {
        return BREAK_NOT_ALLOWED;
    }

    // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
    if (current === PR && [ID, EB, EM].indexOf(next) !== -1 || [ID, EB, EM].indexOf(current) !== -1 && next === PO) {
        return BREAK_NOT_ALLOWED;
    }

    // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
    if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB25 Do not break between the following pairs of classes relevant to numbers:
    if (
    // (PR | PO) × ( OP | HY )? NU
    [PR, PO].indexOf(current) !== -1 && (next === NU || [OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) ||
    // ( OP | HY ) × NU
    [OP, HY].indexOf(current) !== -1 && next === NU ||
    // NU ×	(NU | SY | IS)
    current === NU && [NU, SY, IS].indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
    if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
        var prevIndex = currentIndex;
        while (prevIndex >= 0) {
            var type = classTypes[prevIndex];
            if (type === NU) {
                return BREAK_NOT_ALLOWED;
            } else if ([SY, IS].indexOf(type) !== -1) {
                prevIndex--;
            } else {
                break;
            }
        }
    }

    // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
    if ([PR, PO].indexOf(next) !== -1) {
        var _prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
        while (_prevIndex >= 0) {
            var _type = classTypes[_prevIndex];
            if (_type === NU) {
                return BREAK_NOT_ALLOWED;
            } else if ([SY, IS].indexOf(_type) !== -1) {
                _prevIndex--;
            } else {
                break;
            }
        }
    }

    // LB26 Do not break a Korean syllable.
    if (JL === current && [JL, JV, H2, H3].indexOf(next) !== -1 || [JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1 || [JT, H3].indexOf(current) !== -1 && next === JT) {
        return BREAK_NOT_ALLOWED;
    }

    // LB27 Treat a Korean Syllable Block the same as ID.
    if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) {
        return BREAK_NOT_ALLOWED;
    }

    // LB28 Do not break between alphabetics (“at”).
    if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
    if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
        return BREAK_NOT_ALLOWED;
    }

    // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
    if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) {
        return BREAK_NOT_ALLOWED;
    }

    // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
    // indicators preceding the position of the break.
    if (current === RI && next === RI) {
        var i = indicies[currentIndex];
        var count = 1;
        while (i > 0) {
            i--;
            if (classTypes[i] === RI) {
                count++;
            } else {
                break;
            }
        }
        if (count % 2 !== 0) {
            return BREAK_NOT_ALLOWED;
        }
    }

    // LB30b Do not break between an emoji base and an emoji modifier.
    if (current === EB && next === EM) {
        return BREAK_NOT_ALLOWED;
    }

    return BREAK_ALLOWED;
};

var lineBreakAtIndex = exports.lineBreakAtIndex = function lineBreakAtIndex(codePoints, index) {
    // LB2 Never break at the start of text.
    if (index === 0) {
        return BREAK_NOT_ALLOWED;
    }

    // LB3 Always break at the end of text.
    if (index >= codePoints.length) {
        return BREAK_MANDATORY;
    }

    var _codePointsToCharacte = codePointsToCharacterClasses(codePoints),
        _codePointsToCharacte2 = _slicedToArray(_codePointsToCharacte, 2),
        indicies = _codePointsToCharacte2[0],
        classTypes = _codePointsToCharacte2[1];

    return _lineBreakAtIndex(codePoints, classTypes, indicies, index);
};

var cssFormattedClasses = function cssFormattedClasses(codePoints, options) {
    if (!options) {
        options = { lineBreak: 'normal', wordBreak: 'normal' };
    }

    var _codePointsToCharacte3 = codePointsToCharacterClasses(codePoints, options.lineBreak),
        _codePointsToCharacte4 = _slicedToArray(_codePointsToCharacte3, 3),
        indicies = _codePointsToCharacte4[0],
        classTypes = _codePointsToCharacte4[1],
        isLetterNumber = _codePointsToCharacte4[2];

    if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
        classTypes = classTypes.map(function (type) {
            return [NU, AL, SA].indexOf(type) !== -1 ? ID : type;
        });
    }

    var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function (isLetterNumber, i) {
        return isLetterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
    }) : null;

    return [indicies, classTypes, forbiddenBreakpoints];
};

var inlineBreakOpportunities = exports.inlineBreakOpportunities = function inlineBreakOpportunities(str, options) {
    var codePoints = (0, _Util.toCodePoints)(str);
    var output = BREAK_NOT_ALLOWED;

    var _cssFormattedClasses = cssFormattedClasses(codePoints, options),
        _cssFormattedClasses2 = _slicedToArray(_cssFormattedClasses, 3),
        indicies = _cssFormattedClasses2[0],
        classTypes = _cssFormattedClasses2[1],
        forbiddenBreakpoints = _cssFormattedClasses2[2];

    codePoints.forEach(function (codePoint, i) {
        output += (0, _Util.fromCodePoint)(codePoint) + (i >= codePoints.length - 1 ? BREAK_MANDATORY : _lineBreakAtIndex(codePoints, classTypes, indicies, i + 1, forbiddenBreakpoints));
    });

    return output;
};

var Break = function () {
    function Break(codePoints, lineBreak, start, end) {
        _classCallCheck(this, Break);

        this._codePoints = codePoints;
        this.required = lineBreak === BREAK_MANDATORY;
        this.start = start;
        this.end = end;
    }

    _createClass(Break, [{
        key: 'slice',
        value: function slice() {
            return _Util.fromCodePoint.apply(undefined, _toConsumableArray(this._codePoints.slice(this.start, this.end)));
        }
    }]);

    return Break;
}();

var LineBreaker = exports.LineBreaker = function LineBreaker(str, options) {
    var codePoints = (0, _Util.toCodePoints)(str);

    var _cssFormattedClasses3 = cssFormattedClasses(codePoints, options),
        _cssFormattedClasses4 = _slicedToArray(_cssFormattedClasses3, 3),
        indicies = _cssFormattedClasses4[0],
        classTypes = _cssFormattedClasses4[1],
        forbiddenBreakpoints = _cssFormattedClasses4[2];

    var length = codePoints.length;
    var lastEnd = 0;
    var nextIndex = 0;

    return {
        next: function next() {
            if (nextIndex >= length) {
                return { done: true };
            }
            var lineBreak = BREAK_NOT_ALLOWED;
            while (nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED) {}

            if (lineBreak !== BREAK_NOT_ALLOWED || nextIndex === length) {
                var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                lastEnd = nextIndex;
                return { value: value, done: false };
            }

            return { done: true };
        }
    };
};

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Trie = exports.createTrieFromBase64 = exports.UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_DATA_MASK = exports.UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_SHIFT_1_2 = exports.UTRIE2_INDEX_SHIFT = exports.UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_2 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Util = __webpack_require__(200);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/** Shift size for getting the index-2 table offset. */
var UTRIE2_SHIFT_2 = exports.UTRIE2_SHIFT_2 = 5;

/** Shift size for getting the index-1 table offset. */
var UTRIE2_SHIFT_1 = exports.UTRIE2_SHIFT_1 = 6 + 5;

/**
 * Shift size for shifting left the index array values.
 * Increases possible data size with 16-bit index values at the cost
 * of compactability.
 * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
 */
var UTRIE2_INDEX_SHIFT = exports.UTRIE2_INDEX_SHIFT = 2;

/**
 * Difference between the two shift sizes,
 * for getting an index-1 offset from an index-2 offset. 6=11-5
 */
var UTRIE2_SHIFT_1_2 = exports.UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;

/**
 * The part of the index-2 table for U+D800..U+DBFF stores values for
 * lead surrogate code _units_ not code _points_.
 * Values for lead surrogate code _points_ are indexed with this portion of the table.
 * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
 */
var UTRIE2_LSCP_INDEX_2_OFFSET = exports.UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;

/** Number of entries in a data block. 32=0x20 */
var UTRIE2_DATA_BLOCK_LENGTH = exports.UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
/** Mask for getting the lower bits for the in-data-block offset. */
var UTRIE2_DATA_MASK = exports.UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;

var UTRIE2_LSCP_INDEX_2_LENGTH = exports.UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
/** Count the lengths of both BMP pieces. 2080=0x820 */
var UTRIE2_INDEX_2_BMP_LENGTH = exports.UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
/**
 * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
 * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
 */
var UTRIE2_UTF8_2B_INDEX_2_OFFSET = exports.UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
var UTRIE2_UTF8_2B_INDEX_2_LENGTH = exports.UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
/**
 * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
 * Variable length, for code points up to highStart, where the last single-value range starts.
 * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
 * (For 0x100000 supplementary code points U+10000..U+10ffff.)
 *
 * The part of the index-2 table for supplementary code points starts
 * after this index-1 table.
 *
 * Both the index-1 table and the following part of the index-2 table
 * are omitted completely if there is only BMP data.
 */
var UTRIE2_INDEX_1_OFFSET = exports.UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;

/**
 * Number of index-1 entries for the BMP. 32=0x20
 * This part of the index-1 table is omitted from the serialized form.
 */
var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = exports.UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;

/** Number of entries in an index-2 block. 64=0x40 */
var UTRIE2_INDEX_2_BLOCK_LENGTH = exports.UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
/** Mask for getting the lower bits for the in-index-2-block offset. */
var UTRIE2_INDEX_2_MASK = exports.UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;

var createTrieFromBase64 = exports.createTrieFromBase64 = function createTrieFromBase64(base64) {
    var buffer = (0, _Util.decode)(base64);
    var view32 = Array.isArray(buffer) ? (0, _Util.polyUint32Array)(buffer) : new Uint32Array(buffer);
    var view16 = Array.isArray(buffer) ? (0, _Util.polyUint16Array)(buffer) : new Uint16Array(buffer);
    var headerLength = 24;

    var index = view16.slice(headerLength / 2, view32[4] / 2);
    var data = view32[5] === 2 ? view16.slice((headerLength + view32[4]) / 2) : view32.slice(Math.ceil((headerLength + view32[4]) / 4));

    return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
};

var Trie = exports.Trie = function () {
    function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
        _classCallCheck(this, Trie);

        this.initialValue = initialValue;
        this.errorValue = errorValue;
        this.highStart = highStart;
        this.highValueIndex = highValueIndex;
        this.index = index;
        this.data = data;
    }

    /**
     * Get the value for a code point as stored in the Trie.
     *
     * @param codePoint the code point
     * @return the value
     */


    _createClass(Trie, [{
        key: 'get',
        value: function get(codePoint) {
            var ix = void 0;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }

                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }

                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }

            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        }
    }]);

    return Trie;
}();

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 'KwAAAAAAAAAACA4AIDoAAPAfAAACAAAAAAAIABAAGABAAEgAUABYAF4AZgBeAGYAYABoAHAAeABeAGYAfACEAIAAiACQAJgAoACoAK0AtQC9AMUAXgBmAF4AZgBeAGYAzQDVAF4AZgDRANkA3gDmAOwA9AD8AAQBDAEUARoBIgGAAIgAJwEvATcBPwFFAU0BTAFUAVwBZAFsAXMBewGDATAAiwGTAZsBogGkAawBtAG8AcIBygHSAdoB4AHoAfAB+AH+AQYCDgIWAv4BHgImAi4CNgI+AkUCTQJTAlsCYwJrAnECeQKBAk0CiQKRApkCoQKoArACuALAAsQCzAIwANQC3ALkAjAA7AL0AvwCAQMJAxADGAMwACADJgMuAzYDPgOAAEYDSgNSA1IDUgNaA1oDYANiA2IDgACAAGoDgAByA3YDfgOAAIQDgACKA5IDmgOAAIAAogOqA4AAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAK8DtwOAAIAAvwPHA88D1wPfAyAD5wPsA/QD/AOAAIAABAQMBBIEgAAWBB4EJgQuBDMEIAM7BEEEXgBJBCADUQRZBGEEaQQwADAAcQQ+AXkEgQSJBJEEgACYBIAAoASoBK8EtwQwAL8ExQSAAIAAgACAAIAAgACgAM0EXgBeAF4AXgBeAF4AXgBeANUEXgDZBOEEXgDpBPEE+QQBBQkFEQUZBSEFKQUxBTUFPQVFBUwFVAVcBV4AYwVeAGsFcwV7BYMFiwWSBV4AmgWgBacFXgBeAF4AXgBeAKsFXgCyBbEFugW7BcIFwgXIBcIFwgXQBdQF3AXkBesF8wX7BQMGCwYTBhsGIwYrBjMGOwZeAD8GRwZNBl4AVAZbBl4AXgBeAF4AXgBeAF4AXgBeAF4AXgBeAGMGXgBqBnEGXgBeAF4AXgBeAF4AXgBeAF4AXgB5BoAG4wSGBo4GkwaAAIADHgR5AF4AXgBeAJsGgABGA4AAowarBrMGswagALsGwwbLBjAA0wbaBtoG3QbaBtoG2gbaBtoG2gblBusG8wb7BgMHCwcTBxsHCwcjBysHMAc1BzUHOgdCB9oGSgdSB1oHYAfaBloHaAfaBlIH2gbaBtoG2gbaBtoG2gbaBjUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHbQdeAF4ANQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQd1B30HNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B4MH2gaKB68EgACAAIAAgACAAIAAgACAAI8HlwdeAJ8HpweAAIAArwe3B14AXgC/B8UHygcwANAH2AfgB4AA6AfwBz4B+AcACFwBCAgPCBcIogEYAR8IJwiAAC8INwg/CCADRwhPCFcIXwhnCEoDGgSAAIAAgABvCHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIfQh3CHgIeQh6CHsIfAh9CHcIeAh5CHoIewh8CH0Idwh4CHkIegh7CHwIhAiLCI4IMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlggwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAANQc1BzUHNQc1BzUHNQc1BzUHNQc1B54INQc1B6II2gaqCLIIugiAAIAAvgjGCIAAgACAAIAAgACAAIAAgACAAIAAywiHAYAA0wiAANkI3QjlCO0I9Aj8CIAAgACAAAIJCgkSCRoJIgknCTYHLwk3CZYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiWCJYIlgiAAIAAAAFAAXgBeAGAAcABeAHwAQACQAKAArQC9AJ4AXgBeAE0A3gBRAN4A7AD8AMwBGgEAAKcBNwEFAUwBXAF4QkhCmEKnArcCgAHHAsABz4LAAcABwAHAAd+C6ABoAG+C/4LAAcABwAHAAc+DF4MAAcAB54M3gweDV4Nng3eDaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAGgAaABoAEeDqABVg6WDqABoQ6gAaABoAHXDvcONw/3DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DvcO9w73DncPAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcAB7cPPwlGCU4JMACAAIAAgABWCV4JYQmAAGkJcAl4CXwJgAkwADAAMAAwAIgJgACLCZMJgACZCZ8JowmrCYAAswkwAF4AXgB8AIAAuwkABMMJyQmAAM4JgADVCTAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAqwYWBNkIMAAwADAAMADdCeAJ6AnuCR4E9gkwAP4JBQoNCjAAMACAABUK0wiAAB0KJAosCjQKgAAwADwKQwqAAEsKvQmdCVMKWwowADAAgACAALcEMACAAGMKgABrCjAAMAAwADAAMAAwADAAMAAwADAAMAAeBDAAMAAwADAAMAAwADAAMAAwADAAMAAwAIkEPQFzCnoKiQSCCooKkAqJBJgKoAqkCokEGAGsCrQKvArBCjAAMADJCtEKFQHZCuEK/gHpCvEKMAAwADAAMACAAIwE+QowAIAAPwEBCzAAMAAwADAAMACAAAkLEQswAIAAPwEZCyELgAAOCCkLMAAxCzkLMAAwADAAMAAwADAAXgBeAEELMAAwADAAMAAwADAAMAAwAEkLTQtVC4AAXAtkC4AAiQkwADAAMAAwADAAMAAwADAAbAtxC3kLgAuFC4sLMAAwAJMLlwufCzAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAApwswADAAMACAAIAAgACvC4AAgACAAIAAgACAALcLMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAvwuAAMcLgACAAIAAgACAAIAAyguAAIAAgACAAIAA0QswADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAANkLgACAAIAA4AswADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACJCR4E6AswADAAhwHwC4AA+AsADAgMEAwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMACAAIAAGAwdDCUMMAAwAC0MNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQw1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHPQwwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADUHNQc1BzUHNQc1BzUHNQc2BzAAMAA5DDUHNQc1BzUHNQc1BzUHNQc1BzUHNQdFDDAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAgACAAIAATQxSDFoMMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAF4AXgBeAF4AXgBeAF4AYgxeAGoMXgBxDHkMfwxeAIUMXgBeAI0MMAAwADAAMAAwAF4AXgCVDJ0MMAAwADAAMABeAF4ApQxeAKsMswy7DF4Awgy9DMoMXgBeAF4AXgBeAF4AXgBeAF4AXgDRDNkMeQBqCeAM3Ax8AOYM7Az0DPgMXgBeAF4AXgBeAF4AXgBeAF4AXgBeAF4AXgBeAF4AXgCgAAANoAAHDQ4NFg0wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAeDSYNMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAIAAgACAAIAAgACAAC4NMABeAF4ANg0wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwAD4NRg1ODVYNXg1mDTAAbQ0wADAAMAAwADAAMAAwADAA2gbaBtoG2gbaBtoG2gbaBnUNeg3CBYANwgWFDdoGjA3aBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gaUDZwNpA2oDdoG2gawDbcNvw3HDdoG2gbPDdYN3A3fDeYN2gbsDfMN2gbaBvoN/g3aBgYODg7aBl4AXgBeABYOXgBeACUG2gYeDl4AJA5eACwO2w3aBtoGMQ45DtoG2gbaBtoGQQ7aBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gZJDjUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B1EO2gY1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQdZDjUHNQc1BzUHNQc1B2EONQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHaA41BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B3AO2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gY1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1BzUHNQc1B2EO2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gZJDtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBtoG2gbaBkkOeA6gAKAAoAAwADAAMAAwAKAAoACgAKAAoACgAKAAgA4wADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAD//wQABAAEAAQABAAEAAQABAAEAA0AAwABAAEAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAKABMAFwAeABsAGgAeABcAFgASAB4AGwAYAA8AGAAcAEsASwBLAEsASwBLAEsASwBLAEsAGAAYAB4AHgAeABMAHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAFgAbABIAHgAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYADQARAB4ABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkAFgAaABsAGwAbAB4AHQAdAB4ATwAXAB4ADQAeAB4AGgAbAE8ATwAOAFAAHQAdAB0ATwBPABcATwBPAE8AFgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAFAATwBAAE8ATwBPAEAATwBQAFAATwBQAB4AHgAeAB4AHgAeAB0AHQAdAB0AHgAdAB4ADgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgBQAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAJAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAkACQAJAAkACQAJAAkABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgAeAFAAHgAeAB4AKwArAFAAUABQAFAAGABQACsAKwArACsAHgAeAFAAHgBQAFAAUAArAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAAQABAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUAAeAB4AHgAeAB4AHgArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwAYAA0AKwArAB4AHgAbACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQADQAEAB4ABAAEAB4ABAAEABMABAArACsAKwArACsAKwArACsAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAKwArACsAKwArAFYAVgBWAB4AHgArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AGgAaABoAGAAYAB4AHgAEAAQABAAEAAQABAAEAAQABAAEAAQAEwAEACsAEwATAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABLAEsASwBLAEsASwBLAEsASwBLABoAGQAZAB4AUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABMAUAAEAAQABAAEAAQABAAEAB4AHgAEAAQABAAEAAQABABQAFAABAAEAB4ABAAEAAQABABQAFAASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUAAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAFAABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQAUABQAB4AHgAYABMAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAFAABAAEAAQABAAEAFAABAAEAAQAUAAEAAQABAAEAAQAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAArACsAHgArAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAAQABAANAA0ASwBLAEsASwBLAEsASwBLAEsASwAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAKwArACsAUABQAFAAUAArACsABABQAAQABAAEAAQABAAEAAQAKwArAAQABAArACsABAAEAAQAUAArACsAKwArACsAKwArACsABAArACsAKwArAFAAUAArAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAGgAaAFAAUABQAFAAUABMAB4AGwBQAB4AKwArACsABAAEAAQAKwBQAFAAUABQAFAAUAArACsAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUAArAFAAUAArACsABAArAAQABAAEAAQABAArACsAKwArAAQABAArACsABAAEAAQAKwArACsABAArACsAKwArACsAKwArAFAAUABQAFAAKwBQACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwAEAAQAUABQAFAABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUAArAFAAUABQAFAAUAArACsABABQAAQABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQAKwArAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwAeABsAKwArACsAKwArACsAKwBQAAQABAAEAAQABAAEACsABAAEAAQAKwBQAFAAUABQAFAAUABQAFAAKwArAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwArAAQABAArACsABAAEAAQAKwArACsAKwArACsAKwArAAQABAArACsAKwArAFAAUAArAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwAeAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwAEAFAAKwBQAFAAUABQAFAAUAArACsAKwBQAFAAUAArAFAAUABQAFAAKwArACsAUABQACsAUAArAFAAUAArACsAKwBQAFAAKwArACsAUABQAFAAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwAEAAQABAAEAAQAKwArACsABAAEAAQAKwAEAAQABAAEACsAKwBQACsAKwArACsAKwArAAQAKwArACsAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAB4AHgAeAB4AHgAeABsAHgArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABAArACsAKwArACsAKwArAAQABAArAFAAUABQACsAKwArACsAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAB4AUAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQACsAKwAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABAArACsAKwArACsAKwArAAQABAArACsAKwArACsAKwArAFAAKwBQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAFAABAAEAAQABAAEAAQABAArAAQABAAEACsABAAEAAQABABQAB4AKwArACsAKwBQAFAAUAAEAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwBLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQABoAUABQAFAAUABQAFAAKwArAAQABAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQACsAUAArACsAUABQAFAAUABQAFAAUAArACsAKwAEACsAKwArACsABAAEAAQABAAEAAQAKwAEACsABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgAqACsAKwArACsAGwBcAFwAXABcAFwAXABcACoAKgAqACoAKgAqACoAKgAeAEsASwBLAEsASwBLAEsASwBLAEsADQANACsAKwArACsAKwBcAFwAKwBcACsAKwBcAFwAKwBcACsAKwBcACsAKwArACsAKwArAFwAXABcAFwAKwBcAFwAXABcAFwAXABcACsAXABcAFwAKwBcACsAXAArACsAXABcACsAXABcAFwAXAAqAFwAXAAqACoAKgAqACoAKgArACoAKgBcACsAKwBcAFwAXABcAFwAKwBcACsAKgAqACoAKgAqACoAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArAFwAXABcAFwAUAAOAA4ADgAOAB4ADgAOAAkADgAOAA0ACQATABMAEwATABMACQAeABMAHgAeAB4ABAAEAB4AHgAeAB4AHgAeAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAFAAUAANAAQAHgAEAB4ABAAWABEAFgARAAQABABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAAQABAAEAAQABAANAAQABABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsADQANAB4AHgAeAB4AHgAeAAQAHgAeAB4AHgAeAB4AKwAeAB4ADgAOAA0ADgAeAB4AHgAeAB4ACQAJACsAKwArACsAKwBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqAFwASwBLAEsASwBLAEsASwBLAEsASwANAA0AHgAeAB4AHgBcAFwAXABcAFwAXAAqACoAKgAqAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAKgAqACoAKgAqACoAKgBcAFwAXAAqACoAKgAqAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgAqACoAXAAqAEsASwBLAEsASwBLAEsASwBLAEsAKgAqACoAKgAqACoAUABQAFAAUABQAFAAKwBQACsAKwArACsAKwBQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQACsAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwAEAAQABAAeAA0AHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQABYAEQArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAADQANAA0AUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAA0ADQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQACsABAAEACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoADQANABUAXAANAB4ADQAbAFwAKgArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAB4AHgATABMADQANAA4AHgATABMAHgAEAAQABAAJACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAUABQAFAAUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwAeACsAKwArABMAEwBLAEsASwBLAEsASwBLAEsASwBLAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwBcAFwAXABcAFwAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcACsAKwArACsAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBcACsAKwArACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEACsAKwAeAB4AXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAKgAqACoAKgAqACoAKgArACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgArACsABABLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKgAqACoAKgAqACoAKgBcACoAKgAqACoAKgAqACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAUABQAFAAUABQAFAAUAArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsADQANAB4ADQANAA0ADQAeAB4AHgAeAB4AHgAeAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArAAQABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAEsASwBLAEsASwBLAEsASwBLAEsAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAHgAeAB4AHgBQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwANAA0ADQANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwBQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAANAA0AUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsABAAEAAQAHgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAFAAUABQAFAABABQAFAAUABQAAQABAAEAFAAUAAEAAQABAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAKwBQACsAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAFAAHgAeAB4AUABQAFAAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAKwArAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAKwAeAB4AHgAeAB4AHgAeAA4AHgArAA0ADQANAA0ADQANAA0ACQANAA0ADQAIAAQACwAEAAQADQAJAA0ADQAMAB0AHQAeABcAFwAWABcAFwAXABYAFwAdAB0AHgAeABQAFAAUAA0AAQABAAQABAAEAAQABAAJABoAGgAaABoAGgAaABoAGgAeABcAFwAdABUAFQAeAB4AHgAeAB4AHgAYABYAEQAVABUAFQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgANAB4ADQANAA0ADQAeAA0ADQANAAcAHgAeAB4AHgArAAQABAAEAAQABAAEAAQABAAEAAQAUABQACsAKwBPAFAAUABQAFAAUAAeAB4AHgAWABEATwBQAE8ATwBPAE8AUABQAFAAUABQAB4AHgAeABYAEQArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAGwAbABsAGwAbABsAGwAaABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAaABsAGwAbABsAGgAbABsAGgAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsAGwAbABsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgBQABoAHgAdAB4AUAAeABoAHgAeAB4AHgAeAB4AHgAeAB4ATwAeAFAAGwAeAB4AUABQAFAAUABQAB4AHgAeAB0AHQAeAFAAHgBQAB4AUAAeAFAATwBQAFAAHgAeAB4AHgAeAB4AHgBQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AUABQAFAAUABPAE8AUABQAFAAUABQAE8AUABQAE8AUABPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBQAFAAUABQAE8ATwBPAE8ATwBPAE8ATwBPAE8AUABQAFAAUABQAFAAUABQAFAAHgAeAFAAUABQAFAATwAeAB4AKwArACsAKwAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB0AHQAeAB4AHgAdAB0AHgAeAB0AHgAeAB4AHQAeAB0AGwAbAB4AHQAeAB4AHgAeAB0AHgAeAB0AHQAdAB0AHgAeAB0AHgAdAB4AHQAdAB0AHQAdAB0AHgAdAB4AHgAeAB4AHgAdAB0AHQAdAB4AHgAeAB4AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAeAB4AHgAdAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHgAdAB0AHQAdAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHQAeAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAFgARAB4AHgAeAB4AHgAeAB0AHgAeAB4AHgAeAB4AHgAlACUAHgAeAB4AHgAeAB4AHgAeAB4AFgARAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBQAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeAB0AHQAdAB0AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAdAB0AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAdAB0AHgAeAB0AHQAeAB4AHgAeAB0AHQAeAB4AHgAeAB0AHQAdAB4AHgAdAB4AHgAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAeAB0AHQAeAB4AHQAeAB4AHgAeAB0AHQAeAB4AHgAeACUAJQAdAB0AJQAeACUAJQAlACAAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAHgAeAB4AHgAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB4AHQAdAB0AHgAdACUAHQAdAB4AHQAdAB4AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB0AHQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAHQAdAB0AHQAlAB4AJQAlACUAHQAlACUAHQAdAB0AJQAlAB0AHQAlAB0AHQAlACUAJQAeAB0AHgAeAB4AHgAdAB0AJQAdAB0AHQAdAB0AHQAlACUAJQAlACUAHQAlACUAIAAlAB0AHQAlACUAJQAlACUAJQAlACUAHgAeAB4AJQAlACAAIAAgACAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAdAB4AHgAeABcAFwAXABcAFwAXAB4AEwATACUAHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAWABEAFgARAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAWABEAFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAFgARABYAEQAWABEAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFgARABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeABYAEQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHQAdAB0AHQAdAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAeAB4AKwArACsAKwArABMADQANAA0AUAATAA0AUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUAANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAA0ADQANAA0ADQANAA0ADQAeAA0AFgANAB4AHgAXABcAHgAeABcAFwAWABEAFgARABYAEQAWABEADQANAA0ADQATAFAADQANAB4ADQANAB4AHgAeAB4AHgAMAAwADQANAA0AHgANAA0AFgANAA0ADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArAA0AEQARACUAJQBHAFcAVwAWABEAFgARABYAEQAWABEAFgARACUAJQAWABEAFgARABYAEQAWABEAFQAWABEAEQAlAFcAVwBXAFcAVwBXAFcAVwBXAAQABAAEAAQABAAEACUAVwBXAFcAVwA2ACUAJQBXAFcAVwBHAEcAJQAlACUAKwBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBRAFcAUQBXAFEAVwBXAFcAVwBXAFcAUQBXAFcAVwBXAFcAVwBRAFEAKwArAAQABAAVABUARwBHAFcAFQBRAFcAUQBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFEAVwBRAFcAUQBXAFcAVwBXAFcAVwBRAFcAVwBXAFcAVwBXAFEAUQBXAFcAVwBXABUAUQBHAEcAVwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwArACUAJQBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAKwArACUAJQAlACUAKwArACsAKwArACsAKwArACsAKwArACsAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQBRAFEAUQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAVwBXAFcAVwBXAFcAVwBXAFcAVwAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAE8ATwBPAE8ATwBPAE8ATwAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADQATAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABLAEsASwBLAEsASwBLAEsASwBLAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAABAAEAAQABAAeAAQABAAEAAQABAAEAAQABAAEAAQAHgBQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUABQAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAeAA0ADQANAA0ADQArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAB4AHgAeAB4AHgAeAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAB4AHgAeAB4AHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAAQAUABQAFAABABQAFAAUABQAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAeAB4AHgAeACsAKwArACsAUABQAFAAUABQAFAAHgAeABoAHgArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAADgAOABMAEwArACsAKwArACsAKwArACsABAAEAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwANAA0ASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUAAeAB4AHgBQAA4AUAArACsAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAA0ADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArAB4AWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYAFgAWABYACsAKwArAAQAHgAeAB4AHgAeAB4ADQANAA0AHgAeAB4AHgArAFAASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArAB4AHgBcAFwAXABcAFwAKgBcAFwAXABcAFwAXABcAFwAXABcAEsASwBLAEsASwBLAEsASwBLAEsAXABcAFwAXABcACsAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArAFAAUABQAAQAUABQAFAAUABQAFAAUABQAAQABAArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAHgANAA0ADQBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAKgAqACoAXAAqACoAKgBcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAAqAFwAKgAqACoAXABcACoAKgBcAFwAXABcAFwAKgAqAFwAKgBcACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcACoAKgBQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAA0ADQBQAFAAUAAEAAQAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQADQAEAAQAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAVABVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBUAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVAFUAVQBVACsAKwArACsAKwArACsAKwArACsAKwArAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAWQBZAFkAKwArACsAKwBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAWgBaAFoAKwArACsAKwAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYABgAGAAYAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArACsAKwArAFYABABWAFYAVgBWAFYAVgBWAFYAVgBWAB4AVgBWAFYAVgBWAFYAVgBWAFYAVgBWAFYAVgArAFYAVgBWAFYAVgArAFYAKwBWAFYAKwBWAFYAKwBWAFYAVgBWAFYAVgBWAFYAVgBWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAEQAWAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUAAaAB4AKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAGAARABEAGAAYABMAEwAWABEAFAArACsAKwArACsAKwAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACUAJQAlACUAJQAWABEAFgARABYAEQAWABEAFgARABYAEQAlACUAFgARACUAJQAlACUAJQAlACUAEQAlABEAKwAVABUAEwATACUAFgARABYAEQAWABEAJQAlACUAJQAlACUAJQAlACsAJQAbABoAJQArACsAKwArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAcAKwATACUAJQAbABoAJQAlABYAEQAlACUAEQAlABEAJQBXAFcAVwBXAFcAVwBXAFcAVwBXABUAFQAlACUAJQATACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXABYAJQARACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwAWACUAEQAlABYAEQARABYAEQARABUAVwBRAFEAUQBRAFEAUQBRAFEAUQBRAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAEcARwArACsAVwBXAFcAVwBXAFcAKwArAFcAVwBXAFcAVwBXACsAKwBXAFcAVwBXAFcAVwArACsAVwBXAFcAKwArACsAGgAbACUAJQAlABsAGwArAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwAEAAQABAAQAB0AKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsADQANAA0AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgBQAFAAHgAeAB4AKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAKwArAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQBQAFAAUABQACsAKwArACsAUABQAFAAUABQAFAAUABQAA0AUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAArACsAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQACsAKwArAFAAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAA0AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AHgBQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsADQBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwBQAFAAUABQAFAABAAEAAQAKwAEAAQAKwArACsAKwArAAQABAAEAAQAUABQAFAAUAArAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsABAAEAAQAKwArACsAKwAEAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsADQANAA0ADQANAA0ADQANAB4AKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAB4AUABQAFAAUABQAFAAUABQAB4AUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEACsAKwArACsAUABQAFAAUABQAA0ADQANAA0ADQANABQAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwANAA0ADQANAA0ADQANAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAHgAeAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQAeAB4AHgAeAB4AKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQABAAEAAQABAAeAB4AHgANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAKwArAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsASwBLAEsASwBLAEsASwBLAEsASwANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAeAA4AUAArACsAKwArACsAKwArACsAKwAEAFAAUABQAFAADQANAB4ADQAeAAQABAAEAB4AKwArAEsASwBLAEsASwBLAEsASwBLAEsAUAAOAFAADQANAA0AKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAANAA0AHgANAA0AHgAEACsAUABQAFAAUABQAFAAUAArAFAAKwBQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAA0AKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsABAAEAAQABAArAFAAUABQAFAAUABQAFAAUAArACsAUABQACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAArACsABAAEACsAKwAEAAQABAArACsAUAArACsAKwArACsAKwAEACsAKwArACsAKwBQAFAAUABQAFAABAAEACsAKwAEAAQABAAEAAQABAAEACsAKwArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABABQAFAAUABQAA0ADQANAA0AHgBLAEsASwBLAEsASwBLAEsASwBLACsADQArAB4AKwArAAQABAAEAAQAUABQAB4AUAArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEACsAKwAEAAQABAAEAAQABAAEAAQABAAOAA0ADQATABMAHgAeAB4ADQANAA0ADQANAA0ADQANAA0ADQANAA0ADQANAA0AUABQAFAAUAAEAAQAKwArAAQADQANAB4AUAArACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXABcAFwAXAArACsAKwAqACoAKgAqACoAKgAqACoAKgAqACoAKgAqACoAKgArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAXABcAA0ADQANACoASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwBQAFAABAAEAAQABAAEAAQABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAFAABAAEAAQABAAOAB4ADQANAA0ADQAOAB4ABAArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQAUABQAFAAUAArACsAUABQAFAAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAA0ADQANACsADgAOAA4ADQANACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAABAAEAAQABAAEAAQABAAEACsABAAEAAQABAAEAAQABAAEAFAADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwAOABMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQACsAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAArACsAKwAEACsABAAEACsABAAEAAQABAAEAAQABABQAAQAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsADQANAA0ADQANACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABIAEgAQwBDAEMAUABQAFAAUABDAFAAUABQAEgAQwBIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAASABDAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABIAEMAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAEsASwBLAEsASwBLAEsASwBLAEsAKwArACsAKwANAA0AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArAAQABAAEAAQABAANACsAKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAEAAQABAAEAAQABAAEAA0ADQANAB4AHgAeAB4AHgAeAFAAUABQAFAADQAeACsAKwArACsAKwArACsAKwArACsASwBLAEsASwBLAEsASwBLAEsASwArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAUAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAEcARwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwArACsAKwArACsAKwArACsAKwArACsAKwArAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwBQAFAAUABQAFAAUABQAFAAUABQACsAKwAeAAQABAANAAQABAAEAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAeAB4AHgArACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAEAAQABAAEAB4AHgAeAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQAHgAeAAQABAAEAAQABAAEAAQAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAEAAQABAAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwArACsAKwArACsAKwArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUAArACsAUAArACsAUABQACsAKwBQAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AKwBQACsAUABQAFAAUABQAFAAUAArAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwAeAB4AUABQAFAAUABQACsAUAArACsAKwBQAFAAUABQAFAAUABQACsAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgArACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUAAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAHgAeAB4AHgAeAB4AHgAeAB4AKwArAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsASwBLAEsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4ABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAB4AHgAeAB4AHgAeAB4AHgAEAB4AHgAeAB4AHgAeAB4AHgAeAB4ABAAeAB4ADQANAA0ADQAeACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABAArAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsABAAEAAQABAAEAAQABAArAAQABAArAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwBQAFAAUABQAFAAKwArAFAAUABQAFAAUABQAFAAUABQAAQABAAEAAQABAAEAAQAKwArACsAKwArACsAKwArACsAHgAeAB4AHgAEAAQABAAEAAQABAAEACsAKwArACsAKwBLAEsASwBLAEsASwBLAEsASwBLACsAKwArACsAFgAWAFAAUABQAFAAKwBQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArAFAAUAArAFAAKwArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUAArAFAAKwBQACsAKwArACsAKwArAFAAKwArACsAKwBQACsAUAArAFAAKwBQAFAAUAArAFAAUAArAFAAKwArAFAAKwBQACsAUAArAFAAKwBQACsAUABQACsAUAArACsAUABQAFAAUAArAFAAUABQAFAAUABQAFAAKwBQAFAAUABQACsAUABQAFAAUAArAFAAKwBQAFAAUABQAFAAUABQAFAAUABQACsAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQACsAKwArACsAKwBQAFAAUAArAFAAUABQAFAAUAArAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArAB4AHgArACsAKwArACsAKwArACsAKwArACsAKwArACsATwBPAE8ATwBPAE8ATwBPAE8ATwBPAE8ATwAlACUAJQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAeACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHgAeACUAJQAlACUAHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdAB0AHQAdACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQApACkAKQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeACUAJQAlACUAJQAeACUAJQAlACUAJQAgACAAIAAlACUAIAAlACUAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIQAhACEAIQAhACUAJQAgACAAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACAAIAAlACUAJQAlACAAJQAgACAAIAAgACAAIAAgACAAIAAlACUAJQAgACUAJQAlACUAIAAgACAAJQAgACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeACUAHgAlAB4AJQAlACUAJQAlACAAJQAlACUAJQAeACUAHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACAAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAIAAgACAAJQAlACUAIAAgACAAIAAgAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AFwAXABcAFQAVABUAHgAeAB4AHgAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAIAAgACAAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAIAAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAJQAlAB4AHgAeAB4AHgAeAB4AHgAeAB4AJQAlACUAJQAlACUAHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeAB4AHgAeACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAlACAAIAAlACUAJQAlACUAJQAgACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAIAAgACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACsAKwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAVwBXAFcAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQAlACUAJQArAAQAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsAKwArACsA';

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Path = __webpack_require__(138);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Circle = function Circle(x, y, radius) {
    _classCallCheck(this, Circle);

    this.type = _Path.PATH.CIRCLE;
    this.x = x;
    this.y = y;
    this.radius = radius;
    if (false) {
        if (isNaN(x)) {
            console.error('Invalid x value given for Circle');
        }
        if (isNaN(y)) {
            console.error('Invalid y value given for Circle');
        }
        if (isNaN(radius)) {
            console.error('Invalid radius value given for Circle');
        }
    }
};

exports.default = Circle;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bounds = __webpack_require__(71);

var _Font = __webpack_require__(331);

var _Gradient = __webpack_require__(689);

var _TextContainer = __webpack_require__(141);

var _TextContainer2 = _interopRequireDefault(_TextContainer);

var _background = __webpack_require__(106);

var _border = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Renderer = function () {
    function Renderer(target, options) {
        _classCallCheck(this, Renderer);

        this.target = target;
        this.options = options;
        target.render(options);
    }

    _createClass(Renderer, [{
        key: 'renderNode',
        value: function renderNode(container) {
            if (container.isVisible()) {
                this.renderNodeBackgroundAndBorders(container);
                this.renderNodeContent(container);
            }
        }
    }, {
        key: 'renderNodeContent',
        value: function renderNodeContent(container) {
            var _this = this;

            var callback = function callback() {
                if (container.childNodes.length) {
                    container.childNodes.forEach(function (child) {
                        if (child instanceof _TextContainer2.default) {
                            var style = child.parent.style;
                            _this.target.renderTextNode(child.bounds, style.color, style.font, style.textDecoration, style.textShadow);
                        } else {
                            _this.target.drawShape(child, container.style.color);
                        }
                    });
                }

                if (container.image) {
                    var _image = _this.options.imageStore.get(container.image);
                    if (_image) {
                        var contentBox = (0, _Bounds.calculateContentBox)(container.bounds, container.style.padding, container.style.border);
                        var _width = typeof _image.width === 'number' && _image.width > 0 ? _image.width : contentBox.width;
                        var _height = typeof _image.height === 'number' && _image.height > 0 ? _image.height : contentBox.height;
                        if (_width > 0 && _height > 0) {
                            _this.target.clip([(0, _Bounds.calculatePaddingBoxPath)(container.curvedBounds)], function () {
                                _this.target.drawImage(_image, new _Bounds.Bounds(0, 0, _width, _height), contentBox);
                            });
                        }
                    }
                }
            };
            var paths = container.getClipPaths();
            if (paths.length) {
                this.target.clip(paths, callback);
            } else {
                callback();
            }
        }
    }, {
        key: 'renderNodeBackgroundAndBorders',
        value: function renderNodeBackgroundAndBorders(container) {
            var _this2 = this;

            var HAS_BACKGROUND = !container.style.background.backgroundColor.isTransparent() || container.style.background.backgroundImage.length;

            var hasRenderableBorders = container.style.border.some(function (border) {
                return border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent();
            });

            var callback = function callback() {
                var backgroundPaintingArea = (0, _background.calculateBackgroungPaintingArea)(container.curvedBounds, container.style.background.backgroundClip);

                if (HAS_BACKGROUND) {
                    _this2.target.clip([backgroundPaintingArea], function () {
                        if (!container.style.background.backgroundColor.isTransparent()) {
                            _this2.target.fill(container.style.background.backgroundColor);
                        }

                        _this2.renderBackgroundImage(container);
                    });
                }

                container.style.border.forEach(function (border, side) {
                    if (border.borderStyle !== _border.BORDER_STYLE.NONE && !border.borderColor.isTransparent()) {
                        _this2.renderBorder(border, side, container.curvedBounds);
                    }
                });
            };

            if (HAS_BACKGROUND || hasRenderableBorders) {
                var paths = container.parent ? container.parent.getClipPaths() : [];
                if (paths.length) {
                    this.target.clip(paths, callback);
                } else {
                    callback();
                }
            }
        }
    }, {
        key: 'renderBackgroundImage',
        value: function renderBackgroundImage(container) {
            var _this3 = this;

            container.style.background.backgroundImage.slice(0).reverse().forEach(function (backgroundImage) {
                if (backgroundImage.source.method === 'url' && backgroundImage.source.args.length) {
                    _this3.renderBackgroundRepeat(container, backgroundImage);
                } else if (/gradient/i.test(backgroundImage.source.method)) {
                    _this3.renderBackgroundGradient(container, backgroundImage);
                }
            });
        }
    }, {
        key: 'renderBackgroundRepeat',
        value: function renderBackgroundRepeat(container, background) {
            var image = this.options.imageStore.get(background.source.args[0]);
            if (image) {
                var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
                var backgroundImageSize = (0, _background.calculateBackgroundSize)(background, image, backgroundPositioningArea);
                var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
                var _path = (0, _background.calculateBackgroundRepeatPath)(background, position, backgroundImageSize, backgroundPositioningArea, container.bounds);

                var _offsetX = Math.round(backgroundPositioningArea.left + position.x);
                var _offsetY = Math.round(backgroundPositioningArea.top + position.y);
                this.target.renderRepeat(_path, image, backgroundImageSize, _offsetX, _offsetY);
            }
        }
    }, {
        key: 'renderBackgroundGradient',
        value: function renderBackgroundGradient(container, background) {
            var backgroundPositioningArea = (0, _background.calculateBackgroungPositioningArea)(container.style.background.backgroundOrigin, container.bounds, container.style.padding, container.style.border);
            var backgroundImageSize = (0, _background.calculateGradientBackgroundSize)(background, backgroundPositioningArea);
            var position = (0, _background.calculateBackgroundPosition)(background.position, backgroundImageSize, backgroundPositioningArea);
            var gradientBounds = new _Bounds.Bounds(Math.round(backgroundPositioningArea.left + position.x), Math.round(backgroundPositioningArea.top + position.y), backgroundImageSize.width, backgroundImageSize.height);

            var gradient = (0, _Gradient.parseGradient)(container, background.source, gradientBounds);
            if (gradient) {
                switch (gradient.type) {
                    case _Gradient.GRADIENT_TYPE.LINEAR_GRADIENT:
                        // $FlowFixMe
                        this.target.renderLinearGradient(gradientBounds, gradient);
                        break;
                    case _Gradient.GRADIENT_TYPE.RADIAL_GRADIENT:
                        // $FlowFixMe
                        this.target.renderRadialGradient(gradientBounds, gradient);
                        break;
                }
            }
        }
    }, {
        key: 'renderBorder',
        value: function renderBorder(border, side, curvePoints) {
            this.target.drawShape((0, _Bounds.parsePathForBorder)(curvePoints, side), border.borderColor);
        }
    }, {
        key: 'renderStack',
        value: function renderStack(stack) {
            var _this4 = this;

            if (stack.container.isVisible()) {
                var _opacity = stack.getOpacity();
                if (_opacity !== this._opacity) {
                    this.target.setOpacity(stack.getOpacity());
                    this._opacity = _opacity;
                }

                var _transform = stack.container.style.transform;
                if (_transform !== null) {
                    this.target.transform(stack.container.bounds.left + _transform.transformOrigin[0].value, stack.container.bounds.top + _transform.transformOrigin[1].value, _transform.transform, function () {
                        return _this4.renderStackContent(stack);
                    });
                } else {
                    this.renderStackContent(stack);
                }
            }
        }
    }, {
        key: 'renderStackContent',
        value: function renderStackContent(stack) {
            var _splitStackingContext = splitStackingContexts(stack),
                _splitStackingContext2 = _slicedToArray(_splitStackingContext, 5),
                negativeZIndex = _splitStackingContext2[0],
                zeroOrAutoZIndexOrTransformedOrOpacity = _splitStackingContext2[1],
                positiveZIndex = _splitStackingContext2[2],
                nonPositionedFloats = _splitStackingContext2[3],
                nonPositionedInlineLevel = _splitStackingContext2[4];

            var _splitDescendants = splitDescendants(stack),
                _splitDescendants2 = _slicedToArray(_splitDescendants, 2),
                inlineLevel = _splitDescendants2[0],
                nonInlineLevel = _splitDescendants2[1];

            // https://www.w3.org/TR/css-position-3/#painting-order
            // 1. the background and borders of the element forming the stacking context.


            this.renderNodeBackgroundAndBorders(stack.container);
            // 2. the child stacking contexts with negative stack levels (most negative first).
            negativeZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
            this.renderNodeContent(stack.container);
            nonInlineLevel.forEach(this.renderNode, this);
            // 4. All non-positioned floating descendants, in tree order. For each one of these,
            // treat the element as if it created a new stacking context, but any positioned descendants and descendants
            // which actually create a new stacking context should be considered part of the parent stacking context,
            // not this new one.
            nonPositionedFloats.forEach(this.renderStack, this);
            // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
            nonPositionedInlineLevel.forEach(this.renderStack, this);
            inlineLevel.forEach(this.renderNode, this);
            // 6. All positioned, opacity or transform descendants, in tree order that fall into the following categories:
            //  All positioned descendants with 'z-index: auto' or 'z-index: 0', in tree order.
            //  For those with 'z-index: auto', treat the element as if it created a new stacking context,
            //  but any positioned descendants and descendants which actually create a new stacking context should be
            //  considered part of the parent stacking context, not this new one. For those with 'z-index: 0',
            //  treat the stacking context generated atomically.
            //
            //  All opacity descendants with opacity less than 1
            //
            //  All transform descendants with transform other than none
            zeroOrAutoZIndexOrTransformedOrOpacity.forEach(this.renderStack, this);
            // 7. Stacking contexts formed by positioned descendants with z-indices greater than or equal to 1 in z-index
            // order (smallest first) then tree order.
            positiveZIndex.sort(sortByZIndex).forEach(this.renderStack, this);
        }
    }, {
        key: 'render',
        value: function render(stack) {
            var _this5 = this;

            if (this.options.backgroundColor) {
                this.target.rectangle(this.options.x, this.options.y, this.options.width, this.options.height, this.options.backgroundColor);
            }
            this.renderStack(stack);
            var target = this.target.getTarget();
            if (false) {
                return target.then(function (output) {
                    _this5.options.logger.log('Render completed');
                    return output;
                });
            }
            return target;
        }
    }]);

    return Renderer;
}();

exports.default = Renderer;


var splitDescendants = function splitDescendants(stack) {
    var inlineLevel = [];
    var nonInlineLevel = [];

    var length = stack.children.length;
    for (var i = 0; i < length; i++) {
        var child = stack.children[i];
        if (child.isInlineLevel()) {
            inlineLevel.push(child);
        } else {
            nonInlineLevel.push(child);
        }
    }
    return [inlineLevel, nonInlineLevel];
};

var splitStackingContexts = function splitStackingContexts(stack) {
    var negativeZIndex = [];
    var zeroOrAutoZIndexOrTransformedOrOpacity = [];
    var positiveZIndex = [];
    var nonPositionedFloats = [];
    var nonPositionedInlineLevel = [];
    var length = stack.contexts.length;
    for (var i = 0; i < length; i++) {
        var child = stack.contexts[i];
        if (child.container.isPositioned() || child.container.style.opacity < 1 || child.container.isTransformed()) {
            if (child.container.style.zIndex.order < 0) {
                negativeZIndex.push(child);
            } else if (child.container.style.zIndex.order > 0) {
                positiveZIndex.push(child);
            } else {
                zeroOrAutoZIndexOrTransformedOrOpacity.push(child);
            }
        } else {
            if (child.container.isFloating()) {
                nonPositionedFloats.push(child);
            } else {
                nonPositionedInlineLevel.push(child);
            }
        }
    }
    return [negativeZIndex, zeroOrAutoZIndexOrTransformedOrOpacity, positiveZIndex, nonPositionedFloats, nonPositionedInlineLevel];
};

var sortByZIndex = function sortByZIndex(a, b) {
    if (a.container.style.zIndex.order > b.container.style.zIndex.order) {
        return 1;
    } else if (a.container.style.zIndex.order < b.container.style.zIndex.order) {
        return -1;
    }

    return a.container.index > b.container.index ? 1 : -1;
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transformWebkitRadialGradientArgs = exports.parseGradient = exports.RadialGradient = exports.LinearGradient = exports.RADIAL_GRADIENT_SHAPE = exports.GRADIENT_TYPE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _NodeContainer = __webpack_require__(84);

var _NodeContainer2 = _interopRequireDefault(_NodeContainer);

var _Angle = __webpack_require__(690);

var _Color = __webpack_require__(62);

var _Color2 = _interopRequireDefault(_Color);

var _Length = __webpack_require__(70);

var _Length2 = _interopRequireDefault(_Length);

var _Util = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SIDE_OR_CORNER = /^(to )?(left|top|right|bottom)( (left|top|right|bottom))?$/i;
var PERCENTAGE_ANGLES = /^([+-]?\d*\.?\d+)% ([+-]?\d*\.?\d+)%$/i;
var ENDS_WITH_LENGTH = /(px)|%|( 0)$/i;
var FROM_TO_COLORSTOP = /^(from|to|color-stop)\((?:([\d.]+)(%)?,\s*)?(.+?)\)$/i;
var RADIAL_SHAPE_DEFINITION = /^\s*(circle|ellipse)?\s*((?:([\d.]+)(px|r?em|%)\s*(?:([\d.]+)(px|r?em|%))?)|closest-side|closest-corner|farthest-side|farthest-corner)?\s*(?:at\s*(?:(left|center|right)|([\d.]+)(px|r?em|%))\s+(?:(top|center|bottom)|([\d.]+)(px|r?em|%)))?(?:\s|$)/i;

var GRADIENT_TYPE = exports.GRADIENT_TYPE = {
    LINEAR_GRADIENT: 0,
    RADIAL_GRADIENT: 1
};

var RADIAL_GRADIENT_SHAPE = exports.RADIAL_GRADIENT_SHAPE = {
    CIRCLE: 0,
    ELLIPSE: 1
};

var LENGTH_FOR_POSITION = {
    left: new _Length2.default('0%'),
    top: new _Length2.default('0%'),
    center: new _Length2.default('50%'),
    right: new _Length2.default('100%'),
    bottom: new _Length2.default('100%')
};

var LinearGradient = exports.LinearGradient = function LinearGradient(colorStops, direction) {
    _classCallCheck(this, LinearGradient);

    this.type = GRADIENT_TYPE.LINEAR_GRADIENT;
    this.colorStops = colorStops;
    this.direction = direction;
};

var RadialGradient = exports.RadialGradient = function RadialGradient(colorStops, shape, center, radius) {
    _classCallCheck(this, RadialGradient);

    this.type = GRADIENT_TYPE.RADIAL_GRADIENT;
    this.colorStops = colorStops;
    this.shape = shape;
    this.center = center;
    this.radius = radius;
};

var parseGradient = exports.parseGradient = function parseGradient(container, _ref, bounds) {
    var args = _ref.args,
        method = _ref.method,
        prefix = _ref.prefix;

    if (method === 'linear-gradient') {
        return parseLinearGradient(args, bounds, !!prefix);
    } else if (method === 'gradient' && args[0] === 'linear') {
        // TODO handle correct angle
        return parseLinearGradient(['to bottom'].concat(transformObsoleteColorStops(args.slice(3))), bounds, !!prefix);
    } else if (method === 'radial-gradient') {
        return parseRadialGradient(container, prefix === '-webkit-' ? transformWebkitRadialGradientArgs(args) : args, bounds);
    } else if (method === 'gradient' && args[0] === 'radial') {
        return parseRadialGradient(container, transformObsoleteColorStops(transformWebkitRadialGradientArgs(args.slice(1))), bounds);
    }
};

var parseColorStops = function parseColorStops(args, firstColorStopIndex, lineLength) {
    var colorStops = [];

    for (var i = firstColorStopIndex; i < args.length; i++) {
        var value = args[i];
        var HAS_LENGTH = ENDS_WITH_LENGTH.test(value);
        var lastSpaceIndex = value.lastIndexOf(' ');
        var _color = new _Color2.default(HAS_LENGTH ? value.substring(0, lastSpaceIndex) : value);
        var _stop = HAS_LENGTH ? new _Length2.default(value.substring(lastSpaceIndex + 1)) : i === firstColorStopIndex ? new _Length2.default('0%') : i === args.length - 1 ? new _Length2.default('100%') : null;
        colorStops.push({ color: _color, stop: _stop });
    }

    var absoluteValuedColorStops = colorStops.map(function (_ref2) {
        var color = _ref2.color,
            stop = _ref2.stop;

        var absoluteStop = lineLength === 0 ? 0 : stop ? stop.getAbsoluteValue(lineLength) / lineLength : null;

        return {
            color: color,
            // $FlowFixMe
            stop: absoluteStop
        };
    });

    var previousColorStop = absoluteValuedColorStops[0].stop;
    for (var _i = 0; _i < absoluteValuedColorStops.length; _i++) {
        if (previousColorStop !== null) {
            var _stop2 = absoluteValuedColorStops[_i].stop;
            if (_stop2 === null) {
                var n = _i;
                while (absoluteValuedColorStops[n].stop === null) {
                    n++;
                }
                var steps = n - _i + 1;
                var nextColorStep = absoluteValuedColorStops[n].stop;
                var stepSize = (nextColorStep - previousColorStop) / steps;
                for (; _i < n; _i++) {
                    previousColorStop = absoluteValuedColorStops[_i].stop = previousColorStop + stepSize;
                }
            } else {
                previousColorStop = _stop2;
            }
        }
    }

    return absoluteValuedColorStops;
};

var parseLinearGradient = function parseLinearGradient(args, bounds, hasPrefix) {
    var angle = (0, _Angle.parseAngle)(args[0]);
    var HAS_SIDE_OR_CORNER = SIDE_OR_CORNER.test(args[0]);
    var HAS_DIRECTION = HAS_SIDE_OR_CORNER || angle !== null || PERCENTAGE_ANGLES.test(args[0]);
    var direction = HAS_DIRECTION ? angle !== null ? calculateGradientDirection(
    // if there is a prefix, the 0° angle points due East (instead of North per W3C)
    hasPrefix ? angle - Math.PI * 0.5 : angle, bounds) : HAS_SIDE_OR_CORNER ? parseSideOrCorner(args[0], bounds) : parsePercentageAngle(args[0], bounds) : calculateGradientDirection(Math.PI, bounds);
    var firstColorStopIndex = HAS_DIRECTION ? 1 : 0;

    // TODO: Fix some inaccuracy with color stops with px values
    var lineLength = Math.min((0, _Util.distance)(Math.abs(direction.x0) + Math.abs(direction.x1), Math.abs(direction.y0) + Math.abs(direction.y1)), bounds.width * 2, bounds.height * 2);

    return new LinearGradient(parseColorStops(args, firstColorStopIndex, lineLength), direction);
};

var parseRadialGradient = function parseRadialGradient(container, args, bounds) {
    var m = args[0].match(RADIAL_SHAPE_DEFINITION);
    var shape = m && (m[1] === 'circle' || // explicit shape specification
    m[3] !== undefined && m[5] === undefined) // only one radius coordinate
    ? RADIAL_GRADIENT_SHAPE.CIRCLE : RADIAL_GRADIENT_SHAPE.ELLIPSE;
    var radius = {};
    var center = {};

    if (m) {
        // Radius
        if (m[3] !== undefined) {
            radius.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[3], m[4]).getAbsoluteValue(bounds.width);
        }

        if (m[5] !== undefined) {
            radius.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[5], m[6]).getAbsoluteValue(bounds.height);
        }

        // Position
        if (m[7]) {
            center.x = LENGTH_FOR_POSITION[m[7].toLowerCase()];
        } else if (m[8] !== undefined) {
            center.x = (0, _Length.calculateLengthFromValueWithUnit)(container, m[8], m[9]);
        }

        if (m[10]) {
            center.y = LENGTH_FOR_POSITION[m[10].toLowerCase()];
        } else if (m[11] !== undefined) {
            center.y = (0, _Length.calculateLengthFromValueWithUnit)(container, m[11], m[12]);
        }
    }

    var gradientCenter = {
        x: center.x === undefined ? bounds.width / 2 : center.x.getAbsoluteValue(bounds.width),
        y: center.y === undefined ? bounds.height / 2 : center.y.getAbsoluteValue(bounds.height)
    };
    var gradientRadius = calculateRadius(m && m[2] || 'farthest-corner', shape, gradientCenter, radius, bounds);

    return new RadialGradient(parseColorStops(args, m ? 1 : 0, Math.min(gradientRadius.x, gradientRadius.y)), shape, gradientCenter, gradientRadius);
};

var calculateGradientDirection = function calculateGradientDirection(radian, bounds) {
    var width = bounds.width;
    var height = bounds.height;
    var HALF_WIDTH = width * 0.5;
    var HALF_HEIGHT = height * 0.5;
    var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
    var HALF_LINE_LENGTH = lineLength / 2;

    var x0 = HALF_WIDTH + Math.sin(radian) * HALF_LINE_LENGTH;
    var y0 = HALF_HEIGHT - Math.cos(radian) * HALF_LINE_LENGTH;
    var x1 = width - x0;
    var y1 = height - y0;

    return { x0: x0, x1: x1, y0: y0, y1: y1 };
};

var parseTopRight = function parseTopRight(bounds) {
    return Math.acos(bounds.width / 2 / ((0, _Util.distance)(bounds.width, bounds.height) / 2));
};

var parseSideOrCorner = function parseSideOrCorner(side, bounds) {
    switch (side) {
        case 'bottom':
        case 'to top':
            return calculateGradientDirection(0, bounds);
        case 'left':
        case 'to right':
            return calculateGradientDirection(Math.PI / 2, bounds);
        case 'right':
        case 'to left':
            return calculateGradientDirection(3 * Math.PI / 2, bounds);
        case 'top right':
        case 'right top':
        case 'to bottom left':
        case 'to left bottom':
            return calculateGradientDirection(Math.PI + parseTopRight(bounds), bounds);
        case 'top left':
        case 'left top':
        case 'to bottom right':
        case 'to right bottom':
            return calculateGradientDirection(Math.PI - parseTopRight(bounds), bounds);
        case 'bottom left':
        case 'left bottom':
        case 'to top right':
        case 'to right top':
            return calculateGradientDirection(parseTopRight(bounds), bounds);
        case 'bottom right':
        case 'right bottom':
        case 'to top left':
        case 'to left top':
            return calculateGradientDirection(2 * Math.PI - parseTopRight(bounds), bounds);
        case 'top':
        case 'to bottom':
        default:
            return calculateGradientDirection(Math.PI, bounds);
    }
};

var parsePercentageAngle = function parsePercentageAngle(angle, bounds) {
    var _angle$split$map = angle.split(' ').map(parseFloat),
        _angle$split$map2 = _slicedToArray(_angle$split$map, 2),
        left = _angle$split$map2[0],
        top = _angle$split$map2[1];

    var ratio = left / 100 * bounds.width / (top / 100 * bounds.height);

    return calculateGradientDirection(Math.atan(isNaN(ratio) ? 1 : ratio) + Math.PI / 2, bounds);
};

var findCorner = function findCorner(bounds, x, y, closest) {
    var corners = [{ x: 0, y: 0 }, { x: 0, y: bounds.height }, { x: bounds.width, y: 0 }, { x: bounds.width, y: bounds.height }];

    // $FlowFixMe
    return corners.reduce(function (stat, corner) {
        var d = (0, _Util.distance)(x - corner.x, y - corner.y);
        if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
            return {
                optimumCorner: corner,
                optimumDistance: d
            };
        }

        return stat;
    }, {
        optimumDistance: closest ? Infinity : -Infinity,
        optimumCorner: null
    }).optimumCorner;
};

var calculateRadius = function calculateRadius(extent, shape, center, radius, bounds) {
    var x = center.x;
    var y = center.y;
    var rx = 0;
    var ry = 0;

    switch (extent) {
        case 'closest-side':
            // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, it exactly meets the closest side in each dimension.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.min(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.min(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.min(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;

        case 'closest-corner':
            // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
            // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.min((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                var c = Math.min(Math.abs(y), Math.abs(y - bounds.height)) / Math.min(Math.abs(x), Math.abs(x - bounds.width));
                var corner = findCorner(bounds, x, y, true);
                rx = (0, _Util.distance)(corner.x - x, (corner.y - y) / c);
                ry = c * rx;
            }
            break;

        case 'farthest-side':
            // Same as closest-side, except the ending shape is sized based on the farthest side(s)
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.max(Math.abs(x), Math.abs(x - bounds.width), Math.abs(y), Math.abs(y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                rx = Math.max(Math.abs(x), Math.abs(x - bounds.width));
                ry = Math.max(Math.abs(y), Math.abs(y - bounds.height));
            }
            break;

        case 'farthest-corner':
            // Same as closest-corner, except the ending shape is sized based on the farthest corner.
            // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
            if (shape === RADIAL_GRADIENT_SHAPE.CIRCLE) {
                rx = ry = Math.max((0, _Util.distance)(x, y), (0, _Util.distance)(x, y - bounds.height), (0, _Util.distance)(x - bounds.width, y), (0, _Util.distance)(x - bounds.width, y - bounds.height));
            } else if (shape === RADIAL_GRADIENT_SHAPE.ELLIPSE) {
                // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                var _c = Math.max(Math.abs(y), Math.abs(y - bounds.height)) / Math.max(Math.abs(x), Math.abs(x - bounds.width));
                var _corner = findCorner(bounds, x, y, false);
                rx = (0, _Util.distance)(_corner.x - x, (_corner.y - y) / _c);
                ry = _c * rx;
            }
            break;

        default:
            // pixel or percentage values
            rx = radius.x || 0;
            ry = radius.y !== undefined ? radius.y : rx;
            break;
    }

    return {
        x: rx,
        y: ry
    };
};

var transformWebkitRadialGradientArgs = exports.transformWebkitRadialGradientArgs = function transformWebkitRadialGradientArgs(args) {
    var shape = '';
    var radius = '';
    var extent = '';
    var position = '';
    var idx = 0;

    var POSITION = /^(left|center|right|\d+(?:px|r?em|%)?)(?:\s+(top|center|bottom|\d+(?:px|r?em|%)?))?$/i;
    var SHAPE_AND_EXTENT = /^(circle|ellipse)?\s*(closest-side|closest-corner|farthest-side|farthest-corner|contain|cover)?$/i;
    var RADIUS = /^\d+(px|r?em|%)?(?:\s+\d+(px|r?em|%)?)?$/i;

    var matchStartPosition = args[idx].match(POSITION);
    if (matchStartPosition) {
        idx++;
    }

    var matchShapeExtent = args[idx].match(SHAPE_AND_EXTENT);
    if (matchShapeExtent) {
        shape = matchShapeExtent[1] || '';
        extent = matchShapeExtent[2] || '';
        if (extent === 'contain') {
            extent = 'closest-side';
        } else if (extent === 'cover') {
            extent = 'farthest-corner';
        }
        idx++;
    }

    var matchStartRadius = args[idx].match(RADIUS);
    if (matchStartRadius) {
        idx++;
    }

    var matchEndPosition = args[idx].match(POSITION);
    if (matchEndPosition) {
        idx++;
    }

    var matchEndRadius = args[idx].match(RADIUS);
    if (matchEndRadius) {
        idx++;
    }

    var matchPosition = matchEndPosition || matchStartPosition;
    if (matchPosition && matchPosition[1]) {
        position = matchPosition[1] + (/^\d+$/.test(matchPosition[1]) ? 'px' : '');
        if (matchPosition[2]) {
            position += ' ' + matchPosition[2] + (/^\d+$/.test(matchPosition[2]) ? 'px' : '');
        }
    }

    var matchRadius = matchEndRadius || matchStartRadius;
    if (matchRadius) {
        radius = matchRadius[0];
        if (!matchRadius[1]) {
            radius += 'px';
        }
    }

    if (position && !shape && !radius && !extent) {
        radius = position;
        position = '';
    }

    if (position) {
        position = 'at ' + position;
    }

    return [[shape, extent, radius, position].filter(function (s) {
        return !!s;
    }).join(' ')].concat(args.slice(idx));
};

var transformObsoleteColorStops = function transformObsoleteColorStops(args) {
    return args.map(function (color) {
        return color.match(FROM_TO_COLORSTOP);
    })
    // $FlowFixMe
    .map(function (v, index) {
        if (!v) {
            return args[index];
        }

        switch (v[1]) {
            case 'from':
                return v[4] + ' 0%';
            case 'to':
                return v[4] + ' 100%';
            case 'color-stop':
                if (v[3] === '%') {
                    return v[4] + ' ' + v[2];
                }
                return v[4] + ' ' + parseFloat(v[2]) * 100 + '%';
        }
    });
};

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ANGLE = /([+-]?\d*\.?\d+)(deg|grad|rad|turn)/i;

var parseAngle = exports.parseAngle = function parseAngle(angle) {
    var match = angle.match(ANGLE);

    if (match) {
        var value = parseFloat(match[1]);
        switch (match[2].toLowerCase()) {
            case 'deg':
                return Math.PI * value / 180;
            case 'grad':
                return Math.PI / 200 * value;
            case 'rad':
                return value;
            case 'turn':
                return Math.PI * 2 * value;
        }
    }

    return null;
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cloneWindow = exports.DocumentCloner = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Bounds = __webpack_require__(71);

var _Proxy = __webpack_require__(332);

var _ResourceLoader = __webpack_require__(692);

var _ResourceLoader2 = _interopRequireDefault(_ResourceLoader);

var _Util = __webpack_require__(85);

var _background = __webpack_require__(106);

var _CanvasRenderer = __webpack_require__(321);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _PseudoNodeContent = __webpack_require__(693);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';

var DocumentCloner = exports.DocumentCloner = function () {
    function DocumentCloner(element, options, logger, copyInline, renderer) {
        _classCallCheck(this, DocumentCloner);

        this.referenceElement = element;
        this.scrolledElements = [];
        this.copyStyles = copyInline;
        this.inlineImages = copyInline;
        this.logger = logger;
        this.options = options;
        this.renderer = renderer;
        this.resourceLoader = new _ResourceLoader2.default(options, logger, window);
        this.pseudoContentData = {
            counters: {},
            quoteDepth: 0
        };
        // $FlowFixMe
        this.documentElement = this.cloneNode(element.ownerDocument.documentElement);
    }

    _createClass(DocumentCloner, [{
        key: 'inlineAllImages',
        value: function inlineAllImages(node) {
            var _this = this;

            if (this.inlineImages && node) {
                var style = node.style;
                Promise.all((0, _background.parseBackgroundImage)(style.backgroundImage).map(function (backgroundImage) {
                    if (backgroundImage.method === 'url') {
                        return _this.resourceLoader.inlineImage(backgroundImage.args[0]).then(function (img) {
                            return img && typeof img.src === 'string' ? 'url("' + img.src + '")' : 'none';
                        }).catch(function (e) {
                            if (false) {
                                _this.logger.log('Unable to load image', e);
                            }
                        });
                    }
                    return Promise.resolve('' + backgroundImage.prefix + backgroundImage.method + '(' + backgroundImage.args.join(',') + ')');
                })).then(function (backgroundImages) {
                    if (backgroundImages.length > 1) {
                        // TODO Multiple backgrounds somehow broken in Chrome
                        style.backgroundColor = '';
                    }
                    style.backgroundImage = backgroundImages.join(',');
                });

                if (node instanceof HTMLImageElement) {
                    this.resourceLoader.inlineImage(node.src).then(function (img) {
                        if (img && node instanceof HTMLImageElement && node.parentNode) {
                            var parentNode = node.parentNode;
                            var clonedChild = (0, _Util.copyCSSStyles)(node.style, img.cloneNode(false));
                            parentNode.replaceChild(clonedChild, node);
                        }
                    }).catch(function (e) {
                        if (false) {
                            _this.logger.log('Unable to load image', e);
                        }
                    });
                }
            }
        }
    }, {
        key: 'inlineFonts',
        value: function inlineFonts(document) {
            var _this2 = this;

            return Promise.all(Array.from(document.styleSheets).map(function (sheet) {
                if (sheet.href) {
                    return fetch(sheet.href).then(function (res) {
                        return res.text();
                    }).then(function (text) {
                        return createStyleSheetFontsFromText(text, sheet.href);
                    }).catch(function (e) {
                        if (false) {
                            _this2.logger.log('Unable to load stylesheet', e);
                        }
                        return [];
                    });
                }
                return getSheetFonts(sheet, document);
            })).then(function (fonts) {
                return fonts.reduce(function (acc, font) {
                    return acc.concat(font);
                }, []);
            }).then(function (fonts) {
                return Promise.all(fonts.map(function (font) {
                    return fetch(font.formats[0].src).then(function (response) {
                        return response.blob();
                    }).then(function (blob) {
                        return new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onerror = reject;
                            reader.onload = function () {
                                // $FlowFixMe
                                var result = reader.result;
                                resolve(result);
                            };
                            reader.readAsDataURL(blob);
                        });
                    }).then(function (dataUri) {
                        font.fontFace.setProperty('src', 'url("' + dataUri + '")');
                        return '@font-face {' + font.fontFace.cssText + ' ';
                    });
                }));
            }).then(function (fontCss) {
                var style = document.createElement('style');
                style.textContent = fontCss.join('\n');
                _this2.documentElement.appendChild(style);
            });
        }
    }, {
        key: 'createElementClone',
        value: function createElementClone(node) {
            var _this3 = this;

            if (this.copyStyles && node instanceof HTMLCanvasElement) {
                var img = node.ownerDocument.createElement('img');
                try {
                    img.src = node.toDataURL();
                    return img;
                } catch (e) {
                    if (false) {
                        this.logger.log('Unable to clone canvas contents, canvas is tainted');
                    }
                }
            }

            if (node instanceof HTMLIFrameElement) {
                var tempIframe = node.cloneNode(false);
                var iframeKey = generateIframeKey();
                tempIframe.setAttribute('data-html2canvas-internal-iframe-key', iframeKey);

                var _parseBounds = (0, _Bounds.parseBounds)(node, 0, 0),
                    width = _parseBounds.width,
                    height = _parseBounds.height;

                this.resourceLoader.cache[iframeKey] = getIframeDocumentElement(node, this.options).then(function (documentElement) {
                    return _this3.renderer(documentElement, {
                        async: _this3.options.async,
                        allowTaint: _this3.options.allowTaint,
                        backgroundColor: '#ffffff',
                        canvas: null,
                        imageTimeout: _this3.options.imageTimeout,
                        logging: _this3.options.logging,
                        proxy: _this3.options.proxy,
                        removeContainer: _this3.options.removeContainer,
                        scale: _this3.options.scale,
                        foreignObjectRendering: _this3.options.foreignObjectRendering,
                        useCORS: _this3.options.useCORS,
                        target: new _CanvasRenderer2.default(),
                        width: width,
                        height: height,
                        x: 0,
                        y: 0,
                        windowWidth: documentElement.ownerDocument.defaultView.innerWidth,
                        windowHeight: documentElement.ownerDocument.defaultView.innerHeight,
                        scrollX: documentElement.ownerDocument.defaultView.pageXOffset,
                        scrollY: documentElement.ownerDocument.defaultView.pageYOffset
                    }, _this3.logger.child(iframeKey));
                }).then(function (canvas) {
                    return new Promise(function (resolve, reject) {
                        var iframeCanvas = document.createElement('img');
                        iframeCanvas.onload = function () {
                            return resolve(canvas);
                        };
                        iframeCanvas.onerror = reject;
                        iframeCanvas.src = canvas.toDataURL();
                        if (tempIframe.parentNode) {
                            tempIframe.parentNode.replaceChild((0, _Util.copyCSSStyles)(node.ownerDocument.defaultView.getComputedStyle(node), iframeCanvas), tempIframe);
                        }
                    });
                });
                return tempIframe;
            }

            if (node instanceof HTMLStyleElement && node.sheet && node.sheet.cssRules) {
                var css = [].slice.call(node.sheet.cssRules, 0).reduce(function (css, rule) {
                    try {
                        if (rule && rule.cssText) {
                            return css + rule.cssText;
                        }
                        return css;
                    } catch (err) {
                        _this3.logger.log('Unable to access cssText property', rule.name);
                        return css;
                    }
                }, '');
                var style = node.cloneNode(false);
                style.textContent = css;
                return style;
            }

            return node.cloneNode(false);
        }
    }, {
        key: 'cloneNode',
        value: function cloneNode(node) {
            var clone = node.nodeType === Node.TEXT_NODE ? document.createTextNode(node.nodeValue) : this.createElementClone(node);

            var window = node.ownerDocument.defaultView;
            var style = node instanceof window.HTMLElement ? window.getComputedStyle(node) : null;
            var styleBefore = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':before') : null;
            var styleAfter = node instanceof window.HTMLElement ? window.getComputedStyle(node, ':after') : null;

            if (this.referenceElement === node && clone instanceof window.HTMLElement) {
                this.clonedReferenceElement = clone;
            }

            if (clone instanceof window.HTMLBodyElement) {
                createPseudoHideStyles(clone);
            }

            var counters = (0, _PseudoNodeContent.parseCounterReset)(style, this.pseudoContentData);
            var contentBefore = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleBefore, this.pseudoContentData);

            for (var child = node.firstChild; child; child = child.nextSibling) {
                if (child.nodeType !== Node.ELEMENT_NODE || child.nodeName !== 'SCRIPT' &&
                // $FlowFixMe
                !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' ||
                // $FlowFixMe
                !this.options.ignoreElements(child))) {
                    if (!this.copyStyles || child.nodeName !== 'STYLE') {
                        clone.appendChild(this.cloneNode(child));
                    }
                }
            }

            var contentAfter = (0, _PseudoNodeContent.resolvePseudoContent)(node, styleAfter, this.pseudoContentData);
            (0, _PseudoNodeContent.popCounters)(counters, this.pseudoContentData);

            if (node instanceof window.HTMLElement && clone instanceof window.HTMLElement) {
                if (styleBefore) {
                    this.inlineAllImages(inlinePseudoElement(node, clone, styleBefore, contentBefore, PSEUDO_BEFORE));
                }
                if (styleAfter) {
                    this.inlineAllImages(inlinePseudoElement(node, clone, styleAfter, contentAfter, PSEUDO_AFTER));
                }
                if (style && this.copyStyles && !(node instanceof HTMLIFrameElement)) {
                    (0, _Util.copyCSSStyles)(style, clone);
                }
                this.inlineAllImages(clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                switch (node.nodeName) {
                    case 'CANVAS':
                        if (!this.copyStyles) {
                            cloneCanvasContents(node, clone);
                        }
                        break;
                    case 'TEXTAREA':
                    case 'SELECT':
                        clone.value = node.value;
                        break;
                }
            }
            return clone;
        }
    }]);

    return DocumentCloner;
}();

var getSheetFonts = function getSheetFonts(sheet, document) {
    // $FlowFixMe
    return (sheet.cssRules ? Array.from(sheet.cssRules) : []).filter(function (rule) {
        return rule.type === CSSRule.FONT_FACE_RULE;
    }).map(function (rule) {
        var src = (0, _background.parseBackgroundImage)(rule.style.getPropertyValue('src'));
        var formats = [];
        for (var i = 0; i < src.length; i++) {
            if (src[i].method === 'url' && src[i + 1] && src[i + 1].method === 'format') {
                var a = document.createElement('a');
                a.href = src[i].args[0];
                if (document.body) {
                    document.body.appendChild(a);
                }

                var font = {
                    src: a.href,
                    format: src[i + 1].args[0]
                };
                formats.push(font);
            }
        }

        return {
            // TODO select correct format for browser),

            formats: formats.filter(function (font) {
                return (/^woff/i.test(font.format)
                );
            }),
            fontFace: rule.style
        };
    }).filter(function (font) {
        return font.formats.length;
    });
};

var createStyleSheetFontsFromText = function createStyleSheetFontsFromText(text, baseHref) {
    var doc = document.implementation.createHTMLDocument('');
    var base = document.createElement('base');
    // $FlowFixMe
    base.href = baseHref;
    var style = document.createElement('style');

    style.textContent = text;
    if (doc.head) {
        doc.head.appendChild(base);
    }
    if (doc.body) {
        doc.body.appendChild(style);
    }

    return style.sheet ? getSheetFonts(style.sheet, doc) : [];
};

var restoreOwnerScroll = function restoreOwnerScroll(ownerDocument, x, y) {
    if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
        ownerDocument.defaultView.scrollTo(x, y);
    }
};

var cloneCanvasContents = function cloneCanvasContents(canvas, clonedCanvas) {
    try {
        if (clonedCanvas) {
            clonedCanvas.width = canvas.width;
            clonedCanvas.height = canvas.height;
            var ctx = canvas.getContext('2d');
            var clonedCtx = clonedCanvas.getContext('2d');
            if (ctx) {
                clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
            } else {
                clonedCtx.drawImage(canvas, 0, 0);
            }
        }
    } catch (e) {}
};

var inlinePseudoElement = function inlinePseudoElement(node, clone, style, contentItems, pseudoElt) {
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
        return;
    }

    var anonymousReplacedElement = clone.ownerDocument.createElement('html2canvaspseudoelement');
    (0, _Util.copyCSSStyles)(style, anonymousReplacedElement);

    if (contentItems) {
        var len = contentItems.length;
        for (var i = 0; i < len; i++) {
            var item = contentItems[i];
            switch (item.type) {
                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.IMAGE:
                    var img = clone.ownerDocument.createElement('img');
                    img.src = (0, _background.parseBackgroundImage)('url(' + item.value + ')')[0].args[0];
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                    break;
                case _PseudoNodeContent.PSEUDO_CONTENT_ITEM_TYPE.TEXT:
                    anonymousReplacedElement.appendChild(clone.ownerDocument.createTextNode(item.value));
                    break;
            }
        }
    }

    anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    clone.className += pseudoElt === PSEUDO_BEFORE ? ' ' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : ' ' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
    if (pseudoElt === PSEUDO_BEFORE) {
        clone.insertBefore(anonymousReplacedElement, clone.firstChild);
    } else {
        clone.appendChild(anonymousReplacedElement);
    }

    return anonymousReplacedElement;
};

var URL_REGEXP = /^url\((.+)\)$/i;
var PSEUDO_BEFORE = ':before';
var PSEUDO_AFTER = ':after';
var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';

var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';

var createPseudoHideStyles = function createPseudoHideStyles(body) {
    createStyles(body, '.' + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + '\n         .' + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
};

var createStyles = function createStyles(body, styles) {
    var style = body.ownerDocument.createElement('style');
    style.innerHTML = styles;
    body.appendChild(style);
};

var initNode = function initNode(_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        element = _ref2[0],
        x = _ref2[1],
        y = _ref2[2];

    element.scrollLeft = x;
    element.scrollTop = y;
};

var generateIframeKey = function generateIframeKey() {
    return Math.ceil(Date.now() + Math.random() * 10000000).toString(16);
};

var DATA_URI_REGEXP = /^data:text\/(.+);(base64)?,(.*)$/i;

var getIframeDocumentElement = function getIframeDocumentElement(node, options) {
    try {
        return Promise.resolve(node.contentWindow.document.documentElement);
    } catch (e) {
        return options.proxy ? (0, _Proxy.Proxy)(node.src, options).then(function (html) {
            var match = html.match(DATA_URI_REGEXP);
            if (!match) {
                return Promise.reject();
            }

            return match[2] === 'base64' ? window.atob(decodeURIComponent(match[3])) : decodeURIComponent(match[3]);
        }).then(function (html) {
            return createIframeContainer(node.ownerDocument, (0, _Bounds.parseBounds)(node, 0, 0)).then(function (cloneIframeContainer) {
                var cloneWindow = cloneIframeContainer.contentWindow;
                var documentClone = cloneWindow.document;

                documentClone.open();
                documentClone.write(html);
                var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
                    return documentClone.documentElement;
                });

                documentClone.close();
                return iframeLoad;
            });
        }) : Promise.reject();
    }
};

var createIframeContainer = function createIframeContainer(ownerDocument, bounds) {
    var cloneIframeContainer = ownerDocument.createElement('iframe');

    cloneIframeContainer.className = 'html2canvas-container';
    cloneIframeContainer.style.visibility = 'hidden';
    cloneIframeContainer.style.position = 'fixed';
    cloneIframeContainer.style.left = '-10000px';
    cloneIframeContainer.style.top = '0px';
    cloneIframeContainer.style.border = '0';
    cloneIframeContainer.width = bounds.width.toString();
    cloneIframeContainer.height = bounds.height.toString();
    cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
    cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
    if (!ownerDocument.body) {
        return Promise.reject( false ? 'Body element not found in Document that is getting rendered' : '');
    }

    ownerDocument.body.appendChild(cloneIframeContainer);

    return Promise.resolve(cloneIframeContainer);
};

var iframeLoader = function iframeLoader(cloneIframeContainer) {
    var cloneWindow = cloneIframeContainer.contentWindow;
    var documentClone = cloneWindow.document;

    return new Promise(function (resolve, reject) {
        cloneWindow.onload = cloneIframeContainer.onload = documentClone.onreadystatechange = function () {
            var interval = setInterval(function () {
                if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                    clearInterval(interval);
                    resolve(cloneIframeContainer);
                }
            }, 50);
        };
    });
};

var cloneWindow = exports.cloneWindow = function cloneWindow(ownerDocument, bounds, referenceElement, options, logger, renderer) {
    var cloner = new DocumentCloner(referenceElement, options, logger, false, renderer);
    var scrollX = ownerDocument.defaultView.pageXOffset;
    var scrollY = ownerDocument.defaultView.pageYOffset;

    return createIframeContainer(ownerDocument, bounds).then(function (cloneIframeContainer) {
        var cloneWindow = cloneIframeContainer.contentWindow;
        var documentClone = cloneWindow.document;

        /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */

        var iframeLoad = iframeLoader(cloneIframeContainer).then(function () {
            cloner.scrolledElements.forEach(initNode);
            cloneWindow.scrollTo(bounds.left, bounds.top);
            if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== bounds.top || cloneWindow.scrollX !== bounds.left)) {
                documentClone.documentElement.style.top = -bounds.top + 'px';
                documentClone.documentElement.style.left = -bounds.left + 'px';
                documentClone.documentElement.style.position = 'absolute';
            }

            var result = Promise.resolve([cloneIframeContainer, cloner.clonedReferenceElement, cloner.resourceLoader]);

            var onclone = options.onclone;

            return cloner.clonedReferenceElement instanceof cloneWindow.HTMLElement || cloner.clonedReferenceElement instanceof ownerDocument.defaultView.HTMLElement || cloner.clonedReferenceElement instanceof HTMLElement ? typeof onclone === 'function' ? Promise.resolve().then(function () {
                return onclone(documentClone);
            }).then(function () {
                return result;
            }) : result : Promise.reject( false ? 'Error finding the ' + referenceElement.nodeName + ' in the cloned document' : '');
        });

        documentClone.open();
        documentClone.write(serializeDoctype(document.doctype) + '<html></html>');
        // Chrome scrolls the parent document for some reason after the write to the cloned window???
        restoreOwnerScroll(referenceElement.ownerDocument, scrollX, scrollY);
        documentClone.replaceChild(documentClone.adoptNode(cloner.documentElement), documentClone.documentElement);
        documentClone.close();

        return iframeLoad;
    });
};

var serializeDoctype = function serializeDoctype(doctype) {
    var str = '';
    if (doctype) {
        str += '<!DOCTYPE ';
        if (doctype.name) {
            str += doctype.name;
        }

        if (doctype.internalSubset) {
            str += doctype.internalSubset;
        }

        if (doctype.publicId) {
            str += '"' + doctype.publicId + '"';
        }

        if (doctype.systemId) {
            str += '"' + doctype.systemId + '"';
        }

        str += '>';
    }

    return str;
};

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResourceStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Feature = __webpack_require__(142);

var _Feature2 = _interopRequireDefault(_Feature);

var _Proxy = __webpack_require__(332);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResourceLoader = function () {
    function ResourceLoader(options, logger, window) {
        _classCallCheck(this, ResourceLoader);

        this.options = options;
        this._window = window;
        this.origin = this.getOrigin(window.location.href);
        this.cache = {};
        this.logger = logger;
        this._index = 0;
    }

    _createClass(ResourceLoader, [{
        key: 'loadImage',
        value: function loadImage(src) {
            var _this = this;

            if (this.hasResourceInCache(src)) {
                return src;
            }
            if (isBlobImage(src)) {
                this.cache[src] = _loadImage(src, this.options.imageTimeout || 0);
                return src;
            }

            if (!isSVG(src) || _Feature2.default.SUPPORT_SVG_DRAWING) {
                if (this.options.allowTaint === true || isInlineImage(src) || this.isSameOrigin(src)) {
                    return this.addImage(src, src, false);
                } else if (!this.isSameOrigin(src)) {
                    if (typeof this.options.proxy === 'string') {
                        this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
                            return _loadImage(src, _this.options.imageTimeout || 0);
                        });
                        return src;
                    } else if (this.options.useCORS === true && _Feature2.default.SUPPORT_CORS_IMAGES) {
                        return this.addImage(src, src, true);
                    }
                }
            }
        }
    }, {
        key: 'inlineImage',
        value: function inlineImage(src) {
            var _this2 = this;

            if (isInlineImage(src)) {
                return _loadImage(src, this.options.imageTimeout || 0);
            }
            if (this.hasResourceInCache(src)) {
                return this.cache[src];
            }
            if (!this.isSameOrigin(src) && typeof this.options.proxy === 'string') {
                return this.cache[src] = (0, _Proxy.Proxy)(src, this.options).then(function (src) {
                    return _loadImage(src, _this2.options.imageTimeout || 0);
                });
            }

            return this.xhrImage(src);
        }
    }, {
        key: 'xhrImage',
        value: function xhrImage(src) {
            var _this3 = this;

            this.cache[src] = new Promise(function (resolve, reject) {
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if (xhr.status !== 200) {
                            reject('Failed to fetch image ' + src.substring(0, 256) + ' with status code ' + xhr.status);
                        } else {
                            var reader = new FileReader();
                            reader.addEventListener('load', function () {
                                // $FlowFixMe
                                var result = reader.result;
                                resolve(result);
                            }, false);
                            reader.addEventListener('error', function (e) {
                                return reject(e);
                            }, false);
                            reader.readAsDataURL(xhr.response);
                        }
                    }
                };
                xhr.responseType = 'blob';
                if (_this3.options.imageTimeout) {
                    var timeout = _this3.options.imageTimeout;
                    xhr.timeout = timeout;
                    xhr.ontimeout = function () {
                        return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
                    };
                }
                xhr.open('GET', src, true);
                xhr.send();
            }).then(function (src) {
                return _loadImage(src, _this3.options.imageTimeout || 0);
            });

            return this.cache[src];
        }
    }, {
        key: 'loadCanvas',
        value: function loadCanvas(node) {
            var key = String(this._index++);
            this.cache[key] = Promise.resolve(node);
            return key;
        }
    }, {
        key: 'hasResourceInCache',
        value: function hasResourceInCache(key) {
            return typeof this.cache[key] !== 'undefined';
        }
    }, {
        key: 'addImage',
        value: function addImage(key, src, useCORS) {
            var _this4 = this;

            if (false) {
                this.logger.log('Added image ' + key.substring(0, 256));
            }

            var imageLoadHandler = function imageLoadHandler(supportsDataImages) {
                return new Promise(function (resolve, reject) {
                    var img = new Image();
                    img.onload = function () {
                        return resolve(img);
                    };
                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                    if (!supportsDataImages || useCORS) {
                        img.crossOrigin = 'anonymous';
                    }

                    img.onerror = reject;
                    img.src = src;
                    if (img.complete === true) {
                        // Inline XML images may fail to parse, throwing an Error later on
                        setTimeout(function () {
                            resolve(img);
                        }, 500);
                    }
                    if (_this4.options.imageTimeout) {
                        var timeout = _this4.options.imageTimeout;
                        setTimeout(function () {
                            return reject( false ? 'Timed out (' + timeout + 'ms) fetching ' + src.substring(0, 256) : '');
                        }, timeout);
                    }
                });
            };

            this.cache[key] = isInlineBase64Image(src) && !isSVG(src) ? // $FlowFixMe
            _Feature2.default.SUPPORT_BASE64_DRAWING(src).then(imageLoadHandler) : imageLoadHandler(true);
            return key;
        }
    }, {
        key: 'isSameOrigin',
        value: function isSameOrigin(url) {
            return this.getOrigin(url) === this.origin;
        }
    }, {
        key: 'getOrigin',
        value: function getOrigin(url) {
            var link = this._link || (this._link = this._window.document.createElement('a'));
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        }
    }, {
        key: 'ready',
        value: function ready() {
            var _this5 = this;

            var keys = Object.keys(this.cache);
            var values = keys.map(function (str) {
                return _this5.cache[str].catch(function (e) {
                    if (false) {
                        _this5.logger.log('Unable to load image', e);
                    }
                    return null;
                });
            });
            return Promise.all(values).then(function (images) {
                if (false) {
                    _this5.logger.log('Finished loading ' + images.length + ' images', images);
                }
                return new ResourceStore(keys, images);
            });
        }
    }]);

    return ResourceLoader;
}();

exports.default = ResourceLoader;

var ResourceStore = exports.ResourceStore = function () {
    function ResourceStore(keys, resources) {
        _classCallCheck(this, ResourceStore);

        this._keys = keys;
        this._resources = resources;
    }

    _createClass(ResourceStore, [{
        key: 'get',
        value: function get(key) {
            var index = this._keys.indexOf(key);
            return index === -1 ? null : this._resources[index];
        }
    }]);

    return ResourceStore;
}();

var INLINE_SVG = /^data:image\/svg\+xml/i;
var INLINE_BASE64 = /^data:image\/.*;base64,/i;
var INLINE_IMG = /^data:image\/.*/i;

var isInlineImage = function isInlineImage(src) {
    return INLINE_IMG.test(src);
};
var isInlineBase64Image = function isInlineBase64Image(src) {
    return INLINE_BASE64.test(src);
};
var isBlobImage = function isBlobImage(src) {
    return src.substr(0, 4) === 'blob';
};

var isSVG = function isSVG(src) {
    return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
};

var _loadImage = function _loadImage(src, timeout) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            return resolve(img);
        };
        img.onerror = reject;
        img.src = src;
        if (img.complete === true) {
            // Inline XML images may fail to parse, throwing an Error later on
            setTimeout(function () {
                resolve(img);
            }, 500);
        }
        if (timeout) {
            setTimeout(function () {
                return reject( false ? 'Timed out (' + timeout + 'ms) loading image' : '');
            }, timeout);
        }
    });
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseContent = exports.resolvePseudoContent = exports.popCounters = exports.parseCounterReset = exports.TOKEN_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ListItem = __webpack_require__(201);

var _listStyle = __webpack_require__(140);

var PSEUDO_CONTENT_ITEM_TYPE = exports.PSEUDO_CONTENT_ITEM_TYPE = {
    TEXT: 0,
    IMAGE: 1
};

var TOKEN_TYPE = exports.TOKEN_TYPE = {
    STRING: 0,
    ATTRIBUTE: 1,
    URL: 2,
    COUNTER: 3,
    COUNTERS: 4,
    OPENQUOTE: 5,
    CLOSEQUOTE: 6
};

var parseCounterReset = exports.parseCounterReset = function parseCounterReset(style, data) {
    if (!style || !style.counterReset || style.counterReset === 'none') {
        return [];
    }

    var counterNames = [];
    var counterResets = style.counterReset.split(/\s*,\s*/);
    var lenCounterResets = counterResets.length;

    for (var i = 0; i < lenCounterResets; i++) {
        var _counterResets$i$spli = counterResets[i].split(/\s+/),
            _counterResets$i$spli2 = _slicedToArray(_counterResets$i$spli, 2),
            counterName = _counterResets$i$spli2[0],
            initialValue = _counterResets$i$spli2[1];

        counterNames.push(counterName);
        var counter = data.counters[counterName];
        if (!counter) {
            counter = data.counters[counterName] = [];
        }
        counter.push(parseInt(initialValue || 0, 10));
    }

    return counterNames;
};

var popCounters = exports.popCounters = function popCounters(counterNames, data) {
    var lenCounters = counterNames.length;
    for (var i = 0; i < lenCounters; i++) {
        data.counters[counterNames[i]].pop();
    }
};

var resolvePseudoContent = exports.resolvePseudoContent = function resolvePseudoContent(node, style, data) {
    if (!style || !style.content || style.content === 'none' || style.content === '-moz-alt-content' || style.display === 'none') {
        return null;
    }

    var tokens = parseContent(style.content);

    var len = tokens.length;
    var contentItems = [];
    var s = '';

    // increment the counter (if there is a "counter-increment" declaration)
    var counterIncrement = style.counterIncrement;
    if (counterIncrement && counterIncrement !== 'none') {
        var _counterIncrement$spl = counterIncrement.split(/\s+/),
            _counterIncrement$spl2 = _slicedToArray(_counterIncrement$spl, 2),
            counterName = _counterIncrement$spl2[0],
            incrementValue = _counterIncrement$spl2[1];

        var counter = data.counters[counterName];
        if (counter) {
            counter[counter.length - 1] += incrementValue === undefined ? 1 : parseInt(incrementValue, 10);
        }
    }

    // build the content string
    for (var i = 0; i < len; i++) {
        var token = tokens[i];
        switch (token.type) {
            case TOKEN_TYPE.STRING:
                s += token.value || '';
                break;

            case TOKEN_TYPE.ATTRIBUTE:
                if (node instanceof HTMLElement && token.value) {
                    s += node.getAttribute(token.value) || '';
                }
                break;

            case TOKEN_TYPE.COUNTER:
                var _counter = data.counters[token.name || ''];
                if (_counter) {
                    s += formatCounterValue([_counter[_counter.length - 1]], '', token.format);
                }
                break;

            case TOKEN_TYPE.COUNTERS:
                var _counters = data.counters[token.name || ''];
                if (_counters) {
                    s += formatCounterValue(_counters, token.glue, token.format);
                }
                break;

            case TOKEN_TYPE.OPENQUOTE:
                s += getQuote(style, true, data.quoteDepth);
                data.quoteDepth++;
                break;

            case TOKEN_TYPE.CLOSEQUOTE:
                data.quoteDepth--;
                s += getQuote(style, false, data.quoteDepth);
                break;

            case TOKEN_TYPE.URL:
                if (s) {
                    contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
                    s = '';
                }
                contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.IMAGE, value: token.value || '' });
                break;
        }
    }

    if (s) {
        contentItems.push({ type: PSEUDO_CONTENT_ITEM_TYPE.TEXT, value: s });
    }

    return contentItems;
};

var parseContent = exports.parseContent = function parseContent(content, cache) {
    if (cache && cache[content]) {
        return cache[content];
    }

    var tokens = [];
    var len = content.length;

    var isString = false;
    var isEscaped = false;
    var isFunction = false;
    var str = '';
    var functionName = '';
    var args = [];

    for (var i = 0; i < len; i++) {
        var c = content.charAt(i);

        switch (c) {
            case "'":
            case '"':
                if (isEscaped) {
                    str += c;
                } else {
                    isString = !isString;
                    if (!isFunction && !isString) {
                        tokens.push({ type: TOKEN_TYPE.STRING, value: str });
                        str = '';
                    }
                }
                break;

            case '\\':
                if (isEscaped) {
                    str += c;
                    isEscaped = false;
                } else {
                    isEscaped = true;
                }
                break;

            case '(':
                if (isString) {
                    str += c;
                } else {
                    isFunction = true;
                    functionName = str;
                    str = '';
                    args = [];
                }
                break;

            case ')':
                if (isString) {
                    str += c;
                } else if (isFunction) {
                    if (str) {
                        args.push(str);
                    }

                    switch (functionName) {
                        case 'attr':
                            if (args.length > 0) {
                                tokens.push({ type: TOKEN_TYPE.ATTRIBUTE, value: args[0] });
                            }
                            break;

                        case 'counter':
                            if (args.length > 0) {
                                var counter = {
                                    type: TOKEN_TYPE.COUNTER,
                                    name: args[0]
                                };
                                if (args.length > 1) {
                                    counter.format = args[1];
                                }
                                tokens.push(counter);
                            }
                            break;

                        case 'counters':
                            if (args.length > 0) {
                                var _counters2 = {
                                    type: TOKEN_TYPE.COUNTERS,
                                    name: args[0]
                                };
                                if (args.length > 1) {
                                    _counters2.glue = args[1];
                                }
                                if (args.length > 2) {
                                    _counters2.format = args[2];
                                }
                                tokens.push(_counters2);
                            }
                            break;

                        case 'url':
                            if (args.length > 0) {
                                tokens.push({ type: TOKEN_TYPE.URL, value: args[0] });
                            }
                            break;
                    }

                    isFunction = false;
                    str = '';
                }
                break;

            case ',':
                if (isString) {
                    str += c;
                } else if (isFunction) {
                    args.push(str);
                    str = '';
                }
                break;

            case ' ':
            case '\t':
                if (isString) {
                    str += c;
                } else if (str) {
                    addOtherToken(tokens, str);
                    str = '';
                }
                break;

            default:
                str += c;
        }

        if (c !== '\\') {
            isEscaped = false;
        }
    }

    if (str) {
        addOtherToken(tokens, str);
    }

    if (cache) {
        cache[content] = tokens;
    }

    return tokens;
};

var addOtherToken = function addOtherToken(tokens, identifier) {
    switch (identifier) {
        case 'open-quote':
            tokens.push({ type: TOKEN_TYPE.OPENQUOTE });
            break;
        case 'close-quote':
            tokens.push({ type: TOKEN_TYPE.CLOSEQUOTE });
            break;
    }
};

var getQuote = function getQuote(style, isOpening, quoteDepth) {
    var quotes = style.quotes ? style.quotes.split(/\s+/) : ["'\"'", "'\"'"];
    var idx = quoteDepth * 2;
    if (idx >= quotes.length) {
        idx = quotes.length - 2;
    }
    if (!isOpening) {
        ++idx;
    }
    return quotes[idx].replace(/^["']|["']$/g, '');
};

var formatCounterValue = function formatCounterValue(counter, glue, format) {
    var len = counter.length;
    var result = '';

    for (var i = 0; i < len; i++) {
        if (i > 0) {
            result += glue || '';
        }
        result += (0, _ListItem.createCounterText)(counter[i], (0, _listStyle.parseListStyleType)(format || 'decimal'), false);
    }

    return result;
};

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_render_html__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_render_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_render_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2canvas__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jspdf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AppConfig__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import Heading from 'grommet/components/Heading';
//let TreevieeLevel1;
var StringX;var StringY;var StringZ;var ConfigurationDetails=function(_Component){_inherits(ConfigurationDetails,_Component);function ConfigurationDetails(){_classCallCheck(this,ConfigurationDetails);var _this=_possibleConstructorReturn(this,(ConfigurationDetails.__proto__||Object.getPrototypeOf(ConfigurationDetails)).call(this));_this.state={};_this.onBomSavePdf=_this.onBomSavePdf.bind(_this);_this.ObjectLoopingCommonfn=_this.ObjectLoopingCommonfn.bind(_this);_this.exportConfig=_this.exportConfig.bind(_this);return _this;}_createClass(ConfigurationDetails,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.activeSession.configView==''){var sessionObject=void 0;if(this.props.actvSoln===undefined||this.props.actvSoln===null){sessionObject={"SessionID":this.props.activeSession.id};}else{//var sessionObject = {"SessionID":this.props.activeSession.id };//Rohith-Removed Traditional from backend
sessionObject={"SessionID":this.props.activeSession.id,"EPASolutionType":this.props.actvSoln.toString()};}this.props.onFetchConfigString(sessionObject);}}},{key:'exportConfig',value:function exportConfig(format){//commented by dheeraj as this way of download doesnot surpport to add token to header
//   var mapForm = document.createElement("form");
//         mapForm.id = "FormExportBOM";
//         mapForm.setAttribute("method","GET")
//         mapForm.setAttribute("action", serviceUrl+"/SizingEngine/ConfigDoc");
//         mapForm.target = "_blank";
//         var mapInput1 = document.createElement("input");
//         mapInput1.id = "BomHTMLTemp1";
//         mapInput1.type = "text";
//         mapInput1.name = "format";
//         mapInput1.value = format.toString();
//         mapForm.appendChild(mapInput1);
//         var mapInput = document.createElement("input");
//         mapInput.id = "BomHTMLTemp";
//         mapInput.type = "text";
//         mapInput.name = "sessionId";
//         mapInput.value = this.props.activeSession.id.toString();
//         mapForm.appendChild(mapInput);
//          if(said === 'EPA')
//         {
//             var mapInput2 = document.createElement("input");
//             mapInput2.id = "BomHTMLTemp";
//             mapInput2.type = "text";
//             mapInput2.name = "EPASolutionType";
//             mapInput2.value = null;
//             if(this.props.actvSoln !== null)
//             {
//                 mapInput2.value = this.props.actvSoln.toString();
//             }
//             mapForm.appendChild(mapInput2);
//         }
//         document.body.appendChild(mapForm);
//          mapForm.submit();
//          $("#FormExportBOM").remove();
var exportUrl=void 0;if(this.props.actvSoln){exportUrl=__WEBPACK_IMPORTED_MODULE_9__AppConfig__["g" /* serviceUrl */]+"/SizingEngine/ConfigDoc?format="+format.toString()+"&sessionId="+this.props.activeSession.id.toString()+"&EPASolutionType="+this.props.actvSoln.toString();}else{exportUrl=__WEBPACK_IMPORTED_MODULE_9__AppConfig__["g" /* serviceUrl */]+"/SizingEngine/ConfigDoc?format="+format.toString()+"&sessionId="+this.props.activeSession.id.toString();}var data={url:exportUrl,name:'ConfigurationDetails.'+format.toString()};this.props.onConfigDetailsExport(data);}},{key:'onBomSavePdf',value:function onBomSavePdf(){__WEBPACK_IMPORTED_MODULE_5_html2canvas___default()(document.querySelector("#ConfigureDetails")).then(function(canvas){var imgData=canvas.toDataURL('image/png');var doc;if(canvas.width>canvas.height){doc=new __WEBPACK_IMPORTED_MODULE_6_jspdf___default.a('l','mm',[380,canvas.height]);doc.addImage(imgData,'JPEG',15,15);}else{doc=new __WEBPACK_IMPORTED_MODULE_6_jspdf___default.a('p','mm',[380,canvas.width]);doc.addImage(imgData,'JPEG',15,15);}doc.save("ConfigurationDetails.pdf");//         var doc = new jsPDF({unit:'px'});
//          doc.setFontSize(20);
//         //  doc.text(10, 10, "Configuration Details");
//          doc.addImage(imgData, 'JPEG', 15, 15, 400, 700);
//         doc.save("ConfigurationDetails.pdf");
});//   html2canvas(document.querySelector("#ConfigureDetails")).then(canvas => {
//  const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF();
//     pdf.addImage(imgData, 'JPEG', 15, 20, 190, 300);
//     // pdf.output('dataurlnewwindow');
//     pdf.save("Configuration Details.pdf");
//   //  this.downloadPDF(canvas.toDataURL(), 'canvas.pdf');
// });
}},{key:'ObjectLoopingCommonfn',value:function ObjectLoopingCommonfn(loopObject1){//TreevieeLevel1 = loopObject1.map(function(val,id){
//          return(<ul>
//          <li><span>{val["RoleName"]}</span><ul>
//              <li><span>{val["Processor"]}</span><ul>
//                  <li><span>{val["Storage"]}</span></li>
//                  <li><span>Memory - (Per Server)</span></li>
//                  <li> <span>GB Storage</span></li>
//              </ul></li>
//          </ul></li>
//          </ul>)
//      });
}},{key:'render',value:function render(){var _this2=this;var loopObject;var ObjectArray;if(this.props.activeSession.configView["configuration"]==undefined||this.props.activeSession.configView["configuration"]==''){StringX='';StringY='';StringZ='';}else{StringX=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<div />').html(this.props.activeSession.configView["ConfigDatasize"]).text();StringY=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<div />').html(this.props.activeSession.configView["treeView"]).text();StringZ=__WEBPACK_IMPORTED_MODULE_3_jquery___default()('<div />').html(this.props.activeSession.configView["configuration"]).text();}loopObject=this.props.activeSession.treeView.Solutions.Solution.Roles.Role;if(Array.isArray(loopObject)){this.ObjectLoopingCommonfn(loopObject);}else{ObjectArray=[];ObjectArray.push(loopObject);this.ObjectLoopingCommonfn(ObjectArray);}//  StringY=this.props.activeSession.configView["treeView"];
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{id:'ConfigureDetails',style:{width:'100%',position:'relative',marginTop:'27px'},margin:'none',pad:'none',className:'StringSection'},__WEBPACK_IMPORTED_MODULE_4_react_render_html___default()(StringX),__WEBPACK_IMPORTED_MODULE_4_react_render_html___default()(StringY),__WEBPACK_IMPORTED_MODULE_4_react_render_html___default()(StringZ),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:"small"},className:'StringSection ',alignSelf:'start',align:'start',alignContent:'start',style:{marginLeft:'1%',marginTop:'10px',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Button___default.a,{primary:false,label:'Save as PDF',onClick:function onClick(){return _this2.exportConfig('pdf');}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Button___default.a,{primary:false,label:'Save as Word',onClick:function onClick(){return _this2.exportConfig('doc');}})));}}]);return ConfigurationDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchConfigString:function onFetchConfigString(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__State_actions_sessions__["v" /* fetchConfigString */])(sessionID));},onConfigDetailsExport:function onConfigDetailsExport(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__State_actions_sessions__["m" /* downloadFile */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(ConfigurationDetails));

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Menu__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Anchor__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Anchor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Anchor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Image__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Map__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ConfigureSolution__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_html2canvas__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NimbleStorage__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__SizerUI_SizerConfig_Config__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__State_constants_CommonConstants__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HoverTitleStyle;var SitesList=[];var SiteGrPresentation=void 0;var ActiveTabPass=void 0;var SitesMapping=void 0;var RackServersandEnclosureHover=void 0;var EventTopspace=void 0;var EventLeftspace=void 0;var CountNewWindowOpen=0;//var StorageType;
var totalImages=void 0,loadedImages=void 0;var sizermode='';var ActiveTabObj={Title:'aa',Description:'aaa'};var GrRackServerPresentation=function(_Component){_inherits(GrRackServerPresentation,_Component);function GrRackServerPresentation(props){_classCallCheck(this,GrRackServerPresentation);var _this=_possibleConstructorReturn(this,(GrRackServerPresentation.__proto__||Object.getPrototypeOf(GrRackServerPresentation)).call(this,props));_this.state={scaleRadiusX:50,scaleRadiusY:15,disabledZoomOut:false,InnerView:false,GrInputData:'',RackservHover:true,ActiveTabClass:'',TitleDisplay:false,ServerItemName:'D123467',ActiveSessioonNum:'',ActiveServerTab:ActiveTabObj,PopupLoaderlayer:true,FirstTimeObjLoop:false,ConfigureSolutionData:'',Nimble:false,imageLoaded:false};_this.ZoomIn=_this.ZoomIn.bind(_this);_this.ZoomOut=_this.ZoomOut.bind(_this);_this.InnerViewSec=_this.InnerViewSec.bind(_this);_this.GrPresentation=_this.GrPresentation.bind(_this);_this.openServerActiveTab=_this.openServerActiveTab.bind(_this);_this.ActiveSiteTab=_this.ActiveSiteTab.bind(_this);_this.ClearData=_this.ClearData.bind(_this);_this.HandleActive=_this.HandleActive.bind(_this);_this.RackHoverOver=_this.RackHoverOver.bind(_this);_this.RackHoverOut=_this.RackHoverOut.bind(_this);_this.triggerChildAlert=_this.triggerChildAlert.bind(_this);_this.ImageConvertion=_this.ImageConvertion.bind(_this);_this.downloadURI=_this.downloadURI.bind(_this);_this.PrintImage=_this.PrintImage.bind(_this);_this.PrintImageURI=_this.PrintImageURI.bind(_this);_this.VoucherSourcetoPrint=_this.VoucherSourcetoPrint.bind(_this);_this.VoucherSourcetoPrintIe=_this.VoucherSourcetoPrintIe.bind(_this);_this.NimbleStorage=_this.NimbleStorage.bind(_this);return _this;}_createClass(GrRackServerPresentation,[{key:'componentWillMount',value:function componentWillMount(){this.state.FirstTimeObjLoop=true;if(this.props.StaticGRlist){//      this.state.GrInputData =GRInput;
this.state.GrInputData=this.state.GrInputData.GraphicalInputs;}else{if(this.props.activeSession&&this.props.activeSession.GRInput!=''){this.state.GrInputData=this.props.activeSession&&this.props.activeSession.GRInput;}}}},{key:'componentDidMount',value:function componentDidMount(){if(this.props.StaticGRlist){//    this.state.GrInputData = GRInput;
this.state.GrInputData=this.state.GrInputData.GraphicalInputs;}else{if(!this.props.activeSession||this.props.activeSession.GRInput==''){if(this.props.externalAppProps&&this.props.isFromExternalApp){var sessionObject={"SessionID":this.props.externalAppProps.sizerReference};this.props.onfetchGRinput(sessionObject);}else if(!this.props.activeSession||this.props.activeSession.EPAArray.length==0){var _sessionObject={"SessionID":this.props.activeSession&&this.props.activeSession.id};this.props.onfetchGRinput(_sessionObject);}else{var _sessionObject2={"SessionID":this.props.activeSession&&this.props.activeSession.id,"EPASolutionType":this.props.actvSoln};this.props.onfetchGRinput(_sessionObject2);}// let sessionObject = {"SessionID":this.props.activeSession  && this.props.activeSession.id};
// this.props.onfetchGRinput(sessionObject);
this.state.GrInputData=this.props.activeSession&&this.props.activeSession.GRInput;}}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(nextProps.StaticGRlist){}else{this.state.GrInputData=nextProps.activeSession.GRInput;sizermode=nextProps.activeSession.GRInput.GraphicalInput!==undefined?nextProps.activeSession.GRInput.GraphicalInput["@SizerMode"]:'';/* if(this.props.activeSession.workload && this.props.activeSession.workload.UserInputs.SizerMode!== undefined){
                sizermode = this.props.activeSession.workload.UserInputs.SizerMode; 
            }*/}}},{key:'NimbleStorage',value:function NimbleStorage(){this.setState({Nimble:true});}},{key:'onClose',value:function onClose(){this.setState({Nimble:false});}},{key:'PrintImage',value:function PrintImage(){var _this2=this;this.setState({scaleRadiusX:0.6000000000000001,MinRackHeight:600,scaleRadiusY:1});CountNewWindowOpen++;__WEBPACK_IMPORTED_MODULE_12_html2canvas___default()(document.querySelector("#GrRackServers"),{width:1200,height:1400,useCORS:true}).then(function(canvas){var imgData=canvas.toDataURL();_this2.PrintImageURI(imgData,'Solution.png');});}},{key:'PrintImageURI',value:function PrintImageURI(url,filename){var Pagelink="about:blank";var pwa=window.open(Pagelink,"_new");pwa.document.open();//pwa.document.write("SAPHANA tool");
pwa.document.write(__WEBPACK_IMPORTED_MODULE_19__SizerUI_SizerConfig_Config__["f" /* _title */]);pwa.document.write(this.VoucherSourcetoPrint(url));pwa.document.close();}},{key:'VoucherSourcetoPrint',value:function VoucherSourcetoPrint(url){return"<html><head><script>function step1(){\n"+"setTimeout('step2()', 10);}\n"+"function step2(){window.print();window.close()}\n"+"</script></head><body onload='step1()'>\n"+"<img  style='width:100%,height:100%' src='"+url+"'}} /></body></html>";}},{key:'VoucherSourcetoPrintIe',value:function VoucherSourcetoPrintIe(url){return"<html><head><script>function step1(){\n"+"setTimeout('step2()', 10);}\n"+"function step2(){}\n"+"</script></head><body onload='step1()'>\n"+"<img style='width:100%,height:100%' src='"+url+"' /></body></html>";}},{key:'ImageConvertion',value:function ImageConvertion(div){var _this3=this;CountNewWindowOpen++;this.setState({scaleRadiusX:0.6000000000000001,MinRackHeight:600,scaleRadiusY:1});__WEBPACK_IMPORTED_MODULE_12_html2canvas___default()(document.querySelector("#GrRackServers"),{imageTimeout:0,allowTaint:true,logging:true,width:1200,height:1400,useCORS:true}).then(function(canvas){_this3.downloadURI(canvas.toDataURL(),'Solution.png');});}},{key:'downloadURI',value:function downloadURI(uri,filename){var link=document.createElement('a');link.setAttribute('download','');if(typeof link.getAttribute('download')==='string'){link.setAttribute('href','');link.href=uri;link.download=filename;if(window.navigator.msSaveOrOpenBlob){var Pagelink="about:blank";var pwa=window.open(Pagelink,"_new");pwa.document.open();pwa.document.write(this.VoucherSourcetoPrint(uri));}// For browsers that support the `download` attribute
else{this.href=uri+encodeURIComponent('<p>Hello world!</p>');}//Firefox requires the link to be in the body
document.body.appendChild(link);//simulate click
link.click();document.body.removeChild(link);}else{window.open(uri);}}},{key:'triggerChildAlert',value:function triggerChildAlert(d,e){this.refs.child.ChildAccordianActive(d,e);}},{key:'RackHoverOver',value:function RackHoverOver(e){var HoveText=e.target.getAttribute("id");if(HoveText==null){if(e.target.className.indexOf('grommetux-label')>-1){HoveText=e.target.parentNode.childNodes[0].getAttribute("id").slice(2);}else{HoveText=e.target.childNodes[0].getAttribute("id").slice(2);}}else{HoveText=e.target.getAttribute("id").slice(2);}//    console.log(e);
EventTopspace=e.clientY;EventLeftspace=e.clientX;// console.log(this.state.TitleDisplay);   
this.setState({TitleDisplay:true,ServerItemName:HoveText});}},{key:'RackHoverOut',value:function RackHoverOut(e){//   console.log(e);
this.setState({TitleDisplay:false,ServerItemName:''});//    console.log(this.state.TitleDisplay);
}},{key:'HandleActive',value:function HandleActive(){alert("hoverActive");}},{key:'ClearData',value:function ClearData(){}},{key:'InnerViewSec',value:function InnerViewSec(e){// alert("Exiting");
//  console.log(e);
this.props.RackserverView1(this.state.InnerView,ActiveTabPass);}},{key:'openServerActiveTab',value:function openServerActiveTab(d,e,ID){this.refs.child.ChildAccordianActive(d,e,ID);}},{key:'ZoomIn',value:function ZoomIn(){var ZoomScaleX=7;//  console.log(this.state.scaleRadiusX);
this.setState({scaleRadiusX:this.state.scaleRadiusX+ZoomScaleX,scaleRadiusY:this.state.scaleRadiusY+3,disabledZoomOut:false});}},{key:'ZoomOut',value:function ZoomOut(){var ZoomScaleX=7;if(this.state.scaleRadiusY<15){this.setState({disabledZoomOut:true});}else{this.setState({scaleRadiusX:this.state.scaleRadiusX-ZoomScaleX,scaleRadiusY:this.state.scaleRadiusY-3});}}},{key:'GrPresentation',value:function GrPresentation(){if(SitesList==""){var SiteObj=void 0;if(this.state.GrInputData!=undefined&&this.state.GrInputData.GraphicalInput.length==undefined){SiteObj={Name:this.state.GrInputData.GraphicalInput["@Site"],Id:this.state.GrInputData.GraphicalInput["@SiteID"],ActiveClass:"active"};SitesList=[].concat(_toConsumableArray(SitesList),[SiteObj]);}else{this.state.GrInputData.GraphicalInput.map(function(val){if(val["@SiteID"]=="0"){SiteObj={Name:val["@Site"],Id:val["@SiteID"],ActiveClass:"active"};}else{SiteObj={Name:val["@Site"],Id:val["@SiteID"],ActiveClass:""};}SitesList=[].concat(_toConsumableArray(SitesList),[SiteObj]);});}}}},{key:'ActiveSiteTab',value:function ActiveSiteTab(e){var _this4=this;this.state.FirstTimeObjLoop=false;var ActiveTabIndex=e.target.getAttribute("id");SitesList.map(function(val){if(val["Id"]==ActiveTabIndex){_this4.state.ActiveTabClass='active';val["ActiveClass"]=_this4.state.ActiveTabClass;}else{_this4.state.ActiveTabClass=' ';val["ActiveClass"]='';}});this.setState({});}},{key:'render',value:function render(){var _this5=this;var ShowNimbleStorage='';/*if(!this.props.isFromExternalApp){
           if(this.props.activeSession  && this.props.activeSession.treeView.Solutions.Solution.Roles.SharedRole !== undefined){
            if(this.props.activeSession  && this.props.activeSession.treeView.Solutions.Solution.Roles.SharedRole.SAN!== undefined && Array.isArray(this.props.activeSession  && this.props.activeSession.treeView.Solutions.Solution.Roles.SharedRole.SAN.TableData)){
                StorageType=this.props.activeSession  && this.props.activeSession.treeView.Solutions.Solution.Roles.SharedRole.SAN.TableData[0]['StorageType'];
        }else{
             if(this.props.activeSession  && this.props.activeSession.treeView.Solutions.Solution.Roles.SharedRole.SAN!== undefined){
            StorageType=this.props.activeSession  && this.props.activeSession.treeView.Solutions.Solution.Roles.SharedRole.SAN.TableData.StorageType;
             }
        }
        
        }
    }*/if(this.state.Nimble===true){ShowNimbleStorage=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Layer___default.a,{className:'NimbleStorage'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'NimbleStoragebox',separator:'all',pad:{between:"small"},style:{border:"0px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'NimbleStorageboxheading',direction:'row',separator:'bottom',pad:{between:"small"},style:{backgroundColor:'#425563'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{style:{width:"100%",margin:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default.a,{tag:'h3',style:{marginBottom:'0px',color:'#fff'}},'Explore Nimble Storage')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{id:'informationiconbox',style:{margin:"10px"},direction:'row',margin:'none',pad:'none',justify:'end',onClick:this.onClose.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_base_Close___default.a,{size:'small'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__NimbleStorage__["a" /* default */],null))));}var SitesListMenu=[];if(this.state.GrInputData!==''&&this.state.FirstTimeObjLoop){this.GrPresentation();}var FinalRender=void 0;if(this.state.GrInputData["GraphicalInput"]==undefined){FinalRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default.a,{tag:'h4',align:'center',margin:'medium',strong:false,style:{marginLeft:'45%'}},'Loading... ');}else{HoverTitleStyle={color:'black',width:'auto',height:'auto',padding:'2px 4px',position:'absolute',top:EventTopspace-10+'px',left:EventLeftspace-10+'px',zIndex:'220',backgroundColor:'#cccccc',border:''};SitesListMenu=SitesList.map(function(val){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Anchor___default.a,{className:val["ActiveClass"],id:val["Id"],onClick:function onClick(e){return _this5.ActiveSiteTab(e);}},val["Name"]);});var ActiiveTabObject=SitesList.filter(function(x){return x.ActiveClass==="active";});if(this.props.StaticGRlist){// this.state.ConfigureSolutionData=this.state.GrInputData.GraphicalInput[ActiiveTabObject[0]["Id"]].Items;
this.state.ConfigureSolutionData=this.state.GrInputData.GraphicalInput.Items;}else{this.state.ConfigureSolutionData=this.state.GrInputData.GraphicalInput.Items;}SiteGrPresentation={categories:[{id:'category-1',label:'Rack',items:[]},{id:'category-2',label:'Server',items:[]},{id:'category-3',label:'Storage',items:[]},{id:'category-4',label:'BladeEnclosure',items:[]}],links:[]};if(this.state.GrInputData.GraphicalInput[ActiiveTabObject[0]["Id"]]==undefined){ActiveTabPass=this.state.GrInputData.GraphicalInput["@SiteID"];SitesMapping=this.state.GrInputData.GraphicalInput;}else{ActiveTabPass=this.state.GrInputData.GraphicalInput[ActiiveTabObject[0]["Id"]];SitesMapping=this.state.GrInputData.GraphicalInput[ActiiveTabObject[0]["Id"]];}if(Array.isArray(SitesMapping.Items.Item)){totalImages=0;loadedImages=0;SitesMapping.Items.Item.map(function(val){var SplitObjImagePath=val["@imagepath"].split("\\\\");SplitObjImagePath[1]=SplitObjImagePath[1].replace("Servers","GRE Images");var impath=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"img/SizingEngine/"+SplitObjImagePath[1].replace(/\\/g,"/");var RackItemClick=void 0;SiteGrPresentation.categories.map(function(item,id){var _this6=this;if(item["label"]==="Rack"){RackItemClick=this.InnerViewSec;}else{RackItemClick=function RackItemClick(e){return _this6.openServerActiveTab(val["@name"],val["@description"],val["@id"]);};//  RackItemClick = ""
}if(item["label"]==val["@Type"]){var SynergyHeight;var Synergywidth;if(val["@Type"]=="Server"){if(val["@description"].indexOf('Synergy')>-1){SynergyHeight="140px";Synergywidth="49px";}if(val["@description"].indexOf('Integrity')>-1){SynergyHeight="140px";Synergywidth="49px";}}else if(val["@Type"]=="Storage"){if(val["@description"].indexOf("1 x 20800")>-1){SynergyHeight="170px";Synergywidth='70px';}else if(val["@description"].indexOf("D3940")>-1){SynergyHeight="170px";Synergywidth='100px';}}else if(val["@Type"]=="BladeEnclosure"){if(val["@description"].indexOf("Synergy 12000")>-1){SynergyHeight="100px";Synergywidth='110px';}}else{}var HoverText1=val["@name"];var ItemObj={"id":val["@id"],"label":val["@description"],"node":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none','data-tip':HoverText1,onClick:RackItemClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'DisplayImages',colorIndex:'light-1',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default.a,{onLoad:function onLoad(id){loadedImages++;if(!_this6.state.imageLoaded&&totalImages===loadedImages)_this6.setState({imageLoaded:true});},style:{height:SynergyHeight,width:Synergywidth},src:impath,id:val["@id"]+val["@name"],size:'small',caption:val["@description"]}),' '))};item.items=[].concat(_toConsumableArray(item.items),[ItemObj]);totalImages++;}}.bind(_this5));if(val.Connections==undefined){}else{var connectionObj;var ColorCode;if(!Array.isArray(val.Connections.Connection)){if(val.Connections.Connection["linecolor"]=="Red"||val.Connections.Connection["linetype"]=="Red"){ColorCode="critical";}else if(val.Connections.Connection["linecolor"]=="Green"||val.Connections.Connection["linetype"]=="Green"){ColorCode="brand";}else if(val.Connections.Connection["linetype"]=="Dotted"||val.Connections.Connection["linecolor"]=="Dotted"){ColorCode="neutral-2";}else{ColorCode="neutral-1";}connectionObj={parentId:val["@id"],childId:val.Connections.Connection["id"],colorIndex:ColorCode};SiteGrPresentation.links=[].concat(_toConsumableArray(SiteGrPresentation.links),[connectionObj]);}else{val.Connections.Connection.map(function(d){var ColorCode;if(d["linecolor"]=="Red"||d["linetype"]=="Red"){ColorCode="critical";}else if(d["linecolor"]=="Green"||d["linetype"]=="Green"){ColorCode="brand";}else if(d["linetype"]=="Dotted"||d["linecolor"]=="Dotted"){ColorCode="neutral-2";}else{ColorCode="neutral-1";}connectionObj={parentId:val["@id"],childId:d["id"],colorIndex:ColorCode};SiteGrPresentation.links=[].concat(_toConsumableArray(SiteGrPresentation.links),[connectionObj]);});}}});}else{var SplitObjImagePath=SitesMapping.Items.Item["@imagepath"].split("\\\\");SplitObjImagePath[1]=SplitObjImagePath[1].replace("Servers","GRE Images");var impath=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"img/SizingEngine/"+SplitObjImagePath[1].replace(/\\/g,"/");var RackItemClick=void 0;SiteGrPresentation.categories.map(function(item,id){var _this7=this;if(item["label"]==="Rack"){RackItemClick=this.InnerViewSec;}else{RackItemClick=function RackItemClick(e){return _this7.openServerActiveTab(item["@name"],item["@description"],item["@id"]);};}if(item["label"]==SitesMapping.Items.Item["@Type"]){var SynergyHeight;var Synergywidth;if(SitesMapping.Items.Item["@Type"]=="Server"){if(SitesMapping.Items.Item["@description"].indexOf('Synergy')>-1){if(SitesMapping.Items.Item["@description"]=="HPE CS750 Synergy 3.0 VMw Kit ( Q8A80A )"){SynergyHeight="500px";Synergywidth='150px';}else{SynergyHeight="150px";Synergywidth='49px';}}else if(SitesMapping.Items.Item["@description"]==="1 x HPE Integrity MC990 X 8P"){SynergyHeight="250px";Synergywidth='79px';}}else if(SitesMapping.Items.Item["@Type"]=="Storage"){if(SitesMapping.Items.Item["@description"].indexOf("1 x 20800")>-1){SynergyHeight="170px";Synergywidth='70px';}else if(SitesMapping.Items.Item["@description"].indexOf("D3940")>-1){SynergyHeight="170px";Synergywidth='100px';}}else if(SitesMapping.Items.Item["@Type"]=="BladeEnclosure"){if(SitesMapping.Items.Item["@description"].indexOf("Synergy 12000")>-1){SynergyHeight="100px";Synergywidth='110px';}}else{}var HoverText=SitesMapping.Items.Item["@name"];var ItemObj={"id":SitesMapping.Items.Item["@id"],"label":SitesMapping.Items.Item["@description"],"node":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{'data-tip':HoverText,onClick:RackItemClick,className:'DisplayImages',colorIndex:'light-1',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Image___default.a,{style:{height:SynergyHeight,width:Synergywidth},src:impath,id:SitesMapping.Items.Item["@id"]+SitesMapping.Items.Item["@name"],size:'small',caption:SitesMapping.Items.Item["@description"]}),' ')};item.items=[].concat(_toConsumableArray(item.items),[ItemObj]);}}.bind(this));}if(this.state.RackservHover){RackServersandEnclosureHover=this.state.TitleDisplay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',style:HoverTitleStyle,className:'CheckSvgConnection'},this.state.ServerItemName):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,null);}else{RackServersandEnclosureHover="";}if(!this.props.StaticGRlist){SitesListMenu='';}FinalRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',className:'GrTabSection',justify:'start',align:'center',style:{height:'100%',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react_tooltip___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',align:'start',basis:'1/4',separator:'right',style:{height:'100%',width:'100%'}},this.props.isFromExternalApp?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Button___default.a,{'data-tip':'Print',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print___default.a,{size:'small',colorIndex:'accent-3'}),primary:false,onClick:this.PrintImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Button___default.a,{'data-tip':'Save Image',icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save___default.a,{size:'small',colorIndex:'accent-3'}),primary:false,onClick:this.ImageConvertion})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'SolutionConfigAccordian',justify:'start',margin:'none',pad:'none',align:'start'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ConfigureSolution__["a" /* default */],{MapContent:this.state.ConfigureSolutionData,sizermode:sizermode,ref:'child'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{className:'HrSecPres',margin:'none',pad:'small',justify:'start',align:'start',basis:'3/4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Menu___default.a,{responsive:false,inline:true,direction:'row',className:'SitesMenu',style:{lineHeight:'24px'}},SitesListMenu)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'start',align:'start',style:{height:'100%',width:'100%',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{id:'GrRackServers',margin:'none',align:'start',pad:'none',style:{height:'120%',width:'100%'}},this.props.isFromExternalApp?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{justify:'center',pad:'small',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default.a,{tag:'h5',strong:'true',colorIndex:'brand',style:{color:'#01a982',marginLeft:'23%'}},'Solution Layout')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Map___default.a,{vertical:true,data:SiteGrPresentation,className:'GrMap',style:{width:'100%'}}),RackServersandEnclosureHover)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Paragraph___default.a,{style:{color:"red",margin:"10px",maxWidth:'100%',fontSize:'17px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('b',null,'Note : '),__WEBPACK_IMPORTED_MODULE_21__State_constants_CommonConstants__["h" /* GR_RACKCONFIGURATION_NOTE */])));}if(this.state.imageLoaded){this.props.isPageLoading();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',style:{height:'100%',width:'100%'}},FinalRender,ShowNimbleStorage);}}]);return GrRackServerPresentation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onfetchGRinput:function onfetchGRinput(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_14__State_actions_sessions__["y" /* fetchGRinput */])(sessionID));}};};//export default GrRackServerPresentation;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_13_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GrRackServerPresentation));

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _classnames4 = __webpack_require__(3);

var _classnames5 = _interopRequireDefault(_classnames4);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.MAP;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var ResourceMap = function (_Component) {
  _inherits(ResourceMap, _Component);

  function ResourceMap(props, context) {
    _classCallCheck(this, ResourceMap);

    var _this = _possibleConstructorReturn(this, (ResourceMap.__proto__ || Object.getPrototypeOf(ResourceMap)).call(this, props, context));

    _this._onResize = _this._onResize.bind(_this);
    _this._layout = _this._layout.bind(_this);
    _this._onEnter = _this._onEnter.bind(_this);
    _this._onLeave = _this._onLeave.bind(_this);

    _this.state = _extends({}, _this._stateFromProps(props), {
      height: 100, width: 100, paths: [] });
    return _this;
  }

  _createClass(ResourceMap, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this._onResize);
      this._layout();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this._stateFromProps(nextProps), this._layout);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._onResize);
    }
  }, {
    key: '_hashItems',
    value: function _hashItems(data) {
      var result = {};
      data.categories.forEach(function (category) {
        category.items.forEach(function (item) {
          result[item.id] = item;
        });
      });
      return result;
    }
  }, {
    key: '_children',
    value: function _children(parentId, links, items) {
      var result = [];
      links.forEach(function (link) {
        if (link.parentId === parentId) {
          result.push(items[link.childId]);
        }
      });
      return result;
    }
  }, {
    key: '_parents',
    value: function _parents(childId, links, items) {
      var result = [];
      links.forEach(function (link) {
        if (link.childId === childId) {
          result.push(items[link.parentId]);
        }
      });
      return result;
    }
  }, {
    key: '_buildAriaLabels',
    value: function _buildAriaLabels(data, items) {
      var _this2 = this;

      var intl = this.context.intl;

      var labels = {};
      data.categories.forEach(function (category) {
        category.items.forEach(function (item) {

          var children = _this2._children(item.id, data.links, items);
          var parents = _this2._parents(item.id, data.links, items);

          var message = '';
          if (children.length === 0 && parents.length === 0) {
            message = _Intl2.default.getMessage(intl, 'No Relationship');
          } else {
            if (parents.length > 0) {
              var prefix = _Intl2.default.getMessage(intl, 'Parents');
              var _labels = parents.map(function (item) {
                return item.label || item.node;
              }).join();
              message += prefix + ': (' + _labels + ')';
            }
            if (children.length > 0) {
              if (parents.length > 0) {
                message += ', ';
              }
              var _prefix = _Intl2.default.getMessage(intl, 'Children');
              var _labels2 = children.map(function (item) {
                return item.label || item.node;
              }).join();
              message += _prefix + ': (' + _labels2 + ')';
            }
          }

          labels[item.id] = message;
        });
      });
      return labels;
    }
  }, {
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var activeId = props.hasOwnProperty('active') ? props.active : state.activeId;

      var items = this._hashItems(props.data);

      return {
        activeId: activeId,
        ariaLabels: this._buildAriaLabels(props.data, items),
        items: items
      };
    }
  }, {
    key: '_coords',
    value: function _coords(id, containerRect) {
      var element = document.getElementById(id);
      var rect = element.getBoundingClientRect();
      var left = rect.left - containerRect.left;
      var top = rect.top - containerRect.top;
      var midX = left + rect.width / 2;
      var midY = top + rect.height / 2;
      return {
        top: [midX, top],
        bottom: [midX, top + rect.height],
        left: [left, midY],
        right: [left + rect.width, midY]
      };
    }
  }, {
    key: '_buildPaths',
    value: function _buildPaths(map) {
      var _this3 = this;

      var _props = this.props,
          linkColorIndex = _props.linkColorIndex,
          links = _props.data.links,
          vertical = _props.vertical;
      var activeId = this.state.activeId;

      var rect = map.getBoundingClientRect();

      var paths = links.map(function (link, index) {
        var _classnames;

        var parentCoords = _this3._coords(link.parentId, rect);
        var childCoords = _this3._coords(link.childId, rect);

        var p1 = void 0,
            p2 = void 0;
        if (vertical) {
          if (parentCoords.right[0] < childCoords.left[0]) {
            p1 = parentCoords.right;
            p2 = childCoords.left;
          } else {
            p1 = parentCoords.left;
            p2 = childCoords.right;
          }
        } else {
          if (parentCoords.bottom[1] < childCoords.top[1]) {
            p1 = parentCoords.bottom;
            p2 = childCoords.top;
          } else {
            p1 = parentCoords.top;
            p2 = childCoords.bottom;
          }
        }

        var commands = 'M' + p1[0] + ',' + p1[1];
        var midX = p1[0] + (p2[0] - p1[0]) / 2;
        var midY = p1[1] + (p2[1] - p1[1]) / 2;
        if (vertical) {
          commands += ' Q ' + (midX + (p1[0] - midX) / 2) + ',' + p1[1] + (' ' + midX + ',' + midY);
          commands += ' Q ' + (midX - (p1[0] - midX) / 2) + ',' + p2[1] + (' ' + p2[0] + ',' + p2[1]);
        } else {
          commands += ' Q ' + p1[0] + ',' + (midY + (p1[1] - midY) / 2) + (' ' + midX + ',' + midY);
          commands += ' Q ' + p2[0] + ',' + (midY - (p1[1] - midY) / 2) + (' ' + p2[0] + ',' + p2[1]);
        }

        var pathColorIndex = link.colorIndex || linkColorIndex;
        var classes = (0, _classnames5.default)(CLASS_ROOT + '__path', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__path--active', activeId === link.parentId || activeId === link.childId), _defineProperty(_classnames, COLOR_INDEX + '-' + pathColorIndex, pathColorIndex), _classnames));

        return _react2.default.createElement('path', { key: index, fill: 'none', className: classes, d: commands });
      });

      return paths;
    }
  }, {
    key: '_layout',
    value: function _layout() {
      var map = (0, _reactDom.findDOMNode)(this._mapRef);
      if (map) {
        this.setState({
          width: map.scrollWidth,
          height: map.scrollHeight,
          paths: this._buildPaths(map)
        });
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      // debounce
      clearTimeout(this._layoutTimer);
      this._layoutTimer = setTimeout(this._layout, 50);
    }
  }, {
    key: '_onEnter',
    value: function _onEnter(id) {
      this.setState({ activeId: id }, this._layout);
      if (this.props.onActive) {
        this.props.onActive(id);
      }
    }
  }, {
    key: '_onLeave',
    value: function _onLeave() {
      this.setState({ activeId: undefined }, this._layout);
      if (this.props.onActive) {
        this.props.onActive(undefined);
      }
    }
  }, {
    key: '_renderItems',
    value: function _renderItems(items) {
      var _this4 = this;

      var data = this.props.data;
      var _state = this.state,
          activeId = _state.activeId,
          ariaLabels = _state.ariaLabels;

      return items.map(function (item, index) {
        var _classnames2;

        var active = activeId === item.id || data.links.some(function (link) {
          return (link.parentId === item.id || link.childId === item.id) && (link.parentId === activeId || link.childId === activeId);
        });
        var classes = (0, _classnames5.default)(CLASS_ROOT + '__item', (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '__item--active', active), _defineProperty(_classnames2, CLASS_ROOT + '__item--plain', item.node && typeof item.node !== 'string'), _classnames2));

        return _react2.default.createElement(
          'li',
          { key: index, id: item.id, className: classes,
            'aria-label': (item.label || item.node) + ', ' + ariaLabels[item.id],
            onMouseEnter: _this4._onEnter.bind(_this4, item.id),
            onMouseLeave: _this4._onLeave.bind(_this4, item.id) },
          item.node || item.label
        );
      });
    }
  }, {
    key: '_renderCategories',
    value: function _renderCategories(categories) {
      var _this5 = this;

      return categories.map(function (category) {
        return _react2.default.createElement(
          'li',
          { key: category.id, className: CLASS_ROOT + '__category' },
          _react2.default.createElement(
            'div',
            { className: CLASS_ROOT + '__category-label' },
            category.label
          ),
          _react2.default.createElement(
            'ul',
            { className: CLASS_ROOT + '__category-items' },
            _this5._renderItems(category.items)
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          className = _props2.className,
          data = _props2.data,
          vertical = _props2.vertical,
          props = _objectWithoutProperties(_props2, ['className', 'data', 'vertical']);

      delete props.active;
      delete props.colorIndex;
      delete props.linkColorIndex;
      delete props.onActive;
      var _state2 = this.state,
          height = _state2.height,
          paths = _state2.paths,
          width = _state2.width;

      var classes = (0, _classnames5.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--vertical', vertical), className);

      var categories = void 0;
      if (data.categories) {
        categories = this._renderCategories(data.categories);
      }

      return _react2.default.createElement(
        'div',
        _extends({ ref: function ref(_ref) {
            return _this6._mapRef = _ref;
          } }, props, { className: classes }),
        _react2.default.createElement(
          'svg',
          { className: CLASS_ROOT + '__links',
            width: width, height: height, viewBox: '0 0 ' + width + ' ' + height,
            preserveAspectRatio: 'xMidYMid meet' },
          paths
        ),
        _react2.default.createElement(
          'ol',
          { className: CLASS_ROOT + '__categories' },
          categories
        )
      );
    }
  }]);

  return ResourceMap;
}(_react.Component);

ResourceMap.displayName = 'ResourceMap';
exports.default = ResourceMap;


ResourceMap.contextTypes = {
  intl: _propTypes2.default.object
};

ResourceMap.propTypes = {
  active: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    categories: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string,
      label: _propTypes2.default.node,
      items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string,
        label: _propTypes2.default.string,
        node: _propTypes2.default.node
      }))
    })),
    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      childId: _propTypes2.default.string.isRequired,
      colorIndex: _propTypes2.default.string,
      parentId: _propTypes2.default.string.isRequired
    }))
  }).isRequired,
  linkColorIndex: _propTypes2.default.string,
  onActive: _propTypes2.default.func,
  vertical: _propTypes2.default.bool
};

ResourceMap.defaultProps = {
  linkColorIndex: 'graph-1'
};
module.exports = exports['default'];

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfigDetailsOfRackServers=void 0;var ServerBOMItems=void 0;//var ConfigDetails = [];
var ActiveAccordianBgColor;var ConfigureSolutionDetails=function(_Component){_inherits(ConfigureSolutionDetails,_Component);function ConfigureSolutionDetails(){_classCallCheck(this,ConfigureSolutionDetails);var _this=_possibleConstructorReturn(this,(ConfigureSolutionDetails.__proto__||Object.getPrototypeOf(ConfigureSolutionDetails)).call(this));_this.state={contentVisible:true,HeadingAcc:'Collapse Configure Solution',ActiveTabIndex1:[0],Activedata:'',animate:true};_this.onDivClick=_this.onDivClick.bind(_this);_this.loopConfigureItems=_this.loopConfigureItems.bind(_this);_this.OpenParallelActive=_this.OpenParallelActive.bind(_this);return _this;}_createClass(ConfigureSolutionDetails,[{key:'OpenParallelActive',value:function OpenParallelActive(e){//  this.state.ActiveTabIndex1.length=[];
//    var index=0;
//    if(Array.isArray(this.props.MapContent.Item)){
//     this.props.MapContent.Item.map((val,id)=>{     
//      if(e==id){    
//         //alert(id);              
//            index=id;   
//         }          
//      });
//    }else{      
//    }
ActiveAccordianBgColor=false;var array=[];array=e;this.setState({ActiveTabIndex1:array});}},{key:'onDivClick',value:function onDivClick(){var SetTitle;if(!this.state.contentVisible){SetTitle='Collapse Configure Solution';}else{SetTitle='Expand Configure Solution';}this.setState({contentVisible:!this.state.contentVisible,HeadingAcc:SetTitle});}//    componentWillMount() {
//        ConfigDetails = this.props.MapContent.Item;
//    }
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){//  this.setState({ActiveTabIndex1:this.state.ActiveTabIndex1});
}},{key:'ChildAccordianActive',value:function ChildAccordianActive(d,e,ID){//  this.state.ActiveTabIndex1.length=[];
var index=0;if(Array.isArray(this.props.MapContent.Item)){this.props.MapContent.Item.map(function(val,id){if(d==val["@name"]&&e==val["@description"]&&ID==val["@id"]){index=id;}});}var array=[];array.push(index);ActiveAccordianBgColor=true;this.setState({ActiveTabIndex1:array});this.setState({animate:true});}},{key:'loopConfigureItems',value:function loopConfigureItems(Arraydata){var _this2=this;ConfigDetailsOfRackServers=Arraydata.map(function(val,idx){// if(val["@name"]==="Shared Storage") {
//      console.log(val.Display["Node"].length)
//      console.log(val.Display["Node"])
// }
if(val.Display==undefined){}else{if(val.Display["Node"].length<1){}else{if(val.Display["Node"].length>1){ServerBOMItems=val.Display["Node"].map(function(data){if(data["#text"]==undefined){if(data["@ChildHeading"]==""&&data["@Heading"]==""&&data["@SubHeading"]==""){}else{if(data["SubItem"]==undefined){var FirstSpanWidth='40%';var SecondSpanWidth='60%';if(data["@SubHeading"]==""){FirstSpanWidth='100%';SecondSpanWidth='0%';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:FirstSpanWidth,fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:SecondSpanWidth,color:'#000'}},' ',data["@SubHeading"],' ')));}else{if(data["@SubHeading"]==""){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["SubItem"],' ')));}else{// let Par='';
// if(val["@name"]==="Shared Storage"){
//     if( data["@SubHeading"]!=="Nimble"){
//             Par="-3PAR"
//     }
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["@SubHeading"],' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em'}},'Volume : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["SubItem"],' ')));}}}}else{if(data["@Heading"]==""||data["@Heading"]==undefined){if(data["#text"].indexOf(':')>-1){var SplitText=data["#text"].split(':');return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},SplitText[0]+' : ',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',SplitText[1],' '));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : ','  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["#text"],' '));}}});}else{var data=val.Display.Node;if(data["#text"]==undefined){if(data["@ChildHeading"]==""&&data["@Heading"]==""&&data["@SubHeading"]==""){}else{if(data["SubItem"]==undefined){var FirstSpanWidth='40%';var SecondSpanWidth='60%';if(data["@SubHeading"]==""){FirstSpanWidth='100%';SecondSpanWidth='0%';}ServerBOMItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:FirstSpanWidth,fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:SecondSpanWidth,color:'#000'}},' ',data["@SubHeading"],' ')));}else{if(data["@SubHeading"]==""){ServerBOMItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["SubItem"],' ')));}else{var Par='';//    if(val["@name"]==="Shared Storage"){
//        if( data["@SubHeading"]!=="Nimble"){
//             Par="-3PAR"
//     }
//    }
ServerBOMItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',margin:'none',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["@SubHeading"]+Par,' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em'}},'Volume : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["SubItem"],' ')));}}}}else{if(data["@Heading"]==""||data["@Heading"]==undefined){if(data["#text"].indexOf(':')>-1){var SplitText=data["#text"].split(':');ServerBOMItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},SplitText[0]+' : ',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',SplitText[1],' '));}}else{ServerBOMItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},data["@Heading"]+' : ','  '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',data["#text"],' '));}}}}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel___default.a,{heading:_this2.props.sizermode==='GPElements_VMaaSandCaaS'?val["@description"]:val["@name"]},_this2.props.sizermode==='GPElements_VMaaSandCaaS'?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_List___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},'Role Name : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'secondary',style:{fontSize:'0.785em',width:'60%',color:'#000'}},' ',val["@name"],' ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'40%',fontSize:'0.885em',color:'#000'}},'Description : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{fontSize:'0.785em',width:'60%',color:'#000'},className:'secondary'},' ',val["@description"],' ')),ServerBOMItems));});}},{key:'render',value:function render(){var _this3=this;var findActiveTab='';if(ActiveAccordianBgColor){findActiveTab="AccordianActiveTabfind";}else{findActiveTab='';}if(Array.isArray(this.props.MapContent.Item)){this.loopConfigureItems(this.props.MapContent.Item);}else{var data=[];data.push(this.props.MapContent.Item);this.loopConfigureItems(data);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',colorIndex:'light-2',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'5px',width:'100%',height:'7%'},separator:'bottom',justify:'between',onClick:this.onDivClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default.a,{tag:'h4',strong:true,margin:'none',style:{color:'#01a982'}},this.state.HeadingAcc,' ')),this.state.contentVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp___default.a,{size:'small'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown___default.a,{size:'small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:'none',style:{height:'93%',overflow:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',pad:'none',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate___default.a,{visible:this.state.contentVisible,keep:false,enter:{"animation":"slide-down","duration":200,"delay":0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion___default.a,{active:this.state.ActiveTabIndex1,className:findActiveTab,animate:this.state.animate,onActive:function onActive(e){return _this3.OpenParallelActive(e);},openMulti:true},ConfigDetailsOfRackServers)))));}}]);return ConfigureSolutionDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ConfigureSolutionDetails);

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(18);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactTransitionGroup = __webpack_require__(302);

var _classnames = __webpack_require__(3);

var _classnames2 = _interopRequireDefault(_classnames);

var _Box = __webpack_require__(8);

var _Box2 = _interopRequireDefault(_Box);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.COLLAPSIBLE;

var Collapse = function (_Component) {
  _inherits(Collapse, _Component);

  function Collapse() {
    _classCallCheck(this, Collapse);

    return _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).apply(this, arguments));
  }

  _createClass(Collapse, [{
    key: 'componentWillEnter',
    value: function componentWillEnter(callback) {
      var node = _reactDom2.default.findDOMNode(this);
      if (node) {
        var contentHeight = node.clientHeight;
        node.classList.remove('animate');
        node.style.height = 0;
        setTimeout(function () {
          node.classList.add('animate');
          node.style.height = contentHeight + 'px';
          setTimeout(callback, parseFloat(getComputedStyle(node).transitionDuration) * 1000);
        });
      }
    }
  }, {
    key: 'componentDidEnter',
    value: function componentDidEnter() {
      var node = _reactDom2.default.findDOMNode(this);
      node.classList.remove('animate');
      node.style.height = '';
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(callback) {
      var node = _reactDom2.default.findDOMNode(this);
      if (node) {
        var contentHeight = node.clientHeight;
        node.style.height = contentHeight + 'px';
        setTimeout(function () {
          node.classList.add('animate');
          node.style.height = 0;
          setTimeout(callback, parseFloat(getComputedStyle(node).transitionDuration) * 1000);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)(CLASS_ROOT, this.props.className);
      return _react2.default.createElement(_Box2.default, _extends({}, this.props, { className: classes }));
    }
  }]);

  return Collapse;
}(_react.Component);

Collapse.displayName = 'Collapse';

var Collapsible = function (_Component2) {
  _inherits(Collapsible, _Component2);

  function Collapsible() {
    _classCallCheck(this, Collapsible);

    return _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).apply(this, arguments));
  }

  _createClass(Collapsible, [{
    key: 'render',
    value: function render() {
      var Component = this.props.animate ? _reactTransitionGroup.TransitionGroup : _Box2.default;
      var collapseProps = _Props2.default.omit(this.props, Object.keys(Collapsible.propTypes));

      return _react2.default.createElement(
        Component,
        { className: CLASS_ROOT + '__wrapper' },
        this.props.active && _react2.default.createElement(Collapse, collapseProps)
      );
    }
  }]);

  return Collapsible;
}(_react.Component);

Collapsible.displayName = 'Collapsible';


Collapsible.propTypes = {
  active: _propTypes2.default.bool,
  animate: _propTypes2.default.bool
};

Collapsible.defaultProps = {
  animate: true
};

exports.default = Collapsible;
module.exports = exports['default'];

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Image__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_tooltip__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import GRInput from '../../Datafiles/GRInput.json';
//import Map from 'grommet/components/Map';
var Grinput;var NimbleGrPresentation=void 0;var Rearview=false;var Buttonlabel="Rear View";var NimbleStorage=function(_Component){_inherits(NimbleStorage,_Component);function NimbleStorage(props){_classCallCheck(this,NimbleStorage);var _this=_possibleConstructorReturn(this,(NimbleStorage.__proto__||Object.getPrototypeOf(NimbleStorage)).call(this,props));_this.View=_this.View.bind(_this);return _this;}_createClass(NimbleStorage,[{key:'View',value:function View(e){if(Rearview===false){Rearview=true;Buttonlabel="Front View";}else{Rearview=false;Buttonlabel="Rear View";}this.setState({});}},{key:'render',value:function render(){//Grinput=GRInput
Grinput=this.props.GRinput;var impath="../img/Nimble/GRE Images/";var RearViewpath="../img/Nimble/GRE Images/Rear View/";//console.log(Grinput)
//        var NimbleStoragedisplay="";
NimbleGrPresentation={allArray1:[],links:[]//         var group=1;   
//         var c;
/* Changees by Vinay, added Grinput.NimbleStorage.length!==undefined condition, for CID:10020 *///         c= Grinput.NimbleStorage !==undefined ? Grinput.NimbleStorage.length : '';
};var allArray=[];var currArray=[];var GroupId;/* Changees by Vinay, added Grinput.NimbleStorage !==undefined condition, for CID:10020 */if(Grinput.NimbleStorage!==undefined&&Grinput.NimbleStorage.length!==undefined){for(var i=0;i<Grinput.NimbleStorage.length;i++){if(i===0){currArray.push(Grinput.NimbleStorage[i]['@NimbleImageName']+'||'+Grinput.NimbleStorage[i]['@ControllerName']);GroupId=Grinput.NimbleStorage[i]['@Group'];}else{if(Grinput.NimbleStorage[i]['@Group']===GroupId){currArray.push(Grinput.NimbleStorage[i]['@NimbleImageName']+'||'+Grinput.NimbleStorage[i]['@ControllerName']);}else{allArray.push(currArray);currArray=[];currArray.push(Grinput.NimbleStorage[i]['@NimbleImageName']+'||'+Grinput.NimbleStorage[i]['@ControllerName']);GroupId=Grinput.NimbleStorage[i]['@Group'];}}}// if(allArray.length>0){
//      allArray.push(currArray);
// }
if(currArray.length>0){allArray.push(currArray);}}else{if(Grinput.NimbleStorage!==undefined){allArray.push(Grinput.NimbleStorage['@NimbleImageName']+'||'+Grinput.NimbleStorage['@ControllerName']);}}NimbleGrPresentation.allArray1.push(allArray);var storage=[];var storage1=[];NimbleGrPresentation.allArray1[0].map(function(item){//                            var c=item.length;
var src;if(Array.isArray(item)){storage=item.map(function(image){if(Rearview===false){src=impath+image.split('||')[0];}else{src=RearViewpath+image.split('||')[0];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{pad:{between:'large'},'data-tip':image.split('||')[1]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Image___default.a,{src:src,className:'NimbleImage',size:'medium'}));});storage1.push(storage);}else{if(Rearview===false){src=impath+item.split('||')[0];}else{src=RearViewpath+item.split('||')[0];}storage1.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{pad:{between:'large'},'data-tip':item.split('||')[1]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Image___default.a,{src:src,className:'NimbleImage',size:'medium'})));}});var images=storage1.map(function(item){// var hovertext=
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{pad:{between:'large'}},item);});//    NimbleStoragedisplay=<Box  margin="none"  pad={{between:'small'}}  style={{height:'100%',width:'100%'}}>
//                         <Box  direction='row'margin="none"calssName="storageNimble"  pad={{between:'small'}}  style={{height:'100%',width:'100%'}}>
//                          {images}
//                         {/*   <Map  vertical={true} data= {storage1} className="GrMap" style={{width:'100%'}}/>  */}
//                          </Box>    
//                         </Box>                
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{height:'100%',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',align:'start',basis:'1/4',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{margin:'none',pad:'none',style:{marginLeft:'20px'},className:'Viewbutton',full:true,label:Buttonlabel,onClick:this.View})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_tooltip___default.a,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{className:'storageNimble'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'large',justify:'center',pad:'none',style:{height:'500px'}},images)));}}]);return NimbleStorage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{GRinput:state.sessions.activeSession.GRInput};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,null)(NimbleStorage));

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_ZoomIn__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_ZoomIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_ZoomIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_ZoomOut__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_ZoomOut___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_ZoomOut__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_Overview__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_Overview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_Overview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RackDetails__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_html2canvas__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_tooltip__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__SizerUI_SizerConfig_Config_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_jquery__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AppConfig__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import GRInputRack from '../../Datafiles/GRInput.json';
var RackServersPresentation=void 0;var FrontView;var RacksInsideServers=void 0;var EventTopspace=void 0;var RacksDisplaying=void 0;var EventLeftspace=void 0;var HoverTitleStyle;var RackHeight;var RearviewHOverItems=void 0;var RackInnerHeight;var CountNewWindowOpen=0;var RackNote;var SSETSolutionName='Solution Layout';var EPAvNext="EPAvNext";var DisplayName="@DisplayName";var ToolTip="@ToolTip";var EmptyImage="@EmptyImage";var GrRackServerInnerPresentation=function(_Component){_inherits(GrRackServerInnerPresentation,_Component);function GrRackServerInnerPresentation(){_classCallCheck(this,GrRackServerInnerPresentation);var _this=_possibleConstructorReturn(this,(GrRackServerInnerPresentation.__proto__||Object.getPrototypeOf(GrRackServerInnerPresentation)).call(this));_this.state={scaleRadiusX:1,scaleRadiusY:1,disabledZoomOut:false,disabledZoomIn:false,RackInnerView:false,RackRearView:true,ViewLabelbtn:'Rear View',ActiveSite:'',TopAlignServer:'',TitleDisplay:false,ServerItemName:'D123467',MinRackHeight:700,rackNoteDisplay:true};_this.ZoomIn=_this.ZoomIn.bind(_this);_this.ZoomOut=_this.ZoomOut.bind(_this);_this.RearView=_this.RearView.bind(_this);_this.RevertBack=_this.RevertBack.bind(_this);_this.OuterLayerLoop=_this.OuterLayerLoop.bind(_this);_this.PrintImage=_this.PrintImage.bind(_this);_this.PrintImageURI=_this.PrintImageURI.bind(_this);_this.VoucherSourcetoPrint=_this.VoucherSourcetoPrint.bind(_this);_this.downloadPDF=_this.downloadPDF.bind(_this);_this.GRHoverTextUpdate=_this.GRHoverTextUpdate.bind(_this);return _this;}_createClass(GrRackServerInnerPresentation,[{key:'PrintImage',value:function PrintImage(){var _this2=this;this.setState({scaleRadiusX:0.6,MinRackHeight:600,scaleRadiusY:0.5,rackNoteDisplay:false});CountNewWindowOpen++;__WEBPACK_IMPORTED_MODULE_19_jquery___default()(".RackImageDisplay").css({"marginBottom":"200px","marginTop":"85px"});__WEBPACK_IMPORTED_MODULE_13_html2canvas___default()(document.querySelector("#capture")).then(function(canvas){_this2.PrintImageURI(canvas.toDataURL(),'Solution.png');});}},{key:'PrintImageURI',value:function PrintImageURI(url,filename){var Pagelink="about:blank";var pwa=window.open(Pagelink,"_new");pwa.document.open();pwa.document.write(this.VoucherSourcetoPrint(url));pwa.document.close();}},{key:'VoucherSourcetoPrint',value:function VoucherSourcetoPrint(url){return"<html><head><script>function step1(){\n"+"setTimeout('step2()', 10);}\n"+"function step2(){window.print();window.close()}\n"+"</script></head><body onload='step1()'>\n"+"<img style='width:100%,height:100%' src='"+url+"'}} /></body></html>";}},{key:'GRHoverTextUpdate',value:function GRHoverTextUpdate(product){if(product[DisplayName]!==undefined){return product[DisplayName];}else{return __WEBPACK_IMPORTED_MODULE_16__SizerUI_SizerConfig_Config_js__["d" /* _said */]===EPAvNext&&product[ToolTip]!==undefined?product[ToolTip]:product[EmptyImage].slice(0,-4);}}},{key:'downloadPDF',value:function downloadPDF(format){var isRearView=this.state.RackRearView?false:true;var pdfName=void 0,sessionId=void 0;if(this.props.isFromExternalApp){sessionId=this.props.externalAppProps.sizerReference;pdfName=SSETSolutionName;}else{sessionId=this.props.activeSession.id;pdfName=this.props.activeSession.alias;}pdfName+=" "+Date().substr(4).split('GMT')[0]+".pdf";var pdfUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["g" /* serviceUrl */]+"SizingEngine/GenerateGRpdf?&sessionId="+sessionId+"&name="+pdfName.replace('#','-')+"&isRearView="+isRearView;if(this.props.activeSession.EPAArray&&this.props.activeSession.EPAArray.length>0){pdfUrl+="&EPASolutionType="+this.props.actvSoln;}var data={url:pdfUrl,name:pdfName};this.props.onPDFExport(data);}},{key:'OuterLayerLoop',value:function OuterLayerLoop(idx){var _this3=this;if(Array.isArray(this.state.GrInputRearView.OuterLayer)){if(this.props.PassActiveSite["@SiteID"]==undefined){FrontView=this.state.GrInputRearView.OuterLayer[idx];}else{FrontView=this.state.GrInputRearView.OuterLayer[this.props.PassActiveSite["@SiteID"]];}}else{FrontView=this.state.GrInputRearView.OuterLayer;}if(Array.isArray(FrontView.InnerLayers.InnerLayer)){RacksInsideServers=FrontView.InnerLayers.InnerLayer.map(function(val){var Server=void 0;var InnerServrsHeight=parseInt(val["@Height"].replace("U",""),10)*16;if(val.Item!==undefined){var ServerImgPath=void 0;if(_this3.state.RackRearView){ServerImgPath=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/";}else{ServerImgPath="";}if(val["@EmptyImage"]=="C3000.gif"){var _topstyle=void 0,_leftstyle=void 0,_bottomstyle=void 0,_widthStyle=void 0,_heightStyle=void 0;Server=val.Item.map(function(bladeServer){var serverPosition=bladeServer["@BaysOccupied"];if(serverPosition.split('+').length===1){_widthStyle='50%';_heightStyle='25%';if(serverPosition==1||serverPosition==5){_topstyle='0px';_bottomstyle='';_leftstyle=serverPosition==1?'0%':'50%';}else if(serverPosition==2||serverPosition==6){_topstyle='25%';_bottomstyle='';_leftstyle=serverPosition==2?'0%':'50%';}else if(serverPosition==3||serverPosition==7){_topstyle='';_bottomstyle='25%';_leftstyle=serverPosition==3?'0%':'50%';}else{_topstyle='';_bottomstyle='0px';_leftstyle=serverPosition==4?'0%':'50%';}}else{var serverPositionArray=serverPosition.split('+');if(serverPositionArray.length===2){if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+1).toString())===1){_widthStyle='50%';_heightStyle='50%';}else if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+4).toString())===1){_widthStyle='100%';_heightStyle='25%';}}else if(serverPositionArray.length===4){_widthStyle='100%';_heightStyle='50%';}if(serverPositionArray[0]==1||serverPositionArray[0]==5){_topstyle='0px';_bottomstyle='';_leftstyle=serverPositionArray[0]==1?'0%':'50%';}else if(serverPositionArray[0]==2||serverPositionArray[0]==6){_topstyle='25%';_bottomstyle='';_leftstyle=serverPositionArray[0]==2?'0%':'50%';}else if(serverPositionArray[0]==3||serverPositionArray[0]==7){_topstyle='';_bottomstyle='25%';_leftstyle=serverPositionArray[0]==3?'0%':'50%';}else{_topstyle='';_bottomstyle='0px';_leftstyle=serverPositionArray[0]==4?'0%':'50%';}}var AlignementCss={position:'absolute',width:_widthStyle,bottom:_bottomstyle,top:_topstyle,left:_leftstyle,height:_heightStyle};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',style:AlignementCss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',id:bladeServer["@EmptyImage"].slice(0,-4),className:'ServerItemsHover',style:{width:'100%',height:'100%',backgroundImage:'url("'+ServerImgPath+bladeServer["@EmptyImage"]+'")'},'data-tip':_this3.GRHoverTextUpdate(bladeServer)}));});}else if(val["@EmptyImage"]=="Synergy 12000.gif"||val["@EmptyImage"]=="C7000.gif"){var baysInaRow=6;var widthOfEachBay=100/6;if(val["@EmptyImage"]!="Synergy 12000.gif"){baysInaRow=8;widthOfEachBay=100/8;}var _topstyle2=void 0,_leftstyle2=void 0,_bottomstyle2=void 0,_widthStyle2=void 0,_heightStyle2=void 0;Server=val.Item.map(function(synergyServer){var serverPosition=synergyServer["@BaysOccupied"];if(serverPosition.split('+').length===1){_widthStyle2=widthOfEachBay.toString()+'%';_heightStyle2='50%';if(serverPosition<=baysInaRow){_topstyle2='0px';_bottomstyle2='';_leftstyle2=((serverPosition-1)*widthOfEachBay).toString()+'%';}else{_topstyle2='';_bottomstyle2='0px';_leftstyle2=((serverPosition-baysInaRow-1)*widthOfEachBay).toString()+'%';}}else{var serverPositionArray=serverPosition.split('+');if(serverPositionArray.length===2){if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+1).toString())===1){_widthStyle2=(widthOfEachBay*2).toString()+'%';_heightStyle2='50%';}else if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+baysInaRow).toString())===1){_widthStyle2=widthOfEachBay.toString()+'%';_heightStyle2='100%';}}else if(serverPositionArray.length===4){_widthStyle2=(widthOfEachBay*2).toString()+'%';_heightStyle2='100%';}if(serverPositionArray[0]<=baysInaRow){_topstyle2='0px';_bottomstyle2='';_leftstyle2=((serverPositionArray[0]-1)*widthOfEachBay).toString()+'%';}else{_topstyle2='';_bottomstyle2='0px';_leftstyle2=((serverPositionArray[0]-baysInaRow-1)*widthOfEachBay).toString()+'%';}}var AlignementCss={position:'absolute',width:_widthStyle2,bottom:_bottomstyle2,top:_topstyle2,left:_leftstyle2,height:_heightStyle2};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',style:AlignementCss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',id:synergyServer["@EmptyImage"].slice(0,-4),className:'ServerItemsHover',style:{width:'100%',height:'100%',backgroundImage:'url("'+ServerImgPath+synergyServer["@EmptyImage"]+'")'},'data-tip':_this3.GRHoverTextUpdate(synergyServer)}));});}}var ImgPathUrl='';if(val["@EmptyImage"]==="C7000.gif"||val["@EmptyImage"]==="C3000.gif"||val["@EmptyImage"]==="Synergy 12000.gif"){if(_this3.state.RackRearView){ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/Enclosure/";}else{ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/Rear View/";}}else{if(_this3.state.RackRearView){ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/";}else{ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/Rear View/";}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',margin:'none',pad:'none',className:'',style:{height:InnerServrsHeight,width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',margin:'none',pad:'none',className:'RackItemsHover',style:{height:'100%',width:'4px',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")'}},' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',id:val["@EmptyImage"].slice(0,-4),separator:'top',className:'12345',style:{height:'100%',width:'100%',position:'relative',Padding:'4px',backgroundImage:'url("'+ImgPathUrl+val["@EmptyImage"]+'")'},'data-tip':_this3.GRHoverTextUpdate(val)},Server),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',className:'RackItemsHover',margin:'none',pad:'none',style:{height:'100%',width:'4px',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")'}},' '));});}else{var Server=void 0;var InnerServrsHeight=parseInt(FrontView.InnerLayers.InnerLayer["@Height"].replace("U",""),10)*16;var ImgPathUrl='';if(FrontView.InnerLayers.InnerLayer.Item!==undefined){var ServerImgPath=void 0;if(this.state.RackRearView){ServerImgPath=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/";}else{ServerImgPath="";}if(FrontView.InnerLayers.InnerLayer["@EmptyImage"]=="C3000.gif"){var topstyle,leftstyle,bottomstyle,widthStyle,heightStyle;Server=FrontView.InnerLayers.InnerLayer.Item.map(function(bladeServer){var serverPosition=bladeServer["@BaysOccupied"];if(serverPosition.split('+').length===1){widthStyle='50%';heightStyle='25%';if(serverPosition==1||serverPosition==5){topstyle='0px';bottomstyle='';leftstyle=serverPosition==1?'0%':'50%';}else if(serverPosition==2||serverPosition==6){topstyle='25%';bottomstyle='';leftstyle=serverPosition==2?'0%':'50%';}else if(serverPosition==3||serverPosition==7){topstyle='';bottomstyle='25%';leftstyle=serverPosition==3?'0%':'50%';}else{topstyle='';bottomstyle='0px';leftstyle=serverPosition==4?'0%':'50%';}}else{var serverPositionArray=serverPosition.split('+');if(serverPositionArray.length===2){if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+1).toString())===1){widthStyle='50%';heightStyle='50%';}else if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+4).toString())===1){widthStyle='100%';heightStyle='25%';}}else if(serverPositionArray.length===4){widthStyle='100%';heightStyle='50%';}if(serverPositionArray[0]==1||serverPositionArray[0]==5){topstyle='0px';bottomstyle='';leftstyle=serverPositionArray[0]==1?'0%':'50%';}else if(serverPositionArray[0]==2||serverPositionArray[0]==6){topstyle='25%';bottomstyle='';leftstyle=serverPositionArray[0]==2?'0%':'50%';}else if(serverPositionArray[0]==3||serverPositionArray[0]==7){topstyle='';bottomstyle='25%';leftstyle=serverPositionArray[0]==3?'0%':'50%';}else{topstyle='';bottomstyle='0px';leftstyle=serverPositionArray[0]==4?'0%':'50%';}}var AlignementCss={position:'absolute',width:widthStyle,bottom:bottomstyle,top:topstyle,left:leftstyle,height:heightStyle};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',style:AlignementCss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',id:bladeServer["@EmptyImage"].slice(0,-4),className:'ServerItemsHover',style:{width:'100%',height:'100%',backgroundImage:'url("'+ServerImgPath+bladeServer["@EmptyImage"]+'")'},'data-tip':_this3.GRHoverTextUpdate(bladeServer)}));});}else if(FrontView.InnerLayers.InnerLayer["@EmptyImage"]=="Synergy 12000.gif"||FrontView.InnerLayers.InnerLayer["@EmptyImage"]=="C7000.gif"){var baysInaRow=6;var widthOfEachBay=100/6;if(FrontView.InnerLayers.InnerLayer["@EmptyImage"]!="Synergy 12000.gif"){baysInaRow=8;widthOfEachBay=100/8;}var _topstyle3=void 0,_leftstyle3=void 0,_bottomstyle3=void 0,_widthStyle3=void 0,_heightStyle3=void 0;Server=FrontView.InnerLayers.InnerLayer.Item.map(function(synergyServer){var serverPosition=synergyServer["@BaysOccupied"];if(serverPosition.split('+').length===1){_widthStyle3=widthOfEachBay.toString()+'%';_heightStyle3='50%';if(serverPosition<=baysInaRow){_topstyle3='0px';_bottomstyle3='';_leftstyle3=((serverPosition-1)*widthOfEachBay).toString()+'%';}else{_topstyle3='';_bottomstyle3='0px';_leftstyle3=((serverPosition-baysInaRow-1)*widthOfEachBay).toString()+'%';}}else{var serverPositionArray=serverPosition.split('+');if(serverPositionArray.length===2){if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+1).toString())===1){_widthStyle3=(widthOfEachBay*2).toString()+'%';_heightStyle3='50%';}else if(serverPositionArray.indexOf((parseInt(serverPositionArray[0],10)+baysInaRow).toString())===1){_widthStyle3=widthOfEachBay.toString()+'%';_heightStyle3='100%';}}else if(serverPositionArray.length===4){_widthStyle3=(widthOfEachBay*2).toString()+'%';_heightStyle3='100%';}if(serverPositionArray[0]<=baysInaRow){_topstyle3='0px';_bottomstyle3='';_leftstyle3=((serverPositionArray[0]-1)*widthOfEachBay).toString()+'%';}else{_topstyle3='';_bottomstyle3='0px';_leftstyle3=((serverPositionArray[0]-baysInaRow-1)*widthOfEachBay).toString()+'%';}}var AlignementCss={position:'absolute',width:_widthStyle3,bottom:_bottomstyle3,top:_topstyle3,left:_leftstyle3,height:_heightStyle3};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',style:AlignementCss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',id:synergyServer["@EmptyImage"].slice(0,-4),className:'ServerItemsHover',style:{width:'100%',height:'100%',backgroundImage:'url("'+ServerImgPath+synergyServer["@EmptyImage"]+'")'},'data-tip':_this3.GRHoverTextUpdate(synergyServer)}));});}}if(FrontView.InnerLayers.InnerLayer["@EmptyImage"]==="C7000.gif"||FrontView.InnerLayers.InnerLayer["@EmptyImage"]==="C3000.gif"||FrontView.InnerLayers.InnerLayer["@EmptyImage"]==="Synergy 12000.gif"){if(this.state.RackRearView){ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/Enclosure/";}else{ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/Rear View/";}}else{if(this.state.RackRearView){ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/";}else{ImgPathUrl=__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"/img/SizingEngine/Images/GRE Images/Rear View/";}}RacksInsideServers=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',margin:'none',pad:'none',className:'',style:{height:InnerServrsHeight,width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',margin:'none',pad:'none',className:'RackItemsHover',style:{height:'100%',width:'4px',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")'}},' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row','data-tip':this.GRHoverTextUpdate(FrontView.InnerLayers.InnerLayer),justify:'start',align:'start',className:'idxse',separator:'top',style:{height:'100%',width:'100%',position:'relative',Padding:'4px',backgroundImage:'url("'+ImgPathUrl+FrontView.InnerLayers.InnerLayer["@EmptyImage"]+'")'}},'      ',Server),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',className:'RackItemsHover',margin:'none',pad:'none',style:{height:'100%',width:'4px',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+'/img/SizingEngine/Images/GRE Images/BlankDetails.png")'}},' '));}}},{key:'ZoomIn',value:function ZoomIn(){var ZoomScaleX=0.05;__WEBPACK_IMPORTED_MODULE_19_jquery___default()(".RackImageDisplay").css({"marginTop":"150px","marginLeft":"100px",margin:"100px"});if(this.state.scaleRadiusX===1){__WEBPACK_IMPORTED_MODULE_19_jquery___default()(".RackImageDisplay").css({"marginTop":"270px","marginLeft":"100px"});this.setState({scaleRadiusX:this.state.scaleRadiusX+ZoomScaleX,scaleRadiusY:this.state.scaleRadiusY,MinRackHeight:this.state.MinRackHeight,disabledZoomOut:false});}else if(this.state.scaleRadiusX>1){}else if(this.state.scaleRadiusX===0.8){__WEBPACK_IMPORTED_MODULE_19_jquery___default()(".RackImageDisplay").css({"marginTop":"270px","marginLeft":"100px"});this.setState({scaleRadiusX:this.state.scaleRadiusX=1,scaleRadiusY:this.state.scaleRadiusY,MinRackHeight:this.state.MinRackHeight+50,disabledZoomOut:false});}else{this.setState({scaleRadiusX:this.state.scaleRadiusX+ZoomScaleX,scaleRadiusY:this.state.scaleRadiusY,MinRackHeight:this.state.MinRackHeight+50,disabledZoomOut:false});}}},{key:'ZoomOut',value:function ZoomOut(){var ZoomScaleX=0.2;if(this.state.scaleRadiusX<0.9){}else{this.setState({scaleRadiusX:this.state.scaleRadiusX-ZoomScaleX,MinRackHeight:this.state.MinRackHeight-50,scaleRadiusY:this.state.scaleRadiusY});}}},{key:'componentWillMount',value:function componentWillMount(){this.state.ActiveSite=this.props.PassActiveSite["@SiteID"];/* Static GRinput file *///this.state.GrInputRearView= GRInputRack.GraphicalInputs;
/* dynamic GRinput file */this.state.GrInputRearView=this.props.activeSession.GRInput;this.RackInsideServers();}},{key:'RackInsideServers',value:function RackInsideServers(){var _this4=this;if(this.state.GrInputRearView.OuterLayer.length>1&&this.state.GrInputRearView.OuterLayer[1]["@Site"]==this.state.GrInputRearView.OuterLayer[0]["@Site"]){RacksDisplaying=this.state.GrInputRearView.OuterLayer.map(function(Rackitem,id){_this4.OuterLayerLoop(id);var RackHeight=parseInt(Rackitem["@Height"].replace("U",""),10)*17.4;var RackInnerHeight=parseInt(Rackitem["@Height"].replace("U",""),10)*16;var idname="Rackitem"+id.toString();return(/*Change by Vinay, removed width for colliding rack images issue in I.E Browser*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'small',pad:'none',id:idname,className:'RackImageDisplay',style:{/* width: '200px', */marginTop:'100px',transform:'scale('+_this4.state.scaleRadiusX+','+_this4.state.scaleRadiusX+')'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{strong:true,align:'center',uppercase:false,truncate:false,tag:'h4',style:{paddingTop:'88px'}},Rackitem["@Name"],' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{justify:'center',pad:'none',margin:'small',align:'center',style:{width:'200px',height:RackHeight+'px',transform:'scale('+_this4.state.scaleRadiusX+','+_this4.state.scaleRadiusX+')',transition:'all 0.5s ease-in-out',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"img/SizingEngine/Images/GRE Images/"+FrontView["@OuterLayerImage"]+'")'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{align:'end',pad:'none',margin:'none',reverse:true,style:{height:RackInnerHeight,width:'77%',margin:'auto',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+'img/SizingEngine/Images/GRE Images/Blank.png")',marginBottom:'4%',marginTop:'3%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{align:'end',reverse:true,className:'',style:{height:RackInnerHeight,width:'100%',margin:'auto',marginBottom:'10px'}},RacksInsideServers))),'  '));});}else{var data=this.state.GrInputRearView.OuterLayer;if(Array.isArray(data)){this.OuterLayerLoop(0);FrontView=this.state.GrInputRearView.OuterLayer[0];}else{this.OuterLayerLoop();if(this.props.PassActiveSite["@SiteID"]==undefined){FrontView=this.state.GrInputRearView.OuterLayer;}else{FrontView=this.state.GrInputRearView.OuterLayer[this.props.PassActiveSite["@SiteID"]];}}RackHeight=parseInt(FrontView["@Height"].replace("U",""),10)*17.4;RackInnerHeight=parseInt(FrontView["@Height"].replace("U",""),10)*16;/*Change by Vinay, removed width for colliding rack images issue in I.E Browser*/RacksDisplaying=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'small',pad:'none',id:'Rackitem0',className:'RackImageDisplay',style:{width:'200px',marginTop:'100px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{strong:true,align:'center',uppercase:false,truncate:false,tag:'h4'},FrontView["@Name"],' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{justify:'center',pad:'none',margin:'small',align:'center',style:{width:'100%',height:RackHeight+'px',transform:'scale('+this.state.scaleRadiusX+','+this.state.scaleRadiusX+')',transition:'all 0.5s ease-in-out',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */]+"img/SizingEngine/Images/GRE Images/"+FrontView["@OuterLayerImage"]+'")'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{align:'end',pad:'none',margin:'none',reverse:true,style:{height:RackInnerHeight+'px',width:'77%',margin:'auto',backgroundImage:'url("'+__WEBPACK_IMPORTED_MODULE_20__AppConfig__["a" /* appUrl */].toString()+'img/SizingEngine/Images/GRE Images/Blank.png")',marginBottom:'4%',marginTop:'3%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{align:'end',reverse:true,style:{height:RackInnerHeight,width:'100%',margin:'auto',marginBottom:'10px'}},RacksInsideServers))));}RackServersPresentation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',id:'captures',justify:'center',align:'center',style:{width:'100%',minHeight:this.state.MinRackHeight+'px',maxHeight:'900px',position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',justify:'left',align:'end',style:{width:'100%'}},RacksDisplaying));}},{key:'RevertBack',value:function RevertBack(){this.props.RackserverView(true);}},{key:'RearView',value:function RearView(){if(!this.state.RackRearView){this.setState({ViewLabelbtn:'Rear View',RackRearView:true});}else{this.setState({ViewLabelbtn:'Front View',RackRearView:false});}}},{key:'render',value:function render(){var _this5=this;var RackDet=this.props.activeSession.GRInput;HoverTitleStyle={color:'black',width:'auto',height:'auto',padding:'2px 4px',position:'absolute',top:EventTopspace-10+'px',left:EventLeftspace-10+'px',zIndex:'220',backgroundColor:'#cccccc',border:''};if(this.state.rackNoteDisplay===true){RackNote=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_grommet_components_Paragraph___default.a,{style:{color:"red",margin:"10px",maxWidth:'100%',fontSize:'15px'}},'Note: The above graphical representation gives an overall idea about Rack and its components. The actual positioning/placement may vary depending on the user needs.');}else{RackNote=" ";}this.RackInsideServers();if(this.state.RackRearView){RearviewHOverItems=this.state.TitleDisplay?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none',style:HoverTitleStyle},this.state.ServerItemName):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,null);}else{RearviewHOverItems="";}var wdth='100%';if(__WEBPACK_IMPORTED_MODULE_16__SizerUI_SizerConfig_Config_js__["d" /* _said */]==="EPAvNext"){wdth='75%';}var PDFloadingLayer="";if(this.props.isLoading){PDFloadingLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_grommet_components_Layer___default.a,{className:'PDFlayer',style:{zIndex:'1000002 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px',backgroundColor:"#425563"},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default.a,{size:'small',style:{color:"#fff"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h5',margin:'none',style:{color:"#fff"}},this.props.LoadingMsg)));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none',className:'GrTabSection',justify:'start',align:'center',style:{height:'100%',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react_tooltip___default.a,{style:{height:'100%'}}),PDFloadingLayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'none',className:'GrTabSection',justify:'start',align:'center',style:{height:'90%',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',align:'start',separator:'right',style:{height:'100%',width:'25%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{className:'SolutionConfigAccordian',justify:'start',margin:'none',pad:'none',align:'start',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__RackDetails__["a" /* default */],{MapContent:RackDet.OuterLayer,summary:RackDet.ConsolidateRack}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{className:'HrSecPres',margin:'none',pad:'small',justify:'center',align:'start',style:{width:wdth}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:'small',justify:'center',style:{minHeight:'400px',maxHeight:'700px',width:'100%',overflow:'auto'}},RearviewHOverItems,RackServersPresentation))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{alignSelf:'baseline',width:'100%',height:'10%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',align:'start',basis:'1/4',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{separator:'bottom',direction:'row',margin:'none',justify:'start',className:'ZoomSectionBtns',style:{width:'100%'}},this.props.isFromExternalApp?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_base_Print___default.a,{size:'small',colorIndex:'accent-3'}),'data-tip':'Print',primary:false,onClick:this.PrintImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_icons_base_Save___default.a,{size:'small',colorIndex:'accent-3'}),'data-tip':'Export to PDF',primary:false,onClick:function onClick(){return _this5.downloadPDF("pdf");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_icons_base_ZoomIn___default.a,{size:'small',colorIndex:'accent-3'}),'data-tip':'Zoom in',primary:false,disabled:this.state.disabledZoomIn,onClick:this.ZoomIn}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_icons_base_ZoomOut___default.a,{size:'small',colorIndex:'accent-3'}),'data-tip':'Zoom out',primary:false,disabled:this.state.disabledZoomOut,onClick:this.ZoomOut}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_icons_base_Revert___default.a,{size:'small',colorIndex:'accent-3'}),'data-tip':'Back',primary:false,onClick:this.RevertBack}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Button___default.a,{icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_icons_base_Overview___default.a,{size:'small',colorIndex:'accent-3'}),'data-tip':this.state.ViewLabelbtn,primary:false,onClick:this.RearView}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',align:'start',basis:'3/4',style:{height:'100%'}},RackNote)));}}]);return GrRackServerInnerPresentation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession,isLoading:state.sessions.isLoading,LoadingMsg:state.sessions.LoadingMsg};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onfetchGRinput:function onfetchGRinput(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["y" /* fetchGRinput */])(sessionID));},onPDFExport:function onPDFExport(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["m" /* downloadFile */])(data));}};};//export default GrRackServerPresentation;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GrRackServerInnerPresentation));

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-zoom-in', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'zoom-in');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,15 L10,5 M5,10 L15,10' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'ZoomIn';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-zoom-out', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'zoom-out');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M16,16 L23,23 L16,16 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M5,10 L15,10' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'ZoomOut';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _Props = __webpack_require__(6);

var _Props2 = _interopRequireDefault(_Props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2015 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.CONTROL_ICON;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _classnames;

      var _props = this.props,
          className = _props.className,
          colorIndex = _props.colorIndex;
      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          size = _props2.size,
          responsive = _props2.responsive;
      var intl = this.context.intl;


      var classes = (0, _classnames3.default)(CLASS_ROOT, CLASS_ROOT + '-overview', className, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _classnames));

      a11yTitle = a11yTitle || _Intl2.default.getMessage(intl, 'overview');

      var restProps = _Props2.default.omit(this.props, Object.keys(Icon.propTypes));
      return _react2.default.createElement(
        'svg',
        _extends({}, restProps, { version: '1.1', viewBox: '0 0 24 24', width: '24px', height: '24px', role: 'img', className: classes, 'aria-label': a11yTitle }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#000', strokeWidth: '2', d: 'M18.5,21 C20.9852814,21 23,18.9852814 23,16.5 C23,14.0147186 20.9852814,12 18.5,12 C16.0147186,12 14,14.0147186 14,16.5 C14,18.9852814 16.0147186,21 18.5,21 L18.5,21 Z M10,7 L14,7 M1.5,14.5 C1.5,14.5 5.5,5 6,4 C6.5,3 7.5,3 8,3 C8.5,3 10,3 10,5 L10,16 M5.5,21 C3.01471863,21 1,18.9852814 1,16.5 C1,14.0147186 3.01471863,12 5.5,12 C7.98528137,12 10,14.0147186 10,16.5 C10,18.9852814 7.98528137,21 5.5,21 L5.5,21 L5.5,21 Z M22.5,14.5 C22.5,14.5 18.5,5 18,4 C17.5,3 16.5,3 16,3 C15.5,3 14,3 14,5 L14,16 M10,16 L14,16' })
      );
    }
  }]);

  return Icon;
}(_react.Component);

Icon.displayName = 'Icon';
exports.default = Icon;
;

Icon.contextTypes = {
  intl: _propTypes2.default.object
};

Icon.defaultProps = {
  responsive: true
};

Icon.displayName = 'Overview';

Icon.icon = true;

Icon.propTypes = {
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge', 'huge']),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ConfigDetailsOfRackServers=void 0;var ServerBOMItems=[];//var ConfigDetails = [];
var ActiveAccordianBgColor;var RackDetails=function(_Component){_inherits(RackDetails,_Component);function RackDetails(){_classCallCheck(this,RackDetails);var _this=_possibleConstructorReturn(this,(RackDetails.__proto__||Object.getPrototypeOf(RackDetails)).call(this));_this.styledHeading=function(heading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sapn',{style:{fontSize:'0.95em',fontWeight:'bold'}},heading);};_this.getSummary=function(){var list=[];if(_this.props.summary){_this.props.summary[0].Item.forEach(function(item){var name=item['@Name'];if(item['@Type']!=='Servers'){name=item['@Name'].split(',');}if(name.length>1&&item['@Type']!=='Servers'){name.forEach(function(element,index){if(index===0)list.push(item['@Quantity']+' X '+element);else list.push(''+element);});}else{list.push(item['@Type']+' :  '+item['@Quantity']+' X '+item['@Name']);}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel___default.a,{heading:'Summary'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_List___default.a,null,list.map(function(element){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontSize:'0.835em',color:'#000'}},element));})));};_this.state={contentVisible:true,HeadingAcc:'Collapse Configure Solution',ActiveTabIndex1:[0],Activedata:'',animate:true};_this.onDivClick=_this.onDivClick.bind(_this);_this.loopConfigureItems=_this.loopConfigureItems.bind(_this);_this.OpenParallelActive=_this.OpenParallelActive.bind(_this);return _this;}_createClass(RackDetails,[{key:'OpenParallelActive',value:function OpenParallelActive(e){ActiveAccordianBgColor=false;var array=[];array=e;this.setState({ActiveTabIndex1:array});}},{key:'onDivClick',value:function onDivClick(){var SetTitle;if(!this.state.contentVisible){SetTitle='Collapse Configure Solution';}else{SetTitle='Expand Configure Solution';}this.setState({contentVisible:!this.state.contentVisible,HeadingAcc:SetTitle});}// componentWillMount() {
//     ConfigDetails = this.props.MapContent.Item;
// }
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){}},{key:'ChildAccordianActive',value:function ChildAccordianActive(d){var index=0;if(Array.isArray(this.props.MapContent)){this.props.MapContent.map(function(val,id){if(d==val["@Name"]){index=id;}});}var array=[];array.push(index);ActiveAccordianBgColor=true;this.setState({ActiveTabIndex1:array});this.setState({animate:true});}},{key:'loopConfigureItems',value:function loopConfigureItems(Arraydata){var _this2=this;ConfigDetailsOfRackServers=Arraydata.map(function(val,idx){ServerBOMItems=[];if(val.RackComponents){if(Array.isArray(val.RackComponents.Roles.Role)){val.RackComponents.Roles.Role.map(function(role){role.Item.map(function(rackwise,id){if(Array.isArray(rackwise)){rackwise.map(function(data){if(data['@Name']==="HP Moonshot System"){data['@Name']="HPE Moonshot System";}/* Changes for displaying rack details in multiple lines*/var Data=[];if(data['@Name']!==undefined){Data=data['@Name'].split(',');}if(Data.length>1){ServerBOMItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontSize:'0.835em',color:'#000'}},_this2.styledHeading(data['@Quantity']+' x '+Data[0]+", "+Data[1]),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',Data[2],' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',Data[3],'  ')));}else{ServerBOMItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontSize:'0.835em',color:'#000'}},data['@Quantity']+' x '+data['@Name'],'  ')));}});}else{if(rackwise['@Name']==="HP Moonshot System"){rackwise['@Name']="HPE Moonshot System";}var Data=[];if(rackwise['@Name']!==undefined){Data=rackwise['@Name'].split(',');}if(Data.length>1){ServerBOMItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontSize:'0.835em',color:'#000'}},_this2.styledHeading(rackwise['@Quantity']+' x '+Data[0]+", "+Data[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',Data[2],' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),' ',Data[3],' ')));}else{ServerBOMItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontSize:'0.835em',color:'#000'}},rackwise['@Quantity']+' x '+rackwise['@Name'],'  ')));}}});});}else{if(val.RackComponents.Roles.Role.Item['@Name']==="HP Moonshot System"){val.RackComponents.Roles.Role.Item['@Name']="HPE Moonshot System";}ServerBOMItems.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_ListItem___default.a,{align:'start',alignContent:'start',justify:'between',className:'ListItemsCls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:'100%',fontSize:'0.835em',color:'#000'}},val.RackComponents.Roles.Role.Item['@Quantity']+' x '+val.RackComponents.Roles.Role.Item['@Name'],'  ')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_AccordionPanel___default.a,{heading:val["@Name"]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_List___default.a,null,ServerBOMItems));}});}},{key:'render',value:function render(){var _this3=this;var findActiveTab='';ServerBOMItems=[];if(ActiveAccordianBgColor){findActiveTab="AccordianActiveTabfind";}else{findActiveTab='';}if(Array.isArray(this.props.MapContent)){this.loopConfigureItems(this.props.MapContent);}else{var data=[];data.push(this.props.MapContent);this.loopConfigureItems(data);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',justify:'start',colorIndex:'light-2',style:{width:'100%',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',style:{padding:'5px',width:'100%',height:'7%'},separator:'bottom',justify:'between',onClick:this.onDivClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Heading___default.a,{tag:'h4',strong:true,margin:'none',style:{color:'#01a982'}},this.state.HeadingAcc,' ')),this.state.contentVisible?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_FormUp___default.a,{size:'small'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_icons_base_FormDown___default.a,{size:'small'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',pad:'none',style:{height:'93%',overflow:'auto',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'column',pad:'none',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Animate___default.a,{visible:this.state.contentVisible,keep:false,enter:{"animation":"slide-down","duration":200,"delay":0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Accordion___default.a,{active:this.state.ActiveTabIndex1,className:findActiveTab,animate:this.state.animate,onActive:function onActive(e){return _this3.OpenParallelActive(e);},openMulti:true},this.getSummary(),ConfigDetailsOfRackServers)))));}}]);return RackDetails;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (RackDetails);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Legend__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Value__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_SunBurst__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_SunBurst___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_SunBurst__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__ = __webpack_require__(32);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BOMSitesList=[];var BOMRolesList=[];var ObjectOfRoles=[];var TableContent=[];var TableListitemsLength=void 0;var TableContentSection=[];var ServerColorlen=0;var ServerServiceColorlen=0;var StorageColorlen=0;var StorageServiceColorlen=0;var TotalPrice=0;var SiteDropDown=void 0;var BOMSection=void 0;var StorageTotal=0;var ServerServicesTotal=0;var StorageServiceTotal=0;var ServiceTotal=0;var IntialStates=true;var CountryName=void 0;var PriceFileDate=void 0;var CountryWithDate=void 0;var CurrencySign='';var BOM=function(_Component){_inherits(BOM,_Component);function BOM(){_classCallCheck(this,BOM);var _this=_possibleConstructorReturn(this,(BOM.__proto__||Object.getPrototypeOf(BOM)).call(this));_this.state={RoleName:'',siteName:''};_this.BOMPricePresentation=_this.BOMPricePresentation.bind(_this);_this.BOMonSiteSelChange=_this.BOMonSiteSelChange.bind(_this);_this.BOMonRoleSelChange=_this.BOMonRoleSelChange.bind(_this);_this.TableConentFunc=_this.TableConentFunc.bind(_this);return _this;}_createClass(BOM,[{key:'componentWillMount',value:function componentWillMount(){if(this.props.activeSession.GRBomInput!=''&&this.props.activeSession.GRBomInput!==undefined){IntialStates=true;this.state.BOMPriceFile=this.props.activeSession.GRBomInput;}// if (this.props.activeSession.GRBomInput == '') {
//   if (this.props.actvSoln === undefined || this.props.actvSoln === null) {
//     var sessionObject = { "SessionID": this.props.activeSession.id };
//     this.props.onfetchGRBomInput(sessionObject);
//   } else {
//     IntialStates = true;
//     var sessionObject = { "SessionID": this.props.activeSession.id, "EPASolutionType": this.props.actvSoln };
//     this.props.onfetchGRBomInput(sessionObject);
//   }
//   this.state.BOMPriceFile = this.props.activeSession.GRBomInput;
// }
//  this.BOMPricePresentation();
}},{key:'componentDidMount',value:function componentDidMount(){IntialStates=true;if(this.props.activeSession.GRBomInput==''){if(this.props.actvSoln===undefined||this.props.actvSoln===null){var sessionObject={"SessionID":this.props.activeSession.id};this.props.onfetchGRBomInput(sessionObject);}else{var _sessionObject={"SessionID":this.props.activeSession.id,"EPASolutionType":this.props.actvSoln};this.props.onfetchGRBomInput(_sessionObject);}this.state.BOMPriceFile=this.props.activeSession.GRBomInput;}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextState){if(nextProps.activeSession.GRBomInput!==this.props.activeSession.GRBomInput){this.state.BOMPriceFile=nextProps.activeSession.GRBomInput;}}},{key:'BOMonRoleSelChange',value:function BOMonRoleSelChange(e){var _this2=this;IntialStates=false;ServerColorlen=0;StorageColorlen=0;ServerServiceColorlen=0;StorageServiceColorlen=0;TableContent.length=[];this.state.BOMPriceFile.RoleBOM.map(function(val,id){if(val["@Name"]==="Storage : HDFS and HDFS-EC"){val["@Name"]="Storage : HDFS";}if(BOMSitesList.length>0){if(val["@SiteName"]==_this2.state.siteName&&val["@Name"]==e.option){TableContent=[].concat(_toConsumableArray(TableContent),[val]);}}else{if(val["@Name"]==e.option){TableContent=[].concat(_toConsumableArray(TableContent),[val]);}}});//  ObjectOfRoles.map((val,id)=>{
//      if(val["@Name"]==e.option){
//          TableContent=[...TableContent,val]
//      }
//  });
this.TableConentFunc(TableContent,e.option);this.setState({RoleName:e.option});}},{key:'TableConentFunc',value:function TableConentFunc(data,e){if(TableContent.length==0){data.map(function(val,id){if(val["@Name"]==e){TotalPrice=0;ServerServicesTotal=0;ServiceTotal=0;StorageTotal=0;StorageServiceTotal=0;TableContentSection=val.ConsolidatedBOM.TableData.map(function(obj,idx){var PriceValue;if(obj["Price"]=='NA'||obj["Price"]=='NaN'){obj["Price"]='0';}if(obj["Price"].indexOf(',')>-1){PriceValue=obj["Price"];}else{var n=parseInt(obj["Price"],10);var parts=n.toFixed(2).split(".");PriceValue=parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,").toString();}var PriceCostQty;if(obj["CostAtQty"]=="NA"){obj["CostAtQty"]='0';}if(obj["CostAtQty"].indexOf(',')>-1){PriceCostQty=obj["CostAtQty"];}else{var _n=parseInt(obj["CostAtQty"],10);var _parts=_n.toFixed(2).split(".");PriceCostQty=_parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,").toString();}TotalPrice=TotalPrice+parseInt(obj["CostAtQty"].replace(/,/g,""),10);var RowBgColor;if(obj["@Type"]=="ServerFamilyTotal"||obj["@Type"]=="ModelsTotal"||obj["@Type"]=="NICTotal"||obj["@Type"]=="DiskTotal"||obj["@Type"]=="ProcessorTotal"||obj["@Type"]=="MemoryTotal"){//  if(obj["Description"].indexOf('Storage')>-1){
//         RowBgColor ="rgba(95,122,118,0.8)";
//         StorageColorlen =StorageColorlen+1; 
//         StorageTotal= StorageTotal + parseInt(obj["CostAtQty"].replace(/,/g, ""), 10);
//  }else
//{
RowBgColor="rgba(66,85,99,0.8)";ServerColorlen=ServerColorlen+1;ServiceTotal=ServiceTotal+parseInt(obj["CostAtQty"].replace(/,/g,""),10);//}
}else if(obj["@Type"]=="ServicesTotal"){RowBgColor="rgba(128,116,110,0.8)";ServerServiceColorlen=ServerServiceColorlen+1;ServerServicesTotal=ServerServicesTotal+parseInt(obj["CostAtQty"].replace(/,/g,""),10);}else{if(obj["@Type"]==undefined||obj["@Type"]==""){if(obj["Description"].indexOf("Service")>-1||obj["Description"].indexOf("SVC")>-1){RowBgColor="rgba(118,118,118,0.8)";StorageServiceColorlen=StorageServiceColorlen+1;StorageServiceTotal=StorageServiceTotal+parseInt(obj["CostAtQty"].replace(/,/g,""),10);}else{RowBgColor="rgba(95,122,118,0.8)";StorageColorlen=StorageColorlen+1;StorageTotal=StorageTotal+parseInt(obj["CostAtQty"].replace(/,/g,""),10);}}}var PartNumberText=0;if(_typeof(obj["PartNumber"])==="object"){if(obj["PartNumber"]==null){PartNumberText="";}else{PartNumberText=obj["PartNumber"]["#text"];}}else{PartNumberText=obj["PartNumber"];}if(PartNumberText==""){}else{return!__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,obj["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,obj["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,obj["Status"])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,obj["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,obj["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,obj["Status"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceCostQty));}});TableListitemsLength=val.ConsolidatedBOM.TableData.length;}else{}});}else{TotalPrice=0;ServerServicesTotal=0;ServiceTotal=0;StorageTotal=0;StorageServiceTotal=0;if(Array.isArray(TableContent[0].ConsolidatedBOM.TableData)){}else{var z=[];z[0]=TableContent[0].ConsolidatedBOM.TableData;TableContent[0].ConsolidatedBOM.TableData=z;}var rolename=TableContent[0]["@Name"];TableContentSection=TableContent[0].ConsolidatedBOM.TableData.map(function(val,id){var PriceValue;if(val["Price"]=='NA'||val["Price"]=='NaN'){val["Price"]='0';}if(val["Price"].indexOf(',')>-1){PriceValue=val["Price"];}else{var n=parseInt(val["Price"],10);var parts=n.toFixed(2).split(".");PriceValue=parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,").toString();}var PriceCostQty;if(val["CostAtQty"]=="NA"){val["CostAtQty"]='0';}if(val["CostAtQty"].indexOf(',')>-1){PriceCostQty=val["CostAtQty"];}else{var _n2=parseInt(val["CostAtQty"],10);var _parts2=_n2.toFixed(2).split(".");PriceCostQty=_parts2[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,").toString();}if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){TotalPrice=TotalPrice+parseInt(val["CostAtQty"].replace(/,/g,""),10);}else{if(rolename!=="Consolidated BOM"){if(val["@ID"]!=="0.1"&&val["@ComponentType"]!=="Network"&&val["@ComponentType"]!=="Spines"&&val["@SubType"]!=="Services"){TotalPrice=TotalPrice+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}else{TotalPrice=TotalPrice+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}var RowBgColor;if(val["@Type"]=="ServerFamilyTotal"||val["@Type"]=="ModelsTotal"||val["@Type"]=="NICTotal"||val["@Type"]=="DiskTotal"||val["@Type"]=="ProcessorTotal"||val["@Type"]=="MemoryTotal"){//     if(val["Description"].indexOf('Storage')>-1){
//         RowBgColor ="rgba(95,122,118,0.8)";
//         StorageColorlen =StorageColorlen+1; 
//         StorageTotal= StorageTotal + parseInt(val["CostAtQty"].replace(/,/g, ""), 10);
//  }else
//{
RowBgColor="rgba(66,85,99,0.8)";ServerColorlen=ServerColorlen+1;// ServiceTotal = ServiceTotal + parseInt(val["CostAtQty"].replace(/,/g, ""), 10);
if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){ServiceTotal=ServiceTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}else{if(rolename!=="Consolidated BOM"){if(val["@ID"]!=="0.1"&&val["@ComponentType"]!=="Network"&&val["@ComponentType"]!=="Spines"&&val["@SubType"]!=="Services"){ServiceTotal=ServiceTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}else{ServiceTotal=ServiceTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}//}
}else if(val["@Type"]=="ServicesTotal"){RowBgColor="rgba(128,116,110,0.8)";ServerServiceColorlen=ServerServiceColorlen+1;//ServerServicesTotal = ServerServicesTotal + parseInt(val["CostAtQty"].replace(/,/g, ""), 10);
if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){ServerServicesTotal=ServerServicesTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}else{if(rolename!=="Consolidated BOM"){if(val["@ID"]!=="0.1"&&val["@ComponentType"]!=="Network"&&val["@ComponentType"]!=="Spines"&&val["@SubType"]!=="Services"){ServerServicesTotal=ServerServicesTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}else{ServerServicesTotal=ServerServicesTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}}else{if(val["@Type"]==undefined||val["@Type"]==""){if(val["Description"].indexOf("Service")>-1||val["Description"].indexOf("SVC")>-1){RowBgColor="rgba(118,118,118,0.8)";StorageServiceColorlen=StorageServiceColorlen+1;StorageServiceTotal=StorageServiceTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}else{RowBgColor="rgba(95,122,118,0.8)";StorageColorlen=StorageColorlen+1;StorageTotal=StorageTotal+parseInt(val["CostAtQty"].replace(/,/g,""),10);}}}var PartNumberText=0;if(_typeof(val["PartNumber"])==="object"){if(val["PartNumber"]==null){PartNumberText="";}else{PartNumberText=val["PartNumber"]["#text"];}}else{PartNumberText=val["PartNumber"];}if(PartNumberText==""){}else if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){return!__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Status"])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Status"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceCostQty));}else if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]==="EPAvNext"){if(rolename!=="Consolidated BOM"){if(val["@ID"]!=="0.1"&&val["@ComponentType"]!=="Network"&&val["@ComponentType"]!=="Spines"&&val["@SubType"]!=="Services"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Status"]),__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceValue),__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceCostQty));}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,val["Status"]),__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceValue),__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceCostQty));}}});TableListitemsLength=TableContent[0].ConsolidatedBOM.TableData.length;}}},{key:'BOMonSiteSelChange',value:function BOMonSiteSelChange(e){IntialStates=false;ServerColorlen=0;StorageColorlen=0;ServerServiceColorlen=0;TableContent.length=[];ObjectOfRoles.length=[];BOMRolesList.length=[];var selection=e.option;this.state.BOMPriceFile.RoleBOM.map(function(val,id){if(val["@SiteName"]==selection){if(val["@Name"]==="Storage : HDFS and HDFS-EC"){val["@Name"]="Storage : HDFS";}BOMRolesList=[].concat(_toConsumableArray(BOMRolesList),[val["@Name"]]);ObjectOfRoles=[].concat(_toConsumableArray(ObjectOfRoles),[val]);}});this.TableConentFunc(ObjectOfRoles,BOMRolesList[0]);this.setState({RoleName:BOMRolesList[0],siteName:e.option});}},{key:'BOMPricePresentation',value:function BOMPricePresentation(){ServerColorlen=0;StorageColorlen=0;ServerServiceColorlen=0;BOMRolesList.length=[];BOMSitesList.length=[];this.state.BOMPriceFile.RoleBOM.map(function(val,id){var SiteName=val["@SiteName"];var RoleName=val["@Name"];if(RoleName==="Storage : HDFS and HDFS-EC"){RoleName="Storage : HDFS";}if(val["@SiteName"]!==undefined&&val["@SiteName"]!==""){if(BOMSitesList.indexOf(SiteName)==-1){BOMSitesList=[].concat(_toConsumableArray(BOMSitesList),[SiteName]);}}if(BOMRolesList.indexOf(RoleName)==-1){BOMRolesList=[].concat(_toConsumableArray(BOMRolesList),[RoleName]);}});TotalPrice=0;ServerServicesTotal=0;ServiceTotal=0;StorageServiceTotal=0;StorageTotal=0;if(this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM["@Country"]=="United States"){CountryName=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM["@Country"]+" [$]";CurrencySign="$";}else{CountryName=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM["@Country"]+" ["+this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM["@Currency"]+"]";CurrencySign=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM["@Currency"];}PriceFileDate=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM["@PriceFileDate"];CountryWithDate=CountryName+' - '+PriceFileDate;if(Array.isArray(this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM.TableData)){}else{var z=[];z[0]=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM.TableData;this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM.TableData=z;}//let rolename=this.state.BOMPriceFile.RoleBOM[0]["@Name"]
TableContentSection=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM.TableData.map(function(rowvalue,id){var PriceValue;if(rowvalue["Price"]=='NA'||rowvalue["Price"]=='NaN'){rowvalue["Price"]='0';}if(rowvalue["Price"].indexOf(',')>-1){PriceValue=rowvalue["Price"];}else{var n=parseInt(rowvalue["Price"],10);var parts=n.toFixed(2).split(".");PriceValue=parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,").toString();}var PriceCostQty;if(rowvalue["CostAtQty"]=="NA"){rowvalue["CostAtQty"]='0';}if(rowvalue["CostAtQty"].indexOf(',')>-1){PriceCostQty=rowvalue["CostAtQty"];}else{var _n3=parseInt(rowvalue["CostAtQty"],10);var _parts3=_n3.toFixed(2).split(".");PriceCostQty=_parts3[0].replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,").toString();}var RowBgColor;// TotalPrice = TotalPrice + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){TotalPrice=TotalPrice+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}else{//if (rolename=== "Storage : HDFS and HDFS-EC" || rolename === "Storage : HDFS") {
if(/*rowvalue["@ID"] !== "0.1" &&*/rowvalue["@ComponentType"]!=="Network"&&rowvalue["@ComponentType"]!=="Spines"&&rowvalue["@SubType"]!=="Services"){TotalPrice=TotalPrice+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);//}
}// else{
//   TotalPrice = TotalPrice + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
// }
}if(rowvalue["@Type"]=="ServerFamilyTotal"||rowvalue["@Type"]=="ModelsTotal"||rowvalue["@Type"]=="NICTotal"||rowvalue["@Type"]=="DiskTotal"||rowvalue["@Type"]=="ProcessorTotal"||rowvalue["@Type"]=="MemoryTotal"){//     if(rowvalue["Description"].indexOf('Storage')>-1){
//         RowBgColor ="rgba(95,122,118,0.8)";
//         StorageColorlen =StorageColorlen+1; 
//         StorageTotal= StorageTotal + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
//  }else
//{
RowBgColor="rgba(66,85,99,0.8)";ServerColorlen=ServerColorlen+1;//ServiceTotal = ServiceTotal + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){ServiceTotal=ServiceTotal+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}else{// if (rolename === "Storage : HDFS and HDFS-EC" ||rolename === "Storage : HDFS") {
if(/*rowvalue["@ID"] !== "0.1" && */rowvalue["@ComponentType"]!=="Network"&&rowvalue["@ComponentType"]!=="Spines"&&rowvalue["@SubType"]!=="Services"){ServiceTotal=ServiceTotal+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}//}
// else{
//      ServiceTotal = ServiceTotal + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
// }
}//}
}else if(rowvalue["@Type"]=="ServicesTotal"){RowBgColor="rgba(128,116,110,0.8)";ServerServiceColorlen=ServerServiceColorlen+1;//ServerServicesTotal = ServerServicesTotal + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){ServerServicesTotal=ServerServicesTotal+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}else{//if (rolename === "Storage : HDFS and HDFS-EC" || rolename === "Storage : HDFS") {
if(/*rowvalue["@ID"] !== "0.1" &&*/rowvalue["@ComponentType"]!=="Network"&&rowvalue["@ComponentType"]!=="Spines"&&rowvalue["@SubType"]!=="Services"){ServerServicesTotal=ServerServicesTotal+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}//  }
// else{
//     ServerServicesTotal = ServerServicesTotal + parseInt(rowvalue["CostAtQty"].replace(/,/g, ""), 10);
//   }
}}else{if(rowvalue["@Type"]==undefined||rowvalue["@Type"]==""){if(rowvalue["Description"].indexOf("Service")>-1||rowvalue["Description"].indexOf("SVC")>-1){RowBgColor="rgba(118,118,118,0.8)";StorageServiceColorlen=StorageServiceColorlen+1;StorageServiceTotal=StorageServiceTotal+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}else{RowBgColor="rgba(95,122,118,0.8)";StorageColorlen=StorageColorlen+1;StorageTotal=StorageTotal+parseInt(rowvalue["CostAtQty"].replace(/,/g,""),10);}}}var PartNumberText=0;if(_typeof(rowvalue["PartNumber"])==="object"){if(rowvalue["PartNumber"]==null){PartNumberText="";}else{PartNumberText=rowvalue["PartNumber"]["#text"];}}else{PartNumberText=rowvalue["PartNumber"];}if(PartNumberText==""){}else if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]!=="EPAvNext"){return!__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Status"])):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Status"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceCostQty));}else if(__WEBPACK_IMPORTED_MODULE_10__AppConfig__["f" /* said */]==="EPAvNext"){//if (rolename === "Storage : HDFS and HDFS-EC" || rolename === "Storage : HDFS") {
if(/*rowvalue["@ID"] !== "0.1" &&*/rowvalue["@ComponentType"]!=="Network"&&rowvalue["@ComponentType"]!=="Spines"&&rowvalue["@SubType"]!=="Services"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,{id:id,style:{backgroundColor:RowBgColor}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Qty"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PartNumberText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Description"]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,rowvalue["Status"]),__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceValue),__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,PriceCostQty));}// }
// else{
//   return (
//       <TableRow id={id} style={{ backgroundColor: RowBgColor }}>
//         <td>{rowvalue["Qty"]}</td>
//         <td>{PartNumberText}</td>
//         <td>{rowvalue["Description"]}</td>
//         <td>{rowvalue["Status"]}</td>
//         <td>{PriceValue}</td>
//         <td>{PriceCostQty}</td>
//       </TableRow>
//     );
// }
}});TableListitemsLength=this.state.BOMPriceFile.RoleBOM[0].ConsolidatedBOM.TableData.length;}},{key:'render',value:function render(){var _this3=this;if(this.state.BOMPriceFile!==''&&this.state.BOMPriceFile!==undefined){if(IntialStates){this.BOMPricePresentation();}}if(IntialStates){this.state.RoleName=BOMRolesList[0];this.state.siteName=BOMSitesList[0];}var fillColor;var ServerColorPercentage=0;var ServerServiceColorPercentage=0;var StorageServiceColorPercentage=0;var StorageColorPercentage=0;fillColor=100/TableListitemsLength;ServerColorPercentage=ServerColorlen*fillColor;StorageColorPercentage=StorageColorlen*fillColor;ServerServiceColorPercentage=ServerServiceColorlen*fillColor;StorageServiceColorPercentage=StorageServiceColorlen*fillColor;if(BOMSitesList.length>0){SiteDropDown=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',wrap:true,pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{margin:'small',tag:'h4',uppercase:false,strong:true},' Sites : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Select___default.a,{options:BOMSitesList,multiple:false,value:this.state.siteName,onChange:function onChange(e){return _this3.BOMonSiteSelChange(e);}}));}else{SiteDropDown='';}// if(ServiceTotal.indexOf('$') > -1){
// }else{
//     ServiceTotal=CurrencySign + ' ' +ServiceTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") ;
// }
if(this.state.BOMPriceFile!==''&&this.state.BOMPriceFile!==undefined){/* Assign comma to total sizes as per offline starts here */ServiceTotal=CurrencySign+' '+ServiceTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,");StorageTotal=CurrencySign+' '+StorageTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,");ServerServicesTotal=CurrencySign+' '+ServerServicesTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,");StorageServiceTotal=CurrencySign+' '+StorageServiceTotal.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,");TotalPrice=CurrencySign+' '+TotalPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g,"$1,");BOMSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',className:'BOMDropdownMenu',wrap:true,pad:'none',margin:'none',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',wrap:true,pad:'small',margin:'none',colorIndex:'light-2',style:{width:'100%',height:'11%'},separator:'bottom'},SiteDropDown,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',wrap:true,pad:'none',margin:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{margin:'small',tag:'h4',uppercase:false,strong:true},'Roles : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Select___default.a,{options:BOMRolesList,multiple:false,value:this.state.RoleName,onChange:function onChange(e){return _this3.BOMonRoleSelChange(e);}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',className:'BOMDTableMenu',wrap:true,pad:'small',margin:'none',style:{width:'100%',height:'84%',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',basis:'2/3',wrap:true,pad:'none',margin:'none',colorIndex:'light-2',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Table___default.a,{className:'FixedHeaderTblBOM',scrollable:false,selectable:false,style:{height:'100%',overflow:'auto'}},!__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{style:{backgroundColor:'#01a982'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantitiy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' Part number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{style:{backgroundColor:'#01a982'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Quantitiy'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' Part number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' Description'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Status'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' List Price'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,' Cost at Quantity'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,TableContentSection,!__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,'Total Cost ('+CurrencySign+')',' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',null,TotalPrice.substring(2)))))),!__WEBPACK_IMPORTED_MODULE_12__State_constants_CommonConstants__["c" /* DisplayPrice */]?" ":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{direction:'row',justify:'start',align:'start',basis:'1/3',wrap:true,pad:'none',margin:'none',colorIndex:'light-2',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_SunBurst___default.a,{className:'SunBurst',data:[{"label":"root-1","value":ServerColorPercentage,"colorIndex":"neutral-1"},{"label":"root-2","value":StorageColorPercentage,"colorIndex":"neutral-2"},{"label":"root-3","value":ServerServiceColorPercentage,"colorIndex":"neutral-3"},{"label":"root-4","value":StorageServiceColorPercentage,"colorIndex":"neutral-4"}],active:[0],label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Legend___default.a,{series:[{"label":"Price Date: ","value":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default.a,{className:'ValueSizeText',value:CountryWithDate,size:'small'})}]})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Legend___default.a,{className:'TotalPricelistSunBurst',series:[{"label":"Server(SR)","colorIndex":"neutral-1","value":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default.a,{className:'ValueSizeText',value:ServiceTotal,size:'small'})},{"label":"Storage(ST)","colorIndex":"neutral-2","value":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default.a,{className:'ValueSizeText',value:StorageTotal,size:'small'})},{"label":"Server Services(SRS) ","colorIndex":"neutral-3","value":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default.a,{className:'ValueSizeText',value:ServerServicesTotal,size:'small'})},{"label":"Storage Services(STS)","colorIndex":"neutral-4","value":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default.a,{className:'ValueSizeText',value:StorageServiceTotal,size:'small'})},{"label":"Total Price: ","colorIndex":"light-2","value":__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Value___default.a,{className:'ValueSizeText',value:TotalPrice,size:'small'})}]}))));}else{BOMSection=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',align:'center',margin:'medium',strong:false},'Loading...');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{margin:'none',pad:'none',full:true,justify:'start',colorIndex:'light-2'},BOMSection);}}]);return BOM;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{activeSession:state.sessions.activeSession,workload:state.sizerWorkload.workload};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onfetchGRBomInput:function onfetchGRBomInput(sessionID){dispatch(Object(__WEBPACK_IMPORTED_MODULE_11__State_actions_sessions__["x" /* fetchGRBomInput */])(sessionID));}};};//export default GrRackServerPresentation;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(BOM));

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames3 = __webpack_require__(3);

var _classnames4 = _interopRequireDefault(_classnames3);

var _FormattedMessage = __webpack_require__(261);

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _List = __webpack_require__(48);

var _List2 = _interopRequireDefault(_List);

var _ListItem = __webpack_require__(49);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Announcer = __webpack_require__(34);

var _Announcer2 = _interopRequireDefault(_Announcer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.LEGEND;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

function getMaxDecimalDigits(series) {
  var maxDigits = 0;
  series.forEach(function (item) {
    var currentDigitsGroup = /\.(\d*)$/.exec(item.value.toString());
    if (currentDigitsGroup) {
      var currentDigits = currentDigitsGroup[1].length;
      maxDigits = Math.max(maxDigits, currentDigits);
    }
  });

  return maxDigits;
}

var Legend = function (_Component) {
  _inherits(Legend, _Component);

  function Legend(props, context) {
    _classCallCheck(this, Legend);

    var _this = _possibleConstructorReturn(this, (Legend.__proto__ || Object.getPrototypeOf(Legend)).call(this, props, context));

    _this._onActive = _this._onActive.bind(_this);
    _this._renderSeries = _this._renderSeries.bind(_this);
    _this._renderSwatch = _this._renderSwatch.bind(_this);
    _this._renderLabel = _this._renderLabel.bind(_this);
    _this._renderValue = _this._renderValue.bind(_this);
    _this._renderTotal = _this._renderTotal.bind(_this);
    _this._seriesTotal = _this._seriesTotal.bind(_this);

    _this.state = { activeIndex: _this.props.activeIndex };
    return _this;
  }

  _createClass(Legend, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.activeIndex !== this.state.activeIndex) {
        this.setState({ activeIndex: newProps.activeIndex });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var announce = this.props.announce;

      if (announce) {
        _Announcer2.default.announce(this.legendRef.textContent);
      }
    }
  }, {
    key: '_onActive',
    value: function _onActive(index) {
      var onActive = this.props.onActive;

      this.setState({ activeIndex: index });
      if (onActive) {
        onActive(index);
      }
    }
  }, {
    key: '_itemColorIndex',
    value: function _itemColorIndex(item, index) {
      return item.colorIndex || 'graph-' + (index + 1);
    }
  }, {
    key: '_renderSwatch',
    value: function _renderSwatch(item, index) {
      var colorIndex = this._itemColorIndex(item, index);
      return _react2.default.createElement(
        'svg',
        { className: CLASS_ROOT + '__item-swatch ' + COLOR_INDEX + '-' + colorIndex, viewBox: '0 0 12 12' },
        _react2.default.createElement('path', { className: item.className, d: 'M 5 0 l 0 12' })
      );
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel(item, swatch) {
      if (swatch) {
        return _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__item-label' },
          swatch,
          _react2.default.createElement(
            'span',
            null,
            item.label
          )
        );
      } else {
        return _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__item-label' },
          item.label
        );
      }
    }
  }, {
    key: '_renderValue',
    value: function _renderValue(item) {
      var units = this.props.units;

      var unitsValue = item.units || units;
      var valueClasses = CLASS_ROOT + '__item-value';
      var unitsPrefix = void 0;
      var unitsSuffix = void 0;
      if (unitsValue) {
        if (unitsValue.prefix) {
          unitsPrefix = _react2.default.createElement(
            'span',
            { className: CLASS_ROOT + '__item-units' },
            unitsValue.prefix
          );
        }
        if (unitsValue.suffix || typeof unitsValue === 'string' || unitsValue instanceof String) {
          unitsSuffix = _react2.default.createElement(
            'span',
            { className: CLASS_ROOT + '__item-units' },
            unitsValue.suffix || unitsValue
          );
        }
      }
      return _react2.default.createElement(
        'span',
        { className: valueClasses },
        unitsPrefix,
        item.value,
        unitsSuffix
      );
    }
  }, {
    key: '_seriesTotal',
    value: function _seriesTotal() {
      var series = this.props.series;

      var maxDecimalDigits = getMaxDecimalDigits(series);
      var total = 0;
      series.forEach(function (item) {
        return total += typeof item.value === 'number' ? item.value : 0;
      });
      return parseFloat(total.toFixed(maxDecimalDigits));
    }
  }, {
    key: '_renderSeries',
    value: function _renderSeries() {
      var _this2 = this;

      var _props = this.props,
          series = _props.series,
          responsive = _props.responsive;
      var activeIndex = this.state.activeIndex;


      return series.map(function (item, index) {
        var _classnames;

        var legendClasses = (0, _classnames4.default)(CLASS_ROOT + '__item', (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__item--active', index === activeIndex), _defineProperty(_classnames, CLASS_ROOT + '__item--clickable', item.onClick), _classnames));

        var swatch = void 0;
        if (item.hasOwnProperty('colorIndex')) {
          swatch = _this2._renderSwatch(item, index);
        }

        var label = void 0;
        if (item.hasOwnProperty('label')) {
          label = _this2._renderLabel(item, swatch);
        }

        var value = void 0;
        if (item.hasOwnProperty('value')) {
          value = _this2._renderValue(item);
        }

        return _react2.default.createElement(
          _ListItem2.default,
          { onClick: item.onClick, justify: 'between',
            separator: 'none', pad: { horizontal: 'small' },
            key: item.label || index, className: legendClasses,
            onMouseOver: _this2._onActive.bind(_this2, index),
            onMouseOut: _this2._onActive.bind(_this2, undefined),
            responsive: responsive },
          label,
          value
        );
      }, this);
    }
  }, {
    key: '_renderTotal',
    value: function _renderTotal() {
      var _props2 = this.props,
          total = _props2.total,
          units = _props2.units,
          responsive = _props2.responsive;

      var totalValue = void 0;
      if (total !== true) {
        totalValue = total;
      } else {
        totalValue = this._seriesTotal();
      }
      var unitsPrefix = void 0;
      var unitsSuffix = void 0;
      if (units && units.prefix) {
        unitsPrefix = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__total-units' },
          units.prefix
        );
      }
      if (units && (units.suffix || typeof units === 'string' || units instanceof String)) {
        unitsSuffix = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__total-units' },
          units.suffix || units
        );
      }

      return _react2.default.createElement(
        _ListItem2.default,
        { className: CLASS_ROOT + '__total',
          justify: 'between', separator: 'none', pad: { horizontal: 'small' },
          responsive: responsive },
        _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__total-label' },
          _react2.default.createElement(_FormattedMessage2.default, { id: 'Total', defaultMessage: 'Total' })
        ),
        _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__total-value' },
          unitsPrefix,
          totalValue,
          unitsSuffix
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          className = _props3.className,
          series = _props3.series,
          size = _props3.size,
          total = _props3.total,
          props = _objectWithoutProperties(_props3, ['className', 'series', 'size', 'total']);

      delete props.activeIndex;
      delete props.announce;
      delete props.onActive;
      delete props.units;
      delete props.responsive;

      var classes = (0, _classnames4.default)(CLASS_ROOT, _defineProperty({}, CLASS_ROOT + '--' + size, size), className);

      var items = this._renderSeries();

      // build legend from bottom to top, to align with Meter bar stacking
      items.reverse();

      var totalNode = void 0;
      if (total && series.length > 1) {
        totalNode = this._renderTotal();
      }

      return _react2.default.createElement(
        _List2.default,
        _extends({ ref: function ref(_ref) {
            return _this3.legendRef = _ref;
          } }, props, { className: classes }),
        items.reverse(),
        totalNode
      );
    }
  }]);

  return Legend;
}(_react.Component);

Legend.displayName = 'Legend';
exports.default = Legend;


Legend.defaultProps = {
  announce: false
};

Legend.propTypes = {
  activeIndex: _propTypes2.default.number,
  announce: _propTypes2.default.bool,
  onActive: _propTypes2.default.func,
  series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.node]),
    units: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
      prefix: _propTypes2.default.string,
      suffix: _propTypes2.default.string
    })]),
    colorIndex: _propTypes2.default.oneOfType([_propTypes2.default.number, // 1-6
    _propTypes2.default.string // status
    ]),
    onClick: _propTypes2.default.func
  })).isRequired,
  size: _propTypes2.default.oneOf(['medium', 'large']),
  total: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.node]),
  units: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    prefix: _propTypes2.default.string,
    suffix: _propTypes2.default.string
  })]),
  responsive: _propTypes2.default.bool
};
module.exports = exports['default'];

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.VALUE;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var Value = function (_Component) {
  _inherits(Value, _Component);

  function Value() {
    _classCallCheck(this, Value);

    return _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).apply(this, arguments));
  }

  _createClass(Value, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.announce) {
        (0, _Announcer.announce)(this.valueRef.textContent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          active = _props.active,
          align = _props.align,
          className = _props.className,
          colorIndex = _props.colorIndex,
          icon = _props.icon,
          label = _props.label,
          responsive = _props.responsive,
          size = _props.size,
          trendIcon = _props.trendIcon,
          units = _props.units,
          value = _props.value,
          reverse = _props.reverse,
          props = _objectWithoutProperties(_props, ['active', 'align', 'className', 'colorIndex', 'icon', 'label', 'responsive', 'size', 'trendIcon', 'units', 'value', 'reverse']);

      delete props.announce;
      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames, CLASS_ROOT + '--align-' + align, align), _defineProperty(_classnames, COLOR_INDEX + '-' + colorIndex, colorIndex), _defineProperty(_classnames, CLASS_ROOT + '--responsive', responsive), _defineProperty(_classnames, CLASS_ROOT + '--interactive', props.onClick), _defineProperty(_classnames, CLASS_ROOT + '--active', active), _classnames), className);

      var unitsSpan = void 0;
      if (units) {
        unitsSpan = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__units' },
          units
        );
      }

      var labelSpan = void 0;
      if (label) {
        labelSpan = _react2.default.createElement(
          'span',
          { className: CLASS_ROOT + '__label' },
          label
        );
      }

      var contentNode = void 0;
      if (reverse) {
        contentNode = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            { className: CLASS_ROOT + '__value' },
            value
          ),
          unitsSpan,
          icon
        );
      } else {
        contentNode = _react2.default.createElement(
          'div',
          null,
          icon,
          _react2.default.createElement(
            'span',
            { className: CLASS_ROOT + '__value' },
            value
          ),
          unitsSpan
        );
      }

      return _react2.default.createElement(
        'div',
        _extends({ ref: function ref(_ref) {
            return _this2.valueRef = _ref;
          } }, props, { className: classes }),
        _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + '__annotated' },
          contentNode,
          trendIcon
        ),
        labelSpan
      );
    }
  }]);

  return Value;
}(_react.Component);

Value.displayName = 'Value';
exports.default = Value;


Value.propTypes = {
  active: _propTypes2.default.bool,
  align: _propTypes2.default.oneOf(['start', 'center', 'end']),
  announce: _propTypes2.default.bool,
  colorIndex: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  onClick: _propTypes2.default.func,
  responsive: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
  trendIcon: _propTypes2.default.node,
  reverse: _propTypes2.default.bool,
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string, _propTypes2.default.node]),
  units: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
};

Value.defaultProps = {
  align: 'center',
  announce: false
};
module.exports = exports['default'];

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames4 = __webpack_require__(3);

var _classnames5 = _interopRequireDefault(_classnames4);

var _Graphics = __webpack_require__(86);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Intl = __webpack_require__(5);

var _Intl2 = _interopRequireDefault(_Intl);

var _KeyboardAccelerators = __webpack_require__(23);

var _KeyboardAccelerators2 = _interopRequireDefault(_KeyboardAccelerators);

var _Announcer = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.SUN_BURST;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;
var UNIT_FACTOR = _Graphics.baseUnit * 0.75;
var PAD_FACTOR = _Graphics.baseUnit * 8;

var SunBurst = function (_Component) {
  _inherits(SunBurst, _Component);

  function SunBurst(props, context) {
    _classCallCheck(this, SunBurst);

    var _this = _possibleConstructorReturn(this, (SunBurst.__proto__ || Object.getPrototypeOf(SunBurst)).call(this, props, context));

    _this._layout = _this._layout.bind(_this);
    _this._onResize = _this._onResize.bind(_this);
    _this._onPreviousSunBurst = _this._onPreviousSunBurst.bind(_this);
    _this._onNextSunBurst = _this._onNextSunBurst.bind(_this);
    _this._onParentSunBurst = _this._onParentSunBurst.bind(_this);
    _this._onChildSunBurst = _this._onChildSunBurst.bind(_this);
    _this._onSunBurstFocus = _this._onSunBurstFocus.bind(_this);
    _this._onSunBurstBlur = _this._onSunBurstBlur.bind(_this);
    _this._onSunBurstClick = _this._onSunBurstClick.bind(_this);
    _this._onActiveSunBurst = _this._onActiveSunBurst.bind(_this);
    _this._announceSunBurst = _this._announceSunBurst.bind(_this);

    _this.state = {
      height: 100, width: 100, activeSunBurst: [-1], mouseActive: false
    };

    _this.sunBurstPaths = {};
    return _this;
  }

  _createClass(SunBurst, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this._onResize);
      this._onResize();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._resizeTimer);
      window.removeEventListener('resize', this._onResize);
    }
  }, {
    key: '_onSunBurstFocus',
    value: function _onSunBurstFocus() {
      var mouseActive = this.state.mouseActive;

      this._keyboardHandlers = {
        left: this._onPreviousSunBurst,
        up: this._onParentSunBurst,
        right: this._onNextSunBurst,
        down: this._onChildSunBurst,
        enter: this._onSunBurstClick
      };
      _KeyboardAccelerators2.default.startListeningToKeyboard(this, this._keyboardHandlers);
      if (mouseActive === false) {
        this.setState({ focus: true });
      }
    }
  }, {
    key: '_onSunBurstBlur',
    value: function _onSunBurstBlur() {
      _KeyboardAccelerators2.default.stopListeningToKeyboard(this, this._keyboardHandlers);

      this.setState({ focus: false });
    }
  }, {
    key: '_announceSunBurst',
    value: function _announceSunBurst() {
      var activeSunBurst = this.state.activeSunBurst;


      var sunBurstRef = this.sunBurstPaths[activeSunBurst.join(',')];
      if (sunBurstRef) {
        (0, _Announcer.announce)(sunBurstRef.getAttribute('aria-label'));
      }
    }
  }, {
    key: '_onPreviousSunBurst',
    value: function _onPreviousSunBurst(event) {
      event.preventDefault();
      var onActive = this.props.onActive;

      var previousSunBurst = this.state.activeSunBurst.slice();

      previousSunBurst[previousSunBurst.length - 1] -= 1;
      var id = previousSunBurst.join(',');
      if (this.sunBurstPaths[id]) {
        onActive(previousSunBurst);
        this.setState({ activeSunBurst: previousSunBurst }, this._announceSunBurst);
      }

      //stop event propagation
      return true;
    }
  }, {
    key: '_onParentSunBurst',
    value: function _onParentSunBurst(event) {
      event.preventDefault();
      var onActive = this.props.onActive;

      var parentSunBurst = this.state.activeSunBurst.slice(0, this.state.activeSunBurst.length - 1);

      var id = parentSunBurst.join(',');
      if (this.sunBurstPaths[id]) {
        onActive(parentSunBurst);
        this.setState({ activeSunBurst: parentSunBurst }, this._announceSunBurst);
      }

      //stop event propagation
      return true;
    }
  }, {
    key: '_onChildSunBurst',
    value: function _onChildSunBurst(event) {
      event.preventDefault();
      var onActive = this.props.onActive;

      var childSunBurst = this.state.activeSunBurst.slice();
      childSunBurst.push(0);

      var id = childSunBurst.join(',');
      if (this.sunBurstPaths[id]) {
        onActive(childSunBurst);
        this.setState({ activeSunBurst: childSunBurst }, this._announceSunBurst);
      }

      //stop event propagation
      return true;
    }
  }, {
    key: '_onNextSunBurst',
    value: function _onNextSunBurst(event) {
      event.preventDefault();
      var onActive = this.props.onActive;

      var nextSunBurst = this.state.activeSunBurst.slice();

      nextSunBurst[nextSunBurst.length - 1] += 1;
      var id = nextSunBurst.join(',');
      if (this.sunBurstPaths[id]) {
        onActive(nextSunBurst);
        this.setState({ activeSunBurst: nextSunBurst }, this._announceSunBurst);
      }

      //stop event propagation
      return true;
    }
  }, {
    key: '_onSunBurstClick',
    value: function _onSunBurstClick() {
      var onClick = this.props.onClick;
      var activeSunBurst = this.state.activeSunBurst;


      if (this.sunBurstPaths[activeSunBurst.join(',')] && onClick) {
        onClick(activeSunBurst);
      }
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      // debounce
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(this._layout, 50);
    }
  }, {
    key: '_layout',
    value: function _layout() {
      var rect = this._containerRef.getBoundingClientRect();
      if (rect.width !== this.state.width || rect.height !== this.state.height) {
        this.setState({ height: rect.height, width: rect.width });
      }
    }
  }, {
    key: '_onActiveSunBurst',
    value: function _onActiveSunBurst(sunBurst) {
      var onActive = this.props.onActive;

      this.setState({
        activeSunBurst: sunBurst ? sunBurst : [-1]
      });
      if (sunBurst && onActive) {
        onActive(sunBurst);
      }
    }
  }, {
    key: '_renderData',
    value: function _renderData(path, data, total, centerX, centerY, radius, startAngle, endAngle, role, value) {
      var _this2 = this;

      var _props = this.props,
          active = _props.active,
          onActive = _props.onActive,
          onClick = _props.onClick;
      var width = this.state.width;
      var intl = this.context.intl;

      var unit = width / UNIT_FACTOR;
      var ringPad = width / PAD_FACTOR;
      if (!total) {
        total = 0;
        data.forEach(function (datum) {
          return total += datum.value;
        });
      }
      // reserve 1 degree per data item for margin between slices
      var padCount = endAngle - startAngle === 360 ? data.length : data.length - 1;
      var anglePer = (endAngle - startAngle - padCount) / total;

      var result = [];
      data.forEach(function (datum, index) {
        var _classnames;

        var datumPath = path.concat([index]);
        var colorIndex = datum.colorIndex || 'graph-' + (index % 4 + 1);
        var className = (0, _classnames5.default)(CLASS_ROOT + '__slice', COLOR_INDEX + '-' + colorIndex, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '__slice--hot', onActive || onClick), _defineProperty(_classnames, CLASS_ROOT + '__slice--active', active && active.length === datumPath.length && active.every(function (v, i) {
          return v === datumPath[i];
        })), _classnames));
        var endAngle = (0, _Graphics.translateEndAngle)(startAngle, anglePer, datum.value);
        var commands = (0, _Graphics.arcCommands)(centerX, centerY, radius, startAngle, endAngle);

        var id = datumPath.join(',');

        var enterSelectMessage = '(' + _Intl2.default.getMessage(intl, 'Enter Select') + ')';
        var ariaLabel = datum.value + ' ' + (onClick ? enterSelectMessage : '');

        result.push(_react2.default.createElement('path', { ref: function ref(_ref) {
            return _this2.sunBurstPaths[id] = _ref;
          },
          key: datumPath + '_' + index,
          className: className, tabIndex: onClick ? '-1' : undefined,
          fill: 'none', strokeWidth: unit * 2, d: commands,
          'aria-label': ariaLabel, role: 'row',
          onMouseOver: _this2._onActiveSunBurst.bind(_this2, datumPath),
          onMouseOut: _this2._onActiveSunBurst.bind(_this2, undefined),
          onFocus: _this2._onActiveSunBurst.bind(_this2, datumPath),
          onBlur: _this2._onActiveSunBurst.bind(_this2, undefined),
          onClick: onClick ? function () {
            return onClick(datumPath);
          } : undefined }));

        if (datum.children) {
          result = result.concat(_this2._renderData(datumPath, datum.children, datum.total, centerX, centerY, radius + unit * 2 + ringPad, startAngle, endAngle, 'group', datum.value));
        }

        // + 1 is for margin between slices
        startAngle = endAngle + 1;
      });

      return _react2.default.createElement(
        'g',
        { key: path + '_' + radius + '_' + total, role: role || 'rowgroup',
          'aria-label': value || total },
        result
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames2,
          _this3 = this;

      var _props2 = this.props,
          a11yTitle = _props2.a11yTitle,
          active = _props2.active,
          className = _props2.className,
          data = _props2.data,
          label = _props2.label,
          size = _props2.size,
          props = _objectWithoutProperties(_props2, ['a11yTitle', 'active', 'className', 'data', 'label', 'size']);

      delete props.onActive;
      delete props.onClick;
      var _state = this.state,
          focus = _state.focus,
          height = _state.height,
          width = _state.width;
      var intl = this.context.intl;

      var classes = (0, _classnames5.default)(CLASS_ROOT, (_classnames2 = {}, _defineProperty(_classnames2, CLASS_ROOT + '--' + size, size), _defineProperty(_classnames2, CLASS_ROOT + '--active', active), _classnames2), className);

      var unit = width / UNIT_FACTOR;
      var centerX = width / 2;
      var centerY = height / 2;
      var paths = this._renderData([], data, undefined, centerX, centerY, unit * 2, 0, 360);

      var labelElement = void 0;
      if (label) {
        labelElement = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + '__label' },
          label
        );
      }

      var sunBurstMessage = a11yTitle || _Intl2.default.getMessage(intl, 'SunBurst');
      var navigationHelpMessage = _Intl2.default.getMessage(intl, 'Navigation Help');

      var graphicClasses = (0, _classnames5.default)(CLASS_ROOT + '__graphic', _defineProperty({}, CLASS_ROOT + '__graphic--focus', focus));
      return _react2.default.createElement(
        'div',
        _extends({ ref: function ref(_ref2) {
            return _this3._containerRef = _ref2;
          } }, props, { className: classes }),
        _react2.default.createElement(
          'svg',
          { className: graphicClasses, tabIndex: '0',
            viewBox: '0 0 ' + width + ' ' + height, role: 'group',
            'aria-label': sunBurstMessage + ' (' + navigationHelpMessage + ')',
            onFocus: this._onSunBurstFocus, onBlur: this._onSunBurstBlur,
            onMouseDown: function onMouseDown() {
              return _this3.setState({ mouseActive: true });
            },
            onMouseUp: function onMouseUp() {
              return _this3.setState({ mouseActive: false });
            } },
          paths
        ),
        labelElement
      );
    }
  }]);

  return SunBurst;
}(_react.Component);

SunBurst.displayName = 'SunBurst';
exports.default = SunBurst;


SunBurst.propTypes = {
  a11yTitle: _propTypes2.default.string,
  active: _propTypes2.default.arrayOf(_propTypes2.default.number),
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    children: _propTypes2.default.arrayOf(_propTypes2.default.object),
    colorIndex: _propTypes2.default.string,
    total: _propTypes2.default.number, // sum of all values otherwise
    value: _propTypes2.default.number.isRequired
  })),
  label: _propTypes2.default.node,
  onActive: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'xlarge', 'full'])
};

SunBurst.defaultProps = {
  size: 'medium'
};

SunBurst.contextTypes = {
  intl: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_Spinning__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import TableHeader from 'grommet/components/TableHeader';
var list=[];var MetricsData=function(_Component){_inherits(MetricsData,_Component);function MetricsData(props){_classCallCheck(this,MetricsData);var _this=_possibleConstructorReturn(this,(MetricsData.__proto__||Object.getPrototypeOf(MetricsData)).call(this,props));_this.state={ActvSolution:'',ActvSolutionObj:'',SolutionsList:[],showCompareSoln:false,TCOSelection:'',dataManipulation:{Performance:[true,true,true,true,true],Capacity:[true,true,true,true,true],Density:[true,true,true,true],Cost:[true,true,true,true],Power:[true],CapacityDefaults:{ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},DensityDefaults:{ComputePerf:null,StorageThroughput:null,ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},CostDefaults:{CPUPerf:null,RawStoragecapacity:null,ReplicationStoragecapacity:null,ErasureStoragecapacity:null},PowerDefaults:{CPUPerf:null}},dataManipulationExtra:{Performance:[true,true,true,true,true],Capacity:[true,true,true,true,true],Density:[true,true,true,true],Cost:[true,true,true,true],Power:[true],CapacityDefaults:{ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},DensityDefaults:{ComputePerf:null,StorageThroughput:null,ReplicationDiskCapacity:null,Erasure6DiskCapacity:null},CostDefaults:{CPUPerf:null,RawStoragecapacity:null,ReplicationStoragecapacity:null,ErasureStoragecapacity:null},PowerDefaults:{CPUPerf:null}}};_this.onActvSolutionChange=_this.onActvSolutionChange.bind(_this);_this.onExport=_this.onExport.bind(_this);_this.onTCOChange=_this.onTCOChange.bind(_this);_this.manipulateData=_this.manipulateData.bind(_this);_this.manipulateDataExtra=_this.manipulateDataExtra.bind(_this);return _this;}// componentWillMount(){
// }
// componentWillReceiveProps(nextProps){
//   if(this.props.MetricsData !== nextProps.MetricsData){
//     this.state.ActvSolution = nextProps.MetricsData.Values.Value[0]['@Header'];
//     this.state.ActvSolutionObj = nextProps.MetricsData.Values.Value[0];
//     console.log(nextProps.CompareMetricsData);
//     nextProps.MetricsData.Values.Value.map( (item, index) => {      
//       if(item['TotalCost']['#text'] !== '' && item['TotalCost']['#text'] !== undefined ){
//         list.push(item['@Header']);
//       }      
//     });
//     if(nextProps.MetricsData.Values.Value.length > 1){
//       list.push('Compare Metrics Data');
//     }        
//     this.setState ({SolutionsList: list });
//   }
// }
_createClass(MetricsData,[{key:'manipulateData',value:function manipulateData(index,component,metrics){var _this2=this;var data=this.state.dataManipulation;var actvSol=this.state.ActvSolutionObj;var value;switch(component){case'Performance':data.Performance[index]=!data.Performance[index];actvSol['Performance']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Performance':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dStorageSpecINT):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dStorageSpecINT);item['#text']=value;break;case'Storage Throughput':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeThroughPut):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeThroughPut);item['#text']=value;break;case'Storage Read IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeReadIOPS):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeReadIOPS);item['#text']=value;break;case'Storage Write IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeWriteIOPS):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeWriteIOPS);item['#text']=value;break;}}});break;case'Capacity':data.Capacity[index]=!data.Capacity[index];actvSol['Capacity']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Cores':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.iStorageCores):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.iStorageCores);item['#text']=value;break;case'Memory':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.iStorageMemory):value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.iStorageMemory);item['#text']=value;break;case'Raw Disk Capacity':if(data.Capacity[index]){value=parseFloat(item['#text'])+parseFloat(_this2.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2));}else{value=parseFloat(item['#text'])-parseFloat(_this2.props.MetricsData.manipulationData.dComputeDiskCapacity.toFixed(2));}item['#text']=value;break;case'Replication Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.ReplicationDiskCapacity):value=parseFloat((_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dReplication*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.ReplicationDiskCapacity===null){data.CapacityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.Erasure6DiskCapacity):value=parseFloat((_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/1.5*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.Erasure6DiskCapacity===null){data.CapacityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Density Metrics':data.Density[index]=!data.Density[index];actvSol['DensityMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Compute Perf':data.Density[index]?value=parseFloat(data.DensityDefaults.ComputePerf):value=(parseFloat(_this2.props.MetricsData.manipulationData.dComputeSpecINT)/parseFloat(_this2.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);if(data.DensityDefaults.ComputePerf===null){data.DensityDefaults.ComputePerf=item['#text'];}item['#text']=value;break;case'Raw Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.StorageThroughput):value=(parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity).toFixed(2)/parseFloat(_this2.props.MetricsData.manipulationData.iTotalRackHeight)).toFixed(2);if(data.DensityDefaults.StorageThroughput===null){data.DensityDefaults.StorageThroughput=item['#text'];}item['#text']=value;break;case'Replication Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.ReplicationDiskCapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dReplication*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.iTotalRackHeight).toFixed(2);if(data.DensityDefaults.ReplicationDiskCapacity===null){data.DensityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.Erasure6DiskCapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/1.5*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.iTotalRackHeight).toFixed(2);if(data.DensityDefaults.Erasure6DiskCapacity===null){data.DensityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Cost Metrics':data.Cost[index]=!data.Cost[index];actvSol['CostMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.CPUPerf):value=parseFloat(_this2.props.MetricsData.manipulationData.dComputeSpecINT/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.CPUPerf===null){data.CostDefaults.CPUPerf=item['#text'];}item['#text']=value;break;case'Raw Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.RawStoragecapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.RawStoragecapacity===null){data.CostDefaults.RawStoragecapacity=item['#text'];}item['#text']=value;break;case'Replication Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ReplicationStoragecapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/_this2.props.MetricsData.manipulationData.dReplication*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.ReplicationStoragecapacity===null){data.CostDefaults.ReplicationStoragecapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ErasureStoragecapacity):value=parseFloat(_this2.props.MetricsData.manipulationData.dStorageDiskCapacity/1.5*(1-_this2.props.MetricsData.manipulationData.dOverhead)*_this2.props.MetricsData.manipulationData.dCompression/_this2.props.MetricsData.manipulationData.dTotalCost*1000).toFixed(2);if(data.CostDefaults.ErasureStoragecapacity===null){data.CostDefaults.ErasureStoragecapacity=item['#text'];}item['#text']=value;break;}}});break;case'Power Metrics':data.Power[index]=!data.Power[index];actvSol['PowerMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Watt':data.Power[index]?value=parseFloat(data.PowerDefaults.CPUPerf):value=parseFloat(_this2.props.MetricsData.manipulationData.dComputeSpecINT/_this2.props.MetricsData.manipulationData.dTotalPower*1000).toFixed(2);if(data.PowerDefaults.CPUPerf===null){data.PowerDefaults.CPUPerf=item['#text'];}item['#text']=value;break;}}});}this.setState({dataManipulation:data,ActvSolutionObj:actvSol});}},{key:'manipulateDataExtra',value:function manipulateDataExtra(index,component,metrics){var _this3=this;var data=this.state.dataManipulationExtra;var actvSol=this.state.ActvSolutionObj;var value;switch(component){case'Performance':data.Performance[index]=!data.Performance[index];actvSol['Performance']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Performance':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT);item['#text']=value;break;case'Storage Throughput':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeThroughPut):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeThroughPut);item['#text']=value;break;case'Storage Read IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeReadIOPS):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeReadIOPS);item['#text']=value;break;case'Storage Write IOPS':data.Performance[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeWriteIOPS):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeWriteIOPS);item['#text']=value;break;}}});break;case'Capacity':data.Capacity[index]=!data.Capacity[index];actvSol['Capacity']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Cores':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageCores):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageCores);item['#text']=value;break;case'Memory':data.Capacity[index]?value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageMemory):value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.iExtraStorageMemory);item['#text']=value;break;case'Raw Disk Capacity':if(data.Capacity[index]){value=parseFloat(item['#text'])+parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2));}else{value=parseFloat(item['#text'])-parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity.toFixed(2));}item['#text']=value;break;case'Replication Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.ReplicationDiskCapacity):value=parseFloat((_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dReplication*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.ReplicationDiskCapacity===null){data.CapacityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Disk Capacity':data.Capacity[index]?value=parseFloat(data.CapacityDefaults.Erasure6DiskCapacity):value=parseFloat((_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/1.5*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression).toFixed(2));if(data.CapacityDefaults.Erasure6DiskCapacity===null){data.CapacityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Density Metrics':data.Density[index]=!data.Density[index];actvSol['DensityMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'Compute Perf':data.Density[index]?value=parseFloat(data.DensityDefaults.ComputePerf):value=(parseFloat(_this3.props.MetricsData.manipulationData.dExtraComputeSpecINT-_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT)/parseFloat(_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);if(data.DensityDefaults.ComputePerf===null){data.DensityDefaults.ComputePerf=item['#text'];}item['#text']=value;break;case'Raw Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.StorageThroughput):value=(parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity).toFixed(2)/parseFloat(_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight)).toFixed(2);if(data.DensityDefaults.StorageThroughput===null){data.DensityDefaults.StorageThroughput=item['#text'];}item['#text']=value;break;case'Replication Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.ReplicationDiskCapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dReplication*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight).toFixed(2);if(data.DensityDefaults.ReplicationDiskCapacity===null){data.DensityDefaults.ReplicationDiskCapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Data Capacity':data.Density[index]?value=parseFloat(data.DensityDefaults.Erasure6DiskCapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/1.5*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.iTotalExtraRackHeight).toFixed(2);if(data.DensityDefaults.Erasure6DiskCapacity===null){data.DensityDefaults.Erasure6DiskCapacity=item['#text'];}item['#text']=value;break;}}});break;case'Cost Metrics':data.Cost[index]=!data.Cost[index];actvSol['CostMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.CPUPerf):value=parseFloat((_this3.props.MetricsData.manipulationData.dExtraComputeSpecINT-_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT)/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.CPUPerf===null){data.CostDefaults.CPUPerf=item['#text'];}item['#text']=value;break;case'Raw Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.RawStoragecapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.RawStoragecapacity===null){data.CostDefaults.RawStoragecapacity=item['#text'];}item['#text']=value;break;case'Replication Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ReplicationStoragecapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/_this3.props.MetricsData.manipulationData.dReplication*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.ReplicationStoragecapacity===null){data.CostDefaults.ReplicationStoragecapacity=item['#text'];}item['#text']=value;break;case'Erasure 6:3 Storage capacity/Price':data.Cost[index]?value=parseFloat(data.CostDefaults.ErasureStoragecapacity):value=parseFloat(_this3.props.MetricsData.manipulationData.dExtraStorageDiskCapacity/1.5*(1-_this3.props.MetricsData.manipulationData.dOverhead)*_this3.props.MetricsData.manipulationData.dCompression/_this3.props.MetricsData.manipulationData.dExtraTotalCost*1000).toFixed(2);if(data.CostDefaults.ErasureStoragecapacity===null){data.CostDefaults.ErasureStoragecapacity=item['#text'];}item['#text']=value;break;}}});break;case'Power Metrics':data.Power[index]=!data.Power[index];actvSol['PowerMetrics']['Item'].map(function(item,itemIndex){if(itemIndex===index){switch(metrics){case'CPU Perf/Watt':data.Power[index]?value=parseFloat(data.PowerDefaults.CPUPerf):value=Math.round(parseFloat((_this3.props.MetricsData.manipulationData.dExtraComputeSpecINT-_this3.props.MetricsData.manipulationData.dExtraStorageSpecINT)/_this3.props.MetricsData.manipulationData.dTotalExtraPower*1000));if(data.PowerDefaults.CPUPerf===null){data.PowerDefaults.CPUPerf=item['#text'];}item['#text']=value;break;}}});}this.setState({dataManipulation:data,ActvSolutionObj:actvSol});}},{key:'componentWillMount',value:function componentWillMount(){this.props.onFetchMetricsData({'SessionID':this.props.activeSession.id});this.props.onFetchCompareMetricsData({'SessionID':this.props.activeSession.id});}// componentDidMount(){
//   this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
// }
},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var _this4=this;list=[];if(this.props.MetricsData!==nextProps.MetricsData){nextProps.MetricsData.output.Values.Value.map(function(item,index){if(item['TotalCost']['#text']!==''&&item['TotalCost']['#text']!==undefined){list.push(item['@Header']);if(list.length==1){_this4.state.ActvSolution=item['@Header'];_this4.state.ActvSolutionObj=nextProps.MetricsData.output.Values.Value[index];}}});if(list.indexOf('Elastic Config')!==-1&&list.indexOf('Traditional Nodes')!==-1){list.push('Compare Metrics Data');}this.setState({SolutionsList:list});}}},{key:'onActvSolutionChange',value:function onActvSolutionChange(e){var _this5=this;if(e.value==='Compare Metrics Data'){this.setState({ActvSolution:e.value,showCompareSoln:true});}else{this.props.MetricsData.output.Values.Value.map(function(item,index){if(item['@Header']===e.value){_this5.state.ActvSolutionObj=item;}});this.setState({ActvSolution:e.value,showCompareSoln:false});}}},{key:'onExport',value:function onExport(){var _this6=this;var data;if(this.state.ActvSolution==='Compare Metrics Data'){var obj={root:{element:JSON.parse(JSON.stringify(this.props.CompareMetricsData)),additionalInfo:{isCompareSolution:true}}// var root = {
//   root :obj
// }
};data={"Data":obj};}else{var filter=JSON.parse(JSON.stringify(this.props.MetricsData.output));var temp;if(Array.isArray(filter.Values.Value)){filter.Values.Value.forEach(function(item){if(item['@Header']===_this6.state.ActvSolution){temp=item;}});if(temp!==undefined){filter.Values.Value=[];filter.Values.Value.push(temp);}var content={root:{filter:filter,additionalInfo:{FactoryExpress:this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress,isCompareSolution:false}}};}data={"Data":content};}this.props.onExportMetricsData(data);}},{key:'onTCOChange',value:function onTCOChange(e){var val='';this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map(function(item,index){if(item['@Text']===e.value)val=item['#text'];});this.setState({TCOValue:val,TCOSelection:e.value});}},{key:'render',value:function render(){var _this7=this;var MainData='';var tblRowStyle={border:'1px solid #ccc'};var tblRowBoldStyle={border:'1px solid #ccc',fontWeight:'bold'};var tbltdStyle={padding:'5px',textAlign:'left',width:'10px !important'};var tbltdStyle_btn={padding:'0px',textAlign:'left',borderColor:'white'};var btnStyle={padding:'0px',textAlign:'left',background:'rgb(255, 141, 109)',border:'1px solid',color:'white',marginLeft:'5px'};var tbltdBoldStyle={padding:'5px',textAlign:'left',width:'80px !important',fontWeight:'bold'};var totalcostItems='';var mainTotalCost='';var TCOList=[];var TCOItems='';var FactoryExpress='';var FactoryExpressPerc='';var perfItems='';var capacityItems='';var densityItems='';var costItems='';var powerItems='';// Compare Metrics Variables
var compareMetricsItems='';var LoadingLayer='';if(this.props.isLoading){LoadingLayer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',style:{padding:'40px'},size:'medium',pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_icons_Spinning___default.a,{size:'small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default.a,{tag:'h5',margin:'none'},this.props.LoadingMsg)));}if(this.state.ActvSolutionObj!==''){totalcostItems=this.state.ActvSolutionObj['TotalCostMetrics']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{key:index,style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});mainTotalCost=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCost']['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCost']['#text']));if(this.state.TCOSelection===''){this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map(function(item,index){TCOList.push(item['@Text']);});this.state.TCOSelection=TCOList[0];this.state.TCOValue=this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'][0]['#text'];}else{this.state.ActvSolutionObj['ComboOptions']['TCO']['Item'].map(function(item,index){TCOList.push(item['@Text']);});}var FEOptCost='';var FEOptPerc='';this.state.ActvSolutionObj['ComboOptions']['FEOptionsCost']['Item'].filter(function(item,index){if(item['@Text']===_this7.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress){FEOptCost=item['#text'];}});this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['Item'].filter(function(item,index){if(item['@Text']===_this7.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress){FEOptPerc=item['#text'];}});FactoryExpress=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},FEOptCost));FactoryExpressPerc=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.props.FactoryExpressdata.workload.UserInputs.Environments.FactoryExpress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['ComboOptions']['FEOptionsPerc']['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},FEOptPerc));TCOItems=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowBoldStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{options:TCOList,onChange:this.onTCOChange,value:this.state.TCOSelection}),' '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.ActvSolutionObj['TotalCostMetrics']['Item'][0]['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},this.state.TCOValue));if(this.props.CompareMetricsData!==''){compareMetricsItems=this.props.CompareMetricsData.map(function(metItem,index){if(metItem['Unit']===null&&metItem['Metrics']!==' '||metItem['Unit']===" "&&metItem['Metrics']!==' '){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{key:index,style:tblRowBoldStyle,rowSpan:'4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:tbltdBoldStyle},metItem['Metrics']));}else if(metItem['Metrics']!==' '&&metItem['Unit']!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{key:index,style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['Metrics']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['WDO_Config']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},metItem['Traditional_Nodes']));}});}switch(this.state.ActvSolutionObj['@Header']){case'Elastic Config':{perfItems=this.state.ActvSolutionObj['Performance']['Item'].map(function(item,index){var text='';_this7.state.dataManipulation.Performance[index]?text='Remove':text='Add';item['@Text'].indexOf('Performance')>0?text+=' Storage':text+=' Compute';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{plain:true,style:btnStyle,label:text,onClick:function onClick(){_this7.manipulateData(index,'Performance',item['@Text']);}})));/* Changes by Vinay, removed open and close braces as the content inside that is commented. for CID:10009*//*<td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Performance',item['@Text'])}}>{text}</td>      */});capacityItems=this.state.ActvSolutionObj['Capacity']['Item'].map(function(item,index){var text='';_this7.state.dataManipulation.Capacity[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Compute':text+=' Storage';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{plain:true,style:btnStyle,label:text,onClick:function onClick(){_this7.manipulateData(index,'Capacity',item['@Text']);}})));});densityItems=this.state.ActvSolutionObj['DensityMetrics']['Item'].map(function(item,index){var text='';_this7.state.dataManipulation.Density[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Compute':text+=' Storage';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this7.state.dataManipulation.Density[index]!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this7.manipulateData(index,'Density Metrics',item['@Text']);}})):'');// <TableRow style={tblRowStyle} >
//  <td style={tbltdStyle} onClick={()=>{this.manipulateData(index,'Density Metrics',item['@Text'])}}>{text}</td> 
// </TableRow>
//} 
});costItems=this.state.ActvSolutionObj['CostMetrics']['Item'].map(function(item,index){var text='';_this7.state.dataManipulation.Cost[index]?text='Remove':text='Add';item['@Text'].indexOf('capacity')>0?text+=' Compute':text+=' Storage';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this7.state.dataManipulation.Cost[index]!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this7.manipulateData(index,'Cost Metrics',item['@Text']);}})):'');});powerItems=this.state.ActvSolutionObj['PowerMetrics']['Item'].map(function(item,index){var text='';_this7.state.dataManipulation.Power[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Compute':text+=' Storage';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this7.state.dataManipulation.Power[index]!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this7.manipulateData(index,'Power Metrics',item['@Text']);}})):'');});break;}case'Extra Nodes':{perfItems=this.state.ActvSolutionObj['Performance']['Item'].map(function(item,index){var text='';_this7.state.dataManipulationExtra.Performance[index]?text='Remove':text='Add';item['@Text'].indexOf('Performance')>0?text+=' Custom':text+=' Edge';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{plain:true,style:btnStyle,label:text,onClick:function onClick(){_this7.manipulateDataExtra(index,'Performance',item['@Text']);}})));});capacityItems=this.state.ActvSolutionObj['Capacity']['Item'].map(function(item,index){var text='';_this7.state.dataManipulationExtra.Capacity[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Edge':text+=' Custom';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{plain:true,style:btnStyle,label:text,onClick:function onClick(){_this7.manipulateDataExtra(index,'Capacity',item['@Text']);}})));});densityItems=this.state.ActvSolutionObj['DensityMetrics']['Item'].map(function(item,index){var text='';_this7.state.dataManipulationExtra.Density[index]?text='Remove':text='Add';item['@Text'].indexOf('Capacity')>0?text+=' Edge':text+=' Custom';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this7.state.dataManipulationExtra.Density[index]!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this7.manipulateDataExtra(index,'Density Metrics',item['@Text']);}})):'');});costItems=this.state.ActvSolutionObj['CostMetrics']['Item'].map(function(item,index){var text='';_this7.state.dataManipulationExtra.Cost[index]?text='Remove':text='Add';item['@Text'].indexOf('capacity')>0?text+=' Edge':text+=' Custom';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this7.state.dataManipulationExtra.Cost[index]!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this7.manipulateDataExtra(index,'Cost Metrics',item['@Text']);}})):'');});powerItems=this.state.ActvSolutionObj['PowerMetrics']['Item'].map(function(item,index){var text='';_this7.state.dataManipulationExtra.Power[index]?text='Remove':text='Add';text+=' Custom';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']),_this7.state.dataManipulationExtra.Power[index]!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle_btn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:text,plain:true,style:btnStyle,onClick:function onClick(){_this7.manipulateDataExtra(index,'Power Metrics',item['@Text']);}})):'');});break;}case'Traditional Nodes':{perfItems=this.state.ActvSolutionObj['Performance']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});capacityItems=this.state.ActvSolutionObj['Capacity']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});densityItems=this.state.ActvSolutionObj['DensityMetrics']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});costItems=this.state.ActvSolutionObj['CostMetrics']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});powerItems=this.state.ActvSolutionObj['PowerMetrics']['Item'].map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_TableRow___default.a,{style:tblRowStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Text']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Unit']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['#text']));});break;}default:break;}if(!this.state.showCompareSoln){MainData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Tabs___default.a,{justify:'start',style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Total Cost Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',separator:'bottom',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'500px',width:'100% !important',overflowX:'hidden',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,{scrollable:true,style:{marginTop:'470px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'35%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,totalcostItems,mainTotalCost,FactoryExpress,FactoryExpressPerc,TCOItems)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Performance'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable_Button',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'100%',width:'100%! important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,perfItems)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Capacity'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable_Button',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'100%',width:'100%! important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'10%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,capacityItems)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Density Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable_Button',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'100%',width:'100%!import'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'23%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,densityItems)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Cost Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable_Button',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'100%',width:'100%!import'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'30%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'15%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,costItems)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Tab___default.a,{title:'Power Metrics'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',className:'TabInnerSection MetricsTable_Button',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'100%',width:'100%!import'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'25%'}},'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{width:'20%'}},'Value'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{style:{backgroundColor:'white',border:'white'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,powerItems)))));}else{MainData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{separator:'bottom',className:'TabInnerSection MetricsTable',margin:'none',pad:'none',justify:'center',align:'center',style:{height:'600px',width:'50% !important',overflowX:'hidden',overflowY:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Table___default.a,{className:'marginClassforIe',scrollable:true,style:{marginTop:'50px',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Metrics'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Unit'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Elastic Config'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',null,'Traditional Nodes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,compareMetricsItems)));//   MainData = <Box separator='all' className="TabInnerSection" 
//                   margin="none" pad="small" justify='start' align='start' 
//                   style={{ height:'630px', marginTop: '12px', width:'100% !important', overflow:'auto' }} >
//                   <Table scrollable={true} >
//                       <TableHeader labels={['Metrics', 'Unit', 'WDO Config']} />
//                       <tbody>
//                         <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >CPU Perf/Price</td>
//                             <td style={tbltdStyle} >SpecINT/$1K</td>
//                             <td style={tbltdStyle} >16.23</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.11</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.03</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.06</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Storage Perf/Price</td>
//                             <td style={tbltdStyle} >MB/s per $1K</td>
//                             <td style={tbltdStyle} >25.21</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >CPU Perf/Price</td>
//                             <td style={tbltdStyle} >SpecINT/$1K</td>
//                             <td style={tbltdStyle} >16.23</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.11</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.03</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.06</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Storage Perf/Price</td>
//                             <td style={tbltdStyle} >MB/s per $1K</td>
//                             <td style={tbltdStyle} >25.21</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >CPU Perf/Price</td>
//                             <td style={tbltdStyle} >SpecINT/$1K</td>
//                             <td style={tbltdStyle} >16.23</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.11</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.03</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.06</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Storage Perf/Price</td>
//                             <td style={tbltdStyle} >MB/s per $1K</td>
//                             <td style={tbltdStyle} >25.21</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >CPU Perf/Price</td>
//                             <td style={tbltdStyle} >SpecINT/$1K</td>
//                             <td style={tbltdStyle} >16.23</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Raw Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.11</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Replication Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.03</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Erasure 6:3 Storage capacity/Price</td>
//                             <td style={tbltdStyle} >TB/$1K</td>
//                             <td style={tbltdStyle} >0.06</td>
//                           </TableRow>
//                           <TableRow style={tblRowStyle} >
//                             <td style={tbltdStyle} >Storage Perf/Price</td>
//                             <td style={tbltdStyle} >MB/s per $1K</td>
//                             <td style={tbltdStyle} >25.21</td>
//                         </TableRow>
//                       </tbody>
//                   </Table>
//              </Box>
}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{width:'100% !important',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Heading___default.a,{tag:'h5',margin:'small',strong:false},'Solutions : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Select___default.a,{onChange:this.onActvSolutionChange.bind(this),options:this.state.SolutionsList,style:{maxWidth:'225px'},value:this.state.ActvSolution}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Button___default.a,{label:'Export to Excel',primary:true,onClick:this.onExport,style:{height:'40px',marginTop:'3px'}}),this.state.ActvSolution==='Compare Metrics Data'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_Paragraph___default.a,{style:{margin:'12px 0px 0px 100px',color:'red'}},'Note: Extra node values are included in Elastic config value.'):''),LoadingLayer,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Box___default.a,{margin:'none',pad:'none',style:{width:'100% !important'}},MainData));}}]);return MetricsData;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isLoading:state.sessions.isLoading,LoadingMsg:state.sessions.LoadingMsg,activeSession:state.sessions.activeSession,MetricsData:state.sessions.activeSession.MetricsData,CompareMetricsData:state.sessions.activeSession.CompareMetricsData,FactoryExpressdata:state.sizerWorkload};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onFetchMetricsData:function onFetchMetricsData(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["A" /* fetchMetricsData */])(obj));},onFetchCompareMetricsData:function onFetchCompareMetricsData(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["t" /* fetchCompareMetricsData */])(obj));},onExportMetricsData:function onExportMetricsData(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__State_actions_sessions__["n" /* downloadMetricsData */])(data));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(MetricsData));

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Label__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Alert__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_grommet_components_Box___default.a,{size:'xlarge',direction:'row',margin:'none',pad:'small',style:{backgroundColor:'#ffd144',marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_icons_base_Alert___default.a,{size:'small',margin:'small',type:'status'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Label___default.a,{style:{marginLeft:'10px'},size:'medium',margin:'none'},props.message));});

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var PropTypes = _interopDefault(__webpack_require__(1));
var React = _interopDefault(__webpack_require__(0));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var Beforeunload =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Beforeunload, _React$Component);

  function Beforeunload() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Beforeunload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Beforeunload)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleBeforeunload", function (event) {
      var onBeforeunload = _this.props.onBeforeunload;
      var returnValue;

      if (onBeforeunload) {
        returnValue = onBeforeunload(event);
      }

      if (typeof returnValue === 'string') {
        event.returnValue = returnValue;
        return returnValue;
      }
    });

    return _this;
  }

  _createClass(Beforeunload, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('beforeunload', this.handleBeforeunload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.handleBeforeunload);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$children = this.props.children,
          children = _this$props$children === void 0 ? null : _this$props$children;
      return children;
    }
  }]);

  return Beforeunload;
}(React.Component);

_defineProperty(Beforeunload, "propTypes", {
  children: PropTypes.any,
  onBeforeunload: PropTypes.func.isRequired
});

module.exports = Beforeunload;


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useIdleTimer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function r(e){return(r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function i(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}function u(e){return(u=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function c(e,t){return(c=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function s(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function a(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?s(e):t}function l(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return!1}}();return function(){var n,o=u(e);if(t){var r=u(this).constructor;n=Reflect.construct(o,arguments,r)}else n=o.apply(this,arguments);return a(this,n)}}var d="object"===("undefined"==typeof window||"undefined"==typeof window?"undefined":r(window)),f=d?document:{},v=["mousemove","keydown","wheel","DOMMouseScroll","mouseWheel","mousedown","touchstart","touchmove","MSPointerDown","MSPointerMove","visibilitychange"];function p(e,t){var n;return function(){for(var o=arguments.length,r=new Array(o),i=0;i<o;i++)r[i]=arguments[i];n&&clearTimeout(n),n=setTimeout((function(){e.apply(void 0,r),n=null}),t)}}function h(e,t){var n=0;return function(){var o=(new Date).getTime();if(!(o-n<t))return n=o,e.apply(void 0,arguments)}}var m=function(t){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&c(e,t)}(a,__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var n,o,r,u=l(a);function a(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(t=u.call(this,e)).state={idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null,pageX:null,pageY:null},t.tId=null,t.eventsBound=!1,e.debounce>0&&e.throttle>0)throw new Error("onAction can either be throttled or debounced (not both)");return e.debounce>0?t._onAction=p(e.onAction,e.debounce):e.throttle>0?t._onAction=h(e.onAction,e.throttle):e.onAction?t._onAction=e.onAction:t._onAction=function(){},e.eventsThrottle>0?t._handleEvent=h(t._handleEvent.bind(s(t)),e.eventsThrottle):t._handleEvent=t._handleEvent.bind(s(t)),e.startOnMount||(t.state.idle=!0),t._toggleIdleState=t._toggleIdleState.bind(s(t)),t.reset=t.reset.bind(s(t)),t.pause=t.pause.bind(s(t)),t.resume=t.resume.bind(s(t)),t.getRemainingTime=t.getRemainingTime.bind(s(t)),t.getElapsedTime=t.getElapsedTime.bind(s(t)),t.getLastActiveTime=t.getLastActiveTime.bind(s(t)),t.isIdle=t.isIdle.bind(s(t)),t}return n=a,(o=[{key:"componentDidMount",value:function(){this._bindEvents(),this.props.startOnMount&&this.reset()}},{key:"componentDidUpdate",value:function(e){e.debounce!==this.props.debounce&&(this._onAction=p(this._onAction,this.props.debounce)),e.throttle!==this.props.throttle&&(this._onAction=h(this._onAction,this.props.throttle)),e.eventsThrottle!==this.props.eventsThrottle&&(this._handleEvent=h(this._handleEvent,this.props.eventsThrottle))}},{key:"componentWillUnmount",value:function(){clearTimeout(this.tId),this._unbindEvents(!0)}},{key:"render",value:function(){return this.props.children||null}},{key:"_bindEvents",value:function(){var e=this;if(d){var t=this.props,n=t.element,o=t.events,r=t.passive,i=t.capture;this.eventsBound||(o.forEach((function(t){n.addEventListener(t,e._handleEvent,{capture:i,passive:r})})),this.eventsBound=!0)}}},{key:"_unbindEvents",value:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(d){var n=this.props,o=n.element,r=n.events,i=n.passive,u=n.capture;(this.eventsBound||t)&&(r.forEach((function(t){o.removeEventListener(t,e._handleEvent,{capture:u,passive:i})})),this.eventsBound=!1)}}},{key:"_toggleIdleState",value:function(e){var t=this;this.setState((function(e){return{idle:!e.idle}}),(function(){var n=t.props,o=n.onActive,r=n.onIdle,i=n.stopOnIdle;t.state.idle?(i&&(clearTimeout(t.tId),t.tId=null,t._unbindEvents()),r(e)):i||(t._bindEvents(),o(e))}))}},{key:"_handleEvent",value:function(e){var t=this.state,n=t.remaining,o=t.pageX,r=t.pageY,i=t.idle,u=this.props,c=u.timeout,s=u.stopOnIdle;if(this._onAction(e),!n){if("mousemove"===e.type){if(e.pageX===o&&e.pageY===r)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(this.getElapsedTime()<200)return}clearTimeout(this.tId),this.tId=null;var a=+new Date-this.getLastActiveTime();(i&&!s||!i&&a>c)&&this._toggleIdleState(e),this.setState({lastActive:+new Date,pageX:e.pageX,pageY:e.pageY}),i&&s||(this.tId=setTimeout(this._toggleIdleState,c))}}},{key:"reset",value:function(){clearTimeout(this.tId),this.tId=null,this._bindEvents(),this.setState({idle:!1,oldDate:+new Date,lastActive:+new Date,remaining:null});var e=this.props.timeout;this.tId=setTimeout(this._toggleIdleState,e)}},{key:"pause",value:function(){null===this.state.remaining&&(this._unbindEvents(),clearTimeout(this.tId),this.tId=null,this.setState({remaining:this.getRemainingTime()}))}},{key:"resume",value:function(){var e=this.state,t=e.remaining,n=e.idle;null!==t&&(this._bindEvents(),n||(this.tId=setTimeout(this._toggleIdleState,t),this.setState({remaining:null,lastActive:+new Date})))}},{key:"getRemainingTime",value:function(){var e=this.state,t=e.remaining,n=e.lastActive,o=this.props.timeout;if(null!==t)return t<0?0:t;var r=o-(+new Date-n);return r<0?0:r}},{key:"getElapsedTime",value:function(){var e=this.state.oldDate;return+new Date-e}},{key:"getLastActiveTime",value:function(){return this.state.lastActive}},{key:"isIdle",value:function(){return this.state.idle}}])&&i(n.prototype,o),r&&i(n,r),a}();function b(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},o=e.timeout,r=void 0===o?12e5:o,i=e.element,u=void 0===i?f:i,c=e.events,s=void 0===c?v:c,a=e.onIdle,l=void 0===a?function(){}:a,m=e.onActive,b=void 0===m?function(){}:m,g=e.onAction,y=void 0===g?function(){}:g,T=e.debounce,w=void 0===T?0:T,_=e.throttle,A=void 0===_?0:_,I=e.eventsThrottle,E=void 0===I?200:I,O=e.startOnMount,D=void 0===O||O,S=e.stopOnIdle,k=void 0!==S&&S,M=e.capture,R=void 0===M||M,j=e.passive,P=void 0===j||j,L=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(!1),X=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(!0),Y=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(+new Date),B=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(+new Date),x=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),U=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),W=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),C=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null),q=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(l),z=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(b),F=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(y),G=function(e){var t=!X.current;X.current=t,t?(k&&(clearTimeout(C.current),C.current=null,K()),q.current(e)):k||(J(),z.current(e))},H=function(e){if(F.current(e),!x.current){if("mousemove"===e.type){if(e.pageX===U&&e.pageY===W)return;if(void 0===e.pageX&&void 0===e.pageY)return;if(Q()<200)return}clearTimeout(C.current),C.current=null;var t=+new Date-V();(X.current&&!k||!X.current&&t>r)&&G(e),B.current=+new Date,U.current=e.pageX,W.current=e.pageY,X.current&&k||(C.current=setTimeout(G,r))}},J=function(){d&&(L.current||(s.forEach((function(e){u.addEventListener(e,H,{capture:R,passive:P})})),L.current=!0))},K=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];d&&(L.current||e)&&(s.forEach((function(e){u.removeEventListener(e,H,{capture:R,passive:P})})),L.current=!1)},N=function(){if(null!==x.current)return x.current<0?0:x.current;var e=r-(+new Date-B.current);return e<0?0:e},Q=function(){return+new Date-Y.current},V=function(){return B.current},Z=function(){return X.current},$=function(){clearTimeout(C.current),C.current=null,J(),X.current=!1,Y.current=+new Date,B.current=+new Date,x.current=null,C.current=setTimeout(G,r)},ee=function(){null===x.current&&(K(),clearTimeout(C.current),C.current=null,x.current=N())},te=function(){null!==x.current&&(J(),X.current||(C.current=setTimeout(G,x.current),x.current=null,B.current=+new Date))};return Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){if(w>0&&A>0)throw new Error("onAction can either be throttled or debounced (not both)");return E>0&&(H=h(H,E)),J(),D&&$(),function(){clearTimeout(C.current),K(!0)}}),[]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){q.current=l}),[l]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){z.current=b}),[b]),Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])((function(){F.current=w>0?p(y,w):A>0?h(y,A):y}),[y]),{isIdle:Z,pause:ee,reset:$,resume:te,getLastActiveTime:V,getElapsedTime:Q,getRemainingTime:N}}m.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,events:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),onIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,debounce:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,throttle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,eventsThrottle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,element:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),startOnMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,stopOnIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,passive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,capture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},m.defaultProps={timeout:12e5,element:f,events:v,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0},b.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,events:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),onIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onActive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onAction:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,debounce:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,throttle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,eventsThrottle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,element:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),startOnMount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,stopOnIdle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,passive:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,capture:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},b.defaultProps={timeout:12e5,element:f,events:v,onIdle:function(){},onActive:function(){},onAction:function(){},debounce:0,throttle:0,eventsThrottle:200,startOnMount:!0,stopOnIdle:!1,capture:!0,passive:!0};/* harmony default export */ __webpack_exports__["a"] = (m);
//# sourceMappingURL=index.es.js.map


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Meter__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Meter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Meter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_App__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_App__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var prg="";var Progressbar=function(_Component){_inherits(Progressbar,_Component);function Progressbar(){_classCallCheck(this,Progressbar);var _this=_possibleConstructorReturn(this,(Progressbar.__proto__||Object.getPrototypeOf(Progressbar)).call(this));_this.state={Text:"",progress:0,content2:'Sizing in progress. Please wait while your data is being processed.'};return _this;}_createClass(Progressbar,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var i=0;var interval=100/this.props.inputs.length;var progress=interval;var timeOut=this.props.TimeInterval/this.props.inputs.length;var tempInput=this.props.inputs;this.setState({Text:tempInput[i++],progress:progress});prg=setInterval(function(){progress+=interval;if(i<_this2.props.inputs.length){_this2.setState({Text:tempInput[i++],progress:progress});}else{i++;}if(i===_this2.props.inputs.length+1){_this2.setState({content2:'Sizing is completed.  Please wait until system provides sizing data.'});clearInterval(prg);}},timeOut);}},{key:'render',value:function render(){var layer="";layer=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default.a,{style:{zIndex:'500 !important',width:"30%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{backgroundColor:'white',width:'100%'},pad:{'between':'small'},size:'large'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{backgroundColor:'#425563',marginBottom:"0px",padding:"10px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',style:{color:'white',marginBottom:'0px'}},"Sizer Processing")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{pad:'small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h5',style:{alignSelf:'center',marginBottom:'0px',fontWeight:'400'}},"Step : ",' ',this.state.Text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Meter___default.a,{size:'large',value:this.state.progress}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Heading___default.a,{tag:'h4',style:{alignSelf:'center',fontWeight:'400'}},this.state.content2))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_App___default.a,{centered:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:'everything',className:'everything'},layer));}}]);return Progressbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{isSizingSolutionPending:state.sessions.isSizingSolutionPending};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{isSizingSolutionPendingFalse:function isSizingSolutionPendingFalse(){dispatch({type:'ISSIZINGSOLUTION_PENDING',payload:" "});}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Progressbar));

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Responsive = __webpack_require__(78);

var _Responsive2 = _interopRequireDefault(_Responsive);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _Bar = __webpack_require__(715);

var _Bar2 = _interopRequireDefault(_Bar);

var _Spiral = __webpack_require__(716);

var _Spiral2 = _interopRequireDefault(_Spiral);

var _Circle = __webpack_require__(717);

var _Circle2 = _interopRequireDefault(_Circle);

var _Arc = __webpack_require__(718);

var _Arc2 = _interopRequireDefault(_Arc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.METER;

var TYPE_COMPONENT = {
  'bar': _Bar2.default,
  'circle': _Circle2.default,
  'arc': _Arc2.default,
  'spiral': _Spiral2.default
};

function getMaxDecimalDigits(series) {
  var maxDigits = 0;
  series.forEach(function (item) {
    var currentDigitsGroup = /\.(\d*)$/.exec(item.value.toString());
    if (currentDigitsGroup) {
      var currentDigits = currentDigitsGroup[1].length;
      maxDigits = Math.max(maxDigits, currentDigits);
    }
  });
  return Math.pow(10, maxDigits);
}

var Meter = function (_Component) {
  _inherits(Meter, _Component);

  function Meter(props, context) {
    _classCallCheck(this, Meter);

    var _this = _possibleConstructorReturn(this, (Meter.__proto__ || Object.getPrototypeOf(Meter)).call(this, props, context));

    _this._onResponsive = _this._onResponsive.bind(_this);
    _this._initialTimeout = _this._initialTimeout.bind(_this);
    _this._onActivate = _this._onActivate.bind(_this);

    _this.state = _this._stateFromProps(props);
    _this.state.initial = true;
    _this.state.limitMeterSize = false;
    return _this;
  }

  _createClass(Meter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.responsive) {
        this._responsive = _Responsive2.default.start(this._onResponsive);
      }

      this._initialTimer = setTimeout(this._initialTimeout, 10);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this._stateFromProps(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._initialTimer);

      if (this._responsive) {
        this._responsive.stop();
      }
    }
  }, {
    key: '_normalizeSeries',
    value: function _normalizeSeries(props, thresholds) {
      var series = [];
      if (props.series) {
        series = props.series;
      } else if (props.value || props.value === 0) {
        series = [{ value: props.value }];
        if (props.colorIndex) {
          series[0].colorIndex = props.colorIndex;
        }
      }

      // set color index
      if (series.length === 1 && props.thresholds) {
        var item = series[0];
        if (!item.colorIndex) {
          // see which threshold color index to use
          var cumulative = 0;
          thresholds.some(function (threshold) {
            cumulative += threshold.value;
            if (item.value < cumulative) {
              item.colorIndex = threshold.colorIndex || 'graph-1';
              return true;
            }
            return false;
          });
        }
      } else {
        series.forEach(function (item, index) {
          if (!item.colorIndex) {
            item.colorIndex = 'graph-' + (index + 1);
          }
        });
      }

      return series;
    }
  }, {
    key: '_normalizeThresholds',
    value: function _normalizeThresholds(props, min, max) {
      var thresholds = [];
      if (props.thresholds) {
        // Convert thresholds from absolute values to cummulative,
        // so we can re-use the series drawing code.
        var priorValue = min;
        thresholds.push({ hidden: true });
        for (var i = 0; i < props.thresholds.length; i += 1) {
          var threshold = props.thresholds[i];
          // The value for the prior threshold ends at the beginning of this
          // threshold. Series drawing code expects the end value.
          thresholds[i].value = threshold.value - priorValue;
          thresholds.push({
            colorIndex: threshold.colorIndex
          });
          priorValue = threshold.value;
          if (i === props.thresholds.length - 1) {
            thresholds[thresholds.length - 1].value = max - priorValue;
          }
        }
      } else if (props.threshold) {
        thresholds = [{ value: props.threshold, hidden: true }, {
          value: max - props.threshold,
          colorIndex: 'critical'
        }];
      }
      return thresholds;
    }
  }, {
    key: '_seriesTotal',
    value: function _seriesTotal(series) {
      var maxDecimalDigits = getMaxDecimalDigits(series);
      var total = 0;
      series.forEach(function (item) {
        total += item.value * maxDecimalDigits;
      });

      return total / maxDecimalDigits;
    }
  }, {
    key: '_seriesMax',
    value: function _seriesMax(series) {
      var max = 0;
      series.some(function (item) {
        max = Math.max(max, item.value);
      });
      return max;
    }

    // Generates state based on the provided props.

  }, {
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      var total = void 0;
      if (props.series) {
        total = this._seriesTotal(props.series);
      } else if (props.hasOwnProperty('value')) {
        total = props.value;
      } else {
        total = 0;
      }
      var seriesMax = void 0;
      // only care about series max when there are multiple values
      if (props.series && props.series.length > 1) {
        seriesMax = this._seriesMax(props.series);
      }
      // Normalize min and max
      var min = props.min || 0;
      // Max could be provided in props or come from the total of
      // a multi-value series.
      var max = props.max || (props.stacked ? Math.max(seriesMax, total || 0, 100) : seriesMax || Math.max(total || 0, 100));
      // Normalize simple threshold prop to an array, if needed.
      var thresholds = this._normalizeThresholds(props, min, max);
      // Normalize simple value prop to a series, if needed.
      var series = this._normalizeSeries(props, thresholds);

      var nextState = {
        series: series,
        thresholds: thresholds,
        min: min,
        max: max,
        total: total
      };

      if (props.hasOwnProperty('activeIndex')) {
        nextState.activeIndex = props.activeIndex;
      } else if (props.hasOwnProperty('active')) {
        nextState.activeIndex = props.active ? 0 : undefined;
      }

      return nextState;
    }
  }, {
    key: '_initialTimeout',
    value: function _initialTimeout() {
      this.setState({
        initial: false,
        activeIndex: this.state.activeIndex
      });
      clearTimeout(this._initialTimer);
    }
  }, {
    key: '_onResponsive',
    value: function _onResponsive(small) {
      this.setState({ limitMeterSize: small ? true : false });
    }
  }, {
    key: '_onActivate',
    value: function _onActivate(index) {
      var onActive = this.props.onActive;

      this.setState({ initial: false, activeIndex: index });
      if (onActive) {
        onActive(index);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames,
          _this2 = this;

      var _props = this.props,
          active = _props.active,
          a11yTitle = _props.a11yTitle,
          className = _props.className,
          label = _props.label,
          onActive = _props.onActive,
          size = _props.size,
          stacked = _props.stacked,
          tabIndex = _props.tabIndex,
          type = _props.type,
          vertical = _props.vertical,
          props = _objectWithoutProperties(_props, ['active', 'a11yTitle', 'className', 'label', 'onActive', 'size', 'stacked', 'tabIndex', 'type', 'vertical']);

      delete props.activeIndex;
      delete props.colorIndex;
      delete props.max;
      delete props.min;
      delete props.series;
      delete props.threshold;
      delete props.thresholds;
      delete props.value;
      delete props.responsive;
      var _state = this.state,
          activeIndex = _state.activeIndex,
          limitMeterSize = _state.limitMeterSize,
          max = _state.max,
          min = _state.min,
          series = _state.series,
          thresholds = _state.thresholds,
          total = _state.total;


      var responsiveSize = void 0;
      if (size) {
        responsiveSize = size;
        // shrink Meter to medium size if large and up
        if (limitMeterSize && (size === 'large' || size === 'xlarge')) {
          responsiveSize = 'medium';
        }
      }

      var classes = (0, _classnames3.default)(CLASS_ROOT, (_classnames = {}, _defineProperty(_classnames, CLASS_ROOT + '--' + type, type), _defineProperty(_classnames, CLASS_ROOT + '--stacked', stacked), _defineProperty(_classnames, CLASS_ROOT + '--vertical', vertical), _defineProperty(_classnames, CLASS_ROOT + '--loading', series.length === 0), _defineProperty(_classnames, CLASS_ROOT + '--single', series.length === 1), _defineProperty(_classnames, CLASS_ROOT + '--count-' + series.length, series.length > 1), _defineProperty(_classnames, CLASS_ROOT + '--' + responsiveSize, responsiveSize), _defineProperty(_classnames, CLASS_ROOT + '--active', active), _classnames), className);

      var labelElement = void 0;
      if (label) {
        labelElement = _react2.default.createElement(
          'div',
          { className: CLASS_ROOT + '__label' },
          label
        );
      }

      var onActivate = void 0;
      if (onActive || series.length > 1 || series.length === 1 && series[0].onClick) {
        onActivate = this._onActivate;
      }

      var GraphicComponent = TYPE_COMPONENT[this.props.type];
      var graphic = _react2.default.createElement(GraphicComponent, {
        a11yTitle: a11yTitle,
        activeIndex: activeIndex,
        min: min, max: max,
        onActivate: onActivate,
        series: series,
        stacked: stacked,
        tabIndex: tabIndex,
        thresholds: thresholds,
        total: total,
        vertical: vertical });

      var graphicContainer = _react2.default.createElement(
        'div',
        _extends({}, props, { className: CLASS_ROOT + '__graphic-container' }),
        graphic
      );

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { ref: function ref(_ref) {
              return _this2.activeGraphicRef = _ref;
            },
            className: CLASS_ROOT + '__value-container' },
          graphicContainer,
          labelElement
        )
      );
    }
  }]);

  return Meter;
}(_react.Component);

Meter.displayName = 'Meter';
exports.default = Meter;


Meter.propTypes = {
  active: _propTypes2.default.bool, // when single value
  activeIndex: _propTypes2.default.number, // for series values
  a11yTitle: _propTypes2.default.string,
  colorIndex: _propTypes2.default.string,
  label: _propTypes2.default.node,
  max: _propTypes2.default.number,
  min: _propTypes2.default.number,
  onActive: _propTypes2.default.func,
  series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    colorIndex: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    label: _propTypes2.default.string, // only for Spiral
    value: _propTypes2.default.number.isRequired
  })),
  size: _propTypes2.default.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
  stacked: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.string,
  threshold: _propTypes2.default.number,
  thresholds: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.number.isRequired,
    colorIndex: _propTypes2.default.string
  })),
  type: _propTypes2.default.oneOf(['bar', 'arc', 'circle', 'spiral']),
  value: _propTypes2.default.number,
  vertical: _propTypes2.default.bool,
  responsive: _propTypes2.default.bool
};

Meter.defaultProps = {
  type: 'bar'
};

Meter.contextTypes = {
  intl: _propTypes2.default.object
};
module.exports = exports['default'];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Graphics = __webpack_require__(86);

var _utils = __webpack_require__(107);

var _Graphic2 = __webpack_require__(143);

var _Graphic3 = _interopRequireDefault(_Graphic2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var BAR_LENGTH = _utils.baseDimension;
var BAR_THICKNESS = _Graphics.baseUnit;
var MID_BAR_THICKNESS = BAR_THICKNESS / 2;
// const MINIMUM_THICKNESS = BAR_THICKNESS / 6;

var Bar = function (_Graphic) {
  _inherits(Bar, _Graphic);

  function Bar(props, context) {
    _classCallCheck(this, Bar);

    //needed in Graphic.js to fix minification issues
    var _this = _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).call(this, props, context));

    _this.displayName = 'Bar';
    return _this;
  }

  _createClass(Bar, [{
    key: '_viewBoxDimensions',
    value: function _viewBoxDimensions(props) {
      var viewBoxHeight = void 0;
      var viewBoxWidth = void 0;
      if (props.vertical) {
        if (props.stacked) {
          viewBoxWidth = BAR_THICKNESS;
        } else {
          viewBoxWidth = BAR_THICKNESS * Math.max(1, props.series.length);
        }
        viewBoxHeight = BAR_LENGTH;
      } else {
        viewBoxWidth = BAR_LENGTH;
        if (props.stacked) {
          viewBoxHeight = BAR_THICKNESS;
        } else {
          viewBoxHeight = BAR_THICKNESS * Math.max(1, props.series.length);
        }
      }
      return [viewBoxWidth, viewBoxHeight];
    }
  }, {
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      var viewBoxDimensions = this._viewBoxDimensions(props);

      var state = {
        scale: BAR_LENGTH / (props.max - props.min),
        viewBoxWidth: viewBoxDimensions[0],
        viewBoxHeight: viewBoxDimensions[1]
      };

      return state;
    }
  }, {
    key: '_translateBarWidth',
    value: function _translateBarWidth(value) {
      return Math.ceil(this.state.scale * value);
    }
  }, {
    key: '_sliceCommands',
    value: function _sliceCommands(trackIndex, item, startValue) {
      var value = item.value - this.props.min;
      var start = this._translateBarWidth(startValue);
      var distance = this._translateBarWidth(value);
      // const distance = Math.max((item.value > 0 ? MINIMUM_THICKNESS : 0),
      //   this._translateBarWidth(value));
      var commands = void 0;
      var spot = trackIndex * BAR_THICKNESS + MID_BAR_THICKNESS;
      if (this.props.vertical) {
        commands = "M" + spot + "," + (BAR_LENGTH - start) + " L" + spot + "," + (BAR_LENGTH - (start + distance));
      } else {
        commands = "M" + start + "," + spot + " L" + (start + distance) + "," + spot;
      }
      return commands;
    }
  }]);

  return Bar;
}(_Graphic3.default);

//needed in Graphic.js to fix minification issues


exports.default = Bar;
Bar.displayName = 'Bar';
module.exports = exports['default'];

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames2 = __webpack_require__(3);

var _classnames3 = _interopRequireDefault(_classnames2);

var _Graphics = __webpack_require__(86);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _utils = __webpack_require__(107);

var _Graphic2 = __webpack_require__(143);

var _Graphic3 = _interopRequireDefault(_Graphic2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.METER;

var SPIRAL_WIDTH = _utils.baseDimension;
var SPIRAL_RADIUS = _utils.baseDimension / 2 - _Graphics.baseUnit / 2;
var RING_THICKNESS = _Graphics.baseUnit;
// Allow for active value content next to a spiral meter

var Spiral = function (_Graphic) {
  _inherits(Spiral, _Graphic);

  function Spiral(props, context) {
    _classCallCheck(this, Spiral);

    //needed in Graphic.js to fix minification issues
    var _this = _possibleConstructorReturn(this, (Spiral.__proto__ || Object.getPrototypeOf(Spiral)).call(this, props, context));

    _this.displayName = 'Spiral';
    return _this;
  }

  _createClass(Spiral, [{
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      var viewBoxHeight = Math.max(SPIRAL_WIDTH, RING_THICKNESS * (props.series.length + 1) * 2);
      var viewBoxWidth = viewBoxHeight;

      var state = {
        startAngle: 0,
        anglePer: 270.0 / props.max,
        angleOffset: 180,
        // The last spiral ends out near but not quite at the edge of the
        // view box.
        startRadius: Math.max(SPIRAL_RADIUS, RING_THICKNESS * (props.series.length + 0.5)) - Math.max(0, props.series.length - 1) * RING_THICKNESS,
        viewBoxHeight: viewBoxHeight,
        viewBoxRadius: viewBoxWidth / 2,
        viewBoxWidth: viewBoxWidth
      };

      return state;
    }
  }, {
    key: '_sliceCommands',
    value: function _sliceCommands(trackIndex, item, startValue) {
      var viewBoxRadius = this.state.viewBoxRadius;

      var startAngle = (0, _Graphics.translateEndAngle)(this.state.startAngle, this.state.anglePer, startValue);
      var endAngle = (0, _Graphics.translateEndAngle)(startAngle, this.state.anglePer, item.value);
      var radius = Math.min(viewBoxRadius, this.state.startRadius + trackIndex * RING_THICKNESS);
      return (0, _Graphics.arcCommands)(viewBoxRadius, viewBoxRadius, radius, startAngle + this.state.angleOffset, endAngle + this.state.angleOffset);
    }
  }, {
    key: '_renderThresholds',
    value: function _renderThresholds() {
      return undefined;
    }
  }, {
    key: '_renderTopLayer',
    value: function _renderTopLayer() {
      var _this2 = this;

      var _props = this.props,
          activeIndex = _props.activeIndex,
          onActivate = _props.onActivate;
      var viewBoxRadius = this.state.viewBoxRadius;

      var x = viewBoxRadius + RING_THICKNESS * 0.5;
      var y = viewBoxRadius + RING_THICKNESS * 1.75;
      var labels = this.props.series.map(function (item, index) {
        var classes = (0, _classnames3.default)(CLASS_ROOT + '__label', _defineProperty({}, CLASS_ROOT + '__label--active', index === activeIndex));

        var textX = x;
        var textY = y;

        y += RING_THICKNESS;

        var hoverEvents = void 0;
        if (onActivate) {
          hoverEvents = {
            onMouseOver: _this2.props.onActivate.bind(null, index),
            onMouseOut: _this2.props.onActivate.bind(null, null)
          };
        }

        return _react2.default.createElement(
          'text',
          _extends({ key: item.label || index, x: textX, y: textY,
            textAnchor: 'start', fontSize: 16,
            className: classes,
            onClick: item.onClick }, hoverEvents),
          item.label
        );
      });

      return _react2.default.createElement(
        'g',
        { className: CLASS_ROOT + "__labels" },
        labels
      );
    }
  }]);

  return Spiral;
}(_Graphic3.default);

exports.default = Spiral;


Spiral.defaultProps = {
  thresholds: []
};

//needed in Graphic.js to fix minification issues
Spiral.displayName = 'Spiral';
module.exports = exports['default'];

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(107);

var _Graphic2 = __webpack_require__(143);

var _Graphic3 = _interopRequireDefault(_Graphic2);

var _Graphics = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CIRCLE_WIDTH = _utils.baseDimension;
var CIRCLE_RADIUS = _utils.baseDimension / 2 - _Graphics.baseUnit / 2;
var RING_THICKNESS = _Graphics.baseUnit;

var Circle = function (_Graphic) {
  _inherits(Circle, _Graphic);

  function Circle(props, context) {
    _classCallCheck(this, Circle);

    //needed in Graphic.js to fix minification issues
    var _this = _possibleConstructorReturn(this, (Circle.__proto__ || Object.getPrototypeOf(Circle)).call(this, props, context));

    _this.displayName = 'Circle';
    return _this;
  }

  _createClass(Circle, [{
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      if (!props.stacked && (props.series.length - 1) * RING_THICKNESS > CIRCLE_RADIUS) {
        console.warn("You cannot have more than " + Math.round(CIRCLE_RADIUS / RING_THICKNESS) + " data values in a circle Meter");
      }

      var state = {
        startAngle: 0,
        anglePer: !props.max ? 0 : 360 / (props.max - props.min),
        angleOffset: 180,
        viewBoxWidth: CIRCLE_WIDTH,
        viewBoxHeight: CIRCLE_WIDTH
      };

      return state;
    }
  }, {
    key: '_sliceCommands',
    value: function _sliceCommands(trackIndex, item, startValue, max) {
      var startAngle = (0, _Graphics.translateEndAngle)(this.state.startAngle, this.state.anglePer, startValue);

      var endAngle;
      if (!item.value) {
        endAngle = startAngle;
      } else if (startValue + item.value >= max) {
        endAngle = 360;
      } else {
        endAngle = Math.min(360, Math.max(startAngle, (0, _Graphics.translateEndAngle)(startAngle, this.state.anglePer, item.value)));
      }

      var radius = Math.max(1, CIRCLE_RADIUS - trackIndex * RING_THICKNESS);
      return (0, _Graphics.arcCommands)(CIRCLE_WIDTH / 2, CIRCLE_WIDTH / 2, radius, startAngle + this.state.angleOffset, endAngle + this.state.angleOffset);
    }
  }]);

  return Circle;
}(_Graphic3.default);

//needed in Graphic.js to fix minification issues


exports.default = Circle;
Circle.displayName = 'Circle';
module.exports = exports['default'];

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Graphics = __webpack_require__(86);

var _CSSClassnames = __webpack_require__(2);

var _CSSClassnames2 = _interopRequireDefault(_CSSClassnames);

var _utils = __webpack_require__(107);

var _Graphic2 = __webpack_require__(143);

var _Graphic3 = _interopRequireDefault(_Graphic2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

var CLASS_ROOT = _CSSClassnames2.default.METER;
var COLOR_INDEX = _CSSClassnames2.default.COLOR_INDEX;

var ARC_WIDTH = _utils.baseDimension;
var ARC_HEIGHT = Math.round(_utils.baseDimension * 0.75);
var ARC_RADIUS = _utils.baseDimension / 2 - _Graphics.baseUnit / 2;
var INDICATOR_HUB_RADIUS = _Graphics.baseUnit / 4;
var RING_THICKNESS = _Graphics.baseUnit;

function singleIndicatorCommands(centerX, centerY, radius, startAngle, endAngle, length) {
  var point = (0, _Graphics.polarToCartesian)(centerX, centerY, radius - (length - INDICATOR_HUB_RADIUS), endAngle - 1);
  var start = (0, _Graphics.polarToCartesian)(centerX, centerY, radius, endAngle - 1);
  var d = ["M", centerX, centerY - INDICATOR_HUB_RADIUS, "A", INDICATOR_HUB_RADIUS, INDICATOR_HUB_RADIUS, 0, 1, 1, centerX, centerY + INDICATOR_HUB_RADIUS, "A", INDICATOR_HUB_RADIUS, INDICATOR_HUB_RADIUS, 0, 1, 1, centerX, centerY - INDICATOR_HUB_RADIUS, "M", point.x, point.y, "L", start.x, start.y].join(" ");
  return d;
}

var Arc = function (_Graphic) {
  _inherits(Arc, _Graphic);

  function Arc(props, context) {
    _classCallCheck(this, Arc);

    //needed in Graphic.js to fix minification issues
    var _this = _possibleConstructorReturn(this, (Arc.__proto__ || Object.getPrototypeOf(Arc)).call(this, props, context));

    _this.displayName = 'Arc';
    return _this;
  }

  _createClass(Arc, [{
    key: '_viewBoxDimensions',
    value: function _viewBoxDimensions(props) {
      var viewBoxWidth;
      var viewBoxHeight;
      if (props.vertical) {
        viewBoxWidth = ARC_HEIGHT;
        viewBoxHeight = ARC_WIDTH;
      } else {
        viewBoxWidth = ARC_WIDTH;
        viewBoxHeight = ARC_HEIGHT;
      }
      return [viewBoxWidth, viewBoxHeight];
    }
  }, {
    key: '_stateFromProps',
    value: function _stateFromProps(props) {
      var viewBoxDimensions = this._viewBoxDimensions(props);

      var state = {
        startAngle: 60,
        anglePer: !props.max ? 0 : 240.0 / (props.max - props.min),
        angleOffset: 180,
        viewBoxWidth: viewBoxDimensions[0],
        viewBoxHeight: viewBoxDimensions[1]
      };
      if (props.vertical) {
        state.angleOffset = 90;
      } else {
        state.angleOffset = 180;
      }

      return state;
    }
  }, {
    key: '_sliceCommands',
    value: function _sliceCommands(trackIndex, item, startValue) {
      var startAngle = (0, _Graphics.translateEndAngle)(this.state.startAngle, this.state.anglePer, startValue);
      var endAngle = Math.max(startAngle + (item.value > 0 ? RING_THICKNESS / 2 : 0), (0, _Graphics.translateEndAngle)(startAngle, this.state.anglePer, item.value));
      var radius = Math.max(1, ARC_RADIUS - trackIndex * RING_THICKNESS);
      return (0, _Graphics.arcCommands)(ARC_WIDTH / 2, ARC_WIDTH / 2, radius, startAngle + this.state.angleOffset, endAngle + this.state.angleOffset);
    }
  }, {
    key: '_renderTopLayer',
    value: function _renderTopLayer() {
      var indicator;
      if (this.props.series.length === 1) {
        var item = this.props.series[0];
        var startAngle = this.state.startAngle;
        var endAngle = (0, _Graphics.translateEndAngle)(startAngle, this.state.anglePer, item.value);
        var length = ARC_RADIUS;
        var x = ARC_WIDTH / 2;
        var y = ARC_WIDTH / 2;
        var indicatorCommands = singleIndicatorCommands(x, y, ARC_RADIUS, startAngle + this.state.angleOffset, endAngle + this.state.angleOffset, length);
        indicator = _react2.default.createElement('path', { fill: 'none',
          className: CLASS_ROOT + '__slice-indicator ' + (COLOR_INDEX + '-' + item.colorIndex),
          d: indicatorCommands });
      }

      return indicator;
    }
  }]);

  return Arc;
}(_Graphic3.default);

exports.default = Arc;
module.exports = exports['default'];

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LoadFiles__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_Alert__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Revert__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Revert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_icons_base_Revert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_Animate__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__AppConfig__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__State_constants_CommonConstants__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__State_actions_sessions__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SizerUI_SizerConfig_Config_js__ = __webpack_require__(63);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var compareSolution1Options=["Growth - 1Y","Growth - 2Y","Growth - 3Y"];var compareSolution2Options=[];var compareSolution1value=compareSolution1Options[0];var compareSolution2value="Growth - 2Y";var Com='';var data=[];var compare='';var SavedSolutionname='';var CombineRackSecond=[];var SolutionAlternativeTabsContent=void 0;var RolesList=[];var getSSETData=false;var EPAId='EPAvNext';var BLUE_DATA="BlueData";var GROWTH_4Y="Growth - 4Y";var totalNumOfRows=[];var CombineRack=[];var CombineRackSecond=[];var ComputeNodeArray=[];var ComputeNodeSecondSolArray=[];var totalNumOfRows=[];//let RolesList = [];
var CompareSol=function(_Component){_inherits(CompareSol,_Component);function CompareSol(){_classCallCheck(this,CompareSol);var _this=_possibleConstructorReturn(this,(CompareSol.__proto__||Object.getPrototypeOf(CompareSol)).call(this));_this.compareSolution12Change=function(e){if(e.target.name==="compareSolution1"){compareSolution1value=e.option;}else if(e.target.name==="compareSolution2"){compareSolution2value=e.option;if(e.option==="Browse"){_this.compareSolnMethod(e,true);}}_this.setState({dropDownState:true});};_this.compareSolnMethod=function(e,isfromBrowse){_this.setState({ComapareSolState:true});if(_this.props.activeSession.EPAArray.length>0&&!isfromBrowse){var value=void 0;if(_this.props.activeSession.SavedSolname&&_this.props.activeSession.SavedSolname.SavedSol===compareSolution2value){value={"SessionID":_this.props.activeSession.id,"SessionIDsaved":_this.props.activeSession.SavedSolname.savedId,"EPASolutionType":compareSolution1value.split('-')[1].trim()[0]};}else{var solutionType=compareSolution1value.split('-')[1].trim()[0];solutionType+=':';solutionType+=compareSolution2value.split('-')[1].trim()[0];value={"SessionID":_this.props.activeSession.id,"EPASolutionType":solutionType//this.SaveSolname(compareSolution2value);
};}_this.props.OnComparedata(value);}else{_this.state.flag=true;compareSolution2value='Growth - 1Y';Com=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default.a,{margin:"none",pad:"small",style:{width:'100% !important',zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LoadFiles__["a" /* default */],{title:"Solution",onClose:_this.handleClose,flag:_this.state.flag,Savedname:_this.SaveSolname.bind(_this),solutionIndex:isfromBrowse?compareSolution1value.split('-')[1].trim()[0]:null}));}_this.props.activeSession.selectedTitles={compareSolution1value:compareSolution1value,compareSolution2value:compareSolution2value};_this.setState({header1:compareSolution1value,dropDownState:false});};_this.handleClose=function(){Com='';_this.setState({flag:false});};_this.SaveSolname=function(value,id){SavedSolutionname=value;var compareSolutionObj={SavedSolutionName:value,selectedselection:id};_this.props.SavedSolname(compareSolutionObj);compareSolution2value=value;_this.props.activeSession.selectedTitles.compareSolution2value=value;};_this.populateStorageVolumes=function(tableData){var StorageVolume=[];var strVolume="";tableData.map(function(Volume){StorageVolume.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});StorageVolume.map(function(disk,id){if(id===StorageVolume.length-1){strVolume+=disk;}else{strVolume+=disk+"   ";}});return strVolume;};_this.state={showSaveSolution:false,showDupSoLPopup:false,SessionName:'',CurrentSession:{},SolutionObj:'',RoleObj:'',RoleItems:'',SharedRoleObj:'',SharedRoleItems:'',activeTab:0,ServQty:0,HomePageJson:[],AdditionalInfoPop:false,GRPresent:false,GRPresentStatic:false,MetricsDataPresent:false,ActiveSoln:null,ActiveSolTabClass:'',RackItem:'',showDelSession:true,activeSoltab:0,ComapareSolState:false,compareSolutionTabactive:false,CloseErrorLayer:false,flag:false,header1:'',dropDownState:false};_this.compareSolnMethod=_this.compareSolnMethod.bind(_this);return _this;}_createClass(CompareSol,[{key:"componentDidMount",value:function componentDidMount(){//   this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
if(!this.props.activeSession||this.props.activeSession.SavedSolname==''){if(this.props.externalAppProps&&this.props.isFromExternalApp){getSSETData=true;var queryParameter=__WEBPACK_IMPORTED_MODULE_9_query_string___default.a.parse(window.location.search);var sessionObject={"SessionID":queryParameter.sizerReference};var userData={"reference":queryParameter.reference,"isSizerAsEntry":queryParameter.isSizerAsEntry?true:false,"isCompare":true};if(getSSETData){getSSETData=false;this.props.getSSETData(userData);}//this.props.onFetchCompareSolution(sessionObject);
}}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.activeSession&&nextProps.activeSession.workload){var obj="";var queryParameter=__WEBPACK_IMPORTED_MODULE_9_query_string___default.a.parse(window.location.search);nextProps.activeSession.id=queryParameter.sizerReference;if(__WEBPACK_IMPORTED_MODULE_17__AppConfig__["f" /* said */]==='CS750VirtSizer'||__WEBPACK_IMPORTED_MODULE_17__AppConfig__["f" /* said */]==='SynergySizer'){obj={"Workload":nextProps.activeSession.workload};}else{obj=nextProps.activeSession.workload;}//if(nextProps.activeSession.workload.UserInputs.SizerMode!== commonConstants.GPELEMENT)
//this.props.onNewSession(obj);
}}},{key:"onExport",value:function onExport(){var text={Data:{input:{"content":data,"currencyone":'$ '+this.props.comparedata.CompareData.Solution[1].SolPrice,"currencytwo":'$ '+this.props.comparedata.CompareData.Solution[0].SolPrice,//"Solution1": this.props.activeSession.alias,
"Solution1":this.props.activeSession.selectedTitles.compareSolution1value,"Solution2":this.props.activeSession.selectedTitles.compareSolution2value,"Rack1":this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"],"Rack2":this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"]}}//let jsontext=JSON.stringify(text)
//dumm.push(text)
};this.props.onExportCompaeSolution(text);}},{key:"redirectUrl",value:function redirectUrl(){console.log('redirecting to SSET');window.location.replace(this.props.externalAppProps.ssetUrl);}},{key:"render",value:function render(){var _this2=this;compare='';var Currencyone='';var Currencytwo='';//compareSolution1Options = ["Growth - 1Y", "Growth - 2Y", "Growth - 3Y"];
//compareSolution2Options = compareSolution1Options;
if(!this.props.sessions.isLoading&&this.props.activeSession!==''&&this.props.activeSession.EPAArray!==undefined){if(this.props.activeSession.EPAArray.length>0&&!this.state.dropDownState){if(this.props.activeSession.selectedTitles){compareSolution1value=this.props.activeSession.selectedTitles.compareSolution1value;compareSolution2value=this.props.activeSession.selectedTitles.compareSolution2value;}}if(this.props.activeSession.SavedSolname&&this.props.activeSession.SavedSolname.savedId){compareSolution2Options=compareSolution2Options.concat(this.props.activeSession.SavedSolname.SavedSol);}if(__WEBPACK_IMPORTED_MODULE_17__AppConfig__["f" /* said */]===EPAId&&this.props.activeSession.workload.UserInputs!==undefined&&this.props.activeSession.workload.UserInputs.Environments.WorkloadType===BLUE_DATA){if(compareSolution1Options.indexOf(GROWTH_4Y)===-1){compareSolution1Options.push(GROWTH_4Y);}}compareSolution2Options=compareSolution1Options.concat([]);compareSolution2Options.splice(compareSolution2Options.indexOf(compareSolution1value),1);compareSolution2value=compareSolution2Options.indexOf(compareSolution2value)!==-1?compareSolution2value:compareSolution2Options[0];}if(this.props.activeSession&&this.props.activeSession.EPAArray&&this.props.activeSession.EPAArray.length>0){if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&(this.props.comparedata.CompareData==='File Mismatch'||this.props.comparedata.CompareData==='Different Pricing Region')){if(this.props.comparedata.CompareData['@Currency']==='UD'){Currencyone='$ '+this.props.comparedata.CompareData.Solution[1].SolPrice;Currencytwo='$ '+this.props.comparedata.CompareData.Solution[0].SolPrice;}else{Currencyone=this.props.comparedata.CompareData['@Currency']+" "+this.props.comparedata.CompareData.Solution[1].SolPrice;Currencytwo=this.props.comparedata.CompareData['@Currency']+" "+this.props.comparedata.CompareData.Solution[0].SolPrice;}}var _StyleTable="CompareTable";var _backgrdclrtotal='#fff';if(Currencyone!==Currencytwo&&Currencyone!=='NA'&&Currencytwo!=='NA'){_backgrdclrtotal='#ffd144';}else{_backgrdclrtotal='#fff';}if(__WEBPACK_IMPORTED_MODULE_20__SizerUI_SizerConfig_Config_js__["d" /* _said */]==='EPAvNext'){if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&(this.props.comparedata.CompareData==='File Mismatch'||this.props.comparedata.CompareData==='Different Pricing Region')){this.state.CloseErrorLayer=false;}if(this.props.comparedata!==undefined&&this.props.comparedata!==null&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData!=='File Mismatch'&&this.props.comparedata.CompareData!=='Different Pricing Region'){var FirstSolRoles=[];var ExtraSeconSolroles=[];ComputeNodeArray=[];ComputeNodeSecondSolArray=[];CombineRack=[];CombineRackSecond=[];ComputeNodeArray=[];ComputeNodeSecondSolArray=[];totalNumOfRows=[];RolesList=[];data=[];//dumm = []
var Type=this.props.workload.UserInputs.Environments.WorkloadType;console.log(this.props.comparedata);var backgrdclrrack='none';if(this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"]!==this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"]){backgrdclrrack='#ffd144';}else{backgrdclrrack='#fff';}CombineRack=this.props.comparedata.CompareData.Solution.map(function(val){if(val.RackSelected!==undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{backgroundColor:backgrdclrrack}},val.RackSelected["@CompDesc"]);}});CombineRackSecond=CombineRack.reverse();if(Array.isArray(this.props.comparedata.CompareData.Solution[0].Roles.Role)){this.props.comparedata.CompareData.Solution[0].Roles.Role.map(function(val){var strVolume=void 0;if(val["RoleName"]==="Compute hosts"||val["RoleName"]==="Compute Node"){val["RoleName"]="Compute Hosts";}else if(val["RoleName"].toLowerCase()==="compute hosts with gpus"||val["RoleName"]==="GPU Node"){val["RoleName"]="Compute Hosts With GPUs";}else if(val["RoleName"]==="Gateway Node"){val["RoleName"]="Gateway Host";}else if(val["RoleName"]==="Controller Node"){val["RoleName"]="Controller Host";}else if(val["RoleName"]==="Storage : HDFS and HDFS-EC"){val["RoleName"]="Storage : HDFS";}FirstSolRoles.push(val["RoleName"]);if(Array.isArray(val.DAS.TableData)){strVolume=this.populateStorageVolumes(val.DAS.TableData);}else{strVolume=val.DAS.TableData["VolumeName"]+" - "+val.DAS.TableData["DiskQty"]+" X "+val.DAS.TableData["Disk"];}val["Memory"]=val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeArray.push({"Role Name":val["RoleName"]},{"Server Name":val.ServerName["@Qty"]+" X "+val.ServerName["#text"]},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});}else{var SerName=val.ServerName["@Qty"]+" X "+val.ServerName["#text"];val.Processor=val.Processor.replace("1P"," ");if(val.ServerName["#text"]==="HP Moonshot System"){SerName=val.Processor;}ComputeNodeArray.push({"Role Name":val["RoleName"]},{"Server Name":SerName},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});if(val.CPUPerf!==undefined&&val.StorageTP!==undefined&&val.StorageReadIO!==undefined&&val.StorageWriteIO!==undefined&&val.CPUPerfPrice!==undefined&&val.RawStoragePrice!==undefined&&val.StoragePerfPrice!==undefined&&val.CPUPerfWatt!==undefined&&val.StoragePerfWatt!==undefined){ComputeNodeArray.push({"CPU Performance (SPECint)":val.CPUPerf["#text"]},{"Storage Throughput (MB/s)":val.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":val.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":val.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":val.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":val.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":val.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":val.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":val.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}.bind(this));}else{var roleobj=this.props.comparedata.CompareData.Solution[0].Roles.Role;var StorageVolume=[];var strVolume=void 0;if(roleobj["RoleName"]==="Compute hosts"||roleobj["RoleName"]==="Compute Node"){roleobj["RoleName"]="Compute Hosts";}else if(roleobj["RoleName"].toLowerCase()==="compute hosts with gpus"||roleobj["RoleName"]==="GPU Node"){roleobj["RoleName"]="Compute Hosts With GPUs";}else if(roleobj["RoleName"]==="Gateway Node"){roleobj["RoleName"]="Gateway Host";}else if(roleobj["RoleName"]==="Controller Node"){roleobj["RoleName"]="Controller Host";}else if(roleobj["RoleName"]==="Storage : HDFS and HDFS-ECC"){roleobj["RoleName"]="Storage : HDFS";}FirstSolRoles.push(roleobj["RoleName"]);if(Array.isArray(roleobj.DAS.TableData)){roleobj.DAS.TableData.map(function(Volume){StorageVolume.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});if(StorageVolume[2]!==undefined){strVolume=StorageVolume[0]+"    "+StorageVolume[1]+"    "+StorageVolume[2];}else{strVolume=StorageVolume[0]+"    "+StorageVolume[1];}}else{strVolume=roleobj.DAS.TableData["VolumeName"]+" - "+roleobj.DAS.TableData["DiskQty"]+" X "+roleobj.DAS.TableData["Disk"];}roleobj["Memory"]=roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"]},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});}else{var SerName=roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"];roleobj.Processor=roleobj.Processor.replace("1P"," ");if(roleobj.ServerName["#text"]==="HP Moonshot System"){SerName=roleobj.Processor;}ComputeNodeArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":SerName},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":strVolume});if(roleobj.CPUPerf!==undefined&&roleobj.StorageTP!==undefined&&roleobj.StorageReadIO!==undefined&&roleobj.StorageWriteIO!==undefined&&roleobj.CPUPerfPrice!==undefined&&roleobj.RawStoragePrice!==undefined&&roleobj.StoragePerfPrice!==undefined&&roleobj.CPUPerfWatt!==undefined&&roleobj.StoragePerfWatt!==undefined){ComputeNodeArray.push({"CPU Performance (SPECint)":roleobj.CPUPerf["#text"]},{"Storage Throughput (MB/s)":roleobj.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":roleobj.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":roleobj.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":roleobj.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":roleobj.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":roleobj.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":roleobj.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":roleobj.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}var RolnotPrst=false;FirstSolRoles.filter(function(rol){RolnotPrst=false;if(Array.isArray(_this2.props.comparedata.CompareData.Solution[1].Roles.Role)){_this2.props.comparedata.CompareData.Solution[1].Roles.Role.map(function(val){if(val["RoleName"]==="Compute hosts"||val["RoleName"]==="Compute Node"){val["RoleName"]="Compute Hosts";}else if(val["RoleName"].toLowerCase()==="compute hosts with gpus"||val["RoleName"]==="GPU Node"){val["RoleName"]="Compute Hosts With GPUs";}else if(val["RoleName"]==="Gateway Node"){val["RoleName"]="Gateway Host";}else if(val["RoleName"]==="Controller Node"){val["RoleName"]="Controller Host";}else if(val["RoleName"]==="Storage : HDFS and HDFS-ECC"){val["RoleName"]="Storage : HDFS";}if(rol.toLowerCase()===val["RoleName"].toLowerCase()){RolnotPrst=true;var _strVolume=void 0;if(Array.isArray(val.DAS.TableData)){_strVolume=this.populateStorageVolumes(val.DAS.TableData);}else{_strVolume=val.DAS.TableData["VolumeName"]+" - "+val.DAS.TableData["DiskQty"]+" X "+val.DAS.TableData["Disk"];}val["Memory"]=val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":val.ServerName["@Qty"]+" X "+val.ServerName["#text"]},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume});}else{var _SerName=val.ServerName["@Qty"]+" X "+val.ServerName["#text"];val.Processor=val.Processor.replace("1P"," ");if(val.ServerName["#text"]==="HP Moonshot System"){_SerName=val.Processor;}ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":_SerName},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume});if(val.CPUPerf!==undefined&&val.StorageTP!==undefined&&val.StorageReadIO!==undefined&&val.StorageWriteIO!==undefined&&val.CPUPerfPrice!==undefined&&val.RawStoragePrice!==undefined&&val.StoragePerfPrice!==undefined&&val.CPUPerfWatt!==undefined&&val.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":val.CPUPerf["#text"]},{"Storage Throughput (MB/s)":val.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":val.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":val.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":val.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":val.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":val.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":val.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":val.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}.bind(_this2));}else{var roleobject=_this2.props.comparedata.CompareData.Solution[1].Roles.Role;if(roleobject["RoleName"]==="Compute hosts"||roleobject["RoleName"]==="Compute Node"){roleobject["RoleName"]="Compute Hosts";}else if(roleobject["RoleName"].toLowerCase()==="compute hosts with gpus"||roleobject["RoleName"]==="GPU Node"){roleobject["RoleName"]="Compute Hosts With GPUs";}else if(roleobject["RoleName"]==="Gateway Node"){roleobject["RoleName"]="Gateway Host";}else if(roleobject["RoleName"]==="Controller Node"){roleobject["RoleName"]="Controller Host";}if(rol.toLowerCase()===roleobject["RoleName"].toLowerCase()){RolnotPrst=true;var _StorageVolume=[];var _strVolume2=void 0;if(Array.isArray(roleobject.DAS.TableData)){roleobject.DAS.TableData.map(function(Volume){_StorageVolume.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});if(_StorageVolume[2]!==undefined){_strVolume2=_StorageVolume[0]+"    "+_StorageVolume[1]+"    "+_StorageVolume[2];}else{_strVolume2=_StorageVolume[0]+"    "+_StorageVolume[1];}}else{_strVolume2=roleobject.DAS.TableData["VolumeName"]+" - "+roleobject.DAS.TableData["DiskQty"]+" X "+roleobject.DAS.TableData["Disk"];}roleobject["Memory"]=roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":roleobject["RoleName"]},{"Server Name":roleobject.ServerName["@Qty"]+" X "+roleobject.ServerName["#text"]},{"Processor":roleobject["ProcessorDetails"]},{"Memory":roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume2});}else{var _SerName2=roleobject.ServerName["@Qty"]+" X "+roleobject.ServerName["#text"];roleobj.Processor=roleobj.Processor.replace("1P"," ");if(roleobject.ServerName["#text"]==="HP Moonshot System"){_SerName2=roleobject.Processor;}ComputeNodeSecondSolArray.push({"Role Name":roleobject["RoleName"]},{"Server Name":_SerName2},{"Processor":roleobject["ProcessorDetails"]},{"Memory":roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":_strVolume2});if(roleobject.CPUPerf!==undefined&&roleobject.StorageTP!==undefined&&roleobject.StorageReadIO!==undefined&&roleobject.StorageWriteIO!==undefined&&roleobject.CPUPerfPrice!==undefined&&roleobject.RawStoragePrice!==undefined&&roleobject.StoragePerfPrice!==undefined&&roleobject.CPUPerfWatt!==undefined&&roleobject.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":roleobject.CPUPerf["#text"]},{"Storage Throughput (MB/s)":roleobject.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":roleobject.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":roleobject.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":roleobject.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":roleobject.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":roleobject.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":roleobject.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":roleobject.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}if(!RolnotPrst){if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":"NA"},{"Server Name":"NA"},{"Processor":"NA"},{"Memory":"NA"},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":"NA"});}else{ComputeNodeSecondSolArray.push({"Role Name":"NA"},{"Server Name":"NA"},{"Processor":"NA"},{"Memory":"NA"},// {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
{"Storage":"NA"},{"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}});FirstSolRoles.filter(function(rol){if(Array.isArray(_this2.props.comparedata.CompareData.Solution[1].Roles.Role)){_this2.props.comparedata.CompareData.Solution[1].Roles.Role.map(function(val){if(val["RoleName"]==="Compute hosts"||val["RoleName"]==="Compute Node"){val["RoleName"]="Compute Hosts";}else if(val["RoleName"].toLowerCase()==="compute hosts with gpus"||val["RoleName"]==="GPU Node"){val["RoleName"]="Compute Hosts With GPUs";}else if(val["RoleName"]==="Gateway Node"){val["RoleName"]="Gateway Host";}else if(val["RoleName"]==="Controller Node"){val["RoleName"]="Controller Host";}else if(val["RoleName"]==="Storage : HDFS and HDFS-ECC"){val["RoleName"]="Storage : HDFS";}if(FirstSolRoles.indexOf(val["RoleName"])===-1){if(ExtraSeconSolroles.indexOf(val["RoleName"])===-1){ExtraSeconSolroles.push(val["RoleName"]);}}});}else{var roleobject=_this2.props.comparedata.CompareData.Solution[1].Roles.Role;if(roleobject["RoleName"]==="Compute hosts"||roleobject["RoleName"]==="Compute Node"){roleobject["RoleName"]="Compute Hosts";}else if(roleobject["RoleName"].toLowerCase()==="compute hosts with gpus"||roleobject["RoleName"]==="GPU Node"){roleobject["RoleName"]="Compute Hosts With GPUs";}else if(roleobject["RoleName"]==="Gateway Node"){roleobject["RoleName"]="Gateway Host";}else if(roleobject["RoleName"]==="Controller Node"){roleobject["RoleName"]="Controller Host";}if(FirstSolRoles.indexOf(roleobject["RoleName"])===-1){if(ExtraSeconSolroles.indexOf(roleobject["RoleName"])===-1){ExtraSeconSolroles.push(roleobject["RoleName"]);}}}});ExtraSeconSolroles.filter(function(extrarol){if(Array.isArray(_this2.props.comparedata.CompareData.Solution[1].Roles.Role)){_this2.props.comparedata.CompareData.Solution[1].Roles.Role.map(function(val){if(extrarol.toLowerCase()===val["RoleName"].toLowerCase()){var _strVolume3=void 0;if(Array.isArray(val.DAS.TableData)){_strVolume3=this.populateStorageVolumes(val.DAS.TableData);}else{_strVolume3=val.DAS["VolumeName"]+" - "+val.DAS["DiskQty"]+" X "+val.DAS["Disk"];}val["Memory"]=val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":val.ServerName["@Qty"]+" X "+val.ServerName["#text"]},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume3});}else{var _SerName3=val.ServerName["@Qty"]+" X "+val.ServerName["#text"];val.Processor=val.Processor.replace("1P"," ");if(val.ServerName["#text"]==="HP Moonshot System"){_SerName3=val.Processor;}ComputeNodeSecondSolArray.push({"Role Name":val["RoleName"]},{"Server Name":_SerName3},{"Processor":val["ProcessorDetails"]},{"Memory":val["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume3});if(val.CPUPerf!==undefined&&val.StorageTP!==undefined&&val.StorageReadIO!==undefined&&val.StorageWriteIO!==undefined&&val.CPUPerfPrice!==undefined&&val.RawStoragePrice!==undefined&&val.StoragePerfPrice!==undefined&&val.CPUPerfWatt!==undefined&&val.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":val.CPUPerf["#text"]},{"Storage Throughput (MB/s)":val.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":val.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":val.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":val.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":val.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":val.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":val.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":val.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}.bind(_this2));}else{var roleobj=_this2.props.comparedata.CompareData.Solution[1].Roles.Role;if(extrarol.toLowerCase()===roleobj["RoleName"].toLowerCase()){var _StorageVolume2=[];var _strVolume4=void 0;if(Array.isArray(roleobj.DAS.TableData)){roleobj.DAS.TableData.map(function(Volume){_StorageVolume2.push(Volume["VolumeName"]+" - "+Volume["DiskQty"]+" X "+Volume["Disk"]);});if(_StorageVolume2[2]!==undefined){_strVolume4=_StorageVolume2[0]+"    "+_StorageVolume2[1]+"    "+_StorageVolume2[2];}else{_strVolume4=_StorageVolume2[0]+"    "+_StorageVolume2[1];}}else{_strVolume4=roleobj.DAS["VolumeName"]+" - "+roleobj.DAS["DiskQty"]+" X "+roleobj.DAS["Disk"];}roleobj["Memory"]=roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'');if(Type==="BlueData"){ComputeNodeSecondSolArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"]},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume4});}else{var _SerName4=roleobj.ServerName["@Qty"]+" X "+roleobj.ServerName["#text"];roleobj.Processor=roleobj.Processor.replace("1P"," ");if(roleobj.ServerName["#text"]==="HP Moonshot System"){_SerName4=roleobj.Processor;}ComputeNodeSecondSolArray.push({"Role Name":roleobj["RoleName"]},{"Server Name":_SerName4},{"Processor":roleobj["ProcessorDetails"]},{"Memory":roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig,'')},{"Storage":_strVolume4});if(roleobj.CPUPerf!==undefined&&roleobj.StorageTP!==undefined&&roleobj.StorageReadIO!==undefined&&roleobj.StorageWriteIO!==undefined&&roleobj.CPUPerfPrice!==undefined&&roleobj.RawStoragePrice!==undefined&&roleobj.StoragePerfPrice!==undefined&&roleobj.CPUPerfWatt!==undefined&&roleobj.StoragePerfWatt!==undefined){ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":roleobj.CPUPerf["#text"]},{"Storage Throughput (MB/s)":roleobj.StorageTP["#text"]},{"Storage Read IOPs (IOPs)":roleobj.StorageReadIO["#text"]},{"Storage Write IOPs (IOPs)":roleobj.StorageWriteIO["#text"]},{"CPU Perf/Price (SPECint/$1k)":roleobj.CPUPerfPrice["#text"]},{"Raw Storage capacity/Price (TB/$1k)":roleobj.RawStoragePrice["#text"]},{"Storage Perf/Price (MB/s per $1k)":roleobj.StoragePerfPrice["#text"]},{"CPU Perf/Watt (SPECint/KW)":roleobj.CPUPerfWatt["#text"]},{"Storage Perf/Watt (MB/s per KW)":roleobj.StoragePerfWatt["#text"]});}else{ComputeNodeSecondSolArray.push({"CPU Performance (SPECint)":"NA"},{"Storage Throughput (MB/s)":"NA"},{"Storage Read IOPs (IOPs)":"NA"},{"Storage Write IOPs (IOPs)":"NA"},{"CPU Perf/Price (SPECint/$1k)":"NA"},{"Raw Storage capacity/Price (TB/$1k)":"NA"},{"Storage Perf/Price (MB/s per $1k)":"NA"},{"CPU Perf/Watt (SPECint/KW)":"NA"},{"Storage Perf/Watt (MB/s per KW)":"NA"});}}}}});var x=ComputeNodeArray.length;var y=ComputeNodeSecondSolArray.length;if(x>y){totalNumOfRows.length=x;}else{totalNumOfRows.length=y;}var RoleItems=[];if(Type==="BlueData"){RoleItems=["Role Name","Server Name","Processor","Memory","Storage"];}else{RoleItems=["Role Name","Server Name","Processor","Memory","Storage","CPU Performance (SPECint)","Storage Throughput (MB/s)","Storage Read IOPs (IOPs)","Storage Write IOPs (IOPs)","CPU Perf/Price (SPECint/$1k)","Raw Storage capacity/Price (TB/$1k)","Storage Perf/Price (MB/s per $1k)","CPU Perf/Watt (SPECint/KW)","Storage Perf/Watt (MB/s per KW)"];}var countRole=0;for(var i=0;i<totalNumOfRows.length;i++){var ComputeValue;var ComputeValueSecond;if(i>=ComputeNodeSecondSolArray.length){ComputeValueSecond="NA";}else{ComputeValueSecond=ComputeNodeSecondSolArray[i][RoleItems[countRole]];}if(i>=ComputeNodeArray.length){ComputeValue="NA";}else{ComputeValue=ComputeNodeArray[i][RoleItems[countRole]];}var textspace='';var textspacetwo='';if(ComputeValueSecond==="NA"){textspace='center';}if(ComputeValue==="NA"){textspacetwo='center';}var backgrdclr='#fff';if(ComputeValueSecond!==ComputeValue&&ComputeValueSecond!=='NA'&&ComputeValue!=='NA'){backgrdclr='#ffd144';}else{backgrdclr='#fff';}RolesList.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,RoleItems[countRole]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:textspace,backgroundColor:backgrdclr}},ComputeValueSecond),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:textspacetwo,backgroundColor:backgrdclr}},ComputeValue)));data.push({"role":RoleItems[countRole],"computevaluesecond":ComputeValueSecond,"computevalue":ComputeValue});countRole++;if(Type==="BlueData"){if(countRole==5){countRole=0;}}else{if(countRole==14){countRole=0;}}}var Currencyone='';var Currencytwo='';if(this.props.comparedata.CompareData['@Currency']==='UD'){Currencyone='$ '+this.props.comparedata.CompareData.Solution[1].SolPrice;Currencytwo='$ '+this.props.comparedata.CompareData.Solution[0].SolPrice;}else{Currencyone=this.props.comparedata.CompareData['@Currency']+" "+this.props.comparedata.CompareData.Solution[1].SolPrice;Currencytwo=this.props.comparedata.CompareData['@Currency']+" "+this.props.comparedata.CompareData.Solution[0].SolPrice;}}else if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&!this.props.isLoading&&!this.state.CloseErrorLayer&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData==='File Mismatch'){this.state.CloseErrorLayer=false;compare=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:"none",pad:"none",size:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",colorIndex:"neutral-1",margin:"none",pad:"small",separator:"bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",margin:"none",pad:{between:'small'},align:"start",style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_Alert___default.a,{colorIndex:"critical",size:"small"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:"h4",strong:false,style:{marginBottom:'0px'}},"Error")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",margin:"none",pad:"none",align:"start",alignContent:"start",onClick:this.handleCloseError.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:"small",colorIndex:"light-2",className:"CloseIconStyle"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",margin:"small",pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default.a,{margin:"small"},'Current solution is configured with different platform. Kindly select the solution with same platform to compare'))));}else if(this.props.comparedata!==null&&this.props.comparedata!==undefined&&!this.props.isLoading&&!this.state.CloseErrorLayer&&this.props.comparedata.CompareData!==null&&this.props.comparedata.CompareData==='Different Pricing Region'){this.state.CloseErrorLayer=false;compare=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default.a,{closer:false,overlayClose:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:"none",pad:"none",size:"medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",colorIndex:"neutral-1",margin:"none",pad:"small",separator:"bottom"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",margin:"none",pad:{between:'small'},align:"start",style:{width:'96%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_grommet_components_icons_base_Alert___default.a,{colorIndex:"critical",size:"small"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:"h4",strong:false,style:{marginBottom:'0px'}},"Error")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",margin:"none",pad:"none",align:"start",alignContent:"start",onClick:this.handleCloseError.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:"small",colorIndex:"light-2",className:"CloseIconStyle"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",margin:"small",pad:{between:'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_Paragraph___default.a,{margin:"small"},'Current solution is configured with different Price Region. Kindly select the solution with same Price Region to compare'))));}}var _StyleTable="CompareTable";if(Type==="BlueData"){_StyleTable="CompareTable";}else{_StyleTable="CompareTableBig";}var _backgrdclrtotal='#fff';if(Currencyone!==Currencytwo&&Currencyone!=='NA'&&Currencytwo!=='NA'){_backgrdclrtotal='#ffd144';}else{_backgrdclrtotal='#fff';}// var link = serviceUrl+said+"/ExportCompareSolution?sessionId="+this.props.activeSession.id;
SolutionAlternativeTabsContent='';SolutionAlternativeTabsContent=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:"small",className:"CompareSolutionTable"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{pad:{"between":"small"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",pad:{"between":"small"},justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Select___default.a,{name:"compareSolution1",value:compareSolution1value,options:compareSolution1Options,onChange:function onChange(e){_this2.compareSolution12Change(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Select___default.a,{name:"compareSolution2",value:compareSolution2value,options:compareSolution2Options,onChange:function onChange(e){_this2.compareSolution12Change(e);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default.a,{primary:true,label:"Compare",onClick:this.compareSolnMethod})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{marginLeft:'44%'}})),this.state.ComapareSolState&&Currencyone!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{className:_StyleTable},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{width:'20%'}}," Details"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,this.props.activeSession.EPAArray.length>0&&this.props.activeSession.selectedTitles!==undefined?this.props.activeSession.selectedTitles.compareSolution1value:this.props.activeSession.alias),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,this.props.activeSession.EPAArray.length>0&&this.props.activeSession.selectedTitles!==undefined?this.props.activeSession.selectedTitles.compareSolution2value:this.props.activeSession.alias))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_TableRow___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Rack"),CombineRackSecond),RolesList),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tfoot",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null," Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{textAlign:'center',backgroundColor:_backgrdclrtotal}},Currencyone),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{style:{textAlign:'center',backgroundColor:_backgrdclrtotal}},Currencytwo)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default.a,{label:"Export to Excel",primary:true,onClick:this.onExport.bind(this),style:{height:'40px',marginTop:'20px',width:'27%'}})):'');}var Loading='';if(this.props.sessions.isLoading){Loading=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Layer___default.a,{style:{zIndex:'500 !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",style:{padding:'40px',backgroundColor:"#425563"},size:"medium",pad:{'between':'small'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_grommet_components_icons_Spinning___default.a,{className:"Spinning",size:"small"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:"h5",margin:"none",style:{color:"#fff"}},"Loading Data")));}return this.props.sessions.isLoading&&this.props.activeSession===''&&this.props.activeSession.EPAArray!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,null,Loading):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{height:'98%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{colorIndex:"light-2",direction:"row",align:"start",pad:"none",separator:"left",style:{height:'98%',width:'100%',overflowY:'auto',position:'absolute',right:'0px',top:'0px',zIndex:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_grommet_components_Animate___default.a,{enter:{"animation":"slide-left","duration":200,"delay":0},leave:{"animation":"slide-left","duration":200,"delay":0},keep:true,style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:"row",style:{backgroundColor:'#28ab8c'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{style:{width:"95%",padding:'5px',color:'#fff'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Heading___default.a,{tag:"h4",align:"center",margin:"none",position:"fixed",width:"100%",strong:true},"Compare Solution")),this.props.isFromExternalApp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Button___default.a,{id:"backToSSETyes",primary:false,plain:true,style:{position:'absolute',right:'0',color:'white'}/* icon={<Revert size="small" colorIndex='accent-3' />} */,label:"Back",onClick:function onClick(){_this2.redirectUrl();},className:"ReverseSavewrkloadbtn"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:"informationiconbox",style:{marginTop:"5px"},direction:"row",margin:"none",pad:"none",justify:"end",onClick:function onClick(){return _this2.props.onClose();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_icons_base_Close___default.a,{size:"small"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,null,SolutionAlternativeTabsContent)))));}}]);return CompareSol;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var workloadTemp='';if(state.sizerWorkload.workload!==undefined&&Object.keys(state.sizerWorkload.workload).length>0){workloadTemp=state.sizerWorkload.workload;}else if(state.sessions.activeSession!==undefined&&state.sessions.activeSession.workload!==undefined){workloadTemp=state.sessions.activeSession.workload;}return{allSessions:state.sessions.sessions,activeSession:state.sessions.activeSession,DefaultInputs:state.sessions.sessionDefaults.inputs,OverrideSolMsg:state.sessions.overrideSolMsg,toastNotification:state.sessions.notificationMsg,UserID:state.auth.userData.email,//workload: state.sizerWorkload.workload,
workload:workloadTemp,sessions:state.sessions,CompareMetricsData:state.sessions.activeSession.CompareMetricsData,//comparedata: state.sessions.CompareData,
comparedata:state.sessions.activeSession.CompareData,networkError:state.sessions.networkError};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{OnComparedata:function OnComparedata(value){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_sessions__["i" /* comparedata */])(value));},onFetchCompareSolution:function onFetchCompareSolution(obj){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_sessions__["u" /* fetchCompareSolution */])(obj));},getSSETData:function getSSETData(userData){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_sessions__["I" /* loadSessionfromSSET */])(userData));},onNewSession:function onNewSession(workload){dispatch({type:'UPDATE_SIZER_WORKLOAD',payload:workload});},onExportCompaeSolution:function onExportCompaeSolution(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_19__State_actions_sessions__["q" /* exportCompareSolution */])(text));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(CompareSol));

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_grommet_components_Tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Tab__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_grommet_components_Tab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_grommet_components_Tab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Select__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_grommet_components_Select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Form__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_FormField__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_grommet_components_FormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_grommet_components_FormField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_grommet_components_Layer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Table__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_grommet_components_Table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_TableHeader__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_grommet_components_TableHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_grommet_components_TableHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_List__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_grommet_components_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_grommet_components_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_ListItem__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_grommet_components_ListItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_grommet_components_ListItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_Paragraph__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_grommet_components_Paragraph___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_grommet_components_Paragraph__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_grommet_components_icons_Spinning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_FormClose__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_FormClose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_grommet_components_icons_base_FormClose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_query_string__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__State_actions_sessions__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GlGrowth=function(_Component){_inherits(GlGrowth,_Component);function GlGrowth(props){_classCallCheck(this,GlGrowth);var _this=_possibleConstructorReturn(this,(GlGrowth.__proto__||Object.getPrototypeOf(GlGrowth)).call(this,props));_this.onConfigurationChange=function(e){if(e.target.name==="configurationOne"){_this.state.newHeaderOne=e.option;}else if(e.target.name==="configurationTwo"){_this.state.newHeaderTwo=e.option;}if(_this.state.newHeaderOne===_this.state.newHeaderTwo){var currentIndex=_this.state.configurations1Option.indexOf(_this.state.newHeaderOne);var nextIndex=(currentIndex+1)%_this.state.configurations1Option.length;_this.state.newHeaderOne=_this.state.configurations1Option[nextIndex];}_this.setState({});};_this.state={newHeaderOne:"",newHeaderTwo:"",phaseData:'',comparedData:'',configurations1Option:_this.props.comparedata===undefined?'':_this.props.comparedata['Solutions']['Configurations']['Configuration'],configurations2Option:[],CompareField_Label:'Select Configuration'};_this.onConfigurationChange=_this.onConfigurationChange.bind(_this);return _this;}_createClass(GlGrowth,[{key:'componentDidMount',value:function componentDidMount(){var queryParameter=__WEBPACK_IMPORTED_MODULE_19_query_string___default.a.parse(window.location.search);var strSessionID=queryParameter.sizerReference;this.props.compareGlgrowth(strSessionID);}},{key:'redirectUrl',value:function redirectUrl(){window.location.replace(this.props.externalAppProps.ssetUrl.replace('!&%2F','/').replace('%3F','?'));}},{key:'onExport',value:function onExport(){var _this2=this;var hideDetailsColumn=this.props.comparedata.Solutions.Items.Item[0]["@Header"]==='-'?true:false;var tableHeading=hideDetailsColumn?[this.state.newHeaderOne,this.state.newHeaderTwo,"Delta"]:["Details",this.state.newHeaderOne,this.state.newHeaderTwo,"Delta"];var text={"Data":{"input":{"content":[{"Items":[{"Item":tableHeading}]}]}}};var items=this.props.comparedata["Solutions"]["Items"]["Item"].map(function(item,index){if(_this2.state.newHeaderOne===''){_this2.state.configurations1Option=_this2.props.comparedata['Solutions']['Configurations']['Configuration'];_this2.state.newHeaderOne=_this2.props.comparedata["Solutions"]["Configurations"]["Configuration"][0];}if(_this2.state.newHeaderTwo===''){_this2.state.newHeaderTwo=_this2.props.comparedata["Solutions"]["Configurations"]["Configuration"][1];}var headerOneValue=_this2.state.newHeaderOne;var headerTwoValue=_this2.state.newHeaderTwo;if(_this2.state.configurations1Option.length>1){_this2.state.configurations2Option=_this2.state.configurations1Option.concat([]);_this2.state.configurations2Option.splice(_this2.state.configurations2Option.indexOf(headerOneValue),1);headerTwoValue=_this2.state.configurations2Option.indexOf(headerTwoValue)!==-1?headerTwoValue:_this2.state.configurations2Option[0];}else{_this2.state.configurations2Option=_this2.state.configurations1Option[1];}var len=item["Configuration"].length;var columnOneValue='';var columnTwovalue='';var count1='';var count2='';var diff='';var fontWeight='';for(var i=0;i<len;i++){if(headerOneValue===item["Configuration"][i]["@Name"]){columnOneValue=item["Configuration"][i]["#text"];count1=item["Configuration"][i]["@Count"];}if(headerTwoValue===item["Configuration"][i]["@Name"]){columnTwovalue=item["Configuration"][i]["#text"];count2=item["Configuration"][i]["@Count"];}if(count1!=='-'){if(count1&&count2){diff=Math.abs(count1-count2)+item["Configuration"][i]["@Description"];if(hideDetailsColumn){diff=count1-count2===0?'None':diff;}}}else{diff=item["Configuration"][i]["@Description"];}if(item["Configuration"][i]["@Count"]==="-"){fontWeight="bold";}else{fontWeight='';}}var tableRow=hideDetailsColumn?[columnOneValue,columnTwovalue,diff]:[item['@Header'],columnOneValue,columnTwovalue,diff];var arr={'fontWeight':fontWeight,"Item":tableRow};text.Data.input.content[0]["Items"].push(arr);});//let jsontext=JSON.stringify(text)
//dumm.push(text)
this.props.onExportCompaeSolution(text);}},{key:'render',value:function render(){var _this3=this;if(this.props.comparedata===undefined){return'';}var ConfigurationData='';var TableData='';var tbltdStyle={padding:'5px',textAlign:'left',width:'100px',border:"1px solid rgb(204, 204, 204)"};var hideDetailsColumn=this.props.comparedata.Solutions.Items.Item[0]["@Header"]==='-'?true:false;this.state.phaseData=this.props.comparedata["Solutions"]["Items"]["Item"].map(function(item,index){if(_this3.state.newHeaderOne===''){_this3.state.configurations1Option=_this3.props.comparedata['Solutions']['Configurations']['Configuration'];_this3.state.newHeaderOne=_this3.props.comparedata["Solutions"]["Configurations"]["Configuration"][0];}if(_this3.state.newHeaderTwo===''){_this3.state.newHeaderTwo=_this3.props.comparedata["Solutions"]["Configurations"]["Configuration"][1];}var headerOneValue=_this3.state.newHeaderOne;var headerTwoValue=_this3.state.newHeaderTwo;if(_this3.props.comparedata["Solutions"]["@Header"]!==undefined)_this3.state.CompareField_Label=_this3.props.comparedata["Solutions"]["@Header"];if(_this3.state.configurations1Option.length>1){_this3.state.configurations2Option=_this3.state.configurations1Option.concat([]);_this3.state.configurations2Option.splice(_this3.state.configurations2Option.indexOf(headerOneValue),1);headerTwoValue=_this3.state.configurations2Option.indexOf(headerTwoValue)!==-1?headerTwoValue:_this3.state.configurations2Option[0];}else{_this3.state.configurations2Option=_this3.state.configurations1Option[1];}var len=item["Configuration"].length;var columnOneValue='';var columnTwovalue='';var count1='';var count2='';var diff='';for(var i=0;i<len;i++){if(headerOneValue===item["Configuration"][i]["@Name"]){columnOneValue=item["Configuration"][i]["#text"];count1=item["Configuration"][i]["@Count"];}if(headerTwoValue===item["Configuration"][i]["@Name"]){columnTwovalue=item["Configuration"][i]["#text"];count2=item["Configuration"][i]["@Count"];}if(count1!=='-'){if(count1&&count2){diff=Math.abs(count1-count2)+item["Configuration"][i]["@Description"];if(hideDetailsColumn){diff=count1-count2===0?'None':diff;}}}else{diff=item["Configuration"][i]["@Description"];}if(!Number.isInteger(Math.abs(diff))&&!Number.isNaN(Math.abs(diff)))diff=Math.abs(diff).toFixed(2);if(item["Configuration"][i]["@Count"]==="-"){tbltdStyle={padding:'5px',textAlign:'left',width:'100px',border:"1px solid rgb(204, 204, 204)",fontWeight:'bold'};}else{tbltdStyle={padding:'5px',textAlign:'left',width:'100px',border:"1px solid rgb(204, 204, 204)"};}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_grommet_components_TableRow___default.a,{key:index,scrollable:true},hideDetailsColumn?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},item['@Header']),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},columnOneValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},columnTwovalue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{style:tbltdStyle},diff));});ConfigurationData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'medium'},separator:'all',style:{padding:'10px',width:'80%',border:"white"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:'Select configuration',margin:'none',pad:'none',separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:{between:'small'},separator:'none',style:{padding:'10px',width:'300px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_FormField___default.a,{className:'',label:this.state.CompareField_Label,style:{maxWidth:"225px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Select___default.a,{name:'configurationOne',onChange:function onChange(e){_this3.onConfigurationChange(e);},options:this.state.configurations1Option,value:this.state.newHeaderOne}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{id:'Select configuration',margin:'none',pad:'none',separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'medium'},separator:'none',style:{padding:'10px',width:'300px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_grommet_components_Form___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_grommet_components_FormField___default.a,{className:'',label:this.state.CompareField_Label,style:{maxWidth:"225px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_grommet_components_Select___default.a,{name:'configurationTwo',onChange:function onChange(e){_this3.onConfigurationChange(e);},options:this.state.configurations2Option,value:this.state.newHeaderTwo}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'medium'},separator:'none'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Export to Excel',primary:true,onClick:this.onExport.bind(this),style:{height:'40px',marginTop:'20px',width:'200px'}})));var labels='';if(hideDetailsColumn){labels=[this.state.newHeaderOne,this.state.newHeaderTwo,'Delta'];}else{labels=['Details',this.state.newHeaderOne,this.state.newHeaderTwo,'Delta'];}TableData=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',separator:'bottom',className:'',justify:'center',align:'left',style:{height:'450px',overflowY:'auto',overflowX:'hidden',width:'80% !important'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_grommet_components_Table___default.a,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_grommet_components_TableHeader___default.a,{labels:labels,style:{visibility:'visible',borderBottom:'1px solid white',backgroundColor:"#425563",color:"white",fontSize:"120"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',{scrollable:true},this.state.phaseData)));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{margin:'none',pad:'small',style:{width:'100% !important',height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_grommet_components_Box___default.a,{direction:'row',margin:'none',pad:{between:'small'},style:{height:'55px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_grommet_components_Heading___default.a,{tag:'h2',margin:'small',strong:true,style:{fontSize:'2em'}},'Compare Solutions : '),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_grommet_components_Button___default.a,{label:'Close',primary:true,onClick:function onClick(){_this3.redirectUrl();},style:{height:'40px',marginTop:'10px',position:'relative',left:'825px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),ConfigurationData,TableData);}}]);return GlGrowth;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var comparedata=undefined;if(state.sessions.activeSession!==undefined&&state.sessions.activeSession!==''){comparedata=state.sessions.activeSession;}return{comparedata:comparedata};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{compareGlgrowth:function compareGlgrowth(data){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__State_actions_sessions__["h" /* compareGlgrowthData */])(data));},onExportCompaeSolution:function onExportCompaeSolution(text){dispatch(Object(__WEBPACK_IMPORTED_MODULE_20__State_actions_sessions__["r" /* exportCompareSolutionData */])(text));}};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(GlGrowth));

/***/ }),
/* 721 */
/***/ (function(module, exports) {

/* eslint no-extend-native: "off" */// Polyfill taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find?v=control#Polyfill
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if(!Array.prototype.find){Object.defineProperty(Array.prototype,'find',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return kValue.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return kValue;}// e. Increase k by 1.
k++;}// 7. Return undefined.
return undefined;}});}

/***/ }),
/* 722 */
/***/ (function(module, exports) {

/* eslint no-extend-native: "off" */// Polyfill taken from: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex?v=control#Polyfill
// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if(!Array.prototype.findIndex){Object.defineProperty(Array.prototype,'findIndex',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, � kValue, k, O �)).
// d. If testResult is true, return k.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return k;}// e. Increase k by 1.
k++;}// 7. Return -1.
return-1;},configurable:true,writable:true});}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.cb3e688c.js